(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cx0mh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $91f8d84290b0e35b$export$71511d61b312f219; });
function $91f8d84290b0e35b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("7h4XF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $54bdf82ebe283f1b$export$71511d61b312f219; });
function $54bdf82ebe283f1b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $54bdf82ebe283f1b$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $54bdf82ebe283f1b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $54bdf82ebe283f1b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("8mlhh", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("5RGAp")).then(function() {
    return parcelRequire('fz5vW');
});

});
parcelRegister("ih7W4", function(module, exports) {
"use strict";

var $5Y6Bl = parcelRequire("5Y6Bl");
module.exports = $5Y6Bl(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("5Y6Bl", function(module, exports) {
"use strict";
var $4587ad3ed31b7baa$var$cachedBundles = {};
var $4587ad3ed31b7baa$var$cachedPreloads = {};
var $4587ad3ed31b7baa$var$cachedPrefetches = {};
function $4587ad3ed31b7baa$var$getCache(type) {
    switch(type){
        case 'preload':
            return $4587ad3ed31b7baa$var$cachedPreloads;
        case 'prefetch':
            return $4587ad3ed31b7baa$var$cachedPrefetches;
        default:
            return $4587ad3ed31b7baa$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $4587ad3ed31b7baa$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("hLG03", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("3uTpJ")).then(function() {
    return parcelRequire('5xWmk');
});

});

parcelRegister("kJrPi", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("4XbAZ")).then(function() {
    return parcelRequire('gFNXg');
});

});

parcelRegister("bI71U", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("2bKIP")).then(function() {
    return parcelRequire('iGIhP');
});

});

parcelRegister("eICi1", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("i0BNf")).then(function() {
    return parcelRequire('9105N');
});

});

parcelRegister("kqusB", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("98Cvg")).then(function() {
    return parcelRequire('dH6Cx');
});

});

parcelRegister("57GX6", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("y5edP")).then(function() {
    return parcelRequire('7ZPTi');
});

});

parcelRegister("h75GH", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("9fDFY")).then(function() {
    return parcelRequire('2Ylu6');
});

});

parcelRegister("55azR", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("cW2nR")).then(function() {
    return parcelRequire('aeHic');
});

});

parcelRegister("fWO0c", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("8ucza")).then(function() {
    return parcelRequire('52L7X');
});

});

parcelRegister("4zES7", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("f3RKT")).then(function() {
    return parcelRequire('hmSlK');
});

});

parcelRegister("7KXHm", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("fVlhe")).then(function() {
    return parcelRequire('cmxjs');
});

});

parcelRegister("aqoL6", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("kcBSP")).then(function() {
    return parcelRequire('6vhv2');
});

});

parcelRegister("7TgKV", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("4RByM")).then(function() {
    return parcelRequire('3bjy6');
});

});

parcelRegister("2HU4B", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("ap9yw")).then(function() {
    return parcelRequire('aWNha');
});

});

parcelRegister("lWIVr", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("dsJ3g")).then(function() {
    return parcelRequire('blNy6');
});

});

parcelRegister("bGxAd", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("lF1Tu")).then(function() {
    return parcelRequire('iRLcJ');
});

});

parcelRegister("dJPtW", function(module, exports) {

$parcel$export(module.exports, "Input", function () { return Input; });
$parcel$export(module.exports, "input", function () { return input; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");
var Input = /*#__PURE__*/ function() {
    "use strict";
    function Input(p) {
        var _this = this;
        (0, $cx0mh._)(this, Input);
        this.keyListener = {
            destroy: function() {}
        };
        this.rootEl = (0, $eWjiX.BB).el({
            tagName: 'label',
            content: p.label,
            css: {
                display: 'flex',
                alignItems: 'center',
                gap: '5px'
            }
        });
        this.input = (0, $eWjiX.BB).el({
            tagName: 'input',
            parent: this.rootEl,
            title: p.title,
            custom: {
                name: p.name
            }
        });
        var _p_type;
        this.type = (_p_type = p.type) !== null && _p_type !== void 0 ? _p_type : 'text';
        try {
            this.input.type = this.type;
        } catch (e) {
        // ie can't deal with number
        }
        var _p_step;
        var stepSize = (_p_step = p.step) !== null && _p_step !== void 0 ? _p_step : 1;
        if (this.type === 'number') {
            if (p.min !== undefined) this.input.min = '' + p.min;
            if (p.max !== undefined) this.input.max = '' + p.max;
            if (p.step !== undefined) this.input.step = '' + stepSize;
        }
        this.input.value = '' + p.init;
        var lastValidValue = this.input.value;
        /**
         * return true if not changed
         */ var handleChange = function() {
            var oldVal = lastValidValue;
            var newValue = _this.input.value;
            if (p.doResetIfInvalid) {
                var didChange = false;
                if (newValue === '') {
                    newValue = lastValidValue;
                    didChange = true;
                }
                if (p.min !== undefined && parseFloat(newValue) < p.min) {
                    newValue = '' + p.min;
                    didChange = true;
                }
                if (p.max !== undefined && parseFloat(newValue) > p.max) {
                    newValue = '' + p.max;
                    didChange = true;
                }
                if (didChange) _this.input.value = '' + newValue;
            }
            lastValidValue = newValue;
            return oldVal !== newValue;
        };
        if (p.onChange) {
            var onChange = p.onChange;
            this.input.onchange = function() {
                handleChange() && onChange(_this.input.value);
            };
        }
        if (p.css) (0, $7jh4K.css)(this.input, p.css);
        if (p.doScrollWithoutFocus && p.type === 'number' && p.onChange) {
            var onChange1 = p.onChange;
            this.keyListener = new (0, $eWjiX.BB).KeyListener({});
            this.pointerListener = new (0, $eWjiX.BB).PointerListener({
                target: this.input,
                onWheel: function(e) {
                    /*if (document.hasFocus()) { // what was the point of this?
                        return;
                    }*/ var fac = _this.keyListener.isPressed('shift') ? 4 : 1;
                    _this.input.value = '' + (parseFloat(_this.input.value) - e.deltaY * stepSize * fac);
                    handleChange() && onChange1(_this.input.value);
                }
            });
        }
    }
    (0, $7h4XF._)(Input, [
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.input.value;
            }
        },
        {
            key: "setValue",
            value: function setValue(v) {
                this.input.value = '' + v;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.pointerListener && this.pointerListener.destroy();
                this.keyListener.destroy();
            }
        }
    ]);
    return Input;
}();
var input = function input(params) {
    var result = document.createElement('input');
    if (params.type) try {
        result.type = params.type;
    } catch (e) {
    /* empty */ // ie can't deal with number
    }
    else result.type = 'text';
    if (params.min !== undefined) result.min = '' + params.min;
    if (params.max !== undefined) result.max = '' + params.max;
    result.value = '' + params.init;
    if (params.callback) result.onchange = function() {
        params.callback(result.value);
    };
    if (params.css) (0, $7jh4K.css)(result, params.css);
    return result;
};

});
parcelRegister("eWjiX", function(module, exports) {

$parcel$export(module.exports, "BB", function () { return $05ec456c8871d48f$export$921068d8846a1559; });

var $7jh4K = parcelRequire("7jh4K");

var $6J2My = parcelRequire("6J2My");

var $idV3L = parcelRequire("idV3L");

var $04lDo = parcelRequire("04lDo");

var $eIcQa = parcelRequire("eIcQa");

var $kVHNC = parcelRequire("kVHNC");

var $4toIY = parcelRequire("4toIY");

var $af1iA = parcelRequire("af1iA");

var $dJ1E2 = parcelRequire("dJ1E2");

var $72Jv0 = parcelRequire("72Jv0");

var $eg83P = parcelRequire("eg83P");

var $eelgW = parcelRequire("eelgW");

var $i0uIf = parcelRequire("i0uIf");

var $6l0gQ = parcelRequire("6l0gQ");

var $jjWRi = parcelRequire("jjWRi");

var $2pgVs = parcelRequire("2pgVs");

var $joplQ = parcelRequire("joplQ");

var $c1lmK = parcelRequire("c1lmK");

var $635F6 = parcelRequire("635F6");

var $gCzYB = parcelRequire("gCzYB");
var $05ec456c8871d48f$export$921068d8846a1559 = {
    // ---- browser ----
    eventUsesHighResTimeStamp: (0, $6J2My.EVENT_USES_HIGH_RES_TIMESTAMP),
    hasPointerEvents: (0, $6J2My.HAS_POINTER_EVENTS),
    isCssMinMaxSupported: (0, $6J2My.IS_CSS_MIN_MAX_SUPPORTED),
    canShareFiles: (0, $6J2My.canShareFiles),
    unsetEventHandler: $6J2My.unsetEventHandler,
    insertAfter: // ---- base ----
    $7jh4K.insertAfter,
    loadImage: $7jh4K.loadImage,
    css: $7jh4K.css,
    setAttributes: $7jh4K.setAttributes,
    append: $7jh4K.append,
    fitInto: $7jh4K.fitInto,
    centerWithin: $7jh4K.centerWithin,
    getDate: $7jh4K.getDate,
    gcd: $7jh4K.gcd,
    reduce: $7jh4K.reduce,
    decToFraction: $7jh4K.decToFraction,
    imageBlobToUrl: $7jh4K.imageBlobToUrl,
    dateDayDifference: $7jh4K.dateDayDifference,
    copyObj: $7jh4K.copyObj,
    shareCanvas: $7jh4K.shareCanvas,
    handleClick: $7jh4K.handleClick,
    createSvg: $7jh4K.createSvg,
    BbLog: $i0uIf.BbLog,
    LocalStorage: $6l0gQ.LocalStorage,
    throwIfNull: $7jh4K.throwIfNull,
    nullToUndefined: $7jh4K.nullToUndefined,
    isDark: $7jh4K.isDark,
    mix: // ---- math ----
    $eg83P.mix,
    dist: $eg83P.dist,
    distSquared: $eg83P.distSquared,
    lenSquared: $eg83P.lenSquared,
    pointsToAngleRad: $eg83P.pointsToAngleRad,
    pointsToAngleDeg: $eg83P.pointsToAngleDeg,
    isInsideRect: $eg83P.isInsideRect,
    clamp: $eg83P.clamp,
    rotate: $eg83P.rotate,
    rotateAround: $eg83P.rotateAround,
    Matrix: $kVHNC.Matrix,
    Vec2: $4toIY.Vec2,
    intDxy: $eg83P.intDxy,
    roundEven: $eg83P.roundEven,
    roundUneven: $eg83P.roundUneven,
    round: $eg83P.round,
    updateBounds: $eg83P.updateBounds,
    indexBoundsInArea: $eg83P.indexBoundsInArea,
    projectPointOnLine: // ---- line ----
    $af1iA.projectPointOnLine,
    PointLine: $af1iA.PointLine,
    BezierLine: $af1iA.BezierLine,
    SplineInterpolator: $af1iA.SplineInterpolator,
    powerSplineInput: $af1iA.powerSplineInput,
    // ---- canvas ----
    canvas: (0, $eelgW.createCanvas),
    ctx: $eIcQa.ctx,
    copyCanvas: $eIcQa.copyCanvas,
    testShouldPixelate: $eIcQa.testShouldPixelate,
    drawTransformedImageWithBounds: $eIcQa.drawTransformedImageWithBounds,
    drawTransformedImageOnCanvas: $eIcQa.drawTransformedImageOnCanvas,
    createCheckerCanvas: $eIcQa.createCheckerCanvas,
    createCheckerDataUrl: $eIcQa.createCheckerDataUrl,
    resizeCanvas: $eIcQa.resizeCanvas,
    convertToAlphaChannelCanvas: $eIcQa.convertToAlphaChannelCanvas,
    freeCanvas: $eIcQa.freeCanvas,
    HSV: // ---- color ----
    $dJ1E2.HSV,
    RGB: $dJ1E2.RGB,
    CMYK: $dJ1E2.CMYK,
    ColorConverter: $dJ1E2.ColorConverter,
    testIsWhiteBestContrast: $dJ1E2.testIsWhiteBestContrast,
    appendTextDiv: // ---- UI ----
    $72Jv0.appendTextDiv,
    clearSelection: $72Jv0.clearSelection,
    el: $72Jv0.el,
    destroyEl: $72Jv0.destroyEl,
    isInputFocused: $72Jv0.isInputFocused,
    unfocusAnyInput: $72Jv0.unfocusAnyInput,
    KeyListener: // ---- events / input ----
    $idV3L.KeyListener,
    PointerListener: $04lDo.PointerListener,
    sameKeys: $idV3L.sameKeys,
    EventChain: $gCzYB.EventChain,
    DoubleTapper: $c1lmK.DoubleTapper,
    NFingerTapper: $2pgVs.NFingerTapper,
    PinchZoomer: $joplQ.PinchZoomer,
    CoalescedExploder: $jjWRi.CoalescedExploder,
    OnePointerLimiter: $635F6.OnePointerLimiter
};
Object.keys($05ec456c8871d48f$export$921068d8846a1559); // without this, parcel build may break this object

});
parcelRegister("7jh4K", function(module, exports) {

$parcel$export(module.exports, "insertAfter", function () { return $2bd9b7b9bc92046d$export$c4f94c8b3850a5a9; });
$parcel$export(module.exports, "loadImage", function () { return $2bd9b7b9bc92046d$export$fe58198efe02b173; });
$parcel$export(module.exports, "asyncLoadImage", function () { return $2bd9b7b9bc92046d$export$2a09375022a33e78; });
$parcel$export(module.exports, "css", function () { return $2bd9b7b9bc92046d$export$dbf350e5966cf602; });
$parcel$export(module.exports, "setAttributes", function () { return $2bd9b7b9bc92046d$export$74da2cba014bdc09; });
$parcel$export(module.exports, "append", function () { return $2bd9b7b9bc92046d$export$10d8903dec122b9d; });
$parcel$export(module.exports, "fitInto", function () { return $2bd9b7b9bc92046d$export$fa55905620c22535; });
$parcel$export(module.exports, "centerWithin", function () { return $2bd9b7b9bc92046d$export$76d0c1a172b67a61; });
$parcel$export(module.exports, "getDate", function () { return $2bd9b7b9bc92046d$export$aa350b96d91cd94; });
$parcel$export(module.exports, "gcd", function () { return $2bd9b7b9bc92046d$export$f81847884871263e; });
$parcel$export(module.exports, "reduce", function () { return $2bd9b7b9bc92046d$export$533b26079ad0b4b; });
$parcel$export(module.exports, "decToFraction", function () { return $2bd9b7b9bc92046d$export$8215e6b900906daa; });
$parcel$export(module.exports, "isBlob", function () { return $2bd9b7b9bc92046d$export$5bcd6e94ed871c88; });
$parcel$export(module.exports, "imageBlobToUrl", function () { return $2bd9b7b9bc92046d$export$5063ec57a23c4f2e; });
$parcel$export(module.exports, "dateDayDifference", function () { return $2bd9b7b9bc92046d$export$1093707c159148e8; });
$parcel$export(module.exports, "copyObj", function () { return $2bd9b7b9bc92046d$export$af0d87255f3cfd7e; });
$parcel$export(module.exports, "shareCanvas", function () { return $2bd9b7b9bc92046d$export$331c30fd60da0115; });
$parcel$export(module.exports, "handleClick", function () { return $2bd9b7b9bc92046d$export$b981489921ee18cd; });
$parcel$export(module.exports, "createSvg", function () { return $2bd9b7b9bc92046d$export$c54fe3b9ecaa84cf; });
$parcel$export(module.exports, "throwIfNull", function () { return $2bd9b7b9bc92046d$export$b813e062795b89b5; });
$parcel$export(module.exports, "throwIfUndefined", function () { return $2bd9b7b9bc92046d$export$5c097f720de072a2; });
$parcel$export(module.exports, "nullToUndefined", function () { return $2bd9b7b9bc92046d$export$d802c22d109d9806; });
$parcel$export(module.exports, "isDark", function () { return $2bd9b7b9bc92046d$export$a79ad82046afa44e; });
$parcel$export(module.exports, "addIsDarkListener", function () { return $2bd9b7b9bc92046d$export$a9dfd81f95a8a526; });
$parcel$export(module.exports, "base64ToBlob", function () { return $2bd9b7b9bc92046d$export$b3fb17ae4345ac8f; });
$parcel$export(module.exports, "createArray", function () { return $2bd9b7b9bc92046d$export$7f1ebd623f131021; });
$parcel$export(module.exports, "randomUuid", function () { return $2bd9b7b9bc92046d$export$4773ec3a7b05a3f2; });
$parcel$export(module.exports, "sleep", function () { return $2bd9b7b9bc92046d$export$e772c8ff12451969; });
$parcel$export(module.exports, "timeoutWrapper", function () { return $2bd9b7b9bc92046d$export$f85d414d081200d8; });

var $1LaJZ = parcelRequire("1LaJZ");

var $8N5YG = parcelRequire("8N5YG");

var $fk3zw = parcelRequire("fk3zw");
function $2bd9b7b9bc92046d$export$c4f94c8b3850a5a9(referenceNode, newNode) {
    if (referenceNode.parentNode) referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}
function $2bd9b7b9bc92046d$export$fe58198efe02b173(im, callback) {
    var counter = 0;
    function check() {
        if (counter === 1000) {
            alert("couldn't load");
            return;
        }
        if (im.complete) {
            counter++;
            callback();
        } else setTimeout(check, 1);
    }
    check();
}
function $2bd9b7b9bc92046d$export$2a09375022a33e78(src) {
    return new Promise(function(resolve, reject) {
        var img = new Image();
        img.onload = function() {
            return resolve(img);
        };
        img.onerror = reject;
        img.src = src;
    });
}
function $2bd9b7b9bc92046d$export$dbf350e5966cf602(el, styleObj) {
    var elStyle = el.style;
    Object.keys(styleObj).forEach(function(key) {
        var property = key;
        elStyle[property] = styleObj[property];
        if (property === 'userSelect') elStyle.webkitUserSelect = styleObj[property]; // Safari support
    });
}
function $2bd9b7b9bc92046d$export$74da2cba014bdc09(el, attrObj) {
    var keyArr = Object.keys(attrObj);
    var keyStr;
    for(var i = 0; i < keyArr.length; i++){
        keyStr = keyArr[i];
        el.setAttribute(keyStr, attrObj[keyStr]);
    }
}
function $2bd9b7b9bc92046d$export$10d8903dec122b9d(target, els) {
    var fragment = document.createDocumentFragment();
    els.forEach(function(item) {
        return item && fragment.append(item);
    });
    target.append(fragment);
}
function $2bd9b7b9bc92046d$export$fa55905620c22535(aw, ah, bw, bh, min) {
    var width = aw * bw, height = ah * bw;
    if (width > bw) {
        height = bw / width * height;
        width = bw;
    }
    if (height > bh) {
        width = bh / height * width;
        height = bh;
    }
    if (min) {
        width = Math.max(min, width);
        height = Math.max(min, height);
    }
    return {
        width: width,
        height: height
    };
}
function $2bd9b7b9bc92046d$export$76d0c1a172b67a61(aw, ah, bw, bh) {
    return {
        x: aw / 2 - bw / 2,
        y: ah / 2 - bh / 2
    };
}
function $2bd9b7b9bc92046d$export$aa350b96d91cd94() {
    var date = new Date();
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, '0');
    var day = date.getDate().toString().padStart(2, '0');
    var minutes = (date.getHours() * 60 + date.getMinutes()).toString(36).padStart(3, '0');
    return year + '_' + month + '_' + day + '_' + minutes + '_';
}
function $2bd9b7b9bc92046d$export$f81847884871263e(a, b) {
    return b ? $2bd9b7b9bc92046d$export$f81847884871263e(b, a % b) : a;
}
function $2bd9b7b9bc92046d$export$533b26079ad0b4b(numerator, denominator) {
    var g = $2bd9b7b9bc92046d$export$f81847884871263e(numerator, denominator);
    return [
        numerator / g,
        denominator / g
    ];
}
function $2bd9b7b9bc92046d$export$8215e6b900906daa(decimalNumber) {
    var len = decimalNumber.toString().length - 2;
    var denominator = Math.pow(10, len);
    var numerator = decimalNumber * denominator;
    return $2bd9b7b9bc92046d$export$533b26079ad0b4b(numerator, denominator);
}
function $2bd9b7b9bc92046d$export$5bcd6e94ed871c88(maybeBlob) {
    return maybeBlob instanceof Blob || Object.prototype.toString.call(maybeBlob) === '[object Blob]';
}
function $2bd9b7b9bc92046d$export$5063ec57a23c4f2e(blobObj) {
    if (!blobObj) throw new Error('blobObj is undefined or null');
    if (window.Blob && blobObj instanceof Blob) return URL.createObjectURL(blobObj); // object url
    else if (blobObj.constructor.name === 'Object') {
        var fauxBlob = blobObj;
        return 'data:' + fauxBlob.type + ';' + fauxBlob.encoding + ',' + fauxBlob.data; // data url
    } else throw new Error('unknown blob format');
}
function $2bd9b7b9bc92046d$export$1093707c159148e8(dateA, dateB) {
    dateA = new Date(dateA);
    dateB = new Date(dateB);
    dateA.setHours(0, 0, 0, 0);
    dateB.setHours(0, 0, 0, 0);
    return (dateB.getTime() - dateA.getTime()) / 86400000;
}
function $2bd9b7b9bc92046d$export$af0d87255f3cfd7e(obj) {
    // structuredClone became available around 2022. Let's wait a bit longer for it.
    return JSON.parse(JSON.stringify(obj));
}
function $2bd9b7b9bc92046d$export$331c30fd60da0115(p) {
    var mimetype = 'image/png';
    var err = function() {
        return alert('sharing not supported');
    };
    p.canvas.toBlob(function(blob) {
        if (!blob) {
            err();
            p.callback();
            return;
        }
        try {
            var filesArray = [
                new File([
                    blob
                ], p.fileName, {
                    type: mimetype
                })
            ];
            navigator.share({
                title: p.title,
                files: filesArray
            }).then(function() {}).catch(function() {
                err();
            });
        } catch (e) {
            err();
        }
        p.callback();
    }, mimetype);
}
function $2bd9b7b9bc92046d$export$b981489921ee18cd(clickEvent) {
    var target = clickEvent.target;
    if (!target) return false;
    var el = target;
    while(el){
        if ([
            'A',
            'LABEL',
            'INPUT',
            'SUMMARY'
        ].includes(el.tagName)) return true;
        el = el.parentElement;
    }
    clickEvent.preventDefault();
    return false;
}
function $2bd9b7b9bc92046d$export$c54fe3b9ecaa84cf(p) {
    var result = document.createElementNS('http://www.w3.org/2000/svg', p.elementType);
    Object.entries(p).forEach(function(param) {
        var _param = (0, $8N5YG._)(param, 2), keyStr = _param[0], item = _param[1];
        if (keyStr === 'childrenArr') item.forEach(function(child) {
            result.append($2bd9b7b9bc92046d$export$c54fe3b9ecaa84cf(child));
        });
        else if (keyStr === 'css') $2bd9b7b9bc92046d$export$dbf350e5966cf602(result, item);
        else if (keyStr !== 'elementType') result.setAttribute(keyStr, item);
    });
    return result;
}
function $2bd9b7b9bc92046d$export$b813e062795b89b5(v) {
    // (disabled) eslint-disable-next-line no-null/no-null
    if (v === null) throw new Error('value is null');
    return v;
}
function $2bd9b7b9bc92046d$export$5c097f720de072a2(v) {
    var message = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'value is undefined';
    if (v === undefined) throw new Error(message);
    return v;
}
function $2bd9b7b9bc92046d$export$d802c22d109d9806(v) {
    return v === null ? undefined : v;
}
var $2bd9b7b9bc92046d$var$matchMediaDark = 'matchMedia' in window ? window.matchMedia('(prefers-color-scheme: dark)') : false;
function $2bd9b7b9bc92046d$export$a79ad82046afa44e() {
    return $2bd9b7b9bc92046d$var$matchMediaDark && $2bd9b7b9bc92046d$var$matchMediaDark.matches;
}
function $2bd9b7b9bc92046d$export$a9dfd81f95a8a526(func) {
    $2bd9b7b9bc92046d$var$matchMediaDark && 'addEventListener' in $2bd9b7b9bc92046d$var$matchMediaDark && $2bd9b7b9bc92046d$var$matchMediaDark.addEventListener('change', func);
}
function $2bd9b7b9bc92046d$export$326d4de4659beb75(func) {
    $2bd9b7b9bc92046d$var$matchMediaDark && 'removeEventListener' in $2bd9b7b9bc92046d$var$matchMediaDark && $2bd9b7b9bc92046d$var$matchMediaDark.removeEventListener('change', func);
}
function $2bd9b7b9bc92046d$export$b3fb17ae4345ac8f(base64Str) {
    var parts = base64Str.match(/data:([^;]*)(;base64)?,([0-9A-Za-z+/]+)/);
    var binStr = atob(parts[3]);
    var buf = new ArrayBuffer(binStr.length);
    var view = new Uint8Array(buf);
    for(var i = 0; i < view.length; i++)view[i] = binStr.charCodeAt(i);
    return new Blob([
        view
    ], {
        type: parts[1]
    });
}
function $2bd9b7b9bc92046d$export$7f1ebd623f131021(length, fillValue) {
    return new Array(length).fill(fillValue);
}
function $2bd9b7b9bc92046d$export$4773ec3a7b05a3f2() {
    if ('randumUUID' in crypto) return crypto.randomUUID();
    // fallback just for dev
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $2bd9b7b9bc92046d$export$e772c8ff12451969(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}
function $2bd9b7b9bc92046d$export$f85d414d081200d8(promise, name) {
    var timeoutMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5000;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        return (0, $fk3zw._)(this, function(_state) {
            return [
                2,
                Promise.race([
                    promise,
                    new Promise(function(_, reject) {
                        setTimeout(function() {
                            return reject(new Error(`Promise "${name}" timed out.`));
                        }, timeoutMs);
                    })
                ])
            ];
        });
    })();
}
function $2bd9b7b9bc92046d$export$b6a2e78b63791dfa(url) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var response, svgText, parser, doc, svg;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(url)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        4,
                        response.text()
                    ];
                case 2:
                    svgText = _state.sent();
                    parser = new DOMParser();
                    doc = parser.parseFromString(svgText, 'image/svg+xml');
                    svg = doc.querySelector('svg');
                    if (!svg) throw new Error('No <svg> found in the file');
                    // Optional: Clone to prevent reusing the same node
                    return [
                        2,
                        svg.cloneNode(true)
                    ];
            }
        });
    })();
}

});
parcelRegister("1LaJZ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $148283215f43a235$export$71511d61b312f219; });
function $148283215f43a235$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $148283215f43a235$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $148283215f43a235$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $148283215f43a235$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("8N5YG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $66678966aca60171$export$71511d61b312f219; });

var $vDBh4 = parcelRequire("vDBh4");

var $lMMat = parcelRequire("lMMat");

var $keO5I = parcelRequire("keO5I");

var $kWe4k = parcelRequire("kWe4k");
function $66678966aca60171$export$71511d61b312f219(arr, i) {
    return (0, $vDBh4._)(arr) || (0, $lMMat._)(arr, i) || (0, $kWe4k._)(arr, i) || (0, $keO5I._)();
}

});
parcelRegister("vDBh4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $05f19d23cbc6df58$export$71511d61b312f219; });
function $05f19d23cbc6df58$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("lMMat", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fdc371d02da0e33d$export$71511d61b312f219; });
function $fdc371d02da0e33d$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("keO5I", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ebbbf88aeeb062a0$export$71511d61b312f219; });
function $ebbbf88aeeb062a0$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("kWe4k", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f3e42339f23981ad$export$71511d61b312f219; });

var $gszWS = parcelRequire("gszWS");
function $f3e42339f23981ad$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gszWS._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gszWS._)(o, minLen);
}

});
parcelRegister("gszWS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bfbb257f5464d7e6$export$71511d61b312f219; });
function $bfbb257f5464d7e6$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("fk3zw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b27b7e9b90f723d6$export$71511d61b312f219; });
function $b27b7e9b90f723d6$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}

});


parcelRegister("6J2My", function(module, exports) {

$parcel$export(module.exports, "IS_FIREFOX", function () { return $878b1f179a521546$export$fa35291248be714f; });
$parcel$export(module.exports, "EVENT_USES_HIGH_RES_TIMESTAMP", function () { return $878b1f179a521546$export$69accc8c74894f83; });
$parcel$export(module.exports, "HAS_POINTER_EVENTS", function () { return $878b1f179a521546$export$7728c852ca75bb6d; });
$parcel$export(module.exports, "IS_CSS_MIN_MAX_SUPPORTED", function () { return $878b1f179a521546$export$1a1016cfea93f0d5; });
$parcel$export(module.exports, "canShareFiles", function () { return $878b1f179a521546$export$558f5e20caee48c2; });
$parcel$export(module.exports, "unsetEventHandler", function () { return $878b1f179a521546$export$4fb2cccfca937a8c; });
var $878b1f179a521546$export$fa35291248be714f = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
var $878b1f179a521546$export$69accc8c74894f83 = function() {
    var eventUsesHighResTimeStamp = new Event('').timeStamp < 3600000;
    return function() {
        return eventUsesHighResTimeStamp;
    };
}();
var $878b1f179a521546$export$7728c852ca75bb6d = !!window.PointerEvent;
var $878b1f179a521546$export$1a1016cfea93f0d5 = function() {
    var result;
    function test() {
        var div = document.createElement('div');
        div.style.position = 'absolute';
        div.style.top = '0';
        div.style.left = 'max(0px, 25px)';
        document.body.append(div);
        setTimeout(function() {
            result = div.offsetLeft === 25;
            div.remove();
        }, 25);
    }
    if (document.body) test();
    else window.addEventListener('DOMContentLoaded', function() {
        test();
    });
    return function() {
        if (result === undefined) throw new Error('isCssMinMaxSupported not initialized');
        return result;
    };
}();
var $878b1f179a521546$export$558f5e20caee48c2 = function canShareFiles() {
    return 'share' in navigator && 'canShare' in navigator;
};
function $878b1f179a521546$export$4fb2cccfca937a8c(obj) {
    for(var _len = arguments.length, handlers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        handlers[_key - 1] = arguments[_key];
    }
    handlers.forEach(function(handler) {
        // (disabled) eslint-disable-next-line no-null/no-null
        obj[handler] = null;
    });
}
function $878b1f179a521546$export$a432063205610fa1() {
    navigator.storage.estimate().then(function(estimate) {
        if (estimate.quota === undefined || estimate.usage === undefined) {
            console.log('no quota info');
            return;
        }
        console.log(`using ${(estimate.usage / estimate.quota * 100).toFixed(2)}% of total quota`);
        console.log('usage (GB)', (estimate.usage / 1024 / 1024 / 1024).toFixed(2));
        console.log('quota (GB)', (estimate.quota / 1024 / 1024 / 1024).toFixed(2));
    });
}

});

parcelRegister("idV3L", function(module, exports) {

$parcel$export(module.exports, "KeyListener", function () { return $74d1f29ad2137b2c$export$f17908c5de22d32e; });
$parcel$export(module.exports, "sameKeys", function () { return $74d1f29ad2137b2c$export$e9f65b0175de4c03; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $8N5YG = parcelRequire("8N5YG");
var $74d1f29ad2137b2c$var$globalKey = function() {
    var keyDown = function keyDown(e) {
        var key = e.key;
        var code = e.code;
        if (key in keyToKeyStrObj) {
            var keyStr = keyToKeyStrObj[key];
            if (isDownObj[keyStr]) {
                emitDown(keyStr, e, comboArr.join('+'), true);
                return;
            } else {
                if (keyStr === 'cmd') setupMetaClear(keyStr, code);
                else clearTimeout(metaClearTimeout);
                if (keyStr === 'esc') // Workaround for a macOS behavior
                // When in fullscreen, pressing escape exits the fullscreen mode.
                // When that happens, no keyup for escape is fired.
                setTimeout(function() {
                    return blur();
                });
            }
            isDownObj[keyStr] = true;
            codeIsDownObj[code] = keyStr;
            //add to combo
            comboArr.push(keyStr);
            emitDown(keyStr, e, comboArr.join('+'));
        }
    };
    var keyUp = function keyUp(e) {
        var code = e.code;
        var oldComboStr = comboArr.join('+');
        // because of a macOS bug: when meta key is down, keyup of other keys does not fire.
        // https://stackoverflow.com/questions/25438608/javascript-keyup-isnt-called-when-command-and-another-is-pressed
        if ([
            'Meta',
            'MetaLeft',
            'MetaRight',
            'OSLeft',
            'OSRight'
        ].includes(code)) {
            blur();
            return;
        } else if (isDownObj['cmd']) {
            // Workaround for Windows bug. Windows doesn't fire keyup for Meta key when pressing Windows Key + Space,
            // neither does it fire blur
            blur();
            return;
        }
        var keyStr = codeIsDownObj[code];
        if (keyStr !== undefined) {
            isDownObj[keyStr] = false;
            codeIsDownObj[code] = undefined;
            // remove from combo
            for(var i = 0; i < comboArr.length; i++)if (comboArr[i] == keyStr) {
                comboArr.splice(i, 1);
                i--;
            }
            emitUp(keyStr, e, oldComboStr);
        }
    };
    var blur = function blur() {
        var oldComboStr = comboArr.join('+');
        comboArr = [];
        codeIsDownObj = {};
        var eventArr = [];
        keyStrArr.forEach(function(keyStr) {
            if (isDownObj[keyStr]) {
                isDownObj[keyStr] = false;
                eventArr.push(keyStr);
            }
        });
        for(var i = 0; i < eventArr.length; i++)emitUp(eventArr[i], {
            preventDefault: function preventDefault() {},
            stopPropagation: function stopPropagation() {}
        }, oldComboStr);
        emitBlur();
    };
    // keyStr - our key naming system
    // key - KeyboardEvent.key
    // code - KeyboardEvent.code
    var keyStrToKeyObj = {
        // keyStr not to contain a '+', because that's used for the comboStr
        space: [
            ' ',
            'Spacebar'
        ],
        alt: [
            'Alt',
            'AltGraph'
        ],
        shift: 'Shift',
        ctrl: 'Control',
        cmd: [
            'Meta',
            'MetaLeft',
            'MetaRight'
        ],
        enter: 'Enter',
        esc: 'Escape',
        backspace: 'Backspace',
        delete: 'Delete',
        sqbr_open: '[',
        sqbr_close: ']',
        a: [
            'a',
            'A'
        ],
        b: [
            'b',
            'B'
        ],
        c: [
            'c',
            'C'
        ],
        e: [
            'e',
            'E'
        ],
        f: [
            'f',
            'F'
        ],
        g: [
            'g',
            'G'
        ],
        l: [
            'l',
            'L'
        ],
        r: [
            'r',
            'R'
        ],
        s: [
            's',
            'S'
        ],
        t: [
            't',
            'T'
        ],
        u: [
            'u',
            'U'
        ],
        x: [
            'x',
            'X'
        ],
        y: [
            'y',
            'Y'
        ],
        z: [
            'z',
            'Z'
        ],
        plus: '+',
        minus: '-',
        left: 'ArrowLeft',
        right: 'ArrowRight',
        up: 'ArrowUp',
        down: 'ArrowDown',
        home: 'Home',
        end: 'End'
    };
    // ['space', 'alt', ... ]
    var keyStrArr = Object.keys(keyStrToKeyObj);
    // { space: false, ... }
    var isDownObj = Object.entries(keyStrToKeyObj).reduce(function(acc, param) {
        var _param = (0, $8N5YG._)(param, 1), key = _param[0];
        acc[key] = false;
        return acc;
    }, {});
    // event.key to keyStr
    // { ArrowLeft: 'left', ... }
    var keyToKeyStrObj = Object.entries(keyStrToKeyObj).reduce(function(acc, param) {
        var _param = (0, $8N5YG._)(param, 2), key = _param[0], code = _param[1];
        if (typeof code === 'string') acc[code] = key;
        else code.forEach(function(item) {
            acc[item] = key;
        });
        return acc;
    }, {});
    var comboArr = [];
    // a physical key's "key" can change as other keys get pressed. to keep track, need to also track the code
    // { KeyE: 'e', KeyF: undefined } - undefined - not down, string - the associated keyStr
    var codeIsDownObj = {};
    var listenerArr = [];
    /**
     * Windows bug in all browsers: Pressing the Windows key leads to keyboard events not firing.
     * It breaks key state tracking.
     * Workaround: If after a timeout, only the meta key is pressed, fire a keyup for the meta key.
     */ var metaClearTimeout;
    var setupMetaClear = function(keyStr, code) {
        metaClearTimeout = setTimeout(function() {
            if (comboArr.length !== 1 || comboArr[0] === 'cmd') return;
            var oldComboStr = comboArr.join('+');
            isDownObj[keyStr] = false;
            codeIsDownObj[code] = undefined;
            // remove from combo
            for(var i = 0; i < comboArr.length; i++)if (comboArr[i] == keyStr) {
                comboArr.splice(i, 1);
                i--;
            }
            emitUp(keyStr, {
                preventDefault: function preventDefault() {},
                stopPropagation: function stopPropagation() {}
            }, oldComboStr);
            metaClearTimeout = undefined;
        }, 1000);
    };
    var emitDown = function emitDown(a, b, c, d) {
        listenerArr.forEach(function(item) {
            if (!item[0]) return;
            item[0](a, b, c, d);
        });
    };
    var emitUp = function emitUp(a, b, c) {
        listenerArr.forEach(function(item) {
            if (!item[1]) return;
            item[1](a, b, c);
        });
    };
    var emitBlur = function emitBlur() {
        listenerArr.forEach(function(item) {
            if (!item[2]) return;
            item[2]();
        });
    };
    return {
        add: function(keyListenerRef) {
            if (listenerArr.includes(keyListenerRef)) return;
            var first = listenerArr.length === 0;
            listenerArr.push(keyListenerRef);
            if (first) {
                document.addEventListener('keydown', keyDown);
                document.addEventListener('keyup', keyUp);
                window.addEventListener('blur', blur);
            }
        },
        remove: function(keyListenerRef) {
            if (!listenerArr.includes(keyListenerRef)) return;
            var last = listenerArr.length === 1;
            for(var i = 0; i < listenerArr.length; i++)if (listenerArr[i] === keyListenerRef) {
                listenerArr.splice(i, 1);
                break;
            }
            if (last) {
                document.removeEventListener('keydown', keyDown);
                document.removeEventListener('keyup', keyUp);
                window.removeEventListener('blur', blur);
                // cleanup
                comboArr = [];
                codeIsDownObj = {};
                keyStrArr.forEach(function(keyStr) {
                    if (isDownObj[keyStr]) isDownObj[keyStr] = false;
                });
            }
        },
        getIsDown: function() {
            return isDownObj;
        },
        getCombo: function() {
            return comboArr;
        },
        blur: blur
    };
}();
var $74d1f29ad2137b2c$export$f17908c5de22d32e = /*#__PURE__*/ function() {
    "use strict";
    function KeyListener(p) {
        (0, $cx0mh._)(this, KeyListener);
        this.onDown = p.onDown;
        this.onUp = p.onUp;
        this.onBlur = p.onBlur;
        this.ref = [
            this.onDown,
            this.onUp,
            this.onBlur
        ];
        $74d1f29ad2137b2c$var$globalKey.add(this.ref);
    }
    (0, $7h4XF._)(KeyListener, [
        {
            key: "isPressed",
            value: function isPressed(keyStr) {
                if (!(keyStr in $74d1f29ad2137b2c$var$globalKey.getIsDown())) throw 'key "' + keyStr + '" not found';
                return $74d1f29ad2137b2c$var$globalKey.getIsDown()[keyStr];
            }
        },
        {
            key: "getComboStr",
            value: function getComboStr() {
                return $74d1f29ad2137b2c$var$globalKey.getCombo().join('+');
            }
        },
        {
            key: "comboOnlyContains",
            value: function comboOnlyContains(keyStrArr) {
                for(var i = 0; i < $74d1f29ad2137b2c$var$globalKey.getCombo().length; i++){
                    if (!keyStrArr.includes($74d1f29ad2137b2c$var$globalKey.getCombo()[i])) return false;
                }
                return true;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                $74d1f29ad2137b2c$var$globalKey.remove(this.ref);
            }
        }
    ]);
    return KeyListener;
}();
function $74d1f29ad2137b2c$export$e9f65b0175de4c03(comboAStr, comboBStr) {
    return comboAStr.split('+').sort().join('+') === comboBStr.split('+').sort().join('+');
}

});

parcelRegister("04lDo", function(module, exports) {

$parcel$export(module.exports, "PointerListener", function () { return $893e90c2dcf687ac$export$9371bd96776f4e82; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $6J2My = parcelRequire("6J2My");

var $93oLo = parcelRequire("93oLo");

var $eIAon = parcelRequire("eIAon");
// keeping track of pointers for movement fallback
var $893e90c2dcf687ac$var$pointerArr = [];
function $893e90c2dcf687ac$var$addPointer(event) {
    var pointerObj = {
        pointerId: event.pointerId,
        lastPageX: null,
        lastPageY: null
    };
    $893e90c2dcf687ac$var$pointerArr.push(pointerObj);
    if ($893e90c2dcf687ac$var$pointerArr.length > 15) $893e90c2dcf687ac$var$pointerArr.shift();
    return pointerObj;
}
function $893e90c2dcf687ac$var$getPointer(event) {
    for(var i = $893e90c2dcf687ac$var$pointerArr.length - 1; i >= 0; i--){
        if (event.pointerId === $893e90c2dcf687ac$var$pointerArr[i].pointerId) return $893e90c2dcf687ac$var$pointerArr[i];
    }
    return null;
}
function $893e90c2dcf687ac$var$getButtonStr(buttons) {
    switch(buttons){
        case 1:
            return 'left';
        case 2:
            return 'right';
        case 4:
            return 'middle';
        default:
            return undefined;
    }
}
var $893e90c2dcf687ac$var$pressureNormalizer = new (0, $eIAon.PressureNormalizer)();
var $893e90c2dcf687ac$var$timeStampOffset = (0, $6J2My.EVENT_USES_HIGH_RES_TIMESTAMP)() ? 0 : -performance.timing.navigationStart;
var $893e90c2dcf687ac$var$pointerDownEvt = (0, $6J2My.HAS_POINTER_EVENTS) ? 'pointerdown' : 'mousedown';
var $893e90c2dcf687ac$var$pointerMoveEvt = (0, $6J2My.HAS_POINTER_EVENTS) ? 'pointermove' : 'mousemove';
var $893e90c2dcf687ac$var$pointerUpEvt = (0, $6J2My.HAS_POINTER_EVENTS) ? 'pointerup' : 'mouseup';
var $893e90c2dcf687ac$var$pointerCancelEvt = (0, $6J2My.HAS_POINTER_EVENTS) ? 'pointercancel' : 'mousecancel';
var $893e90c2dcf687ac$var$pointerLeaveEvt = (0, $6J2My.HAS_POINTER_EVENTS) ? 'pointerleave' : 'mouseleave';
var $893e90c2dcf687ac$var$pointerEnterEvt = (0, $6J2My.HAS_POINTER_EVENTS) ? 'pointerenter' : 'mouseenter';
/**
 * More trustworthy pointer attributes. that behave the same across browsers.
 * returns a new object. Also attaches itself to the orig event. -> event.corrected
 */ function $893e90c2dcf687ac$var$correctPointerEvent(event) {
    if ('corrected' in event) return event.corrected;
    function determineButtons() {
        if (event.buttons !== undefined) return event.buttons;
        /*
                button -> buttons
        none:	undefined -> 0
        left:	0 -> 1
        middle:	1 -> 4
        right:	2 -> 2
        fourth:	3 -> 8
        fifth:	4 -> 16
         */ if (event.button !== undefined) // old safari on mac has no buttons. remove eventually.
        return [
            1,
            4,
            2,
            8,
            16
        ][event.button];
        return 0;
    }
    var correctedObj = {
        pointerId: event.pointerId,
        pointerType: event.pointerType,
        pageX: event.pageX,
        pageY: event.pageY,
        clientX: event.clientX,
        clientY: event.clientY,
        movementX: event.movementX,
        movementY: event.movementY,
        timeStamp: event.timeStamp + $893e90c2dcf687ac$var$timeStampOffset,
        pressure: $893e90c2dcf687ac$var$pressureNormalizer.normalize(event.pressure, event.type, event.pointerType),
        buttons: determineButtons(),
        button: event.button,
        coalescedArr: [],
        eventPreventDefault: function() {
            return event.preventDefault();
        },
        eventStopPropagation: function() {
            return event.stopPropagation();
        }
    };
    event.corrected = correctedObj;
    var customPressure = null;
    if ('pointerId' in event) {
        if ('pressure' in event && event.buttons !== 0) {
            if (event.pointerType === 'touch' && event.pressure === 0) {
                correctedObj.pressure = 1;
                customPressure = 1;
            }
            // Spec: If there's no pressure support, pressure is 0.5.
            // https://w3c.github.io/pointerevents/#dom-pointerevent-pressure
            // & in older Safari (<=16) it seems to be "mouse" and 0.
            if (event.pointerType === 'mouse' && (event.pressure === 0.5 || event.pressure === 0)) {
                correctedObj.pressure = 1;
                customPressure = 1;
            }
        }
    } else {
        correctedObj.pointerId = 0;
        correctedObj.pointerType = 'mouse';
        correctedObj.pressure = event.buttons !== 0 ? 1 : 0;
        customPressure = correctedObj.pressure;
    }
    if ((0, $6J2My.IS_FIREFOX) && event.pointerType != 'mouse' && event.type === 'pointermove' && event.buttons === 0) // once again firefox
    correctedObj.buttons = 1; // todo wrong if no buttons actually pressed
    var coalescedEventArr = [];
    if ('getCoalescedEvents' in event) coalescedEventArr = event.getCoalescedEvents();
    // chrome somehow movementX not same scale as pageX. todo: only chrome?
    // so make my own
    var pointerObj = $893e90c2dcf687ac$var$getPointer(correctedObj) || $893e90c2dcf687ac$var$addPointer(correctedObj);
    var totalLastX = pointerObj.lastPageX;
    var totalLastY = pointerObj.lastPageY;
    for(var i = 0; i < coalescedEventArr.length; i++){
        var eventItem = coalescedEventArr[i];
        correctedObj.coalescedArr.push({
            pageX: eventItem.pageX,
            pageY: eventItem.pageY,
            clientX: eventItem.clientX,
            clientY: eventItem.clientY,
            movementX: pointerObj.lastPageX === null ? 0 : eventItem.pageX - pointerObj.lastPageX,
            movementY: pointerObj.lastPageY === null ? 0 : eventItem.pageY - pointerObj.lastPageY,
            timeStamp: eventItem.timeStamp === 0 ? correctedObj.timeStamp : eventItem.timeStamp + $893e90c2dcf687ac$var$timeStampOffset,
            pressure: customPressure === null ? $893e90c2dcf687ac$var$pressureNormalizer.normalize(eventItem.pressure) : customPressure
        });
        pointerObj.lastPageX = eventItem.pageX;
        pointerObj.lastPageY = eventItem.pageY;
    }
    pointerObj.lastPageX = correctedObj.pageX;
    pointerObj.lastPageY = correctedObj.pageY;
    correctedObj.movementX = totalLastX === null ? 0 : pointerObj.lastPageX - totalLastX;
    correctedObj.movementY = totalLastY === null ? 0 : pointerObj.lastPageY - totalLastY;
    return correctedObj;
}
var $893e90c2dcf687ac$var$OPTIONS_PASSIVE = {
    passive: false
};
var $893e90c2dcf687ac$export$9371bd96776f4e82 = /*#__PURE__*/ function() {
    "use strict";
    function PointerListener(p) {
        var _this = this;
        (0, $cx0mh._)(this, PointerListener);
        this.isDestroyed = false;
        this.isOverCounter = 0;
        // pointers that are pressing a button
        this.dragObjArr = [];
        this.dragPointerIdArr = [];
        // chrome input glitch workaround
        this.lastPointerType = null;
        this.didSkip = false;
        this.targetElement = p.target;
        this.onPointerCallback = p.onPointer;
        this.onWheelCallback = p.onWheel;
        this.onEnterLeaveCallback = p.onEnterLeave;
        var _p_maxPointers;
        this.maxPointers = Math.max(1, (_p_maxPointers = p.maxPointers) !== null && _p_maxPointers !== void 0 ? _p_maxPointers : 1);
        var finalizeWheelEvent = function(e) {
            if (_this.isDestroyed || !_this.onWheelCallback) return;
            var bounds = _this.targetElement.getBoundingClientRect();
            var whlEvent = (0, $cL71g._)((0, $4EWN2._)((0, $cL71g._)({}, e instanceof WheelEvent ? {
                deltaY: e.deltaY / 120,
                pageX: e.pageX,
                pageY: e.pageY
            } : e), {
                relX: e.clientX - bounds.left + _this.targetElement.scrollLeft,
                relY: e.clientY - bounds.top + _this.targetElement.scrollTop
            }), e instanceof WheelEvent ? {
                event: e
            } : {});
            _this.onWheelCallback(whlEvent);
        };
        this.wheelCleaner = p.useDirtyWheel ? undefined : new (0, $93oLo.WheelCleaner)(finalizeWheelEvent);
        if (this.onPointerCallback) {
            this.onPointerMove = function(event) {
                var _this_onPointerCallback, _this1;
                var correctedEvent = $893e90c2dcf687ac$var$correctPointerEvent(event);
                var tempLastPointerType = _this.lastPointerType;
                _this.lastPointerType = correctedEvent.pointerType;
                if (_this.dragPointerIdArr.includes(correctedEvent.pointerId) || _this.dragPointerIdArr.length === _this.maxPointers || correctedEvent.pointerType === 'touch') {
                    _this.didSkip = false;
                    return;
                }
                // chrome input glitch workaround - throws in a random mouse event with the wrong position when using a stylus
                if (!_this.didSkip && correctedEvent.pointerType === 'mouse' && tempLastPointerType === 'pen') {
                    _this.didSkip = true;
                    return;
                }
                _this.didSkip = false;
                var outEvent = _this.createPointerOutEvent('pointermove', correctedEvent);
                (_this_onPointerCallback = (_this1 = _this).onPointerCallback) === null || _this_onPointerCallback === void 0 ? void 0 : _this_onPointerCallback.call(_this1, outEvent);
            };
            this.onPointerDown = function(event, onSkipGlobal) {
                var _this_onPointerCallback, _this1;
                //BB.throwOut('pointerdown ' + event.pointerId + ' | ' + dragPointerIdArr.length);
                var correctedEvent = $893e90c2dcf687ac$var$correctPointerEvent(event);
                ////console.log('debug: ' + event.pointerId + ' pointerdown');
                if (_this.dragPointerIdArr.includes(correctedEvent.pointerId) || _this.dragPointerIdArr.length === _this.maxPointers || ![
                    1,
                    2,
                    4
                ].includes(correctedEvent.buttons)) //BB.throwOut('pointerdown ignored');
                return;
                //set up global listeners
                if (_this.dragObjArr.length === 0 && !onSkipGlobal) _this.setupDocumentListeners();
                var dragObj = {
                    pointerId: correctedEvent.pointerId,
                    pointerType: correctedEvent.pointerType,
                    downPageX: correctedEvent.pageX,
                    downPageY: correctedEvent.pageY,
                    buttons: correctedEvent.buttons,
                    lastPageX: correctedEvent.pageX,
                    lastPageY: correctedEvent.pageY,
                    lastTimeStamp: correctedEvent.timeStamp
                };
                _this.dragObjArr.push(dragObj);
                _this.dragPointerIdArr.push(correctedEvent.pointerId);
                var outEvent = _this.createPointerOutEvent('pointerdown', correctedEvent, {
                    downPageX: correctedEvent.pageX,
                    downPageY: correctedEvent.pageY,
                    button: $893e90c2dcf687ac$var$getButtonStr(correctedEvent.buttons),
                    pressure: correctedEvent.pressure
                });
                (_this_onPointerCallback = (_this1 = _this).onPointerCallback) === null || _this_onPointerCallback === void 0 ? void 0 : _this_onPointerCallback.call(_this1, outEvent);
            };
            this.windowOnPointerMove = function(event) {
                var _this_onPointerCallback, _this1;
                //BB.throwOut('pointermove ' + event.pointerId);
                var correctedEvent = $893e90c2dcf687ac$var$correctPointerEvent(event);
                ////console.log('debug: ' + event.pointerId + ' GLOBALpointermove');
                if (!_this.dragPointerIdArr.includes(correctedEvent.pointerId)) return;
                var dragObj = _this.getDragObj(correctedEvent.pointerId);
                if (!dragObj) // todo need to handle this!
                return;
                //if pointer changes button its pressing -> turn into pointerup
                if (correctedEvent.buttons !== dragObj.buttons) {
                    var _this_onPointerCallback1, _this2;
                    //pointer up
                    //remove listener
                    if (_this.dragObjArr.length === 1) _this.destroyDocumentListeners();
                    _this.removeDragObj(correctedEvent.pointerId);
                    var outEvent = _this.createPointerOutEvent('pointerup', correctedEvent, {
                        downPageX: dragObj.downPageX,
                        downPageY: dragObj.downPageY
                    });
                    (_this_onPointerCallback1 = (_this2 = _this).onPointerCallback) === null || _this_onPointerCallback1 === void 0 ? void 0 : _this_onPointerCallback1.call(_this2, outEvent);
                    return;
                }
                // ipad likes to do this
                if (correctedEvent.pointerType === 'pen' && correctedEvent.pageX === dragObj.lastPageX && correctedEvent.pageY === dragObj.lastPageY && correctedEvent.timeStamp === dragObj.lastTimeStamp) //ignore
                return;
                var outEvent1 = _this.createPointerOutEvent('pointermove', correctedEvent, {
                    downPageX: dragObj.downPageX,
                    downPageY: dragObj.downPageY,
                    button: $893e90c2dcf687ac$var$getButtonStr(correctedEvent.buttons),
                    pressure: correctedEvent.pressure
                });
                dragObj.lastPageX = correctedEvent.pageX;
                dragObj.lastPageY = correctedEvent.pageY;
                dragObj.lastTimeStamp = correctedEvent.timeStamp;
                (_this_onPointerCallback = (_this1 = _this).onPointerCallback) === null || _this_onPointerCallback === void 0 ? void 0 : _this_onPointerCallback.call(_this1, outEvent1);
            };
            this.windowOnPointerUp = function(event) {
                var _this_onPointerCallback, _this1;
                //BB.throwOut('pointerup ' + event.pointerId);
                var correctedEvent = $893e90c2dcf687ac$var$correctPointerEvent(event);
                ////console.log('debug: ' + event.pointerId + ' GLOBALpointerup');
                if (!_this.dragPointerIdArr.includes(correctedEvent.pointerId)) return;
                //remove listener
                if (_this.dragObjArr.length === 1) _this.destroyDocumentListeners();
                var dragObj = _this.removeDragObj(correctedEvent.pointerId);
                if (!dragObj) // todo need to handle this!
                return;
                var outEvent = _this.createPointerOutEvent('pointerup', correctedEvent, {
                    downPageX: dragObj.downPageX,
                    downPageY: dragObj.downPageY
                });
                (_this_onPointerCallback = (_this1 = _this).onPointerCallback) === null || _this_onPointerCallback === void 0 ? void 0 : _this_onPointerCallback.call(_this1, outEvent);
            };
            this.windowOnPointerLeave = function(event) {
                var _this_onPointerCallback, _this1;
                //BB.throwOut('pointerleave ' + event.pointerId);
                var correctedEvent = $893e90c2dcf687ac$var$correctPointerEvent(event);
                ////console.log('debug: ' + event.pointerId + ' onGlobalPointerLeave', event);
                if (!_this.dragPointerIdArr.includes(correctedEvent.pointerId)) //} || event.target !== document) {
                return;
                //remove listener
                if (_this.dragObjArr.length === 1) _this.destroyDocumentListeners();
                var dragObj = _this.removeDragObj(correctedEvent.pointerId);
                if (!dragObj) // todo need to handle this!
                return;
                var outEvent = _this.createPointerOutEvent('pointerup', correctedEvent, {
                    downPageX: dragObj.downPageX,
                    downPageY: dragObj.downPageY
                });
                (_this_onPointerCallback = (_this1 = _this).onPointerCallback) === null || _this_onPointerCallback === void 0 ? void 0 : _this_onPointerCallback.call(_this1, outEvent);
            };
            this.targetElement.addEventListener($893e90c2dcf687ac$var$pointerMoveEvt, this.onPointerMove, $893e90c2dcf687ac$var$OPTIONS_PASSIVE);
            this.targetElement.addEventListener($893e90c2dcf687ac$var$pointerDownEvt, this.onPointerDown, $893e90c2dcf687ac$var$OPTIONS_PASSIVE);
            if (!(0, $6J2My.HAS_POINTER_EVENTS)) {
                var touchToFakePointer = function(touch, touchEvent, isDown) {
                    return {
                        pointerId: touch.identifier,
                        pointerType: 'touch',
                        pageX: touch.pageX,
                        pageY: touch.pageY,
                        clientX: touch.clientX,
                        clientY: touch.clientY,
                        button: isDown ? 0 : undefined,
                        buttons: isDown ? 1 : 0,
                        timeStamp: touchEvent.timeStamp,
                        target: touchEvent.target,
                        pressure: isDown ? 1 : 0,
                        preventDefault: function() {
                            return touchEvent.preventDefault();
                        },
                        stopPropagation: function() {
                            return touchEvent.stopPropagation();
                        }
                    };
                };
                var handleTouch = function(e, type) {
                    for(var i = 0; i < e.changedTouches.length; i++){
                        var touch = e.changedTouches[i];
                        var fakePointer = touchToFakePointer(touch, e, [
                            'start',
                            'move'
                        ].includes(type));
                        if (type === 'start') _this.onPointerDown(fakePointer, false);
                        else if (type === 'move') _this.windowOnPointerMove(fakePointer);
                        else if (type === 'end') _this.windowOnPointerUp(fakePointer);
                        else _this.windowOnPointerLeave(fakePointer);
                    }
                };
                this.onTouchStart = function(e) {
                    e.preventDefault();
                    handleTouch(e, 'start');
                };
                this.onTouchMove = function(e) {
                    handleTouch(e, 'move');
                };
                this.onTouchEnd = function(e) {
                    handleTouch(e, 'end');
                };
                this.onTouchCancel = function(e) {
                    handleTouch(e, 'cancel');
                };
                this.targetElement.addEventListener('touchstart', this.onTouchStart, $893e90c2dcf687ac$var$OPTIONS_PASSIVE);
                this.targetElement.addEventListener('touchmove', this.onTouchMove, $893e90c2dcf687ac$var$OPTIONS_PASSIVE);
                this.targetElement.addEventListener('touchend', this.onTouchEnd, $893e90c2dcf687ac$var$OPTIONS_PASSIVE);
                this.targetElement.addEventListener('touchcancel', this.onTouchCancel, $893e90c2dcf687ac$var$OPTIONS_PASSIVE);
            }
        }
        if (this.onWheelCallback) {
            this.onWheel = function(e) {
                if (_this.wheelCleaner) _this.wheelCleaner.process(e);
                else finalizeWheelEvent(e);
            };
            this.targetElement.addEventListener('wheel', this.onWheel, {
                passive: !!p.isWheelPassive
            });
        }
        if (this.onEnterLeaveCallback) {
            this.onPointerEnter = function(e) {
                var _this_onEnterLeaveCallback, _this1;
                // workaround for Safari which can falsely fire pointerenter. For more details see below.
                if (!$893e90c2dcf687ac$var$pointerTypeMouseOccurred && e.pointerType === 'mouse') return;
                _this.isOverCounter++;
                (_this_onEnterLeaveCallback = (_this1 = _this).onEnterLeaveCallback) === null || _this_onEnterLeaveCallback === void 0 ? void 0 : _this_onEnterLeaveCallback.call(_this1, true);
            };
            this.onPointerLeave = function() {
                var _this_onEnterLeaveCallback, _this1;
                _this.isOverCounter--;
                (_this_onEnterLeaveCallback = (_this1 = _this).onEnterLeaveCallback) === null || _this_onEnterLeaveCallback === void 0 ? void 0 : _this_onEnterLeaveCallback.call(_this1, false);
            };
            this.targetElement.addEventListener($893e90c2dcf687ac$var$pointerEnterEvt, this.onPointerEnter, $893e90c2dcf687ac$var$OPTIONS_PASSIVE);
            this.targetElement.addEventListener($893e90c2dcf687ac$var$pointerLeaveEvt, this.onPointerLeave, $893e90c2dcf687ac$var$OPTIONS_PASSIVE);
        }
        if (p.fixScribble) {
            //ipad scribble workaround https://developer.apple.com/forums/thread/662874
            this.onTouchMoveScribbleFix = function(e) {
                return e.preventDefault();
            };
            this.targetElement.addEventListener('touchmove', this.onTouchMoveScribbleFix, $893e90c2dcf687ac$var$OPTIONS_PASSIVE);
        }
    }
    (0, $7h4XF._)(PointerListener, [
        {
            key: "getDragObj",
            value: function getDragObj(pointerId) {
                for(var i = 0; i < this.dragObjArr.length; i++){
                    if (pointerId === this.dragObjArr[i].pointerId) return this.dragObjArr[i];
                }
                return null;
            }
        },
        {
            key: "removeDragObj",
            value: function removeDragObj(pointerId) {
                var removedDragObj = null;
                for(var i = 0; i < this.dragPointerIdArr.length; i++)if (this.dragPointerIdArr[i] === pointerId) {
                    removedDragObj = this.dragObjArr[i];
                    this.dragObjArr.splice(i, 1);
                    this.dragPointerIdArr.splice(i, 1);
                    i--;
                }
                return removedDragObj;
            }
        },
        {
            key: "createPointerOutEvent",
            value: /**
     * Creates a value for onPointer, from a pointer event handler.
     */ function createPointerOutEvent(typeStr, correctedEvent, custom) {
                var bounds = this.targetElement.getBoundingClientRect();
                var result = (0, $cL71g._)({
                    type: typeStr,
                    pointerId: correctedEvent.pointerId,
                    pointerType: correctedEvent.pointerType,
                    pageX: correctedEvent.pageX,
                    pageY: correctedEvent.pageY,
                    clientX: correctedEvent.clientX,
                    clientY: correctedEvent.clientY,
                    relX: correctedEvent.clientX - bounds.left + this.targetElement.scrollLeft,
                    relY: correctedEvent.clientY - bounds.top + this.targetElement.scrollTop,
                    dX: correctedEvent.movementX,
                    dY: correctedEvent.movementY,
                    time: correctedEvent.timeStamp,
                    eventPreventDefault: correctedEvent.eventPreventDefault,
                    eventStopPropagation: correctedEvent.eventStopPropagation
                }, custom);
                if (typeStr === 'pointermove') {
                    result.coalescedArr = [];
                    if (correctedEvent.coalescedArr.length > 1) {
                        var coalescedItem;
                        for(var i = 0; i < correctedEvent.coalescedArr.length; i++){
                            coalescedItem = correctedEvent.coalescedArr[i];
                            result.coalescedArr.push({
                                pageX: coalescedItem.pageX,
                                pageY: coalescedItem.pageY,
                                clientX: coalescedItem.clientX,
                                clientY: coalescedItem.clientY,
                                relX: coalescedItem.clientX - bounds.left + this.targetElement.scrollLeft,
                                relY: coalescedItem.clientY - bounds.top + this.targetElement.scrollTop,
                                dX: coalescedItem.movementX,
                                dY: coalescedItem.movementY,
                                time: coalescedItem.timeStamp
                            });
                        }
                    }
                }
                return result;
            }
        },
        {
            key: "setupDocumentListeners",
            value: function setupDocumentListeners() {
                this.windowOnPointerMove && document.addEventListener($893e90c2dcf687ac$var$pointerMoveEvt, this.windowOnPointerMove, $893e90c2dcf687ac$var$OPTIONS_PASSIVE);
                this.windowOnPointerUp && document.addEventListener($893e90c2dcf687ac$var$pointerUpEvt, this.windowOnPointerUp, $893e90c2dcf687ac$var$OPTIONS_PASSIVE);
                this.windowOnPointerLeave && document.addEventListener($893e90c2dcf687ac$var$pointerCancelEvt, this.windowOnPointerLeave, $893e90c2dcf687ac$var$OPTIONS_PASSIVE);
                this.windowOnPointerLeave && document.addEventListener($893e90c2dcf687ac$var$pointerLeaveEvt, this.windowOnPointerLeave, $893e90c2dcf687ac$var$OPTIONS_PASSIVE);
            }
        },
        {
            key: "destroyDocumentListeners",
            value: function destroyDocumentListeners() {
                this.windowOnPointerMove && document.removeEventListener($893e90c2dcf687ac$var$pointerMoveEvt, this.windowOnPointerMove);
                this.windowOnPointerUp && document.removeEventListener($893e90c2dcf687ac$var$pointerUpEvt, this.windowOnPointerUp);
                this.windowOnPointerLeave && document.removeEventListener($893e90c2dcf687ac$var$pointerCancelEvt, this.windowOnPointerLeave);
                this.windowOnPointerLeave && document.removeEventListener($893e90c2dcf687ac$var$pointerLeaveEvt, this.windowOnPointerLeave);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this.isDestroyed) return;
                this.isDestroyed = true;
                this.onPointerEnter && this.targetElement.removeEventListener($893e90c2dcf687ac$var$pointerEnterEvt, this.onPointerEnter);
                this.onPointerLeave && this.targetElement.removeEventListener($893e90c2dcf687ac$var$pointerLeaveEvt, this.onPointerLeave);
                this.onPointerMove && this.targetElement.removeEventListener($893e90c2dcf687ac$var$pointerMoveEvt, this.onPointerMove);
                this.onPointerDown && this.targetElement.removeEventListener($893e90c2dcf687ac$var$pointerDownEvt, this.onPointerDown);
                this.onWheel && this.targetElement.removeEventListener('wheel', this.onWheel);
                this.destroyDocumentListeners();
                this.onTouchMoveScribbleFix && document.removeEventListener('touchmove', this.onTouchMoveScribbleFix);
                this.onTouchStart && this.targetElement.removeEventListener('touchstart', this.onTouchStart);
                this.onTouchMove && this.targetElement.removeEventListener('touchmove', this.onTouchMove);
                this.onTouchEnd && this.targetElement.removeEventListener('touchend', this.onTouchEnd);
                this.onTouchCancel && this.targetElement.removeEventListener('touchcancel', this.onTouchCancel);
            }
        }
    ]);
    return PointerListener;
}();
// Workaround for Safari (iOS/IPadOS 26.2) https://bugs.webkit.org/show_bug.cgi?id=305856
// The incorrect pointerenter event will be of type "mouse" although the click happened with "touch".
// This workaround won't work if the user uses both touch and mouse. The probability of that should be low enough.
var $893e90c2dcf687ac$var$pointerTypeMouseOccurred = false;
setTimeout(function() {
    var listener = function(e) {
        if (e.pointerType === 'mouse' && !$893e90c2dcf687ac$var$pointerTypeMouseOccurred) {
            $893e90c2dcf687ac$var$pointerTypeMouseOccurred = true;
            document.removeEventListener($893e90c2dcf687ac$var$pointerMoveEvt, listener);
        }
    };
    document.addEventListener($893e90c2dcf687ac$var$pointerMoveEvt, listener);
});

});
parcelRegister("cL71g", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $949f51bc0dc1c31c$export$71511d61b312f219; });

var $exh8t = parcelRequire("exh8t");
function $949f51bc0dc1c31c$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $exh8t._)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("exh8t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a951708b1caecba1$export$71511d61b312f219; });
function $a951708b1caecba1$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("4EWN2", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3648804914912b71$export$71511d61b312f219; });
function $3648804914912b71$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3648804914912b71$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $3648804914912b71$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("93oLo", function(module, exports) {

$parcel$export(module.exports, "WheelCleaner", function () { return $42238a223231ec71$export$c734b8535f2f8e38; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $42238a223231ec71$var$SEQUENCE_TIMEOUT_MS = 200;
var $42238a223231ec71$export$c734b8535f2f8e38 = /*#__PURE__*/ function() {
    "use strict";
    function WheelCleaner(callback) {
        (0, $cx0mh._)(this, WheelCleaner);
        this.callback = callback;
        this.knownUnitArr = [
            100
        ];
        this.sequenceLength = 0;
        this.sequenceUnit = null;
        this.toEmitDelta = null;
        this.position = null;
    }
    (0, $7h4XF._)(WheelCleaner, [
        {
            key: "emit",
            value: function emit(delta) {
                if (this.position === null || this.sequenceUnit === null) return;
                this.callback({
                    deltaY: Math.round(delta / this.sequenceUnit),
                    pageX: this.position.pageX,
                    pageY: this.position.pageY,
                    clientX: this.position.clientX,
                    clientY: this.position.clientY
                });
            }
        },
        {
            key: "endSequence",
            value: function endSequence() {
                if (this.toEmitDelta !== null) {
                    this.emit(this.toEmitDelta);
                    this.toEmitDelta = null;
                }
                if (this.sequenceUnit !== null && !this.knownUnitArr.includes(this.sequenceUnit)) this.knownUnitArr.push(this.sequenceUnit);
                this.sequenceLength = 0;
                this.sequenceUnit = null;
            }
        },
        {
            key: "process",
            value: function process(event) {
                var _this = this;
                this.position = {
                    pageX: event.pageX,
                    pageY: event.pageY,
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                if (this.endSequenceTimeout) clearTimeout(this.endSequenceTimeout);
                this.endSequenceTimeout = setTimeout(function() {
                    return _this.endSequence();
                }, $42238a223231ec71$var$SEQUENCE_TIMEOUT_MS);
                //prep delta
                var delta = event.deltaY;
                if ('deltaMode' in event && event.deltaMode === 1) delta *= 100 / 3;
                var absDelta = Math.abs(delta);
                //sequence begins
                if (this.sequenceLength === 0) {
                    this.sequenceLength++;
                    if (absDelta < 50) //dirty - probably a swipe scroll or pinch scroll on trackpad
                    return;
                    this.sequenceUnit = absDelta;
                    if (this.knownUnitArr.includes(this.sequenceUnit)) //we know this unit - emit right away
                    this.emit(delta);
                    else //unknown unit - wait until next event or sequence end, to have more certainty that it's clean
                    this.toEmitDelta = delta;
                    return;
                }
                if (this.sequenceUnit === null) {
                    //previously determined dirty sequence
                    this.toEmitDelta = null;
                    return;
                }
                //sequence continues
                if (absDelta === 0) //ignore zero scroll
                return;
                if (absDelta === this.sequenceUnit || absDelta / this.sequenceUnit % 1 < 0.0001 // a multiple
                ) ;
                else if (this.sequenceUnit / absDelta % 1 < 0.0001) //unit was actually a multiple - update it
                this.sequenceUnit = absDelta;
                else if (absDelta !== this.sequenceUnit) {
                    //not clean - delta is varying - probably a swipe scroll or pinch scroll on trackpad
                    this.sequenceUnit = null;
                    this.toEmitDelta = null;
                    return;
                }
                if (this.toEmitDelta !== null) {
                    this.emit(this.toEmitDelta);
                    this.toEmitDelta = null;
                }
                this.emit(delta);
            }
        }
    ]);
    return WheelCleaner;
}();

});

parcelRegister("eIAon", function(module, exports) {

$parcel$export(module.exports, "PressureNormalizer", function () { return $e14d50e39929aa54$export$61f95f4b79132931; });
/**
 * Apple Pencil on iPad in Safari has two problems:
 * - You need to press the stylus very strong to reach 1.0 pressure, to the point where the screen starts discoloring
 * - Always fires the same pressure value on pointerdown
 *
 * This normalizer tries to fix that with a workaround.
 *
 * pressure range [0, 1]
 */ 
var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $e14d50e39929aa54$export$61f95f4b79132931 = /*#__PURE__*/ function() {
    "use strict";
    function PressureNormalizer() {
        (0, $cx0mh._)(this, PressureNormalizer);
        this.detectionComplete = false;
        this.isApplePencil = false;
        // detection
        this.initialPointerDownPressure = -1;
        this.pointerDownPressureRepeatCount = 0;
        this.pointerMoveHasDifferentPressure = false;
    }
    (0, $7h4XF._)(PressureNormalizer, [
        {
            // ----------------------------------- public -----------------------------------
            key: "normalize",
            value: function normalize(pressure, eventType, pointerType) {
                if (pointerType === 'pen') {
                    if (!this.detectionComplete) {
                        if (eventType === 'pointerdown') {
                            if (this.initialPointerDownPressure === -1) this.initialPointerDownPressure = pressure;
                            else if (this.initialPointerDownPressure === pressure) {
                                this.pointerDownPressureRepeatCount++;
                                if (this.pointerDownPressureRepeatCount > 1 && this.pointerMoveHasDifferentPressure) {
                                    this.detectionComplete = true;
                                    this.isApplePencil = true;
                                }
                            } else {
                                this.detectionComplete = true;
                                this.isApplePencil = false;
                            }
                        } else if (eventType === 'pointermove') {
                            if (this.initialPointerDownPressure !== pressure) this.pointerMoveHasDifferentPressure = true;
                        }
                    }
                    if (this.detectionComplete && this.isApplePencil) {
                        if (this.initialPointerDownPressure === pressure) return 0;
                        pressure = Math.min(2, pressure * 2);
                    }
                    return pressure;
                } else return pressure;
            }
        }
    ]);
    return PressureNormalizer;
}();

});


parcelRegister("eIcQa", function(module, exports) {

$parcel$export(module.exports, "copyCanvas", function () { return $3f0e2f35371c9852$export$dd0873c0fb3ccff6; });
$parcel$export(module.exports, "ctx", function () { return $3f0e2f35371c9852$export$39f92e86d1722f3a; });
$parcel$export(module.exports, "testShouldPixelate", function () { return $3f0e2f35371c9852$export$1555f643cc9a976; });
$parcel$export(module.exports, "drawTransformedImageWithBounds", function () { return $3f0e2f35371c9852$export$ded2b43392504635; });
$parcel$export(module.exports, "drawTransformedImageOnCanvas", function () { return $3f0e2f35371c9852$export$425a419ef9fc761f; });
$parcel$export(module.exports, "createCheckerCanvas", function () { return $3f0e2f35371c9852$export$754559b36e94ea2f; });
$parcel$export(module.exports, "createCheckerDataUrl", function () { return $3f0e2f35371c9852$export$42af33c76b681867; });
$parcel$export(module.exports, "resizeCanvas", function () { return $3f0e2f35371c9852$export$59b33278b5b2fc8a; });
$parcel$export(module.exports, "convertToAlphaChannelCanvas", function () { return $3f0e2f35371c9852$export$5a7576952c826b4f; });
$parcel$export(module.exports, "freeCanvas", function () { return $3f0e2f35371c9852$export$2384aff49c9b73c2; });
$parcel$export(module.exports, "getCanvasBounds", function () { return $3f0e2f35371c9852$export$c1fcf1f93aeabfbf; });
$parcel$export(module.exports, "canvasToBlob", function () { return $3f0e2f35371c9852$export$403d539f215df596; });
$parcel$export(module.exports, "drawSelectionMask", function () { return $3f0e2f35371c9852$export$f7b95c0f504bef8b; });

var $1LaJZ = parcelRequire("1LaJZ");

var $fk3zw = parcelRequire("fk3zw");

var $eelgW = parcelRequire("eelgW");

var $7jh4K = parcelRequire("7jh4K");

var $9b3eo = parcelRequire("9b3eo");

var $eg83P = parcelRequire("eg83P");
function $3f0e2f35371c9852$export$dd0873c0fb3ccff6(canvas) {
    var resultCanvas = (0, $eelgW.createCanvas)(canvas.width, canvas.height);
    var ctx = resultCanvas.getContext('2d');
    if (!ctx) throw new Error('2d context not supported or canvas already initialized');
    ctx.drawImage(canvas, 0, 0);
    return resultCanvas;
}
function $3f0e2f35371c9852$export$39f92e86d1722f3a(canvas, options) {
    var ctx = canvas.getContext('2d', options);
    if (!ctx) throw new Error("couldn't get 2d context");
    return ctx;
}
function $3f0e2f35371c9852$export$bd64872f2769a724(path) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var im, canvas, ctx;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $7jh4K.asyncLoadImage)(path)
                    ];
                case 1:
                    im = _state.sent();
                    canvas = (0, $eelgW.createCanvas)(im.width, im.height);
                    ctx = canvas.getContext('2d');
                    ctx.drawImage(im, 0, 0);
                    return [
                        2,
                        canvas
                    ];
            }
        });
    })();
}
function $3f0e2f35371c9852$export$1555f643cc9a976(transform, scaleX, scaleY) {
    if (![
        1,
        -1
    ].includes(scaleX) || ![
        1,
        -1
    ].includes(scaleY) || transform.width % 1 !== 0 || transform.height % 1 !== 0 || Math.abs(transform.angleDeg) % 90 !== 0) return false;
    var whSwapped = Math.abs(transform.angleDeg - 90) % 180 === 0;
    var width = whSwapped ? transform.height : transform.width;
    var height = whSwapped ? transform.width : transform.height;
    return (Math.abs(width) % 2 === 0 && transform.x % 1 === 0 || Math.abs(width) % 2 === 1 && transform.x % 1 === 0.5) && (Math.abs(height) % 2 === 0 && transform.y % 1 === 0 || Math.abs(height) % 2 === 1 && transform.y % 1 === 0.5);
}
function $3f0e2f35371c9852$export$ded2b43392504635(destCtx, transformImage, transform, bounds, pixelated) {
    if (!bounds) bounds = {
        x: 0,
        y: 0,
        width: transformImage.width,
        height: transformImage.height
    };
    destCtx.save();
    if (pixelated) destCtx.imageSmoothingEnabled = false;
    else {
        destCtx.imageSmoothingEnabled = true;
        destCtx.imageSmoothingQuality = 'high';
    }
    destCtx.translate(transform.x, transform.y);
    destCtx.rotate(transform.angleDeg / 180 * Math.PI);
    destCtx.scale(transform.width > 0 ? 1 : -1, transform.height > 0 ? 1 : -1);
    destCtx.drawImage(transformImage, bounds.x, bounds.y, bounds.width, bounds.height, -Math.abs(transform.width) / 2, -Math.abs(transform.height) / 2, Math.abs(transform.width), Math.abs(transform.height));
    destCtx.restore();
}
function $3f0e2f35371c9852$export$425a419ef9fc761f(baseCanvas, transformImage, transformObj) {
    transformObj = (0, $7jh4K.copyObj)(transformObj);
    if (!transformObj.center) transformObj.center = {
        x: transformImage.width / 2,
        y: transformImage.height / 2
    };
    if (!transformObj.scale) transformObj.scale = {
        x: 1,
        y: 1
    };
    if (!transformObj.angleDegree) transformObj.angleDegree = 0;
    if (!transformObj.translate) transformObj.translate = {
        x: 0,
        y: 0
    };
    var ctx = baseCanvas.getContext('2d');
    if (!ctx) throw new Error('2d context not supported or canvas already initialized');
    ctx.save();
    if (Math.abs(transformObj.scale.x - 1) > 0.000001 || Math.abs(transformObj.scale.y - 1) > 0.000001 || Math.abs(transformObj.angleDegree % 90) > 0.000001) {
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
    } else ctx.imageSmoothingEnabled = false;
    ctx.translate(transformObj.translate.x, transformObj.translate.y);
    ctx.translate(transformObj.center.x, transformObj.center.y);
    ctx.rotate(transformObj.angleDegree / 180 * Math.PI);
    ctx.scale(transformObj.scale.x, transformObj.scale.y);
    ctx.translate(-transformObj.center.x, -transformObj.center.y);
    ctx.drawImage(transformImage, 0, 0, transformImage.width, transformImage.height);
    ctx.restore();
}
var $3f0e2f35371c9852$export$754559b36e94ea2f = function createCheckerCanvas(size, isDark) {
    var canvas = (0, $eelgW.createCanvas)();
    var ctx;
    if (size < 1) {
        canvas.width = 1;
        canvas.height = 1;
        ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('2d context not supported or canvas already initialized');
        ctx.fillStyle = 'rgb(128, 128, 128)';
        ctx.fillRect(0, 0, 1, 1);
    } else {
        canvas.width = size * 2;
        canvas.height = size * 2;
        ctx = canvas.getContext('2d');
        if (!ctx) throw new Error('2d context not supported or canvas already initialized');
        ctx.fillStyle = isDark ? 'rgb(90, 90, 90)' : 'rgb(255, 255, 255)';
        ctx.fillRect(0, 0, size * 2, size * 2);
        ctx.fillStyle = isDark ? 'rgb(63, 63, 63)' : 'rgb(200, 200, 200)';
        ctx.fillRect(0, 0, size, size);
        ctx.fillRect(size, size, size * 2, size * 2);
    }
    return canvas;
};
var $3f0e2f35371c9852$export$42af33c76b681867 = function() {
    // previously created dataUrls
    var cache = {};
    return function(size, callback, isDark) {
        var modeStr = isDark ? 'd' : 'l';
        function create(size) {
            size = parseInt('' + size);
            if (cache['' + size + modeStr]) return cache['' + size + modeStr];
            var canvas = $3f0e2f35371c9852$export$754559b36e94ea2f(size, isDark);
            var result = canvas.toDataURL('image/png');
            cache['' + size + modeStr] = result;
            return result;
        }
        if (callback) //async
        setTimeout(function() {
            callback(create(size));
        }, 1);
        else //sync
        return create(size);
    };
}();
function $3f0e2f35371c9852$export$59b33278b5b2fc8a(canvas, w, h, tmp1, tmp2) {
    //determine base 2 exponents of old and new size
    function getBase2Obj(oldW, oldH, newW, newH) {
        var result = {
            oldWidthEx: Math.round(Math.log2(oldW)),
            oldHeightEx: Math.round(Math.log2(oldH)),
            newWidthEx: Math.ceil(Math.log2(newW)),
            newHeightEx: Math.ceil(Math.log2(newH))
        };
        result.oldWidthEx = Math.max(result.oldWidthEx, result.newWidthEx);
        result.oldHeightEx = Math.max(result.oldHeightEx, result.newHeightEx);
        return result;
    }
    if (!w || !h || w === canvas.width && h === canvas.height) return;
    w = Math.max(w, 1);
    h = Math.max(h, 1);
    if (w <= canvas.width && h <= canvas.height) {
        tmp1 = !tmp1 ? (0, $eelgW.createCanvas)() : tmp1;
        tmp2 = !tmp2 ? (0, $eelgW.createCanvas)() : tmp2;
        var base2 = getBase2Obj(canvas.width, canvas.height, w, h);
        //initially scale to a base of 2. unless new size is too close to old. e.g. sizing from 900 to 600
        tmp2.width = base2.oldWidthEx > base2.newWidthEx ? Math.pow(2, base2.oldWidthEx) : w;
        tmp2.height = base2.oldHeightEx > base2.newHeightEx ? Math.pow(2, base2.oldHeightEx) : h;
        tmp1.getContext('2d').save();
        tmp2.getContext('2d').save();
        var ew, eh;
        var buffer1 = tmp1, buffer2 = tmp2;
        ew = base2.oldWidthEx;
        eh = base2.oldHeightEx;
        var bufferCtx = buffer2.getContext('2d');
        bufferCtx.imageSmoothingEnabled = true;
        bufferCtx.imageSmoothingQuality = 'high';
        bufferCtx.globalCompositeOperation = 'copy';
        bufferCtx.drawImage(canvas, 0, 0, buffer2.width, buffer2.height);
        var currentWidth = buffer2.width;
        var currentHeight = buffer2.height;
        //stepwise half the size
        for(; ew > base2.newWidthEx || eh > base2.newHeightEx; ew--, eh--){
            bufferCtx = buffer1.getContext('2d');
            bufferCtx.imageSmoothingEnabled = true;
            bufferCtx.imageSmoothingQuality = 'high';
            bufferCtx.globalCompositeOperation = 'copy';
            var newWidth = ew > base2.newWidthEx ? currentWidth / 2 : currentWidth;
            var newHeight = eh > base2.newHeightEx ? currentHeight / 2 : currentHeight;
            //buffer also needs to be properly sized, unfortunately
            buffer1.width = newWidth;
            buffer1.height = newHeight;
            bufferCtx.drawImage(buffer2, 0, 0, currentWidth, currentHeight, 0, 0, newWidth, newHeight);
            currentWidth = newWidth;
            currentHeight = newHeight;
            //swap
            var tmp = buffer1;
            buffer1 = buffer2;
            buffer2 = tmp;
        }
        //when no longer can be halved, bring to target size
        canvas.width = w;
        canvas.height = h;
        var canvasCtx = canvas.getContext('2d');
        canvasCtx.save();
        canvasCtx.imageSmoothingEnabled = true;
        canvasCtx.imageSmoothingQuality = 'high';
        canvasCtx.drawImage(buffer2, 0, 0, currentWidth, currentHeight, 0, 0, w, h);
        canvasCtx.restore();
        tmp1.getContext('2d').restore();
        tmp2.getContext('2d').restore();
    } else if (w >= canvas.width && h >= canvas.height) {
        tmp1 = !tmp1 ? (0, $eelgW.createCanvas)() : tmp1;
        tmp1.width = w;
        tmp1.height = h;
        var tmp1Ctx = tmp1.getContext('2d');
        tmp1Ctx.save();
        tmp1Ctx.imageSmoothingEnabled = true;
        tmp1Ctx.imageSmoothingQuality = 'high';
        tmp1Ctx.drawImage(canvas, 0, 0, w, h);
        tmp1Ctx.restore();
        canvas.width = w;
        canvas.height = h;
        canvas.getContext('2d').drawImage(tmp1, 0, 0);
    } else {
        $3f0e2f35371c9852$export$59b33278b5b2fc8a(canvas, w, canvas.height, tmp1, tmp2);
        $3f0e2f35371c9852$export$59b33278b5b2fc8a(canvas, w, h, tmp1, tmp2);
    }
}
function $3f0e2f35371c9852$export$5a7576952c826b4f(canvas) {
    var imdat = canvas.getContext('2d').getImageData(0, 0, canvas.width, canvas.height);
    for(var i = 0; i < imdat.data.length; i += 4){
        if (imdat.data[i + 3] === 0) continue;
        imdat.data[i + 3] = (imdat.data[i] + imdat.data[i + 1] + imdat.data[i + 2]) / 3 * (imdat.data[i + 3] / 255);
    }
    canvas.getContext('2d').putImageData(imdat, 0, 0);
}
function $3f0e2f35371c9852$export$2384aff49c9b73c2(canvas) {
    canvas.width = 1;
    canvas.height = 1;
    canvas.remove();
}
function $3f0e2f35371c9852$export$c1fcf1f93aeabfbf(context, //restricts the search to this area.
searchArea) {
    var searchRect = searchArea ? (0, $eg83P.boundsToRect)(searchArea) : {
        x: 0,
        y: 0,
        width: context.canvas.width,
        height: context.canvas.height
    };
    if (searchRect.width <= 0 || searchRect.height <= 0) return undefined;
    var imdat = context.getImageData(searchRect.x, searchRect.y, searchRect.width, searchRect.height);
    // top-left and bottom-right are non-transparent.
    if (imdat.data[3] > 0 && imdat.data[imdat.data.length - 1] > 0) return searchRect;
    var tempBounds = {};
    for(var i = 3; i < imdat.data.length; i += 4)if (imdat.data[i] > 0) {
        var px = (i - 3) / 4 % searchRect.width;
        var py = Math.floor((i - 3) / 4 / searchRect.width);
        if (tempBounds.x1 === undefined || px < tempBounds.x1) tempBounds.x1 = px;
        if (tempBounds.y1 === undefined || py < tempBounds.y1) tempBounds.y1 = py;
        if (tempBounds.x2 === undefined || px + 1 > tempBounds.x2) tempBounds.x2 = px;
        if (tempBounds.y2 === undefined || py + 1 > tempBounds.y2) tempBounds.y2 = py;
    }
    if (tempBounds.x1 === undefined || tempBounds.y1 === undefined || tempBounds.x2 === undefined || tempBounds.y2 === undefined) return undefined;
    return {
        x: tempBounds.x1 + searchRect.x,
        y: tempBounds.y1 + searchRect.y,
        width: tempBounds.x2 - tempBounds.x1 + 1,
        height: tempBounds.y2 - tempBounds.y1 + 1
    };
}
function $3f0e2f35371c9852$export$27e43d53d0895782(canvas, mimeType) {
    return new Promise(function(resolve, reject) {
        canvas.toBlob(function(blob) {
            if (blob) resolve(blob);
            else reject(new Error('Failed to create blob from canvas.'));
        }, mimeType);
    });
}
function $3f0e2f35371c9852$export$403d539f215df596(canvas, mimeType) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!('toBlob' in HTMLCanvasElement.prototype)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $3f0e2f35371c9852$export$27e43d53d0895782(canvas, mimeType)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    // assume base64
                    return [
                        2,
                        (0, $7jh4K.base64ToBlob)(canvas.toDataURL(mimeType))
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $3f0e2f35371c9852$export$f7b95c0f504bef8b(selection, context) {
    var canvas = context.canvas;
    context.save();
    context.fillRect(0, 0, canvas.width, canvas.height);
    var selectionPath = (0, $9b3eo.getSelectionPath2d)(selection);
    context.clip(selectionPath);
    context.fillStyle = 'white';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.restore();
}

});
parcelRegister("eelgW", function(module, exports) {

$parcel$export(module.exports, "createCanvas", function () { return $44dda2e48e48a872$export$cd3d1f114b139967; });
/*window['canvases'] = [];

window['printCanvases'] = () => {
    let total = 0;

    console.log(window['canvases'].map(item => {
        total += item.width * item.height;
        return {w: item.width, h: item.height};
    }));

    console.log('total: ' + (total * 4 / 1000 / 1000) + 'mb');
};*/ function $44dda2e48e48a872$export$cd3d1f114b139967(w, h) {
    var result = document.createElement('canvas');
    if (w && h) {
        result.width = w;
        result.height = h;
    }
    // window['canvases'].push(result);
    return result;
}

});

parcelRegister("9b3eo", function(module, exports) {

$parcel$export(module.exports, "getSelectionPath2d", function () { return $3a8abad308fc0b28$export$ba7ed3181f35c1cc; });
$parcel$export(module.exports, "getSvgPathD", function () { return $3a8abad308fc0b28$export$8f2be1db13cf0f94; });

var $bX4ja = parcelRequire("bX4ja");
function $3a8abad308fc0b28$export$ba7ed3181f35c1cc(selection) {
    var path = new Path2D();
    selection.forEach(function(poly) {
        poly.forEach(function(ring) {
            ring.forEach(function(point, index) {
                var _path, _path1;
                if (index === 0) (_path = path).moveTo.apply(_path, (0, $bX4ja._)(point));
                else (_path1 = path).lineTo.apply(_path1, (0, $bX4ja._)(point));
            });
        });
        path.closePath();
    });
    return path;
}
function $3a8abad308fc0b28$export$8f2be1db13cf0f94(poly) {
    var result = '';
    poly.forEach(function(poly) {
        poly.forEach(function(ring) {
            result += 'M';
            ring.forEach(function(point) {
                result += point.join(',') + ' ';
            });
        });
    });
    return result.trim();
}

});
parcelRegister("bX4ja", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8b388beb029932dc$export$71511d61b312f219; });

var $6KGpL = parcelRequire("6KGpL");

var $5mm0I = parcelRequire("5mm0I");

var $kD20o = parcelRequire("kD20o");

var $kWe4k = parcelRequire("kWe4k");
function $8b388beb029932dc$export$71511d61b312f219(arr) {
    return (0, $6KGpL._)(arr) || (0, $5mm0I._)(arr) || (0, $kWe4k._)(arr) || (0, $kD20o._)();
}

});
parcelRegister("6KGpL", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4ea7f09e3565689e$export$71511d61b312f219; });

var $gszWS = parcelRequire("gszWS");
function $4ea7f09e3565689e$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gszWS._)(arr);
}

});

parcelRegister("5mm0I", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3e7014a700b6235f$export$71511d61b312f219; });
function $3e7014a700b6235f$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("kD20o", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f049015e10c27370$export$71511d61b312f219; });
function $f049015e10c27370$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("eg83P", function(module, exports) {

$parcel$export(module.exports, "mix", function () { return $9a5bdb07e7a7c42f$export$2c9e8a9632a706b2; });
$parcel$export(module.exports, "dist", function () { return $9a5bdb07e7a7c42f$export$6c4a311cc157c764; });
$parcel$export(module.exports, "distSquared", function () { return $9a5bdb07e7a7c42f$export$499eb56409f6cbc2; });
$parcel$export(module.exports, "lenSquared", function () { return $9a5bdb07e7a7c42f$export$a4f99f99d3e99cfa; });
$parcel$export(module.exports, "pointsToAngleRad", function () { return $9a5bdb07e7a7c42f$export$627023b405ba5028; });
$parcel$export(module.exports, "pointsToAngleDeg", function () { return $9a5bdb07e7a7c42f$export$c03a8450eabc2532; });
$parcel$export(module.exports, "isInsideRect", function () { return $9a5bdb07e7a7c42f$export$151bd845d70e2099; });
$parcel$export(module.exports, "clamp", function () { return $9a5bdb07e7a7c42f$export$7d15b64cf5a3a4c4; });
$parcel$export(module.exports, "rotate", function () { return $9a5bdb07e7a7c42f$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "rotateAround", function () { return $9a5bdb07e7a7c42f$export$95ec0760d3d00713; });
$parcel$export(module.exports, "snapAngleDeg", function () { return $9a5bdb07e7a7c42f$export$c0156198713d0f0; });
$parcel$export(module.exports, "minimizeAngleDeg", function () { return $9a5bdb07e7a7c42f$export$ec85425cac357ca9; });
$parcel$export(module.exports, "intDxy", function () { return $9a5bdb07e7a7c42f$export$bbf9af158036c5e9; });
$parcel$export(module.exports, "roundEven", function () { return $9a5bdb07e7a7c42f$export$94cce7adf2ec2d08; });
$parcel$export(module.exports, "roundUneven", function () { return $9a5bdb07e7a7c42f$export$f373b6a7b0c159a; });
$parcel$export(module.exports, "round", function () { return $9a5bdb07e7a7c42f$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "fixBounds", function () { return $9a5bdb07e7a7c42f$export$5aa63862e8b9c037; });
$parcel$export(module.exports, "updateBounds", function () { return $9a5bdb07e7a7c42f$export$f4467a4f41373bc7; });
$parcel$export(module.exports, "intersectBounds", function () { return $9a5bdb07e7a7c42f$export$83720aaadc272d85; });
$parcel$export(module.exports, "indexBoundsInArea", function () { return $9a5bdb07e7a7c42f$export$ddc1c0069d484d49; });
$parcel$export(module.exports, "coordinateBoundsToIndexBounds", function () { return $9a5bdb07e7a7c42f$export$b0036cbc597df324; });
$parcel$export(module.exports, "indexBoundsToCoordinateBounds", function () { return $9a5bdb07e7a7c42f$export$86989866a3954672; });
$parcel$export(module.exports, "indexBoundsToRect", function () { return $9a5bdb07e7a7c42f$export$3488993c9d026384; });
$parcel$export(module.exports, "rectToBounds", function () { return $9a5bdb07e7a7c42f$export$d89ccdf57354a99c; });
$parcel$export(module.exports, "boundsToRect", function () { return $9a5bdb07e7a7c42f$export$4218cb0e42c2e7e; });

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");
function $9a5bdb07e7a7c42f$export$2c9e8a9632a706b2(a, b, f) {
    return a * (1 - f) + b * f;
}
function $9a5bdb07e7a7c42f$export$6c4a311cc157c764(ax, ay, bx, by) {
    return Math.sqrt(Math.pow(ax - bx, 2) + Math.pow(ay - by, 2));
}
function $9a5bdb07e7a7c42f$export$499eb56409f6cbc2(ax, ay, bx, by) {
    // faster because no square-root
    return Math.pow(ax - bx, 2) + Math.pow(ay - by, 2);
}
function $9a5bdb07e7a7c42f$export$a4f99f99d3e99cfa(x, y) {
    // faster because no square-root
    return x * x + y * y;
}
function $9a5bdb07e7a7c42f$export$627023b405ba5028(p1, p2) {
    return Math.atan2(p2.y - p1.y, p2.x - p1.x);
}
function $9a5bdb07e7a7c42f$export$c03a8450eabc2532(p1, p2) {
    return $9a5bdb07e7a7c42f$export$627023b405ba5028(p1, p2) * 180 / Math.PI;
}
function $9a5bdb07e7a7c42f$export$151bd845d70e2099(p, rect) {
    return rect.x <= p.x && p.x <= rect.x + rect.width && rect.y <= p.y && p.y <= rect.y + rect.height;
}
function $9a5bdb07e7a7c42f$export$7d15b64cf5a3a4c4(num, min, max) {
    return num < min ? min : num > max ? max : num;
}
function $9a5bdb07e7a7c42f$export$bb628a54ab399bc9(x, y, deg) {
    var theta = deg * (Math.PI / 180);
    var cs = Math.cos(theta);
    var sn = Math.sin(theta);
    return {
        x: x * cs - y * sn,
        y: x * sn + y * cs
    };
}
function $9a5bdb07e7a7c42f$export$95ec0760d3d00713(center, point, deg) {
    var rot = $9a5bdb07e7a7c42f$export$bb628a54ab399bc9(point.x - center.x, point.y - center.y, deg);
    rot.x += center.x;
    rot.y += center.y;
    return rot;
}
function $9a5bdb07e7a7c42f$export$c0156198713d0f0(angleDeg, snapDegIncrement, maxDistDeg) {
    var modDeg = Math.abs(angleDeg % snapDegIncrement);
    var dist = Math.min(modDeg, snapDegIncrement - modDeg);
    if (dist <= maxDistDeg) angleDeg = Math.round(angleDeg / snapDegIncrement) * snapDegIncrement;
    return angleDeg;
}
function $9a5bdb07e7a7c42f$export$ec85425cac357ca9(angleDeg) {
    angleDeg = angleDeg % 360;
    if (angleDeg > 180) angleDeg -= 360;
    else if (angleDeg < -180) angleDeg += 360;
    return angleDeg;
}
function $9a5bdb07e7a7c42f$export$bbf9af158036c5e9(remainder, fDx, fDy) {
    remainder.x += fDx;
    remainder.y += fDy;
    var dX = Math.round(remainder.x);
    var dY = Math.round(remainder.y);
    remainder.x -= dX;
    remainder.y -= dY;
    return {
        dX: dX,
        dY: dY
    };
}
function $9a5bdb07e7a7c42f$export$94cce7adf2ec2d08(f) {
    if (f % 1 === 0) {
        if (f % 2 === 0) return f;
        return f + 1;
    }
    var above = Math.ceil(f);
    var below = Math.floor(f);
    if (above % 2 === 0) return above;
    else return below;
}
function $9a5bdb07e7a7c42f$export$f373b6a7b0c159a(f) {
    if (f % 1 === 0) {
        if (f % 2 === 0) return f + 1;
        return f;
    }
    var above = Math.ceil(f);
    var below = Math.floor(f);
    if (above % 2 === 1) return above;
    else return below;
}
function $9a5bdb07e7a7c42f$export$2077e0241d6afd3c(f, digits) {
    var digitMult = Math.pow(10, digits);
    return Math.round(f /* + Number.EPSILON*/  * digitMult) / digitMult;
}
function $9a5bdb07e7a7c42f$export$5aa63862e8b9c037(bounds) {
    return (0, $4EWN2._)((0, $cL71g._)({}, bounds), {
        x1: Math.min(bounds.x1, bounds.x2),
        y1: Math.min(bounds.y1, bounds.y2),
        x2: Math.max(bounds.x1, bounds.x2),
        y2: Math.max(bounds.y1, bounds.y2)
    });
}
function $9a5bdb07e7a7c42f$export$f4467a4f41373bc7(target, bounds) {
    if (!bounds && !target) throw new Error('at least one param needs to be defined');
    if (!bounds) return target;
    if (!target) target = {
        type: bounds.type,
        x1: bounds.x1,
        y1: bounds.y1,
        x2: bounds.x2,
        y2: bounds.y2
    };
    else {
        target.x1 = Math.min(target.x1, bounds.x1);
        target.y1 = Math.min(target.y1, bounds.y1);
        target.x2 = Math.max(target.x2, bounds.x2);
        target.y2 = Math.max(target.y2, bounds.y2);
    }
    return target;
}
function $9a5bdb07e7a7c42f$export$83720aaadc272d85(bounds, limit) {
    if (!bounds) return undefined;
    if (!limit) return bounds;
    var x1 = Math.max(limit.x1, bounds.x1);
    var y1 = Math.max(limit.y1, bounds.y1);
    var x2 = Math.min(limit.x2, bounds.x2);
    var y2 = Math.min(limit.y2, bounds.y2);
    if (x1 > x2 || y1 > y2) return undefined;
    var _bounds_type;
    return {
        type: (_bounds_type = bounds === null || bounds === void 0 ? void 0 : bounds.type) !== null && _bounds_type !== void 0 ? _bounds_type : limit === null || limit === void 0 ? void 0 : limit.type,
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
}
function $9a5bdb07e7a7c42f$export$ddc1c0069d484d49(bounds, width, height) {
    if (!bounds) return undefined;
    return $9a5bdb07e7a7c42f$export$83720aaadc272d85(bounds, {
        type: 'index',
        x1: 0,
        y1: 0,
        x2: width - 1,
        y2: height - 1
    });
}
function $9a5bdb07e7a7c42f$export$b0036cbc597df324(bounds) {
    var x1 = Math.floor(bounds.x1);
    var y1 = Math.floor(bounds.y1);
    var x2 = Math.ceil(bounds.x2 - 1);
    var y2 = Math.ceil(bounds.y2 - 1);
    return {
        type: 'index',
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
}
function $9a5bdb07e7a7c42f$export$86989866a3954672(bounds) {
    var x1 = bounds.x1;
    var y1 = bounds.y1;
    var x2 = bounds.x2 + 1;
    var y2 = bounds.y2 + 1;
    return {
        type: 'coordinate',
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
}
function $9a5bdb07e7a7c42f$export$3488993c9d026384(bounds) {
    return {
        x: bounds.x1,
        y: bounds.y1,
        width: bounds.x2 - bounds.x1 + 1,
        height: bounds.y2 - bounds.y1 + 1
    };
}
function $9a5bdb07e7a7c42f$export$d89ccdf57354a99c(rect, type) {
    var x2 = rect.x + rect.width;
    var y2 = rect.y + rect.height;
    return type === 'index' ? {
        type: 'index',
        x1: rect.x,
        y1: rect.y,
        x2: x2 - 1,
        y2: y2 - 1
    } : {
        type: 'coordinate',
        x1: rect.x,
        y1: rect.y,
        x2: x2,
        y2: y2
    };
}
function $9a5bdb07e7a7c42f$export$4218cb0e42c2e7e(bounds) {
    var isIndex = bounds.type === 'index';
    return {
        x: bounds.x1,
        y: bounds.y1,
        width: bounds.x2 - bounds.x1 + (isIndex ? 1 : 0),
        height: bounds.y2 - bounds.y1 + (isIndex ? 1 : 0)
    };
}

});


parcelRegister("kVHNC", function(module, exports) {

$parcel$export(module.exports, "Matrix", function () { return $e4df33b4b16105d5$export$5b12bf1653c0dd85; });
// https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Matrix_math_for_the_web
// not optimized
function $e4df33b4b16105d5$var$getIdentity() {
    return [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
// point • matrix
function $e4df33b4b16105d5$var$multiplyMatrixAndPoint(matrix, point) {
    return [
        point[0] * matrix[0] + point[1] * matrix[4] + point[2] * matrix[8] + point[3] * matrix[12],
        point[0] * matrix[1] + point[1] * matrix[5] + point[2] * matrix[9] + point[3] * matrix[13],
        point[0] * matrix[2] + point[1] * matrix[6] + point[2] * matrix[10] + point[3] * matrix[14],
        point[0] * matrix[3] + point[1] * matrix[7] + point[2] * matrix[11] + point[3] * matrix[15]
    ];
}
//matrixB • matrixA
function $e4df33b4b16105d5$var$multiplyMatrices(matrixA, matrixB) {
    // Slice the second matrix up into rows
    var row0 = [
        matrixB[0],
        matrixB[1],
        matrixB[2],
        matrixB[3]
    ];
    var row1 = [
        matrixB[4],
        matrixB[5],
        matrixB[6],
        matrixB[7]
    ];
    var row2 = [
        matrixB[8],
        matrixB[9],
        matrixB[10],
        matrixB[11]
    ];
    var row3 = [
        matrixB[12],
        matrixB[13],
        matrixB[14],
        matrixB[15]
    ];
    // Multiply each row by matrixA
    var result0 = $e4df33b4b16105d5$var$multiplyMatrixAndPoint(matrixA, row0);
    var result1 = $e4df33b4b16105d5$var$multiplyMatrixAndPoint(matrixA, row1);
    var result2 = $e4df33b4b16105d5$var$multiplyMatrixAndPoint(matrixA, row2);
    var result3 = $e4df33b4b16105d5$var$multiplyMatrixAndPoint(matrixA, row3);
    // Turn the result rows back into a single matrix
    return [
        result0[0],
        result0[1],
        result0[2],
        result0[3],
        result1[0],
        result1[1],
        result1[2],
        result1[3],
        result2[0],
        result2[1],
        result2[2],
        result2[3],
        result3[0],
        result3[1],
        result3[2],
        result3[3]
    ];
}
function $e4df33b4b16105d5$var$createTranslationMatrix(x, y) {
    return [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        x,
        y,
        0,
        1
    ];
}
function $e4df33b4b16105d5$var$createRotationMatrix(angleRad) {
    //let angleRad = angleDeg / 360 * 2 * Math.PI;
    return [
        Math.cos(-angleRad),
        -Math.sin(-angleRad),
        0,
        0,
        Math.sin(-angleRad),
        Math.cos(-angleRad),
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
function $e4df33b4b16105d5$var$createScaleMatrix(f) {
    return [
        f,
        0,
        0,
        0,
        0,
        f,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
}
var $e4df33b4b16105d5$export$5b12bf1653c0dd85 = Object.freeze({
    getIdentity: $e4df33b4b16105d5$var$getIdentity,
    multiplyMatrixAndPoint: $e4df33b4b16105d5$var$multiplyMatrixAndPoint,
    multiplyMatrices: $e4df33b4b16105d5$var$multiplyMatrices,
    createTranslationMatrix: $e4df33b4b16105d5$var$createTranslationMatrix,
    createRotationMatrix: $e4df33b4b16105d5$var$createRotationMatrix,
    createScaleMatrix: $e4df33b4b16105d5$var$createScaleMatrix
});

});

parcelRegister("4toIY", function(module, exports) {

$parcel$export(module.exports, "Vec2", function () { return $531c9f41f98b7ec0$export$ac4bca90992eed1; });
var $531c9f41f98b7ec0$export$ac4bca90992eed1 = {
    add: function add(p1, p2) {
        return {
            x: p1.x + p2.x,
            y: p1.y + p2.y
        };
    },
    sub: function sub(p1, p2) {
        return {
            x: p1.x - p2.x,
            y: p1.y - p2.y
        };
    },
    nor: function nor(p) {
        var len = Math.sqrt(Math.pow(p.x, 2) + Math.pow(p.y, 2));
        return {
            x: p.x / len,
            y: p.y / len
        };
    },
    len: function len(p) {
        return Math.sqrt(Math.pow(p.x, 2) + Math.pow(p.y, 2));
    },
    dist: function dist(p1, p2) {
        return $531c9f41f98b7ec0$export$ac4bca90992eed1.len($531c9f41f98b7ec0$export$ac4bca90992eed1.sub(p1, p2));
    },
    mul: function mul(p, s) {
        return {
            x: p.x * s,
            y: p.y * s
        };
    },
    angle: function angle(p1, p2) {
        return Math.atan2(p2.y - p1.y, p2.x - p1.x);
    },
    dot: function dot(a, b) {
        var aArr = [
            a.x,
            a.y
        ];
        var bArr = [
            b.x,
            b.y
        ];
        return aArr.map(function(x, i) {
            return aArr[i] * bArr[i];
        }).reduce(function(m, n) {
            return m + n;
        });
    }
};

});

parcelRegister("af1iA", function(module, exports) {

$parcel$export(module.exports, "projectPointOnLine", function () { return $77ae015f37ebe4f1$export$b4c5b177db876445; });
$parcel$export(module.exports, "PointLine", function () { return $77ae015f37ebe4f1$export$8b36a4a83269a640; });
$parcel$export(module.exports, "BezierLine", function () { return $77ae015f37ebe4f1$export$5379d955c16d4d43; });
$parcel$export(module.exports, "SplineInterpolator", function () { return $77ae015f37ebe4f1$export$80967b1eb9fd6eb4; });
$parcel$export(module.exports, "powerSplineInput", function () { return $77ae015f37ebe4f1$export$c07c3aaef9f2da42; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $4toIY = parcelRequire("4toIY");

var $eg83P = parcelRequire("eg83P");

var $7jh4K = parcelRequire("7jh4K");
var $77ae015f37ebe4f1$export$b4c5b177db876445 = function projectPointOnLine(lineStart, lineEnd, p) {
    var x, y;
    if (lineStart.x === lineEnd.x) {
        x = lineStart.x;
        y = p.y;
        return {
            x: x,
            y: y
        };
    }
    var m = (lineEnd.y - lineStart.y) / (lineEnd.x - lineStart.x);
    var b = lineStart.y - m * lineStart.x;
    x = (m * p.y + p.x - m * b) / (m * m + 1);
    y = (m * m * p.y + m * p.x + b) / (m * m + 1);
    return {
        x: x,
        y: y
    };
};
var $77ae015f37ebe4f1$export$8b36a4a83269a640 = /*#__PURE__*/ function() {
    "use strict";
    function PointLine(p) {
        var _this = this;
        (0, $cx0mh._)(this, PointLine);
        this.segmentArr = [];
        for(var i = 0; i < p.points.length; i++)(function(i) {
            var length = 0;
            if (i < p.points.length - 1) length = (0, $eg83P.dist)(p.points[i].x, p.points[i].y, p.points[i + 1].x, p.points[i + 1].y);
            _this.segmentArr[i] = {
                x: p.points[i].x,
                y: p.points[i].y,
                length: length
            };
        })(i);
    }
    (0, $7h4XF._)(PointLine, [
        {
            // ---- interface ----
            /**
     * returns point when traveling *dist* along the line, > 0
     * @param dist
     */ key: "getAtDist",
            value: function getAtDist(dist) {
                var remainder = Math.min(this.getLength(), dist);
                var i = 0;
                for(; remainder > this.segmentArr[i].length && i < this.segmentArr.length - 2; i++)remainder -= this.segmentArr[i].length;
                var fac = Math.min(1, Math.max(0, remainder / this.segmentArr[i].length));
                return {
                    x: this.segmentArr[i].x * (1 - fac) + this.segmentArr[i + 1].x * fac,
                    y: this.segmentArr[i].y * (1 - fac) + this.segmentArr[i + 1].y * fac
                };
            }
        },
        {
            /**
     * total length of line
     */ key: "getLength",
            value: function getLength() {
                var result = 0;
                for(var i = 0; i < this.segmentArr.length - 1; i++)result += this.segmentArr[i].length;
                return result;
            }
        }
    ]);
    return PointLine;
}();
var $77ae015f37ebe4f1$export$5379d955c16d4d43 = /*#__PURE__*/ function() {
    "use strict";
    function BezierLine() {
        (0, $cx0mh._)(this, BezierLine);
        this.lastDot = 0;
        this.pointArr = [];
    }
    (0, $7h4XF._)(BezierLine, [
        {
            key: "getBezierPoints",
            value: /**
     * creates bezier curve from control points
     * @param p1 - control point 1 {x: float, y: float}
     * @param p2 - control point 2 {x: float, y: float}
     * @param p3 - control point 3 {x: float, y: float}
     * @param p4 - control point 4 {x: float, y: float}
     * @param resolution - int
     * @returns bezier curve made up of points {x: float, y: float}
     */ function getBezierPoints(p1, p2, p3, p4, resolution) {
                var curvePoints = [];
                var t;
                for(var i = 0; i <= resolution; i++){
                    t = i / resolution;
                    curvePoints[curvePoints.length] = {
                        x: Math.pow(1 - t, 3) * p1.x + 3 * Math.pow(1 - t, 2) * t * p2.x + 3 * (1 - t) * Math.pow(t, 2) * p3.x + Math.pow(t, 3) * p4.x,
                        y: Math.pow(1 - t, 3) * p1.y + 3 * Math.pow(1 - t, 2) * t * p2.y + 3 * (1 - t) * Math.pow(t, 2) * p3.y + Math.pow(t, 3) * p4.y
                    };
                }
                return curvePoints;
            }
        },
        {
            // ---- interface ----
            /**
     * Add new point to line. "Drawn" line will go until the previous point.
     *
     * @param x - coord of new point
     * @param y
     * @param spacing - space between each step
     * @param callback - calls for each step
     * @param controlsCallback - calls that callback with the bezier control points
     */ key: "add",
            value: function add(x, y, spacing, callback, controlsCallback) {
                if (this.lastPoint && x === this.lastPoint.x && y === this.lastPoint.y) return;
                this.lastPoint = {
                    x: x,
                    y: y
                };
                this.pointArr[this.pointArr.length] = {
                    x: x,
                    y: y,
                    spacing: spacing
                };
                //calculate directions
                if (this.pointArr.length === 1) {
                    this.lastSpacing = spacing;
                    return;
                } else if (this.pointArr.length === 2) {
                    this.pointArr[0].dir = (0, $4toIY.Vec2).nor((0, $4toIY.Vec2).sub(this.pointArr[1], this.pointArr[0]));
                    this.lastDot = spacing;
                    this.lastSpacing = spacing;
                    return;
                } else {
                    var pointM1 = this.pointArr[this.pointArr.length - 1];
                    var pointM2 = this.pointArr[this.pointArr.length - 2];
                    var pointM3 = this.pointArr[this.pointArr.length - 3];
                    pointM2.dir = (0, $4toIY.Vec2).nor((0, $4toIY.Vec2).sub(pointM1, pointM3));
                    if (isNaN(pointM2.dir.x) || isNaN(pointM2.dir.y)) //when xy -3 == -1
                    pointM2.dir = (0, $7jh4K.copyObj)(pointM3.dir);
                }
                //get bezier curve
                var a = this.pointArr[this.pointArr.length - 3];
                var b = this.pointArr[this.pointArr.length - 2];
                var p1 = a;
                var p2 = (0, $4toIY.Vec2).add(a, (0, $4toIY.Vec2).mul(a.dir, (0, $4toIY.Vec2).dist(a, b) / 4));
                var p3 = (0, $4toIY.Vec2).sub(b, (0, $4toIY.Vec2).mul(b.dir, (0, $4toIY.Vec2).dist(a, b) / 4));
                var p4 = b;
                var pointLine;
                if (callback) {
                    var curvePoints = this.getBezierPoints(p1, p2, p3, p4, 20);
                    pointLine = new $77ae015f37ebe4f1$export$8b36a4a83269a640({
                        points: curvePoints
                    });
                } else pointLine = new $77ae015f37ebe4f1$export$8b36a4a83269a640({
                    points: [
                        p1,
                        p4
                    ]
                });
                //iterate over curve with spacing and callback
                var len = pointLine.getLength();
                var tempSpacing = (0, $eg83P.mix)(this.lastSpacing, spacing, (0, $eg83P.clamp)(this.lastDot / len, 0, 1));
                var d = this.lastDot;
                for(; d <= len; d += tempSpacing){
                    tempSpacing = (0, $eg83P.mix)(this.lastSpacing, spacing, (0, $eg83P.clamp)(d / len, 0, 1));
                    var point = pointLine.getAtDist(d);
                    var angle = this.lastCallbackPoint ? (0, $eg83P.pointsToAngleDeg)(this.lastCallbackPoint, point) : undefined;
                    if (callback) callback({
                        x: point.x,
                        y: point.y,
                        t: d / len,
                        angle: angle,
                        dAngle: this.lastCallbackPoint ? angle - this.lastAngle : 0
                    });
                    this.lastCallbackPoint = point;
                    this.lastAngle = angle;
                }
                if (callback) this.lastDot = d - len;
                else {
                    this.lastDot = 0;
                    controlsCallback === null || controlsCallback === void 0 ? void 0 : controlsCallback({
                        p1: p1,
                        p2: p2,
                        p3: p3,
                        p4: p4
                    });
                }
                this.lastSpacing = spacing;
            }
        },
        {
            key: "addFinal",
            value: function addFinal(spacing, callback, controlsCallback) {
                if (this.pointArr.length < 2) return;
                var p1 = this.pointArr[this.pointArr.length - 2];
                var p2 = this.pointArr[this.pointArr.length - 1];
                var newP = (0, $4toIY.Vec2).add(p2, (0, $4toIY.Vec2).sub(p2, p1));
                this.add(newP.x, newP.y, spacing, callback, controlsCallback);
            }
        }
    ]);
    return BezierLine;
}();
var $77ae015f37ebe4f1$export$80967b1eb9fd6eb4 = /*#__PURE__*/ function() {
    "use strict";
    function SplineInterpolator(points) {
        (0, $cx0mh._)(this, SplineInterpolator);
        var n = points.length;
        this.xa = [];
        this.ya = [];
        this.u = [];
        this.y2 = [];
        var i;
        this.first = points[0][0];
        this.last = points[points.length - 1][0];
        points.sort(function(a, b) {
            return a[0] - b[0];
        });
        for(i = 0; i < n; i++){
            this.xa.push(points[i][0]);
            this.ya.push(points[i][1]);
        }
        this.u[0] = 0;
        this.y2[0] = 0;
        for(i = 1; i < n - 1; ++i){
            // This is the decomposition loop of the tridiagonal algorithm.
            // y2 and u are used for temporary storage of the decomposed factors.
            var wx = this.xa[i + 1] - this.xa[i - 1];
            var sig = (this.xa[i] - this.xa[i - 1]) / wx;
            var p = sig * this.y2[i - 1] + 2.0;
            this.y2[i] = (sig - 1.0) / p;
            var ddydx = (this.ya[i + 1] - this.ya[i]) / (this.xa[i + 1] - this.xa[i]) - (this.ya[i] - this.ya[i - 1]) / (this.xa[i] - this.xa[i - 1]);
            this.u[i] = (6.0 * ddydx / wx - sig * this.u[i - 1]) / p;
        }
        this.y2[n - 1] = 0;
        // This is the backsubstitution loop of the tridiagonal algorithm
        for(i = n - 2; i >= 0; --i)this.y2[i] = this.y2[i] * this.y2[i + 1] + this.u[i];
    }
    (0, $7h4XF._)(SplineInterpolator, [
        {
            // ---- interface ----
            key: "getFirstX",
            value: function getFirstX() {
                return this.first;
            }
        },
        {
            key: "getLastX",
            value: function getLastX() {
                return this.last;
            }
        },
        {
            key: "interpolate",
            value: function interpolate(x) {
                var n = this.ya.length;
                var klo = 0;
                var khi = n - 1;
                // We will find the right place in the table by means of
                // bisection. This is optimal if sequential calls to this
                // routine are at random values of x. If sequential calls
                // are in order, and closely spaced, one would do better
                // to store previous values of klo and khi.
                while(khi - klo > 1){
                    var k = khi + klo >> 1;
                    if (this.xa[k] > x) khi = k;
                    else klo = k;
                }
                var h = this.xa[khi] - this.xa[klo];
                var a = (this.xa[khi] - x) / h;
                var b = (x - this.xa[klo]) / h;
                // Cubic spline polynomial is now evaluated.
                return a * this.ya[klo] + b * this.ya[khi] + ((a * a * a - a) * this.y2[klo] + (b * b * b - b) * this.y2[khi]) * (h * h) / 6.0;
            }
        },
        {
            /**
     * find x to y. simply by stepping through. suboptimal, so don't call often.
     * searches in x 0-1 range
     */ key: "findX",
            value: function findX(y, resolution) {
                var x;
                var dist;
                for(var i = 0; i <= resolution; i++){
                    var tempX = i / resolution;
                    var tempY = this.interpolate(tempX);
                    if (x === undefined) {
                        x = tempX;
                        dist = Math.abs(tempY - y);
                        continue;
                    }
                    var tempDist = Math.abs(tempY - y);
                    if (tempDist < dist) {
                        x = tempX;
                        dist = tempDist;
                    } else break;
                }
                return x;
            }
        }
    ]);
    return SplineInterpolator;
}();
function $77ae015f37ebe4f1$export$c07c3aaef9f2da42(startVal, endVal, stepSize) {
    var exponent = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 2;
    function round(v, dec) {
        return Math.round(v * Math.pow(10, dec)) / Math.pow(10, dec);
    }
    var resultArr = [];
    for(var i = 0; i <= 1; i += stepSize)resultArr.push([
        round(i, 4),
        round(startVal + Math.pow(i, exponent) * (endVal - startVal), 4)
    ]);
    return resultArr;
}

});

parcelRegister("dJ1E2", function(module, exports) {

$parcel$export(module.exports, "HSV", function () { return $5e7aac2fa49b6b1f$export$d2edaecd208aed43; });
$parcel$export(module.exports, "RGB", function () { return $5e7aac2fa49b6b1f$export$8f9ece5a47764b93; });
$parcel$export(module.exports, "CMYK", function () { return $5e7aac2fa49b6b1f$export$89d3f85304bf0767; });
$parcel$export(module.exports, "ColorConverter", function () { return $5e7aac2fa49b6b1f$export$fb7efcd2e153af6e; });
$parcel$export(module.exports, "testIsWhiteBestContrast", function () { return $5e7aac2fa49b6b1f$export$5cf396345d1238ae; });
// based on js color conversion http://www.webtoolkit.info/

var $cx0mh = parcelRequire("cx0mh");
var $5e7aac2fa49b6b1f$export$d2edaecd208aed43 = function HSV(h, s, v) {
    "use strict";
    (0, $cx0mh._)(this, HSV);
    this.h = Math.max(0, Math.min(360, h));
    this.s = Math.max(0.001, Math.min(100, s)); //bug when 0
    this.v = Math.max(0, Math.min(100, v));
};
var $5e7aac2fa49b6b1f$export$8f9ece5a47764b93 = function RGB(r, g, b) {
    "use strict";
    (0, $cx0mh._)(this, RGB);
    this.r = Math.max(0, Math.min(255, r));
    this.g = Math.max(0, Math.min(255, g));
    this.b = Math.max(0, Math.min(255, b));
};
var $5e7aac2fa49b6b1f$export$89d3f85304bf0767 = function CMYK(c, m, y, k) {
    "use strict";
    (0, $cx0mh._)(this, CMYK);
    this.c = Math.max(0, Math.min(100, c));
    this.m = Math.max(0, Math.min(100, m));
    this.y = Math.max(0, Math.min(100, y));
    this.k = Math.max(0, Math.min(100, k));
};
var $5e7aac2fa49b6b1f$export$fb7efcd2e153af6e = {
    _RGBtoHSV: function _RGBtoHSV(RGB) {
        var result = new $5e7aac2fa49b6b1f$export$d2edaecd208aed43(0, 0, 0);
        var r = RGB.r / 255;
        var g = RGB.g / 255;
        var b = RGB.b / 255;
        var minVal = Math.min(r, g, b);
        var maxVal = Math.max(r, g, b);
        var delta = maxVal - minVal;
        result.v = maxVal;
        if (delta == 0) {
            result.h = 0;
            result.s = 0;
        } else {
            result.s = delta / maxVal;
            var del_R = ((maxVal - r) / 6 + delta / 2) / delta;
            var del_G = ((maxVal - g) / 6 + delta / 2) / delta;
            var del_B = ((maxVal - b) / 6 + delta / 2) / delta;
            if (r == maxVal) result.h = del_B - del_G;
            else if (g == maxVal) result.h = 1 / 3 + del_R - del_B;
            else if (b == maxVal) result.h = 2 / 3 + del_G - del_R;
            if (result.h < 0) result.h += 1;
            if (result.h > 1) result.h -= 1;
        }
        result.h = Math.round(result.h * 360);
        result.s = Math.round(result.s * 100);
        result.v = Math.round(result.v * 100);
        return result;
    },
    _HSVtoRGB: function _HSVtoRGB(HSV) {
        var result = new $5e7aac2fa49b6b1f$export$8f9ece5a47764b93(0, 0, 0);
        var var_h, var_i, var_1, var_2, var_3, var_r, var_g, var_b;
        var h = HSV.h / 360 % 1;
        var s = HSV.s / 100;
        var v = HSV.v / 100;
        if (s == 0) {
            result.r = v * 255;
            result.g = v * 255;
            result.b = v * 255;
        } else {
            var_h = h * 6;
            var_i = Math.floor(var_h);
            var_1 = v * (1 - s);
            var_2 = v * (1 - s * (var_h - var_i));
            var_3 = v * (1 - s * (1 - (var_h - var_i)));
            if (var_i == 0) {
                var_r = v;
                var_g = var_3;
                var_b = var_1;
            } else if (var_i == 1) {
                var_r = var_2;
                var_g = v;
                var_b = var_1;
            } else if (var_i == 2) {
                var_r = var_1;
                var_g = v;
                var_b = var_3;
            } else if (var_i == 3) {
                var_r = var_1;
                var_g = var_2;
                var_b = v;
            } else if (var_i == 4) {
                var_r = var_3;
                var_g = var_1;
                var_b = v;
            } else {
                var_r = v;
                var_g = var_1;
                var_b = var_2;
            }
            result.r = var_r * 255;
            result.g = var_g * 255;
            result.b = var_b * 255;
            result.r = Math.round(result.r);
            result.g = Math.round(result.g);
            result.b = Math.round(result.b);
        }
        return result;
    },
    _CMYKtoRGB: function _CMYKtoRGB(CMYK) {
        var result = new $5e7aac2fa49b6b1f$export$8f9ece5a47764b93(0, 0, 0);
        var c = CMYK.c / 100;
        var m = CMYK.m / 100;
        var y = CMYK.y / 100;
        var k = CMYK.k / 100;
        result.r = 1 - Math.min(1, c * (1 - k) + k);
        result.g = 1 - Math.min(1, m * (1 - k) + k);
        result.b = 1 - Math.min(1, y * (1 - k) + k);
        result.r = Math.round(result.r * 255);
        result.g = Math.round(result.g * 255);
        result.b = Math.round(result.b * 255);
        return result;
    },
    _RGBtoCMYK: function _RGBtoCMYK(RGB) {
        var result = new $5e7aac2fa49b6b1f$export$89d3f85304bf0767(0, 0, 0, 0);
        var r = RGB.r / 255;
        var g = RGB.g / 255;
        var b = RGB.b / 255;
        result.k = Math.min(1 - r, 1 - g, 1 - b);
        result.c = (1 - r - result.k) / (1 - result.k);
        result.m = (1 - g - result.k) / (1 - result.k);
        result.y = (1 - b - result.k) / (1 - result.k);
        result.c = Math.round(result.c * 100);
        result.m = Math.round(result.m * 100);
        result.y = Math.round(result.y * 100);
        result.k = Math.round(result.k * 100);
        return result;
    },
    toRGB: function toRGB(o) {
        if (o instanceof $5e7aac2fa49b6b1f$export$8f9ece5a47764b93) return o;
        if (o instanceof $5e7aac2fa49b6b1f$export$d2edaecd208aed43) return this._HSVtoRGB(o);
        if (o instanceof $5e7aac2fa49b6b1f$export$89d3f85304bf0767) return this._CMYKtoRGB(o);
        throw new Error('unknown type');
    },
    toHSV: function toHSV(o) {
        if (o instanceof $5e7aac2fa49b6b1f$export$d2edaecd208aed43) return o;
        if (o instanceof $5e7aac2fa49b6b1f$export$8f9ece5a47764b93) return this._RGBtoHSV(o);
        if (o instanceof $5e7aac2fa49b6b1f$export$89d3f85304bf0767) return this._RGBtoHSV(this._CMYKtoRGB(o));
        throw new Error('unknown type');
    },
    toCMYK: function toCMYK(o) {
        if (o instanceof $5e7aac2fa49b6b1f$export$89d3f85304bf0767) return o;
        if (o instanceof $5e7aac2fa49b6b1f$export$8f9ece5a47764b93) return this._RGBtoCMYK(o);
        if (o instanceof $5e7aac2fa49b6b1f$export$d2edaecd208aed43) return this._RGBtoCMYK(this._HSVtoRGB(o));
        throw new Error('unknown type');
    },
    toHexString: function toHexString(o) {
        if (o instanceof $5e7aac2fa49b6b1f$export$8f9ece5a47764b93 || 'r' in o && 'g' in o && 'b' in o) {
            var ha = parseInt('' + o.r).toString(16);
            var hb = parseInt('' + o.g).toString(16);
            var hc = parseInt('' + o.b).toString(16);
            if (ha.length == 1) ha = '0' + ha;
            if (hb.length == 1) hb = '0' + hb;
            if (hc.length == 1) hc = '0' + hc;
            return ha + hb + hc;
        }
        return '#000';
    },
    toRgbStr: function toRgbStr(rgbObj) {
        return 'rgb(' + Math.round(rgbObj.r) + ', ' + Math.round(rgbObj.g) + ', ' + Math.round(rgbObj.b) + ')';
    },
    toRgbaStr: function toRgbaStr(rgbaObj) {
        return 'rgba(' + Math.round(rgbaObj.r) + ', ' + Math.round(rgbaObj.g) + ', ' + Math.round(rgbaObj.b) + ', ' + rgbaObj.a + ')';
    },
    hexToRGB: function hexToRGB(hexStr) {
        hexStr = hexStr.trim();
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hexStr = hexStr.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
        });
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexStr);
        return result ? new $5e7aac2fa49b6b1f$export$8f9ece5a47764b93(parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)) : undefined;
    }
};
function $5e7aac2fa49b6b1f$export$5cf396345d1238ae(rgbObj) {
    return rgbObj.r * 0.299 + rgbObj.g * 0.587 + rgbObj.b * 0.114 < 125;
}

});

parcelRegister("72Jv0", function(module, exports) {

$parcel$export(module.exports, "appendTextDiv", function () { return $cfe3aa45a75894cc$export$7868464f598ba79d; });
$parcel$export(module.exports, "isInputFocused", function () { return $cfe3aa45a75894cc$export$906dfdb7df31ccfc; });
$parcel$export(module.exports, "unfocusAnyInput", function () { return $cfe3aa45a75894cc$export$e05240ca9e0b8bd9; });
$parcel$export(module.exports, "clearSelection", function () { return $cfe3aa45a75894cc$export$a3d02541b0ebf605; });
$parcel$export(module.exports, "makeUnfocusable", function () { return $cfe3aa45a75894cc$export$6bd63bfceaafae0c; });
$parcel$export(module.exports, "el", function () { return $cfe3aa45a75894cc$export$c3da0dad1b44eea9; });
$parcel$export(module.exports, "destroyEl", function () { return $cfe3aa45a75894cc$export$b1da1db524e22115; });
$parcel$export(module.exports, "createImage", function () { return $cfe3aa45a75894cc$export$ec664d7487540b; });

var $7jh4K = parcelRequire("7jh4K");

var $eWjiX = parcelRequire("eWjiX");
function $cfe3aa45a75894cc$export$7868464f598ba79d(target, text) {
    var div = document.createElement('div');
    div.innerHTML = text;
    target.append(div);
    return div;
}
function $cfe3aa45a75894cc$export$906dfdb7df31ccfc() {
    var getAll = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var _document_activeElement;
    var result = !!document.activeElement && [
        'INPUT',
        'TEXTAREA',
        'SELECT'
    ].includes(document.activeElement.tagName);
    if (getAll) return result;
    else return result && !((_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.getAttribute('data-ignore-focus'));
}
function $cfe3aa45a75894cc$export$e05240ca9e0b8bd9() {
    if ($cfe3aa45a75894cc$export$906dfdb7df31ccfc(true)) {
        /*
            Unfocus anything that is focused.

            If an Input is focused in Firefox, and it gets detached from the DOM via a Node
            that isn't its direct parent, then Firefox will keep anything attached to this
            Input in memory. It will not be garbage collected until a new Input is focused.

            Workaround: Temporarily create an input, focus it, detach it.
             */ var focusEl = (0, $eWjiX.BB).el({
            parent: document.body,
            tagName: 'input',
            css: {
                opacity: '0',
                width: '0',
                height: '0'
            }
        });
        setTimeout(function() {
            focusEl.select();
            focusEl.focus();
            focusEl.remove();
        }, 10);
    }
}
function $cfe3aa45a75894cc$export$a3d02541b0ebf605() {
    if (window.getSelection) {
        var sel = window.getSelection();
        if (sel) {
            if (sel.empty) sel.empty();
            else if (sel.removeAllRanges) sel.removeAllRanges();
        }
    }
}
var $cfe3aa45a75894cc$export$6bd63bfceaafae0c = function() {
    function preventFocus(event) {
        event.preventDefault();
        var didFocusRelated = false;
        if (event.relatedTarget) try {
            event.relatedTarget.focus();
            didFocusRelated = true;
        } catch (e) {
            console.error('failed to focus');
        }
        if (!didFocusRelated) event.currentTarget.blur();
    }
    return function(el) {
        el.setAttribute('tabindex', '-1');
        el.addEventListener('focus', preventFocus);
    };
}();
var $cfe3aa45a75894cc$var$els = [];
function $cfe3aa45a75894cc$export$c3da0dad1b44eea9(params) {
    if (!params) return document.createElement('div');
    var result = document.createElement(params.tagName ? params.tagName : 'div');
    params.css && (0, $7jh4K.css)(result, params.css);
    if (params.content) {
        if (typeof params.content === "string") result.innerHTML = params.content;
        else if (Array.isArray(params.content)) (0, $eWjiX.BB).append(result, params.content);
        else result.append(params.content);
    }
    if (params.textContent) result.textContent = params.textContent;
    if (params.className) result.className = params.className;
    if (params.id) result.id = params.id;
    if (params.parent) params.parent.append(result);
    if ('title' in params && params.title !== undefined) result.title = params.title;
    var listeners = [];
    if (params.onClick !== undefined) {
        result.addEventListener('click', params.onClick);
        !params.noRef && listeners.push([
            'click',
            params.onClick
        ]);
    }
    if (params.onChange !== undefined) {
        result.addEventListener('change', params.onChange);
        !params.noRef && listeners.push([
            'change',
            params.onChange
        ]);
    }
    if (listeners.length > 0) $cfe3aa45a75894cc$var$els.push({
        el: result,
        listeners: listeners
    });
    if ('custom' in params && params.custom) {
        var customKeyArr = Object.keys(params.custom);
        for(var i = 0; i < customKeyArr.length; i++)result.setAttribute(customKeyArr[i], params.custom[customKeyArr[i]]);
    }
    return result;
}
function $cfe3aa45a75894cc$export$b1da1db524e22115(el) {
    if (!el) return;
    for(var i = 0; i < $cfe3aa45a75894cc$var$els.length; i++){
        var item = $cfe3aa45a75894cc$var$els[i];
        if (item.el === el) {
            item.listeners.forEach(function(item) {
                el.removeEventListener(item[0], item[1]);
            });
            $cfe3aa45a75894cc$var$els.splice(i, 1);
            return;
        }
    }
    // not found
    return;
}
function $cfe3aa45a75894cc$export$ec664d7487540b(p) {
    var result = new Image();
    if (p.src !== undefined) result.src = p.src;
    if (p.alt !== undefined) result.alt = p.alt;
    if (p.width !== undefined) result.width = p.width;
    if (p.height !== undefined) result.height = p.height;
    if (p.className !== undefined) result.className = p.className;
    p.css && (0, $7jh4K.css)(result, p.css);
    return result;
}

});

parcelRegister("i0uIf", function(module, exports) {

$parcel$export(module.exports, "BbLog", function () { return $0d0e99c175410ac4$export$9860cd9e09e6f8ba; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $0d0e99c175410ac4$export$9860cd9e09e6f8ba = /*#__PURE__*/ function() {
    "use strict";
    function BbLog() {
        (0, $cx0mh._)(this, BbLog);
    }
    (0, $7h4XF._)(BbLog, null, [
        {
            key: "subscribe",
            value: function subscribe(listener) {
                if (BbLog.listeners.includes(listener)) return;
                BbLog.listeners.push(listener);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(listener) {
                for(var i = 0; i < BbLog.listeners.length; i++)if (listener === BbLog.listeners[i]) {
                    BbLog.listeners.splice(i, 1);
                    return;
                }
            }
        },
        {
            key: "emit",
            value: function emit(msg) {
                BbLog.listeners.forEach(function(item) {
                    item(msg);
                });
            }
        }
    ]);
    return BbLog;
}();
$0d0e99c175410ac4$export$9860cd9e09e6f8ba.listeners = [];

});

parcelRegister("6l0gQ", function(module, exports) {

$parcel$export(module.exports, "LocalStorage", function () { return $9e5fd8359d8b22f2$export$19fffca37ef3e106; });
/**
 * LocalStorage wrapper that does not throw exceptions.
 * If cookies disabled in Safari localStorage interactions throw exception "insecure operation"
 */ 
var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $9e5fd8359d8b22f2$export$19fffca37ef3e106 = /*#__PURE__*/ function() {
    "use strict";
    function LocalStorage() {
        (0, $cx0mh._)(this, LocalStorage);
    }
    (0, $7h4XF._)(LocalStorage, null, [
        {
            key: "getItem",
            value: function getItem(key) {
                // (disabled) eslint-disable-next-line no-null/no-null
                var result = null;
                try {
                    result = localStorage.getItem(key);
                } catch (e) {
                    this.error = e;
                }
                return result;
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value) {
                try {
                    localStorage.setItem(key, value);
                } catch (e) {
                    this.error = e;
                }
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                try {
                    localStorage.removeItem(key);
                } catch (e) {
                    this.error = e;
                }
            }
        },
        {
            key: "getError",
            value: function getError() {
                return this.error;
            }
        }
    ]);
    return LocalStorage;
}();

});

parcelRegister("jjWRi", function(module, exports) {

$parcel$export(module.exports, "CoalescedExploder", function () { return $d2c9f6aa6c7498f1$export$fe11e0afe623a677; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $7jh4K = parcelRequire("7jh4K");
var $d2c9f6aa6c7498f1$export$fe11e0afe623a677 = /*#__PURE__*/ function() {
    "use strict";
    function CoalescedExploder() {
        (0, $cx0mh._)(this, CoalescedExploder);
    }
    (0, $7h4XF._)(CoalescedExploder, [
        {
            // ----------------------------------- public -----------------------------------
            key: "setChainOut",
            value: function setChainOut(func) {
                this.chainOut = func;
            }
        },
        {
            key: "chainIn",
            value: function chainIn(event) {
                if (event.type === 'pointermove') {
                    if (event.coalescedArr && event.coalescedArr.length > 0) for(var i = 0; i < event.coalescedArr.length; i++){
                        var eventCopy = (0, $7jh4K.copyObj)(event);
                        if (i === 0) eventCopy.coalescedArr = [];
                        var coalescedItem = event.coalescedArr[i];
                        eventCopy.pageX = coalescedItem.pageX;
                        eventCopy.pageY = coalescedItem.pageY;
                        eventCopy.relX = coalescedItem.relX;
                        eventCopy.relY = coalescedItem.relY;
                        eventCopy.dX = coalescedItem.dX;
                        eventCopy.dY = coalescedItem.dY;
                        eventCopy.time = coalescedItem.time;
                        eventCopy.isCoalesced = i < event.coalescedArr.length - 1;
                        this.chainOut && this.chainOut(eventCopy);
                    }
                    else return event;
                } else return event;
                return null;
            }
        }
    ]);
    return CoalescedExploder;
}();

});

parcelRegister("2pgVs", function(module, exports) {

$parcel$export(module.exports, "NFingerTapper", function () { return $cc27951506e6ad28$export$510622b8aed00381; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eg83P = parcelRequire("eg83P");
var $cc27951506e6ad28$export$510622b8aed00381 = /*#__PURE__*/ function() {
    "use strict";
    function NFingerTapper(p) {
        (0, $cx0mh._)(this, NFingerTapper);
        this.minSilenceBeforeDurationMs = 50;
        this.maxTapMs = 500;
        this.maxFirstLastFingerDownMs = 250;
        this.maxPressedDistancePx = 12 //5 + fingers * 5;
        ;
        this.fingerArr = [];
        this.eventQueueArr = [];
        this.firstDownTime = 0;
        this.lastEventTime = 0;
        this.nowTime = performance.now();
        this.pointersDownIdArr = [];
        this.timeoutObj = {
            firstLastDownTimeout: null,
            tapTimeout: null
        };
        this.fingers = p.fingers;
        this.onTap = p.onTap;
    }
    (0, $7h4XF._)(NFingerTapper, [
        {
            key: "failGesture",
            value: function failGesture() {
                if (this.eventQueueArr.length === 0) return;
                this.timeoutObj.firstLastDownTimeout && clearTimeout(this.timeoutObj.firstLastDownTimeout);
                this.timeoutObj.tapTimeout && clearTimeout(this.timeoutObj.tapTimeout);
                for(var i = 0; i < this.eventQueueArr.length; i++)this.chainOut && this.chainOut(this.eventQueueArr[i]);
                this.eventQueueArr = [];
                this.fingerArr = [];
            }
        },
        {
            key: "success",
            value: function success() {
                this.timeoutObj.firstLastDownTimeout && clearTimeout(this.timeoutObj.firstLastDownTimeout);
                this.timeoutObj.tapTimeout && clearTimeout(this.timeoutObj.tapTimeout);
                this.eventQueueArr = []; // events get swallowed
                this.fingerArr = [];
                this.onTap();
            }
        },
        {
            key: "setupTimeout",
            value: function setupTimeout(timeoutStr, timeMS) {
                var _this = this;
                var diff = timeMS - this.nowTime;
                //console.log(fingers + ': ' + timeoutStr + ' diff', diff);
                if (diff <= 0) // time already up
                return false;
                this.timeoutObj[timeoutStr] = setTimeout(function() {
                    return _this.failGesture();
                }, diff);
                return true;
            }
        },
        {
            key: "processEvent",
            value: function processEvent(event) {
                var tempLastEventTime = this.lastEventTime;
                this.lastEventTime = event.time;
                if (event.type === 'pointerdown') this.pointersDownIdArr.push(event.pointerId);
                else if (event.type === 'pointerup') {
                    for(var i = 0; i < this.pointersDownIdArr.length; i++)if (this.pointersDownIdArr[i] === event.pointerId) {
                        this.pointersDownIdArr.splice(i, 1);
                        break;
                    }
                }
                if (event.pointerType !== 'touch') {
                    if (this.fingerArr.length > 0) // already in gesture -> fail
                    this.failGesture();
                    return;
                }
                this.nowTime = performance.now();
                if (event.type === 'pointerdown') {
                    //console.log('down');
                    if (this.fingerArr.length + 1 !== this.pointersDownIdArr.length) {
                        // failed before, and some fingers are still down -> fail
                        this.failGesture();
                        return;
                    }
                    if (this.fingerArr.length === this.fingers) {
                        // too many fingers down -> fail
                        //console.log(fingers + ': too many fingers down -> fail');
                        this.failGesture();
                        return;
                    }
                    if (this.fingerArr.length > 0 && event.time - this.maxFirstLastFingerDownMs > this.fingerArr[0].downTimeMs) {
                        // took too long to touch with all fingers -> fail
                        //console.log(fingers + ': took too long to touch with all fingers -> fail');
                        this.failGesture();
                        return;
                    }
                    if (this.fingerArr.length === 0 && event.time - this.minSilenceBeforeDurationMs < tempLastEventTime) {
                        // not enough silence before -> fail
                        //console.log(fingers + ': not enough silence before -> fail');
                        this.failGesture();
                        return;
                    }
                    if (this.fingerArr.length === 0) {
                        this.firstDownTime = event.time;
                        if (!this.setupTimeout('firstLastDownTimeout', event.time + this.maxFirstLastFingerDownMs) || !this.setupTimeout('tapTimeout', event.time + this.maxTapMs)) {
                            // timeouts already up -> fail
                            this.failGesture();
                            return;
                        }
                    }
                    this.fingerArr.push({
                        pointerId: event.pointerId,
                        downTimeMs: event.time,
                        downPageX: event.pageX,
                        downPageY: event.pageY
                    });
                    return;
                }
                if (event.type === 'pointermove') {
                    if (this.fingerArr.length === 0) //not in a gesture -> ignore
                    return;
                    var fingerObj = null;
                    for(var i1 = 0; i1 < this.fingerArr.length; i1++)if (this.fingerArr[i1].pointerId === event.pointerId) {
                        fingerObj = this.fingerArr[i1];
                        break;
                    }
                    if (fingerObj === null) {
                        // finger not part of the tap is on screen -> fail
                        this.failGesture();
                        return;
                    }
                    if (event.time - this.maxTapMs > this.firstDownTime) {
                        // tap took too long -> fail
                        //console.log(fingers + ': tap took too long -> fail');
                        this.failGesture();
                        return;
                    }
                    var distance = (0, $eg83P.dist)(event.pageX, event.pageY, fingerObj.downPageX, fingerObj.downPageY);
                    if (distance > this.maxPressedDistancePx) {
                        // finger moved too much -> fail
                        //console.log(fingers + ': a finger moved too much -> fail', distance);
                        this.failGesture();
                        return;
                    }
                }
                if (event.type === 'pointerup') {
                    if (this.fingerArr.length === 0) //not in a gesture -> ignore
                    return;
                    //console.log('up', event.pageX, event.pageY);
                    if (this.fingerArr.length !== this.fingers) {
                        // not enough fingers -> fail
                        //console.log(fingers + ': not enough fingers -> fail');
                        this.failGesture();
                        return;
                    }
                    var fingerObj1 = null;
                    var i2 = 0;
                    for(; i2 < this.fingerArr.length; i2++)if (this.fingerArr[i2].pointerId === event.pointerId) {
                        fingerObj1 = this.fingerArr[i2];
                        break;
                    }
                    if (fingerObj1 === null) //do nothing
                    return;
                    if (event.time - this.maxTapMs > this.firstDownTime) {
                        // tap took too long -> fail
                        //console.log(fingers + ': tap took too long -> fail');
                        this.failGesture();
                        return;
                    }
                    var distance1 = (0, $eg83P.dist)(event.pageX, event.pageY, fingerObj1.downPageX, fingerObj1.downPageY);
                    if (distance1 > this.maxPressedDistancePx) {
                        // finger moved too much -> fail
                        //console.log(fingers + ': b finger moved too much -> fail', distance, event.pageX, event.pageY);
                        //console.log(fingerArr);
                        this.failGesture();
                        return;
                    }
                    fingerObj1.isUp = true;
                    var allAreUp = true;
                    for(var i3 = 0; i3 < this.fingerArr.length; i3++)if (!this.fingerArr[i3].isUp) {
                        allAreUp = false;
                        break;
                    }
                    //console.log('fingerArr', fingerArr);
                    if (allAreUp) {
                        // success
                        this.success();
                        return true;
                    }
                }
            }
        },
        {
            key: "chainIn",
            value: function chainIn(event) {
                var result = this.processEvent(event);
                //console.log(fingerArr.length);
                if (result === true) //tap success -> event gets swallowed
                return null;
                if (this.fingerArr.length === 0) return event;
                else this.eventQueueArr.push(event);
                return null;
            }
        },
        {
            key: "setChainOut",
            value: function setChainOut(func) {
                this.chainOut = func;
            }
        }
    ]);
    return NFingerTapper;
}();

});

parcelRegister("joplQ", function(module, exports) {

$parcel$export(module.exports, "PinchZoomer", function () { return $670d2777518c365a$export$d62358ac2d82abb3; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eg83P = parcelRequire("eg83P");
var $670d2777518c365a$export$d62358ac2d82abb3 = /*#__PURE__*/ function() {
    "use strict";
    function PinchZoomer(p) {
        (0, $cx0mh._)(this, PinchZoomer);
        this.firstFingerMaxDistancePx = 10;
        this.untilSecondFingerDurationMs = 250;
        this.pointersDownIdArr = [];
        this.gestureObj = null;
        this.eventQueueArr = [];
        this.nowTime = performance.now();
        this.timeoutObj = {
            secondFingerTimeout: null
        };
        this.pincherArr = [];
        this.onPinch = p.onPinch;
    }
    (0, $7h4XF._)(PinchZoomer, [
        {
            key: "end",
            value: function end() {
                this.gestureObj = null;
                this.eventQueueArr = [];
            }
        },
        {
            key: "fail",
            value: function fail(doSwallow) {
                if (!this.gestureObj) // no gesture happening -> ignore
                return;
                this.timeoutObj.secondFingerTimeout && clearTimeout(this.timeoutObj.secondFingerTimeout);
                if (!doSwallow) for(var i = 0; i < this.eventQueueArr.length; i++)this.chainOut && this.chainOut(this.eventQueueArr[i]);
                this.end();
            }
        },
        {
            key: "setupFailTimeout",
            value: function setupFailTimeout(timeMS) {
                var _this = this;
                var diff = timeMS - this.nowTime;
                if (diff <= 0) // time already up
                return false;
                this.timeoutObj.secondFingerTimeout = setTimeout(function() {
                    return _this.fail();
                }, diff);
                return true;
            }
        },
        {
            key: "processEvent",
            value: function processEvent(event) {
                if (event.type === 'pointerdown') this.pointersDownIdArr.push(event.pointerId);
                else if (event.type === 'pointerup') {
                    for(var i = 0; i < this.pointersDownIdArr.length; i++)if (this.pointersDownIdArr[i] === event.pointerId) {
                        this.pointersDownIdArr.splice(i, 1);
                        break;
                    }
                }
                //pass through scenarios
                if (!this.gestureObj && (event.pointerType !== 'touch' || // wrong pointer type
                event.type === 'pointermove' && this.pointersDownIdArr.length > 0 || // failed before
                this.pointersDownIdArr.length > 1 || // failed before
                event.type === 'pointerup' // failed before
                )) return;
                this.nowTime = performance.now();
                //pointer down
                if (event.type === 'pointerdown') {
                    if (this.gestureObj) {
                        if (event.pointerType === 'touch') {
                            // touch finger down - as nth pointer
                            this.gestureObj.touchPointerArr.push({
                                pointerId: event.pointerId,
                                relX: event.relX,
                                relY: event.relY
                            });
                            if (this.gestureObj.isInProgress) this.continuePinch(this.gestureObj, {
                                type: 'down',
                                index: this.gestureObj.touchPointerArr.length - 1
                            });
                            else {
                                this.timeoutObj.secondFingerTimeout && clearTimeout(this.timeoutObj.secondFingerTimeout);
                                this.gestureObj.isInProgress = true;
                                this.beginPinch(this.gestureObj);
                            }
                            return;
                        } else {
                            // non-touch finger down - as nth pointer
                            if (this.gestureObj.isInProgress) this.gestureObj.otherPointerIdArr.push(event.pointerId);
                            else // second pointer wrong type -> fail
                            this.fail();
                            return;
                        }
                    } else {
                        // first finger down - can only be touch if no gestureObj
                        this.gestureObj = {
                            touchPointerArr: [
                                {
                                    pointerId: event.pointerId,
                                    relX: event.relX,
                                    relY: event.relY,
                                    downRelX: event.relX,
                                    downRelY: event.relY
                                }
                            ],
                            otherPointerIdArr: [],
                            isInProgress: false
                        };
                        if (!this.setupFailTimeout(event.time + this.untilSecondFingerDurationMs)) {
                            // time ran out -> fail
                            this.fail();
                            return;
                        }
                        return;
                    }
                }
                // should not happen. something went wrong
                if (!this.gestureObj) {
                    // throw? would make it less robust
                    this.fail();
                    return;
                }
                //pointer move
                if (event.type === 'pointermove' && event.pointerType === 'touch') {
                    //gesture object should always exist here
                    var touchPointerObj = null;
                    var i1 = 0;
                    for(; i1 < this.gestureObj.touchPointerArr.length; i1++)if (event.pointerId === this.gestureObj.touchPointerArr[i1].pointerId) {
                        touchPointerObj = this.gestureObj.touchPointerArr[i1];
                        break;
                    }
                    //null should not be possible. something went wrong
                    if (!touchPointerObj) {
                        // throw? would make it less robust
                        this.fail();
                        return;
                    }
                    touchPointerObj.relX = event.relX;
                    touchPointerObj.relY = event.relY;
                    if (!this.gestureObj.isInProgress) {
                        // only one finger down & pinching hasn't started
                        // should not happen. something went wrong
                        if (!('downRelX' in touchPointerObj && touchPointerObj.downRelX !== undefined) || !('downRelY' in touchPointerObj && touchPointerObj.downRelY !== undefined)) {
                            this.fail();
                            return;
                        }
                        var distance = (0, $eg83P.dist)(touchPointerObj.downRelX, touchPointerObj.downRelY, touchPointerObj.relX, touchPointerObj.relY);
                        if (distance > this.firstFingerMaxDistancePx) {
                            // moved too much -> fail
                            this.fail();
                            return;
                        }
                    } else if (i1 < 2) // only first two touches can affect pinching
                    this.continuePinch(this.gestureObj, {
                        type: 'move',
                        index: i1
                    });
                    return;
                }
                //pointer up
                if (event.type === 'pointerup') {
                    //gesture object should always exist here
                    if (event.pointerType === 'touch') {
                        var i2 = 0;
                        for(; i2 < this.gestureObj.touchPointerArr.length; i2++)if (this.gestureObj.touchPointerArr[i2].pointerId === event.pointerId) {
                            this.gestureObj.touchPointerArr.splice(i2, 1);
                            break;
                        }
                        if (this.gestureObj.touchPointerArr.length > 0) this.continuePinch(this.gestureObj, {
                            type: 'up',
                            index: i2
                        });
                    } else {
                        // non-touch
                        for(var i3 = 0; i3 < this.gestureObj.otherPointerIdArr.length; i3++)if (this.gestureObj.otherPointerIdArr[i3] === event.pointerId) {
                            this.gestureObj.otherPointerIdArr.splice(i3, 1);
                            break;
                        }
                    }
                    //all fingers lifted?
                    if (this.gestureObj.touchPointerArr.length === 0 && this.gestureObj.otherPointerIdArr.length === 0) {
                        if (this.gestureObj.isInProgress) {
                            // lifted last finger -> end of pinching
                            this.end();
                            this.endPinch();
                        } else // lifted finger again before pinching started -> fail
                        this.fail();
                        return;
                    }
                }
            }
        },
        {
            key: "beginPinch",
            value: function beginPinch(gestureObj) {
                for(var i = 0; i < gestureObj.touchPointerArr.length; i++){
                    var pointerObj = gestureObj.touchPointerArr[i];
                    this.pincherArr.push({
                        pointerId: pointerObj.pointerId,
                        relX: pointerObj.relX,
                        relY: pointerObj.relY,
                        downRelX: pointerObj.relX,
                        downRelY: pointerObj.relY
                    });
                }
                var event = {
                    type: 'move',
                    // temp
                    downRelX: 0,
                    downRelY: 0,
                    relX: 0,
                    relY: 0,
                    angleRad: 0,
                    scale: 1
                };
                if (this.pincherArr.length === 1) {
                    event.relX = this.pincherArr[0].downRelX;
                    event.relY = this.pincherArr[0].downRelY;
                } else {
                    event.relX = 0.5 * (this.pincherArr[0].downRelX + this.pincherArr[1].downRelX);
                    event.relY = 0.5 * (this.pincherArr[0].downRelY + this.pincherArr[1].downRelY);
                }
                event.downRelX = event.relX;
                event.downRelY = event.relY;
                this.onPinch(event);
            }
        },
        {
            key: "continuePinch",
            value: //actionObj = {type: 'down'|'move'|'up', index: number}
            function continuePinch(gestureObj, actionObj) {
                if (actionObj.index > 1) // only first two pointers matter
                return;
                if (actionObj.type === 'move') {
                    var event;
                    this.pincherArr[actionObj.index].relX = gestureObj.touchPointerArr[actionObj.index].relX;
                    this.pincherArr[actionObj.index].relY = gestureObj.touchPointerArr[actionObj.index].relY;
                    if (this.pincherArr.length === 1) event = {
                        type: 'move',
                        downRelX: this.pincherArr[0].downRelX,
                        downRelY: this.pincherArr[0].downRelY,
                        relX: this.pincherArr[0].relX,
                        relY: this.pincherArr[0].relY,
                        angleRad: 0,
                        scale: 1
                    };
                    else {
                        var startDist = (0, $eg83P.dist)(this.pincherArr[0].downRelX, this.pincherArr[0].downRelY, this.pincherArr[1].downRelX, this.pincherArr[1].downRelY);
                        var distance = (0, $eg83P.dist)(this.pincherArr[0].relX, this.pincherArr[0].relY, this.pincherArr[1].relX, this.pincherArr[1].relY);
                        var startAngle = (0, $eg83P.pointsToAngleRad)({
                            x: this.pincherArr[0].downRelX,
                            y: this.pincherArr[0].downRelY
                        }, {
                            x: this.pincherArr[1].downRelX,
                            y: this.pincherArr[1].downRelY
                        });
                        var angle = (0, $eg83P.pointsToAngleRad)({
                            x: this.pincherArr[0].relX,
                            y: this.pincherArr[0].relY
                        }, {
                            x: this.pincherArr[1].relX,
                            y: this.pincherArr[1].relY
                        });
                        event = {
                            type: 'move',
                            downRelX: 0.5 * (this.pincherArr[0].downRelX + this.pincherArr[1].downRelX),
                            downRelY: 0.5 * (this.pincherArr[0].downRelY + this.pincherArr[1].downRelY),
                            relX: 0.5 * (this.pincherArr[0].relX + this.pincherArr[1].relX),
                            relY: 0.5 * (this.pincherArr[0].relY + this.pincherArr[1].relY),
                            angleRad: angle - startAngle,
                            scale: distance / startDist
                        };
                    }
                    this.onPinch(event);
                } else if (actionObj.type === 'down' || actionObj.type === 'up') {
                    this.endPinch();
                    this.beginPinch(gestureObj);
                }
            }
        },
        {
            key: "endPinch",
            value: function endPinch() {
                this.pincherArr = [];
                this.onPinch({
                    type: 'end'
                });
            }
        },
        {
            key: "chainIn",
            value: function chainIn(event) {
                this.processEvent(event);
                if (this.gestureObj) {
                    if (!this.gestureObj.isInProgress) // might still fail -> into queue
                    this.eventQueueArr.push(event);
                } else return event;
                return null;
            }
        },
        {
            key: "setChainOut",
            value: function setChainOut(func) {
                this.chainOut = func;
            }
        }
    ]);
    return PinchZoomer;
}();

});

parcelRegister("c1lmK", function(module, exports) {

$parcel$export(module.exports, "DoubleTapper", function () { return $f607ef98ce9eccdc$export$db3963a21c01d803; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $bX4ja = parcelRequire("bX4ja");

var $eg83P = parcelRequire("eg83P");
var $f607ef98ce9eccdc$export$db3963a21c01d803 = /*#__PURE__*/ function() {
    "use strict";
    function DoubleTapper(p) {
        var _this = this;
        (0, $cx0mh._)(this, DoubleTapper);
        this.allowedPointerTypeArr = [
            'touch',
            'mouse',
            'pen'
        ];
        this.allowedButtonArr = [
            'left'
        ];
        this.minSilenceBeforeDurationMs = 400;
        this.maxPressedDurationMs = 300;
        this.maxPressedDistancePx = 10;
        this.maxInbetweenDistancePx = 19;
        this.maxUpToUpDurationMs = 500;
        this.maxUntilSecondDownDurationMs = 300;
        this.minSilenceAfterMs = 250;
        this.sequenceArr = [];
        this.pointersDownIdArr = [];
        this.lastUpTime = 0;
        this.nowTime = 0;
        this.eventQueueArr = [];
        this.timeoutObj = {
            fail: null,
            maxUntilSecondDown: null,
            success: null
        };
        this.onDoubleTap = p.onDoubleTap;
        if (p.isInstant) {
            this.minSilenceBeforeDurationMs = 0;
            this.minSilenceAfterMs = 0;
        }
        this.gestureFailed = function() {
            if (_this.sequenceArr.length === 0) // no gesture started -> can be ignored
            return;
            _this.timeoutObj.fail && clearTimeout(_this.timeoutObj.fail);
            _this.timeoutObj.maxUntilSecondDown && clearTimeout(_this.timeoutObj.maxUntilSecondDown);
            _this.timeoutObj.success && clearTimeout(_this.timeoutObj.success);
            _this.timeoutObj.fail = null;
            _this.timeoutObj.maxUntilSecondDown = null;
            _this.timeoutObj.success = null;
            if (_this.chainOut) for(var i = 0; i < _this.eventQueueArr.length; i++)_this.chainOut(_this.eventQueueArr[i]);
            _this.eventQueueArr = [];
            _this.sequenceArr = [];
        };
    }
    (0, $7h4XF._)(DoubleTapper, [
        {
            key: "success",
            value: // double tap achieved
            function success() {
                this.timeoutObj.fail = null;
                this.timeoutObj.success = null;
                this.eventQueueArr = []; // events get swallowed
                var lastSequenceItem = this.sequenceArr[this.sequenceArr.length - 1];
                this.sequenceArr = [];
                if ('pageX' in lastSequenceItem) this.onDoubleTap({
                    pageX: lastSequenceItem.pageX,
                    pageY: lastSequenceItem.pageY,
                    relX: lastSequenceItem.relX,
                    relY: lastSequenceItem.relY
                });
            }
        },
        {
            key: "setupTimeout",
            value: // returns false if time already up. otherwise sets up timeout
            function setupTimeout(timeoutStr, targetFunc, timeMS, noComparison) {
                var diff = timeMS - this.nowTime;
                // console.log(fingers + ': ' + timeoutStr + ' diff', diff);
                if (diff <= 0 && !noComparison) // time already up
                return false;
                this.timeoutObj[timeoutStr] = setTimeout(targetFunc, Math.max(0, diff));
                return true;
            }
        },
        {
            key: "processEvent",
            value: /**
     * @param event object - a pointer event from BB.PointerListener
     */ function processEvent(event) {
                var _this = this;
                if (event.type === 'pointerdown') this.pointersDownIdArr.push(event.pointerId);
                else if (event.type === 'pointerup') {
                    for(var i = 0; i < this.pointersDownIdArr.length; i++)if (this.pointersDownIdArr[i] === event.pointerId) {
                        this.pointersDownIdArr.splice(i, 1);
                        break;
                    }
                }
                if (!this.allowedPointerTypeArr.includes(event.pointerType)) {
                    //wrong input type -> fail
                    //console.log('wrong input type -> fail');
                    this.gestureFailed();
                    return;
                }
                this.nowTime = performance.now();
                var lastSequenceItem = this.sequenceArr.length > 0 ? this.sequenceArr[this.sequenceArr.length - 1] : null;
                if (event.type === 'pointerup') this.lastUpTime = event.time;
                if (event.type === 'pointerdown') {
                    if (this.pointersDownIdArr.length > 1) {
                        // more than one pointer down -> fail
                        //console.log('more than one pointer down -> fail');
                        this.gestureFailed();
                        return;
                    }
                    if (this.timeoutObj.success !== null) {
                        // silence-after not achieved -> fail
                        //console.log('silence-after not achieved -> fail');
                        this.gestureFailed();
                        return;
                    }
                    if (this.sequenceArr.length === 0 && this.nowTime - this.lastUpTime < this.minSilenceBeforeDurationMs) {
                        // silence before not achieved -> fail
                        //console.log('silence before not achieved -> fail');
                        this.gestureFailed();
                        return;
                    }
                    if (event.button && !this.allowedButtonArr.includes(event.button)) {
                        // wrong button -> fail
                        //console.log('wrong button -> fail', event.button, allowedButtonArr);
                        this.gestureFailed();
                        return;
                    }
                    if (lastSequenceItem && 'isDown' in lastSequenceItem && lastSequenceItem.isDown || this.sequenceArr.length > 2) {
                        // jumbled -> fail
                        //console.log('jumbled -> fail');
                        this.gestureFailed();
                        return;
                    }
                    if (lastSequenceItem && 'position' in lastSequenceItem) {
                        var distance = (0, $eg83P.dist)(lastSequenceItem.position[0], lastSequenceItem.position[1], event.pageX, event.pageY);
                        if (distance > this.maxInbetweenDistancePx) {
                            //moved too much -> reset
                            //console.log('maxInbetweenDistancePx -> reset');
                            this.gestureFailed();
                            if ('time' in lastSequenceItem && this.nowTime - lastSequenceItem.time < this.minSilenceBeforeDurationMs) //silence before not achieved -> fail
                            return;
                        }
                    }
                    this.sequenceArr.push({
                        isDown: true,
                        time: this.nowTime,
                        position: [
                            event.pageX,
                            event.pageY
                        ],
                        pointerId: event.pointerId
                    });
                    //maxUntilSecondDown
                    if (this.sequenceArr.length > 1) this.timeoutObj.maxUntilSecondDown && clearTimeout(this.timeoutObj.maxUntilSecondDown);
                    else if (!this.setupTimeout('maxUntilSecondDown', function() {
                        return _this.gestureFailed();
                    }, event.time + this.maxUntilSecondDownDurationMs)) {
                        //console.log('event.time + maxPressedDurationMs -> fail');
                        this.gestureFailed();
                        return;
                    }
                    this.timeoutObj.fail && clearTimeout(this.timeoutObj.fail);
                    if (!this.setupTimeout('fail', function() {
                        return _this.gestureFailed();
                    }, event.time + this.maxPressedDurationMs)) {
                        //console.log('event.time + maxPressedDurationMs -> fail');
                        this.gestureFailed();
                        return;
                    }
                }
                if (lastSequenceItem && event.type === 'pointermove' && 'pointerId' in lastSequenceItem && lastSequenceItem.pointerId === event.pointerId) {
                    /*if (lastSequenceItem.pointerId !== event.pointerId) { //another pointer mixing in -> fail
                console.log('another pointer mixing in -> fail');
                this.fail();
                return;
            }*/ var distance1 = (0, $eg83P.dist)(lastSequenceItem.position[0], lastSequenceItem.position[1], event.pageX, event.pageY);
                    if (distance1 > this.maxPressedDistancePx) {
                        //moved too much -> fail
                        //console.log('maxPressedDistancePx -> fail');
                        this.gestureFailed();
                        return;
                    }
                }
                if (lastSequenceItem && event.type === 'pointerup') {
                    if ('pointerId' in lastSequenceItem && lastSequenceItem.pointerId !== event.pointerId) {
                        //another pointer mixing in -> fail
                        this.gestureFailed();
                        return;
                    }
                    if ('time' in lastSequenceItem && this.nowTime >= lastSequenceItem.time + this.maxPressedDurationMs) {
                        //pressed too long -> fail
                        this.gestureFailed();
                        return;
                    }
                    this.timeoutObj.fail && clearTimeout(this.timeoutObj.fail);
                    if (this.sequenceArr.length < 3) {
                        if (!this.setupTimeout('fail', function() {
                            return _this.gestureFailed();
                        }, event.time + this.maxUpToUpDurationMs)) {
                            this.gestureFailed();
                            return;
                        }
                        this.sequenceArr = [
                            lastSequenceItem,
                            {
                                isUp: true,
                                time: this.nowTime,
                                position: [
                                    event.pageX,
                                    event.pageY
                                ]
                            }
                        ];
                        return;
                    }
                    if ('time' in this.sequenceArr[1] && this.nowTime < this.sequenceArr[1].time + this.maxUpToUpDurationMs) {
                        // double tap almost success
                        // only needs silence
                        this.sequenceArr.push({
                            pageX: event.pageX,
                            pageY: event.pageY,
                            relX: event.relX,
                            relY: event.relY
                        });
                        if (!this.setupTimeout('success', function() {
                            return _this.success();
                        }, event.time + this.minSilenceAfterMs, true)) this.gestureFailed();
                    } else // time up -> fail
                    this.gestureFailed();
                }
            }
        },
        {
            key: "chainIn",
            value: function chainIn(event) {
                this.processEvent(event);
                if (this.sequenceArr.length === 0) {
                    //existing events can not become a double tap
                    this.gestureFailed();
                    return event;
                }
                // events might become a double tap -> queue
                this.eventQueueArr.push(event);
                return null;
            }
        },
        {
            key: "setChainOut",
            value: function setChainOut(func) {
                this.chainOut = func;
            }
        },
        {
            key: "setAllowedPointerTypeArr",
            value: function setAllowedPointerTypeArr(arr) {
                this.allowedPointerTypeArr = (0, $bX4ja._)(arr);
            }
        },
        {
            key: "setAllowedButtonArr",
            value: function setAllowedButtonArr(arr) {
                this.allowedButtonArr = (0, $bX4ja._)(arr);
            }
        }
    ]);
    return DoubleTapper;
}();

});

parcelRegister("635F6", function(module, exports) {

$parcel$export(module.exports, "OnePointerLimiter", function () { return $956c5ff01a38849f$export$71ff2f51bf1f4062; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $956c5ff01a38849f$export$71ff2f51bf1f4062 = /*#__PURE__*/ function() {
    "use strict";
    function OnePointerLimiter() {
        (0, $cx0mh._)(this, OnePointerLimiter);
        this.downPointerId = null;
        this.ignorePointerIdArr = [];
    }
    (0, $7h4XF._)(OnePointerLimiter, [
        {
            // ----------------------------------- public -----------------------------------
            key: "chainIn",
            value: function chainIn(event) {
                if (this.ignorePointerIdArr.includes(event.pointerId)) {
                    if (event.type === 'pointerup') {
                        for(var i = 0; i < this.ignorePointerIdArr.length; i++)if (this.ignorePointerIdArr[i] === event.pointerId) {
                            this.ignorePointerIdArr.splice(i, 1);
                            break;
                        }
                    }
                    return null;
                }
                if (this.downPointerId === null) {
                    if (event.type === 'pointerdown') this.downPointerId = event.pointerId;
                    return event;
                } else {
                    if (event.pointerId !== this.downPointerId) {
                        if (event.type === 'pointerdown') this.ignorePointerIdArr.push(event.pointerId);
                        return null;
                    }
                    if (event.type === 'pointerup') this.downPointerId = null;
                    return event;
                }
            }
        },
        {
            key: "setChainOut",
            value: function setChainOut(func) {
                this.chainOut = func;
            }
        }
    ]);
    return OnePointerLimiter;
}();

});

parcelRegister("gCzYB", function(module, exports) {

$parcel$export(module.exports, "EventChain", function () { return $4fb7927cde0b2f75$export$649a211db9812745; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $4fb7927cde0b2f75$export$649a211db9812745 = /*#__PURE__*/ function() {
    "use strict";
    function EventChain(p) {
        var _this = this;
        (0, $cx0mh._)(this, EventChain);
        this.chainArr = p.chainArr;
        for(var i = 0; i < this.chainArr.length; i++)(function(i) {
            _this.chainArr[i].setChainOut(function(event) {
                _this.continueChain(i + 1, event);
            });
        })(i);
    }
    (0, $7h4XF._)(EventChain, [
        {
            key: "continueChain",
            value: function continueChain(i, event) {
                for(; i < this.chainArr.length; i++){
                    event = this.chainArr[i].chainIn(event);
                    if (event === null) return null;
                }
                this.chainOut && this.chainOut(event);
                return null;
            }
        },
        {
            /**
     * feed an event into the chain
     */ key: "chainIn",
            value: function chainIn(event) {
                return this.continueChain(0, event);
            }
        },
        {
            /**
     * func will be called when event has passed through the chain
     */ key: "setChainOut",
            value: function setChainOut(func) {
                this.chainOut = func;
            }
        }
    ]);
    return EventChain;
}();

});



parcelRegister("fFwUa", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b684359a5868888a$export$71511d61b312f219; });

var $2JCCy = parcelRequire("2JCCy");

var $ff8rK = parcelRequire("ff8rK");

var $5IlRA = parcelRequire("5IlRA");
function $b684359a5868888a$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $2JCCy._)(derived);
    return (0, $5IlRA._)(_this, (0, $ff8rK._)() ? Reflect.construct(derived, args || [], (0, $2JCCy._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("2JCCy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1fddbe0c3c1a3fa3$export$71511d61b312f219; });
function $1fddbe0c3c1a3fa3$export$71511d61b312f219(o) {
    $1fddbe0c3c1a3fa3$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1fddbe0c3c1a3fa3$export$71511d61b312f219(o);
}

});

parcelRegister("ff8rK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b18ecf0a91605feb$export$71511d61b312f219; });
function $b18ecf0a91605feb$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($b18ecf0a91605feb$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("5IlRA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $42920568c35875bb$export$71511d61b312f219; });

var $d6zUP = parcelRequire("d6zUP");

var $8KHnw = parcelRequire("8KHnw");
function $42920568c35875bb$export$71511d61b312f219(self, call) {
    if (call && ((0, $8KHnw._)(call) === "object" || typeof call === "function")) return call;
    return (0, $d6zUP._)(self);
}

});
parcelRegister("d6zUP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $98a7b1f92515508c$export$71511d61b312f219; });
function $98a7b1f92515508c$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRegister("8KHnw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $65f444a42ac09208$export$71511d61b312f219; });
function $65f444a42ac09208$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



parcelRegister("9xmuV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6f18a5bb13975690$export$71511d61b312f219; });

var $5oklS = parcelRequire("5oklS");
function $6f18a5bb13975690$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $5oklS._)(subClass, superClass);
}

});
parcelRegister("5oklS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $010356a15c2fd2ed$export$71511d61b312f219; });
function $010356a15c2fd2ed$export$71511d61b312f219(o, p) {
    $010356a15c2fd2ed$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $010356a15c2fd2ed$export$71511d61b312f219(o, p);
}

});


parcelRegister("6otAp", function(module, exports) {

$parcel$export(module.exports, "RECOVERY_THUMB_WIDTH_PX", function () { return RECOVERY_THUMB_WIDTH_PX; });
$parcel$export(module.exports, "RECOVERY_THUMB_HEIGHT_PX", function () { return RECOVERY_THUMB_HEIGHT_PX; });
$parcel$export(module.exports, "RECOVERY_AGE_LIMIT_MS", function () { return RECOVERY_AGE_LIMIT_MS; });
$parcel$export(module.exports, "RECOVERY_MEMORY_LIMIT_BYTES", function () { return RECOVERY_MEMORY_LIMIT_BYTES; });
$parcel$export(module.exports, "DEBUG_RETURN_ALL_RECOVERIES", function () { return DEBUG_RETURN_ALL_RECOVERIES; });
$parcel$export(module.exports, "KlRecoveryManager", function () { return KlRecoveryManager; });

var $1LaJZ = parcelRequire("1LaJZ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $fk3zw = parcelRequire("fk3zw");

var $gDbpE = parcelRequire("gDbpE");

var $7jh4K = parcelRequire("7jh4K");

var $3uJxV = parcelRequire("3uJxV");

var $jTg9g = parcelRequire("jTg9g");
var RECOVERY_THUMB_WIDTH_PX = 300;
var RECOVERY_THUMB_HEIGHT_PX = 180;
var RECOVERY_AGE_LIMIT_MS = 604800000; // 1 week
var RECOVERY_MEMORY_LIMIT_BYTES = 1e9;
var FIRST_RECOVERY_AFTER_MS = 300000;
var FIRST_RECOVERY_AFTER_CHANGES = 8;
var SUBSEQUENT_RECOVERY_AFTER_MS = 60000;
var SUBSEQUENT_RECOVERY_AFTER_CHANGES = 4;
var DEBUG_RETURN_ALL_RECOVERIES = false;
var DEBUG_INSTANT_RECOVERY = false;
function setHash(value) {
    if (value === undefined) {
        history.replaceState(null, '', ' ');
        return;
    }
    // avoid creating a new history state
    history.replaceState(null, '', window.location.origin + window.location.pathname + window.location.search + '#' + value);
}
function getHash() {
    // returns without the "#"
    return window.location.hash ? window.location.hash.substring(1) : undefined;
}
var ignoredHashes = [
    'licenses'
];
function hashToTabId(rawHash) {
    if (rawHash === undefined || ignoredHashes.includes(rawHash)) return undefined;
    var num = +rawHash;
    if (isNaN(num) || num < 0 || num % 1 !== 0) return undefined;
    return num;
}
function genNewId(takenIds) {
    var limit = 1000;
    if (takenIds.length >= limit) throw new Error('No available IDs');
    var idSet = new Set(takenIds);
    var pool = (0, $7jh4K.createArray)(limit, 0).map(function(_, index) {
        return index;
    }).filter(function(id) {
        return !idSet.has(id);
    });
    var index = Math.floor(Math.random() * pool.length);
    if (pool[index] === undefined) throw new Error('No available IDs');
    return pool[index];
}
var KlRecoveryManager = /*#__PURE__*/ function() {
    "use strict";
    function KlRecoveryManager(p) {
        (0, $cx0mh._)(this, KlRecoveryManager);
        this.klHistory = {};
        this.isStoring = false;
        this.listeners = new Set();
        this.crossTabChannel = new (0, $3uJxV.CrossTabChannel)('kl-tab-communication');
        this.initListeners();
    }
    (0, $7h4XF._)(KlRecoveryManager, [
        {
            key: "announceTabId",
            value: function announceTabId() {
                this.crossTabChannel.postMessage({
                    type: 'new-tab'
                });
            }
        },
        {
            key: "initListeners",
            value: function initListeners() {
                var _this = this;
                document.addEventListener('visibilitychange', function() {
                    if (document.hidden) return;
                    // changes may have happened since tab last visible
                    // might not register a tab is closed without timeout
                    setTimeout(function() {
                        _this.update();
                    }, 500);
                });
                window.addEventListener('focus', function() {
                    setTimeout(function() {
                        _this.update();
                    }, 500);
                });
                this.crossTabChannel.subscribe(function(message) {
                    if (message.type === 'new-tab') {
                        if (document.hidden) // we'll update when tab visible. noop.
                        return;
                        setTimeout(function() {
                            _this.update();
                        }, 500);
                    }
                    if (message.type === 'request-ids') {
                        if (_this.tabId !== undefined) _this.crossTabChannel.postMessage({
                            type: 'response-ids',
                            id: _this.tabId
                        });
                    }
                });
                // I think this is not needed
                var debounceTimeout;
            /*KL_INDEXED_DB.addListener(async () => {
            if (document.hidden) {
                return;
            }
            console.log('indexed db change!');
            clearTimeout(debounceTimeout);
            debounceTimeout = setTimeout(async () => {
                this.update();
            }, 100);
        });*/ }
        },
        {
            key: "emitUpdate",
            value: function emitUpdate() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this, ids, otherTabIds, tabIds, drawings, totalMemoryUsedBytes;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (!(0, $jTg9g.KL_INDEXED_DB).getIsAvailable()) return [
                                    2
                                ];
                                return [
                                    4,
                                    (0, $gDbpE.getIdsFromRecoveryStore)()
                                ];
                            case 1:
                                ids = _state.sent();
                                return [
                                    4,
                                    this.getIdsFromTabs()
                                ];
                            case 2:
                                otherTabIds = _state.sent();
                                tabIds = DEBUG_RETURN_ALL_RECOVERIES ? ids : ids.filter(function(id) {
                                    return !otherTabIds.includes(id) && id !== _this.tabId;
                                });
                                return [
                                    4,
                                    Promise.all(tabIds.map(function(id) {
                                        return (0, $gDbpE.getMetadata)('' + id, true);
                                    }))
                                ];
                            case 3:
                                drawings = _state.sent();
                                return [
                                    4,
                                    this.getTotalMemoryUsedBytes()
                                ];
                            case 4:
                                totalMemoryUsedBytes = _state.sent();
                                this.listeners.forEach(function(listener) {
                                    listener(drawings, totalMemoryUsedBytes);
                                });
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setHash",
            value: function setHash1(id) {
                setHash(id === undefined ? undefined : '' + id);
                this.announceTabId();
            }
        },
        {
            key: "getIdsFromTabs",
            value: function getIdsFromTabs() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var result, onMessage;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.crossTabChannel.postMessage({
                                    type: 'request-ids'
                                });
                                result = [];
                                onMessage = function(message) {
                                    if (message.type === 'response-ids') result.push(+message.id);
                                };
                                this.crossTabChannel.subscribe(onMessage);
                                return [
                                    4,
                                    (0, $7jh4K.sleep)(100)
                                ];
                            case 1:
                                _state.sent();
                                this.crossTabChannel.unsubscribe(onMessage);
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getTotalMemoryUsedBytes",
            value: function getTotalMemoryUsedBytes() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var ids, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, id, meta, err;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $gDbpE.getIdsFromRecoveryStore)()
                                ];
                            case 1:
                                ids = _state.sent();
                                result = 0;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator = ids[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    6
                                ];
                                id = _step.value;
                                return [
                                    4,
                                    (0, $gDbpE.getMetadata)('' + id)
                                ];
                            case 4:
                                meta = _state.sent();
                                result += meta.memoryEstimateBytes;
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getRecovery",
            value: function getRecovery1() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var initialTabId, openTabIds, storedIds, newId, result;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // is there a tabId?
                                initialTabId = hashToTabId(getHash());
                                if (initialTabId === undefined) {
                                    this.noRecoveryReason = 'noTabIdHash';
                                    // we get a tabId later
                                    return [
                                        2,
                                        undefined
                                    ];
                                }
                                return [
                                    4,
                                    this.getIdsFromTabs()
                                ];
                            case 1:
                                openTabIds = _state.sent();
                                if (openTabIds.includes(initialTabId)) {
                                    this.noRecoveryReason = 'alreadyOpened';
                                    // Already exists -> unset tabId. Nothing to load.
                                    this.setHash(undefined);
                                    return [
                                        2,
                                        undefined
                                    ];
                                }
                                return [
                                    4,
                                    (0, $gDbpE.getIdsFromRecoveryStore)()
                                ];
                            case 2:
                                storedIds = _state.sent();
                                if (!storedIds.includes(initialTabId)) {
                                    this.noRecoveryReason = 'idNotFound';
                                    // not found -> unset tabId and abort
                                    this.setHash(undefined);
                                    return [
                                        2,
                                        undefined
                                    ];
                                }
                                // change id of drawing and tab
                                newId = genNewId(storedIds);
                                return [
                                    4,
                                    (0, $gDbpE.changeRecoveryId)(initialTabId, newId)
                                ];
                            case 3:
                                if (!_state.sent()) {
                                    this.noRecoveryReason = 'idChangeFailed';
                                    this.setHash(undefined);
                                    return [
                                        2,
                                        undefined
                                    ];
                                }
                                this.setHash(newId); // update hash
                                return [
                                    4,
                                    (0, $gDbpE.getRecovery)(newId)
                                ];
                            case 4:
                                result = _state.sent();
                                if (result) this.tabId = newId;
                                setTimeout(function() {
                                    // don't disrupt loading
                                    (0, $gDbpE.removeOrphans)();
                                });
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setKlHistory",
            value: function setKlHistory(klHistory) {
                var _this = this;
                this.klHistory = klHistory;
                var startTime = new Date().getTime();
                var lastStoredChangeCount = 0;
                this.klHistory.addListener(function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                        var changeCount, deltaMs, isFreshDrawing, storedIds, e;
                        return (0, $fk3zw._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (this.isStoring) return [
                                        2
                                    ];
                                    changeCount = this.klHistory.getChangeCount();
                                    if (!DEBUG_INSTANT_RECOVERY) {
                                        deltaMs = new Date().getTime() - startTime;
                                        // initial store after 5 minutes
                                        if (this.tabId === undefined && (deltaMs < FIRST_RECOVERY_AFTER_MS || changeCount < FIRST_RECOVERY_AFTER_CHANGES)) return [
                                            2
                                        ];
                                        // subsequent store after 1 minutes
                                        if (this.tabId !== undefined && (deltaMs < SUBSEQUENT_RECOVERY_AFTER_MS || changeCount - lastStoredChangeCount < SUBSEQUENT_RECOVERY_AFTER_CHANGES)) return [
                                            2
                                        ];
                                    }
                                    isFreshDrawing = false;
                                    if (!!this.tabId) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        (0, $7jh4K.timeoutWrapper)((0, $gDbpE.getIdsFromRecoveryStore)(), 'setKlHistory.getIdsFromStore')
                                    ];
                                case 1:
                                    storedIds = _state.sent();
                                    this.tabId = genNewId(storedIds);
                                    isFreshDrawing = true;
                                    _state.label = 2;
                                case 2:
                                    this.isStoring = true;
                                    _state.label = 3;
                                case 3:
                                    _state.trys.push([
                                        3,
                                        5,
                                        ,
                                        6
                                    ]);
                                    return [
                                        4,
                                        (0, $gDbpE.storeRecovery)(this.tabId, this.klHistory.getComposed(), this.getThumbnail)
                                    ];
                                case 4:
                                    _state.sent();
                                    startTime = new Date().getTime();
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    e = _state.sent();
                                    setTimeout(function() {
                                        throw e;
                                    });
                                    return [
                                        3,
                                        6
                                    ];
                                case 6:
                                    if (!isFreshDrawing) return [
                                        3,
                                        8
                                    ];
                                    this.setHash(this.tabId);
                                    return [
                                        4,
                                        (0, $gDbpE.clearOldRecoveries)()
                                    ];
                                case 7:
                                    _state.sent();
                                    _state.label = 8;
                                case 8:
                                    startTime = new Date().getTime();
                                    lastStoredChangeCount = changeCount;
                                    this.isStoring = false;
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                });
            }
        },
        {
            key: "setGetThumbnail",
            value: function setGetThumbnail(getThumbnail) {
                this.getThumbnail = getThumbnail;
            }
        },
        {
            /**
     * Listener will be informed about recoveries in closed tabs.
     * totalMemoryUsesBytes includes recoveries in open tabs
     */ key: "subscribe",
            value: function subscribe(listener) {
                this.listeners.add(listener);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(listener) {
                this.listeners.delete(listener);
            }
        },
        {
            key: "update",
            value: // re-checks what recoveries exist
            function update() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(this.listeners.size > 0)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    this.emitUpdate()
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "remove",
            value: function remove(recoveryId) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $gDbpE.deleteRecovery)('' + recoveryId)
                                ];
                            case 1:
                                _state.sent();
                                this.update();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getTabId",
            value: function getTabId() {
                return this.tabId;
            }
        },
        {
            key: "getNoRecoveryReason",
            value: function getNoRecoveryReason() {
                return this.noRecoveryReason;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
            // todo
            }
        }
    ]);
    return KlRecoveryManager;
}();

});
parcelRegister("gDbpE", function(module, exports) {

$parcel$export(module.exports, "getIdsFromRecoveryStore", function () { return $43466d1bcd4520c8$export$151da384cc114748; });
$parcel$export(module.exports, "clearOldRecoveries", function () { return $43466d1bcd4520c8$export$907f896f070645af; });
$parcel$export(module.exports, "deleteRecovery", function () { return $43466d1bcd4520c8$export$9c7685b8d5826628; });
$parcel$export(module.exports, "removeOrphans", function () { return $43466d1bcd4520c8$export$4484d7cddf79b0c1; });
$parcel$export(module.exports, "getRecovery", function () { return $43466d1bcd4520c8$export$a6d4bfb7a7d18ef3; });
$parcel$export(module.exports, "changeRecoveryId", function () { return $43466d1bcd4520c8$export$896fee2a85b1fc93; });
$parcel$export(module.exports, "storeRecovery", function () { return $43466d1bcd4520c8$export$b9ecabbf4820fa1b; });
$parcel$export(module.exports, "getMetadata", function () { return $43466d1bcd4520c8$export$8548546c0aa631e6; });

var $1LaJZ = parcelRequire("1LaJZ");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $bX4ja = parcelRequire("bX4ja");

var $fk3zw = parcelRequire("fk3zw");

var $2gUX3 = parcelRequire("2gUX3");

var $jTg9g = parcelRequire("jTg9g");

var $3hwQ7 = parcelRequire("3hwQ7");

var $esGm2 = parcelRequire("esGm2");

var $eWjiX = parcelRequire("eWjiX");

var $gWfkn = parcelRequire("gWfkn");

var $7nLJW = parcelRequire("7nLJW");

var $7jh4K = parcelRequire("7jh4K");

var $6otAp = parcelRequire("6otAp");

var $6mTnI = parcelRequire("6mTnI");
function $43466d1bcd4520c8$export$151da384cc114748() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var keys;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).getKeys((0, $jTg9g.RECOVERY_STORE))
                    ];
                case 1:
                    keys = _state.sent();
                    return [
                        2,
                        keys.map(function(item) {
                            return +item;
                        })
                    ];
            }
        });
    })();
}
function $43466d1bcd4520c8$export$1fabc8133caf46e2() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).getKeys((0, $jTg9g.IMAGE_DATA_STORE))
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}
function $43466d1bcd4520c8$export$907f896f070645af() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var ids, recoveries;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).getKeys((0, $jTg9g.RECOVERY_STORE))
                    ];
                case 1:
                    ids = _state.sent();
                    return [
                        4,
                        Promise.all(ids.map(function(id) {
                            return (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.RECOVERY_STORE), id);
                        }))
                    ];
                case 2:
                    recoveries = _state.sent();
                    return [
                        4,
                        Promise.all(recoveries.map(function(recovery, index) {
                            if (recovery.timestamp < new Date().getTime() - (0, $6otAp.RECOVERY_AGE_LIMIT_MS)) return $43466d1bcd4520c8$export$9c7685b8d5826628(ids[index]);
                            return Promise.resolve();
                        }))
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $43466d1bcd4520c8$var$loadFromImageDataStore(id, commonCtx) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var result, image, e, _image_width, _image_height;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.IMAGE_DATA_STORE), id)
                    ];
                case 1:
                    result = _state.sent();
                    if (!result) {
                        commonCtx.clearRect(0, 0, (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE));
                        return [
                            2,
                            commonCtx.getImageData(0, 0, (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE))
                        ];
                    }
                    if (!(0, $7jh4K.isBlob)(result)) return [
                        3,
                        6
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        (0, $3hwQ7.loadImage)(result)
                    ];
                case 3:
                    image = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    commonCtx.canvas.width = (_image_width = image === null || image === void 0 ? void 0 : image.width) !== null && _image_width !== void 0 ? _image_width : commonCtx.canvas.width;
                    commonCtx.canvas.height = (_image_height = image === null || image === void 0 ? void 0 : image.height) !== null && _image_height !== void 0 ? _image_height : commonCtx.canvas.height;
                    // no clear needed, because size was set
                    image && commonCtx.drawImage(image, 0, 0);
                    return [
                        2,
                        commonCtx.getImageData(0, 0, commonCtx.canvas.width, commonCtx.canvas.height)
                    ];
                case 6:
                    return [
                        2,
                        result
                    ];
            }
        });
    })();
}
function $43466d1bcd4520c8$var$getRawRecoveryProject(id) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.RECOVERY_STORE), '' + id)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}
function $43466d1bcd4520c8$export$4484d7cddf79b0c1(candidateIds) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var imageDataIds, _tmp, usedIds, recoveryIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, id, raw, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, layer, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, tile, err, browserStorageRaw, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, layer1;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(candidateIds !== null && candidateIds !== void 0)) return [
                        3,
                        1
                    ];
                    _tmp = candidateIds;
                    return [
                        3,
                        3
                    ];
                case 1:
                    return [
                        4,
                        $43466d1bcd4520c8$export$1fabc8133caf46e2()
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    imageDataIds = _tmp;
                    usedIds = new Set();
                    return [
                        4,
                        $43466d1bcd4520c8$export$151da384cc114748()
                    ];
                case 4:
                    recoveryIds = _state.sent();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        10,
                        11,
                        12
                    ]);
                    _iterator = recoveryIds[Symbol.iterator]();
                    _state.label = 6;
                case 6:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        9
                    ];
                    id = _step.value;
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.RECOVERY_STORE), '' + id)
                    ];
                case 7:
                    raw = _state.sent();
                    if (!raw) return [
                        3,
                        8
                    ];
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = raw.layers[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            layer = _step1.value;
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(_iterator2 = layer.image[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    tile = _step2.value;
                                    if (!(0, $esGm2.isLayerFill)(tile)) usedIds.add(tile.id);
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    usedIds.add(raw.thumbnail);
                    _state.label = 8;
                case 8:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        6
                    ];
                case 9:
                    return [
                        3,
                        12
                    ];
                case 10:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 11:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 12:
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.BROWSER_STORAGE_STORE), 1)
                    ];
                case 13:
                    browserStorageRaw = _state.sent();
                    if (browserStorageRaw) {
                        if ((0, $6mTnI.isTImageDataReference)(browserStorageRaw.thumbnail)) usedIds.add(browserStorageRaw.thumbnail.id);
                        _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                        try {
                            for(_iterator3 = browserStorageRaw.layers[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                layer1 = _step3.value;
                                if ((0, $6mTnI.isTImageDataReference)(layer1.blob)) usedIds.add(layer1.blob.id);
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                    _iterator3.return();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                    // remove entries
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).bulkRemove((0, $jTg9g.IMAGE_DATA_STORE), imageDataIds.filter(function(id) {
                            return !usedIds.has(id);
                        }))
                    ];
                case 14:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $43466d1bcd4520c8$export$a6d4bfb7a7d18ef3(tabId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var raw, canvas, ctx, layers, _raw_projectId, _tmp;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.RECOVERY_STORE), '' + tabId)
                    ];
                case 1:
                    raw = _state.sent();
                    if (raw === undefined) return [
                        2,
                        undefined
                    ];
                    // shared canvas to load tiles
                    canvas = (0, $eWjiX.BB).canvas((0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE));
                    ctx = (0, $eWjiX.BB).ctx(canvas);
                    // speed up by loading in parallel
                    layers = [];
                    return [
                        4,
                        Promise.all(raw.layers.map(function(layerSerialized, index) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                var tiles, _$index, tile, _, _tmp;
                                return (0, $fk3zw._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            tiles = [];
                                            _$index = 0;
                                            _state.label = 1;
                                        case 1:
                                            if (!(_$index < layerSerialized.image.length)) return [
                                                3,
                                                5
                                            ];
                                            tile = layerSerialized.image[_$index];
                                            if (!(0, $esGm2.isLayerFill)(tile)) return [
                                                3,
                                                2
                                            ];
                                            tiles.push(tile);
                                            return [
                                                3,
                                                4
                                            ];
                                        case 2:
                                            _ = tiles.push;
                                            _tmp = {
                                                id: tile.id
                                            };
                                            return [
                                                4,
                                                $43466d1bcd4520c8$var$loadFromImageDataStore(tile.id, ctx)
                                            ];
                                        case 3:
                                            _.apply(tiles, [
                                                (_tmp.data = _state.sent(), _tmp)
                                            ]);
                                            _state.label = 4;
                                        case 4:
                                            _$index++;
                                            return [
                                                3,
                                                1
                                            ];
                                        case 5:
                                            layers[index] = (0, $4EWN2._)((0, $cL71g._)({}, layerSerialized), {
                                                image: tiles
                                            });
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }))
                    ];
                case 2:
                    _state.sent();
                    _tmp = {
                        project: {
                            projectId: (_raw_projectId = raw.projectId) !== null && _raw_projectId !== void 0 ? _raw_projectId : (0, $7jh4K.randomUuid)(),
                            width: raw.width,
                            height: raw.height,
                            layers: layers
                        },
                        timestamp: 0
                    };
                    return [
                        4,
                        $43466d1bcd4520c8$var$getThumbnail(raw.thumbnail)
                    ];
                case 3:
                    return [
                        2,
                        (_tmp.thumbnail = _state.sent(), _tmp)
                    ];
            }
        });
    })();
}
function $43466d1bcd4520c8$var$getThumbnail(id) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var canvas, ctx, imageData;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    canvas = (0, $eWjiX.BB).canvas((0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE));
                    ctx = (0, $eWjiX.BB).ctx(canvas);
                    return [
                        4,
                        $43466d1bcd4520c8$var$loadFromImageDataStore(id, ctx)
                    ];
                case 1:
                    imageData = _state.sent();
                    canvas.width = imageData.width;
                    canvas.height = imageData.height;
                    ctx.putImageData(imageData, 0, 0);
                    return [
                        2,
                        canvas
                    ];
            }
        });
    })();
}
function $43466d1bcd4520c8$export$896fee2a85b1fc93(oldId, newId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var storedProjectSerialized;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $43466d1bcd4520c8$var$getRawRecoveryProject(oldId)
                    ];
                case 1:
                    storedProjectSerialized = _state.sent();
                    if (!storedProjectSerialized) // nothing to do
                    return [
                        2,
                        false
                    ];
                    storedProjectSerialized.timestamp = new Date().getTime();
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).set((0, $jTg9g.RECOVERY_STORE), '' + newId, storedProjectSerialized)
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).remove((0, $jTg9g.RECOVERY_STORE), '' + oldId)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
            }
        });
    })();
}
function $43466d1bcd4520c8$export$b9ecabbf4820fa1b(tabId, composed, getThumbnail) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var orphanCandidates, fit, thumbCanvas, sortedComposedLayers, storedProjectSerialized, storedImageDataIds, storedImageDataSizes, idsFromProject, layers, imageDataList, memoryEstimateBytes, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step, err, thumbImageData, serialized, totalExceptDrawingBytes, overLimitByBytes, toBeRemovedBytes, idsToRemove, metas, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, id, err;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        ,
                        22,
                        24
                    ]);
                    // get thumbnail early to be accurate
                    fit = (0, $7jh4K.fitInto)(composed.size.width, composed.size.height, (0, $6otAp.RECOVERY_THUMB_WIDTH_PX), (0, $6otAp.RECOVERY_THUMB_HEIGHT_PX));
                    thumbCanvas = getThumbnail(fit.width / composed.size.width);
                    sortedComposedLayers = Object.values(composed.layerMap).sort((0, $7nLJW.sortLayerMap));
                    return [
                        4,
                        (0, $7jh4K.timeoutWrapper)($43466d1bcd4520c8$var$getRawRecoveryProject(tabId), 'storeRecovery.getRawRecoveryProject')
                    ];
                case 1:
                    storedProjectSerialized = _state.sent();
                    storedImageDataIds = new Set(storedProjectSerialized === null || storedProjectSerialized === void 0 ? void 0 : storedProjectSerialized.layers.flatMap(function(layer) {
                        return layer.image.map(function(tile) {
                            return !(0, $esGm2.isLayerFill)(tile) ? tile.id : undefined;
                        }).filter(function(id) {
                            return id !== undefined;
                        });
                    }));
                    storedProjectSerialized && storedImageDataIds.add(storedProjectSerialized.thumbnail);
                    // to help calculate updated memoryEstimateBytes
                    storedImageDataSizes = {};
                    storedProjectSerialized && storedProjectSerialized.layers.forEach(function(layer) {
                        layer.image.forEach(function(tile) {
                            if (!(0, $esGm2.isLayerFill)(tile)) storedImageDataSizes[tile.id] = tile.sizeBytes || 0;
                        });
                    });
                    // make a list of imageData ids in B (to be stored)
                    idsFromProject = new Set(sortedComposedLayers.flatMap(function(layer) {
                        return layer.tiles.flatMap(function(tile) {
                            return (0, $esGm2.isLayerFill)(tile) ? [] : [
                                tile.id
                            ];
                        });
                    }));
                    // the to delete list: not in B (aka no longer stored)
                    orphanCandidates = (0, $bX4ja._)(storedImageDataIds).filter(function(id) {
                        return !idsFromProject.has(id);
                    });
                    layers = [];
                    imageDataList = [];
                    // estimate memory
                    memoryEstimateBytes = 0;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _loop = function() {
                        var composedLayer, _, _tmp;
                        return (0, $fk3zw._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    composedLayer = _step.value;
                                    _ = layers.push;
                                    _tmp = {
                                        name: composedLayer.name,
                                        isVisible: composedLayer.isVisible,
                                        opacity: composedLayer.opacity,
                                        mixModeStr: composedLayer.mixModeStr
                                    };
                                    return [
                                        4,
                                        function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                                var result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, tile, size;
                                                return (0, $fk3zw._)(this, function(_state) {
                                                    result = [];
                                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                    try {
                                                        for(_iterator = composedLayer.tiles[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                            tile = _step.value;
                                                            if ((0, $esGm2.isLayerFill)(tile)) {
                                                                result.push(tile);
                                                                memoryEstimateBytes += tile.fill.length;
                                                            } else {
                                                                size = 0;
                                                                if (storedImageDataIds.has(tile.id)) size = storedImageDataSizes[tile.id];
                                                                else {
                                                                    imageDataList.push({
                                                                        id: tile.id,
                                                                        data: tile.data
                                                                    });
                                                                    size = tile.data.width * tile.data.height * 4; // 4 channels, each 1 byte
                                                                }
                                                                memoryEstimateBytes += size;
                                                                result.push({
                                                                    id: tile.id,
                                                                    sizeBytes: size
                                                                });
                                                            }
                                                        }
                                                    } catch (err) {
                                                        _didIteratorError = true;
                                                        _iteratorError = err;
                                                    } finally{
                                                        try {
                                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                                _iterator.return();
                                                            }
                                                        } finally{
                                                            if (_didIteratorError) {
                                                                throw _iteratorError;
                                                            }
                                                        }
                                                    }
                                                    return [
                                                        2,
                                                        result
                                                    ];
                                                });
                                            })();
                                        }()
                                    ];
                                case 1:
                                    _.apply(layers, [
                                        (_tmp.image = _state.sent(), _tmp)
                                    ]);
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    _iterator = sortedComposedLayers[Symbol.iterator]();
                    _state.label = 3;
                case 3:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        6
                    ];
                    return [
                        5,
                        (0, $2gUX3.__values)(_loop())
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 9:
                    thumbImageData = {
                        id: (0, $7jh4K.randomUuid)(),
                        data: function() {
                            var thumbCtx = (0, $eWjiX.BB).ctx(thumbCanvas);
                            return thumbCtx.getImageData(0, 0, thumbCanvas.width, thumbCanvas.height);
                        }()
                    };
                    imageDataList.push(thumbImageData);
                    memoryEstimateBytes += thumbImageData.data.width * thumbImageData.data.height * 4; // 4 channels, each 1 byte
                    serialized = {
                        projectId: composed.projectId.value,
                        width: composed.size.width,
                        height: composed.size.height,
                        timestamp: new Date().getTime(),
                        thumbnail: thumbImageData.id,
                        layers: layers,
                        memoryEstimateBytes: memoryEstimateBytes
                    };
                    return [
                        4,
                        (0, $7jh4K.timeoutWrapper)($43466d1bcd4520c8$var$getTotalMemoryExceptCurrentDrawing(tabId), 'storeRecovery.getTotalMemory')
                    ];
                case 10:
                    totalExceptDrawingBytes = _state.sent();
                    if (!(totalExceptDrawingBytes + memoryEstimateBytes > (0, $6otAp.RECOVERY_MEMORY_LIMIT_BYTES))) return [
                        3,
                        19
                    ];
                    overLimitByBytes = totalExceptDrawingBytes + memoryEstimateBytes - (0, $6otAp.RECOVERY_MEMORY_LIMIT_BYTES);
                    toBeRemovedBytes = 0;
                    idsToRemove = [];
                    return [
                        4,
                        $43466d1bcd4520c8$var$getAllMeta()
                    ];
                case 11:
                    metas = _state.sent().sort(function(a, b) {
                        if (a.timestamp > b.timestamp) return 1;
                        if (a.timestamp < b.timestamp) return -1;
                        return 0;
                    });
                    metas.forEach(function(meta) {
                        if (toBeRemovedBytes >= overLimitByBytes) // removed enough
                        return;
                        idsToRemove.push(meta.id);
                        toBeRemovedBytes += meta.memoryEstimateBytes;
                    });
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    _state.label = 12;
                case 12:
                    _state.trys.push([
                        12,
                        17,
                        18,
                        19
                    ]);
                    _iterator1 = idsToRemove[Symbol.iterator]();
                    _state.label = 13;
                case 13:
                    if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                        3,
                        16
                    ];
                    id = _step1.value;
                    return [
                        4,
                        $43466d1bcd4520c8$export$9c7685b8d5826628(id)
                    ];
                case 14:
                    _state.sent();
                    _state.label = 15;
                case 15:
                    _iteratorNormalCompletion1 = true;
                    return [
                        3,
                        13
                    ];
                case 16:
                    return [
                        3,
                        19
                    ];
                case 17:
                    err = _state.sent();
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                    return [
                        3,
                        19
                    ];
                case 18:
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                    return [
                        7
                    ];
                case 19:
                    // store first. so nothing will be lost if something goes wrong
                    return [
                        4,
                        (0, $7jh4K.timeoutWrapper)((0, $jTg9g.KL_INDEXED_DB).bulkSet((0, $jTg9g.IMAGE_DATA_STORE), imageDataList.map(function(item) {
                            return {
                                key: item.id,
                                value: item.data
                            };
                        })), 'storeRecovery.storeTile', 30000)
                    ];
                case 20:
                    _state.sent();
                    return [
                        4,
                        (0, $7jh4K.timeoutWrapper)((0, $jTg9g.KL_INDEXED_DB).set((0, $jTg9g.RECOVERY_STORE), '' + tabId, serialized), 'storeRecovery.storeRecovery')
                    ];
                case 21:
                    _state.sent();
                    return [
                        3,
                        24
                    ];
                case 22:
                    /*
        Orphaned tiles are possible and must be cleaned up, even if there's a timeout or other exception.
         */ return [
                        4,
                        (0, $7jh4K.timeoutWrapper)($43466d1bcd4520c8$export$4484d7cddf79b0c1(orphanCandidates), 'storeRecovery.removeOrphans', 8000)
                    ];
                case 23:
                    _state.sent();
                    return [
                        7
                    ];
                case 24:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $43466d1bcd4520c8$export$9c7685b8d5826628(id) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var recovery, orphanCandidates, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, layer, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, tile;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.RECOVERY_STORE), id)
                    ];
                case 1:
                    recovery = _state.sent();
                    if (!recovery) return [
                        2
                    ];
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).remove((0, $jTg9g.RECOVERY_STORE), id)
                    ];
                case 2:
                    _state.sent();
                    orphanCandidates = [
                        recovery.thumbnail
                    ];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = recovery.layers[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            layer = _step.value;
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(_iterator1 = layer.image[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    tile = _step1.value;
                                    if (!(0, $esGm2.isLayerFill)(tile)) orphanCandidates.push(tile.id);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // prevent deletion of tiles referenced by multiple recoveries.
                    return [
                        4,
                        $43466d1bcd4520c8$export$4484d7cddf79b0c1(orphanCandidates)
                    ];
                case 3:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $43466d1bcd4520c8$var$getAllMeta() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var ids, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, id, _, err;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $43466d1bcd4520c8$export$151da384cc114748()
                    ];
                case 1:
                    ids = _state.sent();
                    result = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _iterator = ids[Symbol.iterator]();
                    _state.label = 3;
                case 3:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        6
                    ];
                    id = _step.value;
                    _ = result.push;
                    return [
                        4,
                        $43466d1bcd4520c8$export$8548546c0aa631e6('' + id)
                    ];
                case 4:
                    _.apply(result, [
                        _state.sent()
                    ]);
                    _state.label = 5;
                case 5:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        result
                    ];
            }
        });
    })();
}
function $43466d1bcd4520c8$var$getTotalMemoryExceptCurrentDrawing(tabId) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var ids, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, id, meta, err;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        $43466d1bcd4520c8$export$151da384cc114748()
                    ];
                case 1:
                    ids = _state.sent();
                    result = 0;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        7,
                        8,
                        9
                    ]);
                    _iterator = ids[Symbol.iterator]();
                    _state.label = 3;
                case 3:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        6
                    ];
                    id = _step.value;
                    if (id === tabId) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        $43466d1bcd4520c8$export$8548546c0aa631e6('' + id)
                    ];
                case 4:
                    meta = _state.sent();
                    result += meta.memoryEstimateBytes;
                    _state.label = 5;
                case 5:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        3
                    ];
                case 6:
                    return [
                        3,
                        9
                    ];
                case 7:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        9
                    ];
                case 8:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 9:
                    return [
                        2,
                        result
                    ];
            }
        });
    })();
}
function $43466d1bcd4520c8$export$8548546c0aa631e6(drawingId, includeThumbnail) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var raw, parsed, _tmp, _tmp1;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.RECOVERY_STORE), drawingId)
                    ];
                case 1:
                    raw = _state.sent();
                    if (raw === undefined) throw new Error('drawing not found');
                    parsed = raw;
                    _tmp = {
                        id: drawingId,
                        width: parsed.width,
                        height: parsed.height
                    };
                    if (!includeThumbnail) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $43466d1bcd4520c8$var$getThumbnail(parsed.thumbnail)
                    ];
                case 2:
                    _tmp1 = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    _tmp1 = undefined;
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        (_tmp.thumbnail = _tmp1, _tmp.timestamp = parsed.timestamp, _tmp.memoryEstimateBytes = parsed.memoryEstimateBytes, _tmp)
                    ];
            }
        });
    })();
}

});
parcelRegister("2gUX3", function(module, exports) {

$parcel$export(module.exports, "__values", function () { return $1a7940c44f23ed27$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $1a7940c44f23ed27$var$extendStatics = function extendStatics1(d, b) {
    $1a7940c44f23ed27$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1a7940c44f23ed27$var$extendStatics(d, b);
};
function $1a7940c44f23ed27$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1a7940c44f23ed27$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1a7940c44f23ed27$export$18ce0697a983be9b = function __assign1() {
    $1a7940c44f23ed27$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1a7940c44f23ed27$export$18ce0697a983be9b.apply(this, arguments);
};
function $1a7940c44f23ed27$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1a7940c44f23ed27$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1a7940c44f23ed27$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1a7940c44f23ed27$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1a7940c44f23ed27$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1a7940c44f23ed27$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $1a7940c44f23ed27$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1a7940c44f23ed27$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1a7940c44f23ed27$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1a7940c44f23ed27$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1a7940c44f23ed27$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1a7940c44f23ed27$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1a7940c44f23ed27$export$45d3717a4c69092e(o, m, p);
}
function $1a7940c44f23ed27$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1a7940c44f23ed27$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1a7940c44f23ed27$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1a7940c44f23ed27$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1a7940c44f23ed27$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1a7940c44f23ed27$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1a7940c44f23ed27$export$10c90e4f7922046c(v) {
    return this instanceof $1a7940c44f23ed27$export$10c90e4f7922046c ? (this.v = v, this) : new $1a7940c44f23ed27$export$10c90e4f7922046c(v);
}
function $1a7940c44f23ed27$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1a7940c44f23ed27$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1a7940c44f23ed27$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1a7940c44f23ed27$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1a7940c44f23ed27$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1a7940c44f23ed27$export$19a8beecd37a4c45 === "function" ? $1a7940c44f23ed27$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1a7940c44f23ed27$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1a7940c44f23ed27$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $1a7940c44f23ed27$var$ownKeys = function ownKeys1(o) {
    $1a7940c44f23ed27$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $1a7940c44f23ed27$var$ownKeys(o);
};
function $1a7940c44f23ed27$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $1a7940c44f23ed27$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $1a7940c44f23ed27$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $1a7940c44f23ed27$var$__setModuleDefault(result, mod);
    return result;
}
function $1a7940c44f23ed27$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1a7940c44f23ed27$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1a7940c44f23ed27$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1a7940c44f23ed27$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $1a7940c44f23ed27$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $1a7940c44f23ed27$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $1a7940c44f23ed27$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $1a7940c44f23ed27$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $1a7940c44f23ed27$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $1a7940c44f23ed27$export$2e2bcd8739ae039 = {
    __extends: $1a7940c44f23ed27$export$a8ba968b8961cb8a,
    __assign: $1a7940c44f23ed27$export$18ce0697a983be9b,
    __rest: $1a7940c44f23ed27$export$3c9a16f847548506,
    __decorate: $1a7940c44f23ed27$export$29e00dfd3077644b,
    __param: $1a7940c44f23ed27$export$d5ad3fd78186038f,
    __esDecorate: $1a7940c44f23ed27$export$3a84e1ae4e97e9b0,
    __runInitializers: $1a7940c44f23ed27$export$d831c04e792af3d,
    __propKey: $1a7940c44f23ed27$export$6a2a36740a146cb8,
    __setFunctionName: $1a7940c44f23ed27$export$d1a06452d3489bc7,
    __metadata: $1a7940c44f23ed27$export$f1db080c865becb9,
    __awaiter: $1a7940c44f23ed27$export$1050f835b63b671e,
    __generator: $1a7940c44f23ed27$export$67ebef60e6f28a6,
    __createBinding: $1a7940c44f23ed27$export$45d3717a4c69092e,
    __exportStar: $1a7940c44f23ed27$export$f33643c0debef087,
    __values: $1a7940c44f23ed27$export$19a8beecd37a4c45,
    __read: $1a7940c44f23ed27$export$8d051b38c9118094,
    __spread: $1a7940c44f23ed27$export$afc72e2116322959,
    __spreadArrays: $1a7940c44f23ed27$export$6388937ca91ccae8,
    __spreadArray: $1a7940c44f23ed27$export$1216008129fb82ed,
    __await: $1a7940c44f23ed27$export$10c90e4f7922046c,
    __asyncGenerator: $1a7940c44f23ed27$export$e427f37a30a4de9b,
    __asyncDelegator: $1a7940c44f23ed27$export$bbd80228419bb833,
    __asyncValues: $1a7940c44f23ed27$export$e3b29a3d6162315f,
    __makeTemplateObject: $1a7940c44f23ed27$export$4fb47efe1390b86f,
    __importStar: $1a7940c44f23ed27$export$c21735bcef00d192,
    __importDefault: $1a7940c44f23ed27$export$da59b14a69baef04,
    __classPrivateFieldGet: $1a7940c44f23ed27$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $1a7940c44f23ed27$export$d40a35129aaff81f,
    __classPrivateFieldIn: $1a7940c44f23ed27$export$81fdc39f203e4e04,
    __addDisposableResource: $1a7940c44f23ed27$export$88ac25d8e944e405,
    __disposeResources: $1a7940c44f23ed27$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $1a7940c44f23ed27$export$889dfb5d17574b0b
};

});

parcelRegister("jTg9g", function(module, exports) {

$parcel$export(module.exports, "getKlIndexedDbName", function () { return $3a4b444728a0f049$export$620c18ffd80459f1; });
$parcel$export(module.exports, "RECOVERY_STORE", function () { return $3a4b444728a0f049$export$aa8c311c20a0e91f; });
$parcel$export(module.exports, "IMAGE_DATA_STORE", function () { return $3a4b444728a0f049$export$ca20f3c4ac3fef1e; });
$parcel$export(module.exports, "BROWSER_STORAGE_STORE", function () { return $3a4b444728a0f049$export$2ca9aea562746b89; });
$parcel$export(module.exports, "KL_INDEXED_DB_STORES", function () { return $3a4b444728a0f049$export$94f2205ed1af0024; });
$parcel$export(module.exports, "KL_INDEXED_DB_VERSION", function () { return $3a4b444728a0f049$export$889f6d04a9c72786; });
$parcel$export(module.exports, "KL_INDEXED_DB_UPGRADER", function () { return $3a4b444728a0f049$export$a11d3f631bfac1e6; });
$parcel$export(module.exports, "KL_INDEXED_DB", function () { return $3a4b444728a0f049$export$8d693ea241b9d9a6; });

var $hzsIx = parcelRequire("hzsIx");
var $3a4b444728a0f049$var$dbName = 'Klecks';
function $3a4b444728a0f049$export$d21786ffb58aa58a(name) {
    $3a4b444728a0f049$var$dbName = name;
}
function $3a4b444728a0f049$export$620c18ffd80459f1() {
    return $3a4b444728a0f049$var$dbName;
}
var $3a4b444728a0f049$export$aa8c311c20a0e91f = 'RecoveryStore'; // key is string
var $3a4b444728a0f049$export$ca20f3c4ac3fef1e = 'ImageDataStore'; // key is string
var $3a4b444728a0f049$export$2ca9aea562746b89 = 'ProjectStore'; // key is number
var $3a4b444728a0f049$export$94f2205ed1af0024 = [
    $3a4b444728a0f049$export$aa8c311c20a0e91f,
    $3a4b444728a0f049$export$ca20f3c4ac3fef1e,
    $3a4b444728a0f049$export$2ca9aea562746b89
];
var $3a4b444728a0f049$export$889f6d04a9c72786 = 2;
var $3a4b444728a0f049$export$a11d3f631bfac1e6 = function(event) {
    var oldVersion = event.oldVersion;
    var db = event.target.result;
    if (oldVersion < 1) {
        var store = db.createObjectStore($3a4b444728a0f049$export$2ca9aea562746b89, {
            keyPath: 'id'
        });
        store.createIndex('id', 'id', {
            unique: true
        });
    }
    if (oldVersion < 2) {
        db.createObjectStore($3a4b444728a0f049$export$ca20f3c4ac3fef1e);
        db.createObjectStore($3a4b444728a0f049$export$aa8c311c20a0e91f);
    }
};
var $3a4b444728a0f049$export$8d693ea241b9d9a6 = new (0, $hzsIx.IndexedDb)({});

});
parcelRegister("hzsIx", function(module, exports) {

$parcel$export(module.exports, "IndexedDb", function () { return $328c5a6a1a43a329$export$7d13d7c63364db4b; });

var $1LaJZ = parcelRequire("1LaJZ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $bX4ja = parcelRequire("bX4ja");

var $fk3zw = parcelRequire("fk3zw");

var $7jh4K = parcelRequire("7jh4K");
// 2025-05-20
// Blobs not supported on iPad in private tabs.
// Blobs are required for indexed db to be useful. Data urls would be wasteful.
var $328c5a6a1a43a329$var$areBlobUrlsSupported = function areBlobUrlsSupported() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var result, dbName, blob, db, e;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = true;
                    dbName = 'kl-blob-url-test';
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    blob = new Blob([
                        'test'
                    ], {
                        type: 'text/plain'
                    });
                    return [
                        4,
                        (0, $7jh4K.timeoutWrapper)(new Promise(function(resolve, reject) {
                            var request = indexedDB.open(dbName, 1);
                            request.onerror = function() {
                                return reject(request.error);
                            };
                            request.onsuccess = function() {
                                return resolve(request.result);
                            };
                            request.onupgradeneeded = function(event) {
                                var db = event.target.result;
                                db.createObjectStore('testStore');
                            };
                        }), 'areBlobUrlsSupported.createDb')
                    ];
                case 2:
                    db = _state.sent();
                    return [
                        4,
                        (0, $7jh4K.timeoutWrapper)(new Promise(function(resolve, reject) {
                            var transaction = db.transaction('testStore', 'readwrite');
                            var store = transaction.objectStore('testStore');
                            var request = store.put(blob, 'testStore');
                            transaction.onabort = function() {
                                return resolve();
                            };
                            request.onsuccess = function() {
                                return resolve();
                            };
                            request.onerror = function() {
                                return reject(request.error);
                            };
                        }), 'areBlobUrlsSupported.storeBlob')
                    ];
                case 3:
                    _state.sent();
                    db.close();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    result = false;
                    return [
                        3,
                        5
                    ];
                case 5:
                    try {
                        indexedDB.deleteDatabase(dbName);
                    } catch (e) {
                    // IDBFactory.deleteDatabase() called in an invalid security context
                    }
                    return [
                        2,
                        result
                    ];
            }
        });
    })();
};
var $328c5a6a1a43a329$export$7d13d7c63364db4b = /*#__PURE__*/ function() {
    "use strict";
    function IndexedDb(p) {
        (0, $cx0mh._)(this, IndexedDb);
        this.dbVersion = -1;
        this.dbName = '';
        this.storeNames = [];
        this.upgrader = function() {};
        this.isAvailable = true;
        this.openTransactionCount = 0;
    }
    (0, $7h4XF._)(IndexedDb, [
        {
            key: "disconnect",
            value: function disconnect() {
                var _this_db;
                (_this_db = this.db) === null || _this_db === void 0 ? void 0 : _this_db.close();
                this.db = undefined;
            }
        },
        {
            key: "autoDisconnectWrapper",
            value: function autoDisconnectWrapper(activity) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    3,
                                    4
                                ]);
                                this.openTransactionCount++;
                                clearTimeout(this.disconnectTimeout);
                                return [
                                    4,
                                    activity()
                                ];
                            case 2:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 3:
                                this.openTransactionCount--;
                                if (this.openTransactionCount === 0) {
                                    // When a new version of the app upgrades the DB, old tabs holding open connections would
                                    // block the upgrade.
                                    // -> Close DB connections when inactive.
                                    clearTimeout(this.disconnectTimeout);
                                    this.disconnectTimeout = setTimeout(function() {
                                        return _this.disconnect();
                                    }, 1000);
                                }
                                return [
                                    7
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "openDb",
            value: function openDb() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this;
                    return (0, $fk3zw._)(this, function(_state) {
                        _this = this;
                        if (this.db) return [
                            2
                        ];
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var request = indexedDB.open(_this.dbName, _this.dbVersion);
                                request.onupgradeneeded = function(event) {
                                    _this.upgrader(event);
                                };
                                request.onsuccess = function(event) {
                                    _this.db = event.target.result;
                                    _this.db.onversionchange = function() {
                                        _this.isAvailable = false;
                                        _this.disconnect();
                                        throw new Error('idb onversionchange');
                                    };
                                    resolve();
                                };
                                request.onerror = function(event) {
                                    _this.isAvailable = false;
                                    reject(event.target.error);
                                };
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getTransaction",
            value: function getTransaction(storeName, mode) {
                if (!this.storeNames.includes(storeName)) throw new Error(`indexedDb store "${storeName}" not found in "${this.dbName}"`);
                var transaction = this.db.transaction(storeName, mode);
                return {
                    transaction: transaction,
                    objectStore: transaction.objectStore(storeName)
                };
            }
        },
        {
            key: "init",
            value: function init(dbName, objectStoreNames, version, upgrader) {
                if (this.dbName !== '') throw new Error('IndexedDb already initialized');
                this.dbName = dbName;
                this.storeNames = (0, $bX4ja._)(objectStoreNames);
                this.dbVersion = version;
                this.upgrader = upgrader;
            }
        },
        {
            key: "testConnection",
            value: function testConnection() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _, _tmp, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, name, transaction, err, e;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ = this;
                                _tmp = this.isAvailable;
                                if (!_tmp) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    $328c5a6a1a43a329$var$areBlobUrlsSupported()
                                ];
                            case 1:
                                _tmp = _state.sent();
                                _state.label = 2;
                            case 2:
                                _.isAvailable = _tmp;
                                if (!this.isAvailable) return [
                                    2,
                                    this.isAvailable
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    12,
                                    ,
                                    13
                                ]);
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    9,
                                    10,
                                    11
                                ]);
                                _iterator = this.storeNames[Symbol.iterator]();
                                _state.label = 5;
                            case 5:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    8
                                ];
                                name = _step.value;
                                return [
                                    4,
                                    (0, $7jh4K.timeoutWrapper)(this.openDb(), 'indexed-db.testConnection.openDb')
                                ];
                            case 6:
                                _state.sent();
                                transaction = this.getTransaction(name, 'readonly').transaction;
                                transaction.abort();
                                _state.label = 7;
                            case 7:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    5
                                ];
                            case 8:
                                return [
                                    3,
                                    11
                                ];
                            case 9:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    11
                                ];
                            case 10:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    3,
                                    13
                                ];
                            case 12:
                                e = _state.sent();
                                this.isAvailable = false;
                                return [
                                    3,
                                    13
                                ];
                            case 13:
                                return [
                                    2,
                                    this.isAvailable
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "set",
            value: function set(store, key, value) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this;
                    return (0, $fk3zw._)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            this.autoDisconnectWrapper(function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                    var _this;
                                    return (0, $fk3zw._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this = this;
                                                return [
                                                    4,
                                                    this.openDb()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    4,
                                                    new Promise(function(resolve, reject) {
                                                        var _this_getTransaction = _this.getTransaction(store, 'readwrite'), transaction = _this_getTransaction.transaction, objectStore = _this_getTransaction.objectStore;
                                                        transaction.onabort = function() {
                                                            return reject(transaction.error);
                                                        };
                                                        var request = objectStore.put(value, key);
                                                        request.onsuccess = function() {
                                                            resolve();
                                                        };
                                                        request.onerror = function() {
                                                            return reject(request.error);
                                                        };
                                                    })
                                                ];
                                            case 2:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                }).call(_this);
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "get",
            value: function get(store, key) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this;
                    return (0, $fk3zw._)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            this.autoDisconnectWrapper(function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                    var _this;
                                    return (0, $fk3zw._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this = this;
                                                return [
                                                    4,
                                                    this.openDb()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    4,
                                                    new Promise(function(resolve, reject) {
                                                        var _this_getTransaction = _this.getTransaction(store, 'readonly'), transaction = _this_getTransaction.transaction, objectStore = _this_getTransaction.objectStore;
                                                        transaction.onabort = function() {
                                                            return reject(transaction.error);
                                                        };
                                                        var request = objectStore.get(key);
                                                        request.onsuccess = function() {
                                                            return resolve(request.result);
                                                        };
                                                        request.onerror = function() {
                                                            return reject(request.error);
                                                        };
                                                    })
                                                ];
                                            case 2:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                }).call(_this);
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "has",
            value: function has(store, key) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this;
                    return (0, $fk3zw._)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            this.autoDisconnectWrapper(function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                    var _this;
                                    return (0, $fk3zw._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this = this;
                                                return [
                                                    4,
                                                    this.openDb()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    4,
                                                    new Promise(function(resolve, reject) {
                                                        var _this_getTransaction = _this.getTransaction(store, 'readonly'), transaction = _this_getTransaction.transaction, objectStore = _this_getTransaction.objectStore;
                                                        transaction.onabort = function() {
                                                            return reject(transaction.error);
                                                        };
                                                        var request = objectStore.getKey(key);
                                                        request.onsuccess = function() {
                                                            return resolve(!!request.result);
                                                        };
                                                        request.onerror = function() {
                                                            return reject(request.error);
                                                        };
                                                    })
                                                ];
                                            case 2:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                }).call(_this);
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getKeys",
            value: function getKeys(store) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this;
                    return (0, $fk3zw._)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            this.autoDisconnectWrapper(function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                    var _this;
                                    return (0, $fk3zw._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this = this;
                                                return [
                                                    4,
                                                    this.openDb()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    4,
                                                    new Promise(function(resolve, reject) {
                                                        var _this_getTransaction = _this.getTransaction(store, 'readonly'), transaction = _this_getTransaction.transaction, objectStore = _this_getTransaction.objectStore;
                                                        transaction.onabort = function() {
                                                            return reject(transaction.error);
                                                        };
                                                        var request = objectStore.getAllKeys();
                                                        request.onsuccess = function() {
                                                            return resolve(request.result.map(function(key) {
                                                                return key.toString();
                                                            }));
                                                        };
                                                        request.onerror = function() {
                                                            return reject(request.error);
                                                        };
                                                    })
                                                ];
                                            case 2:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                }).call(_this);
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "remove",
            value: function remove(store, key) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this;
                    return (0, $fk3zw._)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            this.autoDisconnectWrapper(function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                    var _this;
                                    return (0, $fk3zw._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this = this;
                                                return [
                                                    4,
                                                    this.openDb()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    4,
                                                    new Promise(function(resolve, reject) {
                                                        var _this_getTransaction = _this.getTransaction(store, 'readwrite'), transaction = _this_getTransaction.transaction, objectStore = _this_getTransaction.objectStore;
                                                        transaction.onabort = function() {
                                                            return reject(transaction.error);
                                                        };
                                                        var request = objectStore.delete(key);
                                                        request.onsuccess = function() {
                                                            resolve();
                                                        };
                                                        request.onerror = function() {
                                                            return reject(request.error);
                                                        };
                                                    })
                                                ];
                                            case 2:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                }).call(_this);
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "bulkSet",
            value: function bulkSet(store, entries) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this;
                    return (0, $fk3zw._)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            this.autoDisconnectWrapper(function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                    var _this;
                                    return (0, $fk3zw._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this = this;
                                                return [
                                                    4,
                                                    this.openDb()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2,
                                                    new Promise(function(resolve, reject) {
                                                        var _this_getTransaction = _this.getTransaction(store, 'readwrite'), transaction = _this_getTransaction.transaction, objectStore = _this_getTransaction.objectStore;
                                                        transaction.onabort = function() {
                                                            return reject(transaction.error);
                                                        };
                                                        transaction.onerror = function() {
                                                            return reject(transaction.error);
                                                        };
                                                        transaction.oncomplete = function() {
                                                            return resolve();
                                                        };
                                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                        try {
                                                            var _loop = function() {
                                                                var _step_value = _step.value, key = _step_value.key, value = _step_value.value;
                                                                var request = objectStore.put(value, key);
                                                                request.onerror = function() {
                                                                    return reject(request.error);
                                                                };
                                                            };
                                                            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                                                        } catch (err) {
                                                            _didIteratorError = true;
                                                            _iteratorError = err;
                                                        } finally{
                                                            try {
                                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                                    _iterator.return();
                                                                }
                                                            } finally{
                                                                if (_didIteratorError) {
                                                                    throw _iteratorError;
                                                                }
                                                            }
                                                        }
                                                    })
                                                ];
                                        }
                                    });
                                }).call(_this);
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "bulkGet",
            value: function bulkGet(store, keys) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this;
                    return (0, $fk3zw._)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            this.autoDisconnectWrapper(function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                    var _this;
                                    return (0, $fk3zw._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this = this;
                                                return [
                                                    4,
                                                    this.openDb()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2,
                                                    new Promise(function(resolve, reject) {
                                                        var results = {};
                                                        var _this_getTransaction = _this.getTransaction(store, 'readonly'), transaction = _this_getTransaction.transaction, objectStore = _this_getTransaction.objectStore;
                                                        transaction.onabort = function() {
                                                            return reject(transaction.error);
                                                        };
                                                        transaction.onerror = function() {
                                                            return reject(transaction.error);
                                                        };
                                                        transaction.oncomplete = function() {
                                                            return resolve(results);
                                                        };
                                                        keys.forEach(function(key, idx) {
                                                            var request = objectStore.get(key);
                                                            request.onsuccess = function() {
                                                                return results['' + key] = request.result;
                                                            };
                                                            request.onerror = function() {
                                                                return reject(request.error);
                                                            };
                                                        });
                                                    })
                                                ];
                                        }
                                    });
                                }).call(_this);
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "bulkRemove",
            value: function bulkRemove(store, keys) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this;
                    return (0, $fk3zw._)(this, function(_state) {
                        _this = this;
                        return [
                            2,
                            this.autoDisconnectWrapper(function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                    var _this;
                                    return (0, $fk3zw._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this = this;
                                                return [
                                                    4,
                                                    this.openDb()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    2,
                                                    new Promise(function(resolve, reject) {
                                                        var _this_getTransaction = _this.getTransaction(store, 'readwrite'), transaction = _this_getTransaction.transaction, objectStore = _this_getTransaction.objectStore;
                                                        transaction.onabort = function() {
                                                            return reject(transaction.error);
                                                        };
                                                        transaction.onerror = function() {
                                                            return reject(transaction.error);
                                                        };
                                                        transaction.oncomplete = function() {
                                                            return resolve();
                                                        };
                                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                                        try {
                                                            var _loop = function() {
                                                                var key = _step.value;
                                                                var request = objectStore.delete(key);
                                                                request.onerror = function() {
                                                                    return reject(request.error);
                                                                };
                                                            };
                                                            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                                                        } catch (err) {
                                                            _didIteratorError = true;
                                                            _iteratorError = err;
                                                        } finally{
                                                            try {
                                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                                    _iterator.return();
                                                                }
                                                            } finally{
                                                                if (_didIteratorError) {
                                                                    throw _iteratorError;
                                                                }
                                                            }
                                                        }
                                                    })
                                                ];
                                        }
                                    });
                                }).call(_this);
                            })
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getIsAvailable",
            value: function getIsAvailable() {
                return this.isAvailable;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.disconnect();
            }
        }
    ]);
    return IndexedDb;
}();

});


parcelRegister("3hwQ7", function(module, exports) {

$parcel$export(module.exports, "PROJECT_STORE_THUMBNAIL_SIZE_PX", function () { return $3ee249752703e788$export$f14c2a28fc1e9841; });
$parcel$export(module.exports, "loadImage", function () { return $3ee249752703e788$export$fe58198efe02b173; });
$parcel$export(module.exports, "ProjectConverter", function () { return $3ee249752703e788$export$f3c1ac6650038646; });

var $1LaJZ = parcelRequire("1LaJZ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $fk3zw = parcelRequire("fk3zw");

var $eWjiX = parcelRequire("eWjiX");

var $aSJRf = parcelRequire("aSJRf");

var $eIcQa = parcelRequire("eIcQa");
var $3ee249752703e788$export$f14c2a28fc1e9841 = 240;
function $3ee249752703e788$export$fe58198efe02b173(blob) {
    return new Promise(function(resolve, reject) {
        var im = new Image();
        try {
            im.src = (0, $eWjiX.BB).imageBlobToUrl(blob);
        } catch (e) {
            reject('imageBlobToUrl, ' + (e instanceof Error ? e.message : ''));
            return;
        }
        im.onload = function() {
            URL.revokeObjectURL(im.src);
            resolve(im);
        };
        im.onabort = function() {
            URL.revokeObjectURL(im.src);
            reject('layer image failed loading (abort)');
        };
        // This does occur. Maybe decoder runs of memory or storage corruption.
        im.onerror = function() {
            URL.revokeObjectURL(im.src);
            reject('layer image failed loading (error)');
        };
    });
}
var $3ee249752703e788$export$f3c1ac6650038646 = /*#__PURE__*/ function() {
    "use strict";
    function ProjectConverter() {
        (0, $cx0mh._)(this, ProjectConverter);
    }
    (0, $7h4XF._)(ProjectConverter, null, [
        {
            key: "createThumbnail",
            value: function createThumbnail(project) {
                var size = (0, $eWjiX.BB).fitInto(project.width, project.height, $3ee249752703e788$export$f14c2a28fc1e9841, $3ee249752703e788$export$f14c2a28fc1e9841);
                var factor = size.width / project.width;
                return (0, $aSJRf.drawProject)(project, factor);
            }
        },
        {
            key: "createStorageProject",
            value: function createStorageProject(project) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var layers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, blob, _item_mixModeStr, err, _tmp;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                layers = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator = project.layers[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    7
                                ];
                                item = _step.value;
                                blob = void 0;
                                if (!(item.image instanceof HTMLCanvasElement)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    (0, $eIcQa.canvasToBlob)(item.image, 'image/png')
                                ];
                            case 3:
                                blob = _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                // todo image
                                throw new Error('Not implemented');
                            case 5:
                                layers.push({
                                    name: item.name,
                                    isVisible: item.isVisible,
                                    opacity: item.opacity,
                                    mixModeStr: (_item_mixModeStr = item.mixModeStr) !== null && _item_mixModeStr !== void 0 ? _item_mixModeStr : 'source-over',
                                    blob: blob
                                });
                                _state.label = 6;
                            case 6:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                _tmp = {
                                    id: 1,
                                    projectId: project.projectId,
                                    timestamp: new Date().getTime()
                                };
                                return [
                                    4,
                                    (0, $eIcQa.canvasToBlob)(ProjectConverter.createThumbnail(project), 'image/png')
                                ];
                            case 11:
                                return [
                                    2,
                                    (_tmp.thumbnail = _state.sent(), _tmp.width = project.width, _tmp.height = project.height, _tmp.layers = layers, _tmp)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "readStorageProject",
            value: function readStorageProject(storageProject) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var project, _tmp, _tmp1;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!storageProject.width || !storageProject.height || isNaN(storageProject.width) || isNaN(storageProject.height) || storageProject.width < 1 || storageProject.height < 1) throw new Error('readStorageProject invalid canvas size: ' + storageProject.width + ', ' + storageProject.height);
                                _tmp = {
                                    projectId: storageProject.projectId,
                                    width: storageProject.width,
                                    height: storageProject.height
                                };
                                return [
                                    4,
                                    Promise.all(storageProject.layers.map(function(layer) {
                                        if (layer.blob) return $3ee249752703e788$export$fe58198efe02b173(layer.blob).catch(function() {
                                            return new Image(storageProject.width, storageProject.height);
                                        });
                                        return new Image(storageProject.width, storageProject.height);
                                    }))
                                ];
                            case 1:
                                project = (_tmp.layers = _state.sent().map(function(image, i) {
                                    var storageLayer = storageProject.layers[i];
                                    return {
                                        name: storageLayer.name,
                                        isVisible: storageLayer.isVisible,
                                        opacity: storageLayer.opacity,
                                        mixModeStr: storageLayer.mixModeStr,
                                        image: image
                                    };
                                }), _tmp);
                                _tmp1 = {
                                    project: project,
                                    timestamp: storageProject.timestamp
                                };
                                return [
                                    4,
                                    $3ee249752703e788$export$fe58198efe02b173(storageProject.thumbnail).catch(function() {
                                        return new Image($3ee249752703e788$export$f14c2a28fc1e9841, $3ee249752703e788$export$f14c2a28fc1e9841);
                                    })
                                ];
                            case 2:
                                return [
                                    2,
                                    (_tmp1.thumbnail = _state.sent(), _tmp1)
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "readStorageMeta",
            value: function readStorageMeta(rawMeta) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _tmp, _tmp1;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _tmp = {
                                    projectId: rawMeta.projectId,
                                    timestamp: rawMeta.timestamp
                                };
                                if (!rawMeta.thumbnail) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    $3ee249752703e788$export$fe58198efe02b173(rawMeta.thumbnail).catch(function() {
                                        return new Image($3ee249752703e788$export$f14c2a28fc1e9841, $3ee249752703e788$export$f14c2a28fc1e9841);
                                    })
                                ];
                            case 1:
                                _tmp1 = _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                _tmp1 = (0, $eWjiX.BB).canvas(10, 10);
                                _state.label = 3;
                            case 3:
                                return [
                                    2,
                                    (_tmp.thumbnail = _tmp1, _tmp)
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ProjectConverter;
}();

});
parcelRegister("aSJRf", function(module, exports) {

$parcel$export(module.exports, "drawProject", function () { return $089586a542a12f27$export$5f63a7b18dc4503a; });

var $eWjiX = parcelRequire("eWjiX");

var $esGm2 = parcelRequire("esGm2");

var $bbA6w = parcelRequire("bbA6w");
parcelRequire("ciAU9");
var $kFecW = parcelRequire("kFecW");

var $9b3eo = parcelRequire("9b3eo");
function $089586a542a12f27$export$5f63a7b18dc4503a(project, factor, selection) {
    var resultCanvas = (0, $eWjiX.BB).canvas(Math.max(1, Math.round(project.width * factor)), Math.max(1, Math.round(project.height * factor)));
    var transformedSelection = selection ? (0, $bbA6w.transformMultiPolygon)(selection, (0, $kFecW.scale)(resultCanvas.width / project.width, resultCanvas.height / project.height)) : undefined;
    var ctx = (0, $eWjiX.BB).ctx(resultCanvas);
    ctx.save();
    if (transformedSelection) ctx.clip((0, $9b3eo.getSelectionPath2d)(transformedSelection));
    if (factor > 1) ctx.imageSmoothingEnabled = false;
    for(var i = 0; i < project.layers.length; i++){
        var layer = project.layers[i];
        if (!layer.isVisible || layer.opacity === 0) continue;
        ctx.globalAlpha = layer.opacity;
        var mixModeStr = layer.mixModeStr;
        ctx.globalCompositeOperation = mixModeStr !== undefined ? mixModeStr : 'source-over';
        if ((0, $esGm2.isLayerFill)(layer.image)) {
            ctx.fillStyle = layer.image.fill;
            ctx.fillRect(0, 0, resultCanvas.width, resultCanvas.height);
        } else if (layer.image instanceof Array) throw new Error('not implemented');
        else ctx.drawImage(layer.image, 0, 0, resultCanvas.width, resultCanvas.height);
    }
    ctx.restore();
    return resultCanvas;
}

});
parcelRegister("esGm2", function(module, exports) {

$parcel$export(module.exports, "isLayerFill", function () { return $46d40330d7c8c76e$export$dba0834b723f37f4; });
function $46d40330d7c8c76e$export$dba0834b723f37f4(obj) {
    return typeof obj === 'object' && obj !== null && 'fill' in obj && typeof obj.fill === 'string';
}

});

parcelRegister("bbA6w", function(module, exports) {

$parcel$export(module.exports, "transformMultiPolygon", function () { return $a60208d5de6d28fa$export$aa391dbbf8073422; });
parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
function $a60208d5de6d28fa$export$aa391dbbf8073422(multiPolygon, transform) {
    return multiPolygon.map(function(poly) {
        return poly.map(function(ring) {
            return ring.map(function(point) {
                return Object.values((0, $cdZRx.applyToPoint)(transform, {
                    x: point[0],
                    y: point[1]
                }));
            });
        });
    });
}

});
parcelRegister("ciAU9", function(module, exports) {
$parcel$export(module.exports, "applyToPoint", function () { return (parcelRequire("cdZRx")).applyToPoint; });
$parcel$export(module.exports, "identity", function () { return (parcelRequire("83Kse")).identity; });
$parcel$export(module.exports, "inverse", function () { return (parcelRequire("kDVZW")).inverse; });
$parcel$export(module.exports, "rotate", function () { return (parcelRequire("1RMPr")).rotate; });
$parcel$export(module.exports, "scale", function () { return (parcelRequire("kFecW")).scale; });
$parcel$export(module.exports, "compose", function () { return (parcelRequire("dZ59l")).compose; });
$parcel$export(module.exports, "translate", function () { return (parcelRequire("kr2fR")).translate; });
parcelRequire("cdZRx");
parcelRequire("3wE7v");
parcelRequire("btdnM");
parcelRequire("83Kse");
parcelRequire("kDVZW");
parcelRequire("lNvMw");
parcelRequire("1RMPr");
parcelRequire("kFecW");
parcelRequire("8jtBQ");
parcelRequire("ibhub");
parcelRequire("2mZ9s");
parcelRequire("dZ59l");
parcelRequire("kr2fR");
parcelRequire("5687o");
parcelRequire("eP59S");
parcelRequire("i0iB3");
parcelRequire("ag5pW");
parcelRequire("gvDD3");
parcelRequire("4JElo");
parcelRequire("90Qul");

});
parcelRegister("cdZRx", function(module, exports) {

$parcel$export(module.exports, "applyToPoint", function () { return $8e66af8d07a896cb$export$9b20165a36586806; });
/**
 * Calculate a point transformed with an affine matrix
 * @param matrix {Matrix} Affine Matrix
 * @param  point {Point} Point
 * @returns {Point} Point
 */ function $8e66af8d07a896cb$export$9b20165a36586806(matrix, point) {
    return Array.isArray(point) ? [
        matrix.a * point[0] + matrix.c * point[1] + matrix.e,
        matrix.b * point[0] + matrix.d * point[1] + matrix.f
    ] : {
        x: matrix.a * point.x + matrix.c * point.y + matrix.e,
        y: matrix.b * point.x + matrix.d * point.y + matrix.f
    };
}
function $8e66af8d07a896cb$export$25080e195dd950cc(matrix, points) {
    return points.map(function(point) {
        return $8e66af8d07a896cb$export$9b20165a36586806(matrix, point);
    });
}

});

parcelRegister("3wE7v", function(module, exports) {

$parcel$export(module.exports, "fromObject", function () { return $29137b4778dc0966$export$9144c32b59cbaec4; });
/**
 * Extract an affine matrix from an object that contains a,b,c,d,e,f keys
 * Any value could be a float or a string that contains a float
 * @param object {Object} Object that contains a,b,c,d,e,f keys
 * @return {Matrix} Affine Matrix
 */ function $29137b4778dc0966$export$9144c32b59cbaec4(object) {
    return {
        a: parseFloat(object.a),
        b: parseFloat(object.b),
        c: parseFloat(object.c),
        d: parseFloat(object.d),
        e: parseFloat(object.e),
        f: parseFloat(object.f)
    };
}

});

parcelRegister("btdnM", function(module, exports) {
/**
 * @ignore
 * @type {RegExp}
 */ var $859cc8a80e8f98ac$var$matrixRegex = /^matrix\(\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*,\s*([0-9_+-.e]+)\s*\)$/i;
function $859cc8a80e8f98ac$export$3004f64547af360e(string) {
    var parseFloatOrThrow = function(number) {
        var n = parseFloat(number);
        if (Number.isFinite(n)) return n // excludes NaN, +Infinite, -Infinite
        ;
        throw new Error(`'${string}' is not a matrix`);
    };
    var prefix = string.substring(0, 7).toLowerCase();
    var suffix = string.substring(string.length - 1);
    var body = string.substring(7, string.length - 1);
    var elements = body.split(',');
    if (prefix === 'matrix(' && suffix === ')' && elements.length === 6) return {
        a: parseFloatOrThrow(elements[0]),
        b: parseFloatOrThrow(elements[1]),
        c: parseFloatOrThrow(elements[2]),
        d: parseFloatOrThrow(elements[3]),
        e: parseFloatOrThrow(elements[4]),
        f: parseFloatOrThrow(elements[5])
    };
    throw new Error(`'${string}' is not a matrix`);
}
function $859cc8a80e8f98ac$export$c1c8983dc21927d2(string) {
    var parsed = string.match($859cc8a80e8f98ac$var$matrixRegex);
    if (parsed === null || parsed.length < 7) throw new Error(`'${string}' is not a matrix`);
    return {
        a: parseFloat(parsed[1]),
        b: parseFloat(parsed[2]),
        c: parseFloat(parsed[3]),
        d: parseFloat(parsed[4]),
        e: parseFloat(parsed[5]),
        f: parseFloat(parsed[6])
    };
}

});

parcelRegister("83Kse", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $5de2a364f6f616dc$export$f0954fd7d5368655; });
/**
 * Identity matrix
 * @returns {Matrix} Affine Matrix
 */ function $5de2a364f6f616dc$export$f0954fd7d5368655() {
    return {
        a: 1,
        c: 0,
        e: 0,
        b: 0,
        d: 1,
        f: 0
    };
}

});

parcelRegister("kDVZW", function(module, exports) {

$parcel$export(module.exports, "inverse", function () { return $f074705b8dd404f3$export$70ae2c07e401031b; });
/**
 * Calculate a matrix that is the inverse of the provided matrix
 * @param matrix {Matrix} Affine Matrix
 * @returns {Matrix} Inverted Affine Matrix
 */ function $f074705b8dd404f3$export$70ae2c07e401031b(matrix) {
    // http://www.wolframalpha.com/input/?i=Inverse+%5B%7B%7Ba,c,e%7D,%7Bb,d,f%7D,%7B0,0,1%7D%7D%5D
    var a = matrix.a, b = matrix.b, c = matrix.c, d = matrix.d, e = matrix.e, f = matrix.f;
    var denom = a * d - b * c;
    return {
        a: d / denom,
        b: b / -denom,
        c: c / -denom,
        d: a / denom,
        e: (d * e - c * f) / -denom,
        f: (b * e - a * f) / denom
    };
}

});

parcelRegister("lNvMw", function(module, exports) {

var $9LyQ8 = parcelRequire("9LyQ8");
function $fde6d3b8e4c08da5$export$b500e24115cd4dcf(object) {
    return (0, $9LyQ8.isObject)(object) && 'a' in object && (0, $9LyQ8.isNumeric)(object.a) && 'b' in object && (0, $9LyQ8.isNumeric)(object.b) && 'c' in object && (0, $9LyQ8.isNumeric)(object.c) && 'd' in object && (0, $9LyQ8.isNumeric)(object.d) && 'e' in object && (0, $9LyQ8.isNumeric)(object.e) && 'f' in object && (0, $9LyQ8.isNumeric)(object.f);
}

});
parcelRegister("9LyQ8", function(module, exports) {

$parcel$export(module.exports, "isUndefined", function () { return $71c3874ced71ff03$export$fce6876652108ab; });
$parcel$export(module.exports, "isNumeric", function () { return $71c3874ced71ff03$export$e90fb89750dba83f; });
$parcel$export(module.exports, "isObject", function () { return $71c3874ced71ff03$export$a6cdc56e425d0d0a; });
function $71c3874ced71ff03$export$fce6876652108ab(val) {
    return typeof val === 'undefined';
}
function $71c3874ced71ff03$export$e90fb89750dba83f(n) {
    return typeof n === 'number' && !Number.isNaN(n) && Number.isFinite(n);
}
function $71c3874ced71ff03$export$a6cdc56e425d0d0a(obj) {
    return typeof obj === 'object' && obj !== null && !Array.isArray(obj);
}
function $71c3874ced71ff03$export$ea33763237293206(obj, keys) {
    return keys.every(function(key) {
        return key in obj;
    });
}

});


parcelRegister("1RMPr", function(module, exports) {

$parcel$export(module.exports, "rotate", function () { return $15c09e07a0c6cafd$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "rotateDEG", function () { return $15c09e07a0c6cafd$export$9ade995dfe562073; });

var $9LyQ8 = parcelRequire("9LyQ8");

var $kr2fR = parcelRequire("kr2fR");

var $dZ59l = parcelRequire("dZ59l");
var $15c09e07a0c6cafd$var$cos = Math.cos, $15c09e07a0c6cafd$var$sin = Math.sin, $15c09e07a0c6cafd$var$PI = Math.PI;
function $15c09e07a0c6cafd$export$bb628a54ab399bc9(angle, cx, cy) {
    var cosAngle = $15c09e07a0c6cafd$var$cos(angle);
    var sinAngle = $15c09e07a0c6cafd$var$sin(angle);
    var rotationMatrix = {
        a: cosAngle,
        c: -sinAngle,
        e: 0,
        b: sinAngle,
        d: cosAngle,
        f: 0
    };
    if ((0, $9LyQ8.isUndefined)(cx) || (0, $9LyQ8.isUndefined)(cy)) return rotationMatrix;
    return (0, $dZ59l.transform)([
        (0, $kr2fR.translate)(cx, cy),
        rotationMatrix,
        (0, $kr2fR.translate)(-cx, -cy)
    ]);
}
function $15c09e07a0c6cafd$export$9ade995dfe562073(angle, cx, cy) {
    return $15c09e07a0c6cafd$export$bb628a54ab399bc9(angle * $15c09e07a0c6cafd$var$PI / 180, cx, cy);
}

});
parcelRegister("kr2fR", function(module, exports) {

$parcel$export(module.exports, "translate", function () { return $ee0814094139d86b$export$d73ee8ef04f5226a; });
/**
 * Calculate a translate matrix
 * @param tx {number} Translation on axis x
 * @param [ty = 0] {number} Translation on axis y
 * @returns {Matrix} Affine Matrix
 */ function $ee0814094139d86b$export$d73ee8ef04f5226a(tx) {
    var ty = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return {
        a: 1,
        c: 0,
        e: tx,
        b: 0,
        d: 1,
        f: ty
    };
}

});

parcelRegister("dZ59l", function(module, exports) {

$parcel$export(module.exports, "transform", function () { return $a2e4f77e5189f5b0$export$51186ad6e864892a; });
$parcel$export(module.exports, "compose", function () { return $a2e4f77e5189f5b0$export$f672e0b6f7222cd7; });
/**
 * Merge multiple matrices into one
 * @param matrices {...Matrix | Matrix[]} Matrices listed as separate parameters or in an array
 * @returns {Matrix} Affine Matrix
 */ 
var $lYyRs = parcelRequire("lYyRs");

var $bX4ja = parcelRequire("bX4ja");
function $a2e4f77e5189f5b0$export$51186ad6e864892a() {
    for(var _len = arguments.length, matrices = new Array(_len), _key = 0; _key < _len; _key++){
        matrices[_key] = arguments[_key];
    }
    matrices = Array.isArray(matrices[0]) ? matrices[0] : matrices;
    var multiply = function(m1, m2) {
        return {
            a: m1.a * m2.a + m1.c * m2.b,
            c: m1.a * m2.c + m1.c * m2.d,
            e: m1.a * m2.e + m1.c * m2.f + m1.e,
            b: m1.b * m2.a + m1.d * m2.b,
            d: m1.b * m2.c + m1.d * m2.d,
            f: m1.b * m2.e + m1.d * m2.f + m1.f
        };
    };
    switch(matrices.length){
        case 0:
            throw new Error('no matrices provided');
        case 1:
            return matrices[0];
        case 2:
            return multiply(matrices[0], matrices[1]);
        default:
            {
                var _matrices = (0, $lYyRs._)(matrices), m1 = _matrices[0], m2 = _matrices[1], rest = _matrices.slice(2);
                var m = multiply(m1, m2);
                return $a2e4f77e5189f5b0$export$51186ad6e864892a.apply(void 0, [
                    m
                ].concat((0, $bX4ja._)(rest)));
            }
    }
}
function $a2e4f77e5189f5b0$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, matrices = new Array(_len), _key = 0; _key < _len; _key++){
        matrices[_key] = arguments[_key];
    }
    return $a2e4f77e5189f5b0$export$51186ad6e864892a.apply(void 0, (0, $bX4ja._)(matrices));
}

});
parcelRegister("lYyRs", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fffa3e4a9bc2ee5f$export$71511d61b312f219; });

var $vDBh4 = parcelRequire("vDBh4");

var $5mm0I = parcelRequire("5mm0I");

var $keO5I = parcelRequire("keO5I");

var $kWe4k = parcelRequire("kWe4k");
function $fffa3e4a9bc2ee5f$export$71511d61b312f219(arr) {
    return (0, $vDBh4._)(arr) || (0, $5mm0I._)(arr) || (0, $kWe4k._)(arr) || (0, $keO5I._)();
}

});



parcelRegister("kFecW", function(module, exports) {

$parcel$export(module.exports, "scale", function () { return $03e1d96cbab68061$export$dcdf75081b88279d; });

var $9LyQ8 = parcelRequire("9LyQ8");

var $kr2fR = parcelRequire("kr2fR");

var $dZ59l = parcelRequire("dZ59l");
function $03e1d96cbab68061$export$dcdf75081b88279d(sx, sy, cx, cy) {
    if ((0, $9LyQ8.isUndefined)(sy)) sy = sx;
    var scaleMatrix = {
        a: sx,
        c: 0,
        e: 0,
        b: 0,
        d: sy,
        f: 0
    };
    if ((0, $9LyQ8.isUndefined)(cx) || (0, $9LyQ8.isUndefined)(cy)) return scaleMatrix;
    return (0, $dZ59l.transform)([
        (0, $kr2fR.translate)(cx, cy),
        scaleMatrix,
        (0, $kr2fR.translate)(-cx, -cy)
    ]);
}

});

parcelRegister("8jtBQ", function(module, exports) {

$parcel$export(module.exports, "shear", function () { return $60d710e6367df55f$export$4861775273fb6d4f; });
/**
 * Calculate a shear matrix
 * @param shx {number} Shear on axis x
 * @param shy {number} Shear on axis y
 * @returns {Matrix} Affine Matrix
 */ function $60d710e6367df55f$export$4861775273fb6d4f(shx, shy) {
    return {
        a: 1,
        c: shx,
        e: 0,
        b: shy,
        d: 1,
        f: 0
    };
}

});

parcelRegister("ibhub", function(module, exports) {

$parcel$export(module.exports, "skewDEG", function () { return $d3c6d161798aa685$export$80b820e0f249e768; });
// https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/skew
var $d3c6d161798aa685$var$tan = Math.tan;
function $d3c6d161798aa685$export$dd2d5a892675faf1(ax, ay) {
    return {
        a: 1,
        c: $d3c6d161798aa685$var$tan(ax),
        e: 0,
        b: $d3c6d161798aa685$var$tan(ay),
        d: 1,
        f: 0
    };
}
function $d3c6d161798aa685$export$80b820e0f249e768(ax, ay) {
    return $d3c6d161798aa685$export$dd2d5a892675faf1(ax * Math.PI / 180, ay * Math.PI / 180);
}

});

parcelRegister("2mZ9s", function(module, exports) {
/**
 * Serialize an affine matrix to a string that can be used with CSS or SVG
 * @param matrix {Matrix} Affine Matrix
 * @returns {string} String that contains an affine matrix formatted as matrix(a,b,c,d,e,f)
 */ function $1b9d124504ca46a3$export$5d05fd1a2be8c220(matrix) {
    return $1b9d124504ca46a3$export$f84e8e69fd4488a5(matrix);
}
function $1b9d124504ca46a3$export$1d0eee16b7a93374(matrix) {
    return $1b9d124504ca46a3$export$f84e8e69fd4488a5(matrix);
}
function $1b9d124504ca46a3$export$f84e8e69fd4488a5(matrix) {
    return `matrix(${matrix.a},${matrix.b},${matrix.c},${matrix.d},${matrix.e},${matrix.f})`;
}

});

parcelRegister("5687o", function(module, exports) {

var $kDVZW = parcelRequire("kDVZW");

var $dZ59l = parcelRequire("dZ59l");

var $eP59S = parcelRequire("eP59S");
function $3b63cf6a0b2824bb$export$2565f8052cb7f44a(t1, t2) {
    // point p = first point of the triangle
    var px1 = t1[0].x != null ? t1[0].x : t1[0][0];
    var py1 = t1[0].y != null ? t1[0].y : t1[0][1];
    var px2 = t2[0].x != null ? t2[0].x : t2[0][0];
    var py2 = t2[0].y != null ? t2[0].y : t2[0][1];
    // point q = second point of the triangle
    var qx1 = t1[1].x != null ? t1[1].x : t1[1][0];
    var qy1 = t1[1].y != null ? t1[1].y : t1[1][1];
    var qx2 = t2[1].x != null ? t2[1].x : t2[1][0];
    var qy2 = t2[1].y != null ? t2[1].y : t2[1][1];
    // point r = third point of the triangle
    var rx1 = t1[2].x != null ? t1[2].x : t1[2][0];
    var ry1 = t1[2].y != null ? t1[2].y : t1[2][1];
    var rx2 = t2[2].x != null ? t2[2].x : t2[2][0];
    var ry2 = t2[2].y != null ? t2[2].y : t2[2][1];
    var r1 = {
        a: px1 - rx1,
        b: py1 - ry1,
        c: qx1 - rx1,
        d: qy1 - ry1,
        e: rx1,
        f: ry1
    };
    var r2 = {
        a: px2 - rx2,
        b: py2 - ry2,
        c: qx2 - rx2,
        d: qy2 - ry2,
        e: rx2,
        f: ry2
    };
    var inverseR1 = (0, $kDVZW.inverse)(r1);
    var affineMatrix = (0, $dZ59l.transform)([
        r2,
        inverseR1
    ]);
    // round the matrix elements to smooth the finite inversion
    return (0, $eP59S.smoothMatrix)(affineMatrix);
}

});
parcelRegister("eP59S", function(module, exports) {

$parcel$export(module.exports, "smoothMatrix", function () { return $aca9d470fdc365ff$export$8459a0a25f7ea1f1; });
/**
 * Rounds all elements of the given matrix using the given precision
 * @param matrix {Matrix} An affine matrix to round
 * @param [precision] {number} A precision to use for Math.round. Defaults to 10000000000 (meaning which rounds to the 10th digit after the comma).
 * @returns {Matrix} The rounded Affine Matrix
 */ function $aca9d470fdc365ff$export$8459a0a25f7ea1f1(matrix) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10000000000;
    return {
        a: Math.round(matrix.a * precision) / precision,
        b: Math.round(matrix.b * precision) / precision,
        c: Math.round(matrix.c * precision) / precision,
        d: Math.round(matrix.d * precision) / precision,
        e: Math.round(matrix.e * precision) / precision,
        f: Math.round(matrix.f * precision) / precision
    };
}

});


parcelRegister("i0iB3", function(module, exports) {

var $3wE7v = parcelRequire("3wE7v");

var $kr2fR = parcelRequire("kr2fR");

var $kFecW = parcelRequire("kFecW");

var $1RMPr = parcelRequire("1RMPr");

var $ibhub = parcelRequire("ibhub");

var $8jtBQ = parcelRequire("8jtBQ");
function $d1b6a6fad9513312$export$36aa15ab5c729b62(definitionOrArrayOfDefinition) {
    return Array.isArray(definitionOrArrayOfDefinition) ? definitionOrArrayOfDefinition.map(mapper) : mapper(definitionOrArrayOfDefinition);
    function mapper(descriptor) {
        switch(descriptor.type){
            case 'matrix':
                if ('a' in descriptor && 'b' in descriptor && 'c' in descriptor && 'd' in descriptor && 'e' in descriptor && 'f' in descriptor) return (0, $3wE7v.fromObject)(descriptor);
                else throw new Error('MISSING_MANDATORY_PARAM');
            case 'translate':
                if (!('tx' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                if ('ty' in descriptor) return (0, $kr2fR.translate)(descriptor.tx, descriptor.ty);
                return (0, $kr2fR.translate)(descriptor.tx);
            case 'scale':
                if (!('sx' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                if ('sy' in descriptor) return (0, $kFecW.scale)(descriptor.sx, descriptor.sy);
                return (0, $kFecW.scale)(descriptor.sx);
            case 'rotate':
                if (!('angle' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                if ('cx' in descriptor && 'cy' in descriptor) return (0, $1RMPr.rotateDEG)(descriptor.angle, descriptor.cx, descriptor.cy);
                return (0, $1RMPr.rotateDEG)(descriptor.angle);
            case 'skewX':
                if (!('angle' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                return (0, $ibhub.skewDEG)(descriptor.angle, 0);
            case 'skewY':
                if (!('angle' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                return (0, $ibhub.skewDEG)(0, descriptor.angle);
            case 'shear':
                if (!('shx' in descriptor && 'shy' in descriptor)) throw new Error('MISSING_MANDATORY_PARAM');
                return (0, $8jtBQ.shear)(descriptor.shx, descriptor.shy);
            default:
                throw new Error('UNSUPPORTED_DESCRIPTOR');
        }
    }
}

});

parcelRegister("ag5pW", function(module, exports) {

var $376sE = parcelRequire("376sE");
function $777f99c479177083$export$dd451a2a4984e188(transformString) {
    return (0, $376sE.parse)(transformString);
}

});
parcelRegister("376sE", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $2447099a9a566496$export$98e6a39c04603d36; });
// @generated by Peggy 5.0.6.
//
// https://peggyjs.org/

var $fFwUa = parcelRequire("fFwUa");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $9xmuV = parcelRequire("9xmuV");

var $9DtGe = parcelRequire("9DtGe");
var $2447099a9a566496$export$f21cea08b0dd60e8 = /*#__PURE__*/ function(SyntaxError1) {
    "use strict";
    (0, $9xmuV._)(peg$SyntaxError, SyntaxError1);
    function peg$SyntaxError(message, expected, found, location) {
        (0, $cx0mh._)(this, peg$SyntaxError);
        var _this;
        _this = (0, $fFwUa._)(this, peg$SyntaxError, [
            message
        ]);
        _this.expected = expected;
        _this.found = found;
        _this.location = location;
        _this.name = "SyntaxError";
        return _this;
    }
    (0, $7h4XF._)(peg$SyntaxError, [
        {
            key: "format",
            value: function format(sources) {
                var _this = this;
                var str = "Error: " + this.message;
                if (this.location) {
                    var src = null;
                    var st = sources.find(function(s) {
                        return s.source === _this.location.source;
                    });
                    if (st) src = st.text.split(/\r\n|\n|\r/g);
                    var s = this.location.start;
                    var offset_s = this.location.source && typeof this.location.source.offset === "function" ? this.location.source.offset(s) : s;
                    var loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
                    if (src) {
                        var e = this.location.end;
                        var filler = "".padEnd(offset_s.line.toString().length, " ");
                        var line = src[s.line - 1];
                        var last = s.line === e.line ? e.column : line.length + 1;
                        var hatLen = last - s.column || 1;
                        str += "\n --> " + loc + "\n" + filler + " |\n" + offset_s.line + " | " + line + "\n" + filler + " | " + "".padEnd(s.column - 1, " ") + "".padEnd(hatLen, "^");
                    } else str += "\n at " + loc;
                }
                return str;
            }
        }
    ], [
        {
            key: "buildMessage",
            value: function buildMessage(expected, found) {
                function hex(ch) {
                    return ch.codePointAt(0).toString(16).toUpperCase();
                }
                var nonPrintable = Object.prototype.hasOwnProperty.call(RegExp.prototype, "unicode") ? new RegExp("[\\p{C}\\p{Mn}\\p{Mc}]", "gu") : null;
                function unicodeEscape(s) {
                    if (nonPrintable) return s.replace(nonPrintable, function(ch) {
                        return "\\u{" + hex(ch) + "}";
                    });
                    return s;
                }
                function literalEscape(s) {
                    return unicodeEscape(s.replace(/\\/g, "\\\\").replace(/"/g, "\\\"").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
                        return "\\x0" + hex(ch);
                    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
                        return "\\x" + hex(ch);
                    }));
                }
                function classEscape(s) {
                    return unicodeEscape(s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
                        return "\\x0" + hex(ch);
                    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
                        return "\\x" + hex(ch);
                    }));
                }
                var DESCRIBE_EXPECTATION_FNS = {
                    literal (expectation) {
                        return "\"" + literalEscape(expectation.text) + "\"";
                    },
                    class (expectation) {
                        var escapedParts = expectation.parts.map(function(part) {
                            return Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part);
                        });
                        return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]" + (expectation.unicode ? "u" : "");
                    },
                    any () {
                        return "any character";
                    },
                    end () {
                        return "end of input";
                    },
                    other (expectation) {
                        return expectation.description;
                    }
                };
                function describeExpectation(expectation) {
                    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
                }
                function describeExpected(expected) {
                    var descriptions = expected.map(describeExpectation);
                    descriptions.sort();
                    if (descriptions.length > 0) {
                        var j = 1;
                        for(var i = 1; i < descriptions.length; i++)if (descriptions[i - 1] !== descriptions[i]) {
                            descriptions[j] = descriptions[i];
                            j++;
                        }
                        descriptions.length = j;
                    }
                    switch(descriptions.length){
                        case 1:
                            return descriptions[0];
                        case 2:
                            return descriptions[0] + " or " + descriptions[1];
                        default:
                            return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
                    }
                }
                function describeFound(found) {
                    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
                }
                return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
            }
        }
    ]);
    return peg$SyntaxError;
}((0, $9DtGe._)(SyntaxError));
function $2447099a9a566496$export$98e6a39c04603d36(input, options) {
    options = options !== undefined ? options : {};
    var peg$FAILED = {};
    var peg$source = options.grammarSource;
    var peg$startRuleFunctions = {
        transformList: peg$parsetransformList
    };
    var peg$startRuleFunction = peg$parsetransformList;
    var peg$c0 = "matrix";
    var peg$c1 = "(";
    var peg$c2 = ")";
    var peg$c3 = "translate";
    var peg$c4 = "scale";
    var peg$c5 = "rotate";
    var peg$c6 = "skewX";
    var peg$c7 = "skewY";
    var peg$c8 = ",";
    var peg$c9 = ".";
    var peg$r0 = /^[eE]/;
    var peg$r1 = /^[+\-]/;
    var peg$r2 = /^[0-9]/;
    var peg$r3 = /^[ \t\r\n]/;
    var peg$e0 = peg$literalExpectation("matrix", false);
    var peg$e1 = peg$literalExpectation("(", false);
    var peg$e2 = peg$literalExpectation(")", false);
    var peg$e3 = peg$literalExpectation("translate", false);
    var peg$e4 = peg$literalExpectation("scale", false);
    var peg$e5 = peg$literalExpectation("rotate", false);
    var peg$e6 = peg$literalExpectation("skewX", false);
    var peg$e7 = peg$literalExpectation("skewY", false);
    var peg$e8 = peg$literalExpectation(",", false);
    var peg$e9 = peg$otherExpectation("fractionalConstant");
    var peg$e10 = peg$literalExpectation(".", false);
    var peg$e11 = peg$classExpectation([
        "e",
        "E"
    ], false, false, false);
    var peg$e12 = peg$classExpectation([
        "+",
        "-"
    ], false, false, false);
    var peg$e13 = peg$classExpectation([
        [
            "0",
            "9"
        ]
    ], false, false, false);
    var peg$e14 = peg$classExpectation([
        " ",
        "\t",
        "\r",
        "\n"
    ], false, false, false);
    function peg$f0(ts) {
        return ts;
    }
    function peg$f1(t, ts) {
        return t.concat(ts);
    }
    function peg$f2(a, b, c, d, e, f) {
        return [
            {
                type: 'matrix',
                a: a,
                b: b,
                c: c,
                d: d,
                e: e,
                f: f
            }
        ];
    }
    function peg$f3(tx, ty) {
        var t = {
            type: 'translate',
            tx: tx
        };
        if (ty) t.ty = ty;
        return [
            t
        ];
    }
    function peg$f4(sx, sy) {
        var s = {
            type: 'scale',
            sx: sx
        };
        if (sy) s.sy = sy;
        return [
            s
        ];
    }
    function peg$f5(angle, c) {
        var r = {
            type: 'rotate',
            angle: angle
        };
        if (c) {
            r.cx = c[0];
            r.cy = c[1];
        }
        return [
            r
        ];
    }
    function peg$f6(angle) {
        return [
            {
                type: 'skewX',
                angle: angle
            }
        ];
    }
    function peg$f7(angle) {
        return [
            {
                type: 'skewY',
                angle: angle
            }
        ];
    }
    function peg$f8(f) {
        return parseFloat(f.join(""));
    }
    function peg$f9(i) {
        return parseInt(i.join(""));
    }
    function peg$f10(n) {
        return n;
    }
    function peg$f11(n1, n2) {
        return [
            n1,
            n2
        ];
    }
    function peg$f12(ds) {
        return ds.join("");
    }
    function peg$f13(f, e) {
        return [
            f,
            e || null
        ].join("");
    }
    function peg$f14(d, e) {
        return [
            d,
            e
        ].join("");
    }
    function peg$f15(d1, d2) {
        return [
            d1 ? d1.join("") : null,
            ".",
            d2.join("")
        ].join("");
    }
    function peg$f16(d) {
        return d.join("");
    }
    function peg$f17(s, d) {
        return [
            'e',
            s,
            d.join("")
        ].join("");
    }
    var peg$currPos = options.peg$currPos | 0;
    var peg$savedPos = peg$currPos;
    var peg$posDetailsCache = [
        {
            line: 1,
            column: 1
        }
    ];
    var peg$maxFailPos = peg$currPos;
    var peg$maxFailExpected = options.peg$maxFailExpected || [];
    var peg$silentFails = options.peg$silentFails | 0;
    var peg$result;
    if (options.startRule) {
        if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
        peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }
    function text() {
        return input.substring(peg$savedPos, peg$currPos);
    }
    function offset() {
        return peg$savedPos;
    }
    function range() {
        return {
            source: peg$source,
            start: peg$savedPos,
            end: peg$currPos
        };
    }
    function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
    }
    function expected(description, location) {
        location = location !== undefined ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildStructuredError([
            peg$otherExpectation(description)
        ], input.substring(peg$savedPos, peg$currPos), location);
    }
    function error(message, location) {
        location = location !== undefined ? location : peg$computeLocation(peg$savedPos, peg$currPos);
        throw peg$buildSimpleError(message, location);
    }
    function peg$getUnicode() {
        var pos = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : peg$currPos;
        var cp = input.codePointAt(pos);
        if (cp === undefined) return "";
        return String.fromCodePoint(cp);
    }
    function peg$literalExpectation(text, ignoreCase) {
        return {
            type: "literal",
            text: text,
            ignoreCase: ignoreCase
        };
    }
    function peg$classExpectation(parts, inverted, ignoreCase, unicode) {
        return {
            type: "class",
            parts: parts,
            inverted: inverted,
            ignoreCase: ignoreCase,
            unicode: unicode
        };
    }
    function peg$anyExpectation() {
        return {
            type: "any"
        };
    }
    function peg$endExpectation() {
        return {
            type: "end"
        };
    }
    function peg$otherExpectation(description) {
        return {
            type: "other",
            description: description
        };
    }
    function peg$computePosDetails(pos) {
        var details = peg$posDetailsCache[pos];
        var p;
        if (details) return details;
        else {
            if (pos >= peg$posDetailsCache.length) p = peg$posDetailsCache.length - 1;
            else {
                p = pos;
                while(!peg$posDetailsCache[--p]);
            }
            details = peg$posDetailsCache[p];
            details = {
                line: details.line,
                column: details.column
            };
            while(p < pos){
                if (input.charCodeAt(p) === 10) {
                    details.line++;
                    details.column = 1;
                } else details.column++;
                p++;
            }
            peg$posDetailsCache[pos] = details;
            return details;
        }
    }
    function peg$computeLocation(startPos, endPos, offset) {
        var startPosDetails = peg$computePosDetails(startPos);
        var endPosDetails = peg$computePosDetails(endPos);
        var res = {
            source: peg$source,
            start: {
                offset: startPos,
                line: startPosDetails.line,
                column: startPosDetails.column
            },
            end: {
                offset: endPos,
                line: endPosDetails.line,
                column: endPosDetails.column
            }
        };
        if (offset && peg$source && typeof peg$source.offset === "function") {
            res.start = peg$source.offset(res.start);
            res.end = peg$source.offset(res.end);
        }
        return res;
    }
    function peg$fail(expected) {
        if (peg$currPos < peg$maxFailPos) return;
        if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected);
    }
    function peg$buildSimpleError(message, location) {
        return new $2447099a9a566496$export$f21cea08b0dd60e8(message, null, null, location);
    }
    function peg$buildStructuredError(expected, found, location) {
        return new $2447099a9a566496$export$f21cea08b0dd60e8($2447099a9a566496$export$f21cea08b0dd60e8.buildMessage(expected, found), expected, found, location);
    }
    function peg$parsetransformList() {
        var s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsewsp();
        while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = peg$parsewsp();
        }
        s2 = peg$parsetransforms();
        if (s2 === peg$FAILED) s2 = null;
        s3 = [];
        s4 = peg$parsewsp();
        while(s4 !== peg$FAILED){
            s3.push(s4);
            s4 = peg$parsewsp();
        }
        peg$savedPos = s0;
        s0 = peg$f0(s2);
        return s0;
    }
    function peg$parsetransforms() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$parsetransform();
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsecommaWsp();
            if (s3 !== peg$FAILED) while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsecommaWsp();
            }
            else s2 = peg$FAILED;
            if (s2 !== peg$FAILED) {
                s3 = peg$parsetransforms();
                if (s3 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f1(s1, s3);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) s0 = peg$parsetransform();
        return s0;
    }
    function peg$parsetransform() {
        var s0;
        s0 = peg$parsematrix();
        if (s0 === peg$FAILED) {
            s0 = peg$parsetranslate();
            if (s0 === peg$FAILED) {
                s0 = peg$parsescale();
                if (s0 === peg$FAILED) {
                    s0 = peg$parserotate();
                    if (s0 === peg$FAILED) {
                        s0 = peg$parseskewX();
                        if (s0 === peg$FAILED) s0 = peg$parseskewY();
                    }
                }
            }
        }
        return s0;
    }
    function peg$parsematrix() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 6) === peg$c0) {
            s1 = peg$c0;
            peg$currPos += 6;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e0);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parsecommaWsp();
                    if (s6 !== peg$FAILED) {
                        s7 = peg$parsenumber();
                        if (s7 !== peg$FAILED) {
                            s8 = peg$parsecommaWsp();
                            if (s8 !== peg$FAILED) {
                                s9 = peg$parsenumber();
                                if (s9 !== peg$FAILED) {
                                    s10 = peg$parsecommaWsp();
                                    if (s10 !== peg$FAILED) {
                                        s11 = peg$parsenumber();
                                        if (s11 !== peg$FAILED) {
                                            s12 = peg$parsecommaWsp();
                                            if (s12 !== peg$FAILED) {
                                                s13 = peg$parsenumber();
                                                if (s13 !== peg$FAILED) {
                                                    s14 = peg$parsecommaWsp();
                                                    if (s14 !== peg$FAILED) {
                                                        s15 = peg$parsenumber();
                                                        if (s15 !== peg$FAILED) {
                                                            s16 = [];
                                                            s17 = peg$parsewsp();
                                                            while(s17 !== peg$FAILED){
                                                                s16.push(s17);
                                                                s17 = peg$parsewsp();
                                                            }
                                                            if (input.charCodeAt(peg$currPos) === 41) {
                                                                s17 = peg$c2;
                                                                peg$currPos++;
                                                            } else {
                                                                s17 = peg$FAILED;
                                                                if (peg$silentFails === 0) peg$fail(peg$e2);
                                                            }
                                                            if (s17 !== peg$FAILED) {
                                                                peg$savedPos = s0;
                                                                s0 = peg$f2(s5, s7, s9, s11, s13, s15);
                                                            } else {
                                                                peg$currPos = s0;
                                                                s0 = peg$FAILED;
                                                            }
                                                        } else {
                                                            peg$currPos = s0;
                                                            s0 = peg$FAILED;
                                                        }
                                                    } else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                } else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsetranslate() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 9) === peg$c3) {
            s1 = peg$c3;
            peg$currPos += 9;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e3);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parsecommaWspNumber();
                    if (s6 === peg$FAILED) s6 = null;
                    s7 = [];
                    s8 = peg$parsewsp();
                    while(s8 !== peg$FAILED){
                        s7.push(s8);
                        s8 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s8 = peg$c2;
                        peg$currPos++;
                    } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s8 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f3(s5, s6);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsescale() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c4) {
            s1 = peg$c4;
            peg$currPos += 5;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e4);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parsecommaWspNumber();
                    if (s6 === peg$FAILED) s6 = null;
                    s7 = [];
                    s8 = peg$parsewsp();
                    while(s8 !== peg$FAILED){
                        s7.push(s8);
                        s8 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s8 = peg$c2;
                        peg$currPos++;
                    } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s8 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f4(s5, s6);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parserotate() {
        var s0, s1, s2, s3, s4, s5, s6, s7, s8;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 6) === peg$c5) {
            s1 = peg$c5;
            peg$currPos += 6;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e5);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = peg$parsecommaWspTwoNumbers();
                    if (s6 === peg$FAILED) s6 = null;
                    s7 = [];
                    s8 = peg$parsewsp();
                    while(s8 !== peg$FAILED){
                        s7.push(s8);
                        s8 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s8 = peg$c2;
                        peg$currPos++;
                    } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s8 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f5(s5, s6);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseskewX() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c6) {
            s1 = peg$c6;
            peg$currPos += 5;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e6);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = [];
                    s7 = peg$parsewsp();
                    while(s7 !== peg$FAILED){
                        s6.push(s7);
                        s7 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s7 = peg$c2;
                        peg$currPos++;
                    } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s7 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f6(s5);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parseskewY() {
        var s0, s1, s2, s3, s4, s5, s6, s7;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 5) === peg$c7) {
            s1 = peg$c7;
            peg$currPos += 5;
        } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e7);
        }
        if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsewsp();
            while(s3 !== peg$FAILED){
                s2.push(s3);
                s3 = peg$parsewsp();
            }
            if (input.charCodeAt(peg$currPos) === 40) {
                s3 = peg$c1;
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$e1);
            }
            if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parsewsp();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parsewsp();
                }
                s5 = peg$parsenumber();
                if (s5 !== peg$FAILED) {
                    s6 = [];
                    s7 = peg$parsewsp();
                    while(s7 !== peg$FAILED){
                        s6.push(s7);
                        s7 = peg$parsewsp();
                    }
                    if (input.charCodeAt(peg$currPos) === 41) {
                        s7 = peg$c2;
                        peg$currPos++;
                    } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$e2);
                    }
                    if (s7 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f7(s5);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsenumber() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = peg$parsesign();
        if (s2 === peg$FAILED) s2 = null;
        s3 = peg$parsefloatingPointConstant();
        if (s3 !== peg$FAILED) {
            s2 = [
                s2,
                s3
            ];
            s1 = s2;
        } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f8(s1);
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$currPos;
            s2 = peg$parsesign();
            if (s2 === peg$FAILED) s2 = null;
            s3 = peg$parseintegerConstant();
            if (s3 !== peg$FAILED) {
                s2 = [
                    s2,
                    s3
                ];
                s1 = s2;
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f9(s1);
            }
            s0 = s1;
        }
        return s0;
    }
    function peg$parsecommaWspNumber() {
        var s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parsecommaWsp();
        if (s1 !== peg$FAILED) {
            s2 = peg$parsenumber();
            if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f10(s2);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsecommaWspTwoNumbers() {
        var s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = peg$parsecommaWsp();
        if (s1 !== peg$FAILED) {
            s2 = peg$parsenumber();
            if (s2 !== peg$FAILED) {
                s3 = peg$parsecommaWsp();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parsenumber();
                    if (s4 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f11(s2, s4);
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsecommaWsp() {
        var s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parsewsp();
        if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
            s1.push(s2);
            s2 = peg$parsewsp();
        }
        else s1 = peg$FAILED;
        if (s1 !== peg$FAILED) {
            s2 = peg$parsecomma();
            if (s2 === peg$FAILED) s2 = null;
            s3 = [];
            s4 = peg$parsewsp();
            while(s4 !== peg$FAILED){
                s3.push(s4);
                s4 = peg$parsewsp();
            }
            s1 = [
                s1,
                s2,
                s3
            ];
            s0 = s1;
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsecomma();
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsewsp();
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    s3 = peg$parsewsp();
                }
                s1 = [
                    s1,
                    s2
                ];
                s0 = s1;
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parsecomma() {
        var s0;
        if (input.charCodeAt(peg$currPos) === 44) {
            s0 = peg$c8;
            peg$currPos++;
        } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e8);
        }
        return s0;
    }
    function peg$parseintegerConstant() {
        var s0, s1;
        s0 = peg$currPos;
        s1 = peg$parsedigitSequence();
        if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f12(s1);
        }
        s0 = s1;
        return s0;
    }
    function peg$parsefloatingPointConstant() {
        var s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parsefractionalConstant();
        if (s1 !== peg$FAILED) {
            s2 = peg$parseexponent();
            if (s2 === peg$FAILED) s2 = null;
            peg$savedPos = s0;
            s0 = peg$f13(s1, s2);
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsedigitSequence();
            if (s1 !== peg$FAILED) {
                s2 = peg$parseexponent();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f14(s1, s2);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        return s0;
    }
    function peg$parsefractionalConstant() {
        var s0, s1, s2, s3;
        peg$silentFails++;
        s0 = peg$currPos;
        s1 = peg$parsedigitSequence();
        if (s1 === peg$FAILED) s1 = null;
        if (input.charCodeAt(peg$currPos) === 46) {
            s2 = peg$c9;
            peg$currPos++;
        } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e10);
        }
        if (s2 !== peg$FAILED) {
            s3 = peg$parsedigitSequence();
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f15(s1, s3);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsedigitSequence();
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 46) {
                    s2 = peg$c9;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$e10);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f16(s1);
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        }
        peg$silentFails--;
        if (s0 === peg$FAILED) {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e9);
        }
        return s0;
    }
    function peg$parseexponent() {
        var s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = input.charAt(peg$currPos);
        if (peg$r0.test(s1)) peg$currPos++;
        else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e11);
        }
        if (s1 !== peg$FAILED) {
            s2 = peg$parsesign();
            if (s2 === peg$FAILED) s2 = null;
            s3 = peg$parsedigitSequence();
            if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f17(s2, s3);
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
        } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
        }
        return s0;
    }
    function peg$parsesign() {
        var s0;
        s0 = input.charAt(peg$currPos);
        if (peg$r1.test(s0)) peg$currPos++;
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e12);
        }
        return s0;
    }
    function peg$parsedigitSequence() {
        var s0, s1;
        s0 = [];
        s1 = peg$parsedigit();
        if (s1 !== peg$FAILED) while(s1 !== peg$FAILED){
            s0.push(s1);
            s1 = peg$parsedigit();
        }
        else s0 = peg$FAILED;
        return s0;
    }
    function peg$parsedigit() {
        var s0;
        s0 = input.charAt(peg$currPos);
        if (peg$r2.test(s0)) peg$currPos++;
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e13);
        }
        return s0;
    }
    function peg$parsewsp() {
        var s0;
        s0 = input.charAt(peg$currPos);
        if (peg$r3.test(s0)) peg$currPos++;
        else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) peg$fail(peg$e14);
        }
        return s0;
    }
    peg$result = peg$startRuleFunction();
    var peg$success = peg$result !== peg$FAILED && peg$currPos === input.length;
    function peg$throw() {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail(peg$endExpectation());
        throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? peg$getUnicode(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
    if (options.peg$library) return /** @type {any} */ {
        peg$result: peg$result,
        peg$currPos: peg$currPos,
        peg$FAILED: peg$FAILED,
        peg$maxFailExpected: peg$maxFailExpected,
        peg$maxFailPos: peg$maxFailPos,
        peg$success: peg$success,
        peg$throw: peg$success ? undefined : peg$throw
    };
    if (peg$success) return peg$result;
    else peg$throw();
}
var $2447099a9a566496$export$b495b1bde973ffbd = [
    "transformList"
];

});
parcelRegister("9DtGe", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $703ec775c0098297$export$71511d61b312f219; });

var $6J7qs = parcelRequire("6J7qs");

var $2JCCy = parcelRequire("2JCCy");

var $idL7u = parcelRequire("idL7u");

var $5oklS = parcelRequire("5oklS");
function $703ec775c0098297$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $703ec775c0098297$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $idL7u._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $6J7qs._)(Class, arguments, (0, $2JCCy._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $5oklS._)(Wrapper, Class);
    };
    return $703ec775c0098297$export$71511d61b312f219(Class);
}

});
parcelRegister("6J7qs", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4e5cb49fcc82d2dc$export$71511d61b312f219; });

var $ff8rK = parcelRequire("ff8rK");

var $5oklS = parcelRequire("5oklS");
function $4e5cb49fcc82d2dc$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $ff8rK._)()) $4e5cb49fcc82d2dc$export$71511d61b312f219 = Reflect.construct;
    else $4e5cb49fcc82d2dc$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $5oklS._)(instance, Class.prototype);
        return instance;
    };
    return $4e5cb49fcc82d2dc$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("idL7u", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d43dfde8bcbc8a8e$export$71511d61b312f219; });
function $d43dfde8bcbc8a8e$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});




parcelRegister("gvDD3", function(module, exports) {

var $kFecW = parcelRequire("kFecW");

var $dZ59l = parcelRequire("dZ59l");
function $c04e480d5e747a56$export$34daa7fcbfeb2849(matrix) {
    var flipX = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, flipY = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // Remove flip from the matrix first - flip could be incorrectly interpreted as
    // rotations (e.g. flipX + flipY = rotate by 180 degrees).
    // Note flipX is a vertical flip, and flipY is a horizontal flip.
    if (flipX) {
        if (flipY) matrix = (0, $dZ59l.compose)(matrix, (0, $kFecW.scale)(-1, -1));
        else matrix = (0, $dZ59l.compose)(matrix, (0, $kFecW.scale)(1, -1));
    } else if (flipY) matrix = (0, $dZ59l.compose)(matrix, (0, $kFecW.scale)(-1, 1));
    var a = matrix.a;
    var b = matrix.b;
    var c = matrix.c;
    var d = matrix.d;
    var scaleX, scaleY, rotation;
    if (a !== 0 || c !== 0) {
        var hypotAc = Math.hypot(a, c);
        scaleX = hypotAc;
        scaleY = (a * d - b * c) / hypotAc;
        var acos = Math.acos(a / hypotAc);
        rotation = c > 0 ? -acos : acos;
    } else if (b !== 0 || d !== 0) {
        var hypotBd = Math.hypot(b, d);
        scaleX = (a * d - b * c) / hypotBd;
        scaleY = hypotBd;
        var acos1 = Math.acos(b / hypotBd);
        rotation = Math.PI / 2 + (d > 0 ? -acos1 : acos1);
    } else {
        scaleX = 0;
        scaleY = 0;
        rotation = 0;
    }
    // put the flip factors back
    if (flipY) scaleX = -scaleX;
    if (flipX) scaleY = -scaleY;
    return {
        translate: {
            tx: matrix.e,
            ty: matrix.f
        },
        scale: {
            sx: scaleX,
            sy: scaleY
        },
        rotation: {
            angle: rotation
        }
    };
}

});

parcelRegister("4JElo", function(module, exports) {
/**
 * Tranformation matrix that mirrors on x-axis
 * @returns {Matrix} Affine Matrix
 */ function $372aa8e28067fb66$export$9ffbcc0b36390a8f() {
    return {
        a: 1,
        c: 0,
        e: 0,
        b: 0,
        d: -1,
        f: 0
    };
}
function $372aa8e28067fb66$export$13e88519d622f890() {
    return {
        a: -1,
        c: 0,
        e: 0,
        b: 0,
        d: 1,
        f: 0
    };
}
function $372aa8e28067fb66$export$8817f89b5790665a() {
    return {
        a: -1,
        c: 0,
        e: 0,
        b: 0,
        d: -1,
        f: 0
    };
}

});

parcelRegister("90Qul", function(module, exports) {

var $kr2fR = parcelRequire("kr2fR");

var $cdZRx = parcelRequire("cdZRx");

var $1RMPr = parcelRequire("1RMPr");

var $kFecW = parcelRequire("kFecW");

var $dZ59l = parcelRequire("dZ59l");
function $68fcd442c2d47c62$export$91619259a15f04b8(startingPoint, endingPoint) {
    var tx = endingPoint.x - startingPoint.x;
    var ty = endingPoint.y - startingPoint.y;
    return (0, $kr2fR.translate)(tx, ty);
}
function $68fcd442c2d47c62$export$87d7516aee2dd9d9(startingPoint1, startingPoint2, endingPoint1, endingPoint2) {
    // finds translation
    var translationMatrix = $68fcd442c2d47c62$export$91619259a15f04b8(startingPoint1, endingPoint1);
    var pointA = (0, $cdZRx.applyToPoint)(translationMatrix, startingPoint2) // I have to translate this point
    ;
    var center = endingPoint1;
    var pointB = endingPoint2;
    // finds rotation matrix
    var angle = Math.atan2(pointB.y - center.y, pointB.x - center.x) - Math.atan2(pointA.y - center.y, pointA.x - center.x);
    var rotationMatrix = (0, $1RMPr.rotate)(angle, center.x, center.y);
    // finds scale matrix
    var d1 = Math.sqrt(Math.pow(pointA.x - center.x, 2) + Math.pow(pointA.y - center.y, 2));
    var d2 = Math.sqrt(Math.pow(pointB.x - center.x, 2) + Math.pow(pointB.y - center.y, 2));
    var scalingLevel = d2 / d1;
    var scalingMatrix = (0, $kFecW.scale)(scalingLevel, scalingLevel, center.x, center.y);
    return (0, $dZ59l.compose)([
        translationMatrix,
        scalingMatrix,
        rotationMatrix
    ]);
}

});





parcelRegister("gWfkn", function(module, exports) {

$parcel$export(module.exports, "HISTORY_TILE_SIZE", function () { return $b60fce38973759d6$export$f7bc58374d6bc9b6; });
$parcel$export(module.exports, "KlHistory", function () { return $b60fce38973759d6$export$1a1044741a812c67; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $e9flx = parcelRequire("e9flx");

var $c3MH7 = parcelRequire("c3MH7");

var $c0vOZ = parcelRequire("c0vOZ");

var $eIebf = parcelRequire("eIebf");
var $b60fce38973759d6$export$f7bc58374d6bc9b6 = 256;
var $b60fce38973759d6$var$HISTORY_DEBUGGING = false;
var $b60fce38973759d6$export$1a1044741a812c67 = /*#__PURE__*/ function() {
    "use strict";
    function KlHistory(p) {
        var _this = this;
        (0, $cx0mh._)(this, KlHistory);
        this.index = 0 // current action the user is on.
        ;
        this.totalActions = 0;
        this.changeCount = 0 // number keeps incrementing with each change (push, undo, redo)
        ;
        this.pauseStack = 0 // how often paused without unpause. push does nothing when paused.
        ;
        this.listeners = [] // broadcasts on undo, redo, push
        ;
        this.entries = [
            {
                timestamp: new Date().getTime(),
                memoryEstimateBytes: (0, $c3MH7.estimateBytes)(p.oldest),
                data: p.oldest
            }
        ];
        this.composed = p.oldest;
        if ($b60fce38973759d6$var$HISTORY_DEBUGGING) window.getHistoryEntries = function() {
            return _this.entries;
        };
    }
    (0, $7h4XF._)(KlHistory, [
        {
            key: "broadcast",
            value: function broadcast() {
                var _this = this;
                this.changeCount++;
                setTimeout(function() {
                    for(var i = 0; i < _this.listeners.length; i++)_this.listeners[i]();
                }, 1);
            }
        },
        {
            key: "updateComposed",
            value: function updateComposed() {
                this.composed = (0, $e9flx.composeHistoryStateData)(this.entries.slice(0, this.index + 1).map(function(item) {
                    return item.data;
                }));
            }
        },
        {
            /**
     * Needed, because sometimes there are actions that would cause other undo steps.
     * For example a filter that does something with two layers and then merges them.
     * That should be a single undo step, and prevent merging from creating its own undo step.
     * Pause prevents creation of unintended undo steps.
     */ key: "pause",
            value: function pause(b) {
                if (b) this.pauseStack++;
                else this.pauseStack = Math.max(0, this.pauseStack - 1);
            }
        },
        {
            /**
     * listens to changes - on undo, redo, push
     */ key: "addListener",
            value: function addListener(l) {
                this.listeners.push(l);
            }
        },
        {
            // doesn't push if: paused or if entry is empty
            key: "push",
            value: function push(entryData, replaceTop) {
                if (this.pauseStack > 0) return;
                if (Object.keys(entryData).length === 0) // no change -> noop
                return;
                var entry = {
                    timestamp: new Date().getTime(),
                    memoryEstimateBytes: (0, $c3MH7.estimateBytes)(entryData),
                    data: entryData
                };
                if (replaceTop && this.index > 0) {
                    this.index--;
                    // remove current top
                    while(this.index < this.entries.length - 1)this.entries.pop();
                    // it's possible that new entry replacing top is same to composed history
                    // e.g. toggle layer visibility twice
                    var isDifferent = (0, $c0vOZ.entryCausesChange)(entryData, (0, $e9flx.composeHistoryStateData)(this.entries.slice(0, this.index + 1).map(function(item) {
                        return item.data;
                    })));
                    // only need to push if it's different
                    isDifferent && this.entries.push(entry);
                } else {
                    while(this.index < this.entries.length - 1)this.entries.pop();
                    this.entries.push(entry);
                }
                this.entries = (0, $eIebf.trimOldestEntries)(this.entries);
                if ($b60fce38973759d6$var$HISTORY_DEBUGGING) {
                    var totalBytes = (0, $eIebf.getTotalMemoryBytes)(this.entries);
                    console.log(`[KlHistory] pushed ${(entry.memoryEstimateBytes / 1e6).toFixed(1)} MB \u{2014} total: ${(totalBytes / 1e6).toFixed(1)} MB (${this.entries.length} entries)`);
                }
                this.totalActions++;
                this.index = this.entries.length - 1;
                this.updateComposed();
                this.broadcast();
            }
        },
        {
            key: "increaseIndex",
            value: function increaseIndex() {
                if (this.canRedo()) this.index++;
                this.updateComposed();
                this.broadcast();
                return this.entries[this.index];
            }
        },
        {
            key: "decreaseIndex",
            value: function decreaseIndex() {
                if (this.canUndo()) this.index--;
                this.updateComposed();
                this.broadcast();
                return this.entries[this.index];
            }
        },
        {
            key: "canUndo",
            value: function canUndo() {
                return this.index > 0;
            }
        },
        {
            key: "canRedo",
            value: function canRedo() {
                return this.index < this.entries.length - 1;
            }
        },
        {
            key: "getEntries",
            value: function getEntries() {
                return this.entries.slice(0, this.index + 1);
            }
        },
        {
            key: "getComposed",
            value: function getComposed() {
                return this.composed;
            }
        },
        {
            key: "getChangeCount",
            value: function getChangeCount() {
                return this.changeCount;
            }
        },
        {
            key: "getTotalIndex",
            value: function getTotalIndex() {
                return this.totalActions;
            }
        },
        {
            key: "isPaused",
            value: function isPaused() {
                return this.pauseStack > 0;
            }
        }
    ]);
    return KlHistory;
}();

});
parcelRegister("e9flx", function(module, exports) {

$parcel$export(module.exports, "composeHistoryStateData", function () { return $efaa626115445ae7$export$801426c37c1dd1c8; });

var $cL71g = parcelRequire("cL71g");

var $8N5YG = parcelRequire("8N5YG");

var $bX4ja = parcelRequire("bX4ja");
// finds the largest index that is defined
function $efaa626115445ae7$var$getLatestDefined(array) {
    for(var i = array.length - 1; i >= 0; i--){
        var value = array[i];
        if (value !== undefined) return value;
    }
    throw new Error('no defined entry found');
}
// in an array of maps, finds array[i][prop] for the largest index
// where array[i][prop] is defined
function $efaa626115445ae7$var$getLatestDefinedProp(array, prop) {
    for(var i = array.length - 1; i >= 0; i--){
        if (!array[i]) continue;
        var value = array[i][prop];
        if (value !== undefined) return value;
    }
    throw new Error('no defined entry found');
}
// For each tile gets the latest which is defined.
// Each tile[] is from a history entry.
function $efaa626115445ae7$var$composeLayerTiles(tilesEntries) {
    var result = (0, $bX4ja._)($efaa626115445ae7$var$getLatestDefined(tilesEntries));
    Object.entries(result).forEach(function(param) {
        var _param = (0, $8N5YG._)(param, 1), id = _param[0];
        result[+id] = $efaa626115445ae7$var$getLatestDefinedProp(tilesEntries, id);
    });
    return result;
}
// combines layers from multiple history entries into the latest representation
function $efaa626115445ae7$var$composeLayer(layerEntries) {
    var result = {
        name: $efaa626115445ae7$var$getLatestDefinedProp(layerEntries, 'name'),
        opacity: $efaa626115445ae7$var$getLatestDefinedProp(layerEntries, 'opacity'),
        isVisible: $efaa626115445ae7$var$getLatestDefinedProp(layerEntries, 'isVisible'),
        mixModeStr: $efaa626115445ae7$var$getLatestDefinedProp(layerEntries, 'mixModeStr'),
        index: $efaa626115445ae7$var$getLatestDefinedProp(layerEntries, 'index'),
        tiles: $efaa626115445ae7$var$composeLayerTiles(layerEntries.map(function(item) {
            return item ? item.tiles : undefined;
        }))
    };
    // Compose extra animation frame tiles if any entry has them.
    // Frame tiles are always partial (only changed tiles). Use the composed main
    // tiles as the base so that unchanged tile positions fall back to the main canvas content.
    var maxFrames = layerEntries.reduce(function(max, entry) {
        if (!(entry === null || entry === void 0 ? void 0 : entry.frameTiles)) return max;
        return Math.max(max, entry.frameTiles.length);
    }, 0);
    if (maxFrames > 0) {
        var _loop = function(f) {
            var frameEntries = layerEntries.map(function(item) {
                return (item === null || item === void 0 ? void 0 : item.frameTiles) && item.frameTiles[f] ? item.frameTiles[f] : undefined;
            });
            // Start from main tiles as base, then overlay frame-specific changes
            var composedFrame = (0, $bX4ja._)(result.tiles);
            for(var tileIdx = 0; tileIdx < composedFrame.length; tileIdx++)// Find the latest defined tile for this position across frame entries
            for(var e = frameEntries.length - 1; e >= 0; e--){
                var entry = frameEntries[e];
                if (entry && entry[tileIdx] !== undefined) {
                    composedFrame[tileIdx] = entry[tileIdx];
                    break;
                }
            }
            result.frameTiles.push(composedFrame);
        };
        result.frameTiles = [];
        for(var f = 0; f < maxFrames; f++)_loop(f);
    }
    return result;
}
// combines layerMaps from multiple history entries into the latest representation
function $efaa626115445ae7$var$composeLayerMap(layerMaps) {
    var result = (0, $cL71g._)({}, $efaa626115445ae7$var$getLatestDefined(layerMaps));
    Object.entries(result).forEach(function(param) {
        var _param = (0, $8N5YG._)(param, 1), id = _param[0];
        result[id] = $efaa626115445ae7$var$composeLayer(layerMaps.map(function(item) {
            return item ? item[id] : undefined;
        }));
    });
    return result;
}
function $efaa626115445ae7$export$801426c37c1dd1c8(entries, targetIndex) {
    if (targetIndex === undefined) targetIndex = entries.length - 1;
    entries = entries.slice(0, targetIndex + 1);
    return {
        projectId: $efaa626115445ae7$var$getLatestDefinedProp(entries, 'projectId'),
        size: $efaa626115445ae7$var$getLatestDefinedProp(entries, 'size'),
        activeLayerId: $efaa626115445ae7$var$getLatestDefinedProp(entries, 'activeLayerId'),
        selection: $efaa626115445ae7$var$getLatestDefinedProp(entries, 'selection'),
        layerMap: $efaa626115445ae7$var$composeLayerMap(entries.map(function(item) {
            return item.layerMap;
        }))
    };
}

});

parcelRegister("c3MH7", function(module, exports) {

$parcel$export(module.exports, "estimateBytes", function () { return $be0f0ae6c2bda15b$export$9522719957028754; });

var $8N5YG = parcelRequire("8N5YG");

var $esGm2 = parcelRequire("esGm2");
function $be0f0ae6c2bda15b$export$9522719957028754(entry) {
    var // for complex selection paths
    _entry_selection_value, _entry_selection;
    var result = 0;
    (_entry_selection = entry.selection) === null || _entry_selection === void 0 ? void 0 : (_entry_selection_value = _entry_selection.value) === null || _entry_selection_value === void 0 ? void 0 : _entry_selection_value.forEach(function(poly) {
        poly.forEach(function(ring) {
            result += ring.length * 2 * 8; // each number 8 bytes
        });
    });
    entry.layerMap && Object.entries(entry.layerMap).forEach(function(param) {
        var _param = (0, $8N5YG._)(param, 2), layer = _param[1];
        var _layer_frameTiles;
        var estimateTiles = function(tiles) {
            tiles === null || tiles === void 0 ? void 0 : tiles.forEach(function(tile) {
                if (tile === undefined) return;
                if ((0, $esGm2.isLayerFill)(tile)) result += tile.fill.length * 2; // 2 byte per character
                else result += tile.data.width * tile.data.height * 4; // 4 channels, each 1 byte
            });
        };
        estimateTiles(layer.tiles);
        (_layer_frameTiles = layer.frameTiles) === null || _layer_frameTiles === void 0 ? void 0 : _layer_frameTiles.forEach(function(ft) {
            return estimateTiles(ft);
        });
    });
    return result;
}

});

parcelRegister("c0vOZ", function(module, exports) {

$parcel$export(module.exports, "entryCausesChange", function () { return $01f9c7e7c8b40cb3$export$770e40ded99d2233; });
function $01f9c7e7c8b40cb3$export$770e40ded99d2233(entry, composed) {
    if (entry.size !== undefined) {
        if (entry.size.width !== composed.size.width) return true;
        if (entry.size.height !== composed.size.height) return true;
    }
    if (entry.selection !== undefined) {
        if (entry.selection.value !== composed.selection.value) return true;
    }
    if (entry.activeLayerId !== undefined) {
        if (entry.activeLayerId !== composed.activeLayerId) return true;
    }
    if (entry.layerMap !== undefined) {
        var entryLayerMapIds = Object.keys(entry.layerMap);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(composed.layerMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var layerId = _step.value;
                if (!entryLayerMapIds.includes(layerId)) return true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = entryLayerMapIds[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var layerId1 = _step1.value;
                var composedLayer = composed.layerMap[layerId1];
                if (!composedLayer) return true;
                var entryLayer = entry.layerMap[layerId1];
                if (entryLayer.name !== undefined && entryLayer.name !== composedLayer.name) return true;
                if (entryLayer.opacity !== undefined && entryLayer.opacity !== composedLayer.opacity) return true;
                if (entryLayer.isVisible !== undefined && entryLayer.isVisible !== composedLayer.isVisible) return true;
                if (entryLayer.mixModeStr !== undefined && entryLayer.mixModeStr !== composedLayer.mixModeStr) return true;
                if (entryLayer.index !== undefined && entryLayer.index !== composedLayer.index) return true;
                if (entryLayer.tiles !== undefined) // not needed currently
                return true;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    return false;
}

});

parcelRegister("eIebf", function(module, exports) {

$parcel$export(module.exports, "getTotalMemoryBytes", function () { return $3c260ce1d5d1d6ad$export$d67e774f8b500179; });
$parcel$export(module.exports, "trimOldestEntries", function () { return $3c260ce1d5d1d6ad$export$d87cc29d5f016b5d; });

var $bX4ja = parcelRequire("bX4ja");

var $e9flx = parcelRequire("e9flx");

var $c3MH7 = parcelRequire("c3MH7");
var $3c260ce1d5d1d6ad$export$dcf9b1c44bd9f3ca = 200e6; // 200 MB
var $3c260ce1d5d1d6ad$export$b2fc749d02ee72fc = 10e6; // 10 MB
var $3c260ce1d5d1d6ad$export$3581b93879161a65 = 50;
var $3c260ce1d5d1d6ad$export$31969bbe78931f29 = 1e9; // 1 GB
function $3c260ce1d5d1d6ad$export$d67e774f8b500179(entries) {
    return entries.reduce(function(sum, e) {
        return sum + e.memoryEstimateBytes;
    }, 0);
}
function $3c260ce1d5d1d6ad$export$d87cc29d5f016b5d(entries) {
    entries = (0, $bX4ja._)(entries);
    var totalBytes = $3c260ce1d5d1d6ad$export$d67e774f8b500179(entries);
    if (totalBytes <= $3c260ce1d5d1d6ad$export$dcf9b1c44bd9f3ca) // we always keep all below this threshold
    return entries;
    var newestEntryIndex = entries.length - 1; // index of the newest entry
    // limit age of large entries
    // Otherwise they may stick around very long and drive up the average memory usage.
    var oldestIndex = 0;
    for(var i = 0; i <= newestEntryIndex; i++){
        var age = newestEntryIndex - i;
        if (entries[i].memoryEstimateBytes > $3c260ce1d5d1d6ad$export$b2fc749d02ee72fc && age > $3c260ce1d5d1d6ad$export$3581b93879161a65) oldestIndex = i;
    }
    // Regular entries together can't exceed ALWAYS_KEEP_THRESHOLD_BYTES.
    // Large entries not included in this.
    {
        var accumulatedBytes = 0;
        for(var i1 = newestEntryIndex; i1 >= 0; i1--){
            if (entries[i1].memoryEstimateBytes > $3c260ce1d5d1d6ad$export$b2fc749d02ee72fc) continue;
            accumulatedBytes += entries[i1].memoryEstimateBytes;
            if (accumulatedBytes > $3c260ce1d5d1d6ad$export$dcf9b1c44bd9f3ca) {
                oldestIndex = Math.max(oldestIndex, i1);
                break;
            }
        }
    }
    // can't exceed TOTAL_THRESHOLD_BYTES
    {
        var accumulatedBytes1 = 0;
        for(var i2 = newestEntryIndex; i2 >= 0; i2--){
            accumulatedBytes1 += entries[i2].memoryEstimateBytes;
            if (accumulatedBytes1 > $3c260ce1d5d1d6ad$export$31969bbe78931f29) {
                oldestIndex = Math.max(oldestIndex, i2);
                break;
            }
        }
    }
    // compose entries 0..oldestIndex into a single "oldest" entry
    while(oldestIndex > 0){
        var composedData = (0, $e9flx.composeHistoryStateData)(entries.slice(0, oldestIndex + 1).map(function(item) {
            return item.data;
        }), oldestIndex);
        var memoryEstimateBytes = (0, $c3MH7.estimateBytes)(composedData);
        entries = [
            {
                timestamp: entries[oldestIndex].timestamp,
                memoryEstimateBytes: memoryEstimateBytes,
                description: 'oldest',
                data: composedData
            }
        ].concat((0, $bX4ja._)(entries.slice(oldestIndex + 1)));
        oldestIndex = 0;
        // Despite the earlier check the composed entry may still push the total over 1 GB.
        if ($3c260ce1d5d1d6ad$export$d67e774f8b500179(entries) > $3c260ce1d5d1d6ad$export$31969bbe78931f29) oldestIndex = 1;
    }
    return entries;
}

});


parcelRegister("7nLJW", function(module, exports) {

$parcel$export(module.exports, "sortLayerMap", function () { return $9aa66e6c8140249b$export$87eabc555ccfbb9f; });
function $9aa66e6c8140249b$export$87eabc555ccfbb9f(a, b) {
    if (a.index > b.index) return 1;
    if (a.index < b.index) return -1;
    return 0;
}

});

parcelRegister("6mTnI", function(module, exports) {

$parcel$export(module.exports, "isTImageDataReference", function () { return $14b343f2c12ca9c5$export$96cc750ad8f2b8b0; });
$parcel$export(module.exports, "ProjectStore", function () { return $14b343f2c12ca9c5$export$93d91060b9af7e2a; });

var $1LaJZ = parcelRequire("1LaJZ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $fk3zw = parcelRequire("fk3zw");

var $3hwQ7 = parcelRequire("3hwQ7");

var $6l0gQ = parcelRequire("6l0gQ");

var $jTg9g = parcelRequire("jTg9g");

var $7jh4K = parcelRequire("7jh4K");

var $eWjiX = parcelRequire("eWjiX");

var $eIcQa = parcelRequire("eIcQa");
function $14b343f2c12ca9c5$export$96cc750ad8f2b8b0(input) {
    return typeof input === 'object' && input !== null && 'id' in input && typeof input.id === 'string';
}
function $14b343f2c12ca9c5$var$createFallbackThumbnail() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $eIcQa.canvasToBlob)((0, $eWjiX.BB).canvas((0, $3hwQ7.PROJECT_STORE_THUMBNAIL_SIZE_PX), (0, $3hwQ7.PROJECT_STORE_THUMBNAIL_SIZE_PX)), 'image/png')
                    ];
                case 1:
                    // very basic fallback. only affects data stored before version 0.5.1 (2022)
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}
var $14b343f2c12ca9c5$export$93d91060b9af7e2a = /*#__PURE__*/ function() {
    "use strict";
    function ProjectStore() {
        var _this = this;
        (0, $cx0mh._)(this, ProjectStore);
        this.listeners = [];
        this.isAvailable = true;
        if (!(0, $jTg9g.KL_INDEXED_DB).getIsAvailable()) {
            this.isAvailable = false;
            return;
        }
        window.addEventListener('storage', function(e) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                return (0, $fk3zw._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (e.key !== 'indexedDbUpdatedAt' || this.listeners.length === 0) return [
                                2
                            ];
                            return [
                                4,
                                this.update()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
    }
    (0, $7h4XF._)(ProjectStore, [
        {
            key: "lowLevelStore",
            value: function lowLevelStore(project) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var rawOld, deleteIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, layer, imageDataList, thumbnail, layers, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, layer1, blob, raw, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, imageData, err, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, id, err;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.BROWSER_STORAGE_STORE), 1)
                                ];
                            case 1:
                                rawOld = _state.sent();
                                deleteIds = [];
                                if (rawOld) {
                                    if ($14b343f2c12ca9c5$export$96cc750ad8f2b8b0(rawOld.thumbnail)) deleteIds.push(rawOld.thumbnail.id);
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = rawOld.layers[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            layer = _step.value;
                                            if ($14b343f2c12ca9c5$export$96cc750ad8f2b8b0(layer.blob)) deleteIds.push(layer.blob.id);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                                // prepare for storing
                                imageDataList = [];
                                thumbnail = {
                                    id: (0, $7jh4K.randomUuid)()
                                };
                                imageDataList.push({
                                    id: thumbnail.id,
                                    data: project.thumbnail
                                });
                                layers = [];
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(_iterator1 = project.layers[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        layer1 = _step1.value;
                                        blob = {
                                            id: (0, $7jh4K.randomUuid)()
                                        };
                                        imageDataList.push({
                                            id: blob.id,
                                            data: layer1.blob
                                        });
                                        layers.push((0, $4EWN2._)((0, $cL71g._)({}, layer1), {
                                            blob: blob
                                        }));
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                raw = (0, $4EWN2._)((0, $cL71g._)({}, project), {
                                    thumbnail: thumbnail,
                                    layers: layers
                                });
                                _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                _state.label = 2;
                            case 2:
                                _state.trys.push([
                                    2,
                                    7,
                                    8,
                                    9
                                ]);
                                _iterator2 = imageDataList[Symbol.iterator]();
                                _state.label = 3;
                            case 3:
                                if (!!(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done)) return [
                                    3,
                                    6
                                ];
                                imageData = _step2.value;
                                return [
                                    4,
                                    (0, $jTg9g.KL_INDEXED_DB).set((0, $jTg9g.IMAGE_DATA_STORE), imageData.id, imageData.data)
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _iteratorNormalCompletion2 = true;
                                return [
                                    3,
                                    3
                                ];
                            case 6:
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                err = _state.sent();
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    4,
                                    (0, $jTg9g.KL_INDEXED_DB).set((0, $jTg9g.BROWSER_STORAGE_STORE), undefined, raw)
                                ];
                            case 10:
                                _state.sent();
                                _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                _state.label = 11;
                            case 11:
                                _state.trys.push([
                                    11,
                                    16,
                                    17,
                                    18
                                ]);
                                _iterator3 = deleteIds[Symbol.iterator]();
                                _state.label = 12;
                            case 12:
                                if (!!(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done)) return [
                                    3,
                                    15
                                ];
                                id = _step3.value;
                                return [
                                    4,
                                    (0, $jTg9g.KL_INDEXED_DB).remove((0, $jTg9g.IMAGE_DATA_STORE), id)
                                ];
                            case 13:
                                _state.sent();
                                _state.label = 14;
                            case 14:
                                _iteratorNormalCompletion3 = true;
                                return [
                                    3,
                                    12
                                ];
                            case 15:
                                return [
                                    3,
                                    18
                                ];
                            case 16:
                                err = _state.sent();
                                _didIteratorError3 = true;
                                _iteratorError3 = err;
                                return [
                                    3,
                                    18
                                ];
                            case 17:
                                try {
                                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                        _iterator3.return();
                                    }
                                } finally{
                                    if (_didIteratorError3) {
                                        throw _iteratorError3;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 18:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "lowLevelReadMeta",
            value: function lowLevelReadMeta() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var raw, thumbnail, thumbnailReadResult, _tmp, _raw_projectId;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.BROWSER_STORAGE_STORE), 1)
                                ];
                            case 1:
                                raw = _state.sent();
                                if (!raw) return [
                                    2,
                                    undefined
                                ];
                                if (!$14b343f2c12ca9c5$export$96cc750ad8f2b8b0(raw.thumbnail)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.IMAGE_DATA_STORE), raw.thumbnail.id)
                                ];
                            case 2:
                                thumbnailReadResult = _state.sent();
                                if ((0, $7jh4K.isBlob)(thumbnailReadResult)) thumbnail = thumbnailReadResult;
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                thumbnail = raw.thumbnail;
                                _state.label = 4;
                            case 4:
                                if (!(thumbnail !== null && thumbnail !== void 0)) return [
                                    3,
                                    5
                                ];
                                _tmp = thumbnail;
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                return [
                                    4,
                                    $14b343f2c12ca9c5$var$createFallbackThumbnail()
                                ];
                            case 6:
                                _tmp = _state.sent();
                                _state.label = 7;
                            case 7:
                                thumbnail = _tmp;
                                return [
                                    2,
                                    {
                                        projectId: (_raw_projectId = raw.projectId) !== null && _raw_projectId !== void 0 ? _raw_projectId : (0, $7jh4K.randomUuid)(),
                                        timestamp: raw.timestamp,
                                        thumbnail: thumbnail
                                    }
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "lowLevelRead",
            value: function lowLevelRead() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var raw, thumbnail, thumbnailReadResult, _tmp, layers, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, layer, blob, readResult, _layer_isVisible, _layer_mixModeStr, err, _raw_projectId;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.BROWSER_STORAGE_STORE), 1)
                                ];
                            case 1:
                                raw = _state.sent();
                                if (!raw) return [
                                    2,
                                    undefined
                                ];
                                if (!$14b343f2c12ca9c5$export$96cc750ad8f2b8b0(raw.thumbnail)) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.IMAGE_DATA_STORE), raw.thumbnail.id)
                                ];
                            case 2:
                                thumbnailReadResult = _state.sent();
                                if ((0, $7jh4K.isBlob)(thumbnailReadResult)) thumbnail = thumbnailReadResult;
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                thumbnail = raw.thumbnail;
                                _state.label = 4;
                            case 4:
                                if (!(thumbnail !== null && thumbnail !== void 0)) return [
                                    3,
                                    5
                                ];
                                _tmp = thumbnail;
                                return [
                                    3,
                                    7
                                ];
                            case 5:
                                return [
                                    4,
                                    $14b343f2c12ca9c5$var$createFallbackThumbnail()
                                ];
                            case 6:
                                _tmp = _state.sent();
                                _state.label = 7;
                            case 7:
                                thumbnail = _tmp;
                                layers = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 8;
                            case 8:
                                _state.trys.push([
                                    8,
                                    15,
                                    16,
                                    17
                                ]);
                                _iterator = raw.layers[Symbol.iterator]();
                                _state.label = 9;
                            case 9:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    14
                                ];
                                layer = _step.value;
                                blob = void 0;
                                if (!$14b343f2c12ca9c5$export$96cc750ad8f2b8b0(layer.blob)) return [
                                    3,
                                    11
                                ];
                                return [
                                    4,
                                    (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.IMAGE_DATA_STORE), layer.blob.id)
                                ];
                            case 10:
                                readResult = _state.sent();
                                if ((0, $7jh4K.isBlob)(readResult)) blob = readResult;
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                blob = layer.blob;
                                _state.label = 12;
                            case 12:
                                layers.push((0, $4EWN2._)((0, $cL71g._)({}, layer), {
                                    isVisible: (_layer_isVisible = layer.isVisible) !== null && _layer_isVisible !== void 0 ? _layer_isVisible : true,
                                    mixModeStr: (_layer_mixModeStr = layer.mixModeStr) !== null && _layer_mixModeStr !== void 0 ? _layer_mixModeStr : 'source-over',
                                    blob: blob
                                }));
                                _state.label = 13;
                            case 13:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    9
                                ];
                            case 14:
                                return [
                                    3,
                                    17
                                ];
                            case 15:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    17
                                ];
                            case 16:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 17:
                                return [
                                    2,
                                    (0, $4EWN2._)((0, $cL71g._)({}, raw), {
                                        projectId: (_raw_projectId = raw.projectId) !== null && _raw_projectId !== void 0 ? _raw_projectId : (0, $7jh4K.randomUuid)(),
                                        thumbnail: thumbnail,
                                        layers: layers
                                    })
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "lowLevelClear",
            value: function lowLevelClear() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var rawOld, deleteIds, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, layer, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, id, err;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $jTg9g.KL_INDEXED_DB).get((0, $jTg9g.BROWSER_STORAGE_STORE), 1)
                                ];
                            case 1:
                                rawOld = _state.sent();
                                deleteIds = [];
                                if (rawOld) {
                                    if ($14b343f2c12ca9c5$export$96cc750ad8f2b8b0(rawOld.thumbnail)) deleteIds.push(rawOld.thumbnail.id);
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = rawOld.layers[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            layer = _step.value;
                                            if ($14b343f2c12ca9c5$export$96cc750ad8f2b8b0(layer.blob)) deleteIds.push(layer.blob.id);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                                return [
                                    4,
                                    (0, $jTg9g.KL_INDEXED_DB).remove((0, $jTg9g.BROWSER_STORAGE_STORE), 1)
                                ];
                            case 2:
                                _state.sent();
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    8,
                                    9,
                                    10
                                ]);
                                _iterator1 = deleteIds[Symbol.iterator]();
                                _state.label = 4;
                            case 4:
                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    7
                                ];
                                id = _step1.value;
                                return [
                                    4,
                                    (0, $jTg9g.KL_INDEXED_DB).remove((0, $jTg9g.IMAGE_DATA_STORE), id)
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    4
                                ];
                            case 7:
                                return [
                                    3,
                                    10
                                ];
                            case 8:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 10:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "emit",
            value: function emit(meta) {
                this.currentMeta = meta ? (0, $cL71g._)({}, meta) : undefined;
                this.listeners.forEach(function(item) {
                    item.onUpdate(meta);
                });
            }
        },
        {
            key: "updateTimestamp",
            value: function updateTimestamp() {
                (0, $6l0gQ.LocalStorage).setItem('indexedDbUpdatedAt', '' + new Date().getTime());
            }
        },
        {
            key: "update",
            value: function update() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _, _1, e;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                _1 = (_ = this).emit;
                                return [
                                    4,
                                    this.readMeta()
                                ];
                            case 1:
                                _1.apply(_, [
                                    _state.sent()
                                ]);
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                if (e instanceof Error && e.message.indexOf('db-error') === 0) this.isAvailable = false;
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "read",
            value: function read() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var storageProject, e, result, e1;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    this.lowLevelRead()
                                ];
                            case 1:
                                storageProject = _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                this.isAvailable = false;
                                throw new Error('db-error: ' + e);
                            case 3:
                                if (!storageProject) return [
                                    2,
                                    undefined
                                ];
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    (0, $3hwQ7.ProjectConverter).readStorageProject(storageProject)
                                ];
                            case 5:
                                result = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e1 = _state.sent();
                                throw new Error('format-error: ' + e1);
                            case 7:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "readMeta",
            value: function readMeta() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var blobMeta, e, result, e1;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    this.lowLevelReadMeta()
                                ];
                            case 1:
                                blobMeta = _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                this.isAvailable = false;
                                throw new Error('db-error: ' + e);
                            case 3:
                                if (!blobMeta) return [
                                    2,
                                    undefined
                                ];
                                _state.label = 4;
                            case 4:
                                _state.trys.push([
                                    4,
                                    6,
                                    ,
                                    7
                                ]);
                                return [
                                    4,
                                    (0, $3hwQ7.ProjectConverter).readStorageMeta(blobMeta)
                                ];
                            case 5:
                                result = _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e1 = _state.sent();
                                throw new Error('format-error: ' + e1);
                            case 7:
                                return [
                                    2,
                                    result
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "store",
            value: function store(project) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this, storageProject, e;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    (0, $3hwQ7.ProjectConverter).createStorageProject(project)
                                ];
                            case 2:
                                storageProject = _state.sent();
                                return [
                                    4,
                                    this.lowLevelStore(storageProject)
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                e = _state.sent();
                                this.isAvailable = false;
                                throw new Error('db-error: ' + e);
                            case 5:
                                this.updateTimestamp();
                                setTimeout(function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                        var meta;
                                        return (0, $fk3zw._)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    return [
                                                        4,
                                                        this.readMeta()
                                                    ];
                                                case 1:
                                                    meta = _state.sent();
                                                    this.emit(meta);
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    }).call(_this);
                                });
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "clear",
            value: function clear() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                return [
                                    4,
                                    this.lowLevelClear()
                                ];
                            case 1:
                                _state.sent();
                                this.updateTimestamp();
                                setTimeout(function() {
                                    return _this.emit();
                                }, 0);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(listener) {
                if (this.listeners.includes(listener)) return;
                this.listeners.push(listener);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(listener) {
                for(var i = 0; i < this.listeners.length; i++)if (listener === this.listeners[i]) {
                    this.listeners.splice(i, 1);
                    return;
                }
            }
        },
        {
            key: "getIsAvailable",
            value: function getIsAvailable() {
                this.isAvailable = this.isAvailable && (0, $jTg9g.KL_INDEXED_DB).getIsAvailable();
                return this.isAvailable;
            }
        },
        {
            key: "getCurrentMeta",
            value: function getCurrentMeta() {
                return this.currentMeta;
            }
        }
    ]);
    return ProjectStore;
}();

});


parcelRegister("3uJxV", function(module, exports) {

$parcel$export(module.exports, "CrossTabChannel", function () { return $f229d9072041d35e$export$84f7c9d87f70395e; });

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $6l0gQ = parcelRequire("6l0gQ");

var $7jh4K = parcelRequire("7jh4K");
var $f229d9072041d35e$var$originId = (0, $7jh4K.randomUuid)();
var $f229d9072041d35e$export$84f7c9d87f70395e = /*#__PURE__*/ function() {
    "use strict";
    function CrossTabChannel(name) {
        var _this = this;
        (0, $cx0mh._)(this, CrossTabChannel);
        this.name = name;
        this.broadcastChannelListeners = [];
        this.lastReadTimestamp = new Date().getTime();
        this.maxAgeMs = 10000;
        this.localStoragePrefix = 'cross-tab-channel--';
        this.localStorageListeners = new Set();
        this.onLocalStorageChange = function(e) {
            if (e.key !== _this.getLsKey() || e.newValue === null) // case 1: irrelevant key changed
            // case 2: null means no new message
            // -> noop
            return;
            try {
                var entries = JSON.parse(e.newValue);
                entries.forEach(function(entry) {
                    if (entry.originId === $f229d9072041d35e$var$originId || entry.timestamp <= _this.lastReadTimestamp) // ignore messages from our own tab, or that aren't new
                    return;
                    _this.lastReadTimestamp = entry.timestamp;
                    _this.localStorageListeners.forEach(function(listener) {
                        return listener(entry.message);
                    });
                });
            } catch (error) {
                // probably invalid value -> reset
                (0, $6l0gQ.LocalStorage).removeItem(_this.getLsKey());
            }
        };
        if (typeof BroadcastChannel !== 'undefined') this.broadcastChannel = new BroadcastChannel(name);
    }
    (0, $7h4XF._)(CrossTabChannel, [
        {
            key: "getLsKey",
            value: function getLsKey() {
                return this.localStoragePrefix + this.name;
            }
        },
        {
            key: "postMessage",
            value: function postMessage(message) {
                var _this = this;
                if (this.broadcastChannel) this.broadcastChannel.postMessage(message);
                else {
                    var now = new Date().getTime();
                    var raw = null;
                    try {
                        raw = (0, $6l0gQ.LocalStorage).getItem(this.getLsKey());
                    } catch (error) {
                    // probably invalid value -> reset
                    }
                    var entries = raw === null ? [] : JSON.parse(raw);
                    entries = entries.filter(function(entry) {
                        // delete old entries
                        return entry.timestamp > now - _this.maxAgeMs;
                    });
                    entries.push({
                        timestamp: now,
                        originId: $f229d9072041d35e$var$originId,
                        message: message
                    });
                    (0, $6l0gQ.LocalStorage).setItem(this.getLsKey(), JSON.stringify(entries));
                }
            }
        },
        {
            key: "subscribe",
            value: function subscribe(listener) {
                if (this.broadcastChannel) {
                    var preListener = function(message) {
                        return listener(message.data);
                    };
                    this.broadcastChannelListeners.push({
                        preListener: preListener,
                        listener: listener
                    });
                    this.broadcastChannel.addEventListener('message', preListener);
                } else {
                    if (this.localStorageListeners.size === 0) window.addEventListener('storage', this.onLocalStorageChange);
                    this.localStorageListeners.add(listener);
                }
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(listener) {
                if (this.broadcastChannel) {
                    var match = this.broadcastChannelListeners.find(function(item) {
                        return item.listener === listener;
                    });
                    if (match) this.broadcastChannel.removeEventListener('message', match.preListener);
                } else {
                    this.localStorageListeners.delete(listener);
                    if (this.localStorageListeners.size === 0) window.removeEventListener('storage', this.onLocalStorageChange);
                }
            }
        },
        {
            key: "close",
            value: function close() {
                if (this.broadcastChannel) this.broadcastChannel.close();
            }
        }
    ]);
    return CrossTabChannel;
}();

});


parcelRegister("6caCk", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("kNYzr")).then(function() {
    return parcelRequire('2m2jt');
});

});

parcelRegister("kUTcy", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("62mlz")).then(function() {
    return parcelRequire('17YSH');
});

});

parcelRegister("6rG3P", function(module, exports) {

module.exports = (parcelRequire("ih7W4"))($parcel$resolve("76QQo")).then(function() {
    return parcelRequire('evhrb');
});

});

var $9fe7cbf0cbcadecd$exports = {};
$parcel$extendImportMap({
    "5RGAp": "de.1c1dc40e.js",
    "3uTpJ": "es.5d7d4d40.js",
    "4XbAZ": "fi.4a78ea58.js",
    "2bKIP": "fr.80fae70c.js",
    "i0BNf": "hu.c1ee46d6.js",
    "98Cvg": "id.493719fe.js",
    "y5edP": "ja.197fa497.js",
    "9fDFY": "jv.5054fe66.js",
    "cW2nR": "ko.a96a1ab3.js",
    "8ucza": "lv.8b8a4378.js",
    "f3RKT": "nl.831070a8.js",
    "fVlhe": "pt-BR.b8ef2466.js",
    "kcBSP": "ru.b0bf136d.js",
    "4RByM": "su.608f764e.js",
    "ap9yw": "sv.c4cb9ab9.js",
    "dsJ3g": "zh-CN.1ac0941d.js",
    "lF1Tu": "zh-TW.15868ad8.js",
    "kbyFQ": "cancel.340fb0bb.svg",
    "l7FYj": "check.e6114d75.svg",
    "kino6": "remove-layer.da17ce5a.svg",
    "5H9IS": "brush-pressure.8782e24b.svg",
    "la7yv": "copy.22819386.svg",
    "cTtMO": "tool-picker.896489f2.svg",
    "iQ1f0": "angle.319ede69.svg",
    "04ZZm": "tool-zoom-in.a322442c.svg",
    "j9xio": "tool-zoom-out.a0c9b082.svg",
    "fER1z": "viewport-reset.f69c6fbc.svg",
    "2gZH2": "tool-hand.b64de96e.svg",
    "ghFv7": "edit-pencil.070f95f1.svg",
    "cazOx": "edit-crop.5a25544f.svg",
    "1mb1v": "add-layer.ec19e714.svg",
    "11KJK": "duplicate-layer.fd421984.svg",
    "floUo": "merge-layers.ec5eab67.svg",
    "hhQeq": "rename-layer.a037b591.svg",
    "dz3mY": "caret-down.5e676c46.svg",
    "045N6": "cursor-rotate.0c8e34b1.png",
    "eHdqz": "klecks-logo.ae8bd45e.png",
    "3x5dR": "new-image.1891be3f.svg",
    "hbDTd": "import.eacba42d.svg",
    "16iGk": "export.15a4d72c.svg",
    "2ME3z": "share.ab903904.svg",
    "hZnSk": "help.648f7d00.svg",
    "6mHrC": "tool-paint.1b2f44ed.svg",
    "hS5Hj": "tool-fill.bbd4ae51.svg",
    "4KGfM": "tool-gradient.dedc893d.svg",
    "doX4v": "tool-text.0da9f984.svg",
    "7NqHO": "tool-shape.522cd4b5.svg",
    "kOuYd": "tool-select.5ec1da7d.svg",
    "AnO0a": "tool-undo.9138898d.svg",
    "6toXQ": "edit-rotate.8fb5b1ef.svg",
    "b1UMP": "ui-collapse.da4b78fc.svg",
    "lvwQ5": "align-left.dd4a3407.svg",
    "imAvm": "align-center.13c1a9ae.svg",
    "dC0sF": "align-right.20a4fe41.svg",
    "h3hPo": "typo-italic.010c7282.svg",
    "1pAeY": "typo-bold.e186ac23.svg",
    "hapKl": "Caveat-Regular.2fe80bbd.woff2",
    "dqzux": "ClimateCrisis-Regular-VariableFont_YEAR.3ad02523.woff2",
    "l7VGL": "CorrectionBrush.a69973aa.woff2",
    "dm0T7": "DancingScript-Regular.ef2fe647.woff2",
    "2U3dq": "Diabolik-Regular-VF.f4eeb79e.woff2",
    "axzlU": "FreckleFace-Regular.05946539.woff2",
    "avgh6": "Gloock-Regular.60f8f765.woff2",
    "H9bSu": "Pacha.08c8457a.woff2",
    "emBfm": "GochiHand-Regular.c45792b0.woff2",
    "kjRvm": "PassionOne-Bold.9e08b0dc.woff2",
    "c79R0": "PixeloidSans.bc292131.woff2",
    "fndWQ": "PlaypenSans-Thin.314b29a4.woff2",
    "iAFmc": "Quicksand-Light.1f0c44a2.woff2",
    "2Bq6W": "Silkscreen-Regular.cef2b4cb.woff2",
    "hmfbp": "Tehroc-Regular.4540047b.woff2",
    "iItsG": "YUNGA-Display.30c04a15.woff2",
    "5tPq3": "edit-brightness-contrast.78620665.svg",
    "245NA": "edit-curves.56e09e16.svg",
    "1hkCG": "edit-flip.8010ad0f.svg",
    "k2eFf": "edit-hue-saturation.373aa41d.svg",
    "krKGd": "edit-invert.91bfa402.png",
    "ehfxY": "edit-perspective.474c436b.svg",
    "beOjS": "edit-resize.673fffa7.svg",
    "Gk9bV": "edit-tilt-shift.7ad164eb.png",
    "csed7": "edit-to-alpha.10878d74.svg",
    "equSE": "edit-transform.56e34528.svg",
    "h1dN3": "edit-triangle-blur.17417e43.png",
    "LfAXI": "edit-unsharp-mask.38afa514.png",
    "cB6q6": "edit-grid.c20f8e5f.svg",
    "S9ano": "edit-noise.20c18f19.svg",
    "4eqRj": "edit-pattern.f6d27c58.svg",
    "8mvSV": "edit-vanish-point.a8c2dde8.svg",
    "kbc0v": "edit-distort.33c9d58d.svg",
    "iiCd6": "brush-pen.c04fbc65.svg",
    "6fRlX": "brush-blend.d8ce5270.svg",
    "hC7PC": "brush-sketchy.6c75169d.png",
    "eZgVv": "brush-pixel.bfd351cf.svg",
    "fPZin": "brush-eraser.388bfa8c.svg",
    "fp7H1": "brush-smudge.9c9edfb1.svg",
    "eX098": "brush-chemy.a5a188f6.svg",
    "2oHM2": "upload.fb4a8f36.svg",
    "iGeXe": "loading.7ff8a2ac.gif",
    "kNYzr": "dist.b01f3369.js",
    "kSWIa": "bitbof-logo.738252a6.svg",
    "4FMUg": "ui-swap-lr.695f74b3.svg",
    "62mlz": "licenses.b5cc67ec.js",
    "76QQo": "font-licenses.2c928ed7.js",
    "2BZYe": "constrain.46a31747.svg",
    "k9Nks": "tab-settings.980aa34c.svg",
    "bBxqy": "tab-layers.e4748a75.svg",
    "3UXKl": "tab-edit.0d1e8b85.svg",
    "1dLwT": "cursor-picker.71be1460.png",
    "hQSEH": "cursor-fill.ab749dde.png",
    "916ZI": "cursor-text.b4ebf6cd.png",
    "9wZxU": "cursor-zoom-ew.d3ab2d60.png",
    "kiEfz": "select-mode-select.46ceb4fe.svg",
    "4uXfZ": "select-mode-move.321505b0.svg",
    "bjhUB": "select-default.a4d71ff2.svg",
    "9MYhm": "select-union.add41cd9.svg",
    "fsl8L": "select-subtract.f908cd8e.svg",
    "3QHUd": "select-shape-rect.ecb1b83c.svg",
    "5GkZe": "select-shape-ellipse.42a3a2f0.svg",
    "2zM6R": "select-shape-lasso.3dedd955.svg",
    "5rTlv": "select-shape-poly.25fd4f29.svg",
    "dmNGI": "select-transform-warp.b47bdcbe.svg"
});

/**
 * by bitbof (bitbof.com)
 */ 
var $1LaJZ = parcelRequire("1LaJZ");

var $fk3zw = parcelRequire("fk3zw");

var $8N5YG = parcelRequire("8N5YG");

var $bX4ja = parcelRequire("bX4ja");
/**
 * features that were available before module script tags:
 * chrome 61
 * edge 16
 * safari 11
 * firefox 60
 * https://caniuse.com/es6-module
 */ !function() {
    function t() {
        var e = Array.prototype.slice.call(arguments), n = document.createDocumentFragment();
        e.forEach(function(e) {
            var t = e instanceof Node;
            n.appendChild(t ? e : document.createTextNode(String(e)));
        }), this.appendChild(n);
    }
    [
        Element.prototype,
        Document.prototype,
        DocumentFragment.prototype
    ].forEach(function(e) {
        e.hasOwnProperty("append") || Object.defineProperty(e, "append", {
            configurable: !0,
            enumerable: !0,
            writable: !0,
            value: t
        });
    });
}();


!function() {
    function t() {
        var e = Array.prototype.slice.call(arguments), n = document.createDocumentFragment();
        e.forEach(function(e) {
            var t = e instanceof Node;
            n.appendChild(t ? e : document.createTextNode(String(e)));
        }), this.insertBefore(n, this.firstChild);
    }
    [
        Element.prototype,
        Document.prototype,
        DocumentFragment.prototype
    ].forEach(function(e) {
        e.hasOwnProperty("prepend") || Object.defineProperty(e, "prepend", {
            configurable: !0,
            enumerable: !0,
            writable: !0,
            value: t
        });
    });
}();


String.prototype.padStart || (String.prototype.padStart = function(t, n) {
    return t >>= 0, n = String(n || " "), this.length > t ? String(this) : ((t -= this.length) > n.length && (n += n.repeat(t / n.length)), n.slice(0, t) + String(this));
});


Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", {
    value: function value(r) {
        if (null == this) throw new TypeError('"this" is null or not defined');
        var e = Object(this), t = e.length >>> 0;
        if ("function" != typeof r) throw new TypeError("predicate must be a function");
        for(var n = arguments[1], o = 0; o < t;){
            var i = e[o];
            if (r.call(n, i, o, e)) return o;
            o++;
        }
        return -1;
    }
});




/*
 * ---- Below ----------------------
 * features that didn't have support until *after* browsers supported the modules script tag:
 * Chrome 61
 * Edge 16
 * Safari 11
 * Firefox 60
 * https://caniuse.com/es6-module
 */ // chrome 61, edge 79, safari 16, firefox 107
if (!('scrollTo' in Element.prototype)) Object.defineProperty(Element.prototype, 'scrollTo', {
    value: function value(x, y) {
        this.scrollLeft = x;
        this.scrollTop = y;
    }
});
// chrome 61, edge 79, safari 16, firefox 107
if (!('scrollBy' in Element.prototype)) Object.defineProperty(Element.prototype, 'scrollBy', {
    value: function value(x, y) {
        this.scrollLeft += x;
        this.scrollTop += y;
    }
});
// chrome 69, edge 79, safari 12, firefox 62
if (!Array.prototype.flat) Object.defineProperty(Array.prototype, 'flat', {
    configurable: true,
    value: function flat() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var depth = isNaN(args[0]) ? 1 : Number(args[0]);
        return depth ? Array.prototype.reduce.call(this, function(acc, cur) {
            if (Array.isArray(cur)) // eslint-disable-next-line prefer-spread
            acc.push.apply(acc, flat.call(cur, depth - 1));
            else acc.push(cur);
            return acc;
        }, []) : Array.prototype.slice.call(this);
    },
    writable: true
});
// chrome 69, edge 79, safari 12, firefox 62
if (!Array.prototype.flatMap) Object.defineProperty(Array.prototype, 'flatMap', {
    configurable: true,
    writable: true,
    value: function value(callback, thisArg) {
        if (typeof callback !== 'function') throw new TypeError(callback + ' is not a function');
        var result = [];
        for(var i = 0; i < this.length; i++)if (i in this) {
            var _result;
            var mapped = callback.call(thisArg, this[i], i, this);
            if (Array.isArray(mapped)) (_result = result).push.apply(_result, (0, $bX4ja._)(mapped));
            else result.push(mapped);
        }
        return result;
    }
});
// Chrome 85, Firefox 77, Safari 13.1
// if there are problems, maybe use core-js
if (!String.prototype.replaceAll) Object.defineProperty(String.prototype, 'replaceAll', {
    value: function value(searchValue, replaceValue) {
        if (typeof replaceValue === 'function') throw new Error('replaceAll polyfill does not support replaceValue: function');
        return this.replace(new RegExp(searchValue, 'g'), replaceValue);
    }
});
// Chrome 92, Firefox 90, Safari 15.4
if (!('at' in Array.prototype)) Object.defineProperty(Array.prototype, 'at', {
    value: function value(index) {
        if (index > 0) return this[index];
        if (index < 0) return this[index + this.length];
    }
});
/*
    Copyright 2018  Alfredo Mungo <alfredo.mungo@protonmail.ch>

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to
    deal in the Software without restriction, including without limitation the
    rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
    sell copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in
    all copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
    FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
    IN THE SOFTWARE.
*/ if (!Object.fromEntries) Object.defineProperty(Object, 'fromEntries', {
    value (entries) {
        if (!entries || !entries[Symbol.iterator]) throw new Error('Object.fromEntries() requires a single iterable argument');
        var o = {};
        Object.keys(entries).forEach(function(key) {
            var _entries_key = (0, $8N5YG._)(entries[key], 2), k = _entries_key[0], v = _entries_key[1];
            o[k] = v;
        });
        return o;
    }
});
// sometimes Android WebView has no localStorage
if (!('localStorage' in window)) try {
    window.localStorage = {
        getItem: function() {
            return null;
        },
        setItem: function() {},
        removeItem: function() {}
    };
} catch (e) {
// maybe it fails?
}



var $1LaJZ = parcelRequire("1LaJZ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $8N5YG = parcelRequire("8N5YG");

var $bX4ja = parcelRequire("bX4ja");

var $fk3zw = parcelRequire("fk3zw");
/**
 * track how many modals are opened
 */ 
var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $dd0d395ff14a3e11$export$f5386afdb763a67e = /*#__PURE__*/ function() {
    "use strict";
    function DialogCounter() {
        (0, $cx0mh._)(this, DialogCounter);
        this.listeners = [];
        this.count = 0;
    }
    (0, $7h4XF._)(DialogCounter, [
        {
            key: "emit",
            value: function emit() {
                var _this = this;
                this.listeners.forEach(function(item) {
                    item(_this.count);
                });
            }
        },
        {
            // ----------------------------------- public -----------------------------------
            key: "increase",
            value: function increase(v) {
                if (v !== undefined) this.count += v;
                else this.count++;
                this.emit();
            }
        },
        {
            key: "decrease",
            value: function decrease(v) {
                if (v !== undefined) this.count -= v;
                else this.count--;
                this.emit();
            }
        },
        {
            key: "get",
            value: function get() {
                return this.count;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(listener) {
                this.listeners.push(listener);
            }
        }
    ]);
    return DialogCounter;
}();
var $dd0d395ff14a3e11$export$d3d1650bc39c4419 = new $dd0d395ff14a3e11$export$f5386afdb763a67e();



var $eWjiX = parcelRequire("eWjiX");

var $1LaJZ = parcelRequire("1LaJZ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $fk3zw = parcelRequire("fk3zw");
// generated from src/languages. "npm run lang:build" to update

var $1LaJZ = parcelRequire("1LaJZ");

var $fk3zw = parcelRequire("fk3zw");
var $db912034305429b0$exports = {};
$db912034305429b0$exports = JSON.parse('{"switch-ui-left-right":"Switch left/right UI","toggle-show-tools":"Show/Hide Tools","scroll":"Scroll","donate":"Donate","home":"Home","modal-new-tab":"Open in new tab","tab-edit":"Edit","tab-file":"File","tool-brush":"Brush","tool-paint-bucket":"Paint Bucket","tool-gradient":"Gradient","tool-shape":"Shape","tool-text":"Text","tool-hand":"Hand Tool","tool-select":"Select Tool","tool-zoom":"Zoom","tool-more-tools":"More Tools","tool-more-tools-click-again":"Click again for more tools","undo":"Undo","redo":"Redo","brush-pen":"Pen","brush-blend":"Blend","brush-sketchy":"Sketchy","brush-pixel":"Pixel","brush-chemy":"Chemy","brush-smudge":"Smudge","brush-size":"Size","brush-blending":"Blending","brush-toggle-pressure":"Toggle Pressure Sensitivity","brush-pen-circle":"Circle","brush-pen-chalk":"Chalk","brush-pen-calligraphy":"Calligraphy","brush-pen-square":"Square","brush-sketchy-scale":"Scale","brush-pixel-dither":"Dither","brush-chemy-fill":"Fill","brush-chemy-stroke":"Stroke","brush-chemy-mirror-x":"Horizontal Symmetry","brush-chemy-mirror-y":"Vertical Symmetry","brush-chemy-gradient":"Gradient","brush-eraser-transparent-bg":"Transparent Background","stabilizer":"Stabilizer","stabilizer-title":"Stroke Stabilizer","eyedropper":"Eyedropper","secondary-color":"Secondary Color","manual-color-input":"Manual Color Input","mci-hex":"Hex","mci-copy":"Copy","modal-ok":"Ok","modal-cancel":"Cancel","modal-close":"Close","layers-active-layer":"Active Layer","layers-layer":"Layer","layers-copy":"copy","layers-blending":"Blending","layers-new":"New Layer","layers-remove":"Remove Layer","layers-duplicate":"Duplicate Layer","layers-merge":"Merge with layer below","layers-clear":"Clear layer","layers-merge-advanced":"Advanced merge","layers-merge-all":"Merge all","layers-rename":"Rename","layers-active-layer-visible":"Active layer is visible","layers-active-layer-hidden":"Active layer is hidden","layers-visibility-toggle":"Layer Visibility","layers-blend-normal":"normal","layers-blend-darken":"darken","layers-blend-multiply":"multiply","layers-blend-color-burn":"color burn","layers-blend-lighten":"lighten","layers-blend-screen":"screen","layers-blend-color-dodge":"color dodge","layers-blend-overlay":"overlay","layers-blend-soft-light":"soft light","layers-blend-hard-light":"hard light","layers-blend-difference":"difference","layers-blend-exclusion":"exclusion","layers-blend-hue":"hue","layers-blend-saturation":"saturation","layers-blend-color":"color","layers-blend-luminosity":"luminosity","layers-rename-title":"Rename Layer","layers-rename-name":"Name","layers-rename-clear":"Clear Name","layers-rename-sketch":"Sketch","layers-rename-colors":"Colors","layers-rename-shading":"Shading","layers-rename-lines":"Lines","layers-rename-effects":"Effects","layers-rename-foreground":"Foreground","layers-merge-modal-title":"Merge/Mix Layers","layers-merge-description":"Merges the selected layer with the one underneath. Select the mix mode:","file-no-autosave":"No autosave, no cloud storage","file-new":"New","file-import":"Import","file-save":"Save","file-format":"File Format","file-show-save-dialog":"Show save dialog","file-copy":"Copy","file-copy-title":"Copy To Clipboard","file-paste":"Paste","file-share":"Share","file-storage":"Browser Storage","file-storage-about":"About Browser Storage","file-storage-cant-access":"Can\'t access storage.","file-storage-empty":"Empty","file-storage-store":"Store","file-storage-open":"Open","file-storage-open-confirmation":"This image is already open in another tab. Open it here too?","file-storage-open-failed":"Failed to load.","file-storage-clear":"Clear","file-storage-clear-prompt":"Clear Browser Storage? Clearing can not be undone.","file-storage-storing":"Storing","file-storage-overwrite":"Overwrite","file-storage-overwrite-confirm":"Overwrite Browser Storage? Overwritten data will be permanently deleted.","file-storage-min-ago":"{x}min ago","file-storage-hours-ago":"{x}h ago","file-storage-days-ago":"{x}d ago","file-storage-month-ago":"> 1month ago","file-storage-restored":"Restored from Browser Storage","file-storage-stored":"Stored to Browser Storage","file-storage-failed":"Failed to store to Browser Storage","file-storage-failed-1":"Failed to store. Possible causes:","file-storage-failed-2":"Out of disk space","file-storage-failed-3":"Storage disabled in incognito tab","file-storage-failed-4":"Browser doesn\'t support storage","file-storage-failed-clear":"Failed to clear.","file-upload":"Upload","tab-recovery-recover-tabs":"Recover closed tabs","tab-recovery-explanation":"Recovery data is only kept for a little while. Save to ensure your work is not lost.","tab-recovery-total-quota-label":"Total:","tab-recovery-empty":"Nothing to recover.","tab-recovery-recover":"Recover","tab-recovery-delete":"Delete","tab-recovery-delete-confirmation":"Delete this recovery? Deletion can not be undone.","tab-recovery-failed-to-recover":"Failed to recover tab.","tab-recovery-recovered":"Tab recovered.","cleared-layer":"Cleared layer","cleared-selected-area":"Cleared selected area","filled":"Filled","filled-selected-area":"Filled selection","new-title":"New Image","new-current":"Current","new-fit":"Fit","new-oversize":"Oversize","new-square":"Square","new-landscape":"Landscape","new-portrait":"Portrait","new-screen":"Screen","new-video":"Video","new-din-paper":"DIN Paper","new-px":"px","new-ratio":"Ratio","upload-title":"Upload to Imgur","upload-link-notice":"Anyone with the link to your uploaded image will be able to view it.","upload-name":"Title","upload-title-untitled":"Untitled","upload-caption":"Caption","upload-submit":"Upload","upload-uploading":"Uploading...","upload-success":"Upload Successful","upload-failed":"Upload failed.","upload-delete":"To delete your image from Imgur visit:","cropcopy-title-copy":"Copy To Clipboard","cropcopy-title-crop":"Crop","cropcopy-mask":"Mask unselected","cropcopy-click-hold":"Right-click or press hold to copy.","cropcopy-btn-copy":"To Clipboard","cropcopy-copied":"Copied.","cropcopy-btn-crop":"Apply Crop","crop-drag-to-crop":"Drag to crop","filter-crop-extend":"Crop/Extend","filter-flip":"Flip","filter-perspective":"Perspective","filter-resize":"Resize","filter-rotate":"Rotate","filter-transform":"Transform","filter-bright-contrast":"Bright/Contrast","filter-curves":"Curves","filter-hue-sat":"Hue/Saturation","filter-invert":"Invert","filter-tilt-shift":"Tilt Shift","filter-to-alpha":"To Alpha","filter-triangle-blur":"Triangle Blur","filter-unsharp-mask":"Unsharp Mask","filter-crop-title":"Crop / Extend","filter-crop-description":"Crop or extend the image.","filter-crop-left":"Left","filter-crop-right":"Right","filter-crop-top":"Top","filter-crop-bottom":"Bottom","filter-crop-rule-thirds":"Rule of Thirds","filter-crop-fill":"Fill","filter-flip-title":"Flip","filter-flip-description":"Flips layer or whole image.","filter-flip-horizontal":"Horizontal","filter-flip-vertical":"Vertical","filter-flip-image":"Flip Image","filter-flip-layer":"Flip Layer","filter-perspective-title":"Perspective","filter-perspective-description":"Transforms the selected layer.","filter-resize-title":"Resize","filter-resize-description":"Resizes the image.","filter-rotate-title":"Rotate","filter-rotate-description":"Rotates the image.","filter-transform-empty":"Layer is empty.","filter-transform-empty-selection":"Layer is empty in selected area.","filter-transform-title":"Transform","filter-transform-description":"Transforms selected layer. Hold Shift for additional behavior.","filter-transform-rotation":"Rotation","filter-transform-flip":"Flip","filter-transform-center":"Center","filter-transform-constrain":"Constrain","filter-transform-snap":"Snap","filter-transform-snap-title":"Snap Rotation And Position","filter-bright-contrast-title":"Brightness / Contrast","filter-bright-contrast-description":"Change brightness and contrast for the selected layer.","filter-bright-contrast-brightness":"Brightness","filter-bright-contrast-contrast":"Contrast","filter-curves-title":"Curves","filter-curves-description":"Apply curves on the selected layer.","filter-curves-all":"All","filter-hue-sat-title":"Hue / Saturation","filter-hue-sat-description":"Change hue and saturation for the selected layer.","filter-hue-sat-hue":"Hue","filter-hue-sat-saturation":"Saturation","filter-applied":"\\"{x}\\" applied","filter-tilt-shift-title":"Tilt Shift","filter-tilt-shift-description":"Applies tilt shift on the selected layer.","filter-tilt-shift-blur":"Blur Radius","filter-tilt-shift-gradient":"Gradient Radius","filter-to-alpha-title":"To Alpha","filter-to-alpha-description":"Generates alpha channel for selected layer from:","filter-to-alpha-inverted-lum":"Inverted Luminance","filter-to-alpha-lum":"Luminance","filter-to-alpha-replace":"Replace RGB","filter-triangle-blur-title":"Triangle Blur","filter-triangle-blur-description":"Applies triangle blur on the selected layer.","filter-unsharp-mask-title":"Unsharp Mask","filter-unsharp-mask-description":"Sharpens the selected layer by scaling pixels away from the average of their neighbors.","filter-unsharp-mask-strength":"Strength","filter-grid":"Grid","filter-grid-description":"Draws grid on selected layer.","filter-noise":"Noise","filter-noise-description":"Adds noise to selected layer.","filter-noise-scale":"Scale","filter-noise-alpha":"Alpha","filter-pattern":"Pattern","filter-pattern-description":"Generates pattern on selected layer. Drag the preview for further controls.","filter-distort":"Distort","filter-distort-description":"Distorts the selected layer.","filter-distort-phase":"Phase","filter-distort-stepsize":"Step Size","filter-distort-sync-xy":"Sync XY","filter-vanish-point":"Vanish Point","filter-vanish-point-title":"Vanishing Point","filter-vanish-point-description":"Adds vanishing point to selected layer. Drag preview to move.","filter-vanish-point-lines":"Lines","dropper-drop":"Drop to import","dropper-as-image":"As New Image","dropper-as-layer":"As Layer","import-opening":"Opening file...","import-title":"Import Image","import-too-large":"Image too large, will be downscaled.","import-btn-as-layer":"As Layer","import-btn-as-image":"As Image","import-as-layer-title":"Import Image as New Layer","import-as-layer-description":"Adjust the position of the imported image.","import-as-layer-limit-reached":"Layer limit reached. Image will be placed on existing layer.","import-as-layer-fit":"Fit","import-flatten":"Flatten image","import-unsupported-file":"Unsupported file type. See Help for supported types.","import-broken-file":"Couldn\'t load image. File might be corrupted.","import-psd-unsupported":"Unsupported features. PSD had to be flattened.","import-psd-limited-support":"PSD support is limited. Flattened will more likely look correct.","import-psd-too-large":"Image exceeds maximum dimensions of {x} x {x} pixels. Unable to import.","import-psd-size":"Image size","clipboard-read-fail":"Failed to read from clipboard.","clipboard-no-image":"No image found in clipboard.","hand-reset":"Reset","hand-fit":"Fit","hand-inertia-scrolling":"Inertia Scrolling","bucket-tolerance":"Tolerance","bucket-sample":"Sample","bucket-sample-title":"Which layers to sample color from","bucket-sample-all":"All","bucket-sample-active":"Active","bucket-sample-above":"Above","bucket-grow":"Grow","bucket-grow-title":"Grow filled area (in pixels)","bucket-contiguous":"Contiguous","bucket-contiguous-title":"Only fill connected areas","gradient-linear":"Linear","gradient-linear-mirror":"Linear-Mirror","gradient-radial":"Radial","shape-stroke":"Stroke","shape-fill":"Fill","shape-rect":"Rectangle","shape-ellipse":"Ellipse","shape-line":"Line","shape-line-width":"Line Width","shape-outwards":"Outwards","shape-fixed":"Fixed 1:1","shape-auto-pan":"Auto-pan","shape-auto-pan-title":"Automatically moves as you draw","text-instruction":"Click canvas to place text","text-title":"Add Text","text-text":"Text","text-font":"Font","text-placeholder":"Your text","text-color":"Color","text-size":"Size","text-line-height":"Line Height","text-letter-spacing":"Letter Spacing","text-left":"Left","text-center":"Center","text-right":"Right","text-italic":"Italic","text-bold":"Bold","text-failed-import":"Failed to import the following files:","text-supported-formats":"Supported formats:","select-select":"Select","select-transform":"Transform","select-lasso":"Lasso","select-polygon":"Polygon","select-boolean-replace":"Replace","select-boolean-add":"Add","select-boolean-subtract":"Subtract","select-all":"All","select-invert":"Invert","select-reset":"Reset","select-fill":"Fill","select-erase":"Erase","select-transform-warp":"Warp","select-transform-clone":"Clone","select-transform-clone-applied":"Cloned","select-transform-move-to-layer":"Move to layer:","select-transform-applied":"Transformation applied","select-transform-empty":"Selected area on active layer is empty.","save-reminder-title":"Unsaved Work","save-reminder-text":"Image was not saved in {a} minutes{b}. Save now to prevent eventual loss.","save-reminder-save-psd":"Save As PSD","save-reminder-psd-layers":"PSD will remember all layers.","backup-drawing":"You can backup your drawing.","submit":"Submit","submit-title":"Submit Drawing","submit-prompt":"Submit drawing?","submit-submitting":"Submitting","embed-init-loading":"Loading app","embed-init-waiting":"Waiting for image","help":"Help","tab-settings":"Settings","settings-language":"Language","settings-language-reload":"Will update after reloading.","settings-theme":"Theme","settings-save-reminder-label":"Save Reminder","settings-save-reminder-disabled":"disabled","settings-save-reminder-confirm-title":"Turn off Save Reminder?","settings-save-reminder-confirm-a":"There is no autosave and browser tabs don\'t last forever. If you don\'t periodically save you will likely lose work.","settings-save-reminder-confirm-b":"Disable at your own risk?","settings-save-reminder-confirm-disable":"Disable","theme-dark":"Dark","theme-light":"Light","terms-of-service":"Terms of Service","licenses":"Licenses","source-code":"Source Code","auto":"auto","zoom-in":"Zoom In","zoom-out":"Zoom Out","radius":"Radius","constrain-proportions":"Constrain Proportions","width":"Width","height":"Height","opacity":"Opacity","scatter":"Scatter","red":"Red","green":"Green","blue":"Blue","eraser":"Eraser","center":"Center","layers":"Layers","background":"Background","scaling-algorithm":"Scaling Algorithm","algorithm-smooth":"Smooth","algorithm-pixelated":"Pixelated","preview":"Preview","angle-snap":"Snap","angle-snap-title":"45\xb0 Angle Snapping","lock-alpha":"Lock Alpha","lock-alpha-title":"Locks layer\'s alpha channel","reverse":"Reverse","compare-before":"Before","compare-after":"After","loading":"Loading","more":"More","x-minutes":"{x}min","wip":"Work in progress","browser-zoom-help":"Double-tap or pinch-out to reset browser zoom.","dismiss":"Dismiss"}');


var $90c6410f4b764e9c$export$33e6c23ebe2ee669 = (0, (/*@__PURE__*/$parcel$interopDefault($db912034305429b0$exports)));
var $90c6410f4b764e9c$export$d0d68bb9ed2c643d = [
    {
        code: 'en',
        name: 'English'
    },
    {
        code: 'de',
        name: 'Deutsch'
    },
    {
        code: 'es',
        name: "Espa\xf1ol"
    },
    {
        code: 'fi',
        name: 'suomi'
    },
    {
        code: 'fr',
        name: "Fran\xe7ais"
    },
    {
        code: 'hu',
        name: 'Magyar'
    },
    {
        code: 'id',
        name: 'Bahasa Indonesia'
    },
    {
        code: 'ja',
        name: "\u65E5\u672C\u8A9E"
    },
    {
        code: 'jv',
        name: 'Basa Jawa'
    },
    {
        code: 'ko',
        name: "\uD55C\uAD6D\uC5B4"
    },
    {
        code: 'lv',
        name: "Latvie\u0161u Valoda"
    },
    {
        code: 'nl',
        name: 'Nederlands'
    },
    {
        code: 'pt-BR',
        name: "Portugu\xeas Brasil"
    },
    {
        code: 'ru',
        name: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439"
    },
    {
        code: 'su',
        name: 'Basa Sunda'
    },
    {
        code: 'sv',
        name: 'Svenska'
    },
    {
        code: 'zh-CN',
        name: "\u7B80\u4F53\u4E2D\u6587"
    },
    {
        code: 'zh-TW',
        name: "\u7E41\u9AD4\u4E2D\u6587"
    }
];

















var $90c6410f4b764e9c$export$f02cbd868e2f57cf = function(code) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(code === 'en')) return [
                        3,
                        1
                    ];
                    return [
                        2,
                        $90c6410f4b764e9c$export$33e6c23ebe2ee669
                    ];
                case 1:
                    if (!(code === 'de')) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        (parcelRequire("8mlhh"))
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    if (!(code === 'es')) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (parcelRequire("hLG03"))
                    ];
                case 4:
                    return [
                        2,
                        _state.sent()
                    ];
                case 5:
                    if (!(code === 'fi')) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        (parcelRequire("kJrPi"))
                    ];
                case 6:
                    return [
                        2,
                        _state.sent()
                    ];
                case 7:
                    if (!(code === 'fr')) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        (parcelRequire("bI71U"))
                    ];
                case 8:
                    return [
                        2,
                        _state.sent()
                    ];
                case 9:
                    if (!(code === 'hu')) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        (parcelRequire("eICi1"))
                    ];
                case 10:
                    return [
                        2,
                        _state.sent()
                    ];
                case 11:
                    if (!(code === 'id')) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        (parcelRequire("kqusB"))
                    ];
                case 12:
                    return [
                        2,
                        _state.sent()
                    ];
                case 13:
                    if (!(code === 'ja')) return [
                        3,
                        15
                    ];
                    return [
                        4,
                        (parcelRequire("57GX6"))
                    ];
                case 14:
                    return [
                        2,
                        _state.sent()
                    ];
                case 15:
                    if (!(code === 'jv')) return [
                        3,
                        17
                    ];
                    return [
                        4,
                        (parcelRequire("h75GH"))
                    ];
                case 16:
                    return [
                        2,
                        _state.sent()
                    ];
                case 17:
                    if (!(code === 'ko')) return [
                        3,
                        19
                    ];
                    return [
                        4,
                        (parcelRequire("55azR"))
                    ];
                case 18:
                    return [
                        2,
                        _state.sent()
                    ];
                case 19:
                    if (!(code === 'lv')) return [
                        3,
                        21
                    ];
                    return [
                        4,
                        (parcelRequire("fWO0c"))
                    ];
                case 20:
                    return [
                        2,
                        _state.sent()
                    ];
                case 21:
                    if (!(code === 'nl')) return [
                        3,
                        23
                    ];
                    return [
                        4,
                        (parcelRequire("4zES7"))
                    ];
                case 22:
                    return [
                        2,
                        _state.sent()
                    ];
                case 23:
                    if (!(code === 'pt-BR')) return [
                        3,
                        25
                    ];
                    return [
                        4,
                        (parcelRequire("7KXHm"))
                    ];
                case 24:
                    return [
                        2,
                        _state.sent()
                    ];
                case 25:
                    if (!(code === 'ru')) return [
                        3,
                        27
                    ];
                    return [
                        4,
                        (parcelRequire("aqoL6"))
                    ];
                case 26:
                    return [
                        2,
                        _state.sent()
                    ];
                case 27:
                    if (!(code === 'su')) return [
                        3,
                        29
                    ];
                    return [
                        4,
                        (parcelRequire("7TgKV"))
                    ];
                case 28:
                    return [
                        2,
                        _state.sent()
                    ];
                case 29:
                    if (!(code === 'sv')) return [
                        3,
                        31
                    ];
                    return [
                        4,
                        (parcelRequire("2HU4B"))
                    ];
                case 30:
                    return [
                        2,
                        _state.sent()
                    ];
                case 31:
                    if (!(code === 'zh-CN')) return [
                        3,
                        33
                    ];
                    return [
                        4,
                        (parcelRequire("lWIVr"))
                    ];
                case 32:
                    return [
                        2,
                        _state.sent()
                    ];
                case 33:
                    if (!(code === 'zh-TW')) return [
                        3,
                        35
                    ];
                    return [
                        4,
                        (parcelRequire("bGxAd"))
                    ];
                case 34:
                    return [
                        2,
                        _state.sent()
                    ];
                case 35:
                    throw new Error('unknown language code');
            }
        });
    })();
};
 // Dismiss



var $6l0gQ = parcelRequire("6l0gQ");
var $8d7403abedf7cefa$export$991796128b2ca217 = 'klecks-language';
var $8d7403abedf7cefa$var$LanguageStrings = /*#__PURE__*/ function() {
    "use strict";
    function LanguageStrings() {
        (0, $cx0mh._)(this, LanguageStrings);
        this.listeners = [];
        // need to use setLanguage for a different language
        this.data = (0, $cL71g._)({}, (0, $90c6410f4b764e9c$export$33e6c23ebe2ee669));
        this.code = 'en';
    }
    (0, $7h4XF._)(LanguageStrings, [
        {
            key: "setLanguage",
            value: function setLanguage(langCode) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _, _tmp;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(langCode === 'en')) return [
                                    3,
                                    1
                                ];
                                this.data = (0, $cL71g._)({}, (0, $90c6410f4b764e9c$export$33e6c23ebe2ee669));
                                return [
                                    3,
                                    3
                                ];
                            case 1:
                                _ = this;
                                _tmp = [
                                    {},
                                    (0, $90c6410f4b764e9c$export$33e6c23ebe2ee669)
                                ];
                                return [
                                    4,
                                    (0, $90c6410f4b764e9c$export$f02cbd868e2f57cf)(langCode)
                                ];
                            case 2:
                                _.data = (0, $cL71g._).apply(void 0, _tmp.concat([
                                    _state.sent()
                                ]));
                                _state.label = 3;
                            case 3:
                                this.code = langCode;
                                document.documentElement.setAttribute('lang', langCode);
                                this.listeners.forEach(function(item) {
                                    item();
                                });
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "get",
            value: function get(code) {
                if (!(code in this.data)) throw new Error("translation code doesn't exist: " + code);
                return this.data[code];
            }
        },
        {
            key: "getLanguage",
            value: function getLanguage() {
                var _this = this;
                return (0, $90c6410f4b764e9c$export$d0d68bb9ed2c643d).find(function(item) {
                    return item.code === _this.code;
                });
            }
        },
        {
            key: "getAutoLanguage",
            value: function getAutoLanguage() {
                var autoCode = $8d7403abedf7cefa$export$64783e31db14f0ba(false);
                return (0, $90c6410f4b764e9c$export$d0d68bb9ed2c643d).find(function(item) {
                    return item.code === autoCode;
                });
            }
        },
        {
            key: "getCode",
            value: function getCode() {
                return this.code;
            }
        },
        {
            // get notified on language change
            key: "subscribe",
            value: function subscribe(subscriber) {
                if (this.listeners.includes(subscriber)) return;
                this.listeners.push(subscriber);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(subscriber) {
                for(var i = 0; i < this.listeners.length; i++)if (subscriber === this.listeners[i]) {
                    this.listeners.splice(i, 1);
                    return;
                }
            }
        }
    ]);
    return LanguageStrings;
}();
function $8d7403abedf7cefa$export$64783e31db14f0ba(useLocalStorage) {
    var _loop = function(i) {
        var lang = langs[i];
        var found = (0, $90c6410f4b764e9c$export$d0d68bb9ed2c643d).find(function(item) {
            return item.code.toLowerCase() === lang.toLowerCase();
        });
        if (found) {
            result = found.code;
            return "break";
        }
    };
    var result = 'en';
    var langs = []; // from highest to lowest priority
    var navLangs = navigator.languages ? navigator.languages : [
        navigator.language
    ];
    navLangs.forEach(function(item) {
        var split = item.split('-');
        langs.push(item);
        if (split.length === 2) langs.push(split[0]);
    });
    if (useLocalStorage) try {
        var item = (0, $6l0gQ.LocalStorage).getItem($8d7403abedf7cefa$export$991796128b2ca217);
        if (item) langs.unshift(item);
    } catch (e) {
    // likely cookies disabled in Safari
    }
    for(var i = 0; i < langs.length; i++){
        var _ret = _loop(i);
        if (_ret === "break") break;
    }
    return result;
}
var $8d7403abedf7cefa$var$activeLanguageCode = $8d7403abedf7cefa$export$64783e31db14f0ba(true);
var $8d7403abedf7cefa$export$e4ce066d17694649 = new $8d7403abedf7cefa$var$LanguageStrings();
var $8d7403abedf7cefa$export$ce37e184d908d785 = function(code, replace) {
    if (replace) {
        var result = $8d7403abedf7cefa$export$e4ce066d17694649.get(code);
        var keyArr = Object.keys(replace);
        keyArr.forEach(function(key) {
            result = result.replace(`{${key}}`, replace[key]);
        });
        return result;
    } else return $8d7403abedf7cefa$export$e4ce066d17694649.get(code);
};
var $8d7403abedf7cefa$export$7a2ea9f2e4d199d3 = function() {
    return $8d7403abedf7cefa$export$e4ce066d17694649.setLanguage($8d7403abedf7cefa$var$activeLanguageCode);
};


window.onscroll = function(e) {
    e.preventDefault();
};


var $e33dc4efcac9043e$exports = {};
$e33dc4efcac9043e$exports = $parcel$resolve("kbyFQ");


var $10da88069cb8e734$exports = {};
$10da88069cb8e734$exports = $parcel$resolve("l7FYj");


var $720ba2c010612610$exports = {};
$720ba2c010612610$exports = $parcel$resolve("kino6");


function $c902829f68f42bce$export$d7e8d4d4450c819c(p) {
    (0, $dd0d395ff14a3e11$export$d3d1650bc39c4419).increase();
    var isClosed = false;
    var ignoreBackground = !!p.ignoreBackground;
    // need this extra layer because chrome mobile otherwise scrolls the page and then glitches as the address bar goes away
    var rootRootEl = (0, $eWjiX.BB).el({
        parent: document.body,
        css: {
            position: 'absolute',
            left: '0',
            top: '0',
            right: '0',
            bottom: '0',
            overflow: 'hidden'
        }
    });
    var rootEl = (0, $eWjiX.BB).el({
        parent: rootRootEl,
        className: 'kl-popup'
    });
    var scrollContent = (0, $eWjiX.BB).el({
        parent: rootEl,
        css: {
            width: '100%',
            minHeight: '100%',
            // padding: '10px 0',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
        }
    });
    var bgEl = (0, $eWjiX.BB).el({
        parent: scrollContent,
        onClick: function() {
            if (ignoreBackground) return;
            close('Cancel');
        },
        css: {
            position: 'absolute',
            left: '0',
            top: '0',
            zIndex: '0',
            width: '100%',
            height: '100%'
        }
    });
    var titleHeight = 40;
    var xButton = (0, $eWjiX.BB).el({
        tagName: 'button',
        className: 'popup-x',
        content: `<img alt="${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('modal-close')}" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($e33dc4efcac9043e$exports)))}">`,
        title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('modal-close'),
        onClick: function() {
            close('Cancel');
        },
        css: {
            width: titleHeight + 'px',
            height: titleHeight + 'px',
            lineHeight: titleHeight + 'px',
            position: 'absolute',
            right: '0',
            top: '0',
            background: 'none',
            boxShadow: 'none'
        }
    });
    var icon = undefined;
    if (p.type) icon = (0, $eWjiX.BB).el({
        className: {
            error: 'kl-popup__icon-error',
            ok: 'kl-popup__icon-ok',
            warning: 'kl-popup__icon-warning',
            upload: 'kl-popup__icon-upload'
        }[p.type]
    });
    var boxClasses = [
        'kl-popup-box'
    ];
    boxClasses.push('kl-popup-box--sm');
    var boxEl = (0, $eWjiX.BB).el({
        content: [
            xButton,
            icon,
            (0, $eWjiX.BB).el({
                content: p.message,
                css: {
                    marginRight: '15px',
                    marginBottom: p.div ? '10px' : undefined
                }
            }),
            p.div
        ],
        className: boxClasses.join(' '),
        css: p.style ? p.style : undefined
    });
    scrollContent.append((0, $eWjiX.BB).el({
        css: {
            flex: '0.5'
        }
    }), boxEl, (0, $eWjiX.BB).el({
        css: {
            flex: '1'
        }
    }));
    var keyListener = new (0, $eWjiX.BB).KeyListener({
        onDown: function onDown(keyStr, e, comboStr) {
            if (isClosed) return;
            if (clickOnEnterBtn && comboStr === 'enter' && !(0, $eWjiX.BB).isInputFocused()) {
                e.stopPropagation();
                setTimeout(function() {
                    clickOnEnterBtn && clickOnEnterBtn.click();
                }, 10);
            }
            if (comboStr === 'esc') {
                e.stopPropagation();
                e.preventDefault(); // stay in fullscreen on Mac
                close('Cancel');
            }
        }
    });
    // prevent ctrl scroll -> zooming page
    var wheelPrevent = function(event) {
        if (keyListener.isPressed('ctrl')) event.preventDefault();
    };
    rootEl.addEventListener('wheel', wheelPrevent, {
        passive: false
    });
    rootEl.onclick = (0, $eWjiX.BB).handleClick;
    var autoFocus;
    if (p.autoFocus) autoFocus = p.autoFocus;
    else if (p.autoFocus === false) autoFocus = undefined;
    else autoFocus = 'Ok';
    var buttonRowEl = p.buttons && p.buttons.length > 0 ? (0, $eWjiX.BB).el({
        parent: boxEl,
        css: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
            marginTop: '12px',
            marginLeft: '-8px'
        }
    }) : undefined;
    var clickOnEnterBtn;
    var btnElArr = [];
    if (p.buttons) p.buttons.forEach(function(buttonName) {
        var btnClasses = [
            'kl-popup__btn'
        ];
        if (buttonName === 'Ok' || p.primaries && p.primaries.includes(buttonName)) btnClasses.push('kl-button-primary');
        if (buttonName === p.deleteButtonName) btnClasses.push('kl-button-delete');
        var iconUrl;
        var label = buttonName;
        if (buttonName === 'Ok') {
            label = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('modal-ok');
            iconUrl = (0, (/*@__PURE__*/$parcel$interopDefault($10da88069cb8e734$exports)));
        }
        if (buttonName === 'Cancel') {
            label = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('modal-cancel');
            iconUrl = (0, (/*@__PURE__*/$parcel$interopDefault($e33dc4efcac9043e$exports)));
            btnClasses.push('kl-button-cancel');
        }
        if (buttonName === p.deleteButtonName) iconUrl = (0, (/*@__PURE__*/$parcel$interopDefault($720ba2c010612610$exports)));
        var iconImg = undefined;
        if (iconUrl) iconImg = (0, $eWjiX.BB).el({
            tagName: 'img',
            custom: {
                src: iconUrl,
                height: '17'
            }
        });
        var btn = (0, $eWjiX.BB).el({
            parent: buttonRowEl,
            tagName: 'button',
            className: btnClasses.join(' '),
            content: [
                iconImg,
                (0, $eWjiX.BB).el({
                    className: 'kl-popup__btn__text',
                    content: label
                })
            ],
            onClick: function() {
                close(buttonName);
            }
        });
        btnElArr.push(btn);
        if (autoFocus === buttonName) {
            setTimeout(function() {
                btn.focus();
                rootEl.scrollTo(0, 0);
            }, 10);
            setTimeout(function() {
                // safari needs a separate timeout
                rootEl.scrollTo(0, 0);
            }, 20);
        }
        if (buttonName === p.clickOnEnter) clickOnEnterBtn = btn;
    });
    function close(value) {
        if (isClosed) return;
        isClosed = true;
        (0, $eWjiX.BB).clearSelection();
        (0, $eWjiX.BB).unfocusAnyInput();
        rootRootEl.remove();
        (0, $dd0d395ff14a3e11$export$d3d1650bc39c4419).decrease();
        (0, $eWjiX.BB).destroyEl(xButton);
        (0, $eWjiX.BB).destroyEl(bgEl);
        keyListener.destroy();
        rootEl.removeEventListener('wheel', wheelPrevent);
        // (disabled) eslint-disable-next-line no-null/no-null
        rootEl.onclick = null;
        btnElArr.forEach(function(item) {
            return (0, $eWjiX.BB).destroyEl(item);
        });
        btnElArr.splice(0, btnElArr.length);
        if (p.callback) p.callback(value);
    }
    if (p.closeFunc) p.closeFunc(function() {
        close('Cancel');
    });
    return {
        setIgnoreBackground: function(b) {
            ignoreBackground = b;
        }
    };
}



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");


var $eWjiX = parcelRequire("eWjiX");




var $7jh4K = parcelRequire("7jh4K");
var $e59fbd08bcc1a36b$export$185108a9b725b68 = /*#__PURE__*/ function() {
    "use strict";
    function DynamicModal(p) {
        var _this = this;
        (0, $cx0mh._)(this, DynamicModal);
        (0, $dd0d395ff14a3e11$export$d3d1650bc39c4419).increase();
        this.onClose = p.onClose;
        this.parent = document.body;
        this.rootEl = (0, $eWjiX.BB).el({
            parent: this.parent,
            className: 'g-root kl-d-modal-root',
            css: {
                position: 'fixed',
                left: '0',
                top: '0',
                bottom: '0',
                right: '0',
                overflow: 'auto',
                animationName: 'consoleIn',
                animationDuration: '0.3s',
                animationTimingFunction: 'ease-out'
            },
            onClick: (0, $eWjiX.BB).handleClick
        });
        //background element registering clicks
        this.bgEl = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                position: 'absolute',
                left: '0',
                top: '0',
                bottom: '0',
                right: '0'
            },
            onClick: function() {
                return _this.close();
            }
        });
        //the actual popup box
        var popupEl = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            className: 'kl-d-modal',
            css: {
                position: 'absolute',
                width: (0, $eWjiX.BB).isCssMinMaxSupported() ? 'min(calc(100% - 40px), ' + (p.width ? p.width : 400) + 'px)' : (p.width ? p.width : 400) + 'px',
                height: 'calc(100% - 40px)',
                borderRadius: '10px',
                overflow: 'hidden'
            }
        });
        //x and y position via script. flex not powerful enough imo
        this.updatePos = function() {
            var elW = popupEl.offsetWidth;
            var elH = popupEl.offsetHeight;
            (0, $7jh4K.css)(popupEl, {
                left: Math.max(0, (window.innerWidth - elW) / 2) + 'px',
                top: Math.max(20, (window.innerHeight - elH) / 2 - elH * 0.2) + 'px'
            });
        };
        this.updatePos();
        window.addEventListener('resize', this.updatePos);
        //title row in popup
        var titleHeight = 40;
        var titleEl = (0, $eWjiX.BB).el({
            parent: popupEl,
            css: {
                height: titleHeight + 'px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingLeft: titleHeight / 2 + 'px'
            }
        });
        if (p.title) titleEl.append(p.title);
        this.xButton = (0, $eWjiX.BB).el({
            parent: titleEl,
            tagName: 'button',
            className: 'popup-x',
            content: `<img alt="${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('modal-close')}" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($e33dc4efcac9043e$exports)))}">`,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('modal-close'),
            onClick: function() {
                return _this.close();
            },
            css: {
                width: titleHeight + 'px',
                height: titleHeight + 'px',
                lineHeight: titleHeight + 'px',
                background: 'none',
                boxShadow: 'none'
            },
            custom: {
                tabindex: '0'
            }
        });
        var contentEl = (0, $eWjiX.BB).el({
            parent: popupEl,
            css: {
                height: 'calc(100% - ' + titleHeight + 'px)'
            }
        });
        if (p.content) contentEl.append(p.content);
        this.keyListener = new (0, $eWjiX.BB).KeyListener({
            onDown: function(keyStr, e) {
                if (keyStr === 'esc') {
                    e.stopPropagation();
                    e.preventDefault(); // stay in fullscreen on Mac
                    _this.close();
                }
            }
        });
    }
    (0, $7h4XF._)(DynamicModal, [
        {
            // ---- interface ----
            key: "close",
            value: function close() {
                (0, $dd0d395ff14a3e11$export$d3d1650bc39c4419).decrease();
                (0, $eWjiX.BB).destroyEl(this.rootEl);
                this.rootEl.remove();
                window.removeEventListener('resize', this.updatePos);
                this.keyListener.destroy();
                (0, $eWjiX.BB).destroyEl(this.xButton);
                (0, $eWjiX.BB).destroyEl(this.bgEl);
                this.onClose && this.onClose();
            }
        }
    ]);
    return DynamicModal;
}();




var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");
var $365a915dfb503274$export$48513f6b9f8ce62d = /*#__PURE__*/ function() {
    "use strict";
    function Checkbox(p) {
        var _this = this;
        (0, $cx0mh._)(this, Checkbox);
        var _p_isEnabled;
        var isEnabled = (_p_isEnabled = p.isEnabled) !== null && _p_isEnabled !== void 0 ? _p_isEnabled : true;
        this.doHighlight = !!p.doHighlight;
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'kl-checkbox'
        });
        this.rootEl.classList.toggle('kl-checkbox--disabled', !isEnabled);
        var innerEl = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            tagName: 'label',
            className: 'kl-checkbox__inner',
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        this.check = (0, $eWjiX.BB).el({
            parent: innerEl,
            tagName: 'input',
            css: {
                margin: '0 5px 0 0',
                // otherwise varies by browser
                width: '14px',
                height: '14px'
            },
            custom: (0, $cL71g._)({
                type: 'checkbox',
                name: p.name
            }, !isEnabled ? {
                disabled: 'true'
            } : {})
        });
        this.check.checked = !!p.init;
        if (this.doHighlight && this.check.checked) this.rootEl.classList.add('kl-checkbox--highlight');
        if (!p.allowTab) this.check.tabIndex = -1;
        if (p.title) innerEl.title = p.title;
        var label = (0, $eWjiX.BB).el({
            parent: innerEl,
            content: p.label,
            css: {
                display: 'flex',
                alignItems: 'center',
                gap: '3px'
            }
        });
        this.check.onchange = function() {
            if (_this.doHighlight) _this.rootEl.classList.toggle('kl-checkbox--highlight', _this.check.checked);
            p.callback && p.callback(_this.check.checked);
            setTimeout(function() {
                _this.check.blur();
            }, 0);
        };
        if (p.css) (0, $7jh4K.css)(this.rootEl, p.css);
    }
    (0, $7h4XF._)(Checkbox, [
        {
            key: "getValue",
            value: function getValue() {
                return this.check.checked;
            }
        },
        {
            key: "setValue",
            value: function setValue(b) {
                this.check.checked = b;
                if (this.doHighlight) this.rootEl.classList.toggle('kl-checkbox--highlight', this.check.checked);
            }
        },
        {
            key: "setEnabled",
            value: function setEnabled(enabled) {
                this.check.disabled = !enabled;
                this.rootEl.classList.toggle('kl-checkbox--disabled', !enabled);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.check.onchange = null;
            }
        }
    ]);
    return Checkbox;
}();



var $dJPtW = parcelRequire("dJPtW");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");
var $7a3263857aacf58f$export$ef9b1a59e592288f = /*#__PURE__*/ function() {
    "use strict";
    function Select(p) {
        var _this = this;
        (0, $cx0mh._)(this, Select);
        this.optionArr = [];
        this.selectEl = (0, $eWjiX.BB).el({
            tagName: 'select',
            title: p.title,
            className: 'kl-select',
            css: {
                cursor: 'pointer',
                fontSize: '15px',
                padding: '3px'
            },
            custom: {
                name: p.name
            }
        });
        if (p.css) (0, $7jh4K.css)(this.selectEl, p.css);
        var isFocusable = p.isFocusable;
        if (!isFocusable) this.selectEl.tabIndex = -1;
        this.setOptionArr(p.optionArr);
        if (p.onChange) this.onChange = p.onChange;
        this.changeListener = function() {
            if (!isFocusable) _this.selectEl.blur();
            _this.onChange && _this.onChange(_this.getValue());
        };
        this.selectEl.addEventListener('change', this.changeListener);
        this.selectEl.value = p.initValue !== undefined ? p.initValue : '';
    }
    (0, $7h4XF._)(Select, [
        {
            key: "setValue",
            value: function setValue(val) {
                this.selectEl.value = val === undefined ? '' : val;
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.selectEl.value;
            }
        },
        {
            key: "setDeltaValue",
            value: function setDeltaValue(delta) {
                var index = 0;
                for(var i = 0; i < this.optionArr.length; i++){
                    var option = this.optionArr[i];
                    if (option.item && '' + option.item[0] === this.selectEl.value) {
                        index = i;
                        break;
                    }
                }
                index = Math.max(0, Math.min(this.optionArr.length - 1, index + delta));
                var option1 = this.optionArr[index];
                this.selectEl.value = option1.item ? option1.item[0] : '';
                this.onChange && this.onChange(this.getValue());
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.selectEl;
            }
        },
        {
            key: "updateLabel",
            value: function updateLabel(id, label) {
                this.optionArr.forEach(function(option) {
                    if (option.item && option.item[0] === id && option.el) {
                        option.item[1] = label;
                        option.el.textContent = option.item[1];
                    }
                });
            }
        },
        {
            key: "setOptionArr",
            value: function setOptionArr(optionArr) {
                var oldVal = this.selectEl.value;
                this.optionArr = [];
                this.selectEl.innerHTML = '';
                for(var i = 0; i < optionArr.length; i++){
                    var item = optionArr[i];
                    if (!item) {
                        this.optionArr.push({
                            item: item
                        });
                        continue;
                    }
                    var el = document.createElement('option');
                    el.value = item[0];
                    el.textContent = item[1];
                    if (item[2]) (0, $7jh4K.css)(el, item[2].css);
                    this.optionArr.push({
                        item: item,
                        el: el
                    });
                    this.selectEl.append(el);
                }
                // restore old value
                if (oldVal === '' || optionArr.findIndex(function(item) {
                    return item && item[0] === oldVal;
                }) > -1) this.setValue(oldVal);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.selectEl.removeEventListener('change', this.changeListener);
            }
        }
    ]);
    return Select;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $8fa94d142febb502$export$b6d053cded550773 = /*#__PURE__*/ function() {
    "use strict";
    function ImageToggle(p) {
        var _this = this;
        (0, $cx0mh._)(this, ImageToggle);
        this.isActive = p.initValue;
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'image-toggle',
            title: p.title,
            content: (0, $eWjiX.BB).el({
                className: 'image-toggle__im' + (p.darkInvert ? ' dark-invert' : ''),
                css: {
                    backgroundImage: "url('" + p.image + "')"
                }
            }),
            onClick: function(e) {
                e.preventDefault();
                if (p.isRadio && _this.isActive) return;
                _this.isActive = !_this.isActive;
                _this.update();
                p.onChange(_this.isActive);
            }
        });
        this.update();
    }
    (0, $7h4XF._)(ImageToggle, [
        {
            key: "update",
            value: function update() {
                this.rootEl.classList.toggle('image-toggle-active', this.isActive);
            }
        },
        {
            // --- interface ---
            key: "setValue",
            value: function setValue(b) {
                this.isActive = b;
                this.update();
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.isActive;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                (0, $eWjiX.BB).destroyEl(this.rootEl);
            }
        }
    ]);
    return ImageToggle;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $8cb981a3c9e5b15b$export$7cc1012a658e6ad8 = /*#__PURE__*/ function() {
    "use strict";
    function ImageRadioList(p) {
        var _this = this;
        (0, $cx0mh._)(this, ImageRadioList);
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'image-radio-wrapper',
            css: {
                display: 'flex'
            }
        });
        this.optionArr = [];
        var select = function(index, id) {
            _this.activeIndex = index;
            for(var i = 0; i < _this.optionArr.length; i++)_this.optionArr[i].radioEl.setValue(i === _this.activeIndex);
            p.onChange(id);
        };
        var initialIndex;
        var createOption = function(index, o) {
            if (o.id === p.initId) initialIndex = index;
            var radioEl = new (0, $8fa94d142febb502$export$b6d053cded550773)({
                image: o.image,
                title: o.title,
                initValue: o.id === p.initId,
                isRadio: true,
                onChange: function() {
                    select(index, o.id);
                },
                darkInvert: o.darkInvert
            });
            _this.rootEl.append(radioEl.getElement());
            return {
                id: o.id,
                radioEl: radioEl
            };
        };
        for(var i = 0; i < p.optionArr.length; i++)this.optionArr.push(createOption(i, p.optionArr[i]));
        if (initialIndex === undefined) throw new Error('initId not in optionArr');
        this.activeIndex = initialIndex;
    }
    (0, $7h4XF._)(ImageRadioList, [
        {
            // --- interface ---
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.optionArr[this.activeIndex].id;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.optionArr.forEach(function(item) {
                    item.radioEl.destroy();
                });
            }
        }
    ]);
    return ImageRadioList;
}();



var $eWjiX = parcelRequire("eWjiX");

var $98a18d2a4a92ce67$exports = {};
$98a18d2a4a92ce67$exports = $parcel$resolve("5H9IS");



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");
var $afe02cc26c765c2c$export$2358c75ad3c15b2d = /*#__PURE__*/ function() {
    "use strict";
    function BoxToggle(p) {
        var _this = this;
        (0, $cx0mh._)(this, BoxToggle);
        this.value = !!p.init;
        this.el = (0, $eWjiX.BB).el({
            content: p.label,
            title: p.title,
            className: typeof p.label === 'string' ? 'kl-box-toggle' : 'kl-box-toggle kl-box-toggle--custom-el',
            onClick: function() {
                _this.value = !_this.value;
                _this.update();
                p.onChange(_this.value);
            },
            css: {
                cursor: 'pointer'
            }
        });
        if (typeof p.label !== 'string') (0, $7jh4K.css)(p.label, {
            display: 'block',
            pointerEvents: 'none'
        });
        this.update();
    }
    (0, $7h4XF._)(BoxToggle, [
        {
            key: "update",
            value: function update() {
                this.el.classList.toggle('kl-box-toggle--active', this.value);
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.value;
            }
        },
        {
            key: "setValue",
            value: function setValue(b) {
                this.value = b;
                this.update();
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.el;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                (0, $eWjiX.BB).destroyEl(this.el);
            }
        }
    ]);
    return BoxToggle;
}();


var $a49c90053f8766a2$export$9da2e8821e6cbb57 = function createPenPressureToggle(isChecked, changeCallback) {
    var toggleEl = new (0, $afe02cc26c765c2c$export$2358c75ad3c15b2d)({
        label: (0, $eWjiX.BB).el({
            className: 'dark-invert',
            css: {
                width: '17px',
                height: '17px',
                backgroundImage: 'url("' + (0, (/*@__PURE__*/$parcel$interopDefault($98a18d2a4a92ce67$exports))) + '")',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                margin: '1px',
                borderRadius: '3px'
            }
        }),
        title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-toggle-pressure'),
        init: isChecked,
        onChange: function(b) {
            changeCallback(b);
        }
    });
    return toggleEl.getElement();
};



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
/**
 * To make sliders more fine-grained. The falloff when moving cursor away from cursor.
 * Returns the factor [0,1]
 *  0 -> infinite movement required for change of 1
 *  1 -> 1px movement for change of 1
 *
 * @param deltaY vertical distance from pointerdown
 * @param isRightButton
 */ function $16ee6d1163eaf409$export$f8e41e222e32615d(deltaY, isRightButton) {
    var result = Math.min(10, 1 + Math.pow(Math.floor(deltaY / 50), 2));
    if (isRightButton) result *= 2;
    return 1 / result;
}




var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $dJPtW = parcelRequire("dJPtW");

var $7jh4K = parcelRequire("7jh4K");
var $068903cd1342554f$export$db3d4fde05db9a5e = /*#__PURE__*/ function() {
    "use strict";
    function KlSliderManualInput(value, min, max, rect, onChange, onClose, roundDigits) {
        var _this = this;
        (0, $cx0mh._)(this, KlSliderManualInput);
        this.onChange = onChange;
        this.onClose = onClose;
        this.isEnabled = true;
        this.isClosed = false;
        this.input = (0, $dJPtW.input)({
            type: 'number',
            init: value,
            min: min,
            max: max,
            callback: function(val) {
                _this.emit();
            }
        });
        if (roundDigits !== 0) this.input.setAttribute('step', 'any');
        this.input.onblur = function() {
            _this.privateOnClose();
        };
        this.input.addEventListener('keyup', function(e) {
            if ([
                'Enter',
                'Escape'
            ].includes(e.key)) _this.privateOnClose();
            else _this.emit();
        }, {
            passive: false
        });
        this.input.addEventListener('wheel', function() {
            return _this.emit();
        }, {
            passive: false
        });
        this.scrollBefore = {
            x: window.scrollX,
            y: window.scrollY
        };
        var currentValue;
        if (roundDigits || roundDigits === 0) currentValue = (0, $eWjiX.BB).round(value, roundDigits);
        else currentValue = value;
        this.lastValue = currentValue;
        this.input.value = '' + currentValue;
        (0, $7jh4K.css)(this.input, {
            width: rect.width + 'px',
            height: rect.height + 'px'
        });
    }
    (0, $7h4XF._)(KlSliderManualInput, [
        {
            key: "emit",
            value: function emit() {
                if (this.lastValue !== Number(this.input.value)) {
                    this.onChange(Number(this.input.value));
                    this.lastValue = Number(this.input.value);
                }
            }
        },
        {
            key: "privateOnClose",
            value: function privateOnClose() {
                var _this = this;
                if (this.isClosed) return;
                this.isClosed = true;
                this.emit();
                this.onClose();
                setTimeout(function() {
                    // because iPad keyboard changes the scroll position
                    _this.scrollBefore && window.scrollTo(_this.scrollBefore.x, _this.scrollBefore.y);
                    _this.scrollBefore = undefined;
                });
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.input;
            }
        },
        {
            key: "setIsEnabled",
            value: function setIsEnabled(b) {
                this.isEnabled = b;
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.input.focus();
                this.input.select();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                (0, $eWjiX.BB).destroyEl(this.input);
            }
        }
    ]);
    return KlSliderManualInput;
}();



var $7jh4K = parcelRequire("7jh4K");
var $5c0625e6104e2c75$export$a1855b925e534de7 = /*#__PURE__*/ function() {
    "use strict";
    function KlSlider(p) {
        var _this = this;
        (0, $cx0mh._)(this, KlSlider);
        this.isEnabled = p.isEnabled !== false;
        this.manualInputRoundDigits = p.manualInputRoundDigits;
        this.useSpline = !!p.curve;
        if (!p.label) throw new Error('KlSlider missing params');
        if (p.min != 0 && p.max != 0 && p.value != 0) {
            if (!p.min || !p.max || !p.value) throw new Error('KlSlider broken params');
        }
        if (p.min >= p.max) throw new Error('KlSlider broken params');
        this.min = p.min;
        this.max = p.max;
        this.value = (0, $eWjiX.BB).clamp(p.value, this.min, this.max);
        this.elementWidth = p.width;
        this.elementHeight = p.height;
        this.resolution = p.resolution ? p.resolution : this.elementWidth * 2;
        this.onChange = p.onChange ? p.onChange : function() {};
        if (!p.toValue !== !p.toDisplayValue) throw new Error('both or neither have to be set, toValue and toDisplayValue');
        this.displayValueToValue = p.toValue ? p.toValue : function(displayValue) {
            return displayValue;
        };
        this.valueToDisplayValue = p.toDisplayValue ? p.toDisplayValue : function(value) {
            return value;
        };
        this.isChangeOnFinal = !!p.isChangeOnFinal;
        this.formatFunc = p.formatFunc;
        this.eventResMs = p.eventResMs;
        this.unit = p.unit;
        if (this.useSpline) {
            if (!p.curve) throw new Error('curve needs to be set if useSpline true');
            var curveArr = p.curve === 'quadratic' ? (0, $eWjiX.BB).powerSplineInput(this.min, this.max, 0.1) : p.curve;
            this.splineInterpolator = new (0, $eWjiX.BB).SplineInterpolator(curveArr);
        }
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                display: 'flex'
            }
        });
        this.sliderWrapperEl = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            className: 'slider-wrapper',
            css: {
                overflow: 'hidden',
                position: 'relative',
                width: this.elementWidth + 'px',
                height: this.elementHeight + 'px',
                userSelect: 'none'
            }
        });
        this.rootEl.oncontextmenu = function() {
            return false;
        };
        this.label = p.label;
        var labelFontSize = this.elementHeight - 14;
        this.labelValueEl = (0, $eWjiX.BB).el({
            css: {
                fontWeight: 'bold'
            }
        });
        this.textEl = (0, $eWjiX.BB).el({
            content: [
                (0, $eWjiX.BB).el({
                    content: this.label,
                    css: {
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }
                }),
                this.labelValueEl
            ],
            css: {
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                padding: '0 7px',
                height: '100%',
                width: '100%',
                fontSize: labelFontSize + 'px',
                pointerEvents: 'none',
                gap: '8px'
            }
        });
        this.control = (0, $eWjiX.BB).el({
            className: 'slider-inner',
            css: {
                position: 'absolute',
                left: '0',
                top: '0',
                width: this.valueToSliderValue(this.value) * this.elementWidth + 'px',
                height: this.elementHeight + 'px'
            }
        });
        var controlInner = document.createElement('div');
        this.sliderWrapperEl.append(this.control, this.textEl);
        this.control.append(controlInner);
        this.updateEnable();
        var doubleTapper = new (0, $eWjiX.BB).DoubleTapper({
            onDoubleTap: function() {
                _this.showManualInput();
            }
        });
        doubleTapper.setAllowedButtonArr([
            'left',
            'right'
        ]);
        var eventChain = new (0, $eWjiX.BB).EventChain({
            chainArr: [
                doubleTapper
            ]
        });
        var virtualVal;
        var onPointer = function(event) {
            event.eventPreventDefault();
            if (!_this.isEnabled) return;
            if (event.type === 'pointerdown') {
                // unfocus manual slider input
                (0, $eWjiX.BB).unfocusAnyInput();
                _this.sliderWrapperEl.className = 'slider-wrapper slider-wrapper--active';
                if (event.button === 'left') {
                    var sliderValue = event.relX / _this.elementWidth;
                    sliderValue = Math.max(0, Math.min(1, sliderValue));
                    _this.value = _this.sliderValueToValue(sliderValue);
                    _this.updateLabel();
                    _this.emit(false);
                }
                virtualVal = _this.valueToSliderValue(_this.value);
            }
            if (event.type === 'pointermove' && [
                'left',
                'right'
            ].includes(event.button || '')) {
                var deltaX = event.dX;
                var deltaY = Math.abs(event.pageY - (event.downPageY || 0));
                var factor = (0, $16ee6d1163eaf409$export$f8e41e222e32615d)(deltaY, event.button === 'right');
                deltaX *= factor;
                deltaX /= _this.elementWidth;
                virtualVal += deltaX;
                var sliderValue1 = Math.max(0, Math.min(1, virtualVal));
                _this.value = _this.sliderValueToValue(sliderValue1);
                _this.updateLabel();
                _this.emit(false);
            }
            if (event.type === 'pointerup') {
                _this.sliderWrapperEl.className = 'slider-wrapper';
                _this.emit(true);
            }
        };
        this.pointerListenerTimeout = setTimeout(function() {
            _this.pointerListener = new (0, $eWjiX.BB).PointerListener({
                target: _this.sliderWrapperEl,
                fixScribble: true,
                onPointer: function(e) {
                    onPointer(e);
                    eventChain.chainIn(e);
                },
                onWheel: function(event) {
                    var sliderValue = _this.valueToSliderValue(_this.value);
                    sliderValue = (0, $eWjiX.BB).clamp(sliderValue - event.deltaY / 40, 0, 1);
                    _this.value = _this.sliderValueToValue(sliderValue);
                    _this.updateLabel();
                    _this.onChange(_this.value);
                }
            });
            _this.updateLabel();
        }, 1);
    }
    (0, $7h4XF._)(KlSlider, [
        {
            key: "valueToSliderValue",
            value: function valueToSliderValue(value) {
                if (this.useSpline && this.splineInterpolator) return this.splineInterpolator.findX(value, Math.floor(this.resolution)) || 0;
                return (value - this.min) / (this.max - this.min);
            }
        },
        {
            key: "sliderValueToValue",
            value: function sliderValueToValue(sliderValue) {
                var result = this.min + sliderValue * (this.max - this.min);
                if (this.useSpline && this.splineInterpolator) result = this.splineInterpolator.interpolate(sliderValue) || 0;
                return result;
            }
        },
        {
            key: "updateLabel",
            value: function updateLabel() {
                var displayValue = this.valueToDisplayValue(this.value);
                displayValue = this.formatFunc ? this.formatFunc(displayValue) : Math.round(displayValue);
                displayValue = displayValue.toLocaleString((0, $8d7403abedf7cefa$export$e4ce066d17694649).getCode());
                var unit = this.unit !== undefined ? this.unit : '';
                this.labelValueEl.textContent = displayValue + unit;
                var sliderValue = this.valueToSliderValue(this.value);
                this.control.style.width = sliderValue * this.elementWidth + 'px';
            }
        },
        {
            key: "emit",
            value: function emit(isFinal) {
                var _this = this;
                if (!isFinal && this.isChangeOnFinal) return;
                if (isFinal || !this.eventResMs) {
                    this.onChange(this.value);
                    if (this.emitInterval) {
                        clearInterval(this.emitInterval);
                        this.emitInterval = undefined;
                    }
                    return;
                }
                if (this.emitInterval) this.emitValue = this.value;
                else {
                    this.onChange(this.value);
                    this.emitInterval = setInterval(function() {
                        if (_this.emitValue === undefined) {
                            clearInterval(_this.emitInterval);
                            _this.emitInterval = undefined;
                        } else {
                            _this.onChange(_this.emitValue);
                            _this.emitValue = undefined;
                        }
                    }, this.eventResMs);
                }
            }
        },
        {
            key: "updateEnable",
            value: function updateEnable() {
                this.sliderWrapperEl.classList.toggle('slider-wrapper--disabled', !this.isEnabled);
                (0, $7jh4K.css)(this.sliderWrapperEl, {
                    opacity: this.isEnabled ? '' : '0.5',
                    pointerEvents: this.isEnabled ? '' : 'none'
                });
                if (this.manualInput) this.manualInput.setIsEnabled(this.isEnabled);
            }
        },
        {
            key: "showManualInput",
            value: function showManualInput() {
                var _this = this;
                this.manualInput = new (0, $068903cd1342554f$export$db3d4fde05db9a5e)(this.valueToDisplayValue(this.value), this.valueToDisplayValue(this.min), this.valueToDisplayValue(this.max), this.sliderWrapperEl.getBoundingClientRect(), function(val) {
                    val = _this.displayValueToValue(val);
                    _this.setValue((0, $eWjiX.BB).clamp(val, _this.min, _this.max));
                    _this.onChange(_this.value);
                }, function() {
                    (0, $7jh4K.css)(_this.sliderWrapperEl, {
                        display: ''
                    });
                    if (_this.manualInput) {
                        _this.manualInput.getElement().remove();
                        _this.manualInput.destroy();
                    }
                    _this.manualInput = undefined;
                }, this.manualInputRoundDigits && this.manualInputRoundDigits > 0 ? this.manualInputRoundDigits : 0);
                this.manualInput.setIsEnabled(this.isEnabled);
                this.rootEl.append(this.manualInput.getElement());
                setTimeout(function() {
                    _this.manualInput && _this.manualInput.focus();
                });
                (0, $7jh4K.css)(this.sliderWrapperEl, {
                    display: 'none'
                });
            }
        },
        {
            key: "changeSliderValue",
            value: function changeSliderValue(f) {
                if (!this.isEnabled) return;
                var sliderValue = this.valueToSliderValue(this.value);
                sliderValue = (0, $eWjiX.BB).clamp(sliderValue + f, 0, 1);
                this.value = this.sliderValueToValue(sliderValue);
                this.updateLabel();
                this.onChange(this.value);
            }
        },
        {
            key: "setValue",
            value: function setValue(v) {
                this.value = (0, $eWjiX.BB).clamp(v, this.min, this.max);
                this.updateLabel();
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.value;
            }
        },
        {
            key: "getDisplayValue",
            value: function getDisplayValue() {
                return this.valueToDisplayValue(this.value);
            }
        },
        {
            key: "update",
            value: function update(config) {
                this.min = config.min;
                this.max = config.max;
                this.useSpline = !!config.curve;
                if (this.useSpline) {
                    if (!config.curve) throw new Error('curve needs to be set if useSpline true');
                    var curveArr = config.curve === 'quadratic' ? (0, $eWjiX.BB).powerSplineInput(this.min, this.max, 0.1) : config.curve;
                    this.splineInterpolator = new (0, $eWjiX.BB).SplineInterpolator(curveArr);
                } else this.splineInterpolator = undefined;
                this.setIsEnabled(!config.isDisabled);
            }
        },
        {
            key: "setIsEnabled",
            value: function setIsEnabled(e) {
                this.isEnabled = e;
                this.updateEnable();
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                clearTimeout(this.pointerListenerTimeout);
                this.pointerListener && this.pointerListener.destroy();
                if (this.manualInput) this.manualInput.destroy();
                if (this.emitInterval) clearInterval(this.emitInterval);
            }
        }
    ]);
    return KlSlider;
}();



var $cx0mh = parcelRequire("cx0mh");

var $eWjiX = parcelRequire("eWjiX");

var $dJPtW = parcelRequire("dJPtW");


var $a77baa3d81294bff$exports = {};
$a77baa3d81294bff$exports = $parcel$resolve("la7yv");



var $bX4ja = parcelRequire("bX4ja");

var $72Jv0 = parcelRequire("72Jv0");

var $7jh4K = parcelRequire("7jh4K");
function $075b9fd415bad4ff$var$decomposeElString(el) {
    if (el === '') return {};
    var split;
    var tagName;
    var classes = [];
    split = el.split('.');
    if (split.length === 1) {
        split = split[0].split(',');
        tagName = split.shift();
    } else {
        tagName = split.shift();
        split.forEach(function(item, index) {
            var isLast = index === split.length - 1;
            if (isLast) {
                split = item.split(',');
                var last = split.shift();
                if (last !== undefined) classes.push(last);
            } else classes.push(item);
        });
    }
    var result = {};
    if (tagName !== '') result.tagName = tagName;
    if (classes.length > 0) result.classes = classes;
    if (split.length > 0) result.styles = split;
    return result;
}
function $075b9fd415bad4ff$var$applyStyleNames(el, styleNames) {
    var style = {};
    var operations = {
        c: function(params) {
            style.color = params[0];
        },
        bg: function(params) {
            style.background = params[0];
        },
        p: function(params) {
            style.padding = params[0] + 'px';
        },
        py: function(params) {
            style.paddingTop = params[0] + 'px';
            style.paddingBottom = params[0] + 'px';
        },
        pt: function(params) {
            style.paddingTop = params[0] + 'px';
        },
        pr: function(params) {
            style.paddingRight = params[0] + 'px';
        },
        pb: function(params) {
            style.paddingBottom = params[0] + 'px';
        },
        pl: function(params) {
            style.paddingLeft = params[0] + 'px';
        },
        mt: function(params) {
            style.marginTop = params[0] + 'px';
        },
        mr: function(params) {
            style.marginRight = params[0] + 'px';
        },
        mb: function(params) {
            style.marginBottom = params[0] + 'px';
        },
        ml: function(params) {
            style.marginLeft = params[0] + 'px';
        },
        // flex
        flex: function() {
            style.display = 'flex';
        },
        flexCol: function() {
            style.flexDirection = 'column';
        },
        flexWrap: function() {
            style.flexWrap = 'wrap';
        },
        gap: function(params) {
            style.gap = params.map(function(item) {
                return item + 'px';
            }).join(' ');
        },
        grow: function() {
            style.flexGrow = '1';
        },
        justify: function(params) {
            style.justifyContent = params[0];
        },
        items: function(params) {
            style.alignItems = params[0];
        },
        hidden: function() {
            style.display = 'none';
        },
        nowrap: function() {
            style.whiteSpace = 'nowrap';
        },
        abs: function(params) {
            style.position = 'absolute';
            style.left = params[0] + 'px';
            style.top = params[1] + 'px';
        },
        w: function(params) {
            style.width = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        h: function(params) {
            style.height = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        minh: function(params) {
            style.minHeight = params[0] + 'px';
        },
        z: function(params) {
            style.zIndex = params[0];
        },
        overflow: function(params) {
            style.overflow = params[0];
        },
        pos: function(params) {
            style.position = params[0];
        },
        left: function(params) {
            style.left = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        top: function(params) {
            style.top = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        right: function(params) {
            style.right = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        bottom: function(params) {
            style.bottom = params[0] === 'full' ? '100%' : params[0] + 'px';
        },
        size: function(params) {
            style.fontSize = params[0] + 'px';
        },
        pointer: function(params) {
            style.pointerEvents = params[0];
        }
    };
    styleNames.forEach(function(item) {
        var params = item.split('-');
        var operation = params.shift();
        operations[operation](params);
    });
    (0, $7jh4K.css)(el, style);
}
function $075b9fd415bad4ff$export$db3b6bfb95261072(element, inner) {
    var _result_classList;
    if (element === undefined) return document.createElement('div');
    if (typeof element !== 'string') {
        if (!(element instanceof HTMLElement)) element = (0, $72Jv0.el)(element);
        if (inner) {
            var _element;
            if (typeof inner === 'string') element.innerHTML = inner;
            else (_element = element).append.apply(_element, (0, $bX4ja._)(inner));
        }
        return element;
    }
    var decomp = $075b9fd415bad4ff$var$decomposeElString(element);
    var _decomp_tagName;
    var result = document.createElement((_decomp_tagName = decomp.tagName) !== null && _decomp_tagName !== void 0 ? _decomp_tagName : 'div');
    decomp.classes && (_result_classList = result.classList).add.apply(_result_classList, (0, $bX4ja._)(decomp.classes));
    decomp.styles && $075b9fd415bad4ff$var$applyStyleNames(result, decomp.styles);
    if (inner) {
        var _result;
        if (typeof inner === 'string') result.innerHTML = inner;
        else (_result = result).append.apply(_result, (0, $bX4ja._)(inner));
    }
    return result;
}


var $6796041293c91113$export$9852986a3ec5f6a0;
$6796041293c91113$export$9852986a3ec5f6a0 = `_7-bVqq_table`;


var $dada52d673c8c4ac$export$cc42e119007cb939 = function HexColorDialog(p) {
    "use strict";
    (0, $cx0mh._)(this, HexColorDialog);
    var createRgbInputRow = // --- R G B ---
    function createRgbInputRow(labelStr, attributeStr) {
        var inputEl = (0, $dJPtW.input)({
            init: lastValidRgb[attributeStr],
            min: 0,
            max: 255,
            type: 'number',
            css: {
                width: '80px'
            },
            callback: function callback() {
                if (inputEl.value === '' || parseFloat(inputEl.value) < 0 || parseFloat(inputEl.value) > 255) {
                    result.update();
                    return;
                }
                inputEl.value = '' + Math.round(parseFloat(inputEl.value));
                lastValidRgb[attributeStr] = Number(inputEl.value);
                previewEl.style.background = '#' + (0, $eWjiX.BB).ColorConverter.toHexString(lastValidRgb);
                hexInput.value = '#' + (0, $eWjiX.BB).ColorConverter.toHexString(lastValidRgb);
            }
        });
        var rowEl = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('tr', [
            (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('td,pr-10', labelStr),
            (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('td', [
                inputEl
            ])
        ]);
        var result = {
            update: function() {
                inputEl.value = '' + lastValidRgb[attributeStr];
            },
            destroy: function() {
                (0, $eWjiX.BB).unsetEventHandler(inputEl, 'onchange');
            },
            element: rowEl
        };
        return result;
    };
    var lastValidRgb = new (0, $eWjiX.BB).RGB(p.color.r, p.color.g, p.color.b);
    var previewEl = (0, $eWjiX.BB).el({
        css: {
            width: '20px',
            height: '20px',
            marginBottom: '10px',
            boxShadow: 'inset 0 0 0 1px #fff, 0 0 0 1px #000',
            background: '#' + (0, $eWjiX.BB).ColorConverter.toHexString(lastValidRgb)
        }
    });
    // --- Hex ---
    var hexLabel = (0, $eWjiX.BB).el({
        content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('mci-hex')
    });
    var hexInput = (0, $dJPtW.input)({
        init: '#' + (0, $eWjiX.BB).ColorConverter.toHexString(lastValidRgb),
        css: {
            width: '80px'
        },
        callback: function callback() {
            var rgbObj = (0, $eWjiX.BB).ColorConverter.hexToRGB(hexInput.value);
            if (!rgbObj) {
                rgbObj = lastValidRgb;
                hexInput.value = '#' + (0, $eWjiX.BB).ColorConverter.toHexString(lastValidRgb);
            } else lastValidRgb = rgbObj;
            previewEl.style.background = '#' + (0, $eWjiX.BB).ColorConverter.toHexString(rgbObj);
            for(var i = 0; i < rgbArr.length; i++)rgbArr[i].update();
        }
    });
    var copyButton = (0, $eWjiX.BB).el({
        tagName: 'button',
        content: '<img src="' + (0, (/*@__PURE__*/$parcel$interopDefault($a77baa3d81294bff$exports))) + '" height="20" alt=""/>',
        title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('mci-copy'),
        onClick: function onClick() {
            hexInput.select();
            navigator.clipboard.writeText(hexInput.value).then().catch();
        }
    });
    var hexRowEl = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)({
        css: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '15px',
            flexWrap: 'wrap',
            gap: '5px 10px',
            maxWidth: '250px'
        }
    }, [
        hexLabel,
        (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',flex,items-center,gap-10', [
            hexInput,
            copyButton
        ])
    ]);
    setTimeout(function() {
        hexInput.focus();
        hexInput.select();
    }, 0);
    var rgbArr = [
        createRgbInputRow((0, $8d7403abedf7cefa$export$ce37e184d908d785)('red'), 'r'),
        createRgbInputRow((0, $8d7403abedf7cefa$export$ce37e184d908d785)('green'), 'g'),
        createRgbInputRow((0, $8d7403abedf7cefa$export$ce37e184d908d785)('blue'), 'b')
    ];
    var rootEl = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('', [
        previewEl,
        hexRowEl,
        (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('table.' + $6796041293c91113$export$9852986a3ec5f6a0, [
            (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('tbody', rgbArr.map(function(item) {
                return item.element;
            }))
        ])
    ]);
    (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('manual-color-input')}</b>`,
        div: rootEl,
        autoFocus: false,
        clickOnEnter: 'Ok',
        buttons: [
            'Ok',
            'Cancel'
        ],
        callback: function callback(resultStr) {
            (0, $eWjiX.BB).destroyEl(copyButton);
            rgbArr.forEach(function(item) {
                return item.destroy();
            });
            rgbArr.splice(0, rgbArr.length);
            p.onClose(resultStr === 'Ok' ? (0, $eWjiX.BB).ColorConverter.hexToRGB(hexInput.value) : undefined);
        }
    });
};



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");


var $c698add026ba173f$exports = {};
$c698add026ba173f$exports = $parcel$resolve("cTtMO");




var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $7jh4K = parcelRequire("7jh4K");

var $6l0gQ = parcelRequire("6l0gQ");
var $e3b2ff8d1f8c5253$var$LS_THEME_KEY = 'klecks-theme';
var $e3b2ff8d1f8c5253$var$Theme = /*#__PURE__*/ function() {
    "use strict";
    function Theme() {
        var _this = this;
        (0, $cx0mh._)(this, Theme);
        // initialization will be overwritten.
        this.mediaQueryTheme = 'light' // prefers-color-scheme
        ;
        this.theme = 'light';
        this.listeners = [];
        // init media query
        this.mediaQueryTheme = (0, $7jh4K.isDark)() ? 'dark' : 'light';
        (0, $7jh4K.addIsDarkListener)(function() {
            _this.mediaQueryTheme = (0, $7jh4K.isDark)() ? 'dark' : 'light';
            _this.updateTheme();
        });
        // init local storage
        this.storedTheme = this.readLocalStorage();
        addEventListener('storage', function(e) {
            if (e.key === $e3b2ff8d1f8c5253$var$LS_THEME_KEY) {
                _this.storedTheme = _this.readLocalStorage();
                _this.updateTheme();
            }
        });
        this.updateTheme();
    }
    (0, $7h4XF._)(Theme, [
        {
            key: "updateTheme",
            value: function updateTheme() {
                var oldTheme = this.theme;
                this.theme = this.storedTheme || this.mediaQueryTheme;
                if (this.theme === oldTheme) return;
                document.documentElement.classList.toggle('kl-theme-dark', this.theme === 'dark');
                this.listeners.forEach(function(item) {
                    return item();
                });
            }
        },
        {
            key: "readLocalStorage",
            value: function readLocalStorage() {
                var result = (0, $6l0gQ.LocalStorage).getItem($e3b2ff8d1f8c5253$var$LS_THEME_KEY);
                if (!result || typeof result === 'string' && ![
                    'dark',
                    'light'
                ].includes(result)) {
                    result = undefined;
                    (0, $6l0gQ.LocalStorage).removeItem($e3b2ff8d1f8c5253$var$LS_THEME_KEY); // reset because invalid
                }
                return result;
            }
        },
        {
            key: "isDark",
            value: function isDark() {
                return this.theme === 'dark';
            }
        },
        {
            key: "addIsDarkListener",
            value: function addIsDarkListener(func) {
                if (this.listeners.includes(func)) return;
                this.listeners.push(func);
            }
        },
        {
            key: "removeIsDarkListener",
            value: function removeIsDarkListener(func) {
                for(var i = 0; i < this.listeners.length; i++)if (this.listeners[i] === func) {
                    this.listeners.splice(i, 1);
                    return;
                }
            }
        },
        {
            key: "getMediaQueryTheme",
            value: function getMediaQueryTheme() {
                return this.mediaQueryTheme;
            }
        },
        {
            key: "getStoredTheme",
            value: function getStoredTheme() {
                return this.storedTheme;
            }
        },
        {
            key: "setStoredTheme",
            value: function setStoredTheme(theme) {
                if (theme) (0, $6l0gQ.LocalStorage).setItem($e3b2ff8d1f8c5253$var$LS_THEME_KEY, theme);
                else (0, $6l0gQ.LocalStorage).removeItem($e3b2ff8d1f8c5253$var$LS_THEME_KEY);
                this.storedTheme = theme;
                this.updateTheme();
            }
        }
    ]);
    return Theme;
}();
var $e3b2ff8d1f8c5253$export$5714e40777c1bcc2 = new $e3b2ff8d1f8c5253$var$Theme();


var $00f785a5ea9e210d$export$e4203cb02d5e5b28 = (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).isDark() ? 255 : 255;
function $00f785a5ea9e210d$export$8627e24041b28589() {
    return {
        r: $00f785a5ea9e210d$export$e4203cb02d5e5b28,
        g: $00f785a5ea9e210d$export$e4203cb02d5e5b28,
        b: $00f785a5ea9e210d$export$e4203cb02d5e5b28
    };
}



var $7jh4K = parcelRequire("7jh4K");
var $0ebf4eb3a9343b24$export$4e5102252876c5d7 = /*#__PURE__*/ function() {
    "use strict";
    function KlColorSlider(p) {
        var _this = this;
        (0, $cx0mh._)(this, KlColorSlider);
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'kl-color-picker',
            css: {
                position: 'relative'
            }
        });
        this.outputDiv = (0, $eWjiX.BB).el({
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        this.width = p.width;
        this.svHeight = p.svHeight;
        this.height = p.height;
        this.emitColor = p.onPick;
        this.onEyedropper = p.onEyedropper;
        this.primaryColorRgb = {
            r: parseInt('' + p.startValue.r),
            g: parseInt('' + p.startValue.g),
            b: parseInt('' + p.startValue.b)
        };
        this.primaryColorHsv = (0, $eWjiX.BB).ColorConverter.toHSV(p.startValue); // BB.HSV
        this.secondaryColorRgb = {
            r: (0, $00f785a5ea9e210d$export$e4203cb02d5e5b28),
            g: (0, $00f785a5ea9e210d$export$e4203cb02d5e5b28),
            b: (0, $00f785a5ea9e210d$export$e4203cb02d5e5b28)
        };
        this.secondaryColorHsv = (0, $eWjiX.BB).ColorConverter._RGBtoHSV(this.secondaryColorRgb); // BB.HSV
        var svWrapper = (0, $eWjiX.BB).el();
        this.svGradient = (0, $eWjiX.BB).el({
            css: {
                background: 'linear-gradient(0deg, #000 0%, rgba(255, 0, 0, 0) 100%), linear-gradient(-90deg, var(--kl-color-picker--hue) 0%, #fff 100%)',
                width: this.width + 'px',
                height: this.svHeight + 'px'
            }
        });
        svWrapper.append(this.svGradient);
        var divH = (0, $eWjiX.BB).el({
            className: 'kl-color-picker__h',
            css: {
                overflow: 'hidden',
                position: 'relative',
                width: this.width + 'px',
                height: this.height + 'px',
                cursor: 'ew-resize',
                marginTop: '1px',
                marginBottom: '1px'
            }
        });
        this.divPreview = (0, $eWjiX.BB).el({
            className: 'kl-color-picker__preview',
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                width: this.height * 2.5 + 'px',
                height: this.height + 'px'
            }
        });
        this.controlH = (0, $eWjiX.BB).el();
        var createHueBg = function(targetEl) {
            var im = new Image();
            (0, $7jh4K.css)(im, {
                position: 'absolute',
                left: '0',
                top: '0',
                display: 'none',
                pointerEvents: 'none'
            });
            var cv = (0, $eWjiX.BB).canvas(_this.width, _this.height);
            var ctx = (0, $eWjiX.BB).ctx(cv);
            var gradH = ctx.createLinearGradient(0, 0, _this.width, 0);
            for(var i = 0; i < 1; i += 0.01){
                var col = (0, $eWjiX.BB).ColorConverter.toRGB(new (0, $eWjiX.BB).HSV(i * 360, 100, 100));
                var ha = parseInt('' + col.r).toString(16);
                var hb = parseInt('' + col.g).toString(16);
                var hc = parseInt('' + col.b).toString(16);
                if (ha.length === 1) ha = '0' + ha;
                if (hb.length === 1) hb = '0' + hb;
                if (hc.length === 1) hc = '0' + hc;
                gradH.addColorStop(i, '#' + ha + hb + hc);
            }
            ctx.fillStyle = gradH;
            ctx.fillRect(0, 0, _this.width, _this.height);
            targetEl.append(im);
            im.alt = 'hue';
            im.src = cv.toDataURL('image/png');
            im.style.display = 'block';
        };
        this.updateSVCanvas();
        this.rootEl.style.width = this.width + 'px';
        this.rootEl.oncontextmenu = function() {
            return false;
        };
        this.SVContainer = (0, $eWjiX.BB).el({
            className: 'kl-color-picker__sv',
            css: {
                width: this.width + 'px',
                height: this.svHeight + 'px',
                overflow: 'hidden',
                display: 'block',
                position: 'relative',
                cursor: 'crosshair'
            }
        });
        this.pointerSV = (0, $eWjiX.BB).el({
            css: {
                width: '12px',
                height: '12px',
                borderRadius: '6px',
                position: 'absolute',
                pointerEvents: 'none',
                boxShadow: '0px 0px 0 1px #000, inset 0px 0px 0 1px #fff'
            }
        });
        this.SVContainer.append(svWrapper, this.pointerSV);
        this.updateSVPointer();
        this.rootEl.append(this.SVContainer, divH);
        this.outputDiv.append(this.divPreview);
        //divH.className = "svSlider";
        (0, $7jh4K.css)(this.controlH, {
            width: '2px',
            height: this.height + 'px',
            background: '#000',
            borderLeft: '1px solid #fff',
            position: 'absolute',
            top: '0',
            left: parseInt('' + (this.primaryColorHsv.h / 360 * this.width - 1)) + 'px'
        });
        var virtualHSV = {
            h: 0,
            s: 0,
            v: 0
        };
        this.pickerButton = (0, $eWjiX.BB).el({
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('eyedropper') + ' [Alt]',
            className: 'color-picker-preview-button',
            css: {
                width: '30px',
                height: '30px',
                backgroundImage: 'url(' + (0, (/*@__PURE__*/$parcel$interopDefault($c698add026ba173f$exports))) + ')',
                backgroundRepeat: 'no-repeat',
                backgroundSize: '70%',
                backgroundPosition: 'center'
            },
            onClick: function() {
                if (_this.isPicking) _this.setIsEyedropping(false);
                else {
                    _this.pickerButton.classList.remove('color-picker-preview-button-hover');
                    _this.pickerButton.classList.add('color-picker-preview-button-active');
                    _this.isPicking = true;
                    _this.onEyedropper(true);
                }
            }
        });
        this.isPicking = false;
        var pickerButtonPointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.pickerButton,
            onEnterLeave: function(isOver) {
                if (_this.isPicking) return;
                _this.pickerButton.classList.toggle('color-picker-preview-button-hover', isOver);
            }
        });
        this.divPreview.append(this.pickerButton);
        this.hexButton = (0, $eWjiX.BB).el({
            content: '#',
            className: 'color-picker-preview-button',
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('manual-color-input'),
            css: {
                height: '100%',
                width: this.height + 'px',
                lineHeight: this.height + 'px',
                fontSize: this.height * 0.65 + 'px'
            },
            onClick: function() {
                new (0, $dada52d673c8c4ac$export$cc42e119007cb939)({
                    color: new (0, $eWjiX.BB).RGB(_this.primaryColorRgb.r, _this.primaryColorRgb.g, _this.primaryColorRgb.b),
                    onClose: function(rgbObj) {
                        if (!rgbObj) return;
                        _this.setColor(rgbObj);
                        _this.emitColor(new (0, $eWjiX.BB).RGB(_this.primaryColorRgb.r, _this.primaryColorRgb.g, _this.primaryColorRgb.b));
                    }
                });
            }
        });
        var hexButtonPointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.hexButton,
            onEnterLeave: function(isOver) {
                _this.hexButton.classList.toggle('color-picker-preview-button-hover', isOver);
            }
        });
        this.divPreview.append(this.hexButton);
        this.setColPreview();
        setTimeout(function() {
            createHueBg(divH);
            divH.append(_this.controlH);
            var svPointerListener = new (0, $eWjiX.BB).PointerListener({
                target: svWrapper,
                fixScribble: true,
                onPointer: function(event) {
                    if (event.type === 'pointerdown') {
                        // prevent manual slider input keeping focus on iPad
                        (0, $eWjiX.BB).unfocusAnyInput();
                        _this.SVContainer.classList.toggle('kl-color-picker--active', true);
                        if (event.button === 'left') {
                            virtualHSV.s = event.relX / _this.width * 100;
                            virtualHSV.v = 100 - event.relY / _this.svHeight * 100;
                            _this.primaryColorHsv = new (0, $eWjiX.BB).HSV(_this.primaryColorHsv.h, virtualHSV.s, virtualHSV.v);
                            _this.primaryColorRgb = (0, $eWjiX.BB).ColorConverter.toRGB(_this.primaryColorHsv);
                            _this.updateSVPointer();
                            _this.setColPreview();
                            _this.emitColor((0, $eWjiX.BB).ColorConverter.toRGB(_this.primaryColorHsv));
                        } else {
                            virtualHSV.s = _this.primaryColorHsv.s;
                            virtualHSV.v = _this.primaryColorHsv.v;
                        }
                    }
                    if (event.type === 'pointermove' && [
                        'left',
                        'right'
                    ].includes(event.button || '')) {
                        var factor = 1;
                        if (event.button === 'right') factor = 0.5;
                        virtualHSV.s += event.dX / _this.width * 100 * factor;
                        virtualHSV.v -= event.dY / _this.svHeight * 100 * factor;
                        _this.primaryColorHsv = new (0, $eWjiX.BB).HSV(_this.primaryColorHsv.h, virtualHSV.s, virtualHSV.v);
                        _this.primaryColorRgb = (0, $eWjiX.BB).ColorConverter.toRGB(_this.primaryColorHsv);
                        _this.updateSVPointer();
                        _this.setColPreview();
                        _this.emitColor((0, $eWjiX.BB).ColorConverter.toRGB(_this.primaryColorHsv));
                    }
                    if (event.type === 'pointerup') _this.SVContainer.classList.toggle('kl-color-picker--active', false);
                }
            });
            var hPointerListener = new (0, $eWjiX.BB).PointerListener({
                target: divH,
                fixScribble: true,
                onPointer: function(event) {
                    if (event.type === 'pointerdown') {
                        // prevent manual slider input keeping focus on iPad
                        (0, $eWjiX.BB).unfocusAnyInput();
                        divH.classList.toggle('kl-color-picker--active', true);
                        if (event.button === 'left') {
                            virtualHSV.h = event.relX / _this.width * 359.99;
                            _this.primaryColorHsv = new (0, $eWjiX.BB).HSV(virtualHSV.h, _this.primaryColorHsv.s, _this.primaryColorHsv.v);
                            _this.primaryColorRgb = (0, $eWjiX.BB).ColorConverter.toRGB(_this.primaryColorHsv);
                            _this.controlH.style.left = Math.round(_this.primaryColorHsv.h / 359.99 * _this.width) - 1 + 'px';
                            _this.updateSVCanvas();
                            _this.setColPreview();
                            _this.emitColor((0, $eWjiX.BB).ColorConverter.toRGB(_this.primaryColorHsv));
                        } else virtualHSV.h = _this.primaryColorHsv.h;
                    }
                    if (event.type === 'pointermove' && [
                        'left',
                        'right'
                    ].includes(event.button || '')) {
                        var deltaY = Math.abs(event.pageY - event.downPageY);
                        var factor = (0, $16ee6d1163eaf409$export$f8e41e222e32615d)(deltaY, event.button === 'right');
                        virtualHSV.h += event.dX / _this.width * 359.99 * factor;
                        if (event.button === 'right') {
                            virtualHSV.h = virtualHSV.h % 359.99;
                            if (virtualHSV.h < 0) virtualHSV.h += 359.99;
                        }
                        virtualHSV.h = Math.min(359.99, virtualHSV.h);
                        _this.primaryColorHsv = new (0, $eWjiX.BB).HSV(virtualHSV.h, _this.primaryColorHsv.s, _this.primaryColorHsv.v);
                        _this.primaryColorRgb = (0, $eWjiX.BB).ColorConverter.toRGB(_this.primaryColorHsv);
                        _this.controlH.style.left = Math.round(_this.primaryColorHsv.h / 359.99 * _this.width) - 1 + 'px';
                        _this.updateSVCanvas();
                        _this.setColPreview();
                        _this.emitColor((0, $eWjiX.BB).ColorConverter.toRGB(_this.primaryColorHsv));
                    }
                    if (event.type === 'pointerup') divH.classList.toggle('kl-color-picker--active', false);
                }
            });
        }, 1);
        // --- secondary color ---
        this.secondaryColorBtn = (0, $eWjiX.BB).el({
            parent: this.outputDiv,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('secondary-color') + ' [X]',
            className: 'kl-color-picker__secondary',
            css: {
                cursor: 'pointer',
                marginLeft: '5px',
                width: '22px',
                height: '22px'
            },
            onClick: function(e) {
                e.preventDefault();
                _this.swapColors();
            }
        });
        this.updateSecondaryColor();
    }
    (0, $7h4XF._)(KlColorSlider, [
        {
            key: "updatePrimaryHSV",
            value: function updatePrimaryHSV(hsv) {
                if (hsv.s === 0) this.primaryColorHsv = new (0, $eWjiX.BB).HSV(this.primaryColorHsv.h, hsv.s, hsv.v);
                else this.primaryColorHsv = new (0, $eWjiX.BB).HSV(hsv.h, hsv.s, hsv.v);
            }
        },
        {
            key: "updateSVCanvas",
            value: function updateSVCanvas() {
                var rgb = (0, $eWjiX.BB).ColorConverter.toRGB(new (0, $eWjiX.BB).HSV(this.primaryColorHsv.h, 100, 100));
                this.svGradient.style.setProperty('--kl-color-picker--hue', '#' + (0, $eWjiX.BB).ColorConverter.toHexString(rgb));
            }
        },
        {
            key: "updateSVPointer",
            value: function updateSVPointer() {
                var left = this.primaryColorHsv.s / 100 * this.width - 7;
                var top = (1 - this.primaryColorHsv.v / 100) * this.svHeight - 6;
                (0, $7jh4K.css)(this.pointerSV, {
                    left: left + 'px',
                    top: top + 'px'
                });
            }
        },
        {
            key: "setColPreview",
            value: function setColPreview() {
                this.divPreview.style.backgroundColor = 'rgb(' + this.primaryColorRgb.r + ',' + this.primaryColorRgb.g + ',' + this.primaryColorRgb.b + ')';
                if ((0, $eWjiX.BB).testIsWhiteBestContrast(this.primaryColorRgb)) {
                    (0, $7jh4K.css)(this.pickerButton, {
                        filter: 'invert(1)'
                    });
                    (0, $7jh4K.css)(this.hexButton, {
                        filter: 'invert(1)'
                    });
                } else {
                    (0, $7jh4K.css)(this.pickerButton, {
                        filter: ''
                    });
                    (0, $7jh4K.css)(this.hexButton, {
                        filter: ''
                    });
                }
            }
        },
        {
            key: "updateSecondaryColor",
            value: function updateSecondaryColor() {
                this.secondaryColorBtn.style.backgroundColor = (0, $eWjiX.BB).ColorConverter.toRgbStr(this.secondaryColorRgb);
            }
        },
        {
            key: "setColor",
            value: function setColor(c) {
                this.primaryColorRgb = {
                    r: parseInt('' + c.r),
                    g: parseInt('' + c.g),
                    b: parseInt('' + c.b)
                };
                this.updatePrimaryHSV((0, $eWjiX.BB).ColorConverter.toHSV(c));
                this.controlH.style.left = parseInt('' + (this.primaryColorHsv.h / 359 * this.width - 1)) + 'px';
                this.updateSVCanvas();
                this.updateSVPointer();
                this.setColPreview();
            }
        },
        {
            key: "getColor",
            value: function getColor() {
                return new (0, $eWjiX.BB).RGB(this.primaryColorRgb.r, this.primaryColorRgb.g, this.primaryColorRgb.b);
            }
        },
        {
            key: "getSecondaryRGB",
            value: function getSecondaryRGB() {
                return new (0, $eWjiX.BB).RGB(this.secondaryColorRgb.r, this.secondaryColorRgb.g, this.secondaryColorRgb.b);
            }
        },
        {
            key: "getIsEyedropping",
            value: function getIsEyedropping() {
                return this.isPicking;
            }
        },
        {
            key: "setIsEyedropping",
            value: function setIsEyedropping(b) {
                if (b) {
                    this.isPicking = true;
                    this.onEyedropper(true);
                    this.pickerButton.classList.add('color-picker-preview-button-active');
                } else {
                    this.isPicking = false;
                    this.onEyedropper(false);
                    this.pickerButton.classList.remove('color-picker-preview-button-active');
                }
            }
        },
        {
            key: "enable",
            value: function enable(e) {
                var style = {
                    pointerEvents: e ? '' : 'none',
                    opacity: e ? '1' : '0.5'
                };
                (0, $7jh4K.css)(this.rootEl, style);
                (0, $7jh4K.css)(this.outputDiv, style);
            }
        },
        {
            key: "setHeight",
            value: function setHeight(h) {
                h = parseInt('' + (h - this.height * 2 - 3), 10);
                if (h === this.svHeight) return;
                this.svHeight = h;
                (0, $7jh4K.css)(this.svGradient, {
                    width: this.width + 'px',
                    height: this.svHeight + 'px'
                });
                this.SVContainer.style.height = this.svHeight + 'px';
                this.updateSVPointer();
            }
        },
        {
            key: "swapColors",
            value: function swapColors() {
                // swap hsv
                var tmp = this.secondaryColorHsv;
                this.secondaryColorHsv = this.primaryColorHsv;
                this.updatePrimaryHSV(tmp);
                // swap rgb
                tmp = this.secondaryColorRgb;
                this.secondaryColorRgb = this.primaryColorRgb;
                this.primaryColorRgb = tmp;
                this.controlH.style.left = parseInt('' + (this.primaryColorHsv.h / 359 * this.width - 1)) + 'px';
                this.updateSVCanvas();
                this.updateSVPointer();
                this.setColPreview();
                this.updateSecondaryColor();
                this.emitColor(new (0, $eWjiX.BB).RGB(this.primaryColorRgb.r, this.primaryColorRgb.g, this.primaryColorRgb.b));
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getOutputElement",
            value: function getOutputElement() {
                return this.outputDiv;
            }
        }
    ]);
    return KlColorSlider;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");


var $7jh4K = parcelRequire("7jh4K");
var $3ce0af1e789f1ab4$export$66306bf21a9ff39e = /*#__PURE__*/ function() {
    "use strict";
    function KlColorSliderSmall(p) {
        var _this = this;
        (0, $cx0mh._)(this, KlColorSliderSmall);
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                width: p.width + 'px',
                position: 'relative',
                overflow: 'hidden',
                userSelect: 'none'
            }
        });
        this.rootEl.oncontextmenu = function(e) {
            e.preventDefault();
        };
        this.color = (0, $eWjiX.BB).ColorConverter.toHSV(new (0, $eWjiX.BB).RGB(p.color.r, p.color.g, p.color.b));
        this.width = p.width;
        this.heightSV = p.heightSV;
        this.canvasSV = (0, $eWjiX.BB).canvas(10, 10);
        (0, $7jh4K.css)(this.canvasSV, {
            width: this.width + 'px',
            height: this.heightSV + 'px',
            cursor: 'crosshair'
        });
        this.updateSV();
        var canvasH = (0, $eWjiX.BB).canvas(p.width, p.heightH);
        canvasH.style.cursor = 'ew-resize';
        (function() {
            var ctx = (0, $eWjiX.BB).ctx(canvasH);
            var gradH = ctx.createLinearGradient(0, 0, p.width, 0);
            for(var i = 0; i < 1; i += 0.01){
                var col = (0, $eWjiX.BB).ColorConverter.toRGB(new (0, $eWjiX.BB).HSV(i * 360, 100, 100));
                gradH.addColorStop(i, 'rgba(' + parseInt('' + col.r) + ', ' + parseInt('' + col.g) + ', ' + parseInt('' + col.b) + ', 1)');
            }
            ctx.fillStyle = gradH;
            ctx.fillRect(0, 0, p.width, p.heightH);
        })();
        (0, $7jh4K.css)(this.canvasSV, {
            width: p.width + 'px',
            height: p.heightSV + 'px',
            overflow: 'hidden',
            position: 'relative'
        });
        this.canvasSV.style.cssFloat = 'left';
        canvasH.style.cssFloat = 'left';
        this.rootEl.append(this.canvasSV, canvasH);
        this.pointerSV = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                width: '8px',
                height: '8px',
                borderRadius: '8px',
                position: 'absolute',
                pointerEvents: 'none',
                boxShadow: '0 0 0 1px #000, inset 0 0 0 1px #fff'
            }
        });
        this.pointerH = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                width: '0',
                height: p.heightH + 'px',
                borderLeft: '1px solid #fff',
                borderRight: '1px solid #000',
                position: 'absolute',
                top: p.heightSV + 'px',
                pointerEvents: 'none'
            }
        });
        this.updateSVPointer();
        this.updateHPointer();
        var virtualHSV = {
            h: 0,
            s: 0,
            v: 0
        };
        this.svPointerId = null;
        this.svPointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.canvasSV,
            fixScribble: true,
            onPointer: function(event) {
                if (event.type === 'pointerdown') {
                    // prevent manual slider input keeping focus on iPad
                    (0, $eWjiX.BB).unfocusAnyInput();
                    _this.svPointerId = event.pointerId;
                    if (event.button === 'left') {
                        virtualHSV.s = event.relX / p.width * 100;
                        virtualHSV.v = 100 - event.relY / p.heightSV * 100;
                        _this.color = new (0, $eWjiX.BB).HSV(_this.color.h, virtualHSV.s, virtualHSV.v);
                        _this.updateSVPointer();
                        p.callback((0, $eWjiX.BB).ColorConverter.toRGB(_this.color));
                    } else {
                        virtualHSV.s = _this.color.s;
                        virtualHSV.v = _this.color.v;
                    }
                }
                if (event.type === 'pointermove' && [
                    'left',
                    'right'
                ].includes('' + event.button) && _this.svPointerId === event.pointerId) {
                    var factor = 1;
                    if (event.button === 'right') factor = 0.5;
                    virtualHSV.s += event.dX / p.width * 100 * factor;
                    virtualHSV.v -= event.dY / p.heightSV * 100 * factor;
                    _this.color = new (0, $eWjiX.BB).HSV(_this.color.h, virtualHSV.s, virtualHSV.v);
                    _this.updateSVPointer();
                    p.callback((0, $eWjiX.BB).ColorConverter.toRGB(_this.color));
                }
                if (event.type === 'pointerup') _this.svPointerId = null;
            }
        });
        this.hPointerId = null;
        this.hPointerListener = new (0, $eWjiX.BB).PointerListener({
            target: canvasH,
            fixScribble: true,
            onPointer: function(event) {
                if (event.type === 'pointerdown') {
                    _this.hPointerId = event.pointerId;
                    if (event.button === 'left') {
                        virtualHSV.h = event.relX / p.width * 359.99;
                        _this.color = new (0, $eWjiX.BB).HSV(virtualHSV.h, _this.color.s, _this.color.v);
                        _this.updateSV();
                        _this.updateHPointer();
                        p.callback((0, $eWjiX.BB).ColorConverter.toRGB(_this.color));
                    } else virtualHSV.h = _this.color.h;
                }
                if (event.type === 'pointermove' && [
                    'left',
                    'right'
                ].includes('' + event.button) && _this.hPointerId === event.pointerId) {
                    var deltaY = Math.abs(event.pageY - event.downPageY);
                    var factor = (0, $16ee6d1163eaf409$export$f8e41e222e32615d)(deltaY, event.button === 'right');
                    virtualHSV.h += event.dX / p.width * 359.99 * factor;
                    if (event.button === 'right') {
                        virtualHSV.h = virtualHSV.h % 359.99;
                        if (virtualHSV.h < 0) virtualHSV.h += 359.99;
                    }
                    virtualHSV.h = Math.min(359.99, virtualHSV.h);
                    _this.color = new (0, $eWjiX.BB).HSV(virtualHSV.h, _this.color.s, _this.color.v);
                    _this.updateSV();
                    _this.updateHPointer();
                    p.callback((0, $eWjiX.BB).ColorConverter.toRGB(_this.color));
                }
                if (event.type === 'pointerup') _this.hPointerId = null;
            }
        });
        var cleardiv = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                clear: 'both'
            }
        });
    }
    (0, $7h4XF._)(KlColorSliderSmall, [
        {
            key: "updateSV",
            value: function updateSV() {
                var ctx = (0, $eWjiX.BB).ctx(this.canvasSV);
                if (!ctx) throw new Error("couldn't create canvas");
                for(var i = 0; i < this.canvasSV.height; i += 1){
                    var gradient1 = ctx.createLinearGradient(0, 0, this.canvasSV.width, 0);
                    var colleft = (0, $eWjiX.BB).ColorConverter.toRGB(new (0, $eWjiX.BB).HSV(this.color.h, 1, 100 - i / this.canvasSV.height * 100.0));
                    var colright = (0, $eWjiX.BB).ColorConverter.toRGB(new (0, $eWjiX.BB).HSV(this.color.h, 100, 100 - i / this.canvasSV.height * 100.0));
                    gradient1.addColorStop(0, '#' + (0, $eWjiX.BB).ColorConverter.toHexString(colleft));
                    gradient1.addColorStop(1, '#' + (0, $eWjiX.BB).ColorConverter.toHexString(colright));
                    ctx.fillStyle = '#ff0000'; //needed for chrome...otherwise alpha problem
                    ctx.fillStyle = gradient1;
                    ctx.fillRect(0, i, this.canvasSV.width, 1);
                }
            }
        },
        {
            key: "updateSVPointer",
            value: function updateSVPointer() {
                var left = this.color.s / 100 * this.width - 4;
                var top = (1 - this.color.v / 100) * this.heightSV - 4;
                (0, $7jh4K.css)(this.pointerSV, {
                    left: left + 'px',
                    top: top + 'px'
                });
            }
        },
        {
            key: "updateHPointer",
            value: function updateHPointer() {
                this.pointerH.style.left = this.color.h / 359.999 * this.width - 1 + 'px';
            }
        },
        {
            // ---- interface ----
            key: "setColor",
            value: function setColor(c) {
                if (this.hPointerId !== null || this.svPointerId !== null) return;
                this.color = (0, $eWjiX.BB).ColorConverter.toHSV(new (0, $eWjiX.BB).RGB(c.r, c.g, c.b));
                this.updateSV();
                this.updateSVPointer();
                this.updateHPointer();
            }
        },
        {
            key: "getColor",
            value: function getColor() {
                return (0, $eWjiX.BB).ColorConverter.toRGB(this.color);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "end",
            value: function end() {
                this.svPointerId = null;
                this.hPointerId = null;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.svPointerListener.destroy();
                this.hPointerListener.destroy();
            }
        }
    ]);
    return KlColorSliderSmall;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");
var $5e81242a941997c7$export$ac00cea56cec3037 = /*#__PURE__*/ function() {
    "use strict";
    function PointSlider(p) {
        var _this = this;
        (0, $cx0mh._)(this, PointSlider);
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                position: 'relative'
            }
        });
        var sliderLine = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            className: 'kl-point-slider__line',
            css: {
                marginTop: parseInt('' + (p.pointSize / 2 - 1)) + 'px',
                width: p.width + 'px'
            }
        });
        this.sliderPoint = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            className: 'kl-point-slider__point'
        });
        var sliderPos;
        var isDragging = false;
        //sliderPoint
        var touchAreaEl = (0, $eWjiX.BB).el({
            // expand clickable area
            parent: this.sliderPoint,
            css: {
                // background: 'rgba(255,0,0,0.4)',
                margin: '-7px 0 0 -7px',
                width: 'calc(100% + 14px)',
                height: 'calc(100% + 7px)'
            }
        });
        var redrawPoint = function() {
            (0, $7jh4K.css)(_this.sliderPoint, {
                left: sliderPos + 'px'
            });
        };
        var getValue = function() {
            return sliderPos / (p.width - p.pointSize);
        };
        {
            var isFirst;
            sliderPos = (0, $eWjiX.BB).clamp(p.init * (p.width - p.pointSize), 0, p.width - p.pointSize);
            (0, $7jh4K.css)(this.sliderPoint, {
                width: p.pointSize + 'px',
                height: p.pointSize + 'px',
                borderRadius: p.pointSize + 'px'
            });
            redrawPoint();
            var imaginaryPos;
            this.pointerListener = new (0, $eWjiX.BB).PointerListener({
                target: this.sliderPoint,
                fixScribble: true,
                onPointer: function(event) {
                    if (event.type === 'pointerdown' && event.button === 'left') {
                        isFirst = true;
                        isDragging = true;
                        imaginaryPos = sliderPos;
                        redrawPoint();
                        event.eventStopPropagation();
                    } else if (event.type === 'pointermove' && event.button === 'left') {
                        event.eventStopPropagation();
                        imaginaryPos = imaginaryPos + event.dX;
                        sliderPos = parseInt('' + (0, $eWjiX.BB).clamp(imaginaryPos, 0, p.width - p.pointSize));
                        redrawPoint();
                        p.callback(getValue(), isFirst, false);
                        isFirst = false;
                    }
                    if (event.type === 'pointerup') {
                        event.eventStopPropagation();
                        isDragging = false;
                        redrawPoint();
                        p.callback(getValue(), false, true);
                    }
                }
            });
        }
    }
    (0, $7h4XF._)(PointSlider, [
        {
            // ---- interface ----
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "setActive",
            value: function setActive(isActive) {
                this.sliderPoint.style.backgroundColor = isActive ? '#fff' : '#eaeaea';
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.pointerListener.destroy();
            }
        }
    ]);
    return PointSlider;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $eWjiX = parcelRequire("eWjiX");

var $dJ1E2 = parcelRequire("dJ1E2");

var $4db8cbbb01889095$export$24ba9b81662d4366 = /*#__PURE__*/ function() {
    "use strict";
    function ColorOptions(p) {
        var _this = this;
        (0, $cx0mh._)(this, ColorOptions);
        this.colorArr = [];
        this.selectedIndex = 0;
        var _p_title;
        this.rootEl = (0, $eWjiX.BB).el({
            content: p.label ? p.label : '',
            title: (_p_title = p.title) !== null && _p_title !== void 0 ? _p_title : undefined,
            css: (0, $cL71g._)({
                display: 'flex',
                alignItems: 'center',
                gap: '7px',
                position: 'relative'
            }, p.css)
        });
        this.buttonArr = [];
        var buttonSize = 22;
        this.onColorInputChange = function() {
            var i = _this.selectedIndex;
            var color = _this.colorArr[i];
            if (!color || color.a < 1) // ignore
            return;
            var newRawColor = _this.colorInput.value;
            _this.buttonArr[_this.selectedIndex].el.style.backgroundColor = newRawColor;
            _this.colorArr[i] = (0, $4EWN2._)((0, $cL71g._)({}, (0, $dJ1E2.ColorConverter).hexToRGB(newRawColor)), {
                a: 1
            });
            p.onChange(_this.colorArr[i]);
        };
        this.colorInput = (0, $eWjiX.BB).el({
            tagName: 'input',
            custom: {
                type: 'color',
                tabIndex: '-1'
            }
        });
        this.colorInput.onchange = this.onColorInputChange;
        this.colorInput.oninput = this.onColorInputChange;
        // build colorArr while removing duplicates
        for(var i = 0; i < p.colorArr.length; i++){
            var item = p.colorArr[i];
            var found = false;
            for(var e = 0; e < this.colorArr.length; e++){
                var sItem = this.colorArr[e];
                if (sItem === item) {
                    found = true;
                    break;
                }
                if (sItem === null || item === null) continue;
                if (sItem.r === item.r && sItem.g === item.g && sItem.b === item.b && sItem.a === item.a) {
                    found = true;
                    break;
                }
            }
            if (found) continue;
            this.colorArr.push(item);
            if ('initialIndex' in p && p.initialIndex === i) this.selectedIndex = this.colorArr.length - 1;
        }
        for(var i1 = 0; i1 < this.colorArr.length; i1++)(function(i) {
            var color = _this.colorArr[i];
            var colorButton = (0, $eWjiX.BB).el({
                parent: _this.rootEl,
                content: color ? '' : 'X',
                className: 'kl-color-option',
                css: {
                    width: buttonSize + 'px',
                    height: buttonSize + 'px',
                    backgroundColor: color ? (0, $eWjiX.BB).ColorConverter.toRgbaStr(color) : 'transparent',
                    lineHeight: buttonSize + 1 + 'px'
                },
                onClick: function(e) {
                    if (_this.selectedIndex === i) {
                        if (color && color.a === 1) _this.colorInput.showPicker ? _this.colorInput.showPicker() : _this.colorInput.click();
                        return;
                    }
                    e.preventDefault();
                    _this.selectedIndex = i;
                    update();
                    p.onChange(_this.colorArr[i]); // color may change
                }
            });
            if (color && color.a === 0) colorButton.style.background = 'var(--kl-checkerboard-background)';
            var setIsSelected = function(b) {
                colorButton.classList.toggle('kl-color-option--active', b);
            };
            _this.buttonArr.push({
                el: colorButton,
                setIsSelected: setIsSelected
            });
        })(i1);
        this.rootEl.append((0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',w-0,h-0,overflow-hidden,abs-0-0', [
            this.colorInput
        ]));
        var update = function() {
            for(var i = 0; i < _this.buttonArr.length; i++)_this.buttonArr[i].setIsSelected(i === _this.selectedIndex);
        };
        update();
    }
    (0, $7h4XF._)(ColorOptions, [
        {
            // ---- interface ----
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.colorArr[this.selectedIndex];
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.rootEl.remove();
                this.buttonArr.forEach(function(item) {
                    (0, $eWjiX.BB).destroyEl(item.el);
                });
                this.buttonArr.splice(0, this.buttonArr.length);
                this.colorInput.onchange = null;
                this.colorInput.oninput = null;
            }
        }
    ]);
    return ColorOptions;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");
var $7960d0c50ff12b0d$export$c019608e5b5bb4cb = /*#__PURE__*/ function() {
    "use strict";
    function Options(p) {
        var _this = this;
        (0, $cx0mh._)(this, Options);
        this.rootEl = (0, $eWjiX.BB).el({
            css: p.css
        });
        var wrapperEl = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            className: 'kl-option-wrapper',
            css: {
                display: 'flex',
                flexDirection: p.isColumn ? 'column' : 'row'
            }
        });
        if (p.onChange) {
            this.onChange = p.onChange;
            this.onBeforeChange = p.onBeforeChange;
        }
        this.optionArr = [];
        this.selectedId = 'initialId' in p && p.initId !== undefined ? p.initId : p.optionArr[0].id;
        var createOption = function(o) {
            var classArr = [
                'kl-option'
            ];
            if (p.isSmall) classArr.push('kl-option--small');
            if (typeof o.label !== 'string') {
                classArr.push('kl-option--custom-el');
                (0, $7jh4K.css)(o.label, {
                    display: 'block',
                    pointerEvents: 'none'
                });
            }
            var optionObj = {
                id: o.id,
                el: (0, $eWjiX.BB).el({
                    parent: wrapperEl,
                    content: o.label,
                    className: classArr.join(' '),
                    onClick: function() {
                        if (_this.selectedId !== optionObj.id) {
                            if (_this.onBeforeChange && !_this.onBeforeChange(optionObj.id)) return;
                            _this.selectedId = optionObj.id;
                            _this.update();
                            _this.onChange && _this.onChange(_this.selectedId);
                        }
                    },
                    css: p.optionCss
                })
            };
            if (o.title) optionObj.el.title = o.title;
            _this.optionArr.push(optionObj);
        };
        for(var i = 0; i < p.optionArr.length; i++)createOption(p.optionArr[i]);
        this.update();
        if (p.changeOnInit) setTimeout(function() {
            _this.onChange && _this.onChange(_this.selectedId);
        }, 0);
    }
    (0, $7h4XF._)(Options, [
        {
            key: "getIndex",
            value: function getIndex() {
                for(var i = 0; i < this.optionArr.length; i++){
                    if (this.optionArr[i].id === this.selectedId) return i;
                }
                return -1;
            }
        },
        {
            key: "update",
            value: function update() {
                for(var i = 0; i < this.optionArr.length; i++)this.optionArr[i].el.classList.toggle('kl-option-selected', this.optionArr[i].id === this.selectedId);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.selectedId;
            }
        },
        {
            key: "next",
            value: function next() {
                this.selectedId = this.optionArr[(this.getIndex() + 1) % this.optionArr.length].id;
                this.update();
                this.onChange && this.onChange(this.selectedId);
            }
        },
        {
            key: "setValue",
            value: function setValue(val, skipEmit) {
                if (this.selectedId === val) return;
                if (this.onBeforeChange && !this.onBeforeChange(val)) return;
                this.selectedId = val;
                this.update();
                !skipEmit && this.onChange && this.onChange(this.selectedId);
            }
        },
        {
            key: "previous",
            value: function previous() {
                this.selectedId = this.optionArr[(this.optionArr.length + this.getIndex() - 1) % this.optionArr.length].id;
                this.update();
                this.onChange && this.onChange(this.selectedId);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.rootEl.remove();
                this.optionArr.forEach(function(item) {
                    (0, $eWjiX.BB).destroyEl(item.el);
                });
                this.optionArr.splice(0, this.optionArr.length);
            }
        }
    ]);
    return Options;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $ad47d2e0edfb40c7$exports = {};
$ad47d2e0edfb40c7$exports = $parcel$resolve("iQ1f0");



var $7jh4K = parcelRequire("7jh4K");
var $c1a93a3cd82636c9$export$5ee0af1d5c87e856 = /*#__PURE__*/ function() {
    "use strict";
    function StatusOverlay() {
        (0, $cx0mh._)(this, StatusOverlay);
        this.isWide = false // tool space hidden
        ;
        this.uiState = 'right';
        this.el = (0, $eWjiX.BB).el({
            className: 'top-overlay g-root',
            onClick: (0, $eWjiX.BB).handleClick
        });
        this.updateUiState();
        this.innerEl = (0, $eWjiX.BB).el({
            className: 'top-overlay--inner'
        });
        this.angleIm = new Image();
        this.angleIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($ad47d2e0edfb40c7$exports)));
        (0, $7jh4K.css)(this.angleIm, {
            verticalAlign: 'bottom',
            width: '20px',
            height: '20px',
            marginLeft: '5px',
            borderRadius: '10px'
        });
        this.innerInnerEl = document.createElement('div');
        this.innerInnerEl.style.display = 'inline-block';
        this.innerEl.append(this.innerInnerEl, this.angleIm);
        this.el.append(this.innerEl);
        document.body.append(this.el);
        this.el.style.display = 'none';
    }
    (0, $7h4XF._)(StatusOverlay, [
        {
            key: "updateUiState",
            value: function updateUiState() {
                if (this.uiState === 'left') this.el.style.left = '271px';
                else this.el.style.removeProperty('left');
            }
        },
        {
            key: "setWide",
            value: function setWide(b) {
                this.isWide = b;
                if (!this.el) return;
                if (this.isWide) {
                    this.el.style.width = '100%';
                    this.el.style.left = '';
                } else {
                    this.el.style.removeProperty('width');
                    this.el.style.left = this.uiState === 'left' ? '271px' : '';
                }
            }
        },
        {
            key: "setUiState",
            value: function setUiState(state) {
                this.uiState = state;
                this.updateUiState();
            }
        },
        {
            key: "out",
            value: function out(msg, doPulse) {
                var _this = this;
                if (typeof msg === 'string') {
                    this.angleIm.style.display = 'none';
                    this.innerInnerEl.style.removeProperty('font-family');
                    this.innerInnerEl.innerHTML = msg;
                } else if (msg.type === 'transform') {
                    this.angleIm.style.display = 'inline-block';
                    this.angleIm.style.transform = 'rotate(' + msg.angleDeg + 'deg)';
                    if (msg.angleDeg % 90 === 0) this.angleIm.style.boxShadow = 'inset 0 0 0 1px rgba(255, 255, 255, 0.7)';
                    else this.angleIm.style.boxShadow = '';
                    this.innerInnerEl.style.fontFamily = 'monospace';
                    this.innerInnerEl.innerHTML = Math.round(msg.scale * 100) + '%';
                } else this.angleIm.style.display = 'none';
                if (doPulse) {
                    this.innerEl.style.animation = '';
                    setTimeout(function() {
                        return _this.innerEl.style.animation = 'topOverlayPulse 0.5s ease-out';
                    }, 20);
                    clearTimeout(this.timeout3);
                    this.timeout3 = setTimeout(function() {
                        return _this.innerEl.style.animation = '';
                    }, 520);
                }
                clearTimeout(this.timeout);
                clearTimeout(this.timeout2);
                this.el.style.animationName = doPulse ? 'consoleInFast' : 'consoleIn';
                this.el.style.opacity = '1';
                this.timeout = setTimeout(function() {
                    _this.el.style.opacity = '0';
                    _this.el.style.animationName = 'consoleOut';
                    _this.timeout2 = setTimeout(function() {
                        _this.el.style.display = 'none';
                    }, 450);
                }, 1200);
                this.el.style.display = 'flex';
            }
        }
    ]);
    return StatusOverlay;
}();



var $1LaJZ = parcelRequire("1LaJZ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $fk3zw = parcelRequire("fk3zw");

var $eWjiX = parcelRequire("eWjiX");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $bX4ja = parcelRequire("bX4ja");


var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $bX4ja = parcelRequire("bX4ja");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");

parcelRequire("ciAU9");
var $dZ59l = parcelRequire("dZ59l");
var $kDVZW = parcelRequire("kDVZW");
parcelRequire("ciAU9");
var $dZ59l = parcelRequire("dZ59l");
var $1RMPr = parcelRequire("1RMPr");
var $kFecW = parcelRequire("kFecW");
var $kr2fR = parcelRequire("kr2fR");
function $92816524e1b72be4$export$ad1d215dd03fe75a(transform) {
    var scaleX = 'scale' in transform ? transform.scale : transform.scaleX;
    var scaleY = 'scale' in transform ? transform.scale : transform.scaleY;
    return (0, $dZ59l.compose)((0, $kr2fR.translate)(transform.x, transform.y), (0, $1RMPr.rotate)(transform.angleDeg / 180 * Math.PI), (0, $kFecW.scale)(scaleX, scaleY));
}


function $c9ab5bbe74e01c89$export$2b60e7dafdbde18a(m) {
    return [
        m.a,
        m.b,
        m.c,
        m.d,
        m.e,
        m.f
    ];
}



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");

var $gWfkn = parcelRequire("gWfkn");
var $41bd6edeccc713f6$export$40257b1b753712da = false;
/**
 * renders into all ProjectViewports
 */ var $41bd6edeccc713f6$var$DebugRender = /*#__PURE__*/ function() {
    "use strict";
    function DebugRender() {
        (0, $cx0mh._)(this, DebugRender);
        this.internalRenderFuncs = [];
        this.renderFuncs = [];
        if ($41bd6edeccc713f6$export$40257b1b753712da) {
            // draw checkerboard
            var checkerCanvas = (0, $eWjiX.BB).createCheckerCanvas(256, false);
            var pattern = (0, $7jh4K.throwIfNull)((0, $eWjiX.BB).ctx((0, $eWjiX.BB).canvas((0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE))).createPattern(checkerCanvas, 'repeat'));
            this.internalRenderFuncs.push(function(ctx, width, height) {
                ctx.fillStyle = pattern;
                ctx.globalAlpha = 0.2;
                ctx.fillRect(0, 0, width, height);
            });
        }
    }
    (0, $7h4XF._)(DebugRender, [
        {
            key: "render",
            value: function render(ctx, width, height, scale) {
                this.internalRenderFuncs.forEach(function(func) {
                    ctx.save();
                    func(ctx, width, height, scale);
                    ctx.restore();
                });
                this.renderFuncs.forEach(function(func) {
                    ctx.save();
                    func(ctx, width, height, scale);
                    ctx.restore();
                });
            }
        },
        {
            // add something to be rendered
            key: "add",
            value: function add(func) {
                this.renderFuncs.push(func);
            }
        },
        {
            key: "remove",
            value: function remove(func) {
                for(var i = 0; i < this.renderFuncs.length; i++)if (this.renderFuncs[i] === func) {
                    this.renderFuncs.splice(i, 1);
                    return;
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.renderFuncs = [];
            }
        }
    ]);
    return DebugRender;
}();
var $41bd6edeccc713f6$export$7bf40fdf7bf55821 = new $41bd6edeccc713f6$var$DebugRender();


function $ee6e64f1b33d2735$var$fixScale(scale, pixels) {
    return Math.round(pixels * scale) / pixels;
}
var $ee6e64f1b33d2735$export$a140ed60c2ca052c = /*#__PURE__*/ function() {
    "use strict";
    function ProjectViewport(p) {
        var _this = this;
        (0, $cx0mh._)(this, ProjectViewport);
        this.doResize = true;
        this.onIsDark = function() {
            _this.pattern = (0, $7jh4K.throwIfNull)(_this.ctx.createPattern((0, $eWjiX.BB).createCheckerCanvas(10, (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).isDark()), 'repeat'));
            _this.render();
        };
        this.oldDPR = devicePixelRatio;
        this.resizeListener = function() {
            if (devicePixelRatio !== _this.oldDPR) {
                _this.canvas.style.imageRendering = Math.round(devicePixelRatio) !== devicePixelRatio ? '' : 'pixelated';
                _this.oldDPR = devicePixelRatio;
            }
        };
        this.width = p.width;
        this.height = p.height;
        this.project = p.project;
        this.useNativeResolution = !!p.useNativeResolution;
        var _p_drawBackground;
        this.drawBackground = (_p_drawBackground = p.drawBackground) !== null && _p_drawBackground !== void 0 ? _p_drawBackground : true;
        this.doFillParent = !!p.fillParent;
        this.renderAfter = p.renderAfter;
        this.transform = (0, $cL71g._)({}, p.transform);
        this.resFactor = this.useNativeResolution ? devicePixelRatio : 1;
        this.canvas = (0, $eWjiX.BB).canvas(this.width * this.resFactor, this.height * this.resFactor);
        this.ctx = (0, $eWjiX.BB).ctx(this.canvas);
        (0, $7jh4K.css)(this.canvas, {
            width: this.doFillParent ? '100%' : this.width + 'px',
            height: this.doFillParent ? '100%' : this.height + 'px',
            imageRendering: Math.round(devicePixelRatio) !== devicePixelRatio ? undefined : 'pixelated',
            display: 'block'
        });
        window.addEventListener('resize', this.resizeListener);
        this.pattern = (0, $7jh4K.throwIfNull)(this.ctx.createPattern((0, $eWjiX.BB).createCheckerCanvas(10, (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).isDark()), 'repeat'));
        (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).addIsDarkListener(this.onIsDark);
    }
    (0, $7h4XF._)(ProjectViewport, [
        {
            key: "render",
            value: function render(optimizeForAnimation) {
                var _this = this;
                var _this_renderAfter, _this1;
                var isDark = (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).isDark();
                var transform = (0, $4EWN2._)((0, $cL71g._)({}, this.transform), {
                    x: this.transform.x,
                    y: this.transform.y,
                    scale: this.transform.scale
                });
                if (this.doResize) {
                    this.doResize = false;
                    this.resFactor = this.useNativeResolution ? devicePixelRatio : 1;
                    this.canvas.width = Math.round(this.width * this.resFactor);
                    this.canvas.height = Math.round(this.height * this.resFactor);
                }
                var renderedTransform = optimizeForAnimation ? {
                    x: transform.x,
                    y: transform.y,
                    angleDeg: transform.angleDeg,
                    scaleX: transform.scale,
                    scaleY: transform.scale
                } : {
                    x: Math.round(transform.x),
                    y: Math.round(transform.y),
                    scaleX: $ee6e64f1b33d2735$var$fixScale(transform.scale, this.project.width),
                    scaleY: $ee6e64f1b33d2735$var$fixScale(transform.scale, this.project.height),
                    angleDeg: transform.angleDeg
                };
                var renderedMat = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(renderedTransform);
                this.ctx.save();
                if (renderedTransform.scaleX >= 4 || renderedTransform.scaleX === 1 && renderedTransform.angleDeg === 0) this.ctx.imageSmoothingEnabled = false;
                else {
                    this.ctx.imageSmoothingEnabled = true;
                    this.ctx.imageSmoothingQuality = 'low'; // art.scale >= 1 ? 'low' : 'medium';
                }
                // this.ctx.imageSmoothingEnabled = false;
                if (this.drawBackground) {
                    this.ctx.fillStyle = isDark ? 'rgb(33, 33, 33)' : 'rgb(158,158,158)';
                    this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
                } else {
                    this.ctx.fillStyle = this.pattern;
                    this.ctx.fillRect(0, 0, this.width, this.height);
                }
                // this.ctx.scale(this.resFactor, this.resFactor);
                this.ctx.translate(renderedTransform.x, renderedTransform.y);
                this.ctx.scale(renderedTransform.scaleX, renderedTransform.scaleY);
                this.ctx.rotate(renderedTransform.angleDeg / 180 * Math.PI);
                if (this.drawBackground) {
                    this.ctx.save();
                    this.ctx.fillStyle = (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).isDark() ? 'rgba(255,255,255,0.25)' : 'rgba(0,0,0,0.2)';
                    var scaledPixelX = 1 / renderedTransform.scaleX;
                    var scaledPixelY = 1 / renderedTransform.scaleY;
                    this.ctx.fillRect(-scaledPixelX, -scaledPixelY, this.project.width + scaledPixelX * 2, this.project.height + scaledPixelY * 2);
                    this.ctx.fillStyle = this.pattern;
                    try {
                        // setTransform got browser support since 2018-2020. catch if fails.
                        this.pattern.setTransform((0, $kDVZW.inverse)(renderedMat));
                    } catch (e) {
                    /* */ }
                    this.ctx.fillRect(0, 0, this.project.width, this.project.height);
                    this.ctx.restore();
                }
                this.project.layers.forEach(function(layer) {
                    if (!layer.isVisible || !layer.opacity) return;
                    _this.ctx.save();
                    _this.ctx.globalCompositeOperation = layer.mixModeStr;
                    _this.ctx.globalAlpha = layer.opacity;
                    var image;
                    if (typeof layer.image === 'function') {
                        var res = layer.image(renderedTransform, _this.canvas.width, _this.canvas.height);
                        if ('image' in res && 'transform' in res) {
                            var _this_ctx;
                            image = res.image;
                            (_this_ctx = _this.ctx).setTransform.apply(_this_ctx, (0, $bX4ja._)((0, $c9ab5bbe74e01c89$export$2b60e7dafdbde18a)((0, $dZ59l.compose)(renderedMat, res.transform))));
                        } else image = res;
                    } else image = layer.image;
                    _this.ctx.drawImage(image, 0, 0); // , this.project.width, this.project.height);
                    _this.ctx.restore();
                });
                (_this_renderAfter = (_this1 = this).renderAfter) === null || _this_renderAfter === void 0 ? void 0 : _this_renderAfter.call(_this1, this.ctx, renderedTransform);
                (0, $41bd6edeccc713f6$export$40257b1b753712da) && (0, $41bd6edeccc713f6$export$7bf40fdf7bf55821).render(this.ctx, this.project.width, this.project.height, renderedTransform.scaleX);
                this.ctx.restore();
            }
        },
        {
            key: "setSize",
            value: function setSize(width, height) {
                this.doResize = true;
                this.width = width;
                this.height = height;
                (0, $7jh4K.css)(this.canvas, {
                    width: this.doFillParent ? '100%' : this.width + 'px',
                    height: this.doFillParent ? '100%' : this.height + 'px'
                });
            }
        },
        {
            key: "setTransform",
            value: function setTransform(transform) {
                this.transform = (0, $cL71g._)({}, transform);
            }
        },
        {
            key: "setProject",
            value: function setProject(project) {
                this.project = project;
            }
        },
        {
            key: "getTransform",
            value: function getTransform() {
                return (0, $cL71g._)({}, this.transform);
            }
        },
        {
            key: "setUseNativeResolution",
            value: function setUseNativeResolution(b) {
                this.useNativeResolution = b;
                this.doResize = true;
            }
        },
        {
            key: "getUseNativeResolution",
            value: function getUseNativeResolution() {
                return this.useNativeResolution;
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.canvas;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                (0, $eWjiX.BB).freeCanvas(this.canvas);
                (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).removeIsDarkListener(this.onIsDark);
                window.removeEventListener('resize', this.resizeListener);
            }
        }
    ]);
    return ProjectViewport;
}();



var $eWjiX = parcelRequire("eWjiX");

var $04lDo = parcelRequire("04lDo");
var $c88da6b7fdef67e7$exports = {};
$c88da6b7fdef67e7$exports = $parcel$resolve("04ZZm");


var $e503dd0072d83d49$exports = {};
$e503dd0072d83d49$exports = $parcel$resolve("j9xio");


var $f121c15402c4c25f$exports = {};
$f121c15402c4c25f$exports = $parcel$resolve("fER1z");


var $ec1da9254c8485a7$exports = {};
$ec1da9254c8485a7$exports = $parcel$resolve("2gZH2");


var $0a0c8fa06baa05ba$exports = {};
$0a0c8fa06baa05ba$exports = $parcel$resolve("ghFv7");



var $gCzYB = parcelRequire("gCzYB");

var $c1lmK = parcelRequire("c1lmK");
var $8df31a3769a54937$export$77aefb1076e6c10f;
var $8df31a3769a54937$export$48c2d0f2f545ac27;
var $8df31a3769a54937$export$d7b7311ec04a3e8f;
$8df31a3769a54937$export$77aefb1076e6c10f = `VFEAZq_kl-theme-dark`;
$8df31a3769a54937$export$48c2d0f2f545ac27 = `VFEAZq_preview`;
$8df31a3769a54937$export$d7b7311ec04a3e8f = `VFEAZq_viewport`;


function $6ac4ab2dc9a117c8$export$8c03162b1a39d183(oldScale, stepNum) {
    var step = Math.log2(oldScale);
    var newStep = step / Math.abs(stepNum);
    newStep += stepNum > 0 ? 1 : -1;
    newStep = Math.round(newStep);
    newStep *= Math.abs(stepNum);
    return Math.pow(2, newStep);
}



var $joplQ = parcelRequire("joplQ");

parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");
parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $dZ59l = parcelRequire("dZ59l");
var $1RMPr = parcelRequire("1RMPr");
var $kFecW = parcelRequire("kFecW");
function $926e1894e59cf403$export$99c68a89351e15c0(viewportPoint, canvasPoint, scale, angleDeg) {
    var mat = (0, $dZ59l.compose)((0, $kFecW.scale)(-scale, -scale), (0, $1RMPr.rotate)(angleDeg / 180 * Math.PI));
    var topLeftP = (0, $cdZRx.applyToPoint)(mat, canvasPoint);
    topLeftP.x += viewportPoint.x;
    topLeftP.y += viewportPoint.y;
    return {
        x: topLeftP.x,
        y: topLeftP.y,
        scale: scale,
        angleDeg: angleDeg
    };
}



parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");
function $c4f45fb8696b5286$export$935bc53f7df03c95(transform, viewportP) {
    var m = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(transform);
    var canvasP = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(m), viewportP);
    return {
        viewportP: viewportP,
        canvasP: canvasP,
        scale: transform.scale,
        angleDeg: transform.angleDeg
    };
}





var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $c08bd94435b4b84a$export$8bb18c96af1baaf3;
var $c08bd94435b4b84a$export$eea3e4f737fa39e3;
var $c08bd94435b4b84a$export$d1eb619e8f7efb22;
var $c08bd94435b4b84a$export$2f48b40a5a83dc1b;
$c08bd94435b4b84a$export$8bb18c96af1baaf3 = `uIhb5a_blackAnim`;
$c08bd94435b4b84a$export$8bb18c96af1baaf3;
$c08bd94435b4b84a$export$eea3e4f737fa39e3 = `uIhb5a_blackPath`;
$c08bd94435b4b84a$export$d1eb619e8f7efb22 = `uIhb5a_whiteAnim`;
$c08bd94435b4b84a$export$d1eb619e8f7efb22;
$c08bd94435b4b84a$export$2f48b40a5a83dc1b = `uIhb5a_whitePath`;




var $9b3eo = parcelRequire("9b3eo");

var $bbA6w = parcelRequire("bbA6w");

var $bX4ja = parcelRequire("bX4ja");
var $1627388b93b6ebf7$exports = {};

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
(function(global, factory) {
    $1627388b93b6ebf7$exports = factory();
})(undefined, function() {
    'use strict';
    /**
     * splaytree v3.1.2
     * Fast Splay tree for Node and browser
     *
     * @author Alexander Milevski <info@w8r.name>
     * @license MIT
     * @preserve
     */ /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */ function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function sent() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    var Node = /** @class */ function() {
        function Node(key, data) {
            this.next = null;
            this.key = key;
            this.data = data;
            this.left = null;
            this.right = null;
        }
        return Node;
    }();
    /* follows "An implementation of top-down splaying"
     * by D. Sleator <sleator@cs.cmu.edu> March 1992
     */ function DEFAULT_COMPARE(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    /**
     * Simple top down splay, not requiring i to be in the tree t.
     */ function splay(i, t, comparator) {
        var N = new Node(null, null);
        var l = N;
        var r = N;
        while(true){
            var cmp = comparator(i, t.key);
            //if (i < t.key) {
            if (cmp < 0) {
                if (t.left === null) break;
                //if (i < t.left.key) {
                if (comparator(i, t.left.key) < 0) {
                    var y = t.left; /* rotate right */ 
                    t.left = y.right;
                    y.right = t;
                    t = y;
                    if (t.left === null) break;
                }
                r.left = t; /* link right */ 
                r = t;
                t = t.left;
            //} else if (i > t.key) {
            } else if (cmp > 0) {
                if (t.right === null) break;
                //if (i > t.right.key) {
                if (comparator(i, t.right.key) > 0) {
                    var y = t.right; /* rotate left */ 
                    t.right = y.left;
                    y.left = t;
                    t = y;
                    if (t.right === null) break;
                }
                l.right = t; /* link left */ 
                l = t;
                t = t.right;
            } else break;
        }
        /* assemble */ l.right = t.left;
        r.left = t.right;
        t.left = N.right;
        t.right = N.left;
        return t;
    }
    function insert(i, data, t, comparator) {
        var node = new Node(i, data);
        if (t === null) {
            node.left = node.right = null;
            return node;
        }
        t = splay(i, t, comparator);
        var cmp = comparator(i, t.key);
        if (cmp < 0) {
            node.left = t.left;
            node.right = t;
            t.left = null;
        } else if (cmp >= 0) {
            node.right = t.right;
            node.left = t;
            t.right = null;
        }
        return node;
    }
    function split(key, v, comparator) {
        var left = null;
        var right = null;
        if (v) {
            v = splay(key, v, comparator);
            var cmp = comparator(v.key, key);
            if (cmp === 0) {
                left = v.left;
                right = v.right;
            } else if (cmp < 0) {
                right = v.right;
                v.right = null;
                left = v;
            } else {
                left = v.left;
                v.left = null;
                right = v;
            }
        }
        return {
            left: left,
            right: right
        };
    }
    function merge(left, right, comparator) {
        if (right === null) return left;
        if (left === null) return right;
        right = splay(left.key, right, comparator);
        right.left = left;
        return right;
    }
    /**
     * Prints level of the tree
     */ function printRow(root, prefix, isTail, out, printNode) {
        if (root) {
            out("" + prefix + (isTail ? "\u2514\u2500\u2500 " : "\u251C\u2500\u2500 ") + printNode(root) + "\n");
            var indent = prefix + (isTail ? '    ' : "\u2502   ");
            if (root.left) printRow(root.left, indent, false, out, printNode);
            if (root.right) printRow(root.right, indent, true, out, printNode);
        }
    }
    var Tree = /** @class */ function() {
        function Tree(comparator) {
            if (comparator === void 0) comparator = DEFAULT_COMPARE;
            this._root = null;
            this._size = 0;
            this._comparator = comparator;
        }
        /**
       * Inserts a key, allows duplicates
       */ Tree.prototype.insert = function(key, data) {
            this._size++;
            return this._root = insert(key, data, this._root, this._comparator);
        };
        /**
       * Adds a key, if it is not present in the tree
       */ Tree.prototype.add = function(key, data) {
            var node = new Node(key, data);
            if (this._root === null) {
                node.left = node.right = null;
                this._size++;
                this._root = node;
            }
            var comparator = this._comparator;
            var t = splay(key, this._root, comparator);
            var cmp = comparator(key, t.key);
            if (cmp === 0) this._root = t;
            else {
                if (cmp < 0) {
                    node.left = t.left;
                    node.right = t;
                    t.left = null;
                } else if (cmp > 0) {
                    node.right = t.right;
                    node.left = t;
                    t.right = null;
                }
                this._size++;
                this._root = node;
            }
            return this._root;
        };
        /**
       * @param  {Key} key
       * @return {Node|null}
       */ Tree.prototype.remove = function(key) {
            this._root = this._remove(key, this._root, this._comparator);
        };
        /**
       * Deletes i from the tree if it's there
       */ Tree.prototype._remove = function(i, t, comparator) {
            var x;
            if (t === null) return null;
            t = splay(i, t, comparator);
            var cmp = comparator(i, t.key);
            if (cmp === 0) {
                /* found it */ if (t.left === null) x = t.right;
                else {
                    x = splay(i, t.left, comparator);
                    x.right = t.right;
                }
                this._size--;
                return x;
            }
            return t; /* It wasn't there */ 
        };
        /**
       * Removes and returns the node with smallest key
       */ Tree.prototype.pop = function() {
            var node = this._root;
            if (node) {
                while(node.left)node = node.left;
                this._root = splay(node.key, this._root, this._comparator);
                this._root = this._remove(node.key, this._root, this._comparator);
                return {
                    key: node.key,
                    data: node.data
                };
            }
            return null;
        };
        /**
       * Find without splaying
       */ Tree.prototype.findStatic = function(key) {
            var current = this._root;
            var compare = this._comparator;
            while(current){
                var cmp = compare(key, current.key);
                if (cmp === 0) return current;
                else if (cmp < 0) current = current.left;
                else current = current.right;
            }
            return null;
        };
        Tree.prototype.find = function(key) {
            if (this._root) {
                this._root = splay(key, this._root, this._comparator);
                if (this._comparator(key, this._root.key) !== 0) return null;
            }
            return this._root;
        };
        Tree.prototype.contains = function(key) {
            var current = this._root;
            var compare = this._comparator;
            while(current){
                var cmp = compare(key, current.key);
                if (cmp === 0) return true;
                else if (cmp < 0) current = current.left;
                else current = current.right;
            }
            return false;
        };
        Tree.prototype.forEach = function(visitor, ctx) {
            var current = this._root;
            var Q = []; /* Initialize stack s */ 
            var done = false;
            while(!done){
                if (current !== null) {
                    Q.push(current);
                    current = current.left;
                } else if (Q.length !== 0) {
                    current = Q.pop();
                    visitor.call(ctx, current);
                    current = current.right;
                } else done = true;
            }
            return this;
        };
        /**
       * Walk key range from `low` to `high`. Stops if `fn` returns a value.
       */ Tree.prototype.range = function(low, high, fn, ctx) {
            var Q = [];
            var compare = this._comparator;
            var node = this._root;
            var cmp;
            while(Q.length !== 0 || node)if (node) {
                Q.push(node);
                node = node.left;
            } else {
                node = Q.pop();
                cmp = compare(node.key, high);
                if (cmp > 0) break;
                else if (compare(node.key, low) >= 0) {
                    if (fn.call(ctx, node)) return this; // stop if smth is returned
                }
                node = node.right;
            }
            return this;
        };
        /**
       * Returns array of keys
       */ Tree.prototype.keys = function() {
            var keys = [];
            this.forEach(function(_a) {
                var key = _a.key;
                return keys.push(key);
            });
            return keys;
        };
        /**
       * Returns array of all the data in the nodes
       */ Tree.prototype.values = function() {
            var values = [];
            this.forEach(function(_a) {
                var data = _a.data;
                return values.push(data);
            });
            return values;
        };
        Tree.prototype.min = function() {
            if (this._root) return this.minNode(this._root).key;
            return null;
        };
        Tree.prototype.max = function() {
            if (this._root) return this.maxNode(this._root).key;
            return null;
        };
        Tree.prototype.minNode = function(t) {
            if (t === void 0) t = this._root;
            if (t) while(t.left)t = t.left;
            return t;
        };
        Tree.prototype.maxNode = function(t) {
            if (t === void 0) t = this._root;
            if (t) while(t.right)t = t.right;
            return t;
        };
        /**
       * Returns node at given index
       */ Tree.prototype.at = function(index) {
            var current = this._root;
            var done = false;
            var i = 0;
            var Q = [];
            while(!done){
                if (current) {
                    Q.push(current);
                    current = current.left;
                } else if (Q.length > 0) {
                    current = Q.pop();
                    if (i === index) return current;
                    i++;
                    current = current.right;
                } else done = true;
            }
            return null;
        };
        Tree.prototype.next = function(d) {
            var root = this._root;
            var successor = null;
            if (d.right) {
                successor = d.right;
                while(successor.left)successor = successor.left;
                return successor;
            }
            var comparator = this._comparator;
            while(root){
                var cmp = comparator(d.key, root.key);
                if (cmp === 0) break;
                else if (cmp < 0) {
                    successor = root;
                    root = root.left;
                } else root = root.right;
            }
            return successor;
        };
        Tree.prototype.prev = function(d) {
            var root = this._root;
            var predecessor = null;
            if (d.left !== null) {
                predecessor = d.left;
                while(predecessor.right)predecessor = predecessor.right;
                return predecessor;
            }
            var comparator = this._comparator;
            while(root){
                var cmp = comparator(d.key, root.key);
                if (cmp === 0) break;
                else if (cmp < 0) root = root.left;
                else {
                    predecessor = root;
                    root = root.right;
                }
            }
            return predecessor;
        };
        Tree.prototype.clear = function() {
            this._root = null;
            this._size = 0;
            return this;
        };
        Tree.prototype.toList = function() {
            return toList(this._root);
        };
        /**
       * Bulk-load items. Both array have to be same size
       */ Tree.prototype.load = function(keys, values, presort) {
            if (values === void 0) values = [];
            if (presort === void 0) presort = false;
            var size = keys.length;
            var comparator = this._comparator;
            // sort if needed
            if (presort) sort(keys, values, 0, size - 1, comparator);
            if (this._root === null) {
                // empty tree
                this._root = loadRecursive(keys, values, 0, size);
                this._size = size;
            } else {
                // that re-builds the whole tree from two in-order traversals
                var mergedList = mergeLists(this.toList(), createList(keys, values), comparator);
                size = this._size + size;
                this._root = sortedListToBST({
                    head: mergedList
                }, 0, size);
            }
            return this;
        };
        Tree.prototype.isEmpty = function() {
            return this._root === null;
        };
        Object.defineProperty(Tree.prototype, "size", {
            get: function get() {
                return this._size;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Tree.prototype, "root", {
            get: function get() {
                return this._root;
            },
            enumerable: true,
            configurable: true
        });
        Tree.prototype.toString = function(printNode) {
            if (printNode === void 0) printNode = function printNode(n) {
                return String(n.key);
            };
            var out = [];
            printRow(this._root, '', true, function(v) {
                return out.push(v);
            }, printNode);
            return out.join('');
        };
        Tree.prototype.update = function(key, newKey, newData) {
            var comparator = this._comparator;
            var _a = split(key, this._root, comparator), left = _a.left, right = _a.right;
            if (comparator(key, newKey) < 0) right = insert(newKey, newData, right, comparator);
            else left = insert(newKey, newData, left, comparator);
            this._root = merge(left, right, comparator);
        };
        Tree.prototype.split = function(key) {
            return split(key, this._root, this._comparator);
        };
        Tree.prototype[Symbol.iterator] = function() {
            var current, Q, done;
            return __generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        current = this._root;
                        Q = [];
                        done = false;
                        _a.label = 1;
                    case 1:
                        if (!!done) return [
                            3 /*break*/ ,
                            6
                        ];
                        if (!(current !== null)) return [
                            3 /*break*/ ,
                            2
                        ];
                        Q.push(current);
                        current = current.left;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        if (!(Q.length !== 0)) return [
                            3 /*break*/ ,
                            4
                        ];
                        current = Q.pop();
                        return [
                            4 /*yield*/ ,
                            current
                        ];
                    case 3:
                        _a.sent();
                        current = current.right;
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        done = true;
                        _a.label = 5;
                    case 5:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        };
        return Tree;
    }();
    function loadRecursive(keys, values, start, end) {
        var size = end - start;
        if (size > 0) {
            var middle = start + Math.floor(size / 2);
            var key = keys[middle];
            var data = values[middle];
            var node = new Node(key, data);
            node.left = loadRecursive(keys, values, start, middle);
            node.right = loadRecursive(keys, values, middle + 1, end);
            return node;
        }
        return null;
    }
    function createList(keys, values) {
        var head = new Node(null, null);
        var p = head;
        for(var i = 0; i < keys.length; i++)p = p.next = new Node(keys[i], values[i]);
        p.next = null;
        return head.next;
    }
    function toList(root) {
        var current = root;
        var Q = [];
        var done = false;
        var head = new Node(null, null);
        var p = head;
        while(!done){
            if (current) {
                Q.push(current);
                current = current.left;
            } else if (Q.length > 0) {
                current = p = p.next = Q.pop();
                current = current.right;
            } else done = true;
        }
        p.next = null; // that'll work even if the tree was empty
        return head.next;
    }
    function sortedListToBST(list, start, end) {
        var size = end - start;
        if (size > 0) {
            var middle = start + Math.floor(size / 2);
            var left = sortedListToBST(list, start, middle);
            var root = list.head;
            root.left = left;
            list.head = list.head.next;
            root.right = sortedListToBST(list, middle + 1, end);
            return root;
        }
        return null;
    }
    function mergeLists(l1, l2, compare) {
        var head = new Node(null, null); // dummy
        var p = head;
        var p1 = l1;
        var p2 = l2;
        while(p1 !== null && p2 !== null){
            if (compare(p1.key, p2.key) < 0) {
                p.next = p1;
                p1 = p1.next;
            } else {
                p.next = p2;
                p2 = p2.next;
            }
            p = p.next;
        }
        if (p1 !== null) p.next = p1;
        else if (p2 !== null) p.next = p2;
        return head.next;
    }
    function sort(keys, values, left, right, compare) {
        if (left >= right) return;
        var pivot = keys[left + right >> 1];
        var i = left - 1;
        var j = right + 1;
        while(true){
            do i++;
            while (compare(keys[i], pivot) < 0);
            do j--;
            while (compare(keys[j], pivot) > 0);
            if (i >= j) break;
            var tmp = keys[i];
            keys[i] = keys[j];
            keys[j] = tmp;
            tmp = values[i];
            values[i] = values[j];
            values[j] = tmp;
        }
        sort(keys, values, left, j, compare);
        sort(keys, values, j + 1, right, compare);
    }
    /**
     * A bounding box has the format:
     *
     *  { ll: { x: xmin, y: ymin }, ur: { x: xmax, y: ymax } }
     *
     */ var isInBbox = function(bbox, point) {
        return bbox.ll.x <= point.x && point.x <= bbox.ur.x && bbox.ll.y <= point.y && point.y <= bbox.ur.y;
    };
    /* Returns either null, or a bbox (aka an ordered pair of points)
     * If there is only one point of overlap, a bbox with identical points
     * will be returned */ var getBboxOverlap = function(b1, b2) {
        // check if the bboxes overlap at all
        if (b2.ur.x < b1.ll.x || b1.ur.x < b2.ll.x || b2.ur.y < b1.ll.y || b1.ur.y < b2.ll.y) return null;
        // find the middle two X values
        var lowerX = b1.ll.x < b2.ll.x ? b2.ll.x : b1.ll.x;
        var upperX = b1.ur.x < b2.ur.x ? b1.ur.x : b2.ur.x;
        // find the middle two Y values
        var lowerY = b1.ll.y < b2.ll.y ? b2.ll.y : b1.ll.y;
        var upperY = b1.ur.y < b2.ur.y ? b1.ur.y : b2.ur.y;
        // put those middle values together to get the overlap
        return {
            ll: {
                x: lowerX,
                y: lowerY
            },
            ur: {
                x: upperX,
                y: upperY
            }
        };
    };
    /* Javascript doesn't do integer math. Everything is
     * floating point with percision Number.EPSILON.
     *
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/EPSILON
     */ var epsilon$1 = Number.EPSILON;
    // IE Polyfill
    if (epsilon$1 === undefined) epsilon$1 = Math.pow(2, -52);
    var EPSILON_SQ = epsilon$1 * epsilon$1;
    /* FLP comparator */ var cmp = function(a, b) {
        // check if they're both 0
        if (-epsilon$1 < a && a < epsilon$1) {
            if (-epsilon$1 < b && b < epsilon$1) return 0;
        }
        // check if they're flp equal
        var ab = a - b;
        if (ab * ab < EPSILON_SQ * a * b) return 0;
        // normal comparison
        return a < b ? -1 : 1;
    };
    /**
     * This class rounds incoming values sufficiently so that
     * floating points problems are, for the most part, avoided.
     *
     * Incoming points are have their x & y values tested against
     * all previously seen x & y values. If either is 'too close'
     * to a previously seen value, it's value is 'snapped' to the
     * previously seen value.
     *
     * All points should be rounded by this class before being
     * stored in any data structures in the rest of this algorithm.
     */ var PtRounder = /*#__PURE__*/ function() {
        function PtRounder() {
            (0, $cx0mh._)(this, PtRounder);
            this.reset();
        }
        (0, $7h4XF._)(PtRounder, [
            {
                key: "reset",
                value: function reset() {
                    this.xRounder = new CoordRounder();
                    this.yRounder = new CoordRounder();
                }
            },
            {
                key: "round",
                value: function round(x, y) {
                    return {
                        x: this.xRounder.round(x),
                        y: this.yRounder.round(y)
                    };
                }
            }
        ]);
        return PtRounder;
    }();
    var CoordRounder = /*#__PURE__*/ function() {
        function CoordRounder() {
            (0, $cx0mh._)(this, CoordRounder);
            this.tree = new Tree();
            // preseed with 0 so we don't end up with values < Number.EPSILON
            this.round(0);
        }
        (0, $7h4XF._)(CoordRounder, [
            {
                // Note: this can rounds input values backwards or forwards.
                //       You might ask, why not restrict this to just rounding
                //       forwards? Wouldn't that allow left endpoints to always
                //       remain left endpoints during splitting (never change to
                //       right). No - it wouldn't, because we snap intersections
                //       to endpoints (to establish independence from the segment
                //       angle for t-intersections).
                key: "round",
                value: function round(coord) {
                    var node = this.tree.add(coord);
                    var prevNode = this.tree.prev(node);
                    if (prevNode !== null && cmp(node.key, prevNode.key) === 0) {
                        this.tree.remove(coord);
                        return prevNode.key;
                    }
                    var nextNode = this.tree.next(node);
                    if (nextNode !== null && cmp(node.key, nextNode.key) === 0) {
                        this.tree.remove(coord);
                        return nextNode.key;
                    }
                    return coord;
                }
            }
        ]);
        return CoordRounder;
    }();
    // singleton available by import
    var rounder = new PtRounder();
    var epsilon = 1.1102230246251565e-16;
    var splitter = 134217729;
    var resulterrbound = (3 + 8 * epsilon) * epsilon;
    // fast_expansion_sum_zeroelim routine from oritinal code
    function sum(elen, e, flen, f, h) {
        var Q, Qnew, hh, bvirt;
        var enow = e[0];
        var fnow = f[0];
        var eindex = 0;
        var findex = 0;
        if (fnow > enow === fnow > -enow) {
            Q = enow;
            enow = e[++eindex];
        } else {
            Q = fnow;
            fnow = f[++findex];
        }
        var hindex = 0;
        if (eindex < elen && findex < flen) {
            if (fnow > enow === fnow > -enow) {
                Qnew = enow + Q;
                hh = Q - (Qnew - enow);
                enow = e[++eindex];
            } else {
                Qnew = fnow + Q;
                hh = Q - (Qnew - fnow);
                fnow = f[++findex];
            }
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
            while(eindex < elen && findex < flen){
                if (fnow > enow === fnow > -enow) {
                    Qnew = Q + enow;
                    bvirt = Qnew - Q;
                    hh = Q - (Qnew - bvirt) + (enow - bvirt);
                    enow = e[++eindex];
                } else {
                    Qnew = Q + fnow;
                    bvirt = Qnew - Q;
                    hh = Q - (Qnew - bvirt) + (fnow - bvirt);
                    fnow = f[++findex];
                }
                Q = Qnew;
                if (hh !== 0) h[hindex++] = hh;
            }
        }
        while(eindex < elen){
            Qnew = Q + enow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (enow - bvirt);
            enow = e[++eindex];
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
        while(findex < flen){
            Qnew = Q + fnow;
            bvirt = Qnew - Q;
            hh = Q - (Qnew - bvirt) + (fnow - bvirt);
            fnow = f[++findex];
            Q = Qnew;
            if (hh !== 0) h[hindex++] = hh;
        }
        if (Q !== 0 || hindex === 0) h[hindex++] = Q;
        return hindex;
    }
    function estimate(elen, e) {
        var Q = e[0];
        for(var i = 1; i < elen; i++)Q += e[i];
        return Q;
    }
    function vec(n) {
        return new Float64Array(n);
    }
    var ccwerrboundA = (3 + 16 * epsilon) * epsilon;
    var ccwerrboundB = (2 + 12 * epsilon) * epsilon;
    var ccwerrboundC = (9 + 64 * epsilon) * epsilon * epsilon;
    var B = vec(4);
    var C1 = vec(8);
    var C2 = vec(12);
    var D = vec(16);
    var u = vec(4);
    function orient2dadapt(ax, ay, bx, by, cx, cy, detsum) {
        var acxtail, acytail, bcxtail, bcytail;
        var bvirt, c, ahi, alo, bhi, blo, _i, _j, _0, s1, s0, t1, t0, u3;
        var acx = ax - cx;
        var bcx = bx - cx;
        var acy = ay - cy;
        var bcy = by - cy;
        s1 = acx * bcy;
        c = splitter * acx;
        ahi = c - (c - acx);
        alo = acx - ahi;
        c = splitter * bcy;
        bhi = c - (c - bcy);
        blo = bcy - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acy * bcx;
        c = splitter * acy;
        ahi = c - (c - acy);
        alo = acy - ahi;
        c = splitter * bcx;
        bhi = c - (c - bcx);
        blo = bcx - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        B[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        B[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        B[2] = _j - (u3 - bvirt) + (_i - bvirt);
        B[3] = u3;
        var det = estimate(4, B);
        var errbound = ccwerrboundB * detsum;
        if (det >= errbound || -det >= errbound) return det;
        bvirt = ax - acx;
        acxtail = ax - (acx + bvirt) + (bvirt - cx);
        bvirt = bx - bcx;
        bcxtail = bx - (bcx + bvirt) + (bvirt - cx);
        bvirt = ay - acy;
        acytail = ay - (acy + bvirt) + (bvirt - cy);
        bvirt = by - bcy;
        bcytail = by - (bcy + bvirt) + (bvirt - cy);
        if (acxtail === 0 && acytail === 0 && bcxtail === 0 && bcytail === 0) return det;
        errbound = ccwerrboundC * detsum + resulterrbound * Math.abs(det);
        det += acx * bcytail + bcy * acxtail - (acy * bcxtail + bcx * acytail);
        if (det >= errbound || -det >= errbound) return det;
        s1 = acxtail * bcy;
        c = splitter * acxtail;
        ahi = c - (c - acxtail);
        alo = acxtail - ahi;
        c = splitter * bcy;
        bhi = c - (c - bcy);
        blo = bcy - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acytail * bcx;
        c = splitter * acytail;
        ahi = c - (c - acytail);
        alo = acytail - ahi;
        c = splitter * bcx;
        bhi = c - (c - bcx);
        blo = bcx - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        var C1len = sum(4, B, 4, u, C1);
        s1 = acx * bcytail;
        c = splitter * acx;
        ahi = c - (c - acx);
        alo = acx - ahi;
        c = splitter * bcytail;
        bhi = c - (c - bcytail);
        blo = bcytail - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acy * bcxtail;
        c = splitter * acy;
        ahi = c - (c - acy);
        alo = acy - ahi;
        c = splitter * bcxtail;
        bhi = c - (c - bcxtail);
        blo = bcxtail - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        var C2len = sum(C1len, C1, 4, u, C2);
        s1 = acxtail * bcytail;
        c = splitter * acxtail;
        ahi = c - (c - acxtail);
        alo = acxtail - ahi;
        c = splitter * bcytail;
        bhi = c - (c - bcytail);
        blo = bcytail - bhi;
        s0 = alo * blo - (s1 - ahi * bhi - alo * bhi - ahi * blo);
        t1 = acytail * bcxtail;
        c = splitter * acytail;
        ahi = c - (c - acytail);
        alo = acytail - ahi;
        c = splitter * bcxtail;
        bhi = c - (c - bcxtail);
        blo = bcxtail - bhi;
        t0 = alo * blo - (t1 - ahi * bhi - alo * bhi - ahi * blo);
        _i = s0 - t0;
        bvirt = s0 - _i;
        u[0] = s0 - (_i + bvirt) + (bvirt - t0);
        _j = s1 + _i;
        bvirt = _j - s1;
        _0 = s1 - (_j - bvirt) + (_i - bvirt);
        _i = _0 - t1;
        bvirt = _0 - _i;
        u[1] = _0 - (_i + bvirt) + (bvirt - t1);
        u3 = _j + _i;
        bvirt = u3 - _j;
        u[2] = _j - (u3 - bvirt) + (_i - bvirt);
        u[3] = u3;
        var Dlen = sum(C2len, C2, 4, u, D);
        return D[Dlen - 1];
    }
    function orient2d(ax, ay, bx, by, cx, cy) {
        var detleft = (ay - cy) * (bx - cx);
        var detright = (ax - cx) * (by - cy);
        var det = detleft - detright;
        var detsum = Math.abs(detleft + detright);
        if (Math.abs(det) >= ccwerrboundA * detsum) return det;
        return -orient2dadapt(ax, ay, bx, by, cx, cy, detsum);
    }
    /* Cross Product of two vectors with first point at origin */ var crossProduct = function(a, b) {
        return a.x * b.y - a.y * b.x;
    };
    /* Dot Product of two vectors with first point at origin */ var dotProduct = function(a, b) {
        return a.x * b.x + a.y * b.y;
    };
    /* Comparator for two vectors with same starting point */ var compareVectorAngles = function(basePt, endPt1, endPt2) {
        var res = orient2d(basePt.x, basePt.y, endPt1.x, endPt1.y, endPt2.x, endPt2.y);
        if (res > 0) return -1;
        if (res < 0) return 1;
        return 0;
    };
    var length = function(v) {
        return Math.sqrt(dotProduct(v, v));
    };
    /* Get the sine of the angle from pShared -> pAngle to pShaed -> pBase */ var sineOfAngle = function(pShared, pBase, pAngle) {
        var vBase = {
            x: pBase.x - pShared.x,
            y: pBase.y - pShared.y
        };
        var vAngle = {
            x: pAngle.x - pShared.x,
            y: pAngle.y - pShared.y
        };
        return crossProduct(vAngle, vBase) / length(vAngle) / length(vBase);
    };
    /* Get the cosine of the angle from pShared -> pAngle to pShaed -> pBase */ var cosineOfAngle = function(pShared, pBase, pAngle) {
        var vBase = {
            x: pBase.x - pShared.x,
            y: pBase.y - pShared.y
        };
        var vAngle = {
            x: pAngle.x - pShared.x,
            y: pAngle.y - pShared.y
        };
        return dotProduct(vAngle, vBase) / length(vAngle) / length(vBase);
    };
    /* Get the x coordinate where the given line (defined by a point and vector)
     * crosses the horizontal line with the given y coordiante.
     * In the case of parrallel lines (including overlapping ones) returns null. */ var horizontalIntersection = function(pt, v, y) {
        if (v.y === 0) return null;
        return {
            x: pt.x + v.x / v.y * (y - pt.y),
            y: y
        };
    };
    /* Get the y coordinate where the given line (defined by a point and vector)
     * crosses the vertical line with the given x coordiante.
     * In the case of parrallel lines (including overlapping ones) returns null. */ var verticalIntersection = function(pt, v, x) {
        if (v.x === 0) return null;
        return {
            x: x,
            y: pt.y + v.y / v.x * (x - pt.x)
        };
    };
    /* Get the intersection of two lines, each defined by a base point and a vector.
     * In the case of parrallel lines (including overlapping ones) returns null. */ var intersection$1 = function(pt1, v1, pt2, v2) {
        // take some shortcuts for vertical and horizontal lines
        // this also ensures we don't calculate an intersection and then discover
        // it's actually outside the bounding box of the line
        if (v1.x === 0) return verticalIntersection(pt2, v2, pt1.x);
        if (v2.x === 0) return verticalIntersection(pt1, v1, pt2.x);
        if (v1.y === 0) return horizontalIntersection(pt2, v2, pt1.y);
        if (v2.y === 0) return horizontalIntersection(pt1, v1, pt2.y);
        // General case for non-overlapping segments.
        // This algorithm is based on Schneider and Eberly.
        // http://www.cimec.org.ar/~ncalvo/Schneider_Eberly.pdf - pg 244
        var kross = crossProduct(v1, v2);
        if (kross == 0) return null;
        var ve = {
            x: pt2.x - pt1.x,
            y: pt2.y - pt1.y
        };
        var d1 = crossProduct(ve, v1) / kross;
        var d2 = crossProduct(ve, v2) / kross;
        // take the average of the two calculations to minimize rounding error
        var x1 = pt1.x + d2 * v1.x, x2 = pt2.x + d1 * v2.x;
        var y1 = pt1.y + d2 * v1.y, y2 = pt2.y + d1 * v2.y;
        var x = (x1 + x2) / 2;
        var y = (y1 + y2) / 2;
        return {
            x: x,
            y: y
        };
    };
    var SweepEvent = /*#__PURE__*/ function() {
        function SweepEvent(point, isLeft) {
            (0, $cx0mh._)(this, SweepEvent);
            if (point.events === undefined) point.events = [
                this
            ];
            else point.events.push(this);
            this.point = point;
            this.isLeft = isLeft;
        }
        (0, $7h4XF._)(SweepEvent, [
            {
                key: "link",
                value: function link(other) {
                    if (other.point === this.point) throw new Error("Tried to link already linked events");
                    var otherEvents = other.point.events;
                    for(var i = 0, iMax = otherEvents.length; i < iMax; i++){
                        var evt = otherEvents[i];
                        this.point.events.push(evt);
                        evt.point = this.point;
                    }
                    this.checkForConsuming();
                }
            },
            {
                /* Do a pass over our linked events and check to see if any pair
       * of segments match, and should be consumed. */ key: "checkForConsuming",
                value: function checkForConsuming() {
                    // FIXME: The loops in this method run O(n^2) => no good.
                    //        Maintain little ordered sweep event trees?
                    //        Can we maintaining an ordering that avoids the need
                    //        for the re-sorting with getLeftmostComparator in geom-out?
                    // Compare each pair of events to see if other events also match
                    var numEvents = this.point.events.length;
                    for(var i = 0; i < numEvents; i++){
                        var evt1 = this.point.events[i];
                        if (evt1.segment.consumedBy !== undefined) continue;
                        for(var j = i + 1; j < numEvents; j++){
                            var evt2 = this.point.events[j];
                            if (evt2.consumedBy !== undefined) continue;
                            if (evt1.otherSE.point.events !== evt2.otherSE.point.events) continue;
                            evt1.segment.consume(evt2.segment);
                        }
                    }
                }
            },
            {
                key: "getAvailableLinkedEvents",
                value: function getAvailableLinkedEvents() {
                    // point.events is always of length 2 or greater
                    var events = [];
                    for(var i = 0, iMax = this.point.events.length; i < iMax; i++){
                        var evt = this.point.events[i];
                        if (evt !== this && !evt.segment.ringOut && evt.segment.isInResult()) events.push(evt);
                    }
                    return events;
                }
            },
            {
                /**
       * Returns a comparator function for sorting linked events that will
       * favor the event that will give us the smallest left-side angle.
       * All ring construction starts as low as possible heading to the right,
       * so by always turning left as sharp as possible we'll get polygons
       * without uncessary loops & holes.
       *
       * The comparator function has a compute cache such that it avoids
       * re-computing already-computed values.
       */ key: "getLeftmostComparator",
                value: function getLeftmostComparator(baseEvent) {
                    var _this = this;
                    var cache = new Map();
                    var fillCache = function(linkedEvent) {
                        var nextEvent = linkedEvent.otherSE;
                        cache.set(linkedEvent, {
                            sine: sineOfAngle(_this.point, baseEvent.point, nextEvent.point),
                            cosine: cosineOfAngle(_this.point, baseEvent.point, nextEvent.point)
                        });
                    };
                    return function(a, b) {
                        if (!cache.has(a)) fillCache(a);
                        if (!cache.has(b)) fillCache(b);
                        var _cache_get = cache.get(a), asine = _cache_get.sine, acosine = _cache_get.cosine;
                        var _cache_get1 = cache.get(b), bsine = _cache_get1.sine, bcosine = _cache_get1.cosine;
                        // both on or above x-axis
                        if (asine >= 0 && bsine >= 0) {
                            if (acosine < bcosine) return 1;
                            if (acosine > bcosine) return -1;
                            return 0;
                        }
                        // both below x-axis
                        if (asine < 0 && bsine < 0) {
                            if (acosine < bcosine) return -1;
                            if (acosine > bcosine) return 1;
                            return 0;
                        }
                        // one above x-axis, one below
                        if (bsine < asine) return -1;
                        if (bsine > asine) return 1;
                        return 0;
                    };
                }
            }
        ], [
            {
                key: "compare",
                value: // for ordering sweep events in the sweep event queue
                function compare(a, b) {
                    // favor event with a point that the sweep line hits first
                    var ptCmp = SweepEvent.comparePoints(a.point, b.point);
                    if (ptCmp !== 0) return ptCmp;
                    // the points are the same, so link them if needed
                    if (a.point !== b.point) a.link(b);
                    // favor right events over left
                    if (a.isLeft !== b.isLeft) return a.isLeft ? 1 : -1;
                    // we have two matching left or right endpoints
                    // ordering of this case is the same as for their segments
                    return Segment.compare(a.segment, b.segment);
                }
            },
            {
                key: "comparePoints",
                value: // for ordering points in sweep line order
                function comparePoints(aPt, bPt) {
                    if (aPt.x < bPt.x) return -1;
                    if (aPt.x > bPt.x) return 1;
                    if (aPt.y < bPt.y) return -1;
                    if (aPt.y > bPt.y) return 1;
                    return 0;
                }
            }
        ]);
        return SweepEvent;
    }();
    // Give segments unique ID's to get consistent sorting of
    // segments and sweep events when all else is identical
    var segmentId = 0;
    var Segment = /*#__PURE__*/ function() {
        function Segment(leftSE, rightSE, rings, windings) {
            (0, $cx0mh._)(this, Segment);
            this.id = ++segmentId;
            this.leftSE = leftSE;
            leftSE.segment = this;
            leftSE.otherSE = rightSE;
            this.rightSE = rightSE;
            rightSE.segment = this;
            rightSE.otherSE = leftSE;
            this.rings = rings;
            this.windings = windings;
        }
        (0, $7h4XF._)(Segment, [
            {
                /* When a segment is split, the rightSE is replaced with a new sweep event */ key: "replaceRightSE",
                value: function replaceRightSE(newRightSE) {
                    this.rightSE = newRightSE;
                    this.rightSE.segment = this;
                    this.rightSE.otherSE = this.leftSE;
                    this.leftSE.otherSE = this.rightSE;
                }
            },
            {
                key: "bbox",
                value: function bbox() {
                    var y1 = this.leftSE.point.y;
                    var y2 = this.rightSE.point.y;
                    return {
                        ll: {
                            x: this.leftSE.point.x,
                            y: y1 < y2 ? y1 : y2
                        },
                        ur: {
                            x: this.rightSE.point.x,
                            y: y1 > y2 ? y1 : y2
                        }
                    };
                }
            },
            {
                /* A vector from the left point to the right */ key: "vector",
                value: function vector() {
                    return {
                        x: this.rightSE.point.x - this.leftSE.point.x,
                        y: this.rightSE.point.y - this.leftSE.point.y
                    };
                }
            },
            {
                key: "isAnEndpoint",
                value: function isAnEndpoint(pt) {
                    return pt.x === this.leftSE.point.x && pt.y === this.leftSE.point.y || pt.x === this.rightSE.point.x && pt.y === this.rightSE.point.y;
                }
            },
            {
                /* Compare this segment with a point.
       *
       * A point P is considered to be colinear to a segment if there
       * exists a distance D such that if we travel along the segment
       * from one * endpoint towards the other a distance D, we find
       * ourselves at point P.
       *
       * Return value indicates:
       *
       *   1: point lies above the segment (to the left of vertical)
       *   0: point is colinear to segment
       *  -1: point lies below the segment (to the right of vertical)
       */ key: "comparePoint",
                value: function comparePoint(point) {
                    if (this.isAnEndpoint(point)) return 0;
                    var lPt = this.leftSE.point;
                    var rPt = this.rightSE.point;
                    var v = this.vector();
                    // Exactly vertical segments.
                    if (lPt.x === rPt.x) {
                        if (point.x === lPt.x) return 0;
                        return point.x < lPt.x ? 1 : -1;
                    }
                    // Nearly vertical segments with an intersection.
                    // Check to see where a point on the line with matching Y coordinate is.
                    var yDist = (point.y - lPt.y) / v.y;
                    var xFromYDist = lPt.x + yDist * v.x;
                    if (point.x === xFromYDist) return 0;
                    // General case.
                    // Check to see where a point on the line with matching X coordinate is.
                    var xDist = (point.x - lPt.x) / v.x;
                    var yFromXDist = lPt.y + xDist * v.y;
                    if (point.y === yFromXDist) return 0;
                    return point.y < yFromXDist ? -1 : 1;
                }
            },
            {
                /**
       * Given another segment, returns the first non-trivial intersection
       * between the two segments (in terms of sweep line ordering), if it exists.
       *
       * A 'non-trivial' intersection is one that will cause one or both of the
       * segments to be split(). As such, 'trivial' vs. 'non-trivial' intersection:
       *
       *   * endpoint of segA with endpoint of segB --> trivial
       *   * endpoint of segA with point along segB --> non-trivial
       *   * endpoint of segB with point along segA --> non-trivial
       *   * point along segA with point along segB --> non-trivial
       *
       * If no non-trivial intersection exists, return null
       * Else, return null.
       */ key: "getIntersection",
                value: function getIntersection(other) {
                    // If bboxes don't overlap, there can't be any intersections
                    var tBbox = this.bbox();
                    var oBbox = other.bbox();
                    var bboxOverlap = getBboxOverlap(tBbox, oBbox);
                    if (bboxOverlap === null) return null;
                    // We first check to see if the endpoints can be considered intersections.
                    // This will 'snap' intersections to endpoints if possible, and will
                    // handle cases of colinearity.
                    var tlp = this.leftSE.point;
                    var trp = this.rightSE.point;
                    var olp = other.leftSE.point;
                    var orp = other.rightSE.point;
                    // does each endpoint touch the other segment?
                    // note that we restrict the 'touching' definition to only allow segments
                    // to touch endpoints that lie forward from where we are in the sweep line pass
                    var touchesOtherLSE = isInBbox(tBbox, olp) && this.comparePoint(olp) === 0;
                    var touchesThisLSE = isInBbox(oBbox, tlp) && other.comparePoint(tlp) === 0;
                    var touchesOtherRSE = isInBbox(tBbox, orp) && this.comparePoint(orp) === 0;
                    var touchesThisRSE = isInBbox(oBbox, trp) && other.comparePoint(trp) === 0;
                    // do left endpoints match?
                    if (touchesThisLSE && touchesOtherLSE) {
                        // these two cases are for colinear segments with matching left
                        // endpoints, and one segment being longer than the other
                        if (touchesThisRSE && !touchesOtherRSE) return trp;
                        if (!touchesThisRSE && touchesOtherRSE) return orp;
                        // either the two segments match exactly (two trival intersections)
                        // or just on their left endpoint (one trivial intersection
                        return null;
                    }
                    // does this left endpoint matches (other doesn't)
                    if (touchesThisLSE) {
                        // check for segments that just intersect on opposing endpoints
                        if (touchesOtherRSE) {
                            if (tlp.x === orp.x && tlp.y === orp.y) return null;
                        }
                        // t-intersection on left endpoint
                        return tlp;
                    }
                    // does other left endpoint matches (this doesn't)
                    if (touchesOtherLSE) {
                        // check for segments that just intersect on opposing endpoints
                        if (touchesThisRSE) {
                            if (trp.x === olp.x && trp.y === olp.y) return null;
                        }
                        // t-intersection on left endpoint
                        return olp;
                    }
                    // trivial intersection on right endpoints
                    if (touchesThisRSE && touchesOtherRSE) return null;
                    // t-intersections on just one right endpoint
                    if (touchesThisRSE) return trp;
                    if (touchesOtherRSE) return orp;
                    // None of our endpoints intersect. Look for a general intersection between
                    // infinite lines laid over the segments
                    var pt = intersection$1(tlp, this.vector(), olp, other.vector());
                    // are the segments parrallel? Note that if they were colinear with overlap,
                    // they would have an endpoint intersection and that case was already handled above
                    if (pt === null) return null;
                    // is the intersection found between the lines not on the segments?
                    if (!isInBbox(bboxOverlap, pt)) return null;
                    // round the the computed point if needed
                    return rounder.round(pt.x, pt.y);
                }
            },
            {
                /**
       * Split the given segment into multiple segments on the given points.
       *  * Each existing segment will retain its leftSE and a new rightSE will be
       *    generated for it.
       *  * A new segment will be generated which will adopt the original segment's
       *    rightSE, and a new leftSE will be generated for it.
       *  * If there are more than two points given to split on, new segments
       *    in the middle will be generated with new leftSE and rightSE's.
       *  * An array of the newly generated SweepEvents will be returned.
       *
       * Warning: input array of points is modified
       */ key: "split",
                value: function split(point) {
                    var newEvents = [];
                    var alreadyLinked = point.events !== undefined;
                    var newLeftSE = new SweepEvent(point, true);
                    var newRightSE = new SweepEvent(point, false);
                    var oldRightSE = this.rightSE;
                    this.replaceRightSE(newRightSE);
                    newEvents.push(newRightSE);
                    newEvents.push(newLeftSE);
                    var newSeg = new Segment(newLeftSE, oldRightSE, this.rings.slice(), this.windings.slice());
                    // when splitting a nearly vertical downward-facing segment,
                    // sometimes one of the resulting new segments is vertical, in which
                    // case its left and right events may need to be swapped
                    if (SweepEvent.comparePoints(newSeg.leftSE.point, newSeg.rightSE.point) > 0) newSeg.swapEvents();
                    if (SweepEvent.comparePoints(this.leftSE.point, this.rightSE.point) > 0) this.swapEvents();
                    // in the point we just used to create new sweep events with was already
                    // linked to other events, we need to check if either of the affected
                    // segments should be consumed
                    if (alreadyLinked) {
                        newLeftSE.checkForConsuming();
                        newRightSE.checkForConsuming();
                    }
                    return newEvents;
                }
            },
            {
                /* Swap which event is left and right */ key: "swapEvents",
                value: function swapEvents() {
                    var tmpEvt = this.rightSE;
                    this.rightSE = this.leftSE;
                    this.leftSE = tmpEvt;
                    this.leftSE.isLeft = true;
                    this.rightSE.isLeft = false;
                    for(var i = 0, iMax = this.windings.length; i < iMax; i++)this.windings[i] *= -1;
                }
            },
            {
                /* Consume another segment. We take their rings under our wing
       * and mark them as consumed. Use for perfectly overlapping segments */ key: "consume",
                value: function consume(other) {
                    var consumer = this;
                    var consumee = other;
                    while(consumer.consumedBy)consumer = consumer.consumedBy;
                    while(consumee.consumedBy)consumee = consumee.consumedBy;
                    var cmp = Segment.compare(consumer, consumee);
                    if (cmp === 0) return; // already consumed
                    // the winner of the consumption is the earlier segment
                    // according to sweep line ordering
                    if (cmp > 0) {
                        var tmp = consumer;
                        consumer = consumee;
                        consumee = tmp;
                    }
                    // make sure a segment doesn't consume it's prev
                    if (consumer.prev === consumee) {
                        var tmp1 = consumer;
                        consumer = consumee;
                        consumee = tmp1;
                    }
                    for(var i = 0, iMax = consumee.rings.length; i < iMax; i++){
                        var ring = consumee.rings[i];
                        var winding = consumee.windings[i];
                        var index = consumer.rings.indexOf(ring);
                        if (index === -1) {
                            consumer.rings.push(ring);
                            consumer.windings.push(winding);
                        } else consumer.windings[index] += winding;
                    }
                    consumee.rings = null;
                    consumee.windings = null;
                    consumee.consumedBy = consumer;
                    // mark sweep events consumed as to maintain ordering in sweep event queue
                    consumee.leftSE.consumedBy = consumer.leftSE;
                    consumee.rightSE.consumedBy = consumer.rightSE;
                }
            },
            {
                /* The first segment previous segment chain that is in the result */ key: "prevInResult",
                value: function prevInResult() {
                    if (this._prevInResult !== undefined) return this._prevInResult;
                    if (!this.prev) this._prevInResult = null;
                    else if (this.prev.isInResult()) this._prevInResult = this.prev;
                    else this._prevInResult = this.prev.prevInResult();
                    return this._prevInResult;
                }
            },
            {
                key: "beforeState",
                value: function beforeState() {
                    if (this._beforeState !== undefined) return this._beforeState;
                    if (!this.prev) this._beforeState = {
                        rings: [],
                        windings: [],
                        multiPolys: []
                    };
                    else {
                        var seg = this.prev.consumedBy || this.prev;
                        this._beforeState = seg.afterState();
                    }
                    return this._beforeState;
                }
            },
            {
                key: "afterState",
                value: function afterState() {
                    if (this._afterState !== undefined) return this._afterState;
                    var beforeState = this.beforeState();
                    this._afterState = {
                        rings: beforeState.rings.slice(0),
                        windings: beforeState.windings.slice(0),
                        multiPolys: []
                    };
                    var ringsAfter = this._afterState.rings;
                    var windingsAfter = this._afterState.windings;
                    var mpsAfter = this._afterState.multiPolys;
                    // calculate ringsAfter, windingsAfter
                    for(var i = 0, iMax = this.rings.length; i < iMax; i++){
                        var ring = this.rings[i];
                        var winding = this.windings[i];
                        var index = ringsAfter.indexOf(ring);
                        if (index === -1) {
                            ringsAfter.push(ring);
                            windingsAfter.push(winding);
                        } else windingsAfter[index] += winding;
                    }
                    // calcualte polysAfter
                    var polysAfter = [];
                    var polysExclude = [];
                    for(var i1 = 0, iMax1 = ringsAfter.length; i1 < iMax1; i1++){
                        if (windingsAfter[i1] === 0) continue; // non-zero rule
                        var ring1 = ringsAfter[i1];
                        var poly = ring1.poly;
                        if (polysExclude.indexOf(poly) !== -1) continue;
                        if (ring1.isExterior) polysAfter.push(poly);
                        else {
                            if (polysExclude.indexOf(poly) === -1) polysExclude.push(poly);
                            var index1 = polysAfter.indexOf(ring1.poly);
                            if (index1 !== -1) polysAfter.splice(index1, 1);
                        }
                    }
                    // calculate multiPolysAfter
                    for(var i2 = 0, iMax2 = polysAfter.length; i2 < iMax2; i2++){
                        var mp = polysAfter[i2].multiPoly;
                        if (mpsAfter.indexOf(mp) === -1) mpsAfter.push(mp);
                    }
                    return this._afterState;
                }
            },
            {
                /* Is this segment part of the final result? */ key: "isInResult",
                value: function isInResult() {
                    // if we've been consumed, we're not in the result
                    if (this.consumedBy) return false;
                    if (this._isInResult !== undefined) return this._isInResult;
                    var mpsBefore = this.beforeState().multiPolys;
                    var mpsAfter = this.afterState().multiPolys;
                    switch(operation.type){
                        case "union":
                            {
                                // UNION - included iff:
                                //  * On one side of us there is 0 poly interiors AND
                                //  * On the other side there is 1 or more.
                                var noBefores = mpsBefore.length === 0;
                                var noAfters = mpsAfter.length === 0;
                                this._isInResult = noBefores !== noAfters;
                                break;
                            }
                        case "intersection":
                            {
                                // INTERSECTION - included iff:
                                //  * on one side of us all multipolys are rep. with poly interiors AND
                                //  * on the other side of us, not all multipolys are repsented
                                //    with poly interiors
                                var least;
                                var most;
                                if (mpsBefore.length < mpsAfter.length) {
                                    least = mpsBefore.length;
                                    most = mpsAfter.length;
                                } else {
                                    least = mpsAfter.length;
                                    most = mpsBefore.length;
                                }
                                this._isInResult = most === operation.numMultiPolys && least < most;
                                break;
                            }
                        case "xor":
                            {
                                // XOR - included iff:
                                //  * the difference between the number of multipolys represented
                                //    with poly interiors on our two sides is an odd number
                                var diff = Math.abs(mpsBefore.length - mpsAfter.length);
                                this._isInResult = diff % 2 === 1;
                                break;
                            }
                        case "difference":
                            {
                                // DIFFERENCE included iff:
                                //  * on exactly one side, we have just the subject
                                var isJustSubject = function(mps) {
                                    return mps.length === 1 && mps[0].isSubject;
                                };
                                this._isInResult = isJustSubject(mpsBefore) !== isJustSubject(mpsAfter);
                                break;
                            }
                        default:
                            throw new Error(`Unrecognized operation type found ${operation.type}`);
                    }
                    return this._isInResult;
                }
            }
        ], [
            {
                key: "compare",
                value: /* This compare() function is for ordering segments in the sweep
       * line tree, and does so according to the following criteria:
       *
       * Consider the vertical line that lies an infinestimal step to the
       * right of the right-more of the two left endpoints of the input
       * segments. Imagine slowly moving a point up from negative infinity
       * in the increasing y direction. Which of the two segments will that
       * point intersect first? That segment comes 'before' the other one.
       *
       * If neither segment would be intersected by such a line, (if one
       * or more of the segments are vertical) then the line to be considered
       * is directly on the right-more of the two left inputs.
       */ function compare(a, b) {
                    var alx = a.leftSE.point.x;
                    var blx = b.leftSE.point.x;
                    var arx = a.rightSE.point.x;
                    var brx = b.rightSE.point.x;
                    // check if they're even in the same vertical plane
                    if (brx < alx) return 1;
                    if (arx < blx) return -1;
                    var aly = a.leftSE.point.y;
                    var bly = b.leftSE.point.y;
                    var ary = a.rightSE.point.y;
                    var bry = b.rightSE.point.y;
                    // is left endpoint of segment B the right-more?
                    if (alx < blx) {
                        // are the two segments in the same horizontal plane?
                        if (bly < aly && bly < ary) return 1;
                        if (bly > aly && bly > ary) return -1;
                        // is the B left endpoint colinear to segment A?
                        var aCmpBLeft = a.comparePoint(b.leftSE.point);
                        if (aCmpBLeft < 0) return 1;
                        if (aCmpBLeft > 0) return -1;
                        // is the A right endpoint colinear to segment B ?
                        var bCmpARight = b.comparePoint(a.rightSE.point);
                        if (bCmpARight !== 0) return bCmpARight;
                        // colinear segments, consider the one with left-more
                        // left endpoint to be first (arbitrary?)
                        return -1;
                    }
                    // is left endpoint of segment A the right-more?
                    if (alx > blx) {
                        if (aly < bly && aly < bry) return -1;
                        if (aly > bly && aly > bry) return 1;
                        // is the A left endpoint colinear to segment B?
                        var bCmpALeft = b.comparePoint(a.leftSE.point);
                        if (bCmpALeft !== 0) return bCmpALeft;
                        // is the B right endpoint colinear to segment A?
                        var aCmpBRight = a.comparePoint(b.rightSE.point);
                        if (aCmpBRight < 0) return 1;
                        if (aCmpBRight > 0) return -1;
                        // colinear segments, consider the one with left-more
                        // left endpoint to be first (arbitrary?)
                        return 1;
                    }
                    // if we get here, the two left endpoints are in the same
                    // vertical plane, ie alx === blx
                    // consider the lower left-endpoint to come first
                    if (aly < bly) return -1;
                    if (aly > bly) return 1;
                    // left endpoints are identical
                    // check for colinearity by using the left-more right endpoint
                    // is the A right endpoint more left-more?
                    if (arx < brx) {
                        var bCmpARight1 = b.comparePoint(a.rightSE.point);
                        if (bCmpARight1 !== 0) return bCmpARight1;
                    }
                    // is the B right endpoint more left-more?
                    if (arx > brx) {
                        var aCmpBRight1 = a.comparePoint(b.rightSE.point);
                        if (aCmpBRight1 < 0) return 1;
                        if (aCmpBRight1 > 0) return -1;
                    }
                    if (arx !== brx) {
                        // are these two [almost] vertical segments with opposite orientation?
                        // if so, the one with the lower right endpoint comes first
                        var ay = ary - aly;
                        var ax = arx - alx;
                        var by = bry - bly;
                        var bx = brx - blx;
                        if (ay > ax && by < bx) return 1;
                        if (ay < ax && by > bx) return -1;
                    }
                    // we have colinear segments with matching orientation
                    // consider the one with more left-more right endpoint to be first
                    if (arx > brx) return 1;
                    if (arx < brx) return -1;
                    // if we get here, two two right endpoints are in the same
                    // vertical plane, ie arx === brx
                    // consider the lower right-endpoint to come first
                    if (ary < bry) return -1;
                    if (ary > bry) return 1;
                    // right endpoints identical as well, so the segments are idential
                    // fall back on creation order as consistent tie-breaker
                    if (a.id < b.id) return -1;
                    if (a.id > b.id) return 1;
                    // identical segment, ie a === b
                    return 0;
                }
            },
            {
                key: "fromRing",
                value: function fromRing(pt1, pt2, ring) {
                    var leftPt, rightPt, winding;
                    // ordering the two points according to sweep line ordering
                    var cmpPts = SweepEvent.comparePoints(pt1, pt2);
                    if (cmpPts < 0) {
                        leftPt = pt1;
                        rightPt = pt2;
                        winding = 1;
                    } else if (cmpPts > 0) {
                        leftPt = pt2;
                        rightPt = pt1;
                        winding = -1;
                    } else throw new Error(`Tried to create degenerate segment at [${pt1.x}, ${pt1.y}]`);
                    var leftSE = new SweepEvent(leftPt, true);
                    var rightSE = new SweepEvent(rightPt, false);
                    return new Segment(leftSE, rightSE, [
                        ring
                    ], [
                        winding
                    ]);
                }
            }
        ]);
        return Segment;
    }();
    var RingIn = /*#__PURE__*/ function() {
        function RingIn(geomRing, poly, isExterior) {
            (0, $cx0mh._)(this, RingIn);
            if (!Array.isArray(geomRing) || geomRing.length === 0) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            this.poly = poly;
            this.isExterior = isExterior;
            this.segments = [];
            if (typeof geomRing[0][0] !== "number" || typeof geomRing[0][1] !== "number") throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            var firstPoint = rounder.round(geomRing[0][0], geomRing[0][1]);
            this.bbox = {
                ll: {
                    x: firstPoint.x,
                    y: firstPoint.y
                },
                ur: {
                    x: firstPoint.x,
                    y: firstPoint.y
                }
            };
            var prevPoint = firstPoint;
            for(var i = 1, iMax = geomRing.length; i < iMax; i++){
                if (typeof geomRing[i][0] !== "number" || typeof geomRing[i][1] !== "number") throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
                var point = rounder.round(geomRing[i][0], geomRing[i][1]);
                // skip repeated points
                if (point.x === prevPoint.x && point.y === prevPoint.y) continue;
                this.segments.push(Segment.fromRing(prevPoint, point, this));
                if (point.x < this.bbox.ll.x) this.bbox.ll.x = point.x;
                if (point.y < this.bbox.ll.y) this.bbox.ll.y = point.y;
                if (point.x > this.bbox.ur.x) this.bbox.ur.x = point.x;
                if (point.y > this.bbox.ur.y) this.bbox.ur.y = point.y;
                prevPoint = point;
            }
            // add segment from last to first if last is not the same as first
            if (firstPoint.x !== prevPoint.x || firstPoint.y !== prevPoint.y) this.segments.push(Segment.fromRing(prevPoint, firstPoint, this));
        }
        (0, $7h4XF._)(RingIn, [
            {
                key: "getSweepEvents",
                value: function getSweepEvents() {
                    var sweepEvents = [];
                    for(var i = 0, iMax = this.segments.length; i < iMax; i++){
                        var segment = this.segments[i];
                        sweepEvents.push(segment.leftSE);
                        sweepEvents.push(segment.rightSE);
                    }
                    return sweepEvents;
                }
            }
        ]);
        return RingIn;
    }();
    var PolyIn = /*#__PURE__*/ function() {
        function PolyIn(geomPoly, multiPoly) {
            (0, $cx0mh._)(this, PolyIn);
            if (!Array.isArray(geomPoly)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            this.exteriorRing = new RingIn(geomPoly[0], this, true);
            // copy by value
            this.bbox = {
                ll: {
                    x: this.exteriorRing.bbox.ll.x,
                    y: this.exteriorRing.bbox.ll.y
                },
                ur: {
                    x: this.exteriorRing.bbox.ur.x,
                    y: this.exteriorRing.bbox.ur.y
                }
            };
            this.interiorRings = [];
            for(var i = 1, iMax = geomPoly.length; i < iMax; i++){
                var ring = new RingIn(geomPoly[i], this, false);
                if (ring.bbox.ll.x < this.bbox.ll.x) this.bbox.ll.x = ring.bbox.ll.x;
                if (ring.bbox.ll.y < this.bbox.ll.y) this.bbox.ll.y = ring.bbox.ll.y;
                if (ring.bbox.ur.x > this.bbox.ur.x) this.bbox.ur.x = ring.bbox.ur.x;
                if (ring.bbox.ur.y > this.bbox.ur.y) this.bbox.ur.y = ring.bbox.ur.y;
                this.interiorRings.push(ring);
            }
            this.multiPoly = multiPoly;
        }
        (0, $7h4XF._)(PolyIn, [
            {
                key: "getSweepEvents",
                value: function getSweepEvents() {
                    var sweepEvents = this.exteriorRing.getSweepEvents();
                    for(var i = 0, iMax = this.interiorRings.length; i < iMax; i++){
                        var ringSweepEvents = this.interiorRings[i].getSweepEvents();
                        for(var j = 0, jMax = ringSweepEvents.length; j < jMax; j++)sweepEvents.push(ringSweepEvents[j]);
                    }
                    return sweepEvents;
                }
            }
        ]);
        return PolyIn;
    }();
    var MultiPolyIn = /*#__PURE__*/ function() {
        function MultiPolyIn(geom, isSubject) {
            (0, $cx0mh._)(this, MultiPolyIn);
            if (!Array.isArray(geom)) throw new Error("Input geometry is not a valid Polygon or MultiPolygon");
            try {
                // if the input looks like a polygon, convert it to a multipolygon
                if (typeof geom[0][0][0] === "number") geom = [
                    geom
                ];
            } catch (ex) {
            // The input is either malformed or has empty arrays.
            // In either case, it will be handled later on.
            }
            this.polys = [];
            this.bbox = {
                ll: {
                    x: Number.POSITIVE_INFINITY,
                    y: Number.POSITIVE_INFINITY
                },
                ur: {
                    x: Number.NEGATIVE_INFINITY,
                    y: Number.NEGATIVE_INFINITY
                }
            };
            for(var i = 0, iMax = geom.length; i < iMax; i++){
                var poly = new PolyIn(geom[i], this);
                if (poly.bbox.ll.x < this.bbox.ll.x) this.bbox.ll.x = poly.bbox.ll.x;
                if (poly.bbox.ll.y < this.bbox.ll.y) this.bbox.ll.y = poly.bbox.ll.y;
                if (poly.bbox.ur.x > this.bbox.ur.x) this.bbox.ur.x = poly.bbox.ur.x;
                if (poly.bbox.ur.y > this.bbox.ur.y) this.bbox.ur.y = poly.bbox.ur.y;
                this.polys.push(poly);
            }
            this.isSubject = isSubject;
        }
        (0, $7h4XF._)(MultiPolyIn, [
            {
                key: "getSweepEvents",
                value: function getSweepEvents() {
                    var sweepEvents = [];
                    for(var i = 0, iMax = this.polys.length; i < iMax; i++){
                        var polySweepEvents = this.polys[i].getSweepEvents();
                        for(var j = 0, jMax = polySweepEvents.length; j < jMax; j++)sweepEvents.push(polySweepEvents[j]);
                    }
                    return sweepEvents;
                }
            }
        ]);
        return MultiPolyIn;
    }();
    var RingOut = /*#__PURE__*/ function() {
        function RingOut(events) {
            (0, $cx0mh._)(this, RingOut);
            this.events = events;
            for(var i = 0, iMax = events.length; i < iMax; i++)events[i].segment.ringOut = this;
            this.poly = null;
        }
        (0, $7h4XF._)(RingOut, [
            {
                key: "getGeom",
                value: function getGeom() {
                    // Remove superfluous points (ie extra points along a straight line),
                    var prevPt = this.events[0].point;
                    var points = [
                        prevPt
                    ];
                    for(var i = 1, iMax = this.events.length - 1; i < iMax; i++){
                        var pt = this.events[i].point;
                        var nextPt = this.events[i + 1].point;
                        if (compareVectorAngles(pt, prevPt, nextPt) === 0) continue;
                        points.push(pt);
                        prevPt = pt;
                    }
                    // ring was all (within rounding error of angle calc) colinear points
                    if (points.length === 1) return null;
                    // check if the starting point is necessary
                    var pt1 = points[0];
                    var nextPt1 = points[1];
                    if (compareVectorAngles(pt1, prevPt, nextPt1) === 0) points.shift();
                    points.push(points[0]);
                    var step = this.isExteriorRing() ? 1 : -1;
                    var iStart = this.isExteriorRing() ? 0 : points.length - 1;
                    var iEnd = this.isExteriorRing() ? points.length : -1;
                    var orderedPoints = [];
                    for(var i1 = iStart; i1 != iEnd; i1 += step)orderedPoints.push([
                        points[i1].x,
                        points[i1].y
                    ]);
                    return orderedPoints;
                }
            },
            {
                key: "isExteriorRing",
                value: function isExteriorRing() {
                    if (this._isExteriorRing === undefined) {
                        var enclosing = this.enclosingRing();
                        this._isExteriorRing = enclosing ? !enclosing.isExteriorRing() : true;
                    }
                    return this._isExteriorRing;
                }
            },
            {
                key: "enclosingRing",
                value: function enclosingRing() {
                    if (this._enclosingRing === undefined) this._enclosingRing = this._calcEnclosingRing();
                    return this._enclosingRing;
                }
            },
            {
                /* Returns the ring that encloses this one, if any */ key: "_calcEnclosingRing",
                value: function _calcEnclosingRing() {
                    // start with the ealier sweep line event so that the prevSeg
                    // chain doesn't lead us inside of a loop of ours
                    var leftMostEvt = this.events[0];
                    for(var i = 1, iMax = this.events.length; i < iMax; i++){
                        var evt = this.events[i];
                        if (SweepEvent.compare(leftMostEvt, evt) > 0) leftMostEvt = evt;
                    }
                    var prevSeg = leftMostEvt.segment.prevInResult();
                    var prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
                    while(true){
                        // no segment found, thus no ring can enclose us
                        if (!prevSeg) return null;
                        // no segments below prev segment found, thus the ring of the prev
                        // segment must loop back around and enclose us
                        if (!prevPrevSeg) return prevSeg.ringOut;
                        // if the two segments are of different rings, the ring of the prev
                        // segment must either loop around us or the ring of the prev prev
                        // seg, which would make us and the ring of the prev peers
                        if (prevPrevSeg.ringOut !== prevSeg.ringOut) {
                            if (prevPrevSeg.ringOut.enclosingRing() !== prevSeg.ringOut) return prevSeg.ringOut;
                            else return prevSeg.ringOut.enclosingRing();
                        }
                        // two segments are from the same ring, so this was a penisula
                        // of that ring. iterate downward, keep searching
                        prevSeg = prevPrevSeg.prevInResult();
                        prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
                    }
                }
            }
        ], [
            {
                key: "factory",
                value: /* Given the segments from the sweep line pass, compute & return a series
       * of closed rings from all the segments marked to be part of the result */ function factory(allSegments) {
                    var ringsOut = [];
                    for(var i = 0, iMax = allSegments.length; i < iMax; i++){
                        var segment = allSegments[i];
                        if (!segment.isInResult() || segment.ringOut) continue;
                        var prevEvent = null;
                        var event = segment.leftSE;
                        var nextEvent = segment.rightSE;
                        var events = [
                            event
                        ];
                        var startingPoint = event.point;
                        var intersectionLEs = [];
                        /* Walk the chain of linked events to form a closed ring */ while(true){
                            prevEvent = event;
                            event = nextEvent;
                            events.push(event);
                            /* Is the ring complete? */ if (event.point === startingPoint) break;
                            while(true){
                                var availableLEs = event.getAvailableLinkedEvents();
                                /* Did we hit a dead end? This shouldn't happen.
               * Indicates some earlier part of the algorithm malfunctioned. */ if (availableLEs.length === 0) {
                                    var firstPt = events[0].point;
                                    var lastPt = events[events.length - 1].point;
                                    throw new Error(`Unable to complete output ring starting at [${firstPt.x},` + ` ${firstPt.y}]. Last matching segment found ends at` + ` [${lastPt.x}, ${lastPt.y}].`);
                                }
                                /* Only one way to go, so cotinue on the path */ if (availableLEs.length === 1) {
                                    nextEvent = availableLEs[0].otherSE;
                                    break;
                                }
                                /* We must have an intersection. Check for a completed loop */ var indexLE = null;
                                for(var j = 0, jMax = intersectionLEs.length; j < jMax; j++)if (intersectionLEs[j].point === event.point) {
                                    indexLE = j;
                                    break;
                                }
                                /* Found a completed loop. Cut that off and make a ring */ if (indexLE !== null) {
                                    var intersectionLE = intersectionLEs.splice(indexLE)[0];
                                    var ringEvents = events.splice(intersectionLE.index);
                                    ringEvents.unshift(ringEvents[0].otherSE);
                                    ringsOut.push(new RingOut(ringEvents.reverse()));
                                    continue;
                                }
                                /* register the intersection */ intersectionLEs.push({
                                    index: events.length,
                                    point: event.point
                                });
                                /* Choose the left-most option to continue the walk */ var comparator = event.getLeftmostComparator(prevEvent);
                                nextEvent = availableLEs.sort(comparator)[0].otherSE;
                                break;
                            }
                        }
                        ringsOut.push(new RingOut(events));
                    }
                    return ringsOut;
                }
            }
        ]);
        return RingOut;
    }();
    var PolyOut = /*#__PURE__*/ function() {
        function PolyOut(exteriorRing) {
            (0, $cx0mh._)(this, PolyOut);
            this.exteriorRing = exteriorRing;
            exteriorRing.poly = this;
            this.interiorRings = [];
        }
        (0, $7h4XF._)(PolyOut, [
            {
                key: "addInterior",
                value: function addInterior(ring) {
                    this.interiorRings.push(ring);
                    ring.poly = this;
                }
            },
            {
                key: "getGeom",
                value: function getGeom() {
                    var geom = [
                        this.exteriorRing.getGeom()
                    ];
                    // exterior ring was all (within rounding error of angle calc) colinear points
                    if (geom[0] === null) return null;
                    for(var i = 0, iMax = this.interiorRings.length; i < iMax; i++){
                        var ringGeom = this.interiorRings[i].getGeom();
                        // interior ring was all (within rounding error of angle calc) colinear points
                        if (ringGeom === null) continue;
                        geom.push(ringGeom);
                    }
                    return geom;
                }
            }
        ]);
        return PolyOut;
    }();
    var MultiPolyOut = /*#__PURE__*/ function() {
        function MultiPolyOut(rings) {
            (0, $cx0mh._)(this, MultiPolyOut);
            this.rings = rings;
            this.polys = this._composePolys(rings);
        }
        (0, $7h4XF._)(MultiPolyOut, [
            {
                key: "getGeom",
                value: function getGeom() {
                    var geom = [];
                    for(var i = 0, iMax = this.polys.length; i < iMax; i++){
                        var polyGeom = this.polys[i].getGeom();
                        // exterior ring was all (within rounding error of angle calc) colinear points
                        if (polyGeom === null) continue;
                        geom.push(polyGeom);
                    }
                    return geom;
                }
            },
            {
                key: "_composePolys",
                value: function _composePolys(rings) {
                    var polys = [];
                    for(var i = 0, iMax = rings.length; i < iMax; i++){
                        var ring = rings[i];
                        if (ring.poly) continue;
                        if (ring.isExteriorRing()) polys.push(new PolyOut(ring));
                        else {
                            var enclosingRing = ring.enclosingRing();
                            if (!enclosingRing.poly) polys.push(new PolyOut(enclosingRing));
                            enclosingRing.poly.addInterior(ring);
                        }
                    }
                    return polys;
                }
            }
        ]);
        return MultiPolyOut;
    }();
    /**
     * NOTE:  We must be careful not to change any segments while
     *        they are in the SplayTree. AFAIK, there's no way to tell
     *        the tree to rebalance itself - thus before splitting
     *        a segment that's in the tree, we remove it from the tree,
     *        do the split, then re-insert it. (Even though splitting a
     *        segment *shouldn't* change its correct position in the
     *        sweep line tree, the reality is because of rounding errors,
     *        it sometimes does.)
     */ var SweepLine = /*#__PURE__*/ function() {
        function SweepLine(queue) {
            (0, $cx0mh._)(this, SweepLine);
            var comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Segment.compare;
            this.queue = queue;
            this.tree = new Tree(comparator);
            this.segments = [];
        }
        (0, $7h4XF._)(SweepLine, [
            {
                key: "process",
                value: function process(event) {
                    var segment = event.segment;
                    var newEvents = [];
                    // if we've already been consumed by another segment,
                    // clean up our body parts and get out
                    if (event.consumedBy) {
                        if (event.isLeft) this.queue.remove(event.otherSE);
                        else this.tree.remove(segment);
                        return newEvents;
                    }
                    var node = event.isLeft ? this.tree.add(segment) : this.tree.find(segment);
                    if (!node) throw new Error(`Unable to find segment #${segment.id} ` + `[${segment.leftSE.point.x}, ${segment.leftSE.point.y}] -> ` + `[${segment.rightSE.point.x}, ${segment.rightSE.point.y}] ` + "in SweepLine tree.");
                    var prevNode = node;
                    var nextNode = node;
                    var prevSeg = undefined;
                    var nextSeg = undefined;
                    // skip consumed segments still in tree
                    while(prevSeg === undefined){
                        prevNode = this.tree.prev(prevNode);
                        if (prevNode === null) prevSeg = null;
                        else if (prevNode.key.consumedBy === undefined) prevSeg = prevNode.key;
                    }
                    // skip consumed segments still in tree
                    while(nextSeg === undefined){
                        nextNode = this.tree.next(nextNode);
                        if (nextNode === null) nextSeg = null;
                        else if (nextNode.key.consumedBy === undefined) nextSeg = nextNode.key;
                    }
                    if (event.isLeft) {
                        // Check for intersections against the previous segment in the sweep line
                        var prevMySplitter = null;
                        if (prevSeg) {
                            var prevInter = prevSeg.getIntersection(segment);
                            if (prevInter !== null) {
                                if (!segment.isAnEndpoint(prevInter)) prevMySplitter = prevInter;
                                if (!prevSeg.isAnEndpoint(prevInter)) {
                                    var newEventsFromSplit = this._splitSafely(prevSeg, prevInter);
                                    for(var i = 0, iMax = newEventsFromSplit.length; i < iMax; i++)newEvents.push(newEventsFromSplit[i]);
                                }
                            }
                        }
                        // Check for intersections against the next segment in the sweep line
                        var nextMySplitter = null;
                        if (nextSeg) {
                            var nextInter = nextSeg.getIntersection(segment);
                            if (nextInter !== null) {
                                if (!segment.isAnEndpoint(nextInter)) nextMySplitter = nextInter;
                                if (!nextSeg.isAnEndpoint(nextInter)) {
                                    var newEventsFromSplit1 = this._splitSafely(nextSeg, nextInter);
                                    for(var i1 = 0, iMax1 = newEventsFromSplit1.length; i1 < iMax1; i1++)newEvents.push(newEventsFromSplit1[i1]);
                                }
                            }
                        }
                        // For simplicity, even if we find more than one intersection we only
                        // spilt on the 'earliest' (sweep-line style) of the intersections.
                        // The other intersection will be handled in a future process().
                        if (prevMySplitter !== null || nextMySplitter !== null) {
                            var mySplitter = null;
                            if (prevMySplitter === null) mySplitter = nextMySplitter;
                            else if (nextMySplitter === null) mySplitter = prevMySplitter;
                            else {
                                var cmpSplitters = SweepEvent.comparePoints(prevMySplitter, nextMySplitter);
                                mySplitter = cmpSplitters <= 0 ? prevMySplitter : nextMySplitter;
                            }
                            // Rounding errors can cause changes in ordering,
                            // so remove afected segments and right sweep events before splitting
                            this.queue.remove(segment.rightSE);
                            newEvents.push(segment.rightSE);
                            var newEventsFromSplit2 = segment.split(mySplitter);
                            for(var i2 = 0, iMax2 = newEventsFromSplit2.length; i2 < iMax2; i2++)newEvents.push(newEventsFromSplit2[i2]);
                        }
                        if (newEvents.length > 0) {
                            // We found some intersections, so re-do the current event to
                            // make sure sweep line ordering is totally consistent for later
                            // use with the segment 'prev' pointers
                            this.tree.remove(segment);
                            newEvents.push(event);
                        } else {
                            // done with left event
                            this.segments.push(segment);
                            segment.prev = prevSeg;
                        }
                    } else {
                        // event.isRight
                        // since we're about to be removed from the sweep line, check for
                        // intersections between our previous and next segments
                        if (prevSeg && nextSeg) {
                            var inter = prevSeg.getIntersection(nextSeg);
                            if (inter !== null) {
                                if (!prevSeg.isAnEndpoint(inter)) {
                                    var newEventsFromSplit3 = this._splitSafely(prevSeg, inter);
                                    for(var i3 = 0, iMax3 = newEventsFromSplit3.length; i3 < iMax3; i3++)newEvents.push(newEventsFromSplit3[i3]);
                                }
                                if (!nextSeg.isAnEndpoint(inter)) {
                                    var newEventsFromSplit4 = this._splitSafely(nextSeg, inter);
                                    for(var i4 = 0, iMax4 = newEventsFromSplit4.length; i4 < iMax4; i4++)newEvents.push(newEventsFromSplit4[i4]);
                                }
                            }
                        }
                        this.tree.remove(segment);
                    }
                    return newEvents;
                }
            },
            {
                /* Safely split a segment that is currently in the datastructures
       * IE - a segment other than the one that is currently being processed. */ key: "_splitSafely",
                value: function _splitSafely(seg, pt) {
                    // Rounding errors can cause changes in ordering,
                    // so remove afected segments and right sweep events before splitting
                    // removeNode() doesn't work, so have re-find the seg
                    // https://github.com/w8r/splay-tree/pull/5
                    this.tree.remove(seg);
                    var rightSE = seg.rightSE;
                    this.queue.remove(rightSE);
                    var newEvents = seg.split(pt);
                    newEvents.push(rightSE);
                    // splitting can trigger consumption
                    if (seg.consumedBy === undefined) this.tree.add(seg);
                    return newEvents;
                }
            }
        ]);
        return SweepLine;
    }();
    // Limits on iterative processes to prevent infinite loops - usually caused by floating-point math round-off errors.
    var POLYGON_CLIPPING_MAX_QUEUE_SIZE = 1000000;
    var POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS = 1000000;
    var Operation = /*#__PURE__*/ function() {
        function Operation() {
            (0, $cx0mh._)(this, Operation);
        }
        (0, $7h4XF._)(Operation, [
            {
                key: "run",
                value: function run(type, geom, moreGeoms) {
                    operation.type = type;
                    rounder.reset();
                    /* Convert inputs to MultiPoly objects */ var multipolys = [
                        new MultiPolyIn(geom, true)
                    ];
                    for(var i = 0, iMax = moreGeoms.length; i < iMax; i++)multipolys.push(new MultiPolyIn(moreGeoms[i], false));
                    operation.numMultiPolys = multipolys.length;
                    /* BBox optimization for difference operation
         * If the bbox of a multipolygon that's part of the clipping doesn't
         * intersect the bbox of the subject at all, we can just drop that
         * multiploygon. */ if (operation.type === "difference") {
                        // in place removal
                        var subject = multipolys[0];
                        var i1 = 1;
                        while(i1 < multipolys.length)if (getBboxOverlap(multipolys[i1].bbox, subject.bbox) !== null) i1++;
                        else multipolys.splice(i1, 1);
                    }
                    /* BBox optimization for intersection operation
         * If we can find any pair of multipolygons whose bbox does not overlap,
         * then the result will be empty. */ if (operation.type === "intersection") // TODO: this is O(n^2) in number of polygons. By sorting the bboxes,
                    //       it could be optimized to O(n * ln(n))
                    for(var i2 = 0, iMax1 = multipolys.length; i2 < iMax1; i2++){
                        var mpA = multipolys[i2];
                        for(var j = i2 + 1, jMax = multipolys.length; j < jMax; j++){
                            if (getBboxOverlap(mpA.bbox, multipolys[j].bbox) === null) return [];
                        }
                    }
                    /* Put segment endpoints in a priority queue */ var queue = new Tree(SweepEvent.compare);
                    for(var i3 = 0, iMax2 = multipolys.length; i3 < iMax2; i3++){
                        var sweepEvents = multipolys[i3].getSweepEvents();
                        for(var j1 = 0, jMax1 = sweepEvents.length; j1 < jMax1; j1++){
                            queue.insert(sweepEvents[j1]);
                            if (queue.size > POLYGON_CLIPPING_MAX_QUEUE_SIZE) // prevents an infinite loop, an otherwise common manifestation of bugs
                            throw new Error("Infinite loop when putting segment endpoints in a priority queue (queue size too big).");
                        }
                    }
                    /* Pass the sweep line over those endpoints */ var sweepLine = new SweepLine(queue);
                    var prevQueueSize = queue.size;
                    var node = queue.pop();
                    while(node){
                        var evt = node.key;
                        if (queue.size === prevQueueSize) {
                            // prevents an infinite loop, an otherwise common manifestation of bugs
                            var seg = evt.segment;
                            throw new Error(`Unable to pop() ${evt.isLeft ? "left" : "right"} SweepEvent ` + `[${evt.point.x}, ${evt.point.y}] from segment #${seg.id} ` + `[${seg.leftSE.point.x}, ${seg.leftSE.point.y}] -> ` + `[${seg.rightSE.point.x}, ${seg.rightSE.point.y}] from queue.`);
                        }
                        if (queue.size > POLYGON_CLIPPING_MAX_QUEUE_SIZE) // prevents an infinite loop, an otherwise common manifestation of bugs
                        throw new Error("Infinite loop when passing sweep line over endpoints (queue size too big).");
                        if (sweepLine.segments.length > POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS) // prevents an infinite loop, an otherwise common manifestation of bugs
                        throw new Error("Infinite loop when passing sweep line over endpoints (too many sweep line segments).");
                        var newEvents = sweepLine.process(evt);
                        for(var i4 = 0, iMax3 = newEvents.length; i4 < iMax3; i4++){
                            var evt1 = newEvents[i4];
                            if (evt1.consumedBy === undefined) queue.insert(evt1);
                        }
                        prevQueueSize = queue.size;
                        node = queue.pop();
                    }
                    // free some memory we don't need anymore
                    rounder.reset();
                    /* Collect and compile segments we're keeping into a multipolygon */ var ringsOut = RingOut.factory(sweepLine.segments);
                    var result = new MultiPolyOut(ringsOut);
                    return result.getGeom();
                }
            }
        ]);
        return Operation;
    }();
    // singleton available by import
    var operation = new Operation();
    var union = function union(geom) {
        for(var _len = arguments.length, moreGeoms = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)moreGeoms[_key - 1] = arguments[_key];
        return operation.run("union", geom, moreGeoms);
    };
    var intersection = function intersection(geom) {
        for(var _len2 = arguments.length, moreGeoms = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)moreGeoms[_key2 - 1] = arguments[_key2];
        return operation.run("intersection", geom, moreGeoms);
    };
    var xor = function xor(geom) {
        for(var _len3 = arguments.length, moreGeoms = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)moreGeoms[_key3 - 1] = arguments[_key3];
        return operation.run("xor", geom, moreGeoms);
    };
    var difference = function difference(subjectGeom) {
        for(var _len4 = arguments.length, clippingGeoms = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)clippingGeoms[_key4 - 1] = arguments[_key4];
        return operation.run("difference", subjectGeom, clippingGeoms);
    };
    var index = {
        union: union,
        intersection: intersection,
        xor: xor,
        difference: difference
    };
    return index;
});


function $0b0ef140191bcf10$export$7ec1a3fdd6e82838(operation, geom) {
    for(var _len = arguments.length, geoms = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        geoms[_key - 2] = arguments[_key];
    }
    var result = []; // initialized with fallback
    try {
        var _polygonClipping;
        result = (_polygonClipping = $1627388b93b6ebf7$exports)[operation].apply(_polygonClipping, [
            geom
        ].concat((0, $bX4ja._)(geoms)));
    } catch (e) {
    /* */ }
    return result;
}
function $0b0ef140191bcf10$export$ea06409da076aec8(multiPolygon, clip) {
    var result = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator = multiPolygon[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
            var polygon = _step.value;
            try {
                for(var _iterator1 = polygon[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                    var ring = _step1.value;
                    var clipped = $0b0ef140191bcf10$export$7ec1a3fdd6e82838('intersection', [
                        [
                            ring
                        ]
                    ], [
                        [
                            clip
                        ]
                    ]);
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = clipped[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var poly = _step2.value;
                            result.push(poly);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return result;
}


function $396117890b5c76b0$export$f3040a9d9c5d06ba(multiPolygon) {
    return multiPolygon.map(function(poly) {
        return poly.map(function(ring) {
            return ring.map(function(point) {
                return [
                    Math.round(point[0] + 0.5) - 0.5,
                    Math.round(point[1] + 0.5) - 0.5
                ]; // on .5
            });
        });
    });
}
var $396117890b5c76b0$export$c61ab90e0d3eb9b1 = /*#__PURE__*/ function() {
    "use strict";
    function SelectionRenderer(p) {
        (0, $cx0mh._)(this, SelectionRenderer);
        this.renderedSelection = null // overwrites this.selection, unless it's null
        ;
        this.viewportTransform = p.transform;
        this.viewportMat = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(this.viewportTransform);
        this.selection = p.selection;
        this.viewportWidth = p.width;
        this.viewportHeight = p.height;
        this.svgPath1 = (0, $eWjiX.BB).createSvg({
            elementType: 'path',
            'vector-effect': 'non-scaling-stroke'
        });
        this.svgPath1.classList.add($c08bd94435b4b84a$export$2f48b40a5a83dc1b);
        this.svgPath2 = (0, $eWjiX.BB).createSvg({
            elementType: 'path',
            'vector-effect': 'non-scaling-stroke'
        });
        this.svgPath2.classList.add($c08bd94435b4b84a$export$eea3e4f737fa39e3);
        this.rootEl = (0, $eWjiX.BB).createSvg({
            elementType: 'g'
        });
        this.rootEl.append(this.svgPath1, this.svgPath2);
    }
    (0, $7h4XF._)(SelectionRenderer, [
        {
            key: "update",
            value: function update() {
                var selection = this.renderedSelection === null ? this.selection : this.renderedSelection;
                if (!selection) {
                    this.svgPath1.setAttribute('d', '');
                    this.svgPath2.setAttribute('d', '');
                    return;
                }
                // firefox has problems with non-scaling-stroke, so we scale manually.
                // ^ it has visual glitches when the transformation changes.
                var transformedSelection = (0, $bbA6w.transformMultiPolygon)(selection, this.viewportMat);
                // Firefox has bad performance when zoomed in far (guess: it doesn't clip the path)
                // So we clip manually.
                var clipPadding = 10;
                var clippedSelection = (0, $0b0ef140191bcf10$export$ea06409da076aec8)(transformedSelection, [
                    [
                        -clipPadding,
                        -clipPadding
                    ],
                    [
                        this.viewportWidth + clipPadding,
                        -clipPadding
                    ],
                    [
                        this.viewportWidth + clipPadding,
                        this.viewportHeight + clipPadding
                    ],
                    [
                        -clipPadding,
                        this.viewportHeight + clipPadding
                    ],
                    [
                        -clipPadding,
                        -clipPadding
                    ]
                ]);
                var d = (0, $9b3eo.getSvgPathD)($396117890b5c76b0$export$f3040a9d9c5d06ba(clippedSelection));
                this.svgPath1.setAttribute('d', d);
                this.svgPath2.setAttribute('d', d);
            }
        },
        {
            key: "setTransform",
            value: function setTransform(transform) {
                this.viewportTransform = transform;
                this.viewportMat = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(this.viewportTransform);
                this.update();
            }
        },
        {
            key: "setSelection",
            value: function setSelection(selection) {
                if (this.selection === selection) return;
                this.selection = selection;
                // only need to update when this.selection is used
                if (this.renderedSelection === null) this.update();
            }
        },
        {
            // overwrite project selection
            key: "setRenderedSelection",
            value: function setRenderedSelection(renderedSelection, isImmediate) {
                if (this.renderedSelection === renderedSelection) return;
                this.renderedSelection = renderedSelection;
                this.update();
            }
        },
        {
            // render project selection again
            key: "clearRenderedSelection",
            value: function clearRenderedSelection(isImmediate) {
                this.renderedSelection = null;
                if (!isImmediate) // good enough to update on next setSelection. (to prevent flickering)
                return;
                this.update();
            }
        },
        {
            key: "setSize",
            value: function setSize(width, height) {
                this.viewportWidth = width;
                this.viewportHeight = height;
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.rootEl.remove();
                this.selection = undefined;
            }
        }
    ]);
    return SelectionRenderer;
}();



var $7jh4K = parcelRequire("7jh4K");
var $99362267c0b49949$var$DEFAULT_PADDING = 10;
var $99362267c0b49949$export$133773870222880f = /*#__PURE__*/ function() {
    "use strict";
    function Preview(p) {
        var _this = this;
        (0, $cx0mh._)(this, Preview);
        this.isReset = true;
        this.doRender = false;
        this.lastEmittedTransform = {
            x: 0,
            y: 0,
            scale: 0,
            angleDeg: 0
        };
        this.renderLoop = function() {
            _this.animationFrameId = requestAnimationFrame(_this.renderLoop);
            if (_this.doRender) {
                var _this_selectionRenderer;
                _this.doRender = false;
                _this.viewport.render();
                var viewportTransform = _this.viewport.getTransform();
                (_this_selectionRenderer = _this.selectionRenderer) === null || _this_selectionRenderer === void 0 ? void 0 : _this_selectionRenderer.setTransform(viewportTransform);
                if (_this.onTransformChange && JSON.stringify(_this.lastEmittedTransform) !== JSON.stringify(viewportTransform)) {
                    _this.onTransformChange(viewportTransform);
                    _this.lastEmittedTransform = viewportTransform;
                }
            }
        };
        this.onWheel = function(e) {
            var viewportRect = _this.viewport.getElement().getBoundingClientRect();
            var vX = e.pageX - viewportRect.x;
            var vY = e.pageY - viewportRect.y;
            var oldScale = _this.viewport.getTransform().scale;
            var newScale = (0, $6ac4ab2dc9a117c8$export$8c03162b1a39d183)(oldScale, -e.deltaY / 2);
            _this.transformCanvas({
                type: 'zoom',
                vX: vX,
                vY: vY,
                fac: newScale / oldScale
            });
        };
        this.width = p.width;
        this.height = p.height;
        this.project = p.project;
        this.onTransformChange = p.onTransformChange;
        var _p_padding;
        this.padding = (_p_padding = p.padding) !== null && _p_padding !== void 0 ? _p_padding : $99362267c0b49949$var$DEFAULT_PADDING;
        var fit = (0, $eWjiX.BB).fitInto(this.project.width, this.project.height, this.width - this.padding * 2, this.height - this.padding * 2);
        var scale = fit.width / this.project.width;
        this.viewport = new (0, $ee6e64f1b33d2735$export$a140ed60c2ca052c)({
            width: this.width,
            height: this.height,
            transform: (0, $926e1894e59cf403$export$99c68a89351e15c0)({
                x: this.width / 2,
                y: this.height / 2
            }, {
                x: this.project.width / 2,
                y: this.project.height / 2
            }, scale, 0),
            project: this.project,
            useNativeResolution: false,
            drawBackground: true
        });
        var doubleTapper = new (0, $c1lmK.DoubleTapper)({
            onDoubleTap: function(e) {
                var m = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(_this.viewport.getTransform());
                var tl = (0, $cdZRx.applyToPoint)(m, {
                    x: 0,
                    y: 0
                });
                var br = (0, $cdZRx.applyToPoint)(m, {
                    x: _this.project.width,
                    y: _this.project.height
                });
                var isInside = (0, $eWjiX.BB).isInsideRect({
                    x: e.relX,
                    y: e.relY
                }, {
                    x: tl.x,
                    y: tl.y,
                    width: br.x - tl.x,
                    height: br.y - tl.y
                });
                if (!_this.isReset || isInside) _this.resetOrZoom(e.relX, e.relY);
            },
            isInstant: true
        });
        var oldTransform = undefined;
        var pinchZoomer = new (0, $joplQ.PinchZoomer)({
            onPinch: function(e) {
                if (e.type === 'move') {
                    if (!oldTransform) oldTransform = _this.viewport.getTransform();
                    var metaTransform = (0, $c4f45fb8696b5286$export$935bc53f7df03c95)(oldTransform, {
                        x: e.downRelX,
                        y: e.downRelY
                    });
                    metaTransform.scale *= e.scale;
                    metaTransform.viewportP.x += e.relX - e.downRelX;
                    metaTransform.viewportP.y += e.relY - e.downRelY;
                    _this.viewport.setTransform((0, $926e1894e59cf403$export$99c68a89351e15c0)(metaTransform.viewportP, metaTransform.canvasP, metaTransform.scale, metaTransform.angleDeg));
                    _this.requestRerender();
                    _this.isReset = false;
                } else if (e.type === 'end') oldTransform = undefined;
            }
        });
        this.pointerChain = new (0, $gCzYB.EventChain)({
            chainArr: [
                pinchZoomer,
                doubleTapper
            ]
        });
        this.pointerChain.setChainOut(function(e) {
            if (e.button && [
                'left',
                'middle'
            ].includes(e.button)) // debugOut(JSON.stringify(e));
            _this.transformCanvas({
                type: 'translate',
                x: e.dX,
                y: e.dY
            });
        });
        this.viewport.getElement().classList.add($8df31a3769a54937$export$d7b7311ec04a3e8f);
        (0, $7jh4K.css)(this.viewport.getElement(), {
            userSelect: 'none',
            touchAction: 'none'
        });
        this.viewport.getElement().addEventListener('touchend', function(e) {
            e.preventDefault();
            return false;
        });
        this.viewport.getElement().addEventListener('contextmenu', function(e) {
            e.preventDefault();
            return false;
        });
        this.viewport.getElement().addEventListener('dragstart', function(e) {
            e.preventDefault();
            return false;
        });
        this.viewportPointerListener = new (0, $04lDo.PointerListener)({
            target: this.viewport.getElement(),
            onPointer: function(e) {
                _this.pointerChain.chainIn(e);
            },
            onWheel: this.onWheel,
            maxPointers: 2
        });
        this.viewport.getElement().addEventListener('wheel', function(e) {
            e.preventDefault();
        });
        var svgRoot = (0, $eWjiX.BB).createSvg({
            elementType: 'svg'
        });
        (0, $7jh4K.css)(svgRoot, {
            position: 'absolute',
            left: '0',
            top: '0',
            width: '100%',
            height: '100%',
            pointerEvents: 'none'
        });
        if (p.selection) {
            this.selectionRenderer = new (0, $396117890b5c76b0$export$c61ab90e0d3eb9b1)({
                transform: this.lastEmittedTransform,
                selection: p.selection,
                width: this.width,
                height: this.height
            });
            svgRoot.append(this.selectionRenderer.getElement());
        }
        if (p.hasEditMode) this.modeToggle = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: [
                'edit',
                'hand'
            ].map(function(id) {
                var _p_editIcon;
                var el = (0, $eWjiX.BB).el({
                    className: 'dark-invert',
                    css: {
                        width: '28px',
                        height: '28px',
                        backgroundSize: 'contain',
                        margin: '5px',
                        backgroundImage: `url(${id === 'edit' ? (_p_editIcon = p.editIcon) !== null && _p_editIcon !== void 0 ? _p_editIcon : (0, (/*@__PURE__*/$parcel$interopDefault($0a0c8fa06baa05ba$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($ec1da9254c8485a7$exports)))})`,
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }
                });
                return {
                    id: id,
                    label: el,
                    title: id === 'edit' ? (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-edit') : (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-hand')
                };
            }),
            initId: 'edit',
            onChange: function(val) {
                p.onModeChange && p.onModeChange(val);
            }
        });
        // pointer-events: auto - So the canvas can be ignored, while the buttons still work.
        this.rootEl = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)({
            className: p.hasBorder === false ? undefined : $8df31a3769a54937$export$48c2d0f2f545ac27,
            css: {
                position: 'relative',
                zIndex: '0'
            }
        }, [
            this.viewport.getElement(),
            svgRoot
        ].concat((0, $bX4ja._)(this.modeToggle ? [
            (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',pos-absolute,left-5,top-5,z-1,pointer-auto', [
                this.modeToggle.getElement()
            ])
        ] : []), [
            (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',pos-absolute,right-5,bottom-5,flex,flexCol,gap-5,z-1,pointer-auto', [
                (0, $075b9fd415bad4ff$export$db3b6bfb95261072)({
                    tagName: 'button',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('hand-reset'),
                    onClick: function() {
                        _this.reset();
                    },
                    content: `<img alt="reset" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($f121c15402c4c25f$exports)))}">`,
                    noRef: true
                }),
                (0, $075b9fd415bad4ff$export$db3b6bfb95261072)({
                    tagName: 'button',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('zoom-in'),
                    onClick: function() {
                        var oldScale = _this.viewport.getTransform().scale;
                        var newScale = (0, $6ac4ab2dc9a117c8$export$8c03162b1a39d183)(oldScale, 1);
                        _this.transformCanvas({
                            type: 'zoom',
                            fac: newScale / oldScale
                        });
                    },
                    content: `<img alt="zoom-in" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($c88da6b7fdef67e7$exports)))}">`,
                    noRef: true
                }),
                (0, $075b9fd415bad4ff$export$db3b6bfb95261072)({
                    tagName: 'button',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('zoom-out'),
                    onClick: function() {
                        var oldScale = _this.viewport.getTransform().scale;
                        var newScale = (0, $6ac4ab2dc9a117c8$export$8c03162b1a39d183)(oldScale, -1);
                        _this.transformCanvas({
                            type: 'zoom',
                            fac: newScale / oldScale
                        });
                    },
                    content: `<img alt="zoom-out" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($e503dd0072d83d49$exports)))}">`,
                    noRef: true
                })
            ])
        ]));
        this.renderLoop();
    }
    (0, $7h4XF._)(Preview, [
        {
            key: "requestRerender",
            value: function requestRerender() {
                this.doRender = true;
            }
        },
        {
            key: "resetOrZoom",
            value: function resetOrZoom(x, y) {
                if (this.isReset) {
                    this.isReset = false;
                    var canvasP = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)((0, $92816524e1b72be4$export$ad1d215dd03fe75a)(this.viewport.getTransform())), {
                        x: x,
                        y: y
                    });
                    this.viewport.setTransform((0, $926e1894e59cf403$export$99c68a89351e15c0)({
                        x: this.width / 2,
                        y: this.height / 2
                    }, canvasP, 1, 0));
                    this.requestRerender();
                } else this.reset();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var fit = (0, $eWjiX.BB).fitInto(this.project.width, this.project.height, this.width - this.padding * 2, this.height - this.padding * 2);
                var scale = fit.width / this.project.width;
                this.viewport.setTransform((0, $926e1894e59cf403$export$99c68a89351e15c0)({
                    x: this.width / 2,
                    y: this.height / 2
                }, {
                    x: this.project.width / 2,
                    y: this.project.height / 2
                }, scale, 0));
                this.isReset = true;
                this.requestRerender();
            }
        },
        {
            key: "transformCanvas",
            value: function transformCanvas(t) {
                if (t.type === 'translate') {
                    var old = this.viewport.getTransform();
                    if (t.x === 0 && t.y === 0) return;
                    this.viewport.setTransform((0, $4EWN2._)((0, $cL71g._)({}, old), {
                        x: old.x + t.x,
                        y: old.y + t.y
                    }));
                } else if (t.type === 'zoom') {
                    var old1 = this.viewport.getTransform();
                    var viewportRect = this.viewport.getElement().getBoundingClientRect();
                    var _t_vX;
                    t.vX = (_t_vX = t.vX) !== null && _t_vX !== void 0 ? _t_vX : viewportRect.width / 2;
                    var _t_vY;
                    t.vY = (_t_vY = t.vY) !== null && _t_vY !== void 0 ? _t_vY : viewportRect.height / 2;
                    var metaTransform = (0, $c4f45fb8696b5286$export$935bc53f7df03c95)(old1, {
                        x: t.vX,
                        y: t.vY
                    });
                    metaTransform.scale *= t.fac;
                    this.viewport.setTransform((0, $926e1894e59cf403$export$99c68a89351e15c0)(metaTransform.viewportP, metaTransform.canvasP, metaTransform.scale, metaTransform.angleDeg));
                }
                this.isReset = false;
                this.requestRerender();
            }
        },
        {
            key: "render",
            value: function render() {
                this.requestRerender();
            }
        },
        {
            key: "setTransform",
            value: function setTransform(transform) {
                this.viewport.setTransform(transform);
                this.requestRerender();
                this.isReset = false;
            }
        },
        {
            key: "getTransform",
            value: function getTransform() {
                return this.viewport.getTransform();
            }
        },
        {
            key: "onPointer",
            value: function onPointer(event) {
                this.pointerChain.chainIn(event);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this_selectionRenderer;
                this.animationFrameId !== undefined && cancelAnimationFrame(this.animationFrameId);
                this.viewport.destroy();
                this.viewportPointerListener.destroy();
                this.rootEl.remove();
                this.modeToggle && this.modeToggle.destroy();
                (_this_selectionRenderer = this.selectionRenderer) === null || _this_selectionRenderer === void 0 ? void 0 : _this_selectionRenderer.destroy();
            }
        }
    ]);
    return Preview;
}();


parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");


var $eg83P = parcelRequire("eg83P");

var $96cbdba315fc6e81$exports = {};
$96cbdba315fc6e81$exports = $parcel$resolve("cazOx");



var $gCzYB = parcelRequire("gCzYB");

var $635F6 = parcelRequire("635F6");

var $eIcQa = parcelRequire("eIcQa");

var $7jh4K = parcelRequire("7jh4K");
var $01fcd0ed15aa4018$export$40175a5948a88a57 = /*#__PURE__*/ function() {
    "use strict";
    function CropCopy(p) {
        var _this = this;
        (0, $cx0mh._)(this, CropCopy);
        this.cropRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        } // canvas coordinates
        ;
        this.mode = 'edit';
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'kl-edit-crop-preview',
            css: {
                position: 'relative',
                height: p.height + 'px',
                width: p.width + 'px',
                overflow: 'hidden'
            }
        });
        if (p.onChange) this.onChange = p.onChange;
        this.canvas = p.canvas;
        if (p.init) this.cropRect = p.init;
        else this.resetCrop();
        var isInsideSelectionRect = function(p) {
            return (0, $eWjiX.BB).isInsideRect(p, _this.getViewportSelectionRect());
        };
        this.croppedCanvas = (0, $eWjiX.BB).canvas();
        this.croppedBlob = {};
        this.croppedObjectUrl = '';
        this.eventTarget = this.croppedCanvas;
        if (p.enableRightClickCopy) {
            this.croppedImageElement = new Image();
            this.eventTarget = this.croppedImageElement;
        }
        (0, $7jh4K.css)(this.eventTarget, {
            height: p.height + 'px',
            width: p.width + 'px'
        });
        this.rootEl.append(this.eventTarget);
        this.updateCroppedCanvas();
        this.previewLayer = {
            image: p.canvas,
            opacity: 1,
            isVisible: true,
            mixModeStr: 'source-over',
            hasClipping: false
        };
        this.preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: p.width,
            height: p.height - 2,
            project: {
                width: p.canvas.width,
                height: p.canvas.height,
                layers: [
                    this.previewLayer
                ]
            },
            hasEditMode: true,
            onModeChange: function(mode) {
                _this.mode = mode;
                _this.preview.getElement().style.pointerEvents = mode === 'edit' ? 'none' : '';
                _this.rootEl.title = mode === 'edit' ? (0, $8d7403abedf7cefa$export$ce37e184d908d785)('crop-drag-to-crop') : '';
            },
            onTransformChange: function() {
                return _this.updateSelectionRect();
            },
            padding: 20,
            hasBorder: false,
            editIcon: (0, (/*@__PURE__*/$parcel$interopDefault($96cbdba315fc6e81$exports)))
        });
        (0, $7jh4K.css)(this.preview.getElement(), {
            position: 'absolute',
            left: '0',
            top: '0',
            overflow: 'hidden',
            pointerEvents: 'none'
        });
        this.preview.render();
        this.rootEl.append(this.preview.getElement());
        this.selectionRectEl = (0, $eWjiX.BB).el({
            parent: this.preview.getElement(),
            className: 'kl-edit-crop-preview__sel'
        });
        this.updateSelectionRect();
        //gen crop from viewport points
        var genCrop = function(p1, p2) {
            var mat = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(_this.preview.getTransform());
            var inverseMat = (0, $kDVZW.inverse)(mat);
            var topLeftP = {
                x: Math.min(p1.x, p2.x),
                y: Math.min(p1.y, p2.y)
            };
            var bottomRightP = {
                x: Math.max(p1.x, p2.x),
                y: Math.max(p1.y, p2.y)
            };
            var origTopLeftP = (0, $cdZRx.applyToPoint)(inverseMat, topLeftP);
            var origBottomRightP = (0, $cdZRx.applyToPoint)(inverseMat, bottomRightP);
            origTopLeftP.x = (0, $eg83P.clamp)(Math.floor(origTopLeftP.x), 0, _this.canvas.width);
            origTopLeftP.y = (0, $eg83P.clamp)(Math.floor(origTopLeftP.y), 0, _this.canvas.height);
            origBottomRightP.x = (0, $eg83P.clamp)(Math.ceil(origBottomRightP.x), 0, _this.canvas.width);
            origBottomRightP.y = (0, $eg83P.clamp)(Math.ceil(origBottomRightP.y), 0, _this.canvas.height);
            return {
                x: origTopLeftP.x,
                y: origTopLeftP.y,
                width: origBottomRightP.x - origTopLeftP.x,
                height: origBottomRightP.y - origTopLeftP.y
            };
        };
        var startP;
        var startCrop = null;
        var isDragging = false;
        var didMove = false;
        var updateCropTimeout;
        var pointerChain = new (0, $gCzYB.EventChain)({
            chainArr: [
                new (0, $635F6.OnePointerLimiter)()
            ]
        });
        pointerChain.setChainOut(function(event) {
            if (event.type === 'pointerdown' && event.button === 'left') {
                event.eventPreventDefault();
                isDragging = true;
                startP = {
                    x: event.relX,
                    y: event.relY
                };
                if (!_this.isReset() && isInsideSelectionRect(startP)) startCrop = {
                    x: _this.cropRect.x,
                    y: _this.cropRect.y,
                    width: _this.cropRect.width,
                    height: _this.cropRect.height
                };
                else _this.cropRect = genCrop(startP, startP);
            } else if (event.type === 'pointermove' && event.button === 'left') {
                event.eventPreventDefault();
                didMove = true;
                if (startCrop) {
                    var transform = _this.preview.getTransform();
                    _this.cropRect.x = startCrop.x + Math.round((event.relX - startP.x) / transform.scale);
                    _this.cropRect.y = startCrop.y + Math.round((event.relY - startP.y) / transform.scale);
                    _this.cropRect.x = (0, $eWjiX.BB).clamp(_this.cropRect.x, 0, _this.canvas.width - _this.cropRect.width);
                    _this.cropRect.y = (0, $eWjiX.BB).clamp(_this.cropRect.y, 0, _this.canvas.height - _this.cropRect.height);
                } else _this.cropRect = genCrop(startP, {
                    x: event.relX,
                    y: event.relY
                });
                _this.updateSelectionRect();
            } else if (event.type === 'pointerup' && startP) {
                event.eventPreventDefault();
                isDragging = false;
                startCrop = null;
                startP = null;
                if (_this.cropRect.width === 0 || _this.cropRect.height === 0 || !didMove) {
                    _this.resetCrop();
                    _this.updateSelectionRect();
                }
                didMove = false;
                updateCropTimeout = setTimeout(function() {
                    return _this.updateCroppedCanvas();
                }, 1);
            }
        });
        this.pointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.eventTarget,
            fixScribble: true,
            onWheel: function(event) {
                _this.preview.onWheel(event);
            },
            onPointer: function(event) {
                if (_this.mode === 'hand') {
                    event.eventPreventDefault();
                    _this.preview.onPointer(event);
                    return;
                }
                pointerChain.chainIn(event);
            },
            maxPointers: 2
        });
        this.keyListener = new (0, $eWjiX.BB).KeyListener({
            onDown: function(keyStr, e) {
                if (isDragging) return;
                var doUpdate = false;
                var transform = _this.preview.getTransform();
                var stepSize = Math.max(1, 1 / transform.scale);
                var shiftIsPressed = _this.keyListener.isPressed('shift');
                if (keyStr === 'left') {
                    if (shiftIsPressed) _this.cropRect.width = (0, $eWjiX.BB).clamp(_this.cropRect.width - stepSize, 1, _this.canvas.width - _this.cropRect.x);
                    else _this.cropRect.x = (0, $eWjiX.BB).clamp(_this.cropRect.x - stepSize, 0, _this.canvas.width - _this.cropRect.width);
                    doUpdate = true;
                }
                if (keyStr === 'right') {
                    if (shiftIsPressed) _this.cropRect.width = (0, $eWjiX.BB).clamp(_this.cropRect.width + stepSize, 1, _this.canvas.width - _this.cropRect.x);
                    else _this.cropRect.x = (0, $eWjiX.BB).clamp(_this.cropRect.x + stepSize, 0, _this.canvas.width - _this.cropRect.width);
                    doUpdate = true;
                }
                if (keyStr === 'up') {
                    if (shiftIsPressed) _this.cropRect.height = (0, $eWjiX.BB).clamp(_this.cropRect.height - stepSize, 1, _this.canvas.height - _this.cropRect.y);
                    else _this.cropRect.y = (0, $eWjiX.BB).clamp(_this.cropRect.y - stepSize, 0, _this.canvas.height - _this.cropRect.height);
                    doUpdate = true;
                }
                if (keyStr === 'down') {
                    if (shiftIsPressed) _this.cropRect.height = (0, $eWjiX.BB).clamp(_this.cropRect.height + stepSize, 1, _this.canvas.height - _this.cropRect.y);
                    else _this.cropRect.y = (0, $eWjiX.BB).clamp(_this.cropRect.y + stepSize, 0, _this.canvas.height - _this.cropRect.height);
                    doUpdate = true;
                }
                if (doUpdate) {
                    e.preventDefault();
                    _this.updateSelectionRect();
                    clearTimeout(updateCropTimeout);
                    updateCropTimeout = setTimeout(function() {
                        return _this.updateCroppedCanvas();
                    }, 100);
                }
            }
        });
    }
    (0, $7h4XF._)(CropCopy, [
        {
            key: "resetCrop",
            value: function resetCrop() {
                this.cropRect = {
                    x: 0,
                    y: 0,
                    width: this.canvas.width,
                    height: this.canvas.height
                };
            }
        },
        {
            key: "getViewportSelectionRect",
            value: function getViewportSelectionRect() {
                var transform = this.preview.getTransform();
                var mat = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(transform);
                var p = (0, $cdZRx.applyToPoint)(mat, this.cropRect);
                return {
                    x: p.x,
                    y: p.y,
                    width: this.cropRect.width * transform.scale,
                    height: this.cropRect.height * transform.scale
                };
            }
        },
        {
            key: "updateCroppedCanvas",
            value: function updateCroppedCanvas() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this_onChange, _this, ctx, blob;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.croppedCanvas.width = Math.round(this.cropRect.width);
                                this.croppedCanvas.height = Math.round(this.cropRect.height);
                                ctx = (0, $eWjiX.BB).ctx(this.croppedCanvas);
                                ctx.drawImage(this.canvas, Math.round(-this.cropRect.x), Math.round(-this.cropRect.y));
                                return [
                                    4,
                                    (0, $eIcQa.canvasToBlob)(this.croppedCanvas, 'image/png')
                                ];
                            case 1:
                                blob = _state.sent();
                                this.croppedBlob = blob;
                                if (this.croppedObjectUrl !== '') URL.revokeObjectURL(this.croppedObjectUrl);
                                this.croppedObjectUrl = URL.createObjectURL(blob);
                                if (this.croppedImageElement) this.croppedImageElement.src = this.croppedObjectUrl;
                                (_this_onChange = (_this = this).onChange) === null || _this_onChange === void 0 ? void 0 : _this_onChange.call(_this, this.croppedCanvas.width, this.croppedCanvas.height);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "updateSelectionRect",
            value: function updateSelectionRect() {
                var _this_onChange, _this;
                var rect = this.getViewportSelectionRect();
                (0, $7jh4K.css)(this.selectionRectEl, {
                    left: rect.x + 'px',
                    top: rect.y + 'px',
                    width: rect.width + 'px',
                    height: rect.height + 'px',
                    display: this.isReset() ? 'none' : ''
                });
                (_this_onChange = (_this = this).onChange) === null || _this_onChange === void 0 ? void 0 : _this_onChange.call(_this, Math.round(this.cropRect.width), Math.round(this.cropRect.height));
            }
        },
        {
            key: "isReset",
            value: function isReset() {
                return this.cropRect.x === 0 && this.cropRect.y === 0 && this.cropRect.width === this.canvas.width && this.cropRect.height === this.canvas.height;
            }
        },
        {
            // ---- interface ----
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            // in input canvas coordinates
            key: "getCropRect",
            value: function getCropRect() {
                return (0, $eWjiX.BB).copyObj(this.cropRect);
            }
        },
        {
            key: "getCroppedCanvas",
            value: function getCroppedCanvas() {
                return this.croppedCanvas;
            }
        },
        {
            // image/png blob
            key: "getCroppedBlob",
            value: function getCroppedBlob() {
                return this.croppedBlob;
            }
        },
        {
            key: "setCanvas",
            value: function setCanvas(canvas) {
                this.canvas = canvas;
                this.previewLayer.image = canvas;
                this.updateCroppedCanvas();
                this.preview.render();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this.croppedImageElement) this.croppedImageElement.src = '';
                URL.revokeObjectURL(this.croppedObjectUrl);
                this.rootEl.remove();
                this.eventTarget.style.removeProperty('width');
                this.eventTarget.style.removeProperty('height');
                this.keyListener.destroy();
                this.pointerListener.destroy();
                this.preview.destroy();
            }
        }
    ]);
    return CropCopy;
}();



var $1LaJZ = parcelRequire("1LaJZ");

var $fk3zw = parcelRequire("fk3zw");

var $eWjiX = parcelRequire("eWjiX");




var $eg83P = parcelRequire("eg83P");

var $eg83P = parcelRequire("eg83P");
function $2c64e9e8cb297da3$export$a04a50ae6d6450f8(poly, type) {
    var x1;
    var y1;
    var x2;
    var y2;
    poly.forEach(function(poly) {
        poly.forEach(function(ring) {
            ring.forEach(function(p) {
                x1 = x1 === undefined ? p[0] : Math.min(x1, p[0]);
                y1 = y1 === undefined ? p[1] : Math.min(y1, p[1]);
                x2 = x2 === undefined ? p[0] : Math.max(x2, p[0]);
                y2 = y2 === undefined ? p[1] : Math.max(y2, p[1]);
            });
        });
    });
    if (x1 === undefined || y1 === undefined || x2 === undefined || y2 === undefined) throw new Error('empty MultiPolygon');
    var bounds = {
        type: 'coordinate',
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
    return type === 'index' ? (0, $eg83P.coordinateBoundsToIndexBounds)(bounds) : bounds;
}




var $7jh4K = parcelRequire("7jh4K");
var $ffd40240385bb9f9$var$maskSelection = false;
function $ffd40240385bb9f9$export$32b89bc9bb92706a(parent, getFullCanvas, cropCallback, output, showCropButton) {
    var closeOnBlur = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : true, selection = arguments.length > 6 ? arguments[6] : void 0;
    var clipboardItemIsSupported = false;
    try {
        clipboardItemIsSupported = !!ClipboardItem;
    } catch (e) {
    /* empty */ }
    var div = document.createElement('div');
    var isSmall = window.innerWidth < 550 || window.innerHeight < 550;
    var maskToggle = selection ? new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
        init: $ffd40240385bb9f9$var$maskSelection,
        label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('cropcopy-mask'),
        name: 'check-mask-selection',
        css: {
            width: 'fit-content'
        },
        callback: function(b) {
            $ffd40240385bb9f9$var$maskSelection = b;
            cropCopy.setCanvas(getFullCanvas(b));
        }
    }) : undefined;
    var topWrapper = (0, $eWjiX.BB).el({
        content: [
            maskToggle === null || maskToggle === void 0 ? void 0 : maskToggle.getElement(),
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('crop-drag-to-crop') + (clipboardItemIsSupported ? '' : '<br>' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('cropcopy-click-hold'))
        ],
        css: {
            textAlign: 'center'
        }
    });
    div.append(topWrapper);
    var fullCanvas = getFullCanvas($ffd40240385bb9f9$var$maskSelection);
    var init;
    if (selection) {
        var bounds = (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(selection, 'index');
        var boundsInCanvas = (0, $eg83P.indexBoundsInArea)(bounds, fullCanvas.width, fullCanvas.height);
        init = boundsInCanvas ? (0, $eg83P.boundsToRect)(boundsInCanvas) : undefined;
    }
    var cropCopy = new (0, $01fcd0ed15aa4018$export$40175a5948a88a57)({
        width: isSmall ? 340 : 540,
        height: isSmall ? 300 : 350,
        canvas: fullCanvas,
        enableRightClickCopy: true,
        init: init
    });
    (0, $7jh4K.css)(cropCopy.getElement(), {
        marginTop: '10px',
        marginLeft: '-20px'
    });
    div.append(cropCopy.getElement());
    function toClipboard() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
            var blob, err;
            return (0, $fk3zw._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        blob = cropCopy.getCroppedBlob();
                        return [
                            4,
                            navigator.clipboard.write([
                                new ClipboardItem({
                                    [blob.type]: blob
                                })
                            ])
                        ];
                    case 1:
                        _state.sent();
                        setTimeout(function() {
                            output.out((0, $8d7403abedf7cefa$export$ce37e184d908d785)('cropcopy-copied'), true);
                        }, 200);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        console.error(err.name, err.message);
                        return [
                            2
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    var keyListener = new (0, $eWjiX.BB).KeyListener({
        onDown: function onDown(keyStr, KeyEvent, comboStr) {
            if ([
                'ctrl+c',
                'cmd+c'
            ].includes(comboStr)) {
                toClipboard();
                closeFunc && closeFunc();
            }
        }
    });
    var closeFunc;
    function blur() {
        if (closeOnBlur) closeFunc === null || closeFunc === void 0 ? void 0 : closeFunc();
    }
    window.addEventListener('blur', blur);
    var buttonArr = [];
    if (clipboardItemIsSupported) buttonArr.push((0, $8d7403abedf7cefa$export$ce37e184d908d785)('cropcopy-btn-copy'));
    if (showCropButton) buttonArr.push((0, $8d7403abedf7cefa$export$ce37e184d908d785)('cropcopy-btn-crop'));
    buttonArr.push('Cancel');
    (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
        message: '<b>' + (showCropButton ? `${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('cropcopy-title-copy')} / ${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('cropcopy-title-crop')}` : `${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('cropcopy-title-copy')}`) + '</b>',
        div: div,
        style: isSmall ? {} : {
            width: '540px'
        },
        buttons: buttonArr,
        primaries: [
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('cropcopy-btn-copy')
        ],
        callback: function callback(result) {
            if (result === (0, $8d7403abedf7cefa$export$ce37e184d908d785)('cropcopy-btn-copy')) toClipboard();
            else if (result === (0, $8d7403abedf7cefa$export$ce37e184d908d785)('cropcopy-btn-crop')) {
                var rectObj = cropCopy.getCropRect();
                cropCallback({
                    left: Math.round(-rectObj.x),
                    right: Math.round(rectObj.x + rectObj.width - fullCanvas.width),
                    top: Math.round(-rectObj.y),
                    bottom: Math.round(rectObj.y + rectObj.height - fullCanvas.height)
                });
            }
            window.removeEventListener('blur', blur);
            (0, $eWjiX.BB).freeCanvas(cropCopy.getCroppedCanvas());
            cropCopy.destroy();
            keyListener.destroy();
        },
        clickOnEnter: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('cropcopy-btn-copy'),
        closeFunc: function closeFunc1(func) {
            closeFunc = func;
        }
    });
}



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $bX4ja = parcelRequire("bX4ja");

var $eWjiX = parcelRequire("eWjiX");
/**
 * Set values in data within rect to 254, unless they're 255
 *
 * @param data Uint8Array
 * @param width int
 * @param x0 int
 * @param y0 int
 * @param x1 int >x0
 * @param y1 int >y0
 */ function $7069db2f5e23d00f$var$fillRect(data, width, x0, y0, x1, y1) {
    for(var x = x0; x <= x1; x++)for(var y = y0; y <= y1; y++){
        if (data[y * width + x] === 255) continue;
        data[y * width + x] = 254;
    }
}
// test, should fill, if there is a tolerance < 255
function $7069db2f5e23d00f$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, i) {
    return Math.pow(srcArr[i * 4] - initR, 2) <= toleranceSquared && Math.pow(srcArr[i * 4 + 1] - initG, 2) <= toleranceSquared && Math.pow(srcArr[i * 4 + 2] - initB, 2) <= toleranceSquared && Math.pow(srcArr[i * 4 + 3] - initA, 2) <= toleranceSquared;
}
// check is within selection
function $7069db2f5e23d00f$var$selectionMaskTest(selectionMaskArr, i) {
    return !selectionMaskArr || !!selectionMaskArr[i];
}
/**
 *
 * @param srcArr Uint8ClampedArray rgba
 * @param selectionMaskArr Uint8Array width x height, 0 or 1 values
 * @param targetArr Uint8Array
 * @param width int
 * @param height int
 * @param px int
 * @param py int
 * @param tolerance int 0 - 255
 * @param grow int >= 0
 * @param isContiguous boolean
 */ function $7069db2f5e23d00f$var$floodFill(srcArr, selectionMaskArr, targetArr, width, height, px, py, tolerance, grow, isContiguous) {
    var initR = srcArr[(py * width + px) * 4];
    var initG = srcArr[(py * width + px) * 4 + 1];
    var initB = srcArr[(py * width + px) * 4 + 2];
    var initA = srcArr[(py * width + px) * 4 + 3];
    var view = new DataView(srcArr.buffer);
    var init = view.getUint32((py * width + px) * 4, true);
    var toleranceSquared = Math.pow(tolerance, 2);
    var bounds = {
        type: 'index',
        x1: px,
        y1: py,
        x2: px,
        y2: py
    };
    if (isContiguous) {
        var q = []; // queue of pixel indices. they are already filled.
        q.push(py * width + px); // starting pixel, where the user clicked to fill
        targetArr[py * width + px] = 255;
        var i, e;
        var x, y;
        while(q.length){
            // checks neighbors of queued pixels, fills, and queues them.
            // Adds to queue after filling it. Skip if was already filled.
            i = q.pop();
            y = Math.floor(i / width);
            x = i % width;
            if (x > 0) {
                // can go left
                e = i - 1;
                if (targetArr[e] !== 255 && $7069db2f5e23d00f$var$selectionMaskTest(selectionMaskArr, e) && (view.getUint32(e * 4, true) === init || tolerance > 0 && $7069db2f5e23d00f$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, e))) {
                    bounds.x1 = Math.min(bounds.x1, x - 1);
                    targetArr[e] = 255;
                    q.push(e);
                }
            }
            if (x < width - 1) {
                // can go right
                e = i + 1;
                if (targetArr[e] !== 255 && $7069db2f5e23d00f$var$selectionMaskTest(selectionMaskArr, e) && (view.getUint32(e * 4, true) === init || tolerance > 0 && $7069db2f5e23d00f$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, e))) {
                    bounds.x2 = Math.max(bounds.x2, x + 1);
                    targetArr[e] = 255;
                    q.push(e);
                }
            }
            if (y > 0) {
                // can go up
                e = i - width;
                if (targetArr[e] !== 255 && $7069db2f5e23d00f$var$selectionMaskTest(selectionMaskArr, e) && (view.getUint32(e * 4, true) === init || tolerance > 0 && $7069db2f5e23d00f$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, e))) {
                    bounds.y1 = Math.min(bounds.y1, y - 1);
                    targetArr[e] = 255;
                    q.push(e);
                }
            }
            if (y < height - 1) {
                // can go down
                e = i + width;
                if (targetArr[e] !== 255 && $7069db2f5e23d00f$var$selectionMaskTest(selectionMaskArr, e) && (view.getUint32(e * 4, true) === init || tolerance > 0 && $7069db2f5e23d00f$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, e))) {
                    bounds.y2 = Math.max(bounds.y2, y + 1);
                    targetArr[e] = 255;
                    q.push(e);
                }
            }
        }
    } else // not contiguous
    for(var y1 = 0, i1 = 0; y1 < height; y1++){
        for(var x1 = 0; x1 < width; x1++, i1++)if ($7069db2f5e23d00f$var$selectionMaskTest(selectionMaskArr, i1) && (view.getUint32(i1 * 4, true) === init || tolerance > 0 && $7069db2f5e23d00f$var$toleranceTest(srcArr, initR, initG, initB, initA, toleranceSquared, i1))) {
            targetArr[i1] = 255;
            if (x1 < bounds.x1) bounds.x1 = x1;
            if (y1 < bounds.y1) bounds.y1 = y1;
            if (x1 > bounds.x2) bounds.x2 = x1;
            if (y1 > bounds.y2) bounds.y2 = y1;
        }
    }
    if (grow === 0) return bounds;
    // --- grow ---
    // how does it grow? it finds all pixel at the edge.
    // then depending on what kind of edge it is, it draws a rectangle into target
    // In the rectangle each pixel has the value 254, or else it will mess it all up.
    // after it's all done, replaces it with 255
    var x0, x11, y0, y11;
    var l, tl, t, tr, r, br, b, bl; // left, top left, top, top right, etc.
    for(var x2 = bounds.x1; x2 <= bounds.x2; x2++)for(var y2 = bounds.y1; y2 <= bounds.y2; y2++){
        if (targetArr[y2 * width + x2] !== 255) continue;
        // bounds of rectangle
        x0 = x2;
        x11 = x2;
        y0 = y2;
        y11 = y2;
        l = targetArr[y2 * width + x2 - 1] !== 255;
        tl = targetArr[(y2 - 1) * width + x2 - 1] !== 255;
        t = targetArr[(y2 - 1) * width + x2] !== 255;
        tr = targetArr[(y2 - 1) * width + x2 + 1] !== 255;
        r = targetArr[y2 * width + x2 + 1] !== 255;
        br = targetArr[(y2 + 1) * width + x2 + 1] !== 255;
        b = targetArr[(y2 + 1) * width + x2] !== 255;
        bl = targetArr[(y2 + 1) * width + x2 - 1] !== 255;
        if (l) // left
        x0 = x2 - grow;
        if (l && tl && t) {
            // top left
            x0 = x2 - grow;
            y0 = y2 - grow;
        }
        if (t) // top
        y0 = Math.min(y0, y2 - grow);
        if (t && tr && r) {
            // top right
            y0 = Math.min(y0, y2 - grow);
            x11 = x2 + grow;
        }
        if (r) // right
        x11 = Math.max(x11, x2 + grow);
        if (r && br && b) {
            // bottom right
            x11 = Math.max(x11, x2 + grow);
            y11 = Math.max(y11, y2 + grow);
        }
        if (b) // bottom
        y11 = Math.max(y11, y2 + grow);
        if (b && bl && l) {
            // bottom left
            x0 = Math.min(x0, x2 - grow);
            y11 = Math.max(y11, y2 + grow);
        }
        if (!l && !tl && !t && !tr && !r && !br && !b && !bl) continue;
        $7069db2f5e23d00f$var$fillRect(targetArr, width, Math.max(0, x0), Math.max(0, y0), Math.min(width - 1, x11), Math.min(height - 1, y11));
    }
    for(var i2 = 0; i2 < width * height; i2++)if (targetArr[i2] === 254) targetArr[i2] = 255;
    // expand bounds by grow
    bounds.x1 -= grow;
    bounds.y1 -= grow;
    bounds.x2 += grow;
    bounds.y2 += grow;
    return bounds;
}
function $7069db2f5e23d00f$export$13d50f258a8034f(rgbaArr, // width x height, 0 or 1 values
selectionMaskArr, width, height, x, y, tolerance, grow, isContiguous) {
    x = Math.round(x); // just in case
    y = Math.round(y);
    var resultArr = new Uint8Array(new ArrayBuffer(width * height));
    var bounds = $7069db2f5e23d00f$var$floodFill(rgbaArr, selectionMaskArr, resultArr, width, height, x, y, tolerance, grow, isContiguous);
    return {
        data: resultArr,
        bounds: bounds
    };
}



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $bX4ja = parcelRequire("bX4ja");

var $eWjiX = parcelRequire("eWjiX");
parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
function $b04075c332ce65cd$export$5dd60a54dd55622(bounds, transform) {
    var p1 = (0, $cdZRx.applyToPoint)(transform, {
        x: bounds.x1,
        y: bounds.y1
    });
    var p2 = (0, $cdZRx.applyToPoint)(transform, {
        x: bounds.x2,
        y: bounds.y1
    });
    var p3 = (0, $cdZRx.applyToPoint)(transform, {
        x: bounds.x2,
        y: bounds.y2
    });
    var p4 = (0, $cdZRx.applyToPoint)(transform, {
        x: bounds.x1,
        y: bounds.y2
    });
    return {
        type: 'coordinate',
        x1: Math.min(p1.x, p2.x, p3.x, p4.x),
        y1: Math.min(p1.y, p2.y, p3.y, p4.y),
        x2: Math.max(p1.x, p2.x, p3.x, p4.x),
        y2: Math.max(p1.y, p2.y, p3.y, p4.y)
    };
}


parcelRequire("ciAU9");
var $dZ59l = parcelRequire("dZ59l");
var $1RMPr = parcelRequire("1RMPr");


var $eg83P = parcelRequire("eg83P");
var $01d7180c5d1d0fdf$export$27550cc14d7ae85a = /*#__PURE__*/ function() {
    "use strict";
    function ShapeTool(p) {
        (0, $cx0mh._)(this, ShapeTool);
        this.downX = 0;
        this.downY = 0;
        this.downAngleRad = 0;
        this.onShape = p.onShape;
    }
    (0, $7h4XF._)(ShapeTool, [
        {
            key: "onDown",
            value: function onDown(x, y, angleRad) {
                this.downX = x;
                this.downY = y;
                this.downAngleRad = angleRad;
            }
        },
        {
            key: "onMove",
            value: function onMove(x, y) {
                this.onShape(false, this.downX, this.downY, x, y, this.downAngleRad);
            }
        },
        {
            key: "onUp",
            value: function onUp(x, y) {
                this.onShape(true, this.downX, this.downY, x, y, this.downAngleRad);
            }
        }
    ]);
    return ShapeTool;
}();
function $01d7180c5d1d0fdf$export$71b514a25c47df50(ctx, shapeObj, selectionPath) {
    shapeObj = (0, $cL71g._)({
        // defaults
        angleRad: 0,
        isOutwards: false,
        opacity: 1,
        isEraser: false,
        doLockAlpha: false
    }, (0, $eWjiX.BB).copyObj(shapeObj));
    var bounds = {
        type: 'coordinate',
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
    };
    if ([
        'rect',
        'ellipse',
        'line'
    ].includes(shapeObj.type)) {
        var _ctx;
        if (shapeObj.angleRad === undefined) throw new Error('angleRad undefined');
        var lineWidth = shapeObj.lineWidth === undefined ? -1 : Math.round(shapeObj.lineWidth);
        var angleDeg = shapeObj.angleRad * 180 / Math.PI;
        // --- prep color ---
        if (!shapeObj.isEraser && shapeObj.fillRgb === undefined && shapeObj.strokeRgb === undefined) throw new Error('fillRgb and strokeRgb undefined');
        var colorRgb = shapeObj.isEraser ? {
            r: 255,
            g: 255,
            b: 255
        } : shapeObj.fillRgb ? shapeObj.fillRgb : shapeObj.strokeRgb;
        // --- prep canvas ---
        ctx.save();
        selectionPath && ctx.clip(selectionPath);
        if (shapeObj.opacity) ctx.globalAlpha = shapeObj.opacity;
        if (shapeObj.isEraser) ctx.globalCompositeOperation = 'destination-out';
        if (shapeObj.doLockAlpha) ctx.globalCompositeOperation = 'source-atop';
        var transformation = (0, $dZ59l.compose)((0, $1RMPr.rotate)(-shapeObj.angleRad));
        (_ctx = ctx).setTransform.apply(_ctx, (0, $bX4ja._)((0, $c9ab5bbe74e01c89$export$2b60e7dafdbde18a)(transformation)));
        if (shapeObj.fillRgb) ctx.fillStyle = (0, $eWjiX.BB).ColorConverter.toRgbStr(colorRgb);
        else if (shapeObj.strokeRgb) {
            ctx.strokeStyle = (0, $eWjiX.BB).ColorConverter.toRgbStr(colorRgb);
            ctx.lineWidth = lineWidth;
        }
        var x1 = shapeObj.x1;
        var y1 = shapeObj.y1;
        var x2 = shapeObj.x2;
        var y2 = shapeObj.y2;
        // --- angle snapping ---
        if (shapeObj.isAngleSnap) {
            var r1 = (0, $eWjiX.BB).rotate(x1, y1, shapeObj.angleRad / Math.PI * 180);
            var r2 = (0, $eWjiX.BB).rotate(x2, y2, shapeObj.angleRad / Math.PI * 180);
            var pAngleDeg = (0, $eWjiX.BB).pointsToAngleDeg(r1, r2) + 90;
            var pAngleDegSnapped = Math.round(pAngleDeg / 45) * 45;
            var rotated = (0, $eWjiX.BB).rotateAround({
                x: x1,
                y: y1
            }, {
                x: x2,
                y: y2
            }, pAngleDegSnapped - pAngleDeg);
            x2 = rotated.x;
            y2 = rotated.y;
            // needs to be perfect if p1->p2 aligns with canvas x- or y-axis
            if ((angleDeg + pAngleDegSnapped) % 90 === 0) {
                if (Math.round((angleDeg - pAngleDegSnapped) / 90) % 2 === 0) // up or down
                x2 = x1;
                else // left or right
                y2 = y1;
            }
        }
        var x = x1;
        var y = y1;
        var dX = x2 - x1;
        var dY = y2 - y1;
        // --- 1:1 ratio ---
        if (shapeObj.type !== 'line' && shapeObj.isFixedRatio) {
            var r11 = (0, $eWjiX.BB).rotate(shapeObj.x1, shapeObj.y1, shapeObj.angleRad / Math.PI * 180);
            var r21 = (0, $eWjiX.BB).rotate(shapeObj.x2, shapeObj.y2, shapeObj.angleRad / Math.PI * 180);
            var rx = r11.x;
            var ry = r11.y;
            var rdX = r21.x - r11.x;
            var rdY = r21.y - r11.y;
            if (Math.abs(rdX) < Math.abs(rdY)) rdY = Math.abs(rdX) * (rdY < 0 ? -1 : 1);
            else rdX = Math.abs(rdY) * (rdX < 0 ? -1 : 1);
            r21.x = rx + rdX;
            r21.y = ry + rdY;
            r11 = (0, $eWjiX.BB).rotate(r11.x, r11.y, -shapeObj.angleRad / Math.PI * 180);
            r21 = (0, $eWjiX.BB).rotate(r21.x, r21.y, -shapeObj.angleRad / Math.PI * 180);
            x1 = r11.x;
            y1 = r11.y;
            x2 = r21.x;
            y2 = r21.y;
            x = x1;
            y = y1;
            dX = x2 - x1;
            dY = y2 - y1;
        }
        // outwards modifier
        if (shapeObj.isOutwards) {
            x -= dX;
            y -= dY;
            dX *= 2;
            dY *= 2;
            x1 = x;
            y1 = y;
            x2 = x + dX;
            y2 = y + dY;
        }
        var p1;
        var p2;
        if (shapeObj.type === 'line') {
            // --- line ---
            // rounded
            var x1r = Math.round(x1);
            var y1r = Math.round(y1);
            var x2r = Math.round(x2);
            var y2r = Math.round(y2);
            // floored
            var x1f = Math.floor(x1);
            var y1f = Math.floor(y1);
            var x2f = Math.floor(x2);
            var y2f = Math.floor(y2);
            if (lineWidth % 2 === 0) {
                if (y1r === y2r) {
                    p1 = {
                        x: x1f,
                        y: y1r
                    };
                    p2 = {
                        x: x2f,
                        y: y2r
                    };
                    if (x1f < x2f) p2.x += 1;
                    else p1.x += 1;
                } else if (x1r === x2r) {
                    p1 = {
                        x: x1r,
                        y: y1f
                    };
                    p2 = {
                        x: x2r,
                        y: y2f
                    };
                    if (y1f < y2f) p2.y += 1;
                    else p1.y += 1;
                } else {
                    p1 = {
                        x: x1,
                        y: y1
                    };
                    p2 = {
                        x: x2,
                        y: y2
                    };
                }
            } else {
                p1 = {
                    x: x1f,
                    y: y1f
                };
                p2 = {
                    x: x2f,
                    y: y2f
                };
                if (y1f === y2f) {
                    if (x1f < x2f) p2.x += 1;
                    else p1.x += 1;
                    p1.y += 0.5;
                    p2.y += 0.5;
                } else if (x1f === x2f) {
                    if (y1f < y2f) p2.y += 1;
                    else p1.y += 1;
                    p1.x += 0.5;
                    p2.x += 0.5;
                } else {
                    p1.x = x1;
                    p1.y = y1;
                    p2.x = x2;
                    p2.y = y2;
                }
            }
            bounds = {
                type: 'coordinate',
                x1: Math.min(p1.x, p2.x) - lineWidth / 2,
                y1: Math.min(p1.y, p2.y) - lineWidth / 2,
                x2: Math.max(p1.x, p2.x) + lineWidth / 2,
                y2: Math.max(p1.y, p2.y) + lineWidth / 2
            };
            p1 = (0, $eWjiX.BB).rotate(p1.x, p1.y, shapeObj.angleRad / Math.PI * 180);
            p2 = (0, $eWjiX.BB).rotate(p2.x, p2.y, shapeObj.angleRad / Math.PI * 180);
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
        } else if (shapeObj.type === 'rect') {
            // --- rect ---
            // floored
            var x1f1 = Math.floor(x1);
            var y1f1 = Math.floor(y1);
            var x2f1 = Math.floor(x2);
            var y2f1 = Math.floor(y2);
            if (angleDeg % 90 === 0) {
                if (shapeObj.fillRgb) {
                    if (x1 % 1 === 0) x1 += 1;
                    if (y1 % 1 === 0) y1 += 1;
                    if (x2 % 1 === 0) x2 += 1;
                    if (y2 % 1 === 0) y2 += 1;
                    p1 = {
                        x: x1 < x2 ? x1f1 : x2f1,
                        y: y1 < y2 ? y1f1 : y2f1
                    };
                    p2 = {
                        x: Math.ceil((x1 < x2 ? x2 : x1) - p1.x),
                        y: Math.ceil((y1 < y2 ? y2 : y1) - p1.y)
                    };
                    p2.x = p1.x + p2.x;
                    p2.y = p1.y + p2.y;
                } else if (lineWidth % 2 === 0) {
                    p1 = {
                        x: x1f1,
                        y: y1f1
                    };
                    p2 = {
                        x: x2f1,
                        y: y2f1
                    };
                } else {
                    p1 = {
                        x: x1f1 + 0.5,
                        y: y1f1 + 0.5
                    };
                    p2 = {
                        x: x2f1 + 0.5,
                        y: y2f1 + 0.5
                    };
                }
            } else {
                p1 = {
                    x: x1,
                    y: y1
                };
                p2 = {
                    x: x2,
                    y: y2
                };
            }
            p1 = (0, $eWjiX.BB).rotate(p1.x, p1.y, shapeObj.angleRad / Math.PI * 180);
            p2 = (0, $eWjiX.BB).rotate(p2.x, p2.y, shapeObj.angleRad / Math.PI * 180);
            var rect = {
                x: p1.x,
                y: p1.y,
                width: p2.x - p1.x,
                height: p2.y - p1.y
            };
            var padding = shapeObj.fillRgb ? 0 : lineWidth / 2;
            bounds = (0, $b04075c332ce65cd$export$5dd60a54dd55622)({
                type: 'coordinate',
                x1: Math.min(p1.x, p2.x) - padding,
                y1: Math.min(p1.y, p2.y) - padding,
                x2: Math.max(p1.x, p2.x) + padding,
                y2: Math.max(p1.y, p2.y) + padding
            }, transformation);
            if (shapeObj.fillRgb) ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
            else ctx.strokeRect(rect.x, rect.y, rect.width, rect.height);
        } else {
            // --- circle ---
            p1 = (0, $eWjiX.BB).rotate(x1, y1, shapeObj.angleRad / Math.PI * 180);
            p2 = (0, $eWjiX.BB).rotate(x2, y2, shapeObj.angleRad / Math.PI * 180);
            x = p1.x;
            y = p1.y;
            dX = p2.x - p1.x;
            dY = p2.y - p1.y;
            var center = {
                x: x + dX / 2,
                y: y + dY / 2
            };
            var rX = Math.abs(dX / 2);
            var rY = Math.abs(dY / 2);
            ctx.beginPath();
            ctx.ellipse(center.x, center.y, rX, rY, 0, 0, Math.PI * 2);
            if (shapeObj.fillRgb) ctx.fill();
            else ctx.stroke();
            var padding1 = shapeObj.fillRgb ? 0 : lineWidth / 2;
            // bounds are bigger than they need to be when it's rotated and rX ~ rY. should be good enough though.
            bounds = (0, $b04075c332ce65cd$export$5dd60a54dd55622)({
                type: 'coordinate',
                x1: center.x - rX - padding1,
                y1: center.y - rY - padding1,
                x2: center.x + rX + padding1,
                y2: center.y + rY + padding1
            }, transformation);
        }
        ctx.restore();
    } else throw new Error('unknown shape');
    return (0, $eg83P.coordinateBoundsToIndexBounds)(bounds);
}



var $eWjiX = parcelRequire("eWjiX");
// accurately represents the bounds of the text, even it's fancy Zalgo text that tries to break layout
function $fdc12d72a3df9be9$var$textMetricToRect(metrics, align) {
    var ascent = metrics.actualBoundingBoxAscent;
    var descent = metrics.actualBoundingBoxDescent;
    var left = metrics.actualBoundingBoxLeft;
    var right = metrics.actualBoundingBoxRight;
    var width = right + left; // More accurate width calculation considering left/right bounds
    var height = ascent + descent;
    if (align === 'left') return {
        x: -left,
        y: -ascent,
        width: width,
        height: height
    };
    if (align === 'right') return {
        x: -width,
        y: -ascent,
        width: width,
        height: height
    };
    // center
    return {
        x: -left,
        y: -ascent,
        width: width,
        height: height
    };
}
function $fdc12d72a3df9be9$export$482c90f94eb9717c(canvas, p, selectionPath) {
    p = (0, $eWjiX.BB).copyObj(p);
    // setup context
    var ctx = (0, $eWjiX.BB).ctx(canvas);
    ctx.save();
    selectionPath && ctx.clip(selectionPath);
    ctx.textAlign = p.align;
    ctx.letterSpacing = p.letterSpacing ? p.letterSpacing + 'px' : '0';
    // font
    var fontArr = [
        p.size + 'px ' + (p.font ? p.font : 'sans-serif')
    ];
    if (p.isBold) fontArr.unshift('bold');
    if (p.isItalic) fontArr.unshift('italic');
    ctx.font = fontArr.join(' ');
    // fill
    ctx.fillStyle = p.fill ? (0, $eWjiX.BB).ColorConverter.toRgbaStr(p.fill.color) : 'transparent';
    // stroke
    ctx.strokeStyle = p.stroke ? (0, $eWjiX.BB).ColorConverter.toRgbaStr(p.stroke.color) : 'transparent';
    if (p.stroke) {
        ctx.lineWidth = p.stroke.lineWidth;
        ctx.lineJoin = 'round';
    }
    ctx.translate(p.x, p.y);
    ctx.rotate(-p.angleRad);
    var lines = p.text.split('\n').map(function(line) {
        return line.replaceAll('\t', '    ');
    });
    // bounds
    var bounds = {
        type: 'index',
        x1: 0,
        y1: 0,
        x2: 0,
        y2: 0
    };
    {
        var isFirst = true;
        lines.forEach(function(line, lineIndex) {
            var metrics = ctx.measureText(line);
            var x = 0;
            var _p_lineHeight;
            var y = p.size * ((_p_lineHeight = p.lineHeight) !== null && _p_lineHeight !== void 0 ? _p_lineHeight : 1) * lineIndex;
            var mRect = $fdc12d72a3df9be9$var$textMetricToRect(metrics, p.align);
            if (isFirst) {
                isFirst = false;
                bounds.x1 = x + mRect.x;
                bounds.y1 = y + mRect.y;
                bounds.x2 = x + mRect.x + mRect.width - 1;
                bounds.y2 = y + mRect.y + mRect.height - 1;
            } else {
                bounds.x1 = Math.min(bounds.x1, x + mRect.x);
                bounds.y1 = Math.min(bounds.y1, y + mRect.y);
                bounds.x2 = Math.max(bounds.x2, x + mRect.x + mRect.width - 1);
                bounds.y2 = Math.max(bounds.y2, y + mRect.y + mRect.height - 1);
            }
        });
    }
    // draw stroke
    lines.forEach(function(line, lineIndex) {
        var x = 0;
        var _p_lineHeight;
        var y = p.size * ((_p_lineHeight = p.lineHeight) !== null && _p_lineHeight !== void 0 ? _p_lineHeight : 1) * lineIndex;
        ctx.strokeText(line, x, y);
    });
    // draw fill
    lines.forEach(function(line, lineIndex) {
        var x = 0;
        var _p_lineHeight;
        var y = p.size * ((_p_lineHeight = p.lineHeight) !== null && _p_lineHeight !== void 0 ? _p_lineHeight : 1) * lineIndex;
        ctx.fillText(line, x, y);
    });
    ctx.restore();
    return {
        x: bounds.x1,
        y: bounds.y1,
        width: bounds.x2 - bounds.x1,
        height: bounds.y2 - bounds.y1
    };
}



var $esGm2 = parcelRequire("esGm2");

var $aSJRf = parcelRequire("aSJRf");


var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $eWjiX = parcelRequire("eWjiX");
var $5e45fa121ba5050f$export$74d12f09ff9f1956 = /*#__PURE__*/ function() {
    "use strict";
    function GradientTool(p) {
        (0, $cx0mh._)(this, GradientTool);
        this.downX = 0;
        this.downY = 0;
        this.downAngleRad = 0;
        this.onGradient = p.onGradient;
    }
    (0, $7h4XF._)(GradientTool, [
        {
            key: "onDown",
            value: function onDown(x, y, angleRad) {
                this.downX = x;
                this.downY = y;
                this.downAngleRad = angleRad;
            }
        },
        {
            key: "onMove",
            value: function onMove(x, y) {
                this.onGradient(false, this.downX, this.downY, x, y, this.downAngleRad);
            }
        },
        {
            key: "onUp",
            value: function onUp(x, y) {
                this.onGradient(true, this.downX, this.downY, x, y, this.downAngleRad);
            }
        }
    ]);
    return GradientTool;
}();
function $5e45fa121ba5050f$export$b1f70a113e3b5c1b(ctx, gradientObj, selectionPath) {
    ctx.save();
    selectionPath && ctx.clip(selectionPath);
    var x1 = gradientObj.x1;
    var y1 = gradientObj.y1;
    var x2 = gradientObj.x2;
    var y2 = gradientObj.y2;
    if (gradientObj.doSnap) {
        var angleDeg = gradientObj.angleRad * 180 / Math.PI;
        var r1 = (0, $eWjiX.BB).rotate(x1, y1, gradientObj.angleRad / Math.PI * 180);
        var r2 = (0, $eWjiX.BB).rotate(x2, y2, gradientObj.angleRad / Math.PI * 180);
        var pAngleDeg = (0, $eWjiX.BB).pointsToAngleDeg(r1, r2) + 90;
        var pAngleDegSnapped = Math.round(pAngleDeg / 45) * 45;
        var rotated = (0, $eWjiX.BB).rotateAround({
            x: x1,
            y: y1
        }, {
            x: x2,
            y: y2
        }, pAngleDegSnapped - pAngleDeg);
        x2 = rotated.x;
        y2 = rotated.y;
        // needs to be perfect if p1->p2 aligns with canvas x- or y-axis
        if ((angleDeg + pAngleDegSnapped) % 90 === 0) {
            if (Math.round((angleDeg - pAngleDegSnapped) / 90) % 2 === 0) // up or down
            x2 = x1;
            else // left or right
            y2 = y1;
        }
    }
    var baseColor = gradientObj.color1;
    if (gradientObj.isEraser && gradientObj.doLockAlpha) baseColor = {
        r: 255,
        g: 255,
        b: 255
    };
    var color1 = (0, $4EWN2._)((0, $cL71g._)({}, baseColor), {
        a: gradientObj.opacity
    });
    var color2 = (0, $4EWN2._)((0, $cL71g._)({}, baseColor), {
        a: 0
    });
    if (gradientObj.isReversed) {
        var temp = color1;
        color1 = color2;
        color2 = temp;
    }
    var gradient;
    if (gradientObj.type === 'linear') {
        gradient = ctx.createLinearGradient(x1, y1, x2, y2);
        gradient.addColorStop(0, (0, $eWjiX.BB).ColorConverter.toRgbaStr(color1));
        gradient.addColorStop(1, (0, $eWjiX.BB).ColorConverter.toRgbaStr(color2));
    } else if (gradientObj.type === 'linear-mirror') {
        var d = {
            x: x2 - x1,
            y: y2 - y1
        };
        gradient = ctx.createLinearGradient(x1 - d.x, y1 - d.y, x2, y2);
        gradient.addColorStop(0, (0, $eWjiX.BB).ColorConverter.toRgbaStr(color2));
        gradient.addColorStop(0.5, (0, $eWjiX.BB).ColorConverter.toRgbaStr(color1));
        gradient.addColorStop(1, (0, $eWjiX.BB).ColorConverter.toRgbaStr(color2));
    } else if (gradientObj.type === 'radial') {
        var r = (0, $eWjiX.BB).Vec2.dist({
            x: x1,
            y: y1
        }, {
            x: x2,
            y: y2
        });
        gradient = ctx.createRadialGradient(x1, y1, 0, x1, y1, r);
        gradient.addColorStop(0, (0, $eWjiX.BB).ColorConverter.toRgbaStr(color1));
        gradient.addColorStop(1, (0, $eWjiX.BB).ColorConverter.toRgbaStr(color2));
    }
    ctx.fillStyle = gradient;
    if (gradientObj.isEraser) ctx.globalCompositeOperation = 'destination-out';
    if (gradientObj.doLockAlpha) ctx.globalCompositeOperation = 'source-atop';
    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.restore();
}


parcelRequire("ciAU9");
var $dZ59l = parcelRequire("dZ59l");
var $83Kse = parcelRequire("83Kse");
var $1RMPr = parcelRequire("1RMPr");
var $kFecW = parcelRequire("kFecW");
var $kr2fR = parcelRequire("kr2fR");

var $9b3eo = parcelRequire("9b3eo");

var $bbA6w = parcelRequire("bbA6w");


var $eg83P = parcelRequire("eg83P");



var $gWfkn = parcelRequire("gWfkn");
var $47ad43347dcf2f3c$var$layerId = 0;
function $47ad43347dcf2f3c$export$b2ce7a8a096070e2() {
    return '' + $47ad43347dcf2f3c$var$layerId++;
}



var $gWfkn = parcelRequire("gWfkn");
function $d031f92b803c75e5$export$9a1731baa7701cc7(width, height, fill) {
    var result = [];
    var tilesX = Math.ceil(width / (0, $gWfkn.HISTORY_TILE_SIZE));
    var tilesY = Math.ceil(height / (0, $gWfkn.HISTORY_TILE_SIZE));
    for(var y = 0; y < tilesY; y++)for(var x = 0; x < tilesX; x++)result.push({
        fill: fill
    });
    return result;
}



var $8N5YG = parcelRequire("8N5YG");

var $gWfkn = parcelRequire("gWfkn");

var $eWjiX = parcelRequire("eWjiX");

var $7nLJW = parcelRequire("7nLJW");

var $esGm2 = parcelRequire("esGm2");
function $5d9e95126ab2b87f$export$cee5b735b1b9bad1(layers, before, after) {
    var sizeDidChange = before.size.width !== after.size.width || before.size.height !== after.size.height;
    return Object.entries(after.layerMap).map(function(param) {
        var _param = (0, $8N5YG._)(param, 2), id = _param[0], composedAfterLayer = _param[1];
        var canvas = {};
        var context = {};
        var composedBeforeLayer = before.layerMap[id];
        var tilesPerX = Math.ceil(after.size.width / (0, $gWfkn.HISTORY_TILE_SIZE));
        if (sizeDidChange || !composedBeforeLayer) {
            // create new canvas
            canvas = (0, $eWjiX.BB).canvas(after.size.width, after.size.height);
            context = (0, $eWjiX.BB).ctx(canvas);
            composedAfterLayer.tiles.forEach(function(item, index) {
                var x = index % tilesPerX;
                var y = Math.floor(index / tilesPerX);
                if ((0, $esGm2.isLayerFill)(item)) {
                    context.save();
                    context.fillStyle = item.fill;
                    context.fillRect(x * (0, $gWfkn.HISTORY_TILE_SIZE), y * (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE));
                    context.restore();
                } else context.putImageData(item.data, x * (0, $gWfkn.HISTORY_TILE_SIZE), y * (0, $gWfkn.HISTORY_TILE_SIZE));
            });
        } else {
            canvas = layers[composedBeforeLayer.index].canvas;
            context = layers[composedBeforeLayer.index].context;
            composedAfterLayer.tiles.forEach(function(item, index) {
                if (item === composedBeforeLayer.tiles[index]) // todo more advanced check ^
                return;
                var x = index % tilesPerX;
                var y = Math.floor(index / tilesPerX);
                if ((0, $esGm2.isLayerFill)(item)) {
                    context.save();
                    context.fillStyle = item.fill;
                    context.clearRect(x * (0, $gWfkn.HISTORY_TILE_SIZE), y * (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE));
                    context.fillRect(x * (0, $gWfkn.HISTORY_TILE_SIZE), y * (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE));
                    context.restore();
                } else context.putImageData(item.data, x * (0, $gWfkn.HISTORY_TILE_SIZE), y * (0, $gWfkn.HISTORY_TILE_SIZE));
            });
        }
        var result = {
            id: id,
            index: composedAfterLayer.index,
            name: composedAfterLayer.name,
            mixModeStr: composedAfterLayer.mixModeStr,
            isVisible: composedAfterLayer.isVisible,
            opacity: composedAfterLayer.opacity,
            canvas: canvas,
            context: context
        };
        // Restore animation frames if present
        if (composedAfterLayer.frameTiles && composedAfterLayer.frameTiles.length > 0) {
            var _loop = function(f) {
                var _existingLayer_frames;
                var frameTiles = composedAfterLayer.frameTiles[f];
                var existingLayer = composedBeforeLayer ? layers[composedBeforeLayer.index] : undefined;
                var existingFrame = existingLayer === null || existingLayer === void 0 ? void 0 : (_existingLayer_frames = existingLayer.frames) === null || _existingLayer_frames === void 0 ? void 0 : _existingLayer_frames[f + 1];
                var fc = void 0;
                var fctx = void 0;
                if (sizeDidChange || !composedBeforeLayer || !existingFrame) {
                    fc = (0, $eWjiX.BB).canvas(after.size.width, after.size.height);
                    fctx = (0, $eWjiX.BB).ctx(fc);
                    frameTiles.forEach(function(item, index) {
                        var x = index % tilesPerX;
                        var y = Math.floor(index / tilesPerX);
                        if ((0, $esGm2.isLayerFill)(item)) {
                            fctx.save();
                            fctx.fillStyle = item.fill;
                            fctx.fillRect(x * (0, $gWfkn.HISTORY_TILE_SIZE), y * (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE));
                            fctx.restore();
                        } else fctx.putImageData(item.data, x * (0, $gWfkn.HISTORY_TILE_SIZE), y * (0, $gWfkn.HISTORY_TILE_SIZE));
                    });
                } else {
                    var _composedBeforeLayer_frameTiles;
                    fc = existingFrame;
                    fctx = fc.getContext('2d');
                    var composedBeforeFrameTiles = (_composedBeforeLayer_frameTiles = composedBeforeLayer.frameTiles) === null || _composedBeforeLayer_frameTiles === void 0 ? void 0 : _composedBeforeLayer_frameTiles[f];
                    frameTiles.forEach(function(item, index) {
                        if (composedBeforeFrameTiles && item === composedBeforeFrameTiles[index]) return;
                        var x = index % tilesPerX;
                        var y = Math.floor(index / tilesPerX);
                        if ((0, $esGm2.isLayerFill)(item)) {
                            fctx.save();
                            fctx.fillStyle = item.fill;
                            fctx.clearRect(x * (0, $gWfkn.HISTORY_TILE_SIZE), y * (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE));
                            fctx.fillRect(x * (0, $gWfkn.HISTORY_TILE_SIZE), y * (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE));
                            fctx.restore();
                        } else fctx.putImageData(item.data, x * (0, $gWfkn.HISTORY_TILE_SIZE), y * (0, $gWfkn.HISTORY_TILE_SIZE));
                    });
                }
                frames.push(fc);
                frameContexts.push(fctx);
            };
            var frames = [
                canvas
            ];
            var frameContexts = [
                context
            ];
            for(var f = 0; f < composedAfterLayer.frameTiles.length; f++)_loop(f);
            result.frames = frames;
            result.frameContexts = frameContexts;
        }
        return result;
    }).sort((0, $7nLJW.sortLayerMap));
}


function $66a11a95db3a7e23$export$e173233eae155bba(entry, layerId) {
    var keys = Object.keys(entry);
    if (keys.length !== 1 || !entry.layerMap) return false;
    var ids = Object.keys(entry.layerMap);
    for(var i = 0; i < ids.length; i++){
        var id = ids[i];
        var layer = entry.layerMap[id];
        if (id === layerId) {
            var layerKeys = Object.keys(layer);
            if (layerKeys.length !== 1 || layerKeys[0] !== 'opacity') return false;
        } else {
            var layerKeys1 = Object.keys(layer);
            if (layerKeys1.length > 0) return false;
        }
    }
    return true;
}


function $ac5e0dd69c1dea2d$export$b706b44cfdbaaa7d(entry, layerId) {
    var keys = Object.keys(entry);
    if (keys.length !== 1 || !entry.layerMap) return false;
    var ids = Object.keys(entry.layerMap);
    for(var i = 0; i < ids.length; i++){
        var id = ids[i];
        var layer = entry.layerMap[id];
        if (id === layerId) {
            var layerKeys = Object.keys(layer);
            if (layerKeys.length !== 1 || layerKeys[0] !== 'isVisible') return false;
        } else {
            var layerKeys1 = Object.keys(layer);
            if (layerKeys1.length > 0) return false;
        }
    }
    return true;
}




var $gWfkn = parcelRequire("gWfkn");

var $eWjiX = parcelRequire("eWjiX");
function $9497dda3f00e23d9$export$6b742be78fc940fb(canvas, col, row, tileSize) {
    var ctx = (0, $eWjiX.BB).ctx(canvas);
    var width = Math.min(canvas.width, (col + 1) * tileSize) - col * tileSize;
    var height = Math.min(canvas.height, (row + 1) * tileSize) - row * tileSize;
    if (width <= 0 || height <= 0) throw new Error('invalid out-of-bounds tile');
    return ctx.getImageData(col * tileSize, row * tileSize, width, height);
}



var $gWfkn = parcelRequire("gWfkn");

var $eg83P = parcelRequire("eg83P");

var $7jh4K = parcelRequire("7jh4K");
function $3798530d3967d87a$export$2098fe43203ddd32(bounds, width, height) {
    var tileSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0, $gWfkn.HISTORY_TILE_SIZE);
    // ensure: 1 top left, 2 bottom right
    bounds = {
        type: 'index',
        x1: Math.min(bounds.x1, bounds.x2),
        y1: Math.min(bounds.y1, bounds.y2),
        x2: Math.max(bounds.x1, bounds.x2),
        y2: Math.max(bounds.y1, bounds.y2)
    };
    var boundsInCanvas = (0, $eg83P.indexBoundsInArea)(bounds, width, height);
    var tilesX = Math.ceil(width / tileSize);
    var tilesY = Math.ceil(height / tileSize);
    if (!boundsInCanvas) // no change if bounds don't overlap canvas
    return (0, $7jh4K.createArray)(tilesX * tilesY, false);
    var result = (0, $7jh4K.createArray)(tilesX * tilesY, false);
    var tileBounds = {
        x1: (0, $eg83P.clamp)(Math.floor(bounds.x1 / tileSize), 0, tilesX - 1),
        y1: (0, $eg83P.clamp)(Math.floor(bounds.y1 / tileSize), 0, tilesY - 1),
        x2: (0, $eg83P.clamp)(Math.floor(bounds.x2 / tileSize), 0, tilesX - 1),
        y2: (0, $eg83P.clamp)(Math.floor(bounds.y2 / tileSize), 0, tilesY - 1)
    };
    for(var i = tileBounds.x1; i <= tileBounds.x2; i++)for(var e = tileBounds.y1; e <= tileBounds.y2; e++)result[e * tilesX + i] = true;
    return result;
}
function $3798530d3967d87a$export$1774f90c6da5013c(oldChangedOrEmpty, newChanged) {
    return newChanged.map(function(newItem, index) {
        return newItem || !!oldChangedOrEmpty[index];
    });
}


var $871c020f286838cc$export$3d7bd55e322555b1 = function(imageData) {
    return new ImageData(new Uint8ClampedArray(imageData.data), imageData.width, imageData.height);
};



var $7jh4K = parcelRequire("7jh4K");
function $90d1e8bd87cfe19c$export$55941c74c8f934(data) {
    return {
        id: (0, $7jh4K.randomUuid)(),
        // timestamp: new Date().getTime(),
        data: data
    };
}
function $90d1e8bd87cfe19c$export$1a44c122b8668cb(tile) {
    return {
        id: (0, $7jh4K.randomUuid)(),
        // timestamp: new Date().getTime(),
        data: (0, $871c020f286838cc$export$3d7bd55e322555b1)(tile.data)
    };
}


function $1a6c9997bc8182ff$export$6706c882ea9c3dbd(canvas, changedTiles) {
    var result = [];
    var tilesX = Math.ceil(canvas.width / (0, $gWfkn.HISTORY_TILE_SIZE));
    var tilesY = Math.ceil(canvas.height / (0, $gWfkn.HISTORY_TILE_SIZE));
    for(var row = 0; row < tilesY; row++)for(var col = 0; col < tilesX; col++)result.push(changedTiles[row * tilesX + col] ? (0, $90d1e8bd87cfe19c$export$55941c74c8f934)((0, $9497dda3f00e23d9$export$6b742be78fc940fb)(canvas, col, row, (0, $gWfkn.HISTORY_TILE_SIZE))) : undefined);
    return result;
}
function $1a6c9997bc8182ff$export$7b1ba44282f9a519(canvas, bounds) {
    if (bounds) {
        var changedTiles = (0, $3798530d3967d87a$export$2098fe43203ddd32)(bounds, canvas.width, canvas.height);
        return $1a6c9997bc8182ff$export$6706c882ea9c3dbd(canvas, changedTiles);
    } else {
        // only do a single read back
        var ctx = canvas.getContext('2d');
        var fullImageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var tilesX = Math.ceil(canvas.width / (0, $gWfkn.HISTORY_TILE_SIZE));
        var tilesY = Math.ceil(canvas.height / (0, $gWfkn.HISTORY_TILE_SIZE));
        var result = [];
        // manually transfer into tiles
        for(var row = 0; row < tilesY; row++)for(var col = 0; col < tilesX; col++){
            var x = col * (0, $gWfkn.HISTORY_TILE_SIZE);
            var y = row * (0, $gWfkn.HISTORY_TILE_SIZE);
            var tileWidth = Math.min((0, $gWfkn.HISTORY_TILE_SIZE), canvas.width - x);
            var tileHeight = Math.min((0, $gWfkn.HISTORY_TILE_SIZE), canvas.height - y);
            var tileData = new ImageData(tileWidth, tileHeight);
            for(var line = 0; line < tileHeight; line++){
                var srcStart = ((y + line) * canvas.width + x) * 4;
                var destStart = line * tileWidth * 4;
                tileData.data.set(fullImageData.data.subarray(srcStart, srcStart + tileWidth * 4), destStart);
            }
            result.push((0, $90d1e8bd87cfe19c$export$55941c74c8f934)(tileData));
        }
        return result;
    }
}


// create individual THistoryEntryLayer
function $17f5ce4410029f54$var$createEntryLayer(layer, attributes, bounds, tiles) {
    var useAll = attributes === 'all';
    var result = {};
    if (useAll || attributes.includes('name')) result.name = layer.name;
    if (useAll || attributes.includes('opacity')) result.opacity = layer.opacity;
    if (useAll || attributes.includes('isVisible')) result.isVisible = layer.isVisible;
    if (useAll || attributes.includes('mixModeStr')) result.mixModeStr = layer.mixModeStr;
    if (useAll || attributes.includes('index')) result.index = layer.index;
    if (useAll || attributes.includes('tiles')) result.tiles = tiles !== null && tiles !== void 0 ? tiles : (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(layer.context.canvas, bounds);
    return result;
}
function $17f5ce4410029f54$export$7cefb04ac49374c4(layers) {
    for(var _len = arguments.length, items = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        items[_key - 1] = arguments[_key];
    }
    var _items_find;
    var generic = (_items_find = items.find(function(item) {
        return item && !('layerId' in item);
    })) !== null && _items_find !== void 0 ? _items_find : {
        attributes: []
    };
    var targets = items.filter(function(item) {
        return !!item;
    }).filter(function(item) {
        return 'layerId' in item;
    });
    return Object.fromEntries(layers.map(function(layer, index) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = targets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var target = _step.value;
                if (target.layerId === layer.id) return [
                    layer.id,
                    $17f5ce4410029f54$var$createEntryLayer(layer, target.attributes, target.bounds, target.tiles)
                ];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return [
            layer.id,
            $17f5ce4410029f54$var$createEntryLayer(layer, generic.attributes)
        ];
    }));
}



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $esGm2 = parcelRequire("esGm2");

var $eWjiX = parcelRequire("eWjiX");

var $gWfkn = parcelRequire("gWfkn");

var $7nLJW = parcelRequire("7nLJW");
var $ed54e2a153d1f006$export$a8c18874b9331404 = /*#__PURE__*/ function() {
    "use strict";
    function Eyedropper() {
        (0, $cx0mh._)(this, Eyedropper);
    }
    (0, $7h4XF._)(Eyedropper, [
        {
            // Reads from history (ImageData) to avoid reading from canvas.
            key: "getColorAt",
            value: function getColorAt(x, y, composed) {
                x = Math.floor(x);
                y = Math.floor(y);
                if (x < 0 || x >= composed.size.width || y < 0 || y >= composed.size.height) return new (0, $eWjiX.BB).RGB(0, 0, 0);
                var canvas = (0, $eWjiX.BB).canvas(1, 1);
                var ctx = (0, $eWjiX.BB).ctx(canvas);
                ctx.imageSmoothingEnabled = false;
                var tilesX = Math.ceil(composed.size.width / (0, $gWfkn.HISTORY_TILE_SIZE));
                var tileCol = Math.floor(x / (0, $gWfkn.HISTORY_TILE_SIZE));
                var tileRow = Math.floor(y / (0, $gWfkn.HISTORY_TILE_SIZE));
                var tileIndex = tileRow * tilesX + tileCol;
                Object.values(composed.layerMap).sort((0, $7nLJW.sortLayerMap)).forEach(function(layer) {
                    if (!layer.isVisible || layer.opacity === 0) return;
                    var tile = layer.tiles[tileIndex];
                    var fillStyle = '';
                    if ((0, $esGm2.isLayerFill)(tile)) fillStyle = tile.fill;
                    else {
                        var tileWidth = (0, $gWfkn.HISTORY_TILE_SIZE);
                        if (composed.size.width % (0, $gWfkn.HISTORY_TILE_SIZE) !== 0 && tileCol === tilesX - 1) tileWidth = composed.size.width % (0, $gWfkn.HISTORY_TILE_SIZE);
                        var pixelIndex = y % (0, $gWfkn.HISTORY_TILE_SIZE) * tileWidth + x % (0, $gWfkn.HISTORY_TILE_SIZE);
                        if (tile.data.data[pixelIndex * 4 + 3] === 0) return;
                        fillStyle = (0, $eWjiX.BB).ColorConverter.toRgbaStr({
                            r: tile.data.data[pixelIndex * 4],
                            g: tile.data.data[pixelIndex * 4 + 1],
                            b: tile.data.data[pixelIndex * 4 + 2],
                            a: tile.data.data[pixelIndex * 4 + 3] / 255
                        });
                    }
                    ctx.fillStyle = fillStyle;
                    ctx.globalAlpha = layer.opacity;
                    ctx.globalCompositeOperation = layer.mixModeStr;
                    ctx.fillRect(0, 0, 1, 1);
                });
                var imData = ctx.getImageData(0, 0, 1, 1);
                return new (0, $eWjiX.BB).RGB(imData.data[0], imData.data[1], imData.data[2]);
            }
        }
    ]);
    return Eyedropper;
}();




var $7jh4K = parcelRequire("7jh4K");
function $f2ea5f654adc2709$export$199acb5b15c43176(poly, x, y) {
    return poly.map(function(poly) {
        return poly.map(function(ring) {
            return ring.map(function(p) {
                return [
                    p[0] + x,
                    p[1] + y
                ];
            });
        });
    });
}



var $eWjiX = parcelRequire("eWjiX");

var $eIcQa = parcelRequire("eIcQa");
function $bdef137f4147ecbc$export$820c5732ce56544(selection, width, height) {
    var result = new Uint8Array(new ArrayBuffer(width * height));
    var canvas = (0, $eWjiX.BB).canvas(width, height);
    var ctx = (0, $eWjiX.BB).ctx(canvas);
    (0, $eIcQa.drawSelectionMask)(selection, ctx);
    var imageData = ctx.getImageData(0, 0, width, height);
    (0, $eWjiX.BB).freeCanvas(canvas);
    var len = width * height;
    for(var i = 0, e = 0; i < len; i++, e += 4)result[i] = imageData.data[e] >>> 7;
    return result;
}


var $0621fc8724f6bfac$export$9f4f73b1bd7c2f26 = 16;
var $0621fc8724f6bfac$var$KL_CANVAS_DEBUGGING = false;
var $0621fc8724f6bfac$export$4a819bde91671014 = /*#__PURE__*/ function() {
    "use strict";
    function KlCanvas(history) {
        var _this = this;
        var layerNrOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, $cx0mh._)(this, KlCanvas);
        this.layerNrOffset = layerNrOffset;
        this.isDestroyed = false;
        this.selection = undefined;
        this.klHistory = history;
        this.layers = [];
        if ($0621fc8724f6bfac$var$KL_CANVAS_DEBUGGING) window.getCanvasLayers = function() {
            return _this.layers;
        };
        this.eyedropper = new (0, $ed54e2a153d1f006$export$a8c18874b9331404)();
        this.width = 0;
        this.height = 0;
        this.updateViaComposed({
            projectId: {
                value: (0, $7jh4K.randomUuid)()
            },
            size: {
                width: 0,
                height: 0
            },
            activeLayerId: '',
            selection: {
                value: []
            },
            layerMap: {}
        }, this.klHistory.getComposed());
    }
    (0, $7h4XF._)(KlCanvas, [
        {
            key: "updateIndices",
            value: function updateIndices() {
                this.layers.forEach(function(item, index) {
                    item.index = index;
                });
            }
        },
        {
            /*
     * Resets canvas -> 1 layer, 100% opacity,
     * unless layers provided.
     * @param p
     */ key: "reset",
            value: function reset(p) {
                if (!p.width || !p.height || p.width < 1 || p.height < 1 || isNaN(p.width) || isNaN(p.height)) throw new Error('invalid canvas size');
                this.klHistory.pause(true);
                this.width = p.width;
                this.height = p.height;
                this.selection = undefined;
                this.layers.splice(1, Math.max(0, this.layers.length - 1));
                if (p.layers) for(var i = 0; i < p.layers.length; i++){
                    var pItem = p.layers[i];
                    if (!this.layers[i]) this.addLayer();
                    var layer = this.layers[i];
                    layer.id = pItem.id;
                    layer.name = pItem.name;
                    layer.isVisible = pItem.isVisible;
                    layer.mixModeStr = pItem.mixModeStr ? pItem.mixModeStr : 'source-over';
                    layer.canvas.width = this.width;
                    layer.canvas.height = this.height;
                    layer.context.drawImage(pItem.image, 0, 0);
                    this.setOpacity(i, pItem.opacity);
                }
                else {
                    var layer1 = this.layers[0];
                    layer1.name = p.layerName ? p.layerName : (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-layer') + ' 1';
                    layer1.isVisible = true;
                    layer1.canvas.width = this.width;
                    layer1.canvas.height = this.height;
                    layer1.mixModeStr = 'source-over';
                    this.setOpacity(0, 1);
                    if (p.color) this.layerFill(0, p.color);
                    else if (p.image) layer1.context.drawImage(p.image, 0, 0);
                }
                this.updateIndices();
                this.klHistory.pause(false);
                if (!this.klHistory.isPaused()) {
                    var _p_projectId;
                    var historyEntryData = {
                        projectId: {
                            value: (_p_projectId = p.projectId) !== null && _p_projectId !== void 0 ? _p_projectId : (0, $7jh4K.randomUuid)()
                        },
                        size: {
                            width: this.width,
                            height: this.height
                        },
                        selection: {
                            value: this.selection
                        },
                        activeLayerId: this.layers[this.layers.length - 1].id,
                        layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                            attributes: 'all'
                        })
                    };
                    this.klHistory.push(historyEntryData);
                }
                return this.layers.length - 1;
            }
        },
        {
            key: "isLayerLimitReached",
            value: function isLayerLimitReached() {
                return this.layers.length >= $0621fc8724f6bfac$export$9f4f73b1bd7c2f26;
            }
        },
        {
            key: "getWidth",
            value: function getWidth() {
                return this.width;
            }
        },
        {
            key: "getHeight",
            value: function getHeight() {
                return this.height;
            }
        },
        {
            /**
     * without resizing
     */ key: "setSize",
            value: function setSize(width, height) {
                this.width = width;
                this.height = height;
            }
        },
        {
            key: "getLayerCount",
            value: function getLayerCount() {
                return this.layers.length;
            }
        },
        {
            key: "resize",
            value: function resize(w, h) {
                var algorithm = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'smooth';
                if (!w || !h || w === this.width && h === this.height || isNaN(w) || isNaN(h) || w < 1 || h < 1) return false;
                w = Math.max(w, 1);
                h = Math.max(h, 1);
                var tmp1, tmp2;
                if (algorithm === 'pixelated') {
                    tmp1 = (0, $eWjiX.BB).canvas(w, h);
                    var tmp1Ctx = (0, $eWjiX.BB).ctx(tmp1);
                    tmp1Ctx.imageSmoothingEnabled = false;
                    for(var i = 0; i < this.layers.length; i++){
                        if (i > 0) tmp1Ctx.clearRect(0, 0, w, h);
                        var layer = this.layers[i];
                        tmp1Ctx.drawImage(layer.canvas, 0, 0, w, h);
                        layer.canvas.width = w;
                        layer.canvas.height = h;
                        layer.context.drawImage(tmp1, 0, 0);
                    }
                } else if (algorithm === 'smooth') {
                    tmp1 = (0, $eWjiX.BB).canvas();
                    tmp2 = (0, $eWjiX.BB).canvas();
                    for(var i1 = 0; i1 < this.layers.length; i1++)(0, $eWjiX.BB).resizeCanvas(this.layers[i1].canvas, w, h, tmp1, tmp2);
                } else throw new Error('unknown resize algorithm');
                if (this.selection) this.selection = (0, $bbA6w.transformMultiPolygon)(this.selection, (0, $kFecW.scale)(w / this.width, h / this.height));
                this.width = w;
                this.height = h;
                this.klHistory.push((0, $cL71g._)({
                    size: {
                        width: this.width,
                        height: this.height
                    },
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        attributes: [
                            'tiles'
                        ]
                    })
                }, this.selection ? {
                    selection: {
                        value: this.selection
                    }
                } : {}));
                return true;
            }
        },
        {
            /**
     * crop / extend
     */ key: "resizeCanvas",
            value: function resizeCanvas(p) {
                var newW = Math.round(p.left) + this.width + Math.round(p.right);
                var newH = Math.round(p.top) + this.height + Math.round(p.bottom);
                var offX = Math.round(p.left);
                var offY = Math.round(p.top);
                if (isNaN(newW) || isNaN(newH) || newW < 1 || newH < 1) throw new Error('KlCanvas.resizeCanvas - invalid canvas size');
                for(var i = 0; i < this.layers.length; i++){
                    var ctemp = (0, $eWjiX.BB).canvas(this.width, this.height);
                    var layer = this.layers[i];
                    (0, $eWjiX.BB).ctx(ctemp).drawImage(layer.canvas, 0, 0);
                    layer.canvas.width = newW;
                    layer.canvas.height = newH;
                    layer.context.save();
                    if (i === 0 && p.fillColor) {
                        layer.context.fillStyle = (0, $eWjiX.BB).ColorConverter.toRgbStr(p.fillColor);
                        layer.context.fillRect(0, 0, newW, newH);
                        layer.context.clearRect(offX, offY, this.width, this.height);
                    }
                    layer.context.drawImage(ctemp, offX, offY);
                    layer.context.restore();
                }
                this.width = newW;
                this.height = newH;
                if (this.selection) this.selection = (0, $f2ea5f654adc2709$export$199acb5b15c43176)(this.selection, offX, offY);
                this.klHistory.push((0, $cL71g._)({
                    size: {
                        width: this.width,
                        height: this.height
                    },
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        attributes: [
                            'tiles'
                        ]
                    })
                }, this.selection ? {
                    selection: {
                        value: this.selection
                    }
                } : {}));
            }
        },
        {
            /**
     * will be inserted above of selected
     */ key: "addLayer",
            value: function addLayer(selectedIndex, data) {
                if (this.isLayerLimitReached()) return false;
                var index = selectedIndex === undefined ? this.layers.length : selectedIndex + 1;
                var canvas = (0, $eWjiX.BB).canvas(this.width, this.height);
                var context = (0, $eWjiX.BB).ctx(canvas);
                if (data) {
                    if (typeof data.image === 'function') data.image(context);
                    else context.drawImage(data.image, 0, 0);
                }
                var layerId = (0, $47ad43347dcf2f3c$export$b2ce7a8a096070e2)();
                var _data_mixModeStr;
                var layer = {
                    id: layerId,
                    index: index,
                    name: data && data.name !== undefined ? data.name : (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-layer') + ' ' + (this.layers.length + this.layerNrOffset),
                    mixModeStr: data ? (_data_mixModeStr = data.mixModeStr) !== null && _data_mixModeStr !== void 0 ? _data_mixModeStr : 'source-over' : 'source-over',
                    isVisible: data ? data.isVisible : true,
                    opacity: data ? data.opacity : 1,
                    canvas: canvas,
                    context: context
                };
                this.layers.splice(index, 0, layer);
                this.klHistory.pause(true);
                this.setOpacity(index, 1);
                this.klHistory.pause(false);
                this.updateIndices();
                if (!this.klHistory.isPaused()) this.klHistory.push({
                    activeLayerId: layerId,
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        attributes: [
                            'index'
                        ]
                    }, {
                        layerId: layerId,
                        attributes: 'all',
                        tiles: data ? undefined : (0, $d031f92b803c75e5$export$9a1731baa7701cc7)(this.width, this.height, 'transparent')
                    })
                });
                return index;
            }
        },
        {
            key: "duplicateLayer",
            value: function duplicateLayer(srcIndex) {
                if (!this.layers[srcIndex] || this.isLayerLimitReached()) return false;
                var srcLayer = this.layers[srcIndex];
                var newIndex = srcIndex + 1;
                var composed = this.klHistory.getComposed();
                var srcComposed = composed.layerMap[srcLayer.id];
                var canvas = (0, $eWjiX.BB).canvas(this.width, this.height);
                var ctx = (0, $eWjiX.BB).ctx(canvas);
                var layerId = (0, $47ad43347dcf2f3c$export$b2ce7a8a096070e2)();
                var newLayer = {
                    id: layerId,
                    index: newIndex,
                    name: srcLayer.name + ' ' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-copy'),
                    mixModeStr: srcLayer.mixModeStr,
                    isVisible: srcLayer.isVisible,
                    opacity: srcLayer.opacity,
                    canvas: canvas,
                    context: ctx
                };
                this.layers.splice(newIndex, 0, newLayer);
                {
                    // draw into new layer from old
                    var tilesPerX = Math.ceil(this.width / (0, $gWfkn.HISTORY_TILE_SIZE));
                    srcComposed.tiles.forEach(function(tile, index) {
                        var x = index % tilesPerX;
                        var y = Math.floor(index / tilesPerX);
                        ctx.save();
                        if ((0, $esGm2.isLayerFill)(tile)) {
                            ctx.fillStyle = tile.fill;
                            ctx.fillRect(x * (0, $gWfkn.HISTORY_TILE_SIZE), y * (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE));
                        } else ctx.putImageData(tile.data, x * (0, $gWfkn.HISTORY_TILE_SIZE), y * (0, $gWfkn.HISTORY_TILE_SIZE));
                        ctx.restore();
                    });
                }
                this.updateIndices();
                if (!this.klHistory.isPaused()) this.klHistory.push({
                    activeLayerId: layerId,
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        attributes: [
                            'index'
                        ]
                    }, {
                        layerId: layerId,
                        attributes: 'all',
                        tiles: srcComposed.tiles.map(function(tile) {
                            if ((0, $esGm2.isLayerFill)(tile)) return (0, $cL71g._)({}, tile);
                            return (0, $90d1e8bd87cfe19c$export$1a44c122b8668cb)(tile);
                        })
                    })
                });
                return srcIndex + 1;
            }
        },
        {
            key: "getLayerContext",
            value: function getLayerContext(index, doReturnNull) {
                if (this.layers[index]) return this.layers[index].context;
                if (doReturnNull) return null;
                throw new Error('layer of index ' + index + ' not found (in ' + this.layers.length + ' layers)');
            }
        },
        {
            key: "removeLayer",
            value: function removeLayer(index) {
                var toDeleteLayer = this.layers[index];
                if (!toDeleteLayer) return false;
                (0, $eWjiX.BB).freeCanvas(toDeleteLayer.canvas);
                this.layers.splice(index, 1);
                this.updateIndices();
                var activeLayerIndex = Math.max(0, index - 1);
                var activeLayerId = this.layers[activeLayerIndex].id;
                if (!this.klHistory.isPaused()) this.klHistory.push({
                    activeLayerId: activeLayerId,
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        attributes: [
                            'index'
                        ]
                    })
                });
                return activeLayerIndex;
            }
        },
        {
            key: "renameLayer",
            value: function renameLayer(index, name) {
                var targetLayer = this.layers[index];
                if (targetLayer) targetLayer.name = name;
                else return false;
                if (!this.klHistory.isPaused()) this.klHistory.push({
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        layerId: targetLayer.id,
                        attributes: [
                            'name'
                        ]
                    })
                });
                return true;
            }
        },
        {
            key: "setOpacity",
            value: function setOpacity(layerIndex, opacity) {
                if (!this.layers[layerIndex]) return;
                opacity = Math.max(0, Math.min(1, opacity));
                this.layers[layerIndex].opacity = opacity;
                if (!this.klHistory.isPaused()) {
                    var layerId = this.layers[layerIndex].id;
                    var topEntry = this.klHistory.getEntries().at(-1).data;
                    var replaceTop = (0, $66a11a95db3a7e23$export$e173233eae155bba)(topEntry, layerId);
                    this.klHistory.push({
                        layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                            layerId: layerId,
                            attributes: [
                                'opacity'
                            ]
                        })
                    }, replaceTop);
                }
            }
        },
        {
            key: "setLayerIsVisible",
            value: function setLayerIsVisible(layerIndex, isVisible) {
                if (this.layers[layerIndex]) this.layers[layerIndex].isVisible = isVisible;
                else throw new Error(`layer ${layerIndex} undefined`);
                if (!this.klHistory.isPaused()) {
                    var layerId = this.layers[layerIndex].id;
                    var topEntry = this.klHistory.getEntries().at(-1).data;
                    var replaceTop = (0, $ac5e0dd69c1dea2d$export$b706b44cfdbaaa7d)(topEntry, layerId);
                    this.klHistory.push({
                        layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                            layerId: layerId,
                            attributes: [
                                'isVisible'
                            ]
                        })
                    }, replaceTop);
                }
            }
        },
        {
            key: "moveLayer",
            value: function moveLayer(index, delta) {
                if (delta === 0) return;
                if (!this.layers[index]) return;
                var temp = this.layers[index];
                this.layers.splice(index, 1);
                var targetIndex = Math.max(0, Math.min(index + delta, this.layers.length));
                this.layers.splice(targetIndex, 0, temp);
                this.updateIndices();
                if (!this.klHistory.isPaused()) this.klHistory.push({
                    activeLayerId: this.layers[targetIndex].id,
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        attributes: [
                            'index'
                        ]
                    })
                });
                return targetIndex;
            }
        },
        {
            key: "mergeLayers",
            value: function mergeLayers(layerBottomIndex, layerTopIndex, mixModeStr) {
                if (!this.layers[layerBottomIndex] || !this.layers[layerTopIndex] || layerBottomIndex === layerTopIndex) return;
                //order messed up
                if (layerBottomIndex > layerTopIndex) {
                    var temp = layerBottomIndex;
                    layerBottomIndex = layerTopIndex;
                    layerTopIndex = temp;
                }
                var topLayer = this.layers[layerTopIndex];
                var bottomLayer = this.layers[layerBottomIndex];
                if (mixModeStr === undefined) mixModeStr = topLayer.mixModeStr;
                var topOpacity = this.layers[layerTopIndex].opacity;
                var mergedPixelData = topLayer.opacity > 0;
                if (mergedPixelData) {
                    var bottomCtx = bottomLayer.context;
                    bottomCtx.save();
                    if (mixModeStr === 'as-alpha') {
                        // todo remove this?
                        (0, $eWjiX.BB).convertToAlphaChannelCanvas(topLayer.canvas);
                        bottomCtx.globalCompositeOperation = 'destination-in';
                        bottomCtx.globalAlpha = topOpacity;
                        bottomCtx.drawImage(topLayer.canvas, 0, 0);
                    } else {
                        if (mixModeStr) bottomCtx.globalCompositeOperation = mixModeStr;
                        bottomCtx.globalAlpha = topOpacity;
                        bottomCtx.drawImage(topLayer.canvas, 0, 0);
                    }
                    bottomCtx.restore();
                }
                this.klHistory.pause(true);
                this.removeLayer(layerTopIndex);
                this.klHistory.pause(false);
                if (!this.klHistory.isPaused()) this.klHistory.push({
                    activeLayerId: bottomLayer.id,
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        attributes: [
                            'index'
                        ]
                    }, mergedPixelData ? {
                        layerId: bottomLayer.id,
                        attributes: 'all'
                    } : undefined)
                });
                return layerBottomIndex;
            }
        },
        {
            key: "mergeAll",
            value: function mergeAll() {
                if (this.layers.length === 1) return false;
                // draw all on bottom layer
                var bottomLayer = this.layers[0];
                bottomLayer.name = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-layer') + ' 1';
                var bottomCtx = bottomLayer.context;
                for(var i = 1; i < this.layers.length; i++){
                    var layer = this.layers[i];
                    if (!layer.isVisible || layer.opacity === 0) continue;
                    bottomCtx.save();
                    bottomCtx.globalCompositeOperation = layer.mixModeStr;
                    bottomCtx.globalAlpha = layer.opacity;
                    bottomCtx.drawImage(layer.canvas, 0, 0);
                    bottomCtx.restore();
                }
                this.klHistory.pause(true);
                // remove upper layers
                for(var i1 = this.layers.length - 1; i1 > 0; i1--)this.removeLayer(i1);
                this.klHistory.pause(false);
                if (!this.klHistory.isPaused()) {
                    var activeLayerId = bottomLayer.id;
                    this.klHistory.push({
                        activeLayerId: activeLayerId,
                        layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                            attributes: [
                                'tiles'
                            ]
                        })
                    });
                }
                return 0;
            }
        },
        {
            // rotates the canvas with all layers. either by 90, 180, or 270 degrees
            key: "rotate",
            value: function rotate1(deg) {
                while(deg < 0)deg += 360;
                deg %= 360;
                if (deg !== 90 && deg !== 180 && deg !== 270) return;
                var temp = (0, $eWjiX.BB).canvas();
                if (deg === 180) {
                    temp.width = this.width;
                    temp.height = this.height;
                } else if (deg === 90 || deg === 270) {
                    temp.width = this.height;
                    temp.height = this.width;
                }
                var matrix = (0, $83Kse.identity)();
                if (deg === 90) matrix = (0, $dZ59l.compose)((0, $kr2fR.translate)(this.height, 0), (0, $1RMPr.rotate)(Math.PI / 2));
                else if (deg === 180) matrix = (0, $dZ59l.compose)((0, $kr2fR.translate)(this.width, this.height), (0, $1RMPr.rotate)(Math.PI));
                else if (deg === 270) matrix = (0, $dZ59l.compose)((0, $kr2fR.translate)(0, this.width), (0, $1RMPr.rotate)(3 * Math.PI / 2));
                var ctx = (0, $eWjiX.BB).ctx(temp);
                for(var i = 0; i < this.layers.length; i++){
                    var _ctx;
                    ctx.clearRect(0, 0, temp.width, temp.height);
                    ctx.save();
                    (_ctx = ctx).setTransform.apply(_ctx, (0, $bX4ja._)((0, $c9ab5bbe74e01c89$export$2b60e7dafdbde18a)(matrix)));
                    ctx.drawImage(this.layers[i].canvas, 0, 0);
                    ctx.restore();
                    this.layers[i].canvas.width = temp.width;
                    this.layers[i].canvas.height = temp.height;
                    this.layers[i].context.drawImage(temp, 0, 0);
                }
                this.width = temp.width;
                this.height = temp.height;
                if (this.selection) this.selection = (0, $bbA6w.transformMultiPolygon)(this.selection, matrix);
                this.klHistory.push((0, $cL71g._)({
                    size: {
                        width: this.width,
                        height: this.height
                    },
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        attributes: [
                            'tiles'
                        ]
                    })
                }, this.selection ? {
                    selection: {
                        value: this.selection
                    }
                } : {}));
            }
        },
        {
            key: "flip",
            value: function flip(isHorizontal, isVertical, layerIndex) {
                if (!isHorizontal && !isVertical) return;
                var temp = (0, $eWjiX.BB).canvas(this.width, this.height);
                temp.width = this.width;
                temp.height = this.height;
                var tempCtx = (0, $eWjiX.BB).ctx(temp);
                var matrix = (0, $dZ59l.compose)((0, $kr2fR.translate)(temp.width / 2, temp.height / 2), (0, $kFecW.scale)(isHorizontal ? -1 : 1, isVertical ? -1 : 1), (0, $kr2fR.translate)(-temp.width / 2, -temp.height / 2));
                for(var i = 0; i < this.layers.length; i++){
                    var _tempCtx;
                    if ((layerIndex || layerIndex === 0) && i !== layerIndex) continue;
                    tempCtx.save();
                    tempCtx.clearRect(0, 0, temp.width, temp.height);
                    (_tempCtx = tempCtx).setTransform.apply(_tempCtx, (0, $bX4ja._)((0, $c9ab5bbe74e01c89$export$2b60e7dafdbde18a)(matrix)));
                    tempCtx.drawImage(this.layers[i].canvas, 0, 0);
                    tempCtx.restore();
                    this.layers[i].context.clearRect(0, 0, this.layers[i].canvas.width, this.layers[i].canvas.height);
                    this.layers[i].context.drawImage(temp, 0, 0);
                }
                if (this.selection) this.selection = (0, $bbA6w.transformMultiPolygon)(this.selection, matrix);
                var targetLayer = layerIndex === undefined ? undefined : this.layers[layerIndex];
                this.klHistory.push((0, $cL71g._)({
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, targetLayer ? {
                        layerId: targetLayer.id,
                        attributes: [
                            'tiles'
                        ]
                    } : {
                        attributes: [
                            'tiles'
                        ]
                    })
                }, this.selection ? {
                    selection: {
                        value: this.selection
                    }
                } : {}));
            }
        },
        {
            // arbitrary drawing operation & focus layer
            key: "drawOperation",
            value: function drawOperation(layerIndex, operation) {
                var targetLayer = this.layers[layerIndex];
                var ctx = targetLayer.context;
                operation(ctx);
                if (!this.klHistory.isPaused()) this.klHistory.push({
                    activeLayerId: targetLayer.id,
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        layerId: targetLayer.id,
                        attributes: [
                            'tiles'
                        ]
                    })
                });
            }
        },
        {
            key: "layerFill",
            value: function layerFill(layerIndex, colorObj, compositeOperation, doClipSelection) {
                var ctx = this.layers[layerIndex].context;
                ctx.save();
                var isUniformFill = !(doClipSelection && this.selection) && compositeOperation === undefined;
                if (compositeOperation) ctx.globalCompositeOperation = compositeOperation;
                var bounds;
                if (doClipSelection && this.selection) {
                    var selectionPath = (0, $9b3eo.getSelectionPath2d)(this.selection);
                    ctx.clip(selectionPath);
                    bounds = (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(this.selection, 'index');
                }
                var fill = 'rgba(' + colorObj.r + ',' + colorObj.g + ',' + colorObj.b + ',1)';
                ctx.fillStyle = fill;
                ctx.fillRect(0, 0, this.layers[layerIndex].canvas.width, this.layers[layerIndex].canvas.height);
                ctx.restore();
                // workaround for chrome bug https://bugs.chromium.org/p/chromium/issues/detail?id=1281185
                // TODO remove if chrome updated
                ctx.save();
                ctx.fillStyle = 'rgba(0,0,0,0.01)';
                ctx.fillRect(-0.9999999, -0.9999999, 1, 1);
                ctx.restore();
                /*if (!document.getElementById('testocanvas')) {
            layerCanvasArr[layerIndex].id = 'testocanvas';
            document.body.append(layerCanvasArr[layerIndex]);
            BB.css(layerCanvasArr[layerIndex], {
                position: 'fixed',
                left: '0',
                top: '0',
                zIndex: '1111111',
                transform: 'scale(0.2)',
                border: '10px solid red',
            });
        }
        if (!document.getElementById('testocanvas')) {
            let c = document.createElement('canvas');
            c.width = 1000;
            c.height = 1000;
            let ctx2 = c.getContext('2d');
            ctx2.drawImage(layerCanvasArr[layerIndex], 0, 0);
            c.id = 'testocanvas';
            document.body.append(c);
            BB.css(c, {
                position: 'fixed',
                left: '0',
                top: '0',
                zIndex: '1111111',
                transform: 'scale(0.2)',
                border: '10px solid red',
            });
        }*/ if (!this.klHistory.isPaused()) {
                    var targetLayer = this.layers[layerIndex];
                    this.klHistory.push({
                        layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                            layerId: targetLayer.id,
                            attributes: [
                                'tiles'
                            ],
                            tiles: isUniformFill ? (0, $d031f92b803c75e5$export$9a1731baa7701cc7)(this.width, this.height, fill) : undefined,
                            bounds: bounds
                        })
                    });
                }
            }
        },
        {
            key: "floodFill",
            value: function floodFill(layerIndex, x, y, rgb, opacity, tolerance, sampleStr, grow, isContiguous) {
                if (x < 0 || y < 0 || x >= this.width || y >= this.height || opacity === 0) return;
                tolerance = Math.round(tolerance);
                x = Math.round(x);
                y = Math.round(y);
                if (![
                    'above',
                    'current',
                    'all'
                ].includes(sampleStr)) throw new Error('invalid sampleStr');
                var selectionMask = this.selection ? (0, $bdef137f4147ecbc$export$820c5732ce56544)(this.selection, this.width, this.height) : undefined;
                if (selectionMask && selectionMask[y * this.width + x] === 0) // don't fill if outside of selection
                return;
                var targetLayer = this.layers[layerIndex];
                var result;
                var targetCtx;
                var targetImageData;
                if (sampleStr === 'all') {
                    var srcCanvas = this.layers.length === 1 ? this.layers[0].canvas : this.getCompleteCanvas(1);
                    var srcCtx = (0, $eWjiX.BB).ctx(srcCanvas);
                    var srcImageData = srcCtx.getImageData(0, 0, this.width, this.height);
                    var srcData = srcImageData.data;
                    result = (0, $7069db2f5e23d00f$export$13d50f258a8034f)(srcData, selectionMask, this.width, this.height, x, y, tolerance, Math.round(grow), isContiguous);
                    targetCtx = targetLayer.context;
                    targetImageData = targetCtx.getImageData(0, 0, this.width, this.height);
                } else {
                    var srcIndex = sampleStr === 'above' ? layerIndex + 1 : layerIndex;
                    if (srcIndex >= this.layers.length) return;
                    var srcCtx1 = this.layers[srcIndex].context;
                    var srcImageData1 = srcCtx1.getImageData(0, 0, this.width, this.height);
                    var srcData1 = srcImageData1.data;
                    result = (0, $7069db2f5e23d00f$export$13d50f258a8034f)(srcData1, selectionMask, this.width, this.height, x, y, tolerance, Math.round(grow), isContiguous);
                    targetCtx = layerIndex === srcIndex ? srcCtx1 : targetLayer.context;
                    targetImageData = layerIndex === srcIndex ? srcImageData1 : targetCtx.getImageData(0, 0, this.width, this.height);
                }
                var targetData = targetImageData.data;
                if (rgb) {
                    if (opacity === 1) {
                        for(var i = 0; i < this.width * this.height; i++)if (result.data[i] === 255) {
                            targetData[i * 4] = rgb.r;
                            targetData[i * 4 + 1] = rgb.g;
                            targetData[i * 4 + 2] = rgb.b;
                            targetData[i * 4 + 3] = 255;
                        }
                    } else {
                        for(var i1 = 0; i1 < this.width * this.height; i1++)if (result.data[i1] === 255) {
                            targetData[i1 * 4] = (0, $eWjiX.BB).mix(targetData[i1 * 4], rgb.r, opacity);
                            targetData[i1 * 4 + 1] = (0, $eWjiX.BB).mix(targetData[i1 * 4 + 1], rgb.g, opacity);
                            targetData[i1 * 4 + 2] = (0, $eWjiX.BB).mix(targetData[i1 * 4 + 2], rgb.b, opacity);
                            targetData[i1 * 4 + 3] = (0, $eWjiX.BB).mix(targetData[i1 * 4 + 3], 255, opacity);
                        }
                    }
                } else // erase
                if (opacity === 1) {
                    for(var i2 = 0; i2 < this.width * this.height; i2++)if (result.data[i2] === 255) targetData[i2 * 4 + 3] = 0;
                } else {
                    for(var i3 = 0; i3 < this.width * this.height; i3++)if (result.data[i3] === 255) targetData[i3 * 4 + 3] = (0, $eWjiX.BB).mix(targetData[i3 * 4 + 3], 0, opacity);
                }
                targetCtx.putImageData(targetImageData, 0, 0);
                // const ctx = this.layers[layerIndex].context;
                // ctx.save();
                // ctx.fillStyle = 'rgba(255,0,0,0.2)';
                // ctx.fillRect(
                //     result.bounds.x1,
                //     result.bounds.y1,
                //     result.bounds.x2 - result.bounds.x1,
                //     result.bounds.y2 - result.bounds.y1,
                // );
                // ctx.restore();
                if (!this.klHistory.isPaused()) this.klHistory.push({
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        layerId: targetLayer.id,
                        attributes: [
                            'tiles'
                        ],
                        bounds: result.bounds
                    })
                });
            }
        },
        {
            /**
     * draw geometric shape (circle, line, rect)
     * @param layerIndex
     * @param shapeObj
     */ key: "drawShape",
            value: function drawShape1(layerIndex, shapeObj) {
                if (shapeObj.x1 === shapeObj.x2 && shapeObj.y1 === shapeObj.y2) return;
                var targetLayer = this.layers[layerIndex];
                var selectionPath = this.selection ? new Path2D((0, $9b3eo.getSelectionPath2d)(this.selection)) : undefined;
                var bounds = (0, $01d7180c5d1d0fdf$export$71b514a25c47df50)(targetLayer.context, shapeObj, selectionPath);
                // debug
                /*const ctx = this.layers[layerIndex].context;
        ctx.save();
        ctx.fillStyle = 'rgba(255,0,0,0.2)';
        ctx.fillRect(bounds.x1, bounds.y1, bounds.x2 - bounds.x1, bounds.y2 - bounds.y1);
        ctx.restore();*/ if (!this.klHistory.isPaused()) this.klHistory.push({
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        layerId: targetLayer.id,
                        attributes: [
                            'tiles'
                        ],
                        bounds: bounds
                    })
                });
            }
        },
        {
            key: "drawGradient",
            value: function drawGradient1(layerIndex, gradientObj) {
                var targetLayer = this.layers[layerIndex];
                var selectionPath = this.selection ? new Path2D((0, $9b3eo.getSelectionPath2d)(this.selection)) : undefined;
                (0, $5e45fa121ba5050f$export$b1f70a113e3b5c1b)(targetLayer.context, gradientObj, selectionPath);
                if (!this.klHistory.isPaused()) this.klHistory.push({
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        layerId: targetLayer.id,
                        attributes: [
                            'tiles'
                        ]
                    })
                });
            }
        },
        {
            key: "text",
            value: function text(layerIndex, p) {
                var targetLayer = this.layers[layerIndex];
                var rect = (0, $fdc12d72a3df9be9$export$482c90f94eb9717c)(targetLayer.canvas, (0, $eWjiX.BB).copyObj(p), this.selection ? new Path2D((0, $9b3eo.getSelectionPath2d)(this.selection)) : undefined);
                // add 2, because rect not entirely accurate
                var padding = 2 + (p.stroke ? p.stroke.lineWidth / 2 : 0);
                var changedBounds = (0, $b04075c332ce65cd$export$5dd60a54dd55622)((0, $eg83P.rectToBounds)(rect, 'coordinate'), (0, $dZ59l.compose)((0, $kr2fR.translate)(p.x, p.y), (0, $1RMPr.rotate)(-p.angleRad)));
                changedBounds.x1 -= padding;
                changedBounds.y1 -= padding;
                changedBounds.x2 += padding;
                changedBounds.y2 += padding;
                // const ctx = this.layers[layerIndex].context;
                // ctx.save();
                // ctx.fillStyle = 'rgba(255,0,0,0.2)';
                // ctx.fillRect(bounds.x1, bounds.y1, bounds.x2 - bounds.x1, bounds.y2 - bounds.y1);
                // ctx.restore();
                if (!this.klHistory.isPaused()) this.klHistory.push({
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        layerId: targetLayer.id,
                        attributes: [
                            'tiles'
                        ],
                        bounds: (0, $eg83P.coordinateBoundsToIndexBounds)(changedBounds)
                    })
                });
            }
        },
        {
            key: "eraseLayer",
            value: function eraseLayer(p) {
                var targetLayer = this.layers[p.layerIndex];
                var ctx = targetLayer.context;
                ctx.save();
                var bounds;
                if (p.useSelection && this.selection) {
                    var selectionPath = (0, $9b3eo.getSelectionPath2d)(this.selection);
                    ctx.clip(selectionPath);
                    bounds = (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(this.selection, 'index');
                }
                if (p.useAlphaLock) ctx.globalCompositeOperation = 'source-atop';
                else ctx.globalCompositeOperation = 'destination-out';
                ctx.fillStyle = (0, $eWjiX.BB).ColorConverter.toRgbStr((0, $00f785a5ea9e210d$export$8627e24041b28589)());
                ctx.fillRect(0, 0, this.width, this.height);
                ctx.restore();
                var isUniformFill = !p.useAlphaLock && !(p.useSelection && this.selection);
                if (!this.klHistory.isPaused()) this.klHistory.push({
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        layerId: targetLayer.id,
                        attributes: [
                            'tiles'
                        ],
                        tiles: isUniformFill ? (0, $d031f92b803c75e5$export$9a1731baa7701cc7)(this.width, this.height, 'transparent') : undefined,
                        bounds: bounds
                    })
                });
            }
        },
        {
            key: "getKlHistory",
            value: function getKlHistory() {
                return this.klHistory;
            }
        },
        {
            key: "getLayersRaw",
            value: function getLayersRaw() {
                return this.layers;
            }
        },
        {
            key: "getLayers",
            value: function getLayers() {
                return this.layers.map(function(layer) {
                    return {
                        id: layer.id,
                        canvas: layer.canvas,
                        context: layer.context,
                        isVisible: layer.isVisible,
                        opacity: layer.opacity,
                        name: layer.name,
                        mixModeStr: layer.mixModeStr
                    };
                });
            }
        },
        {
            key: "getLayersFast",
            value: function getLayersFast() {
                return this.layers.map(function(item) {
                    return (0, $cL71g._)({
                        canvas: item.canvas,
                        isVisible: item.isVisible,
                        opacity: item.opacity,
                        name: item.name,
                        mixModeStr: item.mixModeStr
                    }, item.compositeObj ? {
                        compositeObj: item.compositeObj
                    } : {}, item.frames ? {
                        frames: item.frames,
                        frameContexts: item.frameContexts
                    } : {});
                });
            }
        },
        {
            key: "initLayerFrames",
            value: function initLayerFrames(layerIndex, frameCount) {
                var layer = this.layers[layerIndex];
                if (layer.frames && layer.frames.length === frameCount) return; // already initialized with same frame count
                var frames = [
                    layer.canvas
                ];
                var frameContexts = [
                    layer.context
                ];
                for(var i = 1; i < frameCount; i++){
                    var c = (0, $eWjiX.BB).canvas(this.width, this.height);
                    var ctx = (0, $eWjiX.BB).ctx(c);
                    ctx.drawImage(layer.canvas, 0, 0);
                    frames.push(c);
                    frameContexts.push(ctx);
                }
                layer.frames = frames;
                layer.frameContexts = frameContexts;
            }
        },
        {
            key: "clearLayerFrames",
            value: function clearLayerFrames(layerIndex) {
                var layer = this.layers[layerIndex];
                if (!layer.frames) return;
                // Free extra canvases (skip frames[0] which is the main canvas)
                for(var i = 1; i < layer.frames.length; i++)(0, $eWjiX.BB).freeCanvas(layer.frames[i]);
                layer.frames = undefined;
                layer.frameContexts = undefined;
            }
        },
        {
            key: "getLayerIndex",
            value: function getLayerIndex(canvasObj, doReturnNull) {
                for(var i = 0; i < this.layers.length; i++){
                    if (this.layers[i].canvas === canvasObj) return i;
                }
                if (!doReturnNull) throw new Error('layer not found (in ' + this.layers.length + ' layers)');
                return null;
            }
        },
        {
            key: "getLayerOld",
            value: function getLayerOld(index, doReturnNull) {
                if (this.layers[index]) return {
                    context: this.layers[index].context,
                    isVisible: this.layers[index].isVisible,
                    opacity: this.layers[index].opacity,
                    name: this.layers[index].name,
                    id: index
                };
                if (!doReturnNull) throw new Error('layer of index ' + index + ' not found (in ' + this.layers.length + ' layers)');
                return null;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(index) {
                return this.layers[index];
            }
        },
        {
            key: "getColorAt",
            value: function getColorAt(x, y) {
                var result;
                try {
                    result = this.eyedropper.getColorAt(x, y, this.klHistory.getComposed());
                } catch (_) {
                // history probably messed up. but the app should stay operational
                }
                return result;
            }
        },
        {
            key: "getCompleteCanvas",
            value: function getCompleteCanvas(factor, maskSelection) {
                return (0, $aSJRf.drawProject)(this.getProject(), factor, maskSelection ? this.selection : undefined);
            }
        },
        {
            key: "getProject",
            value: function getProject() {
                return {
                    projectId: this.klHistory.getComposed().projectId.value,
                    width: this.width,
                    height: this.height,
                    layers: this.layers.map(function(layer) {
                        return {
                            name: layer.name,
                            isVisible: layer.isVisible,
                            opacity: layer.opacity,
                            mixModeStr: layer.mixModeStr,
                            image: layer.canvas
                        };
                    })
                };
            }
        },
        {
            key: "setMixMode",
            value: function setMixMode(layerIndex, mixModeStr) {
                var targetLayer = this.layers[layerIndex];
                targetLayer.mixModeStr = mixModeStr;
                if (!this.klHistory.isPaused()) this.klHistory.push({
                    layerMap: (0, $17f5ce4410029f54$export$7cefb04ac49374c4)(this.layers, {
                        layerId: targetLayer.id,
                        attributes: [
                            'mixModeStr'
                        ]
                    })
                });
            }
        },
        {
            /**
     * Set composite drawing step for KlCanvasWorkspace.
     * To apply temporary manipulations to a layer.
     *
     * @param layerIndex
     * @param compositeObj
     */ key: "setComposite",
            value: function setComposite(layerIndex, compositeObj) {
                if (!this.layers[layerIndex]) throw new Error('invalid layer');
                this.layers[layerIndex].compositeObj = compositeObj;
            }
        },
        {
            key: "setSelection",
            value: function setSelection(selection) {
                if (!this.selection && !selection) return;
                this.selection = selection;
                this.klHistory.push({
                    selection: {
                        value: selection
                    }
                });
            }
        },
        {
            key: "getSelection",
            value: function getSelection() {
                return this.selection;
            }
        },
        {
            /**
     * called after undo/redo, to apply the changes to the klCanvas.
     * before - before undo/redo was called - equivalent to current state of klCanvas.
     * after - after undo/redo was called.
     */ key: "updateViaComposed",
            value: function updateViaComposed(before, after) {
                this.width = after.size.width;
                this.height = after.size.height;
                this.selection = after.selection.value;
                this.layers = (0, $5d9e95126ab2b87f$export$cee5b735b1b9bad1)(this.layers, before, after);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                if (this.isDestroyed) return;
                this.layers.forEach(function(layer) {
                    (0, $eWjiX.BB).freeCanvas(layer.canvas);
                    layer.canvas = {};
                    layer.context = {};
                });
                this.layers = [];
                this.isDestroyed = true;
            }
        }
    ]);
    return KlCanvas;
}();




function $2f1281ced73ab1dc$export$6e1bedb2a6cdff30(blendMode) {
    if (!blendMode) return (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-blend-normal');
    var codes = {
        'source-over': 'layers-blend-normal',
        darken: 'layers-blend-darken',
        multiply: 'layers-blend-multiply',
        'color-burn': 'layers-blend-color-burn',
        lighten: 'layers-blend-lighten',
        screen: 'layers-blend-screen',
        'color-dodge': 'layers-blend-color-dodge',
        overlay: 'layers-blend-overlay',
        'soft-light': 'layers-blend-soft-light',
        'hard-light': 'layers-blend-hard-light',
        difference: 'layers-blend-difference',
        exclusion: 'layers-blend-exclusion',
        hue: 'layers-blend-hue',
        saturation: 'layers-blend-saturation',
        color: 'layers-blend-color',
        luminosity: 'layers-blend-luminosity'
    };
    if (!(blendMode in codes)) throw new Error('unknown blend mode');
    return (0, $8d7403abedf7cefa$export$ce37e184d908d785)(codes[blendMode]);
}



var $eWjiX = parcelRequire("eWjiX");



function $ac876b2e34c8d94f$export$28debfc111084e87(parentEl, currentName, callback) {
    var div = (0, $eWjiX.BB).el();
    var label = (0, $eWjiX.BB).el({
        content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename-name') + ':',
        css: {
            marginRight: '5px'
        }
    });
    var row = (0, $eWjiX.BB).el({
        css: {
            display: 'flex'
        }
    });
    var input = (0, $eWjiX.BB).el({
        tagName: 'input'
    });
    input.value = currentName;
    input.setAttribute('data-ignore-focus', 'true');
    input.style.flexGrow = '1';
    var clearBtn = (0, $eWjiX.BB).el({
        tagName: 'button',
        content: '<img src="' + (0, (/*@__PURE__*/$parcel$interopDefault($720ba2c010612610$exports))) + '" height="20"/>',
        title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename-clear'),
        css: {
            marginLeft: '10px'
        },
        onClick: function() {
            input.value = '';
            input.focus();
        }
    });
    var suggestions = [
        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename-sketch'),
        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename-colors'),
        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename-shading'),
        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename-lines'),
        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename-effects'),
        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('background'),
        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename-foreground')
    ];
    var suggestionBtns = [];
    var row2 = (0, $eWjiX.BB).el({
        css: {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '5px',
            marginLeft: '-5px'
        }
    });
    suggestions.forEach(function(item) {
        var btn = (0, $eWjiX.BB).el({
            parent: row2,
            tagName: 'button',
            content: item,
            onClick: function() {
                input.value = '' + btn.textContent;
            },
            css: {
                margin: '5px 0 0 5px'
            }
        });
        suggestionBtns.push(btn);
    });
    div.append(label);
    label.append(row, row2);
    row.append(input, clearBtn);
    setTimeout(function() {
        input.focus();
        input.select();
    }, 10);
    (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename-title')}</b>`,
        div: div,
        buttons: [
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename'),
            'Cancel'
        ],
        primaries: [
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename')
        ],
        callback: function(val) {
            (0, $eWjiX.BB).destroyEl(clearBtn);
            suggestionBtns.forEach(function(item) {
                (0, $eWjiX.BB).destroyEl(item);
            });
            suggestionBtns.splice(0, suggestionBtns.length);
            if (val === (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename')) callback(input.value);
            else callback(undefined);
        },
        clickOnEnter: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename')
    });
}



var $eWjiX = parcelRequire("eWjiX");




function $9eb64c51bad4097c$export$ee79aceabae6bb8a(parentEl, p) {
    var div = (0, $eWjiX.BB).el();
    div.innerHTML = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-merge-description');
    var options = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
        optionArr: [
            {
                id: p.mixModeStr,
                label: (0, $2f1281ced73ab1dc$export$6e1bedb2a6cdff30)(p.mixModeStr)
            },
            {
                id: 'source-in',
                label: 'source-in'
            },
            {
                id: 'source-out',
                label: 'source-out'
            },
            {
                id: 'source-atop',
                label: 'source-atop'
            },
            {
                id: 'destination-in',
                label: 'destination-in'
            },
            {
                id: 'destination-out',
                label: 'destination-out'
            },
            {
                id: 'destination-atop',
                label: 'destination-atop'
            },
            {
                id: 'xor',
                label: 'xor'
            }
        ],
        initId: p.mixModeStr,
        onChange: function() {
            update();
        },
        isSmall: true,
        css: {
            marginTop: '5px'
        }
    });
    div.append(options.getElement());
    var thumbDimensions = (0, $eWjiX.BB).fitInto(p.topCanvas.width, p.topCanvas.height, 200, 200, 1);
    var preview = (0, $eWjiX.BB).canvas(thumbDimensions.width, thumbDimensions.height);
    preview.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('preview');
    preview.className = 'kl-merge-preview';
    var spacer = (0, $eWjiX.BB).el({
        content: '<br/>',
        css: {
            clear: 'both'
        }
    });
    div.append(spacer, preview);
    var alphaCanvas = (0, $eWjiX.BB).copyCanvas(preview);
    (0, $eWjiX.BB).ctx(alphaCanvas).drawImage(p.topCanvas, 0, 0, alphaCanvas.width, alphaCanvas.height);
    (0, $eWjiX.BB).convertToAlphaChannelCanvas(alphaCanvas);
    var update = function() {
        var ctx = (0, $eWjiX.BB).ctx(preview);
        ctx.save();
        ctx.clearRect(0, 0, preview.width, preview.height);
        if (preview.width > p.topCanvas.width) ctx.imageSmoothingEnabled = false;
        ctx.drawImage(p.bottomCanvas, 0, 0, preview.width, preview.height);
        if (options.getValue() === 'as-alpha') {
            ctx.globalCompositeOperation = 'destination-in';
            ctx.globalAlpha = p.topOpacity;
            ctx.drawImage(alphaCanvas, 0, 0, preview.width, preview.height);
        } else {
            ctx.globalCompositeOperation = options.getValue();
            ctx.globalAlpha = p.topOpacity;
            ctx.drawImage(p.topCanvas, 0, 0, preview.width, preview.height);
        }
        ctx.restore();
    };
    update();
    var keyListener = new (0, $eWjiX.BB).KeyListener({
        onDown: function(keyStr) {
            if (keyStr === 'right') options.next();
            if (keyStr === 'left') options.previous();
        }
    });
    (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-merge-modal-title')}</b>`,
        div: div,
        buttons: [
            'Ok',
            'Cancel'
        ],
        clickOnEnter: 'Ok',
        callback: function(val) {
            keyListener.destroy();
            options.destroy();
            if (val === 'Ok') p.callback(options.getValue());
        }
    });
}



var $7jh4K = parcelRequire("7jh4K");

var $6J2My = parcelRequire("6J2My");


var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");


var $72Jv0 = parcelRequire("72Jv0");
var $f65760a075b19ea7$export$e44a253a59704894 = /*#__PURE__*/ function() {
    "use strict";
    function DropdownMenu(p) {
        var _this = this;
        (0, $cx0mh._)(this, DropdownMenu);
        this.isExpanded = false;
        this.onSetEnabled = function() {
            return 0;
        };
        var button = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('button,w-full,h-full', [
            p.button
        ]);
        button.onclick = function() {
            toggle(!_this.isExpanded);
        };
        if (p.buttonTitle) button.title = p.buttonTitle;
        (0, $72Jv0.makeUnfocusable)(button);
        var items = [];
        var itemMap = {};
        p.items.forEach(function(item) {
            var itemButton = (0, $72Jv0.el)({
                tagName: 'button',
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                    gap: '10px'
                }
            });
            itemButton.append((0, $72Jv0.el)({
                content: item[1]
            }));
            if (item[2]) itemButton.append((0, $72Jv0.el)({
                content: item[2],
                css: {
                    fontSize: '0.8em',
                    opacity: '0.8'
                }
            }));
            (0, $72Jv0.makeUnfocusable)(itemButton);
            itemButton.onclick = function() {
                toggle(false);
                p.onItemClick(item[0]);
            };
            items.push(itemButton);
            itemMap[item[0]] = itemButton;
        });
        this.onSetEnabled = function(id, enabled) {
            itemMap[id].disabled = !enabled;
        };
        var menu = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('.kl-dropdown-menu,right-0,top-full,nowrap,hidden', items);
        this.rootElement = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',pos-relative', [
            button,
            menu
        ]);
        var toggle = function(force) {
            _this.isExpanded = force;
            menu.style.display = _this.isExpanded ? '' : 'none';
            if (_this.isExpanded) {
                document.addEventListener('pointerdown', onPointerDown, {
                    passive: false
                });
                window.addEventListener('blur', onBlur);
            } else {
                document.removeEventListener('pointerdown', onPointerDown);
                window.removeEventListener('blur', onBlur);
            }
        };
        var onPointerDown = function(e) {
            var target = e.target;
            if (button.contains(target) || menu.contains(target)) return;
            toggle(false);
        };
        var onBlur = function() {
            return toggle(false);
        };
    }
    (0, $7h4XF._)(DropdownMenu, [
        {
            key: "getElement",
            value: function getElement() {
                return this.rootElement;
            }
        },
        {
            key: "setEnabled",
            value: function setEnabled(id, enabled) {
                this.onSetEnabled(id, enabled);
            }
        }
    ]);
    return DropdownMenu;
}();


var $46a8fca82ef6ceef$exports = {};
$46a8fca82ef6ceef$exports = $parcel$resolve("1mb1v");


var $ff6378202995f780$exports = {};
$ff6378202995f780$exports = $parcel$resolve("11KJK");


var $61b1afb588560014$exports = {};
$61b1afb588560014$exports = $parcel$resolve("floUo");



var $1d893fdc8bec1e3c$exports = {};
$1d893fdc8bec1e3c$exports = $parcel$resolve("hhQeq");


var $6fd1f44a6252da08$exports = {};
$6fd1f44a6252da08$exports = $parcel$resolve("dz3mY");



var $72Jv0 = parcelRequire("72Jv0");
var $615843517fb18518$var$paddingLeft = 25;
var $615843517fb18518$export$c3bf51e04f391d6d = /*#__PURE__*/ function() {
    "use strict";
    function LayersUi(p) {
        var _this = this;
        (0, $cx0mh._)(this, LayersUi);
        this.lastpos = 0;
        this.layerHeight = 35;
        this.layerSpacing = 0;
        this.klCanvas = p.klCanvas;
        this.onSelect = p.onSelect;
        this.parentEl = p.parentEl;
        this.uiState = p.uiState;
        this.applyUncommitted = p.applyUncommitted;
        this.klHistory = p.klHistory;
        this.onUpdateProject = p.onUpdateProject;
        this.onClearLayer = p.onClearLayer;
        this.layerElArr = [];
        this.layerHeight = 35;
        this.layerSpacing = 0;
        var width = 270;
        this.largeThumbDiv = (0, $eWjiX.BB).el({
            onClick: (0, $eWjiX.BB).handleClick,
            css: {
                position: 'absolute',
                top: '500px',
                boxShadow: '1px 1px 3px rgba(0,0,0,0.3)',
                pointerEvents: 'none',
                padding: '0',
                border: '1px solid #aaa',
                transition: 'opacity 0.3s ease-out',
                userSelect: 'none',
                background: 'var(--kl-checkerboard-background)'
            }
        });
        this.setUiState(this.uiState);
        this.largeThumbCanvas = (0, $eWjiX.BB).canvas(200, 200);
        this.largeThumbCanvas.style.display = 'block';
        this.largeThumbDiv.append(this.largeThumbCanvas);
        this.largeThumbInDocument = false;
        this.klCanvasLayerArr = this.klCanvas.getLayers();
        this.selectedSpotIndex = this.klCanvasLayerArr.length - 1;
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                marginRight: '10px',
                marginBottom: '10px',
                marginLeft: '10px',
                marginTop: '10px',
                cursor: 'default',
                position: 'relative',
                zIndex: '0'
            }
        });
        var listDiv = (0, $eWjiX.BB).el({
            css: {
                width: width + 'px',
                position: 'relative',
                margin: '0 -10px',
                zIndex: '0'
            }
        });
        this.layerListEl = (0, $eWjiX.BB).el({
            parent: listDiv
        });
        this.addBtn = (0, $eWjiX.BB).el({
            tagName: 'button'
        });
        this.duplicateBtn = (0, $eWjiX.BB).el({
            tagName: 'button'
        });
        this.mergeBtn = (0, $eWjiX.BB).el({
            tagName: 'button'
        });
        this.removeBtn = (0, $eWjiX.BB).el({
            tagName: 'button'
        });
        var renameBtn = (0, $eWjiX.BB).el({
            tagName: 'button'
        });
        this.moreDropdown = new (0, $f65760a075b19ea7$export$e44a253a59704894)({
            button: (0, $eWjiX.BB).el({
                content: `<img src="${(0, (/*@__PURE__*/$parcel$interopDefault($6fd1f44a6252da08$exports)))}" width="13"/>`,
                css: {
                    display: 'flex',
                    justifyContent: 'center',
                    opacity: '0.9'
                }
            }),
            buttonTitle: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('more'),
            items: [
                [
                    'clear-layer',
                    (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-clear'),
                    "\u232B"
                ],
                [
                    'advanced-merge',
                    (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-merge-advanced'),
                    'Ctrl + Shift + E'
                ],
                [
                    'merge-all',
                    (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-merge-all')
                ]
            ],
            onItemClick: function(id) {
                if (id === 'clear-layer') {
                    _this.applyUncommitted();
                    _this.onClearLayer();
                }
                if (id === 'advanced-merge') _this.advancedMergeDialog();
                if (id === 'merge-all') {
                    _this.applyUncommitted();
                    var newIndex = _this.klCanvas.mergeAll();
                    if (newIndex === false) return;
                    _this.klCanvasLayerArr = _this.klCanvas.getLayers();
                    _this.selectedSpotIndex = newIndex;
                    //this.createLayerList();
                    _this.onSelect(_this.selectedSpotIndex, false);
                    _this.updateButtons();
                }
            }
        });
        this.updateButtons();
        var createButtons = function() {
            var div = (0, $eWjiX.BB).el();
            var async = function() {
                (0, $72Jv0.makeUnfocusable)(_this.addBtn);
                (0, $72Jv0.makeUnfocusable)(_this.duplicateBtn);
                (0, $72Jv0.makeUnfocusable)(_this.mergeBtn);
                (0, $72Jv0.makeUnfocusable)(_this.removeBtn);
                (0, $72Jv0.makeUnfocusable)(renameBtn);
                var commonStyle = {
                    cssFloat: 'left',
                    paddingLeft: '5px',
                    paddingRight: '3px'
                };
                (0, $7jh4K.css)(_this.addBtn, commonStyle);
                (0, $7jh4K.css)(_this.duplicateBtn, commonStyle);
                (0, $7jh4K.css)(_this.mergeBtn, commonStyle);
                (0, $7jh4K.css)(_this.removeBtn, commonStyle);
                (0, $7jh4K.css)(renameBtn, {
                    cssFloat: 'left',
                    height: '30px',
                    lineHeight: '20px'
                });
                _this.addBtn.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-new');
                _this.duplicateBtn.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-duplicate');
                _this.removeBtn.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-remove');
                _this.mergeBtn.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-merge');
                renameBtn.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-rename-title');
                _this.addBtn.innerHTML = "<img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($46a8fca82ef6ceef$exports))) + "' height='20'/>";
                _this.duplicateBtn.innerHTML = "<img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($ff6378202995f780$exports))) + "' height='20'/>";
                _this.mergeBtn.innerHTML = "<img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($61b1afb588560014$exports))) + "' height='20'/>";
                _this.removeBtn.innerHTML = "<img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($720ba2c010612610$exports))) + "' height='20'/>";
                renameBtn.innerHTML = "<img src='" + (0, (/*@__PURE__*/$parcel$interopDefault($1d893fdc8bec1e3c$exports))) + "' height='20'/>";
                div.append((0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',flex,gap-5,mb-10', [
                    _this.addBtn,
                    _this.removeBtn,
                    _this.duplicateBtn,
                    _this.mergeBtn,
                    renameBtn,
                    (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',grow-1'),
                    _this.moreDropdown.getElement()
                ]));
                _this.addBtn.onclick = function() {
                    _this.applyUncommitted();
                    if (_this.klCanvas.addLayer(_this.selectedSpotIndex) === false) return;
                    _this.klCanvasLayerArr = _this.klCanvas.getLayers();
                    _this.selectedSpotIndex = _this.selectedSpotIndex + 1;
                    //this.createLayerList();
                    _this.onSelect(_this.selectedSpotIndex, false);
                    _this.updateButtons();
                };
                _this.duplicateBtn.onclick = function() {
                    _this.applyUncommitted();
                    if (_this.klCanvas.duplicateLayer(_this.selectedSpotIndex) === false) return;
                    _this.klCanvasLayerArr = _this.klCanvas.getLayers();
                    _this.selectedSpotIndex++;
                    //this.createLayerList();
                    _this.onSelect(_this.selectedSpotIndex, false);
                    _this.updateButtons();
                };
                _this.removeBtn.onclick = function() {
                    _this.applyUncommitted();
                    if (_this.layerElArr.length <= 1) return;
                    _this.klCanvas.removeLayer(_this.selectedSpotIndex);
                    if (_this.selectedSpotIndex > 0) _this.selectedSpotIndex--;
                    _this.klCanvasLayerArr = _this.klCanvas.getLayers();
                    //this.createLayerList();
                    _this.onSelect(_this.selectedSpotIndex, false);
                    _this.updateButtons();
                };
                _this.mergeBtn.onclick = function() {
                    // fast merge
                    _this.applyUncommitted();
                    if (_this.selectedSpotIndex <= 0) return;
                    _this.klCanvas.mergeLayers(_this.selectedSpotIndex, _this.selectedSpotIndex - 1);
                    _this.klCanvasLayerArr = _this.klCanvas.getLayers();
                    _this.selectedSpotIndex--;
                    _this.onSelect(_this.selectedSpotIndex, false);
                    _this.updateButtons();
                };
                renameBtn.onclick = function() {
                    _this.applyUncommitted();
                    _this.renameLayer(_this.selectedSpotIndex);
                };
            };
            setTimeout(async, 1);
            return div;
        };
        this.rootEl.append(createButtons());
        var modeWrapper;
        modeWrapper = (0, $eWjiX.BB).el({
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-blending') + '&nbsp;',
            css: {
                fontSize: '15px'
            }
        });
        this.modeSelect = new (0, $7a3263857aacf58f$export$ef9b1a59e592288f)({
            optionArr: [
                'source-over',
                undefined,
                'darken',
                'multiply',
                'color-burn',
                undefined,
                'lighten',
                'screen',
                'color-dodge',
                undefined,
                'overlay',
                'soft-light',
                'hard-light',
                undefined,
                'difference',
                'exclusion',
                undefined,
                'hue',
                'saturation',
                'color',
                'luminosity'
            ].map(function(item) {
                return item ? [
                    item,
                    (0, $2f1281ced73ab1dc$export$6e1bedb2a6cdff30)(item)
                ] : undefined;
            }),
            onChange: function(val) {
                _this.klCanvas.setMixMode(_this.selectedSpotIndex, val);
                _this.update(_this.selectedSpotIndex);
            },
            css: {
                marginBottom: '10px'
            },
            name: 'layer-blend-mode'
        });
        modeWrapper.append(this.modeSelect.getElement());
        this.rootEl.append(modeWrapper);
        this.rootEl.append(listDiv);
        this.klHistory.addListener(function() {
            if (_this.rootEl.style.display !== 'block') return;
            _this.createLayerList();
        });
        this.createLayerList();
    }
    (0, $7h4XF._)(LayersUi, [
        {
            key: "move",
            value: function move(oldSpotIndex, newSpotIndex) {
                var _this = this;
                if (isNaN(oldSpotIndex) || isNaN(newSpotIndex)) throw 'layers-ui - invalid move';
                for(var i = 0; i < this.klCanvasLayerArr.length; i++)(function(i) {
                    var posy = _this.layerElArr[i].spot; // <- here
                    if (_this.layerElArr[i].spot === oldSpotIndex) posy = newSpotIndex;
                    else {
                        if (_this.layerElArr[i].spot > oldSpotIndex) posy--;
                        if (posy >= newSpotIndex) posy++;
                    }
                    _this.layerElArr[i].spot = posy;
                    _this.layerElArr[i].posY = (_this.layerHeight + _this.layerSpacing) * (_this.klCanvasLayerArr.length - posy - 1);
                    _this.layerElArr[i].style.top = _this.layerElArr[i].posY + 'px';
                })(i);
                if (oldSpotIndex === newSpotIndex) return;
                this.applyUncommitted();
                this.klCanvas.moveLayer(this.selectedSpotIndex, newSpotIndex - oldSpotIndex);
                this.klCanvasLayerArr = this.klCanvas.getLayers();
                this.selectedSpotIndex = newSpotIndex;
                this.mergeBtn.disabled = this.selectedSpotIndex === 0;
            }
        },
        {
            key: "posToSpot",
            value: function posToSpot(p) {
                var result = parseInt('' + (p / (this.layerHeight + this.layerSpacing) + 0.5));
                result = Math.min(this.klCanvasLayerArr.length - 1, Math.max(0, result));
                result = this.klCanvasLayerArr.length - result - 1;
                return result;
            }
        },
        {
            key: "updateLayersVerticalPosition",
            value: /**
     * update css position of all layers that are not being dragged, while dragging
     */ function updateLayersVerticalPosition(id, newspot) {
                newspot = Math.min(this.klCanvasLayerArr.length - 1, Math.max(0, newspot));
                if (newspot === this.lastpos) return;
                for(var i = 0; i < this.klCanvasLayerArr.length; i++){
                    if (this.layerElArr[i].spot === id) continue;
                    var posy = this.layerElArr[i].spot;
                    if (this.layerElArr[i].spot > id) posy--;
                    if (posy >= newspot) posy++;
                    this.layerElArr[i].posY = (this.layerHeight + this.layerSpacing) * (this.klCanvasLayerArr.length - posy - 1);
                    this.layerElArr[i].style.top = this.layerElArr[i].posY + 'px';
                }
                this.lastpos = newspot;
            }
        },
        {
            key: "renameLayer",
            value: function renameLayer(layerSpot) {
                var _this = this;
                (0, $ac876b2e34c8d94f$export$28debfc111084e87)(this.parentEl, this.klCanvas.getLayerOld(layerSpot).name, function(newName) {
                    if (newName === undefined || newName === _this.klCanvas.getLayerOld(layerSpot).name) return;
                    _this.klCanvas.renameLayer(layerSpot, newName);
                    //this.createLayerList();
                    _this.onSelect(layerSpot, false);
                });
            }
        },
        {
            key: "updateHeight",
            value: function updateHeight() {
                this.layerListEl.style.height = this.layerElArr.length * 35 + 'px';
            }
        },
        {
            key: "createLayerList",
            value: function createLayerList(force) {
                var _this = this;
                if (this.klHistory.getChangeCount() === this.oldHistoryState && !force) return;
                this.oldHistoryState = this.klHistory.getChangeCount();
                this.klCanvasLayerArr = this.klCanvas.getLayers();
                var createLayerEntry = function(index) {
                    var klLayer = (0, $7jh4K.throwIfNull)(_this.klCanvas.getLayerOld(index));
                    var layerName = klLayer.name;
                    var opacity = _this.klCanvasLayerArr[index].opacity;
                    var isVisible = klLayer.isVisible;
                    var layercanvas = _this.klCanvasLayerArr[index].context.canvas;
                    var layer = (0, $eWjiX.BB).el({
                        className: 'kl-layer'
                    });
                    _this.layerElArr[index] = layer;
                    layer.posY = (_this.klCanvasLayerArr.length - 1) * 35 - index * 35;
                    (0, $7jh4K.css)(layer, {
                        top: layer.posY + 'px'
                    });
                    var innerLayer = (0, $eWjiX.BB).el();
                    (0, $7jh4K.css)(innerLayer, {
                        position: 'relative'
                    });
                    var container1 = (0, $eWjiX.BB).el();
                    (0, $7jh4K.css)(container1, {
                        width: '270px',
                        height: '34px'
                    });
                    var container2 = (0, $eWjiX.BB).el();
                    layer.append(innerLayer);
                    innerLayer.append(container1, container2);
                    layer.spot = index;
                    //checkbox - visibility
                    {
                        var checkWrapper = (0, $eWjiX.BB).el({
                            tagName: 'label',
                            parent: container1,
                            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-visibility-toggle'),
                            css: {
                                display: 'flex',
                                width: '25px',
                                height: '100%',
                                justifyContent: 'right',
                                alignItems: 'center',
                                cursor: 'pointer'
                            }
                        });
                        var check = (0, $eWjiX.BB).el({
                            tagName: 'input',
                            parent: checkWrapper,
                            custom: {
                                type: 'checkbox',
                                tabindex: '-1',
                                name: 'layer-visibility'
                            },
                            css: {
                                display: 'block',
                                cursor: 'pointer',
                                margin: '0',
                                marginRight: '5px'
                            }
                        });
                        check.checked = isVisible;
                        check.onchange = function() {
                            _this.klCanvas.setLayerIsVisible(layer.spot, check.checked);
                            //this.createLayerList();
                            if (layer.spot === _this.selectedSpotIndex) _this.onSelect(_this.selectedSpotIndex, false);
                        };
                        // prevent layer getting dragged
                        var preventFunc = function(e) {
                            e.preventDefault();
                            e.stopPropagation();
                        };
                        if (0, $6J2My.HAS_POINTER_EVENTS) checkWrapper.onpointerdown = preventFunc;
                        else checkWrapper.onmousedown = preventFunc;
                    }
                    //thumb
                    {
                        var thumbDimensions = (0, $eWjiX.BB).fitInto(layercanvas.width, layercanvas.height, 30, 30, 1);
                        layer.thumb = (0, $eWjiX.BB).canvas(thumbDimensions.width, thumbDimensions.height);
                        var thc = (0, $eWjiX.BB).ctx(layer.thumb);
                        thc.save();
                        if (layer.thumb.width > layercanvas.width) thc.imageSmoothingEnabled = false;
                        thc.drawImage(layercanvas, 0, 0, layer.thumb.width, layer.thumb.height);
                        thc.restore();
                        (0, $7jh4K.css)(layer.thumb, {
                            position: 'absolute',
                            left: (32 - layer.thumb.width) / 2 + $615843517fb18518$var$paddingLeft + 'px',
                            top: (32 - layer.thumb.height) / 2 + 1 + 'px',
                            background: 'var(--kl-checkerboard-background)'
                        });
                    }
                    layer.label = (0, $eWjiX.BB).el({
                        className: 'kl-layer__label'
                    });
                    layer.layerName = layerName;
                    layer.label.append(layer.layerName);
                    (0, $7jh4K.css)(layer.label, {
                        position: 'absolute',
                        left: 38 + $615843517fb18518$var$paddingLeft + 'px',
                        top: "1px",
                        fontSize: '13px',
                        width: '165px',
                        height: '20px',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis'
                    });
                    layer.label.ondblclick = function() {
                        _this.applyUncommitted();
                        _this.renameLayer(layer.spot);
                    };
                    layer.opacityLabel = (0, $eWjiX.BB).el({
                        className: 'kl-layer__opacity-label'
                    });
                    layer.opacity = opacity;
                    layer.opacityLabel.append(parseInt('' + layer.opacity * 100) + '%');
                    (0, $7jh4K.css)(layer.opacityLabel, {
                        position: 'absolute',
                        left: 189 + $615843517fb18518$var$paddingLeft + 'px',
                        top: "1px",
                        fontSize: '13px',
                        textAlign: 'right',
                        width: '50px',
                        transition: 'color 0.2s ease-in-out',
                        textDecoration: isVisible ? undefined : 'line-through'
                    });
                    var oldOpacity;
                    var opacitySlider = new (0, $5e81242a941997c7$export$ac00cea56cec3037)({
                        init: layer.opacity,
                        width: 200,
                        pointSize: 14,
                        callback: function(sliderValue, isFirst, isLast) {
                            if (isFirst) {
                                oldOpacity = _this.klCanvas.getLayerOld(layer.spot).opacity;
                                _this.klHistory.pause(true);
                                return;
                            }
                            if (isLast) {
                                _this.klHistory.pause(false);
                                if (oldOpacity !== sliderValue) _this.klCanvas.setOpacity(layer.spot, sliderValue);
                                return;
                            }
                            layer.opacityLabel.innerHTML = Math.round(sliderValue * 100) + '%';
                            _this.klCanvas.setOpacity(layer.spot, sliderValue);
                            _this.onUpdateProject();
                        }
                    });
                    (0, $7jh4K.css)(opacitySlider.getElement(), {
                        position: 'absolute',
                        left: 39 + $615843517fb18518$var$paddingLeft + 'px',
                        top: '17px'
                    });
                    layer.opacitySlider = opacitySlider;
                    //larger layer preview - hover
                    layer.thumb.onpointerover = function(e) {
                        if (e.buttons !== 0 && (!e.pointerType || e.pointerType !== 'touch')) //shouldn't show while dragging
                        return;
                        var thumbDimensions = (0, $eWjiX.BB).fitInto(layercanvas.width, layercanvas.height, 250, 250, 1);
                        if (_this.largeThumbCanvas.width !== thumbDimensions.width || _this.largeThumbCanvas.height !== thumbDimensions.height) {
                            _this.largeThumbCanvas.width = thumbDimensions.width;
                            _this.largeThumbCanvas.height = thumbDimensions.height;
                        }
                        var ctx = (0, $eWjiX.BB).ctx(_this.largeThumbCanvas);
                        ctx.save();
                        if (_this.largeThumbCanvas.width > layercanvas.width) ctx.imageSmoothingEnabled = false;
                        ctx.imageSmoothingQuality = 'high';
                        ctx.clearRect(0, 0, _this.largeThumbCanvas.width, _this.largeThumbCanvas.height);
                        ctx.drawImage(layercanvas, 0, 0, _this.largeThumbCanvas.width, _this.largeThumbCanvas.height);
                        ctx.restore();
                        (0, $7jh4K.css)(_this.largeThumbDiv, {
                            top: e.clientY - _this.largeThumbCanvas.height / 2 + 'px',
                            opacity: '0'
                        });
                        if (!_this.largeThumbInDocument) {
                            document.body.append(_this.largeThumbDiv);
                            _this.largeThumbInDocument = true;
                        }
                        clearTimeout(_this.largeThumbInTimeout);
                        _this.largeThumbInTimeout = setTimeout(function() {
                            (0, $7jh4K.css)(_this.largeThumbDiv, {
                                opacity: '1'
                            });
                        }, 20);
                        clearTimeout(_this.largeThumbTimeout);
                    };
                    layer.thumb.onpointerout = function() {
                        clearTimeout(_this.largeThumbInTimeout);
                        (0, $7jh4K.css)(_this.largeThumbDiv, {
                            opacity: '0'
                        });
                        clearTimeout(_this.largeThumbTimeout);
                        _this.largeThumbTimeout = setTimeout(function() {
                            if (!_this.largeThumbInDocument) return;
                            _this.largeThumbDiv.remove();
                            _this.largeThumbInDocument = false;
                        }, 300);
                    };
                    container1.append(layer.thumb, layer.label, layer.opacityLabel, opacitySlider.getElement());
                    var dragstart = false;
                    var freshSelection = false;
                    //events for moving layers up and down
                    var dragEventHandler = function(event) {
                        if (event.type === 'pointerdown' && event.button === 'left') {
                            (0, $7jh4K.css)(layer, {
                                transition: 'box-shadow 0.3s ease-in-out',
                                zIndex: '1'
                            });
                            _this.lastpos = layer.spot;
                            freshSelection = false;
                            if (!layer.isSelected) {
                                freshSelection = true;
                                _this.activateLayer(layer.spot);
                            }
                            dragstart = true;
                        } else if (event.type === 'pointermove' && event.button === 'left') {
                            if (dragstart) {
                                dragstart = false;
                                (0, $7jh4K.css)(layer, {
                                    boxShadow: '1px 3px 5px rgba(0,0,0,0.4)'
                                });
                            }
                            layer.posY += event.dY;
                            var corrected = Math.max(0, Math.min((_this.klCanvasLayerArr.length - 1) * 35, layer.posY));
                            layer.style.top = corrected + 'px';
                            _this.updateLayersVerticalPosition(layer.spot, _this.posToSpot(layer.posY));
                        }
                        if (event.type === 'pointerup') {
                            (0, $7jh4K.css)(layer, {
                                transition: 'all 0.1s linear'
                            });
                            setTimeout(function() {
                                (0, $7jh4K.css)(layer, {
                                    boxShadow: ''
                                });
                            }, 20);
                            layer.posY = Math.max(0, Math.min((_this.klCanvasLayerArr.length - 1) * 35, layer.posY));
                            layer.style.zIndex = '';
                            var newSpot = _this.posToSpot(layer.posY);
                            var oldSpot = layer.spot;
                            _this.move(layer.spot, newSpot);
                            if (oldSpot != newSpot) _this.onSelect(_this.selectedSpotIndex, false);
                            if (oldSpot === newSpot && freshSelection) {
                                _this.applyUncommitted();
                                _this.onSelect(_this.selectedSpotIndex, true);
                            }
                            freshSelection = false;
                        }
                    };
                    layer.pointerListener = new (0, $eWjiX.BB).PointerListener({
                        target: container1,
                        onPointer: dragEventHandler
                    });
                    _this.layerListEl.append(layer);
                };
                this.layerElArr = [];
                while(this.layerListEl.firstChild){
                    var child = this.layerListEl.firstChild;
                    child.pointerListener.destroy();
                    child.opacitySlider.destroy();
                    child.remove();
                }
                for(var i = 0; i < this.klCanvasLayerArr.length; i++)createLayerEntry(i);
                this.activateLayer(this.selectedSpotIndex);
                this.updateHeight();
            }
        },
        {
            key: "updateButtons",
            value: function updateButtons() {
                var maxReached = this.klCanvasLayerArr.length === (0, $0621fc8724f6bfac$export$9f4f73b1bd7c2f26);
                var oneLayer = this.klCanvasLayerArr.length === 1;
                this.addBtn.disabled = maxReached;
                this.removeBtn.disabled = oneLayer;
                this.duplicateBtn.disabled = maxReached;
                this.mergeBtn.disabled = this.selectedSpotIndex === 0;
                this.moreDropdown.setEnabled('advanced-merge', !oneLayer);
                this.moreDropdown.setEnabled('merge-all', !oneLayer);
            }
        },
        {
            // ---- interface ----
            key: "update",
            value: function update(activeLayerSpotIndex) {
                var _this = this;
                this.klCanvasLayerArr = this.klCanvas.getLayers();
                if (activeLayerSpotIndex || activeLayerSpotIndex === 0) this.selectedSpotIndex = activeLayerSpotIndex;
                this.updateButtons();
                setTimeout(function() {
                    return _this.createLayerList();
                }, 1);
            }
        },
        {
            key: "getSelected",
            value: function getSelected() {
                return this.selectedSpotIndex;
            }
        },
        {
            key: "activateLayer",
            value: function activateLayer(spotIndex) {
                if (spotIndex < 0 || spotIndex > this.layerElArr.length - 1) throw 'invalid spotIndex ' + spotIndex + ', layerElArr.length ' + this.layerElArr.length;
                this.selectedSpotIndex = spotIndex;
                this.modeSelect.setValue(this.klCanvasLayerArr[this.selectedSpotIndex].mixModeStr);
                for(var i = 0; i < this.layerElArr.length; i++){
                    var layer = this.layerElArr[i];
                    var isSelected = this.selectedSpotIndex === layer.spot;
                    (0, $7jh4K.css)(layer, {
                        boxShadow: ''
                    });
                    layer.classList.toggle('kl-layer--selected', isSelected);
                    layer.opacitySlider.setActive(isSelected);
                    layer.isSelected = isSelected;
                }
                this.mergeBtn.disabled = this.selectedSpotIndex === 0;
            }
        },
        {
            key: "setUiState",
            value: function setUiState(stateStr) {
                this.uiState = stateStr;
                if (this.uiState === 'left') (0, $7jh4K.css)(this.largeThumbDiv, {
                    left: '280px',
                    right: ''
                });
                else (0, $7jh4K.css)(this.largeThumbDiv, {
                    left: '',
                    right: '280px'
                });
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "advancedMergeDialog",
            value: function advancedMergeDialog() {
                var _this = this;
                this.applyUncommitted();
                if (this.selectedSpotIndex <= 0) return;
                (0, $9eb64c51bad4097c$export$ee79aceabae6bb8a)(this.parentEl, {
                    topCanvas: this.klCanvasLayerArr[this.selectedSpotIndex].context.canvas,
                    bottomCanvas: this.klCanvasLayerArr[this.selectedSpotIndex - 1].context.canvas,
                    topOpacity: this.klCanvas.getLayerOld(this.selectedSpotIndex).opacity,
                    mixModeStr: this.klCanvasLayerArr[this.selectedSpotIndex].mixModeStr,
                    callback: function(mode) {
                        _this.klCanvas.mergeLayers(_this.selectedSpotIndex, _this.selectedSpotIndex - 1, mode);
                        _this.klCanvasLayerArr = _this.klCanvas.getLayers();
                        _this.selectedSpotIndex--;
                        //this.createLayerList();
                        _this.onSelect(_this.selectedSpotIndex, false);
                        _this.updateButtons();
                    }
                });
            }
        }
    ]);
    return LayersUi;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");
var $e6889b231e436752$export$e258ade1648009b7 = /*#__PURE__*/ function() {
    "use strict";
    function KlCanvasPreview(p) {
        var _this = this;
        (0, $cx0mh._)(this, KlCanvasPreview);
        this.layers = p.layers;
        var scale = p.width / p.layers[0].image.width;
        var width = scale > 1 ? p.layers[0].image.width : p.width;
        var height = scale > 1 ? p.layers[0].image.height : p.height;
        this.canvas = (0, $eWjiX.BB).canvas(width, height);
        this.ctx = (0, $eWjiX.BB).ctx(this.canvas);
        (0, $7jh4K.css)(this.canvas, {
            width: '100%',
            height: '100%',
            imageRendering: scale > 1 ? 'pixelated' : undefined,
            background: 'var(--kl-checkerboard-background)',
            backgroundSize: '16px'
        });
        setTimeout(function() {
            return _this.render();
        }, 0);
    }
    (0, $7h4XF._)(KlCanvasPreview, [
        {
            key: "getElement",
            value: function getElement() {
                return this.canvas;
            }
        },
        {
            key: "render",
            value: function render() {
                if (!this.ctx) return;
                this.ctx.save();
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                for(var i = 0; i < this.layers.length; i++){
                    var layer = this.layers[i];
                    if (!layer.isVisible || layer.opacity === 0) continue;
                    this.ctx.globalAlpha = this.layers[i].opacity;
                    this.ctx.globalCompositeOperation = this.layers[i].mixModeStr;
                    if (this.canvas.width > this.layers[i].image.width) this.ctx.imageSmoothingEnabled = false;
                    this.ctx.drawImage(this.layers[i].image, 0, 0, this.canvas.width, this.canvas.height);
                }
                this.ctx.restore();
            }
        },
        {
            key: "destroy",
            value: function destroy() {}
        }
    ]);
    return KlCanvasPreview;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $eWjiX = parcelRequire("eWjiX");
var $416711db5dd64cf1$exports = {};
$416711db5dd64cf1$exports = $parcel$resolve("045N6");



var $eWjiX = parcelRequire("eWjiX");
function $6c5cb3001c773523$export$958c2bfe8d7142a9(transform) {
    transform = (0, $eWjiX.BB).copyObj(transform);
    if (Math.abs(transform.angleDeg) % 90 !== 0) return transform;
    transform.width = Math.round(transform.width);
    transform.height = Math.round(transform.height);
    // 0° is original orientation.
    // At 90° and 270° width and height become swapped due to different orientation.
    var whSwapped = Math.abs(transform.angleDeg - 90) % 180 === 0;
    transform.x = (whSwapped ? transform.height : transform.width) % 2 === 0 ? Math.round(transform.x) : Math.round(transform.x - 0.5) + 0.5;
    transform.y = (whSwapped ? transform.width : transform.height) % 2 === 0 ? Math.round(transform.y) : Math.round(transform.y - 0.5) + 0.5;
    return transform;
}
function $6c5cb3001c773523$export$6a4549ec4168874a(x, y, transform) {
    var px, py;
    px = x - transform.x;
    py = y - transform.y;
    var rot = (0, $eWjiX.BB).rotateAround({
        x: 0,
        y: 0
    }, {
        x: px,
        y: py
    }, -transform.angleDeg);
    px = rot.x;
    py = rot.y;
    return {
        x: px,
        y: py
    };
}
function $6c5cb3001c773523$export$3fba3b383c654cc6(x, y, transform) {
    var rot = (0, $eWjiX.BB).rotateAround({
        x: 0,
        y: 0
    }, {
        x: x,
        y: y
    }, transform.angleDeg);
    return {
        x: rot.x + transform.x,
        y: rot.y + transform.y
    };
}



var $7jh4K = parcelRequire("7jh4K");

parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");

var $eg83P = parcelRequire("eg83P");
var $0370167ee97a20d9$var$gripSize = 16;
var $0370167ee97a20d9$var$edgeSize = 10;
// 0 - east
function $0370167ee97a20d9$var$angleDegToCursor(angleDeg) {
    var cursors = [
        'e',
        'ne',
        'n',
        'nw',
        'w',
        'sw',
        's',
        'se'
    ];
    while(angleDeg < 0)angleDeg += 360;
    var index = Math.round(angleDeg / 45) % cursors.length;
    return cursors[index] + '-resize';
}
var $0370167ee97a20d9$export$79a74567acf241b0 = /*#__PURE__*/ function() {
    "use strict";
    function FreeTransform(p) {
        var _this = this;
        (0, $cx0mh._)(this, FreeTransform);
        var resetRemainder = function resetRemainder() {
            pointerRemainder.x = 0;
            pointerRemainder.y = 0;
        };
        this.rectInViewport = {
            // x and y in center of rect
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            // relative to center of rect. without rotation.
            corners: [
                {
                    x: 0,
                    y: 0
                }
            ]
        };
        this.minSnapDist = 7 // minimal snapping distance in px viewport space
        ;
        this.corners = [];
        this.edges = [];
        this.viewportTransform = (0, $cL71g._)({}, p.viewportTransform);
        this.value = {
            // coordinates and dimensions of transformation
            x: p.x,
            y: p.y,
            width: p.width,
            height: p.height,
            angleDeg: p.angleDeg
        };
        this.isConstrained = p.isConstrained;
        this.snapX = p.snapX;
        this.snapY = p.snapY;
        this.callback = p.callback;
        this.snappingEnabled = true;
        this.ratio = this.value.width / this.value.height;
        var onWheel = p.onWheel ? function(e) {
            if (!p.onWheel || !p.wheelParent) return;
            var parentRect = p.wheelParent.getBoundingClientRect();
            e.relX = e.pageX - parentRect.left;
            e.relY = e.pageY - parentRect.top;
            p.onWheel(e);
        } : undefined;
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'kl-free-transform',
            css: {
                userSelect: 'none'
            }
        });
        this.transEl = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                position: 'absolute'
            }
        });
        this.boundsEl = (0, $eWjiX.BB).el({
            css: {
                position: 'absolute',
                cursor: 'move',
                boxShadow: 'rgba(255, 255, 255, 0.5) 0 0 0 1px inset, rgba(0, 0, 0, 0.5) 0 0 0 1px'
            }
        });
        var pointerRemainder = {
            x: 0,
            y: 0
        };
        this.keyListener = new (0, $eWjiX.BB).KeyListener({});
        var boundsStartP = {
            x: 0,
            y: 0
        };
        this.boundsPointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.boundsEl,
            fixScribble: true,
            onPointer: function(event) {
                event.eventPreventDefault();
                if (event.type === 'pointerdown') boundsStartP = {
                    x: _this.value.x,
                    y: _this.value.y
                };
                if (event.type === 'pointermove' && event.button === 'left') {
                    var viewportMatrix = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(_this.viewportTransform);
                    var originInCanvas = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(viewportMatrix), {
                        x: event.downPageX,
                        y: event.downPageY
                    });
                    var deltaInCanvas = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(viewportMatrix), {
                        x: event.pageX,
                        y: event.pageY
                    });
                    var delta = {
                        x: deltaInCanvas.x - originInCanvas.x,
                        y: deltaInCanvas.y - originInCanvas.y
                    };
                    _this.value.x = boundsStartP.x + delta.x;
                    _this.value.y = boundsStartP.y + delta.y;
                    var dist;
                    var snap = {
                        distX: -1,
                        distY: -1
                    };
                    if (_this.snappingEnabled) {
                        var i;
                        for(i = 0; i < _this.snapX.length; i++){
                            dist = Math.abs(_this.value.x - _this.snapX[i]);
                            if (dist < _this.minSnapDist / _this.viewportTransform.scale) {
                                if (snap.x === undefined || dist < snap.distX) {
                                    snap.x = _this.snapX[i];
                                    snap.distX = dist;
                                }
                            }
                        }
                        for(i = 0; i < _this.snapY.length; i++){
                            dist = Math.abs(_this.value.y - _this.snapY[i]);
                            if (dist < _this.minSnapDist / _this.viewportTransform.scale) {
                                if (snap.y === undefined || dist < snap.distY) {
                                    snap.y = _this.snapY[i];
                                    snap.distY = dist;
                                }
                            }
                        }
                        var iP;
                        for(i = 0; i < 4; i++){
                            iP = (0, $6c5cb3001c773523$export$3fba3b383c654cc6)(_this.corners[i].x, _this.corners[i].y, _this.value);
                            var j = void 0;
                            for(j = 0; j < _this.snapX.length; j++){
                                dist = Math.abs(iP.x - _this.snapX[j]);
                                if (dist < _this.minSnapDist / _this.viewportTransform.scale) {
                                    if (snap.x === undefined || dist < snap.distX) {
                                        snap.x = _this.snapX[j] - (iP.x - _this.value.x);
                                        snap.distX = dist;
                                    }
                                }
                            }
                            for(j = 0; j < _this.snapY.length; j++){
                                dist = Math.abs(iP.y - _this.snapY[j]);
                                if (dist < _this.minSnapDist / _this.viewportTransform.scale) {
                                    if (snap.y === undefined || dist < snap.distY) {
                                        snap.y = _this.snapY[j] - (iP.y - _this.value.y);
                                        snap.distY = dist;
                                    }
                                }
                            }
                        }
                    }
                    if (_this.keyListener.getComboStr() === 'shift') {
                        var projected = (0, $eWjiX.BB).projectPointOnLine({
                            x: 0,
                            y: boundsStartP.y
                        }, {
                            x: 10,
                            y: boundsStartP.y
                        }, {
                            x: _this.value.x,
                            y: _this.value.y
                        });
                        var dist1 = (0, $eWjiX.BB).dist(projected.x, projected.y, _this.value.x, _this.value.y);
                        snap = {
                            x: projected.x,
                            y: projected.y,
                            distX: dist1,
                            distY: dist1
                        };
                        projected = (0, $eWjiX.BB).projectPointOnLine({
                            x: boundsStartP.x,
                            y: 0
                        }, {
                            x: boundsStartP.x,
                            y: 10
                        }, {
                            x: _this.value.x,
                            y: _this.value.y
                        });
                        dist1 = (0, $eWjiX.BB).dist(projected.x, projected.y, _this.value.x, _this.value.y);
                        if (dist1 < snap.distX) snap = {
                            x: projected.x,
                            y: projected.y,
                            distX: dist1,
                            distY: dist1
                        };
                        projected = (0, $eWjiX.BB).projectPointOnLine({
                            x: boundsStartP.x,
                            y: boundsStartP.y
                        }, {
                            x: boundsStartP.x + 1,
                            y: boundsStartP.y + 1
                        }, {
                            x: _this.value.x,
                            y: _this.value.y
                        });
                        dist1 = (0, $eWjiX.BB).dist(projected.x, projected.y, _this.value.x, _this.value.y);
                        if (dist1 < snap.distX) snap = {
                            x: projected.x,
                            y: projected.y,
                            distX: dist1,
                            distY: dist1
                        };
                        projected = (0, $eWjiX.BB).projectPointOnLine({
                            x: boundsStartP.x,
                            y: boundsStartP.y
                        }, {
                            x: boundsStartP.x + 1,
                            y: boundsStartP.y - 1
                        }, {
                            x: _this.value.x,
                            y: _this.value.y
                        });
                        dist1 = (0, $eWjiX.BB).dist(projected.x, projected.y, _this.value.x, _this.value.y);
                        if (dist1 < snap.distX) snap = {
                            x: projected.x,
                            y: projected.y,
                            distX: dist1,
                            distY: dist1
                        };
                    }
                    if (snap.x != undefined) _this.value.x = snap.x;
                    if (snap.y != undefined) _this.value.y = snap.y;
                    // snap to pixels
                    if (Math.abs(_this.value.angleDeg) % 90 === 0) {
                        _this.value = (0, $6c5cb3001c773523$export$958c2bfe8d7142a9)(_this.value);
                        _this.updateCornerPositions();
                    }
                    _this.updateDOM();
                }
            },
            useDirtyWheel: true,
            onWheel: onWheel
        });
        for(var i = 0; i < 4; i++)(function(i) {
            var g = _this.corners[i] = {
                i: i,
                el: (0, $eWjiX.BB).el({
                    css: {
                        width: $0370167ee97a20d9$var$gripSize + 'px',
                        height: $0370167ee97a20d9$var$gripSize + 'px',
                        background: '#fff',
                        /*background: [
                                '#ff0000',
                                '#00ff00',
                                '#0000ff',
                                '#ff00ff',
                            ][i],*/ borderRadius: $0370167ee97a20d9$var$gripSize + 'px',
                        position: 'absolute',
                        border: '2px solid #000'
                    }
                }),
                x: 0,
                y: 0,
                virtualPos: {
                    x: 0,
                    y: 0
                }
            };
            g.updateDOM = function() {
                // grip position
                // if it gets small: slightly offset grips, so easier to handle
                var offsetArr = [
                    [
                        -1,
                        -1
                    ],
                    [
                        1,
                        -1
                    ],
                    [
                        1,
                        1
                    ],
                    [
                        -1,
                        1
                    ]
                ].map(function(item) {
                    item[0] *= _this.value.width > 0 ? 1 : -1;
                    item[1] *= _this.value.height > 0 ? 1 : -1;
                    return item;
                });
                var tinyOffset = Math.abs(_this.rectInViewport.width) < 20 || Math.abs(_this.rectInViewport.height) < 20 ? 10 : 0;
                (0, $7jh4K.css)(g.el, {
                    left: _this.rectInViewport.corners[g.i].x - $0370167ee97a20d9$var$gripSize / 2 + offsetArr[i][0] * tinyOffset + 'px',
                    top: _this.rectInViewport.corners[g.i].y - $0370167ee97a20d9$var$gripSize / 2 + offsetArr[i][1] * tinyOffset + 'px'
                });
                // cursor
                var xMult = _this.value.width < 0 ? -1 : 1;
                var yMult = _this.value.height < 0 ? -1 : 1;
                var cornerVectors = [
                    {
                        x: -1,
                        y: -1
                    },
                    {
                        x: 1,
                        y: -1
                    },
                    {
                        x: 1,
                        y: 1
                    },
                    {
                        x: -1,
                        y: 1
                    }
                ];
                var cornerVector = {
                    x: cornerVectors[i].x * xMult,
                    y: cornerVectors[i].y * yMult * -1
                };
                var angleDeg = (0, $eg83P.pointsToAngleDeg)({
                    x: 0,
                    y: 0
                }, cornerVector) - _this.value.angleDeg - _this.viewportTransform.angleDeg;
                (0, $7jh4K.css)(g.el, {
                    cursor: $0370167ee97a20d9$var$angleDegToCursor(angleDeg)
                });
            };
            g.pointerListener = new (0, $eWjiX.BB).PointerListener({
                target: _this.corners[i].el,
                fixScribble: true,
                onPointer: function(event) {
                    event.eventPreventDefault();
                    if (event.type === 'pointerdown' && event.button === 'left') _this.corners[i].virtualPos = (0, $6c5cb3001c773523$export$3fba3b383c654cc6)(_this.corners[i].x, _this.corners[i].y, _this.value);
                    else if (event.type === 'pointermove' && event.button === 'left') {
                        var viewportMatrix = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(_this.viewportTransform);
                        var originInCanvas = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(viewportMatrix), {
                            x: 0,
                            y: 0
                        });
                        var deltaInCanvas = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(viewportMatrix), {
                            x: event.dX,
                            y: event.dY
                        });
                        var delta = {
                            x: deltaInCanvas.x - originInCanvas.x,
                            y: deltaInCanvas.y - originInCanvas.y
                        };
                        _this.corners[i].virtualPos.x += delta.x;
                        _this.corners[i].virtualPos.y += delta.y;
                        var iP = {
                            x: _this.corners[i].virtualPos.x,
                            y: _this.corners[i].virtualPos.y
                        };
                        iP = _this.constrainCorner(i, iP.x, iP.y);
                        if (!_this.isConstrained) iP = _this.snapCorner(iP.x, iP.y);
                        if (Math.abs(_this.value.angleDeg) % 90 === 0) {
                            iP.x = Math.round(iP.x);
                            iP.y = Math.round(iP.y);
                        }
                        var tP = (0, $6c5cb3001c773523$export$6a4549ec4168874a)(iP.x, iP.y, _this.value);
                        var dX = tP.x - _this.corners[i].x;
                        var dY = tP.y - _this.corners[i].y;
                        _this.corners[i].x = tP.x;
                        _this.corners[i].y = tP.y;
                        var indexes = [];
                        if (i === 0) // top left
                        indexes = [
                            3,
                            1,
                            2
                        ];
                        else if (i === 1) // top right
                        indexes = [
                            2,
                            0,
                            3
                        ];
                        else if (i === 2) // bottom right
                        indexes = [
                            1,
                            3,
                            0
                        ];
                        else if (i === 3) // bottom left
                        indexes = [
                            0,
                            2,
                            1
                        ];
                        _this.corners[indexes[0]].x = _this.corners[i].x;
                        _this.corners[indexes[1]].y = _this.corners[i].y;
                        if (_this.keyListener.isPressed('shift')) {
                            _this.corners[indexes[2]].x -= dX;
                            _this.corners[indexes[2]].y -= dY;
                            _this.corners[indexes[1]].x = _this.corners[indexes[2]].x;
                            _this.corners[indexes[0]].y = _this.corners[indexes[2]].y;
                        }
                        _this.updateTransformViaCorners();
                    }
                },
                useDirtyWheel: true,
                onWheel: onWheel
            });
        })(i);
        this.updateCornerPositions();
        this.updateScaled();
        var isInverted;
        for(var i1 = 0; i1 < 4; i1++)(function(i) {
            _this.edges[i] = {
                el: (0, $eWjiX.BB).el({
                    css: {
                        width: $0370167ee97a20d9$var$edgeSize + 'px',
                        height: $0370167ee97a20d9$var$edgeSize + 'px',
                        //background: ['red', 'green', 'blue', 'orange'][i],
                        position: 'absolute'
                    }
                })
            };
            var g = _this.edges[i];
            g.updateDOM = function() {
                if (i === 0) (0, $7jh4K.css)(g.el, {
                    left: Math.min(_this.rectInViewport.corners[0].x, _this.rectInViewport.corners[1].x) + 'px',
                    top: Math.min(_this.rectInViewport.corners[0].y, _this.rectInViewport.corners[3].y) - $0370167ee97a20d9$var$edgeSize + 'px',
                    width: Math.abs(_this.rectInViewport.width) + 'px',
                    height: $0370167ee97a20d9$var$edgeSize + 'px'
                });
                else if (i === 1) (0, $7jh4K.css)(g.el, {
                    left: Math.max(_this.rectInViewport.corners[0].x, _this.rectInViewport.corners[1].x) + 'px',
                    top: Math.min(_this.rectInViewport.corners[1].y, _this.rectInViewport.corners[2].y) + 'px',
                    width: $0370167ee97a20d9$var$edgeSize + 'px',
                    height: Math.abs(_this.rectInViewport.height) + 'px'
                });
                else if (i === 2) (0, $7jh4K.css)(g.el, {
                    left: Math.min(_this.rectInViewport.corners[3].x, _this.rectInViewport.corners[2].x) + 'px',
                    top: Math.max(_this.rectInViewport.corners[0].y, _this.rectInViewport.corners[3].y) + 'px',
                    width: Math.abs(_this.rectInViewport.width) + 'px',
                    height: $0370167ee97a20d9$var$edgeSize + 'px'
                });
                else if (i === 3) (0, $7jh4K.css)(g.el, {
                    left: Math.min(_this.rectInViewport.corners[0].x, _this.rectInViewport.corners[1].x) - $0370167ee97a20d9$var$edgeSize + 'px',
                    top: Math.min(_this.rectInViewport.corners[0].y, _this.rectInViewport.corners[3].y) + 'px',
                    width: $0370167ee97a20d9$var$edgeSize + 'px',
                    height: Math.abs(_this.rectInViewport.height) + 'px'
                });
                var xFlipped = _this.value.width < 0;
                var yFlipped = _this.value.height < 0;
                var angles = [
                    yFlipped ? -90 : 90,
                    xFlipped ? 180 : 0,
                    yFlipped ? 90 : -90,
                    xFlipped ? 0 : 180
                ];
                var angleDeg = angles[i] - _this.value.angleDeg - _this.viewportTransform.angleDeg;
                (0, $7jh4K.css)(g.el, {
                    cursor: $0370167ee97a20d9$var$angleDegToCursor(angleDeg)
                });
            };
            var isVertical = [
                0,
                2
            ].includes(i);
            g.pointerListener = new (0, $eWjiX.BB).PointerListener({
                target: _this.edges[i].el,
                fixScribble: true,
                onPointer: function(event) {
                    event.eventPreventDefault();
                    if (event.type === 'pointerdown' && event.button === 'left') {
                        if (isVertical) // top bottom
                        isInverted = _this.corners[0].y >= _this.corners[3].y;
                        else // left right
                        isInverted = _this.corners[0].x >= _this.corners[1].x;
                        resetRemainder();
                    }
                    if (event.type === 'pointermove' && event.button === 'left') {
                        var viewportMatrix = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(_this.viewportTransform);
                        var originInCanvas = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(viewportMatrix), {
                            x: 0,
                            y: 0
                        });
                        var deltaInCanvas = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(viewportMatrix), {
                            x: event.dX,
                            y: event.dY
                        });
                        var originInTransform = (0, $6c5cb3001c773523$export$6a4549ec4168874a)(originInCanvas.x, originInCanvas.y, _this.value);
                        var deltaInTransform = (0, $6c5cb3001c773523$export$6a4549ec4168874a)(deltaInCanvas.x, deltaInCanvas.y, _this.value);
                        var tfD = {
                            x: deltaInTransform.x - originInTransform.x,
                            y: deltaInTransform.y - originInTransform.y
                        };
                        var ti = {
                            dX: tfD.x,
                            dY: tfD.y
                        };
                        if (Math.abs(_this.value.angleDeg) % 90 === 0) ti = (0, $eWjiX.BB).intDxy(pointerRemainder, tfD.x, tfD.y);
                        var indexes = [];
                        if (i === 0) // top
                        indexes = [
                            2,
                            3,
                            0,
                            1
                        ];
                        else if (i === 1) // right
                        indexes = [
                            0,
                            3,
                            1,
                            2
                        ];
                        else if (i === 2) // bottom
                        indexes = [
                            0,
                            1,
                            2,
                            3
                        ];
                        else if (i === 3) // left
                        indexes = [
                            1,
                            2,
                            0,
                            3
                        ];
                        var dimension = isVertical ? 'y' : 'x';
                        var d = isVertical ? ti.dY : ti.dX;
                        if (isInverted) {
                            _this.corners[indexes[0]][dimension] += d;
                            _this.corners[indexes[1]][dimension] += d;
                        } else {
                            _this.corners[indexes[2]][dimension] += d;
                            _this.corners[indexes[3]][dimension] += d;
                        }
                        if (_this.keyListener.isPressed('shift')) {
                            if (isInverted) {
                                _this.corners[indexes[2]][dimension] -= d;
                                _this.corners[indexes[3]][dimension] -= d;
                            } else {
                                _this.corners[indexes[0]][dimension] -= d;
                                _this.corners[indexes[1]][dimension] -= d;
                            }
                        }
                        if (isVertical) // top bottom
                        _this.restoreRatio(false, true);
                        else // left right
                        _this.restoreRatio(true, false);
                        _this.updateTransformViaCorners();
                    }
                },
                useDirtyWheel: true,
                onWheel: onWheel
            });
        })(i1);
        this.angleGrip = {
            el: (0, $eWjiX.BB).el({
                css: {
                    cursor: 'url(' + (0, (/*@__PURE__*/$parcel$interopDefault($416711db5dd64cf1$exports))) + ') 10 10, move',
                    width: $0370167ee97a20d9$var$gripSize + 'px',
                    height: $0370167ee97a20d9$var$gripSize + 'px',
                    background: '#0ff',
                    borderRadius: $0370167ee97a20d9$var$gripSize + 'px',
                    position: 'absolute',
                    boxShadow: 'inset 0 0 0 2px #000'
                }
            }),
            x: 0,
            y: 0,
            snap: false,
            updateDOM: function() {
                (0, $7jh4K.css)(_this.angleGrip.el, {
                    left: _this.angleGrip.x - $0370167ee97a20d9$var$gripSize / 2 + 'px',
                    top: _this.angleGrip.y - $0370167ee97a20d9$var$gripSize / 2 + 'px'
                });
            }
        };
        (0, $eWjiX.BB).el({
            parent: this.angleGrip.el,
            css: {
                width: '2px',
                height: '13px',
                left: $0370167ee97a20d9$var$gripSize / 2 - 1 + 'px',
                top: $0370167ee97a20d9$var$gripSize + 'px',
                background: '#0ff',
                position: 'absolute'
            }
        });
        this.anglePointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.angleGrip.el,
            fixScribble: true,
            onPointer: function(event) {
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    var viewportMatrix = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(_this.viewportTransform);
                    var rootBoundingClientRect = _this.rootEl.getBoundingClientRect();
                    var cursorInViewportPosition = {
                        x: event.clientX - rootBoundingClientRect.left,
                        y: event.clientY - rootBoundingClientRect.top
                    };
                    var cursorInCanvasPosition = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(viewportMatrix), cursorInViewportPosition);
                    var a = (0, $eWjiX.BB).pointsToAngleDeg({
                        x: _this.value.x,
                        y: _this.value.y
                    }, cursorInCanvasPosition) + 90;
                    _this.value.angleDeg = a;
                    var snapDeg = Math.round(a / 360 * 8) * 45;
                    if (_this.keyListener.getComboStr() === 'shift') _this.value.angleDeg = snapDeg;
                    else if (_this.snappingEnabled && Math.abs(snapDeg - a) < 8) _this.value.angleDeg = snapDeg;
                    _this.updateDOM();
                }
                if (event.type === 'pointerup') {
                    if (Math.abs(_this.value.angleDeg) % 90 === 0) {
                        _this.value = (0, $6c5cb3001c773523$export$958c2bfe8d7142a9)(_this.value);
                        _this.updateCornerPositions();
                        _this.updateDOM();
                    }
                }
            },
            useDirtyWheel: true,
            onWheel: onWheel
        });
        this.value = (0, $6c5cb3001c773523$export$958c2bfe8d7142a9)(this.value);
        this.updateDOM(true);
        (0, $eWjiX.BB).append(this.transEl, [
            this.boundsEl,
            this.edges[0].el,
            this.edges[1].el,
            this.edges[2].el,
            this.edges[3].el,
            this.corners[0].el,
            this.corners[1].el,
            this.corners[2].el,
            this.corners[3].el,
            this.angleGrip.el
        ]);
    }
    (0, $7h4XF._)(FreeTransform, [
        {
            key: "updateScaled",
            value: function updateScaled() {
                var _this = this;
                var viewportMatrix = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(this.viewportTransform);
                var centerInViewport = (0, $cdZRx.applyToPoint)(viewportMatrix, {
                    x: this.value.x,
                    y: this.value.y
                });
                this.rectInViewport.x = centerInViewport.x;
                this.rectInViewport.y = centerInViewport.y;
                this.rectInViewport.width = this.value.width * this.viewportTransform.scale;
                this.rectInViewport.height = this.value.height * this.viewportTransform.scale;
                this.rectInViewport.corners = this.corners.map(function(item) {
                    return {
                        x: item.x * _this.viewportTransform.scale,
                        y: item.y * _this.viewportTransform.scale
                    };
                });
            }
        },
        {
            key: "snapCorner",
            value: /**
     * Returns snapped point, if ix, iy snaps. If no snapping, returns point unchanged.
     * both in image space
     *
     * @param iX - image space
     * @param iY - image space
     * @private
     */ function snapCorner(iX, iY) {
                if (!this.snappingEnabled) return {
                    x: iX,
                    y: iY
                };
                var dist;
                var snap = {
                    x: undefined,
                    y: undefined,
                    dist: {
                        x: undefined,
                        y: undefined
                    }
                };
                for(var e = 0; e < this.snapX.length; e++){
                    dist = Math.abs(iX - this.snapX[e]);
                    if (dist < this.minSnapDist / this.viewportTransform.scale) {
                        if (snap.x === undefined || dist < snap.dist.x) {
                            snap.x = this.snapX[e];
                            snap.dist.x = dist;
                        }
                    }
                }
                for(var e1 = 0; e1 < this.snapY.length; e1++){
                    dist = Math.abs(iY - this.snapY[e1]);
                    if (dist < this.minSnapDist / this.viewportTransform.scale) {
                        if (snap.y === undefined || dist < snap.dist.y) {
                            snap.y = this.snapY[e1];
                            snap.dist.y = dist;
                        }
                    }
                }
                if (snap.x === undefined && snap.y === undefined) return {
                    x: iX,
                    y: iY
                };
                var _snap_x, _snap_y;
                return {
                    x: (_snap_x = snap.x) !== null && _snap_x !== void 0 ? _snap_x : iX,
                    y: (_snap_y = snap.y) !== null && _snap_y !== void 0 ? _snap_y : iY
                };
            }
        },
        {
            key: "constrainCorner",
            value: /**
     * If constrained return nearest corner pos that fits aspect ratio
     *
     * @param cornerIndex
     * @param iX
     * @param iY
     * @private
     */ function constrainCorner(cornerIndex, iX, iY) {
                if (!this.isConstrained) return {
                    x: iX,
                    y: iY
                };
                var flip = this.value.width * this.value.height < 0 ? -1 : 1;
                return (0, $eWjiX.BB).projectPointOnLine({
                    x: this.value.x,
                    y: this.value.y
                }, (0, $6c5cb3001c773523$export$3fba3b383c654cc6)(this.ratio, flip * ([
                    0,
                    2
                ].includes(cornerIndex) ? 1 : -1), this.value), {
                    x: iX,
                    y: iY
                });
            }
        },
        {
            key: "updateCornerPositions",
            value: /**
     * Update corners according to width height.
     * Not their DOM.
     */ function updateCornerPositions() {
                this.corners[0].x = -this.value.width / 2; // top left
                this.corners[0].y = -this.value.height / 2;
                this.corners[1].x = this.value.width / 2; // top right
                this.corners[1].y = -this.value.height / 2;
                this.corners[2].x = this.value.width / 2; // bottom right
                this.corners[2].y = this.value.height / 2;
                this.corners[3].x = -this.value.width / 2; // bottom left
                this.corners[3].y = this.value.height / 2;
            }
        },
        {
            key: "restoreRatio",
            value: /**
     * If constrained and dragging an edge, restore aspect ratio
     * Updates corner positions.
     *
     * @param widthChanged
     * @param heightChanged
     * @private
     */ function restoreRatio(widthChanged, heightChanged) {
                if (!this.isConstrained) return;
                var angle90 = Math.abs(this.value.angleDeg) % 90 === 0;
                var whSwapped = Math.abs(this.value.angleDeg - 90) % 180 === 0;
                if (heightChanged && !widthChanged) {
                    var newHeight = Math.abs(this.corners[3].y - this.corners[0].y);
                    var newWidth = this.ratio * newHeight;
                    if (angle90) newWidth = (whSwapped ? this.value.y % 1 : this.value.x % 1) === 0 ? (0, $eWjiX.BB).roundEven(newWidth) : (0, $eWjiX.BB).roundUneven(newWidth);
                    if (this.corners[1].x - this.corners[0].x < 0) newWidth *= -1;
                    this.corners[0].x = -newWidth / 2;
                    this.corners[3].x = -newWidth / 2;
                    this.corners[1].x = newWidth / 2;
                    this.corners[2].x = newWidth / 2;
                }
                if (!heightChanged && widthChanged) {
                    var newWidth1 = Math.abs(this.corners[0].x - this.corners[1].x);
                    var newHeight1 = newWidth1 / this.ratio;
                    if (angle90) newHeight1 = (whSwapped ? this.value.x % 1 : this.value.y % 1) === 0 ? (0, $eWjiX.BB).roundEven(newHeight1) : (0, $eWjiX.BB).roundUneven(newHeight1);
                    if (this.corners[3].y - this.corners[0].y < 0) newHeight1 *= -1;
                    this.corners[0].y = -newHeight1 / 2;
                    this.corners[1].y = -newHeight1 / 2;
                    this.corners[2].y = newHeight1 / 2;
                    this.corners[3].y = newHeight1 / 2;
                }
            }
        },
        {
            key: "updateTransformViaCorners",
            value: /**
     * update transform based on corners
     * @private
     */ function updateTransformViaCorners() {
                // calc transform center in image space
                var rot = (0, $eWjiX.BB).rotateAround({
                    x: 0,
                    y: 0
                }, {
                    x: (this.corners[0].x + this.corners[1].x) / 2,
                    y: (this.corners[0].y + this.corners[3].y) / 2
                }, this.value.angleDeg);
                this.value.x = rot.x + this.value.x;
                this.value.y = rot.y + this.value.y;
                // update size
                this.value.width = this.corners[1].x - this.corners[0].x;
                this.value.height = this.corners[3].y - this.corners[0].y;
                // new center means corners changed their position
                this.updateCornerPositions();
                this.updateDOM();
            }
        },
        {
            key: "updateDOM",
            value: /**
     * updates DOM according to transform
     * @param skipCallback
     */ function updateDOM(skipCallback) {
                this.updateScaled();
                (0, $7jh4K.css)(this.transEl, {
                    left: this.rectInViewport.x + 'px',
                    top: this.rectInViewport.y + 'px',
                    transformOrigin: '0 0',
                    transform: 'rotate(' + (this.value.angleDeg + this.viewportTransform.angleDeg) + 'deg)'
                });
                (0, $7jh4K.css)(this.boundsEl, {
                    width: Math.abs(this.rectInViewport.width) + 'px',
                    height: Math.abs(this.rectInViewport.height) + 'px',
                    left: Math.min(this.rectInViewport.corners[0].x, this.rectInViewport.corners[1].x) + 'px',
                    top: Math.min(this.rectInViewport.corners[0].y, this.rectInViewport.corners[3].y) + 'px'
                });
                this.corners[0].updateDOM();
                this.corners[1].updateDOM();
                this.corners[2].updateDOM();
                this.corners[3].updateDOM();
                this.edges[0].updateDOM();
                this.edges[1].updateDOM();
                this.edges[2].updateDOM();
                this.edges[3].updateDOM();
                this.angleGrip.x = 0;
                this.angleGrip.y = -Math.abs(this.value.height * this.viewportTransform.scale) / 2 - 20;
                this.angleGrip.updateDOM();
                if (!skipCallback) {
                    if (this.callback) // why should updateDOM trigger the callback?
                    this.callback((0, $cL71g._)({}, this.value));
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return (0, $cL71g._)({}, this.value);
            }
        },
        {
            key: "setIsConstrained",
            value: function setIsConstrained(b) {
                this.isConstrained = b;
                if (b && this.value.width !== 0 && this.value.height !== 0) this.ratio = Math.abs(this.value.width / this.value.height);
            }
        },
        {
            key: "setSnapping",
            value: function setSnapping(b) {
                this.snappingEnabled = b;
            }
        },
        {
            key: "setSnappingPoints",
            value: function setSnappingPoints(snapX, snapY) {
                this.snapX = snapX;
                this.snapY = snapY;
            }
        },
        {
            key: "setPos",
            value: function setPos(p) {
                this.value.x = p.x;
                this.value.y = p.y;
                this.updateDOM(true);
            }
        },
        {
            key: "move",
            value: function move(dX, dY) {
                this.value.x += dX;
                this.value.y += dY;
                this.updateDOM(false);
            }
        },
        {
            key: "setSize",
            value: function setSize(w, h) {
                this.value.width = w;
                this.value.height = h;
                if (Math.abs(this.value.angleDeg) % 90 === 0) this.value = (0, $6c5cb3001c773523$export$958c2bfe8d7142a9)(this.value);
                this.updateCornerPositions();
                this.updateDOM(false);
            }
        },
        {
            key: "initialise",
            value: function initialise(transform) {
                this.value.x = transform.x;
                this.value.y = transform.y;
                this.value.width = transform.width;
                this.value.height = transform.height;
                this.value.angleDeg = transform.angleDeg;
                this.ratio = Math.abs(transform.width / transform.height);
                this.updateCornerPositions();
                this.updateDOM(true);
            }
        },
        {
            key: "setAngleDeg",
            value: function setAngleDeg(a) {
                this.value.angleDeg = a;
                if (Math.abs(this.value.angleDeg) % 90 === 0) {
                    this.value = (0, $6c5cb3001c773523$export$958c2bfe8d7142a9)(this.value);
                    this.updateCornerPositions();
                }
                this.updateDOM(true);
            }
        },
        {
            key: "setViewportTransform",
            value: function setViewportTransform(transform) {
                this.viewportTransform = (0, $cL71g._)({}, transform);
                this.updateScaled();
                // skip callback because viewport change does not affect the value
                this.updateDOM(true);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getRatio",
            value: function getRatio() {
                return this.ratio;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.keyListener.destroy();
                this.boundsPointerListener.destroy();
                this.corners.forEach(function(item) {
                    return item.pointerListener.destroy();
                });
                this.edges.forEach(function(item) {
                    return item.pointerListener.destroy();
                });
                this.anglePointerListener.destroy();
            }
        }
    ]);
    return FreeTransform;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");



var $7jh4K = parcelRequire("7jh4K");
var $48f5d87739d28bf9$export$205c2dd29f8a66b5 = /*#__PURE__*/ function() {
    "use strict";
    function FreeTransformCanvas(p) {
        var _this = this;
        (0, $cx0mh._)(this, FreeTransformCanvas);
        this.algorithm = 'smooth';
        this.imageWidth = p.imageWidth;
        this.imageHeight = p.imageHeight;
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'kl-preview-wrapper',
            css: {
                width: p.elementWidth + 'px',
                height: p.elementHeight + 'px'
            }
        });
        this.rootEl.oncontextmenu = function() {
            return false;
        };
        this.layers = p.layers;
        this.transformIndex = p.transformIndex;
        this.previewLayerArr = this.layers.map(function(item) {
            var _item_mixModeStr;
            return {
                image: item.image,
                isVisible: item.isVisible,
                mixModeStr: (_item_mixModeStr = item.mixModeStr) !== null && _item_mixModeStr !== void 0 ? _item_mixModeStr : 'source-over',
                opacity: item.opacity,
                hasClipping: false
            };
        });
        this.previewCanvas = (0, $eWjiX.BB).canvas(this.imageWidth, this.imageHeight);
        this.previewLayerArr[this.previewLayerArr.length - 1].image = this.previewCanvas;
        this.preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: p.elementWidth,
            height: p.elementHeight,
            project: {
                width: p.imageWidth,
                height: p.imageHeight,
                layers: this.previewLayerArr
            },
            hasEditMode: true,
            onModeChange: function(m) {
                (0, $7jh4K.css)(_this.freeTransform.getElement(), {
                    pointerEvents: m === 'edit' ? '' : 'none',
                    opacity: m === 'edit' ? '' : '0.5'
                });
            },
            onTransformChange: function(transform) {
                _this.freeTransform.setViewportTransform(transform);
            },
            padding: 30
        });
        (0, $7jh4K.css)(this.preview.getElement(), {
            overflow: 'hidden',
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        this.rootEl.append(this.preview.getElement());
        this.initTransform = {
            x: this.imageWidth / 2,
            y: this.imageHeight / 2,
            width: this.layers[this.transformIndex].image.width,
            height: this.layers[this.transformIndex].image.height
        };
        this.freeTransform = new (0, $0370167ee97a20d9$export$79a74567acf241b0)({
            x: this.initTransform.x,
            y: this.initTransform.y,
            width: this.initTransform.width,
            height: this.initTransform.height,
            angleDeg: 0,
            isConstrained: true,
            snapX: [
                0,
                this.imageWidth
            ],
            snapY: [
                0,
                this.imageHeight
            ],
            viewportTransform: this.preview.getTransform(),
            callback: function() {
                _this.updatePreview();
            }
        });
        this.preview.getElement().append(this.freeTransform.getElement());
        (0, $7jh4K.css)(this.freeTransform.getElement(), {
            position: 'absolute',
            left: '0',
            top: '0'
        });
        setTimeout(function() {
            return _this.updatePreview();
        }, 0);
    }
    (0, $7h4XF._)(FreeTransformCanvas, [
        {
            key: "updatePreview",
            value: function updatePreview() {
                var transform = this.freeTransform.getValue();
                var ctx = (0, $eWjiX.BB).ctx(this.previewCanvas);
                ctx.save();
                ctx.clearRect(0, 0, this.previewCanvas.width, this.previewCanvas.height);
                (0, $eWjiX.BB).drawTransformedImageWithBounds(ctx, this.layers[this.transformIndex].image, transform, undefined, this.algorithm === 'pixelated' || (0, $eWjiX.BB).testShouldPixelate(transform, transform.width / this.initTransform.width, transform.height / this.initTransform.height));
                ctx.restore();
                this.preview.render();
            }
        },
        {
            // ---- interface ----
            key: "move",
            value: function move(dX, dY) {
                this.freeTransform.move(dX, dY);
            }
        },
        {
            key: "reset",
            value: function reset() {
                var w = this.layers[this.transformIndex].image.width;
                var h = this.layers[this.transformIndex].image.height;
                this.freeTransform.setSize(w, h);
                this.freeTransform.setPos({
                    x: w / 2,
                    y: h / 2
                });
                this.freeTransform.setAngleDeg(0);
                this.updatePreview();
            }
        },
        {
            key: "setTransformFit",
            value: function setTransformFit() {
                var fit = (0, $eWjiX.BB).fitInto(this.layers[this.transformIndex].image.width, this.layers[this.transformIndex].image.height, this.imageWidth, this.imageHeight, 1);
                this.freeTransform.setSize(fit.width, fit.height);
                this.freeTransform.setPos({
                    x: fit.width / 2,
                    y: fit.height / 2
                });
                this.freeTransform.setAngleDeg(0);
                this.updatePreview();
            }
        },
        {
            key: "setTransformCenter",
            value: function setTransformCenter() {
                this.freeTransform.setPos({
                    x: this.imageWidth / 2,
                    y: this.imageHeight / 2
                });
                this.freeTransform.setAngleDeg(0);
                this.updatePreview();
            }
        },
        {
            key: "setAlgorithm",
            value: function setAlgorithm(algo) {
                this.algorithm = algo;
                this.updatePreview();
            }
        },
        {
            /**
     * gives you the transformation in the original scale
     */ key: "getTransformation",
            value: function getTransformation() {
                return this.freeTransform.getValue();
            }
        },
        {
            key: "getIsPixelated",
            value: function getIsPixelated() {
                var transform = this.freeTransform.getValue();
                return this.algorithm === 'pixelated' || (0, $eWjiX.BB).testShouldPixelate(transform, transform.width / this.initTransform.width, transform.height / this.initTransform.height);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.freeTransform.destroy();
                this.preview.destroy();
                (0, $eWjiX.BB).freeCanvas(this.previewCanvas);
            }
        }
    ]);
    return FreeTransformCanvas;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");
var $de496a1759b04ed9$export$71ed2b85d4ca43d3 = /*#__PURE__*/ function() {
    "use strict";
    function Cropper(p) {
        var _this = this;
        (0, $cx0mh._)(this, Cropper);
        this.x = p.x;
        this.y = p.y;
        this.width = p.width;
        this.height = p.height;
        this.scale = p.scale;
        this.callback = p.callback;
        var maxW = p.maxW;
        var maxH = p.maxW;
        this.rootEl = (0, $eWjiX.BB).el();
        var gripCursors = [
            'nw',
            'n',
            'ne',
            'e',
            'se',
            's',
            'sw',
            'w'
        ];
        this.keyListener = new (0, $eWjiX.BB).KeyListener({});
        (0, $7jh4K.css)(this.rootEl, {
            position: 'absolute',
            left: this.x * this.scale + 'px',
            top: this.y * this.scale + 'px'
        });
        this.outline = {
            el: (0, $eWjiX.BB).el({
                css: {
                    position: 'absolute',
                    border: '1px dashed #fff',
                    cursor: 'move'
                }
            }),
            update: function() {
                (0, $7jh4K.css)(_this.outline.el, {
                    left: _this.grips[0].x * _this.scale - 1 + 'px',
                    top: _this.grips[0].y * _this.scale - 1 + 'px',
                    width: (_this.grips[2].x - _this.grips[0].x) * _this.scale + 'px',
                    height: (_this.grips[2].y - _this.grips[0].y) * _this.scale + 'px'
                });
            }
        };
        this.pointerRemainder = {
            // needs to be reset after dragging complete
            x: 0,
            y: 0
        };
        this.outlinePointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.outline.el,
            onPointer: function(event) {
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    var _BB_intDxy = (0, $eWjiX.BB).intDxy(_this.pointerRemainder, event.dX / _this.scale, event.dY / _this.scale), dX = _BB_intDxy.dX, dY = _BB_intDxy.dY;
                    _this.grips[0].x += dX;
                    _this.grips[0].y += dY;
                    _this.grips[1].x += dX;
                    _this.grips[1].y += dY;
                    _this.grips[2].x += dX;
                    _this.grips[2].y += dY;
                    _this.grips[3].x += dX;
                    _this.grips[3].y += dY;
                    _this.update();
                }
                if (event.type === 'pointerup') _this.commit();
            }
        });
        this.thirdsHorizontal = {
            el: (0, $eWjiX.BB).el({
                css: {
                    position: 'absolute',
                    borderTop: '1px solid #0ff',
                    borderBottom: '1px solid #0ff'
                }
            }),
            update: function() {
                (0, $7jh4K.css)(_this.thirdsHorizontal.el, {
                    left: _this.grips[0].x * _this.scale + 'px',
                    top: (_this.grips[0].y + (_this.grips[2].y - _this.grips[0].y) / 3) * _this.scale + 'px',
                    width: (_this.grips[2].x - _this.grips[0].x) * _this.scale + 'px',
                    height: (_this.grips[2].y - _this.grips[0].y) / 3 * _this.scale + 'px'
                });
            }
        };
        this.thirdsVertical = {
            el: (0, $eWjiX.BB).el({
                css: {
                    position: 'absolute',
                    borderLeft: '1px solid #0ff',
                    borderRight: '1px solid #0ff'
                }
            }),
            update: function() {
                (0, $7jh4K.css)(_this.thirdsVertical.el, {
                    left: (_this.grips[0].x + (_this.grips[2].x - _this.grips[0].x) / 3) * _this.scale + 'px',
                    top: _this.grips[0].y * _this.scale + 'px',
                    width: (_this.grips[2].x - _this.grips[0].x) / 3 * _this.scale + 'px',
                    height: (_this.grips[2].y - _this.grips[0].y) * _this.scale + 'px'
                });
            }
        };
        var gripSize = 40;
        var gripOverlay = 10;
        if (p.init) this.grips = [
            {
                x: p.init.x1,
                y: p.init.y1
            },
            {
                x: p.init.x2,
                y: p.init.y1
            },
            {
                x: p.init.x2,
                y: p.init.y2
            },
            {
                x: p.init.x1,
                y: p.init.y2
            }
        ];
        else this.grips = [
            {
                x: 0,
                y: 0
            },
            {
                x: this.width,
                y: 0
            },
            {
                x: this.width,
                y: this.height
            },
            {
                x: 0,
                y: this.height
            }
        ];
        var transformTop = function(dY) {
            _this.grips[0].y += dY;
            _this.grips[0].y = (0, $eWjiX.BB).clamp(_this.grips[0].y, _this.grips[3].y - maxH, _this.grips[3].y - 1);
            _this.grips[1].y = _this.grips[0].y;
        };
        var transformRight = function(dX) {
            _this.grips[1].x += dX;
            _this.grips[1].x = (0, $eWjiX.BB).clamp(_this.grips[1].x, _this.grips[0].x + 1, _this.grips[0].x + maxW);
            _this.grips[2].x = _this.grips[1].x;
        };
        var transformBottom = function(dY) {
            _this.grips[2].y += dY;
            _this.grips[2].y = (0, $eWjiX.BB).clamp(_this.grips[2].y, _this.grips[1].y + 1, _this.grips[1].y + maxH);
            _this.grips[3].y = _this.grips[2].y;
        };
        var transformLeft = function(dX) {
            _this.grips[0].x += dX;
            _this.grips[0].x = (0, $eWjiX.BB).clamp(_this.grips[0].x, _this.grips[1].x - maxW, _this.grips[1].x - 1);
            _this.grips[3].x = _this.grips[0].x;
        };
        this.edges = [];
        for(var i = 0; i < 4; i++)(function(i) {
            var el = (0, $eWjiX.BB).el({
                css: {
                    width: gripSize + 'px',
                    height: gripSize + 'px',
                    //background: '#0f0',
                    position: 'absolute'
                }
            });
            var update = function() {
                if (i === 0) //top
                (0, $7jh4K.css)(el, {
                    left: _this.grips[0].x * _this.scale + gripOverlay + 'px',
                    top: _this.grips[0].y * _this.scale - gripSize * 2 + gripOverlay + 'px',
                    width: (_this.grips[1].x - _this.grips[0].x) * _this.scale - gripOverlay * 2 + 'px',
                    height: gripSize * 2 + 'px'
                });
                else if (i === 1) //right
                (0, $7jh4K.css)(el, {
                    left: _this.grips[1].x * _this.scale - gripOverlay + 'px',
                    top: _this.grips[1].y * _this.scale + gripOverlay + 'px',
                    width: gripSize * 2 + 'px',
                    height: (_this.grips[2].y - _this.grips[1].y) * _this.scale - gripOverlay * 2 + 'px'
                });
                else if (i === 2) //bottom
                (0, $7jh4K.css)(el, {
                    left: _this.grips[3].x * _this.scale + gripOverlay + 'px',
                    top: _this.grips[3].y * _this.scale - gripOverlay + 'px',
                    width: (_this.grips[2].x - _this.grips[3].x) * _this.scale - gripOverlay * 2 + 'px',
                    height: gripSize * 2 + 'px'
                });
                else if (i === 3) //left
                (0, $7jh4K.css)(el, {
                    left: _this.grips[0].x * _this.scale - gripSize * 2 + gripOverlay + 'px',
                    top: _this.grips[0].y * _this.scale + gripOverlay + 'px',
                    width: gripSize * 2 + 'px',
                    height: (_this.grips[3].y - _this.grips[0].y) * _this.scale - gripOverlay * 2 + 'px'
                });
                var angleOffset = i * 2 + 1;
                el.style.cursor = gripCursors[angleOffset] + '-resize';
            };
            _this.edges[i] = {
                el: el,
                update: update
            };
        })(i);
        this.darken = [];
        for(var i1 = 0; i1 < 4; i1++)(function(i) {
            var g = (0, $eWjiX.BB).el({
                css: {
                    position: 'absolute',
                    background: '#000',
                    opacity: '0.5'
                }
            });
            var update = function() {
                if (i === 0) (0, $7jh4K.css)(g, {
                    left: _this.grips[0].x * _this.scale + 'px',
                    top: _this.grips[0].y * _this.scale - 8000 + 'px',
                    width: (_this.grips[1].x - _this.grips[0].x) * _this.scale + 'px',
                    height: '8000px'
                });
                else if (i === 1) (0, $7jh4K.css)(g, {
                    left: _this.grips[1].x * _this.scale + 'px',
                    top: _this.grips[1].y * _this.scale - 8000 + 'px',
                    width: '8000px',
                    height: "16000px"
                });
                else if (i === 2) (0, $7jh4K.css)(g, {
                    left: _this.grips[3].x * _this.scale + 'px',
                    top: _this.grips[3].y * _this.scale + 'px',
                    width: (_this.grips[2].x - _this.grips[3].x) * _this.scale + 'px',
                    height: '8000px'
                });
                else if (i === 3) (0, $7jh4K.css)(g, {
                    left: _this.grips[0].x * _this.scale - 8000 + 'px',
                    top: _this.grips[0].y * _this.scale - 8000 + 'px',
                    width: '8000px',
                    height: "16000px"
                });
            };
            _this.darken[i] = {
                el: g,
                update: update
            };
        })(i1);
        this.edge0PointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.edges[0].el,
            fixScribble: true,
            onPointer: function(event) {
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    var dY = (0, $eWjiX.BB).intDxy(_this.pointerRemainder, event.dX / _this.scale, event.dY / _this.scale).dY;
                    transformTop(dY);
                    if (_this.keyListener.isPressed('shift')) transformBottom(-dY);
                    _this.update();
                }
                if (event.type === 'pointerup') _this.commit();
            }
        });
        this.edge1PointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.edges[1].el,
            fixScribble: true,
            onPointer: function(event) {
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    var _BB_intDxy = (0, $eWjiX.BB).intDxy(_this.pointerRemainder, event.dX / _this.scale, event.dY / _this.scale), dX = _BB_intDxy.dX, dY = _BB_intDxy.dY;
                    transformRight(dX);
                    if (_this.keyListener.isPressed('shift')) transformLeft(-dX);
                    _this.update();
                }
                if (event.type === 'pointerup') _this.commit();
            }
        });
        this.edge2PointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.edges[2].el,
            fixScribble: true,
            onPointer: function(event) {
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    var _BB_intDxy = (0, $eWjiX.BB).intDxy(_this.pointerRemainder, event.dX / _this.scale, event.dY / _this.scale), dX = _BB_intDxy.dX, dY = _BB_intDxy.dY;
                    transformBottom(dY);
                    if (_this.keyListener.isPressed('shift')) transformTop(-dY);
                    _this.update();
                }
                if (event.type === 'pointerup') _this.commit();
            }
        });
        this.edge3PointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.edges[3].el,
            fixScribble: true,
            onPointer: function(event) {
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    var _BB_intDxy = (0, $eWjiX.BB).intDxy(_this.pointerRemainder, event.dX / _this.scale, event.dY / _this.scale), dX = _BB_intDxy.dX, dY = _BB_intDxy.dY;
                    transformLeft(dX);
                    if (_this.keyListener.isPressed('shift')) transformRight(-dX);
                    _this.update();
                }
                if (event.type === 'pointerup') _this.commit();
            }
        });
        this.cornerElArr = [];
        (function() {
            for(var i = 0; i < 4; i++)(function(i) {
                var g = (0, $eWjiX.BB).el({
                    css: {
                        //background: '#f00',
                        width: gripSize * 2 + 'px',
                        height: gripSize * 2 + 'px',
                        position: 'absolute',
                        cursor: [
                            'nwse-resize',
                            'nesw-resize'
                        ][i % 2]
                    }
                });
                var update = function() {
                    if (i === 0) //top left
                    (0, $7jh4K.css)(g, {
                        left: _this.grips[0].x * _this.scale - gripSize * 2 + gripOverlay + 'px',
                        top: _this.grips[0].y * _this.scale - gripSize * 2 + gripOverlay + 'px'
                    });
                    else if (i === 1) //top right
                    (0, $7jh4K.css)(g, {
                        left: _this.grips[1].x * _this.scale - gripOverlay + 'px',
                        top: _this.grips[1].y * _this.scale - gripSize * 2 + gripOverlay + 'px'
                    });
                    else if (i === 2) //bottom right
                    (0, $7jh4K.css)(g, {
                        left: _this.grips[1].x * _this.scale - gripOverlay + 'px',
                        top: _this.grips[2].y * _this.scale - gripOverlay + 'px'
                    });
                    else if (i === 3) //bottom left
                    (0, $7jh4K.css)(g, {
                        left: _this.grips[0].x * _this.scale - gripSize * 2 + gripOverlay + 'px',
                        top: _this.grips[2].y * _this.scale - gripOverlay + 'px'
                    });
                };
                _this.cornerElArr[i] = {
                    el: g,
                    update: update
                };
            })(i);
        })();
        //top left
        this.corner0PointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.cornerElArr[0].el,
            fixScribble: true,
            onPointer: function(event) {
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    var _BB_intDxy = (0, $eWjiX.BB).intDxy(_this.pointerRemainder, event.dX / _this.scale, event.dY / _this.scale), dX = _BB_intDxy.dX, dY = _BB_intDxy.dY;
                    transformLeft(dX);
                    transformTop(dY);
                    if (_this.keyListener.isPressed('shift')) {
                        transformRight(-dX);
                        transformBottom(-dY);
                    }
                    _this.update();
                }
                if (event.type === 'pointerup') _this.commit();
            }
        });
        //top right
        this.corner1PointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.cornerElArr[1].el,
            fixScribble: true,
            onPointer: function(event) {
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    var _BB_intDxy = (0, $eWjiX.BB).intDxy(_this.pointerRemainder, event.dX / _this.scale, event.dY / _this.scale), dX = _BB_intDxy.dX, dY = _BB_intDxy.dY;
                    transformRight(dX);
                    transformTop(dY);
                    if (_this.keyListener.isPressed('shift')) {
                        transformLeft(-dX);
                        transformBottom(-dY);
                    }
                    _this.update();
                }
                if (event.type === 'pointerup') _this.commit();
            }
        });
        //bottom right
        this.corner2PointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.cornerElArr[2].el,
            fixScribble: true,
            onPointer: function(event) {
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    var _BB_intDxy = (0, $eWjiX.BB).intDxy(_this.pointerRemainder, event.dX / _this.scale, event.dY / _this.scale), dX = _BB_intDxy.dX, dY = _BB_intDxy.dY;
                    transformRight(dX);
                    transformBottom(dY);
                    if (_this.keyListener.isPressed('shift')) {
                        transformLeft(-dX);
                        transformTop(-dY);
                    }
                    _this.update();
                }
                if (event.type === 'pointerup') _this.commit();
            }
        });
        //bottom left
        this.corner3PointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.cornerElArr[3].el,
            fixScribble: true,
            onPointer: function(event) {
                event.eventPreventDefault();
                if (event.type === 'pointermove' && event.button === 'left') {
                    var _BB_intDxy = (0, $eWjiX.BB).intDxy(_this.pointerRemainder, event.dX / _this.scale, event.dY / _this.scale), dX = _BB_intDxy.dX, dY = _BB_intDxy.dY;
                    transformLeft(dX);
                    transformBottom(dY);
                    if (_this.keyListener.isPressed('shift')) {
                        transformRight(-dX);
                        transformTop(-dY);
                    }
                    _this.update();
                }
                if (event.type === 'pointerup') _this.commit();
            }
        });
        this.rootEl.append(this.darken[1].el, this.darken[0].el, this.darken[2].el, this.darken[3].el, this.thirdsHorizontal.el, this.thirdsVertical.el, this.outline.el, this.edges[1].el, this.edges[0].el, this.edges[2].el, this.edges[3].el, this.cornerElArr[0].el, this.cornerElArr[1].el, this.cornerElArr[2].el, this.cornerElArr[3].el);
        this.update();
    }
    (0, $7h4XF._)(Cropper, [
        {
            key: "update",
            value: function update() {
                this.edges[0].update();
                this.edges[1].update();
                this.edges[2].update();
                this.edges[3].update();
                this.cornerElArr[0].update();
                this.cornerElArr[1].update();
                this.cornerElArr[2].update();
                this.cornerElArr[3].update();
                this.darken[0].update();
                this.darken[1].update();
                this.darken[2].update();
                this.darken[3].update();
                this.outline.update();
                this.thirdsHorizontal.update();
                this.thirdsVertical.update();
            }
        },
        {
            key: "commit",
            value: function commit() {
                this.pointerRemainder.x = 0;
                this.pointerRemainder.y = 0;
                this.callback(this.getTransform());
            }
        },
        {
            // ---- interface ----
            key: "getTransform",
            value: function getTransform() {
                this.grips[1].x -= this.grips[0].x;
                this.grips[1].y -= this.grips[0].y;
                this.grips[2].x -= this.grips[0].x;
                this.grips[2].y -= this.grips[0].y;
                this.grips[3].x -= this.grips[0].x;
                this.grips[3].y -= this.grips[0].y;
                this.x += this.grips[0].x;
                this.y += this.grips[0].y;
                this.grips[0].x = 0;
                this.grips[0].y = 0;
                return {
                    x: this.x,
                    y: this.y,
                    width: this.grips[1].x,
                    height: this.grips[2].y
                };
            }
        },
        {
            key: "setTransform",
            value: function setTransform(p) {
                this.x = p.x;
                this.y = p.y;
                this.width = p.width;
                this.height = p.height;
                (0, $7jh4K.css)(this.rootEl, {
                    left: this.x * this.scale + 'px',
                    top: this.y * this.scale + 'px'
                });
                this.grips[0].x = 0;
                this.grips[0].y = 0;
                this.grips[1].x = this.width;
                this.grips[1].y = 0;
                this.grips[2].x = this.width;
                this.grips[2].y = this.height;
                this.grips[3].x = 0;
                this.grips[3].y = this.height;
                this.update();
                this.commit();
            }
        },
        {
            key: "setScale",
            value: function setScale(s) {
                this.scale = s;
                (0, $7jh4K.css)(this.rootEl, {
                    left: this.x * this.scale + 'px',
                    top: this.y * this.scale + 'px'
                });
                this.update();
            }
        },
        {
            key: "showThirds",
            value: function showThirds(b) {
                this.thirdsHorizontal.el.style.display = b ? 'block' : 'none';
                this.thirdsVertical.el.style.display = b ? 'block' : 'none';
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.keyListener.destroy();
                this.outlinePointerListener.destroy();
                this.corner0PointerListener.destroy();
                this.corner1PointerListener.destroy();
                this.corner2PointerListener.destroy();
                this.corner3PointerListener.destroy();
                this.edge0PointerListener.destroy();
                this.edge1PointerListener.destroy();
                this.edge2PointerListener.destroy();
                this.edge3PointerListener.destroy();
            }
        }
    ]);
    return Cropper;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");



var $7jh4K = parcelRequire("7jh4K");
var $18e69c7d4cb991e8$export$d25420b53e16716f = /*#__PURE__*/ function() {
    "use strict";
    function LayerPreview(p) {
        var _this = this;
        (0, $cx0mh._)(this, LayerPreview);
        this.animationCanvasCheckerPattern = {};
        this.largeCanvasCheckerPattern = {};
        // internally redraws with in an interval. checks history is something changed
        // this update will be animated
        // it will not be animated if the resolution changed
        // also redraws when you call updateLayer - not animated
        // syncs via updateLayer, and internally updates layer opacity via a hack
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'kl-layer-preview'
        });
        this.klHistory = p.klHistory;
        this.isPreviewVisible = true;
        this.height = 40;
        this.canvasSize = this.height - 10;
        this.largeCanvasSize = 300;
        this.lastDrawnState = -2;
        this.lastDrawnSize = {
            width: 0,
            height: 0
        };
        this.animationCanvas = (0, $eWjiX.BB).canvas(); // to help animate the transition
        this.animationCanvasCtx = (0, $eWjiX.BB).ctx(this.animationCanvas);
        this.animationLength = 30;
        this.animationCount = 0;
        this.largeCanvasIsVisible = false;
        var largeCanvasAnimationTimeout;
        var largeCanvasAnimationDurationMs = 300;
        this.uiState = p.uiState;
        // --- setup dom ---
        this.contentWrapperEl = (0, $eWjiX.BB).el({
            css: {
                display: 'flex',
                alignItems: 'center',
                height: this.height + 'px'
            }
        });
        var checkWrapper = (0, $eWjiX.BB).el({
            css: {
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                width: '23px',
                flexShrink: '0'
            }
        });
        this.checkEl = (0, $eWjiX.BB).el({
            parent: checkWrapper,
            tagName: 'input',
            css: {
                pointerEvents: 'none'
            },
            custom: {
                type: 'checkbox',
                disabled: 'true',
                name: 'layer-visible'
            }
        });
        var canvasWrapperEl = (0, $eWjiX.BB).el({
            css: {
                //background: '#f00',
                minWidth: this.height + 'px',
                height: this.height + 'px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        });
        this.canvas = (0, $eWjiX.BB).canvas(this.canvasSize, this.canvasSize);
        this.canvasCtx = (0, $eWjiX.BB).ctx(this.canvas);
        this.canvas.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-active-layer');
        var nameWrapper = (0, $eWjiX.BB).el({
            css: {
                //background: '#ff0',
                flexGrow: '1',
                paddingLeft: '10px',
                fontSize: '13px',
                overflow: 'hidden',
                position: 'relative'
            }
        });
        this.nameLabelEl = (0, $eWjiX.BB).el({
            content: '',
            css: {
                cssFloat: 'left',
                whiteSpace: 'nowrap'
            }
        });
        var clickableEl = (0, $eWjiX.BB).el({
            css: {
                // background: 'rgba(0,255,0,0.6)',
                position: 'absolute',
                left: '10px',
                top: '0',
                width: '90px',
                height: '100%'
            }
        });
        if (p.onClick) {
            clickableEl.addEventListener('click', function() {
                return p.onClick();
            }, {
                passive: false
            });
            this.canvas.addEventListener('click', function() {
                return p.onClick();
            }, {
                passive: false
            });
            checkWrapper.addEventListener('click', function() {
                return p.onClick();
            }, {
                passive: false
            });
        }
        this.opacityEl = (0, $eWjiX.BB).el({
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity') + '<br>100%',
            css: {
                minWidth: '60px',
                fontSize: '12px',
                textAlign: 'center'
            }
        });
        this.largeCanvasWrapper = (0, $eWjiX.BB).el({
            onClick: (0, $eWjiX.BB).handleClick,
            css: {
                pointerEvents: 'none',
                background: '#fff',
                position: 'absolute',
                right: '280px',
                top: '10px',
                border: '1px solid #aaa',
                boxShadow: '1px 1px 3px rgba(0,0,0,0.3)',
                transition: 'opacity ' + largeCanvasAnimationDurationMs + 'ms ease-in-out',
                userSelect: 'none',
                display: 'block',
                ['webkitTouchCallout']: 'none'
            }
        });
        this.largeCanvas = (0, $eWjiX.BB).canvas(this.largeCanvasSize, this.largeCanvasSize);
        this.largeCanvasWrapper.append(this.largeCanvas);
        this.largeCanvasCtx = (0, $eWjiX.BB).ctx(this.largeCanvas);
        (0, $7jh4K.css)(this.largeCanvas, {
            display: 'block'
        });
        canvasWrapperEl.append(this.canvas);
        nameWrapper.append(this.nameLabelEl, clickableEl);
        this.contentWrapperEl.append(checkWrapper, canvasWrapperEl, nameWrapper, this.opacityEl);
        this.rootEl.append(this.contentWrapperEl);
        this.updateCheckerPatterns();
        (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).addIsDarkListener(function() {
            _this.updateCheckerPatterns();
            _this.draw(true);
        });
        // --- update logic ---
        // cross-fade done via 2 canvases (old and new state)
        // both have checkerboard background drawn on them, both fully opaque
        // -> no "lighter" is needed for accurate cross-fading
        // label should update instantly
        this.klHistory.addListener(function() {
            _this.updateLabel();
        });
        setInterval(function() {
            if (!_this.layer) return;
            var currentState = _this.klHistory.getChangeCount();
            if (currentState === _this.lastDrawnState) return;
            _this.draw(false);
        }, 2000);
        var removeLargeCanvas = function() {
            _this.largeCanvasWrapper.remove();
        };
        var showLargeCanvas = function(b) {
            if (_this.largeCanvasIsVisible === b) return;
            clearTimeout(largeCanvasAnimationTimeout);
            _this.largeCanvasIsVisible = b;
            if (b) largeCanvasAnimationTimeout = setTimeout(function() {
                _this.drawLargeCanvas();
                _this.largeCanvasWrapper.style.opacity = '0';
                p.klRootEl.append(_this.largeCanvasWrapper);
                setTimeout(function() {
                    _this.largeCanvasWrapper.style.opacity = '1';
                }, 20);
            }, 250);
            else {
                _this.largeCanvasWrapper.style.opacity = '0';
                largeCanvasAnimationTimeout = setTimeout(removeLargeCanvas, largeCanvasAnimationDurationMs + 20);
            }
        };
        var pointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.canvas,
            onEnterLeave: function(b) {
                showLargeCanvas(b);
            }
        });
    }
    (0, $7h4XF._)(LayerPreview, [
        {
            key: "updateCheckerPatterns",
            value: function updateCheckerPatterns() {
                var checker = (0, $eWjiX.BB).createCheckerCanvas(4, (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).isDark());
                this.animationCanvasCheckerPattern = (0, $7jh4K.throwIfNull)(this.animationCanvasCtx.createPattern(checker, 'repeat'));
                this.largeCanvasCheckerPattern = (0, $7jh4K.throwIfNull)(this.canvasCtx.createPattern(checker, 'repeat'));
            }
        },
        {
            key: "animate",
            value: function animate() {
                var _this = this;
                if (this.animationCount === 0) return;
                this.animationCount--;
                this.canvasCtx.save();
                this.canvasCtx.globalAlpha = Math.pow((this.animationLength - this.animationCount) / this.animationLength, 2);
                this.canvasCtx.drawImage(this.animationCanvas, 0, 0);
                this.canvasCtx.restore();
                if (this.animationCount > 0) requestAnimationFrame(function() {
                    return _this.animate();
                });
            }
        },
        {
            key: "drawLargeCanvas",
            value: /**
     * is always instant
     */ function drawLargeCanvas() {
                if (!this.largeCanvasIsVisible || !this.layer) return;
                var layerCanvas = this.layer.canvas;
                var canvasDimensions = (0, $eWjiX.BB).fitInto(layerCanvas.width, layerCanvas.height, this.largeCanvasSize, this.largeCanvasSize, 1);
                this.largeCanvas.width = Math.round(canvasDimensions.width);
                this.largeCanvas.height = Math.round(canvasDimensions.height);
                this.largeCanvasCtx.save();
                if (this.largeCanvas.width > layerCanvas.width) this.largeCanvasCtx.imageSmoothingEnabled = false;
                else {
                    this.largeCanvasCtx.imageSmoothingEnabled = true;
                    this.largeCanvasCtx.imageSmoothingQuality = 'high';
                }
                this.largeCanvasCtx.fillStyle = this.largeCanvasCheckerPattern;
                this.largeCanvasCtx.fillRect(0, 0, this.largeCanvas.width, this.largeCanvas.height);
                this.largeCanvasCtx.drawImage(layerCanvas, 0, 0, this.largeCanvas.width, this.largeCanvas.height);
                this.largeCanvasCtx.restore();
                var bounds = this.rootEl.getBoundingClientRect();
                (0, $7jh4K.css)(this.largeCanvasWrapper, {
                    top: Math.max(10, bounds.top + this.height / 2 - this.largeCanvas.height / 2) + 'px'
                });
            }
        },
        {
            key: "updateLabel",
            value: function updateLabel() {
                if (!this.isPreviewVisible || !this.layer) return;
                var layerIsVisible = this.layer.isVisible;
                this.checkEl.parentElement.title = layerIsVisible ? (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-active-layer-visible') : (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-active-layer-hidden');
                this.checkEl.checked = layerIsVisible;
                this.checkEl.style.boxShadow = layerIsVisible ? '' : '0 0 0 1px red';
                this.nameLabelEl.textContent = this.layer.name;
                if (this.layer.isVisible) this.opacityEl.innerHTML = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity') + '<br>' + Math.round(this.layer.opacity * 100) + '%';
                else this.opacityEl.innerHTML = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity') + '<br><s>' + Math.round(this.layer.opacity * 100) + '%</s>';
            }
        },
        {
            key: "draw",
            value: function draw(isInstant) {
                if (!this.isPreviewVisible || !this.layer) return;
                this.updateLabel();
                var layerCanvas = this.layer.canvas;
                if (layerCanvas.width !== this.lastDrawnSize.width || layerCanvas.height !== this.lastDrawnSize.height) {
                    var canvasDimensions = (0, $eWjiX.BB).fitInto(layerCanvas.width, layerCanvas.height, this.canvasSize, this.canvasSize, 1);
                    this.canvas.width = Math.round(canvasDimensions.width);
                    this.canvas.height = Math.round(canvasDimensions.height);
                    isInstant = true; // can't animate when size changed
                }
                this.animationCanvas.width = this.canvas.width;
                this.animationCanvas.height = this.canvas.height;
                this.animationCanvasCtx.save();
                this.animationCanvasCtx.imageSmoothingEnabled = false;
                this.animationCanvasCtx.fillStyle = this.animationCanvasCheckerPattern;
                this.animationCanvasCtx.fillRect(0, 0, this.animationCanvas.width, this.animationCanvas.height);
                this.animationCanvasCtx.drawImage(layerCanvas, 0, 0, this.animationCanvas.width, this.animationCanvas.height);
                this.animationCanvasCtx.restore();
                if (isInstant) {
                    this.animationCount = 0;
                    this.canvasCtx.save();
                    this.canvasCtx.drawImage(this.animationCanvas, 0, 0);
                    this.canvasCtx.restore();
                } else {
                    this.animationCount = this.animationLength;
                    this.animate();
                }
                this.drawLargeCanvas();
                this.lastDrawnState = this.klHistory.getChangeCount();
                this.lastDrawnSize.width = layerCanvas.width;
                this.lastDrawnSize.height = layerCanvas.height;
            }
        },
        {
            // ---- interface ----
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "setIsVisible",
            value: function setIsVisible(b) {
                if (this.isPreviewVisible === b) return;
                this.isPreviewVisible = b;
                this.contentWrapperEl.style.display = this.isPreviewVisible ? 'flex' : 'none';
                this.rootEl.style.marginBottom = this.isPreviewVisible ? '' : '10px';
                var currentState = this.klHistory.getChangeCount();
                if (b && this.lastDrawnState !== currentState) this.draw(true);
            }
        },
        {
            //when the layer might have changed
            key: "setLayer",
            value: function setLayer(layer) {
                this.layer = layer;
                this.draw(true);
            }
        },
        {
            key: "setUiState",
            value: function setUiState(stateStr) {
                this.uiState = stateStr;
                if (this.uiState === 'left') (0, $7jh4K.css)(this.largeCanvasWrapper, {
                    left: '280px',
                    right: ''
                });
                else (0, $7jh4K.css)(this.largeCanvasWrapper, {
                    left: '',
                    right: '280px'
                });
            }
        }
    ]);
    return LayerPreview;
}();



var $eWjiX = parcelRequire("eWjiX");



function $042ba564475611dc$export$8f6817a932bf45cd() {
    return window.innerWidth < 550;
}


var $a433d11ad38d7c38$export$ec2d17c6d3ae0768 = {
    width: 340,
    height: 220
};
var $a433d11ad38d7c38$export$3a4a74a7d8c44e62 = {
    width: 540,
    height: 300
};
function $a433d11ad38d7c38$export$8b9199c1f5e4be8(isSmall) {
    return isSmall ? $a433d11ad38d7c38$export$ec2d17c6d3ae0768.width : $a433d11ad38d7c38$export$3a4a74a7d8c44e62.width;
}
function $a433d11ad38d7c38$export$94cffdbcf128864a(isSmall) {
    return isSmall ? $a433d11ad38d7c38$export$ec2d17c6d3ae0768.height : $a433d11ad38d7c38$export$3a4a74a7d8c44e62.height;
}




var $7jh4K = parcelRequire("7jh4K");
function $e3dfa43019bc3f08$export$962af7e240721d88(params) {
    var div = document.createElement('div');
    (0, $eWjiX.BB).appendTextDiv(div, (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-as-layer-description'));
    if (params.klCanvas.isLayerLimitReached()) {
        var noteEl = (0, $eWjiX.BB).el({
            className: 'kl-import-note',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-as-layer-limit-reached')
        });
        div.append(noteEl);
    }
    var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
    var buttonRowEl = (0, $eWjiX.BB).el({
        css: {
            display: 'flex'
        }
    });
    var originalSizeBtn = (0, $eWjiX.BB).el({
        tagName: 'button',
        content: '1:1',
        css: {
            marginRight: '10px'
        },
        onClick: function onClick() {
            freeTransformCanvas.reset();
        }
    });
    var fitSizeBtn = (0, $eWjiX.BB).el({
        tagName: 'button',
        content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-as-layer-fit'),
        css: {
            marginRight: '10px'
        },
        onClick: function onClick() {
            freeTransformCanvas.setTransformFit();
        }
    });
    var centerBtn = (0, $eWjiX.BB).el({
        tagName: 'button',
        content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('center'),
        css: {
            marginRight: '10px'
        },
        onClick: function onClick() {
            freeTransformCanvas.setTransformCenter();
        }
    });
    var algorithmSelect = new (0, $7a3263857aacf58f$export$ef9b1a59e592288f)({
        isFocusable: true,
        optionArr: [
            [
                'smooth',
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('algorithm-smooth')
            ],
            [
                'pixelated',
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('algorithm-pixelated')
            ]
        ],
        initValue: 'smooth',
        title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('scaling-algorithm'),
        onChange: function(val) {
            freeTransformCanvas.setAlgorithm(val);
        },
        name: 'interpolation-algorithm'
    });
    buttonRowEl.append(originalSizeBtn, fitSizeBtn, centerBtn, (0, $eWjiX.BB).el({
        css: {
            flexGrow: '1'
        }
    }), algorithmSelect.getElement());
    div.append(buttonRowEl);
    var layers = [];
    {
        var klCanvasLayerArr = params.klCanvas.getLayers();
        for(var i = 0; i < klCanvasLayerArr.length; i++)layers.push({
            image: klCanvasLayerArr[i].context.canvas,
            isVisible: klCanvasLayerArr[i].isVisible,
            opacity: klCanvasLayerArr[i].opacity,
            mixModeStr: klCanvasLayerArr[i].mixModeStr
        });
    }
    layers.push({
        image: params.importImage,
        isVisible: true,
        opacity: 1,
        mixModeStr: 'source-over'
    });
    var freeTransformCanvas = new (0, $48f5d87739d28bf9$export$205c2dd29f8a66b5)({
        elementWidth: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
        elementHeight: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall) + 50,
        imageWidth: params.klCanvas.getLayerContext(0).canvas.width,
        imageHeight: params.klCanvas.getLayerContext(0).canvas.height,
        layers: layers,
        transformIndex: layers.length - 1
    });
    (0, $7jh4K.css)(freeTransformCanvas.getElement(), {
        marginTop: '10px',
        marginLeft: '-20px'
    });
    div.append(freeTransformCanvas.getElement());
    function move(x, y) {
        freeTransformCanvas.move(x, y);
    }
    var keyListener = new (0, $eWjiX.BB).KeyListener({
        onDown: function onDown(keyStr) {
            if (keyStr === 'left') move(-1, 0);
            if (keyStr === 'right') move(1, 0);
            if (keyStr === 'up') move(0, -1);
            if (keyStr === 'down') move(0, 1);
        }
    });
    (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-as-layer-title')}</b>`,
        div: div,
        style: isSmall ? undefined : {
            width: '540px'
        },
        buttons: [
            'Ok',
            'Cancel'
        ],
        clickOnEnter: 'Ok',
        callback: function callback(buttonStr) {
            keyListener.destroy();
            freeTransformCanvas.destroy();
            (0, $eWjiX.BB).destroyEl(originalSizeBtn);
            (0, $eWjiX.BB).destroyEl(fitSizeBtn);
            (0, $eWjiX.BB).destroyEl(centerBtn);
            if (buttonStr === 'Ok') params.callback(freeTransformCanvas.getTransformation(), freeTransformCanvas.getIsPixelated());
            else params.callback();
        }
    });
}



var $cx0mh = parcelRequire("cx0mh");

var $eWjiX = parcelRequire("eWjiX");

var $01cb8095758db224$export$e789742143ba5b1 = function KlImageDropper(p) {
    "use strict";
    var _this = this;
    (0, $cx0mh._)(this, KlImageDropper);
    //set up DOM
    this.rootEl = (0, $eWjiX.BB).el({
        content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('dropper-drop'),
        css: {
            paddingTop: '100px',
            position: 'fixed',
            left: '0',
            top: '0',
            width: '100%',
            height: '100%',
            background: 'rgba(50, 50, 50, 0.7)',
            color: '#fff',
            textShadow: '2px 2px #000',
            textAlign: 'center',
            fontSize: '25px'
        }
    });
    var wrapperEl = (0, $eWjiX.BB).el({
        css: {
            marginTop: '50px',
            display: 'flex',
            justifyContent: 'center'
        }
    });
    var optionStyle = {
        width: '200px',
        padding: '50px',
        margin: '10px',
        //opacity: 0.5,
        borderRadius: '20px',
        border: '1px dashed #fff',
        background: '#00aefe',
        fontWeight: 'bold'
    };
    var optionLayerEl = (0, $eWjiX.BB).el({
        content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('dropper-as-layer'),
        css: optionStyle
    });
    var optionImageEl = (0, $eWjiX.BB).el({
        content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('dropper-as-image'),
        css: optionStyle
    });
    this.rootEl.append(wrapperEl);
    wrapperEl.append(optionLayerEl, optionImageEl);
    var rootCounter = 0;
    var optionLayerCounter = 0;
    var optionImageCounter = 0;
    var destroy = function() {
        rootCounter = 0;
        optionLayerCounter = 0;
        optionImageCounter = 0;
        _this.rootEl.remove();
    };
    /**
         * check, can drop content be imported
         */ var testAcceptType = function(event) {
        return !!event.dataTransfer && !event.dataTransfer.types.includes('text/plain');
    };
    var updateOptions = function() {
        var boxShadow = '0 0 20px 4px #fff';
        if (optionLayerCounter > 0) {
            optionLayerEl.style.boxShadow = boxShadow;
            optionImageEl.style.boxShadow = '';
        } else if (optionImageCounter > 0) {
            optionLayerEl.style.boxShadow = '';
            optionImageEl.style.boxShadow = boxShadow;
        } else {
            optionLayerEl.style.boxShadow = '';
            optionImageEl.style.boxShadow = '';
        }
    };
    optionLayerEl.addEventListener('dragenter', function() {
        optionLayerCounter++;
        updateOptions();
    }, {
        passive: false
    });
    optionLayerEl.addEventListener('dragleave', function() {
        optionLayerCounter--;
        updateOptions();
    }, {
        passive: false
    });
    optionImageEl.addEventListener('dragenter', function() {
        optionImageCounter++;
        updateOptions();
    }, {
        passive: false
    });
    optionImageEl.addEventListener('dragleave', function() {
        optionImageCounter--;
        updateOptions();
    }, {
        passive: false
    });
    var rootDragOver = function(event) {
        if (!testAcceptType(event)) return;
        event.stopPropagation();
        event.preventDefault();
    };
    var rootDragEnter = function(event) {
        if (!p.enabledTest() || !testAcceptType(event)) return;
        if (rootCounter === 0) p.target.append(_this.rootEl);
        rootCounter++;
    };
    var rootDragLeave = function(event) {
        if (!testAcceptType(event) || rootCounter === 0) return;
        rootCounter = Math.max(0, rootCounter - 1);
        if (rootCounter === 0) _this.rootEl.remove();
    };
    var rootDrop = function(event) {
        if (!testAcceptType(event) || !event.dataTransfer || event.dataTransfer.files.length === 0) {
            destroy();
            return;
        }
        event.stopPropagation();
        event.preventDefault();
        var optionStr = 'default';
        if (optionLayerCounter > 0) optionStr = 'layer';
        else if (optionImageCounter > 0) optionStr = 'image';
        p.onDrop(event.dataTransfer.files, optionStr);
        if (rootCounter > 0) _this.rootEl.remove();
        rootCounter = 0;
        optionLayerCounter = 0;
        optionImageCounter = 0;
        updateOptions();
    };
    window.addEventListener('dragover', rootDragOver, {
        passive: false
    });
    window.addEventListener('dragenter', rootDragEnter, {
        passive: false
    });
    window.addEventListener('dragleave', rootDragLeave, {
        passive: false
    });
    window.addEventListener('drop', rootDrop, {
        passive: false
    });
    // if something goes wrong and you're stuck with overlay
    this.rootEl.addEventListener('pointerdown', function() {
        destroy();
    }, {
        passive: false
    });
    var keyListener = new (0, $eWjiX.BB).KeyListener({
        onDown: function(keyStr) {
            if (rootCounter > 0 && keyStr === 'esc') destroy();
        }
    });
};



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");




var $7jh4K = parcelRequire("7jh4K");
var $d6fe881e8fc421ac$export$9f0da9b942594e99 = /*#__PURE__*/ function() {
    "use strict";
    function OverlayToolspace(p) {
        var _this = this;
        (0, $cx0mh._)(this, OverlayToolspace);
        var sizeObj = {
            width: 150,
            svHeight: 90,
            hHeight: 20,
            sliderHeight: 25
        };
        var isVisible = false;
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'kl-overlay-toolspace'
        });
        var queuedObj = {
            color: null,
            size: null,
            opacity: null
        };
        // --- inputs ---
        //color selection
        var colorEl = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            className: 'kl-overlay-toolspace__color'
        });
        var colorSlider = new (0, $3ce0af1e789f1ab4$export$66306bf21a9ff39e)({
            width: sizeObj.width,
            heightSV: sizeObj.svHeight,
            heightH: sizeObj.hHeight,
            color: p.brushSettingService.getColor(),
            callback: function(rgbObj) {
                selectedColorEl.style.backgroundColor = 'rgb(' + rgbObj.r + ',' + rgbObj.g + ',' + rgbObj.b + ')';
                p.brushSettingService.setColor(rgbObj, subscriptionFunc);
            }
        });
        var selectedColorEl = (0, $eWjiX.BB).el({
            css: {
                width: sizeObj.width + 'px',
                height: sizeObj.hHeight + 'px',
                pointerEvents: 'none'
            }
        });
        {
            var initialColor = p.brushSettingService.getColor();
            selectedColorEl.style.backgroundColor = 'rgb(' + initialColor.r + ',' + initialColor.g + ',' + initialColor.b + ')';
        }
        colorEl.append(selectedColorEl, colorSlider.getElement());
        var updateColor = function(rgbObj) {
            colorSlider.setColor(rgbObj);
            selectedColorEl.style.backgroundColor = 'rgb(' + rgbObj.r + ',' + rgbObj.g + ',' + rgbObj.b + ')';
        };
        //brushsize slider
        var sizeSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-size'),
            width: sizeObj.width,
            height: sizeObj.sliderHeight,
            min: 0,
            max: 500,
            value: 50,
            resolution: 225,
            eventResMs: 1000 / 30,
            toDisplayValue: function(val) {
                return val * 2;
            },
            toValue: function(displayValue) {
                return displayValue / 2;
            },
            onChange: function(v) {
                p.brushSettingService.setSize(v);
            },
            formatFunc: function(displayValue) {
                if (displayValue < 10) return (0, $eWjiX.BB).round(displayValue, 1);
                else return Math.round(displayValue);
            }
        });
        (0, $7jh4K.css)(sizeSlider.getElement(), {
            marginTop: '2px'
        });
        var opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
            width: sizeObj.width,
            height: sizeObj.sliderHeight,
            min: 0,
            max: 1,
            value: 1,
            resolution: 225,
            eventResMs: 1000 / 30,
            toDisplayValue: function(val) {
                return val * 100;
            },
            toValue: function(displayValue) {
                return displayValue / 100;
            },
            onChange: function(v) {
                p.brushSettingService.setOpacity(v);
            }
        });
        (0, $7jh4K.css)(opacitySlider.getElement(), {
            margin: '2px 0'
        });
        this.rootEl.append(sizeSlider.getElement(), opacitySlider.getElement());
        // --- general setup ---
        var subscriptionFunc = function(event) {
            if (event.type === 'color') {
                if (!isVisible) queuedObj.color = event.value;
                else updateColor(event.value);
            }
            if (event.type === 'size') {
                if (!isVisible) queuedObj.size = event.value;
                else sizeSlider.setValue(event.value);
            }
            if (event.type === 'opacity') {
                if (!isVisible) queuedObj.opacity = event.value;
                else opacitySlider.setValue(event.value);
            }
            if (event.type === 'sliderConfig') {
                sizeSlider.update(event.value.sizeSlider);
                opacitySlider.update(event.value.opacitySlider);
            }
        };
        p.brushSettingService.subscribe(subscriptionFunc);
        {
            var sliderConfig = p.brushSettingService.getSliderConfig();
            sizeSlider.update(sliderConfig.sizeSlider);
            opacitySlider.update(sliderConfig.opacitySlider);
            sizeSlider.setValue(p.brushSettingService.getSize());
            opacitySlider.setValue(p.brushSettingService.getOpacity());
        }
        var updateUI = function() {
            // unfocus manual slider input
            (0, $eWjiX.BB).unfocusAnyInput();
            _this.rootEl.style.display = isVisible ? 'block' : 'none';
            if (isVisible && mousePos) (0, $7jh4K.css)(_this.rootEl, {
                left: mousePos.x - Math.round(sizeObj.width / 2) + 'px',
                top: mousePos.y - Math.round(sizeObj.svHeight + sizeObj.hHeight * 3 / 2) + 'px'
            });
        };
        var mousePos = null;
        document.addEventListener('pointermove', function(event) {
            mousePos = {
                x: event.pageX,
                y: event.pageY
            };
        }, {
            passive: false
        });
        var keyListener = new (0, $eWjiX.BB).KeyListener({
            onDown: function(keyStr, event, comboStr, isRepeat) {
                if (isRepeat) return;
                if (isVisible) {
                    isVisible = false;
                    updateUI();
                    return;
                }
                if (!p.enabledTest() || !mousePos) return;
                if ([
                    'ctrl+alt',
                    'cmd+alt',
                    'alt+ctrl',
                    'alt+cmd'
                ].includes(comboStr)) {
                    event.preventDefault();
                    isVisible = true;
                    if (queuedObj.color !== null) {
                        updateColor(queuedObj.color);
                        queuedObj.color = null;
                    }
                    if (queuedObj.size !== null) {
                        sizeSlider.setValue(queuedObj.size);
                        queuedObj.size = null;
                    }
                    if (queuedObj.opacity !== null) {
                        opacitySlider.setValue(queuedObj.opacity);
                        queuedObj.opacity = null;
                    }
                    updateUI();
                }
            },
            onUp: function(keyStr, event, oldComboStr) {
                if ([
                    'ctrl+alt',
                    'cmd+alt',
                    'alt+ctrl',
                    'alt+cmd'
                ].includes(oldComboStr) && isVisible) {
                    isVisible = false;
                    colorSlider.end();
                    updateUI();
                }
            },
            onBlur: function() {
                if (isVisible) {
                    isVisible = false;
                    colorSlider.end();
                    updateUI();
                }
            }
        });
    }
    (0, $7h4XF._)(OverlayToolspace, [
        {
            // ---- interface ----
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return OverlayToolspace;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $8f2db75412060fdc$exports = {};
$8f2db75412060fdc$exports = $parcel$resolve("eHdqz");


var $74ce9fe92d58e953$exports = {};
$74ce9fe92d58e953$exports = $parcel$resolve("3x5dR");


var $ea09e4c322d05e2e$exports = {};
$ea09e4c322d05e2e$exports = $parcel$resolve("hbDTd");


var $7ba84df17a4098f2$exports = {};
$7ba84df17a4098f2$exports = $parcel$resolve("16iGk");


var $680b545dae725a15$exports = {};
$680b545dae725a15$exports = $parcel$resolve("2ME3z");


var $5f1a2e996d986b65$exports = {};
$5f1a2e996d986b65$exports = $parcel$resolve("hZnSk");




var $7jh4K = parcelRequire("7jh4K");
var $6003e73b8cbb69e2$export$665d2c76b1eb8459 = /*#__PURE__*/ function() {
    "use strict";
    function ToolspaceTopRow(p) {
        (0, $cx0mh._)(this, ToolspaceTopRow);
        var createButton = function createButton(p) {
            var padding = 6 + (p.extraPadding ? p.extraPadding : 0);
            var el = (0, $eWjiX.BB).el({
                className: 'toolspace-row-button nohighlight',
                title: p.title,
                onClick: p.onClick,
                css: {
                    padding: p.contain ? padding + 'px 0' : ''
                }
            });
            var im = (0, $eWjiX.BB).el({
                className: p.darkInvert ? 'dark-invert' : undefined,
                css: {
                    backgroundImage: "url('" + p.image + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: p.contain ? 'contain' : '',
                    //filter: 'grayscale(1)',
                    height: '100%'
                }
            });
            im.style.pointerEvents = 'none';
            el.append(im);
            var pointerListener = new (0, $eWjiX.BB).PointerListener({
                // because :hover causes problems w touch
                target: el,
                onEnterLeave: function onEnterLeave(isOver) {
                    el.classList.toggle('toolspace-row-button-hover', isOver);
                }
            });
            return {
                el: el,
                pointerListener: pointerListener
            };
        };
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'kl-toolspace-row',
            css: {
                height: '36px',
                display: 'flex'
            }
        });
        var logoButton = createButton({
            onClick: p.onLogo,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('home'),
            image: p.logoImg ? p.logoImg : (0, (/*@__PURE__*/$parcel$interopDefault($8f2db75412060fdc$exports))),
            contain: true,
            darkInvert: true
        });
        logoButton.el.classList.add('kl-tool-row-border-right');
        (0, $7jh4K.css)(logoButton.el, {
            width: '46px'
        });
        var newButton = createButton({
            onClick: p.onNew,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-new'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($74ce9fe92d58e953$exports))),
            extraPadding: 1,
            contain: true
        });
        var importButton = createButton({
            onClick: p.onImport,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-import'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($ea09e4c322d05e2e$exports))),
            extraPadding: 1,
            contain: true
        });
        var saveButton = createButton({
            onClick: p.onSave,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-save'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($7ba84df17a4098f2$exports))),
            extraPadding: 1,
            contain: true
        });
        var shareButton = null;
        if ((0, $eWjiX.BB).canShareFiles()) shareButton = createButton({
            onClick: p.onShare,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-share'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($680b545dae725a15$exports))),
            contain: true,
            darkInvert: true
        });
        var helpButton = createButton({
            onClick: p.onHelp,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('help'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($5f1a2e996d986b65$exports))),
            contain: true,
            darkInvert: true
        });
        (0, $eWjiX.BB).append(this.rootEl, [
            logoButton.el,
            newButton.el,
            importButton.el,
            saveButton.el,
            shareButton ? shareButton.el : undefined,
            helpButton.el
        ]);
    }
    (0, $7h4XF._)(ToolspaceTopRow, [
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return ToolspaceTopRow;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $1813762111ff3b93$exports = {};
$1813762111ff3b93$exports = $parcel$resolve("6mHrC");


var $09067d6182ed3b8e$exports = {};
$09067d6182ed3b8e$exports = $parcel$resolve("hS5Hj");


var $493fdfa42d027406$exports = {};
$493fdfa42d027406$exports = $parcel$resolve("4KGfM");


var $7bad8de727b6761d$exports = {};
$7bad8de727b6761d$exports = $parcel$resolve("doX4v");


var $a931fbdaeae5b97a$exports = {};
$a931fbdaeae5b97a$exports = $parcel$resolve("7NqHO");


var $b8ba25f8f8b8d477$exports = {};
$b8ba25f8f8b8d477$exports = $parcel$resolve("kOuYd");




var $04lDo = parcelRequire("04lDo");


var $7jh4K = parcelRequire("7jh4K");
var $18c597dee53260ff$export$a0a40f8a0b8fee15 = /*#__PURE__*/ function() {
    "use strict";
    function ToolDropdown(p) {
        var _this = this;
        (0, $cx0mh._)(this, ToolDropdown);
        this.smallMargin = '6px 0';
        this.optionArr = [
            'brush',
            'paintBucket',
            'gradient',
            'text',
            'shape',
            'select'
        ];
        this.imArr = [
            (0, (/*@__PURE__*/$parcel$interopDefault($1813762111ff3b93$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($09067d6182ed3b8e$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($493fdfa42d027406$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($7bad8de727b6761d$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($a931fbdaeae5b97a$exports))),
            (0, (/*@__PURE__*/$parcel$interopDefault($b8ba25f8f8b8d477$exports)))
        ];
        this.titleArr = [
            `${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-brush')} [B]`,
            `${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-paint-bucket')} [G]`,
            `${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-gradient')} [G]`,
            `${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-text')} [T]`,
            `${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-shape')} [U]`,
            `${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-select')} [L]`
        ];
        this.currentActiveIndex = 0;
        this.isActive = true;
        var isOpen = false;
        //preload images
        setTimeout(function() {
            for(var i = 1; i < _this.imArr.length; i++){
                var im = new Image();
                im.src = _this.imArr[i];
            }
        }, 100);
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                position: 'relative',
                flexGrow: '1'
            }
        });
        var openTimeout;
        var isDragging = false;
        var startX;
        var startY;
        var pointerListener;
        if ((0, $eWjiX.BB).hasPointerEvents) pointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.rootEl,
            onPointer: function(event) {
                if (event.type === 'pointerdown') {
                    if (isOpen) return;
                    openTimeout = setTimeout(function() {
                        showDropdown();
                    }, 400);
                    isDragging = true;
                    startX = event.pageX;
                    startY = event.pageY;
                } else if (event.type === 'pointermove' && isDragging) {
                    if (!isOpen && (0, $eWjiX.BB).dist(startX, startY, event.pageX, event.pageY) > 5) {
                        clearTimeout(openTimeout);
                        showDropdown();
                    }
                } else if (event.type === 'pointerup' && isDragging) {
                    clearTimeout(openTimeout);
                    isDragging = false;
                    if (isOpen) {
                        var target = document.elementFromPoint(event.pageX, event.pageY);
                        for(var i = 0; i < _this.dropdownBtnArr.length; i++)if (target === _this.dropdownBtnArr[i].wrapper) {
                            closeDropdown();
                            _this.isActive = true;
                            _this.currentActiveIndex = i;
                            _this.updateButton();
                            p.onChange(_this.optionArr[_this.currentActiveIndex]);
                            break;
                        }
                    }
                }
            }
        });
        this.activeButton = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            className: 'toolspace-row-button nohighlight toolspace-row-button-activated',
            title: this.titleArr[this.currentActiveIndex],
            onClick: function(e) {
                if (_this.isActive && !isOpen) {
                    e.preventDefault();
                    e.stopPropagation();
                    showDropdown();
                    return;
                }
                _this.isActive = true;
                p.onChange(_this.optionArr[_this.currentActiveIndex]);
                if (isOpen) closeDropdown();
            },
            css: {
                padding: '10px 0',
                pointerEvents: 'auto',
                height: '100%',
                boxSizing: 'border-box',
                zIndex: '1'
            }
        });
        // hover via JS, so hover-state not stuck on mobile
        var activeButtonPointerListener = new (0, $04lDo.PointerListener)({
            target: this.activeButton,
            onEnterLeave: function(isOver) {
                _this.activeButton.classList.toggle('kl-tool-button--hover', isOver);
            }
        });
        this.activeButtonIm = (0, $eWjiX.BB).el({
            parent: this.activeButton,
            className: 'dark-invert',
            css: {
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                width: 'calc(100% - 7px)',
                height: '100%',
                pointerEvents: 'none',
                opacity: '0.75'
            }
        });
        this.arrowButton = (0, $eWjiX.BB).el({
            parent: this.activeButton,
            className: 'kl-tooldropdown-caret',
            content: (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('.dark-invert'),
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-more-tools'),
            onClick: function(e) {
                e.preventDefault();
                e.stopPropagation();
                showDropdown();
            }
        });
        var overlay = (0, $eWjiX.BB).el({
            css: {
                position: 'absolute',
                //background: 'rgba(255,0,0,0.5)',
                left: '0',
                top: '0',
                right: '0',
                bottom: '0'
            }
        });
        var overlayPointerListener = new (0, $eWjiX.BB).PointerListener({
            target: overlay,
            onPointer: function(e) {
                if (e.type === 'pointerdown') {
                    e.eventPreventDefault();
                    closeDropdown();
                }
            }
        });
        var dropdownWrapper = (0, $eWjiX.BB).el({
            className: 'tool-dropdown-wrapper',
            css: {
                position: 'absolute',
                width: '100%',
                height: 100 * (this.optionArr.length - 1) + '%',
                top: '100%',
                left: '0',
                zIndex: '-1',
                boxSizing: 'border-box',
                cursor: 'pointer',
                transition: 'height 0.1s ease-in-out, opacity 0.1s ease-in-out',
                borderBottomLeftRadius: '5px',
                borderBottomRightRadius: '5px',
                overflow: 'hidden'
            }
        });
        this.dropdownBtnArr = [];
        var createDropdownButton = function(p) {
            var wrapper = (0, $eWjiX.BB).el({
                parent: dropdownWrapper,
                className: 'tool-dropdown-button',
                title: p.title,
                css: {
                    padding: '10px 0',
                    height: 100 / (_this.optionArr.length - 1) + '%',
                    boxSizing: 'border-box'
                },
                onClick: function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    p.onClick(p.index);
                }
            });
            (0, $eWjiX.BB).el({
                parent: wrapper,
                className: 'dark-invert',
                css: {
                    backgroundImage: "url('" + p.image + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    height: '100%',
                    pointerEvents: 'none',
                    opacity: '0.75'
                }
            });
            // --- interface ---
            var show = function(b) {
                wrapper.style.display = b ? 'block' : 'none';
            };
            var setIsSmall = function(b) {
                wrapper.style.padding = b ? _this.smallMargin : '10px 0';
            };
            return {
                wrapper: wrapper,
                show: show,
                setIsSmall: setIsSmall
            };
        };
        var onClickDropdownBtn = function(index) {
            closeDropdown();
            _this.isActive = true;
            _this.currentActiveIndex = index;
            _this.updateButton();
            p.onChange(_this.optionArr[_this.currentActiveIndex]);
        };
        for(var i = 0; i < this.optionArr.length; i++)this.dropdownBtnArr.push(createDropdownButton({
            index: i,
            id: this.optionArr[i],
            image: this.imArr[i],
            title: this.titleArr[i],
            onClick: onClickDropdownBtn
        }));
        var showDropdown = function() {
            if ((0, $dd0d395ff14a3e11$export$d3d1650bc39c4419).get() > 0) return;
            (0, $dd0d395ff14a3e11$export$d3d1650bc39c4419).increase(0.5);
            isOpen = true;
            for(var i = 0; i < _this.optionArr.length; i++)_this.dropdownBtnArr[i].show(_this.currentActiveIndex !== i);
            _this.arrowButton.style.setProperty('opacity', '0');
            _this.arrowButton.style.setProperty('pointer-events', 'none');
            _this.rootEl.style.zIndex = '1';
            document.body.append(overlay);
            _this.rootEl.append(dropdownWrapper);
        };
        var closeDropdown = function() {
            (0, $dd0d395ff14a3e11$export$d3d1650bc39c4419).decrease(0.5);
            isOpen = false;
            _this.arrowButton.style.removeProperty('opacity');
            _this.arrowButton.style.removeProperty('pointer-events');
            _this.rootEl.style.removeProperty('z-index');
            overlay.remove();
            dropdownWrapper.remove();
        };
        this.updateButton();
    }
    (0, $7h4XF._)(ToolDropdown, [
        {
            key: "updateButton",
            value: function updateButton() {
                this.activeButton.title = this.titleArr[this.currentActiveIndex] + (this.isActive ? ' (' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-more-tools-click-again') + ')' : '');
                this.activeButtonIm.style.backgroundImage = "url('" + this.imArr[this.currentActiveIndex] + "')";
            }
        },
        {
            // ---- interface ----
            key: "setIsSmall",
            value: function setIsSmall(b) {
                this.activeButton.style.padding = b ? this.smallMargin : '10px 0';
                for(var i = 0; i < this.optionArr.length; i++)this.dropdownBtnArr[i].setIsSmall(b);
                (0, $7jh4K.css)(this.arrowButton, {
                    width: b ? '14px' : '18px',
                    height: b ? '14px' : '18px'
                });
            }
        },
        {
            key: "setActive",
            value: function setActive(activeStr) {
                if (this.optionArr.includes(activeStr)) {
                    this.isActive = true;
                    for(var i = 0; i < this.optionArr.length; i++)if (this.optionArr[i] === activeStr) {
                        this.currentActiveIndex = i;
                        break;
                    }
                    this.activeButton.classList.add('toolspace-row-button-activated');
                    this.updateButton();
                } else {
                    this.isActive = false;
                    this.activeButton.classList.remove('toolspace-row-button-activated');
                    this.updateButton();
                }
            }
        },
        {
            key: "getActive",
            value: function getActive() {
                return this.optionArr[this.currentActiveIndex];
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return ToolDropdown;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");




var $33d76dcc22e5d968$exports = {};
$33d76dcc22e5d968$exports = $parcel$resolve("AnO0a");




var $7jh4K = parcelRequire("7jh4K");
var $a372d78c806cd0cc$export$c744a22bef9e0b97 = /*#__PURE__*/ function() {
    "use strict";
    function ToolspaceToolRow(p) {
        var _this = this;
        (0, $cx0mh._)(this, ToolspaceToolRow);
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'kl-toolspace-row',
            css: {
                height: '54px',
                display: 'flex'
            }
        });
        this.onActivate = p.onActivate;
        this.currentActiveStr = 'brush';
        var createButton = function(p) {
            var smallMargin = p.doLighten ? '6px 0' : '8px 0';
            var el = (0, $eWjiX.BB).el({
                className: 'toolspace-row-button nohighlight',
                //title: p.title,
                onClick: p.onClick,
                css: {
                    padding: p.contain ? '10px 0' : ''
                }
            });
            var im = (0, $eWjiX.BB).el({
                className: 'dark-invert',
                css: {
                    backgroundImage: "url('" + p.image + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: p.contain ? 'contain' : '',
                    //filter: 'grayscale(1)',
                    height: '100%',
                    transform: p.doMirror ? 'scale(-1, 1)' : '',
                    pointerEvents: 'none',
                    opacity: p.doLighten ? '0.75' : '1'
                }
            });
            el.append(im);
            var pointerListener = new (0, $eWjiX.BB).PointerListener({
                // because :hover causes problems w touch
                target: el,
                onEnterLeave: function(isOver) {
                    el.classList.toggle('toolspace-row-button-hover', isOver);
                }
            });
            var setIsSmall = function(b) {
                el.style.padding = p.contain ? b ? smallMargin : '10px 0' : '';
            };
            return {
                el: el,
                pointerListener: pointerListener,
                setIsSmall: setIsSmall
            };
        };
        var createTriangleButton = function(p) {
            // because IE and Edge don't support clip path
            var result = (0, $eWjiX.BB).el({
                css: {
                    flexGrow: '1',
                    position: 'relative'
                }
            });
            var svg = (0, $eWjiX.BB).createSvg({
                elementType: 'svg',
                width: '67px',
                height: '54px',
                viewBox: '0 0 100 100',
                preserveAspectRatio: 'none'
            });
            (0, $7jh4K.css)(svg, {
                position: 'absolute',
                left: '0',
                top: '0'
            });
            var blurRadius = 10;
            var blurOffsetX = 2;
            var blurOffsetY = 2;
            var defs = (0, $eWjiX.BB).createSvg({
                // inset shadow via svg
                elementType: 'defs',
                childrenArr: [
                    {
                        elementType: 'filter',
                        id: 'innershadow',
                        x0: '-50%',
                        y0: '-50%',
                        width: '200%',
                        height: '200%',
                        childrenArr: [
                            {
                                elementType: 'feGaussianBlur',
                                in: 'SourceAlpha',
                                stdDeviation: '' + blurRadius,
                                result: 'blur'
                            },
                            {
                                elementType: 'feOffset',
                                dx: '' + blurOffsetX,
                                dy: '' + blurOffsetY
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'SourceAlpha',
                                operator: 'arithmetic',
                                k2: '-1',
                                k3: '1',
                                result: 'shadowDiff'
                            },
                            {
                                elementType: 'feFlood',
                                'flood-color': '#000',
                                'flood-opacity': '0.2'
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'shadowDiff',
                                operator: 'in'
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'SourceGraphic',
                                operator: 'over',
                                result: 'firstfilter'
                            },
                            {
                                elementType: 'feGaussianBlur',
                                in: 'firstfilter',
                                stdDeviation: '' + blurRadius,
                                result: 'blur2'
                            },
                            {
                                elementType: 'feOffset',
                                dx: '' + blurOffsetX,
                                dy: '' + blurOffsetY
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'firstfilter',
                                operator: 'arithmetic',
                                k2: '-1',
                                k3: '1',
                                result: 'shadowDiff'
                            },
                            {
                                elementType: 'feFlood',
                                'flood-color': '#000',
                                'flood-opacity': '0.2'
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'shadowDiff',
                                operator: 'in'
                            },
                            {
                                elementType: 'feComposite',
                                in2: 'firstfilter',
                                operator: 'over'
                            }
                        ]
                    }
                ]
            });
            var svgTriangleLeft = (0, $eWjiX.BB).createSvg({
                elementType: 'path',
                'vector-effect': 'non-scaling-stroke',
                d: 'M0,0 L 100,0 0,100 z',
                fill: 'rgba(0,0,0,0)',
                class: 'toolspace-svg-triangle-button'
            });
            svgTriangleLeft.onclick = function() {
                p.onLeft();
                svgTriangleLeft.classList.remove('toolspace-svg-triangle-button-hover');
            };
            var svgTriangleRight = (0, $eWjiX.BB).createSvg({
                elementType: 'path',
                'vector-effect': 'non-scaling-stroke',
                d: 'M100,100 L 100,0 0,100 z',
                fill: 'rgba(0,0,0,0)',
                class: 'toolspace-svg-triangle-button'
            });
            svgTriangleRight.onclick = function() {
                p.onRight();
                svgTriangleRight.classList.remove('toolspace-svg-triangle-button-hover');
            };
            // because :hover causes problems w touch
            var leftPointerListener = new (0, $eWjiX.BB).PointerListener({
                target: svgTriangleLeft,
                onEnterLeave: function(isOver) {
                    svgTriangleLeft.classList.toggle('toolspace-svg-triangle-button-hover', isOver);
                }
            });
            var rightPointerListener = new (0, $eWjiX.BB).PointerListener({
                target: svgTriangleRight,
                onEnterLeave: function(isOver) {
                    svgTriangleRight.classList.toggle('toolspace-svg-triangle-button-hover', isOver);
                }
            });
            svg.append(defs, svgTriangleLeft, svgTriangleRight);
            result.append(svg);
            var leftIm = (0, $eWjiX.BB).el({
                parent: result,
                className: 'dark-invert',
                css: {
                    backgroundImage: "url('" + p.leftImage + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    width: '20px',
                    height: '20px',
                    position: 'absolute',
                    left: '10px',
                    top: '8px',
                    //transform: p.doMirror ? 'scale(-1, 1)' : '',
                    pointerEvents: 'none'
                }
            });
            result.append(leftIm);
            var rightIm = (0, $eWjiX.BB).el({
                parent: result,
                className: 'dark-invert',
                css: {
                    backgroundImage: "url('" + (p.rightImage ? p.rightImage : p.leftImage) + "')",
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain',
                    width: '20px',
                    height: '20px',
                    position: 'absolute',
                    right: '10px',
                    bottom: '8px',
                    transform: p.rightImage ? '' : 'scale(-1, 1)',
                    pointerEvents: 'none'
                }
            });
            var setIsEnabledLeft = function(b) {
                svgTriangleLeft.classList.toggle('toolspace-row-button-disabled', !b);
                leftIm.classList.toggle('toolspace-row-button-disabled', !b);
            };
            var setIsEnabledRight = function(b) {
                svgTriangleRight.classList.toggle('toolspace-row-button-disabled', !b);
                rightIm.classList.toggle('toolspace-row-button-disabled', !b);
            };
            return {
                el: result,
                setIsEnabledLeft: setIsEnabledLeft,
                setIsEnabledRight: setIsEnabledRight,
                leftPointerListener: leftPointerListener,
                rightPointerListener: rightPointerListener
            };
        };
        this.toolDropdown = new (0, $18c597dee53260ff$export$a0a40f8a0b8fee15)({
            onChange: function(activeStr) {
                _this.setActive(activeStr, true);
            }
        });
        this.rootEl.append(this.toolDropdown.getElement());
        this.handButton = createButton({
            onClick: function() {
                _this.setActive('hand', true);
            },
            image: (0, (/*@__PURE__*/$parcel$interopDefault($ec1da9254c8485a7$exports))),
            contain: true,
            doLighten: true
        });
        this.handButton.el.classList.add('kl-tool-row-border-right');
        this.handButton.el.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-hand');
        this.rootEl.append(this.handButton.el);
        this.zoomInNOutButton = createTriangleButton({
            onLeft: p.onZoomIn,
            onRight: p.onZoomOut,
            leftImage: (0, (/*@__PURE__*/$parcel$interopDefault($c88da6b7fdef67e7$exports))),
            rightImage: (0, (/*@__PURE__*/$parcel$interopDefault($e503dd0072d83d49$exports)))
        });
        this.zoomInNOutButton.el.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-zoom');
        this.rootEl.append(this.zoomInNOutButton.el);
        this.zoomInButton = createButton({
            onClick: p.onZoomIn,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($c88da6b7fdef67e7$exports))),
            contain: true
        });
        this.zoomInButton.el.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('zoom-in');
        this.rootEl.append(this.zoomInButton.el);
        this.zoomOutButton = createButton({
            onClick: p.onZoomOut,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($e503dd0072d83d49$exports))),
            contain: true
        });
        this.zoomOutButton.el.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('zoom-out');
        this.rootEl.append(this.zoomOutButton.el);
        this.undoNRedoButton = createTriangleButton({
            onLeft: p.onUndo,
            onRight: p.onRedo,
            leftImage: (0, (/*@__PURE__*/$parcel$interopDefault($33d76dcc22e5d968$exports))),
            rightImage: null
        });
        this.undoNRedoButton.el.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('undo') + '/' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('redo');
        this.undoNRedoButton.setIsEnabledLeft(false);
        this.undoNRedoButton.setIsEnabledRight(false);
        this.rootEl.append(this.undoNRedoButton.el);
        this.undoButton = createButton({
            onClick: p.onUndo,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($33d76dcc22e5d968$exports))),
            contain: true
        });
        this.undoButton.el.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('undo');
        this.undoButton.el.classList.add('toolspace-row-button-disabled');
        this.rootEl.append(this.undoButton.el);
        this.redoButton = createButton({
            onClick: p.onRedo,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($33d76dcc22e5d968$exports))),
            contain: true,
            doMirror: true
        });
        this.redoButton.el.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('redo');
        this.redoButton.el.classList.add('toolspace-row-button-disabled');
        this.rootEl.append(this.redoButton.el);
        this.zoomInButton.el.style.display = 'none';
        this.zoomOutButton.el.style.display = 'none';
        this.undoButton.el.style.display = 'none';
        this.redoButton.el.style.display = 'none';
    }
    (0, $7h4XF._)(ToolspaceToolRow, [
        {
            // ---- interface ----
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "setIsSmall",
            value: function setIsSmall(b) {
                (0, $7jh4K.css)(this.rootEl, {
                    height: b ? '36px' : '54px'
                });
                this.toolDropdown.setIsSmall(b);
                this.handButton.setIsSmall(b);
                this.zoomInButton.setIsSmall(b);
                this.zoomOutButton.setIsSmall(b);
                this.undoButton.setIsSmall(b);
                this.redoButton.setIsSmall(b);
                if (b) {
                    this.zoomInNOutButton.el.style.display = 'none';
                    this.undoNRedoButton.el.style.display = 'none';
                    this.zoomInButton.el.style.display = 'block';
                    this.zoomOutButton.el.style.display = 'block';
                    this.undoButton.el.style.display = 'block';
                    this.redoButton.el.style.display = 'block';
                } else {
                    this.zoomInNOutButton.el.style.display = 'block';
                    this.undoNRedoButton.el.style.display = 'block';
                    this.zoomInButton.el.style.display = 'none';
                    this.zoomOutButton.el.style.display = 'none';
                    this.undoButton.el.style.display = 'none';
                    this.redoButton.el.style.display = 'none';
                }
            }
        },
        {
            key: "setEnableZoomIn",
            value: function setEnableZoomIn(b) {
                this.zoomInButton.el.classList.toggle('toolspace-row-button-disabled', !b);
                this.zoomInNOutButton.setIsEnabledLeft(b);
            }
        },
        {
            key: "setEnableZoomOut",
            value: function setEnableZoomOut(b) {
                this.zoomOutButton.el.classList.toggle('toolspace-row-button-disabled', !b);
                this.zoomInNOutButton.setIsEnabledRight(b);
            }
        },
        {
            key: "setEnableUndo",
            value: function setEnableUndo(b) {
                this.undoButton.el.classList.toggle('toolspace-row-button-disabled', !b);
                this.undoNRedoButton.setIsEnabledLeft(b);
            }
        },
        {
            key: "setEnableRedo",
            value: function setEnableRedo(b) {
                this.redoButton.el.classList.toggle('toolspace-row-button-disabled', !b);
                this.undoNRedoButton.setIsEnabledRight(b);
            }
        },
        {
            key: "setActive",
            value: function setActive(activeStr, doEmit) {
                if (this.currentActiveStr === activeStr) return;
                this.currentActiveStr = activeStr;
                this.toolDropdown.setActive(this.currentActiveStr);
                this.handButton.el.classList.toggle('toolspace-row-button-activated', this.currentActiveStr === 'hand');
                if (doEmit) this.onActivate(this.currentActiveStr);
            }
        },
        {
            key: "getActive",
            value: function getActive() {
                return this.currentActiveStr;
            }
        }
    ]);
    return ToolspaceToolRow;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");


var $90c04b5ac185bf3d$export$8162a66cd18867a7 = /*#__PURE__*/ function() {
    "use strict";
    function ToolspaceStabilizerRow(p) {
        (0, $cx0mh._)(this, ToolspaceStabilizerRow);
        this.rootEl = (0, $eWjiX.BB).el({
            tagName: 'label',
            className: 'kl-stabilizer',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('stabilizer') + '&nbsp;',
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('stabilizer-title')
        });
        var strengthSelect = new (0, $7a3263857aacf58f$export$ef9b1a59e592288f)({
            optionArr: [
                [
                    '0',
                    '0'
                ],
                [
                    '1',
                    '1'
                ],
                [
                    '2',
                    '2'
                ],
                [
                    '3',
                    '3'
                ],
                [
                    '4',
                    '4'
                ],
                [
                    '5',
                    '5'
                ]
            ],
            initValue: '' + p.smoothing,
            onChange: function onChange(val) {
                p.onSelect(parseInt(val));
            },
            name: 'stabilizer-strength'
        });
        this.rootEl.append(strengthSelect.getElement());
        this.pointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.rootEl,
            onWheel: function onWheel(e) {
                strengthSelect.setDeltaValue(e.deltaY);
            }
        });
    }
    (0, $7h4XF._)(ToolspaceStabilizerRow, [
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return ToolspaceStabilizerRow;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");
var $d04d72b97d637d65$export$3c6d17ed0106bfb9 = /*#__PURE__*/ function() {
    "use strict";
    function TabRow(p) {
        var _this = this;
        (0, $cx0mh._)(this, TabRow);
        var _p_height;
        var height = (_p_height = p.height) !== null && _p_height !== void 0 ? _p_height : 35;
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'tabrow',
            css: {
                height: height + 1 + 'px'
            }
        });
        this.tabArr = []; //creates its own internal arr
        var roundSize = 10;
        this.roundRight = (0, $eWjiX.BB).el({
            className: 'tabrow__tab__rounding-left'
        });
        this.roundLeft = (0, $eWjiX.BB).el({
            className: 'tabrow__tab__rounding-right'
        });
        var createTab = function(pTabObj, initialId, useAccent) {
            var isVisible = 'isVisible' in pTabObj && pTabObj.isVisible !== undefined ? pTabObj.isVisible : true;
            var result = {
                id: pTabObj.id,
                isVisible: isVisible,
                onOpen: pTabObj.onOpen,
                onClose: pTabObj.onClose,
                update: function(openedTabObj) {
                    result.el.className = openedTabObj === result ? useAccent ? 'tabrow__tab tabrow__tab--opened-accented' : 'tabrow__tab tabrow__tab--opened' : 'tabrow__tab';
                    result.el.style.display = result.isVisible ? 'block' : 'none';
                },
                el: (0, $eWjiX.BB).el({
                    parent: _this.rootEl,
                    content: 'label' in pTabObj ? pTabObj.label : '',
                    title: 'title' in pTabObj ? pTabObj.title : undefined,
                    className: initialId === pTabObj.id ? useAccent ? 'tabrow__tab tabrow__tab--opened-accented' : 'tabrow__tab tabrow__tab--opened' : 'tabrow__tab',
                    css: {
                        lineHeight: height + 'px',
                        display: isVisible ? 'block' : 'none'
                    },
                    onClick: function() {
                        if (_this.activeTab === result) return;
                        _this.open(result.id);
                    }
                }),
                pointerListener: {}
            };
            if ('image' in pTabObj) (0, $eWjiX.BB).el({
                tagName: 'span',
                parent: result.el,
                className: 'dark-invert',
                css: {
                    backgroundImage: `url("${pTabObj.image}")`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    display: 'flex',
                    height: height - 7 + 'px',
                    justifyContent: 'center',
                    margin: '4px auto'
                }
            });
            if ('css' in pTabObj && pTabObj.css !== undefined) (0, $7jh4K.css)(result.el, pTabObj.css);
            result.pointerListener = new (0, $eWjiX.BB).PointerListener({
                // because :hover causes problems w touch
                target: result.el,
                onEnterLeave: function(isOver) {
                    result.el.classList.toggle('tabrow__tab-hover', isOver);
                }
            });
            if (initialId === result.id) {
                result.onOpen();
                result.el.append(_this.roundRight, _this.roundLeft);
            } else result.onClose();
            return result;
        };
        var initTabObj = null;
        for(var i = 0; i < p.tabArr.length; i++){
            var tab = createTab(p.tabArr[i], p.initialId, p.useAccent || false);
            if (tab.id === p.initialId) initTabObj = tab;
            this.tabArr.push(tab);
        }
        if (!initTabObj) throw 'invalid initialId';
        this.activeTab = initTabObj;
    }
    (0, $7h4XF._)(TabRow, [
        {
            // update
            key: "update",
            value: function update() {
                for(var i = 0; i < this.tabArr.length; i++)this.tabArr[i].update(this.activeTab);
            }
        },
        {
            // ---- interface ----
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "open",
            value: function open(tabId) {
                for(var i = 0; i < this.tabArr.length; i++)if (this.tabArr[i].id === tabId) {
                    if (this.activeTab === this.tabArr[i]) // already open
                    return;
                    this.activeTab.onClose();
                    this.activeTab = this.tabArr[i];
                    this.activeTab.onOpen();
                    this.activeTab.el.append(this.roundRight, this.roundLeft);
                    this.update();
                    return;
                }
                throw 'TabRow.open - invalid tabId';
            }
        },
        {
            key: "getOpenedTabId",
            value: function getOpenedTabId() {
                return '' + this.activeTab.id;
            }
        },
        {
            key: "setIsVisible",
            value: function setIsVisible(tabId, isVisible) {
                for(var i = 0; i < this.tabArr.length; i++)if (this.tabArr[i].id === tabId) {
                    this.tabArr[i].isVisible = isVisible;
                    this.update();
                    return;
                }
                throw 'TabRow.setIsVisible - invalid tabId';
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.tabArr.forEach(function(item) {
                    (0, $eWjiX.BB).destroyEl(item.el);
                    item.pointerListener.destroy();
                });
            }
        }
    ]);
    return TabRow;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $4acb6b8f0d0d377a$exports = {};
$4acb6b8f0d0d377a$exports = $parcel$resolve("6toXQ");





var $6l0gQ = parcelRequire("6l0gQ");

var $7jh4K = parcelRequire("7jh4K");

var $72Jv0 = parcelRequire("72Jv0");
var $9934467c988b088a$var$LS_INERTIA_KEY = 'kl-inertia-scroll';
var $9934467c988b088a$export$cf20160367bae46c = /*#__PURE__*/ function() {
    "use strict";
    function HandUi(p) {
        (0, $cx0mh._)(this, HandUi);
        this.isVisible = true;
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                margin: '10px'
            }
        });
        this.scale = p.scale;
        this.angleDeg = p.angleDeg;
        this.onAngleChange = p.onAngleChange;
        var row1 = (0, $eWjiX.BB).el({
            css: {
                marginBottom: '10px',
                display: 'flex'
            }
        });
        var row2 = (0, $eWjiX.BB).el({
            css: {
                display: 'flex',
                marginBottom: '10px'
            }
        });
        var row3 = (0, $eWjiX.BB).el({
            css: {
                display: 'flex'
            }
        });
        this.rootEl.append(row1, row2, row3);
        this.scaleEl = (0, $eWjiX.BB).el({
            css: {
                width: '65px',
                userSelect: 'none',
                fontFamily: 'monospace'
            }
        });
        row1.append(this.scaleEl);
        this.angleIm = new Image();
        this.angleIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($ad47d2e0edfb40c7$exports)));
        (0, $7jh4K.css)(this.angleIm, {
            verticalAlign: 'bottom',
            width: '20px',
            height: '20px',
            marginRight: '5px',
            borderRadius: '10px',
            background: 'rgba(0,0,0,0.2)',
            userSelect: 'none'
        });
        row1.append(this.angleIm);
        this.angleEl = (0, $eWjiX.BB).el({
            parent: row1,
            css: {
                userSelect: 'none'
            }
        });
        this.updateUi();
        var resetButton = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('hand-reset'),
            onClick: p.onReset
        });
        (0, $72Jv0.makeUnfocusable)(resetButton);
        var fitButton = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('hand-fit'),
            css: {
                marginLeft: '10px'
            },
            onClick: p.onFit
        });
        (0, $72Jv0.makeUnfocusable)(fitButton);
        row2.append(resetButton, fitButton);
        var leftRotateIcon = new Image();
        leftRotateIcon.height = 20;
        leftRotateIcon.src = (0, (/*@__PURE__*/$parcel$interopDefault($4acb6b8f0d0d377a$exports)));
        leftRotateIcon.alt = 'Rotate';
        (0, $7jh4K.css)(leftRotateIcon, {
            transform: 'scale(-1, 1)'
        });
        var leftRotateButton = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: leftRotateIcon,
            onClick: function onClick() {
                p.onAngleChange(-15, true);
            }
        });
        (0, $72Jv0.makeUnfocusable)(leftRotateButton);
        var resetAngleButton = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: "0\xb0",
            css: {
                marginLeft: '10px'
            },
            onClick: function onClick() {
                p.onAngleChange(0);
            }
        });
        (0, $72Jv0.makeUnfocusable)(resetAngleButton);
        var rightRotateButton = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: '<img height="20" src="' + (0, (/*@__PURE__*/$parcel$interopDefault($4acb6b8f0d0d377a$exports))) + '" alt="Rotate"/>',
            css: {
                marginLeft: '10px'
            },
            onClick: function onClick() {
                p.onAngleChange(15, true);
            }
        });
        (0, $72Jv0.makeUnfocusable)(rightRotateButton);
        row3.append(leftRotateButton, resetAngleButton, rightRotateButton);
        var inertiaToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('hand-inertia-scrolling'),
            init: (0, $6l0gQ.LocalStorage).getItem($9934467c988b088a$var$LS_INERTIA_KEY) === 'true',
            callback: function(b) {
                (0, $6l0gQ.LocalStorage).setItem($9934467c988b088a$var$LS_INERTIA_KEY, '' + b);
                p.onChangeUseInertiaScrolling(b);
            },
            name: 'enable-inertia-scrolling'
        });
        setTimeout(function() {
            p.onChangeUseInertiaScrolling(inertiaToggle.getValue());
        }, 500);
        (0, $7jh4K.css)(inertiaToggle.getElement(), {
            marginTop: '10px',
            display: 'inline-block'
        });
        this.rootEl.append(inertiaToggle.getElement());
    }
    (0, $7h4XF._)(HandUi, [
        {
            key: "updateUi",
            value: function updateUi() {
                this.scaleEl.innerHTML = Math.round(this.scale * 100) + '%';
                this.angleEl.innerHTML = Math.round(this.angleDeg) + "\xb0";
                (0, $7jh4K.css)(this.angleIm, {
                    transform: 'rotate(' + this.angleDeg + 'deg)',
                    boxShadow: this.angleDeg % 90 === 0 ? 'inset 0 0 0 1px rgba(255,255,255, 1), 0 0 0 1px rgba(0, 0, 0, 0.3)' : ''
                });
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "setIsVisible",
            value: function setIsVisible(pIsVisible) {
                this.isVisible = pIsVisible;
                this.rootEl.style.display = this.isVisible ? 'block' : 'none';
                if (this.isVisible) this.updateUi();
            }
        },
        {
            key: "update",
            value: function update(pScale, pAngleDeg) {
                this.scale = pScale;
                this.angleDeg = pAngleDeg;
                if (this.isVisible) this.updateUi();
            }
        }
    ]);
    return HandUi;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");





var $7jh4K = parcelRequire("7jh4K");
var $51d47356d698ffec$export$1e63e3b0645421a2 = /*#__PURE__*/ function() {
    "use strict";
    function FillUi(p) {
        var _this = this;
        (0, $cx0mh._)(this, FillUi);
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                margin: '10px'
            }
        });
        this.isVisible = true;
        this.colorDiv = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                marginBottom: '10px'
            }
        });
        this.colorSlider = p.colorSlider;
        this.opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
            width: 250,
            height: 30,
            min: 0.01,
            max: 1,
            value: 1,
            toValue: function(displayValue) {
                return displayValue / 100;
            },
            toDisplayValue: function(value) {
                return value * 100;
            }
        });
        this.rootEl.append(this.opacitySlider.getElement());
        this.toleranceSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('bucket-tolerance'),
            width: 250,
            height: 30,
            min: 0,
            max: 255,
            value: 51,
            toValue: function(displayValue) {
                return displayValue * 2.55;
            },
            toDisplayValue: function(value) {
                return value / 2.55;
            }
        });
        (0, $7jh4K.css)(this.toleranceSlider.getElement(), {
            marginTop: '10px'
        });
        this.rootEl.append(this.toleranceSlider.getElement());
        var selectRow = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                marginTop: '10px'
            }
        });
        var modeWrapper = (0, $eWjiX.BB).el({
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('bucket-sample') + '&nbsp;',
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('bucket-sample-title'),
            css: {
                fontSize: '15px'
            }
        });
        this.modeSelect = new (0, $7a3263857aacf58f$export$ef9b1a59e592288f)({
            optionArr: [
                [
                    'all',
                    (0, $8d7403abedf7cefa$export$ce37e184d908d785)('bucket-sample-all')
                ],
                [
                    'current',
                    (0, $8d7403abedf7cefa$export$ce37e184d908d785)('bucket-sample-active')
                ],
                [
                    'above',
                    (0, $8d7403abedf7cefa$export$ce37e184d908d785)('bucket-sample-above')
                ]
            ],
            initValue: 'all',
            name: 'sampling-mode'
        });
        var modePointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.modeSelect.getElement(),
            onWheel: function(e) {
                _this.modeSelect.setDeltaValue(e.deltaY);
            }
        });
        modeWrapper.append(this.modeSelect.getElement());
        selectRow.append(modeWrapper);
        var growWrapper = (0, $eWjiX.BB).el({
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('bucket-grow') + '&nbsp;',
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('bucket-grow-title'),
            css: {
                fontSize: '15px',
                marginLeft: '10px'
            }
        });
        this.growSelect = new (0, $7a3263857aacf58f$export$ef9b1a59e592288f)({
            optionArr: [
                [
                    '0',
                    '0'
                ],
                [
                    '1',
                    '1'
                ],
                [
                    '2',
                    '2'
                ],
                [
                    '3',
                    '3'
                ],
                [
                    '4',
                    '4'
                ],
                [
                    '5',
                    '5'
                ],
                [
                    '6',
                    '6'
                ],
                [
                    '7',
                    '7'
                ]
            ],
            initValue: '0',
            name: 'fill-growth'
        });
        var growPointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.growSelect.getElement(),
            onWheel: function(e) {
                _this.growSelect.setDeltaValue(e.deltaY);
            }
        });
        growWrapper.append(this.growSelect.getElement());
        selectRow.append(growWrapper);
        this.isContiguous = true;
        var contiguousToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('bucket-contiguous'),
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('bucket-contiguous-title'),
            callback: function(b) {
                _this.isContiguous = b;
            },
            name: 'is-contiguous'
        });
        this.eraserToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('eraser'),
            name: 'eraser-toggle'
        });
        this.rootEl.append((0, $eWjiX.BB).el({
            content: [
                contiguousToggle.getElement(),
                this.eraserToggle.getElement()
            ],
            css: {
                display: 'flex',
                marginTop: '10px',
                gap: '10px'
            }
        }));
    }
    (0, $7h4XF._)(FillUi, [
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "setIsVisible",
            value: function setIsVisible(pIsVisible) {
                this.isVisible = pIsVisible;
                this.rootEl.style.display = this.isVisible ? 'block' : 'none';
                if (this.isVisible) this.colorDiv.append(this.colorSlider.getElement(), this.colorSlider.getOutputElement());
            }
        },
        {
            /**
     * [0, 1]
     */ key: "getTolerance",
            value: function getTolerance() {
                // slider may display 0 when value is 1 -> avoid confusing users
                if (Math.round(this.toleranceSlider.getDisplayValue()) === 0) return 0;
                return this.toleranceSlider.getValue();
            }
        },
        {
            key: "getOpacity",
            value: function getOpacity() {
                return this.opacitySlider.getValue();
            }
        },
        {
            key: "getSample",
            value: function getSample() {
                return this.modeSelect.getValue();
            }
        },
        {
            key: "getGrow",
            value: function getGrow() {
                return parseInt(this.growSelect.getValue(), 10);
            }
        },
        {
            key: "getContiguous",
            value: function getContiguous() {
                return this.isContiguous;
            }
        },
        {
            key: "getIsEraser",
            value: function getIsEraser() {
                return this.eraserToggle.getValue();
            }
        }
    ]);
    return FillUi;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $d06987f550ff485e$export$32a22540e4b2f123 = /*#__PURE__*/ function() {
    "use strict";
    function TextUi(p) {
        (0, $cx0mh._)(this, TextUi);
        this.isVisible = true;
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                margin: '10px'
            }
        });
        this.colorSlider = p.colorSlider;
        this.colorDiv = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                marginBottom: '10px'
            }
        });
        var hint = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-instruction')
        });
    }
    (0, $7h4XF._)(TextUi, [
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "setIsVisible",
            value: function setIsVisible(pIsVisible) {
                this.isVisible = pIsVisible;
                this.rootEl.style.display = this.isVisible ? 'block' : 'none';
                if (this.isVisible) this.colorDiv.append(this.colorSlider.getElement(), this.colorSlider.getOutputElement());
            }
        }
    ]);
    return TextUi;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");





var $7jh4K = parcelRequire("7jh4K");
var $45c003c723de07b5$export$a9387b1d4260d39c = /*#__PURE__*/ function() {
    "use strict";
    function ShapeUi(p) {
        var _this = this;
        (0, $cx0mh._)(this, ShapeUi);
        this.shape = 'rect';
        this.mode = 'stroke';
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                margin: '10px'
            }
        });
        this.isVisible = true;
        this.colorDiv = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                marginBottom: '10px'
            }
        });
        this.colorSlider = p.colorSlider;
        var previewSize = 35;
        var previewPadding = 8;
        var rectStrokeSvgRect = (0, $eWjiX.BB).createSvg({
            elementType: 'rect',
            x: '' + previewPadding,
            width: '' + (previewSize - previewPadding * 2)
        });
        var rectStrokeSvg = (0, $eWjiX.BB).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        rectStrokeSvg.classList.add('dark-invert');
        rectStrokeSvg.append(rectStrokeSvgRect);
        (0, $7jh4K.css)(rectStrokeSvg, {
            display: 'block'
        });
        var rectFilledSvgRect = (0, $eWjiX.BB).createSvg({
            elementType: 'rect',
            x: '' + previewPadding,
            width: '' + (previewSize - previewPadding * 2)
        });
        var rectFilledSvg = (0, $eWjiX.BB).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        rectFilledSvg.classList.add('dark-invert');
        rectFilledSvg.append(rectFilledSvgRect);
        (0, $7jh4K.css)(rectFilledSvg, {
            display: 'block'
        });
        var ellipseStrokeSvgEllipse = (0, $eWjiX.BB).createSvg({
            elementType: 'ellipse',
            cx: '' + previewSize / 2,
            cy: '' + previewSize / 2,
            rx: '' + (previewSize / 2 - previewPadding)
        });
        var ellipseStrokeSvg = (0, $eWjiX.BB).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        ellipseStrokeSvg.classList.add('dark-invert');
        ellipseStrokeSvg.append(ellipseStrokeSvgEllipse);
        (0, $7jh4K.css)(ellipseStrokeSvg, {
            display: 'block'
        });
        var ellipseFilledSvgEllipse = (0, $eWjiX.BB).createSvg({
            elementType: 'ellipse',
            cx: '' + previewSize / 2,
            cy: '' + previewSize / 2,
            rx: '' + (previewSize / 2 - previewPadding)
        });
        var ellipseFilledSvg = (0, $eWjiX.BB).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        ellipseFilledSvg.classList.add('dark-invert');
        ellipseFilledSvg.append(ellipseFilledSvgEllipse);
        (0, $7jh4K.css)(ellipseFilledSvg, {
            display: 'block'
        });
        var lineSvgLine = (0, $eWjiX.BB).createSvg({
            elementType: 'line',
            x1: '' + previewPadding,
            x2: '' + (previewSize - previewPadding)
        });
        var lineSvg = (0, $eWjiX.BB).createSvg({
            elementType: 'svg',
            width: '' + previewSize,
            height: '' + previewSize
        });
        lineSvg.classList.add('dark-invert');
        lineSvg.append(lineSvgLine);
        (0, $7jh4K.css)(lineSvg, {
            display: 'block'
        });
        var updatePreviews = function() {
            var strokeWidth = (0, $eWjiX.BB).clamp(Math.round(_this.lineWidthSlider.getValue() / 10), 1, 10) + 'px';
            var squish = 1.35;
            (0, $7jh4K.css)(rectStrokeSvgRect, {
                fill: 'none',
                stroke: 'black',
                strokeWidth: strokeWidth
            });
            (0, $7jh4K.css)(rectFilledSvgRect, {
                fill: 'black',
                stroke: 'none'
            });
            (0, $7jh4K.css)(ellipseStrokeSvgEllipse, {
                fill: 'none',
                stroke: 'black',
                strokeWidth: strokeWidth
            });
            (0, $7jh4K.css)(ellipseFilledSvgEllipse, {
                fill: 'black',
                stroke: 'none'
            });
            (0, $7jh4K.css)(lineSvgLine, {
                fill: 'none',
                stroke: 'black',
                strokeWidth: strokeWidth
            });
            if (_this.fixedToggle.getValue()) {
                rectStrokeSvgRect.setAttribute('y', '' + previewPadding);
                rectStrokeSvgRect.setAttribute('height', '' + (previewSize - previewPadding * 2));
                rectFilledSvgRect.setAttribute('y', '' + previewPadding);
                rectFilledSvgRect.setAttribute('height', '' + (previewSize - previewPadding * 2));
                ellipseStrokeSvgEllipse.setAttribute('ry', '' + (previewSize / 2 - previewPadding));
                ellipseFilledSvgEllipse.setAttribute('ry', '' + (previewSize / 2 - previewPadding));
            } else {
                rectStrokeSvgRect.setAttribute('y', '' + previewPadding * squish);
                rectStrokeSvgRect.setAttribute('height', '' + (previewSize - previewPadding * squish * 2));
                rectFilledSvgRect.setAttribute('y', '' + previewPadding * squish);
                rectFilledSvgRect.setAttribute('height', '' + (previewSize - previewPadding * squish * 2));
                ellipseStrokeSvgEllipse.setAttribute('ry', '' + (previewSize / 2 - previewPadding * squish));
                ellipseFilledSvgEllipse.setAttribute('ry', '' + (previewSize / 2 - previewPadding * squish));
            }
            if (_this.snapToggle.getValue()) {
                lineSvgLine.setAttribute('y1', '' + (previewSize - previewPadding));
                lineSvgLine.setAttribute('y2', '' + previewPadding);
            } else {
                lineSvgLine.setAttribute('y1', '' + (previewSize - previewPadding * squish));
                lineSvgLine.setAttribute('y2', '' + previewPadding * squish);
            }
        };
        var row1 = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'start'
            }
        });
        var shapeOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'rect-stroke',
                    label: rectStrokeSvg,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-rect') + ' ' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-stroke')
                },
                {
                    id: 'ellipse-stroke',
                    label: ellipseStrokeSvg,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-ellipse') + ' ' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-stroke')
                },
                {
                    id: 'line',
                    label: lineSvg,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-line')
                },
                {
                    id: 'rect-fill',
                    label: rectFilledSvg,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-rect') + ' ' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-fill')
                },
                {
                    id: 'ellipse-fill',
                    label: ellipseFilledSvg,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-ellipse') + ' ' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-fill')
                }
            ],
            initId: this.shape + ' ' + this.mode,
            onChange: function(id) {
                var split = id.split('-');
                _this.shape = split[0];
                _this.mode = split[1];
                (0, $7jh4K.css)(_this.fixedToggle.getElement(), {
                    display: _this.shape === 'line' ? 'none' : ''
                });
                (0, $7jh4K.css)(_this.snapToggle.getElement(), {
                    display: _this.shape === 'line' ? '' : 'none'
                });
                (0, $7jh4K.css)(_this.lineWidthSlider.getElement(), {
                    display: _this.shape !== 'line' && _this.mode === 'fill' ? 'none' : ''
                });
            },
            changeOnInit: true,
            css: {
                width: '120px'
            }
        });
        row1.append(shapeOptions.getElement());
        this.eraserToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('eraser'),
            callback: function() {
                updatePreviews();
            },
            name: 'enable-eraser'
        });
        this.lockAlphaToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha'),
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha-title'),
            doHighlight: true,
            name: 'enable-alpha-lock'
        });
        this.lockAlphaToggle.getElement().style.marginTop = '10px';
        this.panningToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-auto-pan'),
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-auto-pan-title'),
            callback: function(b) {
                return p.onChangePanning(b);
            },
            name: 'enable-auto-pan'
        });
        this.panningToggle.getElement().style.marginTop = '10px';
        row1.append((0, $eWjiX.BB).el({
            content: [
                this.eraserToggle.getElement(),
                this.lockAlphaToggle.getElement(),
                this.panningToggle.getElement()
            ]
        }));
        this.lineWidthSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-line-width'),
            width: 250,
            height: 30,
            min: 1,
            max: 200,
            value: 4,
            curve: 'quadratic',
            onChange: function() {
                updatePreviews();
            }
        });
        (0, $7jh4K.css)(this.lineWidthSlider.getElement(), {
            marginTop: '10px'
        });
        this.rootEl.append(this.lineWidthSlider.getElement());
        this.opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
            width: 250,
            height: 30,
            min: 0.01,
            max: 1,
            value: 1,
            toValue: function(displayValue) {
                return displayValue / 100;
            },
            toDisplayValue: function(value) {
                return value * 100;
            }
        });
        (0, $7jh4K.css)(this.opacitySlider.getElement(), {
            marginTop: '10px'
        });
        this.rootEl.append(this.opacitySlider.getElement());
        var row2 = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px',
                gap: '10px'
            }
        });
        this.outwardsToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-outwards'),
            name: 'enable-outwards'
        });
        row2.append(this.outwardsToggle.getElement());
        this.fixedToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-fixed'),
            callback: function() {
                updatePreviews();
            },
            name: 'enable-fixed-proportions'
        });
        row2.append(this.fixedToggle.getElement());
        this.snapToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('angle-snap'),
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('angle-snap-title'),
            callback: function() {
                updatePreviews();
            },
            name: 'enable-angle-snapping'
        });
        row2.append(this.snapToggle.getElement());
        updatePreviews();
    }
    (0, $7h4XF._)(ShapeUi, [
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "setIsVisible",
            value: function setIsVisible(pIsVisible) {
                this.isVisible = pIsVisible;
                this.rootEl.style.display = this.isVisible ? 'block' : 'none';
                if (this.isVisible) {
                    this.colorDiv.append(this.colorSlider.getElement());
                    this.colorDiv.append(this.colorSlider.getOutputElement());
                //update();
                }
            }
        },
        {
            key: "getShape",
            value: function getShape() {
                return this.shape;
            }
        },
        {
            key: "getMode",
            value: function getMode() {
                return this.mode;
            }
        },
        {
            key: "getIsEraser",
            value: function getIsEraser() {
                return this.eraserToggle.getValue();
            }
        },
        {
            key: "getOpacity",
            value: function getOpacity() {
                return this.opacitySlider.getValue();
            }
        },
        {
            key: "getLineWidth",
            value: function getLineWidth() {
                return this.lineWidthSlider.getValue();
            }
        },
        {
            key: "getIsOutwards",
            value: function getIsOutwards() {
                return this.outwardsToggle.getValue();
            }
        },
        {
            key: "getIsFixed",
            value: function getIsFixed() {
                return this.fixedToggle.getValue();
            }
        },
        {
            key: "getIsSnap",
            value: function getIsSnap() {
                return this.snapToggle.getValue();
            }
        },
        {
            key: "getDoLockAlpha",
            value: function getDoLockAlpha() {
                return this.lockAlphaToggle.getValue();
            }
        }
    ]);
    return ShapeUi;
}();



var $eWjiX = parcelRequire("eWjiX");





var $bX4ja = parcelRequire("bX4ja");

var $eWjiX = parcelRequire("eWjiX");
function $96366ef7b36c82a7$export$9852986a3ec5f6a0(data, cellProps) {
    var result = (0, $eWjiX.BB).el({
        tagName: 'table',
        className: 'kl-table'
    });
    data.forEach(function(row, rowIndex) {
        var _rowEl;
        var rowEl = (0, $eWjiX.BB).el({
            tagName: 'tr'
        });
        (_rowEl = rowEl).append.apply(_rowEl, (0, $bX4ja._)(row.map(function(el, colIndex) {
            var cellEl = (0, $eWjiX.BB).el({
                tagName: 'td',
                content: el
            });
            var key = rowIndex + '.' + colIndex;
            if (cellProps !== undefined && key in cellProps) cellEl.rowSpan = cellProps[key].rowspan;
            return cellEl;
        })));
        result.append(rowEl);
    });
    return result;
}



var $7jh4K = parcelRequire("7jh4K");
function $4fb68589de8a8c9a$export$f77a89101d7d6586(p) {
    var currentColor = p.currentColor;
    var secondaryColor = p.secondaryColor;
    var maxCanvasSize = p.maxCanvasSize;
    var canvasWidth = p.canvasWidth;
    var canvasHeight = p.canvasHeight;
    var workspaceWidth = p.workspaceWidth;
    var workspaceHeight = p.workspaceHeight;
    var onConfirm = p.onConfirm;
    var onCancel = p.onCancel;
    function createRatioSize(ratioX, ratioY, width, height, padding) {
        return (0, $eWjiX.BB).fitInto(ratioX, ratioY, Math.min(maxCanvasSize, width - padding), Math.min(maxCanvasSize, height - padding), 1);
    }
    var newImDiv = (0, $eWjiX.BB).el();
    var widthInput = (0, $eWjiX.BB).el({
        tagName: 'input',
        custom: {
            name: 'image-width'
        }
    });
    var unitStyle = {
        color: '#888',
        fontSize: '12px',
        marginLeft: '5px'
    };
    var widthUnit = (0, $eWjiX.BB).el({
        textContent: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-px'),
        css: unitStyle
    });
    var heightInput = (0, $eWjiX.BB).el({
        tagName: 'input',
        custom: {
            name: 'image-height'
        }
    });
    var heightUnit = (0, $eWjiX.BB).el({
        textContent: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-px'),
        css: unitStyle
    });
    widthInput.setAttribute('data-ignore-focus', 'true');
    heightInput.setAttribute('data-ignore-focus', 'true');
    widthInput.type = 'number';
    widthInput.min = '1';
    widthInput.max = '' + maxCanvasSize;
    (0, $7jh4K.css)(widthInput, {
        width: '70px'
    });
    heightInput.type = 'number';
    heightInput.min = '1';
    heightInput.max = '' + maxCanvasSize;
    heightInput.style.width = '70px';
    widthInput.value = '' + canvasWidth;
    heightInput.value = '' + canvasHeight;
    widthInput.onclick = function() {
        widthInput.focus();
        updateRatio();
    };
    heightInput.onclick = function() {
        heightInput.focus();
        updateRatio();
    };
    var sizeTable = (0, $96366ef7b36c82a7$export$9852986a3ec5f6a0)([
        [
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('width') + ':&nbsp;',
            widthInput,
            widthUnit
        ],
        [
            (0, $eWjiX.BB).el({
                css: {
                    height: '5px'
                }
            }),
            '',
            ''
        ],
        [
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('height') + ':&nbsp;',
            heightInput,
            heightUnit
        ]
    ]);
    (0, $7jh4K.css)(sizeTable, {
        marginBottom: '10px'
    });
    var ratioWrapper = (0, $eWjiX.BB).el({
        css: {
            marginTop: '5px',
            color: '#888'
        }
    });
    var templateWrapper = (0, $eWjiX.BB).el({
        css: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '5px',
            marginBottom: '10px'
        }
    });
    var presetBtnConfig = {
        tagName: 'button',
        css: {
            flexGrow: '1'
        }
    };
    var presetFitBtn = (0, $eWjiX.BB).el(presetBtnConfig);
    var presetCurrentBtn = (0, $eWjiX.BB).el(presetBtnConfig);
    var presetSquareBtn = (0, $eWjiX.BB).el(presetBtnConfig);
    var presetLandscapeBtn = (0, $eWjiX.BB).el(presetBtnConfig);
    var presetPortraitBtn = (0, $eWjiX.BB).el(presetBtnConfig);
    var presetOversizeBtn = (0, $eWjiX.BB).el(presetBtnConfig);
    presetCurrentBtn.textContent = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-current');
    presetFitBtn.textContent = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-fit');
    presetOversizeBtn.textContent = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-oversize');
    presetLandscapeBtn.textContent = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-landscape');
    presetPortraitBtn.textContent = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-portrait');
    presetSquareBtn.textContent = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-square');
    templateWrapper.append(presetCurrentBtn, presetFitBtn, presetOversizeBtn, presetSquareBtn, presetLandscapeBtn, presetPortraitBtn);
    var templatePadding = 0;
    presetCurrentBtn.onclick = function() {
        widthInput.value = '' + canvasWidth;
        heightInput.value = '' + canvasHeight;
        updateRatio();
    };
    presetFitBtn.onclick = function() {
        widthInput.value = '' + workspaceWidth;
        heightInput.value = '' + workspaceHeight;
        updateRatio();
    };
    presetOversizeBtn.onclick = function() {
        widthInput.value = '' + (workspaceWidth + 500);
        heightInput.value = '' + (workspaceHeight + 500);
        updateRatio();
    };
    presetSquareBtn.onclick = function() {
        var sizeObj = createRatioSize(1, 1, workspaceWidth, workspaceHeight, templatePadding);
        widthInput.value = '' + Math.round(sizeObj.width);
        heightInput.value = '' + Math.round(sizeObj.height);
        updateRatio();
    };
    presetLandscapeBtn.onclick = function() {
        var sizeObj = createRatioSize(4, 3, workspaceWidth, workspaceHeight, templatePadding);
        widthInput.value = '' + Math.round(sizeObj.width);
        heightInput.value = '' + Math.round(sizeObj.height);
        updateRatio();
    };
    presetPortraitBtn.onclick = function() {
        var sizeObj = createRatioSize(3, 4, workspaceWidth, workspaceHeight, templatePadding);
        widthInput.value = '' + Math.round(sizeObj.width);
        heightInput.value = '' + Math.round(sizeObj.height);
        updateRatio();
    };
    var select = new (0, $7a3263857aacf58f$export$ef9b1a59e592288f)({
        isFocusable: true,
        optionArr: [
            [
                'screen',
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-screen')
            ],
            [
                '16 9',
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-video') + ' 16:9'
            ],
            [
                '3 2',
                '3:2'
            ],
            [
                '5 3',
                '5:3'
            ],
            [
                '2 1',
                '2:1'
            ],
            [
                'paper',
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-din-paper') + " \u221A2:1"
            ],
            [
                '9 16',
                '9:16'
            ],
            [
                '2 3',
                '2:3'
            ],
            [
                '3 5',
                '3:5'
            ],
            [
                '1 2',
                '1:2'
            ],
            [
                '1 1.4142135623730951',
                "1:\u221A2"
            ]
        ],
        onChange: function onChange(val) {
            if (val === 'screen') {
                widthInput.value = '' + window.screen.width;
                heightInput.value = '' + window.screen.height;
            } else if (val === 'paper') {
                var sizeObj = createRatioSize(Math.sqrt(2), 1, workspaceWidth, workspaceHeight, templatePadding);
                widthInput.value = '' + Math.round(sizeObj.width);
                heightInput.value = '' + Math.round(sizeObj.height);
            } else {
                var split = val.split(' ');
                var sizeObj1 = createRatioSize(parseFloat(split[0]), parseFloat(split[1]), workspaceWidth, workspaceHeight, templatePadding);
                widthInput.value = '' + Math.round(sizeObj1.width);
                heightInput.value = '' + Math.round(sizeObj1.height);
            }
            updateRatio();
            select.setValue(undefined);
        },
        name: 'image-format'
    });
    setTimeout(function() {
        // safari: not empty without also setting it to null via timeout
        select.setValue(undefined);
    }, 0);
    (0, $7jh4K.css)(select.getElement(), {
        width: '80px',
        flexGrow: '1'
    });
    templateWrapper.append(select.getElement());
    var backgroundRgba = {
        r: 255,
        g: 255,
        b: 255,
        a: 1
    };
    var colorOptionsArr = [
        {
            r: 255,
            g: 255,
            b: 255,
            a: 1
        },
        {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        },
        {
            r: 0,
            g: 0,
            b: 0,
            a: 0
        },
        {
            r: currentColor.r,
            g: currentColor.g,
            b: currentColor.b,
            a: 1
        },
        {
            r: secondaryColor.r,
            g: secondaryColor.g,
            b: secondaryColor.b,
            a: 1
        }
    ];
    var colorOptions = new (0, $4db8cbbb01889095$export$24ba9b81662d4366)({
        colorArr: colorOptionsArr,
        initialIndex: 0,
        onChange: function onChange(rgbaObj) {
            backgroundRgba = rgbaObj;
            preview.style.backgroundColor = 'rgba(' + rgbaObj.r + ',' + rgbaObj.g + ',' + rgbaObj.b + ', ' + rgbaObj.a + ')';
        }
    });
    var previewWrapper = (0, $eWjiX.BB).el({
        className: 'kl-transparent-preview',
        css: {
            boxSizing: 'border-box',
            width: '340px',
            height: '140px',
            display: 'table',
            padding: '10px',
            marginTop: '10px',
            marginLeft: '-20px',
            background: 'var(--kl-checkerboard-background)'
        }
    });
    var preview = (0, $eWjiX.BB).el({
        className: 'kl-transparent-preview__canvas',
        css: {
            width: "200px",
            height: "100px",
            backgroundColor: 'rgba(' + backgroundRgba.r + ',' + backgroundRgba.g + ',' + backgroundRgba.b + ', ' + backgroundRgba.a + ')',
            marginLeft: 'auto',
            marginRight: 'auto',
            color: '#aaa',
            fontSize: '16px',
            fontWeight: 'bold',
            textAlign: 'center',
            verticalAlign: 'center',
            display: 'table',
            overflow: 'hidden'
        }
    });
    (0, $eWjiX.BB).el({
        parent: previewWrapper,
        content: preview,
        css: {
            display: 'table-cell',
            verticalAlign: 'middle'
        }
    });
    (0, $eWjiX.BB).el({
        parent: preview,
        css: {
            display: 'table-cell',
            verticalAlign: 'middle'
        }
    });
    function updateRatio() {
        widthInput.value = '' + Math.min(maxCanvasSize, parseInt(widthInput.value));
        heightInput.value = '' + Math.min(maxCanvasSize, parseInt(heightInput.value));
        function hcf(u, v) {
            var U = u, V = v;
            while(true){
                if (!(U %= V)) return V;
                if (!(V %= U)) return U;
            }
        }
        var w = parseInt(widthInput.value);
        var h = parseInt(heightInput.value);
        if (w < 1 || w > maxCanvasSize || h < 1 || h > maxCanvasSize) {
            if (w > maxCanvasSize) w = maxCanvasSize;
            else if (h > maxCanvasSize) h = maxCanvasSize;
            widthInput.value = '' + w;
            heightInput.value = '' + h;
        }
        //generated canvas size doesn't always match ratio. so check if a common ratio is very close
        var commonRatios = [
            [
                1,
                2
            ],
            [
                2,
                1
            ],
            [
                2,
                3
            ],
            [
                3,
                2
            ],
            [
                3,
                4
            ],
            [
                4,
                3
            ],
            [
                4,
                5
            ],
            [
                5,
                4
            ],
            [
                16,
                9
            ],
            [
                9,
                16
            ],
            [
                3,
                2
            ],
            [
                2,
                3
            ],
            [
                5,
                3
            ],
            [
                3,
                5
            ],
            [
                2,
                1
            ],
            [
                1,
                2
            ],
            [
                1.414,
                1
            ],
            [
                1,
                1.414
            ]
        ];
        var reducedArr = (0, $eWjiX.BB).reduce(w, h);
        var closestRatio = commonRatios[0];
        var closestDistance = Math.abs(commonRatios[0][0] / commonRatios[0][1] - reducedArr[0] / reducedArr[1]);
        for(var i = 0; i < commonRatios.length; i++)if (Math.abs(commonRatios[i][0] / commonRatios[i][1] - reducedArr[0] / reducedArr[1]) < closestDistance) {
            closestRatio = commonRatios[i];
            closestDistance = Math.abs(commonRatios[i][0] / commonRatios[i][1] - reducedArr[0] / reducedArr[1]);
        }
        //display ratio
        if (closestDistance > 0 && closestDistance < 0.005) ratioWrapper.innerText = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-ratio') + ': ~' + closestRatio[0] + ':' + closestRatio[1];
        else ratioWrapper.innerText = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-ratio') + ': ' + reducedArr[0] + ':' + reducedArr[1];
        var realw = w;
        var T = hcf(w, h);
        w /= T;
        h /= T;
        w *= 260;
        h *= 260;
        if (w > 260) {
            h = 260 / w * h;
            w = 260;
        }
        if (h > 100) {
            w = 100 / h * w;
            h = 100;
        }
        preview.style.width = w + 'px';
        preview.style.height = h + 'px';
        previewWrapper.style.backgroundSize = Math.round(Math.max(4, 60 * (w / realw))) + 'px';
    }
    widthInput.onchange = function() {
        if (widthInput.value === '' || parseInt(widthInput.value) < 0) widthInput.value = '1';
        updateRatio();
    };
    widthInput.onkeyup = function() {
        updateRatio();
    };
    heightInput.onchange = function() {
        if (heightInput.value === '' || parseFloat(heightInput.value) < 0) heightInput.value = '1';
        updateRatio();
    };
    heightInput.onkeyup = function() {
        updateRatio();
    };
    updateRatio();
    newImDiv.append(templateWrapper);
    var secondRow = (0, $eWjiX.BB).el({
        parent: newImDiv,
        css: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end'
        }
    });
    var secondRowLeft = (0, $eWjiX.BB).el({
        parent: secondRow
    });
    secondRowLeft.append(sizeTable, ratioWrapper);
    secondRow.append(colorOptions.getElement());
    newImDiv.append(previewWrapper);
    (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('new-title')}</b>`,
        div: newImDiv,
        buttons: [
            'Ok',
            'Cancel'
        ],
        callback: function callback(result) {
            (0, $eWjiX.BB).unsetEventHandler(widthInput, 'onclick', 'onchange', 'onkeyup');
            (0, $eWjiX.BB).unsetEventHandler(widthInput, 'onclick', 'onchange', 'onkeyup');
            (0, $eWjiX.BB).unsetEventHandler(presetCurrentBtn, 'onclick');
            (0, $eWjiX.BB).unsetEventHandler(presetFitBtn, 'onclick');
            (0, $eWjiX.BB).unsetEventHandler(presetOversizeBtn, 'onclick');
            (0, $eWjiX.BB).unsetEventHandler(presetSquareBtn, 'onclick');
            (0, $eWjiX.BB).unsetEventHandler(presetLandscapeBtn, 'onclick');
            (0, $eWjiX.BB).unsetEventHandler(presetPortraitBtn, 'onclick');
            select.destroy();
            colorOptions.destroy();
            if (result === 'Cancel' || parseInt(widthInput.value) <= 0 || parseInt(heightInput.value) <= 0 || isNaN(parseInt(widthInput.value)) || isNaN(parseInt(heightInput.value))) {
                onCancel();
                return;
            }
            onConfirm(parseInt(widthInput.value), parseInt(heightInput.value), backgroundRgba);
        },
        clickOnEnter: 'Ok'
    });
}



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $28683410117398a3$exports = {};
$28683410117398a3$exports = $parcel$resolve("b1UMP");



var $9091fb5691a677d9$export$5b91f641162972fc = /*#__PURE__*/ function() {
    "use strict";
    function ToolspaceCollapser(p) {
        var _this = this;
        (0, $cx0mh._)(this, ToolspaceCollapser);
        this.stateIsOpen = true;
        this.orientation = 'right';
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'kl-toolspace-toggle',
            css: {
                width: '36px',
                height: '36px',
                background: 'rgba(100, 100, 100, 0.9)',
                color: '#fff',
                textAlign: 'center',
                lineHeight: '36px',
                cursor: 'pointer',
                userSelect: 'none',
                padding: '6px',
                boxSizing: 'border-box'
            },
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('toggle-show-tools'),
            onClick: function(e) {
                e.preventDefault();
                _this.stateIsOpen = !_this.stateIsOpen;
                _this.update();
                p.onChange();
            }
        });
        this.icon = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                backgroundImage: `url(${(0, (/*@__PURE__*/$parcel$interopDefault($28683410117398a3$exports)))})`,
                width: '100%',
                height: '100%',
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                userSelect: 'none'
            }
        });
        this.update();
        this.rootEl.oncontextmenu = function() {
            return false;
        };
    }
    (0, $7h4XF._)(ToolspaceCollapser, [
        {
            key: "update",
            value: function update() {
                if (this.orientation === 'left') this.icon.style.transform = this.stateIsOpen ? 'rotate(180deg)' : '';
                else this.icon.style.transform = this.stateIsOpen ? '' : 'rotate(180deg)';
            }
        },
        {
            // ---- interface ----
            key: "isOpen",
            value: function isOpen() {
                return this.stateIsOpen;
            }
        },
        {
            key: "setIsOpen",
            value: function setIsOpen(b) {
                this.stateIsOpen = b;
                this.update();
            }
        },
        {
            key: "setOrientation",
            value: function setOrientation(dirStr) {
                this.orientation = dirStr;
                this.update();
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return ToolspaceCollapser;
}();



var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $eWjiX = parcelRequire("eWjiX");



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");





var $7jh4K = parcelRequire("7jh4K");
var $0c994c56e6434e84$export$5cdfb22682d2a5dd = /*#__PURE__*/ function() {
    "use strict";
    function TextToolFillUI(p) {
        var _this = this;
        (0, $cx0mh._)(this, TextToolFillUI);
        var emit = function() {
            p.onUpdate(_this.getValues());
        };
        var colorOptionsArr = [
            null,
            p.fill ? (0, $4EWN2._)((0, $cL71g._)({}, p.fill.color), {
                a: 1
            }) : null,
            (0, $4EWN2._)((0, $cL71g._)({}, p.primaryColor), {
                a: 1
            }),
            (0, $4EWN2._)((0, $cL71g._)({}, p.secondaryColor), {
                a: 1
            }),
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            }
        ];
        this.colorOptions = new (0, $4db8cbbb01889095$export$24ba9b81662d4366)({
            colorArr: colorOptionsArr,
            initialIndex: p.fill ? 1 : 0,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-fill'),
            onChange: function(c) {
                _this.opacitySlider.getElement().style.display = c !== null ? '' : 'none';
                emit();
            }
        });
        this.opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
            width: 150,
            height: 30,
            min: 0.01,
            max: 1,
            value: p.fill ? p.fill.color.a : 1,
            resolution: 225,
            eventResMs: 1000 / 30,
            toValue: function(displayValue) {
                return displayValue / 100;
            },
            toDisplayValue: function(value) {
                return value * 100;
            },
            onChange: function() {
                return emit();
            }
        });
        this.opacitySlider.getElement().style.display = p.fill ? '' : 'none';
        var svg = (0, $7jh4K.createSvg)({
            elementType: 'svg',
            class: 'dark-invert',
            width: '25px',
            height: '25px',
            viewBox: '0 0 30 30',
            childrenArr: [
                {
                    elementType: 'polyline',
                    points: '0,0 30,0 30,8 19,8 19,30 11,30 11,8 0,8 0,0 1,0',
                    'transform-origin': '15px 15px',
                    transform: 'scale(0.8)',
                    fill: '#000c'
                }
            ]
        });
        this.rootEl = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',flex,gap-10,items-center,flexWrap,minh-30', [
            svg,
            this.colorOptions.getElement(),
            this.opacitySlider.getElement()
        ]);
    }
    (0, $7h4XF._)(TextToolFillUI, [
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getValues",
            value: function getValues() {
                var c = this.colorOptions.getValue();
                if (c === null || (c === null || c === void 0 ? void 0 : c.a) === 0) return {
                    fill: undefined
                };
                var color = (0, $4EWN2._)((0, $cL71g._)({}, c), {
                    a: this.opacitySlider.getValue()
                });
                return {
                    fill: {
                        color: color
                    }
                };
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.colorOptions.destroy();
                this.opacitySlider.destroy();
            }
        }
    ]);
    return TextToolFillUI;
}();



var $1LaJZ = parcelRequire("1LaJZ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $bX4ja = parcelRequire("bX4ja");

var $fk3zw = parcelRequire("fk3zw");

var $eWjiX = parcelRequire("eWjiX");

var $dJPtW = parcelRequire("dJPtW");


var $e4604b9a1ac0f4ee$exports = {};
$e4604b9a1ac0f4ee$exports = $parcel$resolve("lvwQ5");


var $8ba3eefd70721d3b$exports = {};
$8ba3eefd70721d3b$exports = $parcel$resolve("imAvm");


var $eb31f16926e61810$exports = {};
$eb31f16926e61810$exports = $parcel$resolve("dC0sF");


var $5cf1958d54bfd5f4$exports = {};
$5cf1958d54bfd5f4$exports = $parcel$resolve("h3hPo");


var $3b43acef7d252779$exports = {};
$3b43acef7d252779$exports = $parcel$resolve("1pAeY");





var $8ef7ad4f80179365$exports = {};
$8ef7ad4f80179365$exports = $parcel$resolve("hapKl");


var $e69f3582668abc99$exports = {};
$e69f3582668abc99$exports = $parcel$resolve("dqzux");


var $cbca1f58563f9d40$exports = {};
$cbca1f58563f9d40$exports = $parcel$resolve("l7VGL");


var $1ac64d6c82edfb95$exports = {};
$1ac64d6c82edfb95$exports = $parcel$resolve("dm0T7");


var $fd0420aef18e587e$exports = {};
$fd0420aef18e587e$exports = $parcel$resolve("2U3dq");


var $e776cdfd0b179eef$exports = {};
$e776cdfd0b179eef$exports = $parcel$resolve("axzlU");


var $64c854750c49b505$exports = {};
$64c854750c49b505$exports = $parcel$resolve("avgh6");


var $eddaaaf7f794edf8$exports = {};
$eddaaaf7f794edf8$exports = $parcel$resolve("H9bSu");


var $39d6a48ea0add86d$exports = {};
$39d6a48ea0add86d$exports = $parcel$resolve("emBfm");


var $e422de72b0c425e5$exports = {};
$e422de72b0c425e5$exports = $parcel$resolve("kjRvm");


var $821093f4bf7188d6$exports = {};
$821093f4bf7188d6$exports = $parcel$resolve("c79R0");


var $eadfb8deb432b851$exports = {};
$eadfb8deb432b851$exports = $parcel$resolve("fndWQ");


var $aeae5535c3cfaf38$exports = {};
$aeae5535c3cfaf38$exports = $parcel$resolve("iAFmc");


var $3746e82f71e0d2e4$exports = {};
$3746e82f71e0d2e4$exports = $parcel$resolve("2Bq6W");


var $ddf5e76f74932ce0$exports = {};
$ddf5e76f74932ce0$exports = $parcel$resolve("hmfbp");


var $73473d030b493ccd$exports = {};
$73473d030b493ccd$exports = $parcel$resolve("iItsG");


var $4830416abb0c56c9$export$826128ff895ed268 = [
    {
        name: 'Caveat',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($8ef7ad4f80179365$exports)))
    },
    {
        name: 'ClimateCrisis',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($e69f3582668abc99$exports)))
    },
    {
        name: 'CorrectionBrush',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($cbca1f58563f9d40$exports)))
    },
    {
        name: 'DancingScript',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($1ac64d6c82edfb95$exports)))
    },
    {
        name: 'Diabolik',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($fd0420aef18e587e$exports)))
    },
    {
        name: 'FreckleFace',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($e776cdfd0b179eef$exports)))
    },
    {
        name: 'Gloock',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($64c854750c49b505$exports)))
    },
    {
        name: 'GochiHand',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($39d6a48ea0add86d$exports)))
    },
    {
        name: 'Pacha',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($eddaaaf7f794edf8$exports)))
    },
    {
        name: 'PassionOne',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($e422de72b0c425e5$exports)))
    },
    {
        name: 'PixeloidSans',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($821093f4bf7188d6$exports)))
    },
    {
        name: 'PlaypenSans',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($eadfb8deb432b851$exports)))
    },
    {
        name: 'Quicksand',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($aeae5535c3cfaf38$exports)))
    },
    {
        name: 'Silkscreen',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($3746e82f71e0d2e4$exports)))
    },
    {
        name: 'Tehroc',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($ddf5e76f74932ce0$exports)))
    },
    {
        name: 'YUNGA',
        url: (0, (/*@__PURE__*/$parcel$interopDefault($73473d030b493ccd$exports)))
    }
];



var $d84067eeb22a523d$var$importedFonts = [
    {
        fontFamily: 'sans-serif',
        fontName: 'Sans-serif'
    },
    {
        fontFamily: 'serif',
        fontName: 'Serif'
    },
    {
        fontFamily: 'monospace',
        fontName: 'Monospace'
    },
    {
        fontFamily: 'cursive',
        fontName: 'Cursive'
    },
    {
        fontFamily: 'fantasy',
        fontName: 'Fantasy'
    }
].concat((0, $bX4ja._)((0, $4830416abb0c56c9$export$826128ff895ed268).map(function(item) {
    return {
        fontFamily: item.name,
        fontName: item.name
    };
})));
var $d84067eeb22a523d$var$didLoadBundledFonts = false;
function $d84067eeb22a523d$var$loadBundledFonts() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var promises;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if ($d84067eeb22a523d$var$didLoadBundledFonts) return [
                        2
                    ];
                    $d84067eeb22a523d$var$didLoadBundledFonts = true;
                    promises = (0, $4830416abb0c56c9$export$826128ff895ed268).map(function(item) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                            var response, buffer, font;
                            return (0, $fk3zw._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            fetch(item.url)
                                        ];
                                    case 1:
                                        response = _state.sent();
                                        return [
                                            4,
                                            response.arrayBuffer()
                                        ];
                                    case 2:
                                        buffer = _state.sent();
                                        font = new FontFace(item.name, buffer);
                                        // await font.load();
                                        document.fonts.add(font);
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    });
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
var $d84067eeb22a523d$export$2e7faedafda1fc85 = /*#__PURE__*/ function() {
    "use strict";
    function TextToolFontUI(p) {
        var _this = this;
        (0, $cx0mh._)(this, TextToolFontUI);
        this.onUpdate = p.onUpdate;
        this.fontSelect = new (0, $7a3263857aacf58f$export$ef9b1a59e592288f)({
            initValue: p.font,
            optionArr: $d84067eeb22a523d$var$importedFonts.map(function(i) {
                return [
                    i.fontFamily,
                    i.fontName,
                    {
                        css: {
                            fontFamily: i.fontFamily,
                            fontSize: '1.2em'
                        }
                    }
                ];
            }),
            isFocusable: true,
            css: {
                width: '180px'
            },
            onChange: function(v) {
                _this.loadBundledFonts();
                p.onUpdate({
                    font: v
                });
            },
            name: 'font'
        });
        this.onFocus = function() {
            return _this.loadBundledFonts();
        };
        this.fontSelect.getElement().addEventListener('focus', this.onFocus);
        this.fontPointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.fontSelect.getElement(),
            onWheel: function(e) {
                return _this.fontSelect.setDeltaValue(e.deltaY);
            }
        });
        this.importButton = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-import'),
            onClick: function() {
                _this.importFont();
            }
        });
        var sizeLabel = (0, $eWjiX.BB).el({
            content: [
                (0, $eWjiX.BB).el({
                    tagName: 'span',
                    content: 'A',
                    css: {
                        fontSize: '0.6em'
                    }
                }),
                'A'
            ],
            css: {
                width: '25px',
                height: '25px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                fontSize: '1.2em',
                userSelect: 'none'
            }
        });
        this.sizeInput = new (0, $dJPtW.Input)({
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-size'),
            type: 'number',
            min: 0,
            max: 1000,
            init: p.size,
            onChange: function(v) {
                p.onUpdate({
                    size: parseFloat(v)
                });
            },
            doResetIfInvalid: true,
            doScrollWithoutFocus: true,
            css: {
                width: '70px'
            },
            name: 'font-size'
        });
        var _p_lineHeight;
        this.lineHeightInput = new (0, $dJPtW.Input)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-line-height'),
            type: 'number',
            min: 0,
            max: 10,
            step: 0.1,
            init: (_p_lineHeight = p.lineHeight) !== null && _p_lineHeight !== void 0 ? _p_lineHeight : 1,
            onChange: function(v) {
                p.onUpdate({
                    lineHeight: parseFloat(v)
                });
            },
            doResetIfInvalid: true,
            doScrollWithoutFocus: true,
            css: {
                width: '60px'
            },
            name: 'line-height'
        });
        var _p_letterSpacing;
        this.letterSpacingInput = new (0, $dJPtW.Input)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-letter-spacing'),
            type: 'number',
            min: -100,
            max: 100,
            init: (_p_letterSpacing = p.letterSpacing) !== null && _p_letterSpacing !== void 0 ? _p_letterSpacing : 0,
            onChange: function(v) {
                p.onUpdate({
                    letterSpacing: parseFloat(v)
                });
            },
            doResetIfInvalid: true,
            doScrollWithoutFocus: true,
            css: {
                width: '60px'
            },
            name: 'letter-spacing'
        });
        this.alignRadioList = new (0, $8cb981a3c9e5b15b$export$7cc1012a658e6ad8)({
            optionArr: [
                {
                    id: 'left',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-left'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($e4604b9a1ac0f4ee$exports))),
                    darkInvert: true
                },
                {
                    id: 'center',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-center'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($8ba3eefd70721d3b$exports))),
                    darkInvert: true
                },
                {
                    id: 'right',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-right'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($eb31f16926e61810$exports))),
                    darkInvert: true
                }
            ],
            initId: p.align,
            onChange: function(v) {
                return p.onUpdate({
                    align: v
                });
            }
        });
        this.italicToggle = new (0, $8fa94d142febb502$export$b6d053cded550773)({
            image: (0, (/*@__PURE__*/$parcel$interopDefault($5cf1958d54bfd5f4$exports))),
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-italic'),
            initValue: p.isItalic,
            onChange: function(v) {
                return p.onUpdate({
                    isItalic: v
                });
            },
            darkInvert: true
        });
        this.boldToggle = new (0, $8fa94d142febb502$export$b6d053cded550773)({
            image: (0, (/*@__PURE__*/$parcel$interopDefault($3b43acef7d252779$exports))),
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-bold'),
            initValue: p.isBold,
            onChange: function(v) {
                return p.onUpdate({
                    isBold: v
                });
            },
            darkInvert: true
        });
        this.rootEl = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',flex,flexWrap,gap-10-15,items-center', [
            (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',flex,gap-5,items-center', [
                sizeLabel,
                this.sizeInput.getElement()
            ]),
            (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',flex,gap-5', [
                this.fontSelect.getElement(),
                this.importButton
            ]),
            (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',flex,gap-7', [
                this.alignRadioList.getElement(),
                this.italicToggle.getElement(),
                this.boldToggle.getElement()
            ]),
            this.letterSpacingInput.getElement(),
            this.lineHeightInput.getElement()
        ]);
    }
    (0, $7h4XF._)(TextToolFontUI, [
        {
            key: "loadBundledFonts",
            value: // only load fonts when interacting with the font input
            function loadBundledFonts1() {
                var _this = this;
                !$d84067eeb22a523d$var$didLoadBundledFonts && $d84067eeb22a523d$var$loadBundledFonts().then(function() {
                    _this.onUpdate({
                        font: _this.fontSelect.getValue()
                    });
                });
            }
        },
        {
            key: "importFont",
            value: function importFont() {
                var _this = this;
                var acceptedExtensions = [
                    'ttf',
                    'otf',
                    'woff',
                    'woff2',
                    'eot'
                ];
                var input = document.createElement('input');
                input.type = 'file';
                input.multiple = true;
                input.accept = acceptedExtensions.map(function(item) {
                    return '.' + item;
                }).join(', ');
                input.focus();
                input.click();
                input.onchange = function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                        var _this, toSelect, failedToLoadFilenames, acceptedAtLeastOne, fontFamilies, i, file, fontName, split, font, _, _tmp, err;
                        return (0, $fk3zw._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _this = this;
                                    if (!input.files || input.files.length === 0) return [
                                        2
                                    ];
                                    toSelect = undefined;
                                    failedToLoadFilenames = [];
                                    acceptedAtLeastOne = false;
                                    fontFamilies = $d84067eeb22a523d$var$importedFonts.map(function(i) {
                                        return i.fontFamily;
                                    });
                                    i = 0;
                                    _state.label = 1;
                                case 1:
                                    if (!(i < input.files.length)) return [
                                        3,
                                        7
                                    ];
                                    file = input.files[i];
                                    fontName = 'kl-' + $d84067eeb22a523d$var$importedFonts.length;
                                    if (fontFamilies.includes(fontName)) return [
                                        3,
                                        6
                                    ];
                                    if (!toSelect) {
                                        toSelect = fontName;
                                        this.importButton.disabled = true;
                                        this.importButton.innerText = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('loading');
                                    }
                                    split = file.name.split('.');
                                    split.pop();
                                    $d84067eeb22a523d$var$importedFonts.push({
                                        fontFamily: fontName,
                                        fontName: split.join('.')
                                    });
                                    _ = FontFace.bind;
                                    _tmp = [
                                        void 0,
                                        fontName
                                    ];
                                    return [
                                        4,
                                        file.arrayBuffer()
                                    ];
                                case 2:
                                    font = new (_.apply(FontFace, _tmp.concat([
                                        _state.sent()
                                    ])));
                                    _state.label = 3;
                                case 3:
                                    _state.trys.push([
                                        3,
                                        5,
                                        ,
                                        6
                                    ]);
                                    return [
                                        4,
                                        font.load()
                                    ];
                                case 4:
                                    _state.sent();
                                    document.fonts.add(font);
                                    acceptedAtLeastOne = true;
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    err = _state.sent();
                                    failedToLoadFilenames.push(file.name);
                                    return [
                                        3,
                                        6
                                    ];
                                case 6:
                                    i++;
                                    return [
                                        3,
                                        1
                                    ];
                                case 7:
                                    if (failedToLoadFilenames.length > 0) (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
                                        message: (0, $eWjiX.BB).el({
                                            content: [
                                                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-failed-import'),
                                                (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('br'),
                                                failedToLoadFilenames.join(', '),
                                                (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('br'),
                                                (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('br'),
                                                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-supported-formats'),
                                                (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('br'),
                                                acceptedExtensions.join(', ')
                                            ]
                                        }),
                                        type: 'error'
                                    });
                                    if (!acceptedAtLeastOne) {
                                        this.importButton.disabled = false;
                                        this.importButton.innerText = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-import');
                                        return [
                                            2
                                        ];
                                    }
                                    // update font selection
                                    setTimeout(function() {
                                        _this.fontSelect.setOptionArr($d84067eeb22a523d$var$importedFonts.map(function(i) {
                                            return [
                                                i.fontFamily,
                                                i.fontName,
                                                {
                                                    css: {
                                                        fontFamily: i.fontFamily,
                                                        fontSize: '1.2em'
                                                    }
                                                }
                                            ];
                                        }));
                                        _this.fontSelect.setValue(toSelect);
                                        _this.onUpdate({
                                            font: toSelect
                                        });
                                        _this.importButton.disabled = false;
                                        _this.importButton.innerText = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-import');
                                    });
                                    return [
                                        2
                                    ];
                            }
                        });
                    }).call(_this);
                };
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getValues",
            value: function getValues() {
                return {
                    font: this.fontSelect.getValue(),
                    size: +this.sizeInput.getValue(),
                    letterSpacing: +this.letterSpacingInput.getValue(),
                    lineHeight: +this.lineHeightInput.getValue(),
                    align: this.alignRadioList.getValue(),
                    isItalic: this.italicToggle.getValue(),
                    isBold: this.boldToggle.getValue()
                };
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.fontPointerListener.destroy();
                this.fontSelect.getElement().removeEventListener('focus', this.onFocus);
                this.fontSelect.destroy();
                (0, $eWjiX.BB).destroyEl(this.importButton);
                this.sizeInput.destroy();
                this.lineHeightInput.destroy();
                this.letterSpacingInput.destroy();
                this.alignRadioList.destroy();
                this.italicToggle.destroy();
                this.boldToggle.destroy();
            }
        }
    ]);
    return TextToolFontUI;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $eWjiX = parcelRequire("eWjiX");





var $7jh4K = parcelRequire("7jh4K");
var $1d4a3fd6cf6c0a9d$export$42bb0e3b48d549f6 = /*#__PURE__*/ function() {
    "use strict";
    function TextToolStrokeUI(p) {
        var _this = this;
        (0, $cx0mh._)(this, TextToolStrokeUI);
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                boxShadow: '0 0 0 1px #aaa'
            }
        });
        var emit = function() {
            p.onUpdate(_this.getValues());
        };
        var colorOptionsArr = [
            null,
            p.stroke ? (0, $4EWN2._)((0, $cL71g._)({}, p.stroke.color), {
                a: 1
            }) : null,
            (0, $4EWN2._)((0, $cL71g._)({}, p.secondaryColor), {
                a: 1
            }),
            (0, $4EWN2._)((0, $cL71g._)({}, p.primaryColor), {
                a: 1
            }),
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            },
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            }
        ];
        this.colorOptions = new (0, $4db8cbbb01889095$export$24ba9b81662d4366)({
            colorArr: colorOptionsArr,
            initialIndex: p.stroke ? 1 : 0,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-stroke'),
            onChange: function(c) {
                _this.opacitySlider.getElement().style.display = c !== null ? '' : 'none';
                _this.lineWidthSlider.getElement().style.display = c !== null ? '' : 'none';
                emit();
            }
        });
        this.opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
            width: 150,
            height: 30,
            min: 0.01,
            max: 1,
            value: p.stroke ? p.stroke.color.a : 1,
            resolution: 225,
            eventResMs: 1000 / 30,
            toValue: function(displayValue) {
                return displayValue / 100;
            },
            toDisplayValue: function(value) {
                return value * 100;
            },
            onChange: function() {
                return emit();
            }
        });
        this.lineWidthSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-line-width'),
            width: 150,
            height: 30,
            min: 0.5,
            max: 100,
            value: p.stroke ? p.stroke.lineWidth : 2,
            eventResMs: 1000 / 30,
            curve: 'quadratic',
            onChange: function() {
                return emit();
            }
        });
        this.opacitySlider.getElement().style.display = p.stroke ? '' : 'none';
        this.lineWidthSlider.getElement().style.display = p.stroke ? '' : 'none';
        var svg = (0, $7jh4K.createSvg)({
            elementType: 'svg',
            class: 'dark-invert',
            width: '25px',
            height: '25px',
            viewBox: '0 0 30 30',
            childrenArr: [
                {
                    elementType: 'polyline',
                    points: '0,0 30,0 30,8 19,8 19,30 11,30 11,8 0,8 0,0 1,0',
                    fill: 'none',
                    stroke: '#000c',
                    'stroke-width': '3',
                    'transform-origin': '15px 15px',
                    transform: 'scale(0.8)'
                }
            ]
        });
        this.rootEl = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',flex,gap-10,items-center,flexWrap,minh-30', [
            svg,
            this.colorOptions.getElement(),
            this.opacitySlider.getElement(),
            this.lineWidthSlider.getElement()
        ]);
    }
    (0, $7h4XF._)(TextToolStrokeUI, [
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getValues",
            value: function getValues() {
                var c = this.colorOptions.getValue();
                if (c === null || (c === null || c === void 0 ? void 0 : c.a) === 0) return {
                    stroke: undefined
                };
                var color = (0, $4EWN2._)((0, $cL71g._)({}, c), {
                    a: this.opacitySlider.getValue()
                });
                return {
                    stroke: {
                        color: color,
                        lineWidth: this.lineWidthSlider.getValue()
                    }
                };
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.colorOptions.destroy();
                this.opacitySlider.destroy();
                this.lineWidthSlider.destroy();
            }
        }
    ]);
    return TextToolStrokeUI;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");


var $c85fd0de8751b6a0$export$c6656360602b35c2 = /*#__PURE__*/ function() {
    "use strict";
    function TextToolTextUI(p) {
        var _this = this;
        (0, $cx0mh._)(this, TextToolTextUI);
        this.onInput = function() {
            _this.emit();
        };
        this.lastEmittedText = p.text;
        this.onUpdate = p.onUpdate;
        this.rootEl = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('');
        this.textInput = (0, $eWjiX.BB).el({
            tagName: 'textarea',
            parent: this.rootEl,
            content: p.text,
            custom: {
                placeholder: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-placeholder')
            },
            css: {
                whiteSpace: 'pre',
                overflow: 'auto',
                width: '100%',
                height: '70px',
                resize: 'vertical'
            },
            onChange: function() {
                _this.emit();
            }
        });
        this.textInput.addEventListener('input', this.onInput);
    }
    (0, $7h4XF._)(TextToolTextUI, [
        {
            key: "emit",
            value: function emit() {
                var text = this.textInput.value;
                if (text === this.lastEmittedText) return;
                this.lastEmittedText = text;
                this.onUpdate({
                    text: text
                });
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getValues",
            value: function getValues() {
                return {
                    text: this.textInput.value
                };
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.textInput.focus();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                (0, $eWjiX.BB).destroyEl(this.textInput);
                this.textInput.removeEventListener('input', this.onInput);
            }
        }
    ]);
    return TextToolTextUI;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");








var $9b3eo = parcelRequire("9b3eo");
var $5ffe4a6cd7b98bc8$export$1d311696e0fb2158 = /*#__PURE__*/ function() {
    "use strict";
    function TextToolViewportUI(p) {
        var _this = this;
        (0, $cx0mh._)(this, TextToolViewportUI);
        this.offset = {
            x: 0,
            y: 0
        };
        this.zoomFac = 0;
        this.scale = 1;
        this.layerArr = [];
        this.onDarkChange = function() {
            _this.checkerPattern = (0, $7jh4K.throwIfNull)(_this.previewCtx.createPattern((0, $eWjiX.BB).createCheckerCanvas(8, (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).isDark()), 'repeat'));
            _this.render();
        };
        this.rootEl = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)();
        this.text = p.text;
        this.layerIndex = p.layerIndex;
        var selection = p.klCanvas.getSelection();
        this.selectionPath = selection ? new Path2D((0, $9b3eo.getSelectionPath2d)(selection)) : undefined;
        var isSmallWidth = window.innerWidth < 550;
        var isSmallHeight = window.innerHeight < 630;
        // --- preview ---
        // Text drawn on klCanvas-sized canvas: textCanvas
        // LayerArr[target].canvas & textCanvas then drawn on targetCanvas
        //      they are transformed. canvas size of final preview
        // All layers and targetCanvas drawn on layersCanvas. transformed and size of final preview
        // Checkerboard, layersCanvas, and outline then drawn on previewCanvas
        this.width = isSmallWidth ? 340 : 540;
        this.height = isSmallWidth ? isSmallHeight ? 210 : 260 : isSmallHeight ? 230 : 350;
        this.layerArr = p.klCanvas.getLayersFast();
        this.textCanvas = (0, $eWjiX.BB).canvas(p.klCanvas.getWidth(), p.klCanvas.getHeight());
        this.textCtx = (0, $eWjiX.BB).ctx(this.textCanvas);
        this.targetCanvas = (0, $eWjiX.BB).canvas(this.width, this.height);
        this.targetCtx = (0, $eWjiX.BB).ctx(this.targetCanvas);
        this.layersCanvas = (0, $eWjiX.BB).canvas(this.width, this.height);
        this.layersCtx = (0, $eWjiX.BB).ctx(this.layersCanvas);
        this.previewCanvas = (0, $eWjiX.BB).canvas(this.width, this.height); // the one that is visible
        this.previewCtx = (0, $eWjiX.BB).ctx(this.previewCanvas);
        (0, $7jh4K.css)(this.previewCanvas, {
            display: 'block'
        });
        this.previewWrapper = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                position: 'relative',
                width: this.width + 'px',
                cursor: 'move',
                touchAction: 'none'
            }
        });
        (0, $eWjiX.BB).el({
            // inset shadow on preview
            parent: this.previewWrapper,
            className: 'kl-text-preview-wrapper'
        });
        this.previewWrapper.append(this.previewCanvas);
        this.checkerPattern = (0, $7jh4K.throwIfNull)(this.previewCtx.createPattern((0, $eWjiX.BB).createCheckerCanvas(8, (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).isDark()), 'repeat'));
        this.emptyCanvas = (0, $eWjiX.BB).canvas(1, 1);
        this.emptyCanvasLight = (0, $eWjiX.BB).canvas(1, 1);
        {
            var ctx = (0, $eWjiX.BB).ctx(this.emptyCanvas);
            ctx.fillRect(0, 0, 1, 1);
            ctx = (0, $eWjiX.BB).ctx(this.emptyCanvasLight);
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, 1, 1);
        }
        (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).addIsDarkListener(this.onDarkChange);
        this.previewCanvas.oncontextmenu = function(e) {
            return e.preventDefault();
        };
        var dragged = false;
        var isDown = false;
        var offsetDragged = false;
        this.previewPointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.previewCanvas,
            onPointer: function(e) {
                // drag detect
                if (e.type === 'pointerdown') {
                    dragged = false;
                    isDown = true;
                }
                if (e.type === 'pointermove' && isDown) dragged = true;
                if (e.type === 'pointerup') {
                    if (isDown && dragged && e.pointerType === 'mouse') // With touch/pen it would be annoying to focus again,
                    // because it probably pops out the keyboard.
                    p.onDragEnd();
                    dragged = false;
                    isDown = false;
                }
                if (e.type === 'pointermove' && e.button === 'left') {
                    e.eventPreventDefault();
                    _this.offset = {
                        x: 0,
                        y: 0
                    };
                    _this.move(-e.dX, -e.dY);
                }
                if (e.type === 'pointerdown' && e.button === 'right') document.body.append(_this.eventCapture);
                if (e.type === 'pointerup') setTimeout(function() {
                    return _this.eventCapture.remove();
                }, 20);
                if (e.type === 'pointermove' && e.button === 'right') {
                    offsetDragged = true;
                    e.eventPreventDefault();
                    _this.offset.x -= e.dX;
                    _this.offset.y -= e.dY;
                    _this.render();
                }
                if (e.type === 'pointerup' && offsetDragged) {
                    var count = 0;
                    _this.interval = setInterval(function() {
                        if (count > 8) {
                            clearInterval(_this.interval);
                            _this.offset = {
                                x: 0,
                                y: 0
                            };
                            _this.render();
                        }
                        _this.offset = {
                            x: _this.offset.x * 0.6,
                            y: _this.offset.y * 0.6
                        };
                        _this.render();
                        count++;
                    }, 10);
                    _this.offset = {
                        x: _this.offset.x * 0.6,
                        y: _this.offset.y * 0.6
                    };
                    _this.render();
                }
            },
            onWheel: function(e) {
                _this.changeZoomFac(-e.deltaY);
            }
        });
        var wheelPrevent = function(event) {
            return event.preventDefault();
        };
        this.previewCanvas.addEventListener('wheel', wheelPrevent, {
            passive: false
        });
        this.rotationSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-transform-rotation'),
            width: 150,
            height: 30,
            min: -Math.PI,
            max: Math.PI,
            value: p.text.angleRad,
            resolution: 225,
            // eventResMs: 1000 / 30,
            toValue: function(deg) {
                return deg * Math.PI / 180;
            },
            toDisplayValue: function(rad) {
                return rad / Math.PI * 180;
            },
            onChange: function() {
                _this.offset = {
                    x: 0,
                    y: 0
                };
                _this.render();
            },
            unit: "\xb0"
        });
        this.zoomInBtn = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: `<img height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($c88da6b7fdef67e7$exports)))}">`,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('zoom-in'),
            onClick: function() {
                return _this.changeZoomFac(1);
            },
            css: {
                fontWeight: 'bold'
            }
        });
        this.zoomOutBtn = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: `<img height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($e503dd0072d83d49$exports)))}">`,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('zoom-out'),
            onClick: function() {
                return _this.changeZoomFac(-1);
            },
            css: {
                fontWeight: 'bold'
            }
        });
        this.eventCapture = (0, $eWjiX.BB).el({
            css: {
                position: 'absolute',
                left: '0',
                top: '0',
                right: '0',
                bottom: '0',
                zIndex: '999',
                cursor: 'move'
            }
        });
        this.eventCapture.oncontextmenu = function(e) {
            return e.preventDefault();
        };
        this.keyListener = new (0, $eWjiX.BB).KeyListener({
            onDown: function(keyStr) {
                if ((0, $eWjiX.BB).isInputFocused(true)) return;
                var factor = _this.keyListener.isPressed('shift') ? 4 : 1;
                if (keyStr === 'left') _this.move(-factor, 0);
                if (keyStr === 'right') _this.move(factor, 0);
                if (keyStr === 'up') _this.move(0, -factor);
                if (keyStr === 'down') _this.move(0, factor);
            }
        });
        this.inputsRootEl = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',flex,gap-5', [
            this.rotationSlider.getElement(),
            (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(),
            this.zoomInBtn,
            this.zoomOutBtn
        ]);
    }
    (0, $7h4XF._)(TextToolViewportUI, [
        {
            key: "canZoom",
            value: function canZoom(d) {
                return this.zoomFac !== Math.min(2, Math.max(-2, this.zoomFac + d));
            }
        },
        {
            key: "changeZoomFac",
            value: function changeZoomFac(d) {
                this.zoomFac = Math.min(2, Math.max(-2, this.zoomFac + d));
                this.render();
                this.zoomInBtn.disabled = !this.canZoom(1);
                this.zoomOutBtn.disabled = !this.canZoom(-1);
            }
        },
        {
            key: "move",
            value: /** Move text by x y **/ function move(x, y) {
                var rotated = (0, $eWjiX.BB).rotate(x, y, -this.rotationSlider.getValue() / Math.PI * 180);
                this.text.x += rotated.x / this.scale;
                this.text.y += rotated.y / this.scale;
                this.render();
            }
        },
        {
            key: "render",
            value: function render() {
                // try to draw very much like klCanvasWorkspace
                var angleRad = this.rotationSlider.getValue();
                // --- draw text ---
                this.textCtx.clearRect(0, 0, this.textCanvas.width, this.textCanvas.height);
                var bounds = (0, $fdc12d72a3df9be9$export$482c90f94eb9717c)(this.textCanvas, (0, $4EWN2._)((0, $cL71g._)({}, this.text), {
                    x: this.text.x,
                    y: this.text.y,
                    angleRad: this.rotationSlider.getValue()
                }), this.selectionPath);
                if (this.selectionPath) {
                    this.textCtx.save();
                    this.textCtx.setLineDash([
                        4
                    ]);
                    this.textCtx.strokeStyle = '#000';
                    this.textCtx.stroke(this.selectionPath);
                    this.textCtx.lineDashOffset = 4;
                    this.textCtx.strokeStyle = '#fff';
                    this.textCtx.stroke(this.selectionPath);
                    this.textCtx.restore();
                }
                // transform offset
                var transformedOffset = (0, $eWjiX.BB).Vec2.mul((0, $eWjiX.BB).rotate(this.offset.x, this.offset.y, -angleRad / Math.PI * 180), 1 / this.scale);
                // --- determine transformation of viewport ---
                // text should always be visible
                bounds.x -= 3;
                bounds.y -= 3;
                bounds.width += 6;
                bounds.height += 6;
                var rotatedXY = (0, $eWjiX.BB).rotate(bounds.x, bounds.y, -angleRad / Math.PI * 180);
                var rotatedWH = (0, $eWjiX.BB).rotate(bounds.width, bounds.height, -angleRad / Math.PI * 180);
                var centerX = this.text.x + rotatedXY.x + rotatedWH.x / 2 + transformedOffset.x;
                var centerY = this.text.y + rotatedXY.y + rotatedWH.y / 2 + transformedOffset.y;
                var padding = 100;
                var fitBounds = (0, $eWjiX.BB).fitInto(bounds.width, bounds.height, this.width - padding, this.height - padding);
                this.scale = Math.min(1, fitBounds.width / bounds.width);
                this.scale = Math.min(4, this.scale * Math.pow(2, this.zoomFac));
                // --- compose text and target layer ---
                this.targetCtx.save();
                if (this.scale >= 4) this.targetCtx.imageSmoothingEnabled = false;
                else {
                    this.targetCtx.imageSmoothingEnabled = true;
                    this.targetCtx.imageSmoothingQuality = this.scale >= 1 ? 'low' : 'medium';
                }
                this.targetCtx.clearRect(0, 0, this.previewCanvas.width, this.previewCanvas.height);
                this.targetCtx.translate(this.width / 2, this.height / 2);
                this.targetCtx.scale(this.scale, this.scale);
                this.targetCtx.rotate(angleRad);
                this.targetCtx.drawImage(this.layerArr[this.layerIndex].canvas, -centerX, -centerY);
                this.targetCtx.drawImage(this.textCanvas, -centerX, -centerY);
                this.targetCtx.restore();
                var isDark = (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).isDark();
                // --- layers ---
                this.layersCtx.save();
                this.layersCtx.fillStyle = isDark ? 'rgb(33,33,33)' : 'rgb(158,158,158)';
                this.layersCtx.fillRect(0, 0, this.width, this.height);
                {
                    // bg
                    this.layersCtx.save();
                    this.layersCtx.translate(this.width / 2, this.height / 2);
                    this.layersCtx.scale(this.scale, this.scale);
                    this.layersCtx.rotate(angleRad);
                    this.layersCtx.imageSmoothingEnabled = false;
                    //outline
                    var borderSize = 1 / this.scale;
                    this.layersCtx.globalAlpha = isDark ? 0.25 : 0.2;
                    this.layersCtx.drawImage(isDark ? this.emptyCanvasLight : this.emptyCanvas, -centerX - borderSize, -centerY - borderSize, this.textCanvas.width + borderSize * 2, this.textCanvas.height + borderSize * 2);
                    this.layersCtx.globalAlpha = 1;
                    //erase
                    this.layersCtx.globalCompositeOperation = 'destination-out';
                    this.layersCtx.drawImage(this.emptyCanvas, -centerX, -centerY, this.textCanvas.width, this.textCanvas.height);
                    this.layersCtx.restore();
                }
                // individual layers
                if (this.scale >= 4) this.layersCtx.imageSmoothingEnabled = false;
                else {
                    this.layersCtx.imageSmoothingEnabled = true;
                    this.layersCtx.imageSmoothingQuality = this.scale >= 1 ? 'low' : 'medium';
                }
                // layers below
                this.layersCtx.save();
                this.layersCtx.translate(this.width / 2, this.height / 2);
                this.layersCtx.scale(this.scale, this.scale);
                this.layersCtx.rotate(angleRad);
                for(var i = 0; i < this.layerIndex; i++)if (this.layerArr[i].isVisible && this.layerArr[i].opacity > 0) {
                    this.layersCtx.globalAlpha = this.layerArr[i].opacity;
                    this.layersCtx.globalCompositeOperation = this.layerArr[i].mixModeStr;
                    this.layersCtx.drawImage(this.layerArr[i].canvas, -centerX, -centerY);
                }
                this.layersCtx.restore();
                // target layer
                this.layersCtx.globalAlpha = this.layerArr[this.layerIndex].opacity * (this.layerArr[this.layerIndex].isVisible ? 1 : 0);
                this.layersCtx.globalCompositeOperation = this.layerArr[this.layerIndex].mixModeStr;
                this.layersCtx.drawImage(this.targetCanvas, 0, 0);
                // layers above
                this.layersCtx.save();
                this.layersCtx.translate(this.width / 2, this.height / 2);
                this.layersCtx.scale(this.scale, this.scale);
                this.layersCtx.rotate(angleRad);
                for(var i1 = this.layerIndex + 1; i1 < this.layerArr.length; i1++)if (this.layerArr[i1].isVisible && this.layerArr[i1].opacity > 0) {
                    this.layersCtx.globalAlpha = this.layerArr[i1].opacity;
                    this.layersCtx.globalCompositeOperation = this.layerArr[i1].mixModeStr;
                    this.layersCtx.drawImage(this.layerArr[i1].canvas, -centerX, -centerY);
                }
                this.layersCtx.restore();
                this.layersCtx.restore();
                // --- final composite ---
                this.previewCtx.save();
                this.previewCtx.fillStyle = this.checkerPattern;
                this.previewCtx.fillRect(0, 0, this.previewCanvas.width, this.previewCanvas.height);
                this.previewCtx.drawImage(this.layersCanvas, 0, 0);
                this.previewCtx.restore();
                // bounds
                this.previewCtx.save();
                this.previewCtx.globalCompositeOperation = 'difference';
                this.previewCtx.strokeStyle = '#fff';
                this.previewCtx.lineWidth = 0.5;
                this.previewCtx.translate(-this.offset.x, -this.offset.y);
                this.previewCtx.strokeRect(Math.round(this.width / 2 - bounds.width / 2 * this.scale) + 0.5, Math.round(this.height / 2 - bounds.height / 2 * this.scale) + 0.5, Math.round(bounds.width * this.scale), Math.round(bounds.height * this.scale));
                this.previewCtx.restore();
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getInputsElement",
            value: function getInputsElement() {
                return this.inputsRootEl;
            }
        },
        {
            key: "getValues",
            value: function getValues() {
                return {
                    x: this.text.x,
                    y: this.text.y,
                    angleRad: this.rotationSlider.getValue()
                };
            }
        },
        {
            key: "setText",
            value: function setText(text) {
                var x = this.text.x;
                var y = this.text.y;
                var angleRad = this.text.angleRad;
                this.text = (0, $4EWN2._)((0, $cL71g._)({}, text), {
                    x: x,
                    y: y,
                    angleRad: angleRad
                });
                this.render();
            }
        },
        {
            key: "setSize",
            value: function setSize(width, height) {
                // prevents: Failed to execute 'drawImage' on 'CanvasRenderingContext2D':
                // The image argument is a canvas element with a width or height of 0.
                width = Math.max(1, width);
                height = Math.max(1, height);
                if (width === this.width && height === this.height) return;
                this.width = width;
                this.height = height;
                this.targetCanvas.width = this.width;
                this.targetCanvas.height = this.height;
                this.layersCanvas.width = this.width;
                this.layersCanvas.height = this.height;
                this.previewCanvas.width = this.width;
                this.previewCanvas.height = this.height;
                this.previewWrapper.style.width = this.width + 'px';
                this.render();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                (0, $eWjiX.BB).destroyEl(this.rootEl);
                (0, $eWjiX.BB).destroyEl(this.inputsRootEl);
                (0, $eWjiX.BB).destroyEl(this.previewWrapper);
                clearInterval(this.interval);
                this.rotationSlider.destroy();
                (0, $eWjiX.BB).destroyEl(this.zoomInBtn);
                (0, $eWjiX.BB).destroyEl(this.zoomOutBtn);
                this.eventCapture.remove();
                this.previewPointerListener.destroy();
                this.keyListener.destroy();
                (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).removeIsDarkListener(this.onDarkChange);
            }
        }
    ]);
    return TextToolViewportUI;
}();


var $5043c756765ef749$export$7b388ca536128c6d;
var $5043c756765ef749$export$62d58b1c91e8e902;
var $5043c756765ef749$export$84aa927130f1a919;
var $5043c756765ef749$export$ee483a02838ec162;
var $5043c756765ef749$export$e114d13b1a258938;
$5043c756765ef749$export$7b388ca536128c6d = `_5vlQAW_inputs`;
$5043c756765ef749$export$62d58b1c91e8e902 = `_5vlQAW_tab`;
$5043c756765ef749$export$84aa927130f1a919 = `_5vlQAW_tabWrapper`;
$5043c756765ef749$export$ee483a02838ec162 = `_5vlQAW_viewportInputs`;
$5043c756765ef749$export$e114d13b1a258938 = `_5vlQAW_viewportWrapper`;




function $7a7111f71abacc0a$export$e263e067d6140649(p) {
    var rootEl = (0, $eWjiX.BB).el({});
    var text = (0, $eWjiX.BB).copyObj(p.text);
    var viewportWrapper = (0, $eWjiX.BB).el({
        className: $5043c756765ef749$export$e114d13b1a258938
    });
    var viewportUI = new (0, $5ffe4a6cd7b98bc8$export$1d311696e0fb2158)({
        text: text,
        klCanvas: p.klCanvas,
        layerIndex: p.layerIndex,
        onDragEnd: function() {
            return tabs.getOpenedTabId() === 'text' ? textUI.focus() : 0;
        }
    });
    viewportUI.render();
    function onUpdate(p) {
        text = (0, $cL71g._)({}, text, p);
        viewportUI.setText(text);
    }
    var fontUI = new (0, $d84067eeb22a523d$export$2e7faedafda1fc85)((0, $4EWN2._)((0, $cL71g._)({}, text), {
        onUpdate: function(p) {
            onUpdate(p);
        }
    }));
    var colorWrapper = (0, $eWjiX.BB).el({
        css: {
            display: 'flex',
            gap: '10px',
            flexDirection: 'column'
        }
    });
    var fillUI = new (0, $0c994c56e6434e84$export$5cdfb22682d2a5dd)({
        fill: text.fill,
        primaryColor: p.primaryColor,
        secondaryColor: p.secondaryColor,
        onUpdate: function(p) {
            onUpdate(p);
        }
    });
    var strokeUI = new (0, $1d4a3fd6cf6c0a9d$export$42bb0e3b48d549f6)({
        stroke: text.stroke,
        primaryColor: p.primaryColor,
        secondaryColor: p.secondaryColor,
        onUpdate: function(p) {
            onUpdate(p);
        }
    });
    var textUI = new (0, $c85fd0de8751b6a0$export$c6656360602b35c2)({
        text: text.text,
        onUpdate: function(p) {
            p.text !== undefined && modal.setIgnoreBackground(p.text.length > 0);
            onUpdate(p);
        }
    });
    var tabs = new (0, $d04d72b97d637d65$export$3c6d17ed0106bfb9)({
        initialId: 'text',
        height: 40,
        tabArr: [
            {
                id: 'text',
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-text'),
                onOpen: function() {
                    textUI.getElement().style.display = '';
                    textUI.focus();
                },
                onClose: function() {
                    textUI.getElement().style.display = 'none';
                }
            },
            {
                id: 'font',
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-font'),
                onOpen: function() {
                    fontUI.getElement().style.display = 'flex';
                },
                onClose: function() {
                    fontUI.getElement().style.display = 'none';
                }
            },
            {
                id: 'color',
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-color'),
                onOpen: function() {
                    colorWrapper.style.display = 'flex';
                },
                onClose: function() {
                    colorWrapper.style.display = 'none';
                }
            }
        ]
    });
    tabs.getElement().classList.add($5043c756765ef749$export$62d58b1c91e8e902);
    rootEl.append((0, $075b9fd415bad4ff$export$db3b6bfb95261072)('', [
        (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(viewportWrapper, [
            viewportUI.getElement()
        ]),
        (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('.' + $5043c756765ef749$export$ee483a02838ec162, [
            viewportUI.getInputsElement()
        ]),
        (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('.tabrow.' + $5043c756765ef749$export$84aa927130f1a919, [
            (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',w-240,h-40'),
            tabs.getElement()
        ]),
        (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('.' + $5043c756765ef749$export$7b388ca536128c6d, [
            (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(colorWrapper, [
                fillUI.getElement(),
                strokeUI.getElement()
            ]),
            fontUI.getElement(),
            textUI.getElement()
        ])
    ]));
    var onResize = function() {
        var b = viewportWrapper.getBoundingClientRect();
        var w = Math.ceil(b.width);
        var h = Math.ceil(b.height);
        viewportUI.setSize(w, h);
    };
    window.addEventListener('resize', onResize);
    setTimeout(function() {
        onResize();
    });
    setTimeout(function() {
        textUI.focus();
    }, 100);
    // prevent mobile keyboards scrolling page
    function onScroll() {
        window.scrollTo(0, 0);
    }
    window.addEventListener('scroll', onScroll, {
        passive: false
    });
    var onModalExit = function(val) {
        window.removeEventListener('resize', onResize);
        window.removeEventListener('scroll', onScroll);
        viewportUI.destroy();
        fontUI.destroy();
        fillUI.destroy();
        strokeUI.destroy();
        textUI.destroy();
        tabs.destroy();
        if (val === 'Ok') p.onConfirm((0, $cL71g._)({}, viewportUI.getValues(), fontUI.getValues(), fillUI.getValues(), strokeUI.getValues(), textUI.getValues()));
    };
    var modal = (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('text-title')}</b>`,
        div: rootEl,
        buttons: [
            'Ok',
            'Cancel'
        ],
        ignoreBackground: p.text.text.length > 0,
        callback: onModalExit,
        style: {
            width: 'calc(100% - 50px)',
            maxWidth: '1000px',
            minWidth: '300px',
            boxSizing: 'border-box'
        },
        clickOnEnter: 'Ok'
    });
}



var $eWjiX = parcelRequire("eWjiX");





var $7jh4K = parcelRequire("7jh4K");
function $c8d2eb7d799b314c$export$1bf16d9bd59fd8f9(p) {
    var rootEl = (0, $eWjiX.BB).el();
    var isSmall = window.innerWidth < 550 || window.innerHeight < 550;
    var style = isSmall ? {} : {
        width: '540px'
    };
    var resolutionEl = (0, $eWjiX.BB).el({
        css: {
            marginTop: '10px',
            textAlign: 'center',
            color: '#888',
            lineHeight: '20px'
        }
    });
    var cropCopy = new (0, $01fcd0ed15aa4018$export$40175a5948a88a57)({
        width: isSmall ? 340 : 540,
        height: isSmall ? 300 : 400,
        canvas: p.image.canvas,
        enableRightClickCopy: false,
        onChange: function(width, height) {
            if (!resolutionEl) return;
            updateResolution(width, height);
        }
    });
    (0, $7jh4K.css)(cropCopy.getElement(), {
        marginLeft: '-20px'
    });
    cropCopy.getElement().title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('crop-drag-to-crop');
    rootEl.append(cropCopy.getElement(), resolutionEl);
    function updateResolution(w, h) {
        var fit = (0, $eWjiX.BB).fitInto(w, h, p.maxSize, p.maxSize);
        if (fit.width < w) {
            resolutionEl.innerHTML = `<span class="kl-text-error">${w} X ${h}</span> \u{27F6} ${Math.round(fit.width)} X ${Math.round(fit.height)}`;
            resolutionEl.title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-too-large');
        } else {
            resolutionEl.innerHTML = `${w} X ${h}`;
            resolutionEl.title = '';
        }
    }
    updateResolution(p.image.width, p.image.height);
    var doFlatten = false;
    function showWarnings(psdWarningArr) {
        var contentArr = [];
        var warningMap = {
            mask: 'Masks not supported. Mask was applied.',
            clipping: 'Clipping not supported. Clipping layers were merged.',
            group: 'Groups not supported. Layers were ungrouped.',
            adjustment: 'Adjustment layers not supported.',
            'layer-effect': 'Layer effects not supported.',
            'smart-object': 'Smart objects not supported.',
            'blend-mode': 'Unsupported layer blend mode.',
            'bits-per-channel': 'Unsupported color depth. Only 8bit per channel supported.'
        };
        for(var i = 0; i < psdWarningArr.length; i++)contentArr.push('- ' + warningMap[psdWarningArr[i]]);
        alert(contentArr.join('\n'));
    }
    var flattenCheckbox;
    var warningsEl;
    if (p.image.type === 'psd') {
        if (p.image.layers) {
            flattenCheckbox = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
                init: doFlatten,
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-flatten'),
                callback: function(b) {
                    doFlatten = b;
                },
                name: 'flatten-image'
            });
            rootEl.append(flattenCheckbox.getElement());
            if (p.image.warningArr) {
                var noteEl = (0, $eWjiX.BB).el({
                    className: 'kl-import-note',
                    content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-psd-limited-support')
                });
                var warnings = p.image.warningArr;
                warningsEl = (0, $eWjiX.BB).el({
                    parent: noteEl,
                    tagName: 'a',
                    content: 'Details',
                    css: {
                        marginLeft: '5px'
                    },
                    onClick: function() {
                        return showWarnings(warnings);
                    }
                });
                rootEl.append(noteEl);
            }
        } else {
            var noteEl1 = (0, $eWjiX.BB).el({
                className: 'kl-import-note',
                content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-psd-unsupported')
            });
            rootEl.append(noteEl1);
        }
    }
    function callback(result) {
        var croppedCanvas = cropCopy.getCroppedCanvas();
        var cropRect = cropCopy.getCropRect();
        var isCropped = p.image.width !== cropRect.width || p.image.height !== cropRect.height;
        cropCopy.destroy();
        (0, $eWjiX.BB).destroyEl(warningsEl);
        if (flattenCheckbox) flattenCheckbox.destroy();
        if (result === (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-btn-as-layer')) {
            p.callback({
                type: 'as-layer',
                image: isCropped ? croppedCanvas : p.image.canvas
            });
            if (!isCropped) (0, $eWjiX.BB).freeCanvas(croppedCanvas);
        } else if (result === (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-btn-as-image')) {
            if (p.image.type === 'psd') {
                if (doFlatten) delete p.image.layers;
                p.callback({
                    type: 'as-image-psd',
                    image: p.image,
                    cropObj: cropRect
                });
                (0, $eWjiX.BB).freeCanvas(croppedCanvas);
            } else if (p.image.type === 'image') p.callback({
                type: 'as-image',
                image: croppedCanvas
            });
        } else {
            p.callback({
                type: 'cancel'
            });
            (0, $eWjiX.BB).freeCanvas(croppedCanvas);
        }
    }
    (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-title')}</b>`,
        div: rootEl,
        style: style,
        buttons: [
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-btn-as-layer'),
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-btn-as-image'),
            'Cancel'
        ],
        primaries: [
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-btn-as-layer'),
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-btn-as-image')
        ],
        callback: callback,
        autoFocus: 'As Image'
    });
}


var $4c230b0de5e1a470$exports = {};

$parcel$export($4c230b0de5e1a470$exports, "blendPsdToKl", function () { return $4c230b0de5e1a470$export$6df36f0c42d2440f; });
$parcel$export($4c230b0de5e1a470$exports, "blendKlToPsd", function () { return $4c230b0de5e1a470$export$4e3b1f7d3ad623b4; });
$parcel$export($4c230b0de5e1a470$exports, "readPsd", function () { return $4c230b0de5e1a470$export$3d649861c4b13fa2; });
$parcel$export($4c230b0de5e1a470$exports, "klPsdToKlProject", function () { return $4c230b0de5e1a470$export$56493bf279c387b3; });

var $eelgW = parcelRequire("eelgW");



var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");
var $4c230b0de5e1a470$var$kl2PsdMap;
var $4c230b0de5e1a470$var$psd2KlMap;
function $4c230b0de5e1a470$var$init() {
    if ($4c230b0de5e1a470$var$kl2PsdMap) return;
    $4c230b0de5e1a470$var$kl2PsdMap = {
        'source-over': 'normal',
        darken: 'darken',
        multiply: 'multiply',
        'color-burn': 'color burn',
        lighten: 'lighten',
        screen: 'screen',
        'color-dodge': 'color dodge',
        overlay: 'overlay',
        'soft-light': 'soft light',
        'hard-light': 'hard light',
        difference: 'difference',
        exclusion: 'exclusion',
        hue: 'hue',
        saturation: 'saturation',
        color: 'color',
        luminosity: 'luminosity'
    };
    $4c230b0de5e1a470$var$psd2KlMap = Object.fromEntries(Object.entries($4c230b0de5e1a470$var$kl2PsdMap).map(function(a) {
        return a.reverse();
    }));
}
function $4c230b0de5e1a470$export$6df36f0c42d2440f(str) {
    $4c230b0de5e1a470$var$init();
    return $4c230b0de5e1a470$var$psd2KlMap[str];
}
function $4c230b0de5e1a470$export$4e3b1f7d3ad623b4(str) {
    $4c230b0de5e1a470$var$init();
    return $4c230b0de5e1a470$var$kl2PsdMap[str];
}
function $4c230b0de5e1a470$export$3d649861c4b13fa2(psdObj) {
    if (!psdObj.canvas) throw new Error('psdObj.canvas undefined');
    var result = {
        type: 'psd',
        canvas: psdObj.canvas,
        width: psdObj.width,
        height: psdObj.height
    };
    function addWarning(warningStr) {
        if (!result.warningArr) result.warningArr = [];
        if (result.warningArr.includes(warningStr)) return;
        result.warningArr.push(warningStr);
    }
    function getMixModeStr(blendMode) {
        var mixModeStr = $4c230b0de5e1a470$export$6df36f0c42d2440f(blendMode);
        if (!mixModeStr) {
            addWarning('blend-mode');
            mixModeStr = 'source-over';
        }
        return mixModeStr;
    }
    if (psdObj.bitsPerChannel !== 8) addWarning('bits-per-channel');
    if (!psdObj.children) {
        result.error = true;
        return result;
    }
    // count resulting layers
    var maxLayers = (0, $0621fc8724f6bfac$export$9f4f73b1bd7c2f26);
    var layerCount = 0;
    function countWithinGroup(groupObj) {
        var result = 0;
        if (groupObj.blendMode) {
            var mixModeStr = $4c230b0de5e1a470$export$6df36f0c42d2440f(groupObj.blendMode);
            if (mixModeStr && mixModeStr !== 'source-over') return 1;
        }
        if (groupObj.children) for(var i = 0; i < groupObj.children.length; i++){
            var item = groupObj.children[i];
            if (item.clipping || item.adjustment) continue;
            if (item.children) {
                addWarning('group');
                result += countWithinGroup(item);
            } else result++;
        }
        return result;
    }
    layerCount += countWithinGroup(psdObj);
    if (layerCount > maxLayers) {
        result.error = true;
        return result;
    }
    result.layers = [];
    function prepareMask(maskCanvas, defaultColor) {
        var groupMaskCtx = (0, $eWjiX.BB).ctx(maskCanvas);
        var imData = groupMaskCtx.getImageData(0, 0, maskCanvas.width, maskCanvas.height);
        if (defaultColor === 0) for(var i = 0; i < imData.data.length; i += 4)imData.data[i + 3] = imData.data[i];
        else for(var i1 = 0; i1 < imData.data.length; i1 += 4)imData.data[i1 + 3] = 255 - imData.data[i1];
        groupMaskCtx.putImageData(imData, 0, 0);
    }
    function convertGroup(psdGroupObj) {
        var resultArr = [];
        var groupIsVisible = !psdGroupObj.hidden;
        var groupOpacity = (0, $7jh4K.throwIfUndefined)(psdGroupObj.opacity, 'groupOpacity is undefined');
        var groupMixModeStr = getMixModeStr(psdGroupObj.blendMode);
        var groupCanvas;
        var groupCtx;
        if (groupMixModeStr !== 'source-over') {
            groupCanvas = (0, $eelgW.createCanvas)(result.width, result.height);
            groupCtx = (0, $eWjiX.BB).ctx(groupCanvas);
        }
        // prepare group mask
        if (psdGroupObj.mask) {
            addWarning('mask');
            prepareMask(psdGroupObj.mask.canvas, psdGroupObj.mask.defaultColor);
        }
        if (psdGroupObj.children) for(var i = 0; i < psdGroupObj.children.length; i++){
            var item = psdGroupObj.children[i];
            if (item.clipping) continue;
            if (item.adjustment) {
                addWarning('adjustment');
                continue;
            }
            var hasClipping = (item.children || item.canvas) && psdGroupObj.children[i + 1] && psdGroupObj.children[i + 1].clipping;
            if (hasClipping) addWarning('clipping');
            if (item.children) {
                var convertedChildGroupItems = convertGroup(item);
                for(var e = 0; e < convertedChildGroupItems.length; e++){
                    var innerItem = convertedChildGroupItems[e];
                    var innerCtx = (0, $eWjiX.BB).ctx(innerItem.image);
                    // clipping
                    if (hasClipping) {
                        var clippingCanvas = (0, $eelgW.createCanvas)(result.width, result.height);
                        var clippingCtx = (0, $eWjiX.BB).ctx(clippingCanvas);
                        clippingCtx.drawImage(innerItem.image, 0, 0);
                        for(var f = i + 1; f < psdGroupObj.children.length && psdGroupObj.children[f].clipping; f++){
                            var clippingItem = psdGroupObj.children[f];
                            if (clippingItem.opacity === 0 || clippingItem.hidden) continue;
                            if (clippingItem.blendMode === undefined) throw new Error('clippingItem.blendMode undefined');
                            if (clippingItem.opacity === undefined) throw new Error('clippingItem.opacity undefined');
                            if (clippingItem.canvas === undefined) throw new Error('clippingItem.canvas undefined');
                            if (clippingItem.left === undefined) throw new Error('clippingItem.left undefined');
                            if (clippingItem.top === undefined) throw new Error('clippingItem.top undefined');
                            clippingCtx.globalCompositeOperation = getMixModeStr(clippingItem.blendMode);
                            clippingCtx.globalAlpha = clippingItem.opacity;
                            clippingCtx.drawImage(clippingItem.canvas, clippingItem.left, clippingItem.top);
                        }
                        innerCtx.globalCompositeOperation = 'source-atop';
                        innerCtx.drawImage(clippingCanvas, 0, 0);
                    }
                    // group mask
                    if (psdGroupObj.mask) {
                        innerCtx.globalCompositeOperation = psdGroupObj.mask.defaultColor === 0 ? 'destination-in' : 'destination-out';
                        if (psdGroupObj.mask.canvas === undefined) throw new Error('psdGroupObj.mask.canvas undefined');
                        if (psdGroupObj.mask.left === undefined) throw new Error('psdGroupObj.mask.left undefined');
                        if (psdGroupObj.mask.top === undefined) throw new Error('psdGroupObj.mask.top undefined');
                        innerCtx.drawImage(psdGroupObj.mask.canvas, psdGroupObj.mask.left, psdGroupObj.mask.top);
                    }
                    if (groupCanvas) {
                        if (groupCtx === undefined) throw new Error('groupCtx undefined');
                        groupCtx.globalCompositeOperation = innerItem.mixModeStr;
                        groupCtx.globalAlpha = innerItem.opacity;
                        groupCtx.drawImage(innerItem.image, 0, 0);
                    } else {
                        innerItem.opacity = innerItem.opacity * groupOpacity;
                        resultArr.push(innerItem);
                    }
                }
                continue;
            }
            var canvas = (0, $eelgW.createCanvas)(result.width, result.height);
            var ctx = (0, $eWjiX.BB).ctx(canvas);
            if (item.canvas) {
                // if a layer is empty it has no canvas
                if (item.top === undefined) throw new Error('item.top undefined');
                if (item.left === undefined) throw new Error('item.left undefined');
                ctx.drawImage(item.canvas, item.left, item.top);
            }
            // effects
            if (item.effects) addWarning('layer-effect');
            // mask
            if (item.mask) {
                addWarning('mask');
                if (item.mask.canvas === undefined) throw new Error('item.mask.canvas undefined');
                if (item.mask.defaultColor === undefined) throw new Error('item.mask.defaultColor undefined');
                if (item.mask.left === undefined) throw new Error('item.mask.left undefined');
                if (item.mask.top === undefined) throw new Error('item.mask.top undefined');
                prepareMask(item.mask.canvas, item.mask.defaultColor);
                ctx.globalCompositeOperation = item.mask.defaultColor === 0 ? 'destination-in' : 'destination-out';
                ctx.drawImage(item.mask.canvas, item.mask.left, item.mask.top);
            }
            // clipping
            if (hasClipping) {
                if (item.right === undefined) throw new Error('item.right undefined');
                if (item.left === undefined) throw new Error('item.left undefined');
                if (item.bottom === undefined) throw new Error('item.bottom undefined');
                if (item.top === undefined) throw new Error('item.top undefined');
                if (item.canvas === undefined) throw new Error('item.canvas undefined');
                var clippingCanvas1 = (0, $eelgW.createCanvas)(item.right - item.left, item.bottom - item.top);
                var clippingCtx1 = (0, $eWjiX.BB).ctx(clippingCanvas1);
                clippingCtx1.drawImage(item.canvas, 0, 0);
                for(var e1 = i + 1; e1 < psdGroupObj.children.length && psdGroupObj.children[e1].clipping; e1++){
                    var clippingItem1 = psdGroupObj.children[e1];
                    if (clippingItem1.opacity === 0 || clippingItem1.hidden) continue;
                    if (clippingItem1.blendMode === undefined) throw new Error('clippingItem.blendMode undefined');
                    if (clippingItem1.opacity === undefined) throw new Error('clippingItem.opacity undefined');
                    if (clippingItem1.canvas === undefined) throw new Error('clippingItem.canvas undefined');
                    if (clippingItem1.left === undefined) throw new Error('clippingItem.left undefined');
                    if (clippingItem1.top === undefined) throw new Error('clippingItem.top undefined');
                    clippingCtx1.globalCompositeOperation = getMixModeStr(clippingItem1.blendMode);
                    clippingCtx1.globalAlpha = clippingItem1.opacity;
                    clippingCtx1.drawImage(clippingItem1.canvas, clippingItem1.left - item.left, clippingItem1.top - item.top);
                }
                ctx.globalCompositeOperation = 'source-atop';
                ctx.drawImage(clippingCanvas1, item.left, item.top);
            }
            // group mask
            if (psdGroupObj.mask) {
                ctx.globalCompositeOperation = psdGroupObj.mask.defaultColor === 0 ? 'destination-in' : 'destination-out';
                if (psdGroupObj.mask.canvas === undefined) throw new Error('psdGroupObj.mask.canvas undefined');
                if (psdGroupObj.mask.left === undefined) throw new Error('psdGroupObj.mask.left undefined');
                if (psdGroupObj.mask.top === undefined) throw new Error('psdGroupObj.mask.top undefined');
                ctx.drawImage(psdGroupObj.mask.canvas, psdGroupObj.mask.left, psdGroupObj.mask.top);
            }
            if (item.blendMode === undefined) throw new Error('item.blendMode undefined');
            if (item.hidden === undefined) throw new Error('item.hidden  undefined');
            if (item.opacity === undefined) throw new Error('item.opacity undefined');
            if (groupCanvas && groupCtx) {
                if (groupOpacity > 0) {
                    groupCtx.globalCompositeOperation = getMixModeStr(item.blendMode);
                    groupCtx.globalAlpha = item.hidden ? 0 : item.opacity;
                    groupCtx.drawImage(canvas, 0, 0);
                }
            } else {
                if (item.name === undefined) throw new Error('item.name undefined');
                resultArr.push({
                    name: item.name,
                    isVisible: !item.hidden && groupIsVisible,
                    opacity: item.opacity * groupOpacity,
                    mixModeStr: getMixModeStr(item.blendMode),
                    image: canvas
                });
            }
        }
        if (groupCanvas) {
            if (psdGroupObj.name === undefined) throw new Error('psdGroupObj.name undefined');
            resultArr = [
                {
                    name: psdGroupObj.name,
                    isVisible: groupIsVisible,
                    opacity: groupOpacity,
                    mixModeStr: groupMixModeStr,
                    image: groupCanvas
                }
            ];
        }
        return resultArr;
    }
    result.layers = convertGroup({
        name: 'root',
        opacity: 1,
        blendMode: 'normal',
        children: psdObj.children
    });
    return result;
}
function $4c230b0de5e1a470$export$56493bf279c387b3(klPsd) {
    // only share references to Canvas elements
    var result = {
        projectId: (0, $7jh4K.randomUuid)(),
        width: klPsd.width,
        height: klPsd.height,
        layers: []
    };
    if (klPsd.layers) result.layers = klPsd.layers.map(function(item) {
        return {
            name: item.name,
            isVisible: item.isVisible,
            opacity: item.opacity,
            mixModeStr: item.mixModeStr,
            image: item.image
        };
    });
    else // flattened
    result.layers = [
        {
            name: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('background'),
            isVisible: true,
            opacity: 1,
            mixModeStr: 'source-over',
            image: klPsd.canvas
        }
    ];
    return result;
}




var $265ee43f4530dfdd$exports = {};
$265ee43f4530dfdd$exports = $parcel$resolve("5tPq3");



var $46f219e0a1cc1280$exports = {};
$46f219e0a1cc1280$exports = $parcel$resolve("245NA");


var $315a989e9c802914$exports = {};
$315a989e9c802914$exports = $parcel$resolve("1hkCG");


var $8a7fd2e695a7a526$exports = {};
$8a7fd2e695a7a526$exports = $parcel$resolve("k2eFf");


var $59220e55090c6477$exports = {};
$59220e55090c6477$exports = $parcel$resolve("krKGd");


var $f2352131ea231846$exports = {};
$f2352131ea231846$exports = $parcel$resolve("ehfxY");


var $5bdc34b3a28d8c4f$exports = {};
$5bdc34b3a28d8c4f$exports = $parcel$resolve("beOjS");



var $5e7602aa944597cf$exports = {};
$5e7602aa944597cf$exports = $parcel$resolve("Gk9bV");


var $f1177b20ba8f372a$exports = {};
$f1177b20ba8f372a$exports = $parcel$resolve("csed7");


var $58b7d5e146b5b789$exports = {};
$58b7d5e146b5b789$exports = $parcel$resolve("equSE");


var $57af312447b22316$exports = {};
$57af312447b22316$exports = $parcel$resolve("h1dN3");


var $112696c449310458$exports = {};
$112696c449310458$exports = $parcel$resolve("LfAXI");


var $2ceb6fbc21a0912d$exports = {};
$2ceb6fbc21a0912d$exports = $parcel$resolve("cB6q6");


var $7c1d057215a9f0a8$exports = {};
$7c1d057215a9f0a8$exports = $parcel$resolve("S9ano");


var $54abf2b24b46f3e1$exports = {};
$54abf2b24b46f3e1$exports = $parcel$resolve("4eqRj");


var $e679ececcabe94c9$exports = {};
$e679ececcabe94c9$exports = $parcel$resolve("8mvSV");


var $524973ee3882f42f$exports = {};
$524973ee3882f42f$exports = $parcel$resolve("kbc0v");


var $805be15a1e91c0ee$export$24724bc1f91cba3 = {
    isLoaded: false
};
var $805be15a1e91c0ee$export$bac24f240bb7727d = {
    brightnessContrast: {
        lang: {
            name: 'filter-bright-contrast-title',
            button: 'filter-bright-contrast',
            description: 'filter-bright-contrast-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($265ee43f4530dfdd$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    cropExtend: {
        lang: {
            name: 'filter-crop-title',
            button: 'filter-crop-extend',
            description: 'filter-crop-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($96cbdba315fc6e81$exports))),
        updatePos: true,
        getDialog: null,
        apply: null,
        inEmbed: false
    },
    curves: {
        lang: {
            name: 'filter-curves-title',
            button: 'filter-curves',
            description: 'filter-curves-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($46f219e0a1cc1280$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    distort: {
        lang: {
            name: 'filter-distort',
            button: 'filter-distort',
            description: 'filter-distort-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($524973ee3882f42f$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    flip: {
        lang: {
            name: 'filter-flip-title',
            button: 'filter-flip',
            description: 'filter-flip-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($315a989e9c802914$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    },
    hueSaturation: {
        lang: {
            name: 'filter-hue-sat-title',
            button: 'filter-hue-sat',
            description: 'filter-hue-sat-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8a7fd2e695a7a526$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    invert: {
        lang: {
            name: 'filter-invert',
            button: 'filter-invert'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($59220e55090c6477$exports))),
        updatePos: false,
        isInstant: true,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    perspective: {
        lang: {
            name: 'filter-perspective-title',
            button: 'filter-perspective',
            description: 'filter-perspective-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f2352131ea231846$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    resize: {
        lang: {
            name: 'filter-resize-title',
            button: 'filter-resize',
            description: 'filter-resize-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5bdc34b3a28d8c4f$exports))),
        updatePos: true,
        getDialog: null,
        apply: null,
        inEmbed: false
    },
    rotate: {
        lang: {
            name: 'filter-rotate-title',
            button: 'filter-rotate',
            description: 'filter-rotate-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4acb6b8f0d0d377a$exports))),
        updatePos: true,
        getDialog: null,
        apply: null,
        inEmbed: false
    },
    tiltShift: {
        lang: {
            name: 'filter-tilt-shift-title',
            button: 'filter-tilt-shift',
            description: 'filter-tilt-shift-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5e7602aa944597cf$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    toAlpha: {
        lang: {
            name: 'filter-to-alpha-title',
            button: 'filter-to-alpha',
            description: 'filter-to-alpha-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f1177b20ba8f372a$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    transform: {
        lang: {
            name: 'filter-transform-title',
            button: 'filter-transform',
            description: 'filter-transform-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($58b7d5e146b5b789$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    },
    blur: {
        lang: {
            name: 'filter-triangle-blur-title',
            button: 'filter-triangle-blur',
            description: 'filter-triangle-blur-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($57af312447b22316$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    unsharpMask: {
        lang: {
            name: 'filter-unsharp-mask-title',
            button: 'filter-unsharp-mask',
            description: 'filter-unsharp-mask-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($112696c449310458$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        darkNoInvert: true,
        webGL: true
    },
    grid: {
        lang: {
            name: 'filter-grid',
            button: 'filter-grid',
            description: 'filter-grid-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2ceb6fbc21a0912d$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    },
    noise: {
        lang: {
            name: 'filter-noise',
            button: 'filter-noise',
            description: 'filter-noise-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7c1d057215a9f0a8$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true,
        webGL: true
    },
    pattern: {
        lang: {
            name: 'filter-pattern',
            button: 'filter-pattern',
            description: 'filter-pattern-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($54abf2b24b46f3e1$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    },
    vanishPoint: {
        lang: {
            name: 'filter-vanish-point-title',
            button: 'filter-vanish-point',
            description: 'filter-vanish-point-description'
        },
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e679ececcabe94c9$exports))),
        updatePos: false,
        getDialog: null,
        apply: null,
        inEmbed: true
    }
};



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $bX4ja = parcelRequire("bX4ja");

var $eWjiX = parcelRequire("eWjiX");

var $eWjiX = parcelRequire("eWjiX");
/*
 * A speed-improved perlin and simplex noise algorithms for 2D.
 *
 * Based on example code by Stefan Gustavson (stegu@itn.liu.se).
 * Optimisations by Peter Eastman (peastman@drizzle.stanford.edu).
 * Better rank ordering method by Stefan Gustavson in 2012.
 * Converted to Javascript by Joseph Gentle.
 *
 * Version 2012-03-09
 *
 * This code was placed in the public domain by its original author,
 * Stefan Gustavson. You may use it as you see fit, but
 * attribution is appreciated.
 *
 */ 
var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $dfc47a34ad9bc378$var$myModule = {};
var $dfc47a34ad9bc378$var$Grad = /*#__PURE__*/ function() {
    "use strict";
    function Grad(x, y, z) {
        (0, $cx0mh._)(this, Grad);
        this.x = x;
        this.y = y;
        this.z = z;
    }
    (0, $7h4XF._)(Grad, [
        {
            key: "dot2",
            value: function dot2(x, y) {
                return this.x * x + this.y * y;
            }
        }
    ]);
    return Grad;
}();
/*
Grad.prototype.dot3 = function(x, y, z) {
    return this.x*x + this.y*y + this.z*z;
};*/ var $dfc47a34ad9bc378$var$grad3 = [
    new $dfc47a34ad9bc378$var$Grad(1, 1, 0),
    new $dfc47a34ad9bc378$var$Grad(-1, 1, 0),
    new $dfc47a34ad9bc378$var$Grad(1, -1, 0),
    new $dfc47a34ad9bc378$var$Grad(-1, -1, 0),
    new $dfc47a34ad9bc378$var$Grad(1, 0, 1),
    new $dfc47a34ad9bc378$var$Grad(-1, 0, 1),
    new $dfc47a34ad9bc378$var$Grad(1, 0, -1),
    new $dfc47a34ad9bc378$var$Grad(-1, 0, -1),
    new $dfc47a34ad9bc378$var$Grad(0, 1, 1),
    new $dfc47a34ad9bc378$var$Grad(0, -1, 1),
    new $dfc47a34ad9bc378$var$Grad(0, 1, -1),
    new $dfc47a34ad9bc378$var$Grad(0, -1, -1)
];
var $dfc47a34ad9bc378$var$p = [
    151,
    160,
    137,
    91,
    90,
    15,
    131,
    13,
    201,
    95,
    96,
    53,
    194,
    233,
    7,
    225,
    140,
    36,
    103,
    30,
    69,
    142,
    8,
    99,
    37,
    240,
    21,
    10,
    23,
    190,
    6,
    148,
    247,
    120,
    234,
    75,
    0,
    26,
    197,
    62,
    94,
    252,
    219,
    203,
    117,
    35,
    11,
    32,
    57,
    177,
    33,
    88,
    237,
    149,
    56,
    87,
    174,
    20,
    125,
    136,
    171,
    168,
    68,
    175,
    74,
    165,
    71,
    134,
    139,
    48,
    27,
    166,
    77,
    146,
    158,
    231,
    83,
    111,
    229,
    122,
    60,
    211,
    133,
    230,
    220,
    105,
    92,
    41,
    55,
    46,
    245,
    40,
    244,
    102,
    143,
    54,
    65,
    25,
    63,
    161,
    1,
    216,
    80,
    73,
    209,
    76,
    132,
    187,
    208,
    89,
    18,
    169,
    200,
    196,
    135,
    130,
    116,
    188,
    159,
    86,
    164,
    100,
    109,
    198,
    173,
    186,
    3,
    64,
    52,
    217,
    226,
    250,
    124,
    123,
    5,
    202,
    38,
    147,
    118,
    126,
    255,
    82,
    85,
    212,
    207,
    206,
    59,
    227,
    47,
    16,
    58,
    17,
    182,
    189,
    28,
    42,
    223,
    183,
    170,
    213,
    119,
    248,
    152,
    2,
    44,
    154,
    163,
    70,
    221,
    153,
    101,
    155,
    167,
    43,
    172,
    9,
    129,
    22,
    39,
    253,
    19,
    98,
    108,
    110,
    79,
    113,
    224,
    232,
    178,
    185,
    112,
    104,
    218,
    246,
    97,
    228,
    251,
    34,
    242,
    193,
    238,
    210,
    144,
    12,
    191,
    179,
    162,
    241,
    81,
    51,
    145,
    235,
    249,
    14,
    239,
    107,
    49,
    192,
    214,
    31,
    181,
    199,
    106,
    157,
    184,
    84,
    204,
    176,
    115,
    121,
    50,
    45,
    127,
    4,
    150,
    254,
    138,
    236,
    205,
    93,
    222,
    114,
    67,
    29,
    24,
    72,
    243,
    141,
    128,
    195,
    78,
    66,
    215,
    61,
    156,
    180
];
// To remove the need for index wrapping, double the permutation table length
var $dfc47a34ad9bc378$var$perm = new Array(512);
var $dfc47a34ad9bc378$var$gradP = new Array(512);
// This isn't a very good seeding function, but it works ok. It supports 2^16
// different seed values. Write something better if you need more seeds.
$dfc47a34ad9bc378$var$myModule.seed = function(seed) {
    if (seed > 0 && seed < 1) // Scale the seed out
    seed *= 65536;
    seed = Math.floor(seed);
    if (seed < 256) seed |= seed << 8;
    for(var i = 0; i < 256; i++){
        var v = void 0;
        if (i & 1) v = $dfc47a34ad9bc378$var$p[i] ^ seed & 255;
        else v = $dfc47a34ad9bc378$var$p[i] ^ seed >> 8 & 255;
        $dfc47a34ad9bc378$var$perm[i] = $dfc47a34ad9bc378$var$perm[i + 256] = v;
        $dfc47a34ad9bc378$var$gradP[i] = $dfc47a34ad9bc378$var$gradP[i + 256] = $dfc47a34ad9bc378$var$grad3[v % 12];
    }
};
$dfc47a34ad9bc378$var$myModule.seed(0);
/*
for (let i=0; i<256; i++) {
  perm[i] = perm[i + 256] = p[i];
  gradP[i] = gradP[i + 256] = grad3[perm[i] % 12];
}*/ // Skewing and unskewing factors for 2, 3, and 4 dimensions
var $dfc47a34ad9bc378$var$F2 = 0.5 * (Math.sqrt(3) - 1);
var $dfc47a34ad9bc378$var$G2 = (3 - Math.sqrt(3)) / 6;
/*let F3 = 1/3;
let G3 = 1/6;*/ // 2D simplex noise
$dfc47a34ad9bc378$var$myModule.simplex2 = function(xin, yin) {
    var n0, n1, n2; // Noise contributions from the three corners
    // Skew the input space to determine which simplex cell we're in
    var s = (xin + yin) * $dfc47a34ad9bc378$var$F2; // Hairy factor for 2D
    var i = Math.floor(xin + s);
    var j = Math.floor(yin + s);
    var t = (i + j) * $dfc47a34ad9bc378$var$G2;
    var x0 = xin - i + t; // The x,y distances from the cell origin, unskewed.
    var y0 = yin - j + t;
    // For the 2D case, the simplex shape is an equilateral triangle.
    // Determine which simplex we are in.
    var i1, j1; // Offsets for second (middle) corner of simplex in (i,j) coords
    if (x0 > y0) {
        // lower triangle, XY order: (0,0)->(1,0)->(1,1)
        i1 = 1;
        j1 = 0;
    } else {
        // upper triangle, YX order: (0,0)->(0,1)->(1,1)
        i1 = 0;
        j1 = 1;
    }
    // A step of (1,0) in (i,j) means a step of (1-c,-c) in (x,y), and
    // a step of (0,1) in (i,j) means a step of (-c,1-c) in (x,y), where
    // c = (3-sqrt(3))/6
    var x1 = x0 - i1 + $dfc47a34ad9bc378$var$G2; // Offsets for middle corner in (x,y) unskewed coords
    var y1 = y0 - j1 + $dfc47a34ad9bc378$var$G2;
    var x2 = x0 - 1 + 2 * $dfc47a34ad9bc378$var$G2; // Offsets for last corner in (x,y) unskewed coords
    var y2 = y0 - 1 + 2 * $dfc47a34ad9bc378$var$G2;
    // Work out the hashed gradient indices of the three simplex corners
    i &= 255;
    j &= 255;
    var gi0 = $dfc47a34ad9bc378$var$gradP[i + $dfc47a34ad9bc378$var$perm[j]];
    var gi1 = $dfc47a34ad9bc378$var$gradP[i + i1 + $dfc47a34ad9bc378$var$perm[j + j1]];
    var gi2 = $dfc47a34ad9bc378$var$gradP[i + 1 + $dfc47a34ad9bc378$var$perm[j + 1]];
    // Calculate the contribution from the three corners
    var t0 = 0.5 - x0 * x0 - y0 * y0;
    if (t0 < 0) n0 = 0;
    else {
        t0 *= t0;
        n0 = t0 * t0 * gi0.dot2(x0, y0); // (x,y) of grad3 used for 2D gradient
    }
    var t1 = 0.5 - x1 * x1 - y1 * y1;
    if (t1 < 0) n1 = 0;
    else {
        t1 *= t1;
        n1 = t1 * t1 * gi1.dot2(x1, y1);
    }
    var t2 = 0.5 - x2 * x2 - y2 * y2;
    if (t2 < 0) n2 = 0;
    else {
        t2 *= t2;
        n2 = t2 * t2 * gi2.dot2(x2, y2);
    }
    // Add contributions from each corner to get the final noise value.
    // The result is scaled to return values in the interval [-1,1].
    return 70 * (n0 + n1 + n2);
};
var $dfc47a34ad9bc378$export$d3022aad56692482 = $dfc47a34ad9bc378$var$myModule;


function $f875015ce1aeb4d3$export$74a44bbc21d06a28(w) {
    var scaleFac = w / 500;
    var h = w;
    var canvas = (0, $eWjiX.BB).canvas(w, h);
    var ctx = (0, $eWjiX.BB).ctx(canvas);
    var imData = ctx.createImageData(w, h);
    for(var x = 0; x < w; x++)for(var y = 0; y < h; y++){
        var i = (y * w + x) * 4;
        // base noise
        var sFac2 = scaleFac + (0, $dfc47a34ad9bc378$export$d3022aad56692482).simplex2(x / 50 / scaleFac, y / 50 / scaleFac) * 0.04;
        var noisePattern = 100 + ((0, $dfc47a34ad9bc378$export$d3022aad56692482).simplex2(x / 50 / sFac2, y / 50 / sFac2) + 1) / 2 * 100;
        noisePattern -= ((0, $dfc47a34ad9bc378$export$d3022aad56692482).simplex2(x / 10 / scaleFac, y / 10 / scaleFac) + 1) / 2 * 100;
        // fade out in circular shape
        var centerDist = (0, $eWjiX.BB).dist(w / 2, h / 2, x, y);
        var falloff = (0, $eWjiX.BB).clamp(1 - ((centerDist - w / 2.5) / (w / 14) + (0, $dfc47a34ad9bc378$export$d3022aad56692482).simplex2(x / 22 / sFac2, y / 22 / sFac2)), 0, 1);
        noisePattern = noisePattern * falloff;
        // make the middle darker
        var falloff2 = (0, $eWjiX.BB).clamp(1 - centerDist / w, 0, 1) * 2;
        noisePattern = noisePattern * falloff2;
        imData.data[i] = 0;
        imData.data[i + 1] = 0;
        imData.data[i + 2] = 0;
        imData.data[i + 3] = (0, $eWjiX.BB).clamp(noisePattern, 0, 255);
    }
    ctx.putImageData(imData, 0, 0);
    return canvas;
}
// https://www.shadertoy.com/view/3tdSDj
function $f875015ce1aeb4d3$var$udSegment(p, a, b) {
    var ba = (0, $eWjiX.BB).Vec2.sub(b, a);
    var pa = (0, $eWjiX.BB).Vec2.sub(p, a);
    var h = (0, $eWjiX.BB).clamp((0, $eWjiX.BB).Vec2.dot(pa, ba) / (0, $eWjiX.BB).Vec2.dot(ba, ba), 0.0, 1.0);
    return (0, $eWjiX.BB).Vec2.len((0, $eWjiX.BB).Vec2.sub(pa, (0, $eWjiX.BB).Vec2.mul(ba, h)));
}
function $f875015ce1aeb4d3$export$eaa218d5d17c8f1c(w) {
    var pDist = 1 / 4;
    var centerSize = 2 / 3;
    var transitionSize = 1 / 3;
    centerSize *= pDist;
    transitionSize *= pDist;
    var p1 = {
        x: pDist * w,
        y: w - w * pDist
    };
    var p2 = {
        x: w - w * pDist,
        y: pDist * w
    };
    var h = w;
    var canvas = (0, $eWjiX.BB).canvas(w, h);
    var ctx = (0, $eWjiX.BB).ctx(canvas);
    var imData = ctx.createImageData(w, h);
    for(var x = 0; x < w; x++)for(var y = 0; y < h; y++){
        var i = (y * w + x) * 4;
        var col = $f875015ce1aeb4d3$var$udSegment({
            x: x,
            y: y
        }, p1, p2);
        col = (0, $eWjiX.BB).clamp(255 - (col - w * centerSize) / (w * transitionSize) * 255, 0, 255);
        imData.data[i] = 0;
        imData.data[i + 1] = 0;
        imData.data[i + 2] = 0;
        imData.data[i + 3] = col;
    }
    ctx.putImageData(imData, 0, 0);
    return canvas;
}


var $ff6c1f784f50f5d5$export$67a3081d7cc6182d = []; // used by default brush
$ff6c1f784f50f5d5$export$67a3081d7cc6182d[1] = (0, $f875015ce1aeb4d3$export$74a44bbc21d06a28)(128);
$ff6c1f784f50f5d5$export$67a3081d7cc6182d[2] = (0, $f875015ce1aeb4d3$export$eaa218d5d17c8f1c)(128);



var $8N5YG = parcelRequire("8N5YG");

var $bX4ja = parcelRequire("bX4ja");

function $5bc59effccf14376$export$263fa670dc037098(composed, imageOrTiles, extraFrameTiles) {
    var activeLayerId = composed.activeLayerId;
    var layerMap = Object.fromEntries(Object.entries(composed.layerMap).map(function(param) {
        var _param = (0, $8N5YG._)(param, 2), layerId = _param[0], layerItem = _param[1];
        if (layerId === activeLayerId) {
            var entry = {
                tiles: imageOrTiles instanceof HTMLCanvasElement ? (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(imageOrTiles) : (0, $bX4ja._)(imageOrTiles)
            };
            if (extraFrameTiles && extraFrameTiles.length > 0) entry.frameTiles = extraFrameTiles;
            return [
                layerId,
                entry
            ];
        }
        return [
            layerId,
            {}
        ];
    }));
    return {
        layerMap: layerMap
    };
}





var $9b3eo = parcelRequire("9b3eo");

var $eg83P = parcelRequire("eg83P");

var $3f0923cd3c55ea92$var$ALPHA_CIRCLE = 0;
var $3f0923cd3c55ea92$var$ALPHA_CHALK = 1;
var $3f0923cd3c55ea92$var$ALPHA_CAL = 2; // calligraphy
var $3f0923cd3c55ea92$var$ALPHA_SQUARE = 3;
var $3f0923cd3c55ea92$var$TWO_PI = 2 * Math.PI;
var $3f0923cd3c55ea92$export$6f96c8f9e6ae7341 = /*#__PURE__*/ function() {
    "use strict";
    function PenBrush() {
        (0, $cx0mh._)(this, PenBrush);
        this.context = {};
        this.klHistory = {};
        this.settingHasOpacityPressure = false;
        this.settingHasScatterPressure = false;
        this.settingHasSizePressure = true;
        this.settingSize = 2;
        this.settingSpacing = 0.8489;
        this.settingOpacity = 1;
        this.settingScatter = 0;
        this.settingColor = {};
        this.settingColorStr = '';
        this.settingAlphaId = $3f0923cd3c55ea92$var$ALPHA_CIRCLE;
        this.settingLockLayerAlpha = false;
        this.hasDrawnDot = false;
        this.lineToolLastDot = 0;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.inputArr = [];
        this.inputIsDrawing = false;
        this.bezierLine = null;
        // mipmapping
        this.alphaCanvas128 = (0, $eWjiX.BB).canvas(128, 128);
        this.alphaCanvas64 = (0, $eWjiX.BB).canvas(64, 64);
        this.alphaCanvas32 = (0, $eWjiX.BB).canvas(32, 32);
        this.alphaOpacityArr = [
            1,
            0.9,
            1,
            1
        ];
        this.changedTiles = [];
        // Extra frame contexts for animation (frame 1, 2, ...)
        this.extraContexts = [];
        this.extraChangedTiles = [];
    }
    (0, $7h4XF._)(PenBrush, [
        {
            key: "updateChangedTiles",
            value: function updateChangedTiles1(bounds) {
                var boundsWithinSelection = (0, $eg83P.intersectBounds)(bounds, this.selectionBounds);
                if (!boundsWithinSelection) return;
                var newTiles = (0, $3798530d3967d87a$export$2098fe43203ddd32)(boundsWithinSelection, this.context.canvas.width, this.context.canvas.height);
                this.changedTiles = (0, $3798530d3967d87a$export$1774f90c6da5013c)(this.changedTiles, newTiles);
            }
        },
        {
            key: "updateExtraChangedTiles",
            value: function updateExtraChangedTiles(frameIndex, bounds) {
                var boundsWithinSelection = (0, $eg83P.intersectBounds)(bounds, this.selectionBounds);
                if (!boundsWithinSelection) return;
                var newTiles = (0, $3798530d3967d87a$export$2098fe43203ddd32)(boundsWithinSelection, this.context.canvas.width, this.context.canvas.height);
                this.extraChangedTiles[frameIndex] = (0, $3798530d3967d87a$export$1774f90c6da5013c)(this.extraChangedTiles[frameIndex] || [], newTiles);
            }
        },
        {
            key: "updateAlphaCanvas",
            value: function updateAlphaCanvas() {
                if (this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_CIRCLE || this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_SQUARE) return;
                var instructionArr = [
                    [
                        this.alphaCanvas128,
                        128
                    ],
                    [
                        this.alphaCanvas64,
                        64
                    ],
                    [
                        this.alphaCanvas32,
                        32
                    ]
                ];
                var ctx;
                for(var i = 0; i < instructionArr.length; i++){
                    ctx = (0, $eWjiX.BB).ctx(instructionArr[i][0]);
                    ctx.save();
                    ctx.clearRect(0, 0, instructionArr[i][1], instructionArr[i][1]);
                    ctx.fillStyle = 'rgba(' + this.settingColor.r + ', ' + this.settingColor.g + ', ' + this.settingColor.b + ', ' + this.alphaOpacityArr[this.settingAlphaId] + ')';
                    ctx.fillRect(0, 0, instructionArr[i][1], instructionArr[i][1]);
                    ctx.globalCompositeOperation = 'destination-in';
                    ctx.imageSmoothingQuality = 'high';
                    ctx.drawImage((0, $ff6c1f784f50f5d5$export$67a3081d7cc6182d)[this.settingAlphaId], 0, 0, instructionArr[i][1], instructionArr[i][1]);
                    ctx.restore();
                }
            }
        },
        {
            key: "calcOpacity",
            value: function calcOpacity(pressure) {
                return this.settingOpacity * (this.settingHasOpacityPressure ? pressure * pressure : 1);
            }
        },
        {
            key: "calcScatter",
            value: function calcScatter(pressure) {
                return this.settingScatter * this.settingSize * (this.settingHasScatterPressure ? pressure : 1);
            }
        },
        {
            key: "drawDotOnCtx",
            value: /**
     * Draws a single dot on a specific context at the given position.
     */ function drawDotOnCtx(ctx, x, y, size, opacity, angle) {
                if (this.settingLockLayerAlpha) ctx.globalCompositeOperation = 'source-atop';
                ctx.globalAlpha = opacity;
                if (this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_CIRCLE || this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_SQUARE) ctx.fillStyle = this.settingColorStr;
                if (this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_CIRCLE) {
                    ctx.beginPath();
                    ctx.arc(x, y, size, 0, $3f0923cd3c55ea92$var$TWO_PI);
                    ctx.closePath();
                    ctx.fill();
                } else if (this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_SQUARE) {
                    if (angle !== undefined) {
                        ctx.save();
                        ctx.translate(x, y);
                        ctx.rotate(angle / 180 * Math.PI);
                        ctx.fillRect(-size, -size, size * 2, size * 2);
                        ctx.restore();
                    }
                } else {
                    ctx.save();
                    ctx.translate(x, y);
                    var targetMipmap = this.alphaCanvas128;
                    if (size <= 32 && size > 16) targetMipmap = this.alphaCanvas64;
                    else if (size <= 16) targetMipmap = this.alphaCanvas32;
                    ctx.scale(size, size);
                    if (this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_CHALK) ctx.rotate((x + y) * 53123 % $3f0923cd3c55ea92$var$TWO_PI);
                    ctx.drawImage(targetMipmap, -1, -1, 2, 2);
                    ctx.restore();
                }
            }
        },
        {
            key: "drawDot",
            value: /**
     * @param x
     * @param y
     * @param size
     * @param opacity
     * @param scatter
     * @param angle
     * @param before - [x, y, size, opacity, angle] the drawDot call before
     */ function drawDot(x, y, size, opacity, scatter, angle, before) {
                if (size <= 0) return;
                if (this.settingLockLayerAlpha) this.context.globalCompositeOperation = 'source-atop';
                if (!before || before[3] !== opacity) this.context.globalAlpha = opacity;
                if (!before && (this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_CIRCLE || this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_SQUARE)) this.context.fillStyle = this.settingColorStr;
                // Apply scatter to main context
                var mainX = x;
                var mainY = y;
                if (scatter > 0) {
                    var scatterAngleRad = Math.random() * $3f0923cd3c55ea92$var$TWO_PI;
                    var distance = Math.sqrt(Math.random()) * scatter;
                    mainX += Math.cos(scatterAngleRad) * distance;
                    mainY += Math.sin(scatterAngleRad) * distance;
                }
                var boundsSize = this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_CIRCLE || this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_CAL ? size : size * Math.sqrt(2);
                this.updateChangedTiles({
                    type: 'index',
                    x1: Math.floor(mainX - boundsSize),
                    y1: Math.floor(mainY - boundsSize),
                    x2: Math.ceil(mainX + boundsSize - 1),
                    y2: Math.ceil(mainY + boundsSize - 1)
                });
                if (this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_CIRCLE) {
                    this.context.beginPath();
                    this.context.arc(mainX, mainY, size, 0, $3f0923cd3c55ea92$var$TWO_PI);
                    this.context.closePath();
                    this.context.fill();
                    this.hasDrawnDot = true;
                } else if (this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_SQUARE) {
                    if (angle !== undefined) {
                        this.context.save();
                        this.context.translate(mainX, mainY);
                        this.context.rotate(angle / 180 * Math.PI);
                        this.context.fillRect(-size, -size, size * 2, size * 2);
                        this.context.restore();
                        this.hasDrawnDot = true;
                    }
                } else {
                    this.context.save();
                    this.context.translate(mainX, mainY);
                    var targetMipmap = this.alphaCanvas128;
                    if (size <= 32 && size > 16) targetMipmap = this.alphaCanvas64;
                    else if (size <= 16) targetMipmap = this.alphaCanvas32;
                    this.context.scale(size, size);
                    if (this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_CHALK) this.context.rotate((mainX + mainY) * 53123 % $3f0923cd3c55ea92$var$TWO_PI);
                    this.context.drawImage(targetMipmap, -1, -1, 2, 2);
                    this.context.restore();
                    this.hasDrawnDot = true;
                }
                // Draw on extra frame contexts
                for(var f = 0; f < this.extraContexts.length; f++){
                    var ctx = this.extraContexts[f];
                    var fx = void 0, fy = void 0;
                    if (scatter > 0) {
                        // Different random scatter for each frame
                        var scatterAngleRad1 = Math.random() * $3f0923cd3c55ea92$var$TWO_PI;
                        var distance1 = Math.sqrt(Math.random()) * scatter;
                        fx = x + Math.cos(scatterAngleRad1) * distance1;
                        fy = y + Math.sin(scatterAngleRad1) * distance1;
                    } else {
                        // No scatter: same position as main
                        fx = mainX;
                        fy = mainY;
                    }
                    this.updateExtraChangedTiles(f, {
                        type: 'index',
                        x1: Math.floor(fx - boundsSize),
                        y1: Math.floor(fy - boundsSize),
                        x2: Math.ceil(fx + boundsSize - 1),
                        y2: Math.ceil(fy + boundsSize - 1)
                    });
                    this.drawDotOnCtx(ctx, fx, fy, size, opacity, angle);
                }
            }
        },
        {
            key: "continueLine",
            value: // continueLine
            function continueLine(x, y, size, pressure) {
                var _this = this;
                if (this.bezierLine === null) {
                    this.bezierLine = new (0, $eWjiX.BB).BezierLine();
                    this.bezierLine.add(this.lastInput.x, this.lastInput.y, 0, function() {});
                }
                var drawArr = []; //draw instructions. will be all drawn at once
                var dotCallback = function(val) {
                    var localPressure = (0, $eWjiX.BB).mix(_this.lastInput2.pressure, pressure, val.t);
                    var localOpacity = _this.calcOpacity(localPressure);
                    var localSize = Math.max(0.1, _this.settingSize * (_this.settingHasSizePressure ? localPressure : 1));
                    var localScatter = _this.calcScatter(localPressure);
                    drawArr.push([
                        val.x,
                        val.y,
                        localSize,
                        localOpacity,
                        localScatter,
                        val.angle
                    ]);
                };
                var localSpacing = size * this.settingSpacing;
                if (x === null || y === null) this.bezierLine.addFinal(localSpacing, dotCallback);
                else this.bezierLine.add(x, y, localSpacing, dotCallback);
                // execute draw instructions
                this.context.save();
                this.extraContexts.forEach(function(ctx) {
                    return ctx.save();
                });
                var before = undefined;
                for(var i = 0; i < drawArr.length; i++){
                    var item = drawArr[i];
                    this.drawDot(item[0], item[1], item[2], item[3], item[4], item[5], before);
                    before = item;
                }
                this.context.restore();
                this.extraContexts.forEach(function(ctx) {
                    return ctx.restore();
                });
            }
        },
        {
            // ---- interface ----
            key: "startLine",
            value: function startLine(x, y, p) {
                var _this = this;
                this.selection = this.klHistory.getComposed().selection.value;
                this.selectionPath = this.selection ? (0, $9b3eo.getSelectionPath2d)(this.selection) : undefined;
                this.selectionBounds = this.selection ? (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
                this.changedTiles = [];
                this.extraChangedTiles = this.extraContexts.map(function() {
                    return [];
                });
                p = (0, $eWjiX.BB).clamp(p, 0, 1);
                var localOpacity = this.calcOpacity(p);
                var localSize = this.settingHasSizePressure ? Math.max(0.1, p * this.settingSize) : Math.max(0.1, this.settingSize);
                var localScatter = this.calcScatter(p);
                this.hasDrawnDot = false;
                this.inputIsDrawing = true;
                this.context.save();
                this.selectionPath && this.context.clip(this.selectionPath);
                this.extraContexts.forEach(function(ctx) {
                    ctx.save();
                    _this.selectionPath && ctx.clip(_this.selectionPath);
                });
                this.drawDot(x, y, localSize, localOpacity, localScatter);
                this.context.restore();
                this.extraContexts.forEach(function(ctx) {
                    return ctx.restore();
                });
                this.lineToolLastDot = localSize * this.settingSpacing;
                this.lastInput.x = x;
                this.lastInput.y = y;
                this.lastInput.pressure = p;
                this.lastInput2.pressure = p;
                this.inputArr = [
                    {
                        x: x,
                        y: y,
                        pressure: p
                    }
                ];
            }
        },
        {
            key: "goLine",
            value: function goLine(x, y, p) {
                var _this = this;
                if (!this.inputIsDrawing) return;
                var pressure = (0, $eWjiX.BB).clamp(p, 0, 1);
                var localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
                this.context.save();
                this.selectionPath && this.context.clip(this.selectionPath);
                this.extraContexts.forEach(function(ctx) {
                    ctx.save();
                    _this.selectionPath && ctx.clip(_this.selectionPath);
                });
                this.continueLine(x, y, localSize, this.lastInput.pressure);
                this.context.restore();
                this.extraContexts.forEach(function(ctx) {
                    return ctx.restore();
                });
                this.lastInput.x = x;
                this.lastInput.y = y;
                this.lastInput2.pressure = this.lastInput.pressure;
                this.lastInput.pressure = pressure;
                this.inputArr.push({
                    x: x,
                    y: y,
                    pressure: p
                });
            }
        },
        {
            key: "endLine",
            value: function endLine() {
                var _this = this;
                var localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
                this.context.save();
                this.selectionPath && this.context.clip(this.selectionPath);
                this.extraContexts.forEach(function(ctx) {
                    ctx.save();
                    _this.selectionPath && ctx.clip(_this.selectionPath);
                });
                this.continueLine(null, null, localSize, this.lastInput.pressure);
                this.context.restore();
                this.extraContexts.forEach(function(ctx) {
                    return ctx.restore();
                });
                this.inputIsDrawing = false;
                if (this.settingAlphaId === $3f0923cd3c55ea92$var$ALPHA_SQUARE && !this.hasDrawnDot) {
                    var maxInput = this.inputArr[0];
                    this.inputArr.forEach(function(item) {
                        if (item.pressure > maxInput.pressure) maxInput = item;
                    });
                    this.context.save();
                    this.selectionPath && this.context.clip(this.selectionPath);
                    this.extraContexts.forEach(function(ctx) {
                        ctx.save();
                        _this.selectionPath && ctx.clip(_this.selectionPath);
                    });
                    var p = (0, $eWjiX.BB).clamp(maxInput.pressure, 0, 1);
                    var localOpacity = this.calcOpacity(p);
                    var localScatter = this.calcScatter(p);
                    this.drawDot(maxInput.x, maxInput.y, localSize, localOpacity, localScatter, 0);
                    this.context.restore();
                    this.extraContexts.forEach(function(ctx) {
                        return ctx.restore();
                    });
                }
                this.bezierLine = null;
                var hasMainChanges = this.changedTiles.some(function(item) {
                    return item;
                });
                var hasExtraChanges = this.extraChangedTiles.some(function(tiles) {
                    return tiles.some(function(item) {
                        return item;
                    });
                });
                if (hasMainChanges || hasExtraChanges) {
                    var mainTiles = (0, $1a6c9997bc8182ff$export$6706c882ea9c3dbd)(this.context.canvas, this.changedTiles);
                    var extraFrameTiles;
                    if (this.extraContexts.length > 0) extraFrameTiles = this.extraContexts.map(function(ctx, i) {
                        // Union of frame 0 changes and this frame's changes.
                        // Without this, compose would incorrectly fall back to frame 0's
                        // content at positions that only changed on frame 0 (not this frame).
                        var unionChanged = (0, $bX4ja._)(_this.changedTiles);
                        var extra = _this.extraChangedTiles[i] || [];
                        for(var t = 0; t < extra.length; t++)if (extra[t]) unionChanged[t] = true;
                        return (0, $1a6c9997bc8182ff$export$6706c882ea9c3dbd)(ctx.canvas, unionChanged);
                    });
                    this.klHistory.push((0, $5bc59effccf14376$export$263fa670dc037098)(this.klHistory.getComposed(), mainTiles, extraFrameTiles));
                }
                this.hasDrawnDot = false;
                this.inputArr = [];
            }
        },
        {
            key: "drawLineSegment",
            value: function drawLineSegment(x1, y1, x2, y2) {
                var _this = this;
                this.selection = this.klHistory.getComposed().selection.value;
                this.selectionPath = this.selection ? (0, $9b3eo.getSelectionPath2d)(this.selection) : undefined;
                this.selectionBounds = this.selection ? (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
                this.changedTiles = [];
                this.extraChangedTiles = this.extraContexts.map(function() {
                    return [];
                });
                this.lastInput.x = x2;
                this.lastInput.y = y2;
                this.lastInput.pressure = 1;
                if (this.inputIsDrawing || x1 === undefined) return;
                var angle = (0, $eWjiX.BB).pointsToAngleDeg({
                    x: x1,
                    y: y1
                }, {
                    x: x2,
                    y: y2
                });
                var mouseDist = Math.sqrt(Math.pow(x2 - x1, 2.0) + Math.pow(y2 - y1, 2.0));
                var eX = (x2 - x1) / mouseDist;
                var eY = (y2 - y1) / mouseDist;
                var loopDist;
                var bdist = this.settingSize * this.settingSpacing;
                this.lineToolLastDot = this.settingSize * this.settingSpacing;
                this.context.save();
                this.selectionPath && this.context.clip(this.selectionPath);
                this.extraContexts.forEach(function(ctx) {
                    ctx.save();
                    _this.selectionPath && ctx.clip(_this.selectionPath);
                });
                var localScatter = this.calcScatter(1);
                for(loopDist = this.lineToolLastDot; loopDist <= mouseDist; loopDist += bdist)this.drawDot(x1 + eX * loopDist, y1 + eY * loopDist, this.settingSize, this.settingOpacity, localScatter, angle);
                this.context.restore();
                this.extraContexts.forEach(function(ctx) {
                    return ctx.restore();
                });
                var hasMainChanges = this.changedTiles.some(function(item) {
                    return item;
                });
                var hasExtraChanges = this.extraChangedTiles.some(function(tiles) {
                    return tiles.some(function(item) {
                        return item;
                    });
                });
                if (hasMainChanges || hasExtraChanges) {
                    var mainTiles = (0, $1a6c9997bc8182ff$export$6706c882ea9c3dbd)(this.context.canvas, this.changedTiles);
                    var extraFrameTiles;
                    if (this.extraContexts.length > 0) extraFrameTiles = this.extraContexts.map(function(ctx, i) {
                        var unionChanged = (0, $bX4ja._)(_this.changedTiles);
                        var extra = _this.extraChangedTiles[i] || [];
                        for(var t = 0; t < extra.length; t++)if (extra[t]) unionChanged[t] = true;
                        return (0, $1a6c9997bc8182ff$export$6706c882ea9c3dbd)(ctx.canvas, unionChanged);
                    });
                    this.klHistory.push((0, $5bc59effccf14376$export$263fa670dc037098)(this.klHistory.getComposed(), mainTiles, extraFrameTiles));
                }
            }
        },
        {
            //IS
            key: "isDrawing",
            value: function isDrawing() {
                return this.inputIsDrawing;
            }
        },
        {
            //SET
            key: "setAlpha",
            value: function setAlpha(a) {
                if (this.settingAlphaId === a) return;
                this.settingAlphaId = a;
                this.updateAlphaCanvas();
            }
        },
        {
            key: "setColor",
            value: function setColor(c) {
                if (this.settingColor === c) return;
                this.settingColor = {
                    r: c.r,
                    g: c.g,
                    b: c.b
                };
                this.settingColorStr = 'rgb(' + this.settingColor.r + ',' + this.settingColor.g + ',' + this.settingColor.b + ')';
                this.updateAlphaCanvas();
            }
        },
        {
            key: "setContext",
            value: function setContext(c) {
                this.context = c;
            }
        },
        {
            key: "setExtraContexts",
            value: function setExtraContexts(contexts) {
                this.extraContexts = contexts;
            }
        },
        {
            key: "setHistory",
            value: function setHistory(klHistory) {
                this.klHistory = klHistory;
            }
        },
        {
            key: "setSize",
            value: function setSize(s) {
                this.settingSize = s;
            }
        },
        {
            key: "setOpacity",
            value: function setOpacity(o) {
                this.settingOpacity = o;
            }
        },
        {
            key: "setScatter",
            value: function setScatter(o) {
                this.settingScatter = o;
            }
        },
        {
            key: "setSpacing",
            value: function setSpacing(s) {
                this.settingSpacing = s;
            }
        },
        {
            key: "sizePressure",
            value: function sizePressure(b) {
                this.settingHasSizePressure = b;
            }
        },
        {
            key: "opacityPressure",
            value: function opacityPressure(b) {
                this.settingHasOpacityPressure = b;
            }
        },
        {
            key: "scatterPressure",
            value: function scatterPressure(b) {
                this.settingHasScatterPressure = b;
            }
        },
        {
            key: "setLockAlpha",
            value: function setLockAlpha(b) {
                this.settingLockLayerAlpha = b;
            }
        },
        {
            //GET
            key: "getSpacing",
            value: function getSpacing() {
                return this.settingSpacing;
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.settingSize;
            }
        },
        {
            key: "getOpacity",
            value: function getOpacity() {
                return this.settingOpacity;
            }
        },
        {
            key: "getScatter",
            value: function getScatter() {
                return this.settingScatter;
            }
        },
        {
            key: "getLockAlpha",
            value: function getLockAlpha() {
                return this.settingLockLayerAlpha;
            }
        }
    ]);
    return PenBrush;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $esGm2 = parcelRequire("esGm2");

var $eg83P = parcelRequire("eg83P");

var $gWfkn = parcelRequire("gWfkn");



var $7jh4K = parcelRequire("7jh4K");




var $02d77b8dd5755328$export$9659db8d01dd5313 = /*#__PURE__*/ function() {
    "use strict";
    function BlendBrush() {
        (0, $cx0mh._)(this, BlendBrush);
        // testing mode - context only gets updated when line is finished
        this.isTesting = false;
        // replay mode - read from canvas context instead of composed tiles
        this.replayMode = false;
        this.context = {};
        this.layerId = 'NOT_SET';
        this.color = {};
        this.size = 29 // radius - 0.5 - 99999
        ;
        this.opacity = 0.6 // 0-1
        ;
        this.blending = 0.65 // 0-1
        ;
        this.settingLockLayerAlpha = false;
        this.settingSizePressure = true;
        this.settingOpacityPressure = false;
        this.blendCol = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        } // todo docs
        ;
        this.blendMix = 0.45 // todo docs
        ;
        this.mixCol = {
            r: 0,
            g: 0,
            b: 0
        } // todo docs
        ;
        this.localColOld = {} // todo docs
        ;
        this.isDrawing = false;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        } // todo docs
        ;
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        } // todo docs
        ;
        this.klHistory = {};
        this.cells = [];
        this.drawBuffer = [];
    }
    (0, $7h4XF._)(BlendBrush, [
        {
            key: "updateRedrawBounds",
            value: function updateRedrawBounds(bounds) {
                var boundsWithinSelection = (0, $eg83P.intersectBounds)(bounds, this.selectionBounds);
                if (!boundsWithinSelection) return;
                this.redrawBounds = (0, $eWjiX.BB).updateBounds(this.redrawBounds, boundsWithinSelection);
            }
        },
        {
            key: "getCellsWidth",
            value: function getCellsWidth() {
                return Math.ceil(this.context.canvas.width / (0, $gWfkn.HISTORY_TILE_SIZE));
            }
        },
        {
            key: "drawCells",
            value: /**
     * draw cells onto context
     * @param cells
     */ function drawCells(cells) {
                var _this = this;
                var cellsW = this.getCellsWidth();
                cells.forEach(function(imageData, index) {
                    if (!imageData) return;
                    var cellOffsetX = index % cellsW * (0, $gWfkn.HISTORY_TILE_SIZE);
                    var cellOffsetY = Math.floor(index / cellsW) * (0, $gWfkn.HISTORY_TILE_SIZE);
                    _this.context.putImageData(imageData, cellOffsetX, cellOffsetY);
                });
            }
        },
        {
            key: "drawChangedCells",
            value: /**
     * draw changed cells (changed by brushstroke) onto context
     * @private
     */ function drawChangedCells() {
                var _this = this;
                if (!this.redrawBounds) return;
                var cells = this.cells.map(function() {
                    return undefined;
                });
                var touchedCells = this.getTouchedCells(this.redrawBounds);
                touchedCells.forEach(function(isTouched, index) {
                    if (isTouched) cells[index] = _this.cells[index];
                });
                this.drawCells(cells);
                this.redrawBounds = undefined;
            }
        },
        {
            key: "getTouchedCells",
            value: function getTouchedCells(bounds) {
                var touchedCells = this.cells.map(function() {
                    return false;
                });
                var cellsW = this.getCellsWidth();
                bounds = {
                    type: 'index',
                    x1: Math.floor(bounds.x1 / (0, $gWfkn.HISTORY_TILE_SIZE)),
                    y1: Math.floor(bounds.y1 / (0, $gWfkn.HISTORY_TILE_SIZE)),
                    x2: Math.floor(bounds.x2 / (0, $gWfkn.HISTORY_TILE_SIZE)),
                    y2: Math.floor(bounds.y2 / (0, $gWfkn.HISTORY_TILE_SIZE))
                };
                for(var i = bounds.x1; i <= bounds.x2; i++)for(var e = bounds.y1; e <= bounds.y2; e++)touchedCells[e * cellsW + i] = true;
                return touchedCells;
            }
        },
        {
            key: "sliceBounds",
            value: /**
     * Slice up bounds according to cells
     * @param bounds
     * @private
     */ function sliceBounds(bounds) {
                var _this = this;
                var boundsWithinSelection = (0, $eg83P.intersectBounds)(bounds, this.selectionBounds);
                if (!boundsWithinSelection) return [];
                var cellsW = this.getCellsWidth();
                var result = [];
                var touchedCells = this.getTouchedCells(boundsWithinSelection);
                touchedCells.forEach(function(cell, i) {
                    if (!cell) return;
                    var cellOffsetX = i % cellsW * (0, $gWfkn.HISTORY_TILE_SIZE);
                    var cellOffsetY = Math.floor(i / cellsW) * (0, $gWfkn.HISTORY_TILE_SIZE);
                    var cellWidth = _this.cells[i].width;
                    var cellHeight = _this.cells[i].height;
                    var inCellBounds = {
                        type: 'index',
                        x1: Math.max(0, boundsWithinSelection.x1 - cellOffsetX),
                        y1: Math.max(0, boundsWithinSelection.y1 - cellOffsetY),
                        x2: Math.min(cellWidth - 1, boundsWithinSelection.x2 - cellOffsetX),
                        y2: Math.min(cellHeight - 1, boundsWithinSelection.y2 - cellOffsetY)
                    };
                    if (inCellBounds.x1 > inCellBounds.x2 || inCellBounds.y1 > inCellBounds.y2) return;
                    result.push({
                        index: i,
                        bounds: inCellBounds
                    });
                });
                return result;
            }
        },
        {
            key: "copyFromCanvas",
            value: /**
     * update copyImageData. copy over new regions if needed
     */ function copyFromCanvas(bounds) {
                var _this = this;
                if (!bounds) return;
                var touchedCells = this.getTouchedCells(bounds);
                var cellsW = this.getCellsWidth();
                if (this.replayMode) // In replay mode, read from the actual canvas context to get
                // per-frame content. Uses a temp canvas to avoid Chrome perf issue.
                touchedCells.forEach(function(item, i) {
                    if (!item || _this.cells[i]) return;
                    var cellOffsetX = i % cellsW * (0, $gWfkn.HISTORY_TILE_SIZE);
                    var cellOffsetY = Math.floor(i / cellsW) * (0, $gWfkn.HISTORY_TILE_SIZE);
                    var w = Math.min((0, $gWfkn.HISTORY_TILE_SIZE), _this.context.canvas.width - cellOffsetX);
                    var h = Math.min((0, $gWfkn.HISTORY_TILE_SIZE), _this.context.canvas.height - cellOffsetY);
                    var tmpCanvas = (0, $eWjiX.BB).canvas(w, h);
                    var tmpCtx = (0, $eWjiX.BB).ctx(tmpCanvas);
                    tmpCtx.drawImage(_this.context.canvas, -cellOffsetX, -cellOffsetY);
                    _this.cells[i] = tmpCtx.getImageData(0, 0, w, h);
                });
                else {
                    var composedLayer = this.klHistory.getComposed().layerMap[this.layerId];
                    touchedCells.forEach(function(item, i) {
                        if (!item || _this.cells[i]) // not touched, or already copied
                        return;
                        var composedTile = composedLayer.tiles[i];
                        if ((0, $esGm2.isLayerFill)(composedTile)) {
                            var canvas = (0, $eWjiX.BB).canvas((0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE));
                            var ctx = (0, $eWjiX.BB).ctx(canvas);
                            ctx.fillStyle = composedTile.fill;
                            ctx.fillRect(0, 0, (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE));
                            _this.cells[i] = ctx.getImageData(0, 0, (0, $gWfkn.HISTORY_TILE_SIZE), (0, $gWfkn.HISTORY_TILE_SIZE));
                        } else _this.cells[i] = (0, $871c020f286838cc$export$3d7bd55e322555b1)(composedTile.data);
                    });
                }
            }
        },
        {
            key: "getAverage",
            value: function getAverage(x, y, size) {
                var _this = this;
                size = Math.max(0.5, size * 0.75);
                var x1 = Math.max(0, Math.floor(x - size));
                var y1 = Math.max(0, Math.floor(y - size));
                var x2 = Math.min(this.context.canvas.width - 1, Math.ceil(x + size));
                var y2 = Math.min(this.context.canvas.height - 1, Math.ceil(y + size));
                if (x1 > x2 || y1 > y2) return {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 0
                };
                var ar = 0, ag = 0, ab = 0, aa = 0;
                var slicedBounds = this.sliceBounds({
                    type: 'index',
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                });
                var cellsW = this.getCellsWidth();
                slicedBounds.forEach(function(slice) {
                    var cellOffsetX = slice.index % cellsW * (0, $gWfkn.HISTORY_TILE_SIZE);
                    var cellOffsetY = Math.floor(slice.index / cellsW) * (0, $gWfkn.HISTORY_TILE_SIZE);
                    var width = _this.cells[slice.index].width;
                    var data = _this.cells[slice.index].data;
                    var bounds = slice.bounds;
                    for(var i = bounds.y1, globalY = i + cellOffsetY; i <= bounds.y2; i++, globalY++)for(var e = bounds.x1, globalX = e + cellOffsetX, e2 = (i * width + bounds.x1) * 4; e <= bounds.x2; e++, globalX++, e2 += 4){
                        if (_this.mask && _this.mask[globalY * _this.context.canvas.width + globalX] === 0) continue;
                        var alpha = data[e2 + 3] / 255;
                        if (alpha === 0) continue;
                        ar += data[e2] * alpha;
                        ag += data[e2 + 1] * alpha;
                        ab += data[e2 + 2] * alpha;
                        aa += alpha;
                    }
                });
                if (aa !== 0) {
                    ar /= aa;
                    ag /= aa;
                    ab /= aa;
                    aa = Math.min(1, aa);
                }
                return {
                    r: ar,
                    g: ag,
                    b: ab,
                    a: aa
                };
            }
        },
        {
            key: "getDotBounds",
            value: function getDotBounds(x, y, size) {
                size = Math.max(0.5, size);
                var x1 = Math.max(0, Math.floor(x - size));
                var y1 = Math.max(0, Math.floor(y - size));
                var x2 = Math.min(this.context.canvas.width - 1, Math.ceil(x + size));
                var y2 = Math.min(this.context.canvas.height - 1, Math.ceil(y + size));
                if (x1 > x2 || y1 > y2) return undefined;
                return {
                    type: 'index',
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                };
            }
        },
        {
            key: "drawDot",
            value: function drawDot(params) {
                var _this = this;
                // array with random numbers. faster than Math.random()
                var randI = 0;
                var randLen = params.size > 30 ? 1024 : 512; // lower lengths lead to noticeable patterns
                var randArr = [];
                for(var i = 0; i < randLen; i++)randArr[i] = (Math.random() - 0.5) / 1.001 + 0.5;
                // thin lines take more than just 1 sample
                var sampleArr = [
                    8,
                    4,
                    4,
                    4,
                    2,
                    2,
                    2,
                    2,
                    2,
                    2
                ]; // <0.5, 0.5, 1, 1.5, etc.
                var samples = sampleArr[Math.floor(params.size * 2)];
                var samplesSquared = samples ? samples * samples : 0;
                var sampleOffsets = [];
                if (samples) {
                    var i1 = 0;
                    for(var n = 0; n < samples; n++)for(var m = 0; m < samples; m++, i1 += 2){
                        sampleOffsets[i1] = (n + 1) / samples; // x offset
                        sampleOffsets[i1 + 1] = (m + 1) / samples; // y offset
                    }
                }
                var sharpness = Math.pow(params.opacity, 2) * 0.8;
                // to optimize calculations
                var invSharpness = 1 - sharpness;
                var sharpnessSubtrahend = sharpness / invSharpness;
                var sizeSquared = params.size * params.size;
                var distDivisor = sizeSquared * invSharpness / params.opacity;
                var alphaMinuend = (1 + sharpnessSubtrahend) * params.opacity;
                var slicedBounds = this.sliceBounds({
                    type: 'index',
                    x1: params.x1,
                    y1: params.y1,
                    x2: params.x2,
                    y2: params.y2
                });
                var cellsW = this.getCellsWidth();
                slicedBounds.forEach(function(slice) {
                    var cellOffsetX = slice.index % cellsW * (0, $gWfkn.HISTORY_TILE_SIZE);
                    var cellOffsetY = Math.floor(slice.index / cellsW) * (0, $gWfkn.HISTORY_TILE_SIZE);
                    var cellWidth = _this.cells[slice.index].width;
                    var data = _this.cells[slice.index].data;
                    // i - y index within cell
                    // e - x index within cell
                    // e2 - index in image data (a tile)
                    // mi - index in mask (one mask for the entire image)
                    // ri - y index within image relative to dot-center
                    // re - x index within image relative to dot-center
                    for(var i = slice.bounds.y1, ri = i + cellOffsetY - params.y; i <= slice.bounds.y2; i++, ri++)for(var e = slice.bounds.x1, mi = (i + cellOffsetY) * _this.context.canvas.width + (slice.bounds.x1 + cellOffsetX), e2 = (i * cellWidth + slice.bounds.x1) * 4, re = e + cellOffsetX - params.x; e <= slice.bounds.x2; e++, mi++, e2 += 4, re++){
                        if (_this.mask && _this.mask[mi] === 0) continue;
                        // O = over -> brush-dot
                        // U = under -> image
                        var alphaO = 0;
                        if (samplesSquared) {
                            for(var f = 0; f < sampleOffsets.length; f += 2){
                                var dist = (0, $eWjiX.BB).lenSquared(re + sampleOffsets[f], ri + sampleOffsets[f + 1]);
                                if (dist >= sizeSquared) continue;
                                alphaO += (0, $eg83P.clamp)(alphaMinuend - dist / distDivisor, 0, params.opacity);
                            }
                            if (!alphaO) continue;
                            alphaO /= samplesSquared;
                        } else {
                            // technically needs + 0.5 offset, but not noticeable with large brush
                            var dist1 = Math.pow(re, 2) + Math.pow(ri, 2);
                            if (dist1 >= sizeSquared) continue;
                            alphaO = (0, $eg83P.clamp)(alphaMinuend - dist1 / distDivisor, 0, params.opacity);
                        }
                        var invAlphaO = 1 - alphaO;
                        var alphaU = data[e2 + 3] / 255;
                        if (_this.settingLockLayerAlpha) {
                            var underR = params.r * alphaO + data[e2] * invAlphaO;
                            var underG = params.g * alphaO + data[e2 + 1] * invAlphaO;
                            var underB = params.b * alphaO + data[e2 + 2] * invAlphaO;
                            if (alphaU) {
                                data[e2] = Math.floor(underR + randArr[randI]);
                                data[e2 + 1] = Math.floor(underG + randArr[randI]);
                                data[e2 + 2] = Math.floor(underB + randArr[randI]);
                            }
                        } else {
                            var underR1 = params.r * alphaO + data[e2] * alphaU * invAlphaO;
                            var underG1 = params.g * alphaO + data[e2 + 1] * alphaU * invAlphaO;
                            var underB1 = params.b * alphaO + data[e2 + 2] * alphaU * invAlphaO;
                            var newAlpha = 1 - invAlphaO * (1 - alphaU);
                            data[e2 + 3] = Math.floor(Math.min(255, newAlpha * 255) + 0.5);
                            if (newAlpha) {
                                data[e2] = Math.floor(underR1 / newAlpha + randArr[randI]);
                                data[e2 + 1] = Math.floor(underG1 / newAlpha + randArr[randI]);
                                data[e2 + 2] = Math.floor(underB1 / newAlpha + randArr[randI]);
                            }
                        }
                        randI = (randI + 1) % randLen;
                    }
                });
            }
        },
        {
            key: "calcSpacing",
            value: function calcSpacing(size) {
                return (0, $eWjiX.BB).mix(size * 2 / 2, size * 2 / 9, (0, $eg83P.clamp)((size - 2.7) / 9.3, 0, 1));
            }
        },
        {
            key: "continueLine",
            value: function continueLine(x, y, p, isCoalesced) {
                var _this = this;
                this.drawBuffer = [];
                var localPressure;
                var localOpacity;
                var localSize = this.settingSizePressure ? Math.max(1, p * this.size) : Math.max(1, this.size);
                var bDist = this.calcSpacing(localSize);
                var avgX = x === undefined ? this.lastInput.x : x;
                var avgY = y === undefined ? this.lastInput.y : y;
                var localColNew;
                if (this.blending === 0) {
                    this.mixCol.r = this.color.r;
                    this.mixCol.g = this.color.g;
                    this.mixCol.b = this.color.b;
                } else {
                    var average;
                    if (isCoalesced) average = {
                        r: this.localColOld.r,
                        g: this.localColOld.g,
                        b: this.localColOld.b,
                        a: 0
                    };
                    else {
                        var avgParams = [
                            avgX,
                            avgY,
                            this.settingSizePressure ? Math.max(0.5, p * this.size) : Math.max(0.5, this.size)
                        ];
                        var bounds = this.getDotBounds(avgParams[0], avgParams[1], avgParams[2]);
                        if (bounds) this.copyFromCanvas(bounds);
                        average = this.getAverage(avgParams[0], avgParams[1], avgParams[2]);
                    }
                    localColNew = {
                        r: 0,
                        g: 0,
                        b: 0,
                        a: 0
                    };
                    if (average.a > 0 && this.blendCol.a === 0) {
                        this.blendCol.r = average.r;
                        this.blendCol.g = average.g;
                        this.blendCol.b = average.b;
                        this.blendCol.a = average.a;
                        localColNew.r = this.blendCol.r;
                        localColNew.g = this.blendCol.g;
                        localColNew.b = this.blendCol.b;
                        localColNew.a = this.blendCol.a;
                    } else {
                        if (average.a === 0) {
                            average.r = this.color.r;
                            average.g = this.color.g;
                            average.b = this.color.b;
                            average.a = 1 - this.blending;
                        }
                        this.blendCol.r = (0, $eWjiX.BB).mix(this.blendCol.r, (0, $eWjiX.BB).mix(this.blendCol.r, average.r, this.blendMix), average.a);
                        this.blendCol.g = (0, $eWjiX.BB).mix(this.blendCol.g, (0, $eWjiX.BB).mix(this.blendCol.g, average.g, this.blendMix), average.a);
                        this.blendCol.b = (0, $eWjiX.BB).mix(this.blendCol.b, (0, $eWjiX.BB).mix(this.blendCol.b, average.b, this.blendMix), average.a);
                        this.blendCol.a = Math.min(1, this.blendCol.a + average.a);
                        localColNew.r = this.blendCol.r;
                        localColNew.g = this.blendCol.g;
                        localColNew.b = this.blendCol.b;
                        localColNew.a = this.blendCol.a;
                    }
                }
                var bezierCallback = function(val) {
                    if (_this.blending >= 1 && _this.blendCol.a <= 0) return;
                    var factor = val.t;
                    localPressure = _this.lastInput2.pressure * (1 - factor) + p * factor;
                    localOpacity = _this.settingOpacityPressure ? _this.opacity * localPressure * localPressure : _this.opacity;
                    localSize = _this.settingSizePressure ? Math.max(0.1, localPressure * _this.size) : Math.max(0.1, _this.size);
                    if (_this.blending != 0) {
                        _this.mixCol.r = (0, $eWjiX.BB).mix(_this.localColOld.r, localColNew.r, factor);
                        _this.mixCol.g = (0, $eWjiX.BB).mix(_this.localColOld.g, localColNew.g, factor);
                        _this.mixCol.b = (0, $eWjiX.BB).mix(_this.localColOld.b, localColNew.b, factor);
                    }
                    if (_this.blending === 1 && _this.localColOld.a === 0) {
                        _this.mixCol.r = localColNew.r;
                        _this.mixCol.g = localColNew.g;
                        _this.mixCol.b = localColNew.b;
                    }
                    var bounds = _this.getDotBounds(val.x, val.y, localSize);
                    if (bounds) {
                        _this.updateRedrawBounds(bounds);
                        _this.drawBuffer.push({
                            x: val.x,
                            y: val.y,
                            size: localSize,
                            opacity: localOpacity,
                            x1: bounds.x1,
                            y1: bounds.y1,
                            x2: bounds.x2,
                            y2: bounds.y2,
                            r: (0, $eWjiX.BB).mix(_this.color.r, _this.mixCol.r, _this.blending),
                            g: (0, $eWjiX.BB).mix(_this.color.g, _this.mixCol.g, _this.blending),
                            b: (0, $eWjiX.BB).mix(_this.color.b, _this.mixCol.b, _this.blending)
                        });
                    }
                };
                if (x === undefined || y === undefined) this.bezierLine.addFinal(bDist, bezierCallback);
                else this.bezierLine.add(x, y, bDist, bezierCallback);
                this.copyFromCanvas(this.redrawBounds);
                this.drawBuffer.forEach(function(item) {
                    _this.drawDot(item);
                });
                this.drawBuffer = [];
                this.localColOld = localColNew;
            }
        },
        {
            key: "setHistory",
            value: function setHistory(klHistory) {
                this.klHistory = klHistory;
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.size;
            }
        },
        {
            key: "setSize",
            value: function setSize(s) {
                this.size = s;
            }
        },
        {
            key: "getOpacity",
            value: function getOpacity() {
                return this.opacity;
            }
        },
        {
            key: "setOpacity",
            value: function setOpacity(o) {
                this.opacity = o;
            }
        },
        {
            key: "getBlending",
            value: function getBlending() {
                return this.blending;
            }
        },
        {
            key: "setBlending",
            value: function setBlending(b) {
                this.blending = b;
            }
        },
        {
            key: "setColor",
            value: function setColor(c) {
                this.color = (0, $eWjiX.BB).copyObj(c);
            }
        },
        {
            key: "setContext",
            value: function setContext(c, id) {
                this.context = c;
                this.layerId = id;
            }
        },
        {
            key: "setSizePressure",
            value: function setSizePressure(b) {
                this.settingSizePressure = b;
            }
        },
        {
            key: "setOpacityPressure",
            value: function setOpacityPressure(b) {
                this.settingOpacityPressure = b;
            }
        },
        {
            key: "getLockAlpha",
            value: function getLockAlpha() {
                return this.settingLockLayerAlpha;
            }
        },
        {
            key: "setLockAlpha",
            value: function setLockAlpha(b) {
                this.settingLockLayerAlpha = b;
            }
        },
        {
            key: "getIsDrawing",
            value: function getIsDrawing() {
                return this.isDrawing;
            }
        },
        {
            key: "setIsTesting",
            value: function setIsTesting(b) {
                this.isTesting = b;
            }
        },
        {
            key: "setReplayMode",
            value: function setReplayMode(replay) {
                this.replayMode = replay;
            }
        },
        {
            key: "startLine",
            value: function startLine(x, y, p) {
                var _this = this;
                var selection = this.klHistory.getComposed().selection.value;
                this.selectionBounds = selection ? (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(selection, 'index') : undefined;
                this.mask = selection ? (0, $bdef137f4147ecbc$export$820c5732ce56544)(selection, this.context.canvas.width, this.context.canvas.height) : undefined;
                var totalCells = Math.ceil(this.context.canvas.width / (0, $gWfkn.HISTORY_TILE_SIZE)) * Math.ceil(this.context.canvas.height / (0, $gWfkn.HISTORY_TILE_SIZE));
                this.cells = (0, $7jh4K.createArray)(totalCells, undefined);
                this.isDrawing = true;
                p = Math.max(0, Math.min(1, p));
                var localOpacity = this.settingOpacityPressure ? this.opacity * p * p : this.opacity;
                var localSize = this.settingSizePressure ? Math.max(0.1, p * this.size) : Math.max(0.1, this.size);
                if (this.blending === 0) {
                    this.mixCol.r = this.color.r;
                    this.mixCol.g = this.color.g;
                    this.mixCol.b = this.color.b;
                } else {
                    this.copyFromCanvas(this.getDotBounds(x, y, localSize));
                    var average = this.getAverage(x, y, this.settingSizePressure ? Math.max(0.1, p * this.size) : Math.max(0.1, this.size));
                    if (average.a === 0) this.blendCol = {
                        r: this.color.r,
                        g: this.color.g,
                        b: this.color.b,
                        a: 1 - this.blending
                    };
                    else this.blendCol = {
                        r: average.r,
                        g: average.g,
                        b: average.b,
                        a: average.a
                    };
                    this.mixCol.r = this.blendCol.r;
                    this.mixCol.g = this.blendCol.g;
                    this.mixCol.b = this.blendCol.b;
                }
                this.localColOld = {
                    r: this.mixCol.r,
                    g: this.mixCol.g,
                    b: this.mixCol.b,
                    a: this.blendCol.a
                };
                this.redrawBounds = undefined;
                this.drawBuffer = [];
                if (this.blending < 1 || this.blendCol.a > 0) {
                    var bounds = this.getDotBounds(x, y, localSize);
                    if (bounds) {
                        this.updateRedrawBounds(bounds);
                        this.drawBuffer.push({
                            x: x,
                            y: y,
                            size: localSize,
                            opacity: localOpacity,
                            x1: bounds.x1,
                            y1: bounds.y1,
                            x2: bounds.x2,
                            y2: bounds.y2,
                            r: (0, $eWjiX.BB).mix(this.color.r, this.mixCol.r, this.blending),
                            g: (0, $eWjiX.BB).mix(this.color.g, this.mixCol.g, this.blending),
                            b: (0, $eWjiX.BB).mix(this.color.b, this.mixCol.b, this.blending)
                        });
                    }
                }
                this.copyFromCanvas(this.redrawBounds);
                this.drawBuffer.forEach(function(item) {
                    _this.drawDot(item);
                });
                this.drawBuffer = [];
                this.bezierLine = new (0, $eWjiX.BB).BezierLine();
                this.bezierLine.add(x, y, 0, function() {});
                this.lastInput.x = x;
                this.lastInput.y = y;
                this.lastInput.pressure = p;
                this.lastInput2 = (0, $eWjiX.BB).copyObj(this.lastInput);
                if (!this.isTesting) this.drawChangedCells();
            }
        },
        {
            key: "goLine",
            value: function goLine(x, y, p, isCoalesced) {
                if (!this.isDrawing) return;
                this.continueLine(x, y, this.lastInput.pressure, isCoalesced);
                this.lastInput2 = (0, $eWjiX.BB).copyObj(this.lastInput);
                this.lastInput.x = x;
                this.lastInput.y = y;
                this.lastInput.pressure = p;
                if (!this.isTesting) this.drawChangedCells();
            }
        },
        {
            key: "endLine",
            value: function endLine() {
                if (this.bezierLine) this.continueLine(undefined, undefined, this.lastInput.pressure, false);
                this.isDrawing = false;
                this.bezierLine = undefined;
                this.drawChangedCells();
                if (this.cells.some(function(item) {
                    return item;
                })) {
                    var cells = this.cells;
                    if (this.selectionBounds) {
                        var tilesInSelection = (0, $3798530d3967d87a$export$2098fe43203ddd32)(this.selectionBounds, this.context.canvas.width, this.context.canvas.height);
                        cells = cells.map(function(cell, index) {
                            return tilesInSelection[index] ? cell : undefined;
                        });
                    }
                    this.klHistory.push((0, $5bc59effccf14376$export$263fa670dc037098)(this.klHistory.getComposed(), cells.map(function(cell) {
                        return cell ? (0, $90d1e8bd87cfe19c$export$55941c74c8f934)(cell) : undefined;
                    })));
                }
                this.cells = [];
            }
        },
        {
            key: "drawLineSegment",
            value: function drawLineSegment(x1, y1, x2, y2) {
                var dx = x2 - x1;
                var dy = y2 - y1;
                var distance = Math.sqrt(dx * dx + dy * dy);
                var steps = Math.ceil(distance / 10);
                this.startLine(x1, y1, 1);
                for(var i = 1; i <= steps; i++){
                    var t = i / steps;
                    var xi = x1 + dx * t;
                    var yi = y1 + dy * t;
                    this.goLine(xi, yi, 1, false);
                }
                this.endLine();
            }
        }
    ]);
    return BlendBrush;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");



var $9b3eo = parcelRequire("9b3eo");

var $eg83P = parcelRequire("eg83P");

var $c214fbe9e4fc15b0$var$sampleCanvas = (0, $eWjiX.BB).canvas(32, 32);
var $c214fbe9e4fc15b0$var$sampleCtx = (0, $eWjiX.BB).ctx($c214fbe9e4fc15b0$var$sampleCanvas);
var $c214fbe9e4fc15b0$export$566f9061f0f5ba33 = /*#__PURE__*/ function() {
    "use strict";
    function SketchyBrush() {
        (0, $cx0mh._)(this, SketchyBrush);
        this.context = {};
        this.settingColor = {};
        this.settingSize = 1;
        this.settingOpacity = 0.2;
        this.settingBlending = 0.5;
        this.settingScale = 1;
        this.lastX = 0;
        this.lastY = 0;
        this.inputIsDrawing = false;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.klHistory = {};
        this.sketchySeed = 0;
        this.points = [] // x y
        ;
        this.count = 0;
        this.mixMode = [
            function(c1) {
                return c1;
            },
            function(c1, c2) {
                // why
                var result = new (0, $eWjiX.BB).RGB(c1.r, c1.g, c1.b);
                result.r *= c2.r / 255;
                result.g *= c2.g / 255;
                result.b *= c2.b / 255;
                return result;
            }
        ];
    }
    (0, $7h4XF._)(SketchyBrush, [
        {
            key: "rand",
            value: function rand() {
                this.sketchySeed++;
                return Math.sin(6324634.2345 * Math.cos(this.sketchySeed * 5342.3423)) * 0.5 + 0.5;
            }
        },
        {
            // ---- interface ----
            key: "setHistory",
            value: function setHistory(klHistory) {
                this.klHistory = klHistory;
            }
        },
        {
            key: "setSeed",
            value: function setSeed(s) {
                this.sketchySeed = parseInt('' + s);
            }
        },
        {
            key: "getSeed",
            value: function getSeed() {
                return parseInt('' + this.sketchySeed);
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.settingSize / 2;
            }
        },
        {
            key: "setColor",
            value: function setColor(c) {
                this.settingColor = c;
            }
        },
        {
            key: "getOpacity",
            value: function getOpacity() {
                return this.settingOpacity;
            }
        },
        {
            key: "setOpacity",
            value: function setOpacity(o) {
                this.settingOpacity = o;
            }
        },
        {
            key: "getBlending",
            value: function getBlending() {
                return this.settingBlending;
            }
        },
        {
            key: "setBlending",
            value: function setBlending(b) {
                this.settingBlending = b;
            }
        },
        {
            key: "setSize",
            value: function setSize(s) {
                this.settingSize = s * 2;
            }
        },
        {
            key: "getScale",
            value: function getScale() {
                return this.settingScale;
            }
        },
        {
            key: "setScale",
            value: function setScale(s) {
                this.settingScale = s;
            }
        },
        {
            key: "setContext",
            value: function setContext(c) {
                this.context = c;
            }
        },
        {
            key: "startLine",
            value: function startLine(x, y, pressure, shift) {
                this.selection = this.klHistory.getComposed().selection.value;
                this.selectionPath = this.selection ? (0, $9b3eo.getSelectionPath2d)(this.selection) : undefined;
                this.selectionBounds = this.selection ? (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
                this.changedBounds = undefined;
                if (shift && this.lastInput.x) {
                    this.inputIsDrawing = true;
                    this.endLine();
                } else {
                    this.inputIsDrawing = true;
                    this.lastX = x;
                    this.lastY = y;
                    this.lastInput.x = x;
                    this.lastInput.y = y;
                }
            }
        },
        {
            key: "goLine",
            value: function goLine(p_x, p_y, pressure, preMixedColor) {
                if (!this.inputIsDrawing || p_x === this.lastInput.x && p_y === this.lastInput.y) return;
                var e, b, a, g;
                var x = parseInt('' + p_x);
                var y = parseInt('' + p_y);
                this.points.push([
                    x,
                    y
                ]);
                var mixr = this.settingColor.r;
                var mixg = this.settingColor.g;
                var mixb = this.settingColor.b;
                if (preMixedColor) {
                    mixr = preMixedColor.r;
                    mixg = preMixedColor.g;
                    mixb = preMixedColor.b;
                } else {
                    if (this.settingBlending !== 0) {
                        if (x + 5 >= 0 && y + 5 >= 0 && x - 5 < this.context.canvas.width - 1 && y - 5 < this.context.canvas.height - 1) {
                            mixr = 0;
                            mixg = 0;
                            mixb = 0;
                            var mixX = Math.min(this.context.canvas.width - 1, Math.max(0, x - 5));
                            var mixY = Math.min(this.context.canvas.height - 1, Math.max(0, y - 5));
                            var mixW = Math.min(this.context.canvas.width - 1, Math.max(0, x + 5));
                            var mixH = Math.min(this.context.canvas.height - 1, Math.max(0, y + 5));
                            mixW -= mixX;
                            mixH -= mixY;
                            if (mixW > 0 && mixH > 0) {
                                var imDat = this.context.getImageData(mixX, mixY, mixW, mixH);
                                var countMix = 0;
                                for(var i = 0; i < imDat.data.length; i += 4){
                                    mixr += imDat.data[i + 0];
                                    mixg += imDat.data[i + 1];
                                    mixb += imDat.data[i + 2];
                                    countMix++;
                                }
                                mixr /= countMix;
                                mixg /= countMix;
                                mixb /= countMix;
                            }
                            var mixed = this.mixMode[0](new (0, $eWjiX.BB).RGB(mixr, mixg, mixb), this.settingColor);
                            mixr = parseInt('' + (0, $eWjiX.BB).mix(this.settingColor.r, mixed.r, this.settingBlending));
                            mixg = parseInt('' + (0, $eWjiX.BB).mix(this.settingColor.g, mixed.g, this.settingBlending));
                            mixb = parseInt('' + (0, $eWjiX.BB).mix(this.settingColor.b, mixed.b, this.settingBlending));
                        }
                    }
                }
                this.context.save();
                this.selectionPath && this.context.clip(this.selectionPath);
                this.context.strokeStyle = 'rgba(' + mixr + ', ' + mixg + ', ' + mixb + ', ' + this.settingOpacity + ')';
                this.context.lineWidth = this.settingSize;
                this.context.beginPath();
                this.context.moveTo(this.lastX, this.lastY);
                this.context.lineTo(x, y);
                for(e = 0; e < this.points.length; e++){
                    b = this.points[e][0] - this.points[this.count][0];
                    a = this.points[e][1] - this.points[this.count][1];
                    g = b * b + a * a;
                    if (g < 4000 * this.settingScale * this.settingScale && this.rand() > g / 2000 / this.settingScale / this.settingScale) {
                        this.context.moveTo(this.points[this.count][0] + b * 0.3, this.points[this.count][1] + a * 0.3);
                        this.context.lineTo(this.points[e][0] - b * 0.3, this.points[e][1] - a * 0.3);
                    }
                }
                this.context.stroke();
                this.context.restore();
                this.count++;
                this.lastX = x;
                this.lastY = y;
                this.lastInput.x = x;
                this.lastInput.y = y;
                this.changedBounds = (0, $eWjiX.BB).updateBounds(this.changedBounds, {
                    type: 'index',
                    x1: Math.floor(x - this.settingSize / 2),
                    y1: Math.floor(y - this.settingSize / 2),
                    x2: Math.ceil(x + this.settingSize / 2),
                    y2: Math.ceil(y + this.settingSize / 2)
                });
            }
        },
        {
            key: "endLine",
            value: function endLine() {
                this.inputIsDrawing = false;
                this.count = 0;
                this.points = [];
                if (this.changedBounds) {
                    var boundsWithinSelection = (0, $eg83P.intersectBounds)(this.changedBounds, this.selectionBounds);
                    var layerData = (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(this.context.canvas, boundsWithinSelection);
                    if (layerData.some(function(item) {
                        return item;
                    })) this.klHistory.push((0, $5bc59effccf14376$export$263fa670dc037098)(this.klHistory.getComposed(), layerData));
                }
            }
        },
        {
            //cheap 'n' ugly
            key: "drawLineSegment",
            value: function drawLineSegment(x1, y1, x2, y2) {
                this.changedBounds = undefined;
                this.lastInput.x = x2;
                this.lastInput.y = y2;
                if (this.inputIsDrawing || x1 === undefined) return;
                this.selection = this.klHistory.getComposed().selection.value;
                this.selectionPath = this.selection ? (0, $9b3eo.getSelectionPath2d)(this.selection) : undefined;
                this.selectionBounds = this.selection ? (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
                this.context.save();
                this.selectionPath && this.context.clip(this.selectionPath);
                this.context.lineWidth = this.settingSize;
                var mixCol = {
                    r: this.settingColor.r,
                    g: this.settingColor.g,
                    b: this.settingColor.b
                };
                if (x1 + 5 >= 0 && y1 + 5 >= 0 && x1 - 5 < this.context.canvas.width - 1 && y1 - 5 < this.context.canvas.height - 1) {
                    mixCol.r = 0;
                    mixCol.g = 0;
                    mixCol.b = 0;
                    var mixX = Math.min(this.context.canvas.width - 1, Math.max(0, x1 - 5));
                    var mixY = Math.min(this.context.canvas.height - 1, Math.max(0, y1 - 5));
                    var mixW = Math.min(this.context.canvas.width - 1, Math.max(0, x1 + 5));
                    var mixH = Math.min(this.context.canvas.height - 1, Math.max(0, y1 + 5));
                    mixW -= mixX;
                    mixH -= mixY;
                    if (mixW > 0 && mixH > 0) {
                        var w = Math.min($c214fbe9e4fc15b0$var$sampleCanvas.width, mixW);
                        var h = Math.min($c214fbe9e4fc15b0$var$sampleCanvas.height, mixH);
                        $c214fbe9e4fc15b0$var$sampleCtx.save();
                        $c214fbe9e4fc15b0$var$sampleCtx.globalCompositeOperation = 'copy';
                        $c214fbe9e4fc15b0$var$sampleCtx.drawImage(this.context.canvas, mixX, mixY, mixW, mixH, 0, 0, w, h);
                        $c214fbe9e4fc15b0$var$sampleCtx.restore();
                        var imDat = $c214fbe9e4fc15b0$var$sampleCtx.getImageData(mixX, mixY, mixW, mixH);
                        var countMix = 0;
                        for(var i = 0; i < imDat.data.length; i += 4){
                            mixCol.r += imDat.data[i + 0];
                            mixCol.g += imDat.data[i + 1];
                            mixCol.b += imDat.data[i + 2];
                            countMix++;
                        }
                        mixCol.r /= countMix;
                        mixCol.g /= countMix;
                        mixCol.b /= countMix;
                    }
                }
                var mixed = this.mixMode[0](new (0, $eWjiX.BB).RGB(mixCol.r, mixCol.g, mixCol.b), this.settingColor);
                mixCol.r = parseInt('' + (this.settingBlending * mixed.r + this.settingColor.r * (1 - this.settingBlending)));
                mixCol.g = parseInt('' + (this.settingBlending * mixed.g + this.settingColor.g * (1 - this.settingBlending)));
                mixCol.b = parseInt('' + (this.settingBlending * mixed.b + this.settingColor.b * (1 - this.settingBlending)));
                this.context.strokeStyle = 'rgba(' + mixCol.r + ', ' + mixCol.g + ', ' + mixCol.b + ', ' + this.settingOpacity + ')';
                this.context.beginPath();
                this.context.moveTo(x1, y1);
                this.context.lineTo(x2, y2);
                this.context.stroke();
                this.context.strokeStyle = 'rgba(' + mixCol.r + ', ' + mixCol.g + ', ' + mixCol.b + ', ' + this.settingOpacity + ')';
                this.context.restore();
                this.changedBounds = (0, $eWjiX.BB).updateBounds(this.changedBounds, {
                    type: 'index',
                    x1: Math.floor(x1 - this.settingSize / 2),
                    y1: Math.floor(y1 - this.settingSize / 2),
                    x2: Math.ceil(x1 + this.settingSize / 2),
                    y2: Math.ceil(y1 + this.settingSize / 2)
                });
                this.changedBounds = (0, $eWjiX.BB).updateBounds(this.changedBounds, {
                    type: 'index',
                    x1: Math.floor(x2 - this.settingSize / 2),
                    y1: Math.floor(y2 - this.settingSize / 2),
                    x2: Math.ceil(x2 + this.settingSize / 2),
                    y2: Math.ceil(y2 + this.settingSize / 2)
                });
                if (this.changedBounds) {
                    var boundsWithinSelection = (0, $eg83P.intersectBounds)(this.changedBounds, this.selectionBounds);
                    var layerData = (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(this.context.canvas, boundsWithinSelection);
                    if (layerData.some(function(item) {
                        return item;
                    })) this.klHistory.push((0, $5bc59effccf14376$export$263fa670dc037098)(this.klHistory.getComposed(), layerData));
                }
            }
        },
        {
            key: "isDrawing",
            value: function isDrawing() {
                return this.inputIsDrawing;
            }
        }
    ]);
    return SketchyBrush;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");


var $7jh4K = parcelRequire("7jh4K");




var $9b3eo = parcelRequire("9b3eo");

var $eg83P = parcelRequire("eg83P");

var $58b45953679baa4a$export$4de5ef8eecde6f12 = /*#__PURE__*/ function() {
    "use strict";
    function PixelBrush() {
        (0, $cx0mh._)(this, PixelBrush);
        this.klHistory = {};
        this.context = {};
        this.settingHasSizePressure = true;
        this.settingHasOpacityPressure = false;
        this.settingSize = 0.5;
        this.settingSpacing = 0.9;
        this.settingOpacity = 1;
        this.settingColor = {};
        this.settingColorStr = '';
        this.settingLockLayerAlpha = false;
        this.settingIsEraser = false;
        this.settingUseDither = true;
        this.inputIsDrawing = false;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.bezierLine = null;
        this.ditherArr = [
            [
                3,
                2
            ],
            [
                1,
                0
            ],
            [
                3,
                0
            ],
            [
                1,
                2
            ],
            [
                2,
                1
            ],
            [
                0,
                3
            ],
            [
                0,
                1
            ],
            [
                2,
                3
            ],
            [
                2,
                0
            ],
            [
                0,
                2
            ],
            [
                0,
                0
            ],
            [
                2,
                2
            ],
            [
                1,
                1
            ],
            [
                3,
                3
            ],
            [
                3,
                1
            ],
            [
                1,
                3
            ]
        ];
        this.ditherPattern = {};
        /*
        Draw brush into fresh canvas for each line,
        because otherwise chrome slows the main canvas down.
        Multiple reads on a canvas -> canvas moved to CPU. (my guess)
     */ this.canvasClone = {};
        this.ctxClone = {};
        // changed tiles that will be pushed to history
        this.historyTiles = [];
        this.ditherCanvas = (0, $eWjiX.BB).canvas(4, 4);
        this.ditherCtx = (0, $eWjiX.BB).ctx(this.ditherCanvas);
    }
    (0, $7h4XF._)(PixelBrush, [
        {
            key: "updateChangedTiles",
            value: function updateChangedTiles1(bounds) {
                // fix bounds
                bounds = {
                    type: 'index',
                    x1: Math.min(bounds.x1, bounds.x2),
                    y1: Math.min(bounds.y1, bounds.y2),
                    x2: Math.max(bounds.x1, bounds.x2),
                    y2: Math.max(bounds.y1, bounds.y2)
                };
                var boundsWithinSelection = (0, $eg83P.intersectBounds)(bounds, this.selectionBounds);
                if (!boundsWithinSelection) return;
                var changedTiles = (0, $3798530d3967d87a$export$2098fe43203ddd32)(boundsWithinSelection, this.context.canvas.width, this.context.canvas.height);
                this.redrawBounds = this.redrawBounds ? (0, $eg83P.updateBounds)(this.redrawBounds, boundsWithinSelection) : boundsWithinSelection;
                this.historyTiles = (0, $3798530d3967d87a$export$1774f90c6da5013c)(this.historyTiles, changedTiles);
            }
        },
        {
            key: "initClone",
            value: function initClone() {
                this.canvasClone = (0, $eWjiX.BB).canvas(this.context.canvas.width, this.context.canvas.height);
                this.ctxClone = (0, $eWjiX.BB).ctx(this.canvasClone);
                this.ctxClone.drawImage(this.context.canvas, 0, 0);
            }
        },
        {
            key: "freeClone",
            value: function freeClone() {
                (0, $eWjiX.BB).freeCanvas(this.canvasClone);
                this.ctxClone = {};
            }
        },
        {
            key: "redrawToCanvas",
            value: function redrawToCanvas() {
                if (!this.redrawBounds) return;
                var boundsRect = (0, $eg83P.boundsToRect)(this.redrawBounds);
                this.context.save();
                this.context.clearRect(boundsRect.x, boundsRect.y, boundsRect.width, boundsRect.height);
                this.context.drawImage(this.canvasClone, boundsRect.x, boundsRect.y, boundsRect.width, boundsRect.height, boundsRect.x, boundsRect.y, boundsRect.width, boundsRect.height);
                this.context.restore();
                this.redrawBounds = undefined;
            }
        },
        {
            key: "updateDither",
            value: function updateDither() {
                this.ditherCtx.clearRect(0, 0, 4, 4);
                this.ditherCtx.fillStyle = this.settingIsEraser ? `rgb(${0, $00f785a5ea9e210d$export$e4203cb02d5e5b28},${0, $00f785a5ea9e210d$export$e4203cb02d5e5b28},${0, $00f785a5ea9e210d$export$e4203cb02d5e5b28})` : this.settingColorStr;
                for(var i = 0; i < Math.max(1, Math.round(this.settingOpacity * this.ditherArr.length)); i++)this.ditherCtx.fillRect(this.ditherArr[i][0], this.ditherArr[i][1], 1, 1);
                this.ditherPattern = (0, $7jh4K.throwIfNull)(this.context.createPattern(this.ditherCanvas, 'repeat'));
            }
        },
        {
            key: "cubicCurveOverThreshold",
            value: /**
     * Tests p1->p2 or p3->p4 deviate in their direction more than max, compared to p1->p4
     */ function cubicCurveOverThreshold(p1, p2, p3, p4, maxAngleRad) {
                var d = (0, $eWjiX.BB).Vec2.nor({
                    x: p4.x - p1.x,
                    y: p4.y - p1.y
                });
                var d2 = (0, $eWjiX.BB).Vec2.nor({
                    x: p2.x - p1.x,
                    y: p2.y - p1.y
                });
                var d3 = (0, $eWjiX.BB).Vec2.nor({
                    x: p4.x - p3.x,
                    y: p4.y - p3.y
                });
                // const a2 = Math.abs(BB.Vec2.angle(d, d2) % Math.PI) / Math.PI * 180;
                // const a3 = Math.abs(BB.Vec2.angle(d, d3) % Math.PI) / Math.PI * 180;
                return Math.max((0, $eWjiX.BB).Vec2.dist(d, d2), (0, $eWjiX.BB).Vec2.dist(d, d3)) > maxAngleRad;
            }
        },
        {
            key: "plotCubicBezierLine",
            value: function plotCubicBezierLine(p1, p2, p3, p4) {
                var isOverThreshold = this.cubicCurveOverThreshold(p1, p2, p3, p4, 0.1);
                p1.x = Math.floor(p1.x);
                p1.y = Math.floor(p1.y);
                p4.x = Math.floor(p4.x);
                p4.y = Math.floor(p4.y);
                var dist = (0, $eWjiX.BB).dist(p1.x, p1.y, p4.x, p4.y);
                if (!isOverThreshold || dist < 7) {
                    this.plotLine(p1.x, p1.y, p4.x, p4.y, true);
                    return;
                }
                var n = Math.max(2, Math.round(dist / 4));
                var pointArr = [];
                for(var i = 0; i <= n; i++){
                    var t = i / n;
                    var a = Math.pow(1 - t, 3);
                    var b = 3 * t * Math.pow(1 - t, 2);
                    var c = 3 * Math.pow(t, 2) * (1 - t);
                    var d = Math.pow(t, 3);
                    pointArr.push({
                        x: a * p1.x + b * p2.x + c * p3.x + d * p4.x,
                        y: a * p1.y + b * p2.y + c * p3.y + d * p4.y
                    });
                }
                for(var i1 = 0; i1 < n; i1++)this.plotLine(Math.round(pointArr[i1].x), Math.round(pointArr[i1].y), Math.round(pointArr[i1 + 1].x), Math.round(pointArr[i1 + 1].y), true);
            }
        },
        {
            key: "drawDot",
            value: function drawDot(x, y, size, opacity) {
                var rect = {
                    x: Math.round(x + -size),
                    y: Math.round(y + -size),
                    width: Math.round(size * 2),
                    height: Math.round(size * 2)
                };
                this.updateChangedTiles((0, $eg83P.rectToBounds)(rect, 'index'));
                this.ctxClone.save();
                if (this.settingIsEraser) {
                    this.ctxClone.fillStyle = this.settingUseDither ? this.ditherPattern : '#fff';
                    if (this.settingLockLayerAlpha) this.ctxClone.globalCompositeOperation = 'source-atop';
                    else this.ctxClone.globalCompositeOperation = 'destination-out';
                } else {
                    this.ctxClone.fillStyle = this.settingUseDither ? this.ditherPattern : this.settingColorStr;
                    if (this.settingLockLayerAlpha) this.ctxClone.globalCompositeOperation = 'source-atop';
                }
                this.ctxClone.globalAlpha = this.settingUseDither ? 1 : opacity;
                this.ctxClone.fillRect(rect.x, rect.y, rect.width, rect.height);
                this.ctxClone.restore();
            }
        },
        {
            key: "continueLine",
            value: function continueLine(x, y, size, pressure) {
                var _this = this;
                if (this.bezierLine === null) {
                    this.bezierLine = new (0, $eWjiX.BB).BezierLine();
                    this.bezierLine.add(this.lastInput.x, this.lastInput.y, 0, function() {});
                }
                this.ctxClone.save();
                this.selectionPath && this.ctxClone.clip(this.selectionPath);
                var dotCallback = function(val) {
                    var localPressure = (0, $eWjiX.BB).mix(_this.lastInput2.pressure, pressure, val.t);
                    var localOpacity = _this.settingOpacity * (_this.settingHasOpacityPressure ? localPressure * localPressure : 1);
                    var localSize = Math.max(0.5, _this.settingSize * (_this.settingHasSizePressure ? localPressure : 1));
                    _this.drawDot(val.x, val.y, localSize, localOpacity);
                };
                var controlCallback = function(controlObj) {
                    _this.plotCubicBezierLine(controlObj.p1, controlObj.p2, controlObj.p3, controlObj.p4);
                };
                if (Math.round(this.settingSize * 2) === 1) {
                    this.bresenheimPath = new Path2D();
                    if (x === null || y === null) this.bezierLine.addFinal(4, undefined, controlCallback);
                    else this.bezierLine.add(x, y, 4, undefined, controlCallback);
                    if (this.settingIsEraser) {
                        this.ctxClone.fillStyle = this.settingUseDither ? this.ditherPattern : '#fff';
                        if (this.settingLockLayerAlpha) this.ctxClone.globalCompositeOperation = 'source-atop';
                        else this.ctxClone.globalCompositeOperation = 'destination-out';
                    } else {
                        this.ctxClone.fillStyle = this.settingUseDither ? this.ditherPattern : this.settingColorStr;
                        if (this.settingLockLayerAlpha) this.ctxClone.globalCompositeOperation = 'source-atop';
                    }
                    this.ctxClone.globalAlpha = this.settingUseDither ? 1 : this.settingOpacity;
                    this.ctxClone.fill(this.bresenheimPath);
                    this.bresenheimPath = undefined;
                } else {
                    var localSpacing = size * this.settingSpacing;
                    if (x === null || y === null) this.bezierLine.addFinal(localSpacing, dotCallback);
                    else this.bezierLine.add(x, y, localSpacing, dotCallback);
                }
                this.ctxClone.restore();
            }
        },
        {
            key: "plotLine",
            value: /**
     * bresenheim line drawing
     */ function plotLine(x0, y0, x1, y1, skipFirst) {
                this.updateChangedTiles((0, $eg83P.fixBounds)({
                    type: 'index',
                    x1: x0,
                    y1: y0,
                    x2: x1,
                    y2: y1
                }));
                x0 = Math.floor(x0);
                y0 = Math.floor(y0);
                x1 = Math.floor(x1);
                y1 = Math.floor(y1);
                var dX = Math.abs(x1 - x0);
                var sX = x0 < x1 ? 1 : -1;
                var dY = -Math.abs(y1 - y0);
                var sY = y0 < y1 ? 1 : -1;
                var err = dX + dY;
                while(true){
                    var _this_bresenheimPath;
                    if (skipFirst) skipFirst = false;
                    else (_this_bresenheimPath = this.bresenheimPath) === null || _this_bresenheimPath === void 0 ? void 0 : _this_bresenheimPath.rect(x0, y0, 1, 1);
                    if (x0 === x1 && y0 === y1) break;
                    var e2 = 2 * err;
                    if (e2 >= dY) {
                        err += dY;
                        x0 += sX;
                    }
                    if (e2 <= dX) {
                        err += dX;
                        y0 += sY;
                    }
                }
            }
        },
        {
            // ---- interface ----
            key: "startLine",
            value: function startLine(x, y, p) {
                this.selection = this.klHistory.getComposed().selection.value;
                this.selectionPath = this.selection ? (0, $9b3eo.getSelectionPath2d)(this.selection) : undefined;
                this.selectionBounds = this.selection ? (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
                this.historyTiles = [];
                this.redrawBounds = undefined;
                if (this.settingUseDither) this.updateDither();
                this.initClone();
                p = Math.max(0, Math.min(1, p));
                var localOpacity = this.settingHasOpacityPressure ? this.settingOpacity * p * p : this.settingOpacity;
                var localSize = this.settingHasSizePressure ? Math.max(0.5, p * this.settingSize) : Math.max(0.5, this.settingSize);
                this.inputIsDrawing = true;
                this.ctxClone.save();
                this.selectionPath && this.ctxClone.clip(this.selectionPath);
                this.drawDot(x, y, localSize, localOpacity);
                this.ctxClone.restore();
                this.lastInput.x = x;
                this.lastInput.y = y;
                this.lastInput.pressure = p;
                this.lastInput2 = (0, $eWjiX.BB).copyObj(this.lastInput);
                this.redrawToCanvas();
            }
        },
        {
            key: "goLine",
            value: function goLine(x, y, p) {
                if (!this.inputIsDrawing) return;
                //debug
                //drawDot(x, y, 1, 0.5);
                var pressure = (0, $eWjiX.BB).clamp(p, 0, 1);
                var localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
                this.continueLine(x, y, localSize, this.lastInput.pressure);
                this.lastInput2 = (0, $eWjiX.BB).copyObj(this.lastInput);
                this.lastInput.x = x;
                this.lastInput.y = y;
                this.lastInput.pressure = pressure;
                this.redrawToCanvas();
            }
        },
        {
            key: "endLine",
            value: function endLine() {
                this.selection = this.klHistory.getComposed().selection.value;
                this.selectionPath = this.selection ? (0, $9b3eo.getSelectionPath2d)(this.selection) : undefined;
                var localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
                this.continueLine(null, null, localSize, this.lastInput.pressure);
                //debug
                //drawDot(lastInput.x, lastInput.y, 3, 1);
                //drawDot(x, y, 10, 0.1);
                this.inputIsDrawing = false;
                this.bezierLine = null;
                this.redrawToCanvas();
                if (this.historyTiles.some(function(item) {
                    return item;
                })) this.klHistory.push((0, $5bc59effccf14376$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $1a6c9997bc8182ff$export$6706c882ea9c3dbd)(this.canvasClone, this.historyTiles)));
                this.freeClone();
            }
        },
        {
            key: "drawLineSegment",
            value: function drawLineSegment(x1, y1, x2, y2) {
                this.startLine(x1, y1, 1);
                this.goLine(x2, y2, 1);
                this.endLine();
            }
        },
        {
            //IS
            key: "isDrawing",
            value: function isDrawing() {
                return this.inputIsDrawing;
            }
        },
        {
            //SET
            key: "setColor",
            value: function setColor(c) {
                if (this.settingColor === c) return;
                this.settingColor = c;
                this.settingColorStr = 'rgb(' + this.settingColor.r + ',' + this.settingColor.g + ',' + this.settingColor.b + ')';
            }
        },
        {
            key: "setContext",
            value: function setContext(c) {
                this.context = c;
            }
        },
        {
            key: "setHistory",
            value: function setHistory(klHistory) {
                this.klHistory = klHistory;
            }
        },
        {
            key: "setSize",
            value: function setSize(s) {
                this.settingSize = Math.round(s * 2) / 2;
            }
        },
        {
            key: "setOpacity",
            value: function setOpacity(o) {
                this.settingOpacity = o;
            }
        },
        {
            key: "setSpacing",
            value: function setSpacing(s) {
                this.settingSpacing = s;
            }
        },
        {
            key: "sizePressure",
            value: function sizePressure(b) {
                this.settingHasSizePressure = b;
            }
        },
        {
            key: "opacityPressure",
            value: function opacityPressure(b) {
                this.settingHasOpacityPressure = b;
            }
        },
        {
            key: "setLockAlpha",
            value: function setLockAlpha(b) {
                this.settingLockLayerAlpha = b;
            }
        },
        {
            key: "setIsEraser",
            value: function setIsEraser(b) {
                this.settingIsEraser = b;
            }
        },
        {
            key: "setUseDither",
            value: function setUseDither(b) {
                this.settingUseDither = b;
            }
        },
        {
            //GET
            key: "getSpacing",
            value: function getSpacing() {
                return this.settingSpacing;
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.settingSize;
            }
        },
        {
            key: "getOpacity",
            value: function getOpacity() {
                return this.settingOpacity;
            }
        },
        {
            key: "getLockAlpha",
            value: function getLockAlpha() {
                return this.settingLockLayerAlpha;
            }
        },
        {
            key: "getIsEraser",
            value: function getIsEraser() {
                return this.settingIsEraser;
            }
        },
        {
            key: "getUseDither",
            value: function getUseDither() {
                return this.settingUseDither;
            }
        }
    ]);
    return PixelBrush;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");





var $9b3eo = parcelRequire("9b3eo");

var $eg83P = parcelRequire("eg83P");

var $fc1a683099fb2d61$export$fe52c90afd1cf5ba = /*#__PURE__*/ function() {
    "use strict";
    function EraserBrush() {
        (0, $cx0mh._)(this, EraserBrush);
        this.size = 30;
        this.spacing = 0.4;
        this.opacity = 1;
        this.useSizePressure = true;
        this.useOpacityPressure = false;
        this.isTransparentBG = false;
        this.klHistory = {};
        this.isBaseLayer = false;
        this.layer = {};
        this.context = {};
        this.started = false;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.changedTiles = [];
    }
    (0, $7h4XF._)(EraserBrush, [
        {
            key: "updateChangedTiles",
            value: function updateChangedTiles1(bounds) {
                var boundsWithinSelection = (0, $eg83P.intersectBounds)(bounds, this.selectionBounds);
                if (!boundsWithinSelection) return;
                this.changedTiles = (0, $3798530d3967d87a$export$1774f90c6da5013c)(this.changedTiles, (0, $3798530d3967d87a$export$2098fe43203ddd32)(bounds, this.context.canvas.width, this.context.canvas.height));
            }
        },
        {
            key: "drawDot",
            value: function drawDot(x, y, size, opacity) {
                this.context.save();
                if (this.isBaseLayer) {
                    if (this.isTransparentBG) this.context.globalCompositeOperation = 'destination-out';
                    else this.context.globalCompositeOperation = 'source-atop';
                } else this.context.globalCompositeOperation = 'destination-out';
                var radgrad = this.context.createRadialGradient(size, size, 0, size, size, size);
                var sharpness = Math.pow(opacity, 2);
                sharpness = Math.max(0, Math.min((size - 1) / size, sharpness));
                var oFac = Math.max(0, Math.min(1, opacity));
                var localOpacity = 2 * oFac - oFac * oFac;
                radgrad.addColorStop(sharpness, `rgba(${(0, $00f785a5ea9e210d$export$e4203cb02d5e5b28)}, ${(0, $00f785a5ea9e210d$export$e4203cb02d5e5b28)}, ${(0, $00f785a5ea9e210d$export$e4203cb02d5e5b28)}, ` + localOpacity + ')');
                radgrad.addColorStop(1, `rgba(${(0, $00f785a5ea9e210d$export$e4203cb02d5e5b28)}, ${(0, $00f785a5ea9e210d$export$e4203cb02d5e5b28)}, ${(0, $00f785a5ea9e210d$export$e4203cb02d5e5b28)}, 0)`);
                this.context.fillStyle = radgrad;
                this.context.translate(x - size, y - size);
                this.context.fillRect(0, 0, size * 2, size * 2);
                this.context.restore();
                this.updateChangedTiles({
                    type: 'index',
                    x1: Math.floor(x - size),
                    y1: Math.floor(y - size),
                    x2: Math.ceil(x + size - 1),
                    y2: Math.ceil(y + size - 1)
                });
            }
        },
        {
            key: "continueLine",
            value: function continueLine(x, y, p) {
                var _this = this;
                p = Math.max(0, Math.min(1, p));
                var localPressure;
                var localOpacity;
                var localSize = this.useSizePressure ? Math.max(0.1, p * this.size) : Math.max(0.1, this.size);
                var bdist = Math.max(1, Math.max(0.5, 1 - this.opacity) * localSize * this.spacing);
                var bezierCallback = function(val) {
                    var factor = val.t;
                    localPressure = _this.lastInput2.pressure * (1 - factor) + p * factor;
                    localOpacity = _this.useOpacityPressure ? _this.opacity * localPressure * localPressure : _this.opacity;
                    localSize = _this.useSizePressure ? Math.max(0.1, localPressure * _this.size) : Math.max(0.1, _this.size);
                    _this.drawDot(val.x, val.y, localSize, localOpacity);
                };
                this.context.save();
                this.selectionPath && this.context.clip(this.selectionPath);
                if (x === undefined || y === undefined) this.bezierLine.addFinal(bdist, bezierCallback);
                else this.bezierLine.add(x, y, bdist, bezierCallback);
                this.context.restore();
            }
        },
        {
            // ---- interface ----
            key: "startLine",
            value: function startLine(x, y, p) {
                this.selection = this.klHistory.getComposed().selection.value;
                this.selectionPath = this.selection ? (0, $9b3eo.getSelectionPath2d)(this.selection) : undefined;
                this.selectionBounds = this.selection ? (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
                this.changedTiles = [];
                this.isBaseLayer = 0 === this.layer.index;
                p = Math.max(0, Math.min(1, p));
                var localOpacity = this.useOpacityPressure ? this.opacity * p * p : this.opacity;
                var localSize = this.useSizePressure ? Math.max(0.1, p * this.size) : Math.max(0.1, this.size);
                this.started = true;
                if (localSize > 1) {
                    this.context.save();
                    this.selectionPath && this.context.clip(this.selectionPath);
                    this.drawDot(x, y, localSize, localOpacity);
                    this.context.restore();
                }
                this.lastDot = localSize * this.spacing;
                this.lastInput.x = x;
                this.lastInput.y = y;
                this.lastInput.pressure = p;
                this.lastInput2 = (0, $eWjiX.BB).copyObj(this.lastInput);
                this.bezierLine = new (0, $eWjiX.BB).BezierLine();
                this.bezierLine.add(x, y, 0, function() {
                    return undefined;
                });
            }
        },
        {
            key: "goLine",
            value: function goLine(x, y, p) {
                if (!this.started) return;
                this.continueLine(x, y, this.lastInput.pressure);
                this.lastInput2 = (0, $eWjiX.BB).copyObj(this.lastInput);
                this.lastInput.x = x;
                this.lastInput.y = y;
                this.lastInput.pressure = p;
            }
        },
        {
            key: "endLine",
            value: function endLine() {
                if (this.bezierLine) this.continueLine(undefined, undefined, this.lastInput.pressure);
                this.started = false;
                this.bezierLine = undefined;
                if (this.changedTiles.some(function(item) {
                    return item;
                })) this.klHistory.push((0, $5bc59effccf14376$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $1a6c9997bc8182ff$export$6706c882ea9c3dbd)(this.context.canvas, this.changedTiles)));
            }
        },
        {
            key: "drawLineSegment",
            value: function drawLineSegment(x1, y1, x2, y2) {
                this.selection = this.klHistory.getComposed().selection.value;
                this.selectionPath = this.selection ? (0, $9b3eo.getSelectionPath2d)(this.selection) : undefined;
                this.selectionBounds = this.selection ? (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
                this.changedTiles = [];
                this.isBaseLayer = 0 === this.layer.index;
                this.lastInput.x = x2;
                this.lastInput.y = y2;
                if (this.started || x1 === undefined) return;
                var mouseDist = Math.sqrt(Math.pow(x2 - x1, 2.0) + Math.pow(y2 - y1, 2.0));
                var eX = (x2 - x1) / mouseDist;
                var eY = (y2 - y1) / mouseDist;
                var loopDist;
                var bdist = Math.max(1, Math.max(0.5, 1 - this.opacity) * this.size * this.spacing);
                this.lastDot = 0;
                this.context.save();
                this.selectionPath && this.context.clip(this.selectionPath);
                for(loopDist = this.lastDot; loopDist <= mouseDist; loopDist += bdist)this.drawDot(x1 + eX * loopDist, y1 + eY * loopDist, this.size, this.opacity);
                this.context.restore();
                if (this.changedTiles.some(function(item) {
                    return item;
                })) this.klHistory.push((0, $5bc59effccf14376$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $1a6c9997bc8182ff$export$6706c882ea9c3dbd)(this.context.canvas, this.changedTiles)));
            }
        },
        {
            //IS
            key: "isDrawing",
            value: function isDrawing() {
                return this.started;
            }
        },
        {
            //SET
            key: "setLayer",
            value: function setLayer(layer) {
                this.layer = layer;
                this.context = layer.context;
            }
        },
        {
            key: "setHistory",
            value: function setHistory(klHistory) {
                this.klHistory = klHistory;
            }
        },
        {
            key: "setSize",
            value: function setSize(s) {
                this.size = s;
            }
        },
        {
            key: "setOpacity",
            value: function setOpacity(o) {
                this.opacity = o;
            }
        },
        {
            key: "sizePressure",
            value: function sizePressure(b) {
                this.useSizePressure = b;
            }
        },
        {
            key: "opacityPressure",
            value: function opacityPressure(b) {
                this.useOpacityPressure = b;
            }
        },
        {
            key: "setTransparentBG",
            value: function setTransparentBG(b) {
                this.isTransparentBG = b;
            }
        },
        {
            //GET
            key: "getSize",
            value: function getSize() {
                return this.size;
            }
        },
        {
            key: "getOpacity",
            value: function getOpacity() {
                return this.opacity;
            }
        }
    ]);
    return EraserBrush;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $eg83P = parcelRequire("eg83P");



var $7jh4K = parcelRequire("7jh4K");


// let statCount = 1;
// let statAcc = 0;
// stats on win10, chrome, size 100, opacity 80, smudge()
// unoptimized: 1 ms
// minimal: 0.09 ms
// minimal + circle: 0.5ms
// minimal + circle + ix, iy: 0.23ms
// unoptimized + ix, iy: 0.64 ms
// unoptimized + ix, iy + sans rounding: 0.61 ms
// ix, iy + sans rounding + sans random: 0.32ms
// ix, iy + sans rounding + fast random: 0.46 ms
// ix, iy + sans rounding + fast random + offset const: 0.48 ms
var $78ad817c60f81b7c$var$CELL_SIZE = 256;
/**
 * determine bounds of smudge
 * @param imWidth
 * @param imHeight
 * @param aP
 * @param bP
 * @param size
 */ function $78ad817c60f81b7c$var$prepSmudge(imWidth, imHeight, aP, bP, size) {
    if (aP.x === bP.x && aP.y === bP.y) return null;
    aP = (0, $eWjiX.BB).copyObj(aP);
    bP = (0, $eWjiX.BB).copyObj(bP);
    size = (0, $eWjiX.BB).copyObj(size);
    // corner behavior
    // cut down rectangles, if a or b go outside
    // i.e. if user drags partially or fully outside the canvas
    {
        var top = 0;
        var right = 0;
        var bottom = 0;
        var left = 0;
        if (aP.x < 0) left = -aP.x;
        if (aP.y < 0) top = -aP.y;
        if (bP.x < 0) left = Math.max(left, -bP.x);
        if (bP.y < 0) top = Math.max(top, -bP.y);
        if (aP.x + size.w > imWidth) right = aP.x + size.w - imWidth;
        if (aP.y + size.h > imHeight) bottom = aP.y + size.h - imHeight;
        if (bP.x + size.w > imWidth) right = Math.max(right, bP.x + size.w - imWidth);
        if (bP.y + size.h > imHeight) bottom = Math.max(bottom, bP.y + size.h - imHeight);
        aP.x += left;
        bP.x += left;
        aP.y += top;
        bP.y += top;
        size.w = size.w - left - right;
        size.h = size.h - top - bottom;
        if (size.w <= 0 || size.h <= 0) return null;
    }
    return {
        aP: {
            x: aP.x,
            y: aP.y
        },
        bP: {
            x: bP.x,
            y: bP.y
        },
        size: {
            w: size.w,
            h: size.h
        }
    };
}
/**
 * Pixel operations that do the smudging via ImageData
 * @param imageData
 * @param p
 */ function $78ad817c60f81b7c$var$smudge(imageData, mask, p) {
    p = (0, $eWjiX.BB).copyObj(p);
    var cSize = p.brush.size;
    var cX = p.brush.center.x;
    var cY = p.brush.center.y;
    /*if (statCount % 1000 === 0) {
        console.log(statAcc / 1000);
        statAcc = 0;
    }
    let start = performance.now();*/ // determine offset
    var aIndex = p.aP.y * imageData.width + p.aP.x;
    var bIndex = p.bP.y * imageData.width + p.bP.x;
    var offset = (bIndex - aIndex) * 4;
    // array with random numbers. faster than Math.random()
    var randI = 0;
    var randLen = cSize > 30 ? 1024 : 512; // lower lengths lead to noticeable patterns
    var randArr = [];
    for(var i = 0; i < randLen; i++)randArr[i] = (Math.random() - 0.5) / 1.001 + 0.5;
    var softnessPx = Math.max(3, Math.min(8, p.brush.size - 8));
    var pixel = function(ai, bi, ix, iy) {
        var dist = (0, $eWjiX.BB).dist(cX, cY, ix, iy);
        var fac = 1 - p.brush.opacity * (1 - (0, $eg83P.clamp)((dist - (cSize - softnessPx)) / softnessPx, 0, 1));
        if (fac === 1) return;
        if (mask && (mask[ai / 4] === 0 || mask[bi / 4] === 0)) return;
        if (!imageData.data[ai + 3]) ;
        else if (!imageData.data[bi + 3]) {
            // don't mix if target fully transparent. pixel might have a strange color.
            imageData.data[bi] = imageData.data[ai];
            imageData.data[bi + 1] = imageData.data[ai + 1];
            imageData.data[bi + 2] = imageData.data[ai + 2];
        } else {
            // consider alpha ratio. If a has lower alpha than b, then b should be stronger, and vice versa
            // not totally accurate. TODO same compositing as blend brush
            var fac2;
            if (imageData.data[ai + 3] < imageData.data[bi + 3]) fac2 = 1 - imageData.data[ai + 3] / imageData.data[bi + 3] * (1 - fac);
            else fac2 = imageData.data[bi + 3] / imageData.data[ai + 3] * fac;
            // ImageData's Uint8ClampedArray rounds -> 0.5 becomes 1. But not in Safari, so needs to be done manually
            // Offset mixed color by random number noise (-0.5, 0.5), so it doesn't get stuck while mixing.
            // No +0.5, because it cancels out with rand.
            imageData.data[bi] = Math.floor((0, $eWjiX.BB).mix(imageData.data[ai], imageData.data[bi + 0], fac2) + randArr[randI]);
            imageData.data[bi + 1] = Math.floor((0, $eWjiX.BB).mix(imageData.data[ai + 1], imageData.data[bi + 1], fac2) + randArr[randI]);
            imageData.data[bi + 2] = Math.floor((0, $eWjiX.BB).mix(imageData.data[ai + 2], imageData.data[bi + 2], fac2) + randArr[randI]);
            randI = (randI + 1) % randLen;
        }
        // Always mix alpha. unless alpha lock
        if (!p.brush.alphaLock) imageData.data[bi + 3] = Math.floor((0, $eWjiX.BB).mix(imageData.data[ai + 3], imageData.data[bi + 3], fac) + 0.5);
    };
    var bx1 = p.bP.x * 4;
    var bx2 = bx1 + (p.size.w - 1) * 4;
    // transfer of pixels depends on direction of smudging if there is overlap
    if (p.aP.y < p.bP.y) for(var y = p.size.h - 1, iy = p.bP.y + p.size.h - 1; y >= 0; y--, iy--){
        var yStart = (y + p.bP.y) * imageData.width * 4;
        for(var x = bx2 + yStart, x2 = bx2 + yStart - offset, ix = p.bP.x + p.size.w - 1; x >= bx1 + yStart; x -= 4, x2 -= 4, ix--)pixel(x2, x, ix, iy);
    }
    else if (p.aP.y > p.bP.y) for(var y1 = 0, iy1 = p.bP.y; y1 < p.size.h; y1++, iy1++){
        var yStart1 = (y1 + p.bP.y) * imageData.width * 4;
        for(var x1 = bx2 + yStart1, x21 = bx2 + yStart1 - offset, ix1 = p.bP.x + p.size.w - 1; x1 >= bx1 + yStart1; x1 -= 4, x21 -= 4, ix1--)pixel(x21, x1, ix1, iy1);
    }
    else {
        if (p.aP.x < p.bP.x) for(var y2 = p.size.h - 1, iy2 = p.bP.y + p.size.h - 1; y2 >= 0; y2--, iy2--){
            var yStart2 = (y2 + p.bP.y) * imageData.width * 4;
            for(var x3 = bx2 + yStart2, x22 = bx2 + yStart2 - offset, ix2 = p.bP.x + p.size.w - 1; x3 >= bx1 + yStart2; x3 -= 4, x22 -= 4, ix2--)pixel(x22, x3, ix2, iy2);
        }
        else for(var y3 = 0, iy3 = p.bP.y; y3 < p.size.h; y3++, iy3++){
            var yStart3 = (y3 + p.bP.y) * imageData.width * 4;
            for(var x4 = bx1 + yStart3, x23 = bx1 + yStart3 - offset, ix3 = p.bP.x; x4 < bx2 + yStart3; x4 += 4, x23 += 4, ix3++)pixel(x23, x4, ix3, iy3);
        }
    }
//statCount++;
//statAcc += performance.now() - start;
}
var $78ad817c60f81b7c$export$c9f800961903deab = /*#__PURE__*/ function() {
    "use strict";
    function SmudgeBrush() {
        (0, $cx0mh._)(this, SmudgeBrush);
        this.context = {};
        this.klHistory = {};
        this.settingColor = {
            r: 0,
            g: 0,
            b: 0
        };
        this.settingSize = 35;
        this.settingSpacing = 0.20446882736951905;
        this.settingOpacity = 0.8;
        this.settingHasSizePressure = false;
        this.settingHasOpacityPressure = false;
        this.settingLockLayerAlpha = false;
        this.lineToolLastDot = 0;
        this.lastInput = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.lastInput2 = {
            x: 0,
            y: 0,
            pressure: 0
        };
        this.isDrawing = false;
        this.copyImageData = {};
        this.drawBuffer = [];
        this.copiedCells = [];
    }
    (0, $7h4XF._)(SmudgeBrush, [
        {
            key: "resetRedrawBounds",
            value: // workaround for https://github.com/microsoft/TypeScript/issues/41654
            function resetRedrawBounds() {
                this.redrawBounds = undefined;
            }
        },
        {
            key: "updateRedrawBounds",
            value: function updateRedrawBounds(bounds) {
                var boundsWithinSelection = (0, $eg83P.intersectBounds)(bounds, this.selectionBounds);
                if (!boundsWithinSelection) return;
                this.redrawBounds = (0, $eWjiX.BB).updateBounds(this.redrawBounds, boundsWithinSelection);
            }
        },
        {
            key: "updateCompleteRedrawBounds",
            value: function updateCompleteRedrawBounds(x1, y1, x2, y2) {
                this.completeRedrawBounds = (0, $eWjiX.BB).updateBounds(this.completeRedrawBounds, {
                    type: 'index',
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2
                });
            }
        },
        {
            /**
     * update copyImageData. copy over new regions if needed
     */ key: "copyFromCanvas",
            value: function copyFromCanvas() {
                var _this = this;
                var touchedCells = this.copiedCells.map(function() {
                    return false;
                });
                var bounds = [];
                var cellsW = Math.ceil(this.copyImageData.width / $78ad817c60f81b7c$var$CELL_SIZE);
                if (!this.redrawBounds) return;
                bounds.push({
                    type: 'index',
                    x1: Math.floor(this.redrawBounds.x1 / $78ad817c60f81b7c$var$CELL_SIZE),
                    y1: Math.floor(this.redrawBounds.y1 / $78ad817c60f81b7c$var$CELL_SIZE),
                    x2: Math.floor(this.redrawBounds.x2 / $78ad817c60f81b7c$var$CELL_SIZE),
                    y2: Math.floor(this.redrawBounds.y2 / $78ad817c60f81b7c$var$CELL_SIZE)
                });
                bounds.forEach(function(item) {
                    for(var i = item.x1; i <= item.x2; i++)for(var e = item.y1; e <= item.y2; e++)touchedCells[e * cellsW + i] = true;
                });
                touchedCells.forEach(function(item, i) {
                    if (!item || _this.copiedCells[i]) // not touched, or already copied
                    return;
                    _this.copiedCells[i] = true;
                    var x = i % cellsW;
                    var y = Math.floor(i / cellsW);
                    var w = (Math.min(x * $78ad817c60f81b7c$var$CELL_SIZE + $78ad817c60f81b7c$var$CELL_SIZE, _this.copyImageData.width) - 1) % $78ad817c60f81b7c$var$CELL_SIZE + 1;
                    var h = (Math.min(y * $78ad817c60f81b7c$var$CELL_SIZE + $78ad817c60f81b7c$var$CELL_SIZE, _this.copyImageData.height) - 1) % $78ad817c60f81b7c$var$CELL_SIZE + 1;
                    // temp canvas to prevent main canvas from getting slowed down in chrome
                    var tmpCanvas = (0, $eWjiX.BB).canvas(w, h);
                    var tmpCtx = (0, $eWjiX.BB).ctx(tmpCanvas);
                    tmpCtx.drawImage(_this.context.canvas, -x * $78ad817c60f81b7c$var$CELL_SIZE, -y * $78ad817c60f81b7c$var$CELL_SIZE);
                    var data = tmpCtx.getImageData(0, 0, w, h);
                    for(var _$i = 0; _$i < h; _$i++)for(var e = 0, e2 = _$i * w * 4, e3 = ((y * $78ad817c60f81b7c$var$CELL_SIZE + _$i) * _this.copyImageData.width + x * $78ad817c60f81b7c$var$CELL_SIZE) * 4; e < w; e++, e2 += 4, e3 += 4){
                        _this.copyImageData.data[e3] = data.data[e2];
                        _this.copyImageData.data[e3 + 1] = data.data[e2 + 1];
                        _this.copyImageData.data[e3 + 2] = data.data[e2 + 2];
                        _this.copyImageData.data[e3 + 3] = data.data[e2 + 3];
                    }
                });
            }
        },
        {
            /**
     * fill drawBuffer with params about to be drawn
     * @param x
     * @param y
     * @param size
     * @param opacity
     */ key: "prepDot",
            value: function prepDot(x, y, size, opacity) {
                if (!this.lastDot) {
                    this.lastDot = {
                        x: x,
                        y: y
                    };
                    return;
                }
                size = Math.round(size);
                var w = Math.round(size * 2);
                var h = Math.round(size * 2);
                var bounds = $78ad817c60f81b7c$var$prepSmudge(this.copyImageData.width, this.copyImageData.height, {
                    x: Math.round(this.lastDot.x - size),
                    y: Math.round(this.lastDot.y - size)
                }, {
                    x: Math.round(x - size),
                    y: Math.round(y - size)
                }, {
                    w: w,
                    h: h
                });
                if (bounds) {
                    var params = {
                        aP: bounds.aP,
                        bP: bounds.bP,
                        size: bounds.size,
                        brush: {
                            center: {
                                x: x,
                                y: y
                            },
                            size: size,
                            opacity: opacity,
                            alphaLock: this.settingLockLayerAlpha
                        }
                    };
                    this.updateRedrawBounds({
                        type: 'index',
                        x1: params.bP.x,
                        y1: params.bP.y,
                        x2: params.bP.x + params.brush.size * 2 - 1,
                        y2: params.bP.y + params.brush.size * 2 - 1
                    });
                    this.drawBuffer.push(params);
                }
                this.lastDot = {
                    x: x,
                    y: y
                };
            }
        },
        {
            key: "continueLine",
            value: function continueLine(x, y, size, pressure) {
                var _this = this;
                this.drawBuffer = [];
                if (!this.bezierLine) {
                    this.bezierLine = new (0, $eWjiX.BB).BezierLine();
                    this.bezierLine.add(this.lastInput.x, this.lastInput.y, 0, function() {});
                }
                var drawArr = []; //draw instructions. will be all drawn at once
                var dotCallback = function(val) {
                    var localPressure = (0, $eWjiX.BB).mix(_this.lastInput2.pressure, pressure, val.t);
                    var localOpacity = _this.settingOpacity * (_this.settingHasOpacityPressure ? localPressure * localPressure : 1);
                    var localSize = Math.max(0.1, _this.settingSize * (_this.settingHasSizePressure ? localPressure : 1));
                    drawArr.push([
                        val.x,
                        val.y,
                        localSize,
                        localOpacity
                    ]); //, val.angle]);
                };
                var localSpacing = size * this.settingSpacing / 3;
                if (x === undefined || y === undefined) this.bezierLine.addFinal(localSpacing, dotCallback);
                else this.bezierLine.add(x, y, localSpacing, dotCallback);
                // execute draw instructions
                for(var i = 0; i < drawArr.length; i++){
                    var item = drawArr[i];
                    this.prepDot(item[0], item[1], item[2], item[3]);
                }
                this.copyFromCanvas();
                for(var i1 = 0; i1 < this.drawBuffer.length; i1++)$78ad817c60f81b7c$var$smudge(this.copyImageData, this.mask, this.drawBuffer[i1]);
            }
        },
        {
            key: "startLine",
            value: function startLine(x, y, p) {
                var selection = this.klHistory.getComposed().selection.value;
                this.selectionBounds = selection ? (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(selection, 'index') : undefined;
                this.mask = selection ? (0, $bdef137f4147ecbc$export$820c5732ce56544)(selection, this.context.canvas.width, this.context.canvas.height) : undefined;
                p = (0, $eWjiX.BB).clamp(p, 0, 1);
                var localOpacity = this.settingHasOpacityPressure ? this.settingOpacity * p * p : this.settingOpacity;
                var localSize = this.settingHasSizePressure ? Math.max(0.1, p * this.settingSize) : Math.max(0.1, this.settingSize);
                this.lastDot = undefined;
                this.isDrawing = true;
                this.copyImageData = new ImageData(this.context.canvas.width, this.context.canvas.height);
                var totalCells = Math.ceil(this.context.canvas.width / $78ad817c60f81b7c$var$CELL_SIZE) * Math.ceil(this.context.canvas.height / $78ad817c60f81b7c$var$CELL_SIZE);
                this.copiedCells = (0, $7jh4K.createArray)(totalCells, false);
                this.prepDot(x, y, localSize, localOpacity);
                this.lineToolLastDot = localSize * this.settingSpacing;
                this.lastInput.x = x;
                this.lastInput.y = y;
                this.lastInput.pressure = p;
                this.lastInput2.pressure = p;
                this.completeRedrawBounds = undefined;
            }
        },
        {
            key: "goLine",
            value: function goLine(x, y, p) {
                if (!this.isDrawing) return;
                this.resetRedrawBounds();
                var pressure = (0, $eWjiX.BB).clamp(p, 0, 1);
                var localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
                this.continueLine(x, y, localSize, this.lastInput.pressure);
                if (this.redrawBounds) {
                    this.context.putImageData(this.copyImageData, 0, 0, this.redrawBounds.x1, this.redrawBounds.y1, this.redrawBounds.x2 - this.redrawBounds.x1, this.redrawBounds.y2 - this.redrawBounds.y1);
                    this.updateCompleteRedrawBounds(this.redrawBounds.x1, this.redrawBounds.y1, this.redrawBounds.x2, this.redrawBounds.y2);
                }
                this.lastInput.x = x;
                this.lastInput.y = y;
                this.lastInput2.pressure = this.lastInput.pressure;
                this.lastInput.pressure = pressure;
            }
        },
        {
            key: "endLine",
            value: function endLine() {
                this.resetRedrawBounds();
                var localSize = this.settingHasSizePressure ? Math.max(0.1, this.lastInput.pressure * this.settingSize) : Math.max(0.1, this.settingSize);
                this.context.save();
                this.continueLine(undefined, undefined, localSize, this.lastInput.pressure);
                this.context.restore();
                this.isDrawing = false;
                this.bezierLine = undefined;
                if (this.redrawBounds) {
                    this.context.putImageData(this.copyImageData, 0, 0, this.redrawBounds.x1, this.redrawBounds.y1, this.redrawBounds.x2 - this.redrawBounds.x1, this.redrawBounds.y2 - this.redrawBounds.y1);
                    this.updateCompleteRedrawBounds(this.redrawBounds.x1, this.redrawBounds.y1, this.redrawBounds.x2, this.redrawBounds.y2);
                }
                if (this.completeRedrawBounds) this.klHistory.push((0, $5bc59effccf14376$export$263fa670dc037098)(this.klHistory.getComposed(), (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(this.context.canvas, this.completeRedrawBounds)));
                this.copyImageData = {};
            }
        },
        {
            key: "drawImage",
            value: function drawImage(im, x, y) {
                if (im instanceof ImageData) this.context.putImageData(im, x, y);
                else {
                    this.context.clearRect(x, y, im.width, im.height);
                    this.context.drawImage(im, x, y);
                }
            }
        },
        {
            key: "drawLineSegment",
            value: function drawLineSegment(x1, y1, x2, y2) {
                return;
            /*
        // todo
        lastInput.x = x2;
        lastInput.y = y2;
        lastInput.pressure = 1;

        if (isDrawing || x1 === undefined) {
            return;
        }

        let angle = BB.pointsToAngleDeg({x:x1, y:y1}, {x:x2, y:y2});
        let mouseDist = Math.sqrt(Math.pow(x2 - x1, 2.0) + Math.pow(y2 - y1, 2.0));
        let eX = (x2 - x1) / mouseDist;
        let eY = (y2 - y1) / mouseDist;
        let loopDist;
        let bdist = settingSize * settingSpacing;
        lineToolLastDot = settingSize * settingSpacing;
        for (loopDist = lineToolLastDot; loopDist <= mouseDist; loopDist += bdist) {
            drawDot(x1 + eX * loopDist, y1 + eY * loopDist, settingSize, settingOpacity);
        }


        let historyEntry = {
            tool: ["brush", "SmudgeBrush"],
            actions: []
        };
        // todo
        history.add(historyEntry);*/ }
        },
        {
            key: "getIsDrawing",
            value: function getIsDrawing() {
                return this.isDrawing;
            }
        },
        {
            key: "setColor",
            value: function setColor(c) {
                if (this.settingColor.r === c.r && this.settingColor.g === c.g && this.settingColor.b === c.b) return;
                this.settingColor = {
                    r: c.r,
                    g: c.g,
                    b: c.b
                };
            }
        },
        {
            key: "setContext",
            value: function setContext(c) {
                this.context = c;
            }
        },
        {
            key: "setHistory",
            value: function setHistory(klHistory) {
                this.klHistory = klHistory;
            }
        },
        {
            key: "setSize",
            value: function setSize(s) {
                this.settingSize = s;
            }
        },
        {
            key: "setOpacity",
            value: function setOpacity(o) {
                this.settingOpacity = o;
            }
        },
        {
            key: "setSpacing",
            value: function setSpacing(s) {
                this.settingSpacing = s;
            }
        },
        {
            key: "sizePressure",
            value: function sizePressure(b) {
                this.settingHasSizePressure = b;
            }
        },
        {
            key: "opacityPressure",
            value: function opacityPressure(b) {
                this.settingHasOpacityPressure = b;
            }
        },
        {
            key: "setLockAlpha",
            value: function setLockAlpha(b) {
                this.settingLockLayerAlpha = b;
            }
        },
        {
            key: "getSpacing",
            value: function getSpacing() {
                return this.settingSpacing;
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.settingSize;
            }
        },
        {
            key: "getOpacity",
            value: function getOpacity() {
                return this.settingOpacity;
            }
        },
        {
            key: "getLockAlpha",
            value: function getLockAlpha() {
                return this.settingLockLayerAlpha;
            }
        }
    ]);
    return SmudgeBrush;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $eWjiX = parcelRequire("eWjiX");




var $9b3eo = parcelRequire("9b3eo");

var $eg83P = parcelRequire("eg83P");

var $348fcce123898af9$export$38b08aa4ea8f61c6 = /*#__PURE__*/ function() {
    "use strict";
    function ChemyBrush() {
        (0, $cx0mh._)(this, ChemyBrush);
        this.context = {};
        this.settingColor = {};
        this.settingSize = 0.25 // radius - 0.5 - 99999
        ;
        this.settingOpacity = 1 // 0-1
        ;
        this.settingLockLayerAlpha = false;
        this.settingIsEraser = false;
        this.settingMode = 'fill';
        this.settingDistort = 0 // 0 - 1
        ;
        this.settingXSymmetry = false;
        this.settingYSymmetry = false;
        this.settingGradient = false;
        this.isDrawing = false;
        this.klHistory = {};
        this.copyCanvas = {};
        this.path = [];
        this.minY = 0;
        this.maxY = 0;
    }
    (0, $7h4XF._)(ChemyBrush, [
        {
            key: "updateCompleteRedrawBounds",
            value: function updateCompleteRedrawBounds(x, y) {
                var bounds = {
                    type: 'index',
                    x1: x,
                    y1: y,
                    x2: x,
                    y2: y
                };
                if (this.settingXSymmetry) bounds = (0, $eWjiX.BB).updateBounds(bounds, {
                    type: 'index',
                    x1: -x + this.copyCanvas.width,
                    y1: y,
                    x2: -x + this.copyCanvas.width,
                    y2: y
                });
                if (this.settingYSymmetry) bounds = (0, $eWjiX.BB).updateBounds(bounds, {
                    type: 'index',
                    x1: x,
                    y1: -y + this.copyCanvas.height,
                    x2: x,
                    y2: -y + this.copyCanvas.height
                });
                var buffer = this.settingMode === 'stroke' ? this.settingSize + 1 : 1;
                bounds.x1 = Math.floor(bounds.x1 - buffer);
                bounds.y1 = Math.floor(bounds.y1 - buffer);
                bounds.x2 = Math.ceil(bounds.x2 + buffer);
                bounds.y2 = Math.ceil(bounds.y2 + buffer);
                this.completeRedrawBounds = (0, $eWjiX.BB).updateBounds(this.completeRedrawBounds, bounds);
            }
        },
        {
            key: "drawShape",
            value: function drawShape() {
                var _this = this;
                this.context.save();
                this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height);
                this.context.drawImage(this.copyCanvas, 0, 0);
                this.selectionPath && this.context.clip(this.selectionPath);
                var color = (0, $cL71g._)({}, this.settingColor);
                if (this.settingIsEraser) {
                    color.r = (0, $00f785a5ea9e210d$export$e4203cb02d5e5b28);
                    color.g = (0, $00f785a5ea9e210d$export$e4203cb02d5e5b28);
                    color.b = (0, $00f785a5ea9e210d$export$e4203cb02d5e5b28);
                    if (this.settingLockLayerAlpha) this.context.globalCompositeOperation = 'source-atop';
                    else this.context.globalCompositeOperation = 'destination-out';
                } else if (this.settingLockLayerAlpha) this.context.globalCompositeOperation = 'source-atop';
                if (this.path.length > 1) {
                    // path
                    var path = new Path2D();
                    this.path.forEach(function(item, index) {
                        if (index === 0) path.moveTo(item.x, item.y);
                        else path.lineTo(item.x, item.y);
                    });
                    var style = (0, $eWjiX.BB).ColorConverter.toRgbaStr({
                        r: color.r,
                        g: color.g,
                        b: color.b,
                        a: this.settingOpacity
                    });
                    if (this.settingGradient) {
                        var startAtTop = this.path[0].x > this.path[this.path.length - 1].x;
                        var gradient = this.context.createLinearGradient(0, startAtTop ? this.minY : this.maxY, 0, startAtTop ? this.maxY : this.minY);
                        gradient.addColorStop(0, (0, $eWjiX.BB).ColorConverter.toRgbaStr({
                            r: color.r,
                            g: color.g,
                            b: color.b,
                            a: this.settingOpacity
                        }));
                        gradient.addColorStop(1, (0, $eWjiX.BB).ColorConverter.toRgbaStr({
                            r: color.r,
                            g: color.g,
                            b: color.b,
                            a: 0
                        }));
                        style = gradient;
                    }
                    // setup params
                    if (this.settingMode === 'fill') this.context.fillStyle = style;
                    else {
                        this.context.lineWidth = this.settingSize * 2;
                        this.context.lineJoin = 'bevel';
                        this.context.strokeStyle = style;
                    }
                    // draw
                    var draw = function() {
                        if (_this.settingMode === 'fill') _this.context.fill(path);
                        else _this.context.stroke(path);
                    };
                    draw();
                    if (this.settingXSymmetry) {
                        this.context.save();
                        this.context.translate(this.context.canvas.width / 2, 0);
                        this.context.scale(-1, 1);
                        this.context.translate(-this.context.canvas.width / 2, 0);
                        draw();
                        this.context.restore();
                    }
                    if (this.settingYSymmetry) {
                        this.context.save();
                        this.context.translate(0, this.context.canvas.height / 2);
                        this.context.scale(1, -1);
                        this.context.translate(0, -this.context.canvas.height / 2);
                        draw();
                        this.context.restore();
                        if (this.settingXSymmetry) {
                            this.context.save();
                            this.context.translate(this.context.canvas.width / 2, this.context.canvas.height / 2);
                            this.context.scale(-1, -1);
                            this.context.translate(-this.context.canvas.width / 2, -this.context.canvas.height / 2);
                            draw();
                            this.context.restore();
                        }
                    }
                }
                this.context.restore();
            }
        },
        {
            key: "setHistory",
            value: function setHistory(klHistory) {
                this.klHistory = klHistory;
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.settingMode === 'stroke' ? this.settingSize : 0;
            }
        },
        {
            key: "setSize",
            value: function setSize(s) {
                this.settingSize = s;
            }
        },
        {
            key: "getOpacity",
            value: function getOpacity() {
                return this.settingOpacity;
            }
        },
        {
            key: "setOpacity",
            value: function setOpacity(o) {
                this.settingOpacity = o;
            }
        },
        {
            key: "setColor",
            value: function setColor(c) {
                this.settingColor = (0, $eWjiX.BB).copyObj(c);
            }
        },
        {
            key: "setContext",
            value: function setContext(c) {
                this.context = c;
            }
        },
        {
            key: "setMode",
            value: function setMode(mode) {
                this.settingMode = mode;
            }
        },
        {
            key: "getMode",
            value: function getMode() {
                return this.settingMode;
            }
        },
        {
            key: "setDistort",
            value: function setDistort(distort) {
                this.settingDistort = (0, $eWjiX.BB).clamp(distort, 0, 1);
            }
        },
        {
            key: "getDistort",
            value: function getDistort() {
                return this.settingDistort;
            }
        },
        {
            key: "setXSymmetry",
            value: function setXSymmetry(b) {
                this.settingXSymmetry = b;
            }
        },
        {
            key: "getXSymmetry",
            value: function getXSymmetry() {
                return this.settingXSymmetry;
            }
        },
        {
            key: "setYSymmetry",
            value: function setYSymmetry(b) {
                this.settingYSymmetry = b;
            }
        },
        {
            key: "getYSymmetry",
            value: function getYSymmetry() {
                return this.settingYSymmetry;
            }
        },
        {
            key: "setGradient",
            value: function setGradient(b) {
                this.settingGradient = b;
            }
        },
        {
            key: "getGradient",
            value: function getGradient() {
                return this.settingGradient;
            }
        },
        {
            key: "getLockAlpha",
            value: function getLockAlpha() {
                return this.settingLockLayerAlpha;
            }
        },
        {
            key: "setLockAlpha",
            value: function setLockAlpha(b) {
                this.settingLockLayerAlpha = b;
            }
        },
        {
            key: "getIsEraser",
            value: function getIsEraser() {
                return this.settingIsEraser;
            }
        },
        {
            key: "setIsEraser",
            value: function setIsEraser(b) {
                this.settingIsEraser = b;
            }
        },
        {
            key: "getIsDrawing",
            value: function getIsDrawing() {
                return this.isDrawing;
            }
        },
        {
            key: "startLine",
            value: function startLine(x, y) {
                this.selection = this.klHistory.getComposed().selection.value;
                this.selectionPath = this.selection ? (0, $9b3eo.getSelectionPath2d)(this.selection) : undefined;
                this.selectionBounds = this.selection ? (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(this.selection, 'index') : undefined;
                this.isDrawing = true;
                this.path = [
                    {
                        x: x,
                        y: y
                    }
                ];
                this.minY = y;
                this.maxY = y;
                this.copyCanvas = (0, $eWjiX.BB).canvas(this.context.canvas.width, this.context.canvas.height);
                (0, $eWjiX.BB).ctx(this.copyCanvas).drawImage(this.context.canvas, 0, 0);
                this.completeRedrawBounds = undefined;
                this.updateCompleteRedrawBounds(x, y);
            }
        },
        {
            key: "goLine",
            value: function goLine(x, y) {
                if (!this.isDrawing) return;
                var pos = {
                    x: x,
                    y: y
                };
                if (this.settingDistort > 0) {
                    pos.x += (Math.random() - 0.5) * this.settingDistort * 80;
                    pos.y += (Math.random() - 0.5) * this.settingDistort * 80;
                }
                this.minY = Math.min(this.minY, pos.y);
                this.maxY = Math.max(this.maxY, pos.y);
                this.path.push(pos);
                this.updateCompleteRedrawBounds(x, y);
                this.drawShape();
            }
        },
        {
            key: "endLine",
            value: function endLine() {
                this.isDrawing = false;
                this.completeRedrawBounds = (0, $eWjiX.BB).indexBoundsInArea(this.completeRedrawBounds, this.copyCanvas.width, this.copyCanvas.height);
                if (this.selectionBounds) this.completeRedrawBounds = (0, $eg83P.intersectBounds)(this.completeRedrawBounds, this.selectionBounds);
                if (this.path.length > 1 && this.completeRedrawBounds) {
                    var layerData = (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(this.context.canvas, this.completeRedrawBounds);
                    this.klHistory.push((0, $5bc59effccf14376$export$263fa670dc037098)(this.klHistory.getComposed(), layerData));
                }
                this.path = [];
                this.copyCanvas = {};
            }
        },
        {
            key: "drawLineSegment",
            value: function drawLineSegment(x1, y1, x2, y2) {
            // might make sense for stroke
            }
        }
    ]);
    return ChemyBrush;
}();


var $42ac5b30ad65dabb$export$32510733a89b2eab = {
    PenBrush: $3f0923cd3c55ea92$export$6f96c8f9e6ae7341,
    BlendBrush: $02d77b8dd5755328$export$9659db8d01dd5313,
    SketchyBrush: $c214fbe9e4fc15b0$export$566f9061f0f5ba33,
    PixelBrush: $58b45953679baa4a$export$4de5ef8eecde6f12,
    ChemyBrush: $348fcce123898af9$export$38b08aa4ea8f61c6,
    SmudgeBrush: $78ad817c60f81b7c$export$c9f800961903deab,
    EraserBrush: $fc1a683099fb2d61$export$fe52c90afd1cf5ba
};



var $eWjiX = parcelRequire("eWjiX");

var $e8a5c017c49bb311$export$f02de051ab70b20e = 20;





var $3941da0020c40ac2$exports = {};
$3941da0020c40ac2$exports = $parcel$resolve("iiCd6");





var $8b6ca25eb0830594$export$a0d4983f3b0b5c8e = function() {
    var brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($3941da0020c40ac2$exports))),
        tooltip: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-pen'),
        sizeSlider: {
            min: 0.5,
            max: 100,
            curve: (0, $eWjiX.BB).powerSplineInput(0.5, 100, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1,
            curve: [
                [
                    0,
                    0.01
                ],
                [
                    0.5,
                    0.3
                ],
                [
                    1,
                    1
                ]
            ]
        },
        scatterSlider: {
            min: 0,
            max: 100,
            curve: (0, $eWjiX.BB).powerSplineInput(0, 100, 0.1, 2.5)
        }
    };
    var alphaNames = [
        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-pen-circle'),
        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-pen-chalk'),
        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-pen-calligraphy'),
        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-pen-square')
    ];
    (0, $8d7403abedf7cefa$export$e4ce066d17694649).subscribe(function() {
        brushInterface.tooltip = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-pen');
        alphaNames = [
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-pen-circle'),
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-pen-chalk'),
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-pen-calligraphy'),
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-pen-square')
        ];
    });
    brushInterface.Ui = function(p) {
        var div = document.createElement('div'); // the gui
        var brush = new (0, $42ac5b30ad65dabb$export$32510733a89b2eab).PenBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        var sizeSlider;
        var opacitySlider;
        var scatterSlider;
        var alphaOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: [
                0,
                1,
                2,
                3
            ].map(function(id) {
                var alpha = (0, $eWjiX.BB).el({
                    className: 'dark-invert',
                    css: {
                        width: '31px',
                        height: '31px',
                        backgroundSize: 'contain',
                        margin: '2px'
                    }
                });
                var canvas = (0, $eWjiX.BB).canvas(70, 70);
                var ctx = (0, $eWjiX.BB).ctx(canvas);
                if (id === 0 || id === 3) {
                    if (id === 0) {
                        ctx.beginPath();
                        ctx.arc(35, 35, 30, 0, 2 * Math.PI);
                        ctx.closePath();
                        ctx.fill();
                    } else ctx.fillRect(5, 5, 60, 60);
                } else if (id === 1) ctx.drawImage((0, $f875015ce1aeb4d3$export$74a44bbc21d06a28)(60), 5, 5);
                else if (id === 2) ctx.drawImage((0, $f875015ce1aeb4d3$export$eaa218d5d17c8f1c)(60), 5, 5);
                alpha.style.backgroundImage = 'url(' + canvas.toDataURL('image/png') + ')';
                return {
                    id: id,
                    label: alpha,
                    title: alphaNames[id]
                };
            }),
            initId: 0,
            onChange: function(id) {
                brush.setAlpha(id);
            }
        });
        var lockAlphaToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: brush.getLockAlpha(),
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha'),
            callback: function callback(b) {
                brush.setLockAlpha(b);
            },
            doHighlight: true,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha-title'),
            css: {
                display: 'inline-block'
            },
            name: 'lock-alpha-toggle'
        });
        var spacingSpline = new (0, $eWjiX.BB).SplineInterpolator([
            [
                0,
                15
            ],
            [
                8,
                7
            ],
            [
                14,
                4
            ],
            [
                30,
                3
            ],
            [
                50,
                2.7
            ],
            [
                100,
                2
            ]
        ]);
        function setSize(size) {
            brush.setSize(size);
            brush.setSpacing(Math.max(2, spacingSpline.interpolate(size)) / 15);
        }
        function init() {
            sizeSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize(),
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 2;
                },
                toValue: function(displayValue) {
                    return displayValue / 2;
                },
                onChange: function(val) {
                    setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: function(displayValue) {
                    if (displayValue < 10) return (0, $eWjiX.BB).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brushInterface.opacitySlider.max,
                curve: brushInterface.opacitySlider.curve,
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 100;
                },
                toValue: function(displayValue) {
                    return displayValue / 100;
                },
                onChange: function(val) {
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            scatterSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('scatter'),
                width: 225,
                height: 30,
                min: brushInterface.scatterSlider.min,
                max: brushInterface.scatterSlider.max,
                value: brushInterface.scatterSlider.min,
                curve: brushInterface.scatterSlider.curve,
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                onChange: function(val) {
                    brush.setScatter(val);
                    p.onScatterChange(val);
                },
                formatFunc: function(displayValue) {
                    if (displayValue < 10) return (0, $eWjiX.BB).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            var pressureSizeToggle = (0, $a49c90053f8766a2$export$9da2e8821e6cbb57)(true, function(b) {
                brush.sizePressure(b);
            });
            var pressureOpacityToggle = (0, $a49c90053f8766a2$export$9da2e8821e6cbb57)(false, function(b) {
                brush.opacityPressure(b);
            });
            var pressureScatterToggle = (0, $a49c90053f8766a2$export$9da2e8821e6cbb57)(false, function(b) {
                brush.scatterPressure(b);
            });
            div.append((0, $eWjiX.BB).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px'
                }
            }), (0, $eWjiX.BB).el({
                content: [
                    opacitySlider.getElement(),
                    pressureOpacityToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px'
                }
            }), (0, $eWjiX.BB).el({
                content: [
                    scatterSlider.getElement(),
                    pressureScatterToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }
            }), (0, $eWjiX.BB).el({
                content: alphaOptions.getElement(),
                css: {
                    marginTop: '10px'
                }
            }), (0, $eWjiX.BB).el({
                content: lockAlphaToggle.getElement(),
                css: {
                    marginTop: '10px'
                }
            }));
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.getScatter = function() {
            return brush.getScatter();
        };
        this.setScatter = function(scatter) {
            brush.setScatter(scatter);
            scatterSlider.setValue(scatter);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p) {
            brush.goLine(x, y, p);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.isDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();



var $eWjiX = parcelRequire("eWjiX");





var $56d129e05aa1cb30$exports = {};
$56d129e05aa1cb30$exports = $parcel$resolve("6fRlX");



var $2e3c50106ba150d5$export$156bb4fe8f4bcb4b = function() {
    var brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($56d129e05aa1cb30$exports))),
        tooltip: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-blend'),
        sizeSlider: {
            min: 0.5,
            max: 100,
            curve: (0, $eWjiX.BB).powerSplineInput(0.5, 100, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1
        }
    };
    (0, $8d7403abedf7cefa$export$e4ce066d17694649).subscribe(function() {
        brushInterface.tooltip = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-blend');
    });
    brushInterface.Ui = function(p) {
        var div = document.createElement('div'); // the gui
        var brush = new (0, $42ac5b30ad65dabb$export$32510733a89b2eab).BlendBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        var sizeSlider;
        var opacitySlider;
        function setSize(size) {
            brush.setSize(size);
        }
        function init() {
            sizeSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: 58,
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 2;
                },
                toValue: function(displayValue) {
                    return displayValue / 2;
                },
                onChange: function(val) {
                    setSize(val);
                    p.onSizeChange(val);
                }
            });
            opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brush.getOpacity(),
                curve: brushInterface.opacitySlider.curve,
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 100;
                },
                toValue: function(displayValue) {
                    return displayValue / 100;
                },
                onChange: function(val) {
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            var blendingSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-blending'),
                width: 225,
                height: 30,
                min: 0,
                max: 1,
                value: brush.getBlending(),
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 100;
                },
                toValue: function(displayValue) {
                    return displayValue / 100;
                },
                onChange: function onChange(val) {
                    brush.setBlending(val);
                }
            });
            blendingSlider.getElement().style.marginTop = '10px';
            var pressureSizeToggle = (0, $a49c90053f8766a2$export$9da2e8821e6cbb57)(true, function(b) {
                brush.setSizePressure(b);
            });
            var pressureOpacityToggle = (0, $a49c90053f8766a2$export$9da2e8821e6cbb57)(false, function(b) {
                brush.setOpacityPressure(b);
            });
            var lockAlphaToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
                init: brush.getLockAlpha(),
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha'),
                callback: function callback(b) {
                    brush.setLockAlpha(b);
                },
                doHighlight: true,
                title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha-title'),
                css: {
                    marginTop: '10px',
                    display: 'inline-block'
                },
                name: 'lock-alpha'
            });
            div.append((0, $eWjiX.BB).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px'
                }
            }), (0, $eWjiX.BB).el({
                content: [
                    opacitySlider.getElement(),
                    pressureOpacityToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }
            }), blendingSlider.getElement(), lockAlphaToggle.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.getIsDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.getIsDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context, layer.id);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p, isCoalesced) {
            brush.goLine(x, y, p, false); // looks weird with isCoalesced
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.getIsDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();





var $28d12d45dca1131c$exports = {};
$28d12d45dca1131c$exports = $parcel$resolve("hC7PC");




var $eWjiX = parcelRequire("eWjiX");
var $94537af75923b9e3$export$ffae56164d1bde68 = function() {
    var brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($28d12d45dca1131c$exports))),
        tooltip: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-sketchy'),
        sizeSlider: {
            min: 0.5,
            max: 10
        },
        opacitySlider: {
            min: 0.01,
            max: 1
        }
    };
    (0, $8d7403abedf7cefa$export$e4ce066d17694649).subscribe(function() {
        brushInterface.tooltip = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-sketchy');
    });
    brushInterface.Ui = function(p) {
        var div = document.createElement('div'); // the gui
        var brush = new (0, $42ac5b30ad65dabb$export$32510733a89b2eab).SketchyBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        var sizeSlider;
        var opacitySlider;
        function setSize(size) {
            brush.setSize(size);
        }
        function init() {
            sizeSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-size'),
                width: 250,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize() * 2,
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 2;
                },
                toValue: function(displayValue) {
                    return displayValue / 2;
                },
                onChange: function onChange(val) {
                    brush.setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: function(displayValue) {
                    if (displayValue < 10) return (0, $eWjiX.BB).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
                width: 250,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brush.getOpacity(),
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 100;
                },
                toValue: function(displayValue) {
                    return displayValue / 100;
                },
                onChange: function(val) {
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            var blendSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-blending'),
                width: 250,
                height: 30,
                min: 0,
                max: 1,
                value: brush.getBlending(),
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 100;
                },
                toValue: function(displayValue) {
                    return displayValue / 100;
                },
                onChange: function onChange(val) {
                    brush.setBlending(val);
                }
            });
            var scaleSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-sketchy-scale'),
                width: 250,
                height: 30,
                min: 1,
                max: 20,
                value: brush.getScale(),
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                onChange: function onChange(val) {
                    brush.setScale(val);
                }
            });
            opacitySlider.getElement().style.marginTop = '10px';
            blendSlider.getElement().style.marginTop = '10px';
            scaleSlider.getElement().style.marginTop = '10px';
            div.append(sizeSlider.getElement(), opacitySlider.getElement(), blendSlider.getElement(), scaleSlider.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, pressure) {
            brush.startLine(x, y, pressure);
        };
        this.goLine = function(x, y, pressure) {
            brush.goLine(x, y, pressure, undefined);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getSeed = function() {
            return parseInt('' + brush.getSeed());
        };
        this.setSeed = function(s) {
            brush.setSeed(parseInt('' + s));
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.isDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();



var $eWjiX = parcelRequire("eWjiX");





var $099bb534dd6472de$exports = {};
$099bb534dd6472de$exports = $parcel$resolve("eZgVv");



var $9519e739bc9666ee$export$d001f3406562d07 = function() {
    var brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($099bb534dd6472de$exports))),
        tooltip: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-pixel'),
        sizeSlider: {
            min: 0.5,
            max: 100,
            curve: (0, $eWjiX.BB).powerSplineInput(0.5, 100, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1,
            curve: [
                [
                    0,
                    0.01
                ],
                [
                    0.5,
                    0.3
                ],
                [
                    1,
                    1
                ]
            ]
        }
    };
    (0, $8d7403abedf7cefa$export$e4ce066d17694649).subscribe(function() {
        brushInterface.tooltip = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-pixel');
    });
    brushInterface.Ui = function(p) {
        var div = document.createElement('div'); // the gui
        var brush = new (0, $42ac5b30ad65dabb$export$32510733a89b2eab).PixelBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        var sizeSlider;
        var opacitySlider;
        var lockAlphaToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: brush.getLockAlpha(),
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha'),
            callback: function callback(b) {
                brush.setLockAlpha(b);
            },
            doHighlight: true,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha-title'),
            name: 'lock-alpha-toggle'
        });
        var eraserToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: brush.getIsEraser(),
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('eraser'),
            callback: function callback(b) {
                brush.setIsEraser(b);
            },
            name: 'eraser-toggle'
        });
        var ditherToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: brush.getUseDither(),
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-pixel-dither'),
            callback: function callback(b) {
                brush.setUseDither(b);
            },
            name: 'dither-toggle'
        });
        var spacingSpline = new (0, $eWjiX.BB).SplineInterpolator([
            [
                0.5,
                0.45
            ],
            [
                100,
                4
            ]
        ]);
        function setSize(size) {
            brush.setSize(size);
            brush.setSpacing(spacingSpline.interpolate(size) / size);
        }
        function init() {
            sizeSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize(),
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 2;
                },
                toValue: function(displayValue) {
                    return displayValue / 2;
                },
                onChange: function(val) {
                    setSize(val);
                    p.onSizeChange(val);
                }
            });
            opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brushInterface.opacitySlider.max,
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 100;
                },
                toValue: function(displayValue) {
                    return displayValue / 100;
                },
                onChange: function(val) {
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            var pressureSizeToggle = (0, $a49c90053f8766a2$export$9da2e8821e6cbb57)(true, function(b) {
                brush.sizePressure(b);
            });
            div.append((0, $eWjiX.BB).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px'
                }
            }), opacitySlider.getElement());
            var toggleRow = (0, $eWjiX.BB).el({
                parent: div,
                css: {
                    display: 'flex',
                    marginTop: '10px',
                    gap: '10px',
                    flexWrap: 'wrap'
                }
            });
            toggleRow.append(lockAlphaToggle.getElement(), eraserToggle.getElement(), ditherToggle.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size * 2);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity * 100);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p) {
            brush.goLine(x, y, p);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.isDrawing();
        };
        this.toggleEraser = function() {
            eraserToggle.setValue(!eraserToggle.getValue());
            brush.setIsEraser(eraserToggle.getValue());
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();



var $eWjiX = parcelRequire("eWjiX");





var $749e6c1deca5fab7$exports = {};
$749e6c1deca5fab7$exports = $parcel$resolve("fPZin");



var $d6fc2ded7d9d56db$export$cf481ecf227135a8 = function() {
    var brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($749e6c1deca5fab7$exports))),
        tooltip: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('eraser') + ' [E]',
        sizeSlider: {
            min: 0.5,
            max: 200,
            curve: (0, $eWjiX.BB).powerSplineInput(0.5, 200, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1
        }
    };
    (0, $8d7403abedf7cefa$export$e4ce066d17694649).subscribe(function() {
        brushInterface.tooltip = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('eraser') + ' [E]';
    });
    brushInterface.Ui = function(p) {
        var div = document.createElement('div'); // the gui
        var brush = new (0, $42ac5b30ad65dabb$export$32510733a89b2eab).EraserBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        var sizeSlider;
        var opacitySlider;
        var isTransparentBg = false;
        function setSize(size) {
            brush.setSize(size);
        }
        function init() {
            sizeSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: 30,
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 2;
                },
                toValue: function(displayValue) {
                    return displayValue / 2;
                },
                onChange: function(val) {
                    setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: function(displayValue) {
                    if (displayValue < 10) return (0, $eWjiX.BB).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brushInterface.opacitySlider.max,
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 100;
                },
                toValue: function(displayValue) {
                    return displayValue / 100;
                },
                onChange: function(val) {
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            var pressureSizeToggle = (0, $a49c90053f8766a2$export$9da2e8821e6cbb57)(true, function(b) {
                brush.sizePressure(b);
            });
            var pressureOpacityToggle = (0, $a49c90053f8766a2$export$9da2e8821e6cbb57)(false, function(b) {
                brush.opacityPressure(b);
            });
            div.append((0, $eWjiX.BB).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px'
                }
            }), (0, $eWjiX.BB).el({
                content: [
                    opacitySlider.getElement(),
                    pressureOpacityToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }
            }));
            var transparencyToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
                init: false,
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-eraser-transparent-bg'),
                callback: function callback(b) {
                    isTransparentBg = b;
                    brush.setTransparentBG(b);
                },
                css: {
                    marginTop: '10px'
                },
                name: 'transparency-toggle'
            });
            div.append(transparencyToggle.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.isDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function() {};
        this.setLayer = function(layer) {
            brush.setLayer(layer);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p) {
            brush.goLine(x, y, p);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.getIsTransparentBg = function() {
            return isTransparentBg;
        };
        this.isDrawing = function() {
            return brush.isDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();



var $eWjiX = parcelRequire("eWjiX");





var $e1552c11f17fda03$exports = {};
$e1552c11f17fda03$exports = $parcel$resolve("fp7H1");



var $1045b9bae2ffbbb4$export$84831662ba707e7a = function() {
    var brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($e1552c11f17fda03$exports))),
        tooltip: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-smudge'),
        sizeSlider: {
            min: 0.5,
            max: 100,
            curve: (0, $eWjiX.BB).powerSplineInput(0.5, 100, 0.1)
        },
        opacitySlider: {
            min: 0.01,
            max: 1,
            curve: [
                [
                    0,
                    0.01
                ],
                [
                    0.5,
                    0.3
                ],
                [
                    1,
                    1
                ]
            ]
        }
    };
    (0, $8d7403abedf7cefa$export$e4ce066d17694649).subscribe(function() {
        brushInterface.tooltip = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-smudge');
    });
    brushInterface.Ui = function(p) {
        var div = document.createElement('div'); // the gui
        var brush = new (0, $42ac5b30ad65dabb$export$32510733a89b2eab).SmudgeBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        var sizeSlider;
        var opacitySlider;
        var lockAlphaToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: brush.getLockAlpha(),
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha'),
            callback: function callback(b) {
                brush.setLockAlpha(b);
            },
            doHighlight: true,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha-title'),
            css: {
                display: 'inline-block'
            },
            name: 'lock-alpha-toggle'
        });
        var spacingSpline = new (0, $eWjiX.BB).SplineInterpolator([
            [
                0,
                15
            ],
            [
                8,
                7
            ],
            [
                14,
                4
            ],
            [
                30,
                3
            ],
            [
                50,
                2.7
            ],
            [
                100,
                2
            ]
        ]);
        function setSize(size) {
            brush.setSize(size);
            brush.setSpacing(Math.max(2, spacingSpline.interpolate(size)) / 15);
        }
        function init() {
            sizeSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-size'),
                width: 225,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize(),
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 2;
                },
                toValue: function(displayValue) {
                    return displayValue / 2;
                },
                onChange: function(val) {
                    setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: function(displayValue) {
                    if (displayValue < 10) return (0, $eWjiX.BB).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
                width: 225,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brush.getOpacity(),
                curve: brushInterface.opacitySlider.curve,
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 100;
                },
                toValue: function(displayValue) {
                    return displayValue / 100;
                },
                onChange: function(val) {
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            var pressureSizeToggle = (0, $a49c90053f8766a2$export$9da2e8821e6cbb57)(false, function(b) {
                brush.sizePressure(b);
            });
            var pressureOpacityToggle = (0, $a49c90053f8766a2$export$9da2e8821e6cbb57)(false, function(b) {
                brush.opacityPressure(b);
            });
            div.append((0, $eWjiX.BB).el({
                content: [
                    sizeSlider.getElement(),
                    pressureSizeToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '10px'
                }
            }), (0, $eWjiX.BB).el({
                content: [
                    opacitySlider.getElement(),
                    pressureOpacityToggle
                ],
                css: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }
            }));
            var bottomRow = (0, $eWjiX.BB).el({
                parent: div,
                css: {
                    marginTop: '10px'
                }
            });
            bottomRow.append(lockAlphaToggle.getElement());
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.getIsDrawing()) sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.getIsDrawing()) sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y, p);
        };
        this.goLine = function(x, y, p) {
            brush.goLine(x, y, p);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.getIsDrawing();
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();



var $eWjiX = parcelRequire("eWjiX");




var $457e9828be061aff$exports = {};
$457e9828be061aff$exports = $parcel$resolve("eX098");






var $7jh4K = parcelRequire("7jh4K");
var $18456e8104a5a825$export$80819a93636ebb04 = function() {
    var brushInterface = {
        image: (0, (/*@__PURE__*/$parcel$interopDefault($457e9828be061aff$exports))),
        tooltip: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-chemy'),
        sizeSlider: {
            min: 0.25,
            max: 25,
            curve: (0, $eWjiX.BB).powerSplineInput(0.25, 25, 0.1),
            isDisabled: true
        },
        opacitySlider: {
            min: 0.01,
            max: 1
        }
    };
    (0, $8d7403abedf7cefa$export$e4ce066d17694649).subscribe(function() {
        brushInterface.tooltip = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-chemy');
    });
    brushInterface.Ui = function(p) {
        var div = document.createElement('div'); // the gui
        var brush = new (0, $42ac5b30ad65dabb$export$32510733a89b2eab).ChemyBrush();
        brush.setHistory(p.klHistory);
        p.onSizeChange(brush.getSize());
        var sizeSlider;
        var opacitySlider;
        function setSize(size) {
            brush.setSize(size);
        }
        var eraserToggle;
        function init() {
            sizeSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-size'),
                width: 250,
                height: 30,
                min: brushInterface.sizeSlider.min,
                max: brushInterface.sizeSlider.max,
                value: brush.getSize(),
                curve: brushInterface.sizeSlider.curve,
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                isEnabled: brush.getMode() === 'stroke',
                toDisplayValue: function(val) {
                    return val * 2;
                },
                toValue: function(displayValue) {
                    return displayValue / 2;
                },
                onChange: function(val) {
                    setSize(val);
                    p.onSizeChange(val);
                },
                formatFunc: function(displayValue) {
                    if (displayValue < 5) return (0, $eWjiX.BB).round(displayValue, 1);
                    else return Math.round(displayValue);
                },
                manualInputRoundDigits: 1
            });
            opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
                width: 250,
                height: 30,
                min: brushInterface.opacitySlider.min,
                max: brushInterface.opacitySlider.max,
                value: brush.getOpacity(),
                eventResMs: (0, $e8a5c017c49bb311$export$f02de051ab70b20e),
                toDisplayValue: function(val) {
                    return val * 100;
                },
                toValue: function(displayValue) {
                    return displayValue / 100;
                },
                onChange: function(val) {
                    brush.setOpacity(val);
                    p.onOpacityChange(val);
                }
            });
            (0, $7jh4K.css)(opacitySlider.getElement(), {
                marginTop: '10px'
            });
            eraserToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
                init: brush.getIsEraser(),
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('eraser'),
                callback: function callback(b) {
                    brush.setIsEraser(b);
                },
                css: {
                    marginTop: '10px',
                    marginLeft: '10px'
                },
                name: 'eraser-toggle'
            });
            var lockAlphaToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
                init: brush.getLockAlpha(),
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha'),
                callback: function callback(b) {
                    brush.setLockAlpha(b);
                },
                doHighlight: true,
                title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha-title'),
                css: {
                    marginTop: '10px'
                },
                name: 'lock-alpha-toggle'
            });
            var toggleRow = (0, $eWjiX.BB).el({
                css: {
                    display: 'flex',
                    marginTop: '10px'
                }
            });
            var iconSize = 35;
            var padding = 8;
            var actualIconSize = iconSize - padding * 2;
            var halfSize = actualIconSize / 2;
            var modeOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
                optionArr: [
                    {
                        id: 'fill',
                        label: (0, $eWjiX.BB).createSvg({
                            class: 'dark-invert',
                            elementType: 'svg',
                            width: iconSize + '',
                            height: iconSize + '',
                            childrenArr: [
                                {
                                    elementType: 'path',
                                    fill: '#000',
                                    css: {
                                        transformOrigin: '0 0',
                                        transform: `translate(-0.5px, -0.5px) scale(${actualIconSize}, ${actualIconSize}) translate(0.5px, 0.5px)`
                                    },
                                    d: 'M 0,0 C 1.5,0 -0.5,1 1,1'
                                }
                            ]
                        }),
                        title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-chemy-fill')
                    },
                    {
                        id: 'stroke',
                        label: (0, $eWjiX.BB).createSvg({
                            class: 'dark-invert',
                            elementType: 'svg',
                            width: iconSize + '',
                            height: iconSize + '',
                            childrenArr: [
                                {
                                    elementType: 'path',
                                    fill: 'none',
                                    stroke: '#000',
                                    css: {
                                        strokeWidth: '0.12px',
                                        transformOrigin: '0 0',
                                        transform: `translate(-0.5px, -0.5px) scale(${actualIconSize}, ${actualIconSize}) translate(0.5px, 0.5px)`
                                    },
                                    d: 'M 0,0 C 1.5,0 -0.5,1 1,1'
                                }
                            ]
                        }),
                        title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-chemy-stroke')
                    }
                ],
                initId: brush.getMode(),
                onChange: function(id) {
                    brush.setMode(id);
                    brushInterface.sizeSlider.isDisabled = brush.getMode() === 'fill';
                    sizeSlider.setIsEnabled(!brushInterface.sizeSlider.isDisabled);
                    var brushSize = brush.getSize();
                    sizeSlider.setValue(brushSize);
                    p.onSizeChange(brushSize);
                    p.onConfigChange();
                }
            });
            var mirrorXToggle = new (0, $afe02cc26c765c2c$export$2358c75ad3c15b2d)({
                label: (0, $eWjiX.BB).createSvg({
                    class: 'dark-invert',
                    elementType: 'svg',
                    width: iconSize + '',
                    height: iconSize + '',
                    childrenArr: [
                        {
                            elementType: 'path',
                            fill: 'none',
                            stroke: '#000',
                            css: {
                                strokeWidth: '1px'
                            },
                            d: `M ${halfSize + padding},${padding} ${halfSize + padding},${actualIconSize + padding}`
                        }
                    ]
                }),
                title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-chemy-mirror-x'),
                init: brush.getXSymmetry(),
                onChange: function(b) {
                    brush.setXSymmetry(b);
                }
            });
            var mirrorYToggle = new (0, $afe02cc26c765c2c$export$2358c75ad3c15b2d)({
                label: (0, $eWjiX.BB).createSvg({
                    class: 'dark-invert',
                    elementType: 'svg',
                    width: iconSize + '',
                    height: iconSize + '',
                    childrenArr: [
                        {
                            elementType: 'path',
                            fill: 'none',
                            stroke: '#000',
                            css: {
                                strokeWidth: '1px'
                            },
                            d: `M ${padding},${halfSize + padding} ${actualIconSize + padding},${halfSize + padding}`
                        }
                    ]
                }),
                title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-chemy-mirror-y'),
                init: brush.getYSymmetry(),
                onChange: function(b) {
                    brush.setYSymmetry(b);
                }
            });
            var gradientToggle = new (0, $afe02cc26c765c2c$export$2358c75ad3c15b2d)({
                label: (0, $eWjiX.BB).createSvg({
                    class: 'dark-invert',
                    elementType: 'svg',
                    width: iconSize + '',
                    height: iconSize + '',
                    childrenArr: [
                        {
                            elementType: 'defs',
                            childrenArr: [
                                {
                                    elementType: 'linearGradient',
                                    id: 'gradient',
                                    x1: '0',
                                    y1: '0',
                                    x2: '0',
                                    y2: '1',
                                    childrenArr: [
                                        {
                                            elementType: 'stop',
                                            offset: '0%',
                                            'stop-color': 'rgba(0,0,0,0)'
                                        },
                                        {
                                            elementType: 'stop',
                                            offset: '100%',
                                            'stop-color': 'rgba(0,0,0,1)'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            elementType: 'rect',
                            fill: "url('#gradient')",
                            x: '' + padding,
                            y: '' + padding,
                            width: '' + actualIconSize,
                            height: '' + actualIconSize
                        }
                    ]
                }),
                title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-chemy-gradient'),
                init: brush.getGradient(),
                onChange: function(b) {
                    brush.setGradient(b);
                }
            });
            (0, $7jh4K.css)(mirrorXToggle.getElement(), {
                marginLeft: '10px'
            });
            {
                var margin = {
                    marginLeft: '4px'
                };
                (0, $7jh4K.css)(mirrorYToggle.getElement(), margin);
                (0, $7jh4K.css)(gradientToggle.getElement(), margin);
            }
            toggleRow.append(modeOptions.getElement(), mirrorXToggle.getElement(), mirrorYToggle.getElement(), gradientToggle.getElement());
            div.append(sizeSlider.getElement(), opacitySlider.getElement(), toggleRow, (0, $eWjiX.BB).el({
                content: [
                    lockAlphaToggle.getElement(),
                    eraserToggle.getElement()
                ],
                css: {
                    display: 'flex'
                }
            }));
        }
        init();
        this.increaseSize = function(f) {
            if (!brush.getIsDrawing() && brush.getMode() === 'stroke') sizeSlider.changeSliderValue(f);
        };
        this.decreaseSize = function(f) {
            if (!brush.getIsDrawing() && brush.getMode() === 'stroke') sizeSlider.changeSliderValue(-f);
        };
        this.getSize = function() {
            return brush.getSize();
        };
        this.setSize = function(size) {
            setSize(size);
            sizeSlider.setValue(size);
        };
        this.getOpacity = function() {
            return brush.getOpacity();
        };
        this.setOpacity = function(opacity) {
            brush.setOpacity(opacity);
            opacitySlider.setValue(opacity);
        };
        this.setColor = function(c) {
            brush.setColor(c);
        };
        this.setLayer = function(layer) {
            brush.setContext(layer.context);
        };
        this.startLine = function(x, y, p) {
            brush.startLine(x, y);
        };
        this.goLine = function(x, y, p, isCoalesced) {
            brush.goLine(x, y);
        };
        this.endLine = function() {
            brush.endLine();
        };
        this.getBrush = function() {
            return brush;
        };
        this.isDrawing = function() {
            return brush.getIsDrawing();
        };
        this.toggleEraser = function() {
            eraserToggle.setValue(!eraserToggle.getValue());
            brush.setIsEraser(eraserToggle.getValue());
        };
        this.getElement = function() {
            return div;
        };
    };
    return brushInterface;
}();


var $7de2f0eab7a9ead7$export$d1a79a5ce7e46547 = {
    penBrush: (0, $8b6ca25eb0830594$export$a0d4983f3b0b5c8e),
    blendBrush: (0, $2e3c50106ba150d5$export$156bb4fe8f4bcb4b),
    sketchyBrush: (0, $94537af75923b9e3$export$ffae56164d1bde68),
    pixelBrush: (0, $9519e739bc9666ee$export$d001f3406562d07),
    chemyBrush: (0, $18456e8104a5a825$export$80819a93636ebb04),
    smudgeBrush: (0, $1045b9bae2ffbbb4$export$84831662ba707e7a),
    eraserBrush: (0, $d6fc2ded7d9d56db$export$cf481ecf227135a8)
};



var $eWjiX = parcelRequire("eWjiX");


function $2d47de6498e5a87c$export$35fa34e5af64bd4a(url, isEmbed) {
    // window very small, modal might look bad
    if (!isEmbed && (window.innerHeight < 500 || window.innerWidth < 700)) {
        window.open(url);
        return;
    }
    var iframe = (0, $eWjiX.BB).el({
        tagName: 'iframe',
        custom: {
            src: url
        },
        css: {
            width: '100%',
            height: '100%',
            opacity: '0'
        }
    });
    setTimeout(function() {
        iframe.style.opacity = ''; // fallback
    }, 500);
    var titleEl = (0, $eWjiX.BB).el();
    var linkEl;
    if (!isEmbed) {
        linkEl = (0, $eWjiX.BB).el({
            tagName: 'a',
            parent: titleEl,
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('modal-new-tab'),
            custom: {
                href: 'help',
                target: '_blank'
            },
            onClick: function onClick() {
                popup.close();
            }
        });
        iframe.onload = function() {
            if (linkEl && iframe.contentWindow) try {
                (0, $eWjiX.BB).setAttributes(linkEl, {
                    href: '' + iframe.contentWindow.location
                });
            } catch (e) {
            // might not have access
            }
            iframe.style.opacity = '';
        };
    }
    var popup = new (0, $e59fbd08bcc1a36b$export$185108a9b725b68)({
        title: titleEl,
        content: iframe,
        width: 880,
        isMaxHeight: true,
        onClose: function() {
            if (linkEl) {
                iframe.src = 'about:blank';
                (0, $eWjiX.BB).destroyEl(linkEl);
                linkEl = undefined;
            }
        }
    });
}



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $de98bdc3369d2e4f$export$3dff5655255b5729 = /*#__PURE__*/ function() {
    "use strict";
    function RadioList(param) {
        var _this = this;
        var name = param.name, init = param.init, items = param.items, ignoreFocus = param.ignoreFocus;
        (0, $cx0mh._)(this, RadioList);
        this.inputs = [];
        this.el = (0, $eWjiX.BB).el({
            className: 'kl-radio'
        });
        items.forEach(function(item) {
            var label = (0, $eWjiX.BB).el({
                tagName: 'label'
            });
            var input = (0, $eWjiX.BB).el({
                tagName: 'input',
                parent: label,
                custom: {
                    name: name,
                    value: item.value,
                    type: 'radio'
                }
            });
            if (ignoreFocus) input.setAttribute('data-ignore-focus', 'true');
            if (init === item.value) input.checked = true;
            label.append(item.label);
            _this.el.append(label);
            _this.inputs.push(input);
        });
    }
    (0, $7h4XF._)(RadioList, [
        {
            key: "getValue",
            value: function getValue() {
                for(var i = 0; i < this.inputs.length; i++){
                    if (this.inputs[i].checked) return this.inputs[i].value;
                }
                return null;
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.el;
            }
        }
    ]);
    return RadioList;
}();



var $1LaJZ = parcelRequire("1LaJZ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $fk3zw = parcelRequire("fk3zw");

var $eWjiX = parcelRequire("eWjiX");





function $57703debd837e772$export$1b9ca798405c9eb6(timestamp) {
    var age = new Date().getTime() - timestamp;
    var ageStr;
    age = Math.floor(age / 1000 / 60);
    ageStr = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-min-ago').replace('{x}', '' + age);
    if (age > 60) {
        age = Math.floor(age / 60);
        ageStr = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-hours-ago').replace('{x}', '' + age);
        if (age > 24) {
            age = Math.floor(age / 24);
            ageStr = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-days-ago').replace('{x}', '' + age);
            if (age > 31) ageStr = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-month-ago');
        }
    }
    return ageStr;
}



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");


var $959a92a71fa952f2$export$852ebaa1b01c8b5a = /*#__PURE__*/ function() {
    "use strict";
    function BrowserStorageHeaderUi() {
        (0, $cx0mh._)(this, BrowserStorageHeaderUi);
        this.infoButton = (0, $eWjiX.BB).el({
            content: '?',
            className: 'kl-info-btn',
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-about'),
            onClick: function() {
                (0, $2d47de6498e5a87c$export$35fa34e5af64bd4a)('./help/#help-browser-storage', false);
            }
        });
        this.rootEl = (0, $eWjiX.BB).el({
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage'),
            css: {
                display: 'flex',
                margin: '-5px 0',
                gap: '6px'
            }
        });
        this.rootEl.append(this.infoButton);
    }
    (0, $7h4XF._)(BrowserStorageHeaderUi, [
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "show",
            value: function show() {}
        },
        {
            key: "destroy",
            value: function destroy() {
                (0, $eWjiX.BB).destroyEl(this.infoButton);
            }
        }
    ]);
    return BrowserStorageHeaderUi;
}();


var $f36d91ca9b37c82f$export$bd46b8ab3689edc4;
var $f36d91ca9b37c82f$export$b5381822af66064b;
$f36d91ca9b37c82f$export$bd46b8ab3689edc4 = `a9LdEW_anim`;
$f36d91ca9b37c82f$export$bd46b8ab3689edc4;
$f36d91ca9b37c82f$export$b5381822af66064b = `a9LdEW_animEl`;



var $72Jv0 = parcelRequire("72Jv0");
/**
 * https://developer.mozilla.org/en-US/docs/Web/API/StorageManager/persist
 * Might reduce deletions of indexedDB data by browser.
 *
 * "The best time to request your storage be marked as persistent is when you save critical user
 * data, and the request should ideally be **wrapped in a user gesture**."
 * from https://web.dev/articles/persistent-storage
 */ 
var $1LaJZ = parcelRequire("1LaJZ");

var $fk3zw = parcelRequire("fk3zw");
function $dc6d4b1d8d494091$export$f565b71ad023b7df() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!('storage' in navigator && 'persist' in navigator.storage)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        navigator.storage.persist()
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    })();
}



var $eIcQa = parcelRequire("eIcQa");
var $0e681e75eb3cab30$export$9c72cf485ef46673 = /*#__PURE__*/ function() {
    "use strict";
    function BrowserStorageUi(p) {
        var _this = this;
        (0, $cx0mh._)(this, BrowserStorageUi);
        var _this_options, _this_options1;
        this.previewEl = {};
        this.ageEl = {};
        this.emptyEl = {};
        this.storeButtonEl = {};
        this.clearButtonEl = {};
        this.storeListener = {};
        this.isFirst = true;
        this.updateAgeInterval = setInterval(function() {
            return _this.updateAge();
        }, 60000);
        this.projectStore = p.projectStore;
        this.getProject = p.getProject;
        this.onStored = p.onStored;
        this.applyUncommitted = p.applyUncommitted;
        this.options = p.options;
        this.onOpen = p.onOpen;
        this.rootEl = (0, $eWjiX.BB).el({});
        this.header = new (0, $959a92a71fa952f2$export$852ebaa1b01c8b5a)();
        this.rootEl.append(this.header.getElement());
        this.contentEl = (0, $eWjiX.BB).el({
            parent: this.rootEl
        });
        if (!this.projectStore.getIsAvailable()) {
            this.showError();
            return;
        }
        this.previewEl = (0, $eWjiX.BB).el({
            className: 'kl-storage-preview',
            onClick: function() {
                var _this_onOpen, _this1;
                return (_this_onOpen = (_this1 = _this).onOpen) === null || _this_onOpen === void 0 ? void 0 : _this_onOpen.call(_this1);
            },
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-open'),
            noRef: true
        });
        this.emptyEl = (0, $eWjiX.BB).el({
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-empty')
        });
        this.ageEl = (0, $eWjiX.BB).el({
            css: {
                position: 'absolute',
                right: '0',
                bottom: '0',
                width: '100%',
                textAlign: 'center',
                background: 'rgba(0,0,0,0.7)',
                color: '#fff',
                fontSize: '13px'
            }
        });
        if (this.onOpen) this.openButtonEl = (0, $eWjiX.BB).el({
            tagName: 'button',
            className: 'grid-button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-open'),
            css: {
                margin: '0'
            },
            onClick: function() {
                var _this_onOpen, _this1;
                return (_this_onOpen = (_this1 = _this).onOpen) === null || _this_onOpen === void 0 ? void 0 : _this_onOpen.call(_this1);
            },
            noRef: true
        });
        this.storeButtonEl = (0, $eWjiX.BB).el({
            tagName: 'button',
            className: 'grid-button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-store'),
            css: {
                margin: '0'
            },
            onClick: function() {
                return _this.store();
            },
            noRef: true
        });
        this.clearButtonEl = (0, $eWjiX.BB).el({
            tagName: 'button',
            className: 'grid-button kl-button-delete',
            content: '<img src="' + (0, (/*@__PURE__*/$parcel$interopDefault($720ba2c010612610$exports))) + '" height="20"/> ' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-clear'),
            css: {
                margin: '0'
            },
            onClick: function() {
                return _this.clear();
            },
            noRef: true
        });
        if (!((_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.isFocusable)) {
            this.openButtonEl && (0, $72Jv0.makeUnfocusable)(this.openButtonEl);
            (0, $72Jv0.makeUnfocusable)(this.storeButtonEl);
            (0, $72Jv0.makeUnfocusable)(this.clearButtonEl);
        }
        if ((_this_options1 = this.options) === null || _this_options1 === void 0 ? void 0 : _this_options1.hideClearButton) this.clearButtonEl.style.visibility = 'hidden';
        this.contentEl.append((0, $eWjiX.BB).el({
            content: [
                (0, $eWjiX.BB).el({
                    content: this.previewEl,
                    css: {
                        alignSelf: 'stretch',
                        flexGrow: '1'
                    }
                }),
                (0, $eWjiX.BB).el({
                    content: [
                        this.openButtonEl,
                        this.storeButtonEl,
                        this.clearButtonEl
                    ],
                    css: {
                        display: 'flex',
                        gap: '10px',
                        flexDirection: 'column'
                    }
                })
            ],
            css: {
                marginTop: '10px',
                display: 'flex',
                gap: '10px'
            }
        }));
        this.storeListener = {
            onUpdate: function(project) {
                _this.updateThumb(project === null || project === void 0 ? void 0 : project.timestamp, project === null || project === void 0 ? void 0 : project.thumbnail);
            }
        };
        this.projectStore.subscribe(this.storeListener);
        this.updateThumb();
    }
    (0, $7h4XF._)(BrowserStorageUi, [
        {
            key: "updateAge",
            value: function updateAge() {
                if (!this.timestamp) return;
                this.ageEl.textContent = (0, $57703debd837e772$export$1b9ca798405c9eb6)(this.timestamp);
            }
        },
        {
            key: "resetButtons",
            value: function resetButtons() {
                this.previewEl.classList.remove('kl-storage-preview--disabled');
                if (this.timestamp) {
                    if (this.openButtonEl) this.openButtonEl.disabled = false;
                    this.storeButtonEl.textContent = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-overwrite');
                    this.storeButtonEl.disabled = false;
                    this.clearButtonEl.disabled = false;
                } else {
                    if (this.openButtonEl) this.openButtonEl.disabled = true;
                    this.storeButtonEl.textContent = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-store');
                    this.storeButtonEl.disabled = false;
                    this.clearButtonEl.disabled = true;
                }
            }
        },
        {
            key: "updateThumb",
            value: function updateThumb(timestamp, thumbnail) {
                var _this_thumbnail;
                this.timestamp = timestamp;
                (_this_thumbnail = this.thumbnail) === null || _this_thumbnail === void 0 ? void 0 : _this_thumbnail.remove();
                this.thumbnail = thumbnail ? (0, $eIcQa.copyCanvas)(thumbnail) : undefined;
                var thumbnailCanvas = this.thumbnail; // typescript being weird
                if (thumbnailCanvas && timestamp) {
                    thumbnailCanvas.classList.add('kl-storage-preview__im');
                    this.ageEl.remove();
                    this.emptyEl.remove();
                    this.updateAge();
                    this.previewEl.append(thumbnailCanvas, this.ageEl);
                    this.previewEl.style.pointerEvents = this.onOpen ? '' : 'none';
                    if (typeof performance !== 'undefined' && timestamp > performance.timeOrigin) {
                        var animEl = (0, $eWjiX.BB).el({
                            parent: this.previewEl,
                            className: $f36d91ca9b37c82f$export$b5381822af66064b
                        });
                        setTimeout(function() {
                            animEl.remove();
                        }, 500);
                    }
                } else {
                    this.ageEl.remove();
                    this.previewEl.append(this.emptyEl);
                    this.previewEl.style.pointerEvents = 'none'; // prevent title
                }
                this.resetButtons();
            }
        },
        {
            key: "store",
            value: function store() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var meta, project, doOverwrite, e;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                meta = this.projectStore.getCurrentMeta();
                                project = this.getProject();
                                if (!(meta && meta.projectId !== project.projectId)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    new Promise(function(resolve, reject) {
                                        (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
                                            type: 'warning',
                                            message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-overwrite-confirm'),
                                            buttons: [
                                                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-overwrite'),
                                                'Cancel'
                                            ],
                                            callback: function(result) {
                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                                    return (0, $fk3zw._)(this, function(_state) {
                                                        if (result === 'Cancel') {
                                                            resolve(false);
                                                            return [
                                                                2
                                                            ];
                                                        }
                                                        resolve(true);
                                                        return [
                                                            2
                                                        ];
                                                    });
                                                })();
                                            }
                                        });
                                    })
                                ];
                            case 1:
                                doOverwrite = _state.sent();
                                if (!doOverwrite) return [
                                    2
                                ];
                                _state.label = 2;
                            case 2:
                                this.applyUncommitted();
                                return [
                                    4,
                                    (0, $dc6d4b1d8d494091$export$f565b71ad023b7df)()
                                ];
                            case 3:
                                _state.sent();
                                if (this.openButtonEl) this.openButtonEl.disabled = true;
                                this.storeButtonEl.textContent = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-storing');
                                this.storeButtonEl.disabled = true;
                                this.clearButtonEl.disabled = true;
                                this.previewEl.classList.add('kl-storage-preview--disabled');
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        setTimeout(function() {
                                            return resolve(null);
                                        }, 20);
                                    })
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    this.projectStore.store(project)
                                ];
                            case 6:
                                _state.sent();
                                this.onStored();
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                e = _state.sent();
                                this.resetButtons();
                                (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                    type: 'error',
                                    message: [
                                        `${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-failed-1')}<ul>`,
                                        `<li>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-failed-2')}</li>`,
                                        `<li>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-failed-3')}</li>`,
                                        `<li>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-failed-4')}</li>`,
                                        '</ul>'
                                    ].join(''),
                                    buttons: [
                                        'Ok'
                                    ]
                                });
                                setTimeout(function() {
                                    throw new Error('storage-ui: failed to store browser storage, ' + e);
                                }, 0);
                                return [
                                    3,
                                    8
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "clear",
            value: function clear() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this;
                    return (0, $fk3zw._)(this, function(_state) {
                        _this = this;
                        (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
                            type: 'warning',
                            message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-clear-prompt'),
                            buttons: [
                                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-clear'),
                                'Cancel'
                            ],
                            deleteButtonName: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-clear'),
                            callback: function(result) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                    var e;
                                    return (0, $fk3zw._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (result === 'Cancel') return [
                                                    2
                                                ];
                                                if (this.openButtonEl) this.openButtonEl.disabled = true;
                                                this.storeButtonEl.disabled = true;
                                                this.clearButtonEl.disabled = true;
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                return [
                                                    4,
                                                    this.projectStore.clear()
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                e = _state.sent();
                                                this.resetButtons();
                                                (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                                    type: 'error',
                                                    message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-failed-clear'),
                                                    buttons: [
                                                        'Ok'
                                                    ]
                                                });
                                                setTimeout(function() {
                                                    throw new Error('storage-ui: failed to clear browser storage, ' + e);
                                                }, 0);
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                }).call(_this);
                            }
                        });
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "showError",
            value: function showError() {
                this.contentEl.innerHTML = '';
                (0, $eWjiX.BB).el({
                    parent: this.contentEl,
                    content: "\uD83D\uDD34 " + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-cant-access'),
                    css: {
                        marginTop: '10px'
                    }
                });
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                if (this.isFirst) {
                    this.isFirst = false;
                    if (!this.projectStore.getIsAvailable()) this.showError();
                    else (function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                            var meta, e;
                            return (0, $fk3zw._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            this.projectStore.update()
                                        ];
                                    case 1:
                                        _state.sent();
                                        meta = this.projectStore.getCurrentMeta();
                                        if (meta) this.updateThumb(meta.timestamp, meta.thumbnail);
                                        else this.updateThumb();
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        e = _state.sent();
                                        this.showError();
                                        throw new Error('browser-storage-ui: failed initial read browser storage, ' + e);
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        }).call(_this);
                    })();
                }
            }
        },
        {
            key: "hide",
            value: function hide() {
            // ...
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.header.destroy();
                (0, $eWjiX.BB).destroyEl(this.storeButtonEl);
                (0, $eWjiX.BB).destroyEl(this.clearButtonEl);
                clearInterval(this.updateAgeInterval);
                this.projectStore.unsubscribe(this.storeListener);
            }
        }
    ]);
    return BrowserStorageUi;
}();



var $6mTnI = parcelRequire("6mTnI");

var $1LaJZ = parcelRequire("1LaJZ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $bX4ja = parcelRequire("bX4ja");

var $fk3zw = parcelRequire("fk3zw");

var $eWjiX = parcelRequire("eWjiX");






var $f596c98d53b60fa1$exports = {};
$f596c98d53b60fa1$exports = $parcel$resolve("2oHM2");





var $6l0gQ = parcelRequire("6l0gQ");


var $eWjiX = parcelRequire("eWjiX");

var $1LaJZ = parcelRequire("1LaJZ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $bX4ja = parcelRequire("bX4ja");

var $fk3zw = parcelRequire("fk3zw");

var $eWjiX = parcelRequire("eWjiX");

var $6otAp = parcelRequire("6otAp");



var $eIcQa = parcelRequire("eIcQa");
var $e87f92103dc0908f$export$48c2d0f2f545ac27;
$e87f92103dc0908f$export$48c2d0f2f545ac27 = `-c3MRW_preview`;





var $7jh4K = parcelRequire("7jh4K");
var $ac1dc556c612a3be$export$feb3da9ac0115d49 = /*#__PURE__*/ function() {
    "use strict";
    function RecoveryManagerPanel(p) {
        var _this = this;
        (0, $cx0mh._)(this, RecoveryManagerPanel);
        this.recoveryListener = function(metas, totalMemoryUsedBytes) {
            _this.update(metas, totalMemoryUsedBytes);
        };
        this.klRecoveryManager = p.klRecoveryManager;
        this.rootEl = (0, $eWjiX.BB).el({
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('loading')
        });
        this.klRecoveryManager.subscribe(this.recoveryListener);
        setTimeout(function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                var e;
                return (0, $fk3zw._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                this.klRecoveryManager.update()
                            ];
                        case 1:
                            _state.sent();
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            setTimeout(function() {
                                throw e;
                            });
                            this.rootEl.innerHTML = 'error';
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        });
    }
    (0, $7h4XF._)(RecoveryManagerPanel, [
        {
            key: "update",
            value: function update(metas, totalMemoryUsedBytes) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this, elements;
                    return (0, $fk3zw._)(this, function(_state) {
                        _this = this;
                        elements = [];
                        metas.sort(function(a, b) {
                            if (a.timestamp > b.timestamp) return -1;
                            if (a.timestamp < b.timestamp) return 1;
                            return 0;
                        }).forEach(function(meta) {
                            var recoverBtn = (0, $eWjiX.BB).el({
                                tagName: 'a',
                                className: 'kl-button kl-button-link',
                                content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-recovery-recover'),
                                custom: {
                                    href: '#' + meta.id,
                                    target: '_blank'
                                }
                            });
                            var deleteBtn = (0, $eWjiX.BB).el({
                                tagName: 'button',
                                className: 'kl-button-delete',
                                content: `<img src="${(0, (/*@__PURE__*/$parcel$interopDefault($720ba2c010612610$exports)))}" height="20"/>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-recovery-delete')}`,
                                onClick: function() {
                                    deleteBtn.blur();
                                    var thumbnail2 = (0, $eIcQa.copyCanvas)(meta.thumbnail);
                                    (0, $7jh4K.css)(thumbnail2, {
                                        alignSelf: 'start',
                                        background: 'var(--kl-checkerboard-background)',
                                        maxWidth: '100%'
                                    });
                                    (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
                                        type: 'warning',
                                        message: (0, $eWjiX.BB).el({
                                            content: [
                                                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-recovery-delete-confirmation'),
                                                thumbnail2
                                            ],
                                            css: {
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '10px'
                                            }
                                        }),
                                        buttons: [
                                            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-recovery-delete'),
                                            'Cancel'
                                        ],
                                        deleteButtonName: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-recovery-delete'),
                                        callback: function(result) {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                                return (0, $fk3zw._)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            if (result === 'Cancel') return [
                                                                2
                                                            ];
                                                            return [
                                                                4,
                                                                this.klRecoveryManager.remove(+meta.id)
                                                            ];
                                                        case 1:
                                                            _state.sent();
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            }).call(_this);
                                        }
                                    });
                                },
                                noRef: true
                            });
                            var preview = meta.thumbnail;
                            var previewWrapper = (0, $eWjiX.BB).el({
                                tagName: 'a',
                                content: preview,
                                className: $e87f92103dc0908f$export$48c2d0f2f545ac27,
                                title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-recovery-recover'),
                                css: {
                                    minHeight: (0, $6otAp.RECOVERY_THUMB_HEIGHT_PX) + 'px'
                                },
                                custom: {
                                    href: '#' + meta.id,
                                    target: '_blank'
                                }
                            });
                            var infoEl = (0, $eWjiX.BB).el({
                                content: [
                                    (0, $57703debd837e772$export$1b9ca798405c9eb6)(meta.timestamp),
                                    ', ' + (0, $eWjiX.BB).round(meta.memoryEstimateBytes / 1000000, 1) + ' MB'
                                ],
                                css: {
                                    textAlign: 'center'
                                }
                            });
                            elements.push((0, $eWjiX.BB).el({
                                content: [
                                    previewWrapper,
                                    infoEl,
                                    recoverBtn,
                                    deleteBtn
                                ],
                                css: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '5px',
                                    maxWidth: '100%'
                                }
                            }));
                        });
                        this.rootEl.innerHTML = '';
                        if (0, $6otAp.DEBUG_RETURN_ALL_RECOVERIES) this.rootEl.append((0, $eWjiX.BB).el({
                            content: 'Debug On - SHOWING ALL TABS',
                            css: {
                                background: 'red'
                            }
                        }));
                        this.rootEl.append((0, $eWjiX.BB).el({
                            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-recovery-explanation'),
                            className: 'kl-toolspace-note'
                        }), (0, $eWjiX.BB).el({
                            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-recovery-total-quota-label') + ' ' + (0, $eWjiX.BB).round(totalMemoryUsedBytes / 1000000, 1) + ' MB / ' + (0, $eWjiX.BB).round((0, $6otAp.RECOVERY_MEMORY_LIMIT_BYTES) / 1000000, 1) + ' MB',
                            css: {
                                margin: '10px 0'
                            }
                        }), (0, $eWjiX.BB).el({
                            content: (0, $bX4ja._)(elements),
                            css: {
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '20px 10px',
                                justifyContent: 'space-evenly'
                            }
                        }));
                        if (elements.length === 0) this.rootEl.append((0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-recovery-empty'));
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.klRecoveryManager.unsubscribe(this.recoveryListener);
            }
        }
    ]);
    return RecoveryManagerPanel;
}();



var $jTg9g = parcelRequire("jTg9g");


function $890b23f3a39679d3$export$abc0e2c9b0afece1(klRecoveryManager) {
    if (!klRecoveryManager || !(0, $jTg9g.KL_INDEXED_DB).getIsAvailable()) {
        (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
            type: 'error',
            message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-cant-access'),
            buttons: [
                'Ok'
            ]
        });
        return;
    }
    var recoveryManager = new (0, $ac1dc556c612a3be$export$feb3da9ac0115d49)({
        klRecoveryManager: klRecoveryManager
    });
    var rootEl = (0, $eWjiX.BB).el({
        content: [
            recoveryManager.getElement()
        ]
    });
    var onModalExit = function(val) {
        recoveryManager.destroy();
    };
    var modal = (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
        message: `<b>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-recovery-recover-tabs')}</b>`,
        div: rootEl,
        buttons: [
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('modal-close')
        ],
        callback: onModalExit,
        style: {
            width: 'calc(100% - 50px)',
            maxWidth: '1000px',
            minWidth: '300px',
            boxSizing: 'border-box'
        },
        clickOnEnter: 'Ok'
    });
}


var $34d04701a8a02997$export$bd7a7a9fa7e7f04b;
$34d04701a8a02997$export$bd7a7a9fa7e7f04b = `Tt6aiG_recoveryBubble`;




var $7jh4K = parcelRequire("7jh4K");
var $775b09ee76e7cc3e$var$LS_SHOW_SAVE_DIALOG = 'kl-save-dialog';
var $775b09ee76e7cc3e$var$createSpacer = function() {
    var el = document.createElement('div');
    var clearer = document.createElement('div');
    var line = (0, $eWjiX.BB).el({
        className: 'grid-hr'
    });
    el.append(clearer, line);
    (0, $7jh4K.css)(clearer, {
        clear: 'both'
    });
    return el;
};
var $775b09ee76e7cc3e$var$createButtonContent = function(text, icon, noInvert) {
    return `<img ${noInvert ? 'class="dark-no-invert"' : ''} src='${icon}' alt='icon' height='20'/>${text}`;
};
var $775b09ee76e7cc3e$export$409b892ffe02580b = /*#__PURE__*/ function() {
    "use strict";
    function FileUi(p) {
        var _this = this;
        (0, $cx0mh._)(this, FileUi);
        this.recoveryListener = function(metas) {
            if (!_this.recoveryCountBubble) return;
            var count = metas.length;
            if (count === 0) _this.recoveryCountBubble.style.display = 'none';
            else {
                _this.recoveryCountBubble.textContent = '' + count;
                _this.recoveryCountBubble.style.display = 'inline-block';
            }
        };
        this.exportType = p.exportType;
        this.applyUncommitted = p.applyUncommitted;
        this.rootEl = document.createElement('div');
        var asyncCreation = function() {
            var _this_browserStorageUi;
            // --- hint ---
            var saveNote = (0, $eWjiX.BB).el({
                className: 'kl-toolspace-note',
                textContent: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-no-autosave'),
                css: {
                    margin: '10px 10px 0 10px'
                }
            });
            // --- new, import, save ---
            var newButton = (0, $eWjiX.BB).el({
                tagName: 'button',
                className: 'grid-button',
                content: $775b09ee76e7cc3e$var$createButtonContent((0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-new'), (0, (/*@__PURE__*/$parcel$interopDefault($74ce9fe92d58e953$exports))), true),
                custom: {
                    tabIndex: '-1'
                },
                css: {
                    cssFloat: 'left'
                },
                onClick: function() {
                    return p.onNewImage();
                }
            });
            var importButton = (0, $eWjiX.BB).el({
                tagName: 'button',
                className: 'grid-button',
                content: $775b09ee76e7cc3e$var$createButtonContent((0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-import'), (0, (/*@__PURE__*/$parcel$interopDefault($ea09e4c322d05e2e$exports))), true),
                css: {
                    position: 'relative',
                    cursor: 'pointer',
                    cssFloat: 'left'
                },
                custom: {
                    tabIndex: '-1'
                },
                onClick: function() {
                    return _this.importInput.click();
                }
            });
            _this.importInput = (0, $eWjiX.BB).el({
                tagName: 'input',
                css: {
                    display: 'none'
                },
                onChange: function() {
                    _this.applyUncommitted();
                    _this.importInput.files && p.onFileSelect(_this.importInput.files, 'default');
                    _this.importInput.value = '';
                },
                custom: {
                    tabIndex: '-1'
                }
            });
            _this.importInput.type = 'file';
            _this.importInput.multiple = true;
            _this.importInput.accept = 'image/*,.psd'; // .psd needed for chrome, although it's image/vnd.adobe.photoshop
            var saveButton = (0, $eWjiX.BB).el({
                tagName: 'button',
                className: 'grid-button grid-button--filter',
                content: $775b09ee76e7cc3e$var$createButtonContent((0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-save'), (0, (/*@__PURE__*/$parcel$interopDefault($7ba84df17a4098f2$exports)))),
                custom: {
                    tabIndex: '-1'
                },
                css: {
                    cssFloat: 'left',
                    flex: '1 0 0',
                    margin: '0'
                },
                onClick: function() {
                    return p.onSaveImageToComputer();
                }
            });
            var canShowSaveDialog = 'showSaveFilePicker' in window;
            var showSaveDialogRaw = (0, $6l0gQ.LocalStorage).getItem($775b09ee76e7cc3e$var$LS_SHOW_SAVE_DIALOG);
            var initialShowSaveDialog = showSaveDialogRaw === null ? false : showSaveDialogRaw === 'true';
            var saveDialogCheckbox = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
                init: initialShowSaveDialog,
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-show-save-dialog'),
                callback: function(value) {
                    if (value) (0, $6l0gQ.LocalStorage).setItem($775b09ee76e7cc3e$var$LS_SHOW_SAVE_DIALOG, 'true');
                    else (0, $6l0gQ.LocalStorage).removeItem($775b09ee76e7cc3e$var$LS_SHOW_SAVE_DIALOG); // default is false
                    p.onChangeShowSaveDialog(value);
                },
                css: {
                    maxWidth: 'fit-content'
                },
                name: 'show-save-dialog'
            });
            p.onChangeShowSaveDialog(initialShowSaveDialog);
            // export filetype dropdown
            var exportTypeSelect = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).Select({
                optionArr: [
                    [
                        'png',
                        'PNG'
                    ],
                    [
                        'jpg',
                        'JPG'
                    ],
                    [
                        'psd',
                        'PSD'
                    ],
                    [
                        'layers',
                        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers') + ' (PNG)'
                    ]
                ],
                initValue: _this.exportType,
                onChange: function(val) {
                    _this.exportType = val;
                    p.onExportTypeChange(_this.exportType);
                    p.onSaveImageToComputer();
                },
                title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-format'),
                name: 'export-type'
            });
            (0, $7jh4K.css)(exportTypeSelect.getElement(), {
                height: '30px',
                width: 'calc(50% - 10px)',
                flex: '1 0 0'
            });
            // --- browser storage ---
            var browserStorageFallbackEl;
            if (p.projectStore) {
                _this.browserStorageUi = new (0, $0e681e75eb3cab30$export$9c72cf485ef46673)({
                    projectStore: p.projectStore,
                    getProject: p.getProject,
                    applyUncommitted: _this.applyUncommitted,
                    onOpen: p.onOpenBrowserStorage,
                    onStored: function() {
                        return p.onStoredToBrowserStorage();
                    }
                });
                (0, $7jh4K.css)(_this.browserStorageUi.getElement(), {
                    margin: '10px'
                });
            } else {
                var header = new (0, $959a92a71fa952f2$export$852ebaa1b01c8b5a)();
                browserStorageFallbackEl = (0, $eWjiX.BB).el({
                    content: [
                        header.getElement(),
                        (0, $eWjiX.BB).el({
                            content: "\uD83D\uDD34 " + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-cant-access'),
                            css: {
                                marginTop: '10px'
                            }
                        })
                    ],
                    css: {
                        margin: '10px 10px 0 10px'
                    }
                });
            }
            var saveRow = (0, $eWjiX.BB).el({
                content: [
                    (0, $eWjiX.BB).el({
                        content: [
                            saveButton,
                            exportTypeSelect.getElement()
                        ],
                        css: {
                            display: 'flex',
                            gap: '10px'
                        }
                    })
                ].concat((0, $bX4ja._)(canShowSaveDialog ? [
                    saveDialogCheckbox.getElement()
                ] : [])),
                css: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                    margin: '10px 10px 0 10px'
                }
            });
            // --- recovery ---
            _this.klRecoveryManager = p.klRecoveryManager;
            var recoveryWrapper = (0, $eWjiX.BB).el({});
            _this.recoveryCountBubble = (0, $eWjiX.BB).el({
                className: $34d04701a8a02997$export$bd7a7a9fa7e7f04b
            });
            var recoveryBrowserButton = (0, $eWjiX.BB).el({
                tagName: 'button',
                content: [
                    (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-recovery-recover-tabs'),
                    _this.recoveryCountBubble
                ],
                onClick: function() {
                    return (0, $890b23f3a39679d3$export$abc0e2c9b0afece1)(_this.klRecoveryManager);
                },
                custom: {
                    tabIndex: '-1'
                },
                css: {
                    margin: '10px 0 0 10px',
                    width: 'calc(100% - 20px)'
                }
            });
            recoveryWrapper.append(recoveryBrowserButton, $775b09ee76e7cc3e$var$createSpacer());
            (function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!this.klRecoveryManager) return [
                                    2
                                ];
                                this.klRecoveryManager.subscribe(this.recoveryListener);
                                return [
                                    4,
                                    this.klRecoveryManager.update()
                                ];
                            case 1:
                                _state.sent();
                                this.klRecoveryManager.unsubscribe(this.recoveryListener);
                                return [
                                    2
                                ];
                        }
                    });
                }).call(_this);
            })();
            // --- upload, share ---
            var shareButton = (0, $eWjiX.BB).el({
                tagName: 'button',
                className: 'grid-button',
                content: $775b09ee76e7cc3e$var$createButtonContent((0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-share'), (0, (/*@__PURE__*/$parcel$interopDefault($680b545dae725a15$exports)))),
                custom: {
                    tabIndex: '-1'
                },
                css: {
                    cssFloat: 'left'
                },
                onClick: function() {
                    shareButton.disabled = true;
                    p.onShareImage(function() {
                        shareButton.disabled = false;
                    });
                }
            });
            var uploadImgurButton = (0, $eWjiX.BB).el({
                tagName: 'button',
                className: 'grid-button',
                content: $775b09ee76e7cc3e$var$createButtonContent((0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-upload'), (0, (/*@__PURE__*/$parcel$interopDefault($f596c98d53b60fa1$exports)))),
                custom: {
                    tabIndex: '-1'
                },
                css: {
                    cssFloat: 'left'
                },
                onClick: function() {
                    p.onUpload();
                }
            });
            (0, $eWjiX.BB).append(_this.rootEl, [
                saveNote,
                newButton,
                importButton,
                (0, $eWjiX.BB).el({
                    css: {
                        clear: 'both'
                    }
                }),
                saveRow,
                $775b09ee76e7cc3e$var$createSpacer(),
                (_this_browserStorageUi = _this.browserStorageUi) === null || _this_browserStorageUi === void 0 ? void 0 : _this_browserStorageUi.getElement(),
                browserStorageFallbackEl,
                $775b09ee76e7cc3e$var$createSpacer(),
                recoveryWrapper,
                uploadImgurButton,
                (0, $eWjiX.BB).canShareFiles() ? shareButton : undefined,
                (0, $eWjiX.BB).el({
                    css: {
                        clear: 'both'
                    }
                })
            ]);
        };
        setTimeout(asyncCreation, 1);
    }
    (0, $7h4XF._)(FileUi, [
        {
            key: "refresh",
            value: function refresh() {}
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "setIsVisible",
            value: function setIsVisible(isVisible) {
                if (isVisible) {
                    var _this_browserStorageUi;
                    this.refresh();
                    (_this_browserStorageUi = this.browserStorageUi) === null || _this_browserStorageUi === void 0 ? void 0 : _this_browserStorageUi.show();
                    if (this.klRecoveryManager) {
                        this.klRecoveryManager.subscribe(this.recoveryListener);
                        this.klRecoveryManager.update();
                    }
                } else if (this.klRecoveryManager) this.klRecoveryManager.unsubscribe(this.recoveryListener);
            }
        },
        {
            key: "triggerImport",
            value: function triggerImport() {
                this.importInput && this.importInput.click();
            }
        }
    ]);
    return FileUi;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $8N5YG = parcelRequire("8N5YG");

var $eWjiX = parcelRequire("eWjiX");



var $eWjiX = parcelRequire("eWjiX");
function $8501a2e1e79821a9$export$d731e22ecd0c25d3(shader, uniforms, textureIn, textureOut) {
    (textureIn || this._.texture).use();
    this._.spareTexture.drawTo(function() {
        shader.uniforms(uniforms).drawRect();
    });
    this._.spareTexture.swapWith(textureOut || this._.texture);
}



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $8N5YG = parcelRequire("8N5YG");
var $deb6b884ba4ae312$export$5822a9d0880a5d82;
function $deb6b884ba4ae312$export$b59c6427db8463f4(newGl) {
    // more problems setting type to null
    $deb6b884ba4ae312$export$5822a9d0880a5d82 = newGl;
}



var $eWjiX = parcelRequire("eWjiX");
var $e0143068cd462268$var$defaultVertexSource = '\
    attribute vec2 vertex;\
    attribute vec2 _texCoord;\
    varying vec2 texCoord;\
    void main() {\
        texCoord = _texCoord;\
        gl_Position = vec4(vertex * 2.0 - 1.0, 0.0, 1.0);\
    }';
var $e0143068cd462268$var$defaultFragmentSource = '\
    uniform sampler2D texture;\
    varying vec2 texCoord;\
    void main() {\
        gl_FragColor = texture2D(texture, texCoord);\
    }';
function $e0143068cd462268$var$isArray(obj) {
    return Object.prototype.toString.call(obj) == '[object Array]';
}
function $e0143068cd462268$var$isNumber(obj) {
    return Object.prototype.toString.call(obj) == '[object Number]';
}
var $e0143068cd462268$var$floatPrecision;
var $e0143068cd462268$export$7d9b0d118d0c4108 = /*#__PURE__*/ function() {
    "use strict";
    function FxShader(vertexSource, fragmentSource, nameStr) {
        (0, $cx0mh._)(this, FxShader);
        this.vertexAttribute = null;
        this.texCoordAttribute = null;
        this.program = (0, $eWjiX.BB).throwIfNull((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).createProgram());
        vertexSource = vertexSource || $e0143068cd462268$var$defaultVertexSource;
        fragmentSource = fragmentSource || $e0143068cd462268$var$defaultFragmentSource;
        if (!$e0143068cd462268$var$floatPrecision) $e0143068cd462268$var$floatPrecision = this.testPrecisionSupport((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).HIGH_FLOAT) ? 'highp' : this.testPrecisionSupport((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).MEDIUM_FLOAT) ? 'mediump' : 'lowp';
        fragmentSource = 'precision ' + $e0143068cd462268$var$floatPrecision + ' float;' + fragmentSource; // annoying requirement is annoying
        (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).attachShader(this.program, this.compileSource((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).VERTEX_SHADER, vertexSource, nameStr + '(vertex)'));
        (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).attachShader(this.program, this.compileSource((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).FRAGMENT_SHADER, fragmentSource, nameStr + '(fragment)'));
        (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).linkProgram(this.program);
        if (!(0, $deb6b884ba4ae312$export$5822a9d0880a5d82).getProgramParameter(this.program, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).LINK_STATUS)) throw 'link error: ' + (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).getProgramInfoLog(this.program);
    }
    (0, $7h4XF._)(FxShader, [
        {
            key: "compileSource",
            value: // ---- private ----
            function compileSource(type, source, nameStr) {
                var shader = (0, $eWjiX.BB).throwIfNull((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).createShader(type));
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).shaderSource(shader, source.replace(/#define.*/, '')); // glslify adds a line add the beginning that breaks it
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).compileShader(shader);
                if (!(0, $deb6b884ba4ae312$export$5822a9d0880a5d82).getShaderParameter(shader, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).COMPILE_STATUS)) throw 'compile error: ' + nameStr + ' - ' + (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).getShaderInfoLog(shader);
                return shader;
            }
        },
        {
            key: "testPrecisionSupport",
            value: /**
     * HIGH_FLOAT | MEDIUM_FLOAT
     */ function testPrecisionSupport(precisionType) {
                var format = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).getShaderPrecisionFormat((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).FRAGMENT_SHADER, precisionType);
                return format !== null && format.precision !== 0;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).deleteProgram(this.program);
                this.program = null;
            }
        },
        {
            key: "uniforms",
            value: function uniforms(uniforms) {
                var _this = this;
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).useProgram(this.program);
                Object.entries(uniforms).forEach(function(param) {
                    var _param = (0, $8N5YG._)(param, 2), name = _param[0], value = _param[1];
                    var location = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).getUniformLocation(_this.program, name);
                    if (location === null) // will be null if the uniform isn't used in the shader
                    return;
                    if ($e0143068cd462268$var$isArray(value)) switch(value.length){
                        case 1:
                            (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).uniform1fv(location, new Float32Array(value));
                            break;
                        case 2:
                            (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).uniform2fv(location, new Float32Array(value));
                            break;
                        case 3:
                            (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).uniform3fv(location, new Float32Array(value));
                            break;
                        case 4:
                            (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).uniform4fv(location, new Float32Array(value));
                            break;
                        case 9:
                            (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).uniformMatrix3fv(location, false, new Float32Array(value));
                            break;
                        case 16:
                            (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).uniformMatrix4fv(location, false, new Float32Array(value));
                            break;
                        default:
                            throw 'don\'t know how to load uniform "' + name + '" of length ' + value.length;
                    }
                    else if ($e0143068cd462268$var$isNumber(value)) (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).uniform1f(location, value);
                    else throw 'attempted to set uniform "' + name + '" to invalid value ' + (value || 'undefined').toString();
                });
                // allow chaining
                return this;
            }
        },
        {
            //
            /**
     * textures are uniforms too but for some reason can't be specified by gl.uniform1f,
     * even though floating point numbers represent the integers 0 through 7 exactly
     */ key: "textures",
            value: function textures(textures) {
                var _this = this;
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).useProgram(this.program);
                Object.entries(textures).forEach(function(param) {
                    var _param = (0, $8N5YG._)(param, 2), name = _param[0], value = _param[1];
                    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).uniform1i((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).getUniformLocation(_this.program, name), value);
                });
                // allow chaining
                return this;
            }
        },
        {
            key: "drawRect",
            value: function drawRect(left, top, right, bottom) {
                var undefined;
                var viewport = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).getParameter((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).VIEWPORT);
                top = top !== undefined ? (top - viewport[1]) / viewport[3] : 0;
                left = left !== undefined ? (left - viewport[0]) / viewport[2] : 0;
                right = right !== undefined ? (right - viewport[0]) / viewport[2] : 1;
                bottom = bottom !== undefined ? (bottom - viewport[1]) / viewport[3] : 1;
                if ((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).vertexBuffer === undefined || (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).vertexBuffer === null) (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).vertexBuffer = (0, $eWjiX.BB).throwIfNull((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).createBuffer());
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bindBuffer((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).ARRAY_BUFFER, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).vertexBuffer);
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bufferData((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).ARRAY_BUFFER, new Float32Array([
                    left,
                    top,
                    left,
                    bottom,
                    right,
                    top,
                    right,
                    bottom
                ]), (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).STATIC_DRAW);
                if ((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).texCoordBuffer == null) {
                    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).texCoordBuffer = (0, $eWjiX.BB).throwIfNull((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).createBuffer());
                    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bindBuffer((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).ARRAY_BUFFER, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).texCoordBuffer);
                    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bufferData((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).ARRAY_BUFFER, new Float32Array([
                        0,
                        0,
                        0,
                        1,
                        1,
                        0,
                        1,
                        1
                    ]), (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).STATIC_DRAW);
                }
                if (this.vertexAttribute == null) {
                    this.vertexAttribute = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).getAttribLocation(this.program, 'vertex');
                    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).enableVertexAttribArray(this.vertexAttribute);
                }
                if (this.texCoordAttribute == null) {
                    this.texCoordAttribute = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).getAttribLocation(this.program, '_texCoord');
                    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).enableVertexAttribArray(this.texCoordAttribute);
                }
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).useProgram(this.program);
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bindBuffer((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).ARRAY_BUFFER, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).vertexBuffer);
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).vertexAttribPointer(this.vertexAttribute, 2, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).FLOAT, false, 0, 0);
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bindBuffer((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).ARRAY_BUFFER, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).texCoordBuffer);
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).vertexAttribPointer(this.texCoordAttribute, 2, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).FLOAT, false, 0, 0);
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).drawArrays((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TRIANGLE_STRIP, 0, 4);
            }
        }
    ], [
        {
            key: "getDefaultShader",
            value: // ---- static ----
            function getDefaultShader() {
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).defaultShader = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).defaultShader || new FxShader();
                return (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).defaultShader;
            }
        }
    ]);
    return FxShader;
}();



var $c50d7229cf0a789e$export$6408eeb1703e74b8 = function brightnessContrast(brightness, contrast) {
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).brightnessContrast = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).brightnessContrast || new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform float brightness;\
        uniform float contrast;\
        varying vec2 texCoord;\
        void main() {\
            vec4 color = texture2D(texture, texCoord);\
            color.rgb += brightness;\
            if (contrast > 0.0) {\
                color.rgb = (color.rgb - 0.5) / (1.0 - contrast) + 0.5;\
            } else {\
                color.rgb = (color.rgb - 0.5) * (1.0 + contrast) + 0.5;\
            }\
            gl_FragColor = clamp(color, 0.0, 1.0);\
        }\
    ', 'brightnessContrast');
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).brightnessContrast, {
        brightness: (0, $eWjiX.BB).clamp(brightness, -1, 1),
        contrast: (0, $eWjiX.BB).clamp(contrast, -1, 1)
    });
    return this;
};





var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");


var $eWjiX = parcelRequire("eWjiX");
var $80392da2a95619fd$export$7e6fd232cff50dd1 = /*#__PURE__*/ function() {
    "use strict";
    function FxTexture(width, height, format, type) {
        (0, $cx0mh._)(this, FxTexture);
        this.gl = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82);
        this.id = (0, $eWjiX.BB).throwIfNull((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).createTexture());
        this.width = width;
        this.height = height;
        this.format = format;
        this.type = type;
        this.canvas = null;
        (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bindTexture((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
        (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).texParameteri((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_MAG_FILTER, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).LINEAR);
        (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).texParameteri((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_MIN_FILTER, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).LINEAR);
        (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).texParameteri((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_WRAP_S, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).CLAMP_TO_EDGE);
        (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).texParameteri((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_WRAP_T, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).CLAMP_TO_EDGE);
        if (width && height) (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).texImage2D((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, 0, this.format, width, height, 0, this.format, this.type, null);
    }
    (0, $7h4XF._)(FxTexture, [
        {
            key: "loadContentsOf",
            value: function loadContentsOf(element) {
                this.width = element.width || element.videoWidth;
                this.height = element.height || element.videoHeight;
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bindTexture((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).texImage2D((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, 0, this.format, this.format, this.type, element);
            }
        },
        {
            key: "initFromBytes",
            value: function initFromBytes(width, height, data) {
                this.width = width;
                this.height = height;
                this.format = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).RGBA;
                this.type = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).UNSIGNED_BYTE;
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bindTexture((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).texImage2D((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, 0, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).RGBA, width, height, 0, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).RGBA, this.type, new Uint8Array(data));
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).deleteTexture(this.id);
                this.id = null;
            }
        },
        {
            key: "use",
            value: function use(unit) {
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).activeTexture((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE0 + (unit || 0));
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bindTexture((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
            }
        },
        {
            key: "unuse",
            value: function unuse(unit) {
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).activeTexture((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE0 + (unit || 0));
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bindTexture((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, null);
            }
        },
        {
            key: "ensureFormat",
            value: function ensureFormat(width, height, format, type) {
                // change the format only if required
                if (width != this.width || height != this.height || format != this.format || type != this.type) {
                    this.width = width;
                    this.height = height;
                    this.format = format;
                    this.type = type;
                    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bindTexture((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, this.id);
                    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).texImage2D((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, 0, this.format, width, height, 0, this.format, this.type, null);
                }
            }
        },
        {
            key: "ensureFormatViaTexture",
            value: function ensureFormatViaTexture(texture) {
                this.ensureFormat(texture.width, texture.height, texture.format, texture.type);
            }
        },
        {
            key: "drawTo",
            value: function drawTo(callback) {
                // start rendering to this texture
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).framebuffer = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).framebuffer || (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).createFramebuffer();
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bindFramebuffer((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).FRAMEBUFFER, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).framebuffer);
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).framebufferTexture2D((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).FRAMEBUFFER, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).COLOR_ATTACHMENT0, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).TEXTURE_2D, this.id, 0);
                if ((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).checkFramebufferStatus((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).FRAMEBUFFER) !== (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).FRAMEBUFFER_COMPLETE) throw new Error('incomplete framebuffer');
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).viewport(0, 0, this.width, this.height);
                // do the drawing
                callback();
                // stop rendering to this texture
                (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).bindFramebuffer((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).FRAMEBUFFER, null);
            }
        },
        {
            /*
    // never seen this being used
    fillUsingCanvas (callback: (canvas: CanvasRenderingContext2D) => void): Texture {
        callback(this.getCanvas(this));
        this.format = gl.RGBA;
        this.type = gl.UNSIGNED_BYTE;
        gl.bindTexture(gl.TEXTURE_2D, this.id);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, this.canvas);
        return this;
    }

    // never seen this being used
    toImage (image: HTMLImageElement): void {
        this.use();
        Shader.getDefaultShader().drawRect();
        const size = this.width * this.height * 4;
        const pixels = new Uint8Array(size);
        const c = this.getCanvas(this);
        const data = c.createImageData(this.width, this.height);
        gl.readPixels(0, 0, this.width, this.height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
        for (let i = 0; i < size; i++) {
            data.data[i] = pixels[i];
        }
        c.putImageData(data, 0, 0);
        image.src = this.canvas.toDataURL();
    }
     */ key: "swapWith",
            value: function swapWith(other) {
                var temp;
                temp = other.id;
                other.id = this.id;
                this.id = temp;
                temp = other.width;
                other.width = this.width;
                this.width = temp;
                temp = other.height;
                other.height = this.height;
                this.height = temp;
                temp = other.format;
                other.format = this.format;
                this.format = temp;
            // type?
            }
        }
    ], [
        {
            key: "fromElement",
            value: // ---- static ----
            function fromElement(element) {
                var texture = new FxTexture(0, 0, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).RGBA, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).UNSIGNED_BYTE);
                texture.loadContentsOf(element);
                return texture;
            }
        }
    ]);
    return FxTexture;
}();



var $eWjiX = parcelRequire("eWjiX");
function $d747444e26286abc$export$4f237735eca1f248(points) {
    var interpolator = new (0, $eWjiX.BB).SplineInterpolator(points);
    var array = [];
    for(var i = 0; i < 256; i++)array.push((0, $eWjiX.BB).clamp(Math.floor(interpolator.interpolate(i / 255) * 256), 0, 255));
    return array;
}





var $7480e3ce85bc65db$export$6894093bf294bea5 = function curves(red, green, blue) {
    // Create the ramp texture
    var redRamp = (0, $d747444e26286abc$export$4f237735eca1f248)(red);
    var greenRamp = (0, $d747444e26286abc$export$4f237735eca1f248)(green);
    var blueRamp = (0, $d747444e26286abc$export$4f237735eca1f248)(blue);
    var array = [];
    for(var i = 0; i < 256; i++)array.splice(array.length, 0, redRamp[i], greenRamp[i], blueRamp[i], 255);
    this._.extraTexture.initFromBytes(256, 1, array);
    this._.extraTexture.use(1);
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).curves = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).curves || new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform sampler2D map;\
        varying vec2 texCoord;\
        void main() {\
            vec4 color = texture2D(texture, texCoord);\
            color.r = texture2D(map, vec2(color.r)).r;\
            color.g = texture2D(map, vec2(color.g)).g;\
            color.b = texture2D(map, vec2(color.b)).b;\
            gl_FragColor = color;\
        }\
    ', 'curves');
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).curves.textures({
        map: 1
    });
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).curves, {});
    return this;
};






var $eWjiX = parcelRequire("eWjiX");
var $6dd7d8fac84d64b7$export$ef28bbbd731e79bf = function hueSaturation(hue, saturation) {
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).hueSaturation = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).hueSaturation || new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform float hue;\
        uniform float saturation;\
        varying vec2 texCoord;\
        void main() {\
            vec4 color = texture2D(texture, texCoord);\
            \
            /* hue adjustment, wolfram alpha: RotationTransform[angle, {1, 1, 1}][{x, y, z}] */\
            float angle = hue * 3.14159265;\
            float s = sin(angle), c = cos(angle);\
            vec3 weights = (vec3(2.0 * c, -sqrt(3.0) * s - c, sqrt(3.0) * s - c) + 1.0) / 3.0;\
            float len = length(color.rgb);\
            color.rgb = vec3(\
                dot(color.rgb, weights.xyz),\
                dot(color.rgb, weights.zxy),\
                dot(color.rgb, weights.yzx)\
            );\
            \
            /* saturation adjustment */\
            float average = (color.r + color.g + color.b) / 3.0;\
            if (saturation > 0.0) {\
                color.rgb += (average - color.rgb) * (1.0 - 1.0 / (1.001 - saturation));\
            } else {\
                color.rgb += (average - color.rgb) * (-saturation);\
            }\
            \
            gl_FragColor = color;\
        }\
    ', 'hueSaturation');
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).hueSaturation, {
        hue: (0, $eWjiX.BB).clamp(hue, -1, 1),
        saturation: (0, $eWjiX.BB).clamp(saturation, -1, 1)
    });
    return this;
};





var $2d6d66f95a729b73$exports = {};
$2d6d66f95a729b73$exports = "#define GLSLIFY 1\nuniform sampler2D texture;\nvarying vec2 texCoord;\nuniform vec2 texSize;\n\nuniform float seed;\nuniform float type;\nuniform vec2 scale;\nuniform vec2 offset;\nuniform float octaves;\nuniform float samples;\n\nuniform float peaks;\nuniform float contrast;\nuniform float brightness;\nuniform float isReversed;\n\nuniform vec3 colA;\nuniform vec3 colB;\n\nuniform float channels; // 0 - rgb, 1 - alpha\n\n// fbm, cellular_noise based on\n// https://github.com/Gonkee/Gonkees-Shaders\n// MIT, Copyright \xa9 Gonkee\n\n// hash & simplex based on\n// https://www.shadertoy.com/view/Msf3WH\n// MIT, Copyright \xa9 2013 Inigo Quilez\n// https://www.youtube.com/c/InigoQuilez\n// https://iquilezles.org\n\nfloat rand(vec2 co) {\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nfloat value_noise(vec2 coord){\n    return rand(floor(coord) / 100.0);\n}\n\nfloat cellular_noise(vec2 coord) {\n    vec2 i = floor(coord);\n    vec2 f = fract(coord);\n\n    float min_dist = 99999.0;\n    for (float x = -1.0; x <= 1.0; x++) {\n        for (float y = -1.0; y <= 1.0; y++) {\n            vec2 node = rand(i + vec2(x, y)) + vec2(x, y);\n            float dist = sqrt((f - node).x * (f - node).x + (f - node).y * (f - node).y);\n            min_dist = min(min_dist, dist);\n        }\n    }\n    return min_dist;\n}\n\n// ---------- Simplex Alternative ---------------------\n\nvec3 hash(vec3 p)\n{ p=vec3(dot(p, vec3(127.1, 311.7, 74.7))\n, dot(p, vec3(269.5, 183.3, 246.1))\n, dot(p, vec3(113.5, 271.9, 124.6)))\n;return fract(sin(p)*43758.5453123)*2.-1.; }\n\nmat3 hash(mat3 p)\n{ return mat3(hash(p[0]), hash(p[1]), hash(p[2])); }\n\nvec3 dots(mat3 a, vec3 w, mat3 b){ return vec3\n(dot(a[0], w-b[0]), dot(a[1], w-b[1]), dot(a[2], w-b[2])); }\n\n//return noiseGra13dx as .x, and its derivatives as .yzw\n// https://www.shadertoy.com/view/llByD1\nvec3 noiseGra13dx(in vec3 x) {\n    vec3 p=floor(x), w=fract(x)\n    #if 1\n    , u=w*w*w*(w*(w*6.-15.)+10.), v=30.*w*w*(w*(w-2.)+1.)//quintic hermite\n    #else\n    , u=w*w*(3.-2.*w), v=6.*w*(1.-w)//cubic hermite\n    #endif\n    //gradients\n    , G=hash(p+vec3(0)), F=hash(p+vec3(1))\n    ;mat3 D=hash(mat3(p, p, p)+mat3(1)), E=hash(mat3(p, p, p)+1.-mat3(1));\n    //projections\n    vec3 d=dots(D, w, mat3(1)), e=dots(E, w, 1.-mat3(1));\n    //interpolations\n    float g=dot(G, w), f=dot(F, w-vec3(1));\n    vec3 h=u.yzx*(g-d.xyx-d.yzz+e.zxy)+d-g, U=u*h, a=d-e;\n    mat3 S=D-mat3(G, G, G), W=D-E;\n    a.x=(a.x+a.y+a.z)+f-g;\n    ;float b=u.x*u.y*u.z;\n\n    vec4 result = vec4(g+U.x+U.y+U.z+a.x*b// value\n    , G*(1.-b)+b*(W[0]+W[1]+W[2]+F)//https://www.shadertoy.com/view/llByD1\n    +u.x*(S[0]+u.y*(G-D[0]-D[1]+E[2]))// derivatives\n    +u.y*(S[1]+u.z*(G-D[1]-D[2]+E[0]))\n    +u.z*(S[2]+u.x*(G-D[0]-D[2]+E[1]))\n    +v*(u.zxy*(g-d.xxy-d.zyz+e.yzx)+h+u.yzx*u.zxy*a.x));\n    return 0.5 + 0.5 * result.xxx;\n}\n\nfloat fbm(vec2 coord) {\n    float normalize_factor = 0.0;\n    float value = 0.0;\n    float scale = 0.5;\n\n    for (float i = 0.0; i < 7.0; i++){\n        if (i < octaves) {\n            if (type == 0.0) {\n                value += value_noise(coord) * scale;\n            } else if (type == 1.0) {\n                value += noiseGra13dx(vec3(coord.x, coord.y, 0.0)).r * scale;\n            } else if (type == 2.0) {\n                value += cellular_noise(coord) * scale;\n            }\n            normalize_factor += scale;\n            coord *= 2.0;\n            scale *= 0.5;\n        }\n    }\n    return value / normalize_factor;\n}\n\nfloat render (vec2 pos) {\n    float result = fbm(pos);\n    //\n\n    if (peaks > 0.0) {\n        result = abs(mod(result * peaks - 0.5, 1.0) - 0.5) * 2.0;// triangle\n        //result = mod(result * (peaks + 1.0), 1.0); // sawtooth\n    }\n\n    result += brightness;\n    if (contrast > 0.0) {\n        result = clamp((result - 0.5) / (1.0 - contrast) + 0.5, 0.0, 1.0);\n    } else if (contrast < 0.0) {\n        result = clamp((result - 0.5) * (1.0 + contrast) + 0.5, 0.0, 1.0);\n    }\n\n    if (isReversed == 1.0) {\n        result = 1.0 - result;\n    }\n    return result;\n}\n\nvoid main() {\n    vec4 color;\n\n    vec2 seedOffset;\n    seedOffset.x = (rand(vec2(seed, 0.0)) * 100.0 - 50.0);\n    seedOffset.y = (rand(vec2(0.0, seed)) * 100.0 - 50.0);\n\n    float val = 0.0;\n    vec2 basePos = texCoord * texSize / scale - offset / scale + seedOffset;\n\n    if (samples == 1.0) {\n        val = render(basePos);\n\n    }/* else if (samples == 4.0) {\n        for (float i = 0.0; i < 2.0; i++) {\n            for (float e = 0.0; e < 2.0; e++) {\n                val += render(basePos + (vec2(i, e) - 0.5) * 0.5 / scale);\n            }\n        }\n        val /= 4.0;\n\n    }*/ else if (samples == 16.0) {\n        for (float i = 0.0; i < 4.0; i++) {\n            for (float e = 0.0; e < 4.0; e++) {\n                val += render(basePos + (vec2(i, e) - 0.25) * 0.25 / scale);\n            }\n        }\n        val /= 16.0;\n    }\n\n    if (channels == 0.0) {\n        gl_FragColor = vec4(vec3(mix(colA, colB, val)), 1.0);\n    } else {\n        gl_FragColor = vec4(vec3(1.0), val);\n    }\n}";


var $dd5d88e299e80db3$export$d3022aad56692482 = function noise(seed, type, scale, offset, octaves, samples, peaks, brightness, contrast, isReversed, colA, colB, channels) {
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).noise = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).noise || new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, (0, (/*@__PURE__*/$parcel$interopDefault($2d6d66f95a729b73$exports))).replace(/#define.*/, ''), 'noise');
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).noise, {
        seed: seed || 0,
        type: type,
        scale: [
            scale[0],
            scale[1]
        ],
        offset: offset,
        octaves: octaves,
        samples: samples,
        texSize: [
            this.width,
            this.height
        ],
        peaks: peaks,
        brightness: brightness,
        contrast: contrast,
        isReversed: isReversed ? 1.0 : 0.0,
        colA: colA ? [
            colA.r / 255,
            colA.g / 255,
            colA.b / 255
        ] : [
            0,
            0,
            0
        ],
        colB: colB ? [
            colB.r / 255,
            colB.g / 255,
            colB.b / 255
        ] : [
            1,
            1,
            1
        ],
        channels: channels === 'rgb' ? 0 : 1
    });
    return this;
};




// returns a random number between 0 and 1
var $904e6ba1142f7a16$export$af69f7ca07da04c9 = '\
    float random(vec3 scale, float seed) {\
        /* use the fragment position for a different seed per-pixel */\
        return fract(sin(dot(gl_FragCoord.xyz + seed, scale)) * 43758.5453 + seed);\
    }\
';



var $b01b186720ebdc8e$export$6e852234f1597a14 = function triangleBlur(radius) {
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).triangleBlur = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).triangleBlur || new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform vec2 delta;\
        varying vec2 texCoord;\
        ' + (0, $904e6ba1142f7a16$export$af69f7ca07da04c9) + '\
        void main() {\
            vec4 color = vec4(0.0);\
            float total = 0.0;\
            \
            /* randomize the lookup values to hide the fixed number of samples */\
            float offset = random(vec3(12.9898, 78.233, 151.7182), 0.0);\
            \
            for (float t = -30.0; t <= 30.0; t++) {\
                float percent = (t + offset - 0.5) / 30.0;\
                float weight = 1.0 - abs(percent);\
                vec4 sample = texture2D(texture, texCoord + delta * percent);\
                \
                color += sample * weight;\
                total += weight;\
            }\
            \
            gl_FragColor = color / total;\
        }\
    ', 'triangleBlur');
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).triangleBlur, {
        delta: [
            radius / this.width,
            0
        ]
    });
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).triangleBlur, {
        delta: [
            0,
            radius / this.height
        ]
    });
    return this;
};






var $1ec92859a97056c3$export$4545acb2b6bb8f22 = function tiltShift(startX, startY, endX, endY, blurRadius, gradientRadius) {
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).tiltShift = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).tiltShift || new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D texture;\
        uniform float blurRadius;\
        uniform float gradientRadius;\
        uniform vec2 start;\
        uniform vec2 end;\
        uniform vec2 delta;\
        uniform vec2 texSize;\
        varying vec2 texCoord;\
        ' + (0, $904e6ba1142f7a16$export$af69f7ca07da04c9) + '\
        void main() {\
            vec4 color = vec4(0.0);\
            float total = 0.0;\
            \
            /* randomize the lookup values to hide the fixed number of samples */\
            float offset = random(vec3(12.9898, 78.233, 151.7182), 0.0);\
            \
            vec2 normal = normalize(vec2(start.y - end.y, end.x - start.x));\
            float radius = smoothstep(0.0, 1.0, abs(dot(texCoord * texSize - start, normal)) / gradientRadius) * blurRadius;\
            for (float t = -30.0; t <= 30.0; t++) {\
                float percent = (t + offset - 0.5) / 30.0;\
                float weight = 1.0 - abs(percent);\
                vec4 sample = texture2D(texture, texCoord + delta / texSize * percent * radius);\
                \
                color += sample * weight;\
                total += weight;\
            }\
            \
            gl_FragColor = color / total;\
        }\
    ', 'tiltShift');
    var dx = endX - startX;
    var dy = endY - startY;
    var d = Math.sqrt(dx * dx + dy * dy);
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).tiltShift, {
        blurRadius: blurRadius,
        gradientRadius: gradientRadius,
        start: [
            startX,
            startY
        ],
        end: [
            endX,
            endY
        ],
        delta: [
            dx / d,
            dy / d
        ],
        texSize: [
            this.width,
            this.height
        ]
    });
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).tiltShift, {
        blurRadius: blurRadius,
        gradientRadius: gradientRadius,
        start: [
            startX,
            startY
        ],
        end: [
            endX,
            endY
        ],
        delta: [
            -dy / d,
            dx / d
        ],
        texSize: [
            this.width,
            this.height
        ]
    });
    return this;
};




function $1d7339974b05a229$export$820b3a44cb7b2b21(uniformsStr, warpStr) {
    return new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, uniformsStr + '\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    void main() {\
        vec2 coord = texCoord * texSize;\
        ' + warpStr + '\
        gl_FragColor = texture2D(texture, coord / texSize);\
        vec2 clampedCoord = clamp(coord, vec2(0.0), texSize);\
        if (coord != clampedCoord) {\
            /* fade to transparent if we are outside the image */\
            gl_FragColor.a *= max(0.0, 1.0 - length(coord - clampedCoord));\
        }\
    }', 'warp');
}



function $303d8d4ec53c4881$export$1c447127d27d7be4(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx1 = x1 - x2;
    var dy1 = y1 - y2;
    var dx2 = x3 - x2;
    var dy2 = y3 - y2;
    var dx3 = x0 - x1 + x2 - x3;
    var dy3 = y0 - y1 + y2 - y3;
    var det = dx1 * dy2 - dx2 * dy1;
    var a = (dx3 * dy2 - dx2 * dy3) / det;
    var b = (dx1 * dy3 - dx3 * dy1) / det;
    return [
        x1 - x0 + a * x1,
        y1 - y0 + a * y1,
        a,
        x3 - x0 + b * x3,
        y3 - y0 + b * y3,
        b,
        x0,
        y0,
        1
    ];
}
function $303d8d4ec53c4881$export$68b3343017e80691(m) {
    var a = m[0], b = m[1], c = m[2];
    var d = m[3], e = m[4], f = m[5];
    var g = m[6], h = m[7], i = m[8];
    var det = a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    return [
        (e * i - f * h) / det,
        (c * h - b * i) / det,
        (b * f - c * e) / det,
        (f * g - d * i) / det,
        (a * i - c * g) / det,
        (c * d - a * f) / det,
        (d * h - e * g) / det,
        (b * g - a * h) / det,
        (a * e - b * d) / det
    ];
}
function $303d8d4ec53c4881$export$2060d2db72cce88f(a, b) {
    return [
        a[0] * b[0] + a[1] * b[3] + a[2] * b[6],
        a[0] * b[1] + a[1] * b[4] + a[2] * b[7],
        a[0] * b[2] + a[1] * b[5] + a[2] * b[8],
        a[3] * b[0] + a[4] * b[3] + a[5] * b[6],
        a[3] * b[1] + a[4] * b[4] + a[5] * b[7],
        a[3] * b[2] + a[4] * b[5] + a[5] * b[8],
        a[6] * b[0] + a[7] * b[3] + a[8] * b[6],
        a[6] * b[1] + a[7] * b[4] + a[8] * b[7],
        a[6] * b[2] + a[7] * b[5] + a[8] * b[8]
    ];
}


var $5b33fb39bf5722a9$export$a93b0222aeadc54b = function matrixWarp(matrix, inverse, useTextureSpace) {
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).matrixWarp = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).matrixWarp || (0, $1d7339974b05a229$export$820b3a44cb7b2b21)('\
        uniform mat3 matrix;\
        uniform bool useTextureSpace;\
    ', '\
        if (useTextureSpace) coord = coord / texSize * 2.0 - 1.0;\
        vec3 warp = matrix * vec3(coord, 1.0);\
        coord = warp.xy / warp.z;\
        if (useTextureSpace) coord = (coord * 0.5 + 0.5) * texSize;\
    ');
    // Flatten all members of matrix into one big list
    matrix = matrix.flat();
    // Extract a 3x3 matrix out of the arguments
    if (matrix.length == 4) matrix = [
        matrix[0],
        matrix[1],
        0,
        matrix[2],
        matrix[3],
        0,
        0,
        0,
        1
    ];
    else if (matrix.length != 9) throw 'can only warp with 2x2 or 3x3 matrix';
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).matrixWarp, {
        matrix: inverse ? (0, $303d8d4ec53c4881$export$68b3343017e80691)(matrix) : matrix,
        texSize: [
            this.width,
            this.height
        ],
        useTextureSpace: useTextureSpace ? 1 : 0
    });
    return this;
};





var $c6e0992c38eb55ab$export$915fb7313c578ba2 = function unsharpMask(radius, strength) {
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).unsharpMask = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).unsharpMask || new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, '\
        uniform sampler2D blurredTexture;\
        uniform sampler2D originalTexture;\
        uniform float strength;\
        uniform float threshold;\
        varying vec2 texCoord;\
        void main() {\
            vec4 blurred = texture2D(blurredTexture, texCoord);\
            vec4 original = texture2D(originalTexture, texCoord);\
            gl_FragColor = mix(blurred, original, 1.0 + strength);\
        }\
    ', 'unsharpMask');
    // Store a copy of the current texture in the second texture unit
    this._.extraTexture.ensureFormatViaTexture(this._.texture);
    this._.texture.use();
    this._.extraTexture.drawTo(function() {
        (0, $e0143068cd462268$export$7d9b0d118d0c4108).getDefaultShader().drawRect();
    });
    // Blur the current texture, then use the stored texture to detect edges
    this._.extraTexture.use(1);
    this.triangleBlur(radius);
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).unsharpMask.textures({
        originalTexture: 1
    });
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).unsharpMask, {
        strength: strength
    });
    this._.extraTexture.unuse(1);
    return this;
};





var $164716f3bce9dcdb$export$be1ee5ea42904fdc = function toAlpha(isInverted, replaceRGBA) {
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).toAlpha = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).toAlpha || new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, '\
    uniform bool isInverted;\
    uniform vec4 replace;\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    \
    void main() {\
        vec4 color = texture2D(texture, texCoord);\
        float alpha = (color.r + color.g + color.b) / 3.0;\
        if (isInverted) alpha = 1.0 - alpha;\
        alpha = min(color.a, alpha);\
        if (replace.a > 0.0) color = replace;\
        gl_FragColor = vec4(color.r, color.g, color.b, alpha);\
    }\
', 'toAlpha');
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).toAlpha, {
        isInverted: isInverted ? 1 : 0,
        replace: replaceRGBA ? [
            replaceRGBA.r / 255,
            replaceRGBA.g / 255,
            replaceRGBA.b / 255,
            replaceRGBA.a
        ] : [
            0,
            0,
            0,
            0
        ],
        texSize: [
            this.width,
            this.height
        ]
    });
    return this;
};





var $6fb892cfa80f1621$export$6897c284b6f9f4dc = function invert() {
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).invert = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).invert || new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, '\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    \
    void main() {\
        vec4 color = texture2D(texture, texCoord);\
        color.rgb = 1.0 - color.rgb;\
        gl_FragColor = color;\
    }\
', 'invert');
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).invert, {
        texSize: [
            this.width,
            this.height
        ]
    });
    return this;
};



var $bX4ja = parcelRequire("bX4ja");

var $4d16a2f492bd5d16$export$541149539f3a4684 = function perspective(before, after) {
    var a = (0, $303d8d4ec53c4881$export$1c447127d27d7be4).apply(void 0, (0, $bX4ja._)(after));
    var b = (0, $303d8d4ec53c4881$export$1c447127d27d7be4).apply(void 0, (0, $bX4ja._)(before));
    var c = (0, $303d8d4ec53c4881$export$2060d2db72cce88f)((0, $303d8d4ec53c4881$export$68b3343017e80691)(a), b);
    return this.matrixWarp(c);
};





var $34a2490457ff8aab$export$b324c80262feb891 = function unmultiplyAlpha() {
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).unmultiplyAlpha = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).unmultiplyAlpha || new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, '\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    \
    void main() {\
        vec4 color = texture2D(texture, texCoord);\
        if(color.a > 0.0) {\
            color.rgb /= color.a;\
        }\
        gl_FragColor = color;\
    }\
', 'unmultiplyAlpha');
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).unmultiplyAlpha, {
        texSize: [
            this.width,
            this.height
        ]
    });
    return this;
};





var $55618926ab99fefa$export$7c9b924528782480 = function distort(settings) {
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).distort = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).distort || (0, $1d7339974b05a229$export$820b3a44cb7b2b21)(`
    uniform float stepSize;
    uniform vec2 scale;
    uniform vec2 strength;
    uniform vec2 phase;
    uniform float type;
    uniform vec2 offset;
`, `
    const float PI = 3.14159265;
    float x = coord.x + offset.x;
    float y = coord.y + offset.y;
    if (stepSize > 1.0) {
        x = floor(x / stepSize) * stepSize;
        y = floor(y / stepSize) * stepSize;
    }
    float distortX = sin((x/scale.x + phase.x) * PI * 2.0) * strength.x;
    float distortY = sin((y/scale.y + phase.y) * PI * 2.0) * strength.y;
    if (type == 0.0) {
        coord.y += distortX;
        coord.x += distortY;
    } else if (type == 1.0) {
        coord.x += distortX;
        coord.y += distortY;
    } else if (type == 2.0) {
        x -= offset.x;
        y -= offset.y;
        gl_FragColor = texture2D(texture, vec2(x, y) / texSize);
        coord.y += sin(gl_FragColor.r/scale.x*200.0 + phase.x * PI * 2.0) * strength.x;
        coord.x += cos(gl_FragColor.g/scale.y*200.0 + phase.y * PI * 2.0) * strength.y;
    }
    coord.x = mod(coord.x, texSize.x);
    coord.y = mod(coord.y, texSize.y);
`);
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).distort, {
        stepSize: settings.stepSize,
        type: settings.distortType,
        scale: [
            settings.scale.x,
            settings.scale.y
        ],
        strength: [
            settings.strength.x,
            settings.strength.y
        ],
        phase: [
            settings.phase.x,
            settings.phase.y
        ],
        offset: [
            settings.offset.x,
            settings.offset.y
        ],
        texSize: [
            this.width,
            this.height
        ]
    });
    return this;
};





var $f157b4bc2111ecb8$export$57b05c961ff98d6a = function multiplyAlpha() {
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).multiplyAlpha = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).multiplyAlpha || new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, '\
    uniform sampler2D texture;\
    uniform vec2 texSize;\
    varying vec2 texCoord;\
    \
    void main() {\
        vec4 color = texture2D(texture, texCoord);\
        color.rgb *= color.a;\
        gl_FragColor = color;\
    }\
', 'multiplyAlpha');
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).multiplyAlpha, {
        texSize: [
            this.width,
            this.height
        ]
    });
    return this;
};



var $eWjiX = parcelRequire("eWjiX");



var $c7d207160ef493f6$export$d99f0801a68bbcf1 = function mask(maskTexture, originalTexture, premultiplyOriginal) {
    maskTexture._.use(1);
    if (originalTexture) originalTexture._.use(2);
    else {
        // should be faster than introducing a conditional in the shader
        this._.extraTexture.use(2);
        this._.extraTexture.initFromBytes(1, 1, [
            0,
            0,
            0,
            0
        ]);
    }
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).mask = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).mask || new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, `
        uniform sampler2D texture;
        uniform sampler2D mask;
        uniform sampler2D original;
        uniform bool premultiplyOriginal;
        varying vec2 texCoord;

        void main() {
            vec4 filteredCol = texture2D(texture, texCoord);
            vec4 originalCol = texture2D(original, texCoord);
            if (premultiplyOriginal) {
                originalCol.rgb *= originalCol.a;
            }
            float maskStrength = texture2D(mask, texCoord).r;
            gl_FragColor = mix(originalCol, filteredCol, maskStrength);
        }
        `, 'mask');
    (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).mask.textures({
        mask: 1,
        original: 2
    });
    (0, $8501a2e1e79821a9$export$d731e22ecd0c25d3).call(this, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).mask, {
        premultiplyOriginal: premultiplyOriginal ? 1 : 0
    });
    return this;
};


var $eeae469bfe7893fd$export$a04cfca62fd2892f = function() {
    function wrapTexture(texture) {
        return {
            _: texture,
            loadContentsOf: function loadContentsOf(element) {
                // Make sure that we're using the correct global WebGL context
                (0, $deb6b884ba4ae312$export$b59c6427db8463f4)(this._.gl);
                this._.loadContentsOf(element);
            },
            destroy: function destroy() {
                // Make sure that we're using the correct global WebGL context
                (0, $deb6b884ba4ae312$export$b59c6427db8463f4)(this._.gl);
                this._.destroy();
            }
        };
    }
    function texture(element) {
        return wrapTexture((0, $80392da2a95619fd$export$7e6fd232cff50dd1).fromElement(element));
    }
    function getTextureType() {
        var textureType = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).UNSIGNED_BYTE;
        // Go for floating point buffer textures if we can, it'll make the bokeh
        // filter look a lot better. Note that on Windows, ANGLE does not let you
        // render to a floating-point texture when linear filtering is enabled.
        // See http://crbug.com/172278 for more information.
        if ((0, $deb6b884ba4ae312$export$5822a9d0880a5d82).getExtension('WEBGL_color_buffer_float') && // firefox shows warning without this line
        (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).getExtension('OES_texture_float') && (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).getExtension('OES_texture_float_linear')) {
            var testTexture = new (0, $80392da2a95619fd$export$7e6fd232cff50dd1)(100, 100, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).RGBA, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).FLOAT);
            try {
                // Only use gl.FLOAT if we can render to it
                testTexture.drawTo(function() {
                    textureType = (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).FLOAT;
                });
            } catch (e) {
            /* empty */ }
            testTexture.destroy();
        }
        return textureType;
    }
    function initialize(width, height) {
        var textureType = getTextureType();
        if (this._.texture) this._.texture.destroy();
        if (this._.spareTexture) this._.spareTexture.destroy();
        this.width = width;
        this.height = height;
        this._.texture = new (0, $80392da2a95619fd$export$7e6fd232cff50dd1)(width, height, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).RGBA, textureType);
        this._.spareTexture = new (0, $80392da2a95619fd$export$7e6fd232cff50dd1)(width, height, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).RGBA, textureType);
        this._.extraTexture = this._.extraTexture || new (0, $80392da2a95619fd$export$7e6fd232cff50dd1)(0, 0, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).RGBA, textureType);
        this._.flippedShader = this._.flippedShader || new (0, $e0143068cd462268$export$7d9b0d118d0c4108)(null, `
uniform sampler2D texture;
varying vec2 texCoord;
void main() {
    gl_FragColor = texture2D(texture, vec2(texCoord.x, 1.0 - texCoord.y));
}
        `, 'flippedShader');
        this._.isInitialized = true;
    }
    function draw(texture, width, height) {
        if (!this._.isInitialized || texture._.width != this.width || texture._.height != this.height) initialize.call(this, width ? width : texture._.width, height ? height : texture._.height);
        texture._.use();
        this._.texture.drawTo(function() {
            (0, $e0143068cd462268$export$7d9b0d118d0c4108).getDefaultShader().drawRect();
        });
        return this;
    }
    function update() {
        this._.texture.use();
        this._.flippedShader.drawRect();
        return this;
    }
    function contents() {
        var texture = new (0, $80392da2a95619fd$export$7e6fd232cff50dd1)(this._.texture.width, this._.texture.height, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).RGBA, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).UNSIGNED_BYTE);
        this._.texture.use();
        texture.drawTo(function() {
            (0, $e0143068cd462268$export$7d9b0d118d0c4108).getDefaultShader().drawRect();
        });
        return wrapTexture(texture);
    }
    /*
       Get a Uint8 array of pixel values: [r, g, b, a, r, g, b, a, ...]
       Length of the array will be width * height * 4.
    */ function getPixelArray() {
        var w = this._.texture.width;
        var h = this._.texture.height;
        var array = new Uint8Array(w * h * 4);
        this._.texture.drawTo(function() {
            (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).readPixels(0, 0, w, h, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).RGBA, (0, $deb6b884ba4ae312$export$5822a9d0880a5d82).UNSIGNED_BYTE, array);
        });
        return array;
    }
    function wrap(fn) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            // Make sure that we're using the correct global WebGL context
            (0, $deb6b884ba4ae312$export$b59c6427db8463f4)(this._.gl);
            // Now that the context has been switched, we can call the wrapped function
            return fn.apply(this, args);
        };
    }
    function getWebGlContext(canvas, options) {
        var contextNames = [
            'webgl',
            'experimental-webgl',
            'webgl2'
        ];
        var context = null;
        contextNames.forEach(function(name) {
            if (context) return;
            // get.webgl.org does a try-catch
            try {
                context = canvas.getContext(name, options);
            } catch (e) {
            /* empty */ }
        });
        return context;
    }
    return function() {
        if (!window.WebGLRenderingContext) throw 'WebGLRenderingContext not set. Browser does not support WebGL.';
        var canvas = (0, $eWjiX.BB).canvas(1, 1);
        var context = getWebGlContext(canvas, {
            premultipliedAlpha: false
        });
        if (!context) throw 'This browser does not support WebGL';
        (0, $deb6b884ba4ae312$export$b59c6427db8463f4)(context);
        canvas._ = {
            gl: $deb6b884ba4ae312$export$5822a9d0880a5d82,
            isInitialized: false,
            texture: null,
            spareTexture: null,
            flippedShader: null
        };
        // Core methods
        canvas.texture = wrap(texture);
        canvas.initialize = wrap(initialize);
        canvas.draw = wrap(draw);
        canvas.update = wrap(update);
        canvas.contents = wrap(contents);
        canvas.getPixelArray = wrap(getPixelArray);
        // Filter methods
        canvas.brightnessContrast = wrap((0, $c50d7229cf0a789e$export$6408eeb1703e74b8));
        canvas.hueSaturation = wrap((0, $6dd7d8fac84d64b7$export$ef28bbbd731e79bf));
        canvas.triangleBlur = wrap((0, $b01b186720ebdc8e$export$6e852234f1597a14));
        canvas.unsharpMask = wrap((0, $c6e0992c38eb55ab$export$915fb7313c578ba2));
        canvas.perspective = wrap((0, $4d16a2f492bd5d16$export$541149539f3a4684));
        canvas.matrixWarp = wrap((0, $5b33fb39bf5722a9$export$a93b0222aeadc54b));
        canvas.tiltShift = wrap((0, $1ec92859a97056c3$export$4545acb2b6bb8f22));
        canvas.noise = wrap((0, $dd5d88e299e80db3$export$d3022aad56692482));
        canvas.curves = wrap((0, $7480e3ce85bc65db$export$6894093bf294bea5));
        canvas.invert = wrap((0, $6fb892cfa80f1621$export$6897c284b6f9f4dc));
        canvas.multiplyAlpha = wrap((0, $f157b4bc2111ecb8$export$57b05c961ff98d6a));
        canvas.unmultiplyAlpha = wrap((0, $34a2490457ff8aab$export$b324c80262feb891));
        canvas.toAlpha = wrap((0, $164716f3bce9dcdb$export$be1ee5ea42904fdc));
        canvas.distort = wrap((0, $55618926ab99fefa$export$7c9b924528782480));
        canvas.mask = wrap((0, $c7d207160ef493f6$export$d99f0801a68bbcf1));
        return canvas;
    };
}();


var $02a74dc72797630f$var$failed = false;
var $02a74dc72797630f$var$fx = null;
function $02a74dc72797630f$export$8c4423af32b21158() {
    // failed previously, don't need to try again.
    if ($02a74dc72797630f$var$failed) return $02a74dc72797630f$var$fx;
    if (!$02a74dc72797630f$var$fx || $02a74dc72797630f$var$fx._.gl.isContextLost()) try {
        $02a74dc72797630f$var$fx = (0, $eeae469bfe7893fd$export$a04cfca62fd2892f)();
    } catch (e) {
        $02a74dc72797630f$var$failed = true;
        $02a74dc72797630f$var$fx = null;
        setTimeout(function() {
            throw e;
        });
    }
    return $02a74dc72797630f$var$fx;
}





var $72Jv0 = parcelRequire("72Jv0");
var $9f0e53c75e472aaf$export$aeb1a0a0e64541b5 = /*#__PURE__*/ function() {
    "use strict";
    function EditUi(p) {
        (0, $cx0mh._)(this, EditUi);
        this.isInit = false;
        this.klRootEl = p.klRootEl;
        this.klColorSlider = p.klColorSlider;
        this.layersUi = p.layersUi;
        this.getCurrentColor = p.getCurrentColor;
        this.maxCanvasSize = p.maxCanvasSize;
        this.klCanvas = p.klCanvas;
        this.getCurrentLayer = p.getCurrentLayer;
        this.isEmbed = p.isEmbed;
        this.statusOverlay = p.statusOverlay;
        this.onCanvasChanged = p.onCanvasChanged;
        this.applyUncommitted = p.applyUncommitted;
        this.klHistory = p.klHistory;
        this.onCopyToClipboard = p.onCopyToClipboard;
        this.onPaste = p.onPaste;
        this.rootEl = (0, $eWjiX.BB).el();
    }
    (0, $7h4XF._)(EditUi, [
        {
            key: "testHasWebGL",
            value: function testHasWebGL() {
                return !!(0, $02a74dc72797630f$export$8c4423af32b21158)();
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                var filters = (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).FILTER_LIB;
                var buttons = [];
                if (!(0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).FILTER_LIB_STATUS.isLoaded) throw new Error('filters not loaded');
                var hasWebGL = this.testHasWebGL();
                if (!hasWebGL) {
                    var note = (0, $eWjiX.BB).el({
                        parent: this.rootEl,
                        className: 'kl-toolspace-note',
                        content: 'Features disabled because WebGL is failing.',
                        css: {
                            margin: '10px',
                            marginBottom: '0'
                        }
                    });
                    var noteButton = (0, $eWjiX.BB).el({
                        parent: note,
                        tagName: 'button',
                        textContent: 'Learn More',
                        css: {
                            marginLeft: '5px'
                        }
                    });
                    noteButton.onclick = function() {
                        (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                            message: '<b>WebGL is not working</b>',
                            div: (0, $eWjiX.BB).el({
                                content: `
See if your browser supports WebGL and has it enabled: <a href="https://get.webgl.org" target="_blank" rel="noopener noreferrer">get.webgl.org</a><br>
<br>
Recently (2023-05) a number of Chrome users on Chrome OS reported that WebGL fails, although it is enabled & supported.
This has been reported to Google.
`
                            }),
                            buttons: [
                                'Ok'
                            ],
                            clickOnEnter: 'Ok'
                        });
                    };
                }
                var createButton = function(filterKey) {
                    var filter = filters[filterKey];
                    var button = (0, $eWjiX.BB).el({
                        tagName: 'button',
                        className: 'grid-button grid-button--filter',
                        content: [
                            (0, $72Jv0.createImage)({
                                alt: 'icon',
                                src: filter.icon,
                                width: 18,
                                height: 20,
                                className: filter.darkNoInvert ? 'dark-no-invert' : '',
                                css: {
                                    marginRight: '3px'
                                }
                            }),
                            (0, $8d7403abedf7cefa$export$ce37e184d908d785)(filter.lang.button)
                        ],
                        css: {
                            lineHeight: '20px',
                            fontSize: '12px'
                        },
                        custom: {
                            tabIndex: '-1'
                        }
                    });
                    var filterName = (0, $8d7403abedf7cefa$export$ce37e184d908d785)(filter.lang.name);
                    var isEnabled = true;
                    if (filter.webGL && !hasWebGL) isEnabled = false;
                    if (isEnabled) button.onclick = function() {
                        _this.applyUncommitted();
                        var dialogButtons = [
                            'Ok',
                            'Cancel'
                        ];
                        var finishedDialog = function(result, filterDialog) {
                            if ('error' in filterDialog) return;
                            if (result == 'Cancel') {
                                if (filterDialog.destroy) filterDialog.destroy();
                                return;
                            }
                            var input;
                            try {
                                input = filterDialog.getInput(); // also destroys
                            } catch (e) {
                                if (e.message.indexOf('.getInput is not a function') !== -1) throw 'filterDialog.getInput is not a function, filter: ' + filterName;
                                else throw e;
                            }
                            applyFilter(input);
                        };
                        if (!('apply' in filters[filterKey])) {
                            (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                message: 'Application not fully loaded',
                                type: 'error'
                            });
                            return;
                        }
                        var applyFilter = function(input) {
                            var filterResult = filters[filterKey].apply({
                                layer: _this.getCurrentLayer(),
                                klCanvas: _this.klCanvas,
                                klHistory: _this.klHistory,
                                input: input
                            });
                            if (!filterResult) (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                message: "Couldn't apply the edit action",
                                type: 'error'
                            });
                            filters[filterKey].updatePos && _this.onCanvasChanged();
                            _this.layersUi.update();
                        };
                        if (filters[filterKey].isInstant) {
                            button.blur();
                            applyFilter(null);
                            _this.statusOverlay.out((0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-applied', {
                                x: filterName
                            }), true);
                        } else {
                            var secondaryColorRGB = _this.klColorSlider.getSecondaryRGB();
                            var filterDialog = undefined;
                            try {
                                filterDialog = filters[filterKey].getDialog({
                                    context: _this.getCurrentLayer().context,
                                    klCanvas: _this.klCanvas,
                                    maxWidth: _this.maxCanvasSize,
                                    maxHeight: _this.maxCanvasSize,
                                    currentColorRgb: {
                                        r: _this.getCurrentColor().r,
                                        g: _this.getCurrentColor().g,
                                        b: _this.getCurrentColor().b
                                    },
                                    secondaryColorRgb: {
                                        r: secondaryColorRGB.r,
                                        g: secondaryColorRGB.g,
                                        b: secondaryColorRGB.b
                                    },
                                    composed: _this.klHistory.getComposed()
                                });
                            } catch (e) {
                                setTimeout(function() {
                                    throw e;
                                });
                            }
                            if (!filterDialog || 'error' in filterDialog) {
                                (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                    message: filterDialog ? filterDialog.error : 'Error: Could not perform action.',
                                    type: 'error'
                                });
                                return;
                            }
                            var closeFunc;
                            // Todo should move into getDialogParams
                            filterDialog.errorCallback = function(e) {
                                (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                    message: 'Error: Could not perform action.',
                                    type: 'error'
                                });
                                setTimeout(function() {
                                    throw e;
                                }, 0);
                                closeFunc();
                            };
                            var style = {};
                            if ('width' in filterDialog) style.width = filterDialog.width + 'px';
                            var title;
                            {
                                var els = [
                                    (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('b', filterName)
                                ];
                                if (filter.lang.description !== undefined) els.push((0, $075b9fd415bad4ff$export$db3b6bfb95261072)({
                                    className: 'kl-info-btn',
                                    onClick: function() {
                                        (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                            message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)(filter.lang.description)
                                        });
                                    },
                                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)(filter.lang.description),
                                    noRef: true
                                }, '?'));
                                title = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',flex,gap-5', els);
                            }
                            (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                message: title,
                                div: filterDialog.element,
                                style: style,
                                buttons: dialogButtons,
                                clickOnEnter: 'Ok',
                                callback: function(result) {
                                    finishedDialog(result, filterDialog);
                                },
                                closeFunc: function(func) {
                                    closeFunc = func;
                                }
                            });
                        }
                    };
                    else button.disabled = true;
                    buttons.push(button);
                    return button;
                };
                var addGroup = function(groupArr) {
                    Object.entries(filters).forEach(function(param) {
                        var _param = (0, $8N5YG._)(param, 2), filterKey = _param[0], filter = _param[1];
                        if (!groupArr.includes(filterKey)) return;
                        if (_this.isEmbed && !filter.inEmbed) return;
                        _this.rootEl.append(createButton(filterKey));
                    });
                };
                var groupA = [
                    'cropExtend',
                    'flip',
                    'perspective',
                    'resize',
                    'rotate',
                    'transform'
                ];
                var groupB = [
                    'brightnessContrast',
                    'curves',
                    'distort',
                    'hueSaturation',
                    'invert',
                    'tiltShift',
                    'toAlpha',
                    'blur',
                    'unsharpMask'
                ];
                var groupC = [
                    'grid',
                    'noise',
                    'pattern',
                    'vanishPoint'
                ];
                if (!this.isEmbed) {
                    var copyBtn = (0, $eWjiX.BB).el({
                        tagName: 'button',
                        className: 'grid-button grid-button--filter',
                        content: [
                            (0, $72Jv0.createImage)({
                                alt: 'icon',
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a77baa3d81294bff$exports))),
                                width: 18,
                                height: 20,
                                css: {
                                    marginRight: '3px'
                                }
                            }),
                            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-copy')
                        ],
                        onClick: function() {
                            return _this.onCopyToClipboard();
                        },
                        title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-copy-title'),
                        custom: {
                            tabIndex: '-1'
                        },
                        css: {
                            lineHeight: '20px'
                        }
                    });
                    var pasteBtn = (0, $eWjiX.BB).el({
                        tagName: 'button',
                        className: 'grid-button grid-button--filter',
                        content: [
                            (0, $eWjiX.BB).el({
                                css: {
                                    height: '20px',
                                    cssFloat: 'left'
                                }
                            }),
                            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-paste')
                        ],
                        custom: {
                            tabIndex: '-1'
                        },
                        css: {
                            lineHeight: '20px'
                        },
                        onClick: function() {
                            return _this.onPaste();
                        }
                    });
                    this.rootEl.append(copyBtn, pasteBtn, (0, $eWjiX.BB).el({
                        className: 'grid-hr'
                    }));
                }
                addGroup(groupA);
                this.rootEl.append((0, $eWjiX.BB).el({
                    className: 'grid-hr'
                }));
                addGroup(groupB);
                this.rootEl.append((0, $eWjiX.BB).el({
                    className: 'grid-hr'
                }));
                addGroup(groupC);
                this.isInit = true;
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "show",
            value: function show() {
                if (!this.isInit) this.init();
                this.rootEl.style.display = 'block';
            }
        },
        {
            key: "hide",
            value: function hide() {
                this.rootEl.style.display = 'none';
            }
        }
    ]);
    return EditUi;
}();



var $1LaJZ = parcelRequire("1LaJZ");

var $fk3zw = parcelRequire("fk3zw");

var $eWjiX = parcelRequire("eWjiX");


var $c80c88976de71b18$exports = {};
$c80c88976de71b18$exports = $parcel$resolve("iGeXe");



var $eIcQa = parcelRequire("eIcQa");

var $7jh4K = parcelRequire("7jh4K");
/**
 * uploads canvas, opens new tab with the upload progress & then opens the image page.
 */ function $6349b006a6604e1b$var$upload(canvas, title, description, type, imgurKey) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var imageBlob, newTab, label, gif, labelText, response, formData, e, data;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, $eIcQa.canvasToBlob)(canvas, 'image/' + type)
                    ];
                case 1:
                    imageBlob = _state.sent();
                    newTab = window.open();
                    if (!newTab) throw new Error('could not create new tab');
                    label = newTab.document.createElement('div');
                    gif = newTab.document.createElement('img');
                    gif.src = (0, (/*@__PURE__*/$parcel$interopDefault($c80c88976de71b18$exports)));
                    label.append(gif);
                    (0, $7jh4K.css)(gif, {
                        filter: 'invert(1)'
                    });
                    (0, $7jh4K.css)(newTab.document.body, {
                        backgroundColor: '#121211',
                        backgroundImage: 'linear-gradient(#2b2b2b 0%, #121211 50%)',
                        backgroundRepeat: 'no-repeat'
                    });
                    labelText = newTab.document.createElement('div');
                    labelText.style.marginTop = '10px';
                    label.append(labelText);
                    labelText.textContent = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-uploading');
                    newTab.document.body.append(label);
                    (0, $7jh4K.css)(label, {
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginTop: '100px',
                        fontFamily: 'system-ui, sans-serif',
                        fontSize: '20px',
                        textAlign: 'center',
                        transition: 'opacity 0.3s ease-in-out',
                        opacity: '0',
                        color: '#ccc'
                    });
                    setTimeout(function() {
                        label.style.opacity = '1';
                    }, 20);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    formData = new FormData();
                    formData.append('title', title);
                    formData.append('description', description);
                    formData.append('image', imageBlob);
                    return [
                        4,
                        fetch('https://api.imgur.com/3/image', {
                            method: 'POST',
                            headers: {
                                Authorization: 'Client-ID ' + imgurKey
                            },
                            body: formData
                        })
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    newTab.close();
                    throw e;
                case 5:
                    if (!response.ok) {
                        newTab.close();
                        throw new Error();
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 6:
                    data = _state.sent().data;
                    newTab.location.href = data.link.replace(/\.(jpg|png)/, '');
                    return [
                        2,
                        data
                    ];
            }
        });
    })();
}
function $6349b006a6604e1b$export$b1dd62fa0b5f32f5(klCanvas, klRootEl, imgurKey, onUploaded) {
    if (!imgurKey) throw new Error('imgur key missing');
    var inputTitle = (0, $eWjiX.BB).el({
        tagName: 'input',
        custom: {
            name: 'image-title'
        }
    });
    inputTitle.type = 'text';
    inputTitle.value = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-title-untitled');
    var inputDescription = (0, $eWjiX.BB).el({
        tagName: 'textarea',
        custom: {
            rows: '2',
            name: 'image-description'
        },
        css: {
            width: '100%',
            maxWidth: '100%'
        }
    });
    var labelTitle = (0, $eWjiX.BB).el({
        textContent: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-name') + ':'
    });
    var labelDescription = (0, $eWjiX.BB).el({
        textContent: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-caption') + ':',
        css: {
            marginTop: '10px'
        }
    });
    var tos = (0, $eWjiX.BB).el({
        content: `<br/><a href="https://imgur.com/tos" target="_blank" rel="noopener noreferrer">${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('terms-of-service')}</a>`
    });
    var typeRadio = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).RadioList({
        name: 'filetype',
        init: 'jpeg',
        items: [
            {
                label: 'JPG',
                value: 'jpeg'
            },
            {
                label: 'PNG',
                value: 'png'
            }
        ],
        ignoreFocus: true
    });
    (0, $7jh4K.css)(typeRadio.getElement(), {
        marginBottom: '10px'
    });
    var outDiv = (0, $eWjiX.BB).el();
    var infoHint = (0, $eWjiX.BB).el({
        className: 'info-hint',
        textContent: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-link-notice')
    });
    outDiv.append(infoHint, typeRadio.getElement(), labelTitle, inputTitle, labelDescription, inputDescription, tos);
    (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
        message: `<b>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-title')}</b>`,
        type: 'upload',
        div: outDiv,
        buttons: [
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-submit'),
            'Cancel'
        ],
        clickOnEnter: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-submit'),
        primaries: [
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-submit')
        ],
        autoFocus: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-submit'),
        callback: function callback(val) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                var result, e;
                return (0, $fk3zw._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(val === (0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-submit') || val === 'Yes' || val === 'Ok')) return [
                                3,
                                4
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                $6349b006a6604e1b$var$upload(klCanvas.getCompleteCanvas(1), inputTitle.value, inputDescription.value, typeRadio.getValue(), imgurKey)
                            ];
                        case 2:
                            result = _state.sent();
                            (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                type: 'ok',
                                message: `<h3>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-success')}</h3><br>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-delete')}<br><a target='_blank' rel="noopener noreferrer" href='https://imgur.com/delete/${result.deletehash}'>imgur.com/delete/${result.deletehash}</a><br><br>`,
                                buttons: [
                                    'Ok'
                                ]
                            });
                            onUploaded();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                type: 'error',
                                message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-failed'),
                                buttons: [
                                    'Ok'
                                ]
                            });
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    });
}



var $1LaJZ = parcelRequire("1LaJZ");

var $fk3zw = parcelRequire("fk3zw");
var $a12fba8bc3214c1d$var$agPsdLazy;

function $a12fba8bc3214c1d$export$ab3d838b1d336b38() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!$a12fba8bc3214c1d$var$agPsdLazy) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (parcelRequire("6caCk"))
                    ];
                case 1:
                    $a12fba8bc3214c1d$var$agPsdLazy = _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        $a12fba8bc3214c1d$var$agPsdLazy
                    ];
            }
        });
    })();
}



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");


var $eWjiX = parcelRequire("eWjiX");


var $6l0gQ = parcelRequire("6l0gQ");
var $7bc9f014309fd931$export$d4ef1ef99f1461a4;
$7bc9f014309fd931$export$d4ef1ef99f1461a4 = `WKn-vG_psdWrapper`;



var $06e8423858d08972$var$DEBUG_TIME_LIMIT_MS = undefined;
var $06e8423858d08972$var$DEBUG_UNSAVED_ACTIONS_LIMIT = undefined;
// minimum number of actions required for reminder to show up (regardless of time limit)
var $06e8423858d08972$var$UNSAVED_ACTIONS_LIMIT = $06e8423858d08972$var$DEBUG_UNSAVED_ACTIONS_LIMIT !== null && $06e8423858d08972$var$DEBUG_UNSAVED_ACTIONS_LIMIT !== void 0 ? $06e8423858d08972$var$DEBUG_UNSAVED_ACTIONS_LIMIT : 100;
var $06e8423858d08972$var$LS_REMINDER_KEY = 'kl-save-reminder';
var $06e8423858d08972$export$befc6437ad34b28a = /*#__PURE__*/ function() {
    "use strict";
    function SaveReminder(p) {
        (0, $cx0mh._)(this, SaveReminder);
        this.klHistory = {};
        this.lastSavedAt = 0;
        this.lastReminderShownAt = 0;
        this.onSaveAsPsd = p.onSaveAsPsd;
        this.isDrawing = p.isDrawing;
        this.projectStore = p.projectStore;
        this.getProject = p.getProject;
        this.onStored = p.onStored;
        this.applyUncommitted = p.applyUncommitted;
        this.klHistory = p.klHistory;
        var _LocalStorage_getItem;
        this.setting = (_LocalStorage_getItem = (0, $6l0gQ.LocalStorage).getItem($06e8423858d08972$var$LS_REMINDER_KEY)) !== null && _LocalStorage_getItem !== void 0 ? _LocalStorage_getItem : '40min';
    }
    (0, $7h4XF._)(SaveReminder, [
        {
            key: "showPopup",
            value: function showPopup() {
                var _this = this;
                var min = Math.round((performance.now() - this.lastSavedAt) / 1000 / 60);
                var contentEl = (0, $eWjiX.BB).el();
                contentEl.append((0, $eWjiX.BB).el({
                    content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('save-reminder-text', {
                        a: '<strong>' + min,
                        b: '</strong>'
                    }),
                    css: {
                        marginBottom: '20px'
                    }
                }));
                var psdWrapper = (0, $eWjiX.BB).el({
                    className: $7bc9f014309fd931$export$d4ef1ef99f1461a4
                });
                var storageWrapper = (0, $eWjiX.BB).el({
                    css: {
                        margin: '0 -20px',
                        padding: '20px',
                        paddingBottom: '0'
                    }
                });
                contentEl.append(psdWrapper, storageWrapper);
                var psdBtn = (0, $eWjiX.BB).el({
                    tagName: 'button',
                    className: 'kl-button kl-button-primary kl-button--extra-focus',
                    content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('save-reminder-save-psd'),
                    onClick: function() {
                        _this.applyUncommitted();
                        _this.onSaveAsPsd();
                    },
                    css: {
                        padding: '14px'
                    },
                    noRef: true
                });
                psdWrapper.append(psdBtn, (0, $eWjiX.BB).el({
                    content: "\u2714 " + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('save-reminder-psd-layers'),
                    css: {
                        marginTop: '10px'
                    }
                }));
                var storageUi = new (0, $0e681e75eb3cab30$export$9c72cf485ef46673)({
                    projectStore: this.projectStore,
                    getProject: this.getProject,
                    applyUncommitted: this.applyUncommitted,
                    options: {
                        hideClearButton: true,
                        isFocusable: true
                    },
                    onStored: function() {
                        return _this.onStored();
                    }
                });
                storageUi.show();
                storageWrapper.append(storageUi.getElement());
                (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                    type: 'warning',
                    message: `<b>${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('save-reminder-title')}</b>`,
                    div: contentEl,
                    ignoreBackground: true,
                    callback: function() {
                        storageUi.destroy();
                        (0, $eWjiX.BB).destroyEl(psdBtn);
                        _this.closeFunc = undefined;
                        _this.lastReminderShownAt = performance.now();
                    },
                    closeFunc: function(f) {
                        _this.closeFunc = f;
                    }
                });
                setTimeout(function() {
                    psdBtn.focus();
                }, 40);
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                if (this.lastSavedHistoryIndex !== undefined) // already initialized
                return;
                this.lastSavedHistoryIndex = this.klHistory.getTotalIndex();
                this.lastReminderShownAt = performance.now();
                this.lastSavedAt = performance.now();
                setInterval(function() {
                    if (document.visibilityState !== 'visible') return;
                    var unsavedActions = Math.abs(_this.klHistory.getTotalIndex() - _this.lastSavedHistoryIndex);
                    var timeLimitMs = $06e8423858d08972$var$DEBUG_TIME_LIMIT_MS !== null && $06e8423858d08972$var$DEBUG_TIME_LIMIT_MS !== void 0 ? $06e8423858d08972$var$DEBUG_TIME_LIMIT_MS : 60000 * ({
                        '20min': 20,
                        '40min': 40,
                        disabled: 0
                    })[_this.setting];
                    if (timeLimitMs > 0 && (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() === 0 && !_this.isDrawing() && _this.lastReminderShownAt + timeLimitMs < performance.now() && unsavedActions >= $06e8423858d08972$var$UNSAVED_ACTIONS_LIMIT) _this.showPopup();
                }, 5000);
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.lastSavedHistoryIndex === undefined) // not initialized
                return;
                this.lastSavedHistoryIndex = this.klHistory.getTotalIndex();
                this.lastReminderShownAt = performance.now();
                this.lastSavedAt = performance.now();
                window.onbeforeunload = null;
                if (this.closeFunc) this.closeFunc();
            }
        },
        {
            key: "getSetting",
            value: function getSetting() {
                return this.setting;
            }
        },
        {
            key: "setSetting",
            value: function setSetting(setting) {
                this.setting = setting;
                (0, $6l0gQ.LocalStorage).setItem($06e8423858d08972$var$LS_REMINDER_KEY, this.setting);
            }
        }
    ]);
    return SaveReminder;
}();



var $1LaJZ = parcelRequire("1LaJZ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $fk3zw = parcelRequire("fk3zw");

var $eWjiX = parcelRequire("eWjiX");


var $1LaJZ = parcelRequire("1LaJZ");

var $fk3zw = parcelRequire("fk3zw");
var $e1c6fbc08bfda4eb$var$types = {
    'image/png': {
        description: 'PNG Image',
        accept: {
            'image/png': [
                '.png'
            ]
        }
    },
    'image/vnd.adobe.photoshop': {
        description: 'Adobe Photoshop Document',
        accept: {
            'image/vnd.adobe.photoshop': [
                '.psd'
            ]
        }
    }
};
// resolves to true if it saves via file picker (or user aborted)
function $e1c6fbc08bfda4eb$var$saveViaFilePicker(blob, fileName) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var mimeType, fileHandle, e, writableStream;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    mimeType = blob.type;
                    if (!('showSaveFilePicker' in window)) return [
                        3,
                        8
                    ];
                    if (!$e1c6fbc08bfda4eb$var$types[mimeType]) {
                        console.error('unknown mime type:', mimeType);
                        return [
                            2,
                            false
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        window.showSaveFilePicker({
                            suggestedName: fileName,
                            types: [
                                $e1c6fbc08bfda4eb$var$types[mimeType]
                            ]
                        })
                    ];
                case 2:
                    fileHandle = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    if (e instanceof Error && e.name === 'AbortError') // cancelled dialog
                    return [
                        2,
                        true
                    ];
                    console.log('unpredicted error', e);
                    return [
                        2,
                        false
                    ];
                case 4:
                    if (!fileHandle) return [
                        2,
                        false
                    ];
                    return [
                        4,
                        fileHandle.createWritable()
                    ];
                case 5:
                    writableStream = _state.sent();
                    return [
                        4,
                        writableStream.write(blob)
                    ];
                case 6:
                    _state.sent();
                    return [
                        4,
                        writableStream.close()
                    ];
                case 7:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 8:
                    return [
                        2,
                        false
                    ];
                case 9:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $e1c6fbc08bfda4eb$export$2bc2a80e311129ac(blob, fileName) {
    var showDialog = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var _tmp, a, objectUrl;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = showDialog;
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        $e1c6fbc08bfda4eb$var$saveViaFilePicker(blob, fileName)
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    if (_tmp) return [
                        2
                    ];
                    // Namespace is used to prevent conflict w/ Chrome Poper Blocker extension (Issue https://github.com/eligrey/FileSaver.js/issues/561)
                    a = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
                    a.download = fileName;
                    a.rel = 'noopener';
                    objectUrl = URL.createObjectURL(blob);
                    a.href = objectUrl;
                    setTimeout(function() {
                        return URL.revokeObjectURL(objectUrl);
                    }, 40000);
                    setTimeout(function() {
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }, 1);
                    return [
                        2
                    ];
            }
        });
    })();
}


var $da1a7600c10c1784$export$67ac20532b9ededa = {
    filenameBase: 'Klecks'
};



var $eIcQa = parcelRequire("eIcQa");
var $956d06d740fc5053$export$75e7b60500bb415b = /*#__PURE__*/ function() {
    "use strict";
    function SaveToComputer(getExportType, klCanvas, onSaved) {
        (0, $cx0mh._)(this, SaveToComputer);
        this.getExportType = getExportType;
        this.klCanvas = klCanvas;
        this.onSaved = onSaved;
        this.showSaveDialog = true;
    }
    (0, $7h4XF._)(SaveToComputer, [
        {
            key: "saveImage",
            value: function saveImage(canvas, filename, mimeType) {
                var showDialog = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var blob;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $eIcQa.canvasToBlob)(canvas, mimeType)
                                ];
                            case 1:
                                blob = _state.sent();
                                return [
                                    4,
                                    (0, $e1c6fbc08bfda4eb$export$2bc2a80e311129ac)(blob, filename, showDialog)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "save",
            value: function save(format) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this, extension, mimeType, filename, fullCanvas, error, extension1, mimeType1, filename1, fullCanvas1, error1, extension2, mimeType2, fileBase, layerArr, i, item, fnameArr, layerArr1, psdConfig, i1, item1;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                if (!format) format = this.getExportType();
                                if (!(format === 'png')) return [
                                    3,
                                    5
                                ];
                                extension = 'png';
                                mimeType = 'image/png';
                                filename = (0, $eWjiX.BB).getDate() + (0, $da1a7600c10c1784$export$67ac20532b9ededa).filenameBase + '.' + extension;
                                fullCanvas = this.klCanvas.getCompleteCanvas(1);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    this.saveImage(fullCanvas, filename, mimeType, this.showSaveDialog)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                //fallback for old browsers
                                alert('could not save');
                                throw new Error('failed png export');
                            case 4:
                                return [
                                    3,
                                    16
                                ];
                            case 5:
                                if (!(format === 'jpg')) return [
                                    3,
                                    10
                                ];
                                extension1 = 'jpg';
                                mimeType1 = 'image/jpeg';
                                filename1 = (0, $eWjiX.BB).getDate() + (0, $da1a7600c10c1784$export$67ac20532b9ededa).filenameBase + '.' + extension1;
                                fullCanvas1 = this.klCanvas.getCompleteCanvas(1);
                                _state.label = 6;
                            case 6:
                                _state.trys.push([
                                    6,
                                    8,
                                    ,
                                    9
                                ]);
                                return [
                                    4,
                                    this.saveImage(fullCanvas1, filename1, mimeType1, this.showSaveDialog)
                                ];
                            case 7:
                                _state.sent();
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                error1 = _state.sent();
                                alert('could not save');
                                throw new Error('failed jpg export');
                            case 9:
                                return [
                                    3,
                                    16
                                ];
                            case 10:
                                if (!(format === 'layers')) return [
                                    3,
                                    15
                                ];
                                extension2 = 'png';
                                mimeType2 = 'image/png';
                                fileBase = (0, $eWjiX.BB).getDate() + (0, $da1a7600c10c1784$export$67ac20532b9ededa).filenameBase;
                                layerArr = this.klCanvas.getLayersFast();
                                i = 0;
                                _state.label = 11;
                            case 11:
                                if (!(i < layerArr.length)) return [
                                    3,
                                    14
                                ];
                                item = layerArr[i];
                                fnameArr = [
                                    fileBase,
                                    '_',
                                    ('' + (i + 1)).padStart(2, '0'),
                                    '_',
                                    item.name,
                                    '.',
                                    extension2
                                ];
                                return [
                                    4,
                                    this.saveImage(item.canvas, fnameArr.join(''), mimeType2)
                                ];
                            case 12:
                                _state.sent();
                                _state.label = 13;
                            case 13:
                                i++;
                                return [
                                    3,
                                    11
                                ];
                            case 14:
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                if (format === 'psd') {
                                    layerArr1 = this.klCanvas.getLayersFast();
                                    psdConfig = {
                                        width: this.klCanvas.getWidth(),
                                        height: this.klCanvas.getHeight(),
                                        children: [],
                                        canvas: this.klCanvas.getCompleteCanvas(1)
                                    };
                                    for(i1 = 0; i1 < layerArr1.length; i1++){
                                        item1 = layerArr1[i1];
                                        psdConfig.children.push({
                                            name: item1.name,
                                            hidden: !item1.isVisible,
                                            opacity: item1.opacity,
                                            canvas: item1.canvas,
                                            blendMode: (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).PSD.blendKlToPsd(item1.mixModeStr),
                                            left: 0,
                                            top: 0
                                        });
                                    }
                                    (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).loadAgPsd().then(function(agPsdLazy) {
                                        var buffer = agPsdLazy.writePsdBuffer(psdConfig);
                                        var blob = new Blob([
                                            buffer
                                        ], {
                                            type: 'image/vnd.adobe.photoshop'
                                        });
                                        (0, $e1c6fbc08bfda4eb$export$2bc2a80e311129ac)(blob, (0, $eWjiX.BB).getDate() + (0, $da1a7600c10c1784$export$67ac20532b9ededa).filenameBase + '.psd', _this.showSaveDialog);
                                    }).catch(function() {
                                        alert('Error: failed to load PSD library');
                                    });
                                }
                                _state.label = 16;
                            case 16:
                                this.onSaved();
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "setShowSaveDialog",
            value: function setShowSaveDialog(b) {
                this.showSaveDialog = b;
            }
        }
    ]);
    return SaveToComputer;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $53cc60fd413705d6$export$272bfd3ef9ef2f48 = /*#__PURE__*/ function() {
    "use strict";
    function BrushSettingService(p) {
        (0, $cx0mh._)(this, BrushSettingService);
        this.subscriberArr = [];
        this.onSetColor = p.onSetColor;
        this.onSetSize = p.onSetSize;
        this.onSetOpacity = p.onSetOpacity;
        this.onSetScatter = p.onSetScatter;
        this.onGetColor = p.onGetColor;
        this.onGetSize = p.onGetSize;
        this.onGetOpacity = p.onGetOpacity;
        this.onGetScatter = p.onGetScatter;
        this.onGetSliderConfig = p.onGetSliderConfig;
        if (BrushSettingService.instance) throw new Error('BrushSettingService already instantiated');
        BrushSettingService.instance = this;
    }
    (0, $7h4XF._)(BrushSettingService, [
        {
            key: "emit",
            value: function emit(obj, skipSubscriber) {
                for(var i = 0; i < this.subscriberArr.length; i++){
                    if (this.subscriberArr[i] === skipSubscriber) continue;
                    this.subscriberArr[i](obj);
                }
            }
        },
        {
            key: "emitColor",
            value: function emitColor(color, skipSubscriber) {
                this.emit({
                    type: 'color',
                    value: color
                }, skipSubscriber);
            }
        },
        {
            key: "emitSize",
            value: function emitSize(size, skipSubscriber) {
                this.emit({
                    type: 'size',
                    value: size
                }, skipSubscriber);
            }
        },
        {
            key: "emitOpacity",
            value: function emitOpacity(opacity, skipSubscriber) {
                this.emit({
                    type: 'opacity',
                    value: opacity
                }, skipSubscriber);
            }
        },
        {
            key: "emitScatter",
            value: function emitScatter(scatter, skipSubscriber) {
                this.emit({
                    type: 'scatter',
                    value: scatter
                }, skipSubscriber);
            }
        },
        {
            key: "emitSliderConfig",
            value: function emitSliderConfig(sliderConfig, skipSubscriber) {
                this.emit({
                    type: 'sliderConfig',
                    value: sliderConfig
                }, skipSubscriber);
            }
        },
        {
            /**
     * set current brush color
     * @param color
     * @param skipSubscriber
     */ key: "setColor",
            value: function setColor(color, skipSubscriber) {
                this.onSetColor(color);
                this.emitColor(color, skipSubscriber);
            }
        },
        {
            /**
     * set current brush size
     * @param size
     * @param skipSubscriber
     */ key: "setSize",
            value: function setSize(size, skipSubscriber) {
                this.onSetSize(size);
            // why not emitting?
            }
        },
        {
            /**
     * set current opacity
     * @param opacity
     * @param skipSubscriber
     */ key: "setOpacity",
            value: function setOpacity(opacity, skipSubscriber) {
                this.onSetOpacity(opacity);
            // why not emitting?
            }
        },
        {
            /**
     * set current scatter
     * @param scatter
     * @param skipSubscriber
     */ key: "setScatter",
            value: function setScatter(scatter, skipSubscriber) {
                this.onSetScatter(scatter);
            // why not emitting?
            }
        },
        {
            /**
     * get current brush color
     */ key: "getColor",
            value: function getColor() {
                return this.onGetColor();
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.onGetSize();
            }
        },
        {
            key: "getOpacity",
            value: function getOpacity() {
                return this.onGetOpacity();
            }
        },
        {
            key: "getScatter",
            value: function getScatter() {
                return this.onGetScatter();
            }
        },
        {
            key: "getSliderConfig",
            value: function getSliderConfig() {
                return this.onGetSliderConfig();
            }
        },
        {
            /**
     * subscribe to changes
     * @param func
     */ key: "subscribe",
            value: function subscribe(func) {
                if (this.subscriberArr.includes(func)) return;
                this.subscriberArr.push(func);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(func) {
                for(var i = 0; i < this.subscriberArr.length; i++)if (func === this.subscriberArr[i]) {
                    this.subscriberArr.splice(i, 1);
                    i--;
                }
            }
        }
    ]);
    return BrushSettingService;
}();




var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $bX4ja = parcelRequire("bX4ja");

var $eWjiX = parcelRequire("eWjiX");



var $85d84ef8897d4b7a$exports = {};
$85d84ef8897d4b7a$exports = $parcel$resolve("kSWIa");



var $659c57669da2cc2c$exports = {};
$659c57669da2cc2c$exports = $parcel$resolve("4FMUg");



var $6l0gQ = parcelRequire("6l0gQ");


var $7jh4K = parcelRequire("7jh4K");

var $8c9a65b29d77fa51$export$1c6ca1c73436aa3c;
$8c9a65b29d77fa51$export$1c6ca1c73436aa3c = `ttl1Ia_licenses`;




var $eWjiX = parcelRequire("eWjiX");



function $c57a53a21f44c053$export$d3fe39c7bff44f23() {
    var libraries = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('.' + $8c9a65b29d77fa51$export$1c6ca1c73436aa3c, (0, $8d7403abedf7cefa$export$ce37e184d908d785)('loading'));
    var fonts = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('.' + $8c9a65b29d77fa51$export$1c6ca1c73436aa3c, (0, $8d7403abedf7cefa$export$ce37e184d908d785)('loading'));
    var content = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',flex,flexCol,gap-10', [
        libraries,
        fonts
    ]);
    new (0, $e59fbd08bcc1a36b$export$185108a9b725b68)({
        title: (0, $eWjiX.BB).el({
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('licenses')
        }),
        content: (0, $eWjiX.BB).el({
            content: content,
            css: {
                height: '100%',
                overflowY: 'auto',
                padding: '10px',
                boxSizing: 'border-box'
            }
        }),
        width: 800,
        isMaxHeight: true,
        onClose: function() {
            if (window.location.hash === '#licenses') history.replaceState('', document.title, window.location.pathname + window.location.search);
        }
    });
    (parcelRequire("kUTcy")).then(function(result) {
        libraries.innerHTML = '';
        result.LICENSES.forEach(function(item) {
            libraries.append((0, $075b9fd415bad4ff$export$db3b6bfb95261072)('details', [
                (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('summary', item.title),
                (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('', item.full.replace(/\n/g, '<br>'))
            ]));
        });
    });
    (parcelRequire("6rG3P")).then(function(result) {
        fonts.innerHTML = '';
        result.FONT_LICENSES.forEach(function(item) {
            fonts.append((0, $075b9fd415bad4ff$export$db3b6bfb95261072)('details', [
                (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('summary', 'Font: ' + item.title),
                (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('', item.full.replace(/\n/g, '<br>'))
            ]));
        });
    });
}





var $72Jv0 = parcelRequire("72Jv0");
var $b02b612f245bffe6$export$ad7f6c626a2cdfad = /*#__PURE__*/ function() {
    "use strict";
    function SettingsUi(param) {
        var onLeftRight = param.onLeftRight, saveReminder = param.saveReminder, customAbout = param.customAbout;
        (0, $cx0mh._)(this, SettingsUi);
        var themeToLabel = // ---- theme ----
        function themeToLabel(theme) {
            return theme === 'dark' ? "\u2B1B " + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('theme-dark') : "\u2B1C " + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('theme-light');
        };
        var makeLicenses = function makeLicenses() {
            return (0, $eWjiX.BB).el({
                tagName: 'a',
                content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('licenses'),
                onClick: function() {
                    return (0, $c57a53a21f44c053$export$d3fe39c7bff44f23)();
                }
            });
        };
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                margin: '10px'
            }
        });
        // ---- language ----
        var autoLanguage = (0, $8d7403abedf7cefa$export$e4ce066d17694649).getAutoLanguage();
        var langWrapper = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            content: (0, $eWjiX.BB).el({
                content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('settings-language') + ':',
                css: {
                    marginRight: '5px',
                    marginBottom: '2px'
                }
            }),
            css: {
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap'
            }
        });
        var options = [
            [
                'auto',
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('auto') + ` \u{2192} ${autoLanguage.name} (${autoLanguage.code})`
            ]
        ].concat((0, $bX4ja._)((0, $90c6410f4b764e9c$export$d0d68bb9ed2c643d).map(function(item) {
            return [
                item.code,
                item.name + ` (${item.code})`
            ];
        })));
        var languageSelect = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).Select({
            initValue: (0, $7jh4K.nullToUndefined)((0, $6l0gQ.LocalStorage).getItem((0, $8d7403abedf7cefa$export$991796128b2ca217)) ? (0, $6l0gQ.LocalStorage).getItem((0, $8d7403abedf7cefa$export$991796128b2ca217)) : 'auto'),
            optionArr: options,
            onChange: function(val) {
                if (val === 'auto') (0, $6l0gQ.LocalStorage).removeItem((0, $8d7403abedf7cefa$export$991796128b2ca217));
                else (0, $6l0gQ.LocalStorage).setItem((0, $8d7403abedf7cefa$export$991796128b2ca217), val);
                languageHint.style.display = 'block';
            },
            name: 'language'
        });
        (0, $7jh4K.css)(languageSelect.getElement(), {
            flexGrow: '1'
        });
        var languageHint = (0, $eWjiX.BB).el({
            className: 'kl-toolspace-note',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('settings-language-reload'),
            css: {
                display: 'none',
                marginTop: '5px',
                flexGrow: '1'
            }
        });
        langWrapper.append(languageSelect.getElement(), languageHint);
        var themeSelect = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).Select({
            optionArr: [
                [
                    'auto',
                    (0, $8d7403abedf7cefa$export$ce37e184d908d785)('auto') + " \u2192 " + themeToLabel((0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).getMediaQueryTheme())
                ],
                [
                    'light',
                    themeToLabel('light')
                ],
                [
                    'dark',
                    themeToLabel('dark')
                ]
            ],
            initValue: (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).getStoredTheme() || 'auto',
            onChange: function(val) {
                (0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).setStoredTheme(val === 'auto' ? undefined : val);
            },
            name: 'ui-theme'
        });
        (0, $7jh4K.css)(themeSelect.getElement(), {
            flexGrow: '1'
        });
        (0, $7jh4K.addIsDarkListener)(function() {
            themeSelect.updateLabel('auto', (0, $8d7403abedf7cefa$export$ce37e184d908d785)('auto') + " \u2192 " + themeToLabel((0, $e3b2ff8d1f8c5253$export$5714e40777c1bcc2).getMediaQueryTheme()));
        });
        (0, $eWjiX.BB).el({
            parent: this.rootEl,
            content: [
                (0, $eWjiX.BB).el({
                    content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('settings-theme') + ':',
                    css: {
                        marginRight: '5px',
                        marginBottom: '2px'
                    }
                }),
                themeSelect.getElement()
            ],
            css: {
                marginTop: '15px',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap'
            }
        });
        // ---- save reminder ----
        if (saveReminder) {
            var reminderSelect = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).Select({
                optionArr: [
                    [
                        '20min',
                        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('x-minutes', {
                            x: '20'
                        })
                    ],
                    [
                        '40min',
                        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('x-minutes', {
                            x: '40'
                        })
                    ],
                    [
                        'disabled',
                        "\u26A0\uFE0F " + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('settings-save-reminder-disabled')
                    ]
                ],
                initValue: saveReminder.getSetting(),
                onChange: function(val) {
                    if (val !== 'disabled') {
                        saveReminder.setSetting(val);
                        return;
                    }
                    var disableStr = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('settings-save-reminder-confirm-disable');
                    (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
                        message: "\u26A0\uFE0F" + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('settings-save-reminder-confirm-title'),
                        div: (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('', [
                            (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('.info-hint', (0, $8d7403abedf7cefa$export$ce37e184d908d785)('settings-save-reminder-confirm-a')),
                            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('settings-save-reminder-confirm-b')
                        ]),
                        buttons: [
                            disableStr,
                            'Cancel'
                        ],
                        callback: function(result) {
                            if (result === disableStr) saveReminder.setSetting(val);
                            else reminderSelect.setValue(saveReminder.getSetting());
                        }
                    });
                },
                name: 'save-reminder-interval'
            });
            reminderSelect.getElement().style.flexGrow = '1';
            this.rootEl.append((0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',flex,items-center,gap-5,mt-15,flexWrap', [
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('settings-save-reminder-label') + ':',
                reminderSelect.getElement()
            ]));
        }
        // ---- flip ui ----
        (0, $eWjiX.BB).el({
            tagName: 'button',
            parent: this.rootEl,
            content: [
                (0, $72Jv0.createImage)({
                    alt: 'icon',
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($659c57669da2cc2c$exports))),
                    width: 18,
                    height: 20,
                    css: {
                        marginRight: '5px'
                    }
                }),
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('switch-ui-left-right')
            ],
            onClick: function() {
                return onLeftRight();
            },
            css: {
                marginTop: '15px'
            },
            custom: {
                tabIndex: '-1'
            }
        });
        // ---- about ----
        this.rootEl.append((0, $eWjiX.BB).el({
            className: 'grid-hr',
            css: {
                margin: '10px 0'
            }
        }));
        if (customAbout) {
            this.rootEl.append(customAbout);
            if (!customAbout.innerHTML) {
                var minimalAbout = (0, $eWjiX.BB).el({
                    parent: customAbout,
                    css: {
                        textAlign: 'center'
                    }
                });
                minimalAbout.append((0, $eWjiX.BB).el({
                    content: [
                        (0, $72Jv0.createImage)({
                            alt: 'icon',
                            height: 20,
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($85d84ef8897d4b7a$exports))),
                            css: {
                                verticalAlign: 'middle'
                            }
                        }),
                        ' ',
                        (0, $eWjiX.BB).el({
                            tagName: 'a',
                            content: 'bitbof',
                            custom: {
                                href: 'https://bitbof.com',
                                target: '_blank',
                                tabIndex: '-1'
                            }
                        }),
                        " \xa9 2025",
                        (0, $eWjiX.BB).el({
                            tagName: 'br'
                        })
                    ]
                }), makeLicenses());
            }
        } else {
            var versionEl = (0, $eWjiX.BB).el({
                parent: this.rootEl,
                css: {
                    textAlign: 'center'
                },
                content: [
                    (0, $72Jv0.createImage)({
                        alt: 'Klecks',
                        className: 'dark-invert',
                        height: 25,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($8f2db75412060fdc$exports)))
                    }),
                    (0, $eWjiX.BB).el({
                        tagName: 'br'
                    }),
                    (0, $72Jv0.createImage)({
                        alt: 'icon',
                        height: 20,
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($85d84ef8897d4b7a$exports))),
                        css: {
                            verticalAlign: 'middle'
                        }
                    }),
                    ' ',
                    (0, $eWjiX.BB).el({
                        tagName: 'a',
                        content: 'bitbof',
                        custom: {
                            href: 'https://bitbof.com',
                            target: '_blank',
                            tabIndex: '-1'
                        }
                    }),
                    " \xa9 2025",
                    (0, $eWjiX.BB).el({
                        tagName: 'br'
                    })
                ]
            });
            versionEl.append(makeLicenses(), document.createTextNode(' | '), (0, $eWjiX.BB).el({
                tagName: 'a',
                content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('donate'),
                custom: {
                    href: 'https://kleki.com/donate/',
                    target: '_blank'
                }
            }), document.createTextNode(' | '), (0, $eWjiX.BB).el({
                tagName: 'a',
                content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('source-code'),
                custom: {
                    href: 'https://klecks.org',
                    target: '_blank'
                }
            }));
        }
        window.addEventListener('storage', function(e) {
            if (e.key !== (0, $8d7403abedf7cefa$export$991796128b2ca217)) return;
            languageSelect.setValue((0, $7jh4K.nullToUndefined)((0, $6l0gQ.LocalStorage).getItem((0, $8d7403abedf7cefa$export$991796128b2ca217)) ? (0, $6l0gQ.LocalStorage).getItem((0, $8d7403abedf7cefa$export$991796128b2ca217)) : 'auto'));
        });
    }
    (0, $7h4XF._)(SettingsUi, [
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return SettingsUi;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");



var $7jh4K = parcelRequire("7jh4K");
var $951e508110f8a437$export$42a534af7eb650e8 = /*#__PURE__*/ function() {
    "use strict";
    function ToolspaceScroller(p) {
        var _this = this;
        (0, $cx0mh._)(this, ToolspaceScroller);
        this.toolspace = p.toolspace;
        this.upBtn = (0, $eWjiX.BB).el({
            parent: this.toolspace,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('scroll'),
            className: 'kl-scroller',
            css: {
                top: '0',
                transform: 'rotate(180deg)'
            }
        });
        this.downBtn = (0, $eWjiX.BB).el({
            parent: this.toolspace,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('scroll'),
            className: 'kl-scroller',
            css: {
                bottom: '0'
            }
        });
        this.updateUiState(p.uiState);
        var upListener = new (0, $eWjiX.BB).PointerListener({
            target: this.upBtn,
            onPointer: function(e) {
                if (e.type === 'pointerdown') _this.upInterval = setInterval(function() {
                    _this.toolspace.scrollBy(0, -13);
                    _this.update();
                }, 20);
                if (e.type === 'pointerup') {
                    clearInterval(_this.upInterval);
                    setTimeout(function() {
                        // prevent ff pressing anything underneath
                        _this.upInterval = null;
                        _this.update();
                    }, 50);
                }
            }
        });
        var downListener = new (0, $eWjiX.BB).PointerListener({
            target: this.downBtn,
            onPointer: function(e) {
                if (e.type === 'pointerdown') _this.downInterval = setInterval(function() {
                    _this.toolspace.scrollBy(0, 13);
                    _this.update();
                }, 20);
                if (e.type === 'pointerup') {
                    clearInterval(_this.downInterval);
                    setTimeout(function() {
                        // prevent ff pressing anything underneath
                        _this.downInterval = null;
                        _this.update();
                    }, 50);
                }
            }
        });
        var wheelListener = function(e) {
            _this.toolspace.scrollBy(0, Math.round(0.7 * e.deltaY));
            _this.update();
        };
        this.upBtn.addEventListener('wheel', wheelListener, {
            passive: false
        });
        this.downBtn.addEventListener('wheel', wheelListener, {
            passive: false
        });
        this.update();
        var observer = new MutationObserver(function() {
            return _this.update();
        });
        observer.observe(this.toolspace, {
            attributes: true,
            childList: true,
            subtree: true
        });
        window.addEventListener('resize', function() {
            return _this.update();
        });
        // hide if in dialog because that can have its own scrollbar
        (0, $dd0d395ff14a3e11$export$d3d1650bc39c4419).subscribe(function(v) {
            // ignores the 0.5 by tool dropdown
            _this.upBtn.style.opacity = v >= 1 ? '0' : '';
            _this.downBtn.style.opacity = v >= 1 ? '0' : '';
        });
    }
    (0, $7h4XF._)(ToolspaceScroller, [
        {
            key: "update",
            value: function update() {
                var newUpDisplay = this.upBtn.style.display;
                var newDownDisplay = this.downBtn.style.display;
                if (this.toolspace.scrollHeight > this.toolspace.offsetHeight + 3) {
                    // small buffer where it's not worth it
                    if (!this.upInterval) newUpDisplay = this.toolspace.scrollTop === 0 ? 'none' : 'block';
                    if (!this.downInterval) newDownDisplay = this.toolspace.scrollTop + this.toolspace.offsetHeight + 1 >= this.toolspace.scrollHeight ? 'none' : 'block';
                } else {
                    newUpDisplay = 'none';
                    newDownDisplay = 'none';
                }
                // check to prevent infinite MutationObserver loop in Pale Moon
                if (newUpDisplay !== this.upBtn.style.display) this.upBtn.style.display = newUpDisplay;
                if (newDownDisplay !== this.downBtn.style.display) this.downBtn.style.display = newDownDisplay;
            }
        },
        {
            key: "updateUiState",
            value: function updateUiState(uiState) {
                (0, $7jh4K.css)(this.upBtn, {
                    left: uiState === 'left' ? '0' : '',
                    right: uiState === 'right' ? '0' : ''
                });
                (0, $7jh4K.css)(this.downBtn, {
                    left: uiState === 'left' ? '0' : '',
                    right: uiState === 'right' ? '0' : ''
                });
            }
        }
    ]);
    return ToolspaceScroller;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");





var $7jh4K = parcelRequire("7jh4K");
var $f244572c1923a3ac$export$7fa03d1ef9d3489e = /*#__PURE__*/ function() {
    "use strict";
    function GradientUi(p) {
        var _this = this;
        (0, $cx0mh._)(this, GradientUi);
        this.settings = {
            opacity: 1,
            type: 'linear',
            doLockAlpha: false,
            doSnap: false,
            isReversed: false,
            isEraser: false
        };
        this.colorSlider = p.colorSlider;
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                margin: '10px'
            }
        });
        this.isVisible = true;
        this.colorDiv = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                marginBottom: '10px'
            }
        });
        this.iconArr = [];
        {
            var size = 33;
            [
                0,
                1,
                2
            ].forEach(function() {
                var el = (0, $eWjiX.BB).el({
                    className: 'dark-invert',
                    css: {
                        width: size + 'px',
                        height: size + 'px',
                        borderRadius: '3px',
                        margin: '1px'
                    }
                });
                _this.iconArr.push(el);
            });
        }
        this.updateIcons();
        var typeOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'linear',
                    label: this.iconArr[0],
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('gradient-linear')
                },
                {
                    id: 'linear-mirror',
                    label: this.iconArr[1],
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('gradient-linear-mirror')
                },
                {
                    id: 'radial',
                    label: this.iconArr[2],
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('gradient-radial')
                }
            ],
            initId: 'linear',
            onChange: function(id) {
                _this.settings.type = id;
            }
        });
        this.rootEl.append(typeOptions.getElement());
        var opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
            width: 250,
            height: 30,
            min: 0.01,
            max: 1,
            value: this.settings.opacity,
            toValue: function(displayValue) {
                return displayValue / 100;
            },
            toDisplayValue: function(value) {
                return value * 100;
            },
            onChange: function(val) {
                _this.settings.opacity = val;
            }
        });
        (0, $7jh4K.css)(opacitySlider.getElement(), {
            marginTop: '10px'
        });
        this.rootEl.append(opacitySlider.getElement());
        var row1 = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px'
            }
        });
        var reverseToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('reverse'),
            callback: function(b) {
                _this.settings.isReversed = b;
                _this.updateIcons();
            },
            css: {
                width: '50%'
            },
            name: 'reverse-gradient'
        });
        var doSnapToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('angle-snap'),
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('angle-snap-title'),
            callback: function(b) {
                _this.settings.doSnap = b;
            },
            css: {
                width: '50%'
            },
            name: 'enable-snapping'
        });
        row1.append(reverseToggle.getElement(), doSnapToggle.getElement());
        var row2 = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px'
            }
        });
        var eraserToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: this.settings.isEraser,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('eraser'),
            callback: function(b) {
                _this.settings.isEraser = b;
            },
            css: {
                width: '50%'
            },
            name: 'enable-eraser'
        });
        var lockAlphaToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: false,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha'),
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('lock-alpha-title'),
            callback: function(b) {
                _this.settings.doLockAlpha = b;
            },
            doHighlight: true,
            css: {
                width: '50%'
            },
            name: 'enable-alpha-lock'
        });
        row2.append(eraserToggle.getElement(), lockAlphaToggle.getElement());
    }
    (0, $7h4XF._)(GradientUi, [
        {
            key: "updateIcons",
            value: function updateIcons() {
                var col1 = this.settings.isReversed ? '#0000' : '#000';
                var col2 = this.settings.isReversed ? '#000' : '#0000';
                this.iconArr[0].style.background = `linear-gradient(${col1}, ${col2})`;
                this.iconArr[1].style.background = `linear-gradient(${col2}, ${col1}, ${col2})`;
                this.iconArr[2].style.background = `radial-gradient(${col1}, ${col2})`;
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "setIsVisible",
            value: function setIsVisible(isVisible) {
                this.isVisible = isVisible;
                this.rootEl.style.display = isVisible ? 'block' : 'none';
                if (isVisible) this.colorDiv.append(this.colorSlider.getElement(), this.colorSlider.getOutputElement());
            }
        },
        {
            key: "getSettings",
            value: function getSettings() {
                return (0, $eWjiX.BB).copyObj(this.settings);
            }
        }
    ]);
    return GradientUi;
}();



var $9cbe98d1fb398012$export$6e4a713ddcda1e5e = {
    BRUSHES: // --- brushes ---
    $42ac5b30ad65dabb$export$32510733a89b2eab,
    BRUSHES_UI: $7de2f0eab7a9ead7$export$d1a79a5ce7e46547,
    BrushSettingService: $53cc60fd413705d6$export$272bfd3ef9ef2f48,
    KlCanvas: // --- canvas ---
    $0621fc8724f6bfac$export$4a819bde91671014,
    KlCanvasPreview: // --- canvas ui ---
    $e6889b231e436752$export$e258ade1648009b7,
    FILTER_LIB_STATUS: // --- filters ---
    $805be15a1e91c0ee$export$24724bc1f91cba3,
    FILTER_LIB: $805be15a1e91c0ee$export$bac24f240bb7727d,
    ShapeTool: // --- image operations ---
    $01d7180c5d1d0fdf$export$27550cc14d7ae85a,
    drawShape: $01d7180c5d1d0fdf$export$71b514a25c47df50,
    GradientTool: $5e45fa121ba5050f$export$74d12f09ff9f1956,
    drawGradient: $5e45fa121ba5050f$export$b1f70a113e3b5c1b,
    PSD: // --- storage ---
    $4c230b0de5e1a470$exports,
    ProjectStore: $6mTnI.ProjectStore,
    loadAgPsd: $a12fba8bc3214c1d$export$ab3d838b1d336b38,
    SaveToComputer: $956d06d740fc5053$export$75e7b60500bb415b,
    Checkbox: // --- ui - components ---
    $365a915dfb503274$export$48513f6b9f8ce62d,
    input: $dJPtW.input,
    Select: $7a3263857aacf58f$export$ef9b1a59e592288f,
    ImageToggle: $8fa94d142febb502$export$b6d053cded550773,
    ImageRadioList: $8cb981a3c9e5b15b$export$7cc1012a658e6ad8,
    RadioList: $de98bdc3369d2e4f$export$3dff5655255b5729,
    createPenPressureToggle: $a49c90053f8766a2$export$9da2e8821e6cbb57,
    KlSlider: $5c0625e6104e2c75$export$a1855b925e534de7,
    HexColorDialog: $dada52d673c8c4ac$export$cc42e119007cb939,
    KlColorSlider: $0ebf4eb3a9343b24$export$4e5102252876c5d7,
    KlColorSliderSmall: $3ce0af1e789f1ab4$export$66306bf21a9ff39e,
    PointSlider: $5e81242a941997c7$export$ac00cea56cec3037,
    ColorOptions: $4db8cbbb01889095$export$24ba9b81662d4366,
    Options: $7960d0c50ff12b0d$export$c019608e5b5bb4cb,
    BoxToggle: $afe02cc26c765c2c$export$2358c75ad3c15b2d,
    StatusOverlay: $c1a93a3cd82636c9$export$5ee0af1d5c87e856,
    CropCopy: $01fcd0ed15aa4018$export$40175a5948a88a57,
    FreeTransform: $0370167ee97a20d9$export$79a74567acf241b0,
    FreeTransformCanvas: $48f5d87739d28bf9$export$205c2dd29f8a66b5,
    Cropper: $de496a1759b04ed9$export$71ed2b85d4ca43d3,
    LayerPreview: $18e69c7d4cb991e8$export$d25420b53e16716f,
    KlImageDropper: $01cb8095758db224$export$e789742143ba5b1,
    OverlayToolspace: $d6fe881e8fc421ac$export$9f0da9b942594e99,
    ToolspaceTopRow: $6003e73b8cbb69e2$export$665d2c76b1eb8459,
    ToolDropdown: $18c597dee53260ff$export$a0a40f8a0b8fee15,
    ToolspaceToolRow: $a372d78c806cd0cc$export$c744a22bef9e0b97,
    ToolspaceStabilizerRow: $90c04b5ac185bf3d$export$8162a66cd18867a7,
    TabRow: $d04d72b97d637d65$export$3c6d17ed0106bfb9,
    ToolspaceCollapser: $9091fb5691a677d9$export$5b91f641162972fc,
    BrowserStorageUi: $0e681e75eb3cab30$export$9c72cf485ef46673,
    SaveReminder: $06e8423858d08972$export$befc6437ad34b28a,
    ToolspaceScroller: $951e508110f8a437$export$42a534af7eb650e8,
    DIALOG_COUNTER: // --- ui - modals ---
    $dd0d395ff14a3e11$export$d3d1650bc39c4419,
    popup: (0, $c902829f68f42bce$export$d7e8d4d4450c819c),
    Popup: (0, $e59fbd08bcc1a36b$export$185108a9b725b68),
    clipboardDialog: $ffd40240385bb9f9$export$32b89bc9bb92706a,
    showImportAsLayerDialog: $e3dfa43019bc3f08$export$962af7e240721d88,
    newImageDialog: $4fb68589de8a8c9a$export$f77a89101d7d6586,
    textToolDialog: $7a7111f71abacc0a$export$e263e067d6140649,
    showImportImageDialog: $c8d2eb7d799b314c$export$1bf16d9bd59fd8f9,
    showIframePopup: (0, $2d47de6498e5a87c$export$35fa34e5af64bd4a),
    imgurUpload: $6349b006a6604e1b$export$b1dd62fa0b5f32f5,
    HandUi: // --- ui - tool tabs ---
    $9934467c988b088a$export$cf20160367bae46c,
    FillUi: $51d47356d698ffec$export$1e63e3b0645421a2,
    GradientUi: $f244572c1923a3ac$export$7fa03d1ef9d3489e,
    TextUi: $d06987f550ff485e$export$32a22540e4b2f123,
    ShapeUi: $45c003c723de07b5$export$a9387b1d4260d39c,
    FileUi: $775b09ee76e7cc3e$export$409b892ffe02580b,
    EditUi: $9f0e53c75e472aaf$export$aeb1a0a0e64541b5,
    SettingsUi: $b02b612f245bffe6$export$ad7f6c626a2cdfad,
    LayersUi: $615843517fb18518$export$c3bf51e04f391d6d
};
Object.keys($9cbe98d1fb398012$export$6e4a713ddcda1e5e); // without this, parcel build may break this object



var $eWjiX = parcelRequire("eWjiX");


var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");



var $1eff19bee197987a$export$ce26cd3db18613a3 = /*#__PURE__*/ function() {
    "use strict";
    function EmbedToolspaceTopRow(p) {
        (0, $cx0mh._)(this, EmbedToolspaceTopRow);
        var createButton = function createButton(p) {
            var padding = 6 + (p.extraPadding ? p.extraPadding : 0);
            var el = (0, $eWjiX.BB).el({
                className: 'toolspace-row-button nohighlight',
                title: p.title,
                onClick: p.onClick,
                css: {
                    padding: p.content ? '' : p.contain ? padding + 'px 0' : ''
                }
            });
            if (p.content) el.append(p.content);
            else {
                var im = (0, $eWjiX.BB).el({
                    className: 'dark-invert',
                    css: {
                        backgroundImage: "url('" + p.image + "')",
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: p.contain ? 'contain' : '',
                        //filter: 'grayscale(1)',
                        height: '100%'
                    }
                });
                im.style.pointerEvents = 'none';
                el.append(im);
            }
            var pointerListener = new (0, $eWjiX.BB).PointerListener({
                // because :hover causes problems w touch
                target: el,
                onEnterLeave: function onEnterLeave(isOver) {
                    el.classList.toggle('toolspace-row-button-hover', isOver);
                }
            });
            return {
                el: el,
                pointerListener: pointerListener
            };
        };
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'kl-toolspace-row',
            css: {
                height: '36px',
                display: 'flex'
            }
        });
        var submitButton = createButton({
            onClick: p.onSubmit,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('submit-title'),
            content: (0, $eWjiX.BB).el({
                content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('submit'),
                className: 'toolspace-row-button__submit',
                css: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '100%'
                }
            }),
            contain: true
        });
        submitButton.el.style.width = '45px';
        var helpButton = createButton({
            onClick: p.onHelp,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('help'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($5f1a2e996d986b65$exports))),
            contain: true
        });
        var leftRightButton = createButton({
            onClick: p.onLeftRight,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('switch-ui-left-right'),
            image: (0, (/*@__PURE__*/$parcel$interopDefault($659c57669da2cc2c$exports))),
            contain: true
        });
        this.rootEl.append(submitButton.el, leftRightButton.el, helpButton.el);
    }
    (0, $7h4XF._)(EmbedToolspaceTopRow, [
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return EmbedToolspaceTopRow;
}();




var $fca35583bfaa35b6$export$f02de051ab70b20e = 60;




var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $bX4ja = parcelRequire("bX4ja");

var $eWjiX = parcelRequire("eWjiX");


var $7jh4K = parcelRequire("7jh4K");
parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $dZ59l = parcelRequire("dZ59l");
var $83Kse = parcelRequire("83Kse");
var $kDVZW = parcelRequire("kDVZW");
var $kFecW = parcelRequire("kFecW");
var $kr2fR = parcelRequire("kr2fR");



var $eIcQa = parcelRequire("eIcQa");

var $bbA6w = parcelRequire("bbA6w");
var $14b90ba44af68d49$export$94ec999f33a691e3 = /*#__PURE__*/ function() {
    "use strict";
    function FxPreviewRenderer(p) {
        var _this = this;
        (0, $cx0mh._)(this, FxPreviewRenderer);
        this.texture = undefined;
        this.maskCanvas = undefined // prevent destroying the mask repeatedly
        ;
        this.maskTexture = undefined;
        this.oldOnUpdateProps = {
            textureWidth: 0,
            textureHeight: 0,
            transform: {
                scaleX: 0,
                scaleY: 0,
                angleDeg: 0,
                x: 0,
                y: 0
            }
        };
        this.render = function(viewportTransform, viewportWidth, viewportHeight) {
            var viewportMat = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(viewportTransform);
            var padding = 0; // render more than visible with padding < 0
            var clippedViewportRect; // rect in viewport coordinates which contains the canvas
            var transformMatrix = (0, $83Kse.identity)();
            {
                var topLeft = (0, $cdZRx.applyToPoint)(viewportMat, {
                    x: 0,
                    y: 0
                });
                var bottomRight = (0, $cdZRx.applyToPoint)(viewportMat, {
                    x: _this.original.width,
                    y: _this.original.height
                });
                bottomRight.x = Math.round(bottomRight.x);
                bottomRight.y = Math.round(bottomRight.y);
                var clippedTL = {
                    x: Math.max(padding, topLeft.x),
                    y: Math.max(padding, topLeft.y)
                };
                var clippedBR = {
                    x: Math.min(viewportWidth - padding, bottomRight.x),
                    y: Math.min(viewportHeight - padding, bottomRight.y)
                };
                clippedViewportRect = {
                    x: clippedTL.x,
                    y: clippedTL.y,
                    width: clippedBR.x - clippedTL.x,
                    height: clippedBR.y - clippedTL.y
                };
                if (clippedViewportRect.width <= 0 || clippedViewportRect.height <= 0) {
                    _this.textureSource.width = 1;
                    _this.textureSource.height = 1;
                    return _this.textureSource;
                }
            }
            var resultTransform = (0, $dZ59l.compose)((0, $kDVZW.inverse)(viewportMat), (0, $kr2fR.translate)(padding, padding), (0, $kr2fR.translate)(clippedViewportRect.x - padding, clippedViewportRect.y - padding));
            var onUpdateProps = {
                textureWidth: Math.ceil(clippedViewportRect.width),
                textureHeight: Math.ceil(clippedViewportRect.height),
                transform: {
                    scaleX: viewportTransform.scaleX,
                    scaleY: viewportTransform.scaleY,
                    angleDeg: viewportTransform.angleDeg,
                    x: viewportTransform.x - clippedViewportRect.x,
                    y: viewportTransform.y - clippedViewportRect.y
                }
            };
            var tlOffsetX = 0;
            var tlOffsetY = 0;
            if (viewportTransform.scaleX > 1) {
                // what pixels of original canvas are actually visible
                var canvasTopLeft = (0, $cdZRx.applyToPoint)(resultTransform, {
                    x: 0,
                    y: 0
                });
                tlOffsetX = -canvasTopLeft.x;
                tlOffsetY = -canvasTopLeft.y;
                canvasTopLeft.x = Math.max(0, Math.floor(canvasTopLeft.x));
                canvasTopLeft.y = Math.max(0, Math.floor(canvasTopLeft.y));
                tlOffsetX += canvasTopLeft.x;
                tlOffsetY += canvasTopLeft.y;
                var canvasBottomRight = (0, $cdZRx.applyToPoint)(resultTransform, {
                    x: clippedViewportRect.width,
                    y: clippedViewportRect.height
                });
                canvasBottomRight.x = Math.min(_this.original.width, Math.ceil(canvasBottomRight.x));
                canvasBottomRight.y = Math.min(_this.original.height, Math.ceil(canvasBottomRight.y));
                var cw = canvasBottomRight.x - canvasTopLeft.x;
                var ch = canvasBottomRight.y - canvasTopLeft.y;
                onUpdateProps.textureWidth = cw;
                onUpdateProps.textureHeight = ch;
                onUpdateProps.transform = {
                    scaleX: 1,
                    scaleY: 1,
                    angleDeg: 0,
                    x: -canvasTopLeft.x,
                    y: -canvasTopLeft.y
                };
                resultTransform = (0, $dZ59l.compose)(resultTransform, (0, $kFecW.scale)(viewportTransform.scaleX, viewportTransform.scaleY), (0, $kr2fR.translate)(tlOffsetX, tlOffsetY));
            }
            if (!_this.texture || JSON.stringify(onUpdateProps) !== JSON.stringify(_this.oldOnUpdateProps) || _this.postMix) {
                // update texture
                _this.textureSource.width = onUpdateProps.textureWidth;
                _this.textureSource.height = onUpdateProps.textureHeight;
                // draw original canvas into temp
                _this.ctx.save();
                _this.ctx.imageSmoothingEnabled = false;
                if (viewportTransform.scaleX > 1) {
                    var _this_ctx;
                    transformMatrix = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(onUpdateProps.transform);
                    (_this_ctx = _this.ctx).setTransform.apply(_this_ctx, (0, $bX4ja._)((0, $c9ab5bbe74e01c89$export$2b60e7dafdbde18a)(transformMatrix)));
                } else {
                    var _this_ctx1;
                    transformMatrix = (0, $kDVZW.inverse)(resultTransform);
                    (_this_ctx1 = _this.ctx).setTransform.apply(_this_ctx1, (0, $bX4ja._)((0, $c9ab5bbe74e01c89$export$2b60e7dafdbde18a)(transformMatrix)));
                }
                _this.ctx.drawImage(_this.original, 0, 0);
                _this.ctx.restore();
                // debug
                /*BB.css(this.canvas, {
                position: 'absolute',
                left: '0',
                top: '0',
                zIndex: '1000',
                boxShadow: '0 0 0 1px #f00',
            });
            document.body.append(this.canvas);*/ var propsDidChange = JSON.stringify(onUpdateProps) !== JSON.stringify(_this.oldOnUpdateProps);
                if (!_this.texture || propsDidChange) {
                    if (_this.texture) _this.texture.loadContentsOf(_this.textureSource);
                    else _this.texture = _this.fxCanvas.texture(_this.textureSource);
                }
                if (_this.selection && (!_this.maskTexture || propsDidChange)) {
                    if (!_this.maskCanvas) _this.maskCanvas = (0, $eWjiX.BB).canvas(onUpdateProps.textureWidth, onUpdateProps.textureHeight);
                    else {
                        _this.maskCanvas.width = onUpdateProps.textureWidth;
                        _this.maskCanvas.height = onUpdateProps.textureHeight;
                    }
                    var ctx = (0, $eWjiX.BB).ctx(_this.maskCanvas);
                    var transformedSelection = (0, $bbA6w.transformMultiPolygon)(_this.selection, transformMatrix);
                    (0, $eIcQa.drawSelectionMask)(transformedSelection, ctx);
                    if (_this.maskTexture) _this.maskTexture.loadContentsOf(_this.maskCanvas);
                    else _this.maskTexture = _this.fxCanvas.texture(_this.maskCanvas);
                }
                if (!_this.postMix) {
                    _this.textureSource.width = 1;
                    _this.textureSource.height = 1;
                }
            }
            _this.oldOnUpdateProps = onUpdateProps;
            _this.onUpdate(_this.fxCanvas.draw(_this.texture), onUpdateProps.transform);
            if (_this.maskTexture) _this.fxCanvas.multiplyAlpha().mask(_this.maskTexture, _this.isMaskingWithEmptyOriginal ? undefined : _this.texture, true).unmultiplyAlpha();
            _this.fxCanvas.update();
            if (_this.postMix) {
                _this.ctx.save();
                _this.ctx.globalAlpha = _this.postMix.opacity;
                _this.ctx.globalCompositeOperation = _this.postMix.operation;
                _this.ctx.drawImage(_this.fxCanvas, 0, 0);
                _this.ctx.restore();
                return {
                    image: _this.textureSource,
                    transform: resultTransform
                };
            }
            return {
                image: _this.fxCanvas,
                transform: resultTransform
            };
        };
        this.original = p.original;
        this.onUpdate = p.onUpdate;
        this.textureSource = (0, $eWjiX.BB).canvas(1, 1);
        this.ctx = (0, $eWjiX.BB).ctx(this.textureSource);
        this.fxCanvas = (0, $7jh4K.throwIfNull)((0, $02a74dc72797630f$export$8c4423af32b21158)());
        this.postMix = p.postMix;
        this.selection = p.selection;
        this.isMaskingWithEmptyOriginal = !!p.isMaskingWithEmptyOriginal;
    }
    (0, $7h4XF._)(FxPreviewRenderer, [
        {
            key: "setPostMix",
            value: function setPostMix(postMix) {
                this.postMix = postMix;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var // I don't remember why the other texture is destroyed differently.
                _this_maskTexture;
                (0, $eWjiX.BB).freeCanvas(this.textureSource);
                this.maskCanvas && (0, $eWjiX.BB).freeCanvas(this.maskCanvas);
                if (this.texture) {
                    this.texture = this.fxCanvas.texture(this.textureSource);
                    this.fxCanvas.draw(this.texture).update();
                    this.texture && this.texture.destroy();
                }
                (_this_maskTexture = this.maskTexture) === null || _this_maskTexture === void 0 ? void 0 : _this_maskTexture.destroy();
            }
        }
    ]);
    return FxPreviewRenderer;
}();




var $eWjiX = parcelRequire("eWjiX");



var $eWjiX = parcelRequire("eWjiX");

var $eIcQa = parcelRequire("eIcQa");




function $670db093f8076d2c$export$66c6ccb6bcae2c94(context, selection, applyFn, klHistory) {
    var fxCanvas = (0, $02a74dc72797630f$export$8c4423af32b21158)();
    if (!fxCanvas) return false; // todo more specific error?
    var maskTexture;
    if (selection) {
        var maskCanvas = (0, $eWjiX.BB).canvas(context.canvas.width, context.canvas.height);
        var maskContext = (0, $eWjiX.BB).ctx(maskCanvas);
        (0, $eIcQa.drawSelectionMask)(selection, maskContext);
        maskTexture = fxCanvas.texture(maskCanvas);
        (0, $eWjiX.BB).freeCanvas(maskCanvas);
    }
    var originalTexture = fxCanvas.texture(context.canvas);
    fxCanvas.draw(originalTexture);
    applyFn(fxCanvas);
    if (maskTexture) {
        fxCanvas.multiplyAlpha().mask(maskTexture, originalTexture, true).unmultiplyAlpha();
        maskTexture.destroy();
    }
    originalTexture.destroy();
    fxCanvas.update();
    context.clearRect(0, 0, context.canvas.width, context.canvas.height);
    context.drawImage(fxCanvas, 0, 0);
    klHistory.push((0, $5bc59effccf14376$export$263fa670dc037098)(klHistory.getComposed(), (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(context.canvas, selection ? (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(selection, 'index') : undefined)));
    return true;
}



var $7jh4K = parcelRequire("7jh4K");
var $024aabab8b30bbfd$export$af433fb90aa90a38 = {
    getDialog (params) {
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall);
        var context = params.context;
        var klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        var brightness = 0, contrast = 0;
        var fxPreviewRenderer = new (0, $14b90ba44af68d49$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: function(fxCanvas) {
                return fxCanvas.brightnessContrast(brightness, contrast);
            },
            selection: klCanvas.getSelection()
        });
        var brightnessSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-bright-contrast-brightness'),
            width: 300,
            height: 30,
            min: 0,
            max: 100,
            value: (brightness + 1) * 50,
            eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
            onChange: function onChange(val) {
                brightness = val / 50 - 1;
                preview.render();
            }
        });
        var contrastSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-bright-contrast-contrast'),
            width: 300,
            height: 30,
            min: 0,
            max: 100,
            value: (contrast + 1) * 50,
            eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
            onChange: function onChange(val) {
                contrast = val / 50 - 1;
                preview.render();
            }
        });
        brightnessSlider.getElement().style.marginBottom = '10px';
        contrastSlider.getElement().style.marginBottom = '10px';
        rootEl.append(brightnessSlider.getElement(), contrastSlider.getElement());
        var previewLayerArr = [];
        for(var i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        var preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $7jh4K.css)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        result.destroy = function() {
            brightnessSlider.destroy();
            contrastSlider.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                brightness: brightness,
                contrast: contrast
            };
        };
        return result;
    },
    apply (params) {
        var context = params.layer.context;
        var brightness = params.input.brightness;
        var contrast = params.input.contrast;
        var klHistory = params.klHistory;
        if (!context) return false;
        return (0, $670db093f8076d2c$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), function(fxCanvas) {
            fxCanvas.brightnessContrast(brightness, contrast);
        }, klHistory);
    }
};



var $eWjiX = parcelRequire("eWjiX");

var $dJPtW = parcelRequire("dJPtW");







var $eg83P = parcelRequire("eg83P");
var $2680b5781517cb67$export$e5937df51b9e1d86 = {
    getDialog (params) {
        var klCanvas = params.klCanvas;
        if (!klCanvas) return false;
        var tempCanvas = (0, $eWjiX.BB).canvas();
        {
            var fit = (0, $eWjiX.BB).fitInto(klCanvas.getWidth(), klCanvas.getHeight(), 560, 400, 1);
            var w = parseInt('' + fit.width), h = parseInt('' + fit.height);
            var previewFactor = w / klCanvas.getWidth();
            tempCanvas.width = w;
            tempCanvas.height = h;
            tempCanvas.style.display = 'block';
            (0, $eWjiX.BB).ctx(tempCanvas).drawImage(klCanvas.getCompleteCanvas(previewFactor), 0, 0, w, h);
        }
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var left = 0, right = 0, top = 0, bottom = 0;
        var leftChanged = false, rightChanged = false, topChanged = false, bottomChanged = false;
        var maxWidth = params.maxWidth, maxHeight = params.maxHeight;
        var scale = 1;
        var selection = klCanvas.getSelection();
        var selectionBounds = selection ? (0, $eg83P.indexBoundsInArea)((0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(selection, 'index'), klCanvas.getWidth(), klCanvas.getHeight()) : undefined;
        if (selectionBounds) {
            var boundsWidth = selectionBounds.x2 - selectionBounds.x1 + 1;
            var boundsHeight = selectionBounds.y2 - selectionBounds.y1 + 1;
            if (boundsWidth <= maxWidth && boundsHeight <= maxHeight) {
                top = selectionBounds.y1;
                right = selectionBounds.x2 - klCanvas.getWidth();
                bottom = selectionBounds.y2 - klCanvas.getHeight();
                left = selectionBounds.x1;
            } else selectionBounds = undefined;
        }
        // --- input elements ---
        var leftInput = (0, $dJPtW.input)({
            init: left,
            type: 'number',
            min: -klCanvas.getWidth(),
            max: maxWidth,
            css: {
                width: '75px'
            },
            callback: function callback() {
                leftChanged = true;
                updateInput();
            }
        });
        var rightInput = (0, $dJPtW.input)({
            init: right,
            type: 'number',
            min: -klCanvas.getWidth(),
            max: maxWidth,
            css: {
                width: '75px'
            },
            callback: function callback() {
                rightChanged = true;
                updateInput();
            }
        });
        var topInput = (0, $dJPtW.input)({
            init: top,
            type: 'number',
            min: -klCanvas.getHeight(),
            max: maxHeight,
            css: {
                width: '75px'
            },
            callback: function callback() {
                topChanged = true;
                updateInput();
            }
        });
        var bottomInput = (0, $dJPtW.input)({
            init: bottom,
            type: 'number',
            min: -klCanvas.getHeight(),
            max: maxHeight,
            css: {
                width: '75px'
            },
            callback: function callback() {
                bottomChanged = true;
                updateInput();
            }
        });
        var sharedCss = {
            display: 'flex',
            flexDirection: 'column',
            width: 'calc(50% - 5px)',
            gap: '3px'
        };
        var leftWrapper = (0, $eWjiX.BB).el({
            content: [
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-crop-left') + ':',
                leftInput
            ],
            css: sharedCss
        });
        var rightWrapper = (0, $eWjiX.BB).el({
            content: [
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-crop-right') + ':',
                rightInput
            ],
            css: sharedCss
        });
        var topWrapper = (0, $eWjiX.BB).el({
            content: [
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-crop-top') + ':',
                topInput
            ],
            css: sharedCss
        });
        var bottomWrapper = (0, $eWjiX.BB).el({
            content: [
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-crop-bottom') + ':',
                bottomInput
            ],
            css: sharedCss
        });
        var wrapWrapper = (0, $eWjiX.BB).el({
            css: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '10px'
            }
        });
        wrapWrapper.append(leftWrapper, rightWrapper, topWrapper, bottomWrapper);
        rootEl.append(wrapWrapper);
        function updateInput() {
            left = parseInt(leftInput.value);
            right = parseInt(rightInput.value);
            top = parseInt(topInput.value);
            bottom = parseInt(bottomInput.value);
            var newWidth = klCanvas.getWidth() + left + right;
            var newHeight = klCanvas.getHeight() + top + bottom;
            if (newWidth <= 0) {
                if (leftChanged) {
                    left = -klCanvas.getWidth() - right + 1;
                    leftInput.value = '' + left;
                }
                if (rightChanged) {
                    right = -klCanvas.getWidth() - left + 1;
                    rightInput.value = '' + right;
                }
                newWidth = 1;
            }
            if (newWidth > maxWidth) {
                if (leftChanged) {
                    left = -klCanvas.getWidth() - right + maxWidth;
                    leftInput.value = '' + left;
                }
                if (rightChanged) {
                    right = -klCanvas.getWidth() - left + maxWidth;
                    rightInput.value = '' + right;
                }
                newWidth = maxWidth;
            }
            if (newHeight <= 0) {
                if (topChanged) {
                    top = -klCanvas.getHeight() - bottom + 1;
                    topInput.value = '' + top;
                }
                if (bottomChanged) {
                    bottom = -klCanvas.getHeight() - top + 1;
                    bottomInput.value = '' + bottom;
                }
                newHeight = 1;
            }
            if (newHeight > maxHeight) {
                if (topChanged) {
                    top = -klCanvas.getHeight() - bottom + maxHeight;
                    topInput.value = '' + top;
                }
                if (bottomChanged) {
                    bottom = -klCanvas.getHeight() - top + maxHeight;
                    bottomInput.value = '' + bottom;
                }
                newHeight = maxHeight;
            }
            cropper.setTransform({
                x: -left,
                y: -top,
                width: newWidth,
                height: newHeight
            });
            leftChanged = false;
            rightChanged = false;
            topChanged = false;
            bottomChanged = false;
        }
        var useRuleOfThirds = true;
        var ruleOThirdsCheckbox = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-crop-rule-thirds'),
            allowTab: true,
            callback: function callback(b) {
                useRuleOfThirds = b;
                cropper.showThirds(useRuleOfThirds);
            },
            name: 'rule-of-thirds'
        });
        rootEl.append((0, $eWjiX.BB).el({
            css: {
                clear: 'both'
            }
        }));
        var selectedRgbaObj = {
            r: 0,
            g: 0,
            b: 0,
            a: 0
        };
        var colorOptionsArr = [
            {
                r: 0,
                g: 0,
                b: 0,
                a: 0
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            },
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            }
        ];
        colorOptionsArr.push({
            r: params.currentColorRgb.r,
            g: params.currentColorRgb.g,
            b: params.currentColorRgb.b,
            a: 1
        });
        colorOptionsArr.push({
            r: params.secondaryColorRgb.r,
            g: params.secondaryColorRgb.g,
            b: params.secondaryColorRgb.b,
            a: 1
        });
        var colorOptions = new (0, $4db8cbbb01889095$export$24ba9b81662d4366)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-crop-fill'),
            colorArr: colorOptionsArr,
            onChange: function onChange(rgbaObj) {
                selectedRgbaObj = rgbaObj;
                updateBg();
            }
        });
        var flexRow = (0, $eWjiX.BB).el({
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '10px'
            }
        });
        rootEl.append(flexRow);
        flexRow.append(ruleOThirdsCheckbox.getElement(), colorOptions.getElement());
        // when input field changed, or dragging in preview finished
        // adjusts the zoom
        function update(transform) {
            var fit = (0, $eWjiX.BB).fitInto(transform.width, transform.height, 260, 180, 1);
            scale = fit.width / transform.width;
            var offset = (0, $eWjiX.BB).centerWithin((0, $a433d11ad38d7c38$export$ec2d17c6d3ae0768).width, previewHeight, fit.width, fit.height);
            tempCanvas.style.width = klCanvas.getWidth() * scale + 'px';
            tempCanvas.style.height = klCanvas.getHeight() * scale + 'px';
            offsetWrapper.style.left = offset.x - transform.x * scale + 'px';
            offsetWrapper.style.top = offset.y - transform.y * scale + 'px';
            left = parseInt('' + -transform.x);
            top = parseInt('' + -transform.y);
            right = parseInt('' + (transform.x + transform.width - klCanvas.getWidth()));
            bottom = parseInt('' + (transform.y + transform.height - klCanvas.getHeight()));
            leftInput.value = '' + left;
            topInput.value = '' + top;
            rightInput.value = '' + right;
            bottomInput.value = '' + bottom;
            if (selectedRgbaObj.a !== 0) {
                tempCanvas.style.background = 'var(--kl-checkerboard-background)';
                tempCanvas.style.backgroundSize = 100 * scale + 'px';
            }
            previewWrapper.style.backgroundPosition = offset.x + 'px ' + offset.y + 'px';
            previewWrapper.style.backgroundSize = 100 * scale + 'px';
            cropper.setScale(scale);
        }
        var previewHeight = (0, $a433d11ad38d7c38$export$ec2d17c6d3ae0768).height - 2; // two less because of border
        var previewWrapper = (0, $eWjiX.BB).el({
            className: 'kl-edit-crop-preview',
            css: {
                width: (0, $a433d11ad38d7c38$export$ec2d17c6d3ae0768).width + 'px',
                marginTop: '10px',
                marginLeft: '-20px',
                height: previewHeight + 'px',
                backgroundColor: '#9e9e9e',
                position: 'relative',
                borderTop: '1px solid rgb(144,144,144)',
                borderBottom: '1px solid rgb(144,144,144)',
                overflow: 'hidden',
                userSelect: 'none',
                touchAction: 'none',
                background: 'var(--kl-checkerboard-background)'
            }
        });
        previewWrapper.oncontextmenu = function() {
            return false;
        };
        var bgColorOverlay = (0, $eWjiX.BB).el({
            css: {
                position: 'absolute',
                left: '0',
                top: '0',
                bottom: '0',
                right: '0'
            }
        });
        previewWrapper.append(bgColorOverlay);
        var offsetWrapper = (0, $eWjiX.BB).el({
            parent: previewWrapper,
            css: {
                position: 'absolute',
                left: '0',
                top: '0'
            }
        });
        (0, $eWjiX.BB).el({
            parent: offsetWrapper,
            content: tempCanvas,
            css: {
                boxShadow: '0 0 0px 1px rgb(130,130,130)',
                position: 'absolute',
                left: '0px',
                top: '0px'
            }
        });
        rootEl.append(previewWrapper);
        var cropper = new (0, $de496a1759b04ed9$export$71ed2b85d4ca43d3)({
            x: 0,
            y: 0,
            width: klCanvas.getWidth(),
            height: klCanvas.getHeight(),
            scale: scale,
            callback: update,
            maxW: maxWidth,
            maxH: maxHeight,
            init: selectionBounds
        });
        update(cropper.getTransform());
        offsetWrapper.append(cropper.getElement());
        function updateBg() {
            if (selectedRgbaObj.a === 0) {
                bgColorOverlay.style.background = '';
                tempCanvas.style.background = '';
            } else {
                bgColorOverlay.style.background = (0, $eWjiX.BB).ColorConverter.toRgbStr(selectedRgbaObj);
                tempCanvas.style.background = 'var(--kl-checkerboard-background)';
                tempCanvas.style.backgroundSize = 100 * scale + 'px';
            }
        }
        result.destroy = function() {
            cropper.destroy();
            ruleOThirdsCheckbox.destroy();
            colorOptions.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                left: left,
                right: right,
                top: top,
                bottom: bottom,
                fillColor: selectedRgbaObj.a === 0 ? undefined : selectedRgbaObj
            };
        };
        return result;
    },
    apply (params) {
        var klCanvas = params.klCanvas;
        if (!klCanvas || isNaN(params.input.left) || isNaN(params.input.right) || isNaN(params.input.top) || isNaN(params.input.bottom)) return false;
        klCanvas.resizeCanvas(params.input);
        return true;
    }
};



var $eWjiX = parcelRequire("eWjiX");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");



var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");
function $81ac57466912ccc9$export$4300cf0a0df418a6() {
    return (0, $eWjiX.BB).copyObj({
        r: [
            [
                0,
                0
            ],
            [
                1 / 3,
                1 / 3
            ],
            [
                2 / 3,
                2 / 3
            ],
            [
                1,
                1
            ]
        ],
        g: [
            [
                0,
                0
            ],
            [
                1 / 3,
                1 / 3
            ],
            [
                2 / 3,
                2 / 3
            ],
            [
                1,
                1
            ]
        ],
        b: [
            [
                0,
                0
            ],
            [
                1 / 3,
                1 / 3
            ],
            [
                2 / 3,
                2 / 3
            ],
            [
                1,
                1
            ]
        ]
    });
}
var $81ac57466912ccc9$export$1c43bf66c2a2e4da = /*#__PURE__*/ function() {
    "use strict";
    function CurvesInput(p) {
        var _this = this;
        (0, $cx0mh._)(this, CurvesInput);
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                position: 'relative',
                marginBottom: '10px'
            }
        });
        this.rootEl.oncontextmenu = function() {
            return false;
        };
        var mode = 'All';
        var curves = p.curves;
        this.modeButtons = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'All',
                    label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-curves-all')
                },
                {
                    id: 'Red',
                    label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('red')
                },
                {
                    id: 'Green',
                    label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('green')
                },
                {
                    id: 'Blue',
                    label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('blue')
                }
            ],
            initId: 'All',
            onChange: function(id) {
                mode = id;
                if (mode === 'All') curves = $81ac57466912ccc9$export$4300cf0a0df418a6();
                var curve = curves.r;
                if (mode === 'Green') curve = curves.g;
                if (mode === 'Blue') curve = curves.b;
                _this.p0.setPos(0, areaH - curve[0][1] * areaH);
                _this.p1.setPos(curve[1][0] * areaW, areaH - curve[1][1] * areaH);
                _this.p2.setPos(curve[2][0] * areaW, areaH - curve[2][1] * areaH);
                _this.p3.setPos(areaW, areaH - curve[3][1] * areaH);
                update();
            }
        });
        this.rootEl.append(this.modeButtons.getElement());
        var curveArea = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            className: 'kl-curves-graph',
            css: {
                position: 'relative',
                marginTop: '10px'
            }
        });
        var areaW = 300, areaH = 100;
        var canvas = (0, $eWjiX.BB).canvas(areaW, areaH);
        var ctx = (0, $eWjiX.BB).ctx(canvas);
        curveArea.append(canvas);
        var fit = function(v) {
            return Math.max(0, Math.min(1, v));
        };
        var createPoint = function(x, y, callback, lock) {
            var gripSize = 14;
            var internalY = y, internalX = x;
            var pointEl = (0, $eWjiX.BB).el({
                className: 'kl-curves-graph__grip',
                css: {
                    left: x - gripSize / 2 + 'px',
                    top: y - gripSize / 2 + 'px',
                    width: gripSize + 'px',
                    height: gripSize + 'px',
                    borderRadius: gripSize + 'px'
                }
            });
            var update = function() {
                (0, $7jh4K.css)(pointEl, {
                    left: x - gripSize / 2 + 'px',
                    top: y - gripSize / 2 + 'px'
                });
            };
            var pointerListener = new (0, $eWjiX.BB).PointerListener({
                target: pointEl,
                onPointer: function(event) {
                    event.eventPreventDefault();
                    if (event.type === 'pointerdown') {
                        internalX = x;
                        internalY = y;
                    }
                    if (event.button === 'left' && event.type === 'pointermove') {
                        if (!lock) internalX += event.dX;
                        x = Math.max(0, Math.min(areaW, internalX));
                        internalY += event.dY;
                        y = Math.max(0, Math.min(areaH, internalY));
                        update();
                        callback({
                            x: x,
                            y: y
                        });
                    }
                }
            });
            curveArea.append(pointEl);
            var setPos = function(newX, newY) {
                x = newX;
                y = newY;
                internalY = y;
                internalX = x;
                (0, $7jh4K.css)(pointEl, {
                    left: x - gripSize / 2 + 'px',
                    top: y - gripSize / 2 + 'px'
                });
            };
            return {
                el: pointEl,
                setPos: setPos,
                pointerListener: pointerListener
            };
        };
        var updateControl = function(i, x, y) {
            if (mode === 'All') {
                curves.r[i] = [
                    fit(x / areaW),
                    fit(1 - y / areaH)
                ];
                curves.g[i] = [
                    fit(x / areaW),
                    fit(1 - y / areaH)
                ];
                curves.b[i] = [
                    fit(x / areaW),
                    fit(1 - y / areaH)
                ];
            }
            if (mode === 'Red') curves.r[i] = [
                fit(x / areaW),
                fit(1 - y / areaH)
            ];
            if (mode === 'Green') curves.g[i] = [
                fit(x / areaW),
                fit(1 - y / areaH)
            ];
            if (mode === 'Blue') curves.b[i] = [
                fit(x / areaW),
                fit(1 - y / areaH)
            ];
        };
        this.p0 = createPoint(0, areaH, function(val) {
            updateControl(0, val.x, val.y);
            update();
        }, true);
        this.p1 = createPoint(areaW / 3, areaH / 3 * 2, function(val) {
            updateControl(1, val.x, val.y);
            update();
        });
        this.p2 = createPoint(areaW / 3 * 2, areaH / 3, function(val) {
            updateControl(2, val.x, val.y);
            update();
        });
        this.p3 = createPoint(areaW, 0, function(val) {
            updateControl(3, val.x, val.y);
            update();
        }, true);
        var update = function() {
            ctx = (0, $eWjiX.BB).ctx(canvas);
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            var outCurves = {
                r: [],
                g: [],
                b: []
            };
            for(var i = 0; i < curves.r.length; i++){
                outCurves.r.push(curves.r[i]);
                outCurves.g.push(curves.g[i]);
                outCurves.b.push(curves.b[i]);
            }
            var drawCurve = function(curve) {
                ctx.beginPath();
                var spline = new (0, $eWjiX.BB).SplineInterpolator(curve);
                for(var i = 0; i < 100; i++){
                    var y = spline.interpolate(i / 100);
                    y = Math.max(0, Math.min(1, y));
                    if (i === 0) ctx.moveTo(i / 100 * areaW, areaH - y * areaH);
                    else ctx.lineTo(i / 100 * areaW, areaH - y * areaH);
                }
                ctx.stroke();
            };
            ctx.save();
            if (mode === 'All') {
                ctx.strokeStyle = 'black';
                drawCurve(outCurves.r);
            } else {
                ctx.globalAlpha = 0.5;
                ctx.strokeStyle = 'red';
                drawCurve(outCurves.r);
                ctx.strokeStyle = 'green';
                drawCurve(outCurves.g);
                ctx.strokeStyle = 'blue';
                drawCurve(outCurves.b);
            }
            ctx.restore();
            p.callback(outCurves);
        };
        update();
    }
    (0, $7h4XF._)(CurvesInput, [
        {
            // ---- interface ----
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getModeButtons",
            value: function getModeButtons() {
                return this.modeButtons;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.p0.pointerListener.destroy();
                this.p1.pointerListener.destroy();
                this.p2.pointerListener.destroy();
                this.p3.pointerListener.destroy();
            }
        }
    ]);
    return CurvesInput;
}();








var $7jh4K = parcelRequire("7jh4K");
var $4c948640eb8ef791$export$309483fcb6d5c7ca = {
    getDialog (params) {
        var context = params.context;
        var klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall);
        var curves = (0, $81ac57466912ccc9$export$4300cf0a0df418a6)();
        var fxPreviewRenderer = new (0, $14b90ba44af68d49$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: function(fxCanvas) {
                return fxCanvas.curves(curves.r, curves.g, curves.b);
            },
            selection: klCanvas.getSelection()
        });
        var previewLayerArr = [];
        for(var i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        var preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        (0, $7jh4K.css)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        var input = new (0, $81ac57466912ccc9$export$1c43bf66c2a2e4da)({
            curves: curves,
            callback: function callback(val) {
                curves = val;
                preview.render();
            }
        });
        var modeButtons = input.getModeButtons();
        rootEl.append(input.getElement(), preview.getElement());
        result.destroy = function() {
            input.destroy();
            modeButtons.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                curves: curves
            };
        };
        return result;
    },
    apply (params) {
        var context = params.layer.context;
        var curves = params.input.curves;
        var klHistory = params.klHistory;
        if (!context) return false;
        return (0, $670db093f8076d2c$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), function(fxCanvas) {
            fxCanvas.curves(curves.r, curves.g, curves.b);
        }, klHistory);
    }
};



var $eWjiX = parcelRequire("eWjiX");




var $7jh4K = parcelRequire("7jh4K");


var $6b01e1931d168e01$export$9b1b7b3985b9625a = {
    getDialog (params) {
        var context = params.context;
        var klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        var fit = (0, $eWjiX.BB).fitInto(context.canvas.width, context.canvas.height, 280, 200, 1);
        var w = parseInt('' + fit.width), h = parseInt('' + fit.height);
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var isHorizontal = true;
        var isVertical = false;
        var doFlipCanvas = true;
        var horizontalCheckbox = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: isHorizontal,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-flip-horizontal') + " \u27F7",
            allowTab: true,
            callback: function callback(v) {
                isHorizontal = v;
                updatePreview();
            },
            css: {
                marginBottom: '10px'
            },
            name: 'flip-horizontal'
        });
        var verticalCheckbox = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: isVertical,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-flip-vertical') + " \u2195",
            allowTab: true,
            callback: function callback(v) {
                isVertical = v;
                updatePreview();
            },
            css: {
                marginBottom: '10px'
            },
            name: 'flip-vertical'
        });
        rootEl.append(horizontalCheckbox.getElement());
        rootEl.append(verticalCheckbox.getElement());
        var targetOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: true,
                    label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-flip-image')
                },
                {
                    id: false,
                    label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-flip-layer')
                }
            ],
            onChange: function(val) {
                doFlipCanvas = val;
                updatePreview();
            }
        });
        rootEl.append(targetOptions.getElement());
        var previewWrapper = (0, $eWjiX.BB).el({
            className: 'kl-preview-wrapper',
            css: {
                width: (0, $a433d11ad38d7c38$export$ec2d17c6d3ae0768).width + 'px',
                height: (0, $a433d11ad38d7c38$export$ec2d17c6d3ae0768).height + 'px'
            }
        });
        var previewLayer = {
            image: (0, $eWjiX.BB).canvas(Math.round(w), Math.round(h)),
            isVisible: true,
            opacity: 1,
            mixModeStr: 'source-over'
        };
        var klCanvasPreview = new (0, $e6889b231e436752$export$e258ade1648009b7)({
            width: Math.round(w),
            height: Math.round(h),
            layers: [
                previewLayer
            ]
        });
        var previewInnerWrapper = (0, $eWjiX.BB).el({
            className: 'kl-preview-wrapper__canvas',
            css: {
                width: parseInt('' + w) + 'px',
                height: parseInt('' + h) + 'px'
            }
        });
        previewInnerWrapper.append(klCanvasPreview.getElement());
        previewWrapper.append(previewInnerWrapper);
        function updatePreview() {
            var ctx = (0, $eWjiX.BB).ctx(previewLayer.image);
            ctx.save();
            ctx.clearRect(0, 0, previewLayer.image.width, previewLayer.image.height);
            if (doFlipCanvas) {
                if (isHorizontal) {
                    ctx.translate(previewLayer.image.width, 0);
                    ctx.scale(-1, 1);
                }
                if (isVertical) {
                    ctx.translate(0, previewLayer.image.height);
                    ctx.scale(1, -1);
                }
            }
            for(var i = 0; i < layers.length; i++){
                if (!layers[i].isVisible) continue;
                ctx.save();
                if (!doFlipCanvas && selectedLayerIndex === i) {
                    if (isHorizontal) {
                        ctx.translate(previewLayer.image.width, 0);
                        ctx.scale(-1, 1);
                    }
                    if (isVertical) {
                        ctx.translate(0, previewLayer.image.height);
                        ctx.scale(1, -1);
                    }
                }
                if (ctx.canvas.width > layers[i].context.canvas.width) ctx.imageSmoothingEnabled = false;
                ctx.globalAlpha = layers[i].opacity;
                ctx.globalCompositeOperation = layers[i].mixModeStr;
                ctx.drawImage(layers[i].context.canvas, 0, 0, previewLayer.image.width, previewLayer.image.height);
                ctx.restore();
            }
            klCanvasPreview.render();
            ctx.restore();
        }
        setTimeout(updatePreview, 0);
        rootEl.append(previewWrapper);
        result.destroy = function() {
            horizontalCheckbox.destroy();
            verticalCheckbox.destroy();
            targetOptions.destroy();
            klCanvasPreview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                horizontal: isHorizontal,
                vertical: isVertical,
                flipCanvas: doFlipCanvas
            };
        };
        return result;
    },
    apply (params) {
        var context = params.layer.context;
        var klCanvas = params.klCanvas;
        var horizontal = params.input.horizontal;
        var vertical = params.input.vertical;
        var flipCanvas = params.input.flipCanvas;
        if (!context || !klCanvas) return false;
        klCanvas.flip(horizontal, vertical, flipCanvas ? undefined : (0, $7jh4K.throwIfNull)(klCanvas.getLayerIndex(context.canvas)));
        return true;
    }
};








var $eWjiX = parcelRequire("eWjiX");




var $7jh4K = parcelRequire("7jh4K");
var $041c656037c77a96$export$2aa46bd5587f0eb = {
    getDialog (params) {
        var context = params.context;
        var klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall);
        var hue = 0, saturation = 0;
        var fxPreviewRenderer = new (0, $14b90ba44af68d49$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: function(fxCanvas) {
                return fxCanvas.hueSaturation(hue, saturation);
            },
            selection: klCanvas.getSelection()
        });
        var hueSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-hue-sat-hue'),
            width: 300,
            height: 30,
            min: -100,
            max: 100,
            value: hue * 100,
            eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
            onChange: function onChange(val) {
                hue = val / 100;
                preview.render();
            }
        });
        var saturationSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-hue-sat-saturation'),
            width: 300,
            height: 30,
            min: 0,
            max: 100,
            value: (saturation + 1) * 50,
            eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
            onChange: function onChange(val) {
                saturation = val / 50 - 1;
                preview.render();
            }
        });
        hueSlider.getElement().style.marginBottom = '10px';
        saturationSlider.getElement().style.marginBottom = '10px';
        rootEl.append(hueSlider.getElement(), saturationSlider.getElement());
        var previewLayerArr = [];
        for(var i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        var preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $7jh4K.css)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        result.destroy = function() {
            hueSlider.destroy();
            saturationSlider.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                hue: hue,
                saturation: saturation
            };
        };
        return result;
    },
    apply (params) {
        var context = params.layer.context;
        var hue = params.input.hue;
        var klHistory = params.klHistory;
        var saturation = params.input.saturation;
        if (!context || hue === null || saturation === null) return false;
        return (0, $670db093f8076d2c$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), function(fxCanvas) {
            fxCanvas.hueSaturation(hue, saturation);
        }, klHistory);
    }
};



var $82b3d1ba61b3412f$export$b7ebcfbdc840ef76 = {
    apply (params) {
        var context = params.layer.context;
        var klHistory = params.klHistory;
        if (!context) return false;
        return (0, $670db093f8076d2c$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), function(fxCanvas) {
            fxCanvas.invert();
        }, klHistory);
    }
};



var $bX4ja = parcelRequire("bX4ja");

var $eWjiX = parcelRequire("eWjiX");



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $8b4f5ae4fe73ff76$export$b1241e74876d9bbe = /*#__PURE__*/ function() {
    "use strict";
    function TwoTabs(p) {
        var _this = this;
        (0, $cx0mh._)(this, TwoTabs);
        this.value = p.init;
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'kl-2-tabs'
        });
        this.leftTab = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            content: p.left,
            className: 'kl-2-tabs__left'
        });
        this.leftTab.onpointerdown = function() {
            return false;
        };
        this.rightTab = (0, $eWjiX.BB).el({
            parent: this.rootEl,
            content: p.right,
            className: 'kl-2-tabs__right'
        });
        this.rightTab.onpointerdown = function() {
            return false;
        };
        this.update();
        this.leftTab.onclick = function() {
            if (_this.value === 0) return;
            _this.value = 0;
            _this.update();
            p.onChange(_this.value);
        };
        this.rightTab.onclick = function() {
            if (_this.value === 1) return;
            _this.value = 1;
            _this.update();
            p.onChange(_this.value);
        };
    }
    (0, $7h4XF._)(TwoTabs, [
        {
            key: "update",
            value: function update() {
                this.leftTab.classList.toggle('kl-2-tabs--active', this.value === 0);
                this.rightTab.classList.toggle('kl-2-tabs--active', this.value === 1);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return TwoTabs;
}();


parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");


var $7jh4K = parcelRequire("7jh4K");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $eWjiX = parcelRequire("eWjiX");
parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");


var $7jh4K = parcelRequire("7jh4K");
var $1ca80fac51ad2a2d$var$SIZE = 16;
var $1ca80fac51ad2a2d$export$87247fc399965417 = /*#__PURE__*/ function() {
    "use strict";
    function DraggableInput(p) {
        var _this = this;
        (0, $cx0mh._)(this, DraggableInput);
        this.value = (0, $cL71g._)({}, p.value);
        this.transform = {
            x: 0,
            y: 0,
            scale: 1,
            angleDeg: 0
        };
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                width: $1ca80fac51ad2a2d$var$SIZE + 'px',
                height: $1ca80fac51ad2a2d$var$SIZE + 'px',
                backgroundColor: '#fff',
                border: '2px solid #000',
                borderRadius: $1ca80fac51ad2a2d$var$SIZE + 'px',
                position: 'absolute',
                cursor: 'move',
                userSelect: 'none',
                touchAction: 'none'
            }
        });
        this.pointerListener = new (0, $eWjiX.BB).PointerListener({
            target: this.rootEl,
            onPointer: function(event) {
                event.eventPreventDefault();
                if (event.button === 'left' && event.type === 'pointermove') {
                    _this.value.x += event.dX / _this.transform.scale;
                    _this.value.y += event.dY / _this.transform.scale;
                    _this.update();
                    p.onChange(_this.value);
                }
            }
        });
    }
    (0, $7h4XF._)(DraggableInput, [
        {
            key: "update",
            value: function update() {
                var p = (0, $cdZRx.applyToPoint)((0, $92816524e1b72be4$export$ad1d215dd03fe75a)(this.transform), this.value);
                (0, $7jh4K.css)(this.rootEl, {
                    left: p.x - $1ca80fac51ad2a2d$var$SIZE / 2 + 'px',
                    top: p.y - $1ca80fac51ad2a2d$var$SIZE / 2 + 'px'
                });
            }
        },
        {
            key: "setTransform",
            value: function setTransform(transform) {
                if (JSON.stringify(this.transform) === JSON.stringify(transform)) return;
                this.transform = transform;
                this.update();
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.value;
            }
        },
        {
            key: "setValue",
            value: function setValue(p) {
                this.value = (0, $cL71g._)({}, p);
                this.update();
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.rootEl.remove();
                this.pointerListener.destroy();
            }
        }
    ]);
    return DraggableInput;
}();





var $460859cbeb601dec$export$a76d798fa7d85e4e = {
    getDialog (params) {
        var _preview_getElement;
        var context = params.context;
        var klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$3a4a74a7d8c44e62).width;
        var fxCanvas = (0, $7jh4K.throwIfNull)((0, $02a74dc72797630f$export$8c4423af32b21158)());
        var texture = (0, $7jh4K.throwIfUndefined)(fxCanvas === null || fxCanvas === void 0 ? void 0 : fxCanvas.texture(context.canvas));
        function update() {
            if (isBefore) fxCanvas.draw(texture).update();
            else fxCanvas.draw(texture).perspective(getFlatArr(beforeInputs), getFlatArr(afterInputs)).update();
            preview.render();
        }
        var rectPoints = [
            {
                x: 0,
                y: 0
            },
            {
                x: context.canvas.width,
                y: 0
            },
            {
                x: context.canvas.width,
                y: context.canvas.height
            },
            {
                x: 0,
                y: context.canvas.height
            }
        ];
        var beforeInputs = rectPoints.map(function(point) {
            return new (0, $1ca80fac51ad2a2d$export$87247fc399965417)({
                value: point,
                onChange: function() {
                    update();
                }
            });
        });
        beforeInputs.forEach(function(item) {
            return item.getElement().style.display = 'none';
        });
        var afterInputs = rectPoints.map(function(point) {
            return new (0, $1ca80fac51ad2a2d$export$87247fc399965417)({
                value: point,
                onChange: function() {
                    update();
                }
            });
        });
        function getFlatArr(inputs, matrix) {
            return inputs.flatMap(function(item) {
                var value = item.getValue();
                if (matrix) value = (0, $cdZRx.applyToPoint)(matrix, value);
                return [
                    value.x,
                    value.y
                ];
            });
        }
        var isBefore = false;
        var beforeAfterTabs = new (0, $8b4f5ae4fe73ff76$export$b1241e74876d9bbe)({
            left: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('compare-before'),
            right: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('compare-after'),
            init: 1,
            onChange: function(val) {
                isBefore = val === 0;
                if (isBefore) {
                    beforeInputs.forEach(function(item) {
                        return item.getElement().style.display = 'block';
                    });
                    afterInputs.forEach(function(item) {
                        return item.getElement().style.display = 'none';
                    });
                } else {
                    beforeInputs.forEach(function(item, index) {
                        afterInputs[index].setValue(item.getValue());
                    });
                    beforeInputs.forEach(function(item) {
                        return item.getElement().style.display = 'none';
                    });
                    afterInputs.forEach(function(item) {
                        return item.getElement().style.display = 'block';
                    });
                }
                update();
            }
        });
        rootEl.append(beforeAfterTabs.getElement());
        var previewLayerArr = [];
        for(var i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxCanvas : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        var preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            onTransformChange: function(transform) {
                beforeInputs.forEach(function(item) {
                    return item.setTransform(transform);
                });
                afterInputs.forEach(function(item) {
                    return item.setTransform(transform);
                });
            }
        });
        (0, $7jh4K.css)(preview.getElement(), {
            overflow: 'hidden',
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        (_preview_getElement = preview.getElement()).append.apply(_preview_getElement, (0, $bX4ja._)(beforeInputs.map(function(item) {
            return item.getElement();
        })).concat((0, $bX4ja._)(afterInputs.map(function(item) {
            return item.getElement();
        }))));
        rootEl.append(preview.getElement());
        update();
        result.destroy = function() {
            preview.destroy();
            texture.destroy();
            beforeInputs.forEach(function(item) {
                return item.destroy();
            });
            afterInputs.forEach(function(item) {
                return item.destroy();
            });
        };
        result.getInput = function() {
            result.destroy();
            return {
                before: getFlatArr(beforeInputs),
                after: getFlatArr(afterInputs)
            };
        };
        return result;
    },
    apply (params) {
        var context = params.layer.context;
        var klHistory = params.klHistory;
        var before = params.input.before;
        var after = params.input.after;
        if (!context || !before || !after) return false;
        var fxCanvas = (0, $02a74dc72797630f$export$8c4423af32b21158)();
        if (!fxCanvas) return false; // todo more specific error?
        var texture = fxCanvas.texture(context.canvas);
        fxCanvas.draw(texture).multiplyAlpha().perspective(before, after).unmultiplyAlpha().update();
        context.clearRect(0, 0, context.canvas.width, context.canvas.height);
        context.drawImage(fxCanvas, 0, 0);
        texture.destroy();
        {
            var layerMap = Object.fromEntries(params.klCanvas.getLayers().map(function(layerItem) {
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push({
                layerMap: layerMap
            });
        }
        return true;
    }
};



var $eWjiX = parcelRequire("eWjiX");


var $10acd09ea053c7b9$exports = {};
$10acd09ea053c7b9$exports = $parcel$resolve("2BZYe");






var $7jh4K = parcelRequire("7jh4K");
var $63d62a20f3ba2c7d$export$5705240d31427a82 = {
    getDialog (params) {
        //BB.centerWithin
        var klCanvas = params.klCanvas;
        if (!klCanvas) return false;
        var fit = (0, $eWjiX.BB).fitInto(klCanvas.getWidth(), klCanvas.getHeight(), 280, 200, 1);
        var w = parseInt('' + fit.width), h = parseInt('' + fit.height);
        var previewFactor = w / klCanvas.getWidth();
        var tempCanvas = klCanvas.getCompleteCanvas(1);
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var newWidth = klCanvas.getWidth(), newHeight = klCanvas.getHeight();
        var maxWidth = params.maxWidth, maxHeight = params.maxHeight;
        var widthWrapper = (0, $eWjiX.BB).el({
            css: {
                width: '150px',
                height: '35px',
                lineHeight: '30px'
            }
        });
        var heightWrapper = (0, $eWjiX.BB).el({
            css: {
                width: '150px',
                height: '35px',
                lineHeight: '30px'
            }
        });
        var widthInput = (0, $eWjiX.BB).el({
            tagName: 'input',
            css: {
                cssFloat: 'right',
                width: '90px'
            },
            custom: {
                type: 'number',
                min: '1',
                max: '' + maxWidth,
                value: '' + klCanvas.getWidth()
            }
        });
        var heightInput = (0, $eWjiX.BB).el({
            tagName: 'input',
            css: {
                cssFloat: 'right',
                width: '90px'
            },
            custom: {
                type: 'number',
                min: '1',
                max: '' + maxHeight,
                value: '' + klCanvas.getHeight()
            }
        });
        widthInput.onclick = function() {
            this.focus();
            widthChanged = true;
            update();
        };
        heightInput.onclick = function() {
            this.focus();
            heightChanged = true;
            update();
        };
        widthInput.onchange = function() {
            widthChanged = true;
            update();
        };
        heightInput.onchange = function() {
            heightChanged = true;
            update();
        };
        widthWrapper.append((0, $8d7403abedf7cefa$export$ce37e184d908d785)('width') + ': ', widthInput);
        heightWrapper.append((0, $8d7403abedf7cefa$export$ce37e184d908d785)('height') + ': ', heightInput);
        var inputWrapper = (0, $eWjiX.BB).el({
            css: {
                background: 'url(' + (0, (/*@__PURE__*/$parcel$interopDefault($10acd09ea053c7b9$exports))) + ') no-repeat 140px 5px',
                backgroundSize: '50px 52px'
            }
        });
        inputWrapper.append(widthWrapper, heightWrapper);
        var constrainIm = new Image();
        constrainIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($10acd09ea053c7b9$exports)));
        constrainIm.height = 40;
        var sizeTable = (0, $96366ef7b36c82a7$export$9852986a3ec5f6a0)([
            [
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('width') + ':&nbsp;',
                widthInput,
                constrainIm
            ],
            [
                (0, $eWjiX.BB).el({
                    css: {
                        height: '5px'
                    }
                }),
                '',
                ''
            ],
            [
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('height') + ':&nbsp;',
                heightInput
            ]
        ], {
            '0.2': {
                rowspan: 3
            }
        });
        (0, $7jh4K.css)(sizeTable, {
            marginBottom: '10px'
        });
        rootEl.append(sizeTable);
        //contrain checkbox
        var heightChanged = false, widthChanged = false;
        var ratio = klCanvas.getWidth() / klCanvas.getHeight();
        function updateConstrain() {
            constrainIm.style.display = isConstrained ? '' : 'none';
            if (isConstrained) {
                widthInput.value = '' + klCanvas.getWidth();
                heightInput.value = '' + klCanvas.getHeight();
                update();
            }
        }
        var isConstrained = true;
        var constrainCheckbox = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('constrain-proportions'),
            allowTab: true,
            callback: function callback(b) {
                isConstrained = b;
                updateConstrain();
            },
            name: 'constrain-proportions'
        });
        rootEl.append((0, $eWjiX.BB).el({
            css: {
                clear: 'both'
            }
        }));
        var algorithmSelect = new (0, $7a3263857aacf58f$export$ef9b1a59e592288f)({
            isFocusable: true,
            optionArr: [
                [
                    'smooth',
                    (0, $8d7403abedf7cefa$export$ce37e184d908d785)('algorithm-smooth')
                ],
                [
                    'pixelated',
                    (0, $8d7403abedf7cefa$export$ce37e184d908d785)('algorithm-pixelated')
                ]
            ],
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('scaling-algorithm'),
            initValue: 'smooth',
            onChange: function() {
                update();
            },
            name: 'interpolation-algorithm'
        });
        var secondRowElement = (0, $eWjiX.BB).el({
            parent: rootEl,
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }
        });
        secondRowElement.append(constrainCheckbox.getElement(), algorithmSelect.getElement());
        var previewCanvas = (0, $eWjiX.BB).canvas(w, h);
        previewCanvas.style.imageRendering = 'pixelated';
        var previewCtx = (0, $eWjiX.BB).ctx(previewCanvas);
        function draw() {
            if (algorithmSelect.getValue() === 'smooth') {
                previewCanvas.style.imageRendering = previewFactor > 1 ? 'pixelated' : '';
                previewCanvas.width = klCanvas.getWidth();
                previewCanvas.height = klCanvas.getHeight();
                previewCtx.save();
                previewCtx.imageSmoothingQuality = 'high';
                previewCtx.drawImage(tempCanvas, 0, 0);
                (0, $eWjiX.BB).resizeCanvas(previewCanvas, newWidth, newHeight);
                previewCtx.restore();
            } else {
                previewCanvas.style.imageRendering = 'pixelated';
                previewCanvas.width = newWidth;
                previewCanvas.height = newHeight;
                previewCtx.save();
                previewCtx.imageSmoothingEnabled = false;
                previewCtx.drawImage(tempCanvas, 0, 0, previewCanvas.width, previewCanvas.height);
                previewCtx.restore();
            }
        }
        function update() {
            if (widthInput.value.length === 0 && widthChanged || heightInput.value.length === 0 && heightChanged) {
                heightChanged = false;
                widthChanged = false;
                return;
            }
            widthInput.value = '' + Math.max(1, parseInt(widthInput.value));
            heightInput.value = '' + Math.max(1, parseInt(heightInput.value));
            if (isConstrained) {
                if (heightChanged) widthInput.value = '' + parseInt('' + parseInt(heightInput.value) * ratio);
                if (widthChanged) heightInput.value = '' + parseInt('' + parseInt(widthInput.value) / ratio);
                if (parseInt(widthInput.value) > maxWidth || parseInt(heightInput.value) > maxHeight) {
                    var fit = (0, $eWjiX.BB).fitInto(parseInt(widthInput.value), parseInt(heightInput.value), maxWidth, maxHeight, 1);
                    widthInput.value = '' + parseInt('' + fit.width);
                    heightInput.value = '' + parseInt('' + fit.height);
                }
            }
            if (parseInt(widthInput.value) > maxWidth) widthInput.value = '' + maxWidth;
            if (parseInt(heightInput.value) > maxHeight) heightInput.value = '' + maxHeight;
            heightChanged = false;
            widthChanged = false;
            newWidth = parseInt(widthInput.value);
            newHeight = parseInt(heightInput.value);
            var preview = (0, $eWjiX.BB).fitInto(newWidth, newHeight, 280, 200, 1);
            var previewW = parseInt('' + preview.width), previewH = parseInt('' + preview.height);
            previewFactor = previewW / newWidth;
            var offset = (0, $eWjiX.BB).centerWithin((0, $a433d11ad38d7c38$export$ec2d17c6d3ae0768).width, (0, $a433d11ad38d7c38$export$ec2d17c6d3ae0768).height, previewW, previewH);
            draw();
            previewCanvas.style.width = Math.max(1, previewW) + 'px';
            previewCanvas.style.height = Math.max(1, previewH) + 'px';
            canvasWrapper.style.left = offset.x + 'px';
            canvasWrapper.style.top = offset.y + 'px';
            canvasWrapper.style.width = Math.max(1, previewW) + 'px';
            canvasWrapper.style.height = Math.max(1, previewH) + 'px';
        }
        var previewWrapper = (0, $eWjiX.BB).el({
            className: 'kl-transparent-preview',
            css: {
                width: (0, $a433d11ad38d7c38$export$ec2d17c6d3ae0768).width + 'px',
                height: (0, $a433d11ad38d7c38$export$ec2d17c6d3ae0768).height + 'px',
                marginLeft: '-20px',
                display: 'table',
                marginTop: '10px',
                position: 'relative',
                userSelect: 'none',
                background: 'var(--kl-checkerboard-background)',
                backgroundSize: '16px'
            }
        });
        var canvasWrapper = (0, $eWjiX.BB).el({
            parent: previewWrapper,
            content: previewCanvas,
            className: 'kl-transparent-preview__canvas',
            css: {
                width: w + 'px',
                height: h + 'px',
                position: 'absolute',
                overflow: 'hidden'
            }
        });
        rootEl.append(previewWrapper);
        update();
        result.destroy = function() {
            constrainCheckbox.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                width: newWidth,
                height: newHeight,
                algorithm: algorithmSelect.getValue()
            };
        };
        return result;
    },
    apply (params) {
        var klCanvas = params.klCanvas;
        var width = params.input.width;
        var height = params.input.height;
        var algorithm = params.input.algorithm;
        if (!klCanvas) return false;
        klCanvas.resize(width, height, algorithm);
        return true;
    }
};



var $eWjiX = parcelRequire("eWjiX");

var $878715182dcd377b$export$ac7e9efc751d5791 = {
    getDialog (params) {
        var klCanvas = params.klCanvas;
        if (!klCanvas) return false;
        var fit = (0, $eWjiX.BB).fitInto(klCanvas.getWidth(), klCanvas.getHeight(), 280, 200, 1);
        var w = parseInt('' + fit.width), h = parseInt('' + fit.height);
        var previewFactor = w / klCanvas.getWidth();
        var tempCanvas = (0, $eWjiX.BB).canvas(w, h);
        tempCanvas.style.display = 'block';
        (0, $eWjiX.BB).ctx(tempCanvas).drawImage(klCanvas.getCompleteCanvas(previewFactor), 0, 0, w, h);
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var deg = 0;
        function update() {
            canvasWrapper.style.transform = 'rotate(' + deg + 'deg)';
            if (Math.abs(deg % 180) === 90) {
                //height has to fit width because of rotation
                var fit = (0, $eWjiX.BB).fitInto(h, w, 280, 200, 1);
                var scale = parseInt('' + fit.height) / w;
                canvasWrapper.style.transform = 'rotate(' + deg + 'deg) scale(' + scale + ')';
            }
        }
        var minusBtn = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: [
                (0, $eWjiX.BB).el({
                    tagName: 'span',
                    content: "\u27F2",
                    css: {
                        fontSize: '1.3em'
                    }
                }),
                " 90\xb0"
            ],
            onClick: function() {
                deg -= 90;
                update();
            },
            noRef: true
        });
        var plusBtn = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: [
                (0, $eWjiX.BB).el({
                    tagName: 'span',
                    content: "\u27F3",
                    css: {
                        fontSize: '1.3em'
                    }
                }),
                " 90\xb0"
            ],
            onClick: function() {
                deg += 90;
                update();
            },
            noRef: true,
            css: {
                marginLeft: '5px'
            }
        });
        rootEl.append(minusBtn, plusBtn);
        var previewWrapper = (0, $eWjiX.BB).el({
            className: 'kl-preview-wrapper',
            css: {
                width: (0, $a433d11ad38d7c38$export$ec2d17c6d3ae0768).width + 'px',
                height: (0, $a433d11ad38d7c38$export$ec2d17c6d3ae0768).height + 'px',
                display: 'table'
            }
        });
        var previewcell = (0, $eWjiX.BB).el({
            parent: previewWrapper,
            css: {
                display: 'table-cell',
                verticalAlign: 'middle'
            }
        });
        var canvasWrapper = (0, $eWjiX.BB).el({
            parent: previewcell,
            content: tempCanvas,
            className: 'kl-preview-wrapper__canvas',
            css: {
                width: w + 'px',
                height: h + 'px',
                marginLeft: 'auto',
                marginRight: 'auto',
                overflow: 'hidden',
                background: 'var(--kl-checkerboard-background)',
                backgroundSize: '16px'
            }
        });
        canvasWrapper.style.transition = 'transform 0.2s ease-out';
        rootEl.append(previewWrapper);
        update();
        result.destroy = function() {};
        result.getInput = function() {
            result.destroy();
            return {
                deg: deg
            };
        };
        return result;
    },
    apply (params) {
        var klCanvas = params.klCanvas;
        if (!klCanvas) return false;
        klCanvas.rotate(params.input.deg);
        return true;
    }
};



var $eWjiX = parcelRequire("eWjiX");






parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");





var $7jh4K = parcelRequire("7jh4K");
var $aa97ed406a9700f0$export$1b8796b18b7c19ed = {
    getDialog (params) {
        var context = params.context;
        var klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall);
        var blur = 20, gradient = 200;
        var fxPreviewRenderer = {
            destroy: function() {}
        };
        fxPreviewRenderer = new (0, $14b90ba44af68d49$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: function(fxCanvas, transform) {
                fa.setTransform(preview.getTransform());
                fb.setTransform(preview.getTransform());
                var m = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(transform);
                var a = (0, $cdZRx.applyToPoint)(m, fa.getValue());
                var b = (0, $cdZRx.applyToPoint)(m, fb.getValue());
                return fxCanvas.multiplyAlpha().tiltShift(a.x, a.y, b.x, b.y, blur * transform.scaleX, gradient * transform.scaleX).unmultiplyAlpha();
            },
            selection: klCanvas.getSelection()
        });
        function update() {
            preview.render();
        }
        // focus line control points
        var fa = new (0, $1ca80fac51ad2a2d$export$87247fc399965417)({
            value: {
                x: context.canvas.width / 4,
                y: context.canvas.height / 2
            },
            onChange: function() {
                update();
            }
        });
        var fb = new (0, $1ca80fac51ad2a2d$export$87247fc399965417)({
            value: {
                x: 3 * context.canvas.width / 4,
                y: context.canvas.height / 2
            },
            onChange: function() {
                update();
            }
        });
        var gradientSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-tilt-shift-gradient'),
            width: 300,
            height: 30,
            min: 0,
            max: 1000,
            value: gradient,
            eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
            onChange: function onChange(val) {
                gradient = val;
                update();
            }
        });
        gradientSlider.getElement().style.marginBottom = '10px';
        rootEl.append(gradientSlider.getElement());
        var blurSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-tilt-shift-blur'),
            width: 300,
            height: 30,
            min: 0,
            max: 200,
            value: blur,
            eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
            onChange: function onChange(val) {
                blur = val;
                update();
            }
        });
        blurSlider.getElement().style.marginBottom = '10px';
        rootEl.append(blurSlider.getElement());
        var previewLayerArr = [];
        for(var i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        var preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $7jh4K.css)(preview.getElement(), {
            overflow: 'hidden',
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        preview.getElement().append(fa.getElement(), fb.getElement());
        rootEl.append(preview.getElement());
        result.destroy = function() {
            blurSlider.destroy();
            gradientSlider.destroy();
            fa.destroy();
            fb.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                a: fa.getValue(),
                b: fb.getValue(),
                blur: blur,
                gradient: gradient
            };
        };
        return result;
    },
    apply (params) {
        var context = params.layer.context;
        var klHistory = params.klHistory;
        var a = params.input.a;
        var b = params.input.b;
        var blur = params.input.blur;
        var gradient = params.input.gradient;
        if (!context) return false;
        return (0, $670db093f8076d2c$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), function(fxCanvas) {
            fxCanvas.multiplyAlpha().tiltShift(a.x, a.y, b.x, b.y, blur, gradient).unmultiplyAlpha();
        }, klHistory);
    }
};



var $cL71g = parcelRequire("cL71g");

var $8N5YG = parcelRequire("8N5YG");

var $bX4ja = parcelRequire("bX4ja");

var $eWjiX = parcelRequire("eWjiX");




var $esGm2 = parcelRequire("esGm2");


var $7jh4K = parcelRequire("7jh4K");






var $eg83P = parcelRequire("eg83P");

var $eIcQa = parcelRequire("eIcQa");
function $4ae5c842364e8628$export$6be4733fa804854c(selection, context) {
    var selectionBounds = (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(selection, 'index');
    // integer bounds that are within the canvas
    var canvasSelectionBounds = (0, $eg83P.indexBoundsInArea)(selectionBounds, context.canvas.width, context.canvas.height);
    // selection area outside of canvas
    if (!canvasSelectionBounds) return undefined;
    // bounds of where pixels are non-transparent
    return (0, $eIcQa.getCanvasBounds)(context, canvasSelectionBounds);
}



var $9b3eo = parcelRequire("9b3eo");
parcelRequire("ciAU9");
var $dZ59l = parcelRequire("dZ59l");
var $1RMPr = parcelRequire("1RMPr");
var $kFecW = parcelRequire("kFecW");
var $kr2fR = parcelRequire("kr2fR");


var $bbA6w = parcelRequire("bbA6w");

var $eIcQa = parcelRequire("eIcQa");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");
parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $dZ59l = parcelRequire("dZ59l");
var $1RMPr = parcelRequire("1RMPr");
var $kFecW = parcelRequire("kFecW");
var $kr2fR = parcelRequire("kr2fR");

var $eWjiX = parcelRequire("eWjiX");
// ---- Helper Functions ----
// Precomputed factorials for n = 0..8 (sufficient for lattice degrees up to 8×8).
// Gave slight performance improvement.
var $abad715f10469dbf$var$factorials = [
    1,
    1,
    2,
    6,
    24,
    120,
    720,
    5040,
    40320
];
function $abad715f10469dbf$export$b10970dad17863b6(n, k, t) {
    var coeff = $abad715f10469dbf$var$factorials[n] / ($abad715f10469dbf$var$factorials[k] * $abad715f10469dbf$var$factorials[n - k]);
    return coeff * Math.pow(1 - t, n - k) * Math.pow(t, k);
}
function $abad715f10469dbf$export$1dc7cad4a5f0f0a6(cols, rows, rect) {
    var controlPoints = [];
    for(var i = 0; i < rows; i++){
        controlPoints[i] = [];
        for(var j = 0; j < cols; j++)controlPoints[i][j] = {
            x: rect.x + j / (cols - 1) * rect.width,
            y: rect.y + i / (rows - 1) * rect.height
        };
    }
    return {
        cols: cols,
        rows: rows,
        controlPoints: controlPoints
    };
}
function $abad715f10469dbf$export$24b0a92fce6b8497(s, t, lattice) {
    var n = lattice.cols - 1;
    var m = lattice.rows - 1;
    var x = 0;
    var y = 0;
    for(var i = 0; i <= m; i++)for(var j = 0; j <= n; j++){
        var weight = $abad715f10469dbf$export$b10970dad17863b6(n, j, s) * $abad715f10469dbf$export$b10970dad17863b6(m, i, t);
        x += lattice.controlPoints[i][j].x * weight;
        y += lattice.controlPoints[i][j].y * weight;
    }
    return {
        x: x,
        y: y
    };
}
function $abad715f10469dbf$export$81dc197f519ea47(resolutionX, resolutionY, ffd, selectionSample, outputWidth, outputHeight, useCanvasSpace) {
    /**
     * Compute the parametric s/t ranges so that mesh only covers the texture's
     * portion of the lattice — UVs stay in [0, 1] and nothing outside the texture is drawn.
     */ var textureWidth = selectionSample.image.width;
    var textureHeight = selectionSample.image.height;
    var offset = selectionSample.imageOffset;
    var selWidth = selectionSample.selectionSize.width;
    var selHeight = selectionSample.selectionSize.height;
    var sRange = [
        offset.x / selWidth,
        (offset.x + textureWidth) / selWidth
    ];
    var tRange = [
        offset.y / selHeight,
        (offset.y + textureHeight) / selHeight
    ];
    return $abad715f10469dbf$export$d6a0409d5640315a(resolutionX, resolutionY, ffd, outputWidth, outputHeight, useCanvasSpace, sRange, tRange);
}
function $abad715f10469dbf$export$d6a0409d5640315a(resolutionX, resolutionY, lattice, // ignored if useCanvasSpace true
canvasWidth, canvasHeight, // if false will use vertex space
useCanvasSpace, /**
     * Parametric horizontal range to generate mesh for. Default: [0, 1].
     * Clips the mesh to the portion of the lattice covered by the texture,
     * so UVs stay in [0, 1] and we avoid texture wrapping issues.
     */ sRange, /**
     * Parametric vertical range to generate mesh for. Default: [0, 1].
     * Clips the mesh to the portion of the lattice covered by the texture,
     * so UVs stay in [0, 1] and we avoid texture wrapping issues.
     */ tRange) {
    var vertices = [];
    var texCoords = [];
    var frontIndices = [];
    var backIndices = [];
    var sMin = sRange ? sRange[0] : 0;
    var sMax = sRange ? sRange[1] : 1;
    var tMin = tRange ? tRange[0] : 0;
    var tMax = tRange ? tRange[1] : 1;
    // Generate mesh vertices
    for(var i = 0; i <= resolutionY; i++)for(var j = 0; j <= resolutionX; j++){
        // Parametric coords within the texture's sub-range of the lattice
        var s = sMin + j / resolutionX * (sMax - sMin);
        var t = tMin + i / resolutionY * (tMax - tMin);
        // Evaluate FFD to get canvas space position
        var canvasPos = $abad715f10469dbf$export$24b0a92fce6b8497(s, t, lattice);
        var x = void 0, y = void 0;
        if (useCanvasSpace) {
            // Keep in canvas space for hit testing
            x = canvasPos.x;
            y = canvasPos.y;
        } else {
            // Convert to normalized vertex space [-1, 1]
            // Top-left is (-1, 1), bottom-right is (1, -1)
            x = canvasPos.x / canvasWidth * 2.0 - 1.0;
            y = 1.0 - canvasPos.y / canvasHeight * 2.0;
        }
        vertices.push(x, y);
        // UV maps linearly from the sub-range to [0, 1]
        var u = (s - sMin) / (sMax - sMin);
        var v = (t - tMin) / (tMax - tMin);
        texCoords.push(u, v);
    }
    // Generate indices, classifying each triangle as front- or back-facing inline
    for(var i1 = 0; i1 < resolutionY; i1++)for(var j1 = 0; j1 < resolutionX; j1++){
        var topLeft = i1 * (resolutionX + 1) + j1;
        var topRight = topLeft + 1;
        var bottomLeft = topLeft + (resolutionX + 1);
        var bottomRight = bottomLeft + 1;
        var x0 = vertices[topLeft * 2], y0 = vertices[topLeft * 2 + 1];
        var x1 = vertices[bottomLeft * 2], y1 = vertices[bottomLeft * 2 + 1];
        var x2 = vertices[topRight * 2], y2 = vertices[topRight * 2 + 1];
        var x3 = vertices[bottomRight * 2], y3 = vertices[bottomRight * 2 + 1];
        var cross0 = (x1 - x0) * (y2 - y0) - (y1 - y0) * (x2 - x0);
        (cross0 > 0 ? frontIndices : backIndices).push(topLeft, bottomLeft, topRight);
        var cross1 = (x1 - x2) * (y3 - y2) - (y1 - y2) * (x3 - x2);
        (cross1 > 0 ? frontIndices : backIndices).push(topRight, bottomLeft, bottomRight);
    }
    return {
        resolutionX: resolutionX,
        resolutionY: resolutionY,
        vertices: vertices,
        texCoords: texCoords,
        frontIndices: frontIndices,
        backIndices: backIndices
    };
}
function $abad715f10469dbf$export$2d232ae0b526c96b(// same space as mesh vertices
x, y, mesh) {
    var vertices = mesh.vertices, texCoords = mesh.texCoords, frontIndices = mesh.frontIndices, backIndices = mesh.backIndices;
    var frontHit = undefined;
    var backHit = undefined;
    function checkTriangles(indices) {
        for(var i = 0; i < indices.length; i += 3){
            var i0 = indices[i];
            var i1 = indices[i + 1];
            var i2 = indices[i + 2];
            var x0 = vertices[i0 * 2];
            var y0 = vertices[i0 * 2 + 1];
            var x1 = vertices[i1 * 2];
            var y1 = vertices[i1 * 2 + 1];
            var x2 = vertices[i2 * 2];
            var y2 = vertices[i2 * 2 + 1];
            // Barycentric coordinates
            var denom = (y1 - y2) * (x0 - x2) + (x2 - x1) * (y0 - y2);
            if (Math.abs(denom) < 0.00001) continue;
            var a = ((y1 - y2) * (x - x2) + (x2 - x1) * (y - y2)) / denom;
            var b = ((y2 - y0) * (x - x2) + (x0 - x2) * (y - y2)) / denom;
            var c = 1 - a - b;
            // Inside triangle?
            if (a >= 0 && b >= 0 && c >= 0) {
                // Get texture coordinates (which are the same as parametric coords)
                var s0 = texCoords[i0 * 2];
                var t0 = texCoords[i0 * 2 + 1];
                var s1 = texCoords[i1 * 2];
                var t1 = texCoords[i1 * 2 + 1];
                var s2 = texCoords[i2 * 2];
                var t2 = texCoords[i2 * 2 + 1];
                // Check winding order
                var cross = (x1 - x0) * (y2 - y0) - (y1 - y0) * (x2 - x0);
                var isBackFacing = cross > 0;
                var hit = {
                    s: a * s0 + b * s1 + c * s2,
                    t: a * t0 + b * t1 + c * t2
                };
                if (isBackFacing) backHit = hit;
                else frontHit = hit;
            }
        }
    }
    checkTriangles(frontIndices);
    checkTriangles(backIndices);
    // Prioritize back, because back faces are also rendered in front.
    return backHit || frontHit;
}
function $abad715f10469dbf$export$fd7a293c27db611b(paramCoordinate, target, lattice) {
    lattice = (0, $eWjiX.BB).copyObj(lattice);
    // via trial and error these felt good
    // so the entire mesh doesn't move when warping. Somewhat localized.
    var influenceRadius = 1 / 3;
    // smaller -> edge folds less easily over
    var edgeFalloff = 0.5;
    var n = lattice.cols - 1;
    var m = lattice.rows - 1;
    var controlPoints = lattice.controlPoints;
    // Calculate basis function values at the drag point
    var basisWeights = [];
    for(var i = 0; i <= m; i++)for(var j = 0; j <= n; j++){
        var w = $abad715f10469dbf$export$b10970dad17863b6(n, j, paramCoordinate.s) * $abad715f10469dbf$export$b10970dad17863b6(m, i, paramCoordinate.t);
        // Calculate distance for influence radius
        var si = j / n;
        var ti = i / m;
        var paramDist = Math.sqrt(Math.pow(si - paramCoordinate.s, 2) + Math.pow(ti - paramCoordinate.t, 2));
        // Calculate a ramp from 1 to 0
        var strength = Math.max(0, 1 - paramDist / influenceRadius);
        var dragDistFromCenterX = Math.abs(paramCoordinate.s - 0.5);
        var cpDistFromCenterX = Math.abs(si - 0.5);
        var dragDistFromCenterY = Math.abs(paramCoordinate.t - 0.5);
        var cpDistFromCenterY = Math.abs(ti - 0.5);
        // weirdly feels right when warping
        if (cpDistFromCenterX > dragDistFromCenterX || cpDistFromCenterY > dragDistFromCenterY) strength *= edgeFalloff;
        basisWeights.push({
            i: i,
            j: j,
            w: w,
            strength: strength
        });
    }
    var start = $abad715f10469dbf$export$24b0a92fce6b8497(paramCoordinate.s, paramCoordinate.t, lattice);
    var dx = target.x - start.x;
    var dy = target.y - start.y;
    // Direct manipulation: solve for control point displacements.
    // Invariant: evalFFD(paramCoordinate, updatedLattice) === target exactly.
    var sumWeightsSq = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = basisWeights[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, w1 = _step_value.w, strength1 = _step_value.strength;
            sumWeightsSq += w1 * w1 * strength1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = basisWeights[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var _step_value1 = _step1.value, i1 = _step_value1.i, j1 = _step_value1.j, w2 = _step_value1.w, strength2 = _step_value1.strength;
            var scale = w2 / sumWeightsSq * strength2;
            controlPoints[i1][j1].x += dx * scale;
            controlPoints[i1][j1].y += dy * scale;
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return {
        cols: lattice.cols,
        rows: lattice.rows,
        controlPoints: controlPoints
    };
}



var $bbA6w = parcelRequire("bbA6w");

var $eg83P = parcelRequire("eg83P");


var $eWjiX = parcelRequire("eWjiX");

// returns bounds of mesh that ffd lattice would create

var $eg83P = parcelRequire("eg83P");


function $5a3072fca1cffb62$var$getFfdMeshBounds(mesh) {
    var vertices = mesh.vertices;
    var x1 = Infinity;
    var y1 = Infinity;
    var x2 = -Infinity;
    var y2 = -Infinity;
    for(var i = 0; i < vertices.length; i += 2){
        x1 = Math.min(x1, vertices[i]);
        y1 = Math.min(y1, vertices[i + 1]);
        x2 = Math.max(x2, vertices[i]);
        y2 = Math.max(y2, vertices[i + 1]);
    }
    // round bernstein floating point errors
    var precision = 1e6;
    return {
        type: 'coordinate',
        x1: Math.round(x1 * precision) / precision,
        y1: Math.round(y1 * precision) / precision,
        x2: Math.round(x2 * precision) / precision,
        y2: Math.round(y2 * precision) / precision
    };
}
function $5a3072fca1cffb62$export$da260002c67d0dd(ffd) {
    // Use a dummy canvas size of 1x1 since we request canvas space — the actual
    // canvas dimensions don't matter here because useCanvasSpace bypasses the
    // NDC conversion entirely.
    var mesh = (0, $abad715f10469dbf$export$d6a0409d5640315a)((0, $c3d05422ca86fac7$export$6ba60dd123964f3e), (0, $c3d05422ca86fac7$export$6ba60dd123964f3e), ffd, 1, 1, true);
    return $5a3072fca1cffb62$var$getFfdMeshBounds(mesh);
}
function $5a3072fca1cffb62$export$b8704036eca28391(mesh, width, height) {
    var ffdBounds = (0, $eg83P.coordinateBoundsToIndexBounds)($5a3072fca1cffb62$var$getFfdMeshBounds(mesh));
    return (0, $eg83P.indexBoundsInArea)(ffdBounds, width, height);
}


var $c3d05422ca86fac7$export$6ba60dd123964f3e = 64;
function $c3d05422ca86fac7$export$552b36716f27e91b(transform, center) {
    transform = (0, $eWjiX.BB).copyObj(transform);
    if (transform.type === 'free' || transform.type === 'ffd+free') return (0, $4EWN2._)((0, $cL71g._)({}, transform), {
        freeTransform: (0, $6c5cb3001c773523$export$958c2bfe8d7142a9)((0, $4EWN2._)((0, $cL71g._)({}, transform.freeTransform), {
            x: center.x,
            y: center.y
        }))
    });
    // ffd
    var bounds = (0, $5a3072fca1cffb62$export$da260002c67d0dd)(transform.ffd);
    // use freeTransform so we can use snapToPixel
    var freeTransform = $c3d05422ca86fac7$export$928f0648354c9a2f((0, $eg83P.boundsToRect)(bounds));
    var snappedTransform = (0, $6c5cb3001c773523$export$958c2bfe8d7142a9)((0, $4EWN2._)((0, $cL71g._)({}, freeTransform), {
        x: center.x,
        y: center.y
    }));
    var matrix = $c3d05422ca86fac7$export$e464a809f7257768(snappedTransform, (0, $eg83P.coordinateBoundsToIndexBounds)(bounds));
    return {
        type: 'ffd',
        ffd: $c3d05422ca86fac7$export$a56ca41a0dbe2002(transform.ffd, matrix)
    };
}
function $c3d05422ca86fac7$export$44831334ca780533(transform, axis) {
    transform = (0, $eWjiX.BB).copyObj(transform);
    if (transform.type === 'free' || transform.type === 'ffd+free') {
        var ft = transform.freeTransform;
        return (0, $4EWN2._)((0, $cL71g._)({}, transform), {
            freeTransform: (0, $4EWN2._)((0, $cL71g._)({}, ft), {
                width: -ft.width,
                height: ft.height,
                angleDeg: axis === 'y' ? -ft.angleDeg + 180 : -ft.angleDeg
            })
        });
    }
    // ffd
    var bounds = (0, $5a3072fca1cffb62$export$da260002c67d0dd)(transform.ffd);
    var center = {
        x: (bounds.x1 + bounds.x2) / 2,
        y: (bounds.y1 + bounds.y2) / 2
    };
    var matrix = (0, $dZ59l.compose)((0, $kr2fR.translate)(center.x, center.y), (0, $kFecW.scale)(axis === 'x' ? -1 : 1, axis === 'y' ? -1 : 1), (0, $kr2fR.translate)(-center.x, -center.y));
    return {
        type: 'ffd',
        ffd: $c3d05422ca86fac7$export$a56ca41a0dbe2002(transform.ffd, matrix)
    };
}
function $c3d05422ca86fac7$export$7eaa413076082bd7(transform, factor) {
    transform = (0, $eWjiX.BB).copyObj(transform);
    if (transform.type === 'free' || transform.type === 'ffd+free') {
        var before = transform.freeTransform;
        // prevent edge cases (leading to NaN) where width and height are 0.
        if (factor > 1 && (factor * before.width === 0 || factor * before.height === 0)) return transform;
        if (factor < 1 && (factor * before.width < 1 || factor * before.height < 1)) return transform;
        return (0, $4EWN2._)((0, $cL71g._)({}, transform), {
            freeTransform: (0, $6c5cb3001c773523$export$958c2bfe8d7142a9)((0, $4EWN2._)((0, $cL71g._)({}, transform.freeTransform), {
                width: transform.freeTransform.width * factor,
                height: transform.freeTransform.height * factor
            }))
        });
    }
    // ffd
    var bounds = (0, $5a3072fca1cffb62$export$da260002c67d0dd)(transform.ffd);
    var center = {
        x: (bounds.x1 + bounds.x2) / 2,
        y: (bounds.y1 + bounds.y2) / 2
    };
    var matrix = (0, $dZ59l.compose)((0, $kr2fR.translate)(center.x, center.y), (0, $kFecW.scale)(factor), (0, $kr2fR.translate)(-center.x, -center.y));
    return {
        type: 'ffd',
        ffd: $c3d05422ca86fac7$export$a56ca41a0dbe2002(transform.ffd, matrix)
    };
}
function $c3d05422ca86fac7$export$71dd993772432b93(transform, deltaAngleDeg) {
    transform = (0, $eWjiX.BB).copyObj(transform);
    if (transform.type === 'free' || transform.type === 'ffd+free') return (0, $4EWN2._)((0, $cL71g._)({}, transform), {
        freeTransform: (0, $6c5cb3001c773523$export$958c2bfe8d7142a9)((0, $4EWN2._)((0, $cL71g._)({}, transform.freeTransform), {
            angleDeg: (transform.freeTransform.angleDeg + deltaAngleDeg) % 360
        }))
    });
    // ffd
    var bounds = (0, $5a3072fca1cffb62$export$da260002c67d0dd)(transform.ffd);
    // use freeTransform so we can use snapToPixel
    var freeTransform = $c3d05422ca86fac7$export$928f0648354c9a2f((0, $eg83P.boundsToRect)(bounds));
    var snappedTransform = (0, $6c5cb3001c773523$export$958c2bfe8d7142a9)((0, $4EWN2._)((0, $cL71g._)({}, freeTransform), {
        angleDeg: deltaAngleDeg % 360
    }));
    var matrix = $c3d05422ca86fac7$export$e464a809f7257768(snappedTransform, (0, $eg83P.coordinateBoundsToIndexBounds)(bounds));
    return {
        type: 'ffd',
        ffd: $c3d05422ca86fac7$export$a56ca41a0dbe2002(transform.ffd, matrix)
    };
}
function $c3d05422ca86fac7$export$e464a809f7257768(transform, bounds) {
    var rect = (0, $eg83P.boundsToRect)(bounds);
    var centerBefore = {
        x: rect.x + rect.width / 2,
        y: rect.y + rect.height / 2
    };
    var scaleX = transform.width / rect.width;
    var scaleY = transform.height / rect.height;
    var angleRad = transform.angleDeg / 180 * Math.PI;
    return (0, $dZ59l.compose)((0, $kr2fR.translate)(transform.x, transform.y), (0, $1RMPr.rotate)(angleRad), (0, $kFecW.scale)(scaleX, scaleY), (0, $kr2fR.translate)(-centerBefore.x, -centerBefore.y));
}
function $c3d05422ca86fac7$export$928f0648354c9a2f(rect) {
    return {
        x: rect.x + rect.width / 2,
        y: rect.y + rect.height / 2,
        width: rect.width,
        height: rect.height,
        angleDeg: 0
    };
}
// warps and automatically subdivides and optimizes the selection polygon
function $c3d05422ca86fac7$var$warpSelection(ffd, selection, selectionBounds) {
    var _boundsToRect = (0, $eg83P.boundsToRect)(selectionBounds), width = _boundsToRect.width, height = _boundsToRect.height;
    var result = selection.map(function(polygon) {
        return polygon.map(function(ring) {
            // ring 1 - subdivide based on edge delta relative to selection bounds
            var ring1 = [];
            for(var i = 0; i < ring.length; i++){
                var p1 = ring[i];
                var p2 = ring[(i + 1) % ring.length];
                // Add current point
                ring1.push(p1);
                // Subdivide based on whichever axis delta is proportionally larger
                var dx = p2[0] - p1[0];
                var dy = p2[1] - p1[1];
                var ratioX = Math.abs(dx) / width;
                var ratioY = Math.abs(dy) / height;
                var dominantRatio = Math.max(ratioX, ratioY);
                var segments = Math.max(1, Math.round(dominantRatio * 4));
                for(var j = 1; j < segments; j++){
                    var t = j / segments;
                    ring1.push([
                        p1[0] + dx * t,
                        p1[1] + dy * t
                    ]);
                }
            }
            // ring 2 - subdivide based on edge delta in warped space. but subdivide in the original space
            var ring2 = [];
            for(var i1 = 0; i1 < ring1.length; i1++){
                var p11 = ring1[i1];
                var p21 = ring1[(i1 + 1) % ring1.length];
                ring2.push(p11);
                // Warp both endpoints to measure edge length in warped space
                var s1 = (p11[0] - selectionBounds.x1) / width;
                var t1 = (p11[1] - selectionBounds.y1) / height;
                var w1 = (0, $abad715f10469dbf$export$24b0a92fce6b8497)(s1, t1, ffd);
                var s2 = (p21[0] - selectionBounds.x1) / width;
                var t2 = (p21[1] - selectionBounds.y1) / height;
                var w2 = (0, $abad715f10469dbf$export$24b0a92fce6b8497)(s2, t2, ffd);
                var wdx = w2.x - w1.x;
                var wdy = w2.y - w1.y;
                var warpedLength = Math.sqrt(wdx * wdx + wdy * wdy);
                var segments1 = Math.max(1, Math.ceil(warpedLength / 4));
                var dx1 = p21[0] - p11[0];
                var dy1 = p21[1] - p11[1];
                for(var j1 = 1; j1 < segments1; j1++){
                    var t3 = j1 / segments1;
                    ring2.push([
                        p11[0] + dx1 * t3,
                        p11[1] + dy1 * t3
                    ]);
                }
            }
            var warpedRing = ring2.map(function(point) {
                // Convert point to normalized coordinates [0, 1]
                var s = (point[0] - selectionBounds.x1) / width;
                var t = (point[1] - selectionBounds.y1) / height;
                // Evaluate FFD at normalized coordinates
                var warped = (0, $abad715f10469dbf$export$24b0a92fce6b8497)(s, t, ffd);
                return [
                    warped.x,
                    warped.y
                ];
            });
            // optimized ring - remove collinear points
            var angleDegThreshold = 1;
            var cosThreshold = Math.cos(angleDegThreshold / 180 * Math.PI);
            var optimizedRing = [];
            for(var i2 = 0; i2 < warpedRing.length - 1; i2++){
                var _optimizedRing_;
                var prev = (_optimizedRing_ = optimizedRing[optimizedRing.length - 1]) !== null && _optimizedRing_ !== void 0 ? _optimizedRing_ : warpedRing[warpedRing.length - 1];
                var curr = warpedRing[i2];
                var next = warpedRing[(i2 + 1) % warpedRing.length];
                var ax = curr[0] - prev[0];
                var ay = curr[1] - prev[1];
                var bx = next[0] - curr[0];
                var by = next[1] - curr[1];
                var lenA = Math.sqrt(ax * ax + ay * ay);
                var lenB = Math.sqrt(bx * bx + by * by);
                if (lenA !== 0 && lenB !== 0 && (ax * bx + ay * by) / (lenA * lenB) <= cosThreshold) optimizedRing.push(curr);
            }
            optimizedRing.push(warpedRing[warpedRing.length - 1]);
            return optimizedRing;
        });
    });
    return result;
}
function $c3d05422ca86fac7$export$c17d845d16ec8ae(transform, selection) {
    var selectionBounds = (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(selection, 'index');
    if (transform.type === 'ffd') return $c3d05422ca86fac7$var$warpSelection(transform.ffd, selection, selectionBounds);
    if (transform.type === 'ffd+free') return $c3d05422ca86fac7$var$warpSelection($c3d05422ca86fac7$export$a56ca41a0dbe2002(transform.ffd, $c3d05422ca86fac7$export$e464a809f7257768(transform.freeTransform, (0, $eg83P.rectToBounds)(transform.ffdBounds, 'index'))), selection, selectionBounds);
    var transformationMatrix = $c3d05422ca86fac7$export$e464a809f7257768(transform.freeTransform, selectionBounds);
    return (0, $bbA6w.transformMultiPolygon)(selection, transformationMatrix);
}
function $c3d05422ca86fac7$export$a56ca41a0dbe2002(ffd, matrix) {
    return {
        cols: ffd.cols,
        rows: ffd.rows,
        controlPoints: ffd.controlPoints.map(function(row) {
            return row.map(function(point) {
                return (0, $cdZRx.applyToPoint)(matrix, point);
            });
        })
    };
}


// preference expressed by user
var $31a0dd41d7428d32$var$preferenceIsTransparentBg;
function $31a0dd41d7428d32$var$getIsTransparentBg(isBgLayer, layerHasTransparency, preference) {
    if (!isBgLayer) return true;
    if (preference !== undefined) return preference;
    return layerHasTransparency;
}
function $31a0dd41d7428d32$var$parseCssColor(colorString) {
    if (colorString.startsWith('#')) {
        var hex = colorString.slice(1);
        if (hex.length === 3) hex = hex.split('').map(function(c) {
            return c + c;
        }).join('');
        if (hex.length === 6) // assume full alpha
        hex += 'ff';
        var intVal = parseInt(hex, 16);
        return {
            r: intVal >> 24 & 255,
            g: intVal >> 16 & 255,
            b: intVal >> 8 & 255,
            a: (intVal & 255) / 255
        };
    }
    var rgbMatch = colorString.match(/rgba?\(([^)]+)\)/);
    if (rgbMatch) {
        var _rgbMatch__split_map = (0, $8N5YG._)(rgbMatch[1].split(',').map(function(v) {
            return parseFloat(v.trim());
        }), 4), r = _rgbMatch__split_map[0], g = _rgbMatch__split_map[1], b = _rgbMatch__split_map[2], tmp = _rgbMatch__split_map[3], a = tmp === void 0 ? 1 : tmp;
        return {
            r: r,
            g: g,
            b: b,
            a: a
        };
    }
    return undefined;
}
function $31a0dd41d7428d32$export$d7a217b118c790a6(layer) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = layer.tiles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var tile = _step.value;
            if ((0, $esGm2.isLayerFill)(tile)) {
                var color = $31a0dd41d7428d32$var$parseCssColor(tile.fill);
                if (color && color.a < 1) return true;
            } else {
                var data = tile.data.data;
                for(var i = 3; i < data.length; i += 4){
                    if (data[i] < 255) return true;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
function $31a0dd41d7428d32$var$drawTransform(ctx, copiedCanvas, isPixelated, transform, selection, boundsObj, doClone, isTransparentBg) {
    var width = ctx.canvas.width;
    var height = ctx.canvas.height;
    ctx.save();
    ctx.clearRect(0, 0, width, height);
    ctx.save();
    if (selection) {
        // draw original with clipped selection
        ctx.drawImage(copiedCanvas, 0, 0);
        if (!doClone) {
            var selectionPath = (0, $9b3eo.getSelectionPath2d)(selection);
            ctx.clip(selectionPath);
            ctx.globalCompositeOperation = isTransparentBg ? 'destination-out' : 'source-atop';
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, width, height);
        }
    } else {
        if (isTransparentBg) {
            if (doClone) ctx.drawImage(copiedCanvas, 0, 0);
        } else {
            ctx.drawImage(copiedCanvas, 0, 0);
            if (!doClone) {
                ctx.fillStyle = 'white';
                ctx.globalCompositeOperation = 'source-atop';
                ctx.fillRect(0, 0, width, height);
            }
        }
    }
    ctx.restore();
    var matrix;
    if (selection) {
        var _ctx;
        var bounds = boundsObj !== null && boundsObj !== void 0 ? boundsObj : {
            x: 0,
            y: 0,
            width: ctx.canvas.width,
            height: ctx.canvas.height
        };
        if (isPixelated || (0, $eWjiX.BB).testShouldPixelate(transform, transform.width / bounds.width, transform.height / bounds.height)) ctx.imageSmoothingEnabled = false;
        else {
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = 'high';
        }
        // derived from drawTransformedImageWithBounds
        matrix = (0, $dZ59l.compose)((0, $kr2fR.translate)(transform.x, transform.y), (0, $1RMPr.rotate)(transform.angleDeg / 180 * Math.PI), (0, $kFecW.scale)(transform.width > 0 ? 1 : -1, transform.height > 0 ? 1 : -1), (0, $kr2fR.translate)(-Math.abs(transform.width) / 2, -Math.abs(transform.height) / 2), (0, $kFecW.scale)(Math.abs(transform.width / bounds.width), Math.abs(transform.height / bounds.height)), (0, $kr2fR.translate)(-bounds.x, -bounds.y));
        (_ctx = ctx).setTransform.apply(_ctx, (0, $bX4ja._)((0, $c9ab5bbe74e01c89$export$2b60e7dafdbde18a)(matrix)));
        var selectionPath1 = (0, $9b3eo.getSelectionPath2d)(selection);
        ctx.clip(selectionPath1);
        ctx.drawImage(copiedCanvas, 0, 0);
    } else (0, $eWjiX.BB).drawTransformedImageWithBounds(ctx, copiedCanvas, transform, boundsObj, isPixelated);
    ctx.restore();
    return matrix;
}
var $31a0dd41d7428d32$export$dc15474d94cdc2b3 = {
    getDialog (params) {
        var context = params.context;
        var klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = (0, $7jh4K.throwIfNull)(klCanvas.getLayerIndex(context.canvas));
        var isBgLayer = selectedLayerIndex === 0;
        var hasTransparency = false;
        if (isBgLayer) {
            var layer = Object.entries(params.composed.layerMap).find(function(param) {
                var _param = (0, $8N5YG._)(param, 2), _ = _param[0], layer = _param[1];
                return layer.index === selectedLayerIndex;
            })[1];
            hasTransparency = $31a0dd41d7428d32$export$d7a217b118c790a6(layer);
        }
        var selection = klCanvas.getSelection();
        // determine bounds and initial transformation
        var boundsObj = selection ? (0, $4ae5c842364e8628$export$6be4733fa804854c)(selection, context) : (0, $eIcQa.getCanvasBounds)(context);
        if (!boundsObj) return {
            error: (0, $8d7403abedf7cefa$export$ce37e184d908d785)(selection ? 'filter-transform-empty-selection' : 'filter-transform-empty')
        };
        var initTransform = {
            x: boundsObj.x + boundsObj.width / 2,
            y: boundsObj.y + boundsObj.height / 2,
            width: boundsObj.width,
            height: boundsObj.height,
            angleDeg: 0
        };
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$3a4a74a7d8c44e62).width;
        var keyListener = new (0, $eWjiX.BB).KeyListener({
            onDown: function onDown(keyStr) {
                if ((0, $eWjiX.BB).isInputFocused(true)) return;
                if (keyStr === 'left') {
                    inputX.value = '' + (parseFloat(inputX.value) - 1);
                    onInputsChanged();
                }
                if (keyStr === 'right') {
                    inputX.value = '' + (parseFloat(inputX.value) + 1);
                    onInputsChanged();
                }
                if (keyStr === 'up') {
                    inputY.value = '' + (parseFloat(inputY.value) - 1);
                    onInputsChanged();
                }
                if (keyStr === 'down') {
                    inputY.value = '' + (parseFloat(inputY.value) + 1);
                    onInputsChanged();
                }
            }
        });
        var leftWrapper = (0, $eWjiX.BB).el({
            css: {
                width: '100px',
                height: '30px',
                display: 'inline-block'
            }
        });
        var rightWrapper = (0, $eWjiX.BB).el({
            css: {
                width: '100px',
                height: '30px',
                display: 'inline-block'
            }
        });
        var rotWrapper = (0, $eWjiX.BB).el({
            css: {
                width: '150px',
                height: '30px',
                display: 'inline-block'
            }
        });
        var inputY = (0, $eWjiX.BB).el({
            tagName: 'input'
        });
        var inputX = (0, $eWjiX.BB).el({
            tagName: 'input'
        });
        var inputR = (0, $eWjiX.BB).el({
            tagName: 'input'
        });
        inputY.type = 'number';
        inputX.type = 'number';
        inputR.type = 'number';
        inputX.style.width = "70px";
        inputY.style.width = "70px";
        inputR.style.width = "70px";
        inputY.value = '0';
        inputX.value = '0';
        inputR.value = '0';
        inputY.onclick = function() {
            inputY.focus();
            onInputsChanged();
        };
        inputX.onclick = function() {
            inputX.focus();
            onInputsChanged();
        };
        inputR.onclick = function() {
            inputR.focus();
            onInputsChanged();
        };
        inputY.onchange = function() {
            onInputsChanged();
        };
        inputX.onchange = function() {
            onInputsChanged();
        };
        inputR.onchange = function() {
            onInputsChanged();
        };
        inputY.onkeyup = function() {
            onInputsChanged();
        };
        inputX.onkeyup = function() {
            onInputsChanged();
        };
        inputR.onkeyup = function() {
            onInputsChanged();
        };
        leftWrapper.append('X: ', inputX);
        rightWrapper.append('Y: ', inputY);
        rotWrapper.append((0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-transform-rotation') + ': ', inputR);
        if (!isSmall) {
            var inputRow = (0, $eWjiX.BB).el({
                parent: rootEl,
                css: {
                    marginTop: '10px'
                }
            });
            inputRow.append(leftWrapper, rightWrapper, rotWrapper);
        }
        // buttons
        var buttonRow = (0, $eWjiX.BB).el({
            parent: rootEl,
            css: {
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '10px',
                marginTop: '10px'
            }
        });
        var flipXBtn = (0, $eWjiX.BB).el({
            parent: buttonRow,
            tagName: 'button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-transform-flip') + ' X',
            onClick: function() {
                var transformed = (0, $c3d05422ca86fac7$export$44831334ca780533)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 'x');
                freeTransform.initialise(transformed.freeTransform);
                updatePreview();
            }
        });
        var flipYBtn = (0, $eWjiX.BB).el({
            parent: buttonRow,
            tagName: 'button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-transform-flip') + ' Y',
            onClick: function() {
                var transformed = (0, $c3d05422ca86fac7$export$44831334ca780533)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 'y');
                freeTransform.initialise(transformed.freeTransform);
                updatePreview();
            }
        });
        var scaleRotLeftBtn = (0, $eWjiX.BB).el({
            parent: buttonRow,
            tagName: 'button',
            content: "-90\xb0",
            onClick: function() {
                var transformed = (0, $c3d05422ca86fac7$export$71dd993772432b93)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, -90);
                freeTransform.initialise(transformed.freeTransform);
                inputR.value = '' + Math.round(transformed.freeTransform.angleDeg);
                updatePreview();
            }
        });
        var scaleRotRightBtn = (0, $eWjiX.BB).el({
            parent: buttonRow,
            tagName: 'button',
            content: "+90\xb0",
            onClick: function() {
                var transformed = (0, $c3d05422ca86fac7$export$71dd993772432b93)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 90);
                freeTransform.initialise(transformed.freeTransform);
                inputR.value = '' + Math.round(transformed.freeTransform.angleDeg);
                updatePreview();
            }
        });
        var scaleDoubleBtn = (0, $eWjiX.BB).el({
            parent: buttonRow,
            tagName: 'button',
            content: '2&times;',
            onClick: function() {
                var transformed = (0, $c3d05422ca86fac7$export$7eaa413076082bd7)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 2);
                freeTransform.initialise(transformed.freeTransform);
                updatePreview();
            }
        });
        var scaleHalfBtn = (0, $eWjiX.BB).el({
            parent: buttonRow,
            tagName: 'button',
            content: '&frac12;&times;',
            onClick: function() {
                var transformed = (0, $c3d05422ca86fac7$export$7eaa413076082bd7)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, 0.5);
                freeTransform.initialise(transformed.freeTransform);
                updatePreview();
            }
        });
        var centerBtn = (0, $eWjiX.BB).el({
            parent: buttonRow,
            tagName: 'button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('center'),
            onClick: function() {
                var transformed = (0, $c3d05422ca86fac7$export$552b36716f27e91b)({
                    type: 'free',
                    freeTransform: freeTransform.getValue()
                }, {
                    x: context.canvas.width / 2,
                    y: context.canvas.height / 2
                });
                freeTransform.initialise(transformed.freeTransform);
                inputX.value = '' + Math.round(transformed.freeTransform.x - initTransform.x);
                inputY.value = '' + Math.round(transformed.freeTransform.y - initTransform.y);
                updatePreview();
            }
        });
        var doClone = false;
        var cloneCheckbox = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: doClone,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-transform-clone'),
            allowTab: true,
            callback: function callback(b) {
                doClone = b;
                updatePreview(true);
            },
            css: {
                display: 'inline-block'
            },
            name: 'clone-before-transforming'
        });
        var isTransparentBg = $31a0dd41d7428d32$var$getIsTransparentBg(isBgLayer, hasTransparency, $31a0dd41d7428d32$var$preferenceIsTransparentBg);
        var transparentBgCheckboxTouched = false;
        var transparentBgCheckbox = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: isTransparentBg,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-eraser-transparent-bg'),
            allowTab: true,
            callback: function callback(b) {
                transparentBgCheckboxTouched = true;
                isTransparentBg = b;
                updatePreview(true);
            },
            css: {
                display: 'inline-block'
            },
            name: 'transparent-background'
        });
        buttonRow.append(cloneCheckbox.getElement());
        if (isBgLayer) buttonRow.append(transparentBgCheckbox.getElement());
        var isConstrained = true;
        var constrainCheckbox = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-transform-constrain'),
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('constrain-proportions'),
            allowTab: true,
            callback: function callback(b) {
                isConstrained = b;
                freeTransform.setIsConstrained(isConstrained);
            },
            css: {
                display: 'inline-block'
            },
            name: 'constrain-proportions'
        });
        var isSnapping = false;
        var snappingCheckbox = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-transform-snap'),
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-transform-snap-title'),
            allowTab: true,
            callback: function callback(b) {
                isSnapping = b;
                freeTransform.setSnapping(isSnapping);
            },
            css: {
                display: 'inline-block',
                marginLeft: '10px'
            },
            name: 'enable-snapping'
        });
        var checkboxWrapper = (0, $eWjiX.BB).el();
        checkboxWrapper.append(constrainCheckbox.getElement(), snappingCheckbox.getElement());
        rootEl.append((0, $eWjiX.BB).el({
            css: {
                clear: 'both',
                height: '10px'
            }
        }));
        var bottomRow = (0, $eWjiX.BB).el({
            parent: rootEl,
            css: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '10px'
            }
        });
        var algorithmSelect = new (0, $7a3263857aacf58f$export$ef9b1a59e592288f)({
            isFocusable: true,
            optionArr: [
                [
                    'smooth',
                    (0, $8d7403abedf7cefa$export$ce37e184d908d785)('algorithm-smooth')
                ],
                [
                    'pixelated',
                    (0, $8d7403abedf7cefa$export$ce37e184d908d785)('algorithm-pixelated')
                ]
            ],
            initValue: 'smooth',
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('scaling-algorithm'),
            onChange: function() {
                updatePreview(true);
            },
            name: 'interpolation-algorithm'
        });
        bottomRow.append(checkboxWrapper, algorithmSelect.getElement());
        var previewCanvas = (0, $eWjiX.BB).canvas(context.canvas.width, context.canvas.height);
        var previewLayerArr = [];
        for(var i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? previewCanvas : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        var preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            hasEditMode: true,
            onModeChange: function(m) {
                freeTransform.getElement().style.pointerEvents = m === 'edit' ? '' : 'none';
                freeTransform.getElement().style.opacity = m === 'edit' ? '' : '0.5';
            },
            onTransformChange: function(transform) {
                freeTransform.setViewportTransform(transform);
            },
            padding: 30
        });
        preview.render();
        (0, $7jh4K.css)(preview.getElement(), {
            overflow: 'hidden',
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        var lastDrawnTransformStr = '';
        function updatePreview() {
            var doForce = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            if (!freeTransform) return;
            var transform = freeTransform.getValue();
            if (JSON.stringify(transform) === lastDrawnTransformStr && !doForce) return;
            lastDrawnTransformStr = JSON.stringify(transform);
            var ctx = (0, $eWjiX.BB).ctx(previewCanvas);
            $31a0dd41d7428d32$var$drawTransform(ctx, layers[selectedLayerIndex].context.canvas, algorithmSelect.getValue() === 'pixelated', transform, selection, boundsObj, doClone, isTransparentBg || selectedLayerIndex > 0);
            preview.render();
        }
        var freeTransform = new (0, $0370167ee97a20d9$export$79a74567acf241b0)({
            x: initTransform.x,
            y: initTransform.y,
            width: initTransform.width,
            height: initTransform.height,
            angleDeg: initTransform.angleDeg,
            isConstrained: true,
            snapX: [
                0,
                context.canvas.width
            ],
            snapY: [
                0,
                context.canvas.height
            ],
            callback: function callback(t) {
                inputX.value = '' + Math.round(t.x - initTransform.x);
                inputY.value = '' + Math.round(t.y - initTransform.y);
                inputR.value = '' + Math.round(t.angleDeg);
                updatePreview();
            },
            viewportTransform: preview.getTransform()
        });
        (0, $7jh4K.css)(freeTransform.getElement(), {
            position: 'absolute',
            left: '0',
            top: '0'
        });
        preview.getElement().append(freeTransform.getElement());
        function onInputsChanged() {
            freeTransform.setPos({
                x: parseInt(inputX.value) + initTransform.x,
                y: parseInt(inputY.value) + initTransform.y
            });
            freeTransform.setAngleDeg(parseInt(inputR.value));
            updatePreview();
        }
        updatePreview();
        result.destroy = function() {
            keyListener.destroy();
            freeTransform.destroy();
            constrainCheckbox.destroy();
            snappingCheckbox.destroy();
            (0, $eWjiX.BB).destroyEl(flipXBtn);
            (0, $eWjiX.BB).destroyEl(flipYBtn);
            (0, $eWjiX.BB).destroyEl(scaleRotLeftBtn);
            (0, $eWjiX.BB).destroyEl(scaleRotRightBtn);
            (0, $eWjiX.BB).destroyEl(scaleDoubleBtn);
            (0, $eWjiX.BB).destroyEl(scaleHalfBtn);
            (0, $eWjiX.BB).destroyEl(centerBtn);
            preview.destroy();
            (0, $eWjiX.BB).freeCanvas(previewCanvas);
        };
        result.getInput = function() {
            var transform = freeTransform.getValue();
            if (transparentBgCheckboxTouched) $31a0dd41d7428d32$var$preferenceIsTransparentBg = isTransparentBg;
            var input = {
                transform: transform,
                bounds: boundsObj,
                isPixelated: algorithmSelect.getValue() === 'pixelated',
                doClone: doClone,
                isTransparentBg: isTransparentBg
            };
            result.destroy();
            return (0, $eWjiX.BB).copyObj(input);
        };
        return result;
    },
    apply (params) {
        var context = params.layer.context;
        var klHistory = params.klHistory;
        if (!context) return false;
        klHistory.pause(true);
        var input = params.input;
        var selectedLayerIndex = params.klCanvas.getLayerIndex(context.canvas);
        var copyCanvas = (0, $eWjiX.BB).copyCanvas(context.canvas);
        var selection = params.klCanvas.getSelection();
        var matrix = $31a0dd41d7428d32$var$drawTransform(context, copyCanvas, input.isPixelated, input.transform, selection, input.bounds, input.doClone, input.isTransparentBg || selectedLayerIndex > 0);
        if (selection && matrix) {
            selection = (0, $bbA6w.transformMultiPolygon)(selection, matrix);
            params.klCanvas.setSelection(selection);
        }
        klHistory.pause(false);
        {
            var layerMap = Object.fromEntries(params.klCanvas.getLayers().map(function(layerItem) {
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push((0, $cL71g._)({
                layerMap: layerMap
            }, selection ? {
                selection: {
                    value: selection
                }
            } : undefined));
        }
        return true;
    }
};








var $eWjiX = parcelRequire("eWjiX");




var $7jh4K = parcelRequire("7jh4K");
var $95b95646154e8218$export$55e7eb2ebd0db869 = {
    getDialog (params) {
        var klCanvas = params.klCanvas;
        var context = params.context;
        if (!klCanvas || !context) return false;
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall);
        var radius = 10;
        var fxPreviewRenderer = new (0, $14b90ba44af68d49$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: function(fxCanvas, transform) {
                return fxCanvas.multiplyAlpha().triangleBlur(radius * transform.scaleX).unmultiplyAlpha();
            },
            selection: klCanvas.getSelection()
        });
        var radiusSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('radius'),
            width: 300,
            height: 30,
            min: 1,
            max: 200,
            value: radius,
            eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
            onChange: function(val) {
                radius = val;
                preview.render();
            }
        });
        radiusSlider.getElement().style.marginBottom = '10px';
        rootEl.append(radiusSlider.getElement());
        var previewLayerArr = [];
        for(var i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        var preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $7jh4K.css)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        result.destroy = function() {
            radiusSlider.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                radius: radius
            };
        };
        return result;
    },
    apply (params) {
        var context = params.layer.context;
        var klHistory = params.klHistory;
        var radius = params.input.radius;
        if (!context || !radius) return false;
        return (0, $670db093f8076d2c$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), function(fxCanvas) {
            fxCanvas.multiplyAlpha().triangleBlur(radius).unmultiplyAlpha();
        }, klHistory);
    }
};







var $eWjiX = parcelRequire("eWjiX");




var $7jh4K = parcelRequire("7jh4K");
var $82f12ab116cea855$export$62ac74a5ea43bd5c = {
    getDialog (params) {
        var context = params.context;
        var klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall);
        var radius = 2, strength = 0.51;
        var fxPreviewRenderer = new (0, $14b90ba44af68d49$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: function(fxCanvas, transform) {
                return fxCanvas.unsharpMask(radius * transform.scaleX, strength);
            },
            selection: klCanvas.getSelection()
        });
        function update() {
            preview.render();
        }
        var radiusSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('radius'),
            width: 300,
            height: 30,
            min: 0,
            max: 200,
            value: 2,
            //eventResMs: eventResMs,
            onChange: function onChange(val) {
                radius = val;
                update();
            },
            curve: [
                [
                    0,
                    0
                ],
                [
                    0.1,
                    2
                ],
                [
                    0.5,
                    50
                ],
                [
                    1,
                    200
                ]
            ]
        });
        var strengthSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-unsharp-mask-strength'),
            width: 300,
            height: 30,
            min: 0,
            max: 50,
            value: 5.1,
            //eventResMs: eventResMs,
            onChange: function onChange(val) {
                strength = val / 10;
                update();
            },
            curve: [
                [
                    0,
                    0
                ],
                [
                    0.1,
                    2
                ],
                [
                    0.5,
                    10
                ],
                [
                    1,
                    50
                ]
            ]
        });
        radiusSlider.getElement().style.marginBottom = '10px';
        strengthSlider.getElement().style.marginBottom = '10px';
        rootEl.append(radiusSlider.getElement());
        rootEl.append(strengthSlider.getElement());
        var previewLayerArr = [];
        for(var i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        var preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        update();
        (0, $7jh4K.css)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        result.destroy = function() {
            radiusSlider.destroy();
            strengthSlider.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                radius: radius,
                strength: strength
            };
        };
        return result;
    },
    apply (params) {
        var context = params.layer.context;
        var klHistory = params.klHistory;
        var radius = params.input.radius;
        var strength = params.input.strength;
        if (!context || radius === null || strength === null) return false;
        return (0, $670db093f8076d2c$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), function(fxCanvas) {
            fxCanvas.unsharpMask(radius, strength);
        }, klHistory);
    }
};








var $eWjiX = parcelRequire("eWjiX");




var $7jh4K = parcelRequire("7jh4K");
var $a535e7a374deb8f5$export$6158ed2b22ebf4d9 = {
    getDialog (params) {
        var context = params.context;
        var klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = klCanvas.getLayerIndex(context.canvas);
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall);
        var fxPreviewRenderer = new (0, $14b90ba44af68d49$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: function(fxCanvas) {
                return fxCanvas.toAlpha(sourceId === 'inverted-luminance', selectedRgbaObj);
            },
            selection: klCanvas.getSelection()
        });
        // source
        var sourceId = 'inverted-luminance';
        var sourceOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'inverted-luminance',
                    label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-to-alpha-inverted-lum')
                },
                {
                    id: 'luminance',
                    label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-to-alpha-lum')
                }
            ],
            initId: sourceId,
            onChange: function onChange(id) {
                sourceId = id;
                preview.render();
            }
        });
        rootEl.append(sourceOptions.getElement());
        // color
        var selectedRgbaObj = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
        var colorOptionsArr = [
            null,
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            },
            {
                r: params.currentColorRgb.r,
                g: params.currentColorRgb.g,
                b: params.currentColorRgb.b,
                a: 1
            },
            {
                r: params.secondaryColorRgb.r,
                g: params.secondaryColorRgb.g,
                b: params.secondaryColorRgb.b,
                a: 1
            }
        ];
        var colorOptions = new (0, $4db8cbbb01889095$export$24ba9b81662d4366)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-to-alpha-replace'),
            colorArr: colorOptionsArr,
            initialIndex: 1,
            onChange: function onChange(rgbaObj) {
                selectedRgbaObj = rgbaObj;
                preview.render();
            },
            css: {
                margin: '10px 0'
            }
        });
        rootEl.append(colorOptions.getElement());
        var previewLayerArr = [];
        for(var i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        var preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $7jh4K.css)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        result.destroy = function() {
            sourceOptions.destroy();
            colorOptions.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return {
                sourceId: sourceId,
                selectedRgbaObj: selectedRgbaObj
            };
        };
        return result;
    },
    apply (params) {
        var context = params.layer.context;
        var klHistory = params.klHistory;
        var sourceId = params.input.sourceId;
        var selectedRgbaObj = params.input.selectedRgbaObj;
        if (!context || !sourceId) return false;
        return (0, $670db093f8076d2c$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), function(fxCanvas) {
            fxCanvas.toAlpha(sourceId === 'inverted-luminance', selectedRgbaObj);
        }, klHistory);
    }
};



var $eWjiX = parcelRequire("eWjiX");


var $dJPtW = parcelRequire("dJPtW");

// ideas: padding, gutter, other shapes
function $74df8e8cd35bce4e$export$20d2db9c68afeac(ctx, cellsX, cellsY, thickness, color, opacity) {
    ctx.save();
    var w = ctx.canvas.width;
    var h = ctx.canvas.height;
    thickness = Math.round(thickness);
    var thickIsRound = thickness % 2 === 0;
    ctx.beginPath();
    ctx.lineWidth = thickness;
    ctx.strokeStyle = color;
    ctx.globalAlpha = opacity;
    for(var i = 0; i < cellsX - 1; i++){
        var cw = w / cellsX;
        var pos = cw * (i + 1);
        if (thickIsRound) pos = Math.round(pos);
        else pos = Math.round(pos + 0.5) - 0.5;
        ctx.moveTo(pos, 0);
        ctx.lineTo(pos, h);
    }
    for(var i1 = 0; i1 < cellsY - 1; i1++){
        var ch = h / cellsY;
        var pos1 = ch * (i1 + 1);
        if (thickIsRound) pos1 = Math.round(pos1);
        else pos1 = Math.round(pos1 + 0.5) - 0.5;
        ctx.moveTo(0, pos1);
        ctx.lineTo(w, pos1);
    }
    ctx.stroke();
    ctx.restore();
}



var $7jh4K = parcelRequire("7jh4K");




var $bad33651972f8d2c$export$50020de79e1bc23 = {
    getDialog (params) {
        var context = params.context;
        var klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = (0, $7jh4K.throwIfNull)(klCanvas.getLayerIndex(context.canvas));
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall);
        var settingsObj = {
            x: 2,
            y: 2,
            thickness: 8,
            color: '#000',
            opacity: 1
        };
        var line1 = (0, $eWjiX.BB).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        var line2 = (0, $eWjiX.BB).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px',
                marginBottom: '10px'
            }
        });
        var xInput = (0, $dJPtW.input)({
            init: 2,
            type: 'number',
            min: 1,
            css: {
                width: '75px',
                marginRight: '20px'
            },
            callback: function callback(v) {
                settingsObj.x = parseFloat(v);
                updatePreview();
            }
        });
        var yInput = (0, $dJPtW.input)({
            init: 2,
            type: 'number',
            min: 1,
            css: {
                width: '75px',
                marginRight: '20px'
            },
            callback: function callback(v) {
                settingsObj.y = parseFloat(v);
                updatePreview();
            }
        });
        var thicknessInput = (0, $dJPtW.input)({
            init: settingsObj.thickness,
            type: 'number',
            min: 1,
            css: {
                width: '75px',
                marginRight: '20px'
            },
            callback: function callback(v) {
                settingsObj.thickness = parseFloat(v);
                updatePreview();
            }
        });
        var selectedRgbaObj = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
        var colorOptionsArr = [
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            }
        ];
        colorOptionsArr.push({
            r: params.currentColorRgb.r,
            g: params.currentColorRgb.g,
            b: params.currentColorRgb.b,
            a: 1
        });
        colorOptionsArr.push({
            r: params.secondaryColorRgb.r,
            g: params.secondaryColorRgb.g,
            b: params.secondaryColorRgb.b,
            a: 1
        });
        settingsObj.color = (0, $eWjiX.BB).ColorConverter.toRgbStr(selectedRgbaObj);
        var colorOptions = new (0, $4db8cbbb01889095$export$24ba9b81662d4366)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-stroke'),
            colorArr: colorOptionsArr,
            onChange: function onChange(rgbaObj) {
                selectedRgbaObj = rgbaObj;
                settingsObj.color = (0, $eWjiX.BB).ColorConverter.toRgbStr(selectedRgbaObj);
                updatePreview();
            }
        });
        var labelStyle = {
            display: 'inline-block',
            marginRight: '5px'
        };
        line1.append((0, $eWjiX.BB).el({
            content: 'X:',
            css: labelStyle
        }), xInput, (0, $eWjiX.BB).el({
            content: 'Y:',
            css: labelStyle
        }), yInput);
        line2.append((0, $eWjiX.BB).el({
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-line-width') + ':',
            css: labelStyle
        }), thicknessInput, (0, $eWjiX.BB).el({
            css: {
                flexGrow: '1'
            }
        }), colorOptions.getElement());
        var previewCanvas = (0, $eWjiX.BB).canvas(context.canvas.width, context.canvas.height);
        var previewCtx = (0, $eWjiX.BB).ctx(previewCanvas);
        var previewLayerArr = layers.map(function(item, i) {
            return {
                image: i === selectedLayerIndex ? previewCanvas : item.context.canvas,
                isVisible: item.isVisible,
                opacity: item.opacity,
                mixModeStr: item.mixModeStr,
                hasClipping: false
            };
        });
        var preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            }
        });
        (0, $7jh4K.css)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        function updatePreview() {
            var ctx = previewCtx;
            ctx.save();
            ctx.clearRect(0, 0, previewCanvas.width, previewCanvas.height);
            ctx.drawImage(context.canvas, 0, 0);
            (0, $74df8e8cd35bce4e$export$20d2db9c68afeac)(ctx, settingsObj.x, settingsObj.y, Math.max(settingsObj.thickness, 1), settingsObj.color, settingsObj.opacity);
            ctx.restore();
            preview.render();
        }
        updatePreview();
        preview.render();
        result.destroy = function() {
            preview.destroy();
            (0, $eWjiX.BB).freeCanvas(previewCanvas);
            colorOptions.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return (0, $eWjiX.BB).copyObj(settingsObj);
        };
        return result;
    },
    apply (params) {
        var context = params.layer.context;
        var klCanvas = params.klCanvas;
        var klHistory = params.klHistory;
        if (!context || !klCanvas) return false;
        (0, $74df8e8cd35bce4e$export$20d2db9c68afeac)(context, params.input.x, params.input.y, params.input.thickness, params.input.color, params.input.opacity);
        {
            var layerMap = Object.fromEntries(params.klCanvas.getLayers().map(function(layerItem) {
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push({
                layerMap: layerMap
            });
        }
        return true;
    }
};



var $bX4ja = parcelRequire("bX4ja");

var $eWjiX = parcelRequire("eWjiX");









var $dJ1E2 = parcelRequire("dJ1E2");


var $7jh4K = parcelRequire("7jh4K");






var $eIcQa = parcelRequire("eIcQa");


var $595c9469b8f94062$var$presetArr = [
    // each pixel random value
    {
        type: 0,
        scaleX: 1,
        scaleY: 1,
        offsetX: 0,
        offsetY: 0,
        octaves: 1,
        samples: 1,
        peaks: 0,
        brightness: 0,
        contrast: 0,
        isReversed: true
    },
    // cloud
    {
        type: 1,
        scaleX: 166,
        scaleY: 164,
        offsetX: 105,
        offsetY: 30,
        octaves: 6,
        samples: 1,
        peaks: 0,
        brightness: 0.055,
        contrast: 0.23,
        isReversed: true
    },
    // thin lines
    {
        type: 1,
        scaleX: 235,
        scaleY: 190,
        offsetX: 3227,
        offsetY: 2156,
        octaves: 4,
        samples: 16,
        peaks: 22,
        brightness: -0.375,
        contrast: 1,
        isReversed: false
    },
    // soft large simplex, only 1 octave
    {
        type: 1,
        scaleX: 40,
        scaleY: 40,
        offsetX: 0,
        offsetY: 0,
        octaves: 1,
        samples: 1,
        peaks: 0,
        brightness: 0,
        contrast: 0,
        isReversed: false
    },
    // two value large pixels
    {
        type: 0,
        scaleX: 26,
        scaleY: 26,
        offsetX: 557,
        offsetY: 365,
        octaves: 1,
        samples: 1,
        peaks: 0,
        brightness: 0.02,
        contrast: 1,
        isReversed: true
    },
    // zebra
    {
        type: 1,
        scaleX: 1500,
        scaleY: 1500,
        offsetX: 745,
        offsetY: 2871,
        octaves: 5,
        samples: 16,
        peaks: 156.02,
        brightness: 0.03,
        contrast: 1,
        isReversed: true
    },
    // sparse dots / stars
    {
        type: 1,
        scaleX: 11,
        scaleY: 11,
        offsetX: 2940,
        offsetY: 2045,
        octaves: 1,
        samples: 16,
        peaks: 1,
        brightness: -0.045,
        contrast: 1,
        isReversed: true
    },
    // pseudo marble
    {
        type: 2,
        scaleX: 74,
        scaleY: 74,
        offsetX: 4816,
        offsetY: 1304,
        octaves: 3,
        samples: 1,
        peaks: 2.78,
        brightness: 0,
        contrast: 0,
        isReversed: false
    }
];
function $595c9469b8f94062$var$createNoiseSettings(input) {
    var result = (0, $eWjiX.BB).copyObj($595c9469b8f94062$var$presetArr[input.presetIndex]);
    result.seed = input.seed;
    result.scaleX = result.scaleX * input.scale / 50;
    result.scaleY = result.scaleY * input.scale / 50;
    result.colA = input.colA;
    result.colB = input.colB;
    result.isReversed = input.isReversed ? !result.isReversed : result.isReversed;
    result.channels = input.channels;
    return result;
}
function $595c9469b8f94062$var$createNoiseParameters(settings) {
    return [
        settings.seed,
        settings.type,
        [
            settings.scaleX,
            settings.scaleY
        ],
        [
            settings.offsetX,
            settings.offsetY
        ],
        settings.octaves,
        settings.samples,
        settings.peaks,
        settings.brightness,
        settings.contrast,
        settings.isReversed,
        settings.colA,
        settings.colB,
        settings.channels ? settings.channels : 'rgb'
    ];
}
var $595c9469b8f94062$export$1dab0536099042f5 = {
    getDialog (params) {
        var context = params.context;
        var klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = (0, $7jh4K.throwIfNull)(klCanvas.getLayerIndex(context.canvas));
        var thumbImgArr = [];
        var thumbSize = 32;
        {
            var fxCanvas = (0, $7jh4K.throwIfNull)((0, $02a74dc72797630f$export$8c4423af32b21158)());
            var canvas = (0, $eWjiX.BB).canvas(thumbSize, thumbSize);
            var ctx = (0, $eWjiX.BB).ctx(canvas);
            var texture = fxCanvas.texture(canvas);
            fxCanvas.draw(texture).update(); // update fxCanvas size
            texture.destroy();
            $595c9469b8f94062$var$presetArr.forEach(function(preset) {
                var _fxCanvas;
                var thumbImg = new Image();
                var settings = (0, $eWjiX.BB).copyObj(preset);
                settings.scaleX /= 10;
                settings.scaleY /= 10;
                (_fxCanvas = fxCanvas).noise.apply(_fxCanvas, (0, $bX4ja._)($595c9469b8f94062$var$createNoiseParameters(settings))).update();
                ctx.drawImage(fxCanvas, 0, 0);
                thumbImg.src = canvas.toDataURL('image/png');
                thumbImgArr.push(thumbImg);
            });
            texture.destroy();
        }
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall);
        var noiseInput = {
            seed: Math.random() * 300,
            presetIndex: 0,
            scale: 50,
            opacity: 0.5,
            isReversed: false,
            channels: 'rgb',
            mixModeStr: 'source-over',
            colA: {
                r: 0,
                g: 0,
                b: 0
            },
            colB: {
                r: 255,
                g: 255,
                b: 255
            }
        };
        var presetOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: thumbImgArr.map(function(img, index) {
                (0, $7jh4K.css)(img, {
                    margin: '1px',
                    borderRadius: '3px',
                    transition: 'all 0.1s ease-in-out'
                });
                return {
                    id: '' + index,
                    label: img
                };
            }),
            initId: '0',
            onChange: function(id) {
                noiseInput.presetIndex = Number(id);
                update();
            },
            css: {
                marginBottom: '10px'
            }
        });
        rootEl.append(presetOptions.getElement());
        var scaleSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-noise-scale'),
            width: 300,
            height: 30,
            min: 1,
            max: 1000,
            value: noiseInput.scale,
            eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
            curve: (0, $eWjiX.BB).powerSplineInput(1, 1000, 0.1),
            onChange: function(value) {
                noiseInput.scale = value;
                update();
            }
        });
        scaleSlider.getElement().style.marginBottom = '10px';
        var opacitySlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('opacity'),
            width: 300,
            height: 30,
            min: 0.01,
            max: 1,
            value: noiseInput.opacity,
            eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
            toValue: function(displayValue) {
                return displayValue / 100;
            },
            toDisplayValue: function(value) {
                return value * 100;
            },
            onChange: function(value) {
                noiseInput.opacity = value;
                update();
            }
        });
        opacitySlider.getElement().style.marginBottom = '10px';
        var row1El = (0, $eWjiX.BB).el({
            css: {
                display: 'flex',
                alignItems: 'center',
                marginBottom: '10px'
            }
        });
        var row2El = (0, $eWjiX.BB).el({
            css: {
                display: 'flex',
                marginBottom: '10px'
            }
        });
        var channelsOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'rgb',
                    label: 'RGB'
                },
                {
                    id: 'alpha',
                    label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-noise-alpha')
                }
            ],
            initId: 'rgb',
            onChange: function(id) {
                noiseInput.channels = id;
                if (id === 'rgb') row2El.style.visibility = '';
                else row2El.style.visibility = 'hidden';
                update();
            }
        });
        var reverseToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('reverse'),
            callback: function(val) {
                noiseInput.isReversed = val;
                update();
            },
            allowTab: true,
            name: 'reverse-gradient'
        });
        var mixModes = [
            'source-over',
            undefined,
            'darken',
            'multiply',
            'color-burn',
            undefined,
            'lighten',
            'screen',
            'color-dodge',
            undefined,
            'overlay',
            'soft-light',
            'hard-light',
            undefined,
            'difference',
            'exclusion',
            undefined,
            'hue',
            'saturation',
            'color',
            'luminosity'
        ];
        var blendSelect = new (0, $7a3263857aacf58f$export$ef9b1a59e592288f)({
            isFocusable: true,
            optionArr: mixModes.map(function(item) {
                return item ? [
                    item,
                    (0, $2f1281ced73ab1dc$export$6e1bedb2a6cdff30)(item)
                ] : undefined;
            }),
            initValue: noiseInput.mixModeStr,
            onChange: function(val) {
                noiseInput.mixModeStr = val;
                update();
            },
            name: 'blend-mode'
        });
        blendSelect.getElement().title = (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-blending');
        var colorWrapper = (0, $eWjiX.BB).el({
            css: {
                display: 'flex'
            }
        });
        var colInputStyle = {
            width: '34px',
            height: '34px',
            marginRight: '5px'
        };
        var colAInput = (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).input({
            type: 'color',
            init: '#' + (0, $dJ1E2.ColorConverter).toHexString(noiseInput.colA),
            callback: function(val) {
                var newColor = (0, $dJ1E2.ColorConverter).hexToRGB(val);
                if (newColor) {
                    noiseInput.colA = newColor;
                    update();
                }
            },
            css: colInputStyle
        });
        var colBInput = (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).input({
            type: 'color',
            init: '#' + (0, $dJ1E2.ColorConverter).toHexString(noiseInput.colB),
            callback: function(val) {
                var newColor = (0, $dJ1E2.ColorConverter).hexToRGB(val);
                if (newColor) {
                    noiseInput.colB = newColor;
                    update();
                }
            },
            css: colInputStyle
        });
        colorWrapper.append(colAInput, colBInput);
        row1El.append(channelsOptions.getElement(), (0, $eWjiX.BB).el({
            css: {
                flexGrow: '1'
            }
        }), reverseToggle.getElement());
        row2El.append(blendSelect.getElement(), (0, $eWjiX.BB).el({
            css: {
                flexGrow: '1'
            }
        }), colorWrapper);
        rootEl.append(scaleSlider.getElement(), opacitySlider.getElement(), row1El, row2El);
        var fxPreviewRenderer = new (0, $14b90ba44af68d49$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: function(fxCanvas, transform) {
                var _fxCanvas;
                var settings = $595c9469b8f94062$var$createNoiseSettings(noiseInput);
                settings.scaleX *= transform.scaleX;
                settings.scaleY *= transform.scaleY;
                settings.offsetX = context.canvas.width / 2 * transform.scaleX + transform.x;
                settings.offsetY = context.canvas.height / 2 * transform.scaleY + transform.y;
                return (_fxCanvas = fxCanvas).noise.apply(_fxCanvas, (0, $bX4ja._)($595c9469b8f94062$var$createNoiseParameters(settings)));
            },
            postMix: {
                opacity: noiseInput.opacity,
                operation: noiseInput.channels === 'alpha' ? 'destination-out' : noiseInput.mixModeStr
            },
            selection: klCanvas.getSelection(),
            isMaskingWithEmptyOriginal: true
        });
        var previewLayerArr = [];
        for(var i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? fxPreviewRenderer.render : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        var preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $7jh4K.css)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        function update() {
            fxPreviewRenderer.setPostMix({
                opacity: noiseInput.opacity,
                operation: noiseInput.channels === 'alpha' ? 'destination-out' : noiseInput.mixModeStr
            });
            preview.render();
        }
        result.destroy = function() {
            presetOptions.destroy();
            scaleSlider.destroy();
            opacitySlider.destroy();
            reverseToggle.destroy();
            channelsOptions.destroy();
            blendSelect.destroy();
            preview.destroy();
            fxPreviewRenderer.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return (0, $eWjiX.BB).copyObj(noiseInput);
        };
        return result;
    },
    apply (params) {
        var context = params.layer.context;
        var klCanvas = params.klCanvas;
        var klHistory = params.klHistory;
        if (!context || !klCanvas) return false;
        var fxCanvas = (0, $02a74dc72797630f$export$8c4423af32b21158)();
        if (!fxCanvas) return false; // todo more specific error?
        var input = params.input;
        var selection = klCanvas.getSelection();
        var maskTexture;
        if (selection) {
            var maskCanvas = (0, $eWjiX.BB).canvas(context.canvas.width, context.canvas.height);
            var maskContext = (0, $eWjiX.BB).ctx(maskCanvas);
            (0, $eIcQa.drawSelectionMask)(selection, maskContext);
            maskTexture = fxCanvas.texture(maskCanvas);
            (0, $eWjiX.BB).freeCanvas(maskCanvas);
        }
        fxCanvas.initialize(context.canvas.width, context.canvas.height);
        {
            var _fxCanvas;
            var settings = $595c9469b8f94062$var$createNoiseSettings(input);
            settings.offsetX = context.canvas.width / 2;
            settings.offsetY = context.canvas.height / 2;
            (_fxCanvas = fxCanvas).noise.apply(_fxCanvas, (0, $bX4ja._)($595c9469b8f94062$var$createNoiseParameters(settings))).update();
        }
        if (maskTexture) {
            fxCanvas.multiplyAlpha().mask(maskTexture).unmultiplyAlpha();
            maskTexture.destroy();
        }
        fxCanvas.update();
        context.save();
        context.globalAlpha = input.opacity;
        if (input.channels === 'alpha') context.globalCompositeOperation = 'destination-out';
        else context.globalCompositeOperation = input.mixModeStr;
        context.drawImage(fxCanvas, 0, 0);
        context.restore();
        klHistory.push((0, $5bc59effccf14376$export$263fa670dc037098)(klHistory.getComposed(), (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(context.canvas, selection ? (0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(selection, 'index') : undefined)));
        return true;
    }
};



var $eWjiX = parcelRequire("eWjiX");

var $dJPtW = parcelRequire("dJPtW");






var $7jh4K = parcelRequire("7jh4K");




var $eIcQa = parcelRequire("eIcQa");
/**
 * Draws pattern onto context. Pattern generated from context.
 * Can use blending for smoother transition. Will use area outside of bounds for blending.
 *
 * @param context
 * @param settings
 */ function $ebbf7e5d844153e5$var$drawPattern(context, settings) {
    // keep bounds in center via offset
    // because blending done towards bottom right
    var blendOffsetX = settings.blend ? Math.round(settings.blend * settings.width / 2) : 0;
    var blendOffsetY = settings.blend ? Math.round(settings.blend * settings.height / 2) : 0;
    var finalPatternCanvas = (0, $eWjiX.BB).canvas(settings.width, settings.height);
    if (settings.blend) {
        // construct pattern via linear blending
        var blendCanvas = (0, $eWjiX.BB).canvas(settings.width * 2, settings.height * 2);
        var blendCtx = (0, $eWjiX.BB).ctx(blendCanvas);
        var colTransparent = '#0000';
        var colOpaque = '#000';
        // transfer source to blendCanvas
        blendCtx.drawImage(context.canvas, -settings.x + blendOffsetX, -settings.y + blendOffsetY);
        // --- 1 cross-fade vertical ------------------------
        // erase vertical gradient bottom half
        blendCtx.save();
        var blendGradient = blendCtx.createLinearGradient(0, settings.height, 0, settings.height * 2);
        blendGradient.addColorStop(0, colOpaque);
        blendGradient.addColorStop(settings.blend, colTransparent);
        blendCtx.globalCompositeOperation = 'destination-in';
        blendCtx.fillStyle = blendGradient;
        blendCtx.fillRect(0, 0, blendCanvas.width, blendCanvas.height);
        blendCtx.restore();
        // erase vertical gradient top half
        blendCtx.save();
        blendGradient = blendCtx.createLinearGradient(0, 0, 0, settings.height);
        blendGradient.addColorStop(0, colTransparent);
        blendGradient.addColorStop(settings.blend, colOpaque);
        blendCtx.globalCompositeOperation = 'destination-in';
        blendCtx.fillStyle = blendGradient;
        blendCtx.fillRect(0, 0, settings.width * 2, settings.height * 2);
        blendCtx.restore();
        // draw bottom half over top half
        blendCtx.save();
        // lighter needed for accurate cross-fade
        blendCtx.globalCompositeOperation = 'lighter';
        blendCtx.drawImage(blendCanvas, 0, -settings.height);
        blendCtx.restore();
        // --- 2 cross-fade horizontal ------------------------
        // erase horizontal gradient right half
        blendCtx.save();
        blendGradient = blendCtx.createLinearGradient(settings.width, 0, settings.width * 2, 0);
        blendGradient.addColorStop(0, colOpaque);
        blendGradient.addColorStop(settings.blend, colTransparent);
        blendCtx.globalCompositeOperation = 'destination-in';
        blendCtx.fillStyle = blendGradient;
        blendCtx.fillRect(0, 0, blendCanvas.width, blendCanvas.height);
        blendCtx.restore();
        // erase horizontal gradient left half
        blendCtx.save();
        blendGradient = blendCtx.createLinearGradient(0, 0, settings.width, 0);
        blendGradient.addColorStop(0, colTransparent);
        blendGradient.addColorStop(settings.blend, colOpaque);
        blendCtx.globalCompositeOperation = 'destination-in';
        blendCtx.fillStyle = blendGradient;
        blendCtx.fillRect(0, 0, settings.width * 2, settings.height * 2);
        blendCtx.restore();
        // draw right half over left half
        blendCtx.save();
        // lighter needed for accurate cross-fade
        blendCtx.globalCompositeOperation = 'lighter';
        blendCtx.drawImage(blendCanvas, -settings.width, 0);
        blendCtx.restore();
        // transfer to pattern canvas
        (0, $eWjiX.BB).ctx(finalPatternCanvas).drawImage(blendCanvas, 0, 0);
    } else (0, $eWjiX.BB).ctx(finalPatternCanvas).drawImage(context.canvas, -settings.x, -settings.y);
    context.save();
    context.clearRect(0, 0, context.canvas.width, context.canvas.height);
    context.translate(settings.offsetX - blendOffsetX, settings.offsetY - blendOffsetY);
    context.fillStyle = (0, $7jh4K.throwIfNull)(context.createPattern(finalPatternCanvas, 'repeat'));
    context.fillRect(-settings.offsetX + blendOffsetX, -settings.offsetY + blendOffsetY, context.canvas.width, context.canvas.height);
    context.restore();
}
var $ebbf7e5d844153e5$export$5b48b77a483d9b33 = {
    getDialog (params) {
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        var maxSize = 1024;
        var rootEl = (0, $eWjiX.BB).el();
        var context = params.context;
        var width = context.canvas.width;
        var height = context.canvas.height;
        var settings = {
            x: 0,
            y: 0,
            width: width <= 250 ? Math.round(width / 4) : 200,
            height: height <= 250 ? Math.round(height / 4) : 200,
            blend: 0,
            offsetX: 0,
            offsetY: 0
        };
        var lastDrawnSettings;
        // determine bounds
        var bounds = (0, $eIcQa.getCanvasBounds)(context);
        // adjust settings according to bounds
        if (// use layer bounds if:
        bounds && bounds.width <= maxSize && bounds.height <= maxSize && // don't exceed max size
        (bounds.width < width * 0.75 || bounds.height < height * 0.75 // aren't too large (heuristic)
        )) {
            settings.x = bounds.x;
            settings.y = bounds.y;
            settings.width = bounds.width;
            settings.height = bounds.height;
        } else {
            // otherwise use default size in center
            settings.x = Math.round(width / 2 - settings.width / 2);
            settings.y = Math.round(height / 2 - settings.height / 2);
        }
        // ---- controls ----
        var xInput = (0, $dJPtW.input)({
            init: settings.x,
            type: 'number',
            min: 0,
            max: width,
            css: {
                width: '100%'
            },
            callback: function callback(v) {
                settings.x = Number(v);
                updatePreview();
            }
        });
        var yInput = (0, $dJPtW.input)({
            init: settings.y,
            type: 'number',
            min: 0,
            max: height,
            css: {
                width: '100%'
            },
            callback: function callback(v) {
                settings.y = Number(v);
                updatePreview();
            }
        });
        var widthInput = (0, $dJPtW.input)({
            init: settings.width,
            type: 'number',
            min: 1,
            max: Math.min(maxSize, width),
            css: {
                width: '100%'
            },
            callback: function callback(v) {
                settings.width = Number(v);
                updatePreview();
            }
        });
        var heightInput = (0, $dJPtW.input)({
            init: settings.height,
            type: 'number',
            min: 1,
            max: Math.min(maxSize, height),
            css: {
                width: '100%'
            },
            callback: function callback(v) {
                settings.height = Number(v);
                updatePreview();
            }
        });
        var inputStyle = {
            marginLeft: '5px',
            flex: '1'
        };
        rootEl.append((0, $eWjiX.BB).el({
            content: [
                (0, $eWjiX.BB).el({
                    tagName: 'label',
                    content: [
                        'X:',
                        xInput
                    ],
                    css: inputStyle
                }),
                (0, $eWjiX.BB).el({
                    tagName: 'label',
                    content: [
                        'Y:',
                        yInput
                    ],
                    css: inputStyle
                }),
                (0, $eWjiX.BB).el({
                    tagName: 'label',
                    content: [
                        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('width') + ':',
                        widthInput
                    ],
                    css: inputStyle
                }),
                (0, $eWjiX.BB).el({
                    tagName: 'label',
                    content: [
                        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('height') + ':',
                        heightInput
                    ],
                    css: inputStyle
                })
            ],
            css: {
                display: 'flex',
                marginLeft: '-5px'
            }
        }));
        var blendSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-blending'),
            width: 300,
            height: 30,
            min: 0,
            max: 1,
            value: settings.blend,
            eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
            onChange: function onChange(val) {
                settings.blend = val;
                updatePreview();
            },
            formatFunc: function(val) {
                return (0, $eWjiX.BB).round(val, 2);
            },
            manualInputRoundDigits: 2
        });
        (0, $7jh4K.css)(blendSlider.getElement(), {
            margin: '10px 0'
        });
        rootEl.append(blendSlider.getElement());
        // ---- preview tabs ----
        var previewMode = 1; // 0 before, 1 after
        var beforeAfterTabs = new (0, $8b4f5ae4fe73ff76$export$b1241e74876d9bbe)({
            left: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('compare-before'),
            right: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('compare-after'),
            init: previewMode,
            onChange: function(val) {
                previewMode = val;
                overlayCanvas.style.display = val === 0 ? 'block' : 'none';
                updatePreview(true);
            }
        });
        rootEl.append(beforeAfterTabs.getElement());
        // ---- previews ----
        var klCanvas = params.klCanvas;
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = (0, $7jh4K.throwIfNull)(klCanvas.getLayerIndex(context.canvas));
        var fit = (0, $eWjiX.BB).fitInto(context.canvas.width, context.canvas.height, isSmall ? 280 : 490, isSmall ? 200 : 240, 1);
        var w = parseInt('' + fit.width), h = parseInt('' + fit.height);
        var renderW = Math.min(w, context.canvas.width);
        var renderH = Math.min(h, context.canvas.height);
        // const renderFactor = renderW / context.canvas.width;
        var previewFactor = w / context.canvas.width;
        var previewWrapper = (0, $eWjiX.BB).el({
            className: 'kl-preview-wrapper',
            css: {
                width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall) + 'px',
                height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall) + 'px',
                marginTop: '0'
            }
        });
        var previewLayer = {
            image: (0, $eWjiX.BB).canvas(renderW, renderH),
            isVisible: layers[selectedLayerIndex].isVisible,
            opacity: layers[selectedLayerIndex].opacity,
            mixModeStr: layers[selectedLayerIndex].mixModeStr
        };
        var previewLayerArr = layers.map(function(item, i) {
            if (i === selectedLayerIndex) return previewLayer;
            else return {
                image: item.context.canvas,
                isVisible: item.isVisible,
                opacity: item.opacity,
                mixModeStr: item.mixModeStr
            };
        });
        var klCanvasPreview = new (0, $e6889b231e436752$export$e258ade1648009b7)({
            width: Math.round(w),
            height: Math.round(h),
            layers: previewLayerArr
        });
        var overlayCanvas = (0, $eWjiX.BB).canvas(w, h);
        (0, $7jh4K.css)(overlayCanvas, {
            position: 'absolute',
            left: '0',
            top: '0',
            mixBlendMode: 'difference',
            imageRendering: 'pixelated'
        });
        var previewInnerWrapper = (0, $eWjiX.BB).el({
            className: 'kl-preview-wrapper__canvas',
            css: {
                width: parseInt('' + w) + 'px',
                height: parseInt('' + h) + 'px'
            }
        });
        previewInnerWrapper.append(klCanvasPreview.getElement(), overlayCanvas);
        previewWrapper.append(previewInnerWrapper);
        rootEl.append(previewWrapper);
        // ---- preview input processing ----
        var inputs = {};
        function syncInputs() {
            xInput.value = '' + settings.x;
            yInput.value = '' + settings.y;
            widthInput.value = '' + settings.width;
            heightInput.value = '' + settings.height;
        }
        var keyListener = new (0, $eWjiX.BB).KeyListener({});
        previewWrapper.oncontextmenu = function() {
            return false;
        };
        previewInnerWrapper.style.touchAction = 'none';
        var pointerListener = new (0, $eWjiX.BB).PointerListener({
            target: previewInnerWrapper,
            onPointer: function(event) {
                if (previewMode === 0) {
                    if (event.type === 'pointerdown') {
                        if (!inputs.state) {
                            inputs.oldSettings = (0, $eWjiX.BB).copyObj(settings);
                            var x = event.relX / previewFactor;
                            var y = event.relY / previewFactor;
                            if ((0, $eWjiX.BB).isInsideRect({
                                x: x,
                                y: y
                            }, {
                                x: settings.x,
                                y: settings.y,
                                width: settings.width,
                                height: settings.height
                            })) inputs.state = 'move';
                            else inputs.state = 'select';
                            inputs.start = {
                                x: x,
                                y: y
                            };
                        }
                    } else if (event.type === 'pointermove') {
                        var x1 = event.relX / previewFactor;
                        var y1 = event.relY / previewFactor;
                        if (inputs.state === 'select') {
                            inputs.end = {
                                x: x1,
                                y: y1
                            };
                            var x11 = Math.max(0, Math.min(inputs.start.x, inputs.end.x));
                            var y11 = Math.max(0, Math.min(inputs.start.y, inputs.end.y));
                            var x2 = Math.min(width, Math.max(inputs.start.x, inputs.end.x));
                            var y2 = Math.min(height, Math.max(inputs.start.y, inputs.end.y));
                            settings.x = Math.floor(x11);
                            settings.y = Math.floor(y11);
                            settings.width = Math.min(maxSize, Math.ceil(x2 - settings.x));
                            settings.height = Math.min(maxSize, Math.ceil(y2 - settings.y));
                            if (keyListener.isPressed('shift')) {
                                settings.width = Math.min(settings.width, settings.height);
                                settings.height = Math.min(settings.width, settings.height);
                            }
                            if (settings.width === 0 || settings.height === 0) settings = (0, $eWjiX.BB).copyObj(inputs.oldSettings);
                            syncInputs();
                            updatePreview();
                        } else if (inputs.state === 'move') {
                            var dX = Math.round(x1 - inputs.start.x);
                            var dY = Math.round(y1 - inputs.start.y);
                            settings.x = (0, $eWjiX.BB).clamp(inputs.oldSettings.x + dX, 0, width - settings.width);
                            settings.y = (0, $eWjiX.BB).clamp(inputs.oldSettings.y + dY, 0, height - settings.height);
                            syncInputs();
                            updatePreview();
                        }
                    } else if (event.type === 'pointerup') {
                        if (inputs.state) inputs.state = null;
                    }
                } else {
                    if (event.type === 'pointerdown') {
                        if (!inputs.state) {
                            inputs.state = 'move';
                            inputs.oldSettings = (0, $eWjiX.BB).copyObj(settings);
                            inputs.start = {
                                x: event.relX / previewFactor,
                                y: event.relY / previewFactor
                            };
                            inputs.end = null;
                        }
                    } else if (event.type === 'pointermove') {
                        if (inputs.state) {
                            inputs.end = {
                                x: event.relX / previewFactor,
                                y: event.relY / previewFactor
                            };
                            settings.offsetX = Math.round(inputs.end.x - inputs.start.x) + inputs.oldSettings.offsetX;
                            settings.offsetY = Math.round(inputs.end.y - inputs.start.y) + inputs.oldSettings.offsetY;
                            updatePreview();
                        }
                    } else if (event.type === 'pointerup') {
                        if (inputs.state) {
                            if (!inputs.end) {
                                settings.offsetX = 0;
                                settings.offsetY = 0;
                                updatePreview();
                            }
                            inputs.state = null;
                        }
                    }
                }
            }
        });
        // ---------- rendering ---------------------
        var fullSizeCanvas = (0, $eWjiX.BB).canvas(width, height);
        var fullSizeCtx = (0, $eWjiX.BB).ctx(fullSizeCanvas);
        function sharpStrokeRect(context, x, y, width, height) {
            var drawX = Math.round(x + 0.5) - 0.5;
            var drawY = Math.round(y + 0.5) - 0.5;
            var drawWidth = Math.round(x + width - drawX);
            var drawHeight = Math.round(y + height - drawY);
            context.strokeRect(drawX, drawY, drawWidth, drawHeight);
        }
        function updatePreview(doForce) {
            if (!doForce && lastDrawnSettings && JSON.stringify(lastDrawnSettings) === JSON.stringify(settings)) return;
            if (previewMode === 0) {
                // before
                fullSizeCtx.clearRect(0, 0, width, height);
                fullSizeCtx.drawImage(context.canvas, 0, 0);
                var previewCanvas = previewLayer.image;
                var previewCtx = (0, $eWjiX.BB).ctx(previewCanvas);
                previewCtx.save();
                previewCtx.clearRect(0, 0, renderW, renderH);
                previewCtx.drawImage(fullSizeCanvas, 0, 0, renderW, renderH);
                previewCtx.restore();
                var pW = settings.width * previewFactor;
                var pH = settings.height * previewFactor;
                var overlayCtx = (0, $eWjiX.BB).ctx(overlayCanvas);
                overlayCtx.save();
                overlayCtx.clearRect(0, 0, w, h);
                overlayCtx.strokeStyle = '#fff';
                sharpStrokeRect(overlayCtx, settings.x * previewFactor, settings.y * previewFactor, pW, pH);
                if (settings.blend > 0.05) {
                    overlayCtx.strokeStyle = '#f0f';
                    sharpStrokeRect(overlayCtx, settings.x * previewFactor - pW / 2 * settings.blend, settings.y * previewFactor - pH / 2 * settings.blend, pW * (1 + settings.blend), pH * (1 + settings.blend));
                }
                overlayCtx.restore();
            } else {
                // after
                fullSizeCtx.clearRect(0, 0, width, height);
                fullSizeCtx.drawImage(context.canvas, 0, 0);
                $ebbf7e5d844153e5$var$drawPattern(fullSizeCtx, settings);
                var previewCanvas1 = previewLayer.image;
                var previewCtx1 = (0, $eWjiX.BB).ctx(previewCanvas1);
                previewCtx1.clearRect(0, 0, renderW, renderH);
                previewCtx1.drawImage(fullSizeCanvas, 0, 0, renderW, renderH);
            }
            klCanvasPreview.render();
            lastDrawnSettings = (0, $eWjiX.BB).copyObj(settings);
        }
        updatePreview();
        // ----- result -------------------
        var destroy = function() {
            blendSlider.destroy();
            keyListener.destroy();
            pointerListener.destroy();
            klCanvasPreview.destroy();
        };
        var result = {
            element: rootEl,
            destroy: destroy,
            getInput: function() {
                destroy();
                return (0, $eWjiX.BB).copyObj(settings);
            }
        };
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$3a4a74a7d8c44e62).width;
        return result;
    },
    apply (params) {
        var klCanvas = params.klCanvas;
        var ctx = params.layer.context;
        var klHistory = params.klHistory;
        if (!klCanvas) return false;
        $ebbf7e5d844153e5$var$drawPattern(ctx, params.input);
        {
            var layerMap = Object.fromEntries(params.klCanvas.getLayers().map(function(layerItem) {
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push({
                layerMap: layerMap
            });
        }
        return true;
    }
};



var $eWjiX = parcelRequire("eWjiX");







var $7jh4K = parcelRequire("7jh4K");





var $67bee9819cf9d9ba$export$77c344cc65ad0ed2 = {
    getDialog (params) {
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        var rootEl = (0, $eWjiX.BB).el();
        var context = params.context;
        var isSynced = true;
        var settings = {
            stepSize: 1,
            distortType: 0,
            scale: {
                x: 100,
                y: 100
            },
            strength: {
                x: 20,
                y: 20
            },
            phase: {
                x: 0,
                y: 0
            },
            offset: {
                x: 0,
                y: 0
            }
        };
        // let lastDrawnSettings = null;
        // ---- thumb -------
        var thumbImgArr = [];
        var thumbSize = 32;
        {
            var canvas = (0, $eWjiX.BB).canvas(thumbSize, thumbSize);
            var ctx = (0, $eWjiX.BB).ctx(canvas);
            ctx.beginPath();
            ctx.arc(thumbSize / 2, thumbSize / 2, thumbSize / 2.5, 0, Math.PI * 2);
            ctx.fill();
            var gradient = ctx.createLinearGradient(0, 0, thumbSize, thumbSize);
            gradient.addColorStop(0, '#00f');
            gradient.addColorStop(0.5, '#f00');
            gradient.addColorStop(1, '#fff');
            ctx.fillStyle = gradient;
            ctx.globalCompositeOperation = 'source-atop';
            ctx.fillRect(0, 0, thumbSize, thumbSize);
            gradient = ctx.createLinearGradient(thumbSize, 0, 0, thumbSize);
            gradient.addColorStop(0, '#000');
            gradient.addColorStop(1, '#000');
            ctx.fillStyle = gradient;
            ctx.globalCompositeOperation = 'destination-atop';
            ctx.fillRect(0, 0, thumbSize, thumbSize);
            var fxCanvas = (0, $7jh4K.throwIfNull)((0, $02a74dc72797630f$export$8c4423af32b21158)());
            var texture = fxCanvas.texture(canvas);
            fxCanvas.draw(texture).update(); // update fxCanvas size
            var scaleFactor = 20;
            [
                0,
                1,
                2
            ].forEach(function(item) {
                var thumbImg = new Image();
                var settingsCopy = (0, $eWjiX.BB).copyObj(settings);
                settingsCopy.distortType = item;
                settingsCopy.scale.x /= scaleFactor;
                settingsCopy.scale.y /= scaleFactor;
                settingsCopy.strength.x /= scaleFactor;
                settingsCopy.strength.y /= scaleFactor;
                fxCanvas.draw(texture).multiplyAlpha().distort(settingsCopy).unmultiplyAlpha().update();
                ctx.clearRect(0, 0, thumbSize, thumbSize);
                ctx.drawImage(fxCanvas, 0, 0);
                thumbImg.src = canvas.toDataURL('image/png');
                thumbImgArr.push(thumbImg);
            });
            texture.destroy();
        }
        // ---- controls ----
        var topRowEl = (0, $eWjiX.BB).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        var typeOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: thumbImgArr.map(function(img, index) {
                (0, $7jh4K.css)(img, {
                    margin: '1px',
                    borderRadius: '3px',
                    transition: 'all 0.1s ease-in-out'
                });
                return {
                    id: '' + index,
                    label: img
                };
            }),
            initId: '0',
            onChange: function(id) {
                settings.distortType = Number(id);
                preview.render();
            }
        });
        function sync(from) {
            if (from === 'x') {
                settings.scale.y = settings.scale.x;
                settings.strength.y = settings.strength.x;
                settings.phase.y = settings.phase.x;
                sliderArr[3].setValue(settings.scale.y);
                sliderArr[4].setValue(settings.strength.y);
                sliderArr[5].setValue(settings.phase.y);
            } else {
                settings.scale.x = settings.scale.y;
                settings.strength.x = settings.strength.y;
                settings.phase.x = settings.phase.y;
                sliderArr[0].setValue(settings.scale.x);
                sliderArr[1].setValue(settings.strength.x);
                sliderArr[2].setValue(settings.phase.x);
            }
            preview.render();
        }
        var syncToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-distort-sync-xy'),
            callback: function(val) {
                isSynced = val;
                if (isSynced) sync('x');
            },
            name: 'sync-xy'
        });
        topRowEl.append(typeOptions.getElement(), (0, $eWjiX.BB).el({
            css: {
                flexGrow: '1'
            }
        }), syncToggle.getElement());
        var xyRowEl = (0, $eWjiX.BB).el({
            parent: rootEl,
            css: {
                display: 'flex',
                flexWrap: 'wrap'
            }
        });
        var leftCol = (0, $eWjiX.BB).el({
            parent: xyRowEl,
            css: {
                marginRight: '10px'
            }
        });
        var rightCol = (0, $eWjiX.BB).el({
            parent: xyRowEl
        });
        var sliderWidth = isSmall ? 300 : 245;
        var sliderArr = [];
        [
            'x',
            'y'
        ].forEach(function(item, index) {
            var targetEl = index === 0 ? leftCol : rightCol;
            var scaleSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-noise-scale') + ' ' + item.toUpperCase(),
                width: sliderWidth,
                height: 30,
                min: 1,
                max: 1000,
                curve: 'quadratic',
                value: settings.scale[item],
                eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
                onChange: function(val) {
                    settings.scale[item] = val;
                    if (isSynced) sync(item);
                    else preview.render();
                }
            });
            scaleSlider.getElement().style.marginTop = '20px';
            targetEl.append(scaleSlider.getElement());
            var strengthSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-unsharp-mask-strength') + ' ' + item.toUpperCase(),
                width: sliderWidth,
                height: 30,
                min: 0,
                max: 200,
                curve: 'quadratic',
                value: settings.strength[item],
                eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
                onChange: function(val) {
                    settings.strength[item] = val;
                    if (isSynced) sync(item);
                    else preview.render();
                }
            });
            strengthSlider.getElement().style.marginTop = '10px';
            targetEl.append(strengthSlider.getElement());
            var phaseSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
                label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-distort-phase') + ' ' + item.toUpperCase(),
                width: sliderWidth,
                height: 30,
                min: 0,
                max: 1,
                value: settings.phase[item],
                manualInputRoundDigits: 2,
                eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
                formatFunc: function(val) {
                    return (0, $eWjiX.BB).round(val, 2);
                },
                onChange: function(val) {
                    settings.phase[item] = val;
                    if (isSynced) sync(item);
                    else preview.render();
                }
            });
            phaseSlider.getElement().style.marginTop = '10px';
            targetEl.append(phaseSlider.getElement());
            sliderArr.push(scaleSlider);
            sliderArr.push(strengthSlider);
            sliderArr.push(phaseSlider);
        });
        var stepSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-distort-stepsize'),
            width: 300,
            height: 30,
            min: 1,
            max: 300,
            curve: 'quadratic',
            value: settings.stepSize,
            eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
            onChange: function(val) {
                settings.stepSize = Math.round(val);
                preview.render();
            }
        });
        stepSlider.getElement().style.marginTop = '20px';
        stepSlider.getElement().style.marginBottom = '10px';
        rootEl.append(stepSlider.getElement());
        // ---- preview ----
        var klCanvas = params.klCanvas;
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = (0, $7jh4K.throwIfNull)(klCanvas.getLayerIndex(context.canvas));
        var fxPreviewRenderer = new (0, $14b90ba44af68d49$export$94ec999f33a691e3)({
            original: context.canvas,
            onUpdate: function(fxCanvas, transform) {
                var scaledSettings = (0, $eWjiX.BB).copyObj(settings);
                scaledSettings.stepSize *= transform.scaleX;
                scaledSettings.strength.x *= transform.scaleX;
                scaledSettings.strength.y *= transform.scaleY;
                if (scaledSettings.distortType !== 2) {
                    scaledSettings.scale.x *= transform.scaleX;
                    scaledSettings.scale.y *= transform.scaleY;
                }
                scaledSettings.offset.x = -transform.x;
                scaledSettings.offset.y = -transform.y;
                return fxCanvas.multiplyAlpha().distort(scaledSettings).unmultiplyAlpha();
            },
            selection: klCanvas.getSelection()
        });
        var previewLayerArr = layers.map(function(item, i) {
            return {
                image: i === selectedLayerIndex ? fxPreviewRenderer.render : item.context.canvas,
                isVisible: item.isVisible,
                opacity: item.opacity,
                mixModeStr: item.mixModeStr,
                hasClipping: false
            };
        });
        var preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            },
            selection: klCanvas.getSelection()
        });
        preview.render();
        (0, $7jh4K.css)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px'
        });
        rootEl.append(preview.getElement());
        var destroy = function() {
            typeOptions.destroy();
            sliderArr.forEach(function(item) {
                return item.destroy();
            });
            stepSlider.destroy();
            syncToggle.destroy();
            fxPreviewRenderer.destroy();
            preview.destroy();
        };
        // ----- result -------------------
        var result = {
            element: rootEl,
            destroy: destroy,
            getInput: function() {
                destroy();
                return (0, $eWjiX.BB).copyObj(settings);
            }
        };
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$3a4a74a7d8c44e62).width;
        return result;
    },
    apply (params) {
        var klCanvas = params.klCanvas;
        var context = params.layer.context;
        var klHistory = params.klHistory;
        if (!klCanvas) return false;
        return (0, $670db093f8076d2c$export$66c6ccb6bcae2c94)(context, params.klCanvas.getSelection(), function(fxCanvas) {
            fxCanvas.multiplyAlpha().distort(params.input).unmultiplyAlpha();
        }, klHistory);
    }
};



var $eWjiX = parcelRequire("eWjiX");


var $dJPtW = parcelRequire("dJPtW");



var $eWjiX = parcelRequire("eWjiX");
function $cd59789add31bb97$export$8f57d6bdbceb36d0(ctx, x, y, lines, thickness, color, opacity) {
    ctx.save();
    var degIncrement = 180 / lines;
    for(var deg = 0; deg < 180; deg += degIncrement){
        var p2 = (0, $eWjiX.BB).rotateAround({
            x: x,
            y: y
        }, {
            x: x + 9999,
            y: y
        }, deg);
        (0, $01d7180c5d1d0fdf$export$71b514a25c47df50)(ctx, {
            type: 'line',
            x1: x,
            y1: y,
            x2: p2.x,
            y2: p2.y,
            //angleRad: 0,
            isOutwards: true,
            opacity: opacity,
            //isEraser: false,
            strokeRgb: color,
            lineWidth: thickness
        });
    }
    ctx.restore();
}





var $7jh4K = parcelRequire("7jh4K");





var $9939d5f20537fa4b$export$a77e8ecd2a7fa9a5 = {
    getDialog (params) {
        var context = params.context;
        var klCanvas = params.klCanvas;
        if (!context || !klCanvas) return false;
        var layers = klCanvas.getLayers();
        var selectedLayerIndex = (0, $7jh4K.throwIfNull)(klCanvas.getLayerIndex(context.canvas));
        var previewCanvas = (0, $eWjiX.BB).canvas(context.canvas.width, context.canvas.height);
        var previewCtx = (0, $eWjiX.BB).ctx(previewCanvas);
        var rootEl = (0, $eWjiX.BB).el();
        var result = {
            element: rootEl
        };
        var isSmall = (0, $042ba564475611dc$export$8f6817a932bf45cd)();
        if (!isSmall) result.width = (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall);
        var settingsObj = {
            x: context.canvas.width / 2,
            y: context.canvas.height / 2,
            lines: 8,
            thickness: 2,
            color: {
                r: 0,
                g: 0,
                b: 0
            },
            opacity: 1
        };
        var linesSlider = new (0, $5c0625e6104e2c75$export$a1855b925e534de7)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-vanish-point-lines'),
            width: 300,
            height: 30,
            min: 2,
            max: 20,
            value: settingsObj.lines,
            curve: 'quadratic',
            eventResMs: (0, $fca35583bfaa35b6$export$f02de051ab70b20e),
            onChange: function onChange(val) {
                settingsObj.lines = Math.round(val);
                update();
            }
        });
        linesSlider.getElement().style.marginBottom = '10px';
        rootEl.append(linesSlider.getElement());
        var line1 = (0, $eWjiX.BB).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center'
            }
        });
        var line2 = (0, $eWjiX.BB).el({
            parent: rootEl,
            css: {
                display: 'flex',
                alignItems: 'center',
                marginTop: '10px',
                marginBottom: '10px'
            }
        });
        var xInput = (0, $dJPtW.input)({
            init: settingsObj.x,
            type: 'number',
            css: {
                width: '75px',
                marginRight: '20px'
            },
            callback: function callback(v) {
                settingsObj.x = parseFloat(v);
                dragInput.setValue({
                    x: settingsObj.x,
                    y: settingsObj.y
                });
                update();
            }
        });
        var yInput = (0, $dJPtW.input)({
            init: settingsObj.y,
            type: 'number',
            css: {
                width: '75px',
                marginRight: '20px'
            },
            callback: function callback(v) {
                settingsObj.y = parseFloat(v);
                dragInput.setValue({
                    x: settingsObj.x,
                    y: settingsObj.y
                });
                update();
            }
        });
        var thicknessInput = (0, $dJPtW.input)({
            init: 2,
            type: 'number',
            min: 1,
            css: {
                width: '75px',
                marginRight: '20px'
            },
            callback: function callback(v) {
                settingsObj.thickness = parseFloat(v);
                update();
            }
        });
        var selectedRgbaObj = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
        var colorOptionsArr = [
            {
                r: 0,
                g: 0,
                b: 0,
                a: 1
            },
            {
                r: 255,
                g: 255,
                b: 255,
                a: 1
            }
        ];
        colorOptionsArr.push({
            r: params.currentColorRgb.r,
            g: params.currentColorRgb.g,
            b: params.currentColorRgb.b,
            a: 1
        });
        colorOptionsArr.push({
            r: params.secondaryColorRgb.r,
            g: params.secondaryColorRgb.g,
            b: params.secondaryColorRgb.b,
            a: 1
        });
        settingsObj.color = (0, $eWjiX.BB).copyObj(selectedRgbaObj);
        var colorOptions = new (0, $4db8cbbb01889095$export$24ba9b81662d4366)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-stroke'),
            colorArr: colorOptionsArr,
            onChange: function onChange(rgbaObj) {
                selectedRgbaObj = rgbaObj;
                settingsObj.color = (0, $eWjiX.BB).copyObj(selectedRgbaObj);
                update();
            }
        });
        var labelStyle = {
            display: 'inline-block',
            marginRight: '5px'
        };
        line1.append((0, $eWjiX.BB).el({
            content: 'X:',
            css: labelStyle
        }), xInput, (0, $eWjiX.BB).el({
            content: 'Y:',
            css: labelStyle
        }), yInput);
        line2.append((0, $eWjiX.BB).el({
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-line-width') + ':',
            css: labelStyle
        }), thicknessInput, (0, $eWjiX.BB).el({
            css: {
                flexGrow: '1'
            }
        }), colorOptions.getElement());
        // ---- preview input processing ----
        function syncInputs() {
            xInput.value = '' + settingsObj.x;
            yInput.value = '' + settingsObj.y;
        }
        function update() {
            var ctx = previewCtx;
            var w = previewCanvas.width;
            var h = previewCanvas.height;
            ctx.save();
            ctx.clearRect(0, 0, w, h);
            ctx.drawImage(context.canvas, 0, 0, w, h);
            (0, $cd59789add31bb97$export$8f57d6bdbceb36d0)(ctx, settingsObj.x, settingsObj.y, settingsObj.lines, Math.max(settingsObj.thickness, 1), settingsObj.color, settingsObj.opacity);
            ctx.restore();
            preview.render();
        }
        var onRender = function() {
            dragInput.setTransform(preview.getTransform());
            return previewCanvas;
        };
        var previewLayerArr = [];
        for(var i = 0; i < layers.length; i++)previewLayerArr.push({
            image: i === selectedLayerIndex ? onRender : layers[i].context.canvas,
            isVisible: layers[i].isVisible,
            opacity: layers[i].opacity,
            mixModeStr: layers[i].mixModeStr,
            hasClipping: false
        });
        var preview = new (0, $99362267c0b49949$export$133773870222880f)({
            width: (0, $a433d11ad38d7c38$export$8b9199c1f5e4be8)(isSmall),
            height: (0, $a433d11ad38d7c38$export$94cffdbcf128864a)(isSmall),
            project: {
                width: context.canvas.width,
                height: context.canvas.height,
                layers: previewLayerArr
            }
        });
        (0, $7jh4K.css)(preview.getElement(), {
            marginLeft: '-20px',
            marginRight: '-20px',
            overflow: 'hidden'
        });
        var dragInput = new (0, $1ca80fac51ad2a2d$export$87247fc399965417)({
            value: {
                x: settingsObj.x,
                y: settingsObj.y
            },
            onChange: function(val) {
                settingsObj.x = Math.round(val.x);
                settingsObj.y = Math.round(val.y);
                syncInputs();
                update();
            }
        });
        update();
        preview.getElement().append(dragInput.getElement());
        rootEl.append(preview.getElement());
        result.destroy = function() {
            linesSlider.destroy();
            colorOptions.destroy();
            preview.destroy();
        };
        result.getInput = function() {
            result.destroy();
            return (0, $eWjiX.BB).copyObj(settingsObj);
        };
        return result;
    },
    apply (params) {
        var context = params.layer.context;
        var klCanvas = params.klCanvas;
        var klHistory = params.klHistory;
        if (!context || !klCanvas) return false;
        (0, $cd59789add31bb97$export$8f57d6bdbceb36d0)(context, params.input.x, params.input.y, params.input.lines, params.input.thickness, params.input.color, params.input.opacity);
        {
            var layerMap = Object.fromEntries(params.klCanvas.getLayers().map(function(layerItem) {
                if (layerItem.id === params.layer.id) return [
                    layerItem.id,
                    {
                        tiles: (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(params.layer.canvas)
                    }
                ];
                return [
                    layerItem.id,
                    {}
                ];
            }));
            klHistory.push({
                layerMap: layerMap
            });
        }
        return true;
    }
};


function $4bb0d03ef02dc0c0$var$importFilter(libObj, moduleObj) {
    if (moduleObj.getDialog) libObj.getDialog = moduleObj.getDialog;
    libObj.apply = moduleObj.apply;
}
function $4bb0d03ef02dc0c0$export$4283b00eae4a6956() {
    if ((0, $805be15a1e91c0ee$export$24724bc1f91cba3).isLoaded) return;
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).brightnessContrast, (0, $024aabab8b30bbfd$export$af433fb90aa90a38));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).cropExtend, (0, $2680b5781517cb67$export$e5937df51b9e1d86));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).curves, (0, $4c948640eb8ef791$export$309483fcb6d5c7ca));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).flip, (0, $6b01e1931d168e01$export$9b1b7b3985b9625a));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).hueSaturation, (0, $041c656037c77a96$export$2aa46bd5587f0eb));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).invert, (0, $82b3d1ba61b3412f$export$b7ebcfbdc840ef76));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).perspective, (0, $460859cbeb601dec$export$a76d798fa7d85e4e));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).resize, (0, $63d62a20f3ba2c7d$export$5705240d31427a82));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).rotate, (0, $878715182dcd377b$export$ac7e9efc751d5791));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).tiltShift, (0, $aa97ed406a9700f0$export$1b8796b18b7c19ed));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).transform, (0, $31a0dd41d7428d32$export$dc15474d94cdc2b3));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).blur, (0, $95b95646154e8218$export$55e7eb2ebd0db869));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).unsharpMask, (0, $82f12ab116cea855$export$62ac74a5ea43bd5c));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).toAlpha, (0, $a535e7a374deb8f5$export$6158ed2b22ebf4d9));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).grid, (0, $bad33651972f8d2c$export$50020de79e1bc23));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).noise, (0, $595c9469b8f94062$export$1dab0536099042f5));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).pattern, (0, $ebbf7e5d844153e5$export$5b48b77a483d9b33));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).distort, (0, $67bee9819cf9d9ba$export$77c344cc65ad0ed2));
    $4bb0d03ef02dc0c0$var$importFilter((0, $805be15a1e91c0ee$export$bac24f240bb7727d).vanishPoint, (0, $9939d5f20537fa4b$export$a77e8ecd2a7fa9a5));
    (0, $805be15a1e91c0ee$export$24724bc1f91cba3).isLoaded = true;
}



var $1LaJZ = parcelRequire("1LaJZ");

var $fk3zw = parcelRequire("fk3zw");


function $40b8cea12adf584e$export$92433b641be3f7a(klCanvas) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var layerArr, psdConfig, agPsd, buffer;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    layerArr = klCanvas.getLayersFast();
                    psdConfig = {
                        width: klCanvas.getWidth(),
                        height: klCanvas.getHeight(),
                        //canvas: klCanvas.getCompleteCanvas(1), // preview, can be skipped
                        children: layerArr.map(function(item) {
                            // todo - can be optimized if layer mostly empty
                            return {
                                name: item.name,
                                hidden: !item.isVisible,
                                opacity: item.opacity,
                                canvas: item.canvas,
                                blendMode: (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).PSD.blendKlToPsd(item.mixModeStr),
                                left: 0,
                                top: 0
                            };
                        })
                    };
                    return [
                        4,
                        (0, $a12fba8bc3214c1d$export$ab3d838b1d336b38)()
                    ];
                case 1:
                    agPsd = _state.sent();
                    buffer = agPsd.writePsdBuffer(psdConfig);
                    return [
                        2,
                        new Blob([
                            buffer
                        ], {
                            type: 'application/octet-stream'
                        })
                    ];
            }
        });
    })();
}



var $6mTnI = parcelRequire("6mTnI");



var $6l0gQ = parcelRequire("6l0gQ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $3adbeb1f050c09d3$export$c57e2ed65bcf4d6a = /*#__PURE__*/ function() {
    "use strict";
    function LineSmoothing(p) {
        (0, $cx0mh._)(this, LineSmoothing);
        this.smoothing = (0, $eWjiX.BB).clamp(p.smoothing, 0, 1);
    }
    (0, $7h4XF._)(LineSmoothing, [
        {
            key: "chainIn",
            value: function chainIn(event) {
                var _this = this;
                event = (0, $eWjiX.BB).copyObj(event);
                clearTimeout(this.timeout);
                clearInterval(this.interval);
                if (event.type === 'down') this.lastMixedInput = {
                    x: event.x,
                    y: event.y,
                    pressure: event.pressure
                };
                if (event.type === 'move') {
                    var inputX = event.x;
                    var inputY = event.y;
                    var inputPressure = event.pressure;
                    event.x = (0, $eWjiX.BB).mix(event.x, this.lastMixedInput.x, this.smoothing);
                    event.y = (0, $eWjiX.BB).mix(event.y, this.lastMixedInput.y, this.smoothing);
                    event.pressure = (0, $eWjiX.BB).mix(event.pressure, this.lastMixedInput.pressure, this.smoothing);
                    this.lastMixedInput = {
                        x: event.x,
                        y: event.y,
                        pressure: event.pressure
                    };
                    if (this.smoothing > 0) this.timeout = setTimeout(function() {
                        _this.interval = setInterval(function() {
                            var _this_chainOut, _this1;
                            event = JSON.parse(JSON.stringify(event));
                            event.x = (0, $eWjiX.BB).mix(inputX, _this.lastMixedInput.x, _this.smoothing);
                            event.y = (0, $eWjiX.BB).mix(inputY, _this.lastMixedInput.y, _this.smoothing);
                            event.pressure = (0, $eWjiX.BB).mix(inputPressure, _this.lastMixedInput.pressure, _this.smoothing);
                            _this.lastMixedInput = {
                                x: event.x,
                                y: event.y,
                                pressure: event.pressure
                            };
                            (_this_chainOut = (_this1 = _this).chainOut) === null || _this_chainOut === void 0 ? void 0 : _this_chainOut.call(_this1, event);
                        }, 35);
                    }, 80);
                }
                return event;
            }
        },
        {
            key: "setChainOut",
            value: function setChainOut(func) {
                this.chainOut = func;
            }
        },
        {
            key: "setSmoothing",
            value: function setSmoothing(s) {
                this.smoothing = (0, $eWjiX.BB).clamp(s, 0, 1);
            }
        }
    ]);
    return LineSmoothing;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $73298182992a8985$export$91dcf4209534d21f = /*#__PURE__*/ function() {
    "use strict";
    function LineSanitizer() {
        (0, $cx0mh._)(this, LineSanitizer);
        this.isDrawing = false;
    }
    (0, $7h4XF._)(LineSanitizer, [
        {
            // ----------------------------------- public -----------------------------------
            key: "chainIn",
            value: function chainIn(event) {
                if (event.type === 'down') {
                    if (this.isDrawing) //console.log('line sanitizer - down, but already drawing');
                    this.chainOut && this.chainOut({
                        type: 'up',
                        scale: event.scale,
                        shiftIsPressed: event.shiftIsPressed,
                        isCoalesced: false
                    });
                    else this.isDrawing = true;
                }
                if (!this.isDrawing && (event.type === 'move' || event.type === 'up')) //console.log('line sanitizer - ' + event.type + ' but not drawing');
                return null;
                if (event.type === 'up' && this.isDrawing) this.isDrawing = false;
                return event;
            }
        },
        {
            key: "setChainOut",
            value: function setChainOut(func) {
                this.chainOut = func;
            }
        },
        {
            key: "getIsDrawing",
            value: function getIsDrawing() {
                return this.isDrawing;
            }
        }
    ]);
    return LineSanitizer;
}();


/**
 * from stabilizer dropdown value to line-smoothing value
 */ function $7aa12ecc06c22770$export$bcd109042a2e4bb5(s) {
    if (s == 1) return 0.5;
    if (s == 2) return 0.84;
    if (s == 3) return 0.965;
    if (s == 4) return 0.9825;
    if (s == 5) return 0.99125;
    return s;
}



var $1LaJZ = parcelRequire("1LaJZ");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $bX4ja = parcelRequire("bX4ja");

var $8KHnw = parcelRequire("8KHnw");

var $fk3zw = parcelRequire("fk3zw");

var $2gUX3 = parcelRequire("2gUX3");



var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");

// image - png, jpg, webp, whatever the browser natively supports

var $1LaJZ = parcelRequire("1LaJZ");

var $fk3zw = parcelRequire("fk3zw");
function $2b16b03b1892d95f$var$isBufferMatch(buffer, bytes) {
    return bytes.every(function(byte, index) {
        if (byte === undefined) return true;
        return buffer[index] === byte;
    });
}
function $2b16b03b1892d95f$export$16b40d0fc7becfe6(file) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var nameSplit, extension, arr, e;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // photoshop is sub type of image.* - so check first
                    nameSplit = file.name.split('.');
                    extension = nameSplit[nameSplit.length - 1].toLowerCase();
                    if (file.type.match('image/vnd.adobe.photoshop') || extension === 'psd') return [
                        2,
                        'psd'
                    ];
                    if (file.type.match('image.*')) return [
                        2,
                        'image'
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        new Promise(function(resolve, reject) {
                            var reader = new FileReader();
                            reader.onload = function() {
                                if (reader.result === null) {
                                    reject();
                                    return;
                                }
                                // we did read as array buffer
                                resolve(new Uint8Array(reader.result));
                            };
                            reader.onerror = reject;
                            reader.readAsArrayBuffer(file.slice(0, 12));
                        })
                    ];
                case 2:
                    arr = _state.sent();
                    // PSD: '8BPS'
                    if ($2b16b03b1892d95f$var$isBufferMatch(arr, [
                        56,
                        66,
                        80,
                        83
                    ])) return [
                        2,
                        'psd'
                    ];
                    // PNG: 89 50 4E 47 0D 0A 1A 0A
                    if ($2b16b03b1892d95f$var$isBufferMatch(arr, [
                        0x89,
                        0x50,
                        0x4e,
                        0x47,
                        0x0d,
                        0x0a,
                        0x1a,
                        0x0a
                    ])) return [
                        2,
                        'image'
                    ];
                    // JPEG: 0xFF 0xD8
                    if ($2b16b03b1892d95f$var$isBufferMatch(arr, [
                        0xff,
                        0xd8
                    ])) return [
                        2,
                        'image'
                    ];
                    // WebP: 'RIFF....WEBP'
                    if ($2b16b03b1892d95f$var$isBufferMatch(arr, [
                        0x52,
                        0x49,
                        0x46,
                        0x46,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        0x57,
                        0x45,
                        0x42,
                        0x50
                    ])) return [
                        2,
                        'image'
                    ];
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        undefined
                    ];
            }
        });
    })();
}


var $da20269bad242e5f$export$1ec1306c0c05d48d = /*#__PURE__*/ function() {
    "use strict";
    function KlAppImportHandler(input, callback) {
        (0, $cx0mh._)(this, KlAppImportHandler);
        this.klRootEl = input.klRootEl;
        this.klMaxCanvasSize = input.maxCanvasSize;
        this.layersUi = input.layersUi;
        this.setCurrentLayer = input.setCurrentLayer;
        this.klCanvas = input.klCanvas;
        this.onImportConfirm = input.onImportConfirm;
        this.applyUncommitted = input.applyUncommitted;
        this.onColor = callback.onColor;
    }
    (0, $7h4XF._)(KlAppImportHandler, [
        {
            key: "importFinishedLoading",
            value: function importFinishedLoading(importedImage, filename, optionStr) {
                var _this = this;
                if (!importedImage || isNaN(importedImage.width) || isNaN(importedImage.height) || importedImage.width <= 0 || importedImage.height <= 0) {
                    (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                        type: 'error',
                        message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-broken-file'),
                        buttons: [
                            'Ok'
                        ]
                    });
                    return;
                }
                var getResizedDimensions = function(width, height) {
                    var w = parseInt('' + width);
                    var h = parseInt('' + height);
                    if (w > _this.klMaxCanvasSize) {
                        h = _this.klMaxCanvasSize / w * h;
                        w = _this.klMaxCanvasSize;
                    }
                    if (h > _this.klMaxCanvasSize) {
                        w = _this.klMaxCanvasSize / h * w;
                        h = _this.klMaxCanvasSize;
                    }
                    w = parseInt('' + w);
                    h = parseInt('' + h);
                    return {
                        width: w,
                        height: h
                    };
                };
                var importAsImage = function(canvas) {
                    _this.applyUncommitted();
                    var resizedDimensions = getResizedDimensions(canvas.width, canvas.height);
                    //resize first
                    var tempCanvas = (0, $eWjiX.BB).canvas(canvas.width, canvas.height);
                    var tempCanvasCtx = (0, $eWjiX.BB).ctx(tempCanvas);
                    tempCanvasCtx.drawImage(canvas, 0, 0);
                    (0, $eWjiX.BB).resizeCanvas(tempCanvas, resizedDimensions.width, resizedDimensions.height);
                    _this.klCanvas.reset({
                        width: resizedDimensions.width,
                        height: resizedDimensions.height,
                        image: tempCanvas,
                        layerName: filename
                    });
                    _this.layersUi.update(0);
                    _this.setCurrentLayer(_this.klCanvas.getLayer(0));
                    _this.onImportConfirm();
                };
                /**
         * convertedPsdObj has no layers if flattened
         */ var importAsImagePsd = function(convertedPsdObj, cropObj) {
                    _this.applyUncommitted();
                    // crop
                    var crop = function(targetCanvas, cropCanvas, cropObj) {
                        // eslint-disable-next-line no-self-assign
                        cropCanvas.width = cropCanvas.width;
                        (0, $eWjiX.BB).ctx(cropCanvas).drawImage(targetCanvas, -cropObj.x, -cropObj.y);
                        targetCanvas.width = cropObj.width;
                        targetCanvas.height = cropObj.height;
                        (0, $eWjiX.BB).ctx(targetCanvas).drawImage(cropCanvas, 0, 0);
                    };
                    if (cropObj && (cropObj.width !== convertedPsdObj.width || cropObj.height !== convertedPsdObj.height)) {
                        var cropCanvas = (0, $eWjiX.BB).canvas(cropObj.width, cropObj.height);
                        convertedPsdObj.width = cropObj.width;
                        convertedPsdObj.height = cropObj.height;
                        if (!convertedPsdObj.layers) crop(convertedPsdObj.canvas, cropCanvas, cropObj);
                        if (convertedPsdObj.layers) for(var i = 0; i < convertedPsdObj.layers.length; i++){
                            var item = convertedPsdObj.layers[i];
                            crop(item.image, cropCanvas, cropObj);
                        }
                    }
                    // resize
                    var resizedDimensions = getResizedDimensions(convertedPsdObj.width, convertedPsdObj.height);
                    convertedPsdObj.width = resizedDimensions.width;
                    convertedPsdObj.height = resizedDimensions.height;
                    if (!convertedPsdObj.layers) (0, $eWjiX.BB).resizeCanvas(convertedPsdObj.canvas, convertedPsdObj.width, convertedPsdObj.height);
                    if (convertedPsdObj.layers) for(var i1 = 0; i1 < convertedPsdObj.layers.length; i1++){
                        var item1 = convertedPsdObj.layers[i1];
                        (0, $eWjiX.BB).resizeCanvas(item1.image, convertedPsdObj.width, convertedPsdObj.height);
                    }
                    var layerIndex;
                    if (convertedPsdObj.layers) layerIndex = _this.klCanvas.reset({
                        width: convertedPsdObj.width,
                        height: convertedPsdObj.height,
                        layers: convertedPsdObj.layers.map(function(layer) {
                            return {
                                id: (0, $47ad43347dcf2f3c$export$b2ce7a8a096070e2)(),
                                name: layer.name,
                                isVisible: layer.isVisible,
                                opacity: layer.opacity,
                                mixModeStr: layer.mixModeStr,
                                image: layer.image
                            };
                        })
                    });
                    else layerIndex = _this.klCanvas.reset({
                        width: convertedPsdObj.width,
                        height: convertedPsdObj.height,
                        image: convertedPsdObj.canvas
                    });
                    _this.layersUi.update(layerIndex);
                    _this.setCurrentLayer(_this.klCanvas.getLayer(layerIndex));
                    _this.onImportConfirm();
                };
                var importAsLayer = function(canvas) {
                    _this.applyUncommitted();
                    (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).showImportAsLayerDialog({
                        target: _this.klRootEl,
                        klCanvas: _this.klCanvas,
                        importImage: canvas,
                        callback: function(transformObj, isPixelated) {
                            if (!transformObj) return;
                            var operation = function(ctx) {
                                (0, $eWjiX.BB).drawTransformedImageWithBounds(ctx, canvas, transformObj, undefined, isPixelated);
                            };
                            if (!_this.klCanvas.addLayer(undefined, {
                                name: filename,
                                isVisible: true,
                                opacity: 1,
                                image: operation
                            })) _this.klCanvas.drawOperation(_this.klCanvas.getLayers().length - 1, operation);
                            var layers = _this.klCanvas.getLayers();
                            var activeLayerIndex = layers.length - 1;
                            _this.setCurrentLayer(_this.klCanvas.getLayer(activeLayerIndex));
                            _this.layersUi.update(activeLayerIndex);
                        }
                    });
                };
                if (optionStr === 'default' || !optionStr) (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).showImportImageDialog({
                    image: importedImage,
                    target: this.klRootEl,
                    maxSize: this.klMaxCanvasSize,
                    callback: function(res) {
                        if (res.type === 'as-image') importAsImage(res.image);
                        else if (res.type === 'as-image-psd') importAsImagePsd(res.image, res.cropObj);
                        else if (res.type === 'as-layer') importAsLayer(res.image);
                        else res.type;
                    }
                });
                if (optionStr === 'layer') importAsLayer(importedImage.canvas);
                if (optionStr === 'image') {
                    if (importedImage.type === 'psd') importAsImagePsd(importedImage);
                    else importAsImage(importedImage.canvas);
                }
            }
        },
        {
            key: "readClipboard",
            value: // ---- interface ----
            function readClipboard() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this, clipboardItems, hasImage, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _loop, _iterator1, _step1, _ret, err, err, error;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    17,
                                    ,
                                    18
                                ]);
                                return [
                                    4,
                                    navigator.clipboard.read()
                                ];
                            case 2:
                                clipboardItems = _state.sent();
                                // On this line it's already done freezing.
                                hasImage = false;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    14,
                                    15,
                                    16
                                ]);
                                _iterator = clipboardItems[Symbol.iterator]();
                                _state.label = 4;
                            case 4:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    13
                                ];
                                item = _step.value;
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 5;
                            case 5:
                                _state.trys.push([
                                    5,
                                    10,
                                    11,
                                    12
                                ]);
                                _loop = function() {
                                    var type, blob, img;
                                    return (0, $fk3zw._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                type = _step1.value;
                                                if (!type.startsWith('image')) return [
                                                    3,
                                                    2
                                                ];
                                                hasImage = true;
                                                return [
                                                    4,
                                                    item.getType(type)
                                                ];
                                            case 1:
                                                blob = _state.sent();
                                                img = new Image();
                                                img.onload = function() {
                                                    URL.revokeObjectURL(img.src);
                                                    _this.importFinishedLoading({
                                                        type: 'image',
                                                        width: img.width,
                                                        height: img.height,
                                                        canvas: img
                                                    }, undefined, 'default');
                                                };
                                                img.src = URL.createObjectURL(blob);
                                                return [
                                                    2,
                                                    {
                                                        v: void void 0
                                                    }
                                                ];
                                            case 2:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _iterator1 = item.types[Symbol.iterator]();
                                _state.label = 6;
                            case 6:
                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    9
                                ];
                                return [
                                    5,
                                    (0, $2gUX3.__values)(_loop())
                                ];
                            case 7:
                                _ret = _state.sent();
                                if ((0, $8KHnw._)(_ret) === "object") return [
                                    2,
                                    _ret.v
                                ];
                                _state.label = 8;
                            case 8:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    6
                                ];
                            case 9:
                                return [
                                    3,
                                    12
                                ];
                            case 10:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    12
                                ];
                            case 11:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 12:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    4
                                ];
                            case 13:
                                return [
                                    3,
                                    16
                                ];
                            case 14:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    16
                                ];
                            case 15:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 16:
                                if (!hasImage) (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                    type: 'error',
                                    message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('clipboard-no-image'),
                                    buttons: [
                                        'Ok'
                                    ]
                                });
                                return [
                                    3,
                                    18
                                ];
                            case 17:
                                error = _state.sent();
                                (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                    type: 'error',
                                    message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('clipboard-read-fail'),
                                    buttons: [
                                        'Ok'
                                    ]
                                });
                                return [
                                    3,
                                    18
                                ];
                            case 18:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "onPaste",
            value: function onPaste(e) {
                var _this = this;
                if ((0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() > 0) return;
                var retrieveImageFromClipboardAsBlob = function(items, callback) {
                    if (!items) return;
                    for(var i = 0; i < items.length; i++){
                        if (items[i].type.indexOf('image') == -1) continue;
                        var file = items[i].getAsFile();
                        file && callback(file);
                    }
                };
                e.stopPropagation();
                e.preventDefault();
                if (!e.clipboardData) return;
                if (e.clipboardData.files[0]) retrieveImageFromClipboardAsBlob(e.clipboardData.items, function(imageBlob) {
                    // If there's an image, display it in the canvas
                    var img = new Image();
                    img.onload = function() {
                        URL.revokeObjectURL(img.src);
                        _this.importFinishedLoading({
                            type: 'image',
                            width: img.width,
                            height: img.height,
                            canvas: img
                        }, undefined, 'default');
                    };
                    var URLObj = window.URL || window.webkitURL;
                    img.src = URLObj.createObjectURL(imageBlob);
                });
                else if (e.clipboardData.items[0]) e.clipboardData.items[0].getAsString(function(pasteStr) {
                    pasteStr = pasteStr.trim();
                    if (pasteStr.match(/^https?/)) {
                        // url
                        var img = new Image();
                        img.onload = function() {
                            _this.importFinishedLoading({
                                type: 'image',
                                width: img.width,
                                height: img.height,
                                canvas: img
                            }, undefined, 'default');
                        };
                        img.onerror = function(e) {
                            console.log('error loading', e);
                        };
                        img.crossOrigin = 'Anonymous';
                        img.src = pasteStr;
                    } else if (pasteStr.match(/^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/)) {
                        // url
                        var rgbObj = (0, $eWjiX.BB).ColorConverter.hexToRGB(pasteStr.replace('#', ''));
                        rgbObj && _this.onColor(rgbObj);
                    }
                });
            }
        },
        {
            key: "handleFileSelect",
            value: function handleFileSelect(files, optionStr) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    var _this, showWarningPsdFlattened, hasUnsupportedFile, fileArr, i, file, fileType;
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                showWarningPsdFlattened = function() {
                                    (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                        type: 'warning',
                                        message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-psd-unsupported') + '<br /><br />',
                                        buttons: [
                                            'Ok'
                                        ]
                                    });
                                };
                                hasUnsupportedFile = false;
                                // files need to be copied, because the input is reset
                                fileArr = (0, $bX4ja._)(files);
                                i = 0;
                                _state.label = 1;
                            case 1:
                                if (!(i < fileArr.length)) return [
                                    3,
                                    4
                                ];
                                file = fileArr[i];
                                return [
                                    4,
                                    (0, $2b16b03b1892d95f$export$16b40d0fc7becfe6)(file)
                                ];
                            case 2:
                                fileType = _state.sent();
                                if (fileType === 'image') (function(f) {
                                    window.URL = window.URL || window.webkitURL;
                                    var url = window.URL.createObjectURL(f);
                                    var im = new Image();
                                    im.src = url;
                                    (0, $eWjiX.BB).loadImage(im, function() {
                                        URL.revokeObjectURL(url);
                                        _this.importFinishedLoading({
                                            type: 'image',
                                            width: im.width,
                                            height: im.height,
                                            canvas: im
                                        }, f.name, optionStr);
                                    });
                                })(file);
                                else if (fileType === 'psd') (function(f) {
                                    var loaderSizeBytes = 26214400; // 25mb
                                    var maxSizeBytes = 1073741824; // 1gb
                                    var maxResolution = 4096;
                                    if (f.size >= maxSizeBytes) {
                                        // pretty likely to break stuff
                                        (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                            type: 'error',
                                            message: 'File too big. Unable to import.<br /><br />',
                                            buttons: [
                                                'Ok'
                                            ]
                                        });
                                        return;
                                    }
                                    var doShowLoader = fileArr.length === 1 && f.size >= loaderSizeBytes;
                                    var loaderIsOpen = true;
                                    var closeLoader;
                                    if (doShowLoader) (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                        message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-opening'),
                                        callback: function(result) {
                                            loaderIsOpen = false;
                                            closeLoader = null;
                                        },
                                        closeFunc: function(f) {
                                            closeLoader = f;
                                        }
                                    });
                                    var reader = new FileReader();
                                    reader.onload = function(readerResult) {
                                        var target = (0, $7jh4K.throwIfNull)(readerResult.target);
                                        (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).loadAgPsd().then(function(agPsdLazy) {
                                            if (doShowLoader && !loaderIsOpen) return;
                                            try {
                                                var psd;
                                                // first pass, only read metadata
                                                psd = agPsdLazy.readPsd(target.result, {
                                                    skipLayerImageData: true,
                                                    skipThumbnail: true,
                                                    skipCompositeImageData: true
                                                });
                                                if (psd.width > maxResolution || psd.height > maxResolution) {
                                                    if (closeLoader) closeLoader();
                                                    (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                                        type: 'error',
                                                        message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-psd-too-large').replace(/{x}/g, '' + maxResolution) + '<br /><br />' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-psd-size') + ': ' + psd.width + ' x ' + psd.height + ' pixels' + '<br /><br />',
                                                        buttons: [
                                                            'Ok'
                                                        ]
                                                    });
                                                    return;
                                                }
                                                // second pass, now load actual data.
                                                psd = null;
                                                try {
                                                    psd = agPsdLazy.readPsd(target.result);
                                                } catch (e) {
                                                //console.log('failed regular psd import', e);
                                                }
                                                if (psd) {
                                                    //console.log('psd', psd);
                                                    var convertedPsd = (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).PSD.readPsd(psd);
                                                    //console.log('converted', convertedPsd);
                                                    if (optionStr === 'image' && convertedPsd.error) showWarningPsdFlattened();
                                                    if (closeLoader) closeLoader();
                                                    _this.importFinishedLoading(convertedPsd, f.name, optionStr);
                                                } else {
                                                    psd = agPsdLazy.readPsd(target.result, {
                                                        skipLayerImageData: true,
                                                        skipThumbnail: true
                                                    });
                                                    if (optionStr === 'image') showWarningPsdFlattened();
                                                    if (closeLoader) closeLoader();
                                                    _this.importFinishedLoading({
                                                        type: 'psd',
                                                        width: psd.width,
                                                        height: psd.height,
                                                        canvas: (0, $7jh4K.throwIfUndefined)(psd.canvas),
                                                        error: true
                                                    }, f.name, optionStr);
                                                }
                                            } catch (e) {
                                                closeLoader === null || closeLoader === void 0 ? void 0 : closeLoader();
                                                (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                                    type: 'error',
                                                    message: 'Failed to load PSD.<br /><br />',
                                                    buttons: [
                                                        'Ok'
                                                    ]
                                                });
                                                console.log(e);
                                                setTimeout(function() {
                                                    throw new Error('psd load error');
                                                });
                                            }
                                        }).catch(function(e) {
                                            closeLoader === null || closeLoader === void 0 ? void 0 : closeLoader();
                                            alert('Error: failed to load PSD library');
                                        });
                                    };
                                    reader.readAsArrayBuffer(f);
                                })(file);
                                else hasUnsupportedFile = true;
                                _state.label = 3;
                            case 3:
                                i++;
                                return [
                                    3,
                                    1
                                ];
                            case 4:
                                if (hasUnsupportedFile) (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                    message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('import-unsupported-file'),
                                    type: 'error',
                                    buttons: [
                                        'OK'
                                    ]
                                });
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        }
    ]);
    return KlAppImportHandler;
}();









var $297fb258e45d3497$exports = {};
$297fb258e45d3497$exports = $parcel$resolve("k9Nks");


var $35c1331d74740d5d$exports = {};
$35c1331d74740d5d$exports = $parcel$resolve("bBxqy");


var $9d5703f01759ee19$exports = {};
$9d5703f01759ee19$exports = $parcel$resolve("3UXKl");



var $bX4ja = parcelRequire("bX4ja");
function $a8abbf3a9def9692$export$982e7602957287fa(p) {
    var _console, _console1;
    var output = [
        'Draw via the console! Learn more: %cKL.help()',
        'background: #000; color: #0f0;'
    ];
    'info' in console ? (_console = console).info.apply(_console, (0, $bX4ja._)(output)) : (_console1 = console).log.apply(_console1, (0, $bX4ja._)(output));
    return Object.freeze({
        draw: function(path) {
            p.onDraw(path);
        },
        help: function() {
            console.log(`KL.draw({x: number; y: number}[]) // draw a line
KL.help() // print help
`);
        }
    });
}




var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $8N5YG = parcelRequire("8N5YG");

var $bX4ja = parcelRequire("bX4ja");



var $04lDo = parcelRequire("04lDo");

var $eWjiX = parcelRequire("eWjiX");



parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $bX4ja = parcelRequire("bX4ja");

var $eWjiX = parcelRequire("eWjiX");

var $gCzYB = parcelRequire("gCzYB");
var $7d3bbf0db34a31fc$export$ae7d5b5c7fa00e77 = /*#__PURE__*/ function() {
    "use strict";
    function EaselPointerPreprocessor(p) {
        (0, $cx0mh._)(this, EaselPointerPreprocessor);
        var nFingerSubChain = [];
        if (p.onUndo) {
            this.twoFingerTap = new (0, $eWjiX.BB).NFingerTapper({
                fingers: 2,
                onTap: p.onUndo
            });
            nFingerSubChain.push(this.twoFingerTap);
        }
        if (p.onRedo) {
            this.threeFingerTap = new (0, $eWjiX.BB).NFingerTapper({
                fingers: 3,
                onTap: p.onRedo
            });
            nFingerSubChain.push(this.threeFingerTap);
        }
        this.mainDoubleTapper = new (0, $eWjiX.BB).DoubleTapper({
            onDoubleTap: p.onDoubleTap
        });
        this.mainDoubleTapper.setAllowedPointerTypeArr([
            'touch'
        ]);
        this.middleDoubleTapper = new (0, $eWjiX.BB).DoubleTapper({
            onDoubleTap: p.onDoubleTap
        });
        this.middleDoubleTapper.setAllowedButtonArr([
            'middle'
        ]);
        this.pinchZoomer = new (0, $eWjiX.BB).PinchZoomer({
            onPinch: p.onPinch
        });
        this.pointerEventChain = new (0, $gCzYB.EventChain)({
            chainArr: (0, $bX4ja._)(nFingerSubChain).concat([
                this.mainDoubleTapper,
                this.middleDoubleTapper,
                this.pinchZoomer,
                new (0, $eWjiX.BB).OnePointerLimiter()
            ])
        });
        this.pointerEventChain.setChainOut(p.onChainOut);
    }
    (0, $7h4XF._)(EaselPointerPreprocessor, [
        {
            key: "chainIn",
            value: function chainIn(e) {
                this.pointerEventChain.chainIn(e);
            }
        },
        {
            key: "setDoubleTapPointerTypes",
            value: function setDoubleTapPointerTypes(p) {
                this.mainDoubleTapper.setAllowedPointerTypeArr(p);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
            // todo
            }
        }
    ]);
    return EaselPointerPreprocessor;
}();



var $idV3L = parcelRequire("idV3L");




var $eg83P = parcelRequire("eg83P");

var $bX4ja = parcelRequire("bX4ja");
var $991ab38832278e02$export$31ee023005d8c68f = [
    'touch'
];
var $991ab38832278e02$export$4f41ddbc92f66d7d = [
    'space',
    'alt',
    'r',
    'z'
];
var $991ab38832278e02$export$c5299001bfb7de59 = [
    'mouse-middle',
    'mouse-right'
].concat((0, $bX4ja._)($991ab38832278e02$export$4f41ddbc92f66d7d));
var $991ab38832278e02$export$5e2c057e240c0b8c = 1 / 16;
var $991ab38832278e02$export$ac82c07320907c00 = Math.pow(2, 7);


function $da90e23ff63572c1$export$296b597c2b22784a(a, b) {
    var isPositionChanged = a.x !== b.x || a.y !== b.y;
    var isScaleOrAngleChanged = a.scale !== b.scale || a.angleDeg !== b.angleDeg;
    return !isPositionChanged && !isScaleOrAngleChanged;
}



var $cL71g = parcelRequire("cL71g");


var $eWjiX = parcelRequire("eWjiX");



parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
function $11590af1b0c2eaf1$export$e5cb90f7d2eee96c(currentTransform, targetTransform, projectSize, viewportCenter, easeFactor) {
    // equal
    if ((0, $da90e23ff63572c1$export$296b597c2b22784a)(currentTransform, targetTransform)) return (0, $cL71g._)({}, targetTransform);
    // approximately equal
    if ((currentTransform.x === targetTransform.x || Math.abs(currentTransform.x - targetTransform.x) < 2) && (currentTransform.y === targetTransform.y || Math.abs(currentTransform.y - targetTransform.y) < 2) && (currentTransform.scale === targetTransform.scale || Math.abs(currentTransform.scale - targetTransform.scale) < 0.08 * targetTransform.scale)) return (0, $cL71g._)({}, targetTransform);
    // same angle, just translate and scale
    if (currentTransform.angleDeg === targetTransform.angleDeg) return {
        x: (0, $eWjiX.BB).mix(currentTransform.x, targetTransform.x, easeFactor),
        y: (0, $eWjiX.BB).mix(currentTransform.y, targetTransform.y, easeFactor),
        angleDeg: targetTransform.angleDeg,
        scale: (0, $eWjiX.BB).mix(currentTransform.scale, targetTransform.scale, easeFactor)
    };
    // rotating around a point
    var currentMeta = (0, $c4f45fb8696b5286$export$935bc53f7df03c95)(currentTransform, viewportCenter);
    var targetMeta = (0, $c4f45fb8696b5286$export$935bc53f7df03c95)(targetTransform, viewportCenter);
    if ((0, $eWjiX.BB).Vec2.dist(currentMeta.canvasP, targetMeta.canvasP) < 1) {
        // move angles closer to each other. assumes [-180, 180] angle range.
        var closerCurrentAngleDeg = currentMeta.angleDeg;
        // -180 180 -> 180 + 180 = 360
        // 180 -180 -> -180 - 180 = -360
        var angleDelta = targetMeta.angleDeg - currentMeta.angleDeg;
        if (angleDelta > 180) closerCurrentAngleDeg += 360;
        if (angleDelta < -180) closerCurrentAngleDeg -= 360;
        var mixedMeta = {
            viewportP: viewportCenter,
            canvasP: targetMeta.canvasP,
            scale: (0, $eWjiX.BB).mix(currentTransform.scale, targetTransform.scale, easeFactor),
            angleDeg: (0, $eWjiX.BB).mix(closerCurrentAngleDeg, targetTransform.angleDeg, easeFactor)
        };
        return (0, $926e1894e59cf403$export$99c68a89351e15c0)(mixedMeta.viewportP, mixedMeta.canvasP, mixedMeta.scale, mixedMeta.angleDeg);
    }
    // rotate around center of canvas
    var canvasCenter = {
        x: projectSize.width / 2,
        y: projectSize.height / 2
    };
    var currentMatrix = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(currentTransform);
    var targetMatrix = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(targetTransform);
    var currentCenter = (0, $cdZRx.applyToPoint)(currentMatrix, canvasCenter);
    var targetCenter = (0, $cdZRx.applyToPoint)(targetMatrix, canvasCenter);
    var mixedCenter = {
        x: (0, $eWjiX.BB).mix(currentCenter.x, targetCenter.x, easeFactor),
        y: (0, $eWjiX.BB).mix(currentCenter.y, targetCenter.y, easeFactor)
    };
    var mixedScale = (0, $eWjiX.BB).mix(currentTransform.scale, targetTransform.scale, easeFactor);
    var mixedAngleDeg = (0, $eWjiX.BB).mix(currentTransform.angleDeg, targetTransform.angleDeg, easeFactor);
    var mixedAngleRad = mixedAngleDeg * (Math.PI / 180);
    // calculate the offset from the center to the top-left corner (origin)
    var offsetX = -canvasCenter.x * mixedScale;
    var offsetY = -canvasCenter.y * mixedScale;
    var rotatedOffsetX = offsetX * Math.cos(mixedAngleRad) - offsetY * Math.sin(mixedAngleRad);
    var rotatedOffsetY = offsetX * Math.sin(mixedAngleRad) + offsetY * Math.cos(mixedAngleRad);
    var origin = {
        x: mixedCenter.x + rotatedOffsetX,
        y: mixedCenter.y + rotatedOffsetY
    };
    return {
        x: origin.x,
        y: origin.y,
        scale: mixedScale,
        angleDeg: mixedAngleDeg
    };
}




var $7jh4K = parcelRequire("7jh4K");

var $eWjiX = parcelRequire("eWjiX");

var $eg83P = parcelRequire("eg83P");
function $b12878515d74b1ca$export$29dc1c77cb35d1c5(rect, viewportTransform, easelSize, snapRotation) {
    var padding = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
    // rotate
    var newAngleDeg = viewportTransform.angleDeg;
    if (snapRotation) {
        if (newAngleDeg === 45) // would otherwise get rounded to 90
        newAngleDeg = 0;
        newAngleDeg = (0, $eg83P.snapAngleDeg)(newAngleDeg, 90, 90);
    }
    // calc width and height of bounds after rotation
    var rectCenterX = rect.x + rect.width / 2;
    var rectCenterY = rect.y + rect.height / 2;
    var canvasPointsArr = [
        [
            rect.x,
            rect.y
        ],
        [
            rect.x + rect.width,
            rect.y
        ],
        [
            rect.x + rect.width,
            rect.y + rect.height
        ],
        [
            rect.x,
            rect.y + rect.height
        ]
    ];
    // setup transformation matrix
    var matrix = (0, $eWjiX.BB).Matrix.getIdentity();
    matrix = (0, $eWjiX.BB).Matrix.multiplyMatrices(matrix, (0, $eWjiX.BB).Matrix.createRotationMatrix(newAngleDeg / 180 * Math.PI));
    // rotate points
    for(var i = 0; i < canvasPointsArr.length; i++){
        var coords = [
            canvasPointsArr[i][0],
            canvasPointsArr[i][1],
            0,
            1
        ];
        coords = (0, $eWjiX.BB).Matrix.multiplyMatrixAndPoint(matrix, coords);
        canvasPointsArr[i][0] = coords[0];
        canvasPointsArr[i][1] = coords[1];
    }
    var boundsObj = {};
    for(var i1 = 0; i1 < canvasPointsArr.length; i1++){
        if (boundsObj.x1 === undefined || canvasPointsArr[i1][0] < boundsObj.x1) boundsObj.x1 = canvasPointsArr[i1][0];
        if (boundsObj.y1 === undefined || canvasPointsArr[i1][1] < boundsObj.y1) boundsObj.y1 = canvasPointsArr[i1][1];
        if (boundsObj.x2 === undefined || canvasPointsArr[i1][0] > boundsObj.x2) boundsObj.x2 = canvasPointsArr[i1][0];
        if (boundsObj.y2 === undefined || canvasPointsArr[i1][1] > boundsObj.y2) boundsObj.y2 = canvasPointsArr[i1][1];
    }
    var boundsWidth = boundsObj.x2 - boundsObj.x1;
    var boundsHeight = boundsObj.y2 - boundsObj.y1;
    // fit bounds
    var _fitInto = (0, $7jh4K.fitInto)(boundsWidth, boundsHeight, easelSize.width - padding * 2, easelSize.height - padding * 2, 1), fitWidth = _fitInto.width;
    // determine scale
    // when bringing something into view avoid zooming in too far
    var maxScale = Math.max(viewportTransform.scale, 1);
    var factor = Math.min(maxScale, fitWidth / boundsWidth);
    return (0, $926e1894e59cf403$export$99c68a89351e15c0)({
        x: easelSize.width / 2,
        y: easelSize.height / 2
    }, {
        x: rectCenterX,
        y: rectCenterY
    }, factor, newAngleDeg);
}



var $7jh4K = parcelRequire("7jh4K");
function $33e4247c53b6e65b$var$getToolEntries(tools) {
    return Object.entries(tools);
}
var $33e4247c53b6e65b$export$2732362bcaeb02c2 = /*#__PURE__*/ function() {
    "use strict";
    function Easel(p) {
        var _this = this;
        var _this1 = this;
        var _this_svgEl, _this_htmlOverlayEl;
        (0, $cx0mh._)(this, Easel);
        var _this_toolsMap_this_toolId_activate, _this_toolsMap_this_toolId;
        this.doRender = false // true -> will render on next renderLoop
        ;
        this.isFrozen = false // disable interaction with the easel whatsoever
        ;
        this.lastRenderedTransform = {} // previously rendered viewport transformation
        ;
        this.targetTransform = {};
        // Animation frame cycling
        this.animFrameIndex = 0;
        this.animLastTick = 0;
        this.animFps = 8;
        this.hasAnimatedLayers = false;
        this.animPaused = false;
        // custom interface passed to tools
        this.easelInterface = {
            setCursor: function(cursor) {
                return _this.rootEl.style.cursor = cursor;
            },
            getTransform: function() {
                return _this.viewport.getTransform();
            },
            getTargetTransform: function() {
                return _this.targetTransform;
            },
            getSize: function() {
                return {
                    width: _this.width,
                    height: _this.height
                };
            },
            getProjectSize: function() {
                return {
                    width: _this.project.width,
                    height: _this.project.height
                };
            },
            setTransform: function(transform, isImmediate) {
                return _this.setTargetTransform(transform, isImmediate);
            },
            requestRender: function() {
                return _this.requestRender();
            },
            isKeyPressed: function(keyStr) {
                return _this.keyListener.isPressed(keyStr);
            },
            minScale: (0, $991ab38832278e02$export$5e2c057e240c0b8c),
            maxScale: (0, $991ab38832278e02$export$ac82c07320907c00),
            setAngleDeg: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return _this1.setAngleDeg.apply(_this1, (0, $bX4ja._)(args));
            },
            keyListener: {},
            updateDoubleTapPointerTypes: function() {
                return _this.updateDoubleTapPointerTypes();
            },
            setRenderedSelection: function(selection) {
                return _this.selectionRenderer.setRenderedSelection(selection);
            },
            clearRenderedSelection: function(isImmediate) {
                return _this.selectionRenderer.clearRenderedSelection(isImmediate);
            },
            onWheel: function(e) {
                return _this.onWheel(e);
            },
            getElement: function() {
                return _this.rootEl;
            }
        };
        this.lastFrameTimestamp = 0;
        this.onWheel = function(e) {
            var _e_event;
            (_e_event = e.event) === null || _e_event === void 0 ? void 0 : _e_event.preventDefault();
            var isImmediate = false;
            if (Math.abs(e.deltaY) < 0.8) isImmediate = true;
            if (e.event && e.event.ctrlKey && !_this.keyListener.isPressed('ctrl')) {
                isImmediate = true;
                var factor = 1;
                if (e.event.deltaMode === 0) factor = 6;
                e.deltaY *= factor;
            }
            if (_this.keyListener.isPressed('shift')) e.deltaY /= 4;
            // zoom
            var transform = _this.targetTransform;
            var viewportPoint = {
                x: e.relX,
                y: e.relY
            };
            var mat = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(transform);
            var canvasPoint = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(mat), viewportPoint);
            var newScale = (0, $eWjiX.BB).clamp(transform.scale * Math.pow(1.4, -e.deltaY), (0, $991ab38832278e02$export$5e2c057e240c0b8c), (0, $991ab38832278e02$export$ac82c07320907c00));
            _this.setTargetTransform((0, $926e1894e59cf403$export$99c68a89351e15c0)(viewportPoint, canvasPoint, newScale, transform.angleDeg), isImmediate);
        };
        this.project = p.project;
        this.width = p.width;
        this.height = p.height;
        this.toolId = p.tool;
        this.toolsMap = (0, $cL71g._)({}, p.tools);
        this.onChangeTool = p.onChangeTool;
        this.onTransformChange = p.onTransformChange;
        this.onUndo = p.onUndo;
        this.onRedo = p.onRedo;
        this.tempTools = Object.fromEntries((0, $991ab38832278e02$export$c5299001bfb7de59).map(function(trigger) {
            return [
                trigger,
                $33e4247c53b6e65b$var$getToolEntries(_this.toolsMap).filter(function(param) {
                    var _param = (0, $8N5YG._)(param, 2), toolName = _param[0], tool = _param[1];
                    return tool.tempTriggers && tool.tempTriggers.includes(trigger);
                }).map(function(i) {
                    return i[0];
                })[0]
            ];
        }));
        this.viewport = new (0, $ee6e64f1b33d2735$export$a140ed60c2ca052c)({
            width: this.width,
            height: this.height,
            project: {
                width: this.project.width,
                height: this.project.height,
                layers: this.project.layers
            },
            transform: this.getResetTransform(),
            renderAfter: function(ctx, renderedTransform) {
                var _tool_renderAfterViewport;
                var tool = _this.getActiveTool();
                (_tool_renderAfterViewport = tool.renderAfterViewport) === null || _tool_renderAfterViewport === void 0 ? void 0 : _tool_renderAfterViewport.call(tool, ctx, renderedTransform);
            }
        });
        Object.values(this.toolsMap).forEach(function(tool) {
            var _tool_setEaselInterface, _tool_onResize;
            (_tool_setEaselInterface = tool.setEaselInterface) === null || _tool_setEaselInterface === void 0 ? void 0 : _tool_setEaselInterface.call(tool, _this.easelInterface);
            (_tool_onResize = tool.onResize) === null || _tool_onResize === void 0 ? void 0 : _tool_onResize.call(tool, _this.width, _this.height);
        });
        var mouseMiddleIsDown = false;
        var mouseRightIsDown = false;
        var angleIsExtraSticky = false;
        this.pointerPreprocessor = new (0, $7d3bbf0db34a31fc$export$ae7d5b5c7fa00e77)({
            onUndo: this.onUndo,
            onRedo: this.onRedo,
            onPinch: function(event) {
                if (event.type === 'move') {
                    var transform = _this.viewport.getTransform();
                    if (!_this.pinchInitialTransform) {
                        _this.pinchInitialTransform = (0, $eWjiX.BB).copyObj(transform);
                        angleIsExtraSticky = _this.pinchInitialTransform.angleDeg % 180 === 0;
                    }
                    var newAngleDeg = _this.pinchInitialTransform.angleDeg + event.angleRad / Math.PI * 180;
                    newAngleDeg = (0, $eg83P.minimizeAngleDeg)((0, $eg83P.snapAngleDeg)(newAngleDeg, 90, angleIsExtraSticky ? 12 : 4));
                    if (newAngleDeg % 90 !== 0) angleIsExtraSticky = false;
                    var metaTransform = (0, $c4f45fb8696b5286$export$935bc53f7df03c95)(_this.pinchInitialTransform, {
                        x: event.downRelX,
                        y: event.downRelY
                    });
                    metaTransform.scale = (0, $eWjiX.BB).clamp(_this.pinchInitialTransform.scale * event.scale, (0, $991ab38832278e02$export$5e2c057e240c0b8c), (0, $991ab38832278e02$export$ac82c07320907c00));
                    metaTransform.viewportP.x += event.relX - event.downRelX;
                    metaTransform.viewportP.y += event.relY - event.downRelY;
                    metaTransform.angleDeg = newAngleDeg;
                    _this.setTargetTransform((0, $926e1894e59cf403$export$99c68a89351e15c0)(metaTransform.viewportP, metaTransform.canvasP, metaTransform.scale, metaTransform.angleDeg), true);
                    _this.requestRender();
                } else if (event.type === 'end') _this.pinchInitialTransform = undefined;
            },
            onDoubleTap: function(e) {
                if (_this.fitTransform()) _this.requestRender();
                else _this.scale(2, e.relX, e.relY);
            },
            onChainOut: function(e) {
                _this.cursorPos = {
                    x: e.relX,
                    y: e.relY
                };
                if (e.type === 'pointerdown') {
                    if (e.button === 'middle') {
                        mouseMiddleIsDown = true;
                        _this.pushTempTool(_this.tempTools['mouse-middle']);
                    }
                    if (e.button === 'right') {
                        mouseRightIsDown = true;
                        _this.pushTempTool(_this.tempTools['mouse-right']);
                    }
                } else if (e.type === 'pointermove') ;
                else if (e.type === 'pointerup') {
                    if (mouseMiddleIsDown) {
                        mouseMiddleIsDown = false;
                        _this.getActiveTool().onPointer(e);
                        _this.popTempTool(_this.tempTools['mouse-middle']);
                        return;
                    }
                    if (mouseRightIsDown) {
                        mouseRightIsDown = false;
                        _this.getActiveTool().onPointer(e);
                        _this.popTempTool(_this.tempTools['mouse-right']);
                        return;
                    }
                }
                _this.getActiveTool().onPointer(e);
            }
        });
        /*
        // My trackpad pinching (via PointerListener) doesn't currently work with Safari on macOS.
        // So I tried GestureListener, which works, but doesn't mesh well with the other event listeners.
        let lastScale = 0;
        this.gestureListener = new GestureListener({
            target: this.viewport.getElement(),
            onStart: (e) => {
                lastScale = e.scale;
            },
            onChange: (e) => {
                const deltaScale = e.scale / lastScale;
                lastScale = e.scale;

                // zoom
                const transform = this.viewport.getTransform();
                const viewportPoint = {
                    x: e.layerX,
                    y: e.layerY,
                };
                const mat = createMatrixFromTransform(transform);
                const canvasPoint = applyToPoint(inverse(mat), viewportPoint);
                const newScale = BB.clamp(
                    transform.scale * deltaScale,
                    EASEL_MIN_SCALE,
                    EASEL_MAX_SCALE,
                );
                this.setTransform(
                    createTransform(viewportPoint, canvasPoint, newScale, transform.angleDeg),
                );
                this.requestRender();
            },
        });*/ this.pointerListener = new (0, $04lDo.PointerListener)({
            target: this.viewport.getElement(),
            onPointer: function(e) {
                _this.pointerPreprocessor.chainIn(e);
            },
            onWheel: this.onWheel,
            onEnterLeave: function(isOver) {
                var tool = _this.getActiveTool();
                if (!isOver) {
                    var _tool_onPointerLeave;
                    _this.cursorPos = undefined;
                    (_tool_onPointerLeave = tool.onPointerLeave) === null || _tool_onPointerLeave === void 0 ? void 0 : _tool_onPointerLeave.call(tool);
                }
            },
            useDirtyWheel: true,
            isWheelPassive: false,
            maxPointers: 3
        });
        this.windowPointerListener = function(e) {
            var _this_getActiveTool_onClickOutside, _this_getActiveTool;
            if (_this.isFrozen) return;
            if (!_this.rootEl.contains(e.target)) (_this_getActiveTool_onClickOutside = (_this_getActiveTool = _this.getActiveTool()).onClickOutside) === null || _this_getActiveTool_onClickOutside === void 0 ? void 0 : _this_getActiveTool_onClickOutside.call(_this_getActiveTool);
        };
        window.addEventListener('pointerdown', this.windowPointerListener);
        this.keyListener = new (0, $idV3L.KeyListener)({
            onDown: function(keyStr, e, comboStr, isRepeat) {
                var _tool_onKeyDown;
                if (_this.isFrozen) return;
                if (comboStr === 'plus') {
                    var oldScale = _this.getTransform().scale;
                    var newScale = (0, $6ac4ab2dc9a117c8$export$8c03162b1a39d183)(oldScale, _this.keyListener.isPressed('shift') ? 1 / 8 : 0.5);
                    _this.scale(newScale / oldScale);
                }
                if (comboStr === 'minus') {
                    var oldScale1 = _this.getTransform().scale;
                    var newScale1 = (0, $6ac4ab2dc9a117c8$export$8c03162b1a39d183)(oldScale1, _this.keyListener.isPressed('shift') ? -1 / 8 : -0.5);
                    _this.scale(newScale1 / oldScale1);
                }
                if (_this.keyListener.getComboStr() !== 'shift' && _this.keyListener.comboOnlyContains([
                    'shift',
                    'left',
                    'right',
                    'up',
                    'down'
                ])) {
                    var _activeTool_onArrowKeys;
                    var activeTool = _this.getActiveTool();
                    if (!((_activeTool_onArrowKeys = activeTool.onArrowKeys) === null || _activeTool_onArrowKeys === void 0 ? void 0 : _activeTool_onArrowKeys.call(activeTool, keyStr))) {
                        var stepSize = 40;
                        if (keyStr === 'left') _this.translate(stepSize, 0);
                        if (keyStr === 'right') _this.translate(-stepSize, 0);
                        if (keyStr === 'up') _this.translate(0, stepSize);
                        if (keyStr === 'down') _this.translate(0, -stepSize);
                    }
                }
                // activate temporary tool
                (0, $991ab38832278e02$export$4f41ddbc92f66d7d).forEach(function(keyTrigger) {
                    if (comboStr === keyTrigger && _this.toolsMap[_this.toolId].blockTrigger !== keyTrigger) _this.pushTempTool(_this.tempTools[keyTrigger]);
                });
                var _this_tempToolId;
                var tool = _this.toolsMap[(_this_tempToolId = _this.tempToolId) !== null && _this_tempToolId !== void 0 ? _this_tempToolId : _this.toolId];
                (_tool_onKeyDown = tool.onKeyDown) === null || _tool_onKeyDown === void 0 ? void 0 : _tool_onKeyDown.call(tool, keyStr, e, comboStr, isRepeat);
            },
            onUp: function(keyStr, e, oldComboStr) {
                var _tool_onKeyUp;
                if (_this.isFrozen) return;
                // turn off temporary tool again
                (0, $991ab38832278e02$export$4f41ddbc92f66d7d).forEach(function(keyTrigger) {
                    if (keyStr === keyTrigger && _this.toolsMap[_this.toolId].blockTrigger !== keyTrigger) _this.popTempTool(_this.tempTools[keyTrigger]);
                });
                var _this_tempToolId;
                var tool = _this.toolsMap[(_this_tempToolId = _this.tempToolId) !== null && _this_tempToolId !== void 0 ? _this_tempToolId : _this.toolId];
                (_tool_onKeyUp = tool.onKeyUp) === null || _tool_onKeyUp === void 0 ? void 0 : _tool_onKeyUp.call(tool, keyStr, e, oldComboStr);
            },
            onBlur: function() {
                var _tool_onBlur;
                var _this_tempToolId;
                var tool = _this.toolsMap[(_this_tempToolId = _this.tempToolId) !== null && _this_tempToolId !== void 0 ? _this_tempToolId : _this.toolId];
                (_tool_onBlur = tool.onBlur) === null || _tool_onBlur === void 0 ? void 0 : _tool_onBlur.call(tool);
            }
        });
        this.easelInterface.keyListener = this.keyListener;
        this.selectionRenderer = new (0, $396117890b5c76b0$export$c61ab90e0d3eb9b1)({
            transform: this.viewport.getTransform(),
            selection: this.project.selection,
            width: this.width,
            height: this.height
        });
        this.svgEl = (0, $eWjiX.BB).createSvg({
            elementType: 'svg',
            width: '' + this.width,
            height: '' + this.height
        });
        (0, $7jh4K.css)(this.svgEl, {
            position: 'absolute',
            left: '0',
            top: '0',
            pointerEvents: 'none'
        });
        (_this_svgEl = this.svgEl).append.apply(_this_svgEl, [
            this.selectionRenderer.getElement()
        ].concat((0, $bX4ja._)(Object.values(this.toolsMap).map(function(item) {
            return item.getSvgElement();
        }))));
        this.htmlOverlayEl = (0, $eWjiX.BB).el({
            css: {
                position: 'absolute',
                left: '0',
                top: '0'
            }
        });
        (_this_htmlOverlayEl = this.htmlOverlayEl).append.apply(_this_htmlOverlayEl, (0, $bX4ja._)(Object.values(this.toolsMap).map(function(item) {
            var _item_getHtmlOverlayElement;
            return ((_item_getHtmlOverlayElement = item.getHtmlOverlayElement) === null || _item_getHtmlOverlayElement === void 0 ? void 0 : _item_getHtmlOverlayElement.call(item)) || undefined;
        }).filter(function(item) {
            return item !== undefined;
        })));
        this.updateToolSvgs();
        this.rootEl = (0, $075b9fd415bad4ff$export$db3b6bfb95261072)({
            css: {
                userSelect: 'none',
                touchAction: 'none',
                overscrollBehaviorX: 'none'
            }
        }, [
            this.viewport.getElement(),
            this.svgEl,
            this.htmlOverlayEl
        ]);
        // prevent contextmenu
        this.rootEl.addEventListener('contextmenu', function(e) {
            e.preventDefault();
            return false;
        }, {
            passive: false
        });
        // Carried over from old KlCanvasWorkspace. Prevent some default browser behavior. Todo what breaks if removed?
        this.rootEl.addEventListener('touchend', function(e) {
            e.preventDefault();
            return false;
        });
        // Carried over from old KlCanvasWorkspace. Prevent some default browser behavior. Todo what breaks if removed?
        this.rootEl.addEventListener('dragstart', function(e) {
            e.preventDefault();
            return false;
        });
        (_this_toolsMap_this_toolId_activate = (_this_toolsMap_this_toolId = this.toolsMap[this.toolId]).activate) === null || _this_toolsMap_this_toolId_activate === void 0 ? void 0 : _this_toolsMap_this_toolId_activate.call(_this_toolsMap_this_toolId, this.cursorPos);
        Object.values(this.toolsMap).forEach(function(tool) {
            var _tool_onTool;
            return (_tool_onTool = tool.onTool) === null || _tool_onTool === void 0 ? void 0 : _tool_onTool.call(tool, _this.toolId);
        });
        this.renderLoop();
    }
    (0, $7h4XF._)(Easel, [
        {
            key: "setTargetTransform",
            value: function setTargetTransform(transform, isImmediate) {
                if (isImmediate) this.viewport.setTransform(transform);
                this.targetTransform = transform;
                this.doRender = true;
            }
        },
        {
            key: "updateToolSvgs",
            value: function updateToolSvgs() {
                var _this = this;
                var _this_tempToolId;
                var tool = (_this_tempToolId = this.tempToolId) !== null && _this_tempToolId !== void 0 ? _this_tempToolId : this.toolId;
                Object.keys(this.toolsMap).forEach(function(toolId) {
                    _this.toolsMap[toolId].getSvgElement().style.display = toolId === tool ? '' : 'none';
                });
            }
        },
        {
            key: "updateDoubleTapPointerTypes",
            value: // different tools allow different pointer types to trigger the gesture
            function updateDoubleTapPointerTypes() {
                var _this_tempToolId, _this_toolsMap__doubleTapPointerTypes;
                var pointerTypes = (_this_toolsMap__doubleTapPointerTypes = this.toolsMap[(_this_tempToolId = this.tempToolId) !== null && _this_tempToolId !== void 0 ? _this_tempToolId : this.toolId].doubleTapPointerTypes) !== null && _this_toolsMap__doubleTapPointerTypes !== void 0 ? _this_toolsMap__doubleTapPointerTypes : (0, $991ab38832278e02$export$31ee023005d8c68f);
                this.pointerPreprocessor.setDoubleTapPointerTypes(pointerTypes);
            }
        },
        {
            key: "renderLoop",
            value: /**
     * Only call once from outside. Will perpetuate itself and render when doRender = true
     */ function renderLoop() {
                var _this = this;
                var now = performance.now();
                var deltaMs = now - this.lastFrameTimestamp;
                this.lastFrameTimestamp = now;
                this.animationFrameId = requestAnimationFrame(function() {
                    return _this.renderLoop();
                });
                // Advance animation frame if there are animated layers (and not paused)
                if (this.hasAnimatedLayers && !this.animPaused && now - this.animLastTick >= 1000 / this.animFps) {
                    this.animLastTick = now;
                    this.animFrameIndex = (this.animFrameIndex + 1) % 3;
                    this.doRender = true;
                }
                if (!this.doRender) return;
                var tool = this.getActiveTool();
                var oldTransform = this.viewport.getTransform();
                var newTransform = oldTransform;
                if ((0, $da90e23ff63572c1$export$296b597c2b22784a)(oldTransform, this.targetTransform)) this.doRender = false;
                else {
                    var defaultDeltaMs = 1000 / 60;
                    var timeFactor = deltaMs / defaultDeltaMs;
                    var easeFactor = 1 - Math.pow(0.7, timeFactor);
                    newTransform = (0, $11590af1b0c2eaf1$export$e5cb90f7d2eee96c)(oldTransform, this.targetTransform, {
                        width: this.project.width,
                        height: this.project.height
                    }, {
                        x: this.width / 2,
                        y: this.height / 2
                    }, easeFactor);
                    this.viewport.setTransform(newTransform);
                }
                // todo: is last renderedTransform needed?
                var isPositionChanged = newTransform.x !== this.lastRenderedTransform.x || newTransform.y !== this.lastRenderedTransform.y;
                var isScaleOrAngleChanged = newTransform.scale !== this.lastRenderedTransform.scale || newTransform.angleDeg !== this.lastRenderedTransform.angleDeg;
                this.viewport.render(!(0, $da90e23ff63572c1$export$296b597c2b22784a)(oldTransform, newTransform));
                if (isPositionChanged || isScaleOrAngleChanged) {
                    var _tool_onUpdateTransform;
                    (_tool_onUpdateTransform = tool.onUpdateTransform) === null || _tool_onUpdateTransform === void 0 ? void 0 : _tool_onUpdateTransform.call(tool, newTransform);
                    this.selectionRenderer.setTransform(newTransform);
                    this.onTransformChange(this.targetTransform, isScaleOrAngleChanged);
                    this.lastRenderedTransform = newTransform;
                }
            }
        },
        {
            key: "pushTempTool",
            value: /**
     * activate temporary tool. Can only push one.
     */ function pushTempTool(toolId) {
                var _tool_getIsLocked, _this_toolsMap_activeToolId_activate, _this_toolsMap_activeToolId;
                if (this.tempToolId !== undefined || toolId === undefined) return;
                var tool = this.toolsMap[this.toolId];
                if ((_tool_getIsLocked = tool.getIsLocked) === null || _tool_getIsLocked === void 0 ? void 0 : _tool_getIsLocked.call(tool)) return;
                this.tempToolId = toolId;
                var activeToolId = this.getActiveToolId();
                (_this_toolsMap_activeToolId_activate = (_this_toolsMap_activeToolId = this.toolsMap[activeToolId]).activate) === null || _this_toolsMap_activeToolId_activate === void 0 ? void 0 : _this_toolsMap_activeToolId_activate.call(_this_toolsMap_activeToolId, this.cursorPos);
                Object.values(this.toolsMap).forEach(function(tool) {
                    var _tool_onTool;
                    return (_tool_onTool = tool.onTool) === null || _tool_onTool === void 0 ? void 0 : _tool_onTool.call(tool, activeToolId);
                });
                this.updateToolSvgs();
                this.updateDoubleTapPointerTypes();
            }
        },
        {
            key: "popTempTool",
            value: /**
     * Turn off temporary tool
     */ function popTempTool(toolId) {
                var _this_getActiveTool_activate, _this_getActiveTool;
                if (this.tempToolId !== toolId || toolId === undefined) return;
                this.tempToolId = undefined;
                (_this_getActiveTool_activate = (_this_getActiveTool = this.getActiveTool()).activate) === null || _this_getActiveTool_activate === void 0 ? void 0 : _this_getActiveTool_activate.call(_this_getActiveTool, this.cursorPos, true);
                var activeToolId = this.getActiveToolId();
                Object.values(this.toolsMap).forEach(function(tool) {
                    var _tool_onTool;
                    return (_tool_onTool = tool.onTool) === null || _tool_onTool === void 0 ? void 0 : _tool_onTool.call(tool, activeToolId);
                });
                this.updateToolSvgs();
                this.updateDoubleTapPointerTypes();
            }
        },
        {
            key: "getActiveToolId",
            value: function getActiveToolId() {
                var _this_tempToolId;
                return (_this_tempToolId = this.tempToolId) !== null && _this_tempToolId !== void 0 ? _this_tempToolId : this.toolId;
            }
        },
        {
            key: "getActiveTool",
            value: function getActiveTool() {
                return this.toolsMap[this.getActiveToolId()];
            }
        },
        {
            key: "getResetTransform",
            value: function getResetTransform() {
                return (0, $926e1894e59cf403$export$99c68a89351e15c0)({
                    x: this.width / 2,
                    y: this.height / 2
                }, {
                    x: this.project.width / 2,
                    y: this.project.height / 2
                }, 1, 0);
            }
        },
        {
            key: "getFitTransform",
            value: function getFitTransform() {
                return (0, $b12878515d74b1ca$export$29dc1c77cb35d1c5)({
                    x: 0,
                    y: 0,
                    width: this.project.width,
                    height: this.project.height
                }, this.viewport.getTransform(), {
                    width: this.width,
                    height: this.height
                }, true);
            }
        },
        {
            /** update and render */ key: "setProject",
            value: function setProject(project) {
                var _this_getActiveTool_onUpdateSelection, _this_getActiveTool;
                this.project = project;
                this.viewport.setProject({
                    width: this.project.width,
                    height: this.project.height,
                    layers: this.project.layers
                });
                this.selectionRenderer.setSelection(this.project.selection);
                (_this_getActiveTool_onUpdateSelection = (_this_getActiveTool = this.getActiveTool()).onUpdateSelection) === null || _this_getActiveTool_onUpdateSelection === void 0 ? void 0 : _this_getActiveTool_onUpdateSelection.call(_this_getActiveTool, this.project.selection);
                this.requestRender();
            }
        },
        {
            /** update and render */ key: "setSize",
            value: function setSize(width, height) {
                var _this_getActiveTool_onResize, _this_getActiveTool;
                var m = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(this.viewport.getTransform());
                var canvasCenterPoint = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(m), {
                    x: this.width / 2,
                    y: this.height / 2
                });
                this.width = width;
                this.height = height;
                (0, $eWjiX.BB).setAttributes(this.svgEl, {
                    width: '' + this.width,
                    height: '' + this.height
                });
                this.selectionRenderer.setSize(width, height);
                (_this_getActiveTool_onResize = (_this_getActiveTool = this.getActiveTool()).onResize) === null || _this_getActiveTool_onResize === void 0 ? void 0 : _this_getActiveTool_onResize.call(_this_getActiveTool, width, height);
                this.viewport.setSize(width, height);
                var transform = this.viewport.getTransform();
                this.setTargetTransform((0, $926e1894e59cf403$export$99c68a89351e15c0)({
                    x: this.width / 2,
                    y: this.height / 2
                }, canvasCenterPoint, transform.scale, transform.angleDeg), true);
                this.requestRender();
            }
        },
        {
            key: "requestRender",
            value: function requestRender() {
                this.doRender = true;
            }
        },
        {
            key: "getAnimFrameIndex",
            value: function getAnimFrameIndex() {
                return this.animFrameIndex;
            }
        },
        {
            key: "setHasAnimatedLayers",
            value: function setHasAnimatedLayers(v) {
                this.hasAnimatedLayers = v;
            }
        },
        {
            key: "setAnimPaused",
            value: function setAnimPaused(v) {
                this.animPaused = v;
                if (!v) this.requestRender();
            }
        },
        {
            key: "getTransform",
            value: function getTransform() {
                return this.viewport.getTransform();
            }
        },
        {
            key: "setTransform",
            value: function setTransform(transform) {
                this.setTargetTransform(transform, true);
            }
        },
        {
            key: "setTool",
            value: function setTool(toolId) {
                var _this = this;
                var _this_toolsMap_this_toolId_activate, _this_toolsMap_this_toolId;
                if (toolId === this.toolId) return;
                this.toolId = toolId;
                (_this_toolsMap_this_toolId_activate = (_this_toolsMap_this_toolId = this.toolsMap[this.toolId]).activate) === null || _this_toolsMap_this_toolId_activate === void 0 ? void 0 : _this_toolsMap_this_toolId_activate.call(_this_toolsMap_this_toolId, this.cursorPos);
                Object.values(this.toolsMap).forEach(function(tool) {
                    var _tool_onTool;
                    return (_tool_onTool = tool.onTool) === null || _tool_onTool === void 0 ? void 0 : _tool_onTool.call(tool, _this.toolId);
                });
                this.onChangeTool(toolId);
                this.updateToolSvgs();
                this.updateDoubleTapPointerTypes();
                this.requestRender();
            }
        },
        {
            key: "getTool",
            value: function getTool() {
                return this.toolId;
            }
        },
        {
            key: "translate",
            value: function translate(dX, dY) {
                var transform = this.targetTransform;
                this.setTargetTransform((0, $4EWN2._)((0, $cL71g._)({}, transform), {
                    x: transform.x + dX,
                    y: transform.y + dY
                }));
            }
        },
        {
            key: "scale",
            value: function scale(factor, viewportX, viewportY) {
                var before = this.targetTransform;
                var viewportRect = {
                    width: this.width,
                    height: this.height
                };
                viewportX = viewportX !== null && viewportX !== void 0 ? viewportX : viewportRect.width / 2;
                viewportY = viewportY !== null && viewportY !== void 0 ? viewportY : viewportRect.height / 2;
                var metaTransform = (0, $c4f45fb8696b5286$export$935bc53f7df03c95)(before, {
                    x: viewportX,
                    y: viewportY
                });
                metaTransform.scale = (0, $eWjiX.BB).clamp(metaTransform.scale * factor, (0, $991ab38832278e02$export$5e2c057e240c0b8c), (0, $991ab38832278e02$export$ac82c07320907c00));
                this.setTargetTransform((0, $926e1894e59cf403$export$99c68a89351e15c0)(metaTransform.viewportP, metaTransform.canvasP, metaTransform.scale, metaTransform.angleDeg));
            }
        },
        {
            key: "resetTransform",
            value: function resetTransform(isImmediate) {
                var transform = this.getResetTransform();
                this.setTargetTransform(transform, isImmediate);
                this.requestRender();
            }
        },
        {
            key: "fitTransform",
            value: function fitTransform(isImmediate) {
                var oldTransform = this.viewport.getTransform();
                var transform = this.getFitTransform();
                var isPositionChanged = transform.x !== oldTransform.x || transform.y !== oldTransform.y;
                var isScaleOrAngleChanged = transform.scale !== oldTransform.scale || transform.angleDeg !== oldTransform.angleDeg;
                if (!isPositionChanged && !isScaleOrAngleChanged) return false;
                this.setTargetTransform(transform, isImmediate);
                return true;
            }
        },
        {
            /**
     * Automatically decide what is best. E.g. if it's pixel art, Fit might be better.
     */ key: "resetOrFitTransform",
            value: function resetOrFitTransform(isImmediate) {
                var threshold = 4; // >= 400% zoom. pixelated, not blurry
                if (!(0, $da1a7600c10c1784$export$67ac20532b9ededa).disableAutoFit && this.project.width <= this.width / threshold && this.project.height <= this.height / threshold) this.fitTransform(isImmediate);
                else this.resetTransform(isImmediate);
            }
        },
        {
            key: "setAngleDeg",
            value: function setAngleDeg(angleDeg, isRelative) {
                var viewportTransform = this.targetTransform;
                var viewportMat = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(viewportTransform);
                var viewportRect = {
                    width: this.width,
                    height: this.height
                };
                var viewportCenterP = {
                    x: viewportRect.width / 2,
                    y: viewportRect.height / 2
                };
                var newAngleDeg = (0, $eg83P.minimizeAngleDeg)(isRelative ? viewportTransform.angleDeg + angleDeg : angleDeg);
                var newViewportTransform = (0, $926e1894e59cf403$export$99c68a89351e15c0)(viewportCenterP, (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(viewportMat), viewportCenterP), viewportTransform.scale, newAngleDeg);
                this.setTargetTransform(newViewportTransform);
            }
        },
        {
            key: "getIsLocked",
            value: function getIsLocked() {
                var _this_getActiveTool_getIsLocked, _this_getActiveTool;
                var _this_getActiveTool_getIsLocked1;
                return (_this_getActiveTool_getIsLocked1 = (_this_getActiveTool_getIsLocked = (_this_getActiveTool = this.getActiveTool()).getIsLocked) === null || _this_getActiveTool_getIsLocked === void 0 ? void 0 : _this_getActiveTool_getIsLocked.call(_this_getActiveTool)) !== null && _this_getActiveTool_getIsLocked1 !== void 0 ? _this_getActiveTool_getIsLocked1 : false;
            }
        },
        {
            key: "setIsFrozen",
            value: function setIsFrozen(b) {
                this.isFrozen = b;
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.viewport.destroy();
                this.pointerListener.destroy();
                this.keyListener.destroy();
                this.animationFrameId !== undefined && cancelAnimationFrame(this.animationFrameId);
                this.selectionRenderer.destroy();
                window.removeEventListener('pointerdown', this.windowPointerListener);
            }
        }
    ]);
    return Easel;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $eWjiX = parcelRequire("eWjiX");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $970a66c5cf50c47f$export$6c14c4cb1f26a0eb = /*#__PURE__*/ function() {
    "use strict";
    function InertiaScrolling(p) {
        (0, $cx0mh._)(this, InertiaScrolling);
        this.defaultDeltaMs = 1000 / 60 // time factor is 1 for 60fps, 2 for 120fps
        ;
        this.momentum = {
            x: 0,
            y: 0
        };
        this.isDragging = false;
        this.lastDragTimestamp = 0;
        this.lastTimestamp = 0;
        this.isEnabled = false;
        this.getTransform = p.getTransform;
        this.setTransform = p.setTransform;
    }
    (0, $7h4XF._)(InertiaScrolling, [
        {
            key: "stop",
            value: function stop() {
                if (this.animationFrameHandle === undefined) return;
                cancelAnimationFrame(this.animationFrameHandle);
                this.animationFrameHandle = undefined;
            }
        },
        {
            key: "dampen",
            value: function dampen(timeFactor) {
                var vecLen = (0, $eWjiX.BB).Vec2.len(this.momentum);
                if (vecLen < 0.3) {
                    this.momentum.x = 0;
                    this.momentum.y = 0;
                    this.stop();
                } else if (vecLen < 5) {
                    this.momentum.x *= Math.pow(0.85, timeFactor);
                    this.momentum.y *= Math.pow(0.85, timeFactor);
                } else {
                    this.momentum.x *= Math.pow(0.95, timeFactor);
                    this.momentum.y *= Math.pow(0.95, timeFactor);
                }
            }
        },
        {
            key: "physicsLoop",
            value: // only call through requestAnimationFrame when animationFrameHandle undefined
            function physicsLoop() {
                var _this = this;
                this.animationFrameHandle = requestAnimationFrame(function() {
                    return _this.physicsLoop();
                });
                var nowMs = performance.now();
                var deltaMs = nowMs - this.lastTimestamp;
                var timeFactor = deltaMs / this.defaultDeltaMs;
                this.lastTimestamp = nowMs;
                if (this.momentum.x === 0 && this.momentum.y === 0 || this.isDragging) {
                    if (this.isDragging) this.dampen(timeFactor);
                    else this.stop();
                    return;
                }
                var transform = this.getTransform();
                if (this.lastTransform && (this.lastTransform.x !== transform.x || this.lastTransform.y !== transform.y || this.lastTransform.x !== transform.x || this.lastTransform.x !== transform.x)) {
                    this.momentum.x = 0;
                    this.momentum.y = 0;
                    this.lastTransform = undefined;
                    this.stop();
                    return;
                }
                transform.x += this.momentum.x;
                transform.y += this.momentum.y;
                this.lastTransform = transform;
                this.dampen(timeFactor);
                this.setTransform(transform);
            }
        },
        {
            key: "dragStart",
            value: function dragStart() {
                if (!this.isEnabled) return;
                this.isDragging = true;
                this.momentum.x = 0;
                this.momentum.y = 0;
                this.stop();
            }
        },
        {
            key: "dragMove",
            value: function dragMove(dX, dY) {
                if (!this.isEnabled) return;
                this.momentum = {
                    x: (0, $eWjiX.BB).mix(this.momentum.x, dX, 0.6),
                    y: (0, $eWjiX.BB).mix(this.momentum.y, dY, 0.6)
                };
                this.lastDragTimestamp = new Date().getTime();
            }
        },
        {
            key: "dragEnd",
            value: function dragEnd() {
                var _this = this;
                if (!this.isEnabled) return;
                if (new Date().getTime() - this.lastDragTimestamp > 80) {
                    this.momentum.x = 0;
                    this.momentum.y = 0;
                } else {
                    this.lastTimestamp = performance.now();
                    this.animationFrameHandle = requestAnimationFrame(function() {
                        return _this.physicsLoop();
                    });
                }
                this.lastTransform = undefined;
                this.lastDragTimestamp = 0;
                this.isDragging = false;
            }
        },
        {
            key: "setIsEnabled",
            value: function setIsEnabled(b) {
                this.isEnabled = b;
            }
        }
    ]);
    return InertiaScrolling;
}();


var $66028f220dcd865f$export$8202a4a90789f655 = /*#__PURE__*/ function() {
    "use strict";
    function EaselHand(p) {
        var _this = this;
        (0, $cx0mh._)(this, EaselHand);
        this.easel = {};
        // ----------------------------------- public -----------------------------------
        this.doubleTapPointerTypes = [
            'touch',
            'mouse',
            'pen'
        ];
        this.tempTriggers = [
            'space',
            'mouse-middle'
        ];
        this.svgEl = (0, $eWjiX.BB).createSvg({
            elementType: 'g'
        });
        this.inertiaScrolling = new (0, $970a66c5cf50c47f$export$6c14c4cb1f26a0eb)({
            getTransform: function() {
                return _this.easel.getTransform();
            },
            setTransform: function(transform) {
                return _this.easel.setTransform(transform, true);
            }
        });
    }
    (0, $7h4XF._)(EaselHand, [
        {
            key: "getSvgElement",
            value: function getSvgElement() {
                return this.svgEl;
            }
        },
        {
            key: "onPointer",
            value: function onPointer(e) {
                this.easel.setCursor('grab');
                if (e.type === 'pointerdown' && [
                    'left',
                    'middle'
                ].includes(e.button)) {
                    this.inertiaScrolling.dragStart();
                    this.easel.setCursor('grabbing');
                }
                if (e.type === 'pointermove' && [
                    'left',
                    'middle'
                ].includes(e.button)) {
                    var vTransform = (0, $cL71g._)({}, this.easel.getTransform());
                    vTransform.x += e.dX;
                    vTransform.y += e.dY;
                    this.easel.setTransform(vTransform, true);
                    this.easel.requestRender();
                    this.easel.setCursor('grabbing');
                    this.inertiaScrolling.dragMove(e.dX, e.dY);
                }
                if (e.type === 'pointerup' && e.button === undefined) this.inertiaScrolling.dragEnd();
            }
        },
        {
            key: "setEaselInterface",
            value: function setEaselInterface(easelInterface) {
                this.easel = easelInterface;
            }
        },
        {
            key: "activate",
            value: function activate(cursorPos) {
                this.easel.setCursor('grab');
            }
        },
        {
            key: "setUseInertiaScrolling",
            value: function setUseInertiaScrolling(b) {
                this.inertiaScrolling.setIsEnabled(b);
            }
        }
    ]);
    return EaselHand;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $eWjiX = parcelRequire("eWjiX");

parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");

var $jjWRi = parcelRequire("jjWRi");

var $gCzYB = parcelRequire("gCzYB");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");
parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");

var $62498d9607e3a2ac$export$e91d1e53efcc28e3 = /*#__PURE__*/ function() {
    "use strict";
    function BrushCursorPixelSquare() {
        (0, $cx0mh._)(this, BrushCursorPixelSquare);
        this.rootEl = (0, $eWjiX.BB).createSvg({
            elementType: 'g',
            childrenArr: [
                {
                    elementType: 'path',
                    fill: 'none',
                    stroke: 'rgba(255,255,255,0.7)',
                    'stroke-width': '1'
                },
                {
                    elementType: 'path',
                    fill: 'none',
                    stroke: 'rgba(0,0,0,0.7)',
                    'stroke-width': '1'
                }
            ]
        });
    }
    (0, $7h4XF._)(BrushCursorPixelSquare, [
        {
            key: "update",
            value: function update(transform, position, size) {
                var mat = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(transform);
                size = Math.round(size * 2) / 2;
                var width = Math.round(size * 2);
                var canvasCenter = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(mat), position);
                canvasCenter.x = width % 2 === 0 ? Math.round(canvasCenter.x) : Math.floor(canvasCenter.x) + 0.5;
                canvasCenter.y = width % 2 === 0 ? Math.round(canvasCenter.y) : Math.floor(canvasCenter.y) + 0.5;
                {
                    var canvasPoints = [
                        [
                            canvasCenter.x - size,
                            canvasCenter.y - size
                        ],
                        [
                            canvasCenter.x + size,
                            canvasCenter.y - size
                        ],
                        [
                            canvasCenter.x + size,
                            canvasCenter.y + size
                        ],
                        [
                            canvasCenter.x - size,
                            canvasCenter.y + size
                        ],
                        [
                            canvasCenter.x - size,
                            canvasCenter.y - size
                        ]
                    ];
                    var viewportPoints = canvasPoints.map(function(point) {
                        return (0, $cdZRx.applyToPoint)(mat, point);
                    });
                    var path = 'M ';
                    viewportPoints.forEach(function(point) {
                        path += point.join(',') + ' ';
                    });
                    (0, $7jh4K.setAttributes)(this.rootEl.children[1], {
                        d: path
                    });
                }
                {
                    var viewport1px = 1 / transform.scale;
                    var canvasPoints1 = [
                        [
                            canvasCenter.x - size + viewport1px,
                            canvasCenter.y - size + viewport1px
                        ],
                        [
                            canvasCenter.x + size - viewport1px,
                            canvasCenter.y - size + viewport1px
                        ],
                        [
                            canvasCenter.x + size - viewport1px,
                            canvasCenter.y + size - viewport1px
                        ],
                        [
                            canvasCenter.x - size + viewport1px,
                            canvasCenter.y + size - viewport1px
                        ],
                        [
                            canvasCenter.x - size + viewport1px,
                            canvasCenter.y - size + viewport1px
                        ]
                    ];
                    var viewportPoints1 = canvasPoints1.map(function(point) {
                        return (0, $cdZRx.applyToPoint)(mat, point);
                    });
                    var path1 = 'M ';
                    viewportPoints1.forEach(function(point) {
                        path1 += point.join(',') + ' ';
                    });
                    (0, $7jh4K.setAttributes)(this.rootEl.firstChild, {
                        d: path1
                    });
                }
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return BrushCursorPixelSquare;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $3295e188fd460bfa$export$249b9041c848ec46 = /*#__PURE__*/ function() {
    "use strict";
    function BrushCursorRound() {
        (0, $cx0mh._)(this, BrushCursorRound);
        this.rootEl = (0, $eWjiX.BB).createSvg({
            elementType: 'g',
            childrenArr: [
                {
                    elementType: 'circle',
                    cx: '0',
                    cy: '0',
                    fill: 'none',
                    stroke: 'rgba(255,255,255,0.7)',
                    'stroke-width': '1'
                },
                {
                    elementType: 'circle',
                    cx: '0',
                    cy: '0',
                    fill: 'none',
                    stroke: 'rgba(0,0,0,0.7)',
                    'stroke-width': '1'
                }
            ]
        });
    }
    (0, $7h4XF._)(BrushCursorRound, [
        {
            key: "update",
            value: function update(transform, position, size) {
                (0, $eWjiX.BB).setAttributes(this.rootEl.children[0], {
                    r: '' + Math.max(0, size * transform.scale - 1)
                });
                (0, $eWjiX.BB).setAttributes(this.rootEl.children[1], {
                    r: '' + size * transform.scale
                });
                (0, $eWjiX.BB).setAttributes(this.rootEl, {
                    transform: `translate(${position.x} ${position.y})`
                });
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return BrushCursorRound;
}();


var $e63c9ca4199f5887$export$dfeedd8879a1038a = /*#__PURE__*/ function() {
    "use strict";
    function EaselBrush(p) {
        var _this = this;
        (0, $cx0mh._)(this, EaselBrush);
        this.easel = {};
        this.oldScale = 1;
        this.isDragging = false;
        this.lastPos = {
            x: 0,
            y: 0
        };
        this.isOver = false;
        this.radius = p.radius;
        this.onLineStart = p.onLineStart;
        this.onLineGo = p.onLineGo;
        this.onLineEnd = p.onLineEnd;
        this.onLine = p.onLine;
        this.svgEl = (0, $eWjiX.BB).createSvg({
            elementType: 'g'
        });
        this.brushCursorRound = new (0, $3295e188fd460bfa$export$249b9041c848ec46)();
        this.brushCursorPixelSquare = new (0, $62498d9607e3a2ac$export$e91d1e53efcc28e3)();
        this.currentCursor = this.brushCursorRound;
        this.svgEl.append(this.currentCursor.getElement());
        this.eventChain = new (0, $gCzYB.EventChain)({
            chainArr: [
                new (0, $jjWRi.CoalescedExploder)()
            ]
        });
        this.eventChain.setChainOut(function(e) {
            _this.onExplodedPointer(e);
        });
    }
    (0, $7h4XF._)(EaselBrush, [
        {
            key: "onExplodedPointer",
            value: function onExplodedPointer(e) {
                var vTransform = this.easel.getTransform();
                var m = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(vTransform);
                // canvas coordinates
                var p = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(m), {
                    x: e.relX,
                    y: e.relY
                });
                var x = p.x;
                var y = p.y;
                if (vTransform.scale !== this.oldScale) this.oldScale = vTransform.scale;
                if (!e.isCoalesced) {
                    this.lastPos.x = e.relX;
                    this.lastPos.y = e.relY;
                    this.currentCursor.update(this.easel.getTransform(), {
                        x: e.relX,
                        y: e.relY
                    }, this.radius);
                    if (!this.isOver && e.type !== 'pointerup') this._onPointerEnter();
                }
                var _e_pressure;
                var pressure = (_e_pressure = e.pressure) !== null && _e_pressure !== void 0 ? _e_pressure : 1;
                var isCoalesced = e.isCoalesced;
                var shiftIsPressed = this.easel.keyListener.isPressed('shift');
                if (shiftIsPressed && !this.firstShiftPos) this.firstShiftPos = {
                    x: e.relX,
                    y: e.relY
                };
                if (!shiftIsPressed) {
                    this.firstShiftPos = undefined;
                    this.lineToolDirection = undefined;
                }
                if (e.type === 'pointerdown' && e.button === 'left') {
                    if (shiftIsPressed) {
                        if (this.lastLineEnd) this.onLine(this.lastLineEnd, {
                            x: x,
                            y: y
                        });
                        return;
                    }
                    this.onLineStart({
                        x: x,
                        y: y,
                        pressure: pressure,
                        isCoalesced: isCoalesced
                    });
                    this.isDragging = true;
                }
                if (e.type === 'pointermove' && e.button === 'left') {
                    if (shiftIsPressed) {
                        if (!this.lineToolDirection) {
                            var dX = Math.abs(e.relX - this.firstShiftPos.x);
                            var dY = Math.abs(e.relY - this.firstShiftPos.y);
                            if (dX > 5 || dY > 5) this.lineToolDirection = dX > dY ? 'x' : 'y';
                        }
                        if (this.lineToolDirection) {
                            var viewportP = {
                                x: this.lineToolDirection === 'x' ? e.relX : this.firstShiftPos.x,
                                y: this.lineToolDirection === 'y' ? e.relY : this.firstShiftPos.y
                            };
                            var canvasP = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(m), viewportP);
                            this.onLineGo((0, $4EWN2._)((0, $cL71g._)({}, canvasP), {
                                pressure: pressure,
                                isCoalesced: isCoalesced
                            }));
                        }
                    } else this.onLineGo({
                        x: x,
                        y: y,
                        pressure: pressure,
                        isCoalesced: isCoalesced
                    });
                }
                if (e.type === 'pointerup' && e.button === undefined && this.isDragging) {
                    this.onLineEnd();
                    this.isDragging = false;
                    if (e.pointerType === 'touch') // due to delay of double-tap listener, pointerleave fires to early
                    this.onPointerLeave();
                }
            }
        },
        {
            key: "_onPointerEnter",
            value: function _onPointerEnter() {
                clearTimeout(this.hideCursorTimeout);
                this.svgEl.setAttribute('opacity', '1');
                this.isOver = true;
            }
        },
        {
            key: "getSvgElement",
            value: function getSvgElement() {
                return this.svgEl;
            }
        },
        {
            key: "onPointer",
            value: function onPointer(e) {
                this.eventChain.chainIn(e);
            }
        },
        {
            key: "onPointerLeave",
            value: function onPointerLeave() {
                clearTimeout(this.hideCursorTimeout);
                this.svgEl.setAttribute('opacity', '0');
                this.isOver = false;
            }
        },
        {
            key: "setEaselInterface",
            value: function setEaselInterface(easelInterface) {
                this.easel = easelInterface;
            }
        },
        {
            key: "onUpdateTransform",
            value: function onUpdateTransform(transform) {
                this.currentCursor.update(transform, {
                    x: this.lastPos.x,
                    y: this.lastPos.y
                }, this.radius);
            }
        },
        {
            key: "getIsLocked",
            value: function getIsLocked() {
                return this.isDragging;
            }
        },
        {
            key: "setBrush",
            value: function setBrush(p) {
                var _this = this;
                if (p.radius !== undefined) {
                    this.radius = p.radius;
                    if (!this.isOver) {
                        this.svgEl.setAttribute('opacity', '1');
                        clearTimeout(this.hideCursorTimeout);
                        this.hideCursorTimeout = setTimeout(function() {
                            _this.svgEl.setAttribute('opacity', '0');
                        }, 500);
                    }
                    var _this_easel_getSize = this.easel.getSize(), width = _this_easel_getSize.width, height = _this_easel_getSize.height;
                    this.currentCursor.update(this.easel.getTransform(), this.isOver ? this.lastPos : {
                        x: width / 2,
                        y: height / 2
                    }, this.radius);
                }
                if (p.type !== undefined) {
                    var newBrushCursor = p.type === 'round' ? this.brushCursorRound : this.brushCursorPixelSquare;
                    if (newBrushCursor !== this.currentCursor) {
                        this.currentCursor.getElement().remove();
                        this.currentCursor = newBrushCursor;
                        this.getSvgElement().append(this.currentCursor.getElement());
                    }
                }
            }
        },
        {
            key: "setLastDrawEvent",
            value: function setLastDrawEvent(p) {
                this.lastLineEnd = p ? (0, $cL71g._)({}, p) : undefined;
            }
        },
        {
            key: "activate",
            value: function activate(cursorPos) {
                this.easel.setCursor('crosshair');
                this.isDragging = false;
                if (cursorPos) {
                    this.lastPos.x = cursorPos.x;
                    this.lastPos.y = cursorPos.y;
                    this.currentCursor.update(this.easel.getTransform(), {
                        x: cursorPos.x,
                        y: cursorPos.y
                    }, this.radius);
                } else this.onPointerLeave();
            }
        }
    ]);
    return EaselBrush;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $7jh4K = parcelRequire("7jh4K");
var $3dcbe6df163512b5$export$abfede0290e9bfba = /*#__PURE__*/ function() {
    "use strict";
    function EaselProjectUpdater(p) {
        (0, $cx0mh._)(this, EaselProjectUpdater);
        this.klCanvas = p.klCanvas;
        this.easel = p.easel;
        this.update();
    }
    (0, $7h4XF._)(EaselProjectUpdater, [
        {
            key: "update",
            value: function update() {
                var _this = this;
                var width = this.klCanvas.getWidth();
                var height = this.klCanvas.getHeight();
                var layers = this.klCanvas.getLayersFast();
                // free resources if no compositing being done
                if (layers.some(function(layer) {
                    return layer.compositeObj;
                })) {
                    if (!this.compositeCanvas) this.compositeCanvas = (0, $eWjiX.BB).canvas(width, height);
                } else if (this.compositeCanvas) {
                    (0, $eWjiX.BB).freeCanvas(this.compositeCanvas);
                    this.compositeCanvas = undefined;
                }
                var compositeCanvas = this.compositeCanvas;
                // Detect if any layer has animation frames
                var hasAnimated = layers.some(function(layer) {
                    return layer.frames && layer.frames.length > 1;
                });
                this.easel.setHasAnimatedLayers(hasAnimated);
                this.easel.setProject({
                    width: width,
                    height: height,
                    layers: layers.map(function(layer) {
                        var hasFrames = layer.frames && layer.frames.length > 1;
                        // Use a function for animated layers or composited layers
                        if (hasFrames || layer.compositeObj && compositeCanvas) return {
                            image: function() {
                                // Pick the correct frame canvas
                                var frameCanvas = hasFrames ? layer.frames[_this.easel.getAnimFrameIndex() % layer.frames.length] : layer.canvas;
                                if (layer.compositeObj && compositeCanvas) {
                                    var _layer_compositeObj;
                                    if (compositeCanvas.width != width || compositeCanvas.height != height) {
                                        compositeCanvas.width = width;
                                        compositeCanvas.height = height;
                                    }
                                    var ctx = compositeCanvas.getContext('2d');
                                    ctx.clearRect(0, 0, width, height);
                                    ctx.drawImage(frameCanvas, 0, 0);
                                    (_layer_compositeObj = layer.compositeObj) === null || _layer_compositeObj === void 0 ? void 0 : _layer_compositeObj.draw((0, $7jh4K.throwIfNull)(compositeCanvas.getContext('2d')));
                                    return compositeCanvas;
                                }
                                return frameCanvas;
                            },
                            isVisible: layer.isVisible,
                            opacity: layer.opacity,
                            mixModeStr: layer.mixModeStr,
                            hasClipping: false
                        };
                        return {
                            image: layer.canvas,
                            isVisible: layer.isVisible,
                            opacity: layer.opacity,
                            mixModeStr: layer.mixModeStr,
                            hasClipping: false
                        };
                    }),
                    selection: this.klCanvas.getSelection()
                });
            }
        },
        {
            // if you're not rendering easel for a while
            key: "freeCompositeCanvas",
            value: function freeCompositeCanvas() {
                if (this.compositeCanvas) {
                    (0, $eWjiX.BB).freeCanvas(this.compositeCanvas);
                    this.compositeCanvas = undefined;
                }
            }
        }
    ]);
    return EaselProjectUpdater;
}();




var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $78f5c513e727111b$exports = {};
$78f5c513e727111b$exports = $parcel$resolve("1dLwT");



parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");
var $24db627c4c8e30c9$export$1fda302750a9ba48 = /*#__PURE__*/ function() {
    "use strict";
    function EaselEyedropper(p) {
        (0, $cx0mh._)(this, EaselEyedropper);
        this.easel = {};
        this.isDragging = false;
        // ----------------------------------- public -----------------------------------
        this.tempTriggers = [
            'mouse-right',
            'alt'
        ];
        this.svgEl = (0, $eWjiX.BB).createSvg({
            elementType: 'g'
        });
        this.onPick = p.onPick;
        this.onPickEnd = p.onPickEnd;
        //color picker preview circle
        this.previewBorder = (0, $eWjiX.BB).createSvg({
            elementType: 'circle',
            r: '47',
            stroke: 'black',
            'stroke-width': '22',
            fill: 'none'
        });
        this.previewColor = (0, $eWjiX.BB).createSvg({
            elementType: 'circle',
            r: '47',
            stroke: 'black',
            'stroke-width': '20',
            fill: 'none'
        });
        this.svgEl.append(this.previewBorder, this.previewColor);
    }
    (0, $7h4XF._)(EaselEyedropper, [
        {
            key: "getSvgElement",
            value: function getSvgElement() {
                return this.svgEl;
            }
        },
        {
            key: "onPointer",
            value: function onPointer(e) {
                this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($78f5c513e727111b$exports))) + "') 0 15, crosshair");
                var transform = this.easel.getTransform();
                var m = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(transform);
                var p = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(m), {
                    x: e.relX,
                    y: e.relY
                });
                var color = undefined;
                var isDown = [
                    'left',
                    'right'
                ].includes(e.button);
                if (isDown) {
                    this.svgEl.setAttribute('transform', `translate(${e.relX},${e.relY})`);
                    this.svgEl.style.opacity = '1';
                } else this.svgEl.style.opacity = '0';
                if (e.type === 'pointerdown' && isDown) {
                    color = this.onPick(p);
                    this.isDragging = true;
                    isDown = true;
                }
                if (e.type === 'pointermove' && isDown) {
                    color = this.onPick(p);
                    isDown = true;
                }
                if (e.type === 'pointerup' && e.button === undefined && this.isDragging) {
                    this.onPickEnd();
                    this.isDragging = false;
                }
                if (color && isDown) {
                    this.previewColor.setAttribute('stroke', (0, $eWjiX.BB).ColorConverter.toRgbStr(color));
                    var borderColor = (0, $eWjiX.BB).testIsWhiteBestContrast(color) ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)';
                    this.previewBorder.setAttribute('stroke', borderColor);
                }
            }
        },
        {
            key: "setEaselInterface",
            value: function setEaselInterface(easelInterface) {
                this.easel = easelInterface;
            }
        },
        {
            key: "activate",
            value: function activate(cursorPos) {
                this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($78f5c513e727111b$exports))) + "') 0 15, crosshair");
                this.isDragging = false;
                this.svgEl.style.opacity = '0';
            }
        },
        {
            key: "onPointerLeave",
            value: function onPointerLeave() {
                if (this.isDragging) return;
                this.svgEl.style.opacity = '0';
            }
        }
    ]);
    return EaselEyedropper;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $4bb58f8998e01855$exports = {};
$4bb58f8998e01855$exports = $parcel$resolve("hQSEH");



parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");
var $f8e6779c7f01196e$export$9b29623161064b87 = /*#__PURE__*/ function() {
    "use strict";
    function EaselPaintBucket(p) {
        (0, $cx0mh._)(this, EaselPaintBucket);
        this.easel = {};
        this.svgEl = (0, $eWjiX.BB).createSvg({
            elementType: 'g'
        });
        this.onFill = p.onFill;
    }
    (0, $7h4XF._)(EaselPaintBucket, [
        {
            key: "getSvgElement",
            value: function getSvgElement() {
                return this.svgEl;
            }
        },
        {
            key: "onPointer",
            value: function onPointer(e) {
                this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($4bb58f8998e01855$exports))) + "') 1 12, crosshair");
                var vTransform = this.easel.getTransform();
                var m = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(vTransform);
                var p = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(m), {
                    x: e.relX,
                    y: e.relY
                });
                if (e.type === 'pointerdown' && e.button === 'left') this.onFill({
                    x: Math.floor(p.x),
                    y: Math.floor(p.y)
                });
            }
        },
        {
            key: "setEaselInterface",
            value: function setEaselInterface(easelInterface) {
                this.easel = easelInterface;
            }
        },
        {
            key: "activate",
            value: function activate(cursorPos) {
                this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($4bb58f8998e01855$exports))) + "') 1 12, crosshair");
            }
        }
    ]);
    return EaselPaintBucket;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");
var $04aa501093e072d1$export$11badb1ec62816a1 = /*#__PURE__*/ function() {
    "use strict";
    function EaselGradient(p) {
        (0, $cx0mh._)(this, EaselGradient);
        this.easel = {};
        this.isDragging = false;
        this.svgEl = (0, $eWjiX.BB).createSvg({
            elementType: 'g'
        });
        this.onDown = p.onDown;
        this.onMove = p.onMove;
        this.onUp = p.onUp;
    }
    (0, $7h4XF._)(EaselGradient, [
        {
            key: "getSvgElement",
            value: function getSvgElement() {
                return this.svgEl;
            }
        },
        {
            key: "onPointer",
            value: function onPointer(e) {
                this.easel.setCursor('crosshair');
                var vTransform = this.easel.getTransform();
                var m = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(vTransform);
                var p = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(m), {
                    x: e.relX,
                    y: e.relY
                });
                if (e.type === 'pointerdown' && e.button === 'left') {
                    this.onDown(p, vTransform.angleDeg / 180 * Math.PI);
                    this.isDragging = true;
                }
                if (e.type === 'pointermove' && e.button === 'left') this.onMove(p);
                if (e.type === 'pointerup' && e.button === undefined && this.isDragging) {
                    this.onUp(p);
                    this.isDragging = false;
                }
            }
        },
        {
            key: "setEaselInterface",
            value: function setEaselInterface(easelInterface) {
                this.easel = easelInterface;
            }
        },
        {
            key: "getIsLocked",
            value: function getIsLocked() {
                return this.isDragging;
            }
        },
        {
            key: "activate",
            value: function activate(cursorPos) {
                this.easel.setCursor('crosshair');
                this.isDragging = false;
            }
        }
    ]);
    return EaselGradient;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $0dd25bde578361f5$exports = {};
$0dd25bde578361f5$exports = $parcel$resolve("916ZI");



parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");
var $43b8e046e203efe4$export$b10c22a3fee9197f = /*#__PURE__*/ function() {
    "use strict";
    function EaselText(p) {
        (0, $cx0mh._)(this, EaselText);
        this.easel = {};
        this.svgEl = (0, $eWjiX.BB).createSvg({
            elementType: 'g'
        });
        this.onDown = p.onDown;
    }
    (0, $7h4XF._)(EaselText, [
        {
            key: "getSvgElement",
            value: function getSvgElement() {
                return this.svgEl;
            }
        },
        {
            key: "onPointer",
            value: function onPointer(e) {
                this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($0dd25bde578361f5$exports))) + "') 1 12, crosshair");
                var vTransform = this.easel.getTransform();
                var m = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(vTransform);
                var p = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(m), {
                    x: e.relX,
                    y: e.relY
                });
                if (e.type === 'pointerdown' && e.button === 'left') this.onDown(p, vTransform.angleDeg / 180 * Math.PI);
            }
        },
        {
            key: "setEaselInterface",
            value: function setEaselInterface(easelInterface) {
                this.easel = easelInterface;
            }
        },
        {
            key: "activate",
            value: function activate(cursorPos) {
                this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($0dd25bde578361f5$exports))) + "') 1 12, crosshair");
            }
        }
    ]);
    return EaselText;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $201034f69477f047$export$4deed4c512c630c2 = /*#__PURE__*/ function() {
    "use strict";
    function CornerPanning(p) {
        (0, $cx0mh._)(this, CornerPanning);
        this.thresholdPx = 25;
        this.lastFrameTimestamp = 0;
        this.repeatEvent = {};
        this.getEaselSize = p.getEaselSize;
        this.getTransform = p.getTransform;
        this.setTransform = p.setTransform;
        this.testCanPan = p.testCanPan;
        this.onRepeatEvent = p.onRepeatEvent;
    }
    (0, $7h4XF._)(CornerPanning, [
        {
            key: "movementLoop",
            value: // only call through requestAnimationFrame when animationFrameHandle undefined
            function movementLoop() {
                var _this = this;
                if (!this.cornerDirection) {
                    if (this.animationFrameHandle) cancelAnimationFrame(this.animationFrameHandle);
                    this.animationFrameHandle = undefined;
                    this.lastFrameTimestamp = 0;
                    return;
                }
                this.animationFrameHandle = requestAnimationFrame(function() {
                    return _this.movementLoop();
                });
                var now = performance.now();
                var deltaMs = now - this.lastFrameTimestamp;
                var defaultDeltaMs = 1000 / 60;
                var timeFactor = Math.min(deltaMs / defaultDeltaMs, 10);
                this.lastFrameTimestamp = now;
                var transform = this.getTransform();
                transform.x += this.cornerDirection.x * timeFactor;
                transform.y += this.cornerDirection.y * timeFactor;
                this.setTransform(transform);
                this.onRepeatEvent(this.repeatEvent);
            }
        },
        {
            key: "getSpeed",
            value: function getSpeed(thresholdDelta) {
                return Math.min(thresholdDelta, this.thresholdPx) * 0.4;
            }
        },
        {
            key: "onPointer",
            value: function onPointer(event) {
                var _this = this;
                var isMoving = false;
                this.cornerDirection = {
                    x: 0,
                    y: 0
                };
                if (this.testCanPan(event.button !== undefined) && event.type === 'pointermove') {
                    if (event.relX > this.getEaselSize().width - this.thresholdPx) {
                        this.cornerDirection.x -= this.getSpeed(event.relX - (this.getEaselSize().width - this.thresholdPx));
                        isMoving = true;
                    }
                    if (event.relX < this.thresholdPx) {
                        this.cornerDirection.x += this.getSpeed(this.thresholdPx - event.relX);
                        isMoving = true;
                    }
                    if (event.relY > this.getEaselSize().height - this.thresholdPx) {
                        this.cornerDirection.y -= this.getSpeed(event.relY - (this.getEaselSize().height - this.thresholdPx));
                        isMoving = true;
                    }
                    if (event.relY < this.thresholdPx) {
                        this.cornerDirection.y += this.getSpeed(this.thresholdPx - event.relY);
                        isMoving = true;
                    }
                }
                if (isMoving) {
                    if (this.lastFrameTimestamp === 0) this.lastFrameTimestamp = performance.now();
                    this.repeatEvent = event;
                    this.animationFrameHandle = requestAnimationFrame(function() {
                        return _this.movementLoop();
                    });
                } else this.cornerDirection = undefined;
            }
        }
    ]);
    return CornerPanning;
}();


var $ebd223e87e103321$export$f4821fa73b1145e5 = /*#__PURE__*/ function() {
    "use strict";
    function EaselShape(p) {
        var _this = this;
        (0, $cx0mh._)(this, EaselShape);
        this.easel = {};
        this.isDragging = false;
        this.doPan = false;
        this.svgEl = (0, $eWjiX.BB).createSvg({
            elementType: 'g'
        });
        this.onDown = p.onDown;
        this.onMove = p.onMove;
        this.onUp = p.onUp;
        this.cornerPanning = new (0, $201034f69477f047$export$4deed4c512c630c2)({
            getEaselSize: function() {
                return _this.easel.getSize();
            },
            getTransform: function() {
                return _this.easel.getTargetTransform();
            },
            setTransform: function(transform) {
                return _this.easel.setTransform(transform, true);
            },
            testCanPan: function(buttonIsPressed) {
                return buttonIsPressed;
            },
            onRepeatEvent: function(e) {
                _this.onPointer(e, true);
            }
        });
    }
    (0, $7h4XF._)(EaselShape, [
        {
            key: "getSvgElement",
            value: function getSvgElement() {
                return this.svgEl;
            }
        },
        {
            key: "onPointer",
            value: function onPointer(e, isRepeat) {
                if (this.doPan && !isRepeat) this.cornerPanning.onPointer(e);
                this.easel.setCursor('crosshair');
                var vTransform = this.easel.getTransform();
                var m = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(vTransform);
                var p = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(m), {
                    x: e.relX,
                    y: e.relY
                });
                if (e.type === 'pointerdown' && e.button === 'left') {
                    this.onDown(p, vTransform.angleDeg / 180 * Math.PI);
                    this.isDragging = true;
                }
                if (e.type === 'pointermove' && e.button === 'left') this.onMove(p);
                if (e.type === 'pointerup' && e.button === undefined && this.isDragging) {
                    this.onUp(p);
                    this.isDragging = false;
                }
            }
        },
        {
            key: "setEaselInterface",
            value: function setEaselInterface(easelInterface) {
                this.easel = easelInterface;
            }
        },
        {
            key: "getIsLocked",
            value: function getIsLocked() {
                return this.isDragging;
            }
        },
        {
            key: "activate",
            value: function activate(cursorPos) {
                this.easel.setCursor('crosshair');
                this.isDragging = false;
            }
        },
        {
            key: "setPanning",
            value: function setPanning(doPan) {
                this.doPan = doPan;
            }
        }
    ]);
    return EaselShape;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");


var $eg83P = parcelRequire("eg83P");

var $7jh4K = parcelRequire("7jh4K");
var $5af1201febea9911$export$f3b0846760df78b = /*#__PURE__*/ function() {
    "use strict";
    function EaselRotate(p) {
        (0, $cx0mh._)(this, EaselRotate);
        this.easel = {};
        this.downPos = undefined;
        // ----------------------------------- public -----------------------------------
        this.tempTriggers = [
            'r'
        ];
        this.svgEl = (0, $eWjiX.BB).createSvg({
            elementType: 'g'
        });
        //rotation compass
        this.compassSize = 30;
        this.compass = (0, $eWjiX.BB).createSvg({
            elementType: 'g'
        });
        (0, $7jh4K.css)(this.compass, {
            transition: 'opacity 0.25s ease-in-out'
        });
        this.compassInner = (0, $eWjiX.BB).createSvg({
            elementType: 'g'
        });
        this.compassBaseCircle = (0, $eWjiX.BB).createSvg({
            elementType: 'circle',
            fill: 'rgba(0,0,0,0.9)',
            stroke: 'none',
            cx: '0',
            cy: '0',
            r: '' + this.compassSize
        });
        this.compassLineCircle = (0, $eWjiX.BB).createSvg({
            elementType: 'circle',
            fill: 'none',
            stroke: 'rgba(255,255,255,0.75)',
            'stroke-width': '1',
            cx: '0',
            cy: '0',
            r: '' + this.compassSize * 0.9
        });
        (0, $7jh4K.css)(this.compassLineCircle, {
            transition: 'opacity 0.1s ease-in-out'
        });
        this.needleWrapper = (0, $eWjiX.BB).createSvg({
            elementType: 'g',
            'transform-origin': '0 0'
        });
        this.compassUpperTriangle = (0, $eWjiX.BB).createSvg({
            elementType: 'path',
            fill: '#f00',
            stroke: 'none',
            d: 'M -' + this.compassSize * 0.25 + ',0 ' + this.compassSize * 0.25 + ',0 0,-' + this.compassSize * 0.9 + ' z'
        });
        this.compassLowerTriangle = (0, $eWjiX.BB).createSvg({
            elementType: 'path',
            fill: '#fff',
            stroke: 'none',
            d: 'M -' + this.compassSize * 0.25 + ',0 ' + this.compassSize * 0.25 + ',0 0,' + this.compassSize * 0.9 + ' z'
        });
        this.needleWrapper.append(this.compassUpperTriangle, this.compassLowerTriangle);
        this.compassInner.append(this.compassBaseCircle, this.compassLineCircle, this.needleWrapper);
        this.compass.append(this.compassInner);
        this.svgEl.append(this.compass);
    }
    (0, $7h4XF._)(EaselRotate, [
        {
            key: "getSvgElement",
            value: function getSvgElement() {
                return this.svgEl;
            }
        },
        {
            key: "onPointer",
            value: function onPointer(e) {
                this.easel.setCursor(e.button === 'left' ? 'grabbing' : 'grab');
                if (e.type === 'pointerdown' && e.button === 'left') {
                    this.downPos = {
                        x: e.relX,
                        y: e.relY
                    };
                    this.downTransform = (0, $eWjiX.BB).copyObj(this.easel.getTargetTransform());
                } else if (e.button === 'left' && this.downPos && this.downTransform) {
                    var _this_easel_getSize = this.easel.getSize(), width = _this_easel_getSize.width, height = _this_easel_getSize.height;
                    var centerObj = {
                        x: width / 2,
                        y: height / 2
                    };
                    var startAngleRad = (0, $eWjiX.BB).Vec2.angle(centerObj, this.downPos);
                    var newAngleRad = (0, $eWjiX.BB).Vec2.angle(centerObj, {
                        x: e.relX,
                        y: e.relY
                    });
                    var dAngleDeg = (newAngleRad - startAngleRad) / Math.PI * 180;
                    var newAngleDeg = this.downTransform.angleDeg + dAngleDeg;
                    if (this.easel.isKeyPressed('shift')) newAngleDeg = Math.round(newAngleDeg / 45) * 45;
                    newAngleDeg = (0, $eg83P.minimizeAngleDeg)(newAngleDeg);
                    //rotate transform
                    var mat = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(this.downTransform);
                    var canvasPoint = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(mat), centerObj);
                    this.easel.setTransform((0, $926e1894e59cf403$export$99c68a89351e15c0)(centerObj, canvasPoint, this.downTransform.scale, newAngleDeg), !this.easel.isKeyPressed('shift'));
                    this.easel.requestRender();
                } else if (e.type === 'pointerup' && this.downPos) {
                    this.downPos = undefined;
                    this.downTransform = undefined;
                }
            }
        },
        {
            key: "onUpdateTransform",
            value: function onUpdateTransform(transform) {
                var targetTransform = this.easel.getTargetTransform();
                this.needleWrapper.setAttribute('transform', 'rotate(' + transform.angleDeg + ')');
                this.compassLineCircle.style.opacity = targetTransform.angleDeg % 90 === 0 ? '1' : '0';
            }
        },
        {
            key: "setEaselInterface",
            value: function setEaselInterface(easelInterface) {
                this.easel = easelInterface;
            }
        },
        {
            key: "activate",
            value: function activate(cursorPos) {
                this.easel.setCursor('grab');
                var _this_easel_getSize = this.easel.getSize(), width = _this_easel_getSize.width, height = _this_easel_getSize.height;
                this.compass.setAttribute('transform', 'translate(' + width / 2 + ', ' + height / 2 + ')');
                this.onUpdateTransform(this.easel.getTransform());
            }
        },
        {
            key: "onKeyDown",
            value: function onKeyDown(keyStr, event, comboStr) {
                if ([
                    'r+left',
                    'r+right'
                ].includes(comboStr)) {
                    if (keyStr === 'left') this.easel.setAngleDeg(-15, true);
                    if (keyStr === 'right') this.easel.setAngleDeg(15, true);
                }
                if ([
                    'r+up'
                ].includes(comboStr)) this.easel.setAngleDeg(0, false);
            }
        },
        {
            key: "onResize",
            value: function onResize(width, height) {
                this.compass.setAttribute('transform', 'translate(' + width / 2 + ', ' + height / 2 + ')');
            }
        }
    ]);
    return EaselRotate;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");
var $ff8dbb1bd3f9b85c$exports = {};
$ff8dbb1bd3f9b85c$exports = $parcel$resolve("9wZxU");


parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");


var $e041531c7ca89b12$export$6c389c8425707374 = /*#__PURE__*/ function() {
    "use strict";
    function EaselZoom(p) {
        (0, $cx0mh._)(this, EaselZoom);
        this.easel = {};
        this.downPos = undefined;
        // ----------------------------------- public -----------------------------------
        this.tempTriggers = [
            'z'
        ];
        this.svgEl = (0, $eWjiX.BB).createSvg({
            elementType: 'g'
        });
    }
    (0, $7h4XF._)(EaselZoom, [
        {
            key: "getSvgElement",
            value: function getSvgElement() {
                return this.svgEl;
            }
        },
        {
            key: "onPointer",
            value: function onPointer(e) {
                this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($ff8dbb1bd3f9b85c$exports))) + "') 7 7, zoom-in");
                if (e.type === 'pointerdown' && [
                    'left'
                ].includes(e.button)) {
                    this.downPos = {
                        x: e.relX,
                        y: e.relY
                    };
                    this.downTransform = (0, $eWjiX.BB).copyObj(this.easel.getTransform());
                }
                if (e.type === 'pointermove' && [
                    'left'
                ].includes(e.button) && this.downPos && this.downTransform) {
                    var viewportPoint = this.downPos;
                    var mat = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(this.downTransform);
                    var canvasPoint = (0, $cdZRx.applyToPoint)((0, $kDVZW.inverse)(mat), viewportPoint);
                    var dX = e.relX - this.downPos.x;
                    var newScale = (0, $eWjiX.BB).clamp(this.downTransform.scale * Math.pow(1 + 1 / 400, dX), this.easel.minScale, this.easel.maxScale);
                    this.easel.setTransform((0, $926e1894e59cf403$export$99c68a89351e15c0)(viewportPoint, canvasPoint, newScale, this.downTransform.angleDeg), true);
                    this.easel.requestRender();
                }
                if (e.type === 'pointerup' && e.button === undefined) {
                    this.downPos = undefined;
                    this.downTransform = undefined;
                }
            }
        },
        {
            key: "setEaselInterface",
            value: function setEaselInterface(easelInterface) {
                this.easel = easelInterface;
            }
        },
        {
            key: "activate",
            value: function activate(cursorPos) {
                this.easel.setCursor("url('" + (0, (/*@__PURE__*/$parcel$interopDefault($ff8dbb1bd3f9b85c$exports))) + "') 7 7, zoom-in");
            }
        }
    ]);
    return EaselZoom;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $8N5YG = parcelRequire("8N5YG");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");

var $3e01e916c4e53185$exports = {};
$3e01e916c4e53185$exports = $parcel$resolve("kiEfz");


var $6dae220a5b70a5f8$exports = {};
$6dae220a5b70a5f8$exports = $parcel$resolve("4uXfZ");



var $2c33980c55e55d8e$exports = {};
$2c33980c55e55d8e$exports = $parcel$resolve("bjhUB");


var $f4416a3e89ce50bf$exports = {};
$f4416a3e89ce50bf$exports = $parcel$resolve("9MYhm");


var $4ab563d9dade83ab$exports = {};
$4ab563d9dade83ab$exports = $parcel$resolve("fsl8L");


var $94fd3ca351798f15$exports = {};
$94fd3ca351798f15$exports = $parcel$resolve("3QHUd");


var $115673c0650a4220$exports = {};
$115673c0650a4220$exports = $parcel$resolve("5GkZe");


var $2dfd245fd3bb9927$exports = {};
$2dfd245fd3bb9927$exports = $parcel$resolve("2zM6R");


var $d77fe25b1a559789$exports = {};
$d77fe25b1a559789$exports = $parcel$resolve("5rTlv");




var $f0b183c56b76aebb$exports = {};
$f0b183c56b76aebb$exports = $parcel$resolve("dmNGI");






var $72Jv0 = parcelRequire("72Jv0");

var $7jh4K = parcelRequire("7jh4K");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $eWjiX = parcelRequire("eWjiX");
var $eae820938baa028e$export$f04a61298a47a40f = /*#__PURE__*/ function() {
    "use strict";
    function Icon(p) {
        (0, $cx0mh._)(this, Icon);
        this.rootEl = (0, $eWjiX.BB).el({
            className: p.darkInvert ? 'dark-invert' : '',
            css: (0, $cL71g._)({
                backgroundImage: `url("${p.imageUrl}")`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: p.width + 'px',
                height: p.height + 'px'
            }, p.css)
        });
    }
    (0, $7h4XF._)(Icon, [
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return Icon;
}();



var $eelgW = parcelRequire("eelgW");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $8N5YG = parcelRequire("8N5YG");

var $eelgW = parcelRequire("eelgW");

var $eWjiX = parcelRequire("eWjiX");
function $a8df4ba70dfe7950$export$b9cf8e4fed0549e8() {
    var webgl2IsSupported = false;
    var canvas = (0, $eelgW.createCanvas)();
    try {
        var gl = canvas.getContext('webgl2');
        webgl2IsSupported = gl !== null;
    } catch (_) {
    // noop
    }
    (0, $eWjiX.BB).freeCanvas(canvas);
    return webgl2IsSupported;
}
var $a8df4ba70dfe7950$export$382d1cdfd2c9e133 = /*#__PURE__*/ function() {
    "use strict";
    function GpuCompositeCanvas(canvas) {
        var interpolation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'smooth';
        (0, $cx0mh._)(this, GpuCompositeCanvas);
        this.program = null;
        this.positionLocation = -1;
        this.texCoordLocation = -1;
        this.textureLocation = null;
        this.meshes = new Map();
        this.textures = new Map();
        this.nextMeshId = 1;
        this.nextTextureId = 1;
        this.anisotropicExtension = null;
        this.maxAnisotropy = 1;
        this.multisampleFramebuffer = null;
        this.multisampleRenderbuffer = null;
        this.msaaSamples = 0;
        this.canvas = canvas;
        this.interpolation = interpolation;
        var gl = canvas.getContext('webgl2', {
            alpha: true,
            // All textures and framebuffers have premultiplied alpha
            premultipliedAlpha: true,
            // we manually handle MSAA via a framebuffer
            antialias: false
        });
        if (!gl) throw new Error('WebGL2 not supported');
        // init
        this.gl = gl;
        this.createProgram();
        if (this.interpolation === 'smooth') {
            this.detectAnisotropicFiltering();
            this.createMultisampleFramebuffer();
        }
        // we always want textures with premultiplied alpha
        this.gl.pixelStorei(this.gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
        // we always want blending
        this.gl.enable(this.gl.BLEND);
        this.gl.blendFunc(this.gl.ONE, this.gl.ONE_MINUS_SRC_ALPHA);
    }
    (0, $7h4XF._)(GpuCompositeCanvas, [
        {
            key: "compileShader",
            value: function compileShader(source, type) {
                var shader = this.gl.createShader(type);
                if (!shader) return null;
                this.gl.shaderSource(shader, source);
                this.gl.compileShader(shader);
                if (!this.gl.getShaderParameter(shader, this.gl.COMPILE_STATUS)) {
                    console.error('Shader compile error:', this.gl.getShaderInfoLog(shader));
                    this.gl.deleteShader(shader);
                    return null;
                }
                return shader;
            }
        },
        {
            key: "createProgram",
            value: function createProgram() {
                var vertexShaderSource = `#version 300 es
            in vec2 a_position;
            in vec2 a_texCoord;
            out vec2 v_texCoord;
            void main() {
                gl_Position = vec4(a_position, 0.0, 1.0);
                v_texCoord = a_texCoord;
            }
        `;
                var fragmentShaderSource = `#version 300 es
            precision mediump float;
            in vec2 v_texCoord;
            out vec4 outColor;
            uniform sampler2D u_texture;
            void main() {
                outColor = texture(u_texture, v_texCoord);
            }
        `;
                var vertexShader = this.compileShader(vertexShaderSource, this.gl.VERTEX_SHADER);
                if (!vertexShader) throw new Error('Failed to compile vertex shader');
                var fragmentShader = this.compileShader(fragmentShaderSource, this.gl.FRAGMENT_SHADER);
                if (!fragmentShader) throw new Error('Failed to compile fragment shader');
                this.program = this.gl.createProgram();
                this.gl.attachShader(this.program, vertexShader);
                this.gl.attachShader(this.program, fragmentShader);
                this.gl.linkProgram(this.program);
                if (!this.gl.getProgramParameter(this.program, this.gl.LINK_STATUS)) {
                    console.error('Program link error:', this.gl.getProgramInfoLog(this.program));
                    throw new Error('Failed to link program');
                }
                this.gl.deleteShader(vertexShader);
                this.gl.deleteShader(fragmentShader);
                this.gl.useProgram(this.program);
                this.positionLocation = this.gl.getAttribLocation(this.program, 'a_position');
                this.texCoordLocation = this.gl.getAttribLocation(this.program, 'a_texCoord');
                this.textureLocation = this.gl.getUniformLocation(this.program, 'u_texture');
                this.gl.useProgram(null);
            }
        },
        {
            key: "createMultisampleFramebuffer",
            value: function createMultisampleFramebuffer() {
                var gl = this.gl;
                var maxSamples = gl.getParameter(gl.MAX_SAMPLES);
                this.msaaSamples = Math.min(maxSamples, 8);
                this.multisampleRenderbuffer = gl.createRenderbuffer();
                gl.bindRenderbuffer(gl.RENDERBUFFER, this.multisampleRenderbuffer);
                gl.renderbufferStorageMultisample(gl.RENDERBUFFER, this.msaaSamples, gl.RGBA8, this.canvas.width, this.canvas.height);
                this.multisampleFramebuffer = gl.createFramebuffer();
                gl.bindFramebuffer(gl.FRAMEBUFFER, this.multisampleFramebuffer);
                gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.RENDERBUFFER, this.multisampleRenderbuffer);
                gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                gl.bindRenderbuffer(gl.RENDERBUFFER, null);
            }
        },
        {
            key: "detectAnisotropicFiltering",
            value: function detectAnisotropicFiltering() {
                // Check for anisotropic filtering extension
                this.anisotropicExtension = this.gl.getExtension('EXT_texture_filter_anisotropic') || this.gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic') || this.gl.getExtension('MOZ_EXT_texture_filter_anisotropic');
                if (this.anisotropicExtension) this.maxAnisotropy = this.gl.getParameter(this.anisotropicExtension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
            }
        },
        {
            /**
     * Creates a mesh (vertex array object)
     * @param positions - x,y positions in clip space top-left: (-1,1), bottom-right: (1,-1)
     * @param texCoords - u,v texture coordinates top-left: (0,0), bottom-right: (1,1)
     * @param indices - indices specifying triangles
     */ key: "createMesh",
            value: function createMesh(positions, texCoords, indices) {
                var _this = this;
                var vao = this.gl.createVertexArray();
                this.gl.bindVertexArray(vao);
                var positionBuffer = this.gl.createBuffer();
                this.gl.bindBuffer(this.gl.ARRAY_BUFFER, positionBuffer);
                this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array(positions), this.gl.STATIC_DRAW);
                this.gl.enableVertexAttribArray(this.positionLocation);
                this.gl.vertexAttribPointer(this.positionLocation, 2, this.gl.FLOAT, false, 0, 0);
                var texCoordBuffer = this.gl.createBuffer();
                this.gl.bindBuffer(this.gl.ARRAY_BUFFER, texCoordBuffer);
                this.gl.bufferData(this.gl.ARRAY_BUFFER, new Float32Array(texCoords), this.gl.STATIC_DRAW);
                this.gl.enableVertexAttribArray(this.texCoordLocation);
                this.gl.vertexAttribPointer(this.texCoordLocation, 2, this.gl.FLOAT, false, 0, 0);
                var indexBuffer = this.gl.createBuffer();
                this.gl.bindBuffer(this.gl.ELEMENT_ARRAY_BUFFER, indexBuffer);
                this.gl.bufferData(this.gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(indices), this.gl.STATIC_DRAW);
                var id = this.nextMeshId++;
                this.meshes.set(id, {
                    id: id,
                    vao: vao,
                    positionBuffer: positionBuffer,
                    texCoordBuffer: texCoordBuffer,
                    indexBuffer: indexBuffer,
                    indexCount: indices.length
                });
                return {
                    id: id,
                    destroy: function() {
                        return _this.destroyMesh(id);
                    }
                };
            }
        },
        {
            key: "destroyMesh",
            value: function destroyMesh(id) {
                var mesh = this.meshes.get(id);
                if (mesh) {
                    this.gl.deleteVertexArray(mesh.vao);
                    this.gl.deleteBuffer(mesh.positionBuffer);
                    this.gl.deleteBuffer(mesh.texCoordBuffer);
                    this.gl.deleteBuffer(mesh.indexBuffer);
                    this.meshes.delete(id);
                }
            }
        },
        {
            key: "createTexture",
            value: function createTexture(source) {
                var _this = this;
                var texture = this.gl.createTexture();
                this.gl.bindTexture(this.gl.TEXTURE_2D, texture);
                if (source instanceof HTMLImageElement || source instanceof HTMLCanvasElement) this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA8, this.gl.RGBA, this.gl.UNSIGNED_BYTE, source);
                else this.gl.texImage2D(this.gl.TEXTURE_2D, 0, this.gl.RGBA8, source.width, source.height, 0, this.gl.RGBA, this.gl.UNSIGNED_BYTE, source.data);
                // texture filtering
                if (this.interpolation === 'pixelated') {
                    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.NEAREST);
                    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.NEAREST);
                } else {
                    this.gl.generateMipmap(this.gl.TEXTURE_2D);
                    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MIN_FILTER, this.gl.LINEAR_MIPMAP_LINEAR);
                    this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_MAG_FILTER, this.gl.LINEAR);
                    if (this.anisotropicExtension) this.gl.texParameterf(this.gl.TEXTURE_2D, this.anisotropicExtension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(this.maxAnisotropy, 8));
                }
                this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, this.gl.CLAMP_TO_EDGE);
                this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, this.gl.CLAMP_TO_EDGE);
                var id = this.nextTextureId++;
                this.textures.set(id, {
                    id: id,
                    texture: texture
                });
                return {
                    id: id,
                    destroy: function() {
                        return _this.destroyTexture(id);
                    }
                };
            }
        },
        {
            key: "destroyTexture",
            value: function destroyTexture(id) {
                var texture = this.textures.get(id);
                if (texture) {
                    this.gl.deleteTexture(texture.texture);
                    this.textures.delete(id);
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this_multisampleFramebuffer;
                this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, (_this_multisampleFramebuffer = this.multisampleFramebuffer) !== null && _this_multisampleFramebuffer !== void 0 ? _this_multisampleFramebuffer : null);
                this.gl.clearColor(0, 0, 0, 0);
                this.gl.clear(this.gl.COLOR_BUFFER_BIT);
            }
        },
        {
            key: "draw",
            value: function draw(mesh, texture) {
                var meshData = this.meshes.get(mesh.id);
                var textureData = this.textures.get(texture.id);
                if (!meshData || !textureData) throw new Error('Invalid mesh or texture');
                var _this_multisampleFramebuffer;
                // null -> directly onto the canvas
                this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, (_this_multisampleFramebuffer = this.multisampleFramebuffer) !== null && _this_multisampleFramebuffer !== void 0 ? _this_multisampleFramebuffer : null);
                this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
                this.gl.useProgram(this.program);
                this.gl.bindVertexArray(meshData.vao);
                this.gl.activeTexture(this.gl.TEXTURE0);
                this.gl.bindTexture(this.gl.TEXTURE_2D, textureData.texture);
                this.gl.uniform1i(this.textureLocation, 0);
                this.gl.drawElements(this.gl.TRIANGLES, meshData.indexCount, this.gl.UNSIGNED_SHORT, 0);
            }
        },
        {
            key: "present",
            value: function present() {
                if (!this.multisampleFramebuffer) // pixelated: already drew directly to canvas
                return;
                // Resolve the multisample FBO to the canvas by blitting.
                var gl = this.gl;
                var w = this.canvas.width;
                var h = this.canvas.height;
                gl.bindFramebuffer(gl.READ_FRAMEBUFFER, this.multisampleFramebuffer);
                gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null); // canvas
                gl.blitFramebuffer(0, 0, w, h, 0, 0, w, h, gl.COLOR_BUFFER_BIT, gl.NEAREST);
                gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            }
        },
        {
            key: "getCanvas",
            value: function getCanvas() {
                return this.canvas;
            }
        },
        {
            key: "isContextLost",
            value: function isContextLost() {
                // Yes, every browser supports this for WebGL2RenderingContext.
                return this.gl.isContextLost();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.meshes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $8N5YG._)(_step.value, 1), id = _step_value[0];
                        this.destroyMesh(id);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = this.textures[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value1 = (0, $8N5YG._)(_step1.value, 1), id1 = _step_value1[0];
                        this.destroyTexture(id1);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (this.multisampleFramebuffer) {
                    this.gl.deleteFramebuffer(this.multisampleFramebuffer);
                    this.multisampleFramebuffer = null;
                }
                if (this.multisampleRenderbuffer) {
                    this.gl.deleteRenderbuffer(this.multisampleRenderbuffer);
                    this.multisampleRenderbuffer = null;
                }
                if (this.program) this.gl.deleteProgram(this.program);
                (0, $eWjiX.BB).freeCanvas(this.canvas);
            }
        }
    ]);
    return GpuCompositeCanvas;
}();


function $79d09d3423439479$var$getAlgorithmIconDataUrl() {
    var canvas = (0, $eelgW.createCanvas)(3, 3);
    var ctx = (0, $eWjiX.BB).ctx(canvas);
    ctx.fillRect(0, 0, 1, 1);
    ctx.fillRect(2, 0, 1, 1);
    ctx.fillRect(1, 1, 1, 1);
    ctx.fillRect(0, 2, 1, 1);
    ctx.fillRect(2, 2, 1, 1);
    return canvas.toDataURL('image/png');
}
var $79d09d3423439479$export$b3e6ed306341f794 = /*#__PURE__*/ function() {
    "use strict";
    function SelectUi(p) {
        var _this = this;
        (0, $cx0mh._)(this, SelectUi);
        this.isVisible = true;
        this.hasSelection = false;
        this.onChangeMode = p.onChangeMode;
        this.modeOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'select',
                    label: (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('', [
                        (0, $075b9fd415bad4ff$export$db3b6bfb95261072)({
                            content: "<img class='dark-invert' src='" + (0, (/*@__PURE__*/$parcel$interopDefault($3e01e916c4e53185$exports))) + "' height='20'/>" + '<span>' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-select') + '</span>',
                            css: {
                                display: 'flex',
                                gap: '5px',
                                alignItems: 'center',
                                height: '100%',
                                margin: '10px 4px',
                                justifyContent: 'center'
                            }
                        })
                    ])
                },
                {
                    id: 'transform',
                    label: (0, $075b9fd415bad4ff$export$db3b6bfb95261072)('', [
                        (0, $075b9fd415bad4ff$export$db3b6bfb95261072)({
                            content: "<img class='dark-invert' src='" + (0, (/*@__PURE__*/$parcel$interopDefault($6dae220a5b70a5f8$exports))) + "' height='20'/>" + '<span>' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-transform') + '</span>',
                            css: {
                                display: 'flex',
                                gap: '5px',
                                alignItems: 'center',
                                height: '100%',
                                margin: '10px 4px',
                                justifyContent: 'center'
                            }
                        })
                    ])
                }
            ],
            initId: 'select',
            onChange: function(val) {
                if (val === 'select') _this.operationOptions.setValue('new');
                updateMode();
            },
            onBeforeChange: function(val) {
                // change to "transform" can be rejected if selection is empty
                return _this.onChangeMode(val);
            },
            optionCss: {
                flexGrow: '1',
                flexBasis: '0'
            },
            css: {
                marginBottom: '10px'
            }
        });
        // --- select ---
        var selectModeEl = (0, $eWjiX.BB).el();
        var defaultIm = new Image();
        defaultIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($2c33980c55e55d8e$exports)));
        defaultIm.classList.add('dark-invert');
        var unionIm = new Image();
        unionIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($f4416a3e89ce50bf$exports)));
        unionIm.classList.add('dark-invert');
        var subtractIm = new Image();
        subtractIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($4ab563d9dade83ab$exports)));
        subtractIm.classList.add('dark-invert');
        this.operationOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'new',
                    label: defaultIm,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-boolean-replace')
                },
                {
                    id: 'union',
                    label: unionIm,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-boolean-add')
                },
                {
                    id: 'difference',
                    label: subtractIm,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-boolean-subtract')
                }
            ],
            initId: 'new',
            onChange: function(v) {
                p.onChangeBooleanOperation(v);
            },
            css: {
                marginBottom: '10px'
            }
        });
        var imStyle = {
            width: '32px',
            height: '32px'
        };
        var rectIm = new Image();
        rectIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($94fd3ca351798f15$exports)));
        rectIm.classList.add('dark-invert');
        (0, $7jh4K.css)(rectIm, imStyle);
        var ellipseIm = new Image();
        ellipseIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($115673c0650a4220$exports)));
        ellipseIm.classList.add('dark-invert');
        (0, $7jh4K.css)(ellipseIm, imStyle);
        var lassoIm = new Image();
        lassoIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($2dfd245fd3bb9927$exports)));
        lassoIm.classList.add('dark-invert');
        (0, $7jh4K.css)(lassoIm, imStyle);
        var polyIm = new Image();
        polyIm.src = (0, (/*@__PURE__*/$parcel$interopDefault($d77fe25b1a559789$exports)));
        polyIm.classList.add('dark-invert');
        (0, $7jh4K.css)(polyIm, imStyle);
        var shapeOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'rect',
                    label: rectIm,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-rect')
                },
                {
                    id: 'ellipse',
                    label: ellipseIm,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('shape-ellipse')
                },
                {
                    id: 'lasso',
                    label: lassoIm,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-lasso')
                },
                {
                    id: 'poly',
                    label: polyIm,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-polygon')
                }
            ],
            initId: p.select.shape,
            onChange: function(val) {
                p.select.onChangeShape(val);
            },
            css: {
                marginBottom: '10px'
            }
        });
        selectModeEl.append(shapeOptions.getElement(), this.operationOptions.getElement());
        var actionRow = (0, $eWjiX.BB).el({
            parent: selectModeEl,
            css: {
                display: 'flex',
                gap: '5px',
                flexWrap: 'wrap'
            }
        });
        var selectAllBtn = (0, $eWjiX.BB).el({
            parent: actionRow,
            tagName: 'button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-all'),
            onClick: function() {
                p.select.onAll();
            },
            custom: {
                tabindex: '-1'
            },
            css: {
                minHeight: '30px'
            }
        });
        var selectInvertBtn = (0, $eWjiX.BB).el({
            parent: actionRow,
            tagName: 'button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-invert'),
            onClick: function() {
                p.select.onInvert();
            },
            custom: {
                tabindex: '-1'
            },
            css: {
                minHeight: '30px'
            }
        });
        this.selectResetBtn = (0, $eWjiX.BB).el({
            parent: actionRow,
            tagName: 'button',
            content: [
                (0, $72Jv0.createImage)({
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($720ba2c010612610$exports))),
                    alt: 'icon',
                    height: 20,
                    css: {
                        marginRight: '3px',
                        filter: 'invert(1)'
                    }
                }),
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-reset')
            ],
            className: 'kl-button kl-button-primary',
            css: {
                paddingRight: '8px',
                display: 'none'
            },
            onClick: function() {
                p.select.onReset();
            },
            custom: {
                tabindex: '-1'
            }
        });
        (0, $eWjiX.BB).el({
            className: 'grid-hr',
            parent: selectModeEl,
            css: {
                margin: '10px 0'
            }
        });
        var actionsWrapper = (0, $eWjiX.BB).el({
            parent: selectModeEl,
            css: {
                display: 'flex',
                gap: '5px'
            }
        });
        var eraseBtn = (0, $eWjiX.BB).el({
            parent: actionsWrapper,
            tagName: 'button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-erase'),
            onClick: function() {
                p.onErase();
            },
            custom: {
                tabindex: '-1'
            }
        });
        var fillBtn = (0, $eWjiX.BB).el({
            parent: actionsWrapper,
            tagName: 'button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-fill'),
            onClick: function() {
                p.onFill();
            },
            custom: {
                tabindex: '-1'
            }
        });
        // --- transform ---
        var transformModeEl = (0, $eWjiX.BB).el({
            css: {
                display: 'flex',
                flexDirection: 'column',
                gap: '10px'
            }
        });
        this.positionOutput = (0, $eWjiX.BB).el({
            css: {
                fontFamily: 'monospace',
                fontSize: '13px'
            }
        });
        transformModeEl.append(this.positionOutput);
        var transformFlipXBtn = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-transform-flip') + ' X',
            className: 'kl-button',
            onClick: function() {
                p.transform.onFlipX();
            },
            custom: {
                tabindex: '-1'
            }
        });
        var transformFlipYBtn = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-transform-flip') + ' Y',
            onClick: function() {
                p.transform.onFlipY();
            },
            custom: {
                tabindex: '-1'
            }
        });
        var rotateNegativeBtn = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: "-90\xb0",
            onClick: function() {
                p.transform.onRotateDeg(-90);
            },
            custom: {
                tabindex: '-1'
            }
        });
        var rotatePositiveBtn = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: "+90\xb0",
            onClick: function() {
                p.transform.onRotateDeg(90);
            },
            custom: {
                tabindex: '-1'
            }
        });
        var duplicateIcon = new (0, $eae820938baa028e$export$f04a61298a47a40f)({
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($ff6378202995f780$exports))),
            width: 20,
            height: 20,
            darkInvert: true
        });
        var transformDuplicateBtn = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: [
                duplicateIcon.getElement(),
                (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-transform-clone')
            ],
            onClick: function() {
                p.transform.onClone();
            },
            css: {
                display: 'flex',
                gap: '5px'
            },
            custom: {
                tabindex: '-1'
            }
        });
        var scaleDoubleBtn = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: '2&times;',
            onClick: function() {
                p.transform.onScale(2);
            },
            custom: {
                tabindex: '-1'
            }
        });
        var scaleHalfBtn = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: '&frac12;&times;',
            onClick: function() {
                p.transform.onScale(0.5);
            },
            custom: {
                tabindex: '-1'
            }
        });
        var centerBtn = (0, $eWjiX.BB).el({
            tagName: 'button',
            content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('center'),
            onClick: function() {
                p.transform.onCenter();
            },
            custom: {
                tabindex: '-1'
            }
        });
        (0, $eWjiX.BB).el({
            parent: transformModeEl,
            content: [
                transformDuplicateBtn,
                transformFlipXBtn,
                transformFlipYBtn,
                rotateNegativeBtn,
                rotatePositiveBtn,
                scaleDoubleBtn,
                scaleHalfBtn,
                centerBtn
            ],
            css: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: '5px'
            }
        });
        this.constrainCheckbox = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-transform-constrain'),
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('constrain-proportions'),
            callback: function callback(b) {
                p.transform.onChangeConstrain(b);
            },
            css: {
                display: 'inline-block'
            },
            name: 'constrain-proportions'
        });
        this.snappingCheckbox = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: true,
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-transform-snap'),
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-transform-snap-title'),
            callback: function callback(b) {
                p.transform.onChangeSnapping(b);
            },
            css: {
                display: 'inline-block',
                marginLeft: '10px'
            },
            name: 'enable-snapping'
        });
        this.warpCheckbox = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            init: false,
            isEnabled: (0, $a8df4ba70dfe7950$export$b9cf8e4fed0549e8)(),
            label: `<img src="${(0, (/*@__PURE__*/$parcel$interopDefault($f0b183c56b76aebb$exports)))}" class="dark-invert" height="23">` + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-transform-warp'),
            callback: function(b) {
                p.transform.onChangeWarp(b);
                // Disable constrain and snapping checkboxes when warping
                _this.constrainCheckbox.setEnabled(!b);
                _this.snappingCheckbox.setEnabled(!b);
            },
            css: {
                width: 'fit-content'
            },
            name: 'transform-warp'
        });
        transformModeEl.append(this.warpCheckbox.getElement());
        var checkboxWrapper = (0, $eWjiX.BB).el();
        checkboxWrapper.append(this.constrainCheckbox.getElement(), this.snappingCheckbox.getElement());
        transformModeEl.append(checkboxWrapper);
        var iconSmooth = new Image();
        iconSmooth.src = $79d09d3423439479$var$getAlgorithmIconDataUrl();
        iconSmooth.className = 'dark-invert';
        (0, $7jh4K.css)(iconSmooth, {
            width: '20px',
            height: '20px',
            margin: '4px'
        });
        var iconPixelated = new Image();
        iconPixelated.src = iconSmooth.src;
        iconPixelated.className = 'dark-invert';
        (0, $7jh4K.css)(iconPixelated, {
            width: '20px',
            height: '20px',
            margin: '4px',
            imageRendering: 'pixelated'
        });
        this.algorithmOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'smooth',
                    label: iconSmooth,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('algorithm-smooth')
                },
                {
                    id: 'pixelated',
                    label: iconPixelated,
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('algorithm-pixelated')
                }
            ],
            onChange: function(algorithm) {
                p.transform.onChangeAlgorithm(algorithm);
            }
        });
        transformModeEl.append(this.algorithmOptions.getElement());
        this.moveToLayerSelect = new (0, $7a3263857aacf58f$export$ef9b1a59e592288f)({
            optionArr: [
                [
                    '1',
                    'Layer 2'
                ],
                [
                    '0',
                    'Layer 1'
                ]
            ],
            onChange: function(val) {
                p.transform.onMoveToLayer(+val);
            },
            name: 'move-to-layer',
            css: {
                width: '100%'
            }
        });
        transformModeEl.append((0, $075b9fd415bad4ff$export$db3b6bfb95261072)(',flex,items-center,gap-5,flexWrap', [
            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-transform-move-to-layer'),
            this.moveToLayerSelect.getElement()
        ]));
        this.transparentBackgroundToggle = new (0, $365a915dfb503274$export$48513f6b9f8ce62d)({
            label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('brush-eraser-transparent-bg'),
            callback: function(b) {
                p.transform.onChangeTransparentBackground(b);
            },
            name: 'enable-transparent-background'
        });
        (0, $7jh4K.css)(this.transparentBackgroundToggle.getElement(), {
            display: 'inline-block'
        });
        transformModeEl.append(this.transparentBackgroundToggle.getElement());
        var updateMode = function() {
            if (_this.modeOptions.getValue() === 'select') {
                _this.rootEl.append(selectModeEl);
                transformModeEl.remove();
            } else {
                selectModeEl.remove();
                _this.rootEl.append(transformModeEl);
            }
        };
        this.rootEl = (0, $eWjiX.BB).el({
            content: [
                this.modeOptions.getElement()
            ],
            css: {
                margin: '10px'
            }
        });
        updateMode();
    }
    (0, $7h4XF._)(SelectUi, [
        {
            key: "update",
            value: function update() {
                this.selectResetBtn.style.display = this.hasSelection ? 'block' : 'none';
            }
        },
        {
            key: "setIsVisible",
            value: function setIsVisible(isVisible) {
                this.isVisible = isVisible;
                this.rootEl.style.display = this.isVisible ? 'block' : 'none';
                if (this.isVisible) this.operationOptions.setValue('new');
            }
        },
        {
            key: "setMode",
            value: function setMode(mode) {
                this.modeOptions.setValue(mode);
            }
        },
        {
            key: "setLayers",
            value: function setLayers(layers) {
                this.moveToLayerSelect.setOptionArr(layers.map(function(layer, index) {
                    return [
                        '' + index,
                        layer
                    ];
                }).reverse());
            }
        },
        {
            key: "setMoveToLayer",
            value: function setMoveToLayer(targetIndex) {
                this.moveToLayerSelect.setValue(targetIndex === undefined ? undefined : '' + targetIndex);
            }
        },
        {
            key: "setHasSelection",
            value: function setHasSelection(b) {
                this.hasSelection = b;
                this.update();
            }
        },
        {
            key: "setBackgroundIsTransparent",
            value: function setBackgroundIsTransparent(b) {
                this.transparentBackgroundToggle.setValue(b);
            }
        },
        {
            key: "setAlgorithm",
            value: function setAlgorithm(algorithm) {
                this.algorithmOptions.setValue(algorithm);
            }
        },
        {
            key: "setFreeTransformTransformation",
            value: function setFreeTransformTransformation(transform) {
                var x = (0, $eWjiX.BB).round(transform.x, 0);
                var y = (0, $eWjiX.BB).round(transform.y, 0);
                var rotation = (0, $eWjiX.BB).round(transform.angleDeg, 0);
                this.positionOutput.innerText = `X:${x} Y:${y} ${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('filter-transform-rotation')}:${rotation}\xb0`;
            }
        },
        {
            key: "setShowTransparentBackgroundToggle",
            value: function setShowTransparentBackgroundToggle(show) {
                this.transparentBackgroundToggle.getElement().style.display = show ? 'block' : 'none';
            }
        },
        {
            key: "setIsWarping",
            value: function setIsWarping(isWarping) {
                this.warpCheckbox.setValue(isWarping);
                this.constrainCheckbox.setEnabled(!isWarping);
                this.snappingCheckbox.setEnabled(!isWarping);
            }
        },
        {
            key: "getIsWarping",
            value: function getIsWarping() {
                return this.warpCheckbox.getValue();
            }
        },
        {
            key: "getAlgorithm",
            value: function getAlgorithm() {
                return this.algorithmOptions.getValue();
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
            // ...
            }
        }
    ]);
    return SelectUi;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $4EWN2 = parcelRequire("4EWN2");

var $eWjiX = parcelRequire("eWjiX");

parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
var $kDVZW = parcelRequire("kDVZW");

parcelRequire("ciAU9");
var $cdZRx = parcelRequire("cdZRx");
function $83a803f69a410aa3$export$eca13ebc72c99beb(rect, viewportTransform, easelSize) {
    var padding = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var rectCenterX = rect.x + rect.width / 2;
    var rectCenterY = rect.y + rect.height / 2;
    // compute AABB of the rotated rect in viewport space
    var angleRad = viewportTransform.angleDeg / 180 * Math.PI;
    var cos = Math.abs(Math.cos(angleRad));
    var sin = Math.abs(Math.sin(angleRad));
    var aabbWidth = (rect.width * cos + rect.height * sin) * viewportTransform.scale;
    var aabbHeight = (rect.width * sin + rect.height * cos) * viewportTransform.scale;
    var matrix = (0, $92816524e1b72be4$export$ad1d215dd03fe75a)(viewportTransform);
    var centerInViewport = (0, $cdZRx.applyToPoint)(matrix, {
        x: rectCenterX,
        y: rectCenterY
    });
    var halfW = aabbWidth / 2;
    var halfH = aabbHeight / 2;
    return centerInViewport.x - halfW >= padding && centerInViewport.x + halfW <= easelSize.width - padding && centerInViewport.y - halfH >= padding && centerInViewport.y + halfH <= easelSize.height - padding;
}




var $9b3eo = parcelRequire("9b3eo");

var $gCzYB = parcelRequire("gCzYB");

var $c1lmK = parcelRequire("c1lmK");




var $3d292a495f65a250$var$FFD_DEBUG = false;
var $3d292a495f65a250$var$operationToCursor = {
    new: 'default',
    union: 'copy',
    difference: 'alias'
};
var $3d292a495f65a250$export$24961ed376c522a3 = /*#__PURE__*/ function() {
    "use strict";
    function EaselSelect(p) {
        var _this = this;
        (0, $cx0mh._)(this, EaselSelect);
        this.easel = {};
        this.viewportTransform = {};
        this.tempCtx = (0, $eWjiX.BB).ctx((0, $eWjiX.BB).canvas(1, 1)) // used for isPointInPath()
        ;
        // state
        this.canvasSelection = [];
        this.selectionPath = (0, $9b3eo.getSelectionPath2d)([]);
        this.mode = 'select';
        this.isDragging = false;
        // select-mode state
        this.selectSelectMode = 'select';
        this.didSelectionMove = false;
        this.defaultBooleanOperation = 'new' // set by the UI
        ;
        this.selectShape = 'rect';
        this.polyShape = [];
        this.freeTransformIsConstrained = true;
        this.freeTransformIsSnapping = true;
        // ----------------------------------- public -----------------------------------
        this.doubleTapPointerTypes = [
            'touch'
        ];
        this.blockTrigger = 'alt';
        this.mode = p.selectMode;
        this.onStartSelect = p.onStartSelect;
        this.onGoSelect = p.onGoSelect;
        this.onEndSelect = p.onEndSelect;
        this.onStartMoveSelect = p.onStartMoveSelect;
        this.onGoMoveSelect = p.onGoMoveSelect;
        this.onEndMoveSelect = p.onEndMoveSelect;
        this.onSelectAddPoly = p.onSelectAddPoly;
        this.onResetSelection = p.onResetSelection;
        this.onTransform = p.onTransform;
        this.onTransformEnd = p.onTransformEnd;
        this.cornerPanning = new (0, $201034f69477f047$export$4deed4c512c630c2)({
            getEaselSize: function() {
                return _this.easel.getSize();
            },
            getTransform: function() {
                return _this.easel.getTargetTransform();
            },
            setTransform: function(transform) {
                return _this.easel.setTransform(transform, true);
            },
            testCanPan: function(buttonIsPressed) {
                return (buttonIsPressed || _this.polyShape.length > 1) && !(_this.selectShape === 'lasso' && _this.selectSelectMode === 'select');
            },
            onRepeatEvent: function(e) {
                if (_this.mode === 'select') _this.selectOnPointer(e);
                else _this.transformOnPointer(e);
            }
        });
        this.pointerChain = new (0, $gCzYB.EventChain)({
            chainArr: [
                new (0, $c1lmK.DoubleTapper)({
                    onDoubleTap: function(e) {
                        if (_this.polyShape.length < 3) return;
                        var shape = _this.polyShape.map(function(item) {
                            return {
                                x: item.x,
                                y: item.y
                            };
                        });
                        _this.resetPolyShape();
                        if (shape.length > 1) {
                            shape.push((0, $cL71g._)({}, shape[0]));
                            p.onSelectAddPoly(shape, _this.appliedBooleanOperation);
                        }
                    },
                    isInstant: true
                })
            ]
        });
        this.svgEl = (0, $eWjiX.BB).createSvg({
            elementType: 'g'
        });
        this.htmlEl = (0, $eWjiX.BB).el();
    }
    (0, $7h4XF._)(EaselSelect, [
        {
            key: "viewportToCanvas",
            value: function viewportToCanvas(p) {
                var matrix = (0, $kDVZW.inverse)((0, $92816524e1b72be4$export$ad1d215dd03fe75a)(this.easel.getTransform()));
                return (0, $cdZRx.applyToPoint)(matrix, p);
            }
        },
        {
            key: "updateSelectionPath",
            value: function updateSelectionPath() {
                this.selectionPath = (0, $9b3eo.getSelectionPath2d)(this.canvasSelection);
            }
        },
        {
            key: "resetPolyShape",
            value: function resetPolyShape() {
                if (this.polyShape.length === 0) return false;
                this.polyShape = [];
                this.doubleTapPointerTypes = [
                    'touch'
                ];
                this.easel.updateDoubleTapPointerTypes();
                this.easel.requestRender(); // because polyShape might have changed
                return true;
            }
        },
        {
            key: "getEffectiveBooleanOperation",
            value: /** boolean operation if you also consider keys */ function getEffectiveBooleanOperation() {
                var isSubtract = this.defaultBooleanOperation === 'new' ? this.easel.keyListener.isPressed('alt') : this.defaultBooleanOperation === 'difference';
                var isAdd = this.defaultBooleanOperation === 'new' ? this.easel.keyListener.isPressed('shift') : this.defaultBooleanOperation === 'union';
                if (isSubtract) return 'difference';
                if (isAdd) return 'union';
                return 'new';
            }
        },
        {
            key: "getDoMoveSelection",
            value: function getDoMoveSelection(effectiveOperation, cursorCanvasPos) {
                var isOverSelection = this.polyShape.length < 2 && this.selectionPath && this.tempCtx.isPointInPath(this.selectionPath, cursorCanvasPos.x, cursorCanvasPos.y);
                return effectiveOperation === 'new' && isOverSelection;
            }
        },
        {
            key: "selectOnPointer",
            value: // can be repeatedly called with the same event
            function selectOnPointer(event) {
                var effectiveOperation = this.getEffectiveBooleanOperation();
                var wasDragging = this.isDragging;
                var cursorCanvasPos = this.viewportToCanvas({
                    x: event.relX,
                    y: event.relY
                });
                var doMove = this.getDoMoveSelection(effectiveOperation, cursorCanvasPos);
                if (event.type === 'pointerdown') {
                    this.isDragging = true;
                    if (doMove) this.selectSelectMode = 'move';
                    else this.selectSelectMode = 'select';
                }
                if (event.type === 'pointerup') this.isDragging = false;
                if (this.selectSelectMode === 'move') {
                    if (event.type === 'pointerdown' && event.button === 'left') {
                        this.didSelectionMove = false;
                        this.onStartMoveSelect(cursorCanvasPos);
                    }
                    if (event.type === 'pointermove' && event.button === 'left') {
                        this.didSelectionMove = true;
                        this.onGoMoveSelect(cursorCanvasPos, this.easel.keyListener.isPressed('shift'));
                    }
                    if (event.type === 'pointerup') {
                        this.onEndMoveSelect();
                        if (!this.didSelectionMove) this.onResetSelection();
                    }
                } else // select
                if (this.selectShape === 'poly') {
                    if (event.type === 'pointermove') {
                        var _this_polyShape_;
                        if ((_this_polyShape_ = this.polyShape[this.polyShape.length - 1]) === null || _this_polyShape_ === void 0 ? void 0 : _this_polyShape_.temp) this.polyShape.pop();
                        this.polyShape.push((0, $4EWN2._)((0, $cL71g._)({}, cursorCanvasPos), {
                            temp: true
                        }));
                        this.easel.requestRender();
                    }
                    if (event.type === 'pointerup' && wasDragging) {
                        var _this_polyShape_1;
                        if (this.polyShape.length < 2) this.appliedBooleanOperation = effectiveOperation;
                        this.doubleTapPointerTypes = [];
                        this.easel.updateDoubleTapPointerTypes();
                        if ((_this_polyShape_1 = this.polyShape[this.polyShape.length - 1]) === null || _this_polyShape_1 === void 0 ? void 0 : _this_polyShape_1.temp) this.polyShape.pop();
                        var lastPolyShapePoint = this.polyShape[this.polyShape.length - 1];
                        if (!lastPolyShapePoint || cursorCanvasPos.x !== lastPolyShapePoint.x || cursorCanvasPos.y !== lastPolyShapePoint.y) {
                            this.polyShape.push(cursorCanvasPos);
                            this.easel.requestRender();
                        }
                        var first = this.polyShape[0];
                        var last = this.polyShape[this.polyShape.length - 1];
                        if (this.polyShape.length > 2 && (0, $eWjiX.BB).dist(first.x, first.y, last.x, last.y) * this.viewportTransform.scale < 4) {
                            this.polyShape.pop();
                            this.polyShape.push((0, $cL71g._)({}, this.polyShape[0]));
                            var shape = this.polyShape;
                            this.polyShape = [];
                            this.onSelectAddPoly(shape, this.appliedBooleanOperation);
                            this.appliedBooleanOperation = undefined;
                        }
                    }
                } else {
                    if (event.type === 'pointerdown' && event.button === 'left') {
                        this.appliedBooleanOperation = effectiveOperation;
                        this.onStartSelect(cursorCanvasPos, this.appliedBooleanOperation);
                    }
                    if (event.type === 'pointermove' && event.button === 'left' && this.isDragging) this.onGoSelect(cursorCanvasPos, this.easel.keyListener.isPressed('shift'));
                    if (event.type === 'pointerup' && wasDragging) {
                        this.onEndSelect();
                        this.appliedBooleanOperation = undefined;
                    }
                }
                if (!event.button) {
                    if (doMove) this.selectSelectMode = 'move';
                    else this.selectSelectMode = 'select';
                }
                var _this_appliedBooleanOperation;
                if (this.selectSelectMode === 'move') this.easel.setCursor('move');
                else this.easel.setCursor($3d292a495f65a250$var$operationToCursor[(_this_appliedBooleanOperation = this.appliedBooleanOperation) !== null && _this_appliedBooleanOperation !== void 0 ? _this_appliedBooleanOperation : effectiveOperation]);
            }
        },
        {
            key: "transformOnPointer",
            value: // can be repeatedly called with the same event
            function transformOnPointer(event) {
                if (!this.transformation || this.transformation.type !== 'ffd' || !this.ffdMesh) {
                    this.easel.setCursor('default');
                    // handled via this.freeTransform
                    return;
                }
                // warping
                var cursorCanvasPos = this.viewportToCanvas({
                    x: event.relX,
                    y: event.relY
                });
                var parametricCoordinate = (0, $abad715f10469dbf$export$2d232ae0b526c96b)(cursorCanvasPos.x, cursorCanvasPos.y, this.ffdMesh);
                if (event.type === 'pointerdown' && event.button === 'left') {
                    if (parametricCoordinate) {
                        this.warpStart = {
                            parametricCoordinate: parametricCoordinate,
                            lattice: this.transformation.ffd
                        };
                        this.easel.setCursor('move');
                    }
                }
                if (event.type === 'pointermove' && this.warpStart) {
                    // Apply warp
                    this.transformation.ffd = (0, $abad715f10469dbf$export$fd7a293c27db611b)(this.warpStart.parametricCoordinate, cursorCanvasPos, this.warpStart.lattice);
                    var _this_easel_getProjectSize = this.easel.getProjectSize(), width = _this_easel_getProjectSize.width, height = _this_easel_getProjectSize.height;
                    this.ffdMesh = (0, $abad715f10469dbf$export$d6a0409d5640315a)((0, $c3d05422ca86fac7$export$6ba60dd123964f3e), (0, $c3d05422ca86fac7$export$6ba60dd123964f3e), this.transformation.ffd, width, height, true);
                    this.updateLatticePath();
                    this.easel.requestRender();
                    this.onTransform(this.transformation);
                }
                if (event.type === 'pointerup') {
                    if (this.warpStart) this.onTransformEnd();
                    this.warpStart = undefined;
                }
                if (!this.warpStart) // Update cursor if not already dragging
                this.easel.setCursor(parametricCoordinate ? 'move' : 'default');
            }
        },
        {
            key: "onPointerChainOut",
            value: function onPointerChainOut(event) {
                if (this.mode === 'select') {
                    this.cornerPanning.onPointer(event);
                    this.selectOnPointer(event);
                } else this.transformOnPointer(event);
            }
        },
        {
            key: "createFreeTransform",
            value: function createFreeTransform() {
                var _this = this;
                var isFirstCallback = true;
                this.freeTransform = new (0, $0370167ee97a20d9$export$79a74567acf241b0)({
                    x: 1,
                    y: 1,
                    width: 1,
                    height: 1,
                    angleDeg: 0,
                    isConstrained: this.freeTransformIsConstrained,
                    snapX: [],
                    snapY: [],
                    viewportTransform: {
                        scale: 1,
                        x: 0,
                        y: 0,
                        angleDeg: 0
                    },
                    callback: function(transform) {
                        if (isFirstCallback) {
                            isFirstCallback = false;
                            return;
                        }
                        if (_this.mode === 'select' || !_this.transformation || !(_this.transformation.type === 'free' || _this.transformation.type === 'ffd+free')) return;
                        if (isNaN(transform.x) || isNaN(transform.y) || isNaN(transform.width) || isNaN(transform.height)) //can be provoked by repeatedly x0.5, then dragging a corner
                        return;
                        _this.onTransform((0, $4EWN2._)((0, $cL71g._)({}, _this.transformation), {
                            freeTransform: transform
                        }));
                        // avoid spamming undo steps
                        if (_this.freeTransformTimeout) clearTimeout(_this.freeTransformTimeout);
                        _this.freeTransformTimeout = setTimeout(function() {
                            return _this.onTransformEnd();
                        }, 250);
                    },
                    onWheel: this.easel.onWheel,
                    wheelParent: this.easel.getElement()
                });
                this.freeTransform.setSnapping(this.freeTransformIsSnapping);
                this.htmlEl.append(this.freeTransform.getElement());
                this.freeTransform.setViewportTransform(this.viewportTransform);
            }
        },
        {
            key: "destroyFreeTransform",
            value: function destroyFreeTransform() {
                var _this_freeTransform, _this_freeTransform1;
                (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.getElement().remove();
                (_this_freeTransform1 = this.freeTransform) === null || _this_freeTransform1 === void 0 ? void 0 : _this_freeTransform1.destroy();
                this.freeTransform = undefined;
            }
        },
        {
            key: "updateFreeTransformVisibility",
            value: function updateFreeTransformVisibility() {
                var _this_transformation, _this_freeTransform;
                (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.getElement().style.setProperty('display', ((_this_transformation = this.transformation) === null || _this_transformation === void 0 ? void 0 : _this_transformation.type) === 'ffd' ? 'none' : '');
            }
        },
        {
            key: "updateLatticePath",
            value: function updateLatticePath() {
                if (!this.transformation || this.transformation.type !== 'ffd') {
                    this.latticePath = undefined;
                    return;
                }
                var lattice = this.transformation.ffd;
                var sampleCount = (0, $c3d05422ca86fac7$export$6ba60dd123964f3e);
                var path = new Path2D();
                function addPolyline(path, points) {
                    path.moveTo(points[0].x, points[0].y);
                    for(var i = 1; i < points.length; i++)path.lineTo(points[i].x, points[i].y);
                }
                // horizontal lines
                for(var i = 0; i < lattice.rows; i++){
                    var t = i / (lattice.rows - 1);
                    var pts = [];
                    for(var e = 0; e <= sampleCount; e++)pts.push((0, $abad715f10469dbf$export$24b0a92fce6b8497)(e / sampleCount, t, lattice));
                    addPolyline(path, pts);
                }
                // vertical lines
                for(var i1 = 0; i1 < lattice.cols; i1++){
                    var s = i1 / (lattice.cols - 1);
                    var pts1 = [];
                    for(var e1 = 0; e1 <= sampleCount; e1++)pts1.push((0, $abad715f10469dbf$export$24b0a92fce6b8497)(s, e1 / sampleCount, lattice));
                    addPolyline(path, pts1);
                }
                this.latticePath = path;
            }
        },
        {
            key: "renderLattice",
            value: function renderLattice(ctx, scale) {
                var _this_transformation;
                if (!this.latticePath) return;
                ctx.save();
                ctx.lineWidth = 1 / scale;
                // globalCompositeOperation = 'difference' is slow in firefox,
                // and it doesn't look all that nice in any browser.
                ctx.strokeStyle = 'rgb(128, 128, 128)';
                ctx.stroke(this.latticePath);
                if ($3d292a495f65a250$var$FFD_DEBUG && ((_this_transformation = this.transformation) === null || _this_transformation === void 0 ? void 0 : _this_transformation.type) === 'ffd') {
                    var lattice = this.transformation.ffd;
                    for(var i = 0; i < lattice.rows; i++)for(var j = 0; j < lattice.cols; j++){
                        var cp = lattice.controlPoints[i][j];
                        ctx.beginPath();
                        ctx.arc(cp.x, cp.y, 4 / scale, 0, Math.PI * 2);
                        ctx.fillStyle = 'rgba(255, 100, 100, 0.8)';
                        ctx.fill();
                        ctx.strokeStyle = 'rgba(255, 255, 255, 0.6)';
                        ctx.lineWidth = 1.5 / scale;
                        ctx.stroke();
                    }
                }
                ctx.restore();
            }
        },
        {
            key: "getSvgElement",
            value: function getSvgElement() {
                return this.svgEl;
            }
        },
        {
            key: "getHtmlOverlayElement",
            value: function getHtmlOverlayElement() {
                return this.htmlEl;
            }
        },
        {
            key: "onPointer",
            value: function onPointer(event) {
                this.onPointerChainOut(event);
                this.pointerChain.chainIn(event);
            }
        },
        {
            key: "setEaselInterface",
            value: function setEaselInterface(easelInterface) {
                this.easel = easelInterface;
                this.viewportTransform = this.easel.getTransform();
            }
        },
        {
            key: "setMode",
            value: function setMode(mode) {
                this.mode = mode;
                this.resetPolyShape();
                if (this.mode === 'transform') this.createFreeTransform();
                else {
                    this.ffdMesh = undefined;
                    this.destroyFreeTransform();
                }
            }
        },
        {
            key: "onTool",
            value: function onTool(toolId) {
                if (toolId === 'select') this.htmlEl.style.display = 'block';
                else this.htmlEl.style.display = 'none';
            }
        },
        {
            key: "activate",
            value: function activate(cursorPos, poppedTemp) {
                if (cursorPos && this.transformation && this.ffdMesh) {
                    var cursorCanvasPos = this.viewportToCanvas(cursorPos);
                    var param = (0, $abad715f10469dbf$export$2d232ae0b526c96b)(cursorCanvasPos.x, cursorCanvasPos.y, this.ffdMesh);
                    this.easel.setCursor(param ? 'move' : 'default');
                } else this.easel.setCursor('default');
                this.isDragging = false;
                this.onUpdateTransform(this.easel.getTransform());
                if (!poppedTemp) this.resetPolyShape();
            }
        },
        {
            key: "onUpdateTransform",
            value: function onUpdateTransform(transform) {
                var _this_freeTransform;
                this.viewportTransform = transform;
                this.updateSelectionPath();
                (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.setViewportTransform(transform);
            }
        },
        {
            key: "onUpdateSelection",
            value: function onUpdateSelection(selection) {
                this.canvasSelection = selection || [];
                this.updateSelectionPath();
            }
        },
        {
            key: "setRenderedSelection",
            value: function setRenderedSelection(selection) {
                this.selection = selection;
                this.easel.setRenderedSelection(selection);
            }
        },
        {
            key: "bringTransformRectIntoView",
            value: function bringTransformRectIntoView(freeTransform) {
                var viewportTransform = this.easel.getTransform();
                var easelSize = this.easel.getSize();
                var padding = 40;
                var rect = {
                    x: freeTransform.x - freeTransform.width / 2,
                    y: freeTransform.y - freeTransform.height / 2,
                    width: freeTransform.width,
                    height: freeTransform.height
                };
                if ((0, $83a803f69a410aa3$export$eca13ebc72c99beb)(rect, viewportTransform, easelSize, 0)) return;
                this.easel.setTransform((0, $b12878515d74b1ca$export$29dc1c77cb35d1c5)(rect, viewportTransform, easelSize, false, padding));
            }
        },
        {
            key: "initialiseTransform",
            value: function initialiseTransform(transform) {
                var _this_freeTransform, _this_freeTransform1;
                transform = (0, $eWjiX.BB).copyObj(transform);
                if (transform.type !== 'free') throw new Error('must call initialiseTransform with transform.type = "free"');
                this.transformation = transform;
                (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.initialise(transform.freeTransform);
                var _this_easel_getProjectSize = this.easel.getProjectSize(), width = _this_easel_getProjectSize.width, height = _this_easel_getProjectSize.height;
                (_this_freeTransform1 = this.freeTransform) === null || _this_freeTransform1 === void 0 ? void 0 : _this_freeTransform1.setSnappingPoints([
                    0,
                    width
                ], [
                    0,
                    height
                ]);
                this.bringTransformRectIntoView(transform.freeTransform);
            }
        },
        {
            key: "setTransform",
            value: function setTransform(transform) {
                transform = (0, $eWjiX.BB).copyObj(transform);
                this.transformation = transform;
                if (transform.type === 'ffd') {
                    var _this_easel_getProjectSize = this.easel.getProjectSize(), width = _this_easel_getProjectSize.width, height = _this_easel_getProjectSize.height;
                    this.ffdMesh = (0, $abad715f10469dbf$export$d6a0409d5640315a)((0, $c3d05422ca86fac7$export$6ba60dd123964f3e), (0, $c3d05422ca86fac7$export$6ba60dd123964f3e), transform.ffd, width, height, true);
                    this.easel.requestRender();
                } else {
                    var _this_freeTransform;
                    (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.initialise(transform.freeTransform);
                    this.ffdMesh = undefined;
                }
                this.updateLatticePath();
                this.updateFreeTransformVisibility();
            }
        },
        {
            key: "clearRenderedSelection",
            value: function clearRenderedSelection(isImmediate) {
                this.easel.clearRenderedSelection(isImmediate);
            }
        },
        {
            key: "setBooleanOperation",
            value: function setBooleanOperation(operation) {
                this.defaultBooleanOperation = operation;
            }
        },
        {
            key: "setSelectShape",
            value: function setSelectShape(shape) {
                this.resetPolyShape();
                this.selectShape = shape;
            }
        },
        {
            key: "getIsLocked",
            value: function getIsLocked() {
                return this.isDragging;
            }
        },
        {
            key: "renderAfterViewport",
            value: function renderAfterViewport(ctx, transform) {
                var _this_transformation;
                if (this.mode === 'transform' && ((_this_transformation = this.transformation) === null || _this_transformation === void 0 ? void 0 : _this_transformation.type) === 'ffd') {
                    ctx.save();
                    this.renderLattice(ctx, transform.scaleX);
                    ctx.restore();
                }
                if (this.polyShape.length < 2) return;
                ctx.save();
                ctx.globalCompositeOperation = 'difference';
                ctx.beginPath();
                var shape = this.polyShape;
                ctx.moveTo(shape[0].x, shape[0].y);
                for(var i = 1; i < shape.length; i++)ctx.lineTo(shape[i].x, shape[i].y);
                ctx.lineWidth = 1 / transform.scaleX;
                ctx.strokeStyle = 'white';
                ctx.lineCap = 'round';
                ctx.lineJoin = 'round';
                ctx.stroke();
                ctx.restore();
            }
        },
        {
            key: "onKeyDown",
            value: function onKeyDown(keyStr, e) {
                if (keyStr === 'esc') {
                    if (this.resetPolyShape()) e.preventDefault();
                }
            }
        },
        {
            key: "onClickOutside",
            value: function onClickOutside() {
                this.resetPolyShape();
            }
        },
        {
            key: "onBlur",
            value: function onBlur() {
                this.resetPolyShape();
            }
        },
        {
            key: "onArrowKeys",
            value: function onArrowKeys(direction) {
                if (!this.freeTransform) return false;
                var movementMap = {
                    left: {
                        x: -1,
                        y: 0
                    },
                    right: {
                        x: 1,
                        y: 0
                    },
                    up: {
                        x: 0,
                        y: -1
                    },
                    down: {
                        x: 0,
                        y: 1
                    }
                };
                var multiplier = this.easel.isKeyPressed('shift') ? 5 : 1;
                var movement = movementMap[direction];
                this.freeTransform.move(movement.x * multiplier, movement.y * multiplier);
                return true;
            }
        },
        {
            key: "setIsConstrained",
            value: function setIsConstrained(isConstrained) {
                var _this_freeTransform;
                this.freeTransformIsConstrained = isConstrained;
                (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.setIsConstrained(isConstrained);
            }
        },
        {
            key: "setIsSnapping",
            value: function setIsSnapping(isSnapping) {
                var _this_freeTransform;
                this.freeTransformIsSnapping = isSnapping;
                (_this_freeTransform = this.freeTransform) === null || _this_freeTransform === void 0 ? void 0 : _this_freeTransform.setSnapping(isSnapping);
            }
        }
    ]);
    return EaselSelect;
}();



var $7jh4K = parcelRequire("7jh4K");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $8N5YG = parcelRequire("8N5YG");

function $87b240a7315255f9$export$1b1b9d54d324857f(cx, cy, rx, ry, steps) {
    var result = [];
    var d = 2 * Math.PI / steps;
    for(var i = 0; i < 2 * Math.PI; i += d)result.push([
        Math.cos(i) * rx + cx,
        Math.sin(i) * ry + cy
    ]);
    return [
        result
    ];
}



var $eWjiX = parcelRequire("eWjiX");

var $29bdc5a628b41259$export$6f71e8a0179bd005 = 2;
function $29bdc5a628b41259$export$1f0b3b9c2ff2269f(num) {
    return parseFloat(num.toFixed($29bdc5a628b41259$export$6f71e8a0179bd005));
}
function $29bdc5a628b41259$export$9ff2e12a5746572e(poly) {
    return poly.map(function(ring) {
        return ring.map(function(param) {
            var _param = (0, $8N5YG._)(param, 2), x = _param[0], y = _param[1];
            return [
                $29bdc5a628b41259$export$1f0b3b9c2ff2269f(x),
                $29bdc5a628b41259$export$1f0b3b9c2ff2269f(y)
            ];
        });
    });
}
var $29bdc5a628b41259$export$53d9e71218013355 = /*#__PURE__*/ function() {
    "use strict";
    function SelectTool(p) {
        (0, $cx0mh._)(this, SelectTool);
        this.shape = 'rect';
        this.selectOperation = 'new';
        this.selectDragInputs = [];
        this.didMove = false // was selection moved
        ;
        this.klCanvas = p.klCanvas;
    }
    (0, $7h4XF._)(SelectTool, [
        {
            key: "reset",
            value: function reset() {
                this.selection = undefined;
            }
        },
        {
            key: "combineSelection",
            value: function combineSelection(polygon) {
                var _this_selection;
                var result = (_this_selection = this.selection) !== null && _this_selection !== void 0 ? _this_selection : [];
                if (this.selectOperation === 'new') result = [
                    polygon
                ];
                else {
                    if (this.selection && this.selection.length > 0) {
                        var operation = this.selectOperation === 'difference' ? 'difference' : 'union';
                        result = (0, $0b0ef140191bcf10$export$7ec1a3fdd6e82838)(operation, this.selection, polygon);
                    } else if (this.selectOperation === 'union') result = [
                        polygon
                    ];
                }
                return result;
            }
        },
        {
            /** current state of selection */ key: "getSelection",
            value: function getSelection() {
                // combine selections
                var selection = this.selection || [];
                if (this.selectDragInputs.length > 1) {
                    // currently inputting
                    var operation = this.selectOperation === 'difference' ? 'difference' : 'union';
                    if (this.shape === 'rect') {
                        var first = this.selectDragInputs[0];
                        var last = this.selectDragInputs[this.selectDragInputs.length - 1];
                        // floor and ceil already limit precision
                        var minX = Math.floor(Math.min(first.x, last.x));
                        var minY = Math.floor(Math.min(first.y, last.y));
                        var maxX = Math.ceil(Math.max(first.x, last.x));
                        var maxY = Math.ceil(Math.max(first.y, last.y));
                        selection = this.combineSelection([
                            [
                                [
                                    minX,
                                    minY
                                ],
                                [
                                    maxX,
                                    minY
                                ],
                                [
                                    maxX,
                                    maxY
                                ],
                                [
                                    minX,
                                    maxY
                                ]
                            ]
                        ]);
                    } else if (this.shape === 'ellipse') {
                        var first1 = this.selectDragInputs[0];
                        var last1 = this.selectDragInputs[this.selectDragInputs.length - 1];
                        var cx = (first1.x + last1.x) / 2;
                        var cy = (first1.y + last1.y) / 2;
                        var rx = Math.abs(last1.x - first1.x) / 2;
                        var ry = Math.abs(last1.y - first1.y) / 2;
                        selection = this.combineSelection($29bdc5a628b41259$export$9ff2e12a5746572e((0, $87b240a7315255f9$export$1b1b9d54d324857f)(cx, cy, rx, ry, 50)));
                    } else if (this.shape === 'lasso') selection = this.combineSelection([
                        this.selectDragInputs.map(function(p) {
                            return [
                                $29bdc5a628b41259$export$1f0b3b9c2ff2269f(p.x),
                                $29bdc5a628b41259$export$1f0b3b9c2ff2269f(p.y)
                            ];
                        })
                    ]);
                }
                return selection.length === 0 ? undefined : selection;
            }
        },
        {
            // --- selecting ---
            key: "startSelect",
            value: function startSelect(pos, operation) {
                this.selectOperation = operation;
                if (this.selectOperation === 'new') this.reset();
                this.selectDragInputs = [
                    pos
                ];
            }
        },
        {
            key: "goSelect",
            value: function goSelect(pos) {
                var isShiftPressed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var p = pos;
                if ((this.shape === 'ellipse' || this.shape === 'rect') && isShiftPressed && this.selectDragInputs.length > 0) {
                    var start = this.selectDragInputs[0];
                    var dx = pos.x - start.x;
                    var dy = pos.y - start.y;
                    var size = Math.min(Math.abs(dx), Math.abs(dy));
                    p = {
                        x: start.x + Math.sign(dx) * size,
                        y: start.y + Math.sign(dy) * size
                    };
                }
                this.selectDragInputs.push({
                    x: p.x,
                    y: p.y
                });
            }
        },
        {
            key: "endSelect",
            value: function endSelect() {
                if (this.selectDragInputs.length > 1) // commit
                this.selection = this.getSelection();
                else this.reset();
                this.selectDragInputs = [];
            }
        },
        {
            key: "addPoly",
            value: function addPoly(polygon, operation) {
                this.selectOperation = operation;
                this.selection = this.combineSelection([
                    polygon.map(function(p) {
                        return [
                            $29bdc5a628b41259$export$1f0b3b9c2ff2269f(p.x),
                            $29bdc5a628b41259$export$1f0b3b9c2ff2269f(p.y)
                        ];
                    })
                ]);
            }
        },
        {
            // --- moving selection ---
            key: "startMoveSelect",
            value: function startMoveSelect(pos) {
                this.moveStartPos = pos;
                this.selectionAtMoveStart = this.selection ? (0, $eWjiX.BB).copyObj(this.selection) : undefined;
                this.didMove = false;
            }
        },
        {
            key: "goMoveSelect",
            value: function goMoveSelect(pos) {
                var isShiftPressed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (!this.moveStartPos) return;
                this.didMove = true;
                var dx = pos.x - this.moveStartPos.x;
                var dy = pos.y - this.moveStartPos.y;
                if (isShiftPressed) {
                    // snap to 0°, 45°, 90°, 135° axes from start position
                    var angle = Math.atan2(dy, dx);
                    var snapAngle = Math.round(angle / (Math.PI / 4)) * (Math.PI / 4);
                    var dist = Math.sqrt(dx * dx + dy * dy);
                    dx = Math.cos(snapAngle) * dist;
                    dy = Math.sin(snapAngle) * dist;
                }
                dx = Math.round(dx);
                dy = Math.round(dy);
                if (this.selectionAtMoveStart) this.selection = (0, $f2ea5f654adc2709$export$199acb5b15c43176)(this.selectionAtMoveStart, dx, dy);
            }
        },
        {
            key: "endMoveSelect",
            value: function endMoveSelect() {
                this.moveStartPos = undefined;
                this.selectionAtMoveStart = undefined;
            }
        },
        {
            key: "getDidMove",
            value: function getDidMove() {
                return this.didMove;
            }
        },
        {
            key: "selectAll",
            value: function selectAll() {
                this.reset();
                var width = this.klCanvas.getWidth();
                var height = this.klCanvas.getHeight();
                this.selection = [
                    [
                        [
                            [
                                0,
                                0
                            ],
                            [
                                width,
                                0
                            ],
                            [
                                width,
                                height
                            ],
                            [
                                0,
                                height
                            ],
                            [
                                0,
                                0
                            ]
                        ]
                    ]
                ];
            }
        },
        {
            key: "invertSelection",
            value: function invertSelection() {
                var _this_selection;
                var selection = (_this_selection = this.selection) !== null && _this_selection !== void 0 ? _this_selection : [];
                var width = this.klCanvas.getWidth();
                var height = this.klCanvas.getHeight();
                this.selection = (0, $0b0ef140191bcf10$export$7ec1a3fdd6e82838)('difference', [
                    [
                        [
                            0,
                            0
                        ],
                        [
                            width,
                            0
                        ],
                        [
                            width,
                            height
                        ],
                        [
                            0,
                            height
                        ]
                    ]
                ], selection);
            }
        },
        {
            key: "setShape",
            value: function setShape(shape) {
                this.shape = shape;
            }
        },
        {
            key: "getShape",
            value: function getShape() {
                return this.shape;
            }
        },
        {
            key: "setSelection",
            value: function setSelection(selection) {
                this.selection = selection ? (0, $eWjiX.BB).copyObj(selection).map($29bdc5a628b41259$export$9ff2e12a5746572e) : undefined;
            }
        }
    ]);
    return SelectTool;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");



var $eelgW = parcelRequire("eelgW");

var $7b949f5a2c57e9f4$export$348ded3d52c9ce4c = /*#__PURE__*/ function() {
    "use strict";
    function FfdRenderer() {
        (0, $cx0mh._)(this, FfdRenderer);
    }
    (0, $7h4XF._)(FfdRenderer, [
        {
            key: "invalidateCompositeCanvas",
            value: function invalidateCompositeCanvas() {
                try {
                    var _this_texture, _this_canvas;
                    (_this_texture = this.texture) === null || _this_texture === void 0 ? void 0 : _this_texture.destroy();
                    this.texture = undefined;
                    (_this_canvas = this.canvas) === null || _this_canvas === void 0 ? void 0 : _this_canvas.destroy();
                    this.canvas = undefined;
                } catch (_) {
                // noop
                }
                this.cachedSelectionSample = undefined;
                this.cachedAlgorithm = undefined;
                this.cachedWidth = undefined;
                this.cachedHeight = undefined;
                this.cachedFfdLattice = undefined;
            }
        },
        {
            key: "ensureCompositeCanvas",
            value: function ensureCompositeCanvas(width, height, algorithm) {
                if (!this.canvas || this.canvas.isContextLost() || this.cachedAlgorithm !== algorithm || this.cachedWidth !== width || this.cachedHeight !== height) {
                    this.invalidateCompositeCanvas();
                    try {
                        this.canvas = new (0, $a8df4ba70dfe7950$export$382d1cdfd2c9e133)((0, $eelgW.createCanvas)(width, height), algorithm);
                        this.cachedAlgorithm = algorithm;
                        this.cachedWidth = width;
                        this.cachedHeight = height;
                    } catch (_) {
                    // noop
                    }
                }
            }
        },
        {
            key: "ensureTexture",
            value: function ensureTexture(selectionSample) {
                if (this.cachedSelectionSample !== selectionSample || !this.texture) {
                    var _this_texture;
                    (_this_texture = this.texture) === null || _this_texture === void 0 ? void 0 : _this_texture.destroy();
                    this.texture = undefined;
                    try {
                        this.texture = this.canvas.createTexture(selectionSample.image);
                        this.cachedSelectionSample = selectionSample;
                    } catch (_) {
                    // noop
                    }
                }
            }
        },
        {
            // ---- public ----
            key: "render",
            value: function render(p) {
                if (p.ffdLattice === this.cachedFfdLattice && p.selectionSample === this.cachedSelectionSample && p.algorithm === this.cachedAlgorithm && p.outputWidth === this.cachedWidth && p.outputHeight === this.cachedHeight) return; // output canvas already holds the correct result
                this.ensureCompositeCanvas(p.outputWidth, p.outputHeight, p.algorithm);
                if (!this.canvas) return;
                this.ensureTexture(p.selectionSample);
                if (!this.texture) return;
                this.cachedFfdLattice = p.ffdLattice;
                var ffdMesh = (0, $abad715f10469dbf$export$81dc197f519ea47)((0, $c3d05422ca86fac7$export$6ba60dd123964f3e), (0, $c3d05422ca86fac7$export$6ba60dd123964f3e), p.ffdLattice, p.selectionSample, p.outputWidth, p.outputHeight, undefined);
                var frontMesh;
                var backMesh;
                try {
                    frontMesh = this.canvas.createMesh(ffdMesh.vertices, ffdMesh.texCoords, ffdMesh.frontIndices);
                    backMesh = this.canvas.createMesh(ffdMesh.vertices, ffdMesh.texCoords, ffdMesh.backIndices);
                    this.canvas.clear();
                    this.canvas.draw(frontMesh, this.texture);
                    this.canvas.draw(backMesh, this.texture);
                    this.canvas.present();
                } catch (_) {
                // noop
                } finally{
                    frontMesh === null || frontMesh === void 0 ? void 0 : frontMesh.destroy();
                    backMesh === null || backMesh === void 0 ? void 0 : backMesh.destroy();
                }
            }
        },
        {
            key: "getCanvas",
            value: function getCanvas() {
                var _this_canvas;
                return (_this_canvas = this.canvas) === null || _this_canvas === void 0 ? void 0 : _this_canvas.getCanvas();
            }
        },
        {
            key: "freeResources",
            value: function freeResources() {
                this.invalidateCompositeCanvas();
            }
        },
        {
            // when you want to discard this object
            key: "destroy",
            value: function destroy() {
                this.invalidateCompositeCanvas();
            }
        }
    ]);
    return FfdRenderer;
}();





var $eg83P = parcelRequire("eg83P");

var $bX4ja = parcelRequire("bX4ja");


var $eg83P = parcelRequire("eg83P");
function $a7110fc0560487d2$export$13786f381c8abcf1(selectionSample) {
    var x = selectionSample.x - selectionSample.imageOffset.x;
    var y = selectionSample.y - selectionSample.imageOffset.y;
    return (0, $eg83P.rectToBounds)({
        x: x,
        y: y,
        width: selectionSample.selectionSize.width,
        height: selectionSample.selectionSize.height
    }, 'index');
}
function $a7110fc0560487d2$export$a70ad15f9d5e7f79(selectionSample, transformation) {
    var rect = {
        x: selectionSample.x,
        y: selectionSample.y,
        width: selectionSample.image.width,
        height: selectionSample.image.height
    };
    if (transformation) return (0, $eg83P.coordinateBoundsToIndexBounds)((0, $b04075c332ce65cd$export$5dd60a54dd55622)((0, $eg83P.rectToBounds)(rect, 'coordinate'), transformation));
    return (0, $eg83P.rectToBounds)(rect, 'index');
}
function $a7110fc0560487d2$export$f97155819e62dfa1(selectionSample, transformation) {
    var bounds = (0, $eg83P.indexBoundsToCoordinateBounds)($a7110fc0560487d2$export$a70ad15f9d5e7f79(selectionSample, transformation));
    return [
        [
            [
                [
                    bounds.x1,
                    bounds.y1
                ],
                [
                    bounds.x2,
                    bounds.y1
                ],
                [
                    bounds.x2,
                    bounds.y2
                ],
                [
                    bounds.x1,
                    bounds.y2
                ],
                [
                    bounds.x1,
                    bounds.y1
                ]
            ]
        ]
    ];
}



function $bf77e842daed0824$export$a8cb0d8fd60b16e8(ctx, algorithm) {
    ctx.imageSmoothingEnabled = algorithm === 'smooth';
    if (algorithm === 'smooth') ctx.imageSmoothingQuality = 'high';
}




var $eg83P = parcelRequire("eg83P");

var $bX4ja = parcelRequire("bX4ja");


var $eg83P = parcelRequire("eg83P");
function $e0b98076465e3525$export$7c52f4d84a7cbc6e(layers, changes) {
    var result = {};
    var layerEntries = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var change = _step.value;
            if ('selection' in change) result.selection = {
                value: change.selection
            };
            else {
                var existing = layerEntries.find(function(e) {
                    return e.layerId === change.layerId;
                });
                if (existing) existing.bounds = (0, $eg83P.updateBounds)(existing.bounds, change.bounds);
                else layerEntries.push({
                    layerId: change.layerId,
                    attributes: [
                        'tiles'
                    ],
                    bounds: change.bounds
                });
            }
        };
        for(var _iterator = changes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (layerEntries.length > 0) result.layerMap = (0, $17f5ce4410029f54$export$7cefb04ac49374c4).apply(void 0, [
        layers
    ].concat((0, $bX4ja._)(layerEntries)));
    return result;
}


function $2fd1f16943677fce$var$drawTransformedSelectionSample(algorithm, selectionSample, ctx, transformation) {
    var _ctx;
    ctx.save();
    (_ctx = ctx).setTransform.apply(_ctx, (0, $bX4ja._)((0, $c9ab5bbe74e01c89$export$2b60e7dafdbde18a)(transformation)));
    (0, $bf77e842daed0824$export$a8cb0d8fd60b16e8)(ctx, algorithm);
    ctx.drawImage(selectionSample.image, selectionSample.x, selectionSample.y);
    ctx.restore();
}
function $2fd1f16943677fce$export$2f6704cc6a7abecb(p) {
    var _p_backgroundIsTransparent;
    var backgroundIsTransparent = (_p_backgroundIsTransparent = p.backgroundIsTransparent) !== null && _p_backgroundIsTransparent !== void 0 ? _p_backgroundIsTransparent : false;
    var klHistory = p.klCanvas.getKlHistory();
    var layers = p.klCanvas.getLayersRaw();
    var targetLayer = layers[p.targetLayerIndex];
    var matrix = (0, $c3d05422ca86fac7$export$e464a809f7257768)(p.freeTransform, (0, $a7110fc0560487d2$export$13786f381c8abcf1)(p.selectionSample));
    klHistory.pause(true);
    if (p.eraseLayerIndex !== undefined) p.klCanvas.eraseLayer({
        layerIndex: p.eraseLayerIndex,
        useSelection: true,
        useAlphaLock: p.eraseLayerIndex === 0 && !backgroundIsTransparent
    });
    $2fd1f16943677fce$var$drawTransformedSelectionSample(p.algorithm, p.selectionSample, targetLayer.context, matrix);
    var transformedSelection = p.selection ? (0, $c3d05422ca86fac7$export$c17d845d16ec8ae)({
        type: 'free',
        freeTransform: p.freeTransform
    }, p.selection) : undefined;
    p.klCanvas.setSelection(transformedSelection);
    klHistory.pause(false);
    if (!klHistory.isPaused()) {
        var eraseLayer = p.eraseLayerIndex !== undefined ? layers[p.eraseLayerIndex] : undefined;
        var targetBounds = (0, $eg83P.indexBoundsInArea)((0, $a7110fc0560487d2$export$a70ad15f9d5e7f79)(p.selectionSample, matrix), p.klCanvas.getWidth(), p.klCanvas.getHeight());
        var changes = [];
        transformedSelection && changes.push({
            selection: transformedSelection
        });
        eraseLayer && changes.push({
            layerId: eraseLayer.id,
            bounds: (0, $a7110fc0560487d2$export$a70ad15f9d5e7f79)(p.selectionSample)
        });
        targetBounds && changes.push({
            layerId: targetLayer.id,
            bounds: targetBounds
        });
        klHistory.push((0, $e0b98076465e3525$export$7c52f4d84a7cbc6e)(layers, changes));
    }
}








function $7c6472629b0823c3$var$drawWarpedSelectionSample(algorithm, selectionSample, ctx, ffdLattice, ffdRenderer) {
    ffdRenderer.render({
        ffdLattice: ffdLattice,
        selectionSample: selectionSample,
        algorithm: algorithm,
        outputWidth: ctx.canvas.width,
        outputHeight: ctx.canvas.height
    });
    var outputCanvas = ffdRenderer.getCanvas();
    if (outputCanvas) {
        ctx.save();
        ctx.drawImage(outputCanvas, 0, 0);
        ctx.restore();
    }
}
function $7c6472629b0823c3$export$d43d373c54e74296(p) {
    var _p_backgroundIsTransparent;
    var backgroundIsTransparent = (_p_backgroundIsTransparent = p.backgroundIsTransparent) !== null && _p_backgroundIsTransparent !== void 0 ? _p_backgroundIsTransparent : false;
    var klHistory = p.klCanvas.getKlHistory();
    var layers = p.klCanvas.getLayersRaw();
    var targetLayer = layers[p.targetLayerIndex];
    klHistory.pause(true);
    if (p.eraseLayerIndex !== undefined) p.klCanvas.eraseLayer({
        layerIndex: p.eraseLayerIndex,
        useSelection: true,
        useAlphaLock: p.eraseLayerIndex === 0 && !backgroundIsTransparent
    });
    $7c6472629b0823c3$var$drawWarpedSelectionSample(p.algorithm, p.selectionSample, targetLayer.context, p.ffd, p.ffdRenderer);
    var transformedSelection = p.selection ? (0, $c3d05422ca86fac7$export$c17d845d16ec8ae)({
        type: 'ffd',
        ffd: p.ffd
    }, p.selection) : undefined;
    p.klCanvas.setSelection(transformedSelection);
    klHistory.pause(false);
    if (!klHistory.isPaused()) {
        var ffdMesh = (0, $abad715f10469dbf$export$81dc197f519ea47)((0, $c3d05422ca86fac7$export$6ba60dd123964f3e), (0, $c3d05422ca86fac7$export$6ba60dd123964f3e), p.ffd, p.selectionSample, 1, 1, true);
        var width = p.klCanvas.getWidth();
        var height = p.klCanvas.getHeight();
        var targetBounds = (0, $5a3072fca1cffb62$export$b8704036eca28391)(ffdMesh, width, height);
        var eraseLayer = p.eraseLayerIndex !== undefined ? layers[p.eraseLayerIndex] : undefined;
        var changes = [];
        transformedSelection && changes.push({
            selection: transformedSelection
        });
        eraseLayer && changes.push({
            layerId: eraseLayer.id,
            bounds: (0, $a7110fc0560487d2$export$a70ad15f9d5e7f79)(p.selectionSample)
        });
        targetBounds && changes.push({
            layerId: targetLayer.id,
            bounds: targetBounds
        });
        klHistory.push((0, $e0b98076465e3525$export$7c52f4d84a7cbc6e)(layers, changes));
    }
}






var $eWjiX = parcelRequire("eWjiX");

var $bX4ja = parcelRequire("bX4ja");


var $9b3eo = parcelRequire("9b3eo");


var $eg83P = parcelRequire("eg83P");


function $88f24e8b65f78282$export$fbfe89095a95dee(config, // "same" when (source layer === destination layer)
layer) {
    var _config_selection;
    var selectionPath = (0, $9b3eo.getSelectionPath2d)((_config_selection = config.selection) !== null && _config_selection !== void 0 ? _config_selection : (0, $a7110fc0560487d2$export$f97155819e62dfa1)(config.selectionSample));
    var erase = function(ctx) {
        if (!config.doClone && (layer === 'same' || layer === 'src')) {
            // erase
            ctx.save();
            ctx.clip(selectionPath);
            if (config.backgroundIsTransparent) ctx.clearRect(0, 0, config.klCanvasWidth, config.klCanvasHeight);
            else {
                // fastest in firefox like so
                ctx.globalCompositeOperation = 'source-atop';
                ctx.fillStyle = '#fff';
                ctx.fillRect(0, 0, config.klCanvasWidth, config.klCanvasHeight);
            }
            ctx.restore();
        }
    };
    // ffd
    if (config.transform.type === 'ffd' || config.transform.type === 'ffd+free') {
        var ffd = config.transform.ffd;
        if (config.transform.type === 'ffd+free') // apply further free transform
        ffd = (0, $c3d05422ca86fac7$export$a56ca41a0dbe2002)(ffd, (0, $c3d05422ca86fac7$export$e464a809f7257768)(config.transform.freeTransform, (0, $eg83P.rectToBounds)(config.transform.ffdBounds, 'index')));
        return {
            draw: function(ctx) {
                ctx.save();
                erase(ctx);
                if (layer === 'same' || layer === 'dest') {
                    config.ffdRenderer.render({
                        ffdLattice: ffd,
                        selectionSample: config.selectionSample,
                        algorithm: config.algorithm,
                        outputWidth: config.klCanvasWidth,
                        outputHeight: config.klCanvasHeight
                    });
                    var outputCanvas = config.ffdRenderer.getCanvas();
                    outputCanvas && ctx.drawImage(outputCanvas, 0, 0);
                }
                ctx.restore();
            }
        };
    }
    // free transform
    var selectionBounds = (0, $a7110fc0560487d2$export$13786f381c8abcf1)(config.selectionSample);
    var transformMatrix = (0, $c3d05422ca86fac7$export$e464a809f7257768)(config.transform.freeTransform, selectionBounds);
    return {
        draw: function(ctx) {
            ctx.save();
            erase(ctx);
            if (layer === 'same' || layer === 'dest') {
                var _ctx;
                (0, $bf77e842daed0824$export$a8cb0d8fd60b16e8)(ctx, config.algorithm);
                (_ctx = ctx).setTransform.apply(_ctx, (0, $bX4ja._)((0, $c9ab5bbe74e01c89$export$2b60e7dafdbde18a)(transformMatrix)));
                ctx.drawImage(config.selectionSample.image, config.selectionSample.x, config.selectionSample.y);
            }
            ctx.restore();
        }
    };
}



var $cL71g = parcelRequire("cL71g");

var $eg83P = parcelRequire("eg83P");



var $eWjiX = parcelRequire("eWjiX");

var $9b3eo = parcelRequire("9b3eo");
function $bfcc12ff9a82384a$export$bf78d14945c1101(layerIndex, klCanvas) {
    var srcLayer = klCanvas.getLayersRaw()[layerIndex];
    var klCanvasSelection = klCanvas.getSelection();
    var hasSelection = !!klCanvasSelection;
    var selectionBounds;
    var imageBounds;
    if (hasSelection) {
        selectionBounds = (0, $eg83P.indexBoundsToRect)((0, $2c64e9e8cb297da3$export$a04a50ae6d6450f8)(klCanvasSelection, 'index'));
        imageBounds = (0, $4ae5c842364e8628$export$6be4733fa804854c)(klCanvasSelection, srcLayer.context);
    } else {
        var width = klCanvas.getWidth();
        var height = klCanvas.getHeight();
        var _klCanvas_getSelection;
        imageBounds = (0, $4ae5c842364e8628$export$6be4733fa804854c)((_klCanvas_getSelection = klCanvas.getSelection()) !== null && _klCanvas_getSelection !== void 0 ? _klCanvas_getSelection : [
            [
                [
                    [
                        0,
                        0
                    ],
                    [
                        width,
                        0
                    ],
                    [
                        width,
                        height
                    ],
                    [
                        0,
                        height
                    ],
                    [
                        0,
                        0
                    ]
                ]
            ]
        ], srcLayer.context);
        selectionBounds = imageBounds ? (0, $cL71g._)({}, imageBounds) : undefined;
    }
    // empty
    if (!selectionBounds || !imageBounds) return undefined;
    var sampleCanvas = (0, $eWjiX.BB).canvas(imageBounds.width, imageBounds.height);
    var sampleCtx = (0, $eWjiX.BB).ctx(sampleCanvas);
    sampleCtx.save();
    sampleCtx.translate(-imageBounds.x, -imageBounds.y);
    if (klCanvasSelection) sampleCtx.clip((0, $9b3eo.getSelectionPath2d)(klCanvasSelection));
    sampleCtx.drawImage(srcLayer.canvas, 0, 0);
    sampleCtx.restore();
    return {
        image: sampleCanvas,
        x: imageBounds.x,
        y: imageBounds.y,
        imageOffset: {
            x: imageBounds.x - selectionBounds.x,
            y: imageBounds.y - selectionBounds.y
        },
        selectionSize: {
            width: selectionBounds.width,
            height: selectionBounds.height
        }
    };
}



function $f177420b33748502$var$isSelectTransformTempEntry(entry) {
    return entry.type === 'select-transform' && !!entry.data;
}
function $f177420b33748502$var$initialiseTransformState(p) {
    var selectionSample = p.selectionSample;
    var selectionBounds = (0, $a7110fc0560487d2$export$13786f381c8abcf1)(p.selectionSample);
    var transform = {
        // no ffd initially
        type: 'free',
        freeTransform: (0, $c3d05422ca86fac7$export$928f0648354c9a2f)((0, $eg83P.boundsToRect)(selectionBounds))
    };
    return {
        selection: p.selection,
        selectionSample: selectionSample,
        transform: transform,
        algorithm: p.algorithm,
        doClone: false,
        isWarping: false,
        targetLayerIndex: p.targetLayerIndex,
        backgroundIsTransparent: p.backgroundIsTransparent
    };
}
var $f177420b33748502$export$e471993a29671b7 = /*#__PURE__*/ function() {
    "use strict";
    function KlAppSelect(p) {
        var _this = this;
        (0, $cx0mh._)(this, KlAppSelect);
        // state
        this.selectMode = 'select';
        this.klCanvas = p.klCanvas;
        this.onUpdateProject = p.onUpdateProject;
        this.getCurrentLayerCtx = p.getCurrentLayerCtx;
        this.klHistory = p.klHistory;
        this.tempHistory = p.tempHistory;
        this.statusOverlay = p.statusOverlay;
        this.onFill = p.onFill;
        this.onErase = p.onErase;
        // keep layer list up-to-date
        this.klHistory.addListener(function() {
            _this.selectUi.setHasSelection(!!_this.klCanvas.getSelection());
            if (_this.selectMode === 'transform') _this.updateUiLayerList();
        });
        this.selectTool = new (0, $29bdc5a628b41259$export$53d9e71218013355)({
            klCanvas: this.klCanvas
        });
        this.ffdRenderer = new (0, $7b949f5a2c57e9f4$export$348ded3d52c9ce4c)();
        this.onVisibilityChange = function() {
            if (document.hidden && _this.selectMode === 'transform') _this.ffdRenderer.freeResources();
        };
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.easelSelect = new (0, $3d292a495f65a250$export$24961ed376c522a3)({
            selectMode: this.selectMode,
            onStartSelect: function(p, operation) {
                return _this.selectTool.startSelect(p, operation);
            },
            onGoSelect: function(p, isShiftPressed) {
                _this.selectTool.goSelect(p, isShiftPressed);
                _this.easelSelect.setRenderedSelection(_this.selectTool.getSelection());
            },
            onEndSelect: function() {
                _this.selectTool.endSelect();
                var selection = _this.selectTool.getSelection();
                _this.easelSelect.clearRenderedSelection();
                _this.klCanvas.setSelection(selection);
                _this.selectUi.setHasSelection(!!selection);
            },
            onStartMoveSelect: function(p) {
                _this.selectTool.startMoveSelect(p);
            },
            onGoMoveSelect: function(p, isShiftPressed) {
                _this.selectTool.goMoveSelect(p, isShiftPressed);
                _this.easelSelect.setRenderedSelection(_this.selectTool.getSelection());
            },
            onEndMoveSelect: function() {
                _this.selectTool.endMoveSelect();
                if (!_this.selectTool.getDidMove()) return;
                var selection = _this.selectTool.getSelection();
                _this.easelSelect.clearRenderedSelection();
                _this.klCanvas.setSelection(selection);
                _this.selectUi.setHasSelection(!!selection);
            },
            onSelectAddPoly: function(p, operation) {
                _this.selectTool.addPoly(p, operation);
                var selection = _this.selectTool.getSelection();
                _this.klCanvas.setSelection(selection);
                _this.selectUi.setHasSelection(!!selection);
            },
            onResetSelection: function() {
                return _this.resetSelection();
            },
            onTransform: function(transform) {
                if (!_this.transformState) return;
                _this.transformState.transform = transform;
                _this.propagateTransformationChange(true);
            },
            onTransformEnd: function() {
                _this.tempHistoryPush();
            }
        });
        this.selectUi = new (0, $79d09d3423439479$export$b3e6ed306341f794)({
            onChangeMode: function(mode) {
                if (mode === 'select') {
                    var layerIndex = (0, $7jh4K.throwIfNull)(_this.klCanvas.getLayerIndex(_this.getCurrentLayerCtx().canvas));
                    if (_this.transformState && (_this.isTransformationChanged() || _this.transformState.doClone || layerIndex !== _this.transformState.targetLayerIndex || _this.selectUi.getIsWarping())) {
                        // something changed -> apply
                        var transform = _this.transformState.transform;
                        if (transform.type === 'free') (0, $2fd1f16943677fce$export$2f6704cc6a7abecb)((0, $4EWN2._)((0, $cL71g._)({
                            klCanvas: _this.klCanvas,
                            selectionSample: _this.transformState.selectionSample
                        }, _this.transformState.doClone ? {} : {
                            eraseLayerIndex: layerIndex
                        }), {
                            targetLayerIndex: _this.transformState.targetLayerIndex,
                            freeTransform: transform.freeTransform,
                            backgroundIsTransparent: _this.transformState.backgroundIsTransparent,
                            algorithm: _this.transformState.algorithm,
                            selection: _this.transformState.selection
                        }));
                        else {
                            var ffd = transform.type === 'ffd+free' ? (0, $c3d05422ca86fac7$export$a56ca41a0dbe2002)(transform.ffd, (0, $c3d05422ca86fac7$export$e464a809f7257768)(transform.freeTransform, (0, $eg83P.rectToBounds)(transform.ffdBounds, 'index'))) : transform.ffd;
                            if (_this.transformState.doClone) (0, $7c6472629b0823c3$export$d43d373c54e74296)({
                                klCanvas: _this.klCanvas,
                                selectionSample: _this.transformState.selectionSample,
                                targetLayerIndex: _this.transformState.targetLayerIndex,
                                ffd: ffd,
                                algorithm: _this.transformState.algorithm,
                                selection: _this.transformState.selection,
                                ffdRenderer: _this.ffdRenderer
                            });
                            else (0, $7c6472629b0823c3$export$d43d373c54e74296)({
                                klCanvas: _this.klCanvas,
                                selectionSample: _this.transformState.selectionSample,
                                eraseLayerIndex: layerIndex,
                                targetLayerIndex: _this.transformState.targetLayerIndex,
                                ffd: ffd,
                                backgroundIsTransparent: _this.transformState.backgroundIsTransparent,
                                algorithm: _this.transformState.algorithm,
                                selection: _this.transformState.selection,
                                ffdRenderer: _this.ffdRenderer
                            });
                        }
                        _this.clearTransformState();
                        p.statusOverlay.out((0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-transform-applied'), true);
                    }
                    _this.tempHistory.clear();
                    _this.tempHistory.setIsActive(false);
                    _this.selectUi.setIsWarping(false);
                    _this.resetKlCanvasLayerComposites();
                    _this.ffdRenderer.freeResources();
                    _this.easelSelect.clearRenderedSelection(true);
                    var selection = _this.klCanvas.getSelection();
                    _this.selectTool.setSelection(selection);
                    _this.selectUi.setHasSelection(!!selection);
                    _this.onUpdateProject();
                    _this.easelSelect.setMode(mode);
                } else {
                    // -> transform
                    // avoid changing state while mode-change can be rejected
                    var currentLayerCanvas = _this.getCurrentLayerCtx().canvas;
                    var layerIndex1 = (0, $7jh4K.throwIfNull)(_this.klCanvas.getLayerIndex(currentLayerCanvas));
                    var selectionSample = (0, $bfcc12ff9a82384a$export$bf78d14945c1101)(layerIndex1, _this.klCanvas);
                    if (!selectionSample) {
                        setTimeout(function() {
                            (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
                                message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-transform-empty'),
                                type: 'error'
                            });
                        });
                        return false;
                    }
                    _this.tempHistory.setIsActive(true);
                    var isBgLayer = layerIndex1 === 0;
                    var isTransparent = false;
                    if (isBgLayer) {
                        var layer = Object.entries(_this.klHistory.getComposed().layerMap).find(function(param) {
                            var _param = (0, $8N5YG._)(param, 2), _ = _param[0], layer = _param[1];
                            return layer.index === layerIndex1;
                        })[1];
                        isTransparent = (0, $31a0dd41d7428d32$export$d7a217b118c790a6)(layer);
                        _this.selectUi.setBackgroundIsTransparent(isTransparent);
                    }
                    _this.transformState = $f177420b33748502$var$initialiseTransformState({
                        selection: _this.klCanvas.getSelection(),
                        selectionSample: selectionSample,
                        algorithm: _this.selectUi.getAlgorithm(),
                        targetLayerIndex: layerIndex1,
                        backgroundIsTransparent: isTransparent
                    });
                    // push initial state
                    _this.tempHistoryPush();
                    _this.selectUi.setShowTransparentBackgroundToggle(isBgLayer);
                    _this.updateComposites();
                    _this.updateUiLayerList();
                    _this.selectUi.setMoveToLayer(undefined);
                    _this.onUpdateProject();
                    _this.easelSelect.setMode(mode);
                    if (_this.transformState.selection) {
                        var transformedSelection = (0, $c3d05422ca86fac7$export$c17d845d16ec8ae)(_this.transformState.transform, _this.transformState.selection);
                        _this.easelSelect.setRenderedSelection(transformedSelection);
                    }
                    _this.easelSelect.initialiseTransform(_this.transformState.transform);
                    _this.updateSelectUi();
                }
                _this.selectMode = mode;
                return true;
            },
            onChangeBooleanOperation: function(operation) {
                _this.easelSelect.setBooleanOperation(operation);
            },
            select: {
                shape: this.selectTool.getShape(),
                onChangeShape: function(shape) {
                    _this.selectTool.setShape(shape);
                    _this.easelSelect.setSelectShape(shape);
                },
                onReset: function() {
                    return _this.resetSelection();
                },
                onAll: function() {
                    _this.selectTool.selectAll();
                    var selection = _this.selectTool.getSelection();
                    _this.klCanvas.setSelection(selection);
                    _this.selectUi.setHasSelection(!!selection);
                },
                onInvert: function() {
                    _this.selectTool.invertSelection();
                    var selection = _this.selectTool.getSelection();
                    _this.klCanvas.setSelection(selection);
                    _this.selectUi.setHasSelection(!!selection);
                }
            },
            transform: {
                onFlipY: function() {
                    if (!_this.transformState) return;
                    _this.transformState.transform = (0, $c3d05422ca86fac7$export$44831334ca780533)(_this.transformState.transform, 'y');
                    _this.propagateTransformationChange();
                    _this.easelSelect.setTransform(_this.transformState.transform);
                },
                onFlipX: function() {
                    if (!_this.transformState) return;
                    _this.transformState.transform = (0, $c3d05422ca86fac7$export$44831334ca780533)(_this.transformState.transform, 'x');
                    _this.propagateTransformationChange();
                    _this.easelSelect.setTransform(_this.transformState.transform);
                },
                onRotateDeg: function(deg) {
                    if (!_this.transformState) return;
                    _this.transformState.transform = (0, $c3d05422ca86fac7$export$71dd993772432b93)(_this.transformState.transform, deg);
                    _this.propagateTransformationChange();
                    _this.easelSelect.setTransform(_this.transformState.transform);
                },
                onClone: function() {
                    if (!_this.transformState) return;
                    // commit
                    var layerIndex = (0, $7jh4K.throwIfNull)(_this.klCanvas.getLayerIndex(_this.getCurrentLayerCtx().canvas));
                    var transform = _this.transformState.transform;
                    // apply
                    // should always apply. user might want to make something more opaque.
                    if (transform.type === 'free') {
                        if (_this.transformState.doClone) (0, $2fd1f16943677fce$export$2f6704cc6a7abecb)({
                            klCanvas: _this.klCanvas,
                            selectionSample: _this.transformState.selectionSample,
                            targetLayerIndex: _this.transformState.targetLayerIndex,
                            freeTransform: transform.freeTransform,
                            algorithm: _this.transformState.algorithm,
                            selection: _this.transformState.selection
                        });
                        else if (_this.isTransformationChanged()) (0, $2fd1f16943677fce$export$2f6704cc6a7abecb)({
                            klCanvas: _this.klCanvas,
                            selectionSample: _this.transformState.selectionSample,
                            eraseLayerIndex: layerIndex,
                            targetLayerIndex: _this.transformState.targetLayerIndex,
                            freeTransform: transform.freeTransform,
                            backgroundIsTransparent: _this.transformState.backgroundIsTransparent,
                            algorithm: _this.transformState.algorithm,
                            selection: _this.transformState.selection
                        });
                    } else {
                        var ffd = transform.type === 'ffd+free' ? (0, $c3d05422ca86fac7$export$a56ca41a0dbe2002)(transform.ffd, (0, $c3d05422ca86fac7$export$e464a809f7257768)(transform.freeTransform, (0, $eg83P.rectToBounds)(transform.ffdBounds, 'index'))) : transform.ffd;
                        if (_this.transformState.doClone) (0, $7c6472629b0823c3$export$d43d373c54e74296)({
                            klCanvas: _this.klCanvas,
                            selectionSample: _this.transformState.selectionSample,
                            targetLayerIndex: _this.transformState.targetLayerIndex,
                            ffd: ffd,
                            algorithm: _this.transformState.algorithm,
                            selection: _this.transformState.selection,
                            ffdRenderer: _this.ffdRenderer
                        });
                        else if (_this.isTransformationChanged()) (0, $7c6472629b0823c3$export$d43d373c54e74296)({
                            klCanvas: _this.klCanvas,
                            selectionSample: _this.transformState.selectionSample,
                            eraseLayerIndex: layerIndex,
                            targetLayerIndex: _this.transformState.targetLayerIndex,
                            ffd: ffd,
                            backgroundIsTransparent: _this.transformState.backgroundIsTransparent,
                            algorithm: _this.transformState.algorithm,
                            selection: _this.transformState.selection,
                            ffdRenderer: _this.ffdRenderer
                        });
                    }
                    _this.tempHistory.clear();
                    // push initial state
                    _this.tempHistoryPush();
                    _this.transformState.doClone = true;
                    _this.updateComposites();
                    _this.onUpdateProject();
                    _this.statusOverlay.out((0, $8d7403abedf7cefa$export$ce37e184d908d785)('select-transform-clone-applied'), true);
                },
                onScale: function(factor) {
                    if (!_this.transformState) return;
                    _this.transformState.transform = (0, $c3d05422ca86fac7$export$7eaa413076082bd7)(_this.transformState.transform, factor);
                    _this.propagateTransformationChange();
                    _this.easelSelect.setTransform(_this.transformState.transform);
                },
                onCenter: function() {
                    if (!_this.transformState) return;
                    _this.transformState.transform = (0, $c3d05422ca86fac7$export$552b36716f27e91b)(_this.transformState.transform, {
                        x: _this.klCanvas.getWidth() / 2,
                        y: _this.klCanvas.getHeight() / 2
                    });
                    _this.propagateTransformationChange();
                    _this.easelSelect.setTransform(_this.transformState.transform);
                },
                onMoveToLayer: function(index) {
                    if (!_this.transformState) return;
                    _this.resetKlCanvasLayerComposites();
                    _this.transformState.targetLayerIndex = index;
                    _this.updateComposites();
                    _this.onUpdateProject();
                    _this.tempHistoryPush();
                },
                onChangeTransparentBackground: function(isTransparent) {
                    if (!_this.transformState) return;
                    _this.transformState.backgroundIsTransparent = isTransparent;
                    _this.updateComposites();
                    _this.onUpdateProject();
                    _this.tempHistoryPush();
                },
                onChangeAlgorithm: function(algorithm) {
                    if (!_this.transformState) return;
                    _this.transformState.algorithm = algorithm;
                    _this.updateComposites();
                    _this.onUpdateProject();
                    _this.tempHistoryPush();
                },
                onChangeConstrain: function(isConstrained) {
                    _this.easelSelect.setIsConstrained(isConstrained);
                },
                onChangeSnapping: function(isSnapping) {
                    _this.easelSelect.setIsSnapping(isSnapping);
                },
                onChangeWarp: function(isWarping) {
                    if (!_this.transformState) return;
                    var transform = _this.transformState.transform;
                    if (isWarping) {
                        if (transform.type === 'free') {
                            var selectionBounds = (0, $a7110fc0560487d2$export$13786f381c8abcf1)(_this.transformState.selectionSample);
                            var matrix = (0, $c3d05422ca86fac7$export$e464a809f7257768)(transform.freeTransform, selectionBounds);
                            _this.transformState.transform = {
                                type: 'ffd',
                                ffd: (0, $c3d05422ca86fac7$export$a56ca41a0dbe2002)((0, $abad715f10469dbf$export$1dc7cad4a5f0f0a6)(5, 5, (0, $eg83P.boundsToRect)(selectionBounds)), matrix)
                            };
                        } else if (transform.type === 'ffd+free') {
                            var matrix1 = (0, $c3d05422ca86fac7$export$e464a809f7257768)(transform.freeTransform, (0, $eg83P.rectToBounds)(transform.ffdBounds, 'index'));
                            _this.transformState.transform = {
                                type: 'ffd',
                                ffd: (0, $c3d05422ca86fac7$export$a56ca41a0dbe2002)(transform.ffd, matrix1)
                            };
                        }
                    } else if (transform.type === 'ffd') {
                        var ffdBounds = (0, $eg83P.boundsToRect)((0, $5a3072fca1cffb62$export$da260002c67d0dd)(transform.ffd));
                        var freeTransform = (0, $c3d05422ca86fac7$export$928f0648354c9a2f)(ffdBounds);
                        _this.transformState.transform = {
                            type: 'ffd+free',
                            ffd: (0, $eWjiX.BB).copyObj(transform.ffd),
                            ffdBounds: ffdBounds,
                            freeTransform: freeTransform
                        };
                    }
                    _this.transformState.isWarping = isWarping;
                    _this.easelSelect.setTransform(_this.transformState.transform);
                    _this.updateComposites();
                    _this.onUpdateProject();
                    _this.tempHistoryPush();
                }
            },
            onErase: function() {
                _this.onErase();
            },
            onFill: function() {
                _this.onFill();
            }
        });
        this.klHistory.addListener(function() {
            var selection = _this.klCanvas.getSelection();
            if (_this.selectMode === 'select') _this.selectTool.setSelection(selection);
        });
    }
    (0, $7h4XF._)(KlAppSelect, [
        {
            key: "isTransformationChanged",
            value: // ----------------------------------- private methods -----------------------------------
            function isTransformationChanged() {
                if (!this.transformState) return false;
                var initial = this.tempHistory.getEntries()[0];
                if (!$f177420b33748502$var$isSelectTransformTempEntry(initial)) throw new Error('initial temp history entry has wrong type');
                if (this.transformState.doClone !== initial.data.doClone) return true;
                if (this.transformState.targetLayerIndex !== initial.data.targetLayerIndex) return true;
                // not perfect but would be a lot of effort to determine if two transforms are equivalent
                return JSON.stringify(this.transformState.transform) !== JSON.stringify(initial.data.transform);
            }
        },
        {
            key: "resetKlCanvasLayerComposites",
            value: /** reset KlCanvas layer composites **/ function resetKlCanvasLayerComposites() {
                var srcLayerCtx = this.getCurrentLayerCtx();
                var srcLayerIndex = (0, $7jh4K.throwIfNull)(this.klCanvas.getLayerIndex(srcLayerCtx.canvas));
                this.klCanvas.setComposite(srcLayerIndex, undefined);
                if (this.transformState && this.transformState.targetLayerIndex !== srcLayerIndex) this.klCanvas.setComposite(this.transformState.targetLayerIndex, undefined);
            }
        },
        {
            key: "updateComposites",
            value: function updateComposites() {
                if (!this.transformState) return;
                var srcLayerCanvas = this.getCurrentLayerCtx().canvas;
                var srcLayerIndex = (0, $7jh4K.throwIfNull)(this.klCanvas.getLayerIndex(srcLayerCanvas));
                var config = {
                    klCanvasWidth: this.klCanvas.getWidth(),
                    klCanvasHeight: this.klCanvas.getHeight(),
                    transform: this.transformState.transform,
                    selection: this.transformState.selection,
                    selectionSample: this.transformState.selectionSample,
                    algorithm: this.transformState.algorithm,
                    doClone: this.transformState.doClone,
                    backgroundIsTransparent: srcLayerIndex !== 0 || this.transformState.backgroundIsTransparent,
                    ffdRenderer: this.ffdRenderer
                };
                if (srcLayerIndex === this.transformState.targetLayerIndex) this.klCanvas.setComposite(srcLayerIndex, (0, $88f24e8b65f78282$export$fbfe89095a95dee)(config, 'same'));
                else {
                    this.klCanvas.setComposite(srcLayerIndex, (0, $88f24e8b65f78282$export$fbfe89095a95dee)(config, 'src'));
                    this.klCanvas.setComposite(this.transformState.targetLayerIndex, (0, $88f24e8b65f78282$export$fbfe89095a95dee)(config, 'dest'));
                }
            }
        },
        {
            key: "updateUiLayerList",
            value: function updateUiLayerList() {
                this.selectUi.setLayers(this.klCanvas.getLayers().map(function(layer) {
                    return layer.name;
                }));
            }
        },
        {
            key: "resetSelection",
            value: function resetSelection() {
                this.selectTool.reset();
                var selection = this.selectTool.getSelection();
                this.klCanvas.setSelection(selection);
                this.selectUi.setHasSelection(!!selection);
            }
        },
        {
            key: "tempHistoryPush",
            value: function tempHistoryPush() {
                if (!this.transformState) return;
                var newEntry = {
                    type: 'select-transform',
                    data: {
                        transform: (0, $eWjiX.BB).copyObj(this.transformState.transform),
                        doClone: this.transformState.doClone,
                        targetLayerIndex: this.transformState.targetLayerIndex,
                        backgroundIsTransparent: this.transformState.backgroundIsTransparent,
                        algorithm: this.transformState.algorithm
                    }
                };
                var topEntry = this.tempHistory.getEntries().at(-1);
                // skip if no change
                if (JSON.stringify(newEntry) === JSON.stringify(topEntry)) return;
                this.tempHistory.push(newEntry);
            }
        },
        {
            key: "propagateTransformationChange",
            value: function propagateTransformationChange() {
                var skipPushUndo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (!this.transformState) return;
                if (this.transformState.selection) {
                    var selection = (0, $c3d05422ca86fac7$export$c17d845d16ec8ae)(this.transformState.transform, this.transformState.selection);
                    this.easelSelect.setRenderedSelection(selection);
                }
                this.updateComposites();
                this.onUpdateProject();
                this.updateSelectUi();
                !skipPushUndo && this.tempHistoryPush();
            }
        },
        {
            key: "updateSelectUi",
            value: function updateSelectUi() {
                if (!this.transformState) return;
                if (this.transformState.transform.type !== 'ffd') this.selectUi.setFreeTransformTransformation(this.transformState.transform.freeTransform);
            }
        },
        {
            key: "clearTransformState",
            value: function clearTransformState() {
                if (this.transformState) {
                    (0, $eWjiX.BB).freeCanvas(this.transformState.selectionSample.image);
                    this.transformState = undefined;
                }
            }
        },
        {
            key: "getSelectUi",
            value: function getSelectUi() {
                return this.selectUi;
            }
        },
        {
            key: "getEaselSelect",
            value: function getEaselSelect() {
                return this.easelSelect;
            }
        },
        {
            key: "getSelectMode",
            value: function getSelectMode() {
                return this.selectMode;
            }
        },
        {
            /**
     * If transform changed something, changes are applied. -> return true
     * If no changes applied -> return false
     */ key: "commitTransform",
            value: function commitTransform() {
                var result = false;
                if (this.selectMode === 'transform') {
                    this.selectUi.setMode('select'); // this triggers selectUi.onMode
                    result = true;
                }
                return result;
            }
        },
        {
            /** if transforming, changes are discarded */ key: "discardTransform",
            value: function discardTransform() {
                if (this.selectMode === 'transform') {
                    // so there's no transformation to apply.
                    this.clearTransformState();
                    // this triggers selectUi.onMode synchronously, which does the cleanup
                    this.selectUi.setMode('select');
                    return true;
                }
                return false;
            }
        },
        {
            key: "onHistory",
            value: function onHistory(type) {
                if (this.transformState && (type === 'tempUndo' || type === 'tempRedo')) {
                    this.resetKlCanvasLayerComposites();
                    // recreate
                    var entries = this.tempHistory.getEntries();
                    var top = entries.at(-1);
                    if (!$f177420b33748502$var$isSelectTransformTempEntry(top)) return;
                    var state = top.data;
                    this.transformState.transform = (0, $eWjiX.BB).copyObj(state.transform);
                    this.transformState.doClone = state.doClone;
                    this.transformState.targetLayerIndex = state.targetLayerIndex;
                    this.transformState.backgroundIsTransparent = state.backgroundIsTransparent;
                    this.transformState.algorithm = state.algorithm;
                    this.transformState.isWarping = state.transform.type === 'ffd';
                    this.selectUi.setBackgroundIsTransparent(state.backgroundIsTransparent);
                    this.selectUi.setAlgorithm(state.algorithm);
                    this.selectUi.setIsWarping(state.transform.type === 'ffd');
                    if (this.transformState.selection) {
                        var selection = (0, $c3d05422ca86fac7$export$c17d845d16ec8ae)(this.transformState.transform, this.transformState.selection);
                        this.easelSelect.setRenderedSelection(selection);
                    }
                    this.easelSelect.setTransform(this.transformState.transform);
                    this.selectUi.setMoveToLayer(this.klCanvas.getLayerIndex(this.getCurrentLayerCtx().canvas) === state.targetLayerIndex ? undefined : state.targetLayerIndex);
                    this.updateComposites();
                    this.onUpdateProject();
                    this.updateSelectUi();
                }
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                document.removeEventListener('visibilitychange', this.onVisibilityChange);
            // not a proper cleanup yet
            }
        }
    ]);
    return KlAppSelect;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $d3a44cd9d3ee7598$export$ab82e91194f5da86 = /*#__PURE__*/ function() {
    "use strict";
    function KlTempHistory() {
        (0, $cx0mh._)(this, KlTempHistory);
        this.entries = [];
        this.currentIndex = -1;
        this.listeners = [];
        this.isActive = false;
    }
    (0, $7h4XF._)(KlTempHistory, [
        {
            key: "emit",
            value: function emit(type) {
                this.listeners.forEach(function(item) {
                    return item(type);
                });
            }
        },
        {
            key: "push",
            value: function push(entry) {
                var _this = this;
                while(this.currentIndex < this.entries.length - 1)this.entries.pop();
                this.entries.push(entry);
                this.currentIndex = this.entries.length - 1;
                setTimeout(function() {
                    return _this.emit('push');
                });
            }
        },
        {
            key: "replaceTop",
            value: function replaceTop(newEntry) {
                var _this = this;
                this.entries.splice(this.currentIndex);
                this.entries.push(newEntry);
                this.currentIndex = this.entries.length - 1;
                setTimeout(function() {
                    return _this.emit('push');
                });
            }
        },
        {
            key: "canDecreaseIndex",
            value: function canDecreaseIndex() {
                return this.currentIndex > 0;
            }
        },
        {
            key: "canIncreaseIndex",
            value: function canIncreaseIndex() {
                return this.currentIndex < this.entries.length - 1;
            }
        },
        {
            /** aka undo */ key: "decreaseIndex",
            value: function decreaseIndex() {
                var _this = this;
                if (!this.canDecreaseIndex()) return;
                this.currentIndex--;
                setTimeout(function() {
                    return _this.emit('decrease');
                });
            }
        },
        {
            /** aka redo */ key: "increaseIndex",
            value: function increaseIndex() {
                var _this = this;
                if (!this.canIncreaseIndex()) return;
                this.currentIndex++;
                setTimeout(function() {
                    return _this.emit('increase');
                });
            }
        },
        {
            /**
     * all entries up to currentIndex
     */ key: "getEntries",
            value: function getEntries() {
                return this.entries.slice(0, this.currentIndex + 1);
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this = this;
                this.entries = [];
                this.currentIndex = -1;
                setTimeout(function() {
                    return _this.emit('clear');
                });
            }
        },
        {
            /**
     * emits on push, decrease, increase, clear, or toggle active
     */ key: "addListener",
            value: function addListener(listener) {
                if (this.listeners.includes(listener)) return;
                this.listeners.push(listener);
            }
        },
        {
            key: "removeListener",
            value: function removeListener(listener) {
                var _this = this;
                this.listeners.map(function(item, index) {
                    if (item === listener) _this.listeners.splice(index, 1);
                });
            }
        },
        {
            key: "setIsActive",
            value: function setIsActive(isActive) {
                if (this.isActive === isActive) return;
                this.isActive = isActive;
                this.emit('active');
            }
        },
        {
            key: "getIsActive",
            value: function getIsActive() {
                return this.isActive;
            }
        }
    ]);
    return KlTempHistory;
}();



var $cx0mh = parcelRequire("cx0mh");

var $eWjiX = parcelRequire("eWjiX");


var $7jh4K = parcelRequire("7jh4K");
var $456806b212fdf6a8$export$3e66e8feec69f8d = function PinchZoomWatcher() {
    "use strict";
    (0, $cx0mh._)(this, PinchZoomWatcher);
    var check = function check() {
        if (isDismissed) return;
        var testEl = (0, $eWjiX.BB).el({
            parent: document.body,
            css: {
                position: 'fixed',
                inset: '0',
                zIndex: '-1'
            }
        });
        var rect = testEl.getBoundingClientRect();
        testEl.remove();
        var isZoomed = (viewport.width !== Math.round(rect.width) || viewport.height !== Math.round(rect.height)) && viewport.scale > 1;
        if (isZoomed) {
            (0, $7jh4K.css)(rootEl, {
                left: viewport.offsetLeft + 'px',
                top: viewport.offsetTop + 'px',
                width: viewport.width + 'px',
                height: viewport.height + 'px'
            });
            if (!isInDom) {
                document.body.append(iframe);
                document.body.append(rootEl);
            }
        } else if (isInDom) {
            iframe.remove();
            rootEl.remove();
        }
        isInDom = isZoomed;
    };
    if (!('visualViewport' in window) || visualViewport === null) return;
    var viewport = visualViewport;
    var isDismissed = false;
    var rootEl = (0, $eWjiX.BB).el({
        content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('browser-zoom-help'),
        className: 'kl-pinch-overlay',
        css: {
            position: 'fixed',
            pointerEvents: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: '100',
            flexDirection: 'column',
            gap: '10px',
            padding: '10px',
            backdropFilter: 'blur(3px)'
        }
    });
    (0, $eWjiX.BB).el({
        parent: rootEl,
        tagName: 'button',
        content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('dismiss'),
        onClick: function() {
            isDismissed = true;
            iframe.remove();
            rootEl.remove();
        },
        css: {
            pointerEvents: 'initial'
        }
    });
    // iframe allows pinch-zooming the page even if viewport meta tag set to user-scalable=no
    var iframe = (0, $eWjiX.BB).el({
        tagName: 'iframe',
        css: {
            position: 'fixed',
            width: '100vw',
            height: '100vh',
            zIndex: '99',
            opacity: '0'
        }
    });
    var isInDom = false;
    viewport.addEventListener('resize', check);
    viewport.addEventListener('scroll', check);
    setTimeout(check);
};




var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $45179ad71c16c96a$export$cb9945923eaef1dd = /*#__PURE__*/ function() {
    "use strict";
    function KlHistoryExecutor(p) {
        var _this = this;
        (0, $cx0mh._)(this, KlHistoryExecutor);
        this.doIgnore = false;
        this.lastCanUndo = false;
        this.lastCanRedo = false;
        this.klHistory = p.klHistory;
        this.tempHistory = p.tempHistory;
        this.onCanUndoRedoChange = p.onCanUndoRedoChange;
        var emitCanUndoRedo = function() {
            var canUndo = _this.canUndo();
            var canRedo = _this.canRedo();
            if (_this.lastCanUndo === canUndo && _this.lastCanRedo === canRedo) return;
            _this.lastCanUndo = canUndo;
            _this.lastCanRedo = canRedo;
            _this.onCanUndoRedoChange(canUndo, canRedo);
        };
        this.klHistory.addListener(emitCanUndoRedo);
        this.tempHistory.addListener(emitCanUndoRedo);
    }
    (0, $7h4XF._)(KlHistoryExecutor, [
        {
            key: "testShouldSkip",
            value: /**
     * If UI is frozen while pressing undo/redo, the user might click multiple times
     * because they think the click wasn't registered.
     * This test prevents multiple undo/redo at once.
     * true = skip
     */ function testShouldSkip() {
                var _this = this;
                if (this.doIgnore) return true;
                this.doIgnore = true;
                setTimeout(function() {
                    _this.doIgnore = false;
                }, 0);
                return false;
            }
        },
        {
            key: "canUndo",
            value: function canUndo() {
                return this.tempHistory.getIsActive() && this.tempHistory.canDecreaseIndex() || this.klHistory.canUndo();
            }
        },
        {
            key: "canRedo",
            value: function canRedo() {
                if (this.tempHistory.getIsActive()) return this.tempHistory.canIncreaseIndex();
                return this.klHistory.canRedo();
            }
        },
        {
            // returns undefined if it can't undo
            key: "undo",
            value: function undo() {
                if (this.testShouldSkip()) return undefined;
                if (this.tempHistory.getIsActive() && this.tempHistory.canDecreaseIndex()) {
                    this.tempHistory.decreaseIndex();
                    return {
                        type: 'tempUndo'
                    };
                }
                if (!this.klHistory.canUndo()) return undefined;
                this.klHistory.decreaseIndex();
                return {
                    type: 'undo'
                };
            }
        },
        {
            // returns undefined if it can't redo
            key: "redo",
            value: function redo() {
                if (this.testShouldSkip()) return undefined;
                if (this.tempHistory.getIsActive() && this.tempHistory.canIncreaseIndex()) {
                    this.tempHistory.increaseIndex();
                    return {
                        type: 'tempRedo'
                    };
                }
                if (!this.klHistory.canRedo()) return undefined;
                this.klHistory.increaseIndex();
                return {
                    type: 'redo'
                };
            }
        }
    ]);
    return KlHistoryExecutor;
}();



var $gWfkn = parcelRequire("gWfkn");

function $0eb4c7d1339a9456$export$beb462111ff337c5(entry) {
    var keys = Object.keys(entry);
    return keys.length === 1 && keys[0] === 'activeLayerId';
}



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $bX4ja = parcelRequire("bX4ja");

var $eWjiX = parcelRequire("eWjiX");


var $6l0gQ = parcelRequire("6l0gQ");

var $7jh4K = parcelRequire("7jh4K");
var $ea23e70ae6749408$export$38b681d46b785af1 = /*#__PURE__*/ function() {
    "use strict";
    function MobileUi(p) {
        var _this = this;
        var _this_mobileWrapperEl;
        (0, $cx0mh._)(this, MobileUi);
        this.toolspaceIsOpen = true;
        this.orientation = 'right';
        this.isVisible = false;
        this.onShowToolspace = p.onShowToolspace;
        this.toolspaceCollapser = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).ToolspaceCollapser({
            onChange: function() {
                _this.toolspaceIsOpen = _this.toolspaceCollapser.isOpen();
                _this.onShowToolspace(_this.toolspaceIsOpen);
                if (_this.toolspaceIsOpen) (0, $6l0gQ.LocalStorage).removeItem('uiShowMobile');
                else (0, $6l0gQ.LocalStorage).setItem('uiShowMobile', 'true');
            }
        });
        this.mobileWrapperEl = (0, $eWjiX.BB).el({
            css: {
                marginTop: '4px',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
            }
        });
        (_this_mobileWrapperEl = this.mobileWrapperEl).append.apply(_this_mobileWrapperEl, (0, $bX4ja._)(p.toolUis));
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                position: 'absolute',
                top: '0',
                userSelect: 'none'
            }
        });
        this.rootEl.append(this.toolspaceCollapser.getElement(), this.mobileWrapperEl);
        this.update();
    }
    (0, $7h4XF._)(MobileUi, [
        {
            key: "update",
            value: function update() {
                if (this.isVisible) {
                    if (this.toolspaceIsOpen) {
                        this.mobileWrapperEl.style.display = 'none';
                        if (this.orientation === 'left') (0, $7jh4K.css)(this.rootEl, {
                            left: '271px',
                            right: ''
                        });
                        else (0, $7jh4K.css)(this.rootEl, {
                            left: '',
                            right: '271px'
                        });
                    } else {
                        this.mobileWrapperEl.style.display = 'flex';
                        if (this.orientation === 'left') (0, $7jh4K.css)(this.rootEl, {
                            left: '0',
                            right: ''
                        });
                        else (0, $7jh4K.css)(this.rootEl, {
                            left: '',
                            right: '0'
                        });
                    }
                    this.rootEl.style.display = 'block';
                } else this.rootEl.style.display = 'none';
            }
        },
        {
            key: "setOrientation",
            value: function setOrientation(orientation) {
                this.orientation = orientation;
                this.toolspaceCollapser.setOrientation(orientation);
            }
        },
        {
            key: "setIsVisible",
            value: function setIsVisible(b) {
                this.isVisible = b;
            }
        },
        {
            key: "getToolspaceIsOpen",
            value: function getToolspaceIsOpen() {
                return this.toolspaceIsOpen;
            }
        },
        {
            key: "setToolspaceIsOpen",
            value: function setToolspaceIsOpen(b) {
                this.toolspaceIsOpen = b;
                this.toolspaceCollapser.setIsOpen(b);
                this.onShowToolspace(b);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return MobileUi;
}();



var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $eWjiX = parcelRequire("eWjiX");





var $78e60fb79fb423b6$export$87fd7552ee5cd26e = /*#__PURE__*/ function() {
    "use strict";
    function MobileBrushUi(p) {
        (0, $cx0mh._)(this, MobileBrushUi);
        var brushIcon = new (0, $eae820938baa028e$export$f04a61298a47a40f)({
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($1813762111ff3b93$exports))),
            width: 28,
            height: 28,
            darkInvert: true,
            css: {
                margin: '4px'
            }
        });
        var eraserIcon = new (0, $eae820938baa028e$export$f04a61298a47a40f)({
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($749e6c1deca5fab7$exports))),
            width: 28,
            height: 28,
            darkInvert: true,
            css: {
                margin: '4px'
            }
        });
        this.brushOptions = new (0, $7960d0c50ff12b0d$export$c019608e5b5bb4cb)({
            optionArr: [
                {
                    id: 'brush',
                    label: brushIcon.getElement(),
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-brush')
                },
                {
                    id: 'eraser',
                    label: eraserIcon.getElement(),
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('eraser')
                }
            ],
            initId: 'brush',
            onChange: function(id) {
                if (id === 'brush') p.onBrush();
                else p.onEraser();
            },
            isColumn: true
        });
        this.rootEl = (0, $eWjiX.BB).el({
            css: {}
        });
        this.rootEl.append(this.brushOptions.getElement());
    }
    (0, $7h4XF._)(MobileBrushUi, [
        {
            key: "setIsVisible",
            value: function setIsVisible(b) {
                this.rootEl.style.display = b ? 'block' : 'none';
            }
        },
        {
            key: "setType",
            value: function setType(type) {
                this.brushOptions.setValue(type, true);
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return MobileBrushUi;
}();



var $eIcQa = parcelRequire("eIcQa");

var $bX4ja = parcelRequire("bX4ja");

var $esGm2 = parcelRequire("esGm2");



var $eWjiX = parcelRequire("eWjiX");
function $f2b7ac9d4f1c1625$export$f8f3f96593f6a47(project) {
    var lastId = '';
    var layerMap = Object.fromEntries(project.layers.map(function(layer, index) {
        lastId = (0, $47ad43347dcf2f3c$export$b2ce7a8a096070e2)();
        var tiles = [];
        if (layer.image instanceof Array) tiles = (0, $bX4ja._)(layer.image);
        else {
            var canvas = function() {
                if (layer.image instanceof HTMLCanvasElement) return layer.image;
                var canvas = (0, $eWjiX.BB).canvas(project.width, project.height);
                var ctx = (0, $eWjiX.BB).ctx(canvas);
                if ((0, $esGm2.isLayerFill)(layer.image)) {
                    ctx.fillStyle = layer.image.fill;
                    ctx.fillRect(0, 0, project.width, project.height);
                } else ctx.drawImage(layer.image, 0, 0);
                return canvas;
            }();
            tiles = (0, $1a6c9997bc8182ff$export$7b1ba44282f9a519)(canvas);
        }
        var _layer_mixModeStr;
        return [
            lastId,
            {
                name: layer.name,
                opacity: layer.opacity,
                isVisible: layer.isVisible,
                mixModeStr: (_layer_mixModeStr = layer.mixModeStr) !== null && _layer_mixModeStr !== void 0 ? _layer_mixModeStr : 'source-over',
                index: index,
                tiles: tiles
            }
        ];
    }));
    return {
        projectId: {
            value: project.projectId
        },
        size: {
            width: project.width,
            height: project.height
        },
        selection: {},
        activeLayerId: lastId,
        layerMap: layerMap
    };
}




var $aSJRf = parcelRequire("aSJRf");

var $7jh4K = parcelRequire("7jh4K");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");
var $248aa716a9226bd7$export$747c5e57cda7ca57 = /*#__PURE__*/ function() {
    "use strict";
    function UnloadWarningTrigger(p) {
        var _this = this;
        (0, $cx0mh._)(this, UnloadWarningTrigger);
        this.onBeforeUnload = function(e) {
            e.preventDefault();
            e.returnValue = '';
        };
        this.klHistory = p.klHistory;
        this.getLastSavedHistoryIndex = p.getLastSavedHistoryIndex;
        p.klHistory.addListener(function() {
            return _this.update();
        });
    }
    (0, $7h4XF._)(UnloadWarningTrigger, [
        {
            key: "update",
            value: function update() {
                var historyIndex = this.klHistory.getTotalIndex();
                if (this.getLastSavedHistoryIndex() !== historyIndex) window.addEventListener('beforeunload', this.onBeforeUnload);
                else window.removeEventListener('beforeunload', this.onBeforeUnload);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
            //...
            }
        }
    ]);
    return UnloadWarningTrigger;
}();



var $jTg9g = parcelRequire("jTg9g");


var $1LaJZ = parcelRequire("1LaJZ");

var $fk3zw = parcelRequire("fk3zw");

var $eWjiX = parcelRequire("eWjiX");
var $b07b255a18a05a27$export$bb5ee47d9ea2348e;
var $b07b255a18a05a27$export$534219b709288da9;
var $b07b255a18a05a27$export$8001e369bcc9b474;
var $b07b255a18a05a27$export$efe229eab43a9869;
var $b07b255a18a05a27$export$ad430d422a89f9f0;
var $b07b255a18a05a27$export$48c2d0f2f545ac27;
var $b07b255a18a05a27$export$4a3e8128f471434a;
var $b07b255a18a05a27$export$e8e78c978b129247;
var $b07b255a18a05a27$export$bbeb943159d69f5b;
$b07b255a18a05a27$export$bb5ee47d9ea2348e = `RP219q_banner`;
$b07b255a18a05a27$export$534219b709288da9 = `RP219q_btn`;
$b07b255a18a05a27$export$8001e369bcc9b474 = `RP219q_closeArea`;
$b07b255a18a05a27$export$efe229eab43a9869 = `RP219q_closeButton`;
$b07b255a18a05a27$export$ad430d422a89f9f0 = `RP219q_mainContent`;
$b07b255a18a05a27$export$48c2d0f2f545ac27 = `RP219q_preview`;
$b07b255a18a05a27$export$4a3e8128f471434a = `RP219q_rightCol`;
$b07b255a18a05a27$export$e8e78c978b129247 = `RP219q_root`;
$b07b255a18a05a27$export$bbeb943159d69f5b = `RP219q_rootAnim`;
$b07b255a18a05a27$export$bbeb943159d69f5b;




var $7jh4K = parcelRequire("7jh4K");

var $3uJxV = parcelRequire("3uJxV");

function $ee60bdc4a11355ae$export$4a2ed1038e76f37f(p) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var _p_klRecoveryManager, openedProjectIds, crossTabChannel, otherIdListener, meta, fit, closeButton, preview, title, buttonClass, openBtn, rightCol, mainContent, closeArea, banner, rootEl, timeout, onPointerDown;
        function close() {
            clearTimeout(timeout);
            document.removeEventListener('pointerdown', onPointerDown);
            (0, $7jh4K.css)(rootEl, {
                opacity: '0'
            });
            (0, $7jh4K.css)(banner, {
                pointerEvents: 'none'
            });
            setTimeout(function() {
                rootEl.remove();
            }, 200);
        }
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    /*
    only show banner if all:
    - nothing was recovered
    - project store is not empty
    - no other tab has this project already open (prevent confusion)
     */ if (!p.projectStore) // no store -> noop
                    return [
                        2
                    ];
                    openedProjectIds = [];
                    crossTabChannel = new (0, $3uJxV.CrossTabChannel)('kl-tab-communication');
                    // subscription stays up during run of application
                    crossTabChannel.subscribe(function(message) {
                        if (message.type === 'request-project-ids') crossTabChannel.postMessage({
                            type: 'response-project-id',
                            id: p.klHistory.getComposed().projectId.value
                        });
                    });
                    otherIdListener = function(message) {
                        if (message.type === 'response-project-id') openedProjectIds.push(message.id);
                    };
                    crossTabChannel.subscribe(otherIdListener);
                    crossTabChannel.postMessage({
                        type: 'request-project-ids'
                    });
                    return [
                        4,
                        (0, $7jh4K.sleep)(100)
                    ];
                case 1:
                    _state.sent();
                    crossTabChannel.unsubscribe(otherIdListener);
                    if (((_p_klRecoveryManager = p.klRecoveryManager) === null || _p_klRecoveryManager === void 0 ? void 0 : _p_klRecoveryManager.getTabId()) !== undefined) // something already recovered -> noop
                    return [
                        2
                    ];
                    return [
                        4,
                        p.projectStore.readMeta()
                    ];
                case 2:
                    meta = _state.sent();
                    if (!meta) // nothing stored -> noop
                    return [
                        2
                    ];
                    if (openedProjectIds.includes(meta.projectId)) // already open in other tab -> noop
                    return [
                        2
                    ];
                    fit = (0, $7jh4K.fitInto)(meta.thumbnail.width, meta.thumbnail.height, 100, 100);
                    (0, $7jh4K.css)(meta.thumbnail, {
                        width: fit.width + 'px',
                        height: fit.height + 'px'
                    });
                    closeButton = (0, $eWjiX.BB).el({
                        tagName: 'button',
                        className: $b07b255a18a05a27$export$efe229eab43a9869 + ' popup-x',
                        content: `<img alt="${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('modal-close')}" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($e33dc4efcac9043e$exports)))}">`,
                        title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('modal-close'),
                        custom: {
                            tabindex: '0'
                        }
                    });
                    closeButton.onclick = close;
                    preview = (0, $eWjiX.BB).el({
                        className: $b07b255a18a05a27$export$48c2d0f2f545ac27,
                        content: meta.thumbnail,
                        title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-open')
                    });
                    preview.onclick = function() {
                        close();
                        p.onOpenBrowserStorage();
                    };
                    title = (0, $eWjiX.BB).el({
                        content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage')
                    });
                    buttonClass = $b07b255a18a05a27$export$534219b709288da9;
                    openBtn = (0, $eWjiX.BB).el({
                        tagName: 'button',
                        className: [
                            'kl-button-primary',
                            buttonClass
                        ].join(' '),
                        content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-open'),
                        custom: {
                            tabIndex: '-1'
                        }
                    });
                    openBtn.onclick = function() {
                        close();
                        p.onOpenBrowserStorage();
                    };
                    rightCol = (0, $eWjiX.BB).el({
                        className: $b07b255a18a05a27$export$4a3e8128f471434a,
                        content: [
                            title,
                            openBtn
                        ]
                    });
                    mainContent = (0, $eWjiX.BB).el({
                        className: $b07b255a18a05a27$export$ad430d422a89f9f0,
                        content: [
                            preview,
                            rightCol
                        ]
                    });
                    closeArea = (0, $eWjiX.BB).el({
                        className: $b07b255a18a05a27$export$8001e369bcc9b474
                    });
                    closeArea.onclick = close;
                    banner = (0, $eWjiX.BB).el({
                        className: $b07b255a18a05a27$export$bb5ee47d9ea2348e,
                        content: [
                            closeArea,
                            mainContent,
                            closeButton
                        ]
                    });
                    banner.onclick = (0, $eWjiX.BB).handleClick;
                    rootEl = (0, $eWjiX.BB).el({
                        content: [
                            banner
                        ],
                        className: $b07b255a18a05a27$export$e8e78c978b129247
                    });
                    document.body.append(rootEl);
                    timeout = setTimeout(close, 4500);
                    onPointerDown = function(e) {
                        var target = e.target;
                        if (banner.contains(target) || banner.contains(target)) return;
                        close();
                    };
                    document.addEventListener('pointerdown', onPointerDown, {
                        passive: false
                    });
                    return [
                        2
                    ];
            }
        });
    })();
}




var $3uJxV = parcelRequire("3uJxV");

var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $eWjiX = parcelRequire("eWjiX");





var $cx0mh = parcelRequire("cx0mh");

var $7h4XF = parcelRequire("7h4XF");

var $cL71g = parcelRequire("cL71g");

var $eWjiX = parcelRequire("eWjiX");

var $eg83P = parcelRequire("eg83P");



var $7jh4K = parcelRequire("7jh4K");
var $a6a4d7bf66434db3$export$a82a053f5f536d09 = /*#__PURE__*/ function() {
    "use strict";
    function MobileFloatingWindow(p) {
        var _this = this;
        (0, $cx0mh._)(this, MobileFloatingWindow);
        this.position = (0, $cL71g._)({}, p.position);
        this.xButton = (0, $eWjiX.BB).el({
            tagName: 'button',
            className: 'popup-x',
            content: `<img alt="${(0, $8d7403abedf7cefa$export$ce37e184d908d785)('modal-close')}" height="20" src="${(0, (/*@__PURE__*/$parcel$interopDefault($e33dc4efcac9043e$exports)))}">`,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('modal-close'),
            noRef: true,
            onClick: function() {
                p.onClose();
            },
            css: {
                width: '32px',
                height: '32px',
                lineHeight: '32px',
                background: 'none',
                boxShadow: 'none'
            },
            custom: {
                tabindex: '0'
            }
        });
        var header = (0, $eWjiX.BB).el({
            className: 'kl-floating-window-header'
        });
        header.append(this.xButton);
        var body = (0, $eWjiX.BB).el({
            content: p.content
        });
        var downPosition = {
            x: 0,
            y: 0
        };
        this.pointerListener = new (0, $eWjiX.BB).PointerListener({
            target: header,
            onPointer: function(event) {
                event.eventPreventDefault();
                if (event.button === 'left' && event.type === 'pointerdown') downPosition = (0, $cL71g._)({}, _this.position);
                if (event.button === 'left' && event.type === 'pointermove') {
                    _this.position.x = downPosition.x + event.pageX - event.downPageX;
                    _this.position.y = downPosition.y + event.pageY - event.downPageY;
                    _this.applyPosition();
                }
            }
        });
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                position: 'fixed',
                display: 'flex',
                flexDirection: 'column',
                left: this.position.x + 'px',
                top: this.position.y + 'px'
            }
        });
        this.rootEl.append(header, body);
        setTimeout(function() {
            return _this.applyPosition();
        });
    }
    (0, $7h4XF._)(MobileFloatingWindow, [
        {
            key: "applyPosition",
            value: function applyPosition() {
                var rect = this.rootEl.getBoundingClientRect();
                this.position.x = (0, $eg83P.clamp)(this.position.x, 0, window.innerWidth - rect.width);
                this.position.y = (0, $eg83P.clamp)(this.position.y, 0, window.innerHeight - rect.height);
                (0, $7jh4K.css)(this.rootEl, {
                    left: this.position.x + 'px',
                    top: this.position.y + 'px'
                });
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "getPosition",
            value: function getPosition() {
                return (0, $cL71g._)({}, this.position);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.pointerListener.destroy();
            }
        }
    ]);
    return MobileFloatingWindow;
}();



var $6fc6caead7b75ed5$export$f27d6e4616dd9b30 = /*#__PURE__*/ function() {
    "use strict";
    function MobileColorUi(p) {
        var _this = this;
        (0, $cx0mh._)(this, MobileColorUi);
        this.colorPickerPosition = {
            x: 100,
            y: 100
        };
        this.color = {
            r: 0,
            g: 0,
            b: 0
        };
        this.color = (0, $cL71g._)({}, p.color);
        this.colorCircle = (0, $eWjiX.BB).el({
            css: {
                width: '30px',
                height: '30px',
                background: (0, $eWjiX.BB).ColorConverter.toRgbStr(p.color),
                borderRadius: '100%',
                boxShadow: '0 0 0 1px rgba(0,0,0,0.5), inset 0 0 0 1px rgba(255,255,255,0.5)',
                alignSelf: 'center',
                cursor: 'pointer'
            },
            noRef: true,
            onClick: function() {
                if (_this.colorPicker) {
                    _this.closeColorPicker();
                    return;
                }
                _this.colorPicker = new (0, $3ce0af1e789f1ab4$export$66306bf21a9ff39e)({
                    width: 200,
                    heightSV: 200,
                    heightH: 30,
                    color: _this.color,
                    callback: p.onColorChange
                });
                _this.colorWindow = new (0, $a6a4d7bf66434db3$export$a82a053f5f536d09)({
                    content: (0, $eWjiX.BB).el({
                        content: _this.colorPicker.getElement()
                    }),
                    onClose: function() {
                        _this.closeColorPicker();
                    },
                    position: _this.colorPickerPosition
                });
                document.body.append(_this.colorWindow.getElement());
            }
        });
        var icon = new (0, $eae820938baa028e$export$f04a61298a47a40f)({
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($c698add026ba173f$exports))),
            width: 1,
            height: 1,
            css: {
                width: '100%',
                height: '100%'
            },
            darkInvert: true
        });
        this.eyedropperToggle = new (0, $afe02cc26c765c2c$export$2358c75ad3c15b2d)({
            init: false,
            title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('eyedropper'),
            onChange: function(b) {
                p.onEyedropper(b);
            },
            label: (0, $eWjiX.BB).el({
                content: icon.getElement(),
                css: {
                    padding: '6px',
                    height: '36px'
                }
            })
        });
        this.rootEl = (0, $eWjiX.BB).el({
            css: {
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
            }
        });
        this.rootEl.append(this.colorCircle, this.eyedropperToggle.getElement());
    }
    (0, $7h4XF._)(MobileColorUi, [
        {
            key: "getIsEyedropping",
            value: function getIsEyedropping() {
                return this.eyedropperToggle.getValue();
            }
        },
        {
            key: "setIsEyedropping",
            value: function setIsEyedropping(b) {
                this.eyedropperToggle.setValue(b);
            }
        },
        {
            key: "setColor",
            value: function setColor(color) {
                var _this_colorPicker;
                this.color = (0, $cL71g._)({}, color);
                this.colorCircle.style.backgroundColor = (0, $eWjiX.BB).ColorConverter.toRgbStr(color);
                (_this_colorPicker = this.colorPicker) === null || _this_colorPicker === void 0 ? void 0 : _this_colorPicker.setColor(color);
            }
        },
        {
            key: "closeColorPicker",
            value: function closeColorPicker() {
                var _this_colorPicker;
                if (this.colorWindow) {
                    var _this_colorWindow, _this_colorWindow1;
                    this.colorPickerPosition = this.colorWindow.getPosition();
                    (_this_colorWindow = this.colorWindow) === null || _this_colorWindow === void 0 ? void 0 : _this_colorWindow.destroy();
                    (_this_colorWindow1 = this.colorWindow) === null || _this_colorWindow1 === void 0 ? void 0 : _this_colorWindow1.getElement().remove();
                    this.colorWindow = undefined;
                }
                (_this_colorPicker = this.colorPicker) === null || _this_colorPicker === void 0 ? void 0 : _this_colorPicker.destroy();
                this.colorPicker = undefined;
            }
        },
        {
            key: "setIsVisible",
            value: function setIsVisible(b) {
                this.rootEl.style.display = b ? 'flex' : 'none';
                if (!b) this.closeColorPicker();
            }
        },
        {
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        }
    ]);
    return MobileColorUi;
}();



var $9b3eo = parcelRequire("9b3eo");
(0, $4bb0d03ef02dc0c0$export$4283b00eae4a6956)();
var $cf5d938ee512ebca$export$96f6458b62e4c2c = /*#__PURE__*/ function() {
    "use strict";
    function KlApp(p) {
        var _this = this;
        var _this1 = this;
        (0, $cx0mh._)(this, KlApp);
        var _this_saveReminder;
        this.collapseThreshold = 820;
        this.toolWidth = 271;
        this.lastSavedHistoryIndex = 0;
        this.getPSD = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                return (0, $fk3zw._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $40b8cea12adf584e$export$92433b641be3f7a)(this.klCanvas)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            }).call(_this);
        };
        this.embed = p.embed;
        // default 2048, unless your screen is bigger than that (that computer then probably has the horsepower for that)
        // but not larger than 4096 - a fairly arbitrary decision
        var maxCanvasSize = Math.min(4096, Math.max(2048, Math.max(window.screen.width, window.screen.height)));
        this.uiLayout = this.embed ? 'left' : (0, $6l0gQ.LocalStorage).getItem('uiState') ? (0, $6l0gQ.LocalStorage).getItem('uiState') : 'right';
        var projectStore = (0, $jTg9g.KL_INDEXED_DB).getIsAvailable() ? new (0, $6mTnI.ProjectStore)() : undefined;
        this.rootEl = (0, $eWjiX.BB).el({
            className: 'g-root',
            css: {
                position: 'absolute',
                left: '0',
                top: '0',
                right: '0',
                bottom: '0'
            }
        });
        this.uiWidth = Math.max(0, window.innerWidth);
        this.uiHeight = Math.max(0, window.innerHeight);
        var exportType = 'png';
        var initialWidth = Math.max(10, Math.min(maxCanvasSize, window.innerWidth < this.collapseThreshold ? this.uiWidth : this.uiWidth - this.toolWidth));
        var initialHeight = Math.max(10, Math.min(maxCanvasSize, this.uiHeight));
        var _p_project;
        this.klHistory = new (0, $gWfkn.KlHistory)({
            oldest: (0, $f2b7ac9d4f1c1625$export$f8f3f96593f6a47)((_p_project = p.project) !== null && _p_project !== void 0 ? _p_project : {
                projectId: (0, $7jh4K.randomUuid)(),
                width: initialWidth,
                height: initialHeight,
                layers: [
                    {
                        name: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers-layer') + ' 1',
                        opacity: 1,
                        isVisible: true,
                        mixModeStr: 'source-over',
                        image: {
                            fill: (0, $eWjiX.BB).ColorConverter.toRgbStr({
                                r: (0, $00f785a5ea9e210d$export$e4203cb02d5e5b28),
                                g: (0, $00f785a5ea9e210d$export$e4203cb02d5e5b28),
                                b: (0, $00f785a5ea9e210d$export$e4203cb02d5e5b28)
                            })
                        }
                    }
                ]
            })
        });
        var klRecoveryManager = p.klRecoveryManager;
        if (klRecoveryManager) {
            klRecoveryManager.setKlHistory(this.klHistory);
            klRecoveryManager.setGetThumbnail(function(factor) {
                return (0, $aSJRf.drawProject)(_this.klCanvas.getProject(), factor);
            });
        }
        if (p.project) // attempt at freeing memory
        p.project.layers.forEach(function(layer) {
            if (layer.image instanceof HTMLCanvasElement) (0, $eWjiX.BB).freeCanvas(layer.image);
            layer.image = null;
        });
        this.klCanvas = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).KlCanvas(this.klHistory, this.embed ? -1 : 1);
        var tempHistory = new (0, $d3a44cd9d3ee7598$export$ab82e91194f5da86)();
        var mainTabRow = undefined;
        var clearLayer = function(showStatus, ignoreSelection) {
            applyUncommitted();
            var layerIndex = currentLayer.index;
            _this.klCanvas.eraseLayer({
                layerIndex: layerIndex,
                useAlphaLock: layerIndex === 0 && !brushUiMap.eraserBrush.getIsTransparentBg(),
                useSelection: !ignoreSelection
            });
            showStatus && _this.statusOverlay.out(_this.klCanvas.getSelection() ? (0, $8d7403abedf7cefa$export$ce37e184d908d785)('cleared-selected-area') : (0, $8d7403abedf7cefa$export$ce37e184d908d785)('cleared-layer'), true);
        };
        var currentColor = new (0, $eWjiX.BB).RGB(0, 0, 0);
        var currentBrushUi;
        var currentBrushId;
        var lastNonEraserBrushId;
        var currentLayer = this.klCanvas.getLayer(this.klCanvas.getLayerCount() - 1);
        // when cycling through brushes you need to know the next non-eraser brush
        var getNextBrushId = function() {
            if (currentBrushId === 'eraserBrush') return lastNonEraserBrushId;
            var keyArr = Object.keys(brushUiMap).filter(function(item) {
                return item !== 'eraserBrush';
            });
            var i = keyArr.findIndex(function(item) {
                return item === currentBrushId;
            });
            return keyArr[(i + 1) % keyArr.length];
        };
        var sizeWatcher = function(val) {
            brushSettingService.emitSize(val);
            if (_this.easelBrush) _this.easelBrush.setBrush({
                radius: val
            });
        };
        var brushSettingService = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BrushSettingService({
            onSetColor: function(color) {
                _this.klColorSlider.setColor(color);
                currentBrushUi.setColor(color);
                _this.mobileColorUi.setColor(color);
                currentColor = (0, $eWjiX.BB).copyObj(color);
            },
            onSetSize: function(size) {
                currentBrushUi.setSize(size);
                _this.easelBrush.setBrush({
                    radius: size
                });
            },
            onSetOpacity: function(opacity) {
                currentBrushUi.setOpacity(opacity);
            },
            onSetScatter: function(scatter) {
                currentBrushUi.setScatter(scatter);
            },
            onGetColor: function() {
                return _this.klColorSlider.getColor();
            },
            onGetSize: function() {
                return brushUiMap[currentBrushId].getSize();
            },
            onGetOpacity: function() {
                return brushUiMap[currentBrushId].getOpacity();
            },
            onGetScatter: function() {
                return brushUiMap[currentBrushId].getScatter();
            },
            onGetSliderConfig: function() {
                return {
                    sizeSlider: (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].sizeSlider,
                    opacitySlider: (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].opacitySlider,
                    scatterSlider: (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].scatterSlider
                };
            }
        });
        var lineSmoothing = new (0, $3adbeb1f050c09d3$export$c57e2ed65bcf4d6a)({
            smoothing: (0, $7aa12ecc06c22770$export$bcd109042a2e4bb5)(1)
        });
        this.lineSanitizer = new (0, $73298182992a8985$export$91dcf4209534d21f)();
        var drawEventChain = new (0, $eWjiX.BB).EventChain({
            chainArr: [
                this.lineSanitizer,
                lineSmoothing
            ]
        });
        var ANIM_FRAME_COUNT = 3;
        var originalHistoryPush = this.klHistory.push.bind(this.klHistory);
        var isFrameAwareBrush = function() {
            var brush = currentBrushUi.getBrush();
            return brush && typeof brush.setExtraContexts === 'function';
        };
        // Event replay state for non-frame-aware brushes on animated layers.
        // Instead of a multi-context proxy, we draw on frame 0 normally, then
        // replay the same stroke independently on each extra frame so that
        // pixel-reading brushes (blend, smudge) produce per-frame-different results.
        var replayNeeded = false;
        var replayEventBuffer = [];
        var replayLineEvent = null;
        var heldHistoryEntry = null;
        var heldReplaceTop = false;
        // Setup frame drawing before a brush stroke.
        // - PenBrush (frame-aware): uses setExtraContexts for scatter
        // - Other brushes: event replay — draw on frame 0, then replay on extra frames
        var setupBrushFrames = function() {
            var brush = currentBrushUi.getBrush();
            if (!brush) return;
            if (isFrameAwareBrush()) {
                // PenBrush path: use its own multi-frame scatter logic
                if (typeof brush.getScatter !== 'function') return;
                var layerIndex = _this.klCanvas.getLayerIndex(currentLayer.canvas, true);
                if (layerIndex === null) return;
                if (brush.getScatter() > 0) {
                    _this.klCanvas.initLayerFrames(layerIndex, ANIM_FRAME_COUNT);
                    var updatedLayer = _this.klCanvas.getLayer(layerIndex);
                    if (updatedLayer.frameContexts) brush.setExtraContexts(updatedLayer.frameContexts.slice(1));
                } else if (currentLayer.frames && currentLayer.frames.length > 1) {
                    var refreshedLayer = _this.klCanvas.getLayer(layerIndex);
                    brush.setExtraContexts(refreshedLayer.frameContexts.slice(1));
                } else brush.setExtraContexts([]);
            } else if (currentLayer.frames && currentLayer.frames.length > 1) {
                // Non-frame-aware brush on animated layer: use event replay.
                // Draw on frame 0 only, then replay on extra frames after endLine.
                replayNeeded = true;
                replayEventBuffer = [];
                replayLineEvent = null;
                heldHistoryEntry = null;
                heldReplaceTop = false;
                // Pause animation during drawing to avoid flickering
                // (only frame 0 is being drawn on until replay completes).
                _this.easel.setAnimPaused(true);
                // Intercept history push — hold entry until replay is done.
                _this.klHistory.push = function(entryData, replaceTop) {
                    heldHistoryEntry = entryData;
                    heldReplaceTop = replaceTop;
                };
            }
        };
        // After the primary brush finishes, replay on extra frames and push history.
        var cleanupBrushFrames = function() {
            if (!replayNeeded) return;
            var brush = currentBrushUi.getBrush();
            var layer = currentLayer;
            try {
                if (heldHistoryEntry && layer.frames && layer.frames.length > 1) {
                    var _heldHistoryEntry_layerMap, _ld_tiles, _ld_tiles1;
                    var composed = _this.klHistory.getComposed();
                    var activeId = composed.activeLayerId;
                    var ld = (_heldHistoryEntry_layerMap = heldHistoryEntry.layerMap) === null || _heldHistoryEntry_layerMap === void 0 ? void 0 : _heldHistoryEntry_layerMap[activeId];
                    console.log('[frame-replay] start', {
                        hasHeldEntry: !!heldHistoryEntry,
                        frameCount: layer.frames.length,
                        hasTiles: !!(ld === null || ld === void 0 ? void 0 : ld.tiles),
                        tilesDefined: ld === null || ld === void 0 ? void 0 : (_ld_tiles = ld.tiles) === null || _ld_tiles === void 0 ? void 0 : _ld_tiles.filter(function(t) {
                            return t !== undefined;
                        }).length,
                        totalTiles: ld === null || ld === void 0 ? void 0 : (_ld_tiles1 = ld.tiles) === null || _ld_tiles1 === void 0 ? void 0 : _ld_tiles1.length,
                        bufferLen: replayEventBuffer.length,
                        isLineEvent: !!replayLineEvent
                    });
                    if (ld === null || ld === void 0 ? void 0 : ld.tiles) {
                        var _loop = function(f) {
                            // Intercept the replay's history push to grab its tiles
                            var replayedTiles = null;
                            _this.klHistory.push = function(entryData) {
                                if (entryData.layerMap) {
                                    var rld = entryData.layerMap[activeId];
                                    if (rld === null || rld === void 0 ? void 0 : rld.tiles) replayedTiles = rld.tiles;
                                }
                            };
                            // Swap brush context to this frame
                            currentBrushUi.setLayer((0, $4EWN2._)((0, $cL71g._)({}, layer), {
                                context: layer.frameContexts[f],
                                canvas: layer.frames[f]
                            }));
                            if (replayLineEvent) // Replay a drawLineSegment call
                            brush.drawLineSegment(replayLineEvent.x0, replayLineEvent.y0, replayLineEvent.x1, replayLineEvent.y1);
                            else if (replayEventBuffer.length > 0) {
                                // Replay through brush UI (not brush directly) to ensure
                                // the same parameter transformations as the primary stroke.
                                // E.g. blend-brush-ui always passes isCoalesced=false.
                                var first = replayEventBuffer[0];
                                currentBrushUi.startLine(first.x, first.y, first.p);
                                for(var _$e = 1; _$e < replayEventBuffer.length; _$e++){
                                    var ev = replayEventBuffer[_$e];
                                    currentBrushUi.goLine(ev.x, ev.y, ev.p, ev.isCoalesced);
                                }
                                currentBrushUi.endLine();
                            }
                            // Capture tiles using union of primary + replay changed positions.
                            // This ensures compose doesn't incorrectly fall back to frame 0 content.
                            var unionChanged = ld.tiles.map(function(t, i) {
                                return t !== undefined || replayedTiles && replayedTiles[i] !== undefined;
                            });
                            var primaryCount = ld.tiles.filter(function(t) {
                                return t !== undefined;
                            }).length;
                            var replayCount = replayedTiles ? replayedTiles.filter(function(t) {
                                return t !== undefined;
                            }).length : 0;
                            var unionCount = unionChanged.filter(function(t) {
                                return t;
                            }).length;
                            console.log(`[frame-replay] frame ${f}: primary=${primaryCount} replay=${replayCount} union=${unionCount} replayedTiles=${!!replayedTiles}`);
                            ld.frameTiles.push((0, $1a6c9997bc8182ff$export$6706c882ea9c3dbd)(layer.frames[f], unionChanged));
                        };
                        ld.frameTiles = [];
                        // Enable replay mode so pixel-reading brushes read
                        // from the frame canvas instead of composed tiles.
                        if (typeof brush.setReplayMode === 'function') brush.setReplayMode(true);
                        for(var f = 1; f < layer.frames.length; f++)_loop(f);
                    }
                    if (typeof brush.setReplayMode === 'function') brush.setReplayMode(false);
                    // Restore context to frame 0
                    currentBrushUi.setLayer(layer);
                    // Actually push the augmented history entry
                    _this.klHistory.push = originalHistoryPush;
                    originalHistoryPush(heldHistoryEntry, heldReplaceTop);
                } else {
                    // Nothing to replay — push held entry as-is if any
                    _this.klHistory.push = originalHistoryPush;
                    if (heldHistoryEntry) originalHistoryPush(heldHistoryEntry, heldReplaceTop);
                }
            } catch (e) {
                console.warn('[frame-replay]', e);
                _this.klHistory.push = originalHistoryPush;
                if (heldHistoryEntry) originalHistoryPush(heldHistoryEntry, heldReplaceTop);
            }
            _this.easel.setAnimPaused(false);
            replayNeeded = false;
            replayEventBuffer = [];
            replayLineEvent = null;
            heldHistoryEntry = null;
        };
        drawEventChain.setChainOut(function(event) {
            if (event.type === 'down') {
                _this.toolspace.style.pointerEvents = 'none';
                setupBrushFrames();
                if (replayNeeded) replayEventBuffer.push({
                    x: event.x,
                    y: event.y,
                    p: event.pressure
                });
                currentBrushUi.startLine(event.x, event.y, event.pressure);
                _this.easelBrush.setLastDrawEvent({
                    x: event.x,
                    y: event.y
                });
                _this.easel.requestRender();
            }
            if (event.type === 'move') {
                if (replayNeeded) replayEventBuffer.push({
                    x: event.x,
                    y: event.y,
                    p: event.pressure,
                    isCoalesced: event.isCoalesced
                });
                currentBrushUi.goLine(event.x, event.y, event.pressure, event.isCoalesced);
                _this.easelBrush.setLastDrawEvent({
                    x: event.x,
                    y: event.y
                });
                _this.easel.requestRender();
            }
            if (event.type === 'up') {
                _this.toolspace.style.pointerEvents = '';
                currentBrushUi.endLine();
                cleanupBrushFrames();
                _this.easel.requestRender();
            }
            if (event.type === 'line') {
                setupBrushFrames();
                if (replayNeeded) replayLineEvent = {
                    x0: event.x0,
                    y0: event.y0,
                    x1: event.x1,
                    y1: event.y1
                };
                currentBrushUi.getBrush().drawLineSegment(event.x0, event.y0, event.x1, event.y1);
                cleanupBrushFrames();
                _this.easelBrush.setLastDrawEvent({
                    x: event.x1,
                    y: event.y1
                });
                _this.easel.requestRender();
            }
        });
        var textToolSettings = {
            size: 20,
            align: 'left',
            isBold: false,
            isItalic: false,
            font: 'sans-serif',
            letterSpacing: 0,
            lineHeight: 1,
            fill: {
                color: {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 1
                }
            }
        };
        /**
         * Uncommited action is something like select tool > transform which puts the canvas and UI into
         * a temporary state. Changes need to be committed or discarded *before* doing something else.
         *
         * returns true if something was applied
         */ var applyUncommitted = function() {
            var didApply = false;
            if (_this.easel.getTool() === 'select') didApply = klAppSelect.commitTransform();
            return didApply;
        };
        /** see applyUncommitted **/ var discardUncommitted = function() {
            if (_this.easel.getTool() === 'select') return klAppSelect.discardTransform();
            return false;
        };
        var propagateUndoRedoChanges = function(type, composedBefore) {
            if ([
                'undo',
                'redo'
            ].includes(type)) {
                var composedAfter = _this.klHistory.getComposed();
                _this.klCanvas.updateViaComposed(composedBefore, composedAfter);
                setCurrentLayer(_this.klCanvas.getLayer(composedAfter.layerMap[composedAfter.activeLayerId].index));
                _this.easelProjectUpdater.update(); // triggers render
                var dimensionChanged = composedBefore.size.width !== composedAfter.size.width || composedBefore.size.height !== composedAfter.size.height;
                if (dimensionChanged) _this.easel.resetOrFitTransform(true);
                _this.easelBrush.setLastDrawEvent();
                _this.layersUi.update(currentLayer.index);
            }
            klAppSelect.onHistory(type);
        };
        var undo = function(showMessage) {
            if (!tempHistory.canDecreaseIndex()) discardUncommitted();
            var composedBefore = _this.klHistory.getComposed();
            var result = klHistoryExecutor.undo();
            if (!result) // didn't do anything
            return;
            propagateUndoRedoChanges(result.type, composedBefore);
            if (showMessage) _this.statusOverlay.out((0, $8d7403abedf7cefa$export$ce37e184d908d785)('undo'), true);
        };
        var redo = function(showMessage) {
            var composedBefore = _this.klHistory.getComposed();
            var result = klHistoryExecutor.redo();
            if (!result) // didn't do anything
            return;
            propagateUndoRedoChanges(result.type, composedBefore);
            if (showMessage) _this.statusOverlay.out((0, $8d7403abedf7cefa$export$ce37e184d908d785)('redo'), true);
        };
        this.statusOverlay = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).StatusOverlay();
        var klAppSelect = new (0, $f177420b33748502$export$e471993a29671b7)({
            klCanvas: this.klCanvas,
            getCurrentLayerCtx: function() {
                return currentLayer.context;
            },
            onUpdateProject: function() {
                return _this.easelProjectUpdater.update();
            },
            klHistory: this.klHistory,
            tempHistory: tempHistory,
            statusOverlay: this.statusOverlay,
            onFill: function() {
                _this.klCanvas.layerFill(currentLayer.index, _this.klColorSlider.getColor(), undefined, true);
                _this.statusOverlay.out(_this.klCanvas.getSelection() ? (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filled-selected-area') : (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filled'), true);
            },
            onErase: function() {
                var layerIndex = currentLayer.index;
                _this.klCanvas.eraseLayer({
                    layerIndex: layerIndex,
                    useAlphaLock: layerIndex === 0 && !brushUiMap.eraserBrush.getIsTransparentBg(),
                    useSelection: true
                });
                _this.statusOverlay.out(_this.klCanvas.getSelection() ? (0, $8d7403abedf7cefa$export$ce37e184d908d785)('cleared-selected-area') : (0, $8d7403abedf7cefa$export$ce37e184d908d785)('cleared-layer'), true);
            }
        });
        this.easelBrush = new (0, $e63c9ca4199f5887$export$dfeedd8879a1038a)({
            radius: 5,
            onLineStart: function(e) {
                // expects TDrawEvent
                drawEventChain.chainIn({
                    type: 'down',
                    scale: _this.easel.getTransform().scale,
                    shiftIsPressed: keyListener.isPressed('shift'),
                    pressure: e.pressure,
                    isCoalesced: e.isCoalesced,
                    x: e.x,
                    y: e.y
                });
            },
            onLineGo: function(e) {
                // expects TDrawEvent
                drawEventChain.chainIn({
                    type: 'move',
                    scale: _this.easel.getTransform().scale,
                    shiftIsPressed: keyListener.isPressed('shift'),
                    pressure: e.pressure,
                    isCoalesced: e.isCoalesced,
                    x: e.x,
                    y: e.y
                });
            },
            onLineEnd: function() {
                // expects TDrawEvent
                drawEventChain.chainIn({
                    type: 'up',
                    scale: _this.easel.getTransform().scale,
                    shiftIsPressed: keyListener.isPressed('shift'),
                    isCoalesced: false
                });
            },
            onLine: function(p1, p2) {
                // expects TDrawEvent
                drawEventChain.chainIn({
                    type: 'line',
                    x0: p1.x,
                    y0: p1.y,
                    x1: p2.x,
                    y1: p2.y,
                    pressure0: 1,
                    pressure1: 1
                });
            }
        });
        var easelHand = new (0, $66028f220dcd865f$export$8202a4a90789f655)({});
        var easelShape = new (0, $ebd223e87e103321$export$f4821fa73b1145e5)({
            onDown: function(p, angleRad) {
                shapeTool.onDown(p.x, p.y, angleRad);
            },
            onMove: function(p) {
                shapeTool.onMove(p.x, p.y);
            },
            onUp: function(p) {
                shapeTool.onUp(p.x, p.y);
            }
        });
        var isFirstTransform = true;
        this.easel = new (0, $33e4247c53b6e65b$export$2732362bcaeb02c2)({
            width: Math.max(0, this.uiWidth - this.toolWidth),
            height: this.uiHeight,
            project: {
                width: this.klCanvas.getWidth(),
                height: this.klCanvas.getHeight(),
                layers: []
            },
            tools: {
                brush: this.easelBrush,
                hand: easelHand,
                select: klAppSelect.getEaselSelect(),
                eyedropper: new (0, $24db627c4c8e30c9$export$1fda302750a9ba48)({
                    onPick: function(p) {
                        var color = _this.klCanvas.getColorAt(p.x, p.y);
                        if (color) {
                            brushSettingService.setColor(color);
                            return color;
                        }
                        return brushSettingService.getColor();
                    },
                    onPickEnd: function() {
                        if (_this.klColorSlider.getIsEyedropping() || _this.mobileColorUi.getIsEyedropping()) {
                            _this.klColorSlider.setIsEyedropping(false);
                            _this.mobileColorUi.setIsEyedropping(false);
                            _this.easel.setTool(_this.toolspaceToolRow.getActive());
                        }
                    }
                }),
                paintBucket: new (0, $f8e6779c7f01196e$export$9b29623161064b87)({
                    onFill: function(p) {
                        _this.klCanvas.floodFill(currentLayer.index, p.x, p.y, fillUi.getIsEraser() ? null : _this.klColorSlider.getColor(), fillUi.getOpacity(), fillUi.getTolerance(), fillUi.getSample(), fillUi.getGrow(), fillUi.getContiguous());
                        _this.easel.requestRender();
                    }
                }),
                gradient: new (0, $04aa501093e072d1$export$11badb1ec62816a1)({
                    onDown: function(p, angleRad) {
                        gradientTool.onDown(p.x, p.y, angleRad);
                    },
                    onMove: function(p) {
                        gradientTool.onMove(p.x, p.y);
                    },
                    onUp: function(p) {
                        gradientTool.onUp(p.x, p.y);
                    }
                }),
                text: new (0, $43b8e046e203efe4$export$b10c22a3fee9197f)({
                    onDown: function(p, angleRad) {
                        if ((0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() > 0) return;
                        (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).textToolDialog({
                            klCanvas: _this.klCanvas,
                            layerIndex: currentLayer.index,
                            primaryColor: _this.klColorSlider.getColor(),
                            secondaryColor: _this.klColorSlider.getSecondaryRGB(),
                            text: (0, $4EWN2._)((0, $cL71g._)({}, textToolSettings), {
                                text: '',
                                x: p.x,
                                y: p.y,
                                angleRad: angleRad,
                                fill: textToolSettings.fill ? {
                                    color: (0, $4EWN2._)((0, $cL71g._)({}, _this.klColorSlider.getColor()), {
                                        a: textToolSettings.fill.color.a
                                    })
                                } : undefined,
                                stroke: textToolSettings.stroke ? (0, $4EWN2._)((0, $cL71g._)({}, textToolSettings.stroke), {
                                    color: (0, $4EWN2._)((0, $cL71g._)({}, _this.klColorSlider.getSecondaryRGB()), {
                                        a: textToolSettings.stroke.color.a
                                    })
                                }) : undefined
                            }),
                            onConfirm: function(val) {
                                textToolSettings = (0, $4EWN2._)((0, $cL71g._)({}, val), {
                                    text: ''
                                });
                                _this.klCanvas.text(currentLayer.index, val);
                            }
                        });
                    }
                }),
                shape: easelShape,
                rotate: new (0, $5af1201febea9911$export$f3b0846760df78b)({}),
                zoom: new (0, $e041531c7ca89b12$export$6c389c8425707374)({})
            },
            tool: 'brush',
            onChangeTool: function(toolId) {
                _this.mobileBrushUi.setIsVisible(toolId === 'brush');
                _this.mobileColorUi.setIsVisible(toolId !== 'select');
            },
            onTransformChange: function(transform, isScaleOrAngleChanged) {
                handUi.update(transform.scale, transform.angleDeg);
                _this.toolspaceToolRow.setEnableZoomIn(transform.scale !== (0, $991ab38832278e02$export$ac82c07320907c00));
                _this.toolspaceToolRow.setEnableZoomOut(transform.scale !== (0, $991ab38832278e02$export$5e2c057e240c0b8c));
                if (isScaleOrAngleChanged && !isFirstTransform) _this.statusOverlay.out({
                    type: 'transform',
                    scale: transform.scale,
                    angleDeg: transform.angleDeg
                });
                if (isFirstTransform) isFirstTransform = false;
            },
            onUndo: function() {
                undo(true);
            },
            onRedo: function() {
                redo(true);
            }
        });
        (0, $7jh4K.css)(this.easel.getElement(), {
            position: 'absolute',
            left: '0',
            top: '0'
        });
        this.easelProjectUpdater = new (0, $3dcbe6df163512b5$export$abfede0290e9bfba)({
            klCanvas: this.klCanvas,
            easel: this.easel
        });
        this.klHistory.addListener(function() {
            _this.easelProjectUpdater.update();
        });
        (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).DIALOG_COUNTER.subscribe(function(count) {
            _this.easel.setIsFrozen(count > 0);
        });
        var updateMainTabVisibility = function() {
            if (!mainTabRow) return;
            var toolObj = {
                brush: {},
                hand: {},
                paintBucket: {},
                gradient: {},
                text: {},
                shape: {},
                select: {}
            };
            var activeStr = _this.toolspaceToolRow.getActive();
            var oldTabId = mainTabRow.getOpenedTabId();
            var keysArr = Object.keys(toolObj);
            for(var i = 0; i < keysArr.length; i++)if (activeStr === keysArr[i]) mainTabRow.setIsVisible(keysArr[i], true);
            else {
                mainTabRow.setIsVisible(keysArr[i], false);
                if (oldTabId === keysArr[i]) mainTabRow.open(activeStr);
            }
        };
        var keyListener = new (0, $eWjiX.BB).KeyListener({
            onDown: function(keyStr, event, comboStr) {
                if ((0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() > 0 || (0, $eWjiX.BB).isInputFocused(true)) return;
                var isDrawing = _this.lineSanitizer.getIsDrawing() || _this.easel.getIsLocked();
                if (isDrawing) return;
                if (comboStr === 'home') _this.easel.fitTransform();
                if (comboStr === 'end') _this.easel.resetTransform();
                if ([
                    'ctrl+z',
                    'cmd+z'
                ].includes(comboStr)) {
                    event.preventDefault();
                    undo();
                }
                if ([
                    'ctrl+y',
                    'cmd+y'
                ].includes(comboStr) || ((0, $eWjiX.BB).sameKeys('ctrl+shift+z', comboStr) || (0, $eWjiX.BB).sameKeys('cmd+shift+z', comboStr)) && keyStr === 'z') {
                    event.preventDefault();
                    redo();
                }
                if (!_this.embed) {
                    if ([
                        'ctrl+s',
                        'cmd+s'
                    ].includes(comboStr)) {
                        event.preventDefault();
                        applyUncommitted();
                        _this.saveToComputer.save();
                    }
                    if ([
                        'ctrl+shift+s',
                        'cmd+shift+s'
                    ].includes(comboStr)) {
                        event.preventDefault();
                        applyUncommitted();
                        if (projectStore) (function() {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                var meta, project, doOverwrite, success, e;
                                return (0, $fk3zw._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                (0, $dc6d4b1d8d494091$export$f565b71ad023b7df)()
                                            ];
                                        case 1:
                                            _state.sent();
                                            meta = projectStore.getCurrentMeta();
                                            project = this.getProject();
                                            if (!(meta && meta.projectId !== project.projectId)) return [
                                                3,
                                                3
                                            ];
                                            return [
                                                4,
                                                new Promise(function(resolve, reject) {
                                                    (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
                                                        type: 'warning',
                                                        message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-overwrite-confirm'),
                                                        buttons: [
                                                            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-overwrite'),
                                                            'Cancel'
                                                        ],
                                                        callback: function(result) {
                                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                                                return (0, $fk3zw._)(this, function(_state) {
                                                                    if (result === 'Cancel') {
                                                                        resolve(false);
                                                                        return [
                                                                            2
                                                                        ];
                                                                    }
                                                                    resolve(true);
                                                                    return [
                                                                        2
                                                                    ];
                                                                });
                                                            })();
                                                        }
                                                    });
                                                })
                                            ];
                                        case 2:
                                            doOverwrite = _state.sent();
                                            if (!doOverwrite) return [
                                                2
                                            ];
                                            _state.label = 3;
                                        case 3:
                                            success = true;
                                            _state.label = 4;
                                        case 4:
                                            _state.trys.push([
                                                4,
                                                6,
                                                ,
                                                7
                                            ]);
                                            return [
                                                4,
                                                projectStore.store(this.klCanvas.getProject())
                                            ];
                                        case 5:
                                            _state.sent();
                                            return [
                                                3,
                                                7
                                            ];
                                        case 6:
                                            e = _state.sent();
                                            success = false;
                                            setTimeout(function() {
                                                throw new Error('keyboard-shortcut: failed to store browser storage, ' + e);
                                            }, 0);
                                            this.statusOverlay.out("\u274C " + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-failed'), true);
                                            return [
                                                3,
                                                7
                                            ];
                                        case 7:
                                            if (success) {
                                                this.updateLastSaved();
                                                this.statusOverlay.out((0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-stored'), true);
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }).call(_this);
                        })();
                        else _this.statusOverlay.out("\u274C " + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-failed'), true);
                    }
                    if ([
                        'ctrl+c',
                        'cmd+c'
                    ].includes(comboStr)) {
                        event.preventDefault();
                        applyUncommitted();
                        copyToClipboard(true);
                    }
                }
                if ([
                    'ctrl+a',
                    'cmd+a'
                ].includes(comboStr)) event.preventDefault();
                if (comboStr === 'sqbr_open') currentBrushUi.decreaseSize(Math.max(0.005, 0.03 / _this.easel.getTransform().scale));
                if (comboStr === 'sqbr_close') currentBrushUi.increaseSize(Math.max(0.005, 0.03 / _this.easel.getTransform().scale));
                if (comboStr === 'enter') {
                    if (!applyUncommitted()) {
                        _this.klCanvas.layerFill(currentLayer.index, _this.klColorSlider.getColor(), undefined, true);
                        _this.statusOverlay.out(_this.klCanvas.getSelection() ? (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filled-selected-area') : (0, $8d7403abedf7cefa$export$ce37e184d908d785)('filled'), true);
                    }
                }
                if (comboStr === 'esc') {
                    if (discardUncommitted()) event.preventDefault();
                }
                if ([
                    'delete',
                    'backspace'
                ].includes(comboStr)) clearLayer(true);
                if (comboStr === 'ctrl+shift+e' || comboStr === 'shift+ctrl+e') {
                    event.preventDefault();
                    _this.layersUi.advancedMergeDialog();
                }
                if (comboStr === 'shift+e') {
                    var _currentBrushUi_toggleEraser;
                    event.preventDefault();
                    (_currentBrushUi_toggleEraser = currentBrushUi.toggleEraser) === null || _currentBrushUi_toggleEraser === void 0 ? void 0 : _currentBrushUi_toggleEraser.call(currentBrushUi);
                } else if (comboStr === 'e') {
                    event.preventDefault();
                    applyUncommitted();
                    _this.easel.setTool('brush');
                    _this.toolspaceToolRow.setActive('brush');
                    mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open('brush');
                    updateMainTabVisibility();
                    brushTabRow.open('eraserBrush');
                }
                if (comboStr === 'b') {
                    event.preventDefault();
                    var prevMode = _this.easel.getTool();
                    var prevMainTabId = mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.getOpenedTabId();
                    applyUncommitted();
                    _this.easel.setTool('brush');
                    _this.toolspaceToolRow.setActive('brush');
                    mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open('brush');
                    updateMainTabVisibility();
                    brushTabRow.open(prevMode === 'brush' && prevMainTabId === 'brush' ? getNextBrushId() : currentBrushId);
                }
                if (comboStr === 'g') {
                    event.preventDefault();
                    applyUncommitted();
                    var newMode = _this.easel.getTool() === 'paintBucket' ? 'gradient' : 'paintBucket';
                    _this.easel.setTool(newMode);
                    _this.toolspaceToolRow.setActive(newMode);
                    mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open(newMode);
                    updateMainTabVisibility();
                }
                if (comboStr === 't') {
                    event.preventDefault();
                    applyUncommitted();
                    _this.easel.setTool('text');
                    _this.toolspaceToolRow.setActive('text');
                    mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open('text');
                    updateMainTabVisibility();
                }
                if (comboStr === 'u') {
                    event.preventDefault();
                    applyUncommitted();
                    _this.easel.setTool('shape');
                    _this.toolspaceToolRow.setActive('shape');
                    mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open('shape');
                    updateMainTabVisibility();
                }
                if (comboStr === 'l') {
                    event.preventDefault();
                    var prevTool = _this.easel.getTool();
                    var prevSelectMode = klAppSelect.getSelectMode();
                    var prevMainTabId1 = mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.getOpenedTabId();
                    applyUncommitted();
                    _this.easel.setTool('select');
                    _this.toolspaceToolRow.setActive('select');
                    mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open('select');
                    updateMainTabVisibility();
                    if (prevTool === 'select' && prevSelectMode === 'select' && prevMainTabId1 === 'select') klAppSelect.getSelectUi().setMode('transform');
                }
                if (comboStr === 'x') {
                    event.preventDefault();
                    _this.klColorSlider.swapColors();
                }
            },
            onUp: function(keyStr, event) {}
        });
        var brushUiMap = {};
        // create brush UIs
        Object.entries((0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BRUSHES_UI).forEach(function(param) {
            var _param = (0, $8N5YG._)(param, 2), b = _param[0], brushUi = _param[1];
            var ui = new brushUi.Ui({
                klHistory: _this.klHistory,
                onSizeChange: sizeWatcher,
                onScatterChange: function(scatter) {
                    brushSettingService.emitScatter(scatter);
                },
                onOpacityChange: function(opacity) {
                    brushSettingService.emitOpacity(opacity);
                },
                onConfigChange: function() {
                    brushSettingService.emitSliderConfig({
                        sizeSlider: (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].sizeSlider,
                        opacitySlider: (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].opacitySlider,
                        scatterSlider: (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BRUSHES_UI[currentBrushId].scatterSlider
                    });
                }
            });
            brushUiMap[b] = ui;
            ui.getElement().style.padding = "10px";
        });
        this.toolspace = (0, $eWjiX.BB).el({
            className: 'kl-toolspace',
            css: {
                position: 'absolute',
                right: '0',
                top: '0',
                bottom: '0',
                width: this.toolWidth + 'px',
                overflow: 'hidden',
                userSelect: 'none',
                touchAction: 'none'
            }
        });
        this.toolspaceInner = (0, $eWjiX.BB).el({
            parent: this.toolspace
        });
        this.toolspace.oncontextmenu = function() {
            return false;
        };
        this.toolspace.onclick = (0, $eWjiX.BB).handleClick;
        this.mobileBrushUi = new (0, $78e60fb79fb423b6$export$87fd7552ee5cd26e)({
            onBrush: function() {
                brushTabRow.open(lastNonEraserBrushId);
            },
            onEraser: function() {
                brushTabRow.open('eraserBrush');
            }
        });
        this.mobileColorUi = new (0, $6fc6caead7b75ed5$export$f27d6e4616dd9b30)({
            onEyedropper: function(isActive) {
                if (isActive) {
                    _this.klColorSlider.setIsEyedropping(true);
                    _this.easel.setTool('eyedropper');
                } else {
                    _this.klColorSlider.setIsEyedropping(false);
                    _this.easel.setTool(_this.toolspaceToolRow.getActive());
                }
            },
            color: currentColor,
            onColorChange: function(c) {
                brushSettingService.setColor(c);
            }
        });
        this.mobileUi = new (0, $ea23e70ae6749408$export$38b681d46b785af1)({
            onShowToolspace: function(b) {
                _this.mobileColorUi.closeColorPicker();
                _this.updateCollapse();
            },
            toolUis: [
                this.mobileBrushUi.getElement(),
                this.mobileColorUi.getElement()
            ]
        });
        this.updateCollapse(true);
        var overlayToolspace;
        setTimeout(function() {
            overlayToolspace = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).OverlayToolspace({
                enabledTest: function() {
                    return (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() === 0 && !_this.easel.getIsLocked();
                },
                brushSettingService: brushSettingService
            });
            _this.rootEl.append(overlayToolspace.getElement());
        }, 0);
        (0, $eWjiX.BB).append(this.rootEl, [
            this.easel.getElement(),
            // this.klCanvasWorkspace.getElement(),
            this.toolspace,
            this.mobileUi.getElement()
        ]);
        var toolspaceTopRow;
        if (this.embed) toolspaceTopRow = new (0, $1eff19bee197987a$export$ce26cd3db18613a3)({
            onHelp: function() {
                (0, $2d47de6498e5a87c$export$35fa34e5af64bd4a)(_this.embed.url + '/help.html', !!_this.embed);
            },
            onSubmit: function() {
                applyUncommitted();
                var onFailure = function() {
                    var closeFunc;
                    var saveBtn = (0, $eWjiX.BB).el({
                        tagName: 'button',
                        textContent: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('save-reminder-save-psd'),
                        css: {
                            display: 'block'
                        }
                    });
                    saveBtn.onclick = function() {
                        _this.saveAsPsd();
                        closeFunc();
                    };
                    (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                        message: '<b>' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('upload-failed') + '</b>',
                        div: (0, $eWjiX.BB).el({
                            content: [
                                (0, $eWjiX.BB).el({
                                    content: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('backup-drawing'),
                                    css: {
                                        marginBottom: '10px'
                                    }
                                }),
                                saveBtn
                            ]
                        }),
                        ignoreBackground: true,
                        closeFunc: function(f) {
                            closeFunc = f;
                        }
                    });
                };
                (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                    message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('submit-prompt'),
                    buttons: [
                        (0, $8d7403abedf7cefa$export$ce37e184d908d785)('submit'),
                        'Cancel'
                    ],
                    callback: function(result) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                            var _this, overlay;
                            return (0, $fk3zw._)(this, function(_state) {
                                _this = this;
                                if (result !== (0, $8d7403abedf7cefa$export$ce37e184d908d785)('submit')) return [
                                    2
                                ];
                                overlay = (0, $eWjiX.BB).el({
                                    parent: this.rootEl,
                                    className: 'upload-overlay',
                                    content: '<div class="spinner"></div> ' + (0, $8d7403abedf7cefa$export$ce37e184d908d785)('submit-submitting')
                                });
                                this.embed.onSubmit(function() {
                                    _this.updateLastSaved();
                                    overlay.remove();
                                }, function() {
                                    overlay.remove();
                                    onFailure();
                                });
                                return [
                                    2
                                ];
                            });
                        }).call(_this);
                    }
                });
            },
            onLeftRight: function() {
                _this.uiLayout = _this.uiLayout === 'left' ? 'right' : 'left';
                _this.updateUi();
            }
        });
        else toolspaceTopRow = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).ToolspaceTopRow({
            logoImg: p.logoImg,
            onLogo: function() {
                (0, $2d47de6498e5a87c$export$35fa34e5af64bd4a)('./home/', !!_this.embed);
            },
            onNew: function() {
                showNewImageDialog();
            },
            onImport: function() {
                fileUi.triggerImport();
            },
            onSave: function() {
                _this.saveToComputer.save();
            },
            onShare: function() {
                shareImage();
            },
            onHelp: function() {
                (0, $2d47de6498e5a87c$export$35fa34e5af64bd4a)('./help/', !!_this.embed);
            }
        });
        toolspaceTopRow.getElement().style.marginBottom = '10px';
        this.toolspaceInner.append(toolspaceTopRow.getElement());
        this.toolspaceToolRow = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).ToolspaceToolRow({
            onActivate: function(activeStr) {
                if (activeStr !== 'hand') // hand only one that doesn't cause changes
                applyUncommitted();
                if (activeStr === 'brush') _this.easel.setTool('brush');
                else if (activeStr === 'hand') _this.easel.setTool('hand');
                else if (activeStr === 'paintBucket') _this.easel.setTool('paintBucket');
                else if (activeStr === 'gradient') _this.easel.setTool('gradient');
                else if (activeStr === 'text') _this.easel.setTool('text');
                else if (activeStr === 'shape') _this.easel.setTool('shape');
                else if (activeStr === 'select') // this.klCanvasWorkspace.setMode('shape');
                _this.easel.setTool('select');
                else throw new Error('unknown activeStr');
                mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open(activeStr);
                updateMainTabVisibility();
                _this.klColorSlider.setIsEyedropping(false);
                _this.mobileColorUi.setIsEyedropping(false);
            },
            onZoomIn: function() {
                var oldScale = _this.easel.getTransform().scale;
                var newScale = (0, $6ac4ab2dc9a117c8$export$8c03162b1a39d183)(oldScale, keyListener.isPressed('shift') ? 1 / 8 : 0.5);
                _this.easel.scale(newScale / oldScale);
            },
            onZoomOut: function() {
                var oldScale = _this.easel.getTransform().scale;
                var newScale = (0, $6ac4ab2dc9a117c8$export$8c03162b1a39d183)(oldScale, keyListener.isPressed('shift') ? -1 / 8 : -0.5);
                _this.easel.scale(newScale / oldScale);
            },
            onUndo: function() {
                undo();
            },
            onRedo: function() {
                redo();
            }
        });
        this.toolspaceToolRow.setIsSmall(this.uiHeight < 540);
        this.toolspaceInner.append(this.toolspaceToolRow.getElement());
        var setBrushColor = function(p_color) {
            currentColor = p_color;
            currentBrushUi.setColor(p_color);
            brushSettingService.emitColor(p_color);
            _this.mobileColorUi.setColor(p_color);
            _this.klColorSlider.setIsEyedropping(false);
            _this.mobileColorUi.setIsEyedropping(false);
        };
        this.klColorSlider = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).KlColorSlider({
            width: 250,
            height: 30,
            svHeight: 100,
            startValue: new (0, $eWjiX.BB).RGB(0, 0, 0),
            onPick: setBrushColor,
            onEyedropper: function(isActive) {
                if (isActive) {
                    _this.mobileColorUi.setIsEyedropping(true);
                    _this.easel.setTool('eyedropper');
                } else {
                    _this.mobileColorUi.setIsEyedropping(false);
                    _this.easel.setTool(_this.toolspaceToolRow.getActive());
                }
            }
        });
        this.klColorSlider.setHeight(Math.max(163, Math.min(400, this.uiHeight - 505)));
        var setCurrentBrush = function(brushId) {
            if (brushId !== 'eraserBrush') lastNonEraserBrushId = brushId;
            if (_this.klColorSlider) {
                if (brushId === 'eraserBrush') _this.klColorSlider.enable(false);
                else _this.klColorSlider.enable(true);
            }
            currentBrushId = brushId;
            currentBrushUi = brushUiMap[brushId];
            currentBrushUi.setColor(currentColor);
            currentBrushUi.setLayer(currentLayer);
            _this.easelBrush.setBrush({
                type: currentBrushId === 'pixelBrush' ? 'pixel-square' : 'round'
            });
            _this.toolspaceToolRow.setActive('brush');
            updateMainTabVisibility();
        };
        var setCurrentLayer = function(layer) {
            currentLayer = layer;
            currentBrushUi.setLayer(currentLayer);
            _this.layerPreview.setLayer(currentLayer);
        };
        var brushDiv = (0, $eWjiX.BB).el();
        var colorDiv = (0, $eWjiX.BB).el({
            css: {
                margin: '10px',
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                alignItems: 'flex-end'
            }
        });
        var toolspaceStabilizerRow = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).ToolspaceStabilizerRow({
            smoothing: 1,
            onSelect: function(v) {
                lineSmoothing.setSmoothing((0, $7aa12ecc06c22770$export$bcd109042a2e4bb5)(v));
            }
        });
        brushDiv.append(colorDiv);
        (0, $eWjiX.BB).append(colorDiv, [
            this.klColorSlider.getElement(),
            this.klColorSlider.getOutputElement(),
            toolspaceStabilizerRow.getElement()
        ]);
        var brushTabRow = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).TabRow({
            initialId: 'penBrush',
            useAccent: true,
            tabArr: function() {
                var result = [];
                var createTab = function(keyStr) {
                    return {
                        id: keyStr,
                        image: (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].image,
                        title: (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].tooltip,
                        onOpen: function() {
                            brushUiMap[keyStr].getElement().style.display = 'block';
                            setCurrentBrush(keyStr);
                            _this.klColorSlider.setIsEyedropping(false);
                            _this.mobileColorUi.setIsEyedropping(false);
                            brushSettingService.emitSliderConfig({
                                sizeSlider: (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].sizeSlider,
                                opacitySlider: (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].opacitySlider,
                                scatterSlider: (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BRUSHES_UI[keyStr].scatterSlider
                            });
                            sizeWatcher(brushUiMap[keyStr].getSize());
                            brushSettingService.emitOpacity(brushUiMap[keyStr].getOpacity());
                            _this.mobileBrushUi.setType(keyStr === 'eraserBrush' ? 'eraser' : 'brush');
                        },
                        onClose: function() {
                            brushUiMap[keyStr].getElement().style.display = 'none';
                        }
                    };
                };
                var keyArr = Object.keys(brushUiMap);
                for(var i = 0; i < keyArr.length; i++)result.push(createTab(keyArr[i]));
                return result;
            }()
        });
        (0, $eWjiX.BB).append(brushDiv, [
            brushTabRow.getElement()
        ].concat((0, $bX4ja._)(Object.entries((0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).BRUSHES_UI).map(function(param) {
            var _param = (0, $8N5YG._)(param, 1), b = _param[0];
            return brushUiMap[b].getElement();
        }))));
        var handUi = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).HandUi({
            scale: this.easel.getTransform().scale,
            angleDeg: 0,
            onReset: function() {
                _this.easel.resetTransform();
            },
            onFit: function() {
                _this.easel.fitTransform();
            },
            onAngleChange: function(angleDeg, isRelative) {
                _this.easel.setAngleDeg(angleDeg, isRelative);
            },
            onChangeUseInertiaScrolling: function(b) {
                easelHand.setUseInertiaScrolling(b);
            }
        });
        var fillUi = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).FillUi({
            colorSlider: this.klColorSlider
        });
        var gradientUi = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).GradientUi({
            colorSlider: this.klColorSlider
        });
        var textUi = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).TextUi({
            colorSlider: this.klColorSlider
        });
        var shapeUi = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).ShapeUi({
            colorSlider: this.klColorSlider,
            onChangePanning: function(doPan) {
                return easelShape.setPanning(doPan);
            }
        });
        var gradientTool = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).GradientTool({
            onGradient: function(isDone, x1, y1, x2, y2, angleRad) {
                var layerIndex = currentLayer.index;
                var settings = gradientUi.getSettings();
                var gradientObj = {
                    type: settings.type,
                    color1: _this.klColorSlider.getColor(),
                    isReversed: settings.isReversed,
                    opacity: settings.opacity,
                    doLockAlpha: settings.doLockAlpha,
                    isEraser: settings.isEraser,
                    doSnap: keyListener.isPressed('shift') || settings.doSnap,
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    angleRad: angleRad
                };
                if (isDone) {
                    _this.klCanvas.setComposite(layerIndex, undefined);
                    _this.klCanvas.drawGradient(layerIndex, gradientObj);
                } else {
                    var selection = _this.klCanvas.getSelection();
                    var selectionPath = selection ? new Path2D((0, $9b3eo.getSelectionPath2d)(selection)) : undefined;
                    _this.klCanvas.setComposite(layerIndex, {
                        draw: function(ctx) {
                            (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).drawGradient(ctx, gradientObj, selectionPath);
                        }
                    });
                }
                _this.easelProjectUpdater.update();
            }
        });
        var shapeTool = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).ShapeTool({
            onShape: function(isDone, x1, y1, x2, y2, angleRad) {
                var layerIndex = currentLayer.index;
                var shapeObj = {
                    type: shapeUi.getShape(),
                    x1: x1,
                    y1: y1,
                    x2: x2,
                    y2: y2,
                    angleRad: angleRad,
                    isOutwards: shapeUi.getIsOutwards(),
                    opacity: shapeUi.getOpacity(),
                    isEraser: shapeUi.getIsEraser(),
                    doLockAlpha: shapeUi.getDoLockAlpha()
                };
                if (shapeUi.getShape() === 'line') {
                    shapeObj.strokeRgb = _this.klColorSlider.getColor();
                    shapeObj.lineWidth = shapeUi.getLineWidth();
                    shapeObj.isAngleSnap = shapeUi.getIsSnap() || keyListener.isPressed('shift');
                } else {
                    shapeObj.isFixedRatio = shapeUi.getIsFixed() || keyListener.isPressed('shift');
                    if (shapeUi.getMode() === 'stroke') {
                        shapeObj.strokeRgb = _this.klColorSlider.getColor();
                        shapeObj.lineWidth = shapeUi.getLineWidth();
                    } else shapeObj.fillRgb = _this.klColorSlider.getColor();
                }
                if (isDone) {
                    _this.klCanvas.setComposite(layerIndex, undefined);
                    _this.klCanvas.drawShape(layerIndex, shapeObj);
                } else {
                    var selection = _this.klCanvas.getSelection();
                    var selectionPath = selection ? new Path2D((0, $9b3eo.getSelectionPath2d)(selection)) : undefined;
                    _this.klCanvas.setComposite(layerIndex, {
                        draw: function(ctx) {
                            (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).drawShape(ctx, shapeObj, selectionPath);
                        }
                    });
                }
                _this.easelProjectUpdater.update();
            }
        });
        this.layersUi = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).LayersUi({
            klCanvas: this.klCanvas,
            onSelect: function(layerIndex, pushHistory) {
                var activeLayer = _this.klCanvas.getLayer(layerIndex);
                setCurrentLayer(activeLayer);
                if (pushHistory) {
                    var topEntry = _this.klHistory.getEntries().at(-1).data;
                    var replaceTop = (0, $0eb4c7d1339a9456$export$beb462111ff337c5)(topEntry);
                    _this.klHistory.push({
                        activeLayerId: activeLayer.id
                    }, replaceTop);
                }
            },
            parentEl: this.rootEl,
            uiState: this.uiLayout,
            applyUncommitted: function() {
                return applyUncommitted();
            },
            klHistory: this.klHistory,
            onUpdateProject: function() {
                return _this.easelProjectUpdater.update();
            },
            onClearLayer: function() {
                return clearLayer(false, true);
            }
        });
        this.layerPreview = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).LayerPreview({
            klRootEl: this.rootEl,
            onClick: function() {
                mainTabRow === null || mainTabRow === void 0 ? void 0 : mainTabRow.open('layers');
            },
            uiState: this.uiLayout,
            klHistory: this.klHistory
        });
        this.layerPreview.setIsVisible(this.uiHeight >= 579);
        this.layerPreview.setLayer(currentLayer);
        var editUi = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).EditUi({
            klRootEl: this.rootEl,
            klColorSlider: this.klColorSlider,
            layersUi: this.layersUi,
            getCurrentColor: function() {
                return currentColor;
            },
            maxCanvasSize: maxCanvasSize,
            klCanvas: this.klCanvas,
            getCurrentLayer: function() {
                return currentLayer;
            },
            isEmbed: !!this.embed,
            statusOverlay: this.statusOverlay,
            onCanvasChanged: function() {
                _this.easelProjectUpdater.update();
                _this.easel.resetOrFitTransform(true);
            },
            applyUncommitted: function() {
                return applyUncommitted();
            },
            klHistory: this.klHistory,
            onCopyToClipboard: function() {
                applyUncommitted();
                copyToClipboard(false, false);
            },
            onPaste: function() {
                return importHandler.readClipboard();
            }
        });
        var klHistoryExecutor = new (0, $45179ad71c16c96a$export$cb9945923eaef1dd)({
            klHistory: this.klHistory,
            tempHistory: tempHistory,
            onCanUndoRedoChange: function(canUndo, canRedo) {
                _this.toolspaceToolRow.setEnableUndo(canUndo);
                _this.toolspaceToolRow.setEnableRedo(canRedo);
            }
        });
        var showNewImageDialog = function() {
            applyUncommitted();
            (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).newImageDialog({
                currentColor: currentColor,
                secondaryColor: _this.klColorSlider.getSecondaryRGB(),
                maxCanvasSize: maxCanvasSize,
                canvasWidth: _this.klCanvas.getWidth(),
                canvasHeight: _this.klCanvas.getHeight(),
                workspaceWidth: window.innerWidth < _this.collapseThreshold ? _this.uiWidth : _this.uiWidth - _this.toolWidth,
                workspaceHeight: _this.uiHeight,
                onConfirm: function(width, height, color) {
                    _this.klCanvas.reset({
                        width: width,
                        height: height,
                        color: color.a === 1 ? color : undefined
                    });
                    _this.layersUi.update(0);
                    setCurrentLayer(_this.klCanvas.getLayer(0));
                    _this.easelProjectUpdater.update();
                    _this.easel.resetOrFitTransform(true);
                },
                onCancel: function() {}
            });
        };
        var shareImage = function(callback) {
            applyUncommitted();
            (0, $eWjiX.BB).shareCanvas({
                canvas: _this.klCanvas.getCompleteCanvas(1),
                fileName: (0, $eWjiX.BB).getDate() + (0, $da1a7600c10c1784$export$67ac20532b9ededa).filenameBase + '.png',
                title: (0, $eWjiX.BB).getDate() + (0, $da1a7600c10c1784$export$67ac20532b9ededa).filenameBase + '.png',
                callback: callback ? callback : function() {}
            });
        };
        this.saveToComputer = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).SaveToComputer(function() {
            return exportType;
        }, this.klCanvas, function() {
            _this.updateLastSaved();
        });
        var copyToClipboard = function() {
            var showCrop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, closeOnBlur = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
            (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).clipboardDialog(_this1.rootEl, function(maskSelection) {
                return _this1.klCanvas.getCompleteCanvas(1, maskSelection);
            }, function(inputObj) {
                if (inputObj.left === 0 && inputObj.right === 0 && inputObj.top === 0 && inputObj.bottom === 0) return;
                //do a crop
                (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).FILTER_LIB.cropExtend.apply({
                    layer: currentLayer,
                    klCanvas: _this1.klCanvas,
                    input: inputObj,
                    klHistory: _this1.klHistory
                });
                _this1.layersUi.update();
                _this1.easelProjectUpdater.update();
                _this1.easel.resetOrFitTransform(true);
            }, _this1.statusOverlay, showCrop || false, closeOnBlur, _this1.klCanvas.getSelection());
        };
        var onOpenBrowserStorage = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                var _this, showFailureMessage, meta, doOpen, crossTabChannel, openedProjectIds, otherIdListener, closeLoader, project, e, layerIndex;
                return (0, $fk3zw._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _this = this;
                            showFailureMessage = function() {
                                (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                    message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-open-failed'),
                                    type: 'error'
                                });
                            };
                            if (!projectStore) {
                                showFailureMessage();
                                return [
                                    2
                                ];
                            }
                            meta = projectStore.getCurrentMeta();
                            if (!(meta && this.klHistory.getComposed().projectId.value !== meta.projectId)) return [
                                3,
                                4
                            ];
                            doOpen = true;
                            crossTabChannel = new (0, $3uJxV.CrossTabChannel)('kl-tab-communication');
                            openedProjectIds = [];
                            otherIdListener = function(message) {
                                if (message.type === 'response-project-id') openedProjectIds.push(message.id);
                            };
                            crossTabChannel.subscribe(otherIdListener);
                            crossTabChannel.postMessage({
                                type: 'request-project-ids'
                            });
                            return [
                                4,
                                (0, $7jh4K.sleep)(100)
                            ];
                        case 1:
                            _state.sent();
                            crossTabChannel.unsubscribe(otherIdListener);
                            if (!(meta && openedProjectIds.includes(meta.projectId))) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                new Promise(function(resolve, reject) {
                                    (0, $c902829f68f42bce$export$d7e8d4d4450c819c)({
                                        message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-open-confirmation'),
                                        buttons: [
                                            (0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-open'),
                                            'Cancel'
                                        ],
                                        callback: function(result) {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                                                return (0, $fk3zw._)(this, function(_state) {
                                                    if (result === 'Cancel') {
                                                        resolve(false);
                                                        return [
                                                            2
                                                        ];
                                                    }
                                                    resolve(true);
                                                    return [
                                                        2
                                                    ];
                                                });
                                            })();
                                        }
                                    });
                                })
                            ];
                        case 2:
                            doOpen = _state.sent();
                            _state.label = 3;
                        case 3:
                            crossTabChannel.close();
                            if (!doOpen) return [
                                2
                            ];
                            _state.label = 4;
                        case 4:
                            (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).popup({
                                message: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('loading'),
                                callback: function(result) {
                                    closeLoader = undefined;
                                },
                                closeFunc: function(f) {
                                    closeLoader = f;
                                }
                            });
                            _state.label = 5;
                        case 5:
                            _state.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4,
                                projectStore === null || projectStore === void 0 ? void 0 : projectStore.read()
                            ];
                        case 6:
                            project = _state.sent();
                            return [
                                3,
                                8
                            ];
                        case 7:
                            e = _state.sent();
                            setTimeout(function() {
                                throw e;
                            });
                            return [
                                3,
                                8
                            ];
                        case 8:
                            if (!project) {
                                closeLoader === null || closeLoader === void 0 ? void 0 : closeLoader();
                                showFailureMessage();
                                return [
                                    2
                                ];
                            }
                            applyUncommitted();
                            layerIndex = this.klCanvas.reset({
                                projectId: project.project.projectId,
                                width: project.project.width,
                                height: project.project.height,
                                layers: project.project.layers.map(function(item) {
                                    var image = item.image;
                                    if (!(image instanceof HTMLCanvasElement)) {
                                        image = (0, $eWjiX.BB).canvas(project.project.width, project.project.height);
                                        if (item.image instanceof HTMLImageElement) {
                                            var ctx = (0, $eWjiX.BB).ctx(image);
                                            ctx.drawImage(item.image, 0, 0);
                                        }
                                    }
                                    var _item_mixModeStr;
                                    return (0, $4EWN2._)((0, $cL71g._)({}, item), {
                                        id: (0, $7jh4K.randomUuid)(),
                                        image: image,
                                        mixModeStr: (_item_mixModeStr = item.mixModeStr) !== null && _item_mixModeStr !== void 0 ? _item_mixModeStr : 'source-over'
                                    });
                                })
                            });
                            this.layersUi.update(layerIndex);
                            setCurrentLayer(this.klCanvas.getLayer(layerIndex));
                            this.easelProjectUpdater.update();
                            this.easel.resetOrFitTransform(true);
                            setTimeout(function() {
                                // timeout to overwrite zoom overlay msg
                                _this.statusOverlay.out((0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-restored'));
                            });
                            closeLoader === null || closeLoader === void 0 ? void 0 : closeLoader();
                            return [
                                2
                            ];
                    }
                });
            }).call(_this);
        };
        var fileUi = this.embed ? null : new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).FileUi({
            klRootEl: this.rootEl,
            projectStore: projectStore,
            getProject: function() {
                return _this.klCanvas.getProject();
            },
            exportType: exportType,
            onExportTypeChange: function(type) {
                exportType = type;
            },
            onFileSelect: function(files, optionsStr) {
                return importHandler.handleFileSelect(files, optionsStr);
            },
            onSaveImageToComputer: function() {
                applyUncommitted();
                _this.saveToComputer.save();
            },
            onNewImage: showNewImageDialog,
            onShareImage: function(callback) {
                applyUncommitted();
                shareImage(callback);
            },
            onUpload: function() {
                // on upload
                applyUncommitted();
                (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).imgurUpload(_this.klCanvas, _this.rootEl, p.app && p.app.imgurKey ? p.app.imgurKey : '', function() {
                    return _this.updateLastSaved();
                });
            },
            applyUncommitted: function() {
                return applyUncommitted();
            },
            onChangeShowSaveDialog: function(b) {
                _this.saveToComputer.setShowSaveDialog(b);
            },
            klRecoveryManager: klRecoveryManager,
            onOpenBrowserStorage: onOpenBrowserStorage,
            onStoredToBrowserStorage: function() {
                _this.updateLastSaved();
            }
        });
        if (!this.embed && projectStore) this.saveReminder = new (0, $06e8423858d08972$export$befc6437ad34b28a)({
            onSaveAsPsd: function() {
                if (!_this.embed) _this.saveAsPsd();
            },
            isDrawing: function() {
                return _this.isDrawing();
            },
            projectStore: projectStore,
            getProject: function() {
                return _this.getProject();
            },
            onStored: function() {
                _this.updateLastSaved();
            },
            applyUncommitted: applyUncommitted,
            klHistory: this.klHistory
        });
        var settingsUi = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).SettingsUi({
            onLeftRight: function() {
                _this.uiLayout = _this.uiLayout === 'left' ? 'right' : 'left';
                _this.updateUi();
                if (!_this.embed) (0, $6l0gQ.LocalStorage).setItem('uiState', _this.uiLayout);
            },
            saveReminder: this.saveReminder,
            customAbout: p.aboutEl
        });
        mainTabRow = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).TabRow({
            initialId: 'brush',
            tabArr: [
                {
                    id: 'brush',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-brush'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($1813762111ff3b93$exports))),
                    onOpen: function() {
                        if (currentBrushId === 'eraserBrush') _this.klColorSlider.enable(false);
                        (0, $eWjiX.BB).append(colorDiv, [
                            _this.klColorSlider.getElement(),
                            _this.klColorSlider.getOutputElement(),
                            toolspaceStabilizerRow.getElement()
                        ]);
                        brushDiv.style.display = 'block';
                    },
                    onClose: function() {
                        brushDiv.style.display = 'none';
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'hand',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-hand'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($ec1da9254c8485a7$exports))),
                    isVisible: false,
                    onOpen: function() {
                        handUi.setIsVisible(true);
                    },
                    onClose: function() {
                        handUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'paintBucket',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-paint-bucket'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($09067d6182ed3b8e$exports))),
                    isVisible: false,
                    onOpen: function() {
                        _this.klColorSlider.enable(true);
                        fillUi.setIsVisible(true);
                    },
                    onClose: function() {
                        fillUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'gradient',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-gradient'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($493fdfa42d027406$exports))),
                    isVisible: false,
                    onOpen: function() {
                        _this.klColorSlider.enable(true);
                        gradientUi.setIsVisible(true);
                    },
                    onClose: function() {
                        gradientUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'text',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-text'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($7bad8de727b6761d$exports))),
                    isVisible: false,
                    onOpen: function() {
                        _this.klColorSlider.enable(true);
                        textUi.setIsVisible(true);
                    },
                    onClose: function() {
                        textUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'shape',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-shape'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($a931fbdaeae5b97a$exports))),
                    isVisible: false,
                    onOpen: function() {
                        _this.klColorSlider.enable(true);
                        shapeUi.setIsVisible(true);
                    },
                    onClose: function() {
                        shapeUi.setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'select',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tool-select'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($b8ba25f8f8b8d477$exports))),
                    isVisible: false,
                    onOpen: function() {
                        klAppSelect.getSelectUi().setIsVisible(true);
                    },
                    onClose: function() {
                        klAppSelect.getSelectUi().setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'layers',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('layers'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($35c1331d74740d5d$exports))),
                    onOpen: function() {
                        _this.layersUi.update();
                        _this.layersUi.getElement().style.display = 'block';
                    },
                    onClose: function() {
                        _this.layersUi.getElement().style.display = 'none';
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'edit',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-edit'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($9d5703f01759ee19$exports))),
                    onOpen: function() {
                        editUi.show();
                    },
                    onClose: function() {
                        editUi.hide();
                    },
                    css: {
                        minWidth: '45px'
                    }
                },
                {
                    id: 'file',
                    label: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-file'),
                    isVisible: !!fileUi,
                    onOpen: function() {
                        if (!fileUi) return;
                        fileUi.getElement().style.display = 'block';
                        fileUi.setIsVisible(true);
                    },
                    onClose: function() {
                        if (!fileUi) return;
                        fileUi.getElement().style.display = 'none';
                        fileUi.setIsVisible(false);
                    },
                    css: {
                        padding: '0 7px'
                    }
                },
                {
                    id: 'settings',
                    title: (0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-settings'),
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($297fb258e45d3497$exports))),
                    onOpen: function() {
                        settingsUi.getElement().style.display = 'block';
                    // settingsTab.setIsVisible(true);
                    },
                    onClose: function() {
                        settingsUi.getElement().style.display = 'none';
                    // settingsTab.setIsVisible(false);
                    },
                    css: {
                        minWidth: '45px'
                    }
                }
            ]
        });
        this.bottomBarWrapper = (0, $eWjiX.BB).el({
            css: {
                width: '270px',
                position: 'absolute',
                bottom: '0',
                left: '0'
            }
        });
        if (p.bottomBar) {
            this.bottomBar = p.bottomBar;
            this.bottomBarWrapper.append(this.bottomBar);
            var observer = new MutationObserver(function() {
                return _this.updateBottomBar();
            });
            observer.observe(this.toolspaceInner, {
                attributes: true,
                childList: true,
                subtree: true
            });
        }
        (0, $eWjiX.BB).append(this.toolspaceInner, [
            this.layerPreview.getElement(),
            mainTabRow.getElement(),
            brushDiv,
            handUi.getElement(),
            fillUi.getElement(),
            gradientUi.getElement(),
            textUi.getElement(),
            shapeUi.getElement(),
            klAppSelect.getSelectUi().getElement(),
            this.layersUi.getElement(),
            editUi.getElement(),
            fileUi ? fileUi.getElement() : undefined,
            settingsUi.getElement(),
            (0, $eWjiX.BB).el({
                css: {
                    height: '10px'
                }
            }),
            this.bottomBarWrapper ? this.bottomBarWrapper : undefined
        ]);
        this.toolspaceScroller = new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).ToolspaceScroller({
            toolspace: this.toolspace,
            uiState: this.uiLayout
        });
        if (!this.embed) Object.defineProperty(window, 'KL', {
            value: (0, $a8abbf3a9def9692$export$982e7602957287fa)({
                onDraw: function(path) {
                    if (!path || path.length === 0) return;
                    path.forEach(function(p, index) {
                        if (index === 0) currentBrushUi.startLine(p.x, p.y, 1);
                        else currentBrushUi.goLine(p.x, p.y, 1);
                    });
                    currentBrushUi.endLine();
                }
            }),
            writable: false
        });
        this.resize(this.uiWidth, this.uiHeight);
        this.updateUi();
        var importHandler = new (0, $da20269bad242e5f$export$1ec1306c0c05d48d)({
            klRootEl: this.rootEl,
            maxCanvasSize: maxCanvasSize,
            layersUi: this.layersUi,
            setCurrentLayer: setCurrentLayer,
            klCanvas: this.klCanvas,
            onImportConfirm: function() {
                _this.easelProjectUpdater.update();
                _this.easel.resetOrFitTransform(true);
            },
            applyUncommitted: function() {
                return applyUncommitted();
            }
        }, {
            onColor: function(rgb) {
                return brushSettingService.setColor(rgb);
            }
        });
        if (!this.embed || this.embed.enableImageDropperImport) {
            new (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).KlImageDropper({
                target: document.body,
                onDrop: function(files, optionStr) {
                    if ((0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() > 0) return;
                    applyUncommitted();
                    importHandler.handleFileSelect(files, optionStr);
                },
                enabledTest: function() {
                    return (0, $9cbe98d1fb398012$export$6e4a713ddcda1e5e).DIALOG_COUNTER.get() === 0;
                }
            });
            window.document.addEventListener('paste', function(e) {
                return importHandler.onPaste(e);
            }, false);
        }
        this.unloadWarningTrigger = new (0, $248aa716a9226bd7$export$747c5e57cda7ca57)({
            klHistory: this.klHistory,
            getLastSavedHistoryIndex: function() {
                return _this.lastSavedHistoryIndex;
            }
        });
        {
            window.addEventListener('resize', function() {
                _this.resize(window.innerWidth, window.innerHeight);
            });
            window.addEventListener('orientationchange', function() {
                _this.resize(window.innerWidth, window.innerHeight);
            });
            // 2024-08: window.resize doesn't fire on iPad Safari when:
            // pinch zoomed page, then reload, and un-pinch-zoom page
            // therefor also listen to visualViewport.
            if ('visualViewport' in window && visualViewport !== null) visualViewport.addEventListener('resize', function() {
                _this.resize(window.innerWidth, window.innerHeight);
            });
            // iPad doesn't trigger 'resize' event when using text zoom, although it's resizing the window.
            // Workaround: place a div in the body that fills the window, and use a ResizeObserver
            var windowResizeWatcher = (0, $eWjiX.BB).el({
                parent: document.body,
                css: {
                    position: 'fixed',
                    left: '0',
                    top: '0',
                    right: '0',
                    bottom: '0',
                    pointerEvents: 'none',
                    zIndex: '-1',
                    userSelect: 'none'
                }
            });
            try {
                // Not all browsers support ResizeObserver. Not critical though.
                var observer1 = new ResizeObserver(function() {
                    return _this.resize(window.innerWidth, window.innerHeight);
                });
                observer1.observe(windowResizeWatcher);
            } catch (e) {
                windowResizeWatcher.remove();
            }
            // prevent ctrl scroll -> zooming page
            this.rootEl.addEventListener('wheel', function(event) {
                if (keyListener.isPressed('ctrl')) event.preventDefault();
            }, {
                passive: false
            });
            //maybe prevent zooming on safari mac os - todo still needed?
            var prevent = function(e) {
                e.preventDefault();
            };
            window.addEventListener('gesturestart', prevent, {
                passive: false
            });
            window.addEventListener('gesturechange', prevent, {
                passive: false
            });
            window.addEventListener('gestureend', prevent, {
                passive: false
            });
            var pinchZoomWatcher = new (0, $456806b212fdf6a8$export$3e66e8feec69f8d)();
        }
        if (!this.embed) setTimeout(function() {
            (0, $ee60bdc4a11355ae$export$4a2ed1038e76f37f)({
                projectStore: projectStore,
                klRecoveryManager: klRecoveryManager,
                onOpenBrowserStorage: onOpenBrowserStorage,
                klHistory: _this.klHistory
            });
        });
        (_this_saveReminder = this.saveReminder) === null || _this_saveReminder === void 0 ? void 0 : _this_saveReminder.init();
    }
    (0, $7h4XF._)(KlApp, [
        {
            key: "updateLastSaved",
            value: function updateLastSaved() {
                var _this_saveReminder, _this_unloadWarningTrigger;
                this.lastSavedHistoryIndex = this.klHistory.getTotalIndex();
                (_this_saveReminder = this.saveReminder) === null || _this_saveReminder === void 0 ? void 0 : _this_saveReminder.reset();
                (_this_unloadWarningTrigger = this.unloadWarningTrigger) === null || _this_unloadWarningTrigger === void 0 ? void 0 : _this_unloadWarningTrigger.update();
            }
        },
        {
            key: "updateCollapse",
            value: function updateCollapse(isInitial) {
                if (isInitial) {
                    var _LocalStorage_getItem;
                    var isMobile = Boolean((_LocalStorage_getItem = (0, $6l0gQ.LocalStorage).getItem('uiShowMobile')) !== null && _LocalStorage_getItem !== void 0 ? _LocalStorage_getItem : false);
                    if (isMobile) this.mobileUi.setToolspaceIsOpen(false);
                }
                this.mobileUi.setOrientation(this.uiLayout);
                if (this.uiWidth < this.collapseThreshold) {
                    this.mobileUi.setIsVisible(true);
                    if (this.mobileUi.getToolspaceIsOpen()) {
                        if (this.uiLayout === 'left') (0, $7jh4K.css)(this.easel.getElement(), {
                            left: '271px'
                        });
                        else (0, $7jh4K.css)(this.easel.getElement(), {
                            left: '0'
                        });
                        this.toolspace.style.display = 'block';
                        this.easel.setSize(Math.max(0, this.uiWidth - this.toolWidth), this.uiHeight);
                        this.statusOverlay.setWide(false);
                    } else {
                        if (this.uiLayout === 'left') (0, $7jh4K.css)(this.easel.getElement(), {
                            left: '0'
                        });
                        else (0, $7jh4K.css)(this.easel.getElement(), {
                            left: '0'
                        });
                        this.toolspace.style.display = 'none';
                        this.easel.setSize(Math.max(0, this.uiWidth), this.uiHeight);
                        this.statusOverlay.setWide(true);
                    }
                } else {
                    this.mobileColorUi.closeColorPicker();
                    this.mobileUi.setIsVisible(false);
                    if (this.uiLayout === 'left') (0, $7jh4K.css)(this.easel.getElement(), {
                        left: '271px'
                    });
                    this.toolspace.style.display = 'block';
                    this.easel.setSize(Math.max(0, this.uiWidth - this.toolWidth), this.uiHeight);
                    this.statusOverlay.setWide(false);
                }
                this.mobileUi.update();
            }
        },
        {
            key: "updateBottomBar",
            value: function updateBottomBar() {
                if (!this.bottomBar) return;
                var isVisible = this.toolspaceInner.scrollHeight + 40 < window.innerHeight;
                var newDisplay = isVisible ? '' : 'none';
                // check to prevent infinite MutationObserver loop in Pale Moon
                if (newDisplay !== this.bottomBarWrapper.style.display) this.bottomBarWrapper.style.display = newDisplay;
            }
        },
        {
            key: "updateUi",
            value: function updateUi() {
                this.toolspace.classList.toggle('kl-toolspace--left', this.uiLayout === 'left');
                this.toolspace.classList.toggle('kl-toolspace--right', this.uiLayout === 'right');
                if (this.uiLayout === 'left') {
                    (0, $7jh4K.css)(this.toolspace, {
                        left: '0',
                        right: ''
                    });
                    (0, $7jh4K.css)(this.easel.getElement(), {
                        left: '271px'
                    });
                } else {
                    (0, $7jh4K.css)(this.toolspace, {
                        left: '',
                        right: '0'
                    });
                    (0, $7jh4K.css)(this.easel.getElement(), {
                        left: '0'
                    });
                }
                this.statusOverlay.setUiState(this.uiLayout);
                this.layerPreview.setUiState(this.uiLayout);
                this.layersUi.setUiState(this.uiLayout);
                this.updateCollapse();
                this.toolspaceScroller.updateUiState(this.uiLayout);
            }
        },
        {
            // -------- interface --------
            key: "getElement",
            value: function getElement() {
                return this.rootEl;
            }
        },
        {
            key: "resize",
            value: function resize(w, h) {
                // iPad scrolls down when increasing text zoom
                if (window.scrollY > 0) window.scrollTo(0, 0);
                if (this.uiWidth === Math.max(0, w) && this.uiHeight === Math.max(0, h)) return;
                this.uiWidth = Math.max(0, w);
                this.uiHeight = Math.max(0, h);
                this.updateCollapse();
                this.updateBottomBar();
                this.layerPreview.setIsVisible(this.uiHeight >= 579);
                this.klColorSlider.setHeight(Math.max(163, Math.min(400, this.uiHeight - 505)));
                this.toolspaceToolRow.setIsSmall(this.uiHeight < 540);
            }
        },
        {
            key: "out",
            value: function out(msg) {
                this.statusOverlay.out(msg);
            }
        },
        {
            key: "getPNG",
            value: function getPNG() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
                    return (0, $fk3zw._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    (0, $eIcQa.canvasToBlob)(this.klCanvas.getCompleteCanvas(1), 'image/png')
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "getProject",
            value: function getProject() {
                return this.klCanvas.getProject();
            }
        },
        {
            key: "swapUiLeftRight",
            value: function swapUiLeftRight() {
                this.uiLayout = this.uiLayout === 'left' ? 'right' : 'left';
                if (!this.embed) (0, $6l0gQ.LocalStorage).setItem('uiState', this.uiLayout);
                this.updateUi();
            }
        },
        {
            key: "saveAsPsd",
            value: function saveAsPsd() {
                this.saveToComputer.save('psd');
            }
        },
        {
            key: "isDrawing",
            value: function isDrawing() {
                return this.lineSanitizer.getIsDrawing() || this.easel.getIsLocked();
            }
        }
    ]);
    return KlApp;
}();





var $jTg9g = parcelRequire("jTg9g");

var $6otAp = parcelRequire("6otAp");
function $b8f9b41d70e8fccd$var$showInitError(e) {
    var el = document.createElement('div');
    el.style.textAlign = 'center';
    el.style.background = '#fff';
    el.style.padding = '20px';
    el.innerHTML = '<h1>App failed to initialize</h1>';
    var errorMsg = document.createElement('div');
    errorMsg.textContent = 'Error: ' + (e.message ? e.message : '' + e);
    el.append(errorMsg);
    document.body.append(el);
    console.error(e);
}
(function() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1LaJZ._)(function() {
        var outQueue, klRecoveryManager, project, readResult, _tmp, e, loadingScreenEl, klApp, e1;
        return (0, $fk3zw._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        9,
                        ,
                        10
                    ]);
                    outQueue = [];
                    return [
                        4,
                        (0, $8d7403abedf7cefa$export$7a2ea9f2e4d199d3)()
                    ];
                case 1:
                    _state.sent();
                    (0, $jTg9g.KL_INDEXED_DB).init((0, $jTg9g.getKlIndexedDbName)(), (0, $jTg9g.KL_INDEXED_DB_STORES), (0, $jTg9g.KL_INDEXED_DB_VERSION), (0, $jTg9g.KL_INDEXED_DB_UPGRADER));
                    return [
                        4,
                        (0, $jTg9g.KL_INDEXED_DB).testConnection()
                    ];
                case 2:
                    if (!_state.sent()) outQueue.push((0, $8d7403abedf7cefa$export$ce37e184d908d785)('file-storage-cant-access'));
                    klRecoveryManager = (0, $jTg9g.KL_INDEXED_DB).getIsAvailable() ? new (0, $6otAp.KlRecoveryManager)({}) : undefined;
                    project = undefined;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        7,
                        ,
                        8
                    ]);
                    if (!klRecoveryManager) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        klRecoveryManager.getRecovery()
                    ];
                case 4:
                    _tmp = _state.sent();
                    return [
                        3,
                        6
                    ];
                case 5:
                    _tmp = undefined;
                    _state.label = 6;
                case 6:
                    readResult = _tmp;
                    if (readResult) {
                        project = readResult.project;
                        outQueue.push((0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-recovery-recovered'));
                    }
                    return [
                        3,
                        8
                    ];
                case 7:
                    e = _state.sent();
                    setTimeout(function() {
                        throw e;
                    });
                    outQueue.push((0, $8d7403abedf7cefa$export$ce37e184d908d785)('tab-recovery-failed-to-recover'));
                    return [
                        3,
                        8
                    ];
                case 8:
                    // in case an extension manipulated the page
                    loadingScreenEl = document.getElementById('loading-screen');
                    loadingScreenEl === null || loadingScreenEl === void 0 ? void 0 : loadingScreenEl.remove();
                    klApp = new (0, $cf5d938ee512ebca$export$96f6458b62e4c2c)({
                        project: project,
                        klRecoveryManager: klRecoveryManager
                    });
                    document.body.append(klApp.getElement());
                    setTimeout(function() {
                        outQueue.forEach(function(msg) {
                            klApp.out(msg);
                        });
                    }, 100);
                    return [
                        3,
                        10
                    ];
                case 9:
                    e1 = _state.sent();
                    $b8f9b41d70e8fccd$var$showInitError(e1);
                    return [
                        3,
                        10
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    })();
})();

})();
//# sourceMappingURL=path0.493b274f.js.map
